
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("eqiDo", function(module, exports) {

$parcel$export(module.exports, "main", () => $a801f2c896bd09f1$export$f22da7240b7add18);
var $a801f2c896bd09f1$var$__create = Object.create;
var $a801f2c896bd09f1$var$__defProp = Object.defineProperty;
var $a801f2c896bd09f1$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $a801f2c896bd09f1$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $a801f2c896bd09f1$var$__getProtoOf = Object.getPrototypeOf;
var $a801f2c896bd09f1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a801f2c896bd09f1$var$__commonJS = (cb, mod5)=>function __require() {
        return mod5 || (0, cb[$a801f2c896bd09f1$var$__getOwnPropNames(cb)[0]])((mod5 = {
            exports: {}
        }).exports, mod5), mod5.exports;
    };
var $a801f2c896bd09f1$var$__copyProps = (to2, from3, except2, desc)=>{
    if (from3 && typeof from3 === "object" || typeof from3 === "function") {
        for (let key2 of $a801f2c896bd09f1$var$__getOwnPropNames(from3))if (!$a801f2c896bd09f1$var$__hasOwnProp.call(to2, key2) && key2 !== except2) $a801f2c896bd09f1$var$__defProp(to2, key2, {
            get: ()=>from3[key2],
            enumerable: !(desc = $a801f2c896bd09f1$var$__getOwnPropDesc(from3, key2)) || desc.enumerable
        });
    }
    return to2;
};
var $a801f2c896bd09f1$var$__toESM = (mod5, isNodeMode, target6)=>(target6 = mod5 != null ? $a801f2c896bd09f1$var$__create($a801f2c896bd09f1$var$__getProtoOf(mod5)) : {}, $a801f2c896bd09f1$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod5 || !mod5.__esModule ? $a801f2c896bd09f1$var$__defProp(target6, "default", {
        value: mod5,
        enumerable: true
    }) : target6, mod5));
// node_modules/downloadjs/download.js
var $a801f2c896bd09f1$var$require_download = $a801f2c896bd09f1$var$__commonJS({
    "node_modules/downloadjs/download.js" (exports, module) {
        (function(root, factory) {
            if (typeof define === "function" && define.amd) define([], factory);
            else if (typeof exports === "object") module.exports = factory();
            else root.download = factory();
        })(exports, function() {
            return function download4(data, strFileName, strMimeType) {
                var self2 = window, defaultMime = "application/octet-stream", mimeType = strMimeType || defaultMime, payload = data, url = !strFileName && !strMimeType && payload, anchor = document.createElement("a"), toString2 = function(a3) {
                    return String(a3);
                }, myBlob = self2.Blob || self2.MozBlob || self2.WebKitBlob || toString2, fileName = strFileName || "download", blob, reader;
                myBlob = myBlob.call ? myBlob.bind(self2) : Blob;
                if (String(this) === "true") {
                    payload = [
                        payload,
                        mimeType
                    ];
                    mimeType = payload[0];
                    payload = payload[1];
                }
                if (url && url.length < 2048) {
                    fileName = url.split("/").pop().split("?")[0];
                    anchor.href = url;
                    if (anchor.href.indexOf(url) !== -1) {
                        var ajax = new XMLHttpRequest();
                        ajax.open("GET", url, true);
                        ajax.responseType = "blob";
                        ajax.onload = function(e) {
                            download4(e.target.response, fileName, defaultMime);
                        };
                        setTimeout(function() {
                            ajax.send();
                        }, 0);
                        return ajax;
                    }
                }
                if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
                    if (payload.length > 2096103.424 && myBlob !== toString2) {
                        payload = dataUrlToBlob(payload);
                        mimeType = payload.type || defaultMime;
                    } else return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
                    navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload);
                } else if (/([\x80-\xff])/.test(payload)) {
                    var i2 = 0, tempUiArr = new Uint8Array(payload.length), mx = tempUiArr.length;
                    for(i2; i2 < mx; ++i2)tempUiArr[i2] = payload.charCodeAt(i2);
                    payload = new myBlob([
                        tempUiArr
                    ], {
                        type: mimeType
                    });
                }
                blob = payload instanceof myBlob ? payload : new myBlob([
                    payload
                ], {
                    type: mimeType
                });
                function dataUrlToBlob(strUrl) {
                    var parts = strUrl.split(/[:;,]/), type = parts[1], decoder = parts[2] == "base64" ? atob : decodeURIComponent, binData = decoder(parts.pop()), mx2 = binData.length, i3 = 0, uiArr = new Uint8Array(mx2);
                    for(i3; i3 < mx2; ++i3)uiArr[i3] = binData.charCodeAt(i3);
                    return new myBlob([
                        uiArr
                    ], {
                        type: type
                    });
                }
                function saver(url2, winMode) {
                    if ("download" in anchor) {
                        anchor.href = url2;
                        anchor.setAttribute("download", fileName);
                        anchor.className = "download-js-link";
                        anchor.innerHTML = "downloading...";
                        anchor.style.display = "none";
                        document.body.appendChild(anchor);
                        setTimeout(function() {
                            anchor.click();
                            document.body.removeChild(anchor);
                            if (winMode === true) setTimeout(function() {
                                self2.URL.revokeObjectURL(anchor.href);
                            }, 250);
                        }, 66);
                        return true;
                    }
                    if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                        if (/^data:/.test(url2)) url2 = "data:" + url2.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                        if (!window.open(url2)) {
                            if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) location.href = url2;
                        }
                        return true;
                    }
                    var f2 = document.createElement("iframe");
                    document.body.appendChild(f2);
                    if (!winMode && /^data:/.test(url2)) url2 = "data:" + url2.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                    f2.src = url2;
                    setTimeout(function() {
                        document.body.removeChild(f2);
                    }, 333);
                }
                if (navigator.msSaveBlob) return navigator.msSaveBlob(blob, fileName);
                if (self2.URL) saver(self2.URL.createObjectURL(blob), true);
                else {
                    if (typeof blob === "string" || blob.constructor === toString2) try {
                        return saver("data:" + mimeType + ";base64," + self2.btoa(blob));
                    } catch (y4) {
                        return saver("data:" + mimeType + "," + encodeURIComponent(blob));
                    }
                    reader = new FileReader();
                    reader.onload = function(e) {
                        saver(this.result);
                    };
                    reader.readAsDataURL(blob);
                }
                return true;
            };
        });
    }
});
// output/Data.Boolean/index.js
var $a801f2c896bd09f1$var$otherwise = true;
// output/Data.Eq/foreign.js
var $a801f2c896bd09f1$var$refEq = function(r1) {
    return function(r2) {
        return r1 === r2;
    };
};
var $a801f2c896bd09f1$var$eqBooleanImpl = $a801f2c896bd09f1$var$refEq;
var $a801f2c896bd09f1$var$eqIntImpl = $a801f2c896bd09f1$var$refEq;
var $a801f2c896bd09f1$var$eqNumberImpl = $a801f2c896bd09f1$var$refEq;
var $a801f2c896bd09f1$var$eqCharImpl = $a801f2c896bd09f1$var$refEq;
var $a801f2c896bd09f1$var$eqStringImpl = $a801f2c896bd09f1$var$refEq;
var $a801f2c896bd09f1$var$eqArrayImpl = function(f2) {
    return function(xs) {
        return function(ys) {
            if (xs.length !== ys.length) return false;
            for(var i2 = 0; i2 < xs.length; i2++){
                if (!f2(xs[i2])(ys[i2])) return false;
            }
            return true;
        };
    };
};
// output/Type.Proxy/index.js
var $a801f2c896bd09f1$var$$$Proxy = /* @__PURE__ */ function() {
    function $$Proxy2() {}
    $$Proxy2.value = new $$Proxy2();
    return $$Proxy2;
}();
// output/Data.Symbol/index.js
var $a801f2c896bd09f1$var$reflectSymbol = function(dict) {
    return dict.reflectSymbol;
};
// output/Record.Unsafe/foreign.js
var $a801f2c896bd09f1$var$unsafeGet = function(label5) {
    return function(rec) {
        return rec[label5];
    };
};
var $a801f2c896bd09f1$var$unsafeSet = function(label5) {
    return function(value17) {
        return function(rec) {
            var copy2 = {};
            for(var key2 in rec)if (({}).hasOwnProperty.call(rec, key2)) copy2[key2] = rec[key2];
            copy2[label5] = value17;
            return copy2;
        };
    };
};
// output/Data.Eq/index.js
var $a801f2c896bd09f1$var$eqUnit = {
    eq: function(v3) {
        return function(v1) {
            return true;
        };
    }
};
var $a801f2c896bd09f1$var$eqString = {
    eq: $a801f2c896bd09f1$var$eqStringImpl
};
var $a801f2c896bd09f1$var$eqRowNil = {
    eqRecord: function(v3) {
        return function(v1) {
            return function(v22) {
                return true;
            };
        };
    }
};
var $a801f2c896bd09f1$var$eqRecord = function(dict) {
    return dict.eqRecord;
};
var $a801f2c896bd09f1$var$eqRec = function() {
    return function(dictEqRecord) {
        return {
            eq: $a801f2c896bd09f1$var$eqRecord(dictEqRecord)($a801f2c896bd09f1$var$$$Proxy.value)
        };
    };
};
var $a801f2c896bd09f1$var$eqNumber = {
    eq: $a801f2c896bd09f1$var$eqNumberImpl
};
var $a801f2c896bd09f1$var$eqInt = {
    eq: $a801f2c896bd09f1$var$eqIntImpl
};
var $a801f2c896bd09f1$var$eqChar = {
    eq: $a801f2c896bd09f1$var$eqCharImpl
};
var $a801f2c896bd09f1$var$eqBoolean = {
    eq: $a801f2c896bd09f1$var$eqBooleanImpl
};
var $a801f2c896bd09f1$var$eq1 = function(dict) {
    return dict.eq1;
};
var $a801f2c896bd09f1$var$eq = function(dict) {
    return dict.eq;
};
var $a801f2c896bd09f1$var$eq2 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqBoolean);
var $a801f2c896bd09f1$var$eqArray = function(dictEq) {
    return {
        eq: $a801f2c896bd09f1$var$eqArrayImpl($a801f2c896bd09f1$var$eq(dictEq))
    };
};
var $a801f2c896bd09f1$var$eqRowCons = function(dictEqRecord) {
    var eqRecord1 = $a801f2c896bd09f1$var$eqRecord(dictEqRecord);
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
            return function(dictEq) {
                var eq35 = $a801f2c896bd09f1$var$eq(dictEq);
                return {
                    eqRecord: function(v3) {
                        return function(ra) {
                            return function(rb) {
                                var tail2 = eqRecord1($a801f2c896bd09f1$var$$$Proxy.value)(ra)(rb);
                                var key2 = reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value);
                                var get6 = $a801f2c896bd09f1$var$unsafeGet(key2);
                                return eq35(get6(ra))(get6(rb)) && tail2;
                            };
                        };
                    }
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$notEq = function(dictEq) {
    var eq35 = $a801f2c896bd09f1$var$eq(dictEq);
    return function(x4) {
        return function(y4) {
            return $a801f2c896bd09f1$var$eq2(eq35(x4)(y4))(false);
        };
    };
};
// output/Data.Show/foreign.js
var $a801f2c896bd09f1$var$showIntImpl = function(n) {
    return n.toString();
};
var $a801f2c896bd09f1$var$showNumberImpl = function(n) {
    var str = n.toString();
    return isNaN(str + ".0") ? str : str + ".0";
};
var $a801f2c896bd09f1$var$showCharImpl = function(c3) {
    var code3 = c3.charCodeAt(0);
    if (code3 < 32 || code3 === 127) {
        switch(c3){
            case "\x07":
                return "'\\a'";
            case "\b":
                return "'\\b'";
            case "\f":
                return "'\\f'";
            case "\n":
                return "'\\n'";
            case "\r":
                return "'\\r'";
            case "	":
                return "'\\t'";
            case "\v":
                return "'\\v'";
        }
        return "'\\" + code3.toString(10) + "'";
    }
    return c3 === "'" || c3 === "\\" ? "'\\" + c3 + "'" : "'" + c3 + "'";
};
var $a801f2c896bd09f1$var$showStringImpl = function(s2) {
    var l2 = s2.length;
    return '"' + s2.replace(/[\0-\x1F\x7F"\\]/g, // eslint-disable-line no-control-regex
    function(c3, i2) {
        switch(c3){
            case '"':
            case "\\":
                return "\\" + c3;
            case "\x07":
                return "\\a";
            case "\b":
                return "\\b";
            case "\f":
                return "\\f";
            case "\n":
                return "\\n";
            case "\r":
                return "\\r";
            case "	":
                return "\\t";
            case "\v":
                return "\\v";
        }
        var k2 = i2 + 1;
        var empty8 = k2 < l2 && s2[k2] >= "0" && s2[k2] <= "9" ? "\\&" : "";
        return "\\" + c3.charCodeAt(0).toString(10) + empty8;
    }) + '"';
};
var $a801f2c896bd09f1$var$showArrayImpl = function(f2) {
    return function(xs) {
        var ss = [];
        for(var i2 = 0, l2 = xs.length; i2 < l2; i2++)ss[i2] = f2(xs[i2]);
        return "[" + ss.join(",") + "]";
    };
};
// output/Data.Show/index.js
var $a801f2c896bd09f1$var$showString = {
    show: $a801f2c896bd09f1$var$showStringImpl
};
var $a801f2c896bd09f1$var$showRecordFields = function(dict) {
    return dict.showRecordFields;
};
var $a801f2c896bd09f1$var$showRecord = function() {
    return function() {
        return function(dictShowRecordFields) {
            var showRecordFields1 = $a801f2c896bd09f1$var$showRecordFields(dictShowRecordFields);
            return {
                show: function(record) {
                    return "{" + (showRecordFields1($a801f2c896bd09f1$var$$$Proxy.value)(record) + "}");
                }
            };
        };
    };
};
var $a801f2c896bd09f1$var$showNumber = {
    show: $a801f2c896bd09f1$var$showNumberImpl
};
var $a801f2c896bd09f1$var$showInt = {
    show: $a801f2c896bd09f1$var$showIntImpl
};
var $a801f2c896bd09f1$var$showChar = {
    show: $a801f2c896bd09f1$var$showCharImpl
};
var $a801f2c896bd09f1$var$showBoolean = {
    show: function(v3) {
        if (v3) return "true";
        if (!v3) return "false";
        throw new Error("Failed pattern match at Data.Show (line 29, column 1 - line 31, column 23): " + [
            v3.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$show = function(dict) {
    return dict.show;
};
var $a801f2c896bd09f1$var$showArray = function(dictShow) {
    return {
        show: $a801f2c896bd09f1$var$showArrayImpl($a801f2c896bd09f1$var$show(dictShow))
    };
};
var $a801f2c896bd09f1$var$showRecordFieldsCons = function(dictIsSymbol) {
    var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
    return function(dictShowRecordFields) {
        var showRecordFields1 = $a801f2c896bd09f1$var$showRecordFields(dictShowRecordFields);
        return function(dictShow) {
            var show115 = $a801f2c896bd09f1$var$show(dictShow);
            return {
                showRecordFields: function(v3) {
                    return function(record) {
                        var tail2 = showRecordFields1($a801f2c896bd09f1$var$$$Proxy.value)(record);
                        var key2 = reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value);
                        var focus3 = $a801f2c896bd09f1$var$unsafeGet(key2)(record);
                        return " " + (key2 + (": " + (show115(focus3) + ("," + tail2))));
                    };
                }
            };
        };
    };
};
var $a801f2c896bd09f1$var$showRecordFieldsConsNil = function(dictIsSymbol) {
    var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
    return function(dictShow) {
        var show115 = $a801f2c896bd09f1$var$show(dictShow);
        return {
            showRecordFields: function(v3) {
                return function(record) {
                    var key2 = reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value);
                    var focus3 = $a801f2c896bd09f1$var$unsafeGet(key2)(record);
                    return " " + (key2 + (": " + (show115(focus3) + " ")));
                };
            }
        };
    };
};
// output/Data.Generic.Rep/index.js
var $a801f2c896bd09f1$var$Inl = /* @__PURE__ */ function() {
    function Inl2(value0) {
        this.value0 = value0;
    }
    Inl2.create = function(value0) {
        return new Inl2(value0);
    };
    return Inl2;
}();
var $a801f2c896bd09f1$var$Inr = /* @__PURE__ */ function() {
    function Inr2(value0) {
        this.value0 = value0;
    }
    Inr2.create = function(value0) {
        return new Inr2(value0);
    };
    return Inr2;
}();
var $a801f2c896bd09f1$var$NoArguments = /* @__PURE__ */ function() {
    function NoArguments2() {}
    NoArguments2.value = new NoArguments2();
    return NoArguments2;
}();
var $a801f2c896bd09f1$var$from = function(dict) {
    return dict.from;
};
// output/Data.Functor/foreign.js
var $a801f2c896bd09f1$var$arrayMap = function(f2) {
    return function(arr) {
        var l2 = arr.length;
        var result2 = new Array(l2);
        for(var i2 = 0; i2 < l2; i2++)result2[i2] = f2(arr[i2]);
        return result2;
    };
};
// output/Control.Semigroupoid/index.js
var $a801f2c896bd09f1$var$semigroupoidFn = {
    compose: function(f2) {
        return function(g2) {
            return function(x4) {
                return f2(g2(x4));
            };
        };
    }
};
var $a801f2c896bd09f1$var$compose = function(dict) {
    return dict.compose;
};
// output/Control.Category/index.js
var $a801f2c896bd09f1$var$identity = function(dict) {
    return dict.identity;
};
var $a801f2c896bd09f1$var$categoryFn = {
    identity: function(x4) {
        return x4;
    },
    Semigroupoid0: function() {
        return $a801f2c896bd09f1$var$semigroupoidFn;
    }
};
// output/Data.Function/index.js
var $a801f2c896bd09f1$var$flip = function(f2) {
    return function(b3) {
        return function(a3) {
            return f2(a3)(b3);
        };
    };
};
var $a801f2c896bd09f1$var$$$const = function(a3) {
    return function(v3) {
        return a3;
    };
};
var $a801f2c896bd09f1$var$applyFlipped = function(x4) {
    return function(f2) {
        return f2(x4);
    };
};
// output/Data.Unit/foreign.js
var $a801f2c896bd09f1$var$unit = void 0;
// output/Data.Functor/index.js
var $a801f2c896bd09f1$var$map = function(dict) {
    return dict.map;
};
var $a801f2c896bd09f1$var$mapFlipped = function(dictFunctor) {
    var map121 = $a801f2c896bd09f1$var$map(dictFunctor);
    return function(fa) {
        return function(f2) {
            return map121(f2)(fa);
        };
    };
};
var $a801f2c896bd09f1$var$$$void = function(dictFunctor) {
    return $a801f2c896bd09f1$var$map(dictFunctor)($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$unit));
};
var $a801f2c896bd09f1$var$voidLeft = function(dictFunctor) {
    var map121 = $a801f2c896bd09f1$var$map(dictFunctor);
    return function(f2) {
        return function(x4) {
            return map121($a801f2c896bd09f1$var$$$const(x4))(f2);
        };
    };
};
var $a801f2c896bd09f1$var$voidRight = function(dictFunctor) {
    var map121 = $a801f2c896bd09f1$var$map(dictFunctor);
    return function(x4) {
        return map121($a801f2c896bd09f1$var$$$const(x4));
    };
};
var $a801f2c896bd09f1$var$functorArray = {
    map: $a801f2c896bd09f1$var$arrayMap
};
// output/Data.Semigroup/foreign.js
var $a801f2c896bd09f1$var$concatString = function(s1) {
    return function(s2) {
        return s1 + s2;
    };
};
var $a801f2c896bd09f1$var$concatArray = function(xs) {
    return function(ys) {
        if (xs.length === 0) return ys;
        if (ys.length === 0) return xs;
        return xs.concat(ys);
    };
};
// output/Data.Semigroup/index.js
var $a801f2c896bd09f1$var$semigroupString = {
    append: $a801f2c896bd09f1$var$concatString
};
var $a801f2c896bd09f1$var$semigroupRecordNil = {
    appendRecord: function(v3) {
        return function(v1) {
            return function(v22) {
                return {};
            };
        };
    }
};
var $a801f2c896bd09f1$var$semigroupArray = {
    append: $a801f2c896bd09f1$var$concatArray
};
var $a801f2c896bd09f1$var$appendRecord = function(dict) {
    return dict.appendRecord;
};
var $a801f2c896bd09f1$var$semigroupRecord = function() {
    return function(dictSemigroupRecord) {
        return {
            append: $a801f2c896bd09f1$var$appendRecord(dictSemigroupRecord)($a801f2c896bd09f1$var$$$Proxy.value)
        };
    };
};
var $a801f2c896bd09f1$var$append = function(dict) {
    return dict.append;
};
var $a801f2c896bd09f1$var$semigroupRecordCons = function(dictIsSymbol) {
    var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
    return function() {
        return function(dictSemigroupRecord) {
            var appendRecord1 = $a801f2c896bd09f1$var$appendRecord(dictSemigroupRecord);
            return function(dictSemigroup) {
                var append18 = $a801f2c896bd09f1$var$append(dictSemigroup);
                return {
                    appendRecord: function(v3) {
                        return function(ra) {
                            return function(rb) {
                                var tail2 = appendRecord1($a801f2c896bd09f1$var$$$Proxy.value)(ra)(rb);
                                var key2 = reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value);
                                var insert17 = $a801f2c896bd09f1$var$unsafeSet(key2);
                                var get6 = $a801f2c896bd09f1$var$unsafeGet(key2);
                                return insert17(append18(get6(ra))(get6(rb)))(tail2);
                            };
                        };
                    }
                };
            };
        };
    };
};
// output/Control.Alt/index.js
var $a801f2c896bd09f1$var$altArray = {
    alt: /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray),
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorArray;
    }
};
var $a801f2c896bd09f1$var$alt = function(dict) {
    return dict.alt;
};
// output/Control.Apply/foreign.js
var $a801f2c896bd09f1$var$arrayApply = function(fs) {
    return function(xs) {
        var l2 = fs.length;
        var k2 = xs.length;
        var result2 = new Array(l2 * k2);
        var n = 0;
        for(var i2 = 0; i2 < l2; i2++){
            var f2 = fs[i2];
            for(var j2 = 0; j2 < k2; j2++)result2[n++] = f2(xs[j2]);
        }
        return result2;
    };
};
// output/Control.Apply/index.js
var $a801f2c896bd09f1$var$identity2 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$applyArray = {
    apply: $a801f2c896bd09f1$var$arrayApply,
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorArray;
    }
};
var $a801f2c896bd09f1$var$apply = function(dict) {
    return dict.apply;
};
var $a801f2c896bd09f1$var$applySecond = function(dictApply) {
    var apply1 = $a801f2c896bd09f1$var$apply(dictApply);
    var map59 = $a801f2c896bd09f1$var$map(dictApply.Functor0());
    return function(a3) {
        return function(b3) {
            return apply1(map59($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$identity2))(a3))(b3);
        };
    };
};
// output/Control.Applicative/index.js
var $a801f2c896bd09f1$var$pure = function(dict) {
    return dict.pure;
};
var $a801f2c896bd09f1$var$unless = function(dictApplicative) {
    var pure116 = $a801f2c896bd09f1$var$pure(dictApplicative);
    return function(v3) {
        return function(v1) {
            if (!v3) return v1;
            if (v3) return pure116($a801f2c896bd09f1$var$unit);
            throw new Error("Failed pattern match at Control.Applicative (line 68, column 1 - line 68, column 65): " + [
                v3.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$when = function(dictApplicative) {
    var pure116 = $a801f2c896bd09f1$var$pure(dictApplicative);
    return function(v3) {
        return function(v1) {
            if (v3) return v1;
            if (!v3) return pure116($a801f2c896bd09f1$var$unit);
            throw new Error("Failed pattern match at Control.Applicative (line 63, column 1 - line 63, column 63): " + [
                v3.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$liftA1 = function(dictApplicative) {
    var apply4 = $a801f2c896bd09f1$var$apply(dictApplicative.Apply0());
    var pure116 = $a801f2c896bd09f1$var$pure(dictApplicative);
    return function(f2) {
        return function(a3) {
            return apply4(pure116(f2))(a3);
        };
    };
};
var $a801f2c896bd09f1$var$applicativeArray = {
    pure: function(x4) {
        return [
            x4
        ];
    },
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyArray;
    }
};
// output/Data.Bounded/foreign.js
var $a801f2c896bd09f1$var$topChar = String.fromCharCode(65535);
var $a801f2c896bd09f1$var$bottomChar = String.fromCharCode(0);
var $a801f2c896bd09f1$var$topNumber = Number.POSITIVE_INFINITY;
var $a801f2c896bd09f1$var$bottomNumber = Number.NEGATIVE_INFINITY;
// output/Data.Ord/foreign.js
var $a801f2c896bd09f1$var$unsafeCompareImpl = function(lt2) {
    return function(eq29) {
        return function(gt) {
            return function(x4) {
                return function(y4) {
                    return x4 < y4 ? lt2 : x4 === y4 ? eq29 : gt;
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$ordIntImpl = $a801f2c896bd09f1$var$unsafeCompareImpl;
var $a801f2c896bd09f1$var$ordNumberImpl = $a801f2c896bd09f1$var$unsafeCompareImpl;
var $a801f2c896bd09f1$var$ordStringImpl = $a801f2c896bd09f1$var$unsafeCompareImpl;
var $a801f2c896bd09f1$var$ordCharImpl = $a801f2c896bd09f1$var$unsafeCompareImpl;
var $a801f2c896bd09f1$var$ordArrayImpl = function(f2) {
    return function(xs) {
        return function(ys) {
            var i2 = 0;
            var xlen = xs.length;
            var ylen = ys.length;
            while(i2 < xlen && i2 < ylen){
                var x4 = xs[i2];
                var y4 = ys[i2];
                var o2 = f2(x4)(y4);
                if (o2 !== 0) return o2;
                i2++;
            }
            if (xlen === ylen) return 0;
            else if (xlen > ylen) return -1;
            else return 1;
        };
    };
};
// output/Data.Ordering/index.js
var $a801f2c896bd09f1$var$LT = /* @__PURE__ */ function() {
    function LT2() {}
    LT2.value = new LT2();
    return LT2;
}();
var $a801f2c896bd09f1$var$GT = /* @__PURE__ */ function() {
    function GT2() {}
    GT2.value = new GT2();
    return GT2;
}();
var $a801f2c896bd09f1$var$EQ = /* @__PURE__ */ function() {
    function EQ2() {}
    EQ2.value = new EQ2();
    return EQ2;
}();
var $a801f2c896bd09f1$var$invert = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$GT) return $a801f2c896bd09f1$var$LT.value;
    if (v3 instanceof $a801f2c896bd09f1$var$EQ) return $a801f2c896bd09f1$var$EQ.value;
    if (v3 instanceof $a801f2c896bd09f1$var$LT) return $a801f2c896bd09f1$var$GT.value;
    throw new Error("Failed pattern match at Data.Ordering (line 33, column 1 - line 33, column 31): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$eqOrdering = {
    eq: function(v3) {
        return function(v1) {
            if (v3 instanceof $a801f2c896bd09f1$var$LT && v1 instanceof $a801f2c896bd09f1$var$LT) return true;
            if (v3 instanceof $a801f2c896bd09f1$var$GT && v1 instanceof $a801f2c896bd09f1$var$GT) return true;
            if (v3 instanceof $a801f2c896bd09f1$var$EQ && v1 instanceof $a801f2c896bd09f1$var$EQ) return true;
            return false;
        };
    }
};
// output/Data.Ring/foreign.js
var $a801f2c896bd09f1$var$intSub = function(x4) {
    return function(y4) {
        return x4 - y4 | 0;
    };
};
// output/Data.Semiring/foreign.js
var $a801f2c896bd09f1$var$intAdd = function(x4) {
    return function(y4) {
        return x4 + y4 | 0;
    };
};
var $a801f2c896bd09f1$var$intMul = function(x4) {
    return function(y4) {
        return x4 * y4 | 0;
    };
};
// output/Data.Semiring/index.js
var $a801f2c896bd09f1$var$zero = function(dict) {
    return dict.zero;
};
var $a801f2c896bd09f1$var$semiringInt = {
    add: $a801f2c896bd09f1$var$intAdd,
    zero: 0,
    mul: $a801f2c896bd09f1$var$intMul,
    one: 1
};
var $a801f2c896bd09f1$var$one = function(dict) {
    return dict.one;
};
var $a801f2c896bd09f1$var$mul = function(dict) {
    return dict.mul;
};
var $a801f2c896bd09f1$var$add = function(dict) {
    return dict.add;
};
// output/Data.Ring/index.js
var $a801f2c896bd09f1$var$sub = function(dict) {
    return dict.sub;
};
var $a801f2c896bd09f1$var$ringInt = {
    sub: $a801f2c896bd09f1$var$intSub,
    Semiring0: function() {
        return $a801f2c896bd09f1$var$semiringInt;
    }
};
var $a801f2c896bd09f1$var$negate = function(dictRing) {
    var sub1 = $a801f2c896bd09f1$var$sub(dictRing);
    var zero2 = $a801f2c896bd09f1$var$zero(dictRing.Semiring0());
    return function(a3) {
        return sub1(zero2)(a3);
    };
};
// output/Data.Ord/index.js
var $a801f2c896bd09f1$var$eqRec2 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec();
var $a801f2c896bd09f1$var$notEq2 = /* @__PURE__ */ $a801f2c896bd09f1$var$notEq($a801f2c896bd09f1$var$eqOrdering);
var $a801f2c896bd09f1$var$ordString = /* @__PURE__ */ function() {
    return {
        compare: $a801f2c896bd09f1$var$ordStringImpl($a801f2c896bd09f1$var$LT.value)($a801f2c896bd09f1$var$EQ.value)($a801f2c896bd09f1$var$GT.value),
        Eq0: function() {
            return $a801f2c896bd09f1$var$eqString;
        }
    };
}();
var $a801f2c896bd09f1$var$ordRecordNil = {
    compareRecord: function(v3) {
        return function(v1) {
            return function(v22) {
                return $a801f2c896bd09f1$var$EQ.value;
            };
        };
    },
    EqRecord0: function() {
        return $a801f2c896bd09f1$var$eqRowNil;
    }
};
var $a801f2c896bd09f1$var$ordNumber = /* @__PURE__ */ function() {
    return {
        compare: $a801f2c896bd09f1$var$ordNumberImpl($a801f2c896bd09f1$var$LT.value)($a801f2c896bd09f1$var$EQ.value)($a801f2c896bd09f1$var$GT.value),
        Eq0: function() {
            return $a801f2c896bd09f1$var$eqNumber;
        }
    };
}();
var $a801f2c896bd09f1$var$ordInt = /* @__PURE__ */ function() {
    return {
        compare: $a801f2c896bd09f1$var$ordIntImpl($a801f2c896bd09f1$var$LT.value)($a801f2c896bd09f1$var$EQ.value)($a801f2c896bd09f1$var$GT.value),
        Eq0: function() {
            return $a801f2c896bd09f1$var$eqInt;
        }
    };
}();
var $a801f2c896bd09f1$var$ordChar = /* @__PURE__ */ function() {
    return {
        compare: $a801f2c896bd09f1$var$ordCharImpl($a801f2c896bd09f1$var$LT.value)($a801f2c896bd09f1$var$EQ.value)($a801f2c896bd09f1$var$GT.value),
        Eq0: function() {
            return $a801f2c896bd09f1$var$eqChar;
        }
    };
}();
var $a801f2c896bd09f1$var$compareRecord = function(dict) {
    return dict.compareRecord;
};
var $a801f2c896bd09f1$var$ordRecord = function() {
    return function(dictOrdRecord) {
        var eqRec13 = $a801f2c896bd09f1$var$eqRec2(dictOrdRecord.EqRecord0());
        return {
            compare: $a801f2c896bd09f1$var$compareRecord(dictOrdRecord)($a801f2c896bd09f1$var$$$Proxy.value),
            Eq0: function() {
                return eqRec13;
            }
        };
    };
};
var $a801f2c896bd09f1$var$compare = function(dict) {
    return dict.compare;
};
var $a801f2c896bd09f1$var$compare2 = /* @__PURE__ */ $a801f2c896bd09f1$var$compare($a801f2c896bd09f1$var$ordInt);
var $a801f2c896bd09f1$var$comparing = function(dictOrd) {
    var compare32 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(f2) {
        return function(x4) {
            return function(y4) {
                return compare32(f2(x4))(f2(y4));
            };
        };
    };
};
var $a801f2c896bd09f1$var$greaterThan = function(dictOrd) {
    var compare32 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(a1) {
        return function(a22) {
            var v3 = compare32(a1)(a22);
            if (v3 instanceof $a801f2c896bd09f1$var$GT) return true;
            return false;
        };
    };
};
var $a801f2c896bd09f1$var$greaterThanOrEq = function(dictOrd) {
    var compare32 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(a1) {
        return function(a22) {
            var v3 = compare32(a1)(a22);
            if (v3 instanceof $a801f2c896bd09f1$var$LT) return false;
            return true;
        };
    };
};
var $a801f2c896bd09f1$var$lessThan = function(dictOrd) {
    var compare32 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(a1) {
        return function(a22) {
            var v3 = compare32(a1)(a22);
            if (v3 instanceof $a801f2c896bd09f1$var$LT) return true;
            return false;
        };
    };
};
var $a801f2c896bd09f1$var$signum = function(dictOrd) {
    var lessThan1 = $a801f2c896bd09f1$var$lessThan(dictOrd);
    var greaterThan1 = $a801f2c896bd09f1$var$greaterThan(dictOrd);
    return function(dictRing) {
        var Semiring0 = dictRing.Semiring0();
        var zero2 = $a801f2c896bd09f1$var$zero(Semiring0);
        var negate1 = $a801f2c896bd09f1$var$negate(dictRing);
        var one2 = $a801f2c896bd09f1$var$one(Semiring0);
        return function(x4) {
            var $89 = lessThan1(x4)(zero2);
            if ($89) return negate1(one2);
            var $90 = greaterThan1(x4)(zero2);
            if ($90) return one2;
            return x4;
        };
    };
};
var $a801f2c896bd09f1$var$max = function(dictOrd) {
    var compare32 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(x4) {
        return function(y4) {
            var v3 = compare32(x4)(y4);
            if (v3 instanceof $a801f2c896bd09f1$var$LT) return y4;
            if (v3 instanceof $a801f2c896bd09f1$var$EQ) return x4;
            if (v3 instanceof $a801f2c896bd09f1$var$GT) return x4;
            throw new Error("Failed pattern match at Data.Ord (line 181, column 3 - line 184, column 12): " + [
                v3.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$min = function(dictOrd) {
    var compare32 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(x4) {
        return function(y4) {
            var v3 = compare32(x4)(y4);
            if (v3 instanceof $a801f2c896bd09f1$var$LT) return x4;
            if (v3 instanceof $a801f2c896bd09f1$var$EQ) return x4;
            if (v3 instanceof $a801f2c896bd09f1$var$GT) return y4;
            throw new Error("Failed pattern match at Data.Ord (line 172, column 3 - line 175, column 12): " + [
                v3.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$ordArray = function(dictOrd) {
    var compare32 = $a801f2c896bd09f1$var$compare(dictOrd);
    var eqArray3 = $a801f2c896bd09f1$var$eqArray(dictOrd.Eq0());
    return {
        compare: /* @__PURE__ */ function() {
            var toDelta = function(x4) {
                return function(y4) {
                    var v3 = compare32(x4)(y4);
                    if (v3 instanceof $a801f2c896bd09f1$var$EQ) return 0;
                    if (v3 instanceof $a801f2c896bd09f1$var$LT) return 1;
                    if (v3 instanceof $a801f2c896bd09f1$var$GT) return -1;
                    throw new Error("Failed pattern match at Data.Ord (line 79, column 7 - line 82, column 17): " + [
                        v3.constructor.name
                    ]);
                };
            };
            return function(xs) {
                return function(ys) {
                    return $a801f2c896bd09f1$var$compare2(0)($a801f2c896bd09f1$var$ordArrayImpl(toDelta)(xs)(ys));
                };
            };
        }(),
        Eq0: function() {
            return eqArray3;
        }
    };
};
var $a801f2c896bd09f1$var$ordRecordCons = function(dictOrdRecord) {
    var compareRecord1 = $a801f2c896bd09f1$var$compareRecord(dictOrdRecord);
    var eqRowCons5 = $a801f2c896bd09f1$var$eqRowCons(dictOrdRecord.EqRecord0())();
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
            var eqRowCons12 = eqRowCons5(dictIsSymbol);
            return function(dictOrd) {
                var compare32 = $a801f2c896bd09f1$var$compare(dictOrd);
                var eqRowCons22 = eqRowCons12(dictOrd.Eq0());
                return {
                    compareRecord: function(v3) {
                        return function(ra) {
                            return function(rb) {
                                var key2 = reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value);
                                var left = compare32($a801f2c896bd09f1$var$unsafeGet(key2)(ra))($a801f2c896bd09f1$var$unsafeGet(key2)(rb));
                                var $95 = $a801f2c896bd09f1$var$notEq2(left)($a801f2c896bd09f1$var$EQ.value);
                                if ($95) return left;
                                return compareRecord1($a801f2c896bd09f1$var$$$Proxy.value)(ra)(rb);
                            };
                        };
                    },
                    EqRecord0: function() {
                        return eqRowCons22;
                    }
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$abs = function(dictOrd) {
    var greaterThanOrEq1 = $a801f2c896bd09f1$var$greaterThanOrEq(dictOrd);
    return function(dictRing) {
        var zero2 = $a801f2c896bd09f1$var$zero(dictRing.Semiring0());
        var negate1 = $a801f2c896bd09f1$var$negate(dictRing);
        return function(x4) {
            var $99 = greaterThanOrEq1(x4)(zero2);
            if ($99) return x4;
            return negate1(x4);
        };
    };
};
// output/Data.Bounded/index.js
var $a801f2c896bd09f1$var$top = function(dict) {
    return dict.top;
};
var $a801f2c896bd09f1$var$boundedChar = {
    top: $a801f2c896bd09f1$var$topChar,
    bottom: $a801f2c896bd09f1$var$bottomChar,
    Ord0: function() {
        return $a801f2c896bd09f1$var$ordChar;
    }
};
var $a801f2c896bd09f1$var$bottom = function(dict) {
    return dict.bottom;
};
// output/Data.Maybe/index.js
var $a801f2c896bd09f1$var$identity3 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$Nothing = /* @__PURE__ */ function() {
    function Nothing2() {}
    Nothing2.value = new Nothing2();
    return Nothing2;
}();
var $a801f2c896bd09f1$var$Just = /* @__PURE__ */ function() {
    function Just2(value0) {
        this.value0 = value0;
    }
    Just2.create = function(value0) {
        return new Just2(value0);
    };
    return Just2;
}();
var $a801f2c896bd09f1$var$showMaybe = function(dictShow) {
    var show40 = $a801f2c896bd09f1$var$show(dictShow);
    return {
        show: function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Just) return "(Just " + (show40(v3.value0) + ")");
            if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return "Nothing";
            throw new Error("Failed pattern match at Data.Maybe (line 223, column 1 - line 225, column 28): " + [
                v3.constructor.name
            ]);
        }
    };
};
var $a801f2c896bd09f1$var$maybe = function(v3) {
    return function(v1) {
        return function(v22) {
            if (v22 instanceof $a801f2c896bd09f1$var$Nothing) return v3;
            if (v22 instanceof $a801f2c896bd09f1$var$Just) return v1(v22.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 237, column 1 - line 237, column 51): " + [
                v3.constructor.name,
                v1.constructor.name,
                v22.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$isNothing = /* @__PURE__ */ $a801f2c896bd09f1$var$maybe(true)(/* @__PURE__ */ $a801f2c896bd09f1$var$$$const(false));
var $a801f2c896bd09f1$var$isJust = /* @__PURE__ */ $a801f2c896bd09f1$var$maybe(false)(/* @__PURE__ */ $a801f2c896bd09f1$var$$$const(true));
var $a801f2c896bd09f1$var$functorMaybe = {
    map: function(v3) {
        return function(v1) {
            if (v1 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Just(v3(v1.value0));
            return $a801f2c896bd09f1$var$Nothing.value;
        };
    }
};
var $a801f2c896bd09f1$var$map2 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$fromMaybe = function(a3) {
    return $a801f2c896bd09f1$var$maybe(a3)($a801f2c896bd09f1$var$identity3);
};
var $a801f2c896bd09f1$var$fromJust = function() {
    return function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$Just) return v3.value0;
        throw new Error("Failed pattern match at Data.Maybe (line 288, column 1 - line 288, column 46): " + [
            v3.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$eqMaybe = function(dictEq) {
    var eq29 = $a801f2c896bd09f1$var$eq(dictEq);
    return {
        eq: function(x4) {
            return function(y4) {
                if (x4 instanceof $a801f2c896bd09f1$var$Nothing && y4 instanceof $a801f2c896bd09f1$var$Nothing) return true;
                if (x4 instanceof $a801f2c896bd09f1$var$Just && y4 instanceof $a801f2c896bd09f1$var$Just) return eq29(x4.value0)(y4.value0);
                return false;
            };
        }
    };
};
var $a801f2c896bd09f1$var$ordMaybe = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    var eqMaybe1 = $a801f2c896bd09f1$var$eqMaybe(dictOrd.Eq0());
    return {
        compare: function(x4) {
            return function(y4) {
                if (x4 instanceof $a801f2c896bd09f1$var$Nothing && y4 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$EQ.value;
                if (x4 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$LT.value;
                if (y4 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$GT.value;
                if (x4 instanceof $a801f2c896bd09f1$var$Just && y4 instanceof $a801f2c896bd09f1$var$Just) return compare6(x4.value0)(y4.value0);
                throw new Error("Failed pattern match at Data.Maybe (line 0, column 0 - line 0, column 0): " + [
                    x4.constructor.name,
                    y4.constructor.name
                ]);
            };
        },
        Eq0: function() {
            return eqMaybe1;
        }
    };
};
var $a801f2c896bd09f1$var$applyMaybe = {
    apply: function(v3) {
        return function(v1) {
            if (v3 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$map2(v3.value0)(v1);
            if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$Nothing.value;
            throw new Error("Failed pattern match at Data.Maybe (line 67, column 1 - line 69, column 30): " + [
                v3.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorMaybe;
    }
};
var $a801f2c896bd09f1$var$bindMaybe = {
    bind: function(v3) {
        return function(v1) {
            if (v3 instanceof $a801f2c896bd09f1$var$Just) return v1(v3.value0);
            if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$Nothing.value;
            throw new Error("Failed pattern match at Data.Maybe (line 125, column 1 - line 127, column 28): " + [
                v3.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyMaybe;
    }
};
var $a801f2c896bd09f1$var$applicativeMaybe = /* @__PURE__ */ function() {
    return {
        pure: $a801f2c896bd09f1$var$Just.create,
        Apply0: function() {
            return $a801f2c896bd09f1$var$applyMaybe;
        }
    };
}();
// output/Data.EuclideanRing/foreign.js
var $a801f2c896bd09f1$var$intDegree = function(x4) {
    return Math.min(Math.abs(x4), 2147483647);
};
var $a801f2c896bd09f1$var$intDiv = function(x4) {
    return function(y4) {
        if (y4 === 0) return 0;
        return y4 > 0 ? Math.floor(x4 / y4) : -Math.floor(x4 / -y4);
    };
};
var $a801f2c896bd09f1$var$intMod = function(x4) {
    return function(y4) {
        if (y4 === 0) return 0;
        var yy = Math.abs(y4);
        return (x4 % yy + yy) % yy;
    };
};
// output/Data.CommutativeRing/index.js
var $a801f2c896bd09f1$var$commutativeRingInt = {
    Ring0: function() {
        return $a801f2c896bd09f1$var$ringInt;
    }
};
// output/Data.EuclideanRing/index.js
var $a801f2c896bd09f1$var$mod = function(dict) {
    return dict.mod;
};
var $a801f2c896bd09f1$var$gcd = function(dictEq) {
    var eq29 = $a801f2c896bd09f1$var$eq(dictEq);
    return function(dictEuclideanRing) {
        var zero2 = $a801f2c896bd09f1$var$zero(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0());
        var mod1 = $a801f2c896bd09f1$var$mod(dictEuclideanRing);
        return function(a3) {
            return function(b3) {
                var $24 = eq29(b3)(zero2);
                if ($24) return a3;
                return $a801f2c896bd09f1$var$gcd(dictEq)(dictEuclideanRing)(b3)(mod1(a3)(b3));
            };
        };
    };
};
var $a801f2c896bd09f1$var$euclideanRingInt = {
    degree: $a801f2c896bd09f1$var$intDegree,
    div: $a801f2c896bd09f1$var$intDiv,
    mod: $a801f2c896bd09f1$var$intMod,
    CommutativeRing0: function() {
        return $a801f2c896bd09f1$var$commutativeRingInt;
    }
};
var $a801f2c896bd09f1$var$div = function(dict) {
    return dict.div;
};
// output/Data.Monoid/index.js
var $a801f2c896bd09f1$var$semigroupRecord2 = /* @__PURE__ */ $a801f2c896bd09f1$var$semigroupRecord();
var $a801f2c896bd09f1$var$mod2 = /* @__PURE__ */ $a801f2c896bd09f1$var$mod($a801f2c896bd09f1$var$euclideanRingInt);
var $a801f2c896bd09f1$var$div2 = /* @__PURE__ */ $a801f2c896bd09f1$var$div($a801f2c896bd09f1$var$euclideanRingInt);
var $a801f2c896bd09f1$var$monoidString = {
    mempty: "",
    Semigroup0: function() {
        return $a801f2c896bd09f1$var$semigroupString;
    }
};
var $a801f2c896bd09f1$var$monoidRecordNil = {
    memptyRecord: function(v3) {
        return {};
    },
    SemigroupRecord0: function() {
        return $a801f2c896bd09f1$var$semigroupRecordNil;
    }
};
var $a801f2c896bd09f1$var$monoidArray = {
    mempty: [],
    Semigroup0: function() {
        return $a801f2c896bd09f1$var$semigroupArray;
    }
};
var $a801f2c896bd09f1$var$memptyRecord = function(dict) {
    return dict.memptyRecord;
};
var $a801f2c896bd09f1$var$monoidRecord = function() {
    return function(dictMonoidRecord) {
        var semigroupRecord1 = $a801f2c896bd09f1$var$semigroupRecord2(dictMonoidRecord.SemigroupRecord0());
        return {
            mempty: $a801f2c896bd09f1$var$memptyRecord(dictMonoidRecord)($a801f2c896bd09f1$var$$$Proxy.value),
            Semigroup0: function() {
                return semigroupRecord1;
            }
        };
    };
};
var $a801f2c896bd09f1$var$mempty = function(dict) {
    return dict.mempty;
};
var $a801f2c896bd09f1$var$monoidRecordCons = function(dictIsSymbol) {
    var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
    var semigroupRecordCons2 = $a801f2c896bd09f1$var$semigroupRecordCons(dictIsSymbol)();
    return function(dictMonoid) {
        var mempty12 = $a801f2c896bd09f1$var$mempty(dictMonoid);
        var Semigroup0 = dictMonoid.Semigroup0();
        return function() {
            return function(dictMonoidRecord) {
                var memptyRecord1 = $a801f2c896bd09f1$var$memptyRecord(dictMonoidRecord);
                var semigroupRecordCons1 = semigroupRecordCons2(dictMonoidRecord.SemigroupRecord0())(Semigroup0);
                return {
                    memptyRecord: function(v3) {
                        var tail2 = memptyRecord1($a801f2c896bd09f1$var$$$Proxy.value);
                        var key2 = reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value);
                        var insert17 = $a801f2c896bd09f1$var$unsafeSet(key2);
                        return insert17(mempty12)(tail2);
                    },
                    SemigroupRecord0: function() {
                        return semigroupRecordCons1;
                    }
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$power = function(dictMonoid) {
    var mempty12 = $a801f2c896bd09f1$var$mempty(dictMonoid);
    var append18 = $a801f2c896bd09f1$var$append(dictMonoid.Semigroup0());
    return function(x4) {
        var go2 = function(p3) {
            if (p3 <= 0) return mempty12;
            if (p3 === 1) return x4;
            if ($a801f2c896bd09f1$var$mod2(p3)(2) === 0) {
                var x$prime = go2($a801f2c896bd09f1$var$div2(p3)(2));
                return append18(x$prime)(x$prime);
            }
            if ($a801f2c896bd09f1$var$otherwise) {
                var x$prime = go2($a801f2c896bd09f1$var$div2(p3)(2));
                return append18(x$prime)(append18(x$prime)(x4));
            }
            throw new Error("Failed pattern match at Data.Monoid (line 88, column 3 - line 88, column 17): " + [
                p3.constructor.name
            ]);
        };
        return go2;
    };
};
// output/Data.Group/index.js
var $a801f2c896bd09f1$var$ginverse = function(dict) {
    return dict.ginverse;
};
// output/Data.Pitches.Class/index.js
var $a801f2c896bd09f1$var$map3 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$eq3 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqOrdering);
var $a801f2c896bd09f1$var$Pitch = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$ordPitch = function(dictOrd) {
    return dictOrd;
};
var $a801f2c896bd09f1$var$functorPitch = {
    map: function(f2) {
        return function(m3) {
            return f2(m3);
        };
    }
};
var $a801f2c896bd09f1$var$map1 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorPitch);
var $a801f2c896bd09f1$var$eqPitch = function(dictEq) {
    return dictEq;
};
var $a801f2c896bd09f1$var$writeImplPitch = function(dict) {
    return dict.writeImplPitch;
};
var $a801f2c896bd09f1$var$writeForeignPitch = function(dictWriteForeignPitch) {
    var writeImplPitch1 = $a801f2c896bd09f1$var$writeImplPitch(dictWriteForeignPitch);
    return {
        writeImpl: function(v3) {
            return writeImplPitch1(v3);
        }
    };
};
var $a801f2c896bd09f1$var$unison = function(dictInterval) {
    return $a801f2c896bd09f1$var$mempty(dictInterval.Group0().Monoid0());
};
var $a801f2c896bd09f1$var$showPitchNotation = function(dict) {
    return dict.showPitchNotation;
};
var $a801f2c896bd09f1$var$showPitch = function(dictNotationPitch) {
    var showPitchNotation1 = $a801f2c896bd09f1$var$showPitchNotation(dictNotationPitch);
    return {
        show: function(v3) {
            return showPitchNotation1(v3);
        }
    };
};
var $a801f2c896bd09f1$var$readImplPitch = function(dict) {
    return dict.readImplPitch;
};
var $a801f2c896bd09f1$var$readForeignPitch = function(dictReadForeignPitch) {
    var readImplPitch1 = $a801f2c896bd09f1$var$readImplPitch(dictReadForeignPitch);
    return {
        readImpl: function(f2) {
            return readImplPitch1(f2);
        }
    };
};
var $a801f2c896bd09f1$var$parsePitchNotation = function(dict) {
    return dict.parsePitchNotation;
};
var $a801f2c896bd09f1$var$notationPitch = function(dictNotationPitch) {
    var showPitchNotation1 = $a801f2c896bd09f1$var$showPitchNotation(dictNotationPitch);
    return {
        parseNotation: function() {
            var $163 = $a801f2c896bd09f1$var$map3($a801f2c896bd09f1$var$Pitch);
            var $164 = $a801f2c896bd09f1$var$parsePitchNotation(dictNotationPitch);
            return function($165) {
                return $163($164($165));
            };
        }(),
        showNotation: function(v3) {
            return showPitchNotation1(v3);
        }
    };
};
var $a801f2c896bd09f1$var$parseNotation = function(dict) {
    return dict.parseNotation;
};
var $a801f2c896bd09f1$var$isStep = function(dict) {
    return dict.isStep;
};
var $a801f2c896bd09f1$var$ic = function(dict) {
    return dict.ic;
};
var $a801f2c896bd09f1$var$pc = function(dictHasIntervalClass) {
    return $a801f2c896bd09f1$var$map1($a801f2c896bd09f1$var$ic(dictHasIntervalClass));
};
var $a801f2c896bd09f1$var$down = function(dictInterval) {
    return $a801f2c896bd09f1$var$ginverse(dictInterval.Group0());
};
var $a801f2c896bd09f1$var$pto = function(dictInterval) {
    var append18 = $a801f2c896bd09f1$var$append(dictInterval.Group0().Monoid0().Semigroup0());
    var down1 = $a801f2c896bd09f1$var$down(dictInterval);
    return function(v3) {
        return function(v1) {
            return append18(v1)(down1(v3));
        };
    };
};
var $a801f2c896bd09f1$var$direction = function(dict) {
    return dict.direction;
};
var $a801f2c896bd09f1$var$iabs = function(dictInterval) {
    var direction1 = $a801f2c896bd09f1$var$direction(dictInterval);
    var down1 = $a801f2c896bd09f1$var$down(dictInterval);
    return function(i2) {
        if ($a801f2c896bd09f1$var$eq3(direction1(i2))($a801f2c896bd09f1$var$LT.value)) return down1(i2);
        if ($a801f2c896bd09f1$var$otherwise) return i2;
        throw new Error("Failed pattern match at Data.Pitches.Class (line 168, column 1 - line 168, column 39): " + [
            i2.constructor.name
        ]);
    };
};
// output/Control.Bind/foreign.js
var $a801f2c896bd09f1$var$arrayBind = typeof Array.prototype.flatMap === "function" ? function(arr) {
    return function(f2) {
        return arr.flatMap(f2);
    };
} : function(arr) {
    return function(f2) {
        var result2 = [];
        var l2 = arr.length;
        for(var i2 = 0; i2 < l2; i2++){
            var xs = f2(arr[i2]);
            var k2 = xs.length;
            for(var j2 = 0; j2 < k2; j2++)result2.push(xs[j2]);
        }
        return result2;
    };
};
// output/Control.Bind/index.js
var $a801f2c896bd09f1$var$discard = function(dict) {
    return dict.discard;
};
var $a801f2c896bd09f1$var$bindArray = {
    bind: $a801f2c896bd09f1$var$arrayBind,
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyArray;
    }
};
var $a801f2c896bd09f1$var$bind = function(dict) {
    return dict.bind;
};
var $a801f2c896bd09f1$var$bindFlipped = function(dictBind) {
    return $a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$bind(dictBind));
};
var $a801f2c896bd09f1$var$composeKleisliFlipped = function(dictBind) {
    var bindFlipped14 = $a801f2c896bd09f1$var$bindFlipped(dictBind);
    return function(f2) {
        return function(g2) {
            return function(a3) {
                return bindFlipped14(f2)(g2(a3));
            };
        };
    };
};
var $a801f2c896bd09f1$var$composeKleisli = function(dictBind) {
    var bind115 = $a801f2c896bd09f1$var$bind(dictBind);
    return function(f2) {
        return function(g2) {
            return function(a3) {
                return bind115(f2(a3))(g2);
            };
        };
    };
};
var $a801f2c896bd09f1$var$discardUnit = {
    discard: function(dictBind) {
        return $a801f2c896bd09f1$var$bind(dictBind);
    }
};
// output/Data.Enum/foreign.js
function $a801f2c896bd09f1$var$toCharCode(c3) {
    return c3.charCodeAt(0);
}
function $a801f2c896bd09f1$var$fromCharCode(c3) {
    return String.fromCharCode(c3);
}
// output/Control.Plus/index.js
var $a801f2c896bd09f1$var$plusArray = {
    empty: [],
    Alt0: function() {
        return $a801f2c896bd09f1$var$altArray;
    }
};
var $a801f2c896bd09f1$var$empty = function(dict) {
    return dict.empty;
};
// output/Control.Alternative/index.js
var $a801f2c896bd09f1$var$guard = function(dictAlternative) {
    var pure43 = $a801f2c896bd09f1$var$pure(dictAlternative.Applicative0());
    var empty8 = $a801f2c896bd09f1$var$empty(dictAlternative.Plus1());
    return function(v3) {
        if (v3) return pure43($a801f2c896bd09f1$var$unit);
        if (!v3) return empty8;
        throw new Error("Failed pattern match at Control.Alternative (line 48, column 1 - line 48, column 54): " + [
            v3.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$alternativeArray = {
    Applicative0: function() {
        return $a801f2c896bd09f1$var$applicativeArray;
    },
    Plus1: function() {
        return $a801f2c896bd09f1$var$plusArray;
    }
};
// output/Data.Either/index.js
var $a801f2c896bd09f1$var$Left = /* @__PURE__ */ function() {
    function Left2(value0) {
        this.value0 = value0;
    }
    Left2.create = function(value0) {
        return new Left2(value0);
    };
    return Left2;
}();
var $a801f2c896bd09f1$var$Right = /* @__PURE__ */ function() {
    function Right2(value0) {
        this.value0 = value0;
    }
    Right2.create = function(value0) {
        return new Right2(value0);
    };
    return Right2;
}();
var $a801f2c896bd09f1$var$showEither = function(dictShow) {
    var show40 = $a801f2c896bd09f1$var$show(dictShow);
    return function(dictShow1) {
        var show115 = $a801f2c896bd09f1$var$show(dictShow1);
        return {
            show: function(v3) {
                if (v3 instanceof $a801f2c896bd09f1$var$Left) return "(Left " + (show40(v3.value0) + ")");
                if (v3 instanceof $a801f2c896bd09f1$var$Right) return "(Right " + (show115(v3.value0) + ")");
                throw new Error("Failed pattern match at Data.Either (line 173, column 1 - line 175, column 46): " + [
                    v3.constructor.name
                ]);
            }
        };
    };
};
var $a801f2c896bd09f1$var$functorEither = {
    map: function(f2) {
        return function(m3) {
            if (m3 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(m3.value0);
            if (m3 instanceof $a801f2c896bd09f1$var$Right) return new $a801f2c896bd09f1$var$Right(f2(m3.value0));
            throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                m3.constructor.name
            ]);
        };
    }
};
var $a801f2c896bd09f1$var$map4 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEither);
var $a801f2c896bd09f1$var$eqEither = function(dictEq) {
    var eq29 = $a801f2c896bd09f1$var$eq(dictEq);
    return function(dictEq1) {
        var eq112 = $a801f2c896bd09f1$var$eq(dictEq1);
        return {
            eq: function(x4) {
                return function(y4) {
                    if (x4 instanceof $a801f2c896bd09f1$var$Left && y4 instanceof $a801f2c896bd09f1$var$Left) return eq29(x4.value0)(y4.value0);
                    if (x4 instanceof $a801f2c896bd09f1$var$Right && y4 instanceof $a801f2c896bd09f1$var$Right) return eq112(x4.value0)(y4.value0);
                    return false;
                };
            }
        };
    };
};
var $a801f2c896bd09f1$var$either = function(v3) {
    return function(v1) {
        return function(v22) {
            if (v22 instanceof $a801f2c896bd09f1$var$Left) return v3(v22.value0);
            if (v22 instanceof $a801f2c896bd09f1$var$Right) return v1(v22.value0);
            throw new Error("Failed pattern match at Data.Either (line 208, column 1 - line 208, column 64): " + [
                v3.constructor.name,
                v1.constructor.name,
                v22.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$hush = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$either($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$Nothing.value))($a801f2c896bd09f1$var$Just.create);
}();
var $a801f2c896bd09f1$var$applyEither = {
    apply: function(v3) {
        return function(v1) {
            if (v3 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(v3.value0);
            if (v3 instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$map4(v3.value0)(v1);
            throw new Error("Failed pattern match at Data.Either (line 70, column 1 - line 72, column 30): " + [
                v3.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorEither;
    }
};
var $a801f2c896bd09f1$var$bindEither = {
    bind: /* @__PURE__ */ $a801f2c896bd09f1$var$either(function(e) {
        return function(v3) {
            return new $a801f2c896bd09f1$var$Left(e);
        };
    })(function(a3) {
        return function(f2) {
            return f2(a3);
        };
    }),
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyEither;
    }
};
var $a801f2c896bd09f1$var$applicativeEither = /* @__PURE__ */ function() {
    return {
        pure: $a801f2c896bd09f1$var$Right.create,
        Apply0: function() {
            return $a801f2c896bd09f1$var$applyEither;
        }
    };
}();
var $a801f2c896bd09f1$var$monadEither = {
    Applicative0: function() {
        return $a801f2c896bd09f1$var$applicativeEither;
    },
    Bind1: function() {
        return $a801f2c896bd09f1$var$bindEither;
    }
};
// output/Data.HeytingAlgebra/foreign.js
var $a801f2c896bd09f1$var$boolConj = function(b1) {
    return function(b22) {
        return b1 && b22;
    };
};
var $a801f2c896bd09f1$var$boolDisj = function(b1) {
    return function(b22) {
        return b1 || b22;
    };
};
var $a801f2c896bd09f1$var$boolNot = function(b3) {
    return !b3;
};
// output/Data.HeytingAlgebra/index.js
var $a801f2c896bd09f1$var$tt = function(dict) {
    return dict.tt;
};
var $a801f2c896bd09f1$var$not = function(dict) {
    return dict.not;
};
var $a801f2c896bd09f1$var$implies = function(dict) {
    return dict.implies;
};
var $a801f2c896bd09f1$var$ff = function(dict) {
    return dict.ff;
};
var $a801f2c896bd09f1$var$disj = function(dict) {
    return dict.disj;
};
var $a801f2c896bd09f1$var$heytingAlgebraBoolean = {
    ff: false,
    tt: true,
    implies: function(a3) {
        return function(b3) {
            return $a801f2c896bd09f1$var$disj($a801f2c896bd09f1$var$heytingAlgebraBoolean)($a801f2c896bd09f1$var$not($a801f2c896bd09f1$var$heytingAlgebraBoolean)(a3))(b3);
        };
    },
    conj: $a801f2c896bd09f1$var$boolConj,
    disj: $a801f2c896bd09f1$var$boolDisj,
    not: $a801f2c896bd09f1$var$boolNot
};
var $a801f2c896bd09f1$var$conj = function(dict) {
    return dict.conj;
};
var $a801f2c896bd09f1$var$heytingAlgebraFunction = function(dictHeytingAlgebra) {
    var ff1 = $a801f2c896bd09f1$var$ff(dictHeytingAlgebra);
    var tt1 = $a801f2c896bd09f1$var$tt(dictHeytingAlgebra);
    var implies1 = $a801f2c896bd09f1$var$implies(dictHeytingAlgebra);
    var conj1 = $a801f2c896bd09f1$var$conj(dictHeytingAlgebra);
    var disj1 = $a801f2c896bd09f1$var$disj(dictHeytingAlgebra);
    var not1 = $a801f2c896bd09f1$var$not(dictHeytingAlgebra);
    return {
        ff: function(v3) {
            return ff1;
        },
        tt: function(v3) {
            return tt1;
        },
        implies: function(f2) {
            return function(g2) {
                return function(a3) {
                    return implies1(f2(a3))(g2(a3));
                };
            };
        },
        conj: function(f2) {
            return function(g2) {
                return function(a3) {
                    return conj1(f2(a3))(g2(a3));
                };
            };
        },
        disj: function(f2) {
            return function(g2) {
                return function(a3) {
                    return disj1(f2(a3))(g2(a3));
                };
            };
        },
        not: function(f2) {
            return function(a3) {
                return not1(f2(a3));
            };
        }
    };
};
// output/Data.Tuple/index.js
var $a801f2c896bd09f1$var$Tuple = /* @__PURE__ */ function() {
    function Tuple2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Tuple2.create = function(value0) {
        return function(value1) {
            return new Tuple2(value0, value1);
        };
    };
    return Tuple2;
}();
var $a801f2c896bd09f1$var$uncurry = function(f2) {
    return function(v3) {
        return f2(v3.value0)(v3.value1);
    };
};
var $a801f2c896bd09f1$var$snd = function(v3) {
    return v3.value1;
};
var $a801f2c896bd09f1$var$showTuple = function(dictShow) {
    var show40 = $a801f2c896bd09f1$var$show(dictShow);
    return function(dictShow1) {
        var show115 = $a801f2c896bd09f1$var$show(dictShow1);
        return {
            show: function(v3) {
                return "(Tuple " + (show40(v3.value0) + (" " + (show115(v3.value1) + ")")));
            }
        };
    };
};
var $a801f2c896bd09f1$var$functorTuple = {
    map: function(f2) {
        return function(m3) {
            return new $a801f2c896bd09f1$var$Tuple(m3.value0, f2(m3.value1));
        };
    }
};
var $a801f2c896bd09f1$var$fst = function(v3) {
    return v3.value0;
};
var $a801f2c896bd09f1$var$eqTuple = function(dictEq) {
    var eq29 = $a801f2c896bd09f1$var$eq(dictEq);
    return function(dictEq1) {
        var eq112 = $a801f2c896bd09f1$var$eq(dictEq1);
        return {
            eq: function(x4) {
                return function(y4) {
                    return eq29(x4.value0)(y4.value0) && eq112(x4.value1)(y4.value1);
                };
            }
        };
    };
};
var $a801f2c896bd09f1$var$ordTuple = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    var eqTuple1 = $a801f2c896bd09f1$var$eqTuple(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare14 = $a801f2c896bd09f1$var$compare(dictOrd1);
        var eqTuple2 = eqTuple1(dictOrd1.Eq0());
        return {
            compare: function(x4) {
                return function(y4) {
                    var v3 = compare6(x4.value0)(y4.value0);
                    if (v3 instanceof $a801f2c896bd09f1$var$LT) return $a801f2c896bd09f1$var$LT.value;
                    if (v3 instanceof $a801f2c896bd09f1$var$GT) return $a801f2c896bd09f1$var$GT.value;
                    return compare14(x4.value1)(y4.value1);
                };
            },
            Eq0: function() {
                return eqTuple2;
            }
        };
    };
};
// output/Data.Unfoldable/foreign.js
var $a801f2c896bd09f1$var$unfoldrArrayImpl = function(isNothing2) {
    return function(fromJust6) {
        return function(fst2) {
            return function(snd2) {
                return function(f2) {
                    return function(b3) {
                        var result2 = [];
                        var value17 = b3;
                        while(true){
                            var maybe2 = f2(value17);
                            if (isNothing2(maybe2)) return result2;
                            var tuple = fromJust6(maybe2);
                            result2.push(fst2(tuple));
                            value17 = snd2(tuple);
                        }
                    };
                };
            };
        };
    };
};
// output/Data.Traversable/foreign.js
var $a801f2c896bd09f1$var$traverseArrayImpl = /* @__PURE__ */ function() {
    function array1(a3) {
        return [
            a3
        ];
    }
    function array2(a3) {
        return function(b3) {
            return [
                a3,
                b3
            ];
        };
    }
    function array3(a3) {
        return function(b3) {
            return function(c3) {
                return [
                    a3,
                    b3,
                    c3
                ];
            };
        };
    }
    function concat2(xs) {
        return function(ys) {
            return xs.concat(ys);
        };
    }
    return function(apply4) {
        return function(map59) {
            return function(pure43) {
                return function(f2) {
                    return function(array) {
                        function go2(bot, top2) {
                            switch(top2 - bot){
                                case 0:
                                    return pure43([]);
                                case 1:
                                    return map59(array1)(f2(array[bot]));
                                case 2:
                                    return apply4(map59(array2)(f2(array[bot])))(f2(array[bot + 1]));
                                case 3:
                                    return apply4(apply4(map59(array3)(f2(array[bot])))(f2(array[bot + 1])))(f2(array[bot + 2]));
                                default:
                                    var pivot = bot + Math.floor((top2 - bot) / 4) * 2;
                                    return apply4(map59(concat2)(go2(bot, pivot)))(go2(pivot, top2));
                            }
                        }
                        return go2(0, array.length);
                    };
                };
            };
        };
    };
}();
// output/Data.Foldable/foreign.js
var $a801f2c896bd09f1$var$foldrArray = function(f2) {
    return function(init3) {
        return function(xs) {
            var acc = init3;
            var len = xs.length;
            for(var i2 = len - 1; i2 >= 0; i2--)acc = f2(xs[i2])(acc);
            return acc;
        };
    };
};
var $a801f2c896bd09f1$var$foldlArray = function(f2) {
    return function(init3) {
        return function(xs) {
            var acc = init3;
            var len = xs.length;
            for(var i2 = 0; i2 < len; i2++)acc = f2(acc)(xs[i2]);
            return acc;
        };
    };
};
// output/Data.Bifunctor/index.js
var $a801f2c896bd09f1$var$identity4 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$bimap = function(dict) {
    return dict.bimap;
};
var $a801f2c896bd09f1$var$lmap = function(dictBifunctor) {
    var bimap1 = $a801f2c896bd09f1$var$bimap(dictBifunctor);
    return function(f2) {
        return bimap1(f2)($a801f2c896bd09f1$var$identity4);
    };
};
var $a801f2c896bd09f1$var$bifunctorTuple = {
    bimap: function(f2) {
        return function(g2) {
            return function(v3) {
                return new $a801f2c896bd09f1$var$Tuple(f2(v3.value0), g2(v3.value1));
            };
        };
    }
};
var $a801f2c896bd09f1$var$bifunctorEither = {
    bimap: function(v3) {
        return function(v1) {
            return function(v22) {
                if (v22 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(v3(v22.value0));
                if (v22 instanceof $a801f2c896bd09f1$var$Right) return new $a801f2c896bd09f1$var$Right(v1(v22.value0));
                throw new Error("Failed pattern match at Data.Bifunctor (line 32, column 1 - line 34, column 36): " + [
                    v3.constructor.name,
                    v1.constructor.name,
                    v22.constructor.name
                ]);
            };
        };
    }
};
// output/Data.Monoid.Conj/index.js
var $a801f2c896bd09f1$var$Conj = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$semigroupConj = function(dictHeytingAlgebra) {
    var conj2 = $a801f2c896bd09f1$var$conj(dictHeytingAlgebra);
    return {
        append: function(v3) {
            return function(v1) {
                return conj2(v3)(v1);
            };
        }
    };
};
var $a801f2c896bd09f1$var$monoidConj = function(dictHeytingAlgebra) {
    var semigroupConj1 = $a801f2c896bd09f1$var$semigroupConj(dictHeytingAlgebra);
    return {
        mempty: $a801f2c896bd09f1$var$tt(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupConj1;
        }
    };
};
// output/Data.Monoid.Disj/index.js
var $a801f2c896bd09f1$var$Disj = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$semigroupDisj = function(dictHeytingAlgebra) {
    var disj2 = $a801f2c896bd09f1$var$disj(dictHeytingAlgebra);
    return {
        append: function(v3) {
            return function(v1) {
                return disj2(v3)(v1);
            };
        }
    };
};
var $a801f2c896bd09f1$var$monoidDisj = function(dictHeytingAlgebra) {
    var semigroupDisj1 = $a801f2c896bd09f1$var$semigroupDisj(dictHeytingAlgebra);
    return {
        mempty: $a801f2c896bd09f1$var$ff(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupDisj1;
        }
    };
};
// output/Unsafe.Coerce/foreign.js
var $a801f2c896bd09f1$var$unsafeCoerce2 = function(x4) {
    return x4;
};
// output/Safe.Coerce/index.js
var $a801f2c896bd09f1$var$coerce = function() {
    return $a801f2c896bd09f1$var$unsafeCoerce2;
};
// output/Data.Newtype/index.js
var $a801f2c896bd09f1$var$coerce2 = /* @__PURE__ */ $a801f2c896bd09f1$var$coerce();
var $a801f2c896bd09f1$var$unwrap = function() {
    return $a801f2c896bd09f1$var$coerce2;
};
var $a801f2c896bd09f1$var$unwrap1 = /* @__PURE__ */ $a801f2c896bd09f1$var$unwrap();
var $a801f2c896bd09f1$var$un = function() {
    return function(v3) {
        return $a801f2c896bd09f1$var$unwrap1;
    };
};
var $a801f2c896bd09f1$var$alaF = function() {
    return function() {
        return function() {
            return function() {
                return function(v3) {
                    return $a801f2c896bd09f1$var$coerce2;
                };
            };
        };
    };
};
// output/Data.Foldable/index.js
var $a801f2c896bd09f1$var$identity5 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$alaF2 = /* @__PURE__ */ $a801f2c896bd09f1$var$alaF()()()();
var $a801f2c896bd09f1$var$foldr = function(dict) {
    return dict.foldr;
};
var $a801f2c896bd09f1$var$traverse_ = function(dictApplicative) {
    var applySecond3 = $a801f2c896bd09f1$var$applySecond(dictApplicative.Apply0());
    var pure43 = $a801f2c896bd09f1$var$pure(dictApplicative);
    return function(dictFoldable) {
        var foldr22 = $a801f2c896bd09f1$var$foldr(dictFoldable);
        return function(f2) {
            return foldr22(function($454) {
                return applySecond3(f2($454));
            })(pure43($a801f2c896bd09f1$var$unit));
        };
    };
};
var $a801f2c896bd09f1$var$for_ = function(dictApplicative) {
    var traverse_14 = $a801f2c896bd09f1$var$traverse_(dictApplicative);
    return function(dictFoldable) {
        return $a801f2c896bd09f1$var$flip(traverse_14(dictFoldable));
    };
};
var $a801f2c896bd09f1$var$foldl = function(dict) {
    return dict.foldl;
};
var $a801f2c896bd09f1$var$intercalate = function(dictFoldable) {
    var foldl22 = $a801f2c896bd09f1$var$foldl(dictFoldable);
    return function(dictMonoid) {
        var append18 = $a801f2c896bd09f1$var$append(dictMonoid.Semigroup0());
        var mempty5 = $a801f2c896bd09f1$var$mempty(dictMonoid);
        return function(sep) {
            return function(xs) {
                var go2 = function(v3) {
                    return function(v1) {
                        if (v3.init) return {
                            init: false,
                            acc: v1
                        };
                        return {
                            init: false,
                            acc: append18(v3.acc)(append18(sep)(v1))
                        };
                    };
                };
                return foldl22(go2)({
                    init: true,
                    acc: mempty5
                })(xs).acc;
            };
        };
    };
};
var $a801f2c896bd09f1$var$foldableMaybe = {
    foldr: function(v3) {
        return function(v1) {
            return function(v22) {
                if (v22 instanceof $a801f2c896bd09f1$var$Nothing) return v1;
                if (v22 instanceof $a801f2c896bd09f1$var$Just) return v3(v22.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v3.constructor.name,
                    v1.constructor.name,
                    v22.constructor.name
                ]);
            };
        };
    },
    foldl: function(v3) {
        return function(v1) {
            return function(v22) {
                if (v22 instanceof $a801f2c896bd09f1$var$Nothing) return v1;
                if (v22 instanceof $a801f2c896bd09f1$var$Just) return v3(v1)(v22.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v3.constructor.name,
                    v1.constructor.name,
                    v22.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty5 = $a801f2c896bd09f1$var$mempty(dictMonoid);
        return function(v3) {
            return function(v1) {
                if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return mempty5;
                if (v1 instanceof $a801f2c896bd09f1$var$Just) return v3(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v3.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $a801f2c896bd09f1$var$foldMapDefaultR = function(dictFoldable) {
    var foldr22 = $a801f2c896bd09f1$var$foldr(dictFoldable);
    return function(dictMonoid) {
        var append18 = $a801f2c896bd09f1$var$append(dictMonoid.Semigroup0());
        var mempty5 = $a801f2c896bd09f1$var$mempty(dictMonoid);
        return function(f2) {
            return foldr22(function(x4) {
                return function(acc) {
                    return append18(f2(x4))(acc);
                };
            })(mempty5);
        };
    };
};
var $a801f2c896bd09f1$var$foldableArray = {
    foldr: $a801f2c896bd09f1$var$foldrArray,
    foldl: $a801f2c896bd09f1$var$foldlArray,
    foldMap: function(dictMonoid) {
        return $a801f2c896bd09f1$var$foldMapDefaultR($a801f2c896bd09f1$var$foldableArray)(dictMonoid);
    }
};
var $a801f2c896bd09f1$var$foldMap = function(dict) {
    return dict.foldMap;
};
var $a801f2c896bd09f1$var$fold = function(dictFoldable) {
    var foldMap22 = $a801f2c896bd09f1$var$foldMap(dictFoldable);
    return function(dictMonoid) {
        return foldMap22(dictMonoid)($a801f2c896bd09f1$var$identity5);
    };
};
var $a801f2c896bd09f1$var$find = function(dictFoldable) {
    var foldl22 = $a801f2c896bd09f1$var$foldl(dictFoldable);
    return function(p3) {
        var go2 = function(v3) {
            return function(v1) {
                if (v3 instanceof $a801f2c896bd09f1$var$Nothing && p3(v1)) return new $a801f2c896bd09f1$var$Just(v1);
                return v3;
            };
        };
        return foldl22(go2)($a801f2c896bd09f1$var$Nothing.value);
    };
};
var $a801f2c896bd09f1$var$any = function(dictFoldable) {
    var foldMap22 = $a801f2c896bd09f1$var$foldMap(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $a801f2c896bd09f1$var$alaF2($a801f2c896bd09f1$var$Disj)(foldMap22($a801f2c896bd09f1$var$monoidDisj(dictHeytingAlgebra)));
    };
};
var $a801f2c896bd09f1$var$elem = function(dictFoldable) {
    var any1 = $a801f2c896bd09f1$var$any(dictFoldable)($a801f2c896bd09f1$var$heytingAlgebraBoolean);
    return function(dictEq) {
        var $462 = $a801f2c896bd09f1$var$eq(dictEq);
        return function($463) {
            return any1($462($463));
        };
    };
};
var $a801f2c896bd09f1$var$all = function(dictFoldable) {
    var foldMap22 = $a801f2c896bd09f1$var$foldMap(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $a801f2c896bd09f1$var$alaF2($a801f2c896bd09f1$var$Conj)(foldMap22($a801f2c896bd09f1$var$monoidConj(dictHeytingAlgebra)));
    };
};
// output/Data.Identity/index.js
var $a801f2c896bd09f1$var$Identity = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$functorIdentity = {
    map: function(f2) {
        return function(m3) {
            return f2(m3);
        };
    }
};
var $a801f2c896bd09f1$var$applyIdentity = {
    apply: function(v3) {
        return function(v1) {
            return v3(v1);
        };
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorIdentity;
    }
};
var $a801f2c896bd09f1$var$bindIdentity = {
    bind: function(v3) {
        return function(f2) {
            return f2(v3);
        };
    },
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyIdentity;
    }
};
var $a801f2c896bd09f1$var$applicativeIdentity = {
    pure: $a801f2c896bd09f1$var$Identity,
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyIdentity;
    }
};
var $a801f2c896bd09f1$var$monadIdentity = {
    Applicative0: function() {
        return $a801f2c896bd09f1$var$applicativeIdentity;
    },
    Bind1: function() {
        return $a801f2c896bd09f1$var$bindIdentity;
    }
};
// output/Data.Traversable.Accum.Internal/index.js
var $a801f2c896bd09f1$var$stateL = function(v3) {
    return v3;
};
var $a801f2c896bd09f1$var$functorStateL = {
    map: function(f2) {
        return function(k2) {
            return function(s2) {
                var v3 = $a801f2c896bd09f1$var$stateL(k2)(s2);
                return {
                    accum: v3.accum,
                    value: f2(v3.value)
                };
            };
        };
    }
};
var $a801f2c896bd09f1$var$applyStateL = {
    apply: function(f2) {
        return function(x4) {
            return function(s2) {
                var v3 = $a801f2c896bd09f1$var$stateL(f2)(s2);
                var v1 = $a801f2c896bd09f1$var$stateL(x4)(v3.accum);
                return {
                    accum: v1.accum,
                    value: v3.value(v1.value)
                };
            };
        };
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorStateL;
    }
};
var $a801f2c896bd09f1$var$applicativeStateL = {
    pure: function(a3) {
        return function(s2) {
            return {
                accum: s2,
                value: a3
            };
        };
    },
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyStateL;
    }
};
// output/Data.Traversable/index.js
var $a801f2c896bd09f1$var$identity6 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$traverse = function(dict) {
    return dict.traverse;
};
var $a801f2c896bd09f1$var$sequenceDefault = function(dictTraversable) {
    var traverse22 = $a801f2c896bd09f1$var$traverse(dictTraversable);
    return function(dictApplicative) {
        return traverse22(dictApplicative)($a801f2c896bd09f1$var$identity6);
    };
};
var $a801f2c896bd09f1$var$traversableArray = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        return $a801f2c896bd09f1$var$traverseArrayImpl($a801f2c896bd09f1$var$apply(Apply0))($a801f2c896bd09f1$var$map(Apply0.Functor0()))($a801f2c896bd09f1$var$pure(dictApplicative));
    },
    sequence: function(dictApplicative) {
        return $a801f2c896bd09f1$var$sequenceDefault($a801f2c896bd09f1$var$traversableArray)(dictApplicative);
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorArray;
    },
    Foldable1: function() {
        return $a801f2c896bd09f1$var$foldableArray;
    }
};
var $a801f2c896bd09f1$var$sequence = function(dict) {
    return dict.sequence;
};
var $a801f2c896bd09f1$var$mapAccumL = function(dictTraversable) {
    var traverse22 = $a801f2c896bd09f1$var$traverse(dictTraversable)($a801f2c896bd09f1$var$applicativeStateL);
    return function(f2) {
        return function(s0) {
            return function(xs) {
                return $a801f2c896bd09f1$var$stateL(traverse22(function(a3) {
                    return function(s2) {
                        return f2(s2)(a3);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $a801f2c896bd09f1$var$scanl = function(dictTraversable) {
    var mapAccumL1 = $a801f2c896bd09f1$var$mapAccumL(dictTraversable);
    return function(f2) {
        return function(b0) {
            return function(xs) {
                return mapAccumL1(function(b3) {
                    return function(a3) {
                        var b$prime = f2(b3)(a3);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $a801f2c896bd09f1$var$$$for = function(dictApplicative) {
    return function(dictTraversable) {
        var traverse22 = $a801f2c896bd09f1$var$traverse(dictTraversable)(dictApplicative);
        return function(x4) {
            return function(f2) {
                return traverse22(f2)(x4);
            };
        };
    };
};
// output/Data.Unfoldable1/foreign.js
var $a801f2c896bd09f1$var$unfoldr1ArrayImpl = function(isNothing2) {
    return function(fromJust6) {
        return function(fst2) {
            return function(snd2) {
                return function(f2) {
                    return function(b3) {
                        var result2 = [];
                        var value17 = b3;
                        while(true){
                            var tuple = f2(value17);
                            result2.push(fst2(tuple));
                            var maybe2 = snd2(tuple);
                            if (isNothing2(maybe2)) return result2;
                            value17 = fromJust6(maybe2);
                        }
                    };
                };
            };
        };
    };
};
// output/Data.Unfoldable1/index.js
var $a801f2c896bd09f1$var$fromJust2 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromJust();
var $a801f2c896bd09f1$var$unfoldable1Array = {
    unfoldr1: /* @__PURE__ */ $a801f2c896bd09f1$var$unfoldr1ArrayImpl($a801f2c896bd09f1$var$isNothing)($a801f2c896bd09f1$var$fromJust2)($a801f2c896bd09f1$var$fst)($a801f2c896bd09f1$var$snd)
};
// output/Data.Unfoldable/index.js
var $a801f2c896bd09f1$var$fromJust3 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromJust();
var $a801f2c896bd09f1$var$unfoldr = function(dict) {
    return dict.unfoldr;
};
var $a801f2c896bd09f1$var$unfoldableArray = {
    unfoldr: /* @__PURE__ */ $a801f2c896bd09f1$var$unfoldrArrayImpl($a801f2c896bd09f1$var$isNothing)($a801f2c896bd09f1$var$fromJust3)($a801f2c896bd09f1$var$fst)($a801f2c896bd09f1$var$snd),
    Unfoldable10: function() {
        return $a801f2c896bd09f1$var$unfoldable1Array;
    }
};
var $a801f2c896bd09f1$var$none = function(dictUnfoldable) {
    return $a801f2c896bd09f1$var$unfoldr(dictUnfoldable)($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$Nothing.value))($a801f2c896bd09f1$var$unit);
};
// output/Data.Enum/index.js
var $a801f2c896bd09f1$var$bottom1 = /* @__PURE__ */ $a801f2c896bd09f1$var$bottom($a801f2c896bd09f1$var$boundedChar);
var $a801f2c896bd09f1$var$top1 = /* @__PURE__ */ $a801f2c896bd09f1$var$top($a801f2c896bd09f1$var$boundedChar);
var $a801f2c896bd09f1$var$toEnum = function(dict) {
    return dict.toEnum;
};
var $a801f2c896bd09f1$var$fromEnum = function(dict) {
    return dict.fromEnum;
};
var $a801f2c896bd09f1$var$toEnumWithDefaults = function(dictBoundedEnum) {
    var toEnum1 = $a801f2c896bd09f1$var$toEnum(dictBoundedEnum);
    var fromEnum1 = $a801f2c896bd09f1$var$fromEnum(dictBoundedEnum);
    var bottom2 = $a801f2c896bd09f1$var$bottom(dictBoundedEnum.Bounded0());
    return function(low2) {
        return function(high2) {
            return function(x4) {
                var v3 = toEnum1(x4);
                if (v3 instanceof $a801f2c896bd09f1$var$Just) return v3.value0;
                if (v3 instanceof $a801f2c896bd09f1$var$Nothing) {
                    var $140 = x4 < fromEnum1(bottom2);
                    if ($140) return low2;
                    return high2;
                }
                throw new Error("Failed pattern match at Data.Enum (line 158, column 33 - line 160, column 62): " + [
                    v3.constructor.name
                ]);
            };
        };
    };
};
var $a801f2c896bd09f1$var$defaultSucc = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a3) {
            return toEnum$prime(fromEnum$prime(a3) + 1 | 0);
        };
    };
};
var $a801f2c896bd09f1$var$defaultPred = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a3) {
            return toEnum$prime(fromEnum$prime(a3) - 1 | 0);
        };
    };
};
var $a801f2c896bd09f1$var$charToEnum = function(v3) {
    if (v3 >= $a801f2c896bd09f1$var$toCharCode($a801f2c896bd09f1$var$bottom1) && v3 <= $a801f2c896bd09f1$var$toCharCode($a801f2c896bd09f1$var$top1)) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$fromCharCode(v3));
    return $a801f2c896bd09f1$var$Nothing.value;
};
var $a801f2c896bd09f1$var$enumChar = {
    succ: /* @__PURE__ */ $a801f2c896bd09f1$var$defaultSucc($a801f2c896bd09f1$var$charToEnum)($a801f2c896bd09f1$var$toCharCode),
    pred: /* @__PURE__ */ $a801f2c896bd09f1$var$defaultPred($a801f2c896bd09f1$var$charToEnum)($a801f2c896bd09f1$var$toCharCode),
    Ord0: function() {
        return $a801f2c896bd09f1$var$ordChar;
    }
};
var $a801f2c896bd09f1$var$boundedEnumChar = /* @__PURE__ */ function() {
    return {
        cardinality: $a801f2c896bd09f1$var$toCharCode($a801f2c896bd09f1$var$top1) - $a801f2c896bd09f1$var$toCharCode($a801f2c896bd09f1$var$bottom1) | 0,
        toEnum: $a801f2c896bd09f1$var$charToEnum,
        fromEnum: $a801f2c896bd09f1$var$toCharCode,
        Bounded0: function() {
            return $a801f2c896bd09f1$var$boundedChar;
        },
        Enum1: function() {
            return $a801f2c896bd09f1$var$enumChar;
        }
    };
}();
// output/Data.Char/index.js
var $a801f2c896bd09f1$var$toCharCode2 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromEnum($a801f2c896bd09f1$var$boundedEnumChar);
var $a801f2c896bd09f1$var$fromCharCode2 = /* @__PURE__ */ $a801f2c896bd09f1$var$toEnum($a801f2c896bd09f1$var$boundedEnumChar);
// output/Control.Monad/index.js
var $a801f2c896bd09f1$var$unlessM = function(dictMonad) {
    var bind37 = $a801f2c896bd09f1$var$bind(dictMonad.Bind1());
    var unless2 = $a801f2c896bd09f1$var$unless(dictMonad.Applicative0());
    return function(mb) {
        return function(m3) {
            return bind37(mb)(function(b3) {
                return unless2(b3)(m3);
            });
        };
    };
};
var $a801f2c896bd09f1$var$ap = function(dictMonad) {
    var bind37 = $a801f2c896bd09f1$var$bind(dictMonad.Bind1());
    var pure43 = $a801f2c896bd09f1$var$pure(dictMonad.Applicative0());
    return function(f2) {
        return function(a3) {
            return bind37(f2)(function(f$prime) {
                return bind37(a3)(function(a$prime) {
                    return pure43(f$prime(a$prime));
                });
            });
        };
    };
};
// output/Effect/foreign.js
var $a801f2c896bd09f1$var$pureE = function(a3) {
    return function() {
        return a3;
    };
};
var $a801f2c896bd09f1$var$bindE = function(a3) {
    return function(f2) {
        return function() {
            return f2(a3())();
        };
    };
};
// output/Effect/index.js
var $a801f2c896bd09f1$var$$runtime_lazy = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$monadEffect = {
    Applicative0: function() {
        return $a801f2c896bd09f1$var$applicativeEffect;
    },
    Bind1: function() {
        return $a801f2c896bd09f1$var$bindEffect;
    }
};
var $a801f2c896bd09f1$var$bindEffect = {
    bind: $a801f2c896bd09f1$var$bindE,
    Apply0: function() {
        return $a801f2c896bd09f1$var$$lazy_applyEffect(0);
    }
};
var $a801f2c896bd09f1$var$applicativeEffect = {
    pure: $a801f2c896bd09f1$var$pureE,
    Apply0: function() {
        return $a801f2c896bd09f1$var$$lazy_applyEffect(0);
    }
};
var $a801f2c896bd09f1$var$$lazy_functorEffect = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy("functorEffect", "Effect", function() {
    return {
        map: $a801f2c896bd09f1$var$liftA1($a801f2c896bd09f1$var$applicativeEffect)
    };
});
var $a801f2c896bd09f1$var$$lazy_applyEffect = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy("applyEffect", "Effect", function() {
    return {
        apply: $a801f2c896bd09f1$var$ap($a801f2c896bd09f1$var$monadEffect),
        Functor0: function() {
            return $a801f2c896bd09f1$var$$lazy_functorEffect(0);
        }
    };
});
var $a801f2c896bd09f1$var$functorEffect = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_functorEffect(20);
// output/Effect.Ref/foreign.js
var $a801f2c896bd09f1$var$_new = function(val) {
    return function() {
        return {
            value: val
        };
    };
};
var $a801f2c896bd09f1$var$read = function(ref3) {
    return function() {
        return ref3.value;
    };
};
var $a801f2c896bd09f1$var$modifyImpl = function(f2) {
    return function(ref3) {
        return function() {
            var t2 = f2(ref3.value);
            ref3.value = t2.state;
            return t2.value;
        };
    };
};
var $a801f2c896bd09f1$var$write = function(val) {
    return function(ref3) {
        return function() {
            ref3.value = val;
        };
    };
};
// output/Effect.Ref/index.js
var $a801f2c896bd09f1$var$$$void2 = /* @__PURE__ */ $a801f2c896bd09f1$var$$$void($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$$$new = $a801f2c896bd09f1$var$_new;
var $a801f2c896bd09f1$var$modify$prime = $a801f2c896bd09f1$var$modifyImpl;
var $a801f2c896bd09f1$var$modify = function(f2) {
    return $a801f2c896bd09f1$var$modify$prime(function(s2) {
        var s$prime = f2(s2);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $a801f2c896bd09f1$var$modify_ = function(f2) {
    return function(s2) {
        return $a801f2c896bd09f1$var$$$void2($a801f2c896bd09f1$var$modify(f2)(s2));
    };
};
// output/Control.Monad.Rec.Class/index.js
var $a801f2c896bd09f1$var$bindFlipped2 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindEffect);
var $a801f2c896bd09f1$var$map5 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$Loop = /* @__PURE__ */ function() {
    function Loop2(value0) {
        this.value0 = value0;
    }
    Loop2.create = function(value0) {
        return new Loop2(value0);
    };
    return Loop2;
}();
var $a801f2c896bd09f1$var$Done = /* @__PURE__ */ function() {
    function Done2(value0) {
        this.value0 = value0;
    }
    Done2.create = function(value0) {
        return new Done2(value0);
    };
    return Done2;
}();
var $a801f2c896bd09f1$var$tailRecM = function(dict) {
    return dict.tailRecM;
};
var $a801f2c896bd09f1$var$tailRec = function(f2) {
    var go2 = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Loop) {
                $copy_v = f2(v3.value0);
                return;
            }
            if (v3 instanceof $a801f2c896bd09f1$var$Done) {
                $tco_done = true;
                return v3.value0;
            }
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 103, column 3 - line 103, column 25): " + [
                v3.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($85) {
        return go2(f2($85));
    };
};
var $a801f2c896bd09f1$var$monadRecEither = {
    tailRecM: function(f2) {
        return function(a0) {
            var g2 = function(v3) {
                if (v3 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Done(new $a801f2c896bd09f1$var$Left(v3.value0));
                if (v3 instanceof $a801f2c896bd09f1$var$Right && v3.value0 instanceof $a801f2c896bd09f1$var$Loop) return new $a801f2c896bd09f1$var$Loop(f2(v3.value0.value0));
                if (v3 instanceof $a801f2c896bd09f1$var$Right && v3.value0 instanceof $a801f2c896bd09f1$var$Done) return new $a801f2c896bd09f1$var$Done(new $a801f2c896bd09f1$var$Right(v3.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 145, column 7 - line 145, column 33): " + [
                    v3.constructor.name
                ]);
            };
            return $a801f2c896bd09f1$var$tailRec(g2)(f2(a0));
        };
    },
    Monad0: function() {
        return $a801f2c896bd09f1$var$monadEither;
    }
};
var $a801f2c896bd09f1$var$monadRecEffect = {
    tailRecM: function(f2) {
        return function(a3) {
            var fromDone = function(v3) {
                if (v3 instanceof $a801f2c896bd09f1$var$Done) return v3.value0;
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 137, column 30 - line 137, column 44): " + [
                    v3.constructor.name
                ]);
            };
            return function __do2() {
                var r = $a801f2c896bd09f1$var$bindFlipped2($a801f2c896bd09f1$var$$$new)(f2(a3))();
                (function() {
                    while(!function __do3() {
                        var v3 = $a801f2c896bd09f1$var$read(r)();
                        if (v3 instanceof $a801f2c896bd09f1$var$Loop) {
                            var e = f2(v3.value0)();
                            $a801f2c896bd09f1$var$write(e)(r)();
                            return false;
                        }
                        if (v3 instanceof $a801f2c896bd09f1$var$Done) return true;
                        throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 128, column 22 - line 133, column 28): " + [
                            v3.constructor.name
                        ]);
                    }());
                    return {};
                })();
                return $a801f2c896bd09f1$var$map5(fromDone)($a801f2c896bd09f1$var$read(r))();
            };
        };
    },
    Monad0: function() {
        return $a801f2c896bd09f1$var$monadEffect;
    }
};
var $a801f2c896bd09f1$var$bifunctorStep = {
    bimap: function(v3) {
        return function(v1) {
            return function(v22) {
                if (v22 instanceof $a801f2c896bd09f1$var$Loop) return new $a801f2c896bd09f1$var$Loop(v3(v22.value0));
                if (v22 instanceof $a801f2c896bd09f1$var$Done) return new $a801f2c896bd09f1$var$Done(v1(v22.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 33, column 1 - line 35, column 34): " + [
                    v3.constructor.name,
                    v1.constructor.name,
                    v22.constructor.name
                ]);
            };
        };
    }
};
// output/Data.FunctorWithIndex/foreign.js
var $a801f2c896bd09f1$var$mapWithIndexArray = function(f2) {
    return function(xs) {
        var l2 = xs.length;
        var result2 = Array(l2);
        for(var i2 = 0; i2 < l2; i2++)result2[i2] = f2(i2)(xs[i2]);
        return result2;
    };
};
// output/Data.FunctorWithIndex/index.js
var $a801f2c896bd09f1$var$mapWithIndex = function(dict) {
    return dict.mapWithIndex;
};
var $a801f2c896bd09f1$var$functorWithIndexArray = {
    mapWithIndex: $a801f2c896bd09f1$var$mapWithIndexArray,
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorArray;
    }
};
// output/Data.FoldableWithIndex/index.js
var $a801f2c896bd09f1$var$foldr8 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldr($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$mapWithIndex2 = /* @__PURE__ */ $a801f2c896bd09f1$var$mapWithIndex($a801f2c896bd09f1$var$functorWithIndexArray);
var $a801f2c896bd09f1$var$foldl8 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$foldrWithIndex = function(dict) {
    return dict.foldrWithIndex;
};
var $a801f2c896bd09f1$var$traverseWithIndex_ = function(dictApplicative) {
    var applySecond3 = $a801f2c896bd09f1$var$applySecond(dictApplicative.Apply0());
    var pure43 = $a801f2c896bd09f1$var$pure(dictApplicative);
    return function(dictFoldableWithIndex) {
        var foldrWithIndex1 = $a801f2c896bd09f1$var$foldrWithIndex(dictFoldableWithIndex);
        return function(f2) {
            return foldrWithIndex1(function(i2) {
                var $289 = f2(i2);
                return function($290) {
                    return applySecond3($289($290));
                };
            })(pure43($a801f2c896bd09f1$var$unit));
        };
    };
};
var $a801f2c896bd09f1$var$forWithIndex_ = function(dictApplicative) {
    var traverseWithIndex_1 = $a801f2c896bd09f1$var$traverseWithIndex_(dictApplicative);
    return function(dictFoldableWithIndex) {
        return $a801f2c896bd09f1$var$flip(traverseWithIndex_1(dictFoldableWithIndex));
    };
};
var $a801f2c896bd09f1$var$foldlWithIndex = function(dict) {
    return dict.foldlWithIndex;
};
var $a801f2c896bd09f1$var$foldMapWithIndexDefaultR = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $a801f2c896bd09f1$var$foldrWithIndex(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append18 = $a801f2c896bd09f1$var$append(dictMonoid.Semigroup0());
        var mempty5 = $a801f2c896bd09f1$var$mempty(dictMonoid);
        return function(f2) {
            return foldrWithIndex1(function(i2) {
                return function(x4) {
                    return function(acc) {
                        return append18(f2(i2)(x4))(acc);
                    };
                };
            })(mempty5);
        };
    };
};
var $a801f2c896bd09f1$var$foldableWithIndexArray = {
    foldrWithIndex: function(f2) {
        return function(z3) {
            var $291 = $a801f2c896bd09f1$var$foldr8(function(v3) {
                return function(y4) {
                    return f2(v3.value0)(v3.value1)(y4);
                };
            })(z3);
            var $292 = $a801f2c896bd09f1$var$mapWithIndex2($a801f2c896bd09f1$var$Tuple.create);
            return function($293) {
                return $291($292($293));
            };
        };
    },
    foldlWithIndex: function(f2) {
        return function(z3) {
            var $294 = $a801f2c896bd09f1$var$foldl8(function(y4) {
                return function(v3) {
                    return f2(v3.value0)(y4)(v3.value1);
                };
            })(z3);
            var $295 = $a801f2c896bd09f1$var$mapWithIndex2($a801f2c896bd09f1$var$Tuple.create);
            return function($296) {
                return $294($295($296));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $a801f2c896bd09f1$var$foldMapWithIndexDefaultR($a801f2c896bd09f1$var$foldableWithIndexArray)(dictMonoid);
    },
    Foldable0: function() {
        return $a801f2c896bd09f1$var$foldableArray;
    }
};
// output/Data.TraversableWithIndex/index.js
var $a801f2c896bd09f1$var$traverseWithIndexDefault = function(dictTraversableWithIndex) {
    var sequence5 = $a801f2c896bd09f1$var$sequence(dictTraversableWithIndex.Traversable2());
    var mapWithIndex4 = $a801f2c896bd09f1$var$mapWithIndex(dictTraversableWithIndex.FunctorWithIndex0());
    return function(dictApplicative) {
        var sequence13 = sequence5(dictApplicative);
        return function(f2) {
            var $174 = mapWithIndex4(f2);
            return function($175) {
                return sequence13($174($175));
            };
        };
    };
};
var $a801f2c896bd09f1$var$traverseWithIndex = function(dict) {
    return dict.traverseWithIndex;
};
var $a801f2c896bd09f1$var$traversableWithIndexArray = {
    traverseWithIndex: function(dictApplicative) {
        return $a801f2c896bd09f1$var$traverseWithIndexDefault($a801f2c896bd09f1$var$traversableWithIndexArray)(dictApplicative);
    },
    FunctorWithIndex0: function() {
        return $a801f2c896bd09f1$var$functorWithIndexArray;
    },
    FoldableWithIndex1: function() {
        return $a801f2c896bd09f1$var$foldableWithIndexArray;
    },
    Traversable2: function() {
        return $a801f2c896bd09f1$var$traversableArray;
    }
};
// output/Data.NonEmpty/index.js
var $a801f2c896bd09f1$var$NonEmpty = /* @__PURE__ */ function() {
    function NonEmpty2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    NonEmpty2.create = function(value0) {
        return function(value1) {
            return new NonEmpty2(value0, value1);
        };
    };
    return NonEmpty2;
}();
var $a801f2c896bd09f1$var$singleton2 = function(dictPlus) {
    var empty8 = $a801f2c896bd09f1$var$empty(dictPlus);
    return function(a3) {
        return new $a801f2c896bd09f1$var$NonEmpty(a3, empty8);
    };
};
var $a801f2c896bd09f1$var$showNonEmpty = function(dictShow) {
    var show40 = $a801f2c896bd09f1$var$show(dictShow);
    return function(dictShow1) {
        var show115 = $a801f2c896bd09f1$var$show(dictShow1);
        return {
            show: function(v3) {
                return "(NonEmpty " + (show40(v3.value0) + (" " + (show115(v3.value1) + ")")));
            }
        };
    };
};
var $a801f2c896bd09f1$var$functorNonEmpty = function(dictFunctor) {
    var map215 = $a801f2c896bd09f1$var$map(dictFunctor);
    return {
        map: function(f2) {
            return function(m3) {
                return new $a801f2c896bd09f1$var$NonEmpty(f2(m3.value0), map215(f2)(m3.value1));
            };
        }
    };
};
var $a801f2c896bd09f1$var$foldableNonEmpty = function(dictFoldable) {
    var foldMap5 = $a801f2c896bd09f1$var$foldMap(dictFoldable);
    var foldl10 = $a801f2c896bd09f1$var$foldl(dictFoldable);
    var foldr7 = $a801f2c896bd09f1$var$foldr(dictFoldable);
    return {
        foldMap: function(dictMonoid) {
            var append18 = $a801f2c896bd09f1$var$append(dictMonoid.Semigroup0());
            var foldMap12 = foldMap5(dictMonoid);
            return function(f2) {
                return function(v3) {
                    return append18(f2(v3.value0))(foldMap12(f2)(v3.value1));
                };
            };
        },
        foldl: function(f2) {
            return function(b3) {
                return function(v3) {
                    return foldl10(f2)(f2(b3)(v3.value0))(v3.value1);
                };
            };
        },
        foldr: function(f2) {
            return function(b3) {
                return function(v3) {
                    return f2(v3.value0)(foldr7(f2)(b3)(v3.value1));
                };
            };
        }
    };
};
var $a801f2c896bd09f1$var$eqNonEmpty = function(dictEq1) {
    var eq112 = $a801f2c896bd09f1$var$eq1(dictEq1);
    return function(dictEq) {
        var eq29 = $a801f2c896bd09f1$var$eq(dictEq);
        var eq113 = eq112(dictEq);
        return {
            eq: function(x4) {
                return function(y4) {
                    return eq29(x4.value0)(y4.value0) && eq113(x4.value1)(y4.value1);
                };
            }
        };
    };
};
// output/Data.List.Types/index.js
var $a801f2c896bd09f1$var$Nil = /* @__PURE__ */ function() {
    function Nil2() {}
    Nil2.value = new Nil2();
    return Nil2;
}();
var $a801f2c896bd09f1$var$Cons = /* @__PURE__ */ function() {
    function Cons2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons2.create = function(value0) {
        return function(value1) {
            return new Cons2(value0, value1);
        };
    };
    return Cons2;
}();
var $a801f2c896bd09f1$var$NonEmptyList = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$toList = function(v3) {
    return new $a801f2c896bd09f1$var$Cons(v3.value0, v3.value1);
};
var $a801f2c896bd09f1$var$listMap = function(f2) {
    var chunkedRevMap = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v3, v1) {
                if (v1 instanceof $a801f2c896bd09f1$var$Cons && v1.value1 instanceof $a801f2c896bd09f1$var$Cons && v1.value1.value1 instanceof $a801f2c896bd09f1$var$Cons) {
                    $tco_var_v = new $a801f2c896bd09f1$var$Cons(v1, v3);
                    $copy_v1 = v1.value1.value1.value1;
                    return;
                }
                var unrolledMap = function(v22) {
                    if (v22 instanceof $a801f2c896bd09f1$var$Cons && v22.value1 instanceof $a801f2c896bd09f1$var$Cons && v22.value1.value1 instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Cons(f2(v22.value0), new $a801f2c896bd09f1$var$Cons(f2(v22.value1.value0), $a801f2c896bd09f1$var$Nil.value));
                    if (v22 instanceof $a801f2c896bd09f1$var$Cons && v22.value1 instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Cons(f2(v22.value0), $a801f2c896bd09f1$var$Nil.value);
                    return $a801f2c896bd09f1$var$Nil.value;
                };
                var reverseUnrolledMap = function($copy_v2) {
                    return function($copy_v3) {
                        var $tco_var_v2 = $copy_v2;
                        var $tco_done1 = false;
                        var $tco_result2;
                        function $tco_loop2(v22, v32) {
                            if (v22 instanceof $a801f2c896bd09f1$var$Cons && v22.value0 instanceof $a801f2c896bd09f1$var$Cons && v22.value0.value1 instanceof $a801f2c896bd09f1$var$Cons && v22.value0.value1.value1 instanceof $a801f2c896bd09f1$var$Cons) {
                                $tco_var_v2 = v22.value1;
                                $copy_v3 = new $a801f2c896bd09f1$var$Cons(f2(v22.value0.value0), new $a801f2c896bd09f1$var$Cons(f2(v22.value0.value1.value0), new $a801f2c896bd09f1$var$Cons(f2(v22.value0.value1.value1.value0), v32)));
                                return;
                            }
                            $tco_done1 = true;
                            return v32;
                        }
                        while(!$tco_done1)$tco_result2 = $tco_loop2($tco_var_v2, $copy_v3);
                        return $tco_result2;
                    };
                };
                $tco_done = true;
                return reverseUnrolledMap(v3)(unrolledMap(v1));
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return chunkedRevMap($a801f2c896bd09f1$var$Nil.value);
};
var $a801f2c896bd09f1$var$functorList = {
    map: $a801f2c896bd09f1$var$listMap
};
var $a801f2c896bd09f1$var$map6 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorList);
var $a801f2c896bd09f1$var$functorNonEmptyList = /* @__PURE__ */ $a801f2c896bd09f1$var$functorNonEmpty($a801f2c896bd09f1$var$functorList);
var $a801f2c896bd09f1$var$foldableList = {
    foldr: function(f2) {
        return function(b3) {
            var rev3 = function() {
                var go2 = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v3, v1) {
                            if (v1 instanceof $a801f2c896bd09f1$var$Nil) {
                                $tco_done = true;
                                return v3;
                            }
                            if (v1 instanceof $a801f2c896bd09f1$var$Cons) {
                                $tco_var_v = new $a801f2c896bd09f1$var$Cons(v1.value0, v3);
                                $copy_v1 = v1.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 107, column 7 - line 107, column 23): " + [
                                v3.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go2($a801f2c896bd09f1$var$Nil.value);
            }();
            var $284 = $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableList)($a801f2c896bd09f1$var$flip(f2))(b3);
            return function($285) {
                return $284(rev3($285));
            };
        };
    },
    foldl: function(f2) {
        var go2 = function($copy_b) {
            return function($copy_v) {
                var $tco_var_b = $copy_b;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(b3, v3) {
                    if (v3 instanceof $a801f2c896bd09f1$var$Nil) {
                        $tco_done1 = true;
                        return b3;
                    }
                    if (v3 instanceof $a801f2c896bd09f1$var$Cons) {
                        $tco_var_b = f2(b3)(v3.value0);
                        $copy_v = v3.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List.Types (line 111, column 12 - line 113, column 30): " + [
                        v3.constructor.name
                    ]);
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_b, $copy_v);
                return $tco_result;
            };
        };
        return go2;
    },
    foldMap: function(dictMonoid) {
        var append24 = $a801f2c896bd09f1$var$append(dictMonoid.Semigroup0());
        var mempty5 = $a801f2c896bd09f1$var$mempty(dictMonoid);
        return function(f2) {
            return $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableList)(function(acc) {
                var $286 = append24(acc);
                return function($287) {
                    return $286(f2($287));
                };
            })(mempty5);
        };
    }
};
var $a801f2c896bd09f1$var$foldl2 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$foldr2 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldr($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$intercalate2 = /* @__PURE__ */ $a801f2c896bd09f1$var$intercalate($a801f2c896bd09f1$var$foldableList)($a801f2c896bd09f1$var$monoidString);
var $a801f2c896bd09f1$var$foldableNonEmptyList = /* @__PURE__ */ $a801f2c896bd09f1$var$foldableNonEmpty($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$semigroupList = {
    append: function(xs) {
        return function(ys) {
            return $a801f2c896bd09f1$var$foldr2($a801f2c896bd09f1$var$Cons.create)(ys)(xs);
        };
    }
};
var $a801f2c896bd09f1$var$append1 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupList);
var $a801f2c896bd09f1$var$semigroupNonEmptyList = {
    append: function(v3) {
        return function(as$prime) {
            return new $a801f2c896bd09f1$var$NonEmpty(v3.value0, $a801f2c896bd09f1$var$append1(v3.value1)($a801f2c896bd09f1$var$toList(as$prime)));
        };
    }
};
var $a801f2c896bd09f1$var$showList = function(dictShow) {
    var show40 = $a801f2c896bd09f1$var$show(dictShow);
    return {
        show: function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Nil) return "Nil";
            return "(" + ($a801f2c896bd09f1$var$intercalate2(" : ")($a801f2c896bd09f1$var$map6(show40)(v3)) + " : Nil)");
        }
    };
};
var $a801f2c896bd09f1$var$showNonEmptyList = function(dictShow) {
    var show40 = $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showNonEmpty(dictShow)($a801f2c896bd09f1$var$showList(dictShow)));
    return {
        show: function(v3) {
            return "(NonEmptyList " + (show40(v3) + ")");
        }
    };
};
var $a801f2c896bd09f1$var$unfoldable1List = {
    unfoldr1: function(f2) {
        return function(b3) {
            var go2 = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source3, memo) {
                        var v3 = f2(source3);
                        if (v3.value1 instanceof $a801f2c896bd09f1$var$Just) {
                            $tco_var_source = v3.value1.value0;
                            $copy_memo = new $a801f2c896bd09f1$var$Cons(v3.value0, memo);
                            return;
                        }
                        if (v3.value1 instanceof $a801f2c896bd09f1$var$Nothing) {
                            $tco_done = true;
                            return $a801f2c896bd09f1$var$foldl2($a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$Cons.create))($a801f2c896bd09f1$var$Nil.value)(new $a801f2c896bd09f1$var$Cons(v3.value0, memo));
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 135, column 22 - line 137, column 61): " + [
                            v3.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go2(b3)($a801f2c896bd09f1$var$Nil.value);
        };
    }
};
var $a801f2c896bd09f1$var$unfoldableList = {
    unfoldr: function(f2) {
        return function(b3) {
            var go2 = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source3, memo) {
                        var v3 = f2(source3);
                        if (v3 instanceof $a801f2c896bd09f1$var$Nothing) {
                            $tco_done = true;
                            return $a801f2c896bd09f1$var$foldl2($a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$Cons.create))($a801f2c896bd09f1$var$Nil.value)(memo);
                        }
                        if (v3 instanceof $a801f2c896bd09f1$var$Just) {
                            $tco_var_source = v3.value0.value1;
                            $copy_memo = new $a801f2c896bd09f1$var$Cons(v3.value0.value0, memo);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 142, column 22 - line 144, column 52): " + [
                            v3.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go2(b3)($a801f2c896bd09f1$var$Nil.value);
        };
    },
    Unfoldable10: function() {
        return $a801f2c896bd09f1$var$unfoldable1List;
    }
};
var $a801f2c896bd09f1$var$eq1List = {
    eq1: function(dictEq) {
        var eq29 = $a801f2c896bd09f1$var$eq(dictEq);
        return function(xs) {
            return function(ys) {
                var go2 = function($copy_v) {
                    return function($copy_v1) {
                        return function($copy_v2) {
                            var $tco_var_v = $copy_v;
                            var $tco_var_v1 = $copy_v1;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(v3, v1, v22) {
                                if (!v22) {
                                    $tco_done = true;
                                    return false;
                                }
                                if (v3 instanceof $a801f2c896bd09f1$var$Nil && v1 instanceof $a801f2c896bd09f1$var$Nil) {
                                    $tco_done = true;
                                    return v22;
                                }
                                if (v3 instanceof $a801f2c896bd09f1$var$Cons && v1 instanceof $a801f2c896bd09f1$var$Cons) {
                                    $tco_var_v = v3.value1;
                                    $tco_var_v1 = v1.value1;
                                    $copy_v2 = v22 && eq29(v1.value0)(v3.value0);
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                            return $tco_result;
                        };
                    };
                };
                return go2(xs)(ys)(true);
            };
        };
    }
};
var $a801f2c896bd09f1$var$eq12 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq1($a801f2c896bd09f1$var$eq1List);
var $a801f2c896bd09f1$var$eqNonEmpty2 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqNonEmpty($a801f2c896bd09f1$var$eq1List);
var $a801f2c896bd09f1$var$eqList = function(dictEq) {
    return {
        eq: $a801f2c896bd09f1$var$eq12(dictEq)
    };
};
var $a801f2c896bd09f1$var$eqNonEmptyList = function(dictEq) {
    return $a801f2c896bd09f1$var$eqNonEmpty2(dictEq);
};
var $a801f2c896bd09f1$var$applyList = {
    apply: function(v3) {
        return function(v1) {
            if (v3 instanceof $a801f2c896bd09f1$var$Nil) return $a801f2c896bd09f1$var$Nil.value;
            if (v3 instanceof $a801f2c896bd09f1$var$Cons) return $a801f2c896bd09f1$var$append1($a801f2c896bd09f1$var$map6(v3.value0)(v1))($a801f2c896bd09f1$var$apply($a801f2c896bd09f1$var$applyList)(v3.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 157, column 1 - line 159, column 48): " + [
                v3.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorList;
    }
};
var $a801f2c896bd09f1$var$apply2 = /* @__PURE__ */ $a801f2c896bd09f1$var$apply($a801f2c896bd09f1$var$applyList);
var $a801f2c896bd09f1$var$applyNonEmptyList = {
    apply: function(v3) {
        return function(v1) {
            return new $a801f2c896bd09f1$var$NonEmpty(v3.value0(v1.value0), $a801f2c896bd09f1$var$append1($a801f2c896bd09f1$var$apply2(v3.value1)(new $a801f2c896bd09f1$var$Cons(v1.value0, $a801f2c896bd09f1$var$Nil.value)))($a801f2c896bd09f1$var$apply2(new $a801f2c896bd09f1$var$Cons(v3.value0, v3.value1))(v1.value1)));
        };
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorNonEmptyList;
    }
};
var $a801f2c896bd09f1$var$altList = {
    alt: $a801f2c896bd09f1$var$append1,
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorList;
    }
};
var $a801f2c896bd09f1$var$plusList = /* @__PURE__ */ function() {
    return {
        empty: $a801f2c896bd09f1$var$Nil.value,
        Alt0: function() {
            return $a801f2c896bd09f1$var$altList;
        }
    };
}();
var $a801f2c896bd09f1$var$applicativeNonEmptyList = {
    pure: /* @__PURE__ */ function() {
        var $315 = $a801f2c896bd09f1$var$singleton2($a801f2c896bd09f1$var$plusList);
        return function($316) {
            return $a801f2c896bd09f1$var$NonEmptyList($315($316));
        };
    }(),
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyNonEmptyList;
    }
};
// output/Data.List/index.js
var $a801f2c896bd09f1$var$map7 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$bimap2 = /* @__PURE__ */ $a801f2c896bd09f1$var$bimap($a801f2c896bd09f1$var$bifunctorStep);
var $a801f2c896bd09f1$var$foldl3 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$uncons = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$Nil) return $a801f2c896bd09f1$var$Nothing.value;
    if (v3 instanceof $a801f2c896bd09f1$var$Cons) return new $a801f2c896bd09f1$var$Just({
        head: v3.value0,
        tail: v3.value1
    });
    throw new Error("Failed pattern match at Data.List (line 259, column 1 - line 259, column 66): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$toUnfoldable = function(dictUnfoldable) {
    return $a801f2c896bd09f1$var$unfoldr(dictUnfoldable)(function(xs) {
        return $a801f2c896bd09f1$var$map7(function(rec) {
            return new $a801f2c896bd09f1$var$Tuple(rec.head, rec.tail);
        })($a801f2c896bd09f1$var$uncons(xs));
    });
};
var $a801f2c896bd09f1$var$reverse = /* @__PURE__ */ function() {
    var go2 = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v3, v1) {
                if (v1 instanceof $a801f2c896bd09f1$var$Nil) {
                    $tco_done = true;
                    return v3;
                }
                if (v1 instanceof $a801f2c896bd09f1$var$Cons) {
                    $tco_var_v = new $a801f2c896bd09f1$var$Cons(v1.value0, v3);
                    $copy_v1 = v1.value1;
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 368, column 3 - line 368, column 19): " + [
                    v3.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go2($a801f2c896bd09f1$var$Nil.value);
}();
var $a801f2c896bd09f1$var$zipWith = function(f2) {
    return function(xs) {
        return function(ys) {
            var go2 = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v3, v1, v22) {
                            if (v3 instanceof $a801f2c896bd09f1$var$Nil) {
                                $tco_done = true;
                                return v22;
                            }
                            if (v1 instanceof $a801f2c896bd09f1$var$Nil) {
                                $tco_done = true;
                                return v22;
                            }
                            if (v3 instanceof $a801f2c896bd09f1$var$Cons && v1 instanceof $a801f2c896bd09f1$var$Cons) {
                                $tco_var_v = v3.value1;
                                $tco_var_v1 = v1.value1;
                                $copy_v2 = new $a801f2c896bd09f1$var$Cons(f2(v3.value0)(v1.value0), v22);
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List (line 779, column 3 - line 779, column 21): " + [
                                v3.constructor.name,
                                v1.constructor.name,
                                v22.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            return $a801f2c896bd09f1$var$reverse(go2(xs)(ys)($a801f2c896bd09f1$var$Nil.value));
        };
    };
};
var $a801f2c896bd09f1$var$zip = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$zipWith($a801f2c896bd09f1$var$Tuple.create);
}();
var $a801f2c896bd09f1$var$$$null = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$Nil) return true;
    return false;
};
var $a801f2c896bd09f1$var$manyRec = function(dictMonadRec) {
    var bind115 = $a801f2c896bd09f1$var$bind(dictMonadRec.Monad0().Bind1());
    var tailRecM5 = $a801f2c896bd09f1$var$tailRecM(dictMonadRec);
    return function(dictAlternative) {
        var Alt0 = dictAlternative.Plus1().Alt0();
        var alt10 = $a801f2c896bd09f1$var$alt(Alt0);
        var map121 = $a801f2c896bd09f1$var$map(Alt0.Functor0());
        var pure43 = $a801f2c896bd09f1$var$pure(dictAlternative.Applicative0());
        return function(p3) {
            var go2 = function(acc) {
                return bind115(alt10(map121($a801f2c896bd09f1$var$Loop.create)(p3))(pure43(new $a801f2c896bd09f1$var$Done($a801f2c896bd09f1$var$unit))))(function(aa) {
                    return pure43($a801f2c896bd09f1$var$bimap2(function(v3) {
                        return new $a801f2c896bd09f1$var$Cons(v3, acc);
                    })(function(v3) {
                        return $a801f2c896bd09f1$var$reverse(acc);
                    })(aa));
                });
            };
            return tailRecM5(go2)($a801f2c896bd09f1$var$Nil.value);
        };
    };
};
var $a801f2c896bd09f1$var$length = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl3(function(acc) {
    return function(v3) {
        return acc + 1 | 0;
    };
})(0);
var $a801f2c896bd09f1$var$head = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$Nil) return $a801f2c896bd09f1$var$Nothing.value;
    if (v3 instanceof $a801f2c896bd09f1$var$Cons) return new $a801f2c896bd09f1$var$Just(v3.value0);
    throw new Error("Failed pattern match at Data.List (line 230, column 1 - line 230, column 22): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$fromFoldable = function(dictFoldable) {
    return $a801f2c896bd09f1$var$foldr(dictFoldable)($a801f2c896bd09f1$var$Cons.create)($a801f2c896bd09f1$var$Nil.value);
};
// output/Partial.Unsafe/foreign.js
var $a801f2c896bd09f1$var$_unsafePartial = function(f2) {
    return f2();
};
// output/Partial/foreign.js
var $a801f2c896bd09f1$var$_crashWith = function(msg) {
    throw new Error(msg);
};
// output/Partial/index.js
var $a801f2c896bd09f1$var$crashWith = function() {
    return $a801f2c896bd09f1$var$_crashWith;
};
// output/Partial.Unsafe/index.js
var $a801f2c896bd09f1$var$crashWith2 = /* @__PURE__ */ $a801f2c896bd09f1$var$crashWith();
var $a801f2c896bd09f1$var$unsafePartial = $a801f2c896bd09f1$var$_unsafePartial;
var $a801f2c896bd09f1$var$unsafeCrashWith = function(msg) {
    return $a801f2c896bd09f1$var$unsafePartial(function() {
        return $a801f2c896bd09f1$var$crashWith2(msg);
    });
};
// output/Data.List.NonEmpty/index.js
var $a801f2c896bd09f1$var$singleton3 = /* @__PURE__ */ function() {
    var $200 = $a801f2c896bd09f1$var$singleton2($a801f2c896bd09f1$var$plusList);
    return function($201) {
        return $a801f2c896bd09f1$var$NonEmptyList($200($201));
    };
}();
var $a801f2c896bd09f1$var$length2 = function(v3) {
    return 1 + $a801f2c896bd09f1$var$length(v3.value1) | 0;
};
var $a801f2c896bd09f1$var$cons = function(y4) {
    return function(v3) {
        return new $a801f2c896bd09f1$var$NonEmpty(y4, new $a801f2c896bd09f1$var$Cons(v3.value0, v3.value1));
    };
};
// output/Effect.Exception/foreign.js
function $a801f2c896bd09f1$var$error(msg) {
    return new Error(msg);
}
function $a801f2c896bd09f1$var$message(e) {
    return e.message;
}
function $a801f2c896bd09f1$var$throwException(e) {
    return function() {
        throw e;
    };
}
function $a801f2c896bd09f1$var$catchException(c3) {
    return function(t2) {
        return function() {
            try {
                return t2();
            } catch (e) {
                if (e instanceof Error || Object.prototype.toString.call(e) === "[object Error]") return c3(e)();
                else return c3(new Error(e.toString()))();
            }
        };
    };
}
// output/Effect.Exception/index.js
var $a801f2c896bd09f1$var$pure2 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$map8 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$$$try = function(action2) {
    return $a801f2c896bd09f1$var$catchException(function($3) {
        return $a801f2c896bd09f1$var$pure2($a801f2c896bd09f1$var$Left.create($3));
    })($a801f2c896bd09f1$var$map8($a801f2c896bd09f1$var$Right.create)(action2));
};
var $a801f2c896bd09f1$var$$$throw = function($4) {
    return $a801f2c896bd09f1$var$throwException($a801f2c896bd09f1$var$error($4));
};
// output/Control.Monad.Error.Class/index.js
var $a801f2c896bd09f1$var$throwError = function(dict) {
    return dict.throwError;
};
var $a801f2c896bd09f1$var$catchError = function(dict) {
    return dict.catchError;
};
var $a801f2c896bd09f1$var$$$try2 = function(dictMonadError) {
    var catchError1 = $a801f2c896bd09f1$var$catchError(dictMonadError);
    var Monad0 = dictMonadError.MonadThrow0().Monad0();
    var map59 = $a801f2c896bd09f1$var$map(Monad0.Bind1().Apply0().Functor0());
    var pure43 = $a801f2c896bd09f1$var$pure(Monad0.Applicative0());
    return function(a3) {
        return catchError1(map59($a801f2c896bd09f1$var$Right.create)(a3))(function($52) {
            return pure43($a801f2c896bd09f1$var$Left.create($52));
        });
    };
};
// output/Control.Monad.ST.Internal/foreign.js
var $a801f2c896bd09f1$var$map_ = function(f2) {
    return function(a3) {
        return function() {
            return f2(a3());
        };
    };
};
var $a801f2c896bd09f1$var$pure_ = function(a3) {
    return function() {
        return a3;
    };
};
var $a801f2c896bd09f1$var$bind_ = function(a3) {
    return function(f2) {
        return function() {
            return f2(a3())();
        };
    };
};
var $a801f2c896bd09f1$var$foreach = function(as) {
    return function(f2) {
        return function() {
            for(var i2 = 0, l2 = as.length; i2 < l2; i2++)f2(as[i2])();
        };
    };
};
// output/Control.Monad.ST.Internal/index.js
var $a801f2c896bd09f1$var$$runtime_lazy2 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$functorST = {
    map: $a801f2c896bd09f1$var$map_
};
var $a801f2c896bd09f1$var$monadST = {
    Applicative0: function() {
        return $a801f2c896bd09f1$var$applicativeST;
    },
    Bind1: function() {
        return $a801f2c896bd09f1$var$bindST;
    }
};
var $a801f2c896bd09f1$var$bindST = {
    bind: $a801f2c896bd09f1$var$bind_,
    Apply0: function() {
        return $a801f2c896bd09f1$var$$lazy_applyST(0);
    }
};
var $a801f2c896bd09f1$var$applicativeST = {
    pure: $a801f2c896bd09f1$var$pure_,
    Apply0: function() {
        return $a801f2c896bd09f1$var$$lazy_applyST(0);
    }
};
var $a801f2c896bd09f1$var$$lazy_applyST = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy2("applyST", "Control.Monad.ST.Internal", function() {
    return {
        apply: $a801f2c896bd09f1$var$ap($a801f2c896bd09f1$var$monadST),
        Functor0: function() {
            return $a801f2c896bd09f1$var$functorST;
        }
    };
});
// output/Control.Monad.State.Class/index.js
var $a801f2c896bd09f1$var$state = function(dict) {
    return dict.state;
};
var $a801f2c896bd09f1$var$put = function(dictMonadState) {
    var state1 = $a801f2c896bd09f1$var$state(dictMonadState);
    return function(s2) {
        return state1(function(v3) {
            return new $a801f2c896bd09f1$var$Tuple($a801f2c896bd09f1$var$unit, s2);
        });
    };
};
var $a801f2c896bd09f1$var$modify_2 = function(dictMonadState) {
    var state1 = $a801f2c896bd09f1$var$state(dictMonadState);
    return function(f2) {
        return state1(function(s2) {
            return new $a801f2c896bd09f1$var$Tuple($a801f2c896bd09f1$var$unit, f2(s2));
        });
    };
};
var $a801f2c896bd09f1$var$modify2 = function(dictMonadState) {
    var state1 = $a801f2c896bd09f1$var$state(dictMonadState);
    return function(f2) {
        return state1(function(s2) {
            var s$prime = f2(s2);
            return new $a801f2c896bd09f1$var$Tuple(s$prime, s$prime);
        });
    };
};
var $a801f2c896bd09f1$var$gets = function(dictMonadState) {
    var state1 = $a801f2c896bd09f1$var$state(dictMonadState);
    return function(f2) {
        return state1(function(s2) {
            return new $a801f2c896bd09f1$var$Tuple(f2(s2), s2);
        });
    };
};
var $a801f2c896bd09f1$var$get = function(dictMonadState) {
    return $a801f2c896bd09f1$var$state(dictMonadState)(function(s2) {
        return new $a801f2c896bd09f1$var$Tuple(s2, s2);
    });
};
// output/Control.Monad.Trans.Class/index.js
var $a801f2c896bd09f1$var$lift = function(dict) {
    return dict.lift;
};
// output/Effect.Class/index.js
var $a801f2c896bd09f1$var$monadEffectEffect = {
    liftEffect: /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn),
    Monad0: function() {
        return $a801f2c896bd09f1$var$monadEffect;
    }
};
var $a801f2c896bd09f1$var$liftEffect = function(dict) {
    return dict.liftEffect;
};
// output/Control.Monad.Except.Trans/index.js
var $a801f2c896bd09f1$var$map9 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEither);
var $a801f2c896bd09f1$var$ExceptT = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$withExceptT = function(dictFunctor) {
    var map121 = $a801f2c896bd09f1$var$map(dictFunctor);
    return function(f2) {
        return function(v3) {
            var mapLeft = function(v1) {
                return function(v22) {
                    if (v22 instanceof $a801f2c896bd09f1$var$Right) return new $a801f2c896bd09f1$var$Right(v22.value0);
                    if (v22 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(v1(v22.value0));
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 43, column 3 - line 43, column 32): " + [
                        v1.constructor.name,
                        v22.constructor.name
                    ]);
                };
            };
            return map121(mapLeft(f2))(v3);
        };
    };
};
var $a801f2c896bd09f1$var$runExceptT = function(v3) {
    return v3;
};
var $a801f2c896bd09f1$var$mapExceptT = function(f2) {
    return function(v3) {
        return f2(v3);
    };
};
var $a801f2c896bd09f1$var$functorExceptT = function(dictFunctor) {
    var map121 = $a801f2c896bd09f1$var$map(dictFunctor);
    return {
        map: function(f2) {
            return $a801f2c896bd09f1$var$mapExceptT(map121($a801f2c896bd09f1$var$map9(f2)));
        }
    };
};
var $a801f2c896bd09f1$var$monadExceptT = function(dictMonad) {
    return {
        Applicative0: function() {
            return $a801f2c896bd09f1$var$applicativeExceptT(dictMonad);
        },
        Bind1: function() {
            return $a801f2c896bd09f1$var$bindExceptT(dictMonad);
        }
    };
};
var $a801f2c896bd09f1$var$bindExceptT = function(dictMonad) {
    var bind37 = $a801f2c896bd09f1$var$bind(dictMonad.Bind1());
    var pure43 = $a801f2c896bd09f1$var$pure(dictMonad.Applicative0());
    return {
        bind: function(v3) {
            return function(k2) {
                return bind37(v3)($a801f2c896bd09f1$var$either(function($193) {
                    return pure43($a801f2c896bd09f1$var$Left.create($193));
                })(function(a3) {
                    var v1 = k2(a3);
                    return v1;
                }));
            };
        },
        Apply0: function() {
            return $a801f2c896bd09f1$var$applyExceptT(dictMonad);
        }
    };
};
var $a801f2c896bd09f1$var$applyExceptT = function(dictMonad) {
    var functorExceptT1 = $a801f2c896bd09f1$var$functorExceptT(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $a801f2c896bd09f1$var$ap($a801f2c896bd09f1$var$monadExceptT(dictMonad)),
        Functor0: function() {
            return functorExceptT1;
        }
    };
};
var $a801f2c896bd09f1$var$applicativeExceptT = function(dictMonad) {
    return {
        pure: function() {
            var $194 = $a801f2c896bd09f1$var$pure(dictMonad.Applicative0());
            return function($195) {
                return $a801f2c896bd09f1$var$ExceptT($194($a801f2c896bd09f1$var$Right.create($195)));
            };
        }(),
        Apply0: function() {
            return $a801f2c896bd09f1$var$applyExceptT(dictMonad);
        }
    };
};
var $a801f2c896bd09f1$var$monadThrowExceptT = function(dictMonad) {
    var monadExceptT1 = $a801f2c896bd09f1$var$monadExceptT(dictMonad);
    return {
        throwError: function() {
            var $204 = $a801f2c896bd09f1$var$pure(dictMonad.Applicative0());
            return function($205) {
                return $a801f2c896bd09f1$var$ExceptT($204($a801f2c896bd09f1$var$Left.create($205)));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $a801f2c896bd09f1$var$altExceptT = function(dictSemigroup) {
    var append18 = $a801f2c896bd09f1$var$append(dictSemigroup);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var bind37 = $a801f2c896bd09f1$var$bind(Bind1);
        var pure43 = $a801f2c896bd09f1$var$pure(dictMonad.Applicative0());
        var functorExceptT1 = $a801f2c896bd09f1$var$functorExceptT(Bind1.Apply0().Functor0());
        return {
            alt: function(v3) {
                return function(v1) {
                    return bind37(v3)(function(rm) {
                        if (rm instanceof $a801f2c896bd09f1$var$Right) return pure43(new $a801f2c896bd09f1$var$Right(rm.value0));
                        if (rm instanceof $a801f2c896bd09f1$var$Left) return bind37(v1)(function(rn) {
                            if (rn instanceof $a801f2c896bd09f1$var$Right) return pure43(new $a801f2c896bd09f1$var$Right(rn.value0));
                            if (rn instanceof $a801f2c896bd09f1$var$Left) return pure43(new $a801f2c896bd09f1$var$Left(append18(rm.value0)(rn.value0)));
                            throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 87, column 9 - line 89, column 49): " + [
                                rn.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 83, column 5 - line 89, column 49): " + [
                            rm.constructor.name
                        ]);
                    });
                };
            },
            Functor0: function() {
                return functorExceptT1;
            }
        };
    };
};
// output/Foreign/foreign.js
function $a801f2c896bd09f1$var$typeOf(value17) {
    return typeof value17;
}
function $a801f2c896bd09f1$var$tagOf(value17) {
    return Object.prototype.toString.call(value17).slice(8, -1);
}
function $a801f2c896bd09f1$var$isNull(value17) {
    return value17 === null;
}
function $a801f2c896bd09f1$var$isUndefined(value17) {
    return value17 === void 0;
}
var $a801f2c896bd09f1$var$isArray = Array.isArray || function(value17) {
    return Object.prototype.toString.call(value17) === "[object Array]";
};
// output/Data.Int/foreign.js
var $a801f2c896bd09f1$var$fromNumberImpl = function(just) {
    return function(nothing) {
        return function(n) {
            return (n | 0) === n ? just(n) : nothing;
        };
    };
};
var $a801f2c896bd09f1$var$toNumber = function(n) {
    return n;
};
var $a801f2c896bd09f1$var$fromStringAsImpl = function(just) {
    return function(nothing) {
        return function(radix) {
            var digits;
            if (radix < 11) digits = "[0-" + (radix - 1).toString() + "]";
            else if (radix === 11) digits = "[0-9a]";
            else digits = "[0-9a-" + String.fromCharCode(86 + radix) + "]";
            var pattern2 = new RegExp("^[\\+\\-]?" + digits + "+$", "i");
            return function(s2) {
                if (pattern2.test(s2)) {
                    var i2 = parseInt(s2, radix);
                    return (i2 | 0) === i2 ? just(i2) : nothing;
                } else return nothing;
            };
        };
    };
};
// output/Data.Number/foreign.js
var $a801f2c896bd09f1$var$isFiniteImpl = isFinite;
function $a801f2c896bd09f1$var$fromStringImpl(str, isFinite2, just, nothing) {
    var num = parseFloat(str);
    if (isFinite2(num)) return just(num);
    else return nothing;
}
var $a801f2c896bd09f1$var$exp = Math.exp;
// output/Data.Number/index.js
var $a801f2c896bd09f1$var$fromString = function(str) {
    return $a801f2c896bd09f1$var$fromStringImpl(str, $a801f2c896bd09f1$var$isFiniteImpl, $a801f2c896bd09f1$var$Just.create, $a801f2c896bd09f1$var$Nothing.value);
};
// output/Data.Int/index.js
var $a801f2c896bd09f1$var$fromStringAs = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$fromStringAsImpl($a801f2c896bd09f1$var$Just.create)($a801f2c896bd09f1$var$Nothing.value);
}();
var $a801f2c896bd09f1$var$fromString2 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromStringAs(10);
var $a801f2c896bd09f1$var$fromNumber = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$fromNumberImpl($a801f2c896bd09f1$var$Just.create)($a801f2c896bd09f1$var$Nothing.value);
}();
// output/Data.String.CodeUnits/foreign.js
var $a801f2c896bd09f1$var$singleton4 = function(c3) {
    return c3;
};
var $a801f2c896bd09f1$var$_charAt = function(just) {
    return function(nothing) {
        return function(i2) {
            return function(s2) {
                return i2 >= 0 && i2 < s2.length ? just(s2.charAt(i2)) : nothing;
            };
        };
    };
};
var $a801f2c896bd09f1$var$length3 = function(s2) {
    return s2.length;
};
var $a801f2c896bd09f1$var$drop2 = function(n) {
    return function(s2) {
        return s2.substring(n);
    };
};
var $a801f2c896bd09f1$var$splitAt = function(i2) {
    return function(s2) {
        return {
            before: s2.substring(0, i2),
            after: s2.substring(i2)
        };
    };
};
// output/Data.String.Unsafe/foreign.js
var $a801f2c896bd09f1$var$charAt = function(i2) {
    return function(s2) {
        if (i2 >= 0 && i2 < s2.length) return s2.charAt(i2);
        throw new Error("Data.String.Unsafe.charAt: Invalid index.");
    };
};
// output/Data.String.CodeUnits/index.js
var $a801f2c896bd09f1$var$stripSuffix = function(v3) {
    return function(str) {
        var v1 = $a801f2c896bd09f1$var$splitAt($a801f2c896bd09f1$var$length3(str) - $a801f2c896bd09f1$var$length3(v3) | 0)(str);
        var $14 = v1.after === v3;
        if ($14) return new $a801f2c896bd09f1$var$Just(v1.before);
        return $a801f2c896bd09f1$var$Nothing.value;
    };
};
var $a801f2c896bd09f1$var$charAt2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$_charAt($a801f2c896bd09f1$var$Just.create)($a801f2c896bd09f1$var$Nothing.value);
}();
// output/Foreign/index.js
var $a801f2c896bd09f1$var$show2 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showString);
var $a801f2c896bd09f1$var$show1 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$pure3 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$ForeignError = /* @__PURE__ */ function() {
    function ForeignError2(value0) {
        this.value0 = value0;
    }
    ForeignError2.create = function(value0) {
        return new ForeignError2(value0);
    };
    return ForeignError2;
}();
var $a801f2c896bd09f1$var$TypeMismatch = /* @__PURE__ */ function() {
    function TypeMismatch2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TypeMismatch2.create = function(value0) {
        return function(value1) {
            return new TypeMismatch2(value0, value1);
        };
    };
    return TypeMismatch2;
}();
var $a801f2c896bd09f1$var$ErrorAtIndex = /* @__PURE__ */ function() {
    function ErrorAtIndex2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtIndex2.create = function(value0) {
        return function(value1) {
            return new ErrorAtIndex2(value0, value1);
        };
    };
    return ErrorAtIndex2;
}();
var $a801f2c896bd09f1$var$ErrorAtProperty = /* @__PURE__ */ function() {
    function ErrorAtProperty2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtProperty2.create = function(value0) {
        return function(value1) {
            return new ErrorAtProperty2(value0, value1);
        };
    };
    return ErrorAtProperty2;
}();
var $a801f2c896bd09f1$var$unsafeToForeign = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$unsafeFromForeign = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$showForeignError = {
    show: function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$ForeignError) return "(ForeignError " + ($a801f2c896bd09f1$var$show2(v3.value0) + ")");
        if (v3 instanceof $a801f2c896bd09f1$var$ErrorAtIndex) return "(ErrorAtIndex " + ($a801f2c896bd09f1$var$show1(v3.value0) + (" " + ($a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showForeignError)(v3.value1) + ")")));
        if (v3 instanceof $a801f2c896bd09f1$var$ErrorAtProperty) return "(ErrorAtProperty " + ($a801f2c896bd09f1$var$show2(v3.value0) + (" " + ($a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showForeignError)(v3.value1) + ")")));
        if (v3 instanceof $a801f2c896bd09f1$var$TypeMismatch) return "(TypeMismatch " + ($a801f2c896bd09f1$var$show2(v3.value0) + (" " + ($a801f2c896bd09f1$var$show2(v3.value1) + ")")));
        throw new Error("Failed pattern match at Foreign (line 69, column 1 - line 73, column 89): " + [
            v3.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$renderForeignError = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$ForeignError) return v3.value0;
    if (v3 instanceof $a801f2c896bd09f1$var$ErrorAtIndex) return "Error at array index " + ($a801f2c896bd09f1$var$show1(v3.value0) + (": " + $a801f2c896bd09f1$var$renderForeignError(v3.value1)));
    if (v3 instanceof $a801f2c896bd09f1$var$ErrorAtProperty) return "Error at property " + ($a801f2c896bd09f1$var$show2(v3.value0) + (": " + $a801f2c896bd09f1$var$renderForeignError(v3.value1)));
    if (v3 instanceof $a801f2c896bd09f1$var$TypeMismatch) return "Type mismatch: expected " + (v3.value0 + (", found " + v3.value1));
    throw new Error("Failed pattern match at Foreign (line 78, column 1 - line 78, column 45): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$fail = function(dictMonad) {
    var $153 = $a801f2c896bd09f1$var$throwError($a801f2c896bd09f1$var$monadThrowExceptT(dictMonad));
    return function($154) {
        return $153($a801f2c896bd09f1$var$singleton3($154));
    };
};
var $a801f2c896bd09f1$var$readArray = function(dictMonad) {
    var pure116 = $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeExceptT(dictMonad));
    var fail1 = $a801f2c896bd09f1$var$fail(dictMonad);
    return function(value17) {
        if ($a801f2c896bd09f1$var$isArray(value17)) return pure116($a801f2c896bd09f1$var$unsafeFromForeign(value17));
        if ($a801f2c896bd09f1$var$otherwise) return fail1(new $a801f2c896bd09f1$var$TypeMismatch("array", $a801f2c896bd09f1$var$tagOf(value17)));
        throw new Error("Failed pattern match at Foreign (line 164, column 1 - line 164, column 99): " + [
            value17.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$unsafeReadTagged = function(dictMonad) {
    var pure116 = $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeExceptT(dictMonad));
    var fail1 = $a801f2c896bd09f1$var$fail(dictMonad);
    return function(tag) {
        return function(value17) {
            if ($a801f2c896bd09f1$var$tagOf(value17) === tag) return pure116($a801f2c896bd09f1$var$unsafeFromForeign(value17));
            if ($a801f2c896bd09f1$var$otherwise) return fail1(new $a801f2c896bd09f1$var$TypeMismatch(tag, $a801f2c896bd09f1$var$tagOf(value17)));
            throw new Error("Failed pattern match at Foreign (line 123, column 1 - line 123, column 104): " + [
                tag.constructor.name,
                value17.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$readNumber = function(dictMonad) {
    return $a801f2c896bd09f1$var$unsafeReadTagged(dictMonad)("Number");
};
var $a801f2c896bd09f1$var$readInt = function(dictMonad) {
    var map59 = $a801f2c896bd09f1$var$map(dictMonad.Bind1().Apply0().Functor0());
    var readNumber1 = $a801f2c896bd09f1$var$readNumber(dictMonad);
    return function(value17) {
        var error5 = new $a801f2c896bd09f1$var$Left($a801f2c896bd09f1$var$singleton3(new $a801f2c896bd09f1$var$TypeMismatch("Int", $a801f2c896bd09f1$var$tagOf(value17))));
        var fromNumber2 = function() {
            var $155 = $a801f2c896bd09f1$var$maybe(error5)($a801f2c896bd09f1$var$pure3);
            return function($156) {
                return $155($a801f2c896bd09f1$var$fromNumber($156));
            };
        }();
        return $a801f2c896bd09f1$var$mapExceptT(map59($a801f2c896bd09f1$var$either($a801f2c896bd09f1$var$$$const(error5))(fromNumber2)))(readNumber1(value17));
    };
};
var $a801f2c896bd09f1$var$readString = function(dictMonad) {
    return $a801f2c896bd09f1$var$unsafeReadTagged(dictMonad)("String");
};
var $a801f2c896bd09f1$var$eqForeignError = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$ForeignError && y4 instanceof $a801f2c896bd09f1$var$ForeignError) return x4.value0 === y4.value0;
            if (x4 instanceof $a801f2c896bd09f1$var$TypeMismatch && y4 instanceof $a801f2c896bd09f1$var$TypeMismatch) return x4.value0 === y4.value0 && x4.value1 === y4.value1;
            if (x4 instanceof $a801f2c896bd09f1$var$ErrorAtIndex && y4 instanceof $a801f2c896bd09f1$var$ErrorAtIndex) return x4.value0 === y4.value0 && $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqForeignError)(x4.value1)(y4.value1);
            if (x4 instanceof $a801f2c896bd09f1$var$ErrorAtProperty && y4 instanceof $a801f2c896bd09f1$var$ErrorAtProperty) return x4.value0 === y4.value0 && $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqForeignError)(x4.value1)(y4.value1);
            return false;
        };
    }
};
// output/Simple.JSON/foreign.js
var $a801f2c896bd09f1$var$_parseJSON = JSON.parse;
var $a801f2c896bd09f1$var$_undefined = void 0;
var $a801f2c896bd09f1$var$_unsafeStringify = JSON.stringify;
// output/Control.Monad.Except/index.js
var $a801f2c896bd09f1$var$unwrap2 = /* @__PURE__ */ $a801f2c896bd09f1$var$unwrap();
var $a801f2c896bd09f1$var$withExcept = /* @__PURE__ */ $a801f2c896bd09f1$var$withExceptT($a801f2c896bd09f1$var$functorIdentity);
var $a801f2c896bd09f1$var$runExcept = function($3) {
    return $a801f2c896bd09f1$var$unwrap2($a801f2c896bd09f1$var$runExceptT($3));
};
// output/Data.Array/foreign.js
var $a801f2c896bd09f1$var$replicateFill = function(count, value17) {
    if (count < 1) return [];
    var result2 = new Array(count);
    return result2.fill(value17);
};
var $a801f2c896bd09f1$var$replicatePolyfill = function(count, value17) {
    var result2 = [];
    var n = 0;
    for(var i2 = 0; i2 < count; i2++)result2[n++] = value17;
    return result2;
};
var $a801f2c896bd09f1$var$replicateImpl = typeof Array.prototype.fill === "function" ? $a801f2c896bd09f1$var$replicateFill : $a801f2c896bd09f1$var$replicatePolyfill;
var $a801f2c896bd09f1$var$fromFoldableImpl = /* @__PURE__ */ function() {
    function Cons2(head5, tail2) {
        this.head = head5;
        this.tail = tail2;
    }
    var emptyList = {};
    function curryCons(head5) {
        return function(tail2) {
            return new Cons2(head5, tail2);
        };
    }
    function listToArray(list) {
        var result2 = [];
        var count = 0;
        var xs = list;
        while(xs !== emptyList){
            result2[count++] = xs.head;
            xs = xs.tail;
        }
        return result2;
    }
    return function(foldr7, xs) {
        return listToArray(foldr7(curryCons)(emptyList)(xs));
    };
}();
var $a801f2c896bd09f1$var$length4 = function(xs) {
    return xs.length;
};
var $a801f2c896bd09f1$var$unconsImpl = function(empty8, next, xs) {
    return xs.length === 0 ? empty8({}) : next(xs[0])(xs.slice(1));
};
var $a801f2c896bd09f1$var$indexImpl = function(just, nothing, xs, i2) {
    return i2 < 0 || i2 >= xs.length ? nothing : just(xs[i2]);
};
var $a801f2c896bd09f1$var$findIndexImpl = function(just, nothing, f2, xs) {
    for(var i2 = 0, l2 = xs.length; i2 < l2; i2++){
        if (f2(xs[i2])) return just(i2);
    }
    return nothing;
};
var $a801f2c896bd09f1$var$_deleteAt = function(just, nothing, i2, l2) {
    if (i2 < 0 || i2 >= l2.length) return nothing;
    var l1 = l2.slice();
    l1.splice(i2, 1);
    return just(l1);
};
var $a801f2c896bd09f1$var$reverse2 = function(l2) {
    return l2.slice().reverse();
};
var $a801f2c896bd09f1$var$filterImpl = function(f2, xs) {
    return xs.filter(f2);
};
var $a801f2c896bd09f1$var$sortByImpl = /* @__PURE__ */ function() {
    function mergeFromTo(compare6, fromOrdering, xs1, xs2, from3, to2) {
        var mid;
        var i2;
        var j2;
        var k2;
        var x4;
        var y4;
        var c3;
        mid = from3 + (to2 - from3 >> 1);
        if (mid - from3 > 1) mergeFromTo(compare6, fromOrdering, xs2, xs1, from3, mid);
        if (to2 - mid > 1) mergeFromTo(compare6, fromOrdering, xs2, xs1, mid, to2);
        i2 = from3;
        j2 = mid;
        k2 = from3;
        while(i2 < mid && j2 < to2){
            x4 = xs2[i2];
            y4 = xs2[j2];
            c3 = fromOrdering(compare6(x4)(y4));
            if (c3 > 0) {
                xs1[k2++] = y4;
                ++j2;
            } else {
                xs1[k2++] = x4;
                ++i2;
            }
        }
        while(i2 < mid)xs1[k2++] = xs2[i2++];
        while(j2 < to2)xs1[k2++] = xs2[j2++];
    }
    return function(compare6, fromOrdering, xs) {
        var out;
        if (xs.length < 2) return xs;
        out = xs.slice(0);
        mergeFromTo(compare6, fromOrdering, out, xs.slice(0), 0, xs.length);
        return out;
    };
}();
var $a801f2c896bd09f1$var$zipWithImpl = function(f2, xs, ys) {
    var l2 = xs.length < ys.length ? xs.length : ys.length;
    var result2 = new Array(l2);
    for(var i2 = 0; i2 < l2; i2++)result2[i2] = f2(xs[i2])(ys[i2]);
    return result2;
};
var $a801f2c896bd09f1$var$anyImpl = function(p3, xs) {
    var len = xs.length;
    for(var i2 = 0; i2 < len; i2++){
        if (p3(xs[i2])) return true;
    }
    return false;
};
var $a801f2c896bd09f1$var$unsafeIndexImpl = function(xs, n) {
    return xs[n];
};
// output/Data.Array.ST/foreign.js
function $a801f2c896bd09f1$var$unsafeFreezeThawImpl(xs) {
    return xs;
}
var $a801f2c896bd09f1$var$unsafeFreezeImpl = $a801f2c896bd09f1$var$unsafeFreezeThawImpl;
function $a801f2c896bd09f1$var$copyImpl(xs) {
    return xs.slice();
}
var $a801f2c896bd09f1$var$thawImpl = $a801f2c896bd09f1$var$copyImpl;
var $a801f2c896bd09f1$var$pushImpl = function(a3, xs) {
    return xs.push(a3);
};
// output/Control.Monad.ST.Uncurried/foreign.js
var $a801f2c896bd09f1$var$runSTFn1 = function runSTFn12(fn) {
    return function(a3) {
        return function() {
            return fn(a3);
        };
    };
};
var $a801f2c896bd09f1$var$runSTFn2 = function runSTFn22(fn) {
    return function(a3) {
        return function(b3) {
            return function() {
                return fn(a3, b3);
            };
        };
    };
};
// output/Data.Array.ST/index.js
var $a801f2c896bd09f1$var$unsafeFreeze = /* @__PURE__ */ $a801f2c896bd09f1$var$runSTFn1($a801f2c896bd09f1$var$unsafeFreezeImpl);
var $a801f2c896bd09f1$var$thaw = /* @__PURE__ */ $a801f2c896bd09f1$var$runSTFn1($a801f2c896bd09f1$var$thawImpl);
var $a801f2c896bd09f1$var$withArray = function(f2) {
    return function(xs) {
        return function __do2() {
            var result2 = $a801f2c896bd09f1$var$thaw(xs)();
            f2(result2)();
            return $a801f2c896bd09f1$var$unsafeFreeze(result2)();
        };
    };
};
var $a801f2c896bd09f1$var$push = /* @__PURE__ */ $a801f2c896bd09f1$var$runSTFn2($a801f2c896bd09f1$var$pushImpl);
// output/Data.Function.Uncurried/foreign.js
var $a801f2c896bd09f1$var$runFn2 = function(fn) {
    return function(a3) {
        return function(b3) {
            return fn(a3, b3);
        };
    };
};
var $a801f2c896bd09f1$var$runFn3 = function(fn) {
    return function(a3) {
        return function(b3) {
            return function(c3) {
                return fn(a3, b3, c3);
            };
        };
    };
};
var $a801f2c896bd09f1$var$runFn4 = function(fn) {
    return function(a3) {
        return function(b3) {
            return function(c3) {
                return function(d) {
                    return fn(a3, b3, c3, d);
                };
            };
        };
    };
};
// output/Data.Array/index.js
var $a801f2c896bd09f1$var$map10 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$fromJust4 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromJust();
var $a801f2c896bd09f1$var$append2 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$zipWith2 = /* @__PURE__ */ $a801f2c896bd09f1$var$runFn3($a801f2c896bd09f1$var$zipWithImpl);
var $a801f2c896bd09f1$var$unsafeIndex = function() {
    return $a801f2c896bd09f1$var$runFn2($a801f2c896bd09f1$var$unsafeIndexImpl);
};
var $a801f2c896bd09f1$var$unsafeIndex1 = /* @__PURE__ */ $a801f2c896bd09f1$var$unsafeIndex();
var $a801f2c896bd09f1$var$uncons2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$runFn3($a801f2c896bd09f1$var$unconsImpl)($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$Nothing.value))(function(x4) {
        return function(xs) {
            return new $a801f2c896bd09f1$var$Just({
                head: x4,
                tail: xs
            });
        };
    });
}();
var $a801f2c896bd09f1$var$toUnfoldable2 = function(dictUnfoldable) {
    var unfoldr3 = $a801f2c896bd09f1$var$unfoldr(dictUnfoldable);
    return function(xs) {
        var len = $a801f2c896bd09f1$var$length4(xs);
        var f2 = function(i2) {
            if (i2 < len) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Tuple($a801f2c896bd09f1$var$unsafeIndex1(xs)(i2), i2 + 1 | 0));
            if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$Nothing.value;
            throw new Error("Failed pattern match at Data.Array (line 163, column 3 - line 165, column 26): " + [
                i2.constructor.name
            ]);
        };
        return unfoldr3(f2)(0);
    };
};
var $a801f2c896bd09f1$var$tail = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$runFn3($a801f2c896bd09f1$var$unconsImpl)($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$Nothing.value))(function(v3) {
        return function(xs) {
            return new $a801f2c896bd09f1$var$Just(xs);
        };
    });
}();
var $a801f2c896bd09f1$var$sortBy2 = function(comp) {
    return $a801f2c896bd09f1$var$runFn3($a801f2c896bd09f1$var$sortByImpl)(comp)(function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$GT) return 1;
        if (v3 instanceof $a801f2c896bd09f1$var$EQ) return 0;
        if (v3 instanceof $a801f2c896bd09f1$var$LT) return -1;
        throw new Error("Failed pattern match at Data.Array (line 897, column 38 - line 900, column 11): " + [
            v3.constructor.name
        ]);
    });
};
var $a801f2c896bd09f1$var$sortWith = function(dictOrd) {
    var comparing2 = $a801f2c896bd09f1$var$comparing(dictOrd);
    return function(f2) {
        return $a801f2c896bd09f1$var$sortBy2(comparing2(f2));
    };
};
var $a801f2c896bd09f1$var$snoc2 = function(xs) {
    return function(x4) {
        return $a801f2c896bd09f1$var$withArray($a801f2c896bd09f1$var$push(x4))(xs)();
    };
};
var $a801f2c896bd09f1$var$singleton5 = function(a3) {
    return [
        a3
    ];
};
var $a801f2c896bd09f1$var$replicate = /* @__PURE__ */ $a801f2c896bd09f1$var$runFn2($a801f2c896bd09f1$var$replicateImpl);
var $a801f2c896bd09f1$var$mapWithIndex3 = /* @__PURE__ */ $a801f2c896bd09f1$var$mapWithIndex($a801f2c896bd09f1$var$functorWithIndexArray);
var $a801f2c896bd09f1$var$index2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$runFn4($a801f2c896bd09f1$var$indexImpl)($a801f2c896bd09f1$var$Just.create)($a801f2c896bd09f1$var$Nothing.value);
}();
var $a801f2c896bd09f1$var$last2 = function(xs) {
    return $a801f2c896bd09f1$var$index2(xs)($a801f2c896bd09f1$var$length4(xs) - 1 | 0);
};
var $a801f2c896bd09f1$var$fromFoldable2 = function(dictFoldable) {
    return $a801f2c896bd09f1$var$runFn2($a801f2c896bd09f1$var$fromFoldableImpl)($a801f2c896bd09f1$var$foldr(dictFoldable));
};
var $a801f2c896bd09f1$var$foldr3 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldr($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$findIndex2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$runFn4($a801f2c896bd09f1$var$findIndexImpl)($a801f2c896bd09f1$var$Just.create)($a801f2c896bd09f1$var$Nothing.value);
}();
var $a801f2c896bd09f1$var$find2 = function(f2) {
    return function(xs) {
        return $a801f2c896bd09f1$var$map10($a801f2c896bd09f1$var$unsafeIndex1(xs))($a801f2c896bd09f1$var$findIndex2(f2)(xs));
    };
};
var $a801f2c896bd09f1$var$filter2 = /* @__PURE__ */ $a801f2c896bd09f1$var$runFn2($a801f2c896bd09f1$var$filterImpl);
var $a801f2c896bd09f1$var$elemIndex = function(dictEq) {
    var eq29 = $a801f2c896bd09f1$var$eq(dictEq);
    return function(x4) {
        return $a801f2c896bd09f1$var$findIndex2(function(v3) {
            return eq29(v3)(x4);
        });
    };
};
var $a801f2c896bd09f1$var$elem2 = function(dictEq) {
    var elemIndex1 = $a801f2c896bd09f1$var$elemIndex(dictEq);
    return function(a3) {
        return function(arr) {
            return $a801f2c896bd09f1$var$isJust(elemIndex1(a3)(arr));
        };
    };
};
var $a801f2c896bd09f1$var$deleteAt = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$runFn4($a801f2c896bd09f1$var$_deleteAt)($a801f2c896bd09f1$var$Just.create)($a801f2c896bd09f1$var$Nothing.value);
}();
var $a801f2c896bd09f1$var$deleteBy = function(v3) {
    return function(v1) {
        return function(v22) {
            if (v22.length === 0) return [];
            return $a801f2c896bd09f1$var$maybe(v22)(function(i2) {
                return $a801f2c896bd09f1$var$fromJust4($a801f2c896bd09f1$var$deleteAt(i2)(v22));
            })($a801f2c896bd09f1$var$findIndex2(v3(v1))(v22));
        };
    };
};
var $a801f2c896bd09f1$var$$$delete = function(dictEq) {
    return $a801f2c896bd09f1$var$deleteBy($a801f2c896bd09f1$var$eq(dictEq));
};
var $a801f2c896bd09f1$var$difference = function(dictEq) {
    return $a801f2c896bd09f1$var$foldr3($a801f2c896bd09f1$var$$$delete(dictEq));
};
var $a801f2c896bd09f1$var$cons2 = function(x4) {
    return function(xs) {
        return $a801f2c896bd09f1$var$append2([
            x4
        ])(xs);
    };
};
var $a801f2c896bd09f1$var$concatMap = /* @__PURE__ */ $a801f2c896bd09f1$var$flip(/* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindArray));
var $a801f2c896bd09f1$var$mapMaybe2 = function(f2) {
    return $a801f2c896bd09f1$var$concatMap(function() {
        var $189 = $a801f2c896bd09f1$var$maybe([])($a801f2c896bd09f1$var$singleton5);
        return function($190) {
            return $189(f2($190));
        };
    }());
};
var $a801f2c896bd09f1$var$catMaybes2 = /* @__PURE__ */ $a801f2c896bd09f1$var$mapMaybe2(/* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn));
var $a801f2c896bd09f1$var$any2 = /* @__PURE__ */ $a801f2c896bd09f1$var$runFn2($a801f2c896bd09f1$var$anyImpl);
// output/Data.Nullable/foreign.js
var $a801f2c896bd09f1$var$nullImpl = null;
function $a801f2c896bd09f1$var$nullable(a3, r, f2) {
    return a3 == null ? r : f2(a3);
}
function $a801f2c896bd09f1$var$notNull(x4) {
    return x4;
}
// output/Data.Nullable/index.js
var $a801f2c896bd09f1$var$toNullable = /* @__PURE__ */ $a801f2c896bd09f1$var$maybe($a801f2c896bd09f1$var$nullImpl)($a801f2c896bd09f1$var$notNull);
var $a801f2c896bd09f1$var$toMaybe = function(n) {
    return $a801f2c896bd09f1$var$nullable(n, $a801f2c896bd09f1$var$Nothing.value, $a801f2c896bd09f1$var$Just.create);
};
// output/Data.Variant/index.js
var $a801f2c896bd09f1$var$on2 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
        return function(p3) {
            return function(f2) {
                return function(g2) {
                    return function(r) {
                        if (r.type === reflectSymbol2(p3)) return f2(r.value);
                        return g2(r);
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$inj = function() {
    return function(dictIsSymbol) {
        var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
        return function(p3) {
            return function(value17) {
                return {
                    type: reflectSymbol2(p3),
                    value: value17
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$case_ = function(r) {
    return $a801f2c896bd09f1$var$unsafeCrashWith("Data.Variant: pattern match failure [" + (r.type + "]"));
};
// output/Effect.Uncurried/foreign.js
var $a801f2c896bd09f1$var$runEffectFn1 = function runEffectFn12(fn) {
    return function(a3) {
        return function() {
            return fn(a3);
        };
    };
};
// output/Effect.Unsafe/foreign.js
var $a801f2c896bd09f1$var$unsafePerformEffect = function(f2) {
    return f2();
};
// output/Foreign.Index/foreign.js
function $a801f2c896bd09f1$var$unsafeReadPropImpl(f2, s2, key2, value17) {
    return value17 == null ? f2 : s2(value17[key2]);
}
// output/Foreign.Index/index.js
var $a801f2c896bd09f1$var$unsafeReadProp = function(dictMonad) {
    var fail6 = $a801f2c896bd09f1$var$fail(dictMonad);
    var pure43 = $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeExceptT(dictMonad));
    return function(k2) {
        return function(value17) {
            return $a801f2c896bd09f1$var$unsafeReadPropImpl(fail6(new $a801f2c896bd09f1$var$TypeMismatch("object", $a801f2c896bd09f1$var$typeOf(value17))), pure43, k2, value17);
        };
    };
};
var $a801f2c896bd09f1$var$readProp = function(dictMonad) {
    return $a801f2c896bd09f1$var$unsafeReadProp(dictMonad);
};
// output/Foreign.Object/foreign.js
function $a801f2c896bd09f1$var$_copyST(m3) {
    return function() {
        var r = {};
        for(var k2 in m3)if (hasOwnProperty.call(m3, k2)) r[k2] = m3[k2];
        return r;
    };
}
var $a801f2c896bd09f1$var$empty2 = {};
function $a801f2c896bd09f1$var$runST(f2) {
    return f2();
}
function $a801f2c896bd09f1$var$_fmapObject(m0, f2) {
    var m3 = {};
    for(var k2 in m0)if (hasOwnProperty.call(m0, k2)) m3[k2] = f2(m0[k2]);
    return m3;
}
function $a801f2c896bd09f1$var$_mapWithKey(m0, f2) {
    var m3 = {};
    for(var k2 in m0)if (hasOwnProperty.call(m0, k2)) m3[k2] = f2(k2)(m0[k2]);
    return m3;
}
function $a801f2c896bd09f1$var$_foldM(bind37) {
    return function(f2) {
        return function(mz) {
            return function(m3) {
                var acc = mz;
                function g2(k3) {
                    return function(z3) {
                        return f2(z3)(k3)(m3[k3]);
                    };
                }
                for(var k2 in m3)if (hasOwnProperty.call(m3, k2)) acc = bind37(acc)(g2(k2));
                return acc;
            };
        };
    };
}
function $a801f2c896bd09f1$var$_lookup(no, yes, k2, m3) {
    return k2 in m3 ? yes(m3[k2]) : no;
}
function $a801f2c896bd09f1$var$toArrayWithKey(f2) {
    return function(m3) {
        var r = [];
        for(var k2 in m3)if (hasOwnProperty.call(m3, k2)) r.push(f2(k2)(m3[k2]));
        return r;
    };
}
var $a801f2c896bd09f1$var$keys = Object.keys || $a801f2c896bd09f1$var$toArrayWithKey(function(k2) {
    return function() {
        return k2;
    };
});
// output/Foreign.Object.ST/foreign.js
var $a801f2c896bd09f1$var$newImpl = function() {
    return {};
};
function $a801f2c896bd09f1$var$poke2(k2) {
    return function(v3) {
        return function(m3) {
            return function() {
                m3[k2] = v3;
                return m3;
            };
        };
    };
}
// output/Foreign.Object/index.js
var $a801f2c896bd09f1$var$forWithIndex_2 = /* @__PURE__ */ $a801f2c896bd09f1$var$forWithIndex_($a801f2c896bd09f1$var$applicativeST);
var $a801f2c896bd09f1$var$$$void3 = /* @__PURE__ */ $a801f2c896bd09f1$var$$$void($a801f2c896bd09f1$var$functorST);
var $a801f2c896bd09f1$var$foldr4 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldr($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$identity7 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$values = /* @__PURE__ */ $a801f2c896bd09f1$var$toArrayWithKey(function(v3) {
    return function(v1) {
        return v1;
    };
});
var $a801f2c896bd09f1$var$toUnfoldable3 = function(dictUnfoldable) {
    var $89 = $a801f2c896bd09f1$var$toUnfoldable2(dictUnfoldable);
    var $90 = $a801f2c896bd09f1$var$toArrayWithKey($a801f2c896bd09f1$var$Tuple.create);
    return function($91) {
        return $89($90($91));
    };
};
var $a801f2c896bd09f1$var$thawST = $a801f2c896bd09f1$var$_copyST;
var $a801f2c896bd09f1$var$mutate = function(f2) {
    return function(m3) {
        return $a801f2c896bd09f1$var$runST(function __do2() {
            var s2 = $a801f2c896bd09f1$var$thawST(m3)();
            f2(s2)();
            return s2;
        });
    };
};
var $a801f2c896bd09f1$var$mapWithKey = function(f2) {
    return function(m3) {
        return $a801f2c896bd09f1$var$_mapWithKey(m3, f2);
    };
};
var $a801f2c896bd09f1$var$lookup2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$runFn4($a801f2c896bd09f1$var$_lookup)($a801f2c896bd09f1$var$Nothing.value)($a801f2c896bd09f1$var$Just.create);
}();
var $a801f2c896bd09f1$var$insert2 = function(k2) {
    return function(v3) {
        return $a801f2c896bd09f1$var$mutate($a801f2c896bd09f1$var$poke2(k2)(v3));
    };
};
var $a801f2c896bd09f1$var$functorObject = {
    map: function(f2) {
        return function(m3) {
            return $a801f2c896bd09f1$var$_fmapObject(m3, f2);
        };
    }
};
var $a801f2c896bd09f1$var$functorWithIndexObject = {
    mapWithIndex: $a801f2c896bd09f1$var$mapWithKey,
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorObject;
    }
};
var $a801f2c896bd09f1$var$fromFoldableWithIndex = function(dictFoldableWithIndex) {
    var forWithIndex_1 = $a801f2c896bd09f1$var$forWithIndex_2(dictFoldableWithIndex);
    return function(l2) {
        return $a801f2c896bd09f1$var$runST(function __do2() {
            var s2 = $a801f2c896bd09f1$var$newImpl();
            forWithIndex_1(l2)(function(k2) {
                return function(v3) {
                    return $a801f2c896bd09f1$var$poke2(k2)(v3)(s2);
                };
            })();
            return s2;
        });
    };
};
var $a801f2c896bd09f1$var$fromFoldable3 = function(dictFoldable) {
    var fromFoldable18 = $a801f2c896bd09f1$var$fromFoldable2(dictFoldable);
    return function(l2) {
        return $a801f2c896bd09f1$var$runST(function __do2() {
            var s2 = $a801f2c896bd09f1$var$newImpl();
            $a801f2c896bd09f1$var$foreach(fromFoldable18(l2))(function(v3) {
                return $a801f2c896bd09f1$var$$$void3($a801f2c896bd09f1$var$poke2(v3.value0)(v3.value1)(s2));
            })();
            return s2;
        });
    };
};
var $a801f2c896bd09f1$var$fold2 = /* @__PURE__ */ $a801f2c896bd09f1$var$_foldM($a801f2c896bd09f1$var$applyFlipped);
var $a801f2c896bd09f1$var$foldMap2 = function(dictMonoid) {
    var append18 = $a801f2c896bd09f1$var$append(dictMonoid.Semigroup0());
    var mempty5 = $a801f2c896bd09f1$var$mempty(dictMonoid);
    return function(f2) {
        return $a801f2c896bd09f1$var$fold2(function(acc) {
            return function(k2) {
                return function(v3) {
                    return append18(acc)(f2(k2)(v3));
                };
            };
        })(mempty5);
    };
};
var $a801f2c896bd09f1$var$foldableObject = {
    foldl: function(f2) {
        return $a801f2c896bd09f1$var$fold2(function(z3) {
            return function(v3) {
                return f2(z3);
            };
        });
    },
    foldr: function(f2) {
        return function(z3) {
            return function(m3) {
                return $a801f2c896bd09f1$var$foldr4(f2)(z3)($a801f2c896bd09f1$var$values(m3));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap12 = $a801f2c896bd09f1$var$foldMap2(dictMonoid);
        return function(f2) {
            return foldMap12($a801f2c896bd09f1$var$$$const(f2));
        };
    }
};
var $a801f2c896bd09f1$var$foldableWithIndexObject = {
    foldlWithIndex: function(f2) {
        return $a801f2c896bd09f1$var$fold2($a801f2c896bd09f1$var$flip(f2));
    },
    foldrWithIndex: function(f2) {
        return function(z3) {
            return function(m3) {
                return $a801f2c896bd09f1$var$foldr4($a801f2c896bd09f1$var$uncurry(f2))(z3)($a801f2c896bd09f1$var$toArrayWithKey($a801f2c896bd09f1$var$Tuple.create)(m3));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $a801f2c896bd09f1$var$foldMap2(dictMonoid);
    },
    Foldable0: function() {
        return $a801f2c896bd09f1$var$foldableObject;
    }
};
var $a801f2c896bd09f1$var$traversableWithIndexObject = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply4 = $a801f2c896bd09f1$var$apply(Apply0);
        var map59 = $a801f2c896bd09f1$var$map(Apply0.Functor0());
        var pure116 = $a801f2c896bd09f1$var$pure(dictApplicative);
        return function(f2) {
            return function(ms) {
                return $a801f2c896bd09f1$var$fold2(function(acc) {
                    return function(k2) {
                        return function(v3) {
                            return apply4(map59($a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$insert2(k2)))(acc))(f2(k2)(v3));
                        };
                    };
                })(pure116($a801f2c896bd09f1$var$empty2))(ms);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $a801f2c896bd09f1$var$functorWithIndexObject;
    },
    FoldableWithIndex1: function() {
        return $a801f2c896bd09f1$var$foldableWithIndexObject;
    },
    Traversable2: function() {
        return $a801f2c896bd09f1$var$traversableObject;
    }
};
var $a801f2c896bd09f1$var$traversableObject = {
    traverse: function(dictApplicative) {
        var $96 = $a801f2c896bd09f1$var$traverseWithIndex($a801f2c896bd09f1$var$traversableWithIndexObject)(dictApplicative);
        return function($97) {
            return $96($a801f2c896bd09f1$var$$$const($97));
        };
    },
    sequence: function(dictApplicative) {
        return $a801f2c896bd09f1$var$traverse($a801f2c896bd09f1$var$traversableObject)(dictApplicative)($a801f2c896bd09f1$var$identity7);
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorObject;
    },
    Foldable1: function() {
        return $a801f2c896bd09f1$var$foldableObject;
    }
};
// output/Record/index.js
var $a801f2c896bd09f1$var$get2 = function(dictIsSymbol) {
    var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
    return function() {
        return function(l2) {
            return function(r) {
                return $a801f2c896bd09f1$var$unsafeGet(reflectSymbol2(l2))(r);
            };
        };
    };
};
// output/Record.Builder/foreign.js
function $a801f2c896bd09f1$var$copyRecord(rec) {
    var copy2 = {};
    for(var key2 in rec)if (({}).hasOwnProperty.call(rec, key2)) copy2[key2] = rec[key2];
    return copy2;
}
function $a801f2c896bd09f1$var$unsafeInsert(l2) {
    return function(a3) {
        return function(rec) {
            rec[l2] = a3;
            return rec;
        };
    };
}
// output/Record.Builder/index.js
var $a801f2c896bd09f1$var$semigroupoidBuilder = $a801f2c896bd09f1$var$semigroupoidFn;
var $a801f2c896bd09f1$var$insert3 = function() {
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
            return function(l2) {
                return function(a3) {
                    return function(r1) {
                        return $a801f2c896bd09f1$var$unsafeInsert(reflectSymbol2(l2))(a3)(r1);
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$categoryBuilder = $a801f2c896bd09f1$var$categoryFn;
var $a801f2c896bd09f1$var$build = function(v3) {
    return function(r1) {
        return v3($a801f2c896bd09f1$var$copyRecord(r1));
    };
};
// output/Simple.JSON/index.js
var $a801f2c896bd09f1$var$map11 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$fail2 = /* @__PURE__ */ $a801f2c896bd09f1$var$fail($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$applicativeExceptT2 = /* @__PURE__ */ $a801f2c896bd09f1$var$applicativeExceptT($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$pure4 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeExceptT2);
var $a801f2c896bd09f1$var$map12 = /* @__PURE__ */ $a801f2c896bd09f1$var$map(/* @__PURE__ */ $a801f2c896bd09f1$var$functorExceptT($a801f2c896bd09f1$var$functorIdentity));
var $a801f2c896bd09f1$var$map22 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorNonEmptyList);
var $a801f2c896bd09f1$var$bindExceptT2 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindExceptT($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$bindFlipped3 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindExceptT2);
var $a801f2c896bd09f1$var$composeKleisliFlipped2 = /* @__PURE__ */ $a801f2c896bd09f1$var$composeKleisliFlipped($a801f2c896bd09f1$var$bindExceptT2);
var $a801f2c896bd09f1$var$sequence2 = /* @__PURE__ */ $a801f2c896bd09f1$var$sequence($a801f2c896bd09f1$var$traversableObject)($a801f2c896bd09f1$var$applicativeExceptT2);
var $a801f2c896bd09f1$var$identity8 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryBuilder);
var $a801f2c896bd09f1$var$traverseWithIndex2 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverseWithIndex($a801f2c896bd09f1$var$traversableWithIndexArray)($a801f2c896bd09f1$var$applicativeExceptT2);
var $a801f2c896bd09f1$var$readArray1 = /* @__PURE__ */ $a801f2c896bd09f1$var$readArray($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$bind2 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindExceptT2);
var $a801f2c896bd09f1$var$on3 = /* @__PURE__ */ $a801f2c896bd09f1$var$on2();
var $a801f2c896bd09f1$var$compose1 = /* @__PURE__ */ $a801f2c896bd09f1$var$compose($a801f2c896bd09f1$var$semigroupoidBuilder);
var $a801f2c896bd09f1$var$insert4 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert3()();
var $a801f2c896bd09f1$var$readProp2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readProp($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$alt2 = /* @__PURE__ */ $a801f2c896bd09f1$var$alt(/* @__PURE__ */ $a801f2c896bd09f1$var$altExceptT($a801f2c896bd09f1$var$semigroupNonEmptyList)($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$inj2 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj();
var $a801f2c896bd09f1$var$writeVariantImpl = function(dict) {
    return dict.writeVariantImpl;
};
var $a801f2c896bd09f1$var$writeImplFields = function(dict) {
    return dict.writeImplFields;
};
var $a801f2c896bd09f1$var$writeImpl = function(dict) {
    return dict.writeImpl;
};
var $a801f2c896bd09f1$var$writeJSON = function(dictWriteForeign) {
    var $191 = $a801f2c896bd09f1$var$writeImpl(dictWriteForeign);
    return function($192) {
        return $a801f2c896bd09f1$var$_unsafeStringify($191($192));
    };
};
var $a801f2c896bd09f1$var$writeForeignVariant = function() {
    return function(dictWriteForeignVariant) {
        var writeVariantImpl1 = $a801f2c896bd09f1$var$writeVariantImpl(dictWriteForeignVariant);
        return {
            writeImpl: function(variant) {
                return writeVariantImpl1($a801f2c896bd09f1$var$$$Proxy.value)(variant);
            }
        };
    };
};
var $a801f2c896bd09f1$var$writeForeignString = {
    writeImpl: $a801f2c896bd09f1$var$unsafeToForeign
};
var $a801f2c896bd09f1$var$writeForeignObject = function(dictWriteForeign) {
    return {
        writeImpl: function() {
            var $193 = $a801f2c896bd09f1$var$mapWithKey($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$writeImpl(dictWriteForeign)));
            return function($194) {
                return $a801f2c896bd09f1$var$unsafeToForeign($193($194));
            };
        }()
    };
};
var $a801f2c896bd09f1$var$writeForeignInt = {
    writeImpl: $a801f2c896bd09f1$var$unsafeToForeign
};
var $a801f2c896bd09f1$var$writeForeignArray = function(dictWriteForeign) {
    var writeImpl1 = $a801f2c896bd09f1$var$writeImpl(dictWriteForeign);
    return {
        writeImpl: function(xs) {
            return $a801f2c896bd09f1$var$unsafeToForeign($a801f2c896bd09f1$var$map11(writeImpl1)(xs));
        }
    };
};
var $a801f2c896bd09f1$var$$$undefined = $a801f2c896bd09f1$var$_undefined;
var $a801f2c896bd09f1$var$writeForeignMaybe = function(dictWriteForeign) {
    return {
        writeImpl: $a801f2c896bd09f1$var$maybe($a801f2c896bd09f1$var$$$undefined)($a801f2c896bd09f1$var$writeImpl(dictWriteForeign))
    };
};
var $a801f2c896bd09f1$var$recordWriteForeign = function() {
    return function(dictWriteForeignFields) {
        var writeImplFields1 = $a801f2c896bd09f1$var$writeImplFields(dictWriteForeignFields);
        return {
            writeImpl: function(rec) {
                var steps = writeImplFields1($a801f2c896bd09f1$var$$$Proxy.value)(rec);
                return $a801f2c896bd09f1$var$unsafeToForeign($a801f2c896bd09f1$var$build(steps)({}));
            }
        };
    };
};
var $a801f2c896bd09f1$var$readVariantNil = {
    readVariantImpl: function(v3) {
        return function(v1) {
            return $a801f2c896bd09f1$var$fail2(new $a801f2c896bd09f1$var$ForeignError("Unable to match any variant member."));
        };
    }
};
var $a801f2c896bd09f1$var$readVariantImpl = function(dict) {
    return dict.readVariantImpl;
};
var $a801f2c896bd09f1$var$readString2 = {
    readImpl: /* @__PURE__ */ $a801f2c896bd09f1$var$readString($a801f2c896bd09f1$var$monadIdentity)
};
var $a801f2c896bd09f1$var$readInt2 = {
    readImpl: /* @__PURE__ */ $a801f2c896bd09f1$var$readInt($a801f2c896bd09f1$var$monadIdentity)
};
var $a801f2c896bd09f1$var$readImpl = function(dict) {
    return dict.readImpl;
};
var $a801f2c896bd09f1$var$readMaybe = function(dictReadForeign) {
    return {
        readImpl: function() {
            var readNullOrUndefined = function(v3) {
                return function(v1) {
                    if ($a801f2c896bd09f1$var$isNull(v1) || $a801f2c896bd09f1$var$isUndefined(v1)) return $a801f2c896bd09f1$var$pure4($a801f2c896bd09f1$var$Nothing.value);
                    return $a801f2c896bd09f1$var$map12($a801f2c896bd09f1$var$Just.create)(v3(v1));
                };
            };
            return readNullOrUndefined($a801f2c896bd09f1$var$readImpl(dictReadForeign));
        }()
    };
};
var $a801f2c896bd09f1$var$readObject = function(dictReadForeign) {
    return {
        readImpl: function() {
            var readObject$prime = function(value17) {
                if ($a801f2c896bd09f1$var$tagOf(value17) === "Object") return $a801f2c896bd09f1$var$pure4($a801f2c896bd09f1$var$unsafeFromForeign(value17));
                if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$fail2(new $a801f2c896bd09f1$var$TypeMismatch("Object", $a801f2c896bd09f1$var$tagOf(value17)));
                throw new Error("Failed pattern match at Simple.JSON (line 197, column 7 - line 197, column 51): " + [
                    value17.constructor.name
                ]);
            };
            return $a801f2c896bd09f1$var$composeKleisliFlipped2(function() {
                var $197 = $a801f2c896bd09f1$var$mapWithKey($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$readImpl(dictReadForeign)));
                return function($198) {
                    return $a801f2c896bd09f1$var$sequence2($197($198));
                };
            }())(readObject$prime);
        }()
    };
};
var $a801f2c896bd09f1$var$readForeignVariant = function() {
    return function(dictReadForeignVariant) {
        var readVariantImpl1 = $a801f2c896bd09f1$var$readVariantImpl(dictReadForeignVariant);
        return {
            readImpl: function(o2) {
                return readVariantImpl1($a801f2c896bd09f1$var$$$Proxy.value)(o2);
            }
        };
    };
};
var $a801f2c896bd09f1$var$readForeign = {
    readImpl: $a801f2c896bd09f1$var$pure4
};
var $a801f2c896bd09f1$var$readFieldsNil = {
    getFields: function(v3) {
        return function(v1) {
            return $a801f2c896bd09f1$var$pure4($a801f2c896bd09f1$var$identity8);
        };
    }
};
var $a801f2c896bd09f1$var$readArray2 = function(dictReadForeign) {
    var readImpl22 = $a801f2c896bd09f1$var$readImpl(dictReadForeign);
    return {
        readImpl: function() {
            var readAtIdx = function(i2) {
                return function(f2) {
                    return $a801f2c896bd09f1$var$withExcept($a801f2c896bd09f1$var$map22($a801f2c896bd09f1$var$ErrorAtIndex.create(i2)))(readImpl22(f2));
                };
            };
            return $a801f2c896bd09f1$var$composeKleisliFlipped2($a801f2c896bd09f1$var$traverseWithIndex2(readAtIdx))($a801f2c896bd09f1$var$readArray1);
        }()
    };
};
var $a801f2c896bd09f1$var$read3 = function(dictReadForeign) {
    var $199 = $a801f2c896bd09f1$var$readImpl(dictReadForeign);
    return function($200) {
        return $a801f2c896bd09f1$var$runExcept($199($200));
    };
};
var $a801f2c896bd09f1$var$read_ = function(dictReadForeign) {
    var $203 = $a801f2c896bd09f1$var$read3(dictReadForeign);
    return function($204) {
        return $a801f2c896bd09f1$var$hush($203($204));
    };
};
var $a801f2c896bd09f1$var$parseJSON = /* @__PURE__ */ function() {
    var $205 = $a801f2c896bd09f1$var$lmap($a801f2c896bd09f1$var$bifunctorEither)(function() {
        var $208 = $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeNonEmptyList);
        return function($209) {
            return $208($a801f2c896bd09f1$var$ForeignError.create($a801f2c896bd09f1$var$message($209)));
        };
    }());
    var $206 = $a801f2c896bd09f1$var$runEffectFn1($a801f2c896bd09f1$var$_parseJSON);
    return function($207) {
        return $a801f2c896bd09f1$var$ExceptT($a801f2c896bd09f1$var$Identity($205($a801f2c896bd09f1$var$unsafePerformEffect($a801f2c896bd09f1$var$$$try($206($207))))));
    };
}();
var $a801f2c896bd09f1$var$readJSON = function(dictReadForeign) {
    var $210 = $a801f2c896bd09f1$var$composeKleisliFlipped2($a801f2c896bd09f1$var$readImpl(dictReadForeign))($a801f2c896bd09f1$var$parseJSON);
    return function($211) {
        return $a801f2c896bd09f1$var$runExcept($210($211));
    };
};
var $a801f2c896bd09f1$var$nilWriteForeignVariant = {
    writeVariantImpl: function(v3) {
        return function(v1) {
            return $a801f2c896bd09f1$var$unsafeCrashWith("Variant was not able to be writen row WriteForeign.");
        };
    }
};
var $a801f2c896bd09f1$var$nilWriteForeignFields = {
    writeImplFields: function(v3) {
        return function(v1) {
            return $a801f2c896bd09f1$var$identity8;
        };
    }
};
var $a801f2c896bd09f1$var$getFields = function(dict) {
    return dict.getFields;
};
var $a801f2c896bd09f1$var$readRecord = function() {
    return function(dictReadForeignFields) {
        var getFields1 = $a801f2c896bd09f1$var$getFields(dictReadForeignFields);
        return {
            readImpl: function(o2) {
                return $a801f2c896bd09f1$var$map12($a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$build)({}))(getFields1($a801f2c896bd09f1$var$$$Proxy.value)(o2));
            }
        };
    };
};
var $a801f2c896bd09f1$var$consWriteForeignVariant = function(dictIsSymbol) {
    var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
    var on12 = $a801f2c896bd09f1$var$on3(dictIsSymbol);
    return function(dictWriteForeign) {
        var writeImpl1 = $a801f2c896bd09f1$var$writeImpl(dictWriteForeign);
        return function() {
            return function(dictWriteForeignVariant) {
                var writeVariantImpl1 = $a801f2c896bd09f1$var$writeVariantImpl(dictWriteForeignVariant);
                return {
                    writeVariantImpl: function(v3) {
                        return function(variant) {
                            var writeVariant = function(value17) {
                                return $a801f2c896bd09f1$var$unsafeToForeign({
                                    type: reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value),
                                    value: writeImpl1(value17)
                                });
                            };
                            return on12($a801f2c896bd09f1$var$$$Proxy.value)(writeVariant)(writeVariantImpl1($a801f2c896bd09f1$var$$$Proxy.value))(variant);
                        };
                    }
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$consWriteForeignFields = function(dictIsSymbol) {
    var get6 = $a801f2c896bd09f1$var$get2(dictIsSymbol)();
    var insert17 = $a801f2c896bd09f1$var$insert4(dictIsSymbol);
    return function(dictWriteForeign) {
        var writeImpl1 = $a801f2c896bd09f1$var$writeImpl(dictWriteForeign);
        return function(dictWriteForeignFields) {
            var writeImplFields1 = $a801f2c896bd09f1$var$writeImplFields(dictWriteForeignFields);
            return function() {
                return function() {
                    return function() {
                        return {
                            writeImplFields: function(v3) {
                                return function(rec) {
                                    var rest = writeImplFields1($a801f2c896bd09f1$var$$$Proxy.value)(rec);
                                    var value17 = writeImpl1(get6($a801f2c896bd09f1$var$$$Proxy.value)(rec));
                                    var result2 = $a801f2c896bd09f1$var$compose1(insert17($a801f2c896bd09f1$var$$$Proxy.value)(value17))(rest);
                                    return result2;
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$applyEither2 = function(dictSemigroup) {
    var append18 = $a801f2c896bd09f1$var$append(dictSemigroup);
    return function(v3) {
        return function(v1) {
            if (v3 instanceof $a801f2c896bd09f1$var$Left && v1 instanceof $a801f2c896bd09f1$var$Right) return new $a801f2c896bd09f1$var$Left(v3.value0);
            if (v3 instanceof $a801f2c896bd09f1$var$Left && v1 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(append18(v3.value0)(v1.value0));
            if (v3 instanceof $a801f2c896bd09f1$var$Right && v1 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(v1.value0);
            if (v3 instanceof $a801f2c896bd09f1$var$Right && v1 instanceof $a801f2c896bd09f1$var$Right) return new $a801f2c896bd09f1$var$Right(v3.value0(v1.value0));
            throw new Error("Failed pattern match at Simple.JSON (line 241, column 1 - line 241, column 90): " + [
                v3.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$exceptTApply = function(dictSemigroup) {
    var applyEither1 = $a801f2c896bd09f1$var$applyEither2(dictSemigroup);
    return function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply4 = $a801f2c896bd09f1$var$apply(Apply0);
        var map410 = $a801f2c896bd09f1$var$map(Apply0.Functor0());
        return function(fun) {
            return function(a3) {
                return apply4(map410(applyEither1)($a801f2c896bd09f1$var$runExceptT(fun)))($a801f2c896bd09f1$var$runExceptT(a3));
            };
        };
    };
};
var $a801f2c896bd09f1$var$exceptTApply1 = /* @__PURE__ */ $a801f2c896bd09f1$var$exceptTApply($a801f2c896bd09f1$var$semigroupNonEmptyList)($a801f2c896bd09f1$var$applicativeIdentity);
var $a801f2c896bd09f1$var$readFieldsCons = function(dictIsSymbol) {
    var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
    var insert17 = $a801f2c896bd09f1$var$insert4(dictIsSymbol);
    return function(dictReadForeign) {
        var readImpl22 = $a801f2c896bd09f1$var$readImpl(dictReadForeign);
        return function(dictReadForeignFields) {
            var getFields1 = $a801f2c896bd09f1$var$getFields(dictReadForeignFields);
            return function() {
                return function() {
                    return {
                        getFields: function(v3) {
                            return function(obj) {
                                var rest = getFields1($a801f2c896bd09f1$var$$$Proxy.value)(obj);
                                var name17 = reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value);
                                var withExcept$prime = $a801f2c896bd09f1$var$withExcept($a801f2c896bd09f1$var$map22($a801f2c896bd09f1$var$ErrorAtProperty.create(name17)));
                                var first = $a801f2c896bd09f1$var$bind2(withExcept$prime($a801f2c896bd09f1$var$bindFlipped3(readImpl22)($a801f2c896bd09f1$var$readProp2(name17)(obj))))(function(value17) {
                                    return $a801f2c896bd09f1$var$pure4(insert17($a801f2c896bd09f1$var$$$Proxy.value)(value17));
                                });
                                return $a801f2c896bd09f1$var$exceptTApply1($a801f2c896bd09f1$var$map12($a801f2c896bd09f1$var$compose1)(first))(rest);
                            };
                        }
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$readImpl1 = /* @__PURE__ */ $a801f2c896bd09f1$var$readImpl(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord()(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "type";
    }
})($a801f2c896bd09f1$var$readString2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "value";
    }
})($a801f2c896bd09f1$var$readForeign)($a801f2c896bd09f1$var$readFieldsNil)()())()()));
var $a801f2c896bd09f1$var$readVariantCons = function(dictIsSymbol) {
    var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
    var inj12 = $a801f2c896bd09f1$var$inj2(dictIsSymbol);
    return function(dictReadForeign) {
        var readImpl22 = $a801f2c896bd09f1$var$readImpl(dictReadForeign);
        return function() {
            return function(dictReadForeignVariant) {
                var readVariantImpl1 = $a801f2c896bd09f1$var$readVariantImpl(dictReadForeignVariant);
                return {
                    readVariantImpl: function(v3) {
                        return function(o2) {
                            var name17 = reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value);
                            return $a801f2c896bd09f1$var$alt2($a801f2c896bd09f1$var$bind2($a801f2c896bd09f1$var$readImpl1(o2))(function(v1) {
                                var $189 = v1.type === name17;
                                if ($189) return $a801f2c896bd09f1$var$bind2(readImpl22(v1.value))(function(v22) {
                                    return $a801f2c896bd09f1$var$pure4(inj12($a801f2c896bd09f1$var$$$Proxy.value)(v22));
                                });
                                return $a801f2c896bd09f1$var$fail2($a801f2c896bd09f1$var$ForeignError.create("Did not match variant tag " + name17));
                            }))(readVariantImpl1($a801f2c896bd09f1$var$$$Proxy.value)(o2));
                        };
                    }
                };
            };
        };
    };
};
// output/Data.String.CodePoints/foreign.js
var $a801f2c896bd09f1$var$hasArrayFrom = typeof Array.from === "function";
var $a801f2c896bd09f1$var$hasStringIterator = typeof Symbol !== "undefined" && Symbol != null && typeof Symbol.iterator !== "undefined" && typeof String.prototype[Symbol.iterator] === "function";
var $a801f2c896bd09f1$var$hasFromCodePoint = typeof String.prototype.fromCodePoint === "function";
var $a801f2c896bd09f1$var$hasCodePointAt = typeof String.prototype.codePointAt === "function";
var $a801f2c896bd09f1$var$_unsafeCodePointAt0 = function(fallback) {
    return $a801f2c896bd09f1$var$hasCodePointAt ? function(str) {
        return str.codePointAt(0);
    } : fallback;
};
var $a801f2c896bd09f1$var$_singleton = function(fallback) {
    return $a801f2c896bd09f1$var$hasFromCodePoint ? String.fromCodePoint : fallback;
};
var $a801f2c896bd09f1$var$_toCodePointArray = function(fallback) {
    return function(unsafeCodePointAt02) {
        if ($a801f2c896bd09f1$var$hasArrayFrom) return function(str) {
            return Array.from(str, unsafeCodePointAt02);
        };
        return fallback;
    };
};
// output/Data.String.Common/foreign.js
var $a801f2c896bd09f1$var$replaceAll = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(new RegExp(s1.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"), s2);
        };
    };
};
var $a801f2c896bd09f1$var$split = function(sep) {
    return function(s2) {
        return s2.split(sep);
    };
};
var $a801f2c896bd09f1$var$toUpper = function(s2) {
    return s2.toUpperCase();
};
var $a801f2c896bd09f1$var$trim = function(s2) {
    return s2.trim();
};
var $a801f2c896bd09f1$var$joinWith = function(s2) {
    return function(xs) {
        return xs.join(s2);
    };
};
// output/Data.String.Common/index.js
var $a801f2c896bd09f1$var$$$null2 = function(s2) {
    return s2 === "";
};
// output/Data.String.CodePoints/index.js
var $a801f2c896bd09f1$var$$runtime_lazy3 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$fromEnum2 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromEnum($a801f2c896bd09f1$var$boundedEnumChar);
var $a801f2c896bd09f1$var$map13 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$unfoldr2 = /* @__PURE__ */ $a801f2c896bd09f1$var$unfoldr($a801f2c896bd09f1$var$unfoldableArray);
var $a801f2c896bd09f1$var$div3 = /* @__PURE__ */ $a801f2c896bd09f1$var$div($a801f2c896bd09f1$var$euclideanRingInt);
var $a801f2c896bd09f1$var$mod3 = /* @__PURE__ */ $a801f2c896bd09f1$var$mod($a801f2c896bd09f1$var$euclideanRingInt);
var $a801f2c896bd09f1$var$compare3 = /* @__PURE__ */ $a801f2c896bd09f1$var$compare($a801f2c896bd09f1$var$ordInt);
var $a801f2c896bd09f1$var$CodePoint = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$unsurrogate = function(lead) {
    return function(trail) {
        return (((lead - 55296 | 0) * 1024 | 0) + (trail - 56320 | 0) | 0) + 65536 | 0;
    };
};
var $a801f2c896bd09f1$var$isTrail = function(cu) {
    return 56320 <= cu && cu <= 57343;
};
var $a801f2c896bd09f1$var$isLead = function(cu) {
    return 55296 <= cu && cu <= 56319;
};
var $a801f2c896bd09f1$var$uncons3 = function(s2) {
    var v3 = $a801f2c896bd09f1$var$length3(s2);
    if (v3 === 0) return $a801f2c896bd09f1$var$Nothing.value;
    if (v3 === 1) return new $a801f2c896bd09f1$var$Just({
        head: $a801f2c896bd09f1$var$fromEnum2($a801f2c896bd09f1$var$charAt(0)(s2)),
        tail: ""
    });
    var cu1 = $a801f2c896bd09f1$var$fromEnum2($a801f2c896bd09f1$var$charAt(1)(s2));
    var cu0 = $a801f2c896bd09f1$var$fromEnum2($a801f2c896bd09f1$var$charAt(0)(s2));
    var $43 = $a801f2c896bd09f1$var$isLead(cu0) && $a801f2c896bd09f1$var$isTrail(cu1);
    if ($43) return new $a801f2c896bd09f1$var$Just({
        head: $a801f2c896bd09f1$var$unsurrogate(cu0)(cu1),
        tail: $a801f2c896bd09f1$var$drop2(2)(s2)
    });
    return new $a801f2c896bd09f1$var$Just({
        head: cu0,
        tail: $a801f2c896bd09f1$var$drop2(1)(s2)
    });
};
var $a801f2c896bd09f1$var$unconsButWithTuple = function(s2) {
    return $a801f2c896bd09f1$var$map13(function(v3) {
        return new $a801f2c896bd09f1$var$Tuple(v3.head, v3.tail);
    })($a801f2c896bd09f1$var$uncons3(s2));
};
var $a801f2c896bd09f1$var$toCodePointArrayFallback = function(s2) {
    return $a801f2c896bd09f1$var$unfoldr2($a801f2c896bd09f1$var$unconsButWithTuple)(s2);
};
var $a801f2c896bd09f1$var$unsafeCodePointAt0Fallback = function(s2) {
    var cu0 = $a801f2c896bd09f1$var$fromEnum2($a801f2c896bd09f1$var$charAt(0)(s2));
    var $47 = $a801f2c896bd09f1$var$isLead(cu0) && $a801f2c896bd09f1$var$length3(s2) > 1;
    if ($47) {
        var cu1 = $a801f2c896bd09f1$var$fromEnum2($a801f2c896bd09f1$var$charAt(1)(s2));
        var $48 = $a801f2c896bd09f1$var$isTrail(cu1);
        if ($48) return $a801f2c896bd09f1$var$unsurrogate(cu0)(cu1);
        return cu0;
    }
    return cu0;
};
var $a801f2c896bd09f1$var$unsafeCodePointAt0 = /* @__PURE__ */ $a801f2c896bd09f1$var$_unsafeCodePointAt0($a801f2c896bd09f1$var$unsafeCodePointAt0Fallback);
var $a801f2c896bd09f1$var$toCodePointArray = /* @__PURE__ */ $a801f2c896bd09f1$var$_toCodePointArray($a801f2c896bd09f1$var$toCodePointArrayFallback)($a801f2c896bd09f1$var$unsafeCodePointAt0);
var $a801f2c896bd09f1$var$length5 = function($74) {
    return $a801f2c896bd09f1$var$length4($a801f2c896bd09f1$var$toCodePointArray($74));
};
var $a801f2c896bd09f1$var$fromCharCode3 = /* @__PURE__ */ function() {
    var $75 = $a801f2c896bd09f1$var$toEnumWithDefaults($a801f2c896bd09f1$var$boundedEnumChar)($a801f2c896bd09f1$var$bottom($a801f2c896bd09f1$var$boundedChar))($a801f2c896bd09f1$var$top($a801f2c896bd09f1$var$boundedChar));
    return function($76) {
        return $a801f2c896bd09f1$var$singleton4($75($76));
    };
}();
var $a801f2c896bd09f1$var$singletonFallback = function(v3) {
    if (v3 <= 65535) return $a801f2c896bd09f1$var$fromCharCode3(v3);
    var lead = $a801f2c896bd09f1$var$div3(v3 - 65536 | 0)(1024) + 55296 | 0;
    var trail = $a801f2c896bd09f1$var$mod3(v3 - 65536 | 0)(1024) + 56320 | 0;
    return $a801f2c896bd09f1$var$fromCharCode3(lead) + $a801f2c896bd09f1$var$fromCharCode3(trail);
};
var $a801f2c896bd09f1$var$singleton6 = /* @__PURE__ */ $a801f2c896bd09f1$var$_singleton($a801f2c896bd09f1$var$singletonFallback);
var $a801f2c896bd09f1$var$eqCodePoint = {
    eq: function(x4) {
        return function(y4) {
            return x4 === y4;
        };
    }
};
var $a801f2c896bd09f1$var$ordCodePoint = {
    compare: function(x4) {
        return function(y4) {
            return $a801f2c896bd09f1$var$compare3(x4)(y4);
        };
    },
    Eq0: function() {
        return $a801f2c896bd09f1$var$eqCodePoint;
    }
};
var $a801f2c896bd09f1$var$codePointFromChar = function($77) {
    return $a801f2c896bd09f1$var$CodePoint($a801f2c896bd09f1$var$fromEnum2($77));
};
var $a801f2c896bd09f1$var$boundedCodePoint = {
    bottom: 0,
    top: 1114111,
    Ord0: function() {
        return $a801f2c896bd09f1$var$ordCodePoint;
    }
};
var $a801f2c896bd09f1$var$boundedEnumCodePoint = /* @__PURE__ */ function() {
    return {
        cardinality: 1114112,
        fromEnum: function(v3) {
            return v3;
        },
        toEnum: function(n) {
            if (n >= 0 && n <= 1114111) return new $a801f2c896bd09f1$var$Just(n);
            if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$Nothing.value;
            throw new Error("Failed pattern match at Data.String.CodePoints (line 63, column 1 - line 68, column 26): " + [
                n.constructor.name
            ]);
        },
        Bounded0: function() {
            return $a801f2c896bd09f1$var$boundedCodePoint;
        },
        Enum1: function() {
            return $a801f2c896bd09f1$var$$lazy_enumCodePoint(0);
        }
    };
}();
var $a801f2c896bd09f1$var$$lazy_enumCodePoint = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy3("enumCodePoint", "Data.String.CodePoints", function() {
    return {
        succ: $a801f2c896bd09f1$var$defaultSucc($a801f2c896bd09f1$var$toEnum($a801f2c896bd09f1$var$boundedEnumCodePoint))($a801f2c896bd09f1$var$fromEnum($a801f2c896bd09f1$var$boundedEnumCodePoint)),
        pred: $a801f2c896bd09f1$var$defaultPred($a801f2c896bd09f1$var$toEnum($a801f2c896bd09f1$var$boundedEnumCodePoint))($a801f2c896bd09f1$var$fromEnum($a801f2c896bd09f1$var$boundedEnumCodePoint)),
        Ord0: function() {
            return $a801f2c896bd09f1$var$ordCodePoint;
        }
    };
});
// output/StringParser.Parser/index.js
var $a801f2c896bd09f1$var$map14 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEither);
var $a801f2c896bd09f1$var$bind3 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindEither);
var $a801f2c896bd09f1$var$pure5 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$tailRecM3 = /* @__PURE__ */ $a801f2c896bd09f1$var$tailRecM($a801f2c896bd09f1$var$monadRecEither);
var $a801f2c896bd09f1$var$unParser = function(v3) {
    return v3;
};
var $a801f2c896bd09f1$var$runParser = function(v3) {
    return function(s2) {
        return $a801f2c896bd09f1$var$map14(function(v1) {
            return v1.result;
        })(v3({
            substring: s2,
            position: 0
        }));
    };
};
var $a801f2c896bd09f1$var$functorParser = {
    map: function(f2) {
        return function(v3) {
            var $69 = $a801f2c896bd09f1$var$map14(function(v1) {
                return {
                    result: f2(v1.result),
                    suffix: v1.suffix
                };
            });
            return function($70) {
                return $69(v3($70));
            };
        };
    }
};
var $a801f2c896bd09f1$var$fail3 = function(error5) {
    return function(v3) {
        return new $a801f2c896bd09f1$var$Left({
            pos: v3.position,
            error: error5
        });
    };
};
var $a801f2c896bd09f1$var$applyParser = {
    apply: function(v3) {
        return function(v1) {
            return function(s2) {
                return $a801f2c896bd09f1$var$bind3(v3(s2))(function(v22) {
                    return $a801f2c896bd09f1$var$bind3(v1(v22.suffix))(function(v32) {
                        return $a801f2c896bd09f1$var$pure5({
                            result: v22.result(v32.result),
                            suffix: v32.suffix
                        });
                    });
                });
            };
        };
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorParser;
    }
};
var $a801f2c896bd09f1$var$bindParser = {
    bind: function(v3) {
        return function(f2) {
            return function(s2) {
                return $a801f2c896bd09f1$var$bind3(v3(s2))(function(v1) {
                    return $a801f2c896bd09f1$var$unParser(f2(v1.result))(v1.suffix);
                });
            };
        };
    },
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyParser;
    }
};
var $a801f2c896bd09f1$var$applicativeParser = {
    pure: function(a3) {
        return function(s2) {
            return new $a801f2c896bd09f1$var$Right({
                result: a3,
                suffix: s2
            });
        };
    },
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyParser;
    }
};
var $a801f2c896bd09f1$var$monadParser = {
    Applicative0: function() {
        return $a801f2c896bd09f1$var$applicativeParser;
    },
    Bind1: function() {
        return $a801f2c896bd09f1$var$bindParser;
    }
};
var $a801f2c896bd09f1$var$monadRecParser = {
    tailRecM: function(f2) {
        return function(a3) {
            var split3 = function(v3) {
                if (v3.result instanceof $a801f2c896bd09f1$var$Loop) return new $a801f2c896bd09f1$var$Loop({
                    state: v3.result.value0,
                    str: v3.suffix
                });
                if (v3.result instanceof $a801f2c896bd09f1$var$Done) return new $a801f2c896bd09f1$var$Done({
                    result: v3.result.value0,
                    suffix: v3.suffix
                });
                throw new Error("Failed pattern match at StringParser.Parser (line 87, column 5 - line 87, column 68): " + [
                    v3.constructor.name
                ]);
            };
            return function(str) {
                return $a801f2c896bd09f1$var$tailRecM3(function(st) {
                    return $a801f2c896bd09f1$var$map14(split3)($a801f2c896bd09f1$var$unParser(f2(st.state))(st.str));
                })({
                    state: a3,
                    str: str
                });
            };
        };
    },
    Monad0: function() {
        return $a801f2c896bd09f1$var$monadParser;
    }
};
var $a801f2c896bd09f1$var$altParser = {
    alt: function(v3) {
        return function(v1) {
            return function(s2) {
                var v22 = v3(s2);
                if (v22 instanceof $a801f2c896bd09f1$var$Left) {
                    if (s2.position === v22.value0.pos) return v1(s2);
                    if ($a801f2c896bd09f1$var$otherwise) return new $a801f2c896bd09f1$var$Left({
                        error: v22.value0.error,
                        pos: v22.value0.pos
                    });
                }
                return v22;
            };
        };
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorParser;
    }
};
var $a801f2c896bd09f1$var$plusParser = {
    empty: /* @__PURE__ */ $a801f2c896bd09f1$var$fail3("No alternative"),
    Alt0: function() {
        return $a801f2c896bd09f1$var$altParser;
    }
};
var $a801f2c896bd09f1$var$alternativeParser = {
    Applicative0: function() {
        return $a801f2c896bd09f1$var$applicativeParser;
    },
    Plus1: function() {
        return $a801f2c896bd09f1$var$plusParser;
    }
};
// output/StringParser.Combinators/index.js
var $a801f2c896bd09f1$var$alt3 = /* @__PURE__ */ $a801f2c896bd09f1$var$alt($a801f2c896bd09f1$var$altParser);
var $a801f2c896bd09f1$var$pure6 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeParser);
var $a801f2c896bd09f1$var$map15 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorParser);
var $a801f2c896bd09f1$var$apply3 = /* @__PURE__ */ $a801f2c896bd09f1$var$apply($a801f2c896bd09f1$var$applyParser);
var $a801f2c896bd09f1$var$withError = function(p3) {
    return function(msg) {
        return $a801f2c896bd09f1$var$alt3(p3)($a801f2c896bd09f1$var$fail3(msg));
    };
};
var $a801f2c896bd09f1$var$$$try3 = function(v3) {
    return function(s2) {
        var v1 = v3(s2);
        if (v1 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left({
            pos: s2.position,
            error: v1.value0.error
        });
        return v1;
    };
};
var $a801f2c896bd09f1$var$option = function(a3) {
    return function(p3) {
        return $a801f2c896bd09f1$var$alt3(p3)($a801f2c896bd09f1$var$pure6(a3));
    };
};
var $a801f2c896bd09f1$var$cons$prime = function(h7) {
    return function(t2) {
        return new $a801f2c896bd09f1$var$NonEmpty(h7, t2);
    };
};
var $a801f2c896bd09f1$var$assertConsume = function(v3) {
    return function(s2) {
        var v1 = v3(s2);
        if (v1 instanceof $a801f2c896bd09f1$var$Right) {
            var $34 = s2.position < v1.value0.suffix.position;
            if ($34) return new $a801f2c896bd09f1$var$Right(v1.value0);
            return new $a801f2c896bd09f1$var$Left({
                pos: s2.position,
                error: "Consumed no input."
            });
        }
        return v1;
    };
};
var $a801f2c896bd09f1$var$many = /* @__PURE__ */ function() {
    var $37 = $a801f2c896bd09f1$var$manyRec($a801f2c896bd09f1$var$monadRecParser)($a801f2c896bd09f1$var$alternativeParser);
    return function($38) {
        return $37($a801f2c896bd09f1$var$assertConsume($38));
    };
}();
var $a801f2c896bd09f1$var$many1 = function(p3) {
    return $a801f2c896bd09f1$var$apply3($a801f2c896bd09f1$var$map15($a801f2c896bd09f1$var$cons$prime)(p3))($a801f2c896bd09f1$var$many(p3));
};
// output/StringParser.CodeUnits/index.js
var $a801f2c896bd09f1$var$anyChar = function(v3) {
    var v1 = $a801f2c896bd09f1$var$charAt2(0)(v3.substring);
    if (v1 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Right({
        result: v1.value0,
        suffix: {
            substring: $a801f2c896bd09f1$var$drop2(1)(v3.substring),
            position: v3.position + 1 | 0
        }
    });
    if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Left({
        pos: v3.position,
        error: "Unexpected EOF"
    });
    throw new Error("Failed pattern match at StringParser.CodeUnits (line 50, column 3 - line 52, column 63): " + [
        v1.constructor.name
    ]);
};
// output/StringParser.CodePoints/index.js
var $a801f2c896bd09f1$var$bind4 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindParser);
var $a801f2c896bd09f1$var$pure7 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeParser);
var $a801f2c896bd09f1$var$show3 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showChar);
var $a801f2c896bd09f1$var$show22 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$eof = function(s2) {
    if (0 < $a801f2c896bd09f1$var$length5(s2.substring)) return new $a801f2c896bd09f1$var$Left({
        pos: s2.position,
        error: "Expected EOF"
    });
    return new $a801f2c896bd09f1$var$Right({
        result: $a801f2c896bd09f1$var$unit,
        suffix: s2
    });
};
var $a801f2c896bd09f1$var$anyDigit = /* @__PURE__ */ $a801f2c896bd09f1$var$$$try3(/* @__PURE__ */ $a801f2c896bd09f1$var$bind4($a801f2c896bd09f1$var$anyChar)(function(c3) {
    var $63 = c3 >= "0" && c3 <= "9";
    if ($63) return $a801f2c896bd09f1$var$pure7(c3);
    return $a801f2c896bd09f1$var$fail3("Character " + ($a801f2c896bd09f1$var$show3(c3) + " is not a digit"));
}));
var $a801f2c896bd09f1$var$anyCodePoint = function(v3) {
    var v1 = $a801f2c896bd09f1$var$uncons3(v3.substring);
    if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Left({
        pos: v3.position,
        error: "Unexpected EOF"
    });
    if (v1 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Right({
        result: v1.value0.head,
        suffix: {
            substring: v1.value0.tail,
            position: v3.position + 1 | 0
        }
    });
    throw new Error("Failed pattern match at StringParser.CodePoints (line 72, column 3 - line 74, column 103): " + [
        v1.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$anyChar2 = /* @__PURE__ */ function() {
    var notAChar = function(cc) {
        return $a801f2c896bd09f1$var$fail3("Code point " + ($a801f2c896bd09f1$var$show22(cc) + " is not a character"));
    };
    return $a801f2c896bd09f1$var$bind4($a801f2c896bd09f1$var$mapFlipped($a801f2c896bd09f1$var$functorParser)($a801f2c896bd09f1$var$anyCodePoint)($a801f2c896bd09f1$var$fromEnum($a801f2c896bd09f1$var$boundedEnumCodePoint)))(function(cc) {
        var v3 = $a801f2c896bd09f1$var$fromCharCode2(cc);
        if (v3 instanceof $a801f2c896bd09f1$var$Just) {
            var $73 = cc > 65535;
            if ($73) return notAChar(cc);
            return $a801f2c896bd09f1$var$pure7(v3.value0);
        }
        if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return notAChar(cc);
        throw new Error("Failed pattern match at StringParser.CodePoints (line 57, column 3 - line 65, column 27): " + [
            v3.constructor.name
        ]);
    });
}();
var $a801f2c896bd09f1$var$satisfy = function(f2) {
    return $a801f2c896bd09f1$var$$$try3($a801f2c896bd09f1$var$bind4($a801f2c896bd09f1$var$anyChar2)(function(c3) {
        var $75 = f2(c3);
        if ($75) return $a801f2c896bd09f1$var$pure7(c3);
        return $a801f2c896bd09f1$var$fail3("Character " + ($a801f2c896bd09f1$var$show3(c3) + " did not satisfy predicate"));
    }));
};
var $a801f2c896bd09f1$var$$$char = function(c3) {
    return $a801f2c896bd09f1$var$withError($a801f2c896bd09f1$var$satisfy(function(v3) {
        return v3 === c3;
    }))("Could not match character " + $a801f2c896bd09f1$var$show3(c3));
};
var $a801f2c896bd09f1$var$oneOf2 = function(dictFoldable) {
    var $78 = $a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$elem(dictFoldable)($a801f2c896bd09f1$var$eqChar));
    return function($79) {
        return $a801f2c896bd09f1$var$satisfy($78($79));
    };
};
// output/Data.Pitches.Internal/index.js
var $a801f2c896bd09f1$var$bind5 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind(/* @__PURE__ */ $a801f2c896bd09f1$var$bindExceptT($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$readImpl2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readImpl($a801f2c896bd09f1$var$readString2);
var $a801f2c896bd09f1$var$fail4 = /* @__PURE__ */ $a801f2c896bd09f1$var$fail($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$pure8 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure(/* @__PURE__ */ $a801f2c896bd09f1$var$applicativeExceptT($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$bind1 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindParser);
var $a801f2c896bd09f1$var$pure1 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeParser);
var $a801f2c896bd09f1$var$foldl4 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableNonEmptyList);
var $a801f2c896bd09f1$var$readJSONviaParse = function(dictNotation) {
    var parseNotation3 = $a801f2c896bd09f1$var$parseNotation(dictNotation);
    return function(typ) {
        return function(input3) {
            return $a801f2c896bd09f1$var$bind5($a801f2c896bd09f1$var$readImpl2(input3))(function(str) {
                var v3 = parseNotation3(str);
                if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$fail4(new $a801f2c896bd09f1$var$ForeignError("Cannot parse " + (str + (" as " + (typ + "!")))));
                if (v3 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$pure8(v3.value0);
                throw new Error("Failed pattern match at Data.Pitches.Internal (line 36, column 3 - line 38, column 21): " + [
                    v3.constructor.name
                ]);
            });
        };
    };
};
var $a801f2c896bd09f1$var$ascii0 = /* @__PURE__ */ $a801f2c896bd09f1$var$toCharCode2("0");
var $a801f2c896bd09f1$var$digit = function(d) {
    return $a801f2c896bd09f1$var$toCharCode2(d) - $a801f2c896bd09f1$var$ascii0 | 0;
};
var $a801f2c896bd09f1$var$parseSInt = /* @__PURE__ */ $a801f2c896bd09f1$var$bind1(/* @__PURE__ */ $a801f2c896bd09f1$var$option("+")(/* @__PURE__ */ $a801f2c896bd09f1$var$$$char("-")))(function(signChar) {
    var sign2 = function() {
        var $20 = signChar === "-";
        if ($20) return -1;
        return 1;
    }();
    return $a801f2c896bd09f1$var$bind1($a801f2c896bd09f1$var$many1($a801f2c896bd09f1$var$anyDigit))(function(dgts) {
        return $a801f2c896bd09f1$var$pure1(sign2 * $a801f2c896bd09f1$var$foldl4(function(acc) {
            return function(d) {
                return (10 * acc | 0) + $a801f2c896bd09f1$var$digit(d) | 0;
            };
        })(0)(dgts) | 0);
    });
});
// output/Control.Monad.State.Trans/index.js
var $a801f2c896bd09f1$var$runStateT = function(v3) {
    return v3;
};
var $a801f2c896bd09f1$var$monadTransStateT = {
    lift: function(dictMonad) {
        var bind37 = $a801f2c896bd09f1$var$bind(dictMonad.Bind1());
        var pure43 = $a801f2c896bd09f1$var$pure(dictMonad.Applicative0());
        return function(m3) {
            return function(s2) {
                return bind37(m3)(function(x4) {
                    return pure43(new $a801f2c896bd09f1$var$Tuple(x4, s2));
                });
            };
        };
    }
};
var $a801f2c896bd09f1$var$functorStateT = function(dictFunctor) {
    var map59 = $a801f2c896bd09f1$var$map(dictFunctor);
    return {
        map: function(f2) {
            return function(v3) {
                return function(s2) {
                    return map59(function(v1) {
                        return new $a801f2c896bd09f1$var$Tuple(f2(v1.value0), v1.value1);
                    })(v3(s2));
                };
            };
        }
    };
};
var $a801f2c896bd09f1$var$evalStateT = function(dictFunctor) {
    var map59 = $a801f2c896bd09f1$var$map(dictFunctor);
    return function(v3) {
        return function(s2) {
            return map59($a801f2c896bd09f1$var$fst)(v3(s2));
        };
    };
};
var $a801f2c896bd09f1$var$monadStateT = function(dictMonad) {
    return {
        Applicative0: function() {
            return $a801f2c896bd09f1$var$applicativeStateT(dictMonad);
        },
        Bind1: function() {
            return $a801f2c896bd09f1$var$bindStateT(dictMonad);
        }
    };
};
var $a801f2c896bd09f1$var$bindStateT = function(dictMonad) {
    var bind37 = $a801f2c896bd09f1$var$bind(dictMonad.Bind1());
    return {
        bind: function(v3) {
            return function(f2) {
                return function(s2) {
                    return bind37(v3(s2))(function(v1) {
                        var v32 = f2(v1.value0);
                        return v32(v1.value1);
                    });
                };
            };
        },
        Apply0: function() {
            return $a801f2c896bd09f1$var$applyStateT(dictMonad);
        }
    };
};
var $a801f2c896bd09f1$var$applyStateT = function(dictMonad) {
    var functorStateT1 = $a801f2c896bd09f1$var$functorStateT(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $a801f2c896bd09f1$var$ap($a801f2c896bd09f1$var$monadStateT(dictMonad)),
        Functor0: function() {
            return functorStateT1;
        }
    };
};
var $a801f2c896bd09f1$var$applicativeStateT = function(dictMonad) {
    var pure43 = $a801f2c896bd09f1$var$pure(dictMonad.Applicative0());
    return {
        pure: function(a3) {
            return function(s2) {
                return pure43(new $a801f2c896bd09f1$var$Tuple(a3, s2));
            };
        },
        Apply0: function() {
            return $a801f2c896bd09f1$var$applyStateT(dictMonad);
        }
    };
};
var $a801f2c896bd09f1$var$monadStateStateT = function(dictMonad) {
    var pure43 = $a801f2c896bd09f1$var$pure(dictMonad.Applicative0());
    var monadStateT1 = $a801f2c896bd09f1$var$monadStateT(dictMonad);
    return {
        state: function(f2) {
            return function($206) {
                return pure43(f2($206));
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
// output/Control.Monad.State/index.js
var $a801f2c896bd09f1$var$execState = function(v3) {
    return function(s2) {
        var v1 = v3(s2);
        return v1.value1;
    };
};
// output/Data.Pitches.Spelled/index.js
var $a801f2c896bd09f1$var$mod4 = /* @__PURE__ */ $a801f2c896bd09f1$var$mod($a801f2c896bd09f1$var$euclideanRingInt);
var $a801f2c896bd09f1$var$compare4 = /* @__PURE__ */ $a801f2c896bd09f1$var$compare($a801f2c896bd09f1$var$ordInt);
var $a801f2c896bd09f1$var$power3 = /* @__PURE__ */ $a801f2c896bd09f1$var$power($a801f2c896bd09f1$var$monoidString);
var $a801f2c896bd09f1$var$abs3 = /* @__PURE__ */ $a801f2c896bd09f1$var$abs($a801f2c896bd09f1$var$ordInt)($a801f2c896bd09f1$var$ringInt);
var $a801f2c896bd09f1$var$map16 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorParser);
var $a801f2c896bd09f1$var$alt4 = /* @__PURE__ */ $a801f2c896bd09f1$var$alt($a801f2c896bd09f1$var$altParser);
var $a801f2c896bd09f1$var$div4 = /* @__PURE__ */ $a801f2c896bd09f1$var$div($a801f2c896bd09f1$var$euclideanRingInt);
var $a801f2c896bd09f1$var$eq13 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqOrdering);
var $a801f2c896bd09f1$var$bind6 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindParser);
var $a801f2c896bd09f1$var$oneOf4 = /* @__PURE__ */ $a801f2c896bd09f1$var$oneOf2($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$pure9 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeParser);
var $a801f2c896bd09f1$var$compare12 = /* @__PURE__ */ $a801f2c896bd09f1$var$compare(/* @__PURE__ */ $a801f2c896bd09f1$var$ordArray($a801f2c896bd09f1$var$ordInt));
var $a801f2c896bd09f1$var$discard2 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit)($a801f2c896bd09f1$var$bindParser);
var $a801f2c896bd09f1$var$show12 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$writeImpl2 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeImpl($a801f2c896bd09f1$var$writeForeignString);
var $a801f2c896bd09f1$var$SIC = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$eqSInterval = {
    eq: function(x4) {
        return function(y4) {
            return x4.fifths === y4.fifths && x4.octaves === y4.octaves;
        };
    }
};
var $a801f2c896bd09f1$var$eqSIC = {
    eq: function(x4) {
        return function(y4) {
            return x4 === y4;
        };
    }
};
var $a801f2c896bd09f1$var$ordSIC = {
    compare: function(x4) {
        return function(y4) {
            return $a801f2c896bd09f1$var$compare4(x4)(y4);
        };
    },
    Eq0: function() {
        return $a801f2c896bd09f1$var$eqSIC;
    }
};
var $a801f2c896bd09f1$var$spelled = function(fifths1) {
    return function(octaves32) {
        return {
            fifths: fifths1,
            octaves: octaves32
        };
    };
};
var $a801f2c896bd09f1$var$semigroupSInterval = {
    append: function(v3) {
        return function(v1) {
            return $a801f2c896bd09f1$var$spelled(v3.fifths + v1.fifths | 0)(v3.octaves + v1.octaves | 0);
        };
    }
};
var $a801f2c896bd09f1$var$monoidSInterval = {
    mempty: /* @__PURE__ */ $a801f2c896bd09f1$var$spelled(0)(0),
    Semigroup0: function() {
        return $a801f2c896bd09f1$var$semigroupSInterval;
    }
};
var $a801f2c896bd09f1$var$groupSInterval = {
    ginverse: function(v3) {
        return $a801f2c896bd09f1$var$spelled(-v3.fifths | 0)(-v3.octaves | 0);
    },
    Monoid0: function() {
        return $a801f2c896bd09f1$var$monoidSInterval;
    }
};
var $a801f2c896bd09f1$var$sic = $a801f2c896bd09f1$var$SIC;
var $a801f2c896bd09f1$var$semigroupSIC = {
    append: function(v3) {
        return function(v1) {
            return $a801f2c896bd09f1$var$sic(v3 + v1 | 0);
        };
    }
};
var $a801f2c896bd09f1$var$monoidSIC = {
    mempty: /* @__PURE__ */ $a801f2c896bd09f1$var$sic(0),
    Semigroup0: function() {
        return $a801f2c896bd09f1$var$semigroupSIC;
    }
};
var $a801f2c896bd09f1$var$groupSIC = {
    ginverse: function(v3) {
        return $a801f2c896bd09f1$var$sic(-v3 | 0);
    },
    Monoid0: function() {
        return $a801f2c896bd09f1$var$monoidSIC;
    }
};
var $a801f2c896bd09f1$var$parseAccs = /* @__PURE__ */ function() {
    var munch = function($265) {
        return $a801f2c896bd09f1$var$many1($a801f2c896bd09f1$var$$$char($265));
    };
    var sharps = $a801f2c896bd09f1$var$map16($a801f2c896bd09f1$var$length2)($a801f2c896bd09f1$var$alt4(munch("\u266F"))(munch("#")));
    var flats = $a801f2c896bd09f1$var$map16(function($266) {
        return -$a801f2c896bd09f1$var$length2($266) | 0;
    })($a801f2c896bd09f1$var$alt4(munch("\u266D"))(munch("b")));
    return $a801f2c896bd09f1$var$option(0)($a801f2c896bd09f1$var$alt4(sharps)(flats));
}();
var $a801f2c896bd09f1$var$octaves = function(dict) {
    return dict.octaves;
};
var $a801f2c896bd09f1$var$internalOctaves = function(dict) {
    return dict.internalOctaves;
};
var $a801f2c896bd09f1$var$fifths2degree = function(fifths1) {
    return $a801f2c896bd09f1$var$mod4(fifths1 * 4 | 0)(7);
};
var $a801f2c896bd09f1$var$spelledSIC = {
    fifths: function(v3) {
        return v3;
    },
    octaves: function(v3) {
        return 0;
    },
    internalOctaves: function(v3) {
        return 0;
    },
    degree: function(v3) {
        return $a801f2c896bd09f1$var$fifths2degree(v3);
    },
    generic: function(v3) {
        return $a801f2c896bd09f1$var$fifths2degree(v3);
    },
    diasteps: function(v3) {
        return $a801f2c896bd09f1$var$fifths2degree(v3);
    },
    alteration: function(v3) {
        return $a801f2c896bd09f1$var$div4(v3 + 1 | 0)(7);
    }
};
var $a801f2c896bd09f1$var$fifths = function(dict) {
    return dict.fifths;
};
var $a801f2c896bd09f1$var$diasteps = function(dict) {
    return dict.diasteps;
};
var $a801f2c896bd09f1$var$diasteps1 = /* @__PURE__ */ $a801f2c896bd09f1$var$diasteps($a801f2c896bd09f1$var$spelledSIC);
var $a801f2c896bd09f1$var$intervalSIC = {
    octave: /* @__PURE__ */ $a801f2c896bd09f1$var$sic(0),
    direction: function(i2) {
        var dia = $a801f2c896bd09f1$var$diasteps1(i2);
        var $226 = dia === 0;
        if ($226) return $a801f2c896bd09f1$var$EQ.value;
        var $227 = dia < 4;
        if ($227) return $a801f2c896bd09f1$var$GT.value;
        return $a801f2c896bd09f1$var$LT.value;
    },
    Group0: function() {
        return $a801f2c896bd09f1$var$groupSIC;
    }
};
var $a801f2c896bd09f1$var$hasIntervalClassSICSIC = {
    ic: function(i2) {
        return i2;
    },
    Interval0: function() {
        return $a801f2c896bd09f1$var$intervalSIC;
    },
    Interval1: function() {
        return $a801f2c896bd09f1$var$intervalSIC;
    }
};
var $a801f2c896bd09f1$var$degree2 = function(dict) {
    return dict.degree;
};
var $a801f2c896bd09f1$var$degree1 = /* @__PURE__ */ $a801f2c896bd09f1$var$degree2($a801f2c896bd09f1$var$spelledSIC);
var $a801f2c896bd09f1$var$diatonicSIC = {
    isStep: function(i2) {
        var deg = $a801f2c896bd09f1$var$degree1(i2);
        return deg === 0 || deg === 1 || deg === 6;
    },
    Interval0: function() {
        return $a801f2c896bd09f1$var$intervalSIC;
    }
};
var $a801f2c896bd09f1$var$spelledSInterval = {
    fifths: function(v3) {
        return v3.fifths;
    },
    octaves: function(v3) {
        return v3.octaves + $a801f2c896bd09f1$var$div4(v3.fifths * 4 | 0)(7) | 0;
    },
    internalOctaves: function(v3) {
        return v3.octaves;
    },
    degree: function(v3) {
        return $a801f2c896bd09f1$var$fifths2degree(v3.fifths);
    },
    generic: function(i2) {
        if ($a801f2c896bd09f1$var$eq13($a801f2c896bd09f1$var$direction($a801f2c896bd09f1$var$intervalSInterval)(i2))($a801f2c896bd09f1$var$LT.value)) return -$a801f2c896bd09f1$var$degree2($a801f2c896bd09f1$var$spelledSInterval)($a801f2c896bd09f1$var$down($a801f2c896bd09f1$var$intervalSInterval)(i2)) | 0;
        if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$degree2($a801f2c896bd09f1$var$spelledSInterval)(i2);
        throw new Error("Failed pattern match at Data.Pitches.Spelled (line 346, column 1 - line 355, column 47): " + [
            i2.constructor.name
        ]);
    },
    diasteps: function(v3) {
        return (v3.fifths * 4 | 0) + (v3.octaves * 7 | 0) | 0;
    },
    alteration: function(i2) {
        return $a801f2c896bd09f1$var$div4($a801f2c896bd09f1$var$fifths($a801f2c896bd09f1$var$spelledSInterval)($a801f2c896bd09f1$var$iabs($a801f2c896bd09f1$var$intervalSInterval)(i2)) + 1 | 0)(7);
    }
};
var $a801f2c896bd09f1$var$intervalSInterval = {
    octave: /* @__PURE__ */ $a801f2c896bd09f1$var$spelled(0)(1),
    direction: function(i2) {
        return $a801f2c896bd09f1$var$compare4($a801f2c896bd09f1$var$diasteps($a801f2c896bd09f1$var$spelledSInterval)(i2))(0);
    },
    Group0: function() {
        return $a801f2c896bd09f1$var$groupSInterval;
    }
};
var $a801f2c896bd09f1$var$diasteps2 = /* @__PURE__ */ $a801f2c896bd09f1$var$diasteps($a801f2c896bd09f1$var$spelledSInterval);
var $a801f2c896bd09f1$var$hasIntervalClassSInterval = {
    ic: function(v3) {
        return $a801f2c896bd09f1$var$sic(v3.fifths);
    },
    Interval0: function() {
        return $a801f2c896bd09f1$var$intervalSInterval;
    },
    Interval1: function() {
        return $a801f2c896bd09f1$var$intervalSIC;
    }
};
var $a801f2c896bd09f1$var$asciiA = /* @__PURE__ */ $a801f2c896bd09f1$var$toCharCode2("A");
var $a801f2c896bd09f1$var$letter = function(dictSpelled) {
    var degree32 = $a801f2c896bd09f1$var$degree2(dictSpelled);
    return function(i2) {
        return $a801f2c896bd09f1$var$singleton6($a801f2c896bd09f1$var$codePointFromChar($a801f2c896bd09f1$var$fromMaybe("X")($a801f2c896bd09f1$var$fromCharCode2($a801f2c896bd09f1$var$asciiA + $a801f2c896bd09f1$var$mod4(degree32(i2) + 2 | 0)(7) | 0))));
    };
};
var $a801f2c896bd09f1$var$parseName = /* @__PURE__ */ $a801f2c896bd09f1$var$bind6(/* @__PURE__ */ $a801f2c896bd09f1$var$oneOf4([
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G"
]))(function(name17) {
    var dia = $a801f2c896bd09f1$var$mod4(($a801f2c896bd09f1$var$toCharCode2(name17) - $a801f2c896bd09f1$var$asciiA | 0) - 2 | 0)(7);
    return $a801f2c896bd09f1$var$bind6($a801f2c896bd09f1$var$parseAccs)(function(acc) {
        return $a801f2c896bd09f1$var$pure9(($a801f2c896bd09f1$var$mod4((dia * 2 | 0) + 1 | 0)(7) - 1 | 0) + (7 * acc | 0) | 0);
    });
});
var $a801f2c896bd09f1$var$alteration = function(dict) {
    return dict.alteration;
};
var $a801f2c896bd09f1$var$alteration1 = /* @__PURE__ */ $a801f2c896bd09f1$var$alteration($a801f2c896bd09f1$var$spelledSInterval);
var $a801f2c896bd09f1$var$ordSInterval = {
    compare: function(i1) {
        return function(i2) {
            return $a801f2c896bd09f1$var$compare12([
                $a801f2c896bd09f1$var$diasteps2(i1),
                $a801f2c896bd09f1$var$alteration1(i1)
            ])([
                $a801f2c896bd09f1$var$diasteps2(i2),
                $a801f2c896bd09f1$var$alteration1(i2)
            ]);
        };
    },
    Eq0: function() {
        return $a801f2c896bd09f1$var$eqSInterval;
    }
};
var $a801f2c896bd09f1$var$spelledPitch = function(dictSpelled) {
    var fifths1 = $a801f2c896bd09f1$var$fifths(dictSpelled);
    var octaves32 = $a801f2c896bd09f1$var$octaves(dictSpelled);
    var internalOctaves1 = $a801f2c896bd09f1$var$internalOctaves(dictSpelled);
    var degree32 = $a801f2c896bd09f1$var$degree2(dictSpelled);
    return function(dictHasIntervalClass) {
        var ic3 = $a801f2c896bd09f1$var$ic(dictHasIntervalClass);
        return function(dictSpelled1) {
            var alteration5 = $a801f2c896bd09f1$var$alteration(dictSpelled1);
            return {
                fifths: function(v3) {
                    return fifths1(v3);
                },
                octaves: function(v3) {
                    return octaves32(v3);
                },
                internalOctaves: function(v3) {
                    return internalOctaves1(v3);
                },
                degree: function(v3) {
                    return degree32(v3);
                },
                generic: function(v3) {
                    return degree32(v3);
                },
                diasteps: function(v3) {
                    return degree32(v3);
                },
                alteration: function(v3) {
                    return alteration5(ic3(v3));
                }
            };
        };
    };
};
var $a801f2c896bd09f1$var$spelledPitch2 = /* @__PURE__ */ $a801f2c896bd09f1$var$spelledPitch($a801f2c896bd09f1$var$spelledSInterval)($a801f2c896bd09f1$var$hasIntervalClassSInterval)($a801f2c896bd09f1$var$spelledSIC);
var $a801f2c896bd09f1$var$alteration4 = /* @__PURE__ */ $a801f2c896bd09f1$var$alteration($a801f2c896bd09f1$var$spelledPitch2);
var $a801f2c896bd09f1$var$letter2 = /* @__PURE__ */ $a801f2c896bd09f1$var$letter($a801f2c896bd09f1$var$spelledPitch2);
var $a801f2c896bd09f1$var$octaves2 = /* @__PURE__ */ $a801f2c896bd09f1$var$octaves($a801f2c896bd09f1$var$spelledPitch2);
var $a801f2c896bd09f1$var$accstr = function(n) {
    return function(lu) {
        return function(ld) {
            if (n === 0) return "";
            if (n > 0) return $a801f2c896bd09f1$var$power3(lu)(n);
            if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$power3(ld)($a801f2c896bd09f1$var$abs3(n));
            throw new Error("Failed pattern match at Data.Pitches.Spelled (line 212, column 1 - line 212, column 44): " + [
                n.constructor.name,
                lu.constructor.name,
                ld.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$notationPitchSInterval = {
    parsePitchNotation: function(str) {
        var parser = $a801f2c896bd09f1$var$bind6($a801f2c896bd09f1$var$parseName)(function(fs) {
            return $a801f2c896bd09f1$var$bind6($a801f2c896bd09f1$var$parseSInt)(function(os) {
                return $a801f2c896bd09f1$var$discard2($a801f2c896bd09f1$var$eof)(function() {
                    return $a801f2c896bd09f1$var$pure9($a801f2c896bd09f1$var$spelled(fs)(os - $a801f2c896bd09f1$var$div4(fs * 4 | 0)(7) | 0));
                });
            });
        });
        return $a801f2c896bd09f1$var$hush($a801f2c896bd09f1$var$runParser(parser)(str));
    },
    showPitchNotation: function(i2) {
        var accs = $a801f2c896bd09f1$var$accstr($a801f2c896bd09f1$var$alteration4(i2))("\u266F")("\u266D");
        return $a801f2c896bd09f1$var$letter2(i2) + (accs + $a801f2c896bd09f1$var$show12($a801f2c896bd09f1$var$octaves2(i2)));
    }
};
var $a801f2c896bd09f1$var$notationPitch1 = /* @__PURE__ */ $a801f2c896bd09f1$var$notationPitch($a801f2c896bd09f1$var$notationPitchSInterval);
var $a801f2c896bd09f1$var$readJSONviaParse2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readJSONviaParse($a801f2c896bd09f1$var$notationPitch1);
var $a801f2c896bd09f1$var$show23 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval));
var $a801f2c896bd09f1$var$readForeignPitchSInterval = {
    readImplPitch: function(input3) {
        return $a801f2c896bd09f1$var$readJSONviaParse2("spelled pitch")(input3);
    }
};
var $a801f2c896bd09f1$var$writeForeignPitchSInterva = {
    writeImplPitch: function(i2) {
        return $a801f2c896bd09f1$var$writeImpl2($a801f2c896bd09f1$var$show23(i2));
    }
};
// output/Data.Show.Generic/foreign.js
var $a801f2c896bd09f1$var$intercalate4 = function(separator) {
    return function(xs) {
        return xs.join(separator);
    };
};
// output/Data.Show.Generic/index.js
var $a801f2c896bd09f1$var$append3 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$genericShowArgsNoArguments = {
    genericShowArgs: function(v3) {
        return [];
    }
};
var $a801f2c896bd09f1$var$genericShowArgsArgument = function(dictShow) {
    var show40 = $a801f2c896bd09f1$var$show(dictShow);
    return {
        genericShowArgs: function(v3) {
            return [
                show40(v3)
            ];
        }
    };
};
var $a801f2c896bd09f1$var$genericShowArgs = function(dict) {
    return dict.genericShowArgs;
};
var $a801f2c896bd09f1$var$genericShowConstructor = function(dictGenericShowArgs) {
    var genericShowArgs1 = $a801f2c896bd09f1$var$genericShowArgs(dictGenericShowArgs);
    return function(dictIsSymbol) {
        var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
        return {
            "genericShow'": function(v3) {
                var ctor = reflectSymbol2($a801f2c896bd09f1$var$$$Proxy.value);
                var v1 = genericShowArgs1(v3);
                if (v1.length === 0) return ctor;
                return "(" + ($a801f2c896bd09f1$var$intercalate4(" ")($a801f2c896bd09f1$var$append3([
                    ctor
                ])(v1)) + ")");
            }
        };
    };
};
var $a801f2c896bd09f1$var$genericShow$prime = function(dict) {
    return dict["genericShow'"];
};
var $a801f2c896bd09f1$var$genericShowSum = function(dictGenericShow) {
    var genericShow$prime1 = $a801f2c896bd09f1$var$genericShow$prime(dictGenericShow);
    return function(dictGenericShow1) {
        var genericShow$prime2 = $a801f2c896bd09f1$var$genericShow$prime(dictGenericShow1);
        return {
            "genericShow'": function(v3) {
                if (v3 instanceof $a801f2c896bd09f1$var$Inl) return genericShow$prime1(v3.value0);
                if (v3 instanceof $a801f2c896bd09f1$var$Inr) return genericShow$prime2(v3.value0);
                throw new Error("Failed pattern match at Data.Show.Generic (line 26, column 1 - line 28, column 40): " + [
                    v3.constructor.name
                ]);
            }
        };
    };
};
var $a801f2c896bd09f1$var$genericShow = function(dictGeneric) {
    var from3 = $a801f2c896bd09f1$var$from(dictGeneric);
    return function(dictGenericShow) {
        var genericShow$prime1 = $a801f2c896bd09f1$var$genericShow$prime(dictGenericShow);
        return function(x4) {
            return genericShow$prime1(from3(x4));
        };
    };
};
// output/Data.Map.Internal/index.js
var $a801f2c896bd09f1$var$$runtime_lazy4 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$map17 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$Leaf = /* @__PURE__ */ function() {
    function Leaf2() {}
    Leaf2.value = new Leaf2();
    return Leaf2;
}();
var $a801f2c896bd09f1$var$Node = /* @__PURE__ */ function() {
    function Node2(value0, value1, value22, value32, value42, value52) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
        this.value3 = value32;
        this.value4 = value42;
        this.value5 = value52;
    }
    Node2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return function(value32) {
                    return function(value42) {
                        return function(value52) {
                            return new Node2(value0, value1, value22, value32, value42, value52);
                        };
                    };
                };
            };
        };
    };
    return Node2;
}();
var $a801f2c896bd09f1$var$IterLeaf = /* @__PURE__ */ function() {
    function IterLeaf2() {}
    IterLeaf2.value = new IterLeaf2();
    return IterLeaf2;
}();
var $a801f2c896bd09f1$var$IterEmit = /* @__PURE__ */ function() {
    function IterEmit2(value0, value1, value22) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
    }
    IterEmit2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return new IterEmit2(value0, value1, value22);
            };
        };
    };
    return IterEmit2;
}();
var $a801f2c896bd09f1$var$IterNode = /* @__PURE__ */ function() {
    function IterNode2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    IterNode2.create = function(value0) {
        return function(value1) {
            return new IterNode2(value0, value1);
        };
    };
    return IterNode2;
}();
var $a801f2c896bd09f1$var$IterDone = /* @__PURE__ */ function() {
    function IterDone2() {}
    IterDone2.value = new IterDone2();
    return IterDone2;
}();
var $a801f2c896bd09f1$var$IterNext = /* @__PURE__ */ function() {
    function IterNext2(value0, value1, value22) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
    }
    IterNext2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return new IterNext2(value0, value1, value22);
            };
        };
    };
    return IterNext2;
}();
var $a801f2c896bd09f1$var$Split = /* @__PURE__ */ function() {
    function Split3(value0, value1, value22) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
    }
    Split3.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return new Split3(value0, value1, value22);
            };
        };
    };
    return Split3;
}();
var $a801f2c896bd09f1$var$SplitLast = /* @__PURE__ */ function() {
    function SplitLast2(value0, value1, value22) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
    }
    SplitLast2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return new SplitLast2(value0, value1, value22);
            };
        };
    };
    return SplitLast2;
}();
var $a801f2c896bd09f1$var$unsafeNode = function(k2, v3, l2, r) {
    if (l2 instanceof $a801f2c896bd09f1$var$Leaf) {
        if (r instanceof $a801f2c896bd09f1$var$Leaf) return new $a801f2c896bd09f1$var$Node(1, 1, k2, v3, l2, r);
        if (r instanceof $a801f2c896bd09f1$var$Node) return new $a801f2c896bd09f1$var$Node(1 + r.value0 | 0, 1 + r.value1 | 0, k2, v3, l2, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 702, column 5 - line 706, column 39): " + [
            r.constructor.name
        ]);
    }
    if (l2 instanceof $a801f2c896bd09f1$var$Node) {
        if (r instanceof $a801f2c896bd09f1$var$Leaf) return new $a801f2c896bd09f1$var$Node(1 + l2.value0 | 0, 1 + l2.value1 | 0, k2, v3, l2, r);
        if (r instanceof $a801f2c896bd09f1$var$Node) return new $a801f2c896bd09f1$var$Node(1 + function() {
            var $280 = l2.value0 > r.value0;
            if ($280) return l2.value0;
            return r.value0;
        }() | 0, (1 + l2.value1 | 0) + r.value1 | 0, k2, v3, l2, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 708, column 5 - line 712, column 68): " + [
            r.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 700, column 32 - line 712, column 68): " + [
        l2.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$toMapIter = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$IterNode.create)($a801f2c896bd09f1$var$IterLeaf.value);
}();
var $a801f2c896bd09f1$var$stepWith = function(f2) {
    return function(next) {
        return function(done) {
            var go2 = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v3) {
                    if (v3 instanceof $a801f2c896bd09f1$var$IterLeaf) {
                        $tco_done = true;
                        return done($a801f2c896bd09f1$var$unit);
                    }
                    if (v3 instanceof $a801f2c896bd09f1$var$IterEmit) {
                        $tco_done = true;
                        return next(v3.value0, v3.value1, v3.value2);
                    }
                    if (v3 instanceof $a801f2c896bd09f1$var$IterNode) {
                        $copy_v = f2(v3.value1)(v3.value0);
                        return;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 940, column 8 - line 946, column 20): " + [
                        v3.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go2;
        };
    };
};
var $a801f2c896bd09f1$var$singleton7 = function(k2) {
    return function(v3) {
        return new $a801f2c896bd09f1$var$Node(1, 1, k2, v3, $a801f2c896bd09f1$var$Leaf.value, $a801f2c896bd09f1$var$Leaf.value);
    };
};
var $a801f2c896bd09f1$var$unsafeBalancedNode = /* @__PURE__ */ function() {
    var height9 = function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$Leaf) return 0;
        if (v3 instanceof $a801f2c896bd09f1$var$Node) return v3.value0;
        throw new Error("Failed pattern match at Data.Map.Internal (line 757, column 12 - line 759, column 26): " + [
            v3.constructor.name
        ]);
    };
    var rotateLeft = function(k2, v3, l2, rk, rv, rl, rr) {
        if (rl instanceof $a801f2c896bd09f1$var$Node && rl.value0 > height9(rr)) return $a801f2c896bd09f1$var$unsafeNode(rl.value2, rl.value3, $a801f2c896bd09f1$var$unsafeNode(k2, v3, l2, rl.value4), $a801f2c896bd09f1$var$unsafeNode(rk, rv, rl.value5, rr));
        return $a801f2c896bd09f1$var$unsafeNode(rk, rv, $a801f2c896bd09f1$var$unsafeNode(k2, v3, l2, rl), rr);
    };
    var rotateRight = function(k2, v3, lk, lv, ll, lr, r) {
        if (lr instanceof $a801f2c896bd09f1$var$Node && height9(ll) <= lr.value0) return $a801f2c896bd09f1$var$unsafeNode(lr.value2, lr.value3, $a801f2c896bd09f1$var$unsafeNode(lk, lv, ll, lr.value4), $a801f2c896bd09f1$var$unsafeNode(k2, v3, lr.value5, r));
        return $a801f2c896bd09f1$var$unsafeNode(lk, lv, ll, $a801f2c896bd09f1$var$unsafeNode(k2, v3, lr, r));
    };
    return function(k2, v3, l2, r) {
        if (l2 instanceof $a801f2c896bd09f1$var$Leaf) {
            if (r instanceof $a801f2c896bd09f1$var$Leaf) return $a801f2c896bd09f1$var$singleton7(k2)(v3);
            if (r instanceof $a801f2c896bd09f1$var$Node && r.value0 > 1) return rotateLeft(k2, v3, l2, r.value2, r.value3, r.value4, r.value5);
            return $a801f2c896bd09f1$var$unsafeNode(k2, v3, l2, r);
        }
        if (l2 instanceof $a801f2c896bd09f1$var$Node) {
            if (r instanceof $a801f2c896bd09f1$var$Node) {
                if (r.value0 > (l2.value0 + 1 | 0)) return rotateLeft(k2, v3, l2, r.value2, r.value3, r.value4, r.value5);
                if (l2.value0 > (r.value0 + 1 | 0)) return rotateRight(k2, v3, l2.value2, l2.value3, l2.value4, l2.value5, r);
            }
            if (r instanceof $a801f2c896bd09f1$var$Leaf && l2.value0 > 1) return rotateRight(k2, v3, l2.value2, l2.value3, l2.value4, l2.value5, r);
            return $a801f2c896bd09f1$var$unsafeNode(k2, v3, l2, r);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 717, column 40 - line 738, column 34): " + [
            l2.constructor.name
        ]);
    };
}();
var $a801f2c896bd09f1$var$$lazy_unsafeSplit = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy4("unsafeSplit", "Data.Map.Internal", function() {
    return function(comp, k2, m3) {
        if (m3 instanceof $a801f2c896bd09f1$var$Leaf) return new $a801f2c896bd09f1$var$Split($a801f2c896bd09f1$var$Nothing.value, $a801f2c896bd09f1$var$Leaf.value, $a801f2c896bd09f1$var$Leaf.value);
        if (m3 instanceof $a801f2c896bd09f1$var$Node) {
            var v3 = comp(k2)(m3.value2);
            if (v3 instanceof $a801f2c896bd09f1$var$LT) {
                var v1 = $a801f2c896bd09f1$var$$lazy_unsafeSplit(793)(comp, k2, m3.value4);
                return new $a801f2c896bd09f1$var$Split(v1.value0, v1.value1, $a801f2c896bd09f1$var$unsafeBalancedNode(m3.value2, m3.value3, v1.value2, m3.value5));
            }
            if (v3 instanceof $a801f2c896bd09f1$var$GT) {
                var v1 = $a801f2c896bd09f1$var$$lazy_unsafeSplit(796)(comp, k2, m3.value5);
                return new $a801f2c896bd09f1$var$Split(v1.value0, $a801f2c896bd09f1$var$unsafeBalancedNode(m3.value2, m3.value3, m3.value4, v1.value1), v1.value2);
            }
            if (v3 instanceof $a801f2c896bd09f1$var$EQ) return new $a801f2c896bd09f1$var$Split(new $a801f2c896bd09f1$var$Just(m3.value3), m3.value4, m3.value5);
            throw new Error("Failed pattern match at Data.Map.Internal (line 791, column 5 - line 799, column 30): " + [
                v3.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 787, column 34 - line 799, column 30): " + [
            m3.constructor.name
        ]);
    };
});
var $a801f2c896bd09f1$var$unsafeSplit = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_unsafeSplit(786);
var $a801f2c896bd09f1$var$$lazy_unsafeSplitLast = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy4("unsafeSplitLast", "Data.Map.Internal", function() {
    return function(k2, v3, l2, r) {
        if (r instanceof $a801f2c896bd09f1$var$Leaf) return new $a801f2c896bd09f1$var$SplitLast(k2, v3, l2);
        if (r instanceof $a801f2c896bd09f1$var$Node) {
            var v1 = $a801f2c896bd09f1$var$$lazy_unsafeSplitLast(779)(r.value2, r.value3, r.value4, r.value5);
            return new $a801f2c896bd09f1$var$SplitLast(v1.value0, v1.value1, $a801f2c896bd09f1$var$unsafeBalancedNode(k2, v3, l2, v1.value2));
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 776, column 37 - line 780, column 57): " + [
            r.constructor.name
        ]);
    };
});
var $a801f2c896bd09f1$var$unsafeSplitLast = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_unsafeSplitLast(775);
var $a801f2c896bd09f1$var$unsafeJoinNodes = function(v3, v1) {
    if (v3 instanceof $a801f2c896bd09f1$var$Leaf) return v1;
    if (v3 instanceof $a801f2c896bd09f1$var$Node) {
        var v22 = $a801f2c896bd09f1$var$unsafeSplitLast(v3.value2, v3.value3, v3.value4, v3.value5);
        return $a801f2c896bd09f1$var$unsafeBalancedNode(v22.value0, v22.value1, v22.value2, v1);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 764, column 25 - line 768, column 38): " + [
        v3.constructor.name,
        v1.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$$lazy_unsafeUnionWith = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy4("unsafeUnionWith", "Data.Map.Internal", function() {
    return function(comp, app, l2, r) {
        if (l2 instanceof $a801f2c896bd09f1$var$Leaf) return r;
        if (r instanceof $a801f2c896bd09f1$var$Leaf) return l2;
        if (r instanceof $a801f2c896bd09f1$var$Node) {
            var v3 = $a801f2c896bd09f1$var$unsafeSplit(comp, r.value2, l2);
            var l$prime = $a801f2c896bd09f1$var$$lazy_unsafeUnionWith(809)(comp, app, v3.value1, r.value4);
            var r$prime = $a801f2c896bd09f1$var$$lazy_unsafeUnionWith(810)(comp, app, v3.value2, r.value5);
            if (v3.value0 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$unsafeBalancedNode(r.value2, app(v3.value0.value0)(r.value3), l$prime, r$prime);
            if (v3.value0 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$unsafeBalancedNode(r.value2, r.value3, l$prime, r$prime);
            throw new Error("Failed pattern match at Data.Map.Internal (line 811, column 5 - line 815, column 46): " + [
                v3.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 804, column 42 - line 815, column 46): " + [
            l2.constructor.name,
            r.constructor.name
        ]);
    };
});
var $a801f2c896bd09f1$var$unsafeUnionWith = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_unsafeUnionWith(803);
var $a801f2c896bd09f1$var$unionWith = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(app) {
        return function(m1) {
            return function(m22) {
                return $a801f2c896bd09f1$var$unsafeUnionWith(compare6, app, m1, m22);
            };
        };
    };
};
var $a801f2c896bd09f1$var$union2 = function(dictOrd) {
    return $a801f2c896bd09f1$var$unionWith(dictOrd)($a801f2c896bd09f1$var$$$const);
};
var $a801f2c896bd09f1$var$pop = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(k2) {
        return function(m3) {
            var v3 = $a801f2c896bd09f1$var$unsafeSplit(compare6, k2, m3);
            return $a801f2c896bd09f1$var$map17(function(a3) {
                return new $a801f2c896bd09f1$var$Tuple(a3, $a801f2c896bd09f1$var$unsafeJoinNodes(v3.value1, v3.value2));
            })(v3.value0);
        };
    };
};
var $a801f2c896bd09f1$var$member = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(k2) {
        var go2 = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v3) {
                if (v3 instanceof $a801f2c896bd09f1$var$Leaf) {
                    $tco_done = true;
                    return false;
                }
                if (v3 instanceof $a801f2c896bd09f1$var$Node) {
                    var v1 = compare6(k2)(v3.value2);
                    if (v1 instanceof $a801f2c896bd09f1$var$LT) {
                        $copy_v = v3.value4;
                        return;
                    }
                    if (v1 instanceof $a801f2c896bd09f1$var$GT) {
                        $copy_v = v3.value5;
                        return;
                    }
                    if (v1 instanceof $a801f2c896bd09f1$var$EQ) {
                        $tco_done = true;
                        return true;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 459, column 7 - line 462, column 19): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 456, column 8 - line 462, column 19): " + [
                    v3.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go2;
    };
};
var $a801f2c896bd09f1$var$lookup3 = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(k2) {
        var go2 = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v3) {
                if (v3 instanceof $a801f2c896bd09f1$var$Leaf) {
                    $tco_done = true;
                    return $a801f2c896bd09f1$var$Nothing.value;
                }
                if (v3 instanceof $a801f2c896bd09f1$var$Node) {
                    var v1 = compare6(k2)(v3.value2);
                    if (v1 instanceof $a801f2c896bd09f1$var$LT) {
                        $copy_v = v3.value4;
                        return;
                    }
                    if (v1 instanceof $a801f2c896bd09f1$var$GT) {
                        $copy_v = v3.value5;
                        return;
                    }
                    if (v1 instanceof $a801f2c896bd09f1$var$EQ) {
                        $tco_done = true;
                        return new $a801f2c896bd09f1$var$Just(v3.value3);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 283, column 7 - line 286, column 22): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 280, column 8 - line 286, column 22): " + [
                    v3.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go2;
    };
};
var $a801f2c896bd09f1$var$iterMapL = /* @__PURE__ */ function() {
    var go2 = function($copy_iter) {
        return function($copy_v) {
            var $tco_var_iter = $copy_iter;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(iter, v3) {
                if (v3 instanceof $a801f2c896bd09f1$var$Leaf) {
                    $tco_done = true;
                    return iter;
                }
                if (v3 instanceof $a801f2c896bd09f1$var$Node) {
                    if (v3.value5 instanceof $a801f2c896bd09f1$var$Leaf) {
                        $tco_var_iter = new $a801f2c896bd09f1$var$IterEmit(v3.value2, v3.value3, iter);
                        $copy_v = v3.value4;
                        return;
                    }
                    $tco_var_iter = new $a801f2c896bd09f1$var$IterEmit(v3.value2, v3.value3, new $a801f2c896bd09f1$var$IterNode(v3.value5, iter));
                    $copy_v = v3.value4;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 951, column 13 - line 958, column 48): " + [
                    v3.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_iter, $copy_v);
            return $tco_result;
        };
    };
    return go2;
}();
var $a801f2c896bd09f1$var$stepAscCps = /* @__PURE__ */ $a801f2c896bd09f1$var$stepWith($a801f2c896bd09f1$var$iterMapL);
var $a801f2c896bd09f1$var$stepAsc = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$stepAscCps(function(k2, v3, next) {
        return new $a801f2c896bd09f1$var$IterNext(k2, v3, next);
    })($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$IterDone.value));
}();
var $a801f2c896bd09f1$var$eqMapIter = function(dictEq) {
    var eq112 = $a801f2c896bd09f1$var$eq(dictEq);
    return function(dictEq1) {
        var eq29 = $a801f2c896bd09f1$var$eq(dictEq1);
        return {
            eq: /* @__PURE__ */ function() {
                var go2 = function($copy_a) {
                    return function($copy_b) {
                        var $tco_var_a = $copy_a;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(a3, b3) {
                            var v3 = $a801f2c896bd09f1$var$stepAsc(a3);
                            if (v3 instanceof $a801f2c896bd09f1$var$IterNext) {
                                var v22 = $a801f2c896bd09f1$var$stepAsc(b3);
                                if (v22 instanceof $a801f2c896bd09f1$var$IterNext && eq112(v3.value0)(v22.value0) && eq29(v3.value1)(v22.value1)) {
                                    $tco_var_a = v3.value2;
                                    $copy_b = v22.value2;
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            if (v3 instanceof $a801f2c896bd09f1$var$IterDone) {
                                $tco_done = true;
                                return true;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 859, column 14 - line 868, column 13): " + [
                                v3.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_a, $copy_b);
                        return $tco_result;
                    };
                };
                return go2;
            }()
        };
    };
};
var $a801f2c896bd09f1$var$stepUnfoldr = /* @__PURE__ */ function() {
    var step4 = function(k2, v3, next) {
        return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Tuple(new $a801f2c896bd09f1$var$Tuple(k2, v3), next));
    };
    return $a801f2c896bd09f1$var$stepAscCps(step4)(function(v3) {
        return $a801f2c896bd09f1$var$Nothing.value;
    });
}();
var $a801f2c896bd09f1$var$toUnfoldable4 = function(dictUnfoldable) {
    var $784 = $a801f2c896bd09f1$var$unfoldr(dictUnfoldable)($a801f2c896bd09f1$var$stepUnfoldr);
    return function($785) {
        return $784($a801f2c896bd09f1$var$toMapIter($785));
    };
};
var $a801f2c896bd09f1$var$toUnfoldable1 = /* @__PURE__ */ $a801f2c896bd09f1$var$toUnfoldable4($a801f2c896bd09f1$var$unfoldableArray);
var $a801f2c896bd09f1$var$showMap = function(dictShow) {
    var showTuple2 = $a801f2c896bd09f1$var$showTuple(dictShow);
    return function(dictShow1) {
        var show115 = $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showArray(showTuple2(dictShow1)));
        return {
            show: function(as) {
                return "(fromFoldable " + (show115($a801f2c896bd09f1$var$toUnfoldable1(as)) + ")");
            }
        };
    };
};
var $a801f2c896bd09f1$var$isEmpty = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$Leaf) return true;
    return false;
};
var $a801f2c896bd09f1$var$insertWith = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(app) {
        return function(k2) {
            return function(v3) {
                var go2 = function(v1) {
                    if (v1 instanceof $a801f2c896bd09f1$var$Leaf) return $a801f2c896bd09f1$var$singleton7(k2)(v3);
                    if (v1 instanceof $a801f2c896bd09f1$var$Node) {
                        var v22 = compare6(k2)(v1.value2);
                        if (v22 instanceof $a801f2c896bd09f1$var$LT) return $a801f2c896bd09f1$var$unsafeBalancedNode(v1.value2, v1.value3, go2(v1.value4), v1.value5);
                        if (v22 instanceof $a801f2c896bd09f1$var$GT) return $a801f2c896bd09f1$var$unsafeBalancedNode(v1.value2, v1.value3, v1.value4, go2(v1.value5));
                        if (v22 instanceof $a801f2c896bd09f1$var$EQ) return new $a801f2c896bd09f1$var$Node(v1.value0, v1.value1, k2, app(v1.value3)(v3), v1.value4, v1.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 486, column 7 - line 489, column 44): " + [
                            v22.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 483, column 8 - line 489, column 44): " + [
                        v1.constructor.name
                    ]);
                };
                return go2;
            };
        };
    };
};
var $a801f2c896bd09f1$var$insert6 = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(k2) {
        return function(v3) {
            var go2 = function(v1) {
                if (v1 instanceof $a801f2c896bd09f1$var$Leaf) return $a801f2c896bd09f1$var$singleton7(k2)(v3);
                if (v1 instanceof $a801f2c896bd09f1$var$Node) {
                    var v22 = compare6(k2)(v1.value2);
                    if (v22 instanceof $a801f2c896bd09f1$var$LT) return $a801f2c896bd09f1$var$unsafeBalancedNode(v1.value2, v1.value3, go2(v1.value4), v1.value5);
                    if (v22 instanceof $a801f2c896bd09f1$var$GT) return $a801f2c896bd09f1$var$unsafeBalancedNode(v1.value2, v1.value3, v1.value4, go2(v1.value5));
                    if (v22 instanceof $a801f2c896bd09f1$var$EQ) return new $a801f2c896bd09f1$var$Node(v1.value0, v1.value1, k2, v3, v1.value4, v1.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 471, column 7 - line 474, column 35): " + [
                        v22.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 468, column 8 - line 474, column 35): " + [
                    v1.constructor.name
                ]);
            };
            return go2;
        };
    };
};
var $a801f2c896bd09f1$var$foldableMap = {
    foldr: function(f2) {
        return function(z3) {
            var $lazy_go = $a801f2c896bd09f1$var$$runtime_lazy4("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $a801f2c896bd09f1$var$Leaf) return z$prime;
                    if (m$prime instanceof $a801f2c896bd09f1$var$Node) return $lazy_go(172)(m$prime.value4, f2(m$prime.value3)($lazy_go(172)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 169, column 26 - line 172, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go2 = $lazy_go(169);
            return function(m3) {
                return go2(m3, z3);
            };
        };
    },
    foldl: function(f2) {
        return function(z3) {
            var $lazy_go = $a801f2c896bd09f1$var$$runtime_lazy4("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $a801f2c896bd09f1$var$Leaf) return z$prime;
                    if (m$prime instanceof $a801f2c896bd09f1$var$Node) return $lazy_go(178)(f2($lazy_go(178)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 175, column 26 - line 178, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go2 = $lazy_go(175);
            return function(m3) {
                return go2(z3, m3);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty5 = $a801f2c896bd09f1$var$mempty(dictMonoid);
        var append18 = $a801f2c896bd09f1$var$append(dictMonoid.Semigroup0());
        return function(f2) {
            var go2 = function(v3) {
                if (v3 instanceof $a801f2c896bd09f1$var$Leaf) return mempty5;
                if (v3 instanceof $a801f2c896bd09f1$var$Node) return append18(go2(v3.value4))(append18(f2(v3.value3))(go2(v3.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 181, column 10 - line 184, column 28): " + [
                    v3.constructor.name
                ]);
            };
            return go2;
        };
    }
};
var $a801f2c896bd09f1$var$foldableWithIndexMap = {
    foldrWithIndex: function(f2) {
        return function(z3) {
            var $lazy_go = $a801f2c896bd09f1$var$$runtime_lazy4("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $a801f2c896bd09f1$var$Leaf) return z$prime;
                    if (m$prime instanceof $a801f2c896bd09f1$var$Node) return $lazy_go(192)(m$prime.value4, f2(m$prime.value2)(m$prime.value3)($lazy_go(192)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 189, column 26 - line 192, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go2 = $lazy_go(189);
            return function(m3) {
                return go2(m3, z3);
            };
        };
    },
    foldlWithIndex: function(f2) {
        return function(z3) {
            var $lazy_go = $a801f2c896bd09f1$var$$runtime_lazy4("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $a801f2c896bd09f1$var$Leaf) return z$prime;
                    if (m$prime instanceof $a801f2c896bd09f1$var$Node) return $lazy_go(198)(f2(m$prime.value2)($lazy_go(198)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 195, column 26 - line 198, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go2 = $lazy_go(195);
            return function(m3) {
                return go2(z3, m3);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty5 = $a801f2c896bd09f1$var$mempty(dictMonoid);
        var append18 = $a801f2c896bd09f1$var$append(dictMonoid.Semigroup0());
        return function(f2) {
            var go2 = function(v3) {
                if (v3 instanceof $a801f2c896bd09f1$var$Leaf) return mempty5;
                if (v3 instanceof $a801f2c896bd09f1$var$Node) return append18(go2(v3.value4))(append18(f2(v3.value2)(v3.value3))(go2(v3.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 201, column 10 - line 204, column 30): " + [
                    v3.constructor.name
                ]);
            };
            return go2;
        };
    },
    Foldable0: function() {
        return $a801f2c896bd09f1$var$foldableMap;
    }
};
var $a801f2c896bd09f1$var$keys2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$foldrWithIndex($a801f2c896bd09f1$var$foldableWithIndexMap)(function(k2) {
        return function(v3) {
            return function(acc) {
                return new $a801f2c896bd09f1$var$Cons(k2, acc);
            };
        };
    })($a801f2c896bd09f1$var$Nil.value);
}();
var $a801f2c896bd09f1$var$values2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$foldr($a801f2c896bd09f1$var$foldableMap)($a801f2c896bd09f1$var$Cons.create)($a801f2c896bd09f1$var$Nil.value);
}();
var $a801f2c896bd09f1$var$eqMap = function(dictEq) {
    var eqMapIter1 = $a801f2c896bd09f1$var$eqMapIter(dictEq);
    return function(dictEq1) {
        var eq112 = $a801f2c896bd09f1$var$eq(eqMapIter1(dictEq1));
        return {
            eq: function(xs) {
                return function(ys) {
                    if (xs instanceof $a801f2c896bd09f1$var$Leaf) {
                        if (ys instanceof $a801f2c896bd09f1$var$Leaf) return true;
                        return false;
                    }
                    if (xs instanceof $a801f2c896bd09f1$var$Node) {
                        if (ys instanceof $a801f2c896bd09f1$var$Node && xs.value1 === ys.value1) return eq112($a801f2c896bd09f1$var$toMapIter(xs))($a801f2c896bd09f1$var$toMapIter(ys));
                        return false;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 94, column 14 - line 105, column 16): " + [
                        xs.constructor.name
                    ]);
                };
            }
        };
    };
};
var $a801f2c896bd09f1$var$empty3 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$Leaf.value;
}();
var $a801f2c896bd09f1$var$fromFoldable4 = function(dictOrd) {
    var insert17 = $a801f2c896bd09f1$var$insert6(dictOrd);
    return function(dictFoldable) {
        return $a801f2c896bd09f1$var$foldl(dictFoldable)(function(m3) {
            return function(v3) {
                return insert17(v3.value0)(v3.value1)(m3);
            };
        })($a801f2c896bd09f1$var$empty3);
    };
};
var $a801f2c896bd09f1$var$fromFoldableWith = function(dictOrd) {
    var insertWith1 = $a801f2c896bd09f1$var$insertWith(dictOrd);
    return function(dictFoldable) {
        var foldl10 = $a801f2c896bd09f1$var$foldl(dictFoldable);
        return function(f2) {
            var f$prime = insertWith1($a801f2c896bd09f1$var$flip(f2));
            return foldl10(function(m3) {
                return function(v3) {
                    return f$prime(v3.value0)(v3.value1)(m3);
                };
            })($a801f2c896bd09f1$var$empty3);
        };
    };
};
var $a801f2c896bd09f1$var$fromFoldableWithIndex2 = function(dictOrd) {
    var insert17 = $a801f2c896bd09f1$var$insert6(dictOrd);
    return function(dictFoldableWithIndex) {
        return $a801f2c896bd09f1$var$foldlWithIndex(dictFoldableWithIndex)(function(k2) {
            return function(m3) {
                return function(v3) {
                    return insert17(k2)(v3)(m3);
                };
            };
        })($a801f2c896bd09f1$var$empty3);
    };
};
var $a801f2c896bd09f1$var$$$delete2 = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(k2) {
        var go2 = function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Leaf) return $a801f2c896bd09f1$var$Leaf.value;
            if (v3 instanceof $a801f2c896bd09f1$var$Node) {
                var v1 = compare6(k2)(v3.value2);
                if (v1 instanceof $a801f2c896bd09f1$var$LT) return $a801f2c896bd09f1$var$unsafeBalancedNode(v3.value2, v3.value3, go2(v3.value4), v3.value5);
                if (v1 instanceof $a801f2c896bd09f1$var$GT) return $a801f2c896bd09f1$var$unsafeBalancedNode(v3.value2, v3.value3, v3.value4, go2(v3.value5));
                if (v1 instanceof $a801f2c896bd09f1$var$EQ) return $a801f2c896bd09f1$var$unsafeJoinNodes(v3.value4, v3.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 498, column 7 - line 501, column 43): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 495, column 8 - line 501, column 43): " + [
                v3.constructor.name
            ]);
        };
        return go2;
    };
};
var $a801f2c896bd09f1$var$alter = function(dictOrd) {
    var compare6 = $a801f2c896bd09f1$var$compare(dictOrd);
    return function(f2) {
        return function(k2) {
            return function(m3) {
                var v3 = $a801f2c896bd09f1$var$unsafeSplit(compare6, k2, m3);
                var v22 = f2(v3.value0);
                if (v22 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$unsafeJoinNodes(v3.value1, v3.value2);
                if (v22 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$unsafeBalancedNode(k2, v22.value0, v3.value1, v3.value2);
                throw new Error("Failed pattern match at Data.Map.Internal (line 514, column 3 - line 518, column 41): " + [
                    v22.constructor.name
                ]);
            };
        };
    };
};
// output/Data.Set/index.js
var $a801f2c896bd09f1$var$coerce3 = /* @__PURE__ */ $a801f2c896bd09f1$var$coerce();
var $a801f2c896bd09f1$var$foldMap3 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldMap($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$foldl5 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$foldr5 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldr($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$identity9 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$union3 = function(dictOrd) {
    return $a801f2c896bd09f1$var$coerce3($a801f2c896bd09f1$var$union2(dictOrd));
};
var $a801f2c896bd09f1$var$toList3 = function(v3) {
    return $a801f2c896bd09f1$var$keys2(v3);
};
var $a801f2c896bd09f1$var$toUnfoldable5 = function(dictUnfoldable) {
    var $96 = $a801f2c896bd09f1$var$toUnfoldable(dictUnfoldable);
    return function($97) {
        return $96($a801f2c896bd09f1$var$toList3($97));
    };
};
var $a801f2c896bd09f1$var$toUnfoldable12 = /* @__PURE__ */ $a801f2c896bd09f1$var$toUnfoldable5($a801f2c896bd09f1$var$unfoldableArray);
var $a801f2c896bd09f1$var$singleton8 = function(a3) {
    return $a801f2c896bd09f1$var$singleton7(a3)($a801f2c896bd09f1$var$unit);
};
var $a801f2c896bd09f1$var$showSet = function(dictShow) {
    var show40 = $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showArray(dictShow));
    return {
        show: function(s2) {
            return "(fromFoldable " + (show40($a801f2c896bd09f1$var$toUnfoldable12(s2)) + ")");
        }
    };
};
var $a801f2c896bd09f1$var$semigroupSet = function(dictOrd) {
    return {
        append: $a801f2c896bd09f1$var$union3(dictOrd)
    };
};
var $a801f2c896bd09f1$var$member2 = function(dictOrd) {
    return $a801f2c896bd09f1$var$coerce3($a801f2c896bd09f1$var$member(dictOrd));
};
var $a801f2c896bd09f1$var$insert7 = function(dictOrd) {
    var insert17 = $a801f2c896bd09f1$var$insert6(dictOrd);
    return function(a3) {
        return function(v3) {
            return insert17(a3)($a801f2c896bd09f1$var$unit)(v3);
        };
    };
};
var $a801f2c896bd09f1$var$foldableSet = {
    foldMap: function(dictMonoid) {
        var foldMap12 = $a801f2c896bd09f1$var$foldMap3(dictMonoid);
        return function(f2) {
            var $98 = foldMap12(f2);
            return function($99) {
                return $98($a801f2c896bd09f1$var$toList3($99));
            };
        };
    },
    foldl: function(f2) {
        return function(x4) {
            var $100 = $a801f2c896bd09f1$var$foldl5(f2)(x4);
            return function($101) {
                return $100($a801f2c896bd09f1$var$toList3($101));
            };
        };
    },
    foldr: function(f2) {
        return function(x4) {
            var $102 = $a801f2c896bd09f1$var$foldr5(f2)(x4);
            return function($103) {
                return $102($a801f2c896bd09f1$var$toList3($103));
            };
        };
    }
};
var $a801f2c896bd09f1$var$foldl12 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableSet);
var $a801f2c896bd09f1$var$foldr12 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldr($a801f2c896bd09f1$var$foldableSet);
var $a801f2c896bd09f1$var$eqSet = function(dictEq) {
    var eq29 = $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqMap(dictEq)($a801f2c896bd09f1$var$eqUnit));
    return {
        eq: function(v3) {
            return function(v1) {
                return eq29(v3)(v1);
            };
        }
    };
};
var $a801f2c896bd09f1$var$empty4 = $a801f2c896bd09f1$var$empty3;
var $a801f2c896bd09f1$var$fromFoldable5 = function(dictFoldable) {
    var foldl22 = $a801f2c896bd09f1$var$foldl(dictFoldable);
    return function(dictOrd) {
        var insert17 = $a801f2c896bd09f1$var$insert7(dictOrd);
        return foldl22(function(m3) {
            return function(a3) {
                return insert17(a3)(m3);
            };
        })($a801f2c896bd09f1$var$empty4);
    };
};
var $a801f2c896bd09f1$var$map18 = function(dictOrd) {
    var insert17 = $a801f2c896bd09f1$var$insert7(dictOrd);
    return function(f2) {
        return $a801f2c896bd09f1$var$foldl12(function(m3) {
            return function(a3) {
                return insert17(f2(a3))(m3);
            };
        })($a801f2c896bd09f1$var$empty4);
    };
};
var $a801f2c896bd09f1$var$mapMaybe3 = function(dictOrd) {
    var insert17 = $a801f2c896bd09f1$var$insert7(dictOrd);
    return function(f2) {
        return $a801f2c896bd09f1$var$foldr12(function(a3) {
            return function(acc) {
                return $a801f2c896bd09f1$var$maybe(acc)(function(b3) {
                    return insert17(b3)(acc);
                })(f2(a3));
            };
        })($a801f2c896bd09f1$var$empty4);
    };
};
var $a801f2c896bd09f1$var$monoidSet = function(dictOrd) {
    var semigroupSet1 = $a801f2c896bd09f1$var$semigroupSet(dictOrd);
    return {
        mempty: $a801f2c896bd09f1$var$empty4,
        Semigroup0: function() {
            return semigroupSet1;
        }
    };
};
var $a801f2c896bd09f1$var$catMaybes3 = function(dictOrd) {
    return $a801f2c896bd09f1$var$mapMaybe3(dictOrd)($a801f2c896bd09f1$var$identity9);
};
// output/Effect.Console/foreign.js
var $a801f2c896bd09f1$var$log2 = function(s2) {
    return function() {
        console.log(s2);
    };
};
var $a801f2c896bd09f1$var$warn = function(s2) {
    return function() {
        console.warn(s2);
    };
};
// output/ProtoVoices.Model/index.js
var $a801f2c896bd09f1$var$writeImpl3 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeImpl($a801f2c896bd09f1$var$writeForeignString);
var $a801f2c896bd09f1$var$append4 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$alter2 = /* @__PURE__ */ $a801f2c896bd09f1$var$alter($a801f2c896bd09f1$var$ordString);
var $a801f2c896bd09f1$var$ordTuple2 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordTuple($a801f2c896bd09f1$var$ordString)($a801f2c896bd09f1$var$ordString);
var $a801f2c896bd09f1$var$alter1 = /* @__PURE__ */ $a801f2c896bd09f1$var$alter($a801f2c896bd09f1$var$ordTuple2);
var $a801f2c896bd09f1$var$ordPitch2 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordPitch($a801f2c896bd09f1$var$ordSInterval);
var $a801f2c896bd09f1$var$compare5 = /* @__PURE__ */ $a801f2c896bd09f1$var$compare($a801f2c896bd09f1$var$ordPitch2);
var $a801f2c896bd09f1$var$map19 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$show4 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$insert8 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert6($a801f2c896bd09f1$var$ordString);
var $a801f2c896bd09f1$var$bind7 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind(/* @__PURE__ */ $a801f2c896bd09f1$var$bindExceptT($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$readImpl3 = /* @__PURE__ */ $a801f2c896bd09f1$var$readImpl($a801f2c896bd09f1$var$readString2);
var $a801f2c896bd09f1$var$pure10 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure(/* @__PURE__ */ $a801f2c896bd09f1$var$applicativeExceptT($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$fail5 = /* @__PURE__ */ $a801f2c896bd09f1$var$fail($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$alt5 = /* @__PURE__ */ $a801f2c896bd09f1$var$alt(/* @__PURE__ */ $a801f2c896bd09f1$var$altExceptT($a801f2c896bd09f1$var$semigroupNonEmptyList)($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$map110 = /* @__PURE__ */ $a801f2c896bd09f1$var$map(/* @__PURE__ */ $a801f2c896bd09f1$var$functorExceptT($a801f2c896bd09f1$var$functorIdentity));
var $a801f2c896bd09f1$var$eq14 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqPitch($a801f2c896bd09f1$var$eqSIC));
var $a801f2c896bd09f1$var$pc2 = /* @__PURE__ */ $a801f2c896bd09f1$var$pc($a801f2c896bd09f1$var$hasIntervalClassSInterval);
var $a801f2c896bd09f1$var$add2 = /* @__PURE__ */ $a801f2c896bd09f1$var$add($a801f2c896bd09f1$var$semiringInt);
var $a801f2c896bd09f1$var$genericShowConstructor2 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsNoArguments);
var $a801f2c896bd09f1$var$genericShowSum2 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "NoParents";
    }
}));
var $a801f2c896bd09f1$var$VertParentIsSymbol = {
    reflectSymbol: function() {
        return "VertParent";
    }
};
var $a801f2c896bd09f1$var$showRecord2 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord()();
var $a801f2c896bd09f1$var$leftIsSymbol = {
    reflectSymbol: function() {
        return "left";
    }
};
var $a801f2c896bd09f1$var$showRecordFieldsCons2 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$leftIsSymbol);
var $a801f2c896bd09f1$var$rightIsSymbol = {
    reflectSymbol: function() {
        return "right";
    }
};
var $a801f2c896bd09f1$var$showRecordFieldsConsNil2 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$rightIsSymbol);
var $a801f2c896bd09f1$var$MergeParentsIsSymbol = {
    reflectSymbol: function() {
        return "MergeParents";
    }
};
var $a801f2c896bd09f1$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $a801f2c896bd09f1$var$showRecordFieldsCons1 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$idIsSymbol);
var $a801f2c896bd09f1$var$pitchIsSymbol = {
    reflectSymbol: function() {
        return "pitch";
    }
};
var $a801f2c896bd09f1$var$showRecord1 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons1(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$pitchIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval)))($a801f2c896bd09f1$var$showString));
var $a801f2c896bd09f1$var$showRecordFieldsCons22 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "leftParent";
    }
});
var $a801f2c896bd09f1$var$ornIsSymbol = {
    reflectSymbol: function() {
        return "orn";
    }
};
var $a801f2c896bd09f1$var$showRecordFieldsCons3 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$ornIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "rightParent";
    }
})($a801f2c896bd09f1$var$showRecord1));
var $a801f2c896bd09f1$var$discard3 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit);
var $a801f2c896bd09f1$var$passingIsSymbol = {
    reflectSymbol: function() {
        return "passing";
    }
};
var $a801f2c896bd09f1$var$regularIsSymbol = {
    reflectSymbol: function() {
        return "regular";
    }
};
var $a801f2c896bd09f1$var$explIsSymbol = {
    reflectSymbol: function() {
        return "expl";
    }
};
var $a801f2c896bd09f1$var$noteIsSymbol = {
    reflectSymbol: function() {
        return "note";
    }
};
var $a801f2c896bd09f1$var$genericShowSum1 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "Freeze";
    }
}));
var $a801f2c896bd09f1$var$showRecordFieldsCons4 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "childl";
    }
});
var $a801f2c896bd09f1$var$showRecordFieldsConsNil1 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "childr";
    }
});
var $a801f2c896bd09f1$var$showRecordFieldsCons5 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "op";
    }
});
var $a801f2c896bd09f1$var$SplitIsSymbol = {
    reflectSymbol: function() {
        return "Split";
    }
};
var $a801f2c896bd09f1$var$showRecordFieldsCons6 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "childm";
    }
});
var $a801f2c896bd09f1$var$HoriIsSymbol = {
    reflectSymbol: function() {
        return "Hori";
    }
};
var $a801f2c896bd09f1$var$isStep2 = /* @__PURE__ */ $a801f2c896bd09f1$var$isStep($a801f2c896bd09f1$var$diatonicSIC);
var $a801f2c896bd09f1$var$ic2 = /* @__PURE__ */ $a801f2c896bd09f1$var$ic($a801f2c896bd09f1$var$hasIntervalClassSInterval);
var $a801f2c896bd09f1$var$pto2 = /* @__PURE__ */ $a801f2c896bd09f1$var$pto($a801f2c896bd09f1$var$intervalSInterval);
var $a801f2c896bd09f1$var$degree3 = /* @__PURE__ */ $a801f2c896bd09f1$var$degree2(/* @__PURE__ */ $a801f2c896bd09f1$var$spelledPitch($a801f2c896bd09f1$var$spelledSIC)($a801f2c896bd09f1$var$hasIntervalClassSICSIC)($a801f2c896bd09f1$var$spelledSIC));
var $a801f2c896bd09f1$var$notEq3 = /* @__PURE__ */ $a801f2c896bd09f1$var$notEq($a801f2c896bd09f1$var$eqOrdering);
var $a801f2c896bd09f1$var$direction2 = /* @__PURE__ */ $a801f2c896bd09f1$var$direction($a801f2c896bd09f1$var$intervalSIC);
var $a801f2c896bd09f1$var$compare13 = /* @__PURE__ */ $a801f2c896bd09f1$var$compare($a801f2c896bd09f1$var$ordSIC);
var $a801f2c896bd09f1$var$unison2 = /* @__PURE__ */ $a801f2c896bd09f1$var$unison($a801f2c896bd09f1$var$intervalSIC);
var $a801f2c896bd09f1$var$ordRecord2 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord();
var $a801f2c896bd09f1$var$ordRecordCons2 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons($a801f2c896bd09f1$var$ordRecordNil)();
var $a801f2c896bd09f1$var$scanl3 = /* @__PURE__ */ $a801f2c896bd09f1$var$scanl($a801f2c896bd09f1$var$traversableArray);
var $a801f2c896bd09f1$var$fromFoldable6 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$eqPitch2 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqPitch($a801f2c896bd09f1$var$eqSInterval);
var $a801f2c896bd09f1$var$eq4 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqPitch2);
var $a801f2c896bd09f1$var$eqRec3 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec();
var $a801f2c896bd09f1$var$eqRowCons2 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons($a801f2c896bd09f1$var$eqRowNil)();
var $a801f2c896bd09f1$var$eqRec1 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec3(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons2($a801f2c896bd09f1$var$pitchIsSymbol)($a801f2c896bd09f1$var$eqPitch2))()($a801f2c896bd09f1$var$idIsSymbol)($a801f2c896bd09f1$var$eqString));
var $a801f2c896bd09f1$var$bind12 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindArray);
var $a801f2c896bd09f1$var$pure12 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeArray);
var $a801f2c896bd09f1$var$bind22 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$pure22 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeMaybe);
var $a801f2c896bd09f1$var$foldl6 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$lookup4 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordString);
var $a801f2c896bd09f1$var$bind32 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindEither);
var $a801f2c896bd09f1$var$pure32 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$discard22 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard3($a801f2c896bd09f1$var$bindEither);
var $a801f2c896bd09f1$var$show13 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showString);
var $a801f2c896bd09f1$var$map32 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEither);
var $a801f2c896bd09f1$var$append22 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupList);
var $a801f2c896bd09f1$var$all4 = /* @__PURE__ */ $a801f2c896bd09f1$var$all($a801f2c896bd09f1$var$foldableSet)($a801f2c896bd09f1$var$heytingAlgebraBoolean);
var $a801f2c896bd09f1$var$toUnfoldable13 = /* @__PURE__ */ $a801f2c896bd09f1$var$toUnfoldable4($a801f2c896bd09f1$var$unfoldableArray);
var $a801f2c896bd09f1$var$insertWith2 = /* @__PURE__ */ $a801f2c896bd09f1$var$insertWith($a801f2c896bd09f1$var$ordPitch2);
var $a801f2c896bd09f1$var$unionWith2 = /* @__PURE__ */ $a801f2c896bd09f1$var$unionWith($a801f2c896bd09f1$var$ordPitch2);
var $a801f2c896bd09f1$var$max3 = /* @__PURE__ */ $a801f2c896bd09f1$var$max($a801f2c896bd09f1$var$ordInt);
var $a801f2c896bd09f1$var$map42 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$TransId = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$Start = /* @__PURE__ */ function() {
    function Start2() {}
    Start2.value = new Start2();
    return Start2;
}();
var $a801f2c896bd09f1$var$Inner = /* @__PURE__ */ function() {
    function Inner2(value0) {
        this.value0 = value0;
    }
    Inner2.create = function(value0) {
        return new Inner2(value0);
    };
    return Inner2;
}();
var $a801f2c896bd09f1$var$Stop = /* @__PURE__ */ function() {
    function Stop2() {}
    Stop2.value = new Stop2();
    return Stop2;
}();
var $a801f2c896bd09f1$var$TrebleStaff = /* @__PURE__ */ function() {
    function TrebleStaff2() {}
    TrebleStaff2.value = new TrebleStaff2();
    return TrebleStaff2;
}();
var $a801f2c896bd09f1$var$BassStaff = /* @__PURE__ */ function() {
    function BassStaff2() {}
    BassStaff2.value = new BassStaff2();
    return BassStaff2;
}();
var $a801f2c896bd09f1$var$GrandStaff = /* @__PURE__ */ function() {
    function GrandStaff2() {}
    GrandStaff2.value = new GrandStaff2();
    return GrandStaff2;
}();
var $a801f2c896bd09f1$var$SliceId = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$RightRepeat = /* @__PURE__ */ function() {
    function RightRepeat2() {}
    RightRepeat2.value = new RightRepeat2();
    return RightRepeat2;
}();
var $a801f2c896bd09f1$var$RightNeighbor = /* @__PURE__ */ function() {
    function RightNeighbor2() {}
    RightNeighbor2.value = new RightNeighbor2();
    return RightNeighbor2;
}();
var $a801f2c896bd09f1$var$NoParents = /* @__PURE__ */ function() {
    function NoParents2() {}
    NoParents2.value = new NoParents2();
    return NoParents2;
}();
var $a801f2c896bd09f1$var$VertParent = /* @__PURE__ */ function() {
    function VertParent2(value0) {
        this.value0 = value0;
    }
    VertParent2.create = function(value0) {
        return new VertParent2(value0);
    };
    return VertParent2;
}();
var $a801f2c896bd09f1$var$MergeParents = /* @__PURE__ */ function() {
    function MergeParents2(value0) {
        this.value0 = value0;
    }
    MergeParents2.create = function(value0) {
        return new MergeParents2(value0);
    };
    return MergeParents2;
}();
var $a801f2c896bd09f1$var$LeftRepeat = /* @__PURE__ */ function() {
    function LeftRepeat2() {}
    LeftRepeat2.value = new LeftRepeat2();
    return LeftRepeat2;
}();
var $a801f2c896bd09f1$var$LeftNeighbor = /* @__PURE__ */ function() {
    function LeftNeighbor2() {}
    LeftNeighbor2.value = new LeftNeighbor2();
    return LeftNeighbor2;
}();
var $a801f2c896bd09f1$var$FullNeighbor = /* @__PURE__ */ function() {
    function FullNeighbor2() {}
    FullNeighbor2.value = new FullNeighbor2();
    return FullNeighbor2;
}();
var $a801f2c896bd09f1$var$FullRepeat = /* @__PURE__ */ function() {
    function FullRepeat2() {}
    FullRepeat2.value = new FullRepeat2();
    return FullRepeat2;
}();
var $a801f2c896bd09f1$var$LeftRepeatOfRight = /* @__PURE__ */ function() {
    function LeftRepeatOfRight2() {}
    LeftRepeatOfRight2.value = new LeftRepeatOfRight2();
    return LeftRepeatOfRight2;
}();
var $a801f2c896bd09f1$var$RightRepeatOfLeft = /* @__PURE__ */ function() {
    function RightRepeatOfLeft2() {}
    RightRepeatOfLeft2.value = new RightRepeatOfLeft2();
    return RightRepeatOfLeft2;
}();
var $a801f2c896bd09f1$var$PassingMid = /* @__PURE__ */ function() {
    function PassingMid2() {}
    PassingMid2.value = new PassingMid2();
    return PassingMid2;
}();
var $a801f2c896bd09f1$var$PassingLeft = /* @__PURE__ */ function() {
    function PassingLeft2() {}
    PassingLeft2.value = new PassingLeft2();
    return PassingLeft2;
}();
var $a801f2c896bd09f1$var$PassingRight = /* @__PURE__ */ function() {
    function PassingRight2() {}
    PassingRight2.value = new PassingRight2();
    return PassingRight2;
}();
var $a801f2c896bd09f1$var$NoExpl = /* @__PURE__ */ function() {
    function NoExpl2() {}
    NoExpl2.value = new NoExpl2();
    return NoExpl2;
}();
var $a801f2c896bd09f1$var$RootExpl = /* @__PURE__ */ function() {
    function RootExpl2() {}
    RootExpl2.value = new RootExpl2();
    return RootExpl2;
}();
var $a801f2c896bd09f1$var$HoriExpl = /* @__PURE__ */ function() {
    function HoriExpl2(value0) {
        this.value0 = value0;
    }
    HoriExpl2.create = function(value0) {
        return new HoriExpl2(value0);
    };
    return HoriExpl2;
}();
var $a801f2c896bd09f1$var$RightExpl = /* @__PURE__ */ function() {
    function RightExpl2(value0) {
        this.value0 = value0;
    }
    RightExpl2.create = function(value0) {
        return new RightExpl2(value0);
    };
    return RightExpl2;
}();
var $a801f2c896bd09f1$var$LeftExpl = /* @__PURE__ */ function() {
    function LeftExpl2(value0) {
        this.value0 = value0;
    }
    LeftExpl2.create = function(value0) {
        return new LeftExpl2(value0);
    };
    return LeftExpl2;
}();
var $a801f2c896bd09f1$var$DoubleExpl = /* @__PURE__ */ function() {
    function DoubleExpl2(value0) {
        this.value0 = value0;
    }
    DoubleExpl2.create = function(value0) {
        return new DoubleExpl2(value0);
    };
    return DoubleExpl2;
}();
var $a801f2c896bd09f1$var$Freeze = /* @__PURE__ */ function() {
    function Freeze3() {}
    Freeze3.value = new Freeze3();
    return Freeze3;
}();
var $a801f2c896bd09f1$var$Split2 = /* @__PURE__ */ function() {
    function Split3(value0) {
        this.value0 = value0;
    }
    Split3.create = function(value0) {
        return new Split3(value0);
    };
    return Split3;
}();
var $a801f2c896bd09f1$var$Hori = /* @__PURE__ */ function() {
    function Hori2(value0) {
        this.value0 = value0;
    }
    Hori2.create = function(value0) {
        return new Hori2(value0);
    };
    return Hori2;
}();
var $a801f2c896bd09f1$var$writeForeignTransId = $a801f2c896bd09f1$var$writeForeignInt;
var $a801f2c896bd09f1$var$writeForeignStartStop = function(dictWriteForeign) {
    var writeImpl1 = $a801f2c896bd09f1$var$writeImpl(dictWriteForeign);
    return {
        writeImpl: function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Start) return $a801f2c896bd09f1$var$writeImpl3("start");
            if (v3 instanceof $a801f2c896bd09f1$var$Stop) return $a801f2c896bd09f1$var$writeImpl3("stop");
            if (v3 instanceof $a801f2c896bd09f1$var$Inner) return writeImpl1(v3.value0);
            throw new Error("Failed pattern match at ProtoVoices.Model (line 292, column 15 - line 295, column 27): " + [
                v3.constructor.name
            ]);
        }
    };
};
var $a801f2c896bd09f1$var$writeForeignSliceId = $a801f2c896bd09f1$var$writeForeignInt;
var $a801f2c896bd09f1$var$stylesUpdateNote = function(f2) {
    return function(id4) {
        return function(styles) {
            return {
                edges: styles.edges,
                slices: styles.slices,
                transitions: styles.transitions,
                css: styles.css,
                staff: styles.staff,
                notes: $a801f2c896bd09f1$var$alter2(f2)(id4)(styles.notes)
            };
        };
    };
};
var $a801f2c896bd09f1$var$stylesUpdateEdge = function(f2) {
    return function(id4) {
        return function(styles) {
            return {
                notes: styles.notes,
                slices: styles.slices,
                transitions: styles.transitions,
                css: styles.css,
                staff: styles.staff,
                edges: $a801f2c896bd09f1$var$alter1(f2)(id4)(styles.edges)
            };
        };
    };
};
var $a801f2c896bd09f1$var$startSlice = /* @__PURE__ */ function() {
    return {
        id: 0,
        notes: $a801f2c896bd09f1$var$Start.value,
        x: 0,
        parents: $a801f2c896bd09f1$var$NoParents.value
    };
}();
var $a801f2c896bd09f1$var$staffType2JS = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$GrandStaff) return "grand";
    if (v3 instanceof $a801f2c896bd09f1$var$TrebleStaff) return "treble";
    if (v3 instanceof $a801f2c896bd09f1$var$BassStaff) return "bass";
    throw new Error("Failed pattern match at ProtoVoices.Model (line 489, column 16 - line 492, column 22): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$sortNotes = /* @__PURE__ */ $a801f2c896bd09f1$var$sortBy2(function(a3) {
    return function(b3) {
        return $a801f2c896bd09f1$var$invert($a801f2c896bd09f1$var$compare5(a3.note.pitch)(b3.note.pitch));
    };
});
var $a801f2c896bd09f1$var$thawSlice = function(slice4) {
    return function(id4) {
        return {
            id: id4,
            notes: new $a801f2c896bd09f1$var$Inner($a801f2c896bd09f1$var$map19(function(n) {
                return {
                    note: n.note,
                    expl: $a801f2c896bd09f1$var$NoExpl.value
                };
            })($a801f2c896bd09f1$var$sortNotes(slice4))),
            x: $a801f2c896bd09f1$var$toNumber(id4),
            parents: $a801f2c896bd09f1$var$NoParents.value
        };
    };
};
var $a801f2c896bd09f1$var$showTransId = {
    show: function(v3) {
        return "t" + $a801f2c896bd09f1$var$show4(v3);
    }
};
var $a801f2c896bd09f1$var$show24 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showTransId);
var $a801f2c896bd09f1$var$showStartStop = function(dictShow) {
    var show72 = $a801f2c896bd09f1$var$show(dictShow);
    return {
        show: function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Start) return "\u22CA";
            if (v3 instanceof $a801f2c896bd09f1$var$Stop) return "\u22C9";
            if (v3 instanceof $a801f2c896bd09f1$var$Inner) return show72(v3.value0);
            throw new Error("Failed pattern match at ProtoVoices.Model (line 286, column 1 - line 289, column 26): " + [
                v3.constructor.name
            ]);
        }
    };
};
var $a801f2c896bd09f1$var$showStartStop1 = /* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop($a801f2c896bd09f1$var$showRecord1);
var $a801f2c896bd09f1$var$showRecord22 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil2($a801f2c896bd09f1$var$showStartStop1))($a801f2c896bd09f1$var$showStartStop1));
var $a801f2c896bd09f1$var$showRecord3 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "edges";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons1(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "is2nd";
    }
})($a801f2c896bd09f1$var$showBoolean))($a801f2c896bd09f1$var$showTransId))(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$passingIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$regularIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showSet($a801f2c896bd09f1$var$showRecord22)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray($a801f2c896bd09f1$var$showRecord22)))));
var $a801f2c896bd09f1$var$showRecordFieldsConsNil22 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "trans";
    }
})($a801f2c896bd09f1$var$showRecord3);
var $a801f2c896bd09f1$var$showRecordFieldsCons7 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons5($a801f2c896bd09f1$var$showRecordFieldsConsNil22);
var $a801f2c896bd09f1$var$show42 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showStartStop1);
var $a801f2c896bd09f1$var$showSliceId = {
    show: function(v3) {
        return "s" + $a801f2c896bd09f1$var$show4(v3);
    }
};
var $a801f2c896bd09f1$var$show5 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showSliceId);
var $a801f2c896bd09f1$var$setHoriExplParent = function(_child) {
    return function(parentMaybe) {
        return function(expl) {
            if (parentMaybe instanceof $a801f2c896bd09f1$var$Just) {
                if (expl instanceof $a801f2c896bd09f1$var$NoExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$HoriExpl(parentMaybe.value0));
                if (expl instanceof $a801f2c896bd09f1$var$HoriExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$HoriExpl(parentMaybe.value0));
                return $a801f2c896bd09f1$var$Nothing.value;
            }
            if (parentMaybe instanceof $a801f2c896bd09f1$var$Nothing) {
                if (expl instanceof $a801f2c896bd09f1$var$HoriExpl) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NoExpl.value);
                if (expl instanceof $a801f2c896bd09f1$var$NoExpl) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NoExpl.value);
                return $a801f2c896bd09f1$var$Nothing.value;
            }
            throw new Error("Failed pattern match at ProtoVoices.Model (line 242, column 45 - line 250, column 17): " + [
                parentMaybe.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$readForeignTransId = $a801f2c896bd09f1$var$readInt2;
var $a801f2c896bd09f1$var$readForeignStartStop = function(dictReadForeign) {
    var readImpl12 = $a801f2c896bd09f1$var$readImpl(dictReadForeign);
    return {
        readImpl: function(frgn) {
            var tryOuter = $a801f2c896bd09f1$var$bind7($a801f2c896bd09f1$var$readImpl3(frgn))(function(str) {
                if (str === "start") return $a801f2c896bd09f1$var$pure10($a801f2c896bd09f1$var$Start.value);
                if (str === "stop") return $a801f2c896bd09f1$var$pure10($a801f2c896bd09f1$var$Stop.value);
                return $a801f2c896bd09f1$var$fail5(new $a801f2c896bd09f1$var$ForeignError("StartStop is neither Start nor Stop!"));
            });
            return $a801f2c896bd09f1$var$alt5(tryOuter)($a801f2c896bd09f1$var$map110($a801f2c896bd09f1$var$Inner.create)(readImpl12(frgn)));
        }
    };
};
var $a801f2c896bd09f1$var$readForeignSliceId = $a801f2c896bd09f1$var$readInt2;
var $a801f2c896bd09f1$var$ordTransId = $a801f2c896bd09f1$var$ordInt;
var $a801f2c896bd09f1$var$alter22 = /* @__PURE__ */ $a801f2c896bd09f1$var$alter($a801f2c896bd09f1$var$ordTransId);
var $a801f2c896bd09f1$var$stylesUpdateTrans = function(f2) {
    return function(id4) {
        return function(styles) {
            return {
                notes: styles.notes,
                edges: styles.edges,
                slices: styles.slices,
                css: styles.css,
                staff: styles.staff,
                transitions: $a801f2c896bd09f1$var$alter22(f2)(id4)(styles.transitions)
            };
        };
    };
};
var $a801f2c896bd09f1$var$ordSliceId = $a801f2c896bd09f1$var$ordInt;
var $a801f2c896bd09f1$var$alter3 = /* @__PURE__ */ $a801f2c896bd09f1$var$alter($a801f2c896bd09f1$var$ordSliceId);
var $a801f2c896bd09f1$var$stylesUpdateSlice = function(f2) {
    return function(id4) {
        return function(styles) {
            return {
                notes: styles.notes,
                edges: styles.edges,
                transitions: styles.transitions,
                css: styles.css,
                staff: styles.staff,
                slices: $a801f2c896bd09f1$var$alter3(f2)(id4)(styles.slices)
            };
        };
    };
};
var $a801f2c896bd09f1$var$isRepeatingEdge = function(v3) {
    if (v3.left instanceof $a801f2c896bd09f1$var$Inner && v3.right instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$eq14($a801f2c896bd09f1$var$pc2(v3.left.value0.pitch))($a801f2c896bd09f1$var$pc2(v3.right.value0.pitch));
    return false;
};
var $a801f2c896bd09f1$var$incT = function(v3) {
    return v3 + 1 | 0;
};
var $a801f2c896bd09f1$var$incS = function(v3) {
    return v3 + 1 | 0;
};
var $a801f2c896bd09f1$var$getParents = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$NoParents) return [];
    if (v3 instanceof $a801f2c896bd09f1$var$VertParent) return [
        v3.value0
    ];
    if (v3 instanceof $a801f2c896bd09f1$var$MergeParents) return [
        v3.value0.left,
        v3.value0.right
    ];
    throw new Error("Failed pattern match at ProtoVoices.Model (line 385, column 14 - line 388, column 50): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$getInnerNotes = function(slice4) {
    if (slice4.notes instanceof $a801f2c896bd09f1$var$Start) return [];
    if (slice4.notes instanceof $a801f2c896bd09f1$var$Stop) return [];
    if (slice4.notes instanceof $a801f2c896bd09f1$var$Inner) return slice4.notes.value0;
    throw new Error("Failed pattern match at ProtoVoices.Model (line 398, column 23 - line 401, column 23): " + [
        slice4.notes.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$getInner = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$Inner) return new $a801f2c896bd09f1$var$Just(v3.value0);
    return $a801f2c896bd09f1$var$Nothing.value;
};
var $a801f2c896bd09f1$var$genericStaff = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$TrebleStaff.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$BassStaff.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr) return $a801f2c896bd09f1$var$GrandStaff.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 482, column 1 - line 482, column 48): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$TrebleStaff) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$BassStaff) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value));
        if (x4 instanceof $a801f2c896bd09f1$var$GrandStaff) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr($a801f2c896bd09f1$var$NoArguments.value));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 482, column 1 - line 482, column 48): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$showStaff = {
    show: /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericStaff)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
        reflectSymbol: function() {
            return "TrebleStaff";
        }
    }))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
        reflectSymbol: function() {
            return "BassStaff";
        }
    }))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
        reflectSymbol: function() {
            return "GrandStaff";
        }
    }))))
};
var $a801f2c896bd09f1$var$genericRightOrnament = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$RightRepeat.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr) return $a801f2c896bd09f1$var$RightNeighbor.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 47, column 1 - line 47, column 64): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$RightRepeat) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$RightNeighbor) return new $a801f2c896bd09f1$var$Inr($a801f2c896bd09f1$var$NoArguments.value);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 47, column 1 - line 47, column 64): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow2 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericRightOrnament)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "RightRepeat";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "RightNeighbor";
    }
})));
var $a801f2c896bd09f1$var$showRightOrnament = {
    show: function(ro) {
        return $a801f2c896bd09f1$var$genericShow2(ro);
    }
};
var $a801f2c896bd09f1$var$genericParents = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$NoParents.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$VertParent(x4.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr) return new $a801f2c896bd09f1$var$MergeParents(x4.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 379, column 1 - line 379, column 56): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$NoParents) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$VertParent) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0));
        if (x4 instanceof $a801f2c896bd09f1$var$MergeParents) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(x4.value0));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 379, column 1 - line 379, column 56): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow1 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericParents);
var $a801f2c896bd09f1$var$showParents = function(dictShow) {
    var genericShow62 = $a801f2c896bd09f1$var$genericShow1($a801f2c896bd09f1$var$genericShowSum2($a801f2c896bd09f1$var$genericShowSum($a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsArgument(dictShow))($a801f2c896bd09f1$var$VertParentIsSymbol))($a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsArgument($a801f2c896bd09f1$var$showRecord2($a801f2c896bd09f1$var$showRecordFieldsCons2($a801f2c896bd09f1$var$showRecordFieldsConsNil2(dictShow))(dictShow))))($a801f2c896bd09f1$var$MergeParentsIsSymbol))));
    return {
        show: function(p3) {
            return genericShow62(p3);
        }
    };
};
var $a801f2c896bd09f1$var$genericOp = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$Freeze.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$Split2(x4.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr) return new $a801f2c896bd09f1$var$Hori(x4.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 422, column 1 - line 422, column 42): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Freeze) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$Split2) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0));
        if (x4 instanceof $a801f2c896bd09f1$var$Hori) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(x4.value0));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 422, column 1 - line 422, column 42): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow22 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericOp);
var $a801f2c896bd09f1$var$genericNoteExplanation = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$NoExpl.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$RootExpl.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$HoriExpl(x4.value0.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$RightExpl(x4.value0.value0.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$LeftExpl(x4.value0.value0.value0.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr) return new $a801f2c896bd09f1$var$DoubleExpl(x4.value0.value0.value0.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 89, column 1 - line 89, column 68): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$NoExpl) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$RootExpl) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value));
        if (x4 instanceof $a801f2c896bd09f1$var$HoriExpl) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0)));
        if (x4 instanceof $a801f2c896bd09f1$var$RightExpl) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0))));
        if (x4 instanceof $a801f2c896bd09f1$var$LeftExpl) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0)))));
        if (x4 instanceof $a801f2c896bd09f1$var$DoubleExpl) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(x4.value0)))));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 89, column 1 - line 89, column 68): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericLeftOrnament = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$LeftRepeat.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr) return $a801f2c896bd09f1$var$LeftNeighbor.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 58, column 1 - line 58, column 62): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$LeftRepeat) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$LeftNeighbor) return new $a801f2c896bd09f1$var$Inr($a801f2c896bd09f1$var$NoArguments.value);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 58, column 1 - line 58, column 62): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow3 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericLeftOrnament)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "LeftRepeat";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "LeftNeighbor";
    }
})));
var $a801f2c896bd09f1$var$showLeftOrnament = {
    show: function(lo) {
        return $a801f2c896bd09f1$var$genericShow3(lo);
    }
};
var $a801f2c896bd09f1$var$genericDoubleOrnament = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$FullNeighbor.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$FullRepeat.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$LeftRepeatOfRight.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$RightRepeatOfLeft.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$PassingMid.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$PassingLeft.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr) return $a801f2c896bd09f1$var$PassingRight.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 74, column 1 - line 74, column 66): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$FullNeighbor) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$FullRepeat) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value));
        if (x4 instanceof $a801f2c896bd09f1$var$LeftRepeatOfRight) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value)));
        if (x4 instanceof $a801f2c896bd09f1$var$RightRepeatOfLeft) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value))));
        if (x4 instanceof $a801f2c896bd09f1$var$PassingMid) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value)))));
        if (x4 instanceof $a801f2c896bd09f1$var$PassingLeft) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value))))));
        if (x4 instanceof $a801f2c896bd09f1$var$PassingRight) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr($a801f2c896bd09f1$var$NoArguments.value))))));
        throw new Error("Failed pattern match at ProtoVoices.Model (line 74, column 1 - line 74, column 66): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow4 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericDoubleOrnament)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "FullNeighbor";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "FullRepeat";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "LeftRepeatOfRight";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "RightRepeatOfLeft";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "PassingMid";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "PassingLeft";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "PassingRight";
    }
}))))))));
var $a801f2c896bd09f1$var$showDoubleOrnament = {
    show: function(o2) {
        return $a801f2c896bd09f1$var$genericShow4(o2);
    }
};
var $a801f2c896bd09f1$var$genericShow5 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericNoteExplanation)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "NoExpl";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor2({
    reflectSymbol: function() {
        return "RootExpl";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument($a801f2c896bd09f1$var$showRecord1))({
    reflectSymbol: function() {
        return "HoriExpl";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons22(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$ornIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showMaybe($a801f2c896bd09f1$var$showRightOrnament)))($a801f2c896bd09f1$var$showRecord1))))({
    reflectSymbol: function() {
        return "RightExpl";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons3(/* @__PURE__ */ $a801f2c896bd09f1$var$showMaybe($a801f2c896bd09f1$var$showLeftOrnament)))))({
    reflectSymbol: function() {
        return "LeftExpl";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons22(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons3(/* @__PURE__ */ $a801f2c896bd09f1$var$showMaybe($a801f2c896bd09f1$var$showDoubleOrnament)))($a801f2c896bd09f1$var$showRecord1))))({
    reflectSymbol: function() {
        return "DoubleExpl";
    }
})))))));
var $a801f2c896bd09f1$var$showNoteExplanation = {
    show: function(o2) {
        return $a801f2c896bd09f1$var$genericShow5(o2);
    }
};
var $a801f2c896bd09f1$var$showRecord4 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons1(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "notes";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "parents";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "x";
    }
})($a801f2c896bd09f1$var$showNumber))(/* @__PURE__ */ $a801f2c896bd09f1$var$showParents($a801f2c896bd09f1$var$showSliceId)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$explIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$noteIsSymbol)($a801f2c896bd09f1$var$showRecord1))($a801f2c896bd09f1$var$showNoteExplanation))))))($a801f2c896bd09f1$var$showSliceId));
var $a801f2c896bd09f1$var$showRecordFieldsCons8 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons5(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "rslice";
    }
})($a801f2c896bd09f1$var$showRecordFieldsConsNil22)($a801f2c896bd09f1$var$showRecord4));
var $a801f2c896bd09f1$var$show6 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showRecord4);
var $a801f2c896bd09f1$var$showOp = {
    show: function(x4) {
        return $a801f2c896bd09f1$var$genericShow22($a801f2c896bd09f1$var$genericShowSum1($a801f2c896bd09f1$var$genericShowSum($a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsArgument($a801f2c896bd09f1$var$showRecord2($a801f2c896bd09f1$var$showRecordFieldsCons4($a801f2c896bd09f1$var$showRecordFieldsConsNil1($a801f2c896bd09f1$var$showRecord2($a801f2c896bd09f1$var$showRecordFieldsCons7($a801f2c896bd09f1$var$showOp))))($a801f2c896bd09f1$var$showRecord2($a801f2c896bd09f1$var$showRecordFieldsCons8($a801f2c896bd09f1$var$showOp))))))($a801f2c896bd09f1$var$SplitIsSymbol))($a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsArgument($a801f2c896bd09f1$var$showRecord2($a801f2c896bd09f1$var$showRecordFieldsCons4($a801f2c896bd09f1$var$showRecordFieldsCons6($a801f2c896bd09f1$var$showRecordFieldsConsNil1($a801f2c896bd09f1$var$showRecord2($a801f2c896bd09f1$var$showRecordFieldsCons7($a801f2c896bd09f1$var$showOp))))($a801f2c896bd09f1$var$showRecord2($a801f2c896bd09f1$var$showRecordFieldsCons8($a801f2c896bd09f1$var$showOp))))($a801f2c896bd09f1$var$showRecord2($a801f2c896bd09f1$var$showRecordFieldsCons8($a801f2c896bd09f1$var$showOp))))))($a801f2c896bd09f1$var$HoriIsSymbol))))(x4);
    }
};
var $a801f2c896bd09f1$var$functorStartStop = {
    map: function(f2) {
        return function(m3) {
            if (m3 instanceof $a801f2c896bd09f1$var$Start) return $a801f2c896bd09f1$var$Start.value;
            if (m3 instanceof $a801f2c896bd09f1$var$Inner) return new $a801f2c896bd09f1$var$Inner(f2(m3.value0));
            if (m3 instanceof $a801f2c896bd09f1$var$Stop) return $a801f2c896bd09f1$var$Stop.value;
            throw new Error("Failed pattern match at ProtoVoices.Model (line 0, column 0 - line 0, column 0): " + [
                m3.constructor.name
            ]);
        };
    }
};
var $a801f2c896bd09f1$var$map52 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorStartStop);
var $a801f2c896bd09f1$var$resetExpls = function(seg) {
    return {
        trans: seg.trans,
        op: seg.op,
        rslice: {
            id: seg.rslice.id,
            x: seg.rslice.x,
            parents: seg.rslice.parents,
            notes: $a801f2c896bd09f1$var$map52($a801f2c896bd09f1$var$map19(function(note2) {
                return {
                    note: note2.note,
                    expl: $a801f2c896bd09f1$var$NoExpl.value
                };
            }))(seg.rslice.notes)
        }
    };
};
var $a801f2c896bd09f1$var$findRightOrn = function(child) {
    return function(v3) {
        if ($a801f2c896bd09f1$var$eq14($a801f2c896bd09f1$var$pc2(child))($a801f2c896bd09f1$var$pc2(v3.pitch))) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$RightRepeat.value);
        if ($a801f2c896bd09f1$var$isStep2($a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v3.pitch)))) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$RightNeighbor.value);
        if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$Nothing.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 152, column 1 - line 152, column 54): " + [
            child.constructor.name,
            v3.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$findLeftOrn = function(child) {
    return function(v3) {
        if ($a801f2c896bd09f1$var$eq14($a801f2c896bd09f1$var$pc2(child))($a801f2c896bd09f1$var$pc2(v3.pitch))) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$LeftRepeat.value);
        if ($a801f2c896bd09f1$var$isStep2($a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v3.pitch)))) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$LeftNeighbor.value);
        if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$Nothing.value;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 146, column 1 - line 146, column 52): " + [
            child.constructor.name,
            v3.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$findDoubleOrn = function(child) {
    return function(v3) {
        return function(v1) {
            var v22 = function(v32) {
                var v4 = function(v5) {
                    var v6 = function(v7) {
                        var v8 = function(v9) {
                            var v10 = function(v11) {
                                var v12 = function(v13) {
                                    if ($a801f2c896bd09f1$var$otherwise) {
                                        var $826 = $a801f2c896bd09f1$var$isStep2($a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v3.pitch)));
                                        if ($826) {
                                            var $827 = $a801f2c896bd09f1$var$isStep2($a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v1.pitch)));
                                            if ($827) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingMid.value);
                                            return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingLeft.value);
                                        }
                                        var $828 = $a801f2c896bd09f1$var$isStep2($a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v1.pitch)));
                                        if ($828) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingRight.value);
                                        return $a801f2c896bd09f1$var$Nothing.value;
                                    }
                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 167, column 1 - line 167, column 64): " + [
                                        child.constructor.name,
                                        v3.constructor.name,
                                        v1.constructor.name
                                    ]);
                                };
                                var $834 = $a801f2c896bd09f1$var$degree3($a801f2c896bd09f1$var$pc2(v3.pitch)) === $a801f2c896bd09f1$var$degree3($a801f2c896bd09f1$var$pc2(v1.pitch));
                                if ($834) {
                                    var $835 = $a801f2c896bd09f1$var$isStep2($a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v3.pitch)));
                                    if ($835) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$FullNeighbor.value);
                                    return v12(true);
                                }
                                return v12(true);
                            };
                            var $841 = $a801f2c896bd09f1$var$degree3($a801f2c896bd09f1$var$pc2(child)) === $a801f2c896bd09f1$var$degree3($a801f2c896bd09f1$var$pc2(v1.pitch));
                            if ($841) {
                                var $842 = $a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(v3.pitch)(child));
                                var $843 = $a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v1.pitch));
                                var $844 = $a801f2c896bd09f1$var$isStep2($842);
                                if ($844) {
                                    var $845 = $a801f2c896bd09f1$var$notEq3($a801f2c896bd09f1$var$direction2($842))($a801f2c896bd09f1$var$compare13($843)($a801f2c896bd09f1$var$unison2));
                                    if ($845) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$LeftRepeatOfRight.value);
                                    return v10(true);
                                }
                                return v10(true);
                            }
                            return v10(true);
                        };
                        var $851 = $a801f2c896bd09f1$var$degree3($a801f2c896bd09f1$var$pc2(child)) === $a801f2c896bd09f1$var$degree3($a801f2c896bd09f1$var$pc2(v3.pitch));
                        if ($851) {
                            var $852 = $a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(v3.pitch)(child));
                            var $853 = $a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v1.pitch));
                            var $854 = $a801f2c896bd09f1$var$isStep2($853);
                            if ($854) {
                                var $855 = $a801f2c896bd09f1$var$notEq3($a801f2c896bd09f1$var$compare13($852)($a801f2c896bd09f1$var$unison2))($a801f2c896bd09f1$var$direction2($853));
                                if ($855) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$RightRepeatOfLeft.value);
                                return v8(true);
                            }
                            return v8(true);
                        }
                        return v8(true);
                    };
                    var $861 = $a801f2c896bd09f1$var$eq14($a801f2c896bd09f1$var$pc2(child))($a801f2c896bd09f1$var$pc2(v1.pitch));
                    if ($861) {
                        var $862 = $a801f2c896bd09f1$var$isStep2($a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v3.pitch)));
                        if ($862) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$LeftRepeatOfRight.value);
                        return v6(true);
                    }
                    return v6(true);
                };
                var $868 = $a801f2c896bd09f1$var$eq14($a801f2c896bd09f1$var$pc2(child))($a801f2c896bd09f1$var$pc2(v3.pitch));
                if ($868) {
                    var $869 = $a801f2c896bd09f1$var$isStep2($a801f2c896bd09f1$var$ic2($a801f2c896bd09f1$var$pto2(child)(v1.pitch)));
                    if ($869) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$RightRepeatOfLeft.value);
                    return v4(true);
                }
                return v4(true);
            };
            var $875 = $a801f2c896bd09f1$var$eq14($a801f2c896bd09f1$var$pc2(child))($a801f2c896bd09f1$var$pc2(v3.pitch));
            if ($875) {
                var $876 = $a801f2c896bd09f1$var$eq14($a801f2c896bd09f1$var$pc2(child))($a801f2c896bd09f1$var$pc2(v1.pitch));
                if ($876) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$FullRepeat.value);
                return v22(true);
            }
            return v22(true);
        };
    };
};
var $a801f2c896bd09f1$var$setLeftExplParent = function(child) {
    return function(leftParentMaybe) {
        return function(expl) {
            if (leftParentMaybe instanceof $a801f2c896bd09f1$var$Just) {
                if (expl instanceof $a801f2c896bd09f1$var$NoExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$RightExpl({
                    orn: $a801f2c896bd09f1$var$findRightOrn(child)(leftParentMaybe.value0),
                    leftParent: leftParentMaybe.value0
                }));
                if (expl instanceof $a801f2c896bd09f1$var$RightExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$RightExpl({
                    orn: $a801f2c896bd09f1$var$findRightOrn(child)(leftParentMaybe.value0),
                    leftParent: leftParentMaybe.value0
                }));
                if (expl instanceof $a801f2c896bd09f1$var$LeftExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$DoubleExpl({
                    orn: $a801f2c896bd09f1$var$findDoubleOrn(child)(leftParentMaybe.value0)(expl.value0.rightParent),
                    leftParent: leftParentMaybe.value0,
                    rightParent: expl.value0.rightParent
                }));
                if (expl instanceof $a801f2c896bd09f1$var$DoubleExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$DoubleExpl({
                    orn: $a801f2c896bd09f1$var$findDoubleOrn(child)(leftParentMaybe.value0)(expl.value0.rightParent),
                    leftParent: leftParentMaybe.value0,
                    rightParent: expl.value0.rightParent
                }));
                return $a801f2c896bd09f1$var$Nothing.value;
            }
            if (leftParentMaybe instanceof $a801f2c896bd09f1$var$Nothing) {
                if (expl instanceof $a801f2c896bd09f1$var$LeftExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$LeftExpl(expl.value0));
                if (expl instanceof $a801f2c896bd09f1$var$DoubleExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$LeftExpl({
                    orn: $a801f2c896bd09f1$var$findLeftOrn(child)(expl.value0.rightParent),
                    rightParent: expl.value0.rightParent
                }));
                if (expl instanceof $a801f2c896bd09f1$var$HoriExpl) return $a801f2c896bd09f1$var$Nothing.value;
                return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NoExpl.value);
            }
            throw new Error("Failed pattern match at ProtoVoices.Model (line 190, column 48 - line 213, column 21): " + [
                leftParentMaybe.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$setRightExplParent = function(child) {
    return function(rightParentMaybe) {
        return function(expl) {
            if (rightParentMaybe instanceof $a801f2c896bd09f1$var$Just) {
                if (expl instanceof $a801f2c896bd09f1$var$NoExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$LeftExpl({
                    orn: $a801f2c896bd09f1$var$findLeftOrn(child)(rightParentMaybe.value0),
                    rightParent: rightParentMaybe.value0
                }));
                if (expl instanceof $a801f2c896bd09f1$var$LeftExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$LeftExpl({
                    orn: $a801f2c896bd09f1$var$findLeftOrn(child)(rightParentMaybe.value0),
                    rightParent: rightParentMaybe.value0
                }));
                if (expl instanceof $a801f2c896bd09f1$var$RightExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$DoubleExpl({
                    orn: $a801f2c896bd09f1$var$findDoubleOrn(child)(expl.value0.leftParent)(rightParentMaybe.value0),
                    leftParent: expl.value0.leftParent,
                    rightParent: rightParentMaybe.value0
                }));
                if (expl instanceof $a801f2c896bd09f1$var$DoubleExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$DoubleExpl({
                    orn: $a801f2c896bd09f1$var$findDoubleOrn(child)(expl.value0.leftParent)(rightParentMaybe.value0),
                    leftParent: expl.value0.leftParent,
                    rightParent: rightParentMaybe.value0
                }));
                return $a801f2c896bd09f1$var$Nothing.value;
            }
            if (rightParentMaybe instanceof $a801f2c896bd09f1$var$Nothing) {
                if (expl instanceof $a801f2c896bd09f1$var$RightExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$RightExpl(expl.value0));
                if (expl instanceof $a801f2c896bd09f1$var$DoubleExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$RightExpl({
                    orn: $a801f2c896bd09f1$var$findRightOrn(child)(expl.value0.leftParent),
                    leftParent: expl.value0.leftParent
                }));
                if (expl instanceof $a801f2c896bd09f1$var$HoriExpl) return $a801f2c896bd09f1$var$Nothing.value;
                return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NoExpl.value);
            }
            throw new Error("Failed pattern match at ProtoVoices.Model (line 216, column 50 - line 239, column 21): " + [
                rightParentMaybe.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$explParents = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$NoExpl) return [];
    if (v3 instanceof $a801f2c896bd09f1$var$RootExpl) return [];
    if (v3 instanceof $a801f2c896bd09f1$var$HoriExpl) return [
        v3.value0
    ];
    if (v3 instanceof $a801f2c896bd09f1$var$RightExpl) return [
        v3.value0.leftParent
    ];
    if (v3 instanceof $a801f2c896bd09f1$var$LeftExpl) return [
        v3.value0.rightParent
    ];
    if (v3 instanceof $a801f2c896bd09f1$var$DoubleExpl) return [
        v3.value0.leftParent,
        v3.value0.rightParent
    ];
    throw new Error("Failed pattern match at ProtoVoices.Model (line 262, column 15 - line 268, column 72): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$explIsSplit = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$HoriExpl) return false;
    return true;
};
var $a801f2c896bd09f1$var$explIsHori = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$NoExpl) return true;
    if (v3 instanceof $a801f2c896bd09f1$var$HoriExpl) return true;
    return false;
};
var $a801f2c896bd09f1$var$explHasParent = function(id4) {
    return function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$NoExpl) return false;
        if (v3 instanceof $a801f2c896bd09f1$var$RootExpl) return false;
        if (v3 instanceof $a801f2c896bd09f1$var$HoriExpl) return v3.value0.id === id4;
        if (v3 instanceof $a801f2c896bd09f1$var$RightExpl) return v3.value0.leftParent.id === id4;
        if (v3 instanceof $a801f2c896bd09f1$var$LeftExpl) return v3.value0.rightParent.id === id4;
        if (v3 instanceof $a801f2c896bd09f1$var$DoubleExpl) return v3.value0.leftParent.id === id4 || v3.value0.rightParent.id === id4;
        throw new Error("Failed pattern match at ProtoVoices.Model (line 253, column 20 - line 259, column 88): " + [
            v3.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$eqTransId = $a801f2c896bd09f1$var$eqInt;
var $a801f2c896bd09f1$var$eq7 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqTransId);
var $a801f2c896bd09f1$var$eqStartStop = function(dictEq) {
    var eq172 = $a801f2c896bd09f1$var$eq(dictEq);
    return {
        eq: function(x4) {
            return function(y4) {
                if (x4 instanceof $a801f2c896bd09f1$var$Start && y4 instanceof $a801f2c896bd09f1$var$Start) return true;
                if (x4 instanceof $a801f2c896bd09f1$var$Inner && y4 instanceof $a801f2c896bd09f1$var$Inner) return eq172(x4.value0)(y4.value0);
                if (x4 instanceof $a801f2c896bd09f1$var$Stop && y4 instanceof $a801f2c896bd09f1$var$Stop) return true;
                return false;
            };
        }
    };
};
var $a801f2c896bd09f1$var$eqStartStop1 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqStartStop($a801f2c896bd09f1$var$eqRec1);
var $a801f2c896bd09f1$var$eqRec22 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec3(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons2($a801f2c896bd09f1$var$rightIsSymbol)($a801f2c896bd09f1$var$eqStartStop1))()($a801f2c896bd09f1$var$leftIsSymbol)($a801f2c896bd09f1$var$eqStartStop1));
var $a801f2c896bd09f1$var$eq8 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqArray($a801f2c896bd09f1$var$eqRec22));
var $a801f2c896bd09f1$var$eq9 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqSet($a801f2c896bd09f1$var$eqRec22));
var $a801f2c896bd09f1$var$ordStartStop = function(dictOrd) {
    var compare22 = $a801f2c896bd09f1$var$compare(dictOrd);
    var eqStartStop22 = $a801f2c896bd09f1$var$eqStartStop(dictOrd.Eq0());
    return {
        compare: function(x4) {
            return function(y4) {
                if (x4 instanceof $a801f2c896bd09f1$var$Start && y4 instanceof $a801f2c896bd09f1$var$Start) return $a801f2c896bd09f1$var$EQ.value;
                if (x4 instanceof $a801f2c896bd09f1$var$Start) return $a801f2c896bd09f1$var$LT.value;
                if (y4 instanceof $a801f2c896bd09f1$var$Start) return $a801f2c896bd09f1$var$GT.value;
                if (x4 instanceof $a801f2c896bd09f1$var$Inner && y4 instanceof $a801f2c896bd09f1$var$Inner) return compare22(x4.value0)(y4.value0);
                if (x4 instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$LT.value;
                if (y4 instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$GT.value;
                if (x4 instanceof $a801f2c896bd09f1$var$Stop && y4 instanceof $a801f2c896bd09f1$var$Stop) return $a801f2c896bd09f1$var$EQ.value;
                throw new Error("Failed pattern match at ProtoVoices.Model (line 0, column 0 - line 0, column 0): " + [
                    x4.constructor.name,
                    y4.constructor.name
                ]);
            };
        },
        Eq0: function() {
            return eqStartStop22;
        }
    };
};
var $a801f2c896bd09f1$var$ordStartStop1 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons2($a801f2c896bd09f1$var$pitchIsSymbol)($a801f2c896bd09f1$var$ordPitch2))()($a801f2c896bd09f1$var$idIsSymbol)($a801f2c896bd09f1$var$ordString)));
var $a801f2c896bd09f1$var$ordRecord1 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons2($a801f2c896bd09f1$var$rightIsSymbol)($a801f2c896bd09f1$var$ordStartStop1))()($a801f2c896bd09f1$var$leftIsSymbol)($a801f2c896bd09f1$var$ordStartStop1));
var $a801f2c896bd09f1$var$catMaybes4 = /* @__PURE__ */ $a801f2c896bd09f1$var$catMaybes3($a801f2c896bd09f1$var$ordRecord1);
var $a801f2c896bd09f1$var$map62 = /* @__PURE__ */ $a801f2c896bd09f1$var$map18(/* @__PURE__ */ $a801f2c896bd09f1$var$ordMaybe($a801f2c896bd09f1$var$ordRecord1));
var $a801f2c896bd09f1$var$fromFoldable1 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable5($a801f2c896bd09f1$var$foldableArray)($a801f2c896bd09f1$var$ordRecord1);
var $a801f2c896bd09f1$var$monoidRecord2 = /* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecord()(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecordCons($a801f2c896bd09f1$var$passingIsSymbol)($a801f2c896bd09f1$var$monoidArray)()(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecordCons($a801f2c896bd09f1$var$regularIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidSet($a801f2c896bd09f1$var$ordRecord1))()($a801f2c896bd09f1$var$monoidRecordNil)));
var $a801f2c896bd09f1$var$insert42 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert7($a801f2c896bd09f1$var$ordRecord1);
var $a801f2c896bd09f1$var$append32 = /* @__PURE__ */ $a801f2c896bd09f1$var$append(/* @__PURE__ */ $a801f2c896bd09f1$var$semigroupRecord()(/* @__PURE__ */ $a801f2c896bd09f1$var$semigroupRecordCons($a801f2c896bd09f1$var$passingIsSymbol)()(/* @__PURE__ */ $a801f2c896bd09f1$var$semigroupRecordCons($a801f2c896bd09f1$var$regularIsSymbol)()($a801f2c896bd09f1$var$semigroupRecordNil)(/* @__PURE__ */ $a801f2c896bd09f1$var$semigroupSet($a801f2c896bd09f1$var$ordRecord1)))($a801f2c896bd09f1$var$semigroupArray)));
var $a801f2c896bd09f1$var$foldMap4 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldMap($a801f2c896bd09f1$var$foldableArray)($a801f2c896bd09f1$var$monoidRecord2);
var $a801f2c896bd09f1$var$horiEdgesLeft = function(edgesl) {
    return function(slicel) {
        var v3 = function(v1) {
            if ($a801f2c896bd09f1$var$otherwise) return edgesl;
            throw new Error("Failed pattern match at ProtoVoices.Model (line 777, column 1 - line 777, column 41): " + [
                edgesl.constructor.name,
                slicel.constructor.name
            ]);
        };
        if (slicel.notes instanceof $a801f2c896bd09f1$var$Inner) {
            var replaceRight = function(v1) {
                var v22 = function(v32) {
                    if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$Nothing.value;
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 777, column 1 - line 777, column 41): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.right instanceof $a801f2c896bd09f1$var$Inner) {
                    var $949 = $a801f2c896bd09f1$var$find2(function(n) {
                        if (n.expl instanceof $a801f2c896bd09f1$var$HoriExpl) return n.expl.value0.id === v1.right.value0.id;
                        return false;
                    })(slicel.notes.value0);
                    if ($949 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Just({
                        left: v1.left,
                        right: new $a801f2c896bd09f1$var$Inner($949.value0.note)
                    });
                    return v22(true);
                }
                return v22(true);
            };
            return {
                regular: $a801f2c896bd09f1$var$catMaybes4($a801f2c896bd09f1$var$map62(replaceRight)(edgesl.regular)),
                passing: $a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$map19(replaceRight)(edgesl.passing))
            };
        }
        return v3(true);
    };
};
var $a801f2c896bd09f1$var$horiEdgesRight = function(slicer) {
    return function(edgesr) {
        var v3 = function(v1) {
            if ($a801f2c896bd09f1$var$otherwise) return edgesr;
            throw new Error("Failed pattern match at ProtoVoices.Model (line 798, column 1 - line 798, column 42): " + [
                slicer.constructor.name,
                edgesr.constructor.name
            ]);
        };
        if (slicer.notes instanceof $a801f2c896bd09f1$var$Inner) {
            var replaceLeft = function(v1) {
                var v22 = function(v32) {
                    if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$Nothing.value;
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 798, column 1 - line 798, column 42): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.left instanceof $a801f2c896bd09f1$var$Inner) {
                    var $967 = $a801f2c896bd09f1$var$find2(function(n) {
                        if (n.expl instanceof $a801f2c896bd09f1$var$HoriExpl) return n.expl.value0.id === v1.left.value0.id;
                        return false;
                    })(slicer.notes.value0);
                    if ($967 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Just({
                        left: new $a801f2c896bd09f1$var$Inner($967.value0.note),
                        right: v1.right
                    });
                    return v22(true);
                }
                return v22(true);
            };
            return {
                regular: $a801f2c896bd09f1$var$catMaybes4($a801f2c896bd09f1$var$map62(replaceLeft)(edgesr.regular)),
                passing: $a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$map19(replaceLeft)(edgesr.passing))
            };
        }
        return v3(true);
    };
};
var $a801f2c896bd09f1$var$thawTrans = function(ties) {
    return function(id4) {
        return function(slice4) {
            return {
                id: id4,
                is2nd: false,
                edges: {
                    regular: $a801f2c896bd09f1$var$fromFoldable1(ties),
                    passing: []
                }
            };
        };
    };
};
var $a801f2c896bd09f1$var$thawPiece = function(piece) {
    var thaw2 = function(st) {
        return function(v3) {
            var seg = new $a801f2c896bd09f1$var$Just({
                trans: $a801f2c896bd09f1$var$thawTrans(st.ties)(st.i)(v3.notes),
                rslice: $a801f2c896bd09f1$var$thawSlice(v3.notes)(st.i + 1 | 0),
                op: $a801f2c896bd09f1$var$Freeze.value
            });
            var mkTie = function(note2) {
                if (note2.hold instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$Nothing.value;
                if (note2.hold instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Just({
                    left: new $a801f2c896bd09f1$var$Inner(note2.note),
                    right: new $a801f2c896bd09f1$var$Inner({
                        pitch: note2.note.pitch,
                        id: note2.hold.value0
                    })
                });
                throw new Error("Failed pattern match at ProtoVoices.Model (line 624, column 18 - line 626, column 84): " + [
                    note2.hold.constructor.name
                ]);
            };
            var tiesNext = $a801f2c896bd09f1$var$mapMaybe2(mkTie)(v3.notes);
            return {
                seg: seg,
                ties: tiesNext,
                i: st.i + 1 | 0
            };
        };
    };
    var init3 = {
        seg: $a801f2c896bd09f1$var$Nothing.value,
        ties: [],
        i: 0
    };
    var states = $a801f2c896bd09f1$var$scanl3(thaw2)(init3)(piece);
    var imax = $a801f2c896bd09f1$var$maybe(0)(function(v3) {
        return v3.i;
    })($a801f2c896bd09f1$var$last2(states));
    var lastSeg = {
        trans: $a801f2c896bd09f1$var$thawTrans([])(imax)([]),
        rslice: {
            id: imax + 1 | 0,
            notes: $a801f2c896bd09f1$var$Stop.value,
            x: $a801f2c896bd09f1$var$toNumber(imax + 1 | 0),
            parents: $a801f2c896bd09f1$var$NoParents.value
        },
        op: $a801f2c896bd09f1$var$Freeze.value
    };
    var segs = $a801f2c896bd09f1$var$append4($a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$map19(function(v3) {
        return v3.seg;
    })(states)))([
        lastSeg
    ]);
    return {
        start: $a801f2c896bd09f1$var$startSlice,
        segments: $a801f2c896bd09f1$var$fromFoldable6(segs),
        nextSliceId: imax + 2 | 0,
        nextTransId: imax + 1 | 0
    };
};
var $a801f2c896bd09f1$var$vertEdgesLeft = function(edges) {
    return function(slice4) {
        var v3 = function(v1) {
            if ($a801f2c896bd09f1$var$otherwise) return new $a801f2c896bd09f1$var$Left("The current reduction is invalid: Trying to vert a Start or Stop slice.");
            throw new Error("Failed pattern match at ProtoVoices.Model (line 741, column 1 - line 741, column 55): " + [
                edges.constructor.name,
                slice4.constructor.name
            ]);
        };
        if (slice4.notes instanceof $a801f2c896bd09f1$var$Inner) {
            var replaceRight = function(v1) {
                var v22 = function(v32) {
                    if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$Nothing.value;
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 741, column 1 - line 741, column 55): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.right instanceof $a801f2c896bd09f1$var$Inner) {
                    var $988 = $a801f2c896bd09f1$var$find2(function(n) {
                        return n.note.id === v1.right.value0.id;
                    })(slice4.notes.value0);
                    if ($988 instanceof $a801f2c896bd09f1$var$Just) {
                        if ($988.value0.expl instanceof $a801f2c896bd09f1$var$HoriExpl) return new $a801f2c896bd09f1$var$Just({
                            left: v1.left,
                            right: new $a801f2c896bd09f1$var$Inner($988.value0.expl.value0)
                        });
                        return v22(true);
                    }
                    return v22(true);
                }
                return v22(true);
            };
            return new $a801f2c896bd09f1$var$Right({
                regular: $a801f2c896bd09f1$var$catMaybes4($a801f2c896bd09f1$var$map62(replaceRight)(edges.regular)),
                passing: $a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$map19(replaceRight)(edges.passing))
            });
        }
        return v3(true);
    };
};
var $a801f2c896bd09f1$var$vertEdgesRight = function(edges) {
    return function(slice4) {
        var v3 = function(v1) {
            if ($a801f2c896bd09f1$var$otherwise) return new $a801f2c896bd09f1$var$Left("The current reduction is invalid: Trying to vert a Start or Stop slice.");
            throw new Error("Failed pattern match at ProtoVoices.Model (line 759, column 1 - line 759, column 56): " + [
                edges.constructor.name,
                slice4.constructor.name
            ]);
        };
        if (slice4.notes instanceof $a801f2c896bd09f1$var$Inner) {
            var replaceLeft = function(v1) {
                var v22 = function(v32) {
                    if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$Nothing.value;
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 759, column 1 - line 759, column 56): " + [
                        v1.constructor.name
                    ]);
                };
                if (v1.left instanceof $a801f2c896bd09f1$var$Inner) {
                    var $1006 = $a801f2c896bd09f1$var$find2(function(n) {
                        return n.note.id === v1.left.value0.id;
                    })(slice4.notes.value0);
                    if ($1006 instanceof $a801f2c896bd09f1$var$Just) {
                        if ($1006.value0.expl instanceof $a801f2c896bd09f1$var$HoriExpl) return new $a801f2c896bd09f1$var$Just({
                            left: new $a801f2c896bd09f1$var$Inner($1006.value0.expl.value0),
                            right: v1.right
                        });
                        return v22(true);
                    }
                    return v22(true);
                }
                return v22(true);
            };
            return new $a801f2c896bd09f1$var$Right({
                regular: $a801f2c896bd09f1$var$catMaybes4($a801f2c896bd09f1$var$map62(replaceLeft)(edges.regular)),
                passing: $a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$map19(replaceLeft)(edges.passing))
            });
        }
        return v3(true);
    };
};
var $a801f2c896bd09f1$var$eqStaff = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$TrebleStaff && y4 instanceof $a801f2c896bd09f1$var$TrebleStaff) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$BassStaff && y4 instanceof $a801f2c896bd09f1$var$BassStaff) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$GrandStaff && y4 instanceof $a801f2c896bd09f1$var$GrandStaff) return true;
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$eqSliceId = $a801f2c896bd09f1$var$eqInt;
var $a801f2c896bd09f1$var$eq10 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqSliceId);
var $a801f2c896bd09f1$var$eqRightOrnament = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$RightRepeat && y4 instanceof $a801f2c896bd09f1$var$RightRepeat) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$RightNeighbor && y4 instanceof $a801f2c896bd09f1$var$RightNeighbor) return true;
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$eq11 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqRightOrnament));
var $a801f2c896bd09f1$var$eqParents = function(dictEq) {
    var eq172 = $a801f2c896bd09f1$var$eq(dictEq);
    return {
        eq: function(x4) {
            return function(y4) {
                if (x4 instanceof $a801f2c896bd09f1$var$NoParents && y4 instanceof $a801f2c896bd09f1$var$NoParents) return true;
                if (x4 instanceof $a801f2c896bd09f1$var$VertParent && y4 instanceof $a801f2c896bd09f1$var$VertParent) return eq172(x4.value0)(y4.value0);
                if (x4 instanceof $a801f2c896bd09f1$var$MergeParents && y4 instanceof $a801f2c896bd09f1$var$MergeParents) return eq172(x4.value0.left)(y4.value0.left) && eq172(x4.value0.right)(y4.value0.right);
                return false;
            };
        }
    };
};
var $a801f2c896bd09f1$var$eq122 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqParents($a801f2c896bd09f1$var$eqSliceId));
var $a801f2c896bd09f1$var$eqLeftOrnament = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$LeftRepeat && y4 instanceof $a801f2c896bd09f1$var$LeftRepeat) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$LeftNeighbor && y4 instanceof $a801f2c896bd09f1$var$LeftNeighbor) return true;
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$eq132 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqLeftOrnament));
var $a801f2c896bd09f1$var$eqDoubleOrnament = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$FullNeighbor && y4 instanceof $a801f2c896bd09f1$var$FullNeighbor) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$FullRepeat && y4 instanceof $a801f2c896bd09f1$var$FullRepeat) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$LeftRepeatOfRight && y4 instanceof $a801f2c896bd09f1$var$LeftRepeatOfRight) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$RightRepeatOfLeft && y4 instanceof $a801f2c896bd09f1$var$RightRepeatOfLeft) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$PassingMid && y4 instanceof $a801f2c896bd09f1$var$PassingMid) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$PassingLeft && y4 instanceof $a801f2c896bd09f1$var$PassingLeft) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$PassingRight && y4 instanceof $a801f2c896bd09f1$var$PassingRight) return true;
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$eq142 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqDoubleOrnament));
var $a801f2c896bd09f1$var$eqNoteExplanation = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$NoExpl && y4 instanceof $a801f2c896bd09f1$var$NoExpl) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$RootExpl && y4 instanceof $a801f2c896bd09f1$var$RootExpl) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$HoriExpl && y4 instanceof $a801f2c896bd09f1$var$HoriExpl) return x4.value0.id === y4.value0.id && $a801f2c896bd09f1$var$eq4(x4.value0.pitch)(y4.value0.pitch);
            if (x4 instanceof $a801f2c896bd09f1$var$RightExpl && y4 instanceof $a801f2c896bd09f1$var$RightExpl) return x4.value0.leftParent.id === y4.value0.leftParent.id && $a801f2c896bd09f1$var$eq4(x4.value0.leftParent.pitch)(y4.value0.leftParent.pitch) && $a801f2c896bd09f1$var$eq11(x4.value0.orn)(y4.value0.orn);
            if (x4 instanceof $a801f2c896bd09f1$var$LeftExpl && y4 instanceof $a801f2c896bd09f1$var$LeftExpl) return $a801f2c896bd09f1$var$eq132(x4.value0.orn)(y4.value0.orn) && x4.value0.rightParent.id === y4.value0.rightParent.id && $a801f2c896bd09f1$var$eq4(x4.value0.rightParent.pitch)(y4.value0.rightParent.pitch);
            if (x4 instanceof $a801f2c896bd09f1$var$DoubleExpl && y4 instanceof $a801f2c896bd09f1$var$DoubleExpl) return x4.value0.leftParent.id === y4.value0.leftParent.id && $a801f2c896bd09f1$var$eq4(x4.value0.leftParent.pitch)(y4.value0.leftParent.pitch) && $a801f2c896bd09f1$var$eq142(x4.value0.orn)(y4.value0.orn) && x4.value0.rightParent.id === y4.value0.rightParent.id && $a801f2c896bd09f1$var$eq4(x4.value0.rightParent.pitch)(y4.value0.rightParent.pitch);
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$eq15 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$eqArray(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec3(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons2($a801f2c896bd09f1$var$noteIsSymbol)($a801f2c896bd09f1$var$eqRec1))()($a801f2c896bd09f1$var$explIsSymbol)($a801f2c896bd09f1$var$eqNoteExplanation)))));
var $a801f2c896bd09f1$var$eqOp = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$Freeze && y4 instanceof $a801f2c896bd09f1$var$Freeze) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$Split2 && y4 instanceof $a801f2c896bd09f1$var$Split2) return $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqOp)(x4.value0.childl.op)(y4.value0.childl.op) && $a801f2c896bd09f1$var$eq10(x4.value0.childl.rslice.id)(y4.value0.childl.rslice.id) && $a801f2c896bd09f1$var$eq15(x4.value0.childl.rslice.notes)(y4.value0.childl.rslice.notes) && $a801f2c896bd09f1$var$eq122(x4.value0.childl.rslice.parents)(y4.value0.childl.rslice.parents) && x4.value0.childl.rslice.x === y4.value0.childl.rslice.x && $a801f2c896bd09f1$var$eq8(x4.value0.childl.trans.edges.passing)(y4.value0.childl.trans.edges.passing) && $a801f2c896bd09f1$var$eq9(x4.value0.childl.trans.edges.regular)(y4.value0.childl.trans.edges.regular) && $a801f2c896bd09f1$var$eq7(x4.value0.childl.trans.id)(y4.value0.childl.trans.id) && x4.value0.childl.trans.is2nd === y4.value0.childl.trans.is2nd && $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqOp)(x4.value0.childr.op)(y4.value0.childr.op) && $a801f2c896bd09f1$var$eq8(x4.value0.childr.trans.edges.passing)(y4.value0.childr.trans.edges.passing) && $a801f2c896bd09f1$var$eq9(x4.value0.childr.trans.edges.regular)(y4.value0.childr.trans.edges.regular) && $a801f2c896bd09f1$var$eq7(x4.value0.childr.trans.id)(y4.value0.childr.trans.id) && x4.value0.childr.trans.is2nd === y4.value0.childr.trans.is2nd;
            if (x4 instanceof $a801f2c896bd09f1$var$Hori && y4 instanceof $a801f2c896bd09f1$var$Hori) return $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqOp)(x4.value0.childl.op)(y4.value0.childl.op) && $a801f2c896bd09f1$var$eq10(x4.value0.childl.rslice.id)(y4.value0.childl.rslice.id) && $a801f2c896bd09f1$var$eq15(x4.value0.childl.rslice.notes)(y4.value0.childl.rslice.notes) && $a801f2c896bd09f1$var$eq122(x4.value0.childl.rslice.parents)(y4.value0.childl.rslice.parents) && x4.value0.childl.rslice.x === y4.value0.childl.rslice.x && $a801f2c896bd09f1$var$eq8(x4.value0.childl.trans.edges.passing)(y4.value0.childl.trans.edges.passing) && $a801f2c896bd09f1$var$eq9(x4.value0.childl.trans.edges.regular)(y4.value0.childl.trans.edges.regular) && $a801f2c896bd09f1$var$eq7(x4.value0.childl.trans.id)(y4.value0.childl.trans.id) && x4.value0.childl.trans.is2nd === y4.value0.childl.trans.is2nd && $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqOp)(x4.value0.childm.op)(y4.value0.childm.op) && $a801f2c896bd09f1$var$eq10(x4.value0.childm.rslice.id)(y4.value0.childm.rslice.id) && $a801f2c896bd09f1$var$eq15(x4.value0.childm.rslice.notes)(y4.value0.childm.rslice.notes) && $a801f2c896bd09f1$var$eq122(x4.value0.childm.rslice.parents)(y4.value0.childm.rslice.parents) && x4.value0.childm.rslice.x === y4.value0.childm.rslice.x && $a801f2c896bd09f1$var$eq8(x4.value0.childm.trans.edges.passing)(y4.value0.childm.trans.edges.passing) && $a801f2c896bd09f1$var$eq9(x4.value0.childm.trans.edges.regular)(y4.value0.childm.trans.edges.regular) && $a801f2c896bd09f1$var$eq7(x4.value0.childm.trans.id)(y4.value0.childm.trans.id) && x4.value0.childm.trans.is2nd === y4.value0.childm.trans.is2nd && $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqOp)(x4.value0.childr.op)(y4.value0.childr.op) && $a801f2c896bd09f1$var$eq8(x4.value0.childr.trans.edges.passing)(y4.value0.childr.trans.edges.passing) && $a801f2c896bd09f1$var$eq9(x4.value0.childr.trans.edges.regular)(y4.value0.childr.trans.edges.regular) && $a801f2c896bd09f1$var$eq7(x4.value0.childr.trans.id)(y4.value0.childr.trans.id) && x4.value0.childr.trans.is2nd === y4.value0.childr.trans.is2nd;
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$eq16 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqOp);
var $a801f2c896bd09f1$var$setParents = function(p3) {
    return function(seg) {
        var findUniqueVertExpl = function(parentSlice) {
            return function(child) {
                var v3 = $a801f2c896bd09f1$var$filter2(function(pnote) {
                    return $a801f2c896bd09f1$var$eq4(pnote.note.pitch)(child.note.pitch);
                })($a801f2c896bd09f1$var$getInnerNotes(parentSlice));
                if (v3.length === 1) return {
                    note: child.note,
                    expl: new $a801f2c896bd09f1$var$HoriExpl(v3[0].note)
                };
                return child;
            };
        };
        var findUniqueMergeExpl = function(leftSlice) {
            return function(rightSlice) {
                return function(child) {
                    var v3 = function(v1) {
                        var v22 = function(v33) {
                            if ($a801f2c896bd09f1$var$otherwise) return child;
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 681, column 1 - line 681, column 50): " + [
                                leftSlice.constructor.name,
                                rightSlice.constructor.name,
                                child.constructor.name
                            ]);
                        };
                        if (leftSlice.notes instanceof $a801f2c896bd09f1$var$Inner) {
                            if (rightSlice.notes instanceof $a801f2c896bd09f1$var$Inner) {
                                var rightExpls = $a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$bind12(leftSlice.notes.value0)(function(v33) {
                                    return $a801f2c896bd09f1$var$pure12($a801f2c896bd09f1$var$bind22($a801f2c896bd09f1$var$findRightOrn(child.note.pitch)(v33.note))(function(orn) {
                                        return $a801f2c896bd09f1$var$pure22(new $a801f2c896bd09f1$var$RightExpl({
                                            orn: new $a801f2c896bd09f1$var$Just(orn),
                                            leftParent: v33.note
                                        }));
                                    }));
                                }));
                                var leftExpls = $a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$bind12(rightSlice.notes.value0)(function(v33) {
                                    return $a801f2c896bd09f1$var$pure12($a801f2c896bd09f1$var$bind22($a801f2c896bd09f1$var$findLeftOrn(child.note.pitch)(v33.note))(function(orn) {
                                        return $a801f2c896bd09f1$var$pure22(new $a801f2c896bd09f1$var$LeftExpl({
                                            orn: new $a801f2c896bd09f1$var$Just(orn),
                                            rightParent: v33.note
                                        }));
                                    }));
                                }));
                                var doubleExpls = $a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$bind12(leftSlice.notes.value0)(function(v33) {
                                    return $a801f2c896bd09f1$var$bind12(rightSlice.notes.value0)(function(v4) {
                                        return $a801f2c896bd09f1$var$pure12($a801f2c896bd09f1$var$bind22($a801f2c896bd09f1$var$findDoubleOrn(child.note.pitch)(v33.note)(v4.note))(function(orn) {
                                            return $a801f2c896bd09f1$var$pure22(new $a801f2c896bd09f1$var$DoubleExpl({
                                                orn: new $a801f2c896bd09f1$var$Just(orn),
                                                leftParent: v33.note,
                                                rightParent: v4.note
                                            }));
                                        }));
                                    });
                                }));
                                if (doubleExpls.length === 1) return {
                                    note: child.note,
                                    expl: doubleExpls[0]
                                };
                                var v32 = $a801f2c896bd09f1$var$append4(leftExpls)(rightExpls);
                                if (v32.length === 1) return {
                                    note: child.note,
                                    expl: v32[0]
                                };
                                return child;
                            }
                            return v22(true);
                        }
                        return v22(true);
                    };
                    var $1071 = $a801f2c896bd09f1$var$eq15(leftSlice.notes)($a801f2c896bd09f1$var$Start.value);
                    if ($1071) {
                        var $1072 = $a801f2c896bd09f1$var$eq15(rightSlice.notes)($a801f2c896bd09f1$var$Stop.value);
                        if ($1072) return {
                            note: child.note,
                            expl: $a801f2c896bd09f1$var$RootExpl.value
                        };
                        return v3(true);
                    }
                    return v3(true);
                };
            };
        };
        if (p3 instanceof $a801f2c896bd09f1$var$NoParents) return {
            trans: seg.trans,
            op: seg.op,
            rslice: {
                id: seg.rslice.id,
                notes: seg.rslice.notes,
                x: seg.rslice.x,
                parents: $a801f2c896bd09f1$var$NoParents.value
            }
        };
        if (p3 instanceof $a801f2c896bd09f1$var$VertParent) return {
            trans: seg.trans,
            op: seg.op,
            rslice: {
                id: seg.rslice.id,
                x: seg.rslice.x,
                parents: new $a801f2c896bd09f1$var$VertParent(p3.value0.id),
                notes: $a801f2c896bd09f1$var$map52($a801f2c896bd09f1$var$map19(findUniqueVertExpl(p3.value0)))(seg.rslice.notes)
            }
        };
        if (p3 instanceof $a801f2c896bd09f1$var$MergeParents) return {
            trans: seg.trans,
            op: seg.op,
            rslice: {
                id: seg.rslice.id,
                x: seg.rslice.x,
                parents: new $a801f2c896bd09f1$var$MergeParents({
                    left: p3.value0.left.id,
                    right: p3.value0.right.id
                }),
                notes: $a801f2c896bd09f1$var$map52($a801f2c896bd09f1$var$map19(findUniqueMergeExpl(p3.value0.left)(p3.value0.right)))(seg.rslice.notes)
            }
        };
        throw new Error("Failed pattern match at ProtoVoices.Model (line 682, column 20 - line 697, column 8): " + [
            p3.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$emptyStyle = {
    classes: "",
    label: ""
};
var $a801f2c896bd09f1$var$styleSetClasses = function(classes) {
    return function(styleMaybe) {
        var style3 = $a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$emptyStyle)(styleMaybe);
        var $1078 = $a801f2c896bd09f1$var$$$null2(classes) && $a801f2c896bd09f1$var$$$null2(style3.label);
        if ($1078) return $a801f2c896bd09f1$var$Nothing.value;
        return new $a801f2c896bd09f1$var$Just({
            label: style3.label,
            classes: classes
        });
    };
};
var $a801f2c896bd09f1$var$styleSetLabel = function(label5) {
    return function(styleMaybe) {
        var style3 = $a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$emptyStyle)(styleMaybe);
        var $1079 = $a801f2c896bd09f1$var$$$null2(label5) && $a801f2c896bd09f1$var$$$null2(style3.classes);
        if ($1079) return $a801f2c896bd09f1$var$Nothing.value;
        return new $a801f2c896bd09f1$var$Just({
            classes: style3.classes,
            label: label5
        });
    };
};
var $a801f2c896bd09f1$var$emptyEdges = /* @__PURE__ */ $a801f2c896bd09f1$var$mempty($a801f2c896bd09f1$var$monoidRecord2);
var $a801f2c896bd09f1$var$explLeftEdge = function(v3) {
    var edge = function(l2) {
        return $a801f2c896bd09f1$var$singleton8({
            left: new $a801f2c896bd09f1$var$Inner(l2),
            right: new $a801f2c896bd09f1$var$Inner(v3.note)
        });
    };
    if (v3.expl instanceof $a801f2c896bd09f1$var$DoubleExpl) {
        if (v3.expl.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.expl.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingRight) return {
            regular: $a801f2c896bd09f1$var$emptyEdges.regular,
            passing: [
                {
                    left: new $a801f2c896bd09f1$var$Inner(v3.expl.value0.leftParent),
                    right: new $a801f2c896bd09f1$var$Inner(v3.note)
                }
            ]
        };
        return {
            passing: $a801f2c896bd09f1$var$emptyEdges.passing,
            regular: edge(v3.expl.value0.leftParent)
        };
    }
    if (v3.expl instanceof $a801f2c896bd09f1$var$RightExpl) return {
        passing: $a801f2c896bd09f1$var$emptyEdges.passing,
        regular: edge(v3.expl.value0.leftParent)
    };
    if (v3.expl instanceof $a801f2c896bd09f1$var$RootExpl) return {
        passing: $a801f2c896bd09f1$var$emptyEdges.passing,
        regular: $a801f2c896bd09f1$var$singleton8({
            left: $a801f2c896bd09f1$var$Start.value,
            right: new $a801f2c896bd09f1$var$Inner(v3.note)
        })
    };
    return $a801f2c896bd09f1$var$emptyEdges;
};
var $a801f2c896bd09f1$var$explParentEdge = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$DoubleExpl) {
        var parentEdge = {
            left: new $a801f2c896bd09f1$var$Inner(v3.value0.leftParent),
            right: new $a801f2c896bd09f1$var$Inner(v3.value0.rightParent)
        };
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingMid) return {
            regular: $a801f2c896bd09f1$var$emptyEdges.regular,
            passing: [
                parentEdge
            ]
        };
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingLeft) return {
            regular: $a801f2c896bd09f1$var$emptyEdges.regular,
            passing: [
                parentEdge
            ]
        };
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingRight) return {
            regular: $a801f2c896bd09f1$var$emptyEdges.regular,
            passing: [
                parentEdge
            ]
        };
        return {
            passing: $a801f2c896bd09f1$var$emptyEdges.passing,
            regular: $a801f2c896bd09f1$var$singleton8(parentEdge)
        };
    }
    if (v3 instanceof $a801f2c896bd09f1$var$RootExpl) return {
        passing: $a801f2c896bd09f1$var$emptyEdges.passing,
        regular: $a801f2c896bd09f1$var$singleton8({
            left: $a801f2c896bd09f1$var$Start.value,
            right: $a801f2c896bd09f1$var$Stop.value
        })
    };
    return $a801f2c896bd09f1$var$emptyEdges;
};
var $a801f2c896bd09f1$var$explRightEdge = function(v3) {
    var edge = function(r) {
        return $a801f2c896bd09f1$var$singleton8({
            left: new $a801f2c896bd09f1$var$Inner(v3.note),
            right: new $a801f2c896bd09f1$var$Inner(r)
        });
    };
    if (v3.expl instanceof $a801f2c896bd09f1$var$DoubleExpl) {
        if (v3.expl.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.expl.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingLeft) return {
            regular: $a801f2c896bd09f1$var$emptyEdges.regular,
            passing: [
                {
                    left: new $a801f2c896bd09f1$var$Inner(v3.note),
                    right: new $a801f2c896bd09f1$var$Inner(v3.expl.value0.rightParent)
                }
            ]
        };
        return {
            passing: $a801f2c896bd09f1$var$emptyEdges.passing,
            regular: edge(v3.expl.value0.rightParent)
        };
    }
    if (v3.expl instanceof $a801f2c896bd09f1$var$LeftExpl) return {
        passing: $a801f2c896bd09f1$var$emptyEdges.passing,
        regular: edge(v3.expl.value0.rightParent)
    };
    if (v3.expl instanceof $a801f2c896bd09f1$var$RootExpl) return {
        passing: $a801f2c896bd09f1$var$emptyEdges.passing,
        regular: $a801f2c896bd09f1$var$singleton8({
            left: new $a801f2c896bd09f1$var$Inner(v3.note),
            right: $a801f2c896bd09f1$var$Stop.value
        })
    };
    return $a801f2c896bd09f1$var$emptyEdges;
};
var $a801f2c896bd09f1$var$horiEdgesMid = function(slicel) {
    return function(edges) {
        return function(slicer) {
            var toLeft = $a801f2c896bd09f1$var$foldl6(function(acc) {
                return function(left) {
                    if (left.expl instanceof $a801f2c896bd09f1$var$HoriExpl) return $a801f2c896bd09f1$var$insert8(left.expl.value0.id)(left.note)(acc);
                    return acc;
                };
            })($a801f2c896bd09f1$var$empty3)($a801f2c896bd09f1$var$getInnerNotes(slicel));
            var toBoth = $a801f2c896bd09f1$var$foldl6(function(acc) {
                return function(right) {
                    if (right.expl instanceof $a801f2c896bd09f1$var$HoriExpl) {
                        var v3 = $a801f2c896bd09f1$var$lookup4(right.expl.value0.id)(toLeft);
                        if (v3 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$insert42({
                            left: new $a801f2c896bd09f1$var$Inner(v3.value0),
                            right: new $a801f2c896bd09f1$var$Inner(right.note)
                        })(acc);
                        if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return acc;
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 833, column 30 - line 835, column 27): " + [
                            v3.constructor.name
                        ]);
                    }
                    return acc;
                };
            })($a801f2c896bd09f1$var$empty4)($a801f2c896bd09f1$var$getInnerNotes(slicer));
            return $a801f2c896bd09f1$var$append32(edges)({
                passing: $a801f2c896bd09f1$var$emptyEdges.passing,
                regular: toBoth
            });
        };
    };
};
var $a801f2c896bd09f1$var$parentEdges = function(v3) {
    if (v3.notes instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$foldMap4($a801f2c896bd09f1$var$explParentEdge)($a801f2c896bd09f1$var$map19(function(v1) {
        return v1.expl;
    })(v3.notes.value0));
    return $a801f2c896bd09f1$var$emptyEdges;
};
var $a801f2c896bd09f1$var$noteSetExplanation = function(noteId) {
    return function(expl) {
        return function(model) {
            var setNoteExplInSlice = function(slice4) {
                return {
                    id: slice4.id,
                    x: slice4.x,
                    parents: slice4.parents,
                    notes: $a801f2c896bd09f1$var$map52($a801f2c896bd09f1$var$map19(function(n) {
                        var $1120 = n.note.id === noteId;
                        if ($1120) return {
                            note: n.note,
                            expl: expl
                        };
                        return n;
                    }))(slice4.notes)
                };
            };
            var noteInSlice = function(slice4) {
                return $a801f2c896bd09f1$var$any2(function(n) {
                    return n.note.id === noteId;
                })($a801f2c896bd09f1$var$getInnerNotes(slice4));
            };
            var doSegment$prime = function(upFromLeft) {
                return function(seg) {
                    if (seg.op instanceof $a801f2c896bd09f1$var$Freeze) {
                        if (upFromLeft instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Right({
                            "seg'": seg,
                            rUp: $a801f2c896bd09f1$var$Nil.value
                        });
                        if (upFromLeft instanceof $a801f2c896bd09f1$var$Cons) return new $a801f2c896bd09f1$var$Right({
                            "seg'": function() {
                                var $1123 = {};
                                for(var $1124 in seg)if (({}).hasOwnProperty.call(seg, $1124)) $1123[$1124] = seg[$1124];
                                $1123.trans = {
                                    id: seg.trans.id,
                                    is2nd: seg.trans.is2nd,
                                    edges: upFromLeft.value0
                                };
                                return $1123;
                            }(),
                            rUp: upFromLeft.value1
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1286, column 15 - line 1288, column 86): " + [
                            upFromLeft.constructor.name
                        ]);
                    }
                    if (seg.op instanceof $a801f2c896bd09f1$var$Split2) return $a801f2c896bd09f1$var$bind32(doSegment(upFromLeft)(seg.op.value0.childl))(function(v4) {
                        return $a801f2c896bd09f1$var$bind32(doSegment$prime(v4.rUp)(seg.op.value0.childr))(function(v1) {
                            var segNewOp = function() {
                                var $1130 = {};
                                for(var $1131 in seg)if (({}).hasOwnProperty.call(seg, $1131)) $1130[$1131] = seg[$1131];
                                $1130.op = new $a801f2c896bd09f1$var$Split2({
                                    childl: v4["seg'"],
                                    childr: v1["seg'"]
                                });
                                return $1130;
                            }();
                            return $a801f2c896bd09f1$var$bind32(function() {
                                var $1133 = noteInSlice(seg.op.value0.childl.rslice);
                                if ($1133) {
                                    var $1134 = $a801f2c896bd09f1$var$explIsSplit(expl);
                                    if ($1134) return $a801f2c896bd09f1$var$pure32(function() {
                                        var $1135 = {};
                                        for(var $1136 in segNewOp)if (({}).hasOwnProperty.call(segNewOp, $1136)) $1135[$1136] = segNewOp[$1136];
                                        $1135.trans = {
                                            id: segNewOp.trans.id,
                                            is2nd: segNewOp.trans.is2nd,
                                            edges: $a801f2c896bd09f1$var$parentEdges(v4["seg'"].rslice)
                                        };
                                        return $1135;
                                    }());
                                    return new $a801f2c896bd09f1$var$Left("Cannot explain a split note with a hori.");
                                }
                                return $a801f2c896bd09f1$var$pure32(segNewOp);
                            }())(function(seg$prime) {
                                return $a801f2c896bd09f1$var$pure32({
                                    "seg'": seg$prime,
                                    rUp: v1.rUp
                                });
                            });
                        });
                    });
                    if (seg.op instanceof $a801f2c896bd09f1$var$Hori) return $a801f2c896bd09f1$var$bind32(doSegment(upFromLeft)(seg.op.value0.childl))(function(v4) {
                        return $a801f2c896bd09f1$var$bind32(doSegment(v4.rUp)(seg.op.value0.childm))(function(v1) {
                            return $a801f2c896bd09f1$var$bind32(doSegment$prime(v1.rUp)(seg.op.value0.childr))(function(v22) {
                                return $a801f2c896bd09f1$var$bind32($a801f2c896bd09f1$var$vertEdgesLeft(v4["seg'"].trans.edges)(v4["seg'"].rslice))(function(leftParentEdges) {
                                    return $a801f2c896bd09f1$var$bind32($a801f2c896bd09f1$var$vertEdgesRight(v22["seg'"].trans.edges)(v1["seg'"].rslice))(function(rightParentEdges) {
                                        return $a801f2c896bd09f1$var$discard22(function() {
                                            var $1148 = (noteInSlice(seg.op.value0.childl.rslice) || noteInSlice(seg.op.value0.childm.rslice)) && !$a801f2c896bd09f1$var$explIsHori(expl);
                                            if ($1148) return new $a801f2c896bd09f1$var$Left("Cannot explain a hori note with a split. noteId = " + ($a801f2c896bd09f1$var$show13(noteId) + (", childl.rslice = " + ($a801f2c896bd09f1$var$show6(seg.op.value0.childl.rslice) + (", childm.rslice = " + $a801f2c896bd09f1$var$show6(seg.op.value0.childm.rslice))))));
                                            return $a801f2c896bd09f1$var$pure32($a801f2c896bd09f1$var$unit);
                                        }())(function() {
                                            return $a801f2c896bd09f1$var$pure32({
                                                "seg'": function() {
                                                    var $1149 = {};
                                                    for(var $1150 in seg)if (({}).hasOwnProperty.call(seg, $1150)) $1149[$1150] = seg[$1150];
                                                    $1149.op = new $a801f2c896bd09f1$var$Hori({
                                                        childl: v4["seg'"],
                                                        childm: v1["seg'"],
                                                        childr: v22["seg'"]
                                                    });
                                                    $1149.trans = {
                                                        id: seg.trans.id,
                                                        is2nd: seg.trans.is2nd,
                                                        edges: leftParentEdges
                                                    };
                                                    return $1149;
                                                }(),
                                                rUp: new $a801f2c896bd09f1$var$Cons(rightParentEdges, v22.rUp)
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1285, column 31 - line 1327, column 12): " + [
                        seg.op.constructor.name
                    ]);
                };
            };
            var doSegment = function(upFromLeft) {
                return function(seg) {
                    var rslice$prime = function() {
                        var $1162 = noteInSlice(seg.rslice);
                        if ($1162) return setNoteExplInSlice(seg.rslice);
                        return seg.rslice;
                    }();
                    return $a801f2c896bd09f1$var$map32(function(v4) {
                        return {
                            rUp: v4.rUp,
                            "seg'": {
                                op: v4["seg'"].op,
                                trans: v4["seg'"].trans,
                                rslice: rslice$prime
                            }
                        };
                    })(doSegment$prime(upFromLeft)(seg));
                };
            };
            var traverseTop = function(upFromLeft) {
                return function(v4) {
                    if (v4 instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$Nil.value);
                    if (v4 instanceof $a801f2c896bd09f1$var$Cons) return $a801f2c896bd09f1$var$bind32(doSegment(upFromLeft)(v4.value0))(function(v1) {
                        return $a801f2c896bd09f1$var$bind32(traverseTop(v1.rUp)(v4.value1))(function(rest$prime) {
                            return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Cons(v1["seg'"], rest$prime));
                        });
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1272, column 28 - line 1277, column 29): " + [
                        v4.constructor.name
                    ]);
                };
            };
            var v3 = traverseTop($a801f2c896bd09f1$var$Nil.value)(model.reduction.segments);
            if (v3 instanceof $a801f2c896bd09f1$var$Right) return new $a801f2c896bd09f1$var$Right({
                piece: model.piece,
                styles: model.styles,
                reduction: {
                    nextSliceId: model.reduction.nextSliceId,
                    nextTransId: model.reduction.nextTransId,
                    start: model.reduction.start,
                    segments: v3.value0
                }
            });
            if (v3 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(v3.value0);
            throw new Error("Failed pattern match at ProtoVoices.Model (line 1261, column 40 - line 1263, column 23): " + [
                v3.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$passingEdge = function(edge) {
    return {
        regular: $a801f2c896bd09f1$var$emptyEdges.regular,
        passing: [
            edge
        ]
    };
};
var $a801f2c896bd09f1$var$regularEdge = function(edge) {
    return {
        passing: $a801f2c896bd09f1$var$emptyEdges.passing,
        regular: $a801f2c896bd09f1$var$singleton8(edge)
    };
};
var $a801f2c896bd09f1$var$edgeIds = function(v3) {
    var getId = function(v1) {
        if (v1 instanceof $a801f2c896bd09f1$var$Inner) return v1.value0.id;
        return $a801f2c896bd09f1$var$show42(v1);
    };
    return new $a801f2c896bd09f1$var$Tuple(getId(v3.left), getId(v3.right));
};
var $a801f2c896bd09f1$var$doAt = function(match2) {
    return function(f2) {
        return function(red) {
            var go2 = function(v3) {
                return function(v1) {
                    if (v1 instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left("not found");
                    if (v1 instanceof $a801f2c896bd09f1$var$Cons) {
                        var v22 = match2(v1);
                        if (v22 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$map32(function(result2) {
                            return $a801f2c896bd09f1$var$append22(result2)(v22.value0.value1);
                        })(f2(v3)(v22.value0.value0));
                        if (v22 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$map32($a801f2c896bd09f1$var$Cons.create(v1.value0))(go2(v1.value0.rslice)(v1.value1));
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 677, column 39 - line 679, column 47): " + [
                            v22.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 674, column 3 - line 674, column 62): " + [
                        v3.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return go2(red.start)(red.segments);
        };
    };
};
var $a801f2c896bd09f1$var$detachSegment = function(v3) {
    return {
        trans: v3.trans,
        op: v3.op
    };
};
var $a801f2c896bd09f1$var$mkMerge = function(tid) {
    return function(leftSlice) {
        return function(seg1) {
            return function(seg2) {
                var pars = new $a801f2c896bd09f1$var$MergeParents({
                    left: leftSlice,
                    right: seg2.rslice
                });
                var seg1$prime = $a801f2c896bd09f1$var$setParents(pars)(seg1);
                var op = new $a801f2c896bd09f1$var$Split2({
                    childl: seg1$prime,
                    childr: $a801f2c896bd09f1$var$detachSegment(seg2)
                });
                return {
                    trans: {
                        id: tid,
                        edges: $a801f2c896bd09f1$var$parentEdges(seg1$prime.rslice),
                        is2nd: seg1.trans.is2nd
                    },
                    rslice: seg2.rslice,
                    op: op
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$mergeAtSlice = function(sliceId) {
    return function(model) {
        var tryMerge = function(leftSlice) {
            return function(v4) {
                return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$mkMerge(model.reduction.nextTransId)(leftSlice)(v4.seg1)(v4.seg2), $a801f2c896bd09f1$var$Nil.value));
            };
        };
        var matchSlice = function(v4) {
            if (v4 instanceof $a801f2c896bd09f1$var$Cons && v4.value1 instanceof $a801f2c896bd09f1$var$Cons) {
                var $1193 = $a801f2c896bd09f1$var$eq10(v4.value0.rslice.id)(sliceId);
                if ($1193) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Tuple({
                    seg1: v4.value0,
                    seg2: v4.value1.value0
                }, v4.value1.value1));
                return $a801f2c896bd09f1$var$Nothing.value;
            }
            return $a801f2c896bd09f1$var$Nothing.value;
        };
        var v3 = $a801f2c896bd09f1$var$doAt(matchSlice)(tryMerge)(model.reduction);
        if (v3 instanceof $a801f2c896bd09f1$var$Right) return new $a801f2c896bd09f1$var$Right({
            piece: model.piece,
            styles: model.styles,
            reduction: {
                nextSliceId: model.reduction.nextSliceId,
                start: model.reduction.start,
                segments: v3.value0,
                nextTransId: $a801f2c896bd09f1$var$incT(model.reduction.nextTransId)
            }
        });
        if (v3 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(v3.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 857, column 30 - line 859, column 23): " + [
            v3.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$defaultCSS = "";
var $a801f2c896bd09f1$var$emptyStyles = /* @__PURE__ */ function() {
    return {
        notes: $a801f2c896bd09f1$var$empty3,
        edges: $a801f2c896bd09f1$var$empty3,
        transitions: $a801f2c896bd09f1$var$empty3,
        slices: $a801f2c896bd09f1$var$empty3,
        css: $a801f2c896bd09f1$var$defaultCSS,
        staff: $a801f2c896bd09f1$var$GrandStaff.value
    };
}();
var $a801f2c896bd09f1$var$loadPiece = function(piece) {
    return {
        piece: piece,
        reduction: $a801f2c896bd09f1$var$thawPiece(piece),
        styles: $a801f2c896bd09f1$var$emptyStyles
    };
};
var $a801f2c896bd09f1$var$attachSegment = function(v3) {
    return function(rslice) {
        return {
            trans: v3.trans,
            op: v3.op,
            rslice: rslice
        };
    };
};
var $a801f2c896bd09f1$var$mkVert = function(v3) {
    return function(v1) {
        return function(v22) {
            return function(v32) {
                return function(v4) {
                    if (v22.rslice.notes instanceof $a801f2c896bd09f1$var$Inner && v32.rslice.notes instanceof $a801f2c896bd09f1$var$Inner) {
                        if (!$a801f2c896bd09f1$var$all4($a801f2c896bd09f1$var$isRepeatingEdge)(v32.trans.edges.regular)) return new $a801f2c896bd09f1$var$Left("Middle transition of a vert must only contain repetition and passing edges!");
                        if ($a801f2c896bd09f1$var$otherwise) {
                            var newNotes = function(counts) {
                                var pitches = $a801f2c896bd09f1$var$reverse2($a801f2c896bd09f1$var$concatMap(function(v5) {
                                    return $a801f2c896bd09f1$var$replicate(v5.value1)(v5.value0);
                                })($a801f2c896bd09f1$var$toUnfoldable13(counts)));
                                var mkNote = function(i2) {
                                    return function(p3) {
                                        return {
                                            note: {
                                                pitch: p3,
                                                id: "note" + ($a801f2c896bd09f1$var$show5(v1) + ("." + $a801f2c896bd09f1$var$show4(i2)))
                                            },
                                            expl: $a801f2c896bd09f1$var$NoExpl.value
                                        };
                                    };
                                };
                                return $a801f2c896bd09f1$var$mapWithIndex3(mkNote)(pitches);
                            };
                            var countPitches = function(notes) {
                                return $a801f2c896bd09f1$var$foldl6(function(counts) {
                                    return function(n) {
                                        return $a801f2c896bd09f1$var$insertWith2($a801f2c896bd09f1$var$add2)(n.note.pitch)(1)(counts);
                                    };
                                })($a801f2c896bd09f1$var$empty3)(notes);
                            };
                            var topSlice = {
                                notes: new $a801f2c896bd09f1$var$Inner(newNotes($a801f2c896bd09f1$var$unionWith2($a801f2c896bd09f1$var$max3)(countPitches(v22.rslice.notes.value0))(countPitches(v32.rslice.notes.value0)))),
                                id: v1,
                                x: (v22.rslice.x + v32.rslice.x) / 2,
                                parents: $a801f2c896bd09f1$var$NoParents.value
                            };
                            var childm = $a801f2c896bd09f1$var$setParents(new $a801f2c896bd09f1$var$VertParent(topSlice))(v32);
                            var mkLeftParent = function(lfound) {
                                var childl = $a801f2c896bd09f1$var$setParents(new $a801f2c896bd09f1$var$VertParent(topSlice))($a801f2c896bd09f1$var$attachSegment(lfound)(v22.rslice));
                                return $a801f2c896bd09f1$var$bind32($a801f2c896bd09f1$var$vertEdgesLeft(lfound.trans.edges)(childl.rslice))(function(leftEdges) {
                                    return $a801f2c896bd09f1$var$pure32({
                                        trans: {
                                            id: v3,
                                            is2nd: false,
                                            edges: leftEdges
                                        },
                                        op: new $a801f2c896bd09f1$var$Hori({
                                            childl: childl,
                                            childm: childm,
                                            childr: $a801f2c896bd09f1$var$detachSegment(v4)
                                        })
                                    });
                                });
                            };
                            return $a801f2c896bd09f1$var$bind32($a801f2c896bd09f1$var$vertEdgesRight(v4.trans.edges)(childm.rslice))(function(rightEdges) {
                                var rightParent = {
                                    trans: {
                                        id: $a801f2c896bd09f1$var$incT(v3),
                                        is2nd: true,
                                        edges: rightEdges
                                    },
                                    rslice: v4.rslice,
                                    op: $a801f2c896bd09f1$var$Freeze.value
                                };
                                return $a801f2c896bd09f1$var$pure32({
                                    mkLeftParent: mkLeftParent,
                                    rightParent: rightParent,
                                    topSlice: topSlice
                                });
                            });
                        }
                    }
                    return new $a801f2c896bd09f1$var$Left("Cannot vert an outer slice!");
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$undoMergeAtTrans = function(transId) {
    return function(model) {
        var tryUnmerge = function(v4) {
            return function(seg) {
                if (seg.op instanceof $a801f2c896bd09f1$var$Split2) return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$resetExpls($a801f2c896bd09f1$var$setParents($a801f2c896bd09f1$var$NoParents.value)(seg.op.value0.childl)), new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(seg.op.value0.childr)(seg.rslice), $a801f2c896bd09f1$var$Nil.value)));
                return new $a801f2c896bd09f1$var$Left("Operation is not a split!");
            };
        };
        var matchTrans = function(v4) {
            if (v4 instanceof $a801f2c896bd09f1$var$Cons) {
                var $1224 = $a801f2c896bd09f1$var$eq7(v4.value0.trans.id)(transId);
                if ($1224) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Tuple(v4.value0, v4.value1));
                return $a801f2c896bd09f1$var$Nothing.value;
            }
            return $a801f2c896bd09f1$var$Nothing.value;
        };
        var v3 = $a801f2c896bd09f1$var$doAt(matchTrans)(tryUnmerge)(model.reduction);
        if (v3 instanceof $a801f2c896bd09f1$var$Right) return new $a801f2c896bd09f1$var$Right({
            piece: model.piece,
            styles: model.styles,
            reduction: {
                nextSliceId: model.reduction.nextSliceId,
                nextTransId: model.reduction.nextTransId,
                start: model.reduction.start,
                segments: v3.value0
            }
        });
        if (v3 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(v3.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 1086, column 34 - line 1088, column 23): " + [
            v3.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$undoVertAtSlice = function(sliceId) {
    return function(model) {
        var tryReInsert = function(v3) {
            return function(v1) {
                return function(v22) {
                    return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$resetExpls($a801f2c896bd09f1$var$setParents($a801f2c896bd09f1$var$NoParents.value)({
                        trans: v22.pl.trans,
                        op: v22.pl.op,
                        rslice: v3.slicel
                    })), new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$resetExpls($a801f2c896bd09f1$var$setParents($a801f2c896bd09f1$var$NoParents.value)(v3.childm)), new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(v3.childr)(v22.pr.rslice), $a801f2c896bd09f1$var$Nil.value))));
                };
            };
        };
        var tryExtract = function(count) {
            return function(seg) {
                if (count <= 0) {
                    if (seg.op instanceof $a801f2c896bd09f1$var$Hori) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Right({
                        "seg'": $a801f2c896bd09f1$var$detachSegment(seg.op.value0.childl),
                        result: {
                            slicel: seg.op.value0.childl.rslice,
                            childm: seg.op.value0.childm,
                            childr: seg.op.value0.childr,
                            "pl'": seg.op.value0.childl.trans.edges
                        }
                    }));
                    if (seg.op instanceof $a801f2c896bd09f1$var$Freeze) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Left(count));
                    return new $a801f2c896bd09f1$var$Left("Could not find left parent edge. This is a bug!");
                }
                if ($a801f2c896bd09f1$var$otherwise) {
                    if (seg.op instanceof $a801f2c896bd09f1$var$Freeze) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Left(count));
                    if (seg.op instanceof $a801f2c896bd09f1$var$Split2) return $a801f2c896bd09f1$var$bind32(tryExtract(count)(seg.op.value0.childr))(function(resR) {
                        if (resR instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Right({
                            "seg'": {
                                trans: seg.trans,
                                op: new $a801f2c896bd09f1$var$Split2({
                                    childl: seg.op.value0.childl,
                                    childr: resR["value0"]["seg'"]
                                })
                            },
                            result: resR.value0.result
                        }));
                        if (resR instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$bind32(tryExtract(resR.value0 + 1 | 0)($a801f2c896bd09f1$var$detachSegment(seg.op.value0.childl)))(function(resL) {
                            if (resL instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Right({
                                "seg'": {
                                    trans: seg.trans,
                                    op: new $a801f2c896bd09f1$var$Split2({
                                        childl: $a801f2c896bd09f1$var$attachSegment(resL["value0"]["seg'"])(seg.op.value0.childl.rslice),
                                        childr: seg.op.value0.childr
                                    })
                                },
                                result: resL.value0.result
                            }));
                            if (resL instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Left(resL.value0));
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1176, column 15 - line 1178, column 50): " + [
                                resL.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1171, column 11 - line 1178, column 50): " + [
                            resR.constructor.name
                        ]);
                    });
                    if (seg.op instanceof $a801f2c896bd09f1$var$Hori) return $a801f2c896bd09f1$var$bind32(tryExtract(count - 1 | 0)(seg.op.value0.childr))(function(resR) {
                        if (resR instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Right({
                            "seg'": {
                                trans: seg.trans,
                                op: new $a801f2c896bd09f1$var$Hori({
                                    childl: seg.op.value0.childl,
                                    childm: seg.op.value0.childm,
                                    childr: resR["value0"]["seg'"]
                                })
                            },
                            result: resR.value0.result
                        }));
                        if (resR instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$bind32(tryExtract(resR.value0 + 1 | 0)($a801f2c896bd09f1$var$detachSegment(seg.op.value0.childm)))(function(resM) {
                            if (resM instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Right({
                                "seg'": {
                                    trans: seg.trans,
                                    op: new $a801f2c896bd09f1$var$Hori({
                                        childl: seg.op.value0.childl,
                                        childm: $a801f2c896bd09f1$var$attachSegment(resM["value0"]["seg'"])(seg.op.value0.childm.rslice),
                                        childr: seg.op.value0.childr
                                    })
                                },
                                result: resM.value0.result
                            }));
                            if (resM instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$bind32(tryExtract(resM.value0 + 1 | 0)($a801f2c896bd09f1$var$detachSegment(seg.op.value0.childl)))(function(resL) {
                                if (resL instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Right({
                                    "seg'": {
                                        trans: seg.trans,
                                        op: new $a801f2c896bd09f1$var$Hori({
                                            childl: $a801f2c896bd09f1$var$attachSegment(resL["value0"]["seg'"])(seg.op.value0.childl.rslice),
                                            childm: seg.op.value0.childm,
                                            childr: seg.op.value0.childr
                                        })
                                    },
                                    result: resL.value0.result
                                }));
                                if (resL instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Left(resL.value0));
                                throw new Error("Failed pattern match at ProtoVoices.Model (line 1192, column 19 - line 1194, column 54): " + [
                                    resL.constructor.name
                                ]);
                            });
                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1188, column 15 - line 1194, column 54): " + [
                                resM.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1182, column 11 - line 1194, column 54): " + [
                            resR.constructor.name
                        ]);
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1166, column 19 - line 1194, column 54): " + [
                        seg.op.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at ProtoVoices.Model (line 1152, column 3 - line 1155, column 143): " + [
                    count.constructor.name,
                    seg.constructor.name
                ]);
            };
        };
        var matchSlice = function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Cons && v3.value1 instanceof $a801f2c896bd09f1$var$Cons) {
                var $1279 = $a801f2c896bd09f1$var$eq10(v3.value0.rslice.id)(sliceId);
                if ($1279) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Tuple({
                    pl: v3.value0,
                    pr: v3.value1.value0
                }, v3.value1.value1));
                return $a801f2c896bd09f1$var$Nothing.value;
            }
            return $a801f2c896bd09f1$var$Nothing.value;
        };
        var insertPl = function(count) {
            return function(pl) {
                return function(seg) {
                    if (count <= 0) {
                        if (seg.op instanceof $a801f2c896bd09f1$var$Freeze) return new $a801f2c896bd09f1$var$Right({
                            "seg'": {
                                op: seg.op,
                                trans: {
                                    id: seg.trans.id,
                                    is2nd: seg.trans.is2nd,
                                    edges: pl
                                }
                            },
                            "pl'": pl
                        });
                        return new $a801f2c896bd09f1$var$Left("Invalid structure. This is a bug!");
                    }
                    if ($a801f2c896bd09f1$var$otherwise) {
                        if (seg.op instanceof $a801f2c896bd09f1$var$Freeze) return new $a801f2c896bd09f1$var$Right({
                            "seg'": seg,
                            "pl'": pl
                        });
                        if (seg.op instanceof $a801f2c896bd09f1$var$Split2) return $a801f2c896bd09f1$var$bind32(insertPl(count + 1 | 0)(pl)($a801f2c896bd09f1$var$detachSegment(seg.op.value0.childl)))(function(resL) {
                            return $a801f2c896bd09f1$var$bind32(insertPl(count)(resL["pl'"])(seg.op.value0.childr))(function(resR) {
                                return $a801f2c896bd09f1$var$pure32({
                                    "seg'": {
                                        trans: seg.trans,
                                        op: new $a801f2c896bd09f1$var$Split2({
                                            childl: $a801f2c896bd09f1$var$attachSegment(resL["seg'"])(seg.op.value0.childl.rslice),
                                            childr: resR["seg'"]
                                        })
                                    },
                                    "pl'": resR["pl'"]
                                });
                            });
                        });
                        if (seg.op instanceof $a801f2c896bd09f1$var$Hori) return $a801f2c896bd09f1$var$bind32(insertPl(count + 1 | 0)(pl)($a801f2c896bd09f1$var$detachSegment(seg.op.value0.childl)))(function(resL) {
                            return $a801f2c896bd09f1$var$bind32(insertPl(count)(resL["pl'"])($a801f2c896bd09f1$var$detachSegment(seg.op.value0.childm)))(function(resM) {
                                var $1292 = count === 1;
                                if ($1292) return $a801f2c896bd09f1$var$bind32($a801f2c896bd09f1$var$vertEdgesRight(resM["pl'"])(seg.op.value0.childm.rslice))(function(pl$prime) {
                                    return new $a801f2c896bd09f1$var$Right({
                                        "seg'": {
                                            trans: seg.trans,
                                            op: new $a801f2c896bd09f1$var$Hori({
                                                childl: $a801f2c896bd09f1$var$attachSegment(resL["seg'"])(seg.op.value0.childl.rslice),
                                                childm: $a801f2c896bd09f1$var$attachSegment(resM["seg'"])(seg.op.value0.childm.rslice),
                                                childr: {
                                                    op: seg.op.value0.childr.op,
                                                    trans: {
                                                        id: seg.op.value0.childr.trans.id,
                                                        is2nd: seg.op.value0.childr.trans.is2nd,
                                                        edges: resM["pl'"]
                                                    }
                                                }
                                            })
                                        },
                                        "pl'": pl$prime
                                    });
                                });
                                return $a801f2c896bd09f1$var$bind32(insertPl(count - 1 | 0)(resM["pl'"])(seg.op.value0.childr))(function(resR) {
                                    return new $a801f2c896bd09f1$var$Right({
                                        "seg'": {
                                            trans: seg.trans,
                                            op: new $a801f2c896bd09f1$var$Hori({
                                                childl: $a801f2c896bd09f1$var$attachSegment(resL["seg'"])(seg.op.value0.childl.rslice),
                                                childm: $a801f2c896bd09f1$var$attachSegment(resM["seg'"])(seg.op.value0.childm.rslice),
                                                childr: resR["seg'"]
                                            })
                                        },
                                        "pl'": resR["pl'"]
                                    });
                                });
                            });
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1211, column 19 - line 1247, column 16): " + [
                            seg.op.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1206, column 3 - line 1206, column 95): " + [
                        count.constructor.name,
                        pl.constructor.name,
                        seg.constructor.name
                    ]);
                };
            };
        };
        var fixPl = function(count) {
            return function(pl) {
                if (count >= 0) return function(v3) {
                    if (v3 instanceof $a801f2c896bd09f1$var$Nil) return $a801f2c896bd09f1$var$pure32($a801f2c896bd09f1$var$Nil.value);
                    if (v3 instanceof $a801f2c896bd09f1$var$Cons) return $a801f2c896bd09f1$var$bind32(insertPl(count)(pl)($a801f2c896bd09f1$var$detachSegment(v3.value0)))(function(v1) {
                        return $a801f2c896bd09f1$var$bind32(fixPl(count - 1 | 0)(v1["pl'"])(v3.value1))(function(tail$prime) {
                            return $a801f2c896bd09f1$var$pure32(new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(v1["seg'"])(v3.value0.rslice), tail$prime));
                        });
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1198, column 20 - line 1203, column 55): " + [
                        v3.constructor.name
                    ]);
                };
                if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$pure32;
                throw new Error("Failed pattern match at ProtoVoices.Model (line 1196, column 3 - line 1196, column 72): " + [
                    count.constructor.name,
                    pl.constructor.name
                ]);
            };
        };
        var extractVert = function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left("Could not find hori!");
            if (v3 instanceof $a801f2c896bd09f1$var$Cons && v3.value1 instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left("Could not find hori!");
            if (v3 instanceof $a801f2c896bd09f1$var$Cons && v3.value1 instanceof $a801f2c896bd09f1$var$Cons) {
                var $1308 = $a801f2c896bd09f1$var$eq10(v3.value0.rslice.id)(sliceId);
                if ($1308) {
                    var $1309 = $a801f2c896bd09f1$var$eq16(v3.value1.value0.op)($a801f2c896bd09f1$var$Freeze.value);
                    if ($1309) {
                        if (v3.value0.op instanceof $a801f2c896bd09f1$var$Hori) return new $a801f2c896bd09f1$var$Right({
                            tail: new $a801f2c896bd09f1$var$Cons({
                                op: v3.value0.op.value0.childl.op,
                                trans: v3.value0.op.value0.childl.trans,
                                rslice: v3.value0.rslice
                            }, new $a801f2c896bd09f1$var$Cons(v3.value1.value0, v3.value1.value1)),
                            result: new $a801f2c896bd09f1$var$Right({
                                slicel: v3.value0.op.value0.childl.rslice,
                                childm: v3.value0.op.value0.childm,
                                childr: v3.value0.op.value0.childr,
                                "pl'": v3.value0.op.value0.childl.trans.edges
                            }),
                            surfaceCount: 0
                        });
                        if (v3.value0.op instanceof $a801f2c896bd09f1$var$Freeze) return new $a801f2c896bd09f1$var$Right({
                            tail: new $a801f2c896bd09f1$var$Cons(v3.value0, new $a801f2c896bd09f1$var$Cons(v3.value1.value0, v3.value1.value1)),
                            result: new $a801f2c896bd09f1$var$Left(1),
                            surfaceCount: 1
                        });
                        return new $a801f2c896bd09f1$var$Left("Not a top-level hori!");
                    }
                    return new $a801f2c896bd09f1$var$Left("Not a top-level hori!");
                }
                return $a801f2c896bd09f1$var$bind32(extractVert(new $a801f2c896bd09f1$var$Cons(v3.value1.value0, v3.value1.value1)))(function(next) {
                    if (next.result instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$pure32({
                        tail: new $a801f2c896bd09f1$var$Cons(v3.value0, next.tail),
                        result: next.result,
                        surfaceCount: 0
                    });
                    if (next.result instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$bind32(tryExtract(next.result.value0)($a801f2c896bd09f1$var$detachSegment(v3.value0)))(function(pl$primeMaybe) {
                        if (pl$primeMaybe instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$pure32({
                            tail: new $a801f2c896bd09f1$var$Cons(v3.value0, next.tail),
                            result: new $a801f2c896bd09f1$var$Left(pl$primeMaybe.value0 + 1 | 0),
                            surfaceCount: next.surfaceCount + 1 | 0
                        });
                        if (pl$primeMaybe instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$bind32(fixPl(next.surfaceCount)(pl$primeMaybe["value0"]["result"]["pl'"])(new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(pl$primeMaybe["value0"]["seg'"])(v3.value0.rslice), next.tail)))(function(fixedTail) {
                            return $a801f2c896bd09f1$var$pure32({
                                tail: fixedTail,
                                result: new $a801f2c896bd09f1$var$Right(pl$primeMaybe.value0.result),
                                surfaceCount: 0
                            });
                        });
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1146, column 13 - line 1150, column 80): " + [
                            pl$primeMaybe.constructor.name
                        ]);
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1142, column 9 - line 1150, column 80): " + [
                        next.result.constructor.name
                    ]);
                });
            }
            throw new Error("Failed pattern match at ProtoVoices.Model (line 1112, column 17 - line 1150, column 80): " + [
                v3.constructor.name
            ]);
        };
        return $a801f2c896bd09f1$var$bind32(extractVert(model.reduction.segments))(function(v3) {
            if (v3.result instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$bind32($a801f2c896bd09f1$var$doAt(matchSlice)(tryReInsert(v3.result.value0))({
                start: model.reduction.start,
                nextTransId: model.reduction.nextTransId,
                nextSliceId: model.reduction.nextSliceId,
                segments: v3.tail
            }))(function(segments$prime$prime) {
                return $a801f2c896bd09f1$var$pure32({
                    piece: model.piece,
                    styles: model.styles,
                    reduction: {
                        nextSliceId: model.reduction.nextSliceId,
                        nextTransId: model.reduction.nextTransId,
                        start: model.reduction.start,
                        segments: segments$prime$prime
                    }
                });
            });
            if (v3.result instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left("Could not find left parent edge. This is a bug!");
            throw new Error("Failed pattern match at ProtoVoices.Model (line 1106, column 3 - line 1110, column 69): " + [
                v3.result.constructor.name
            ]);
        });
    };
};
var $a801f2c896bd09f1$var$vertAtMid = function(transId) {
    return function(model) {
        var insertDangling = function(dist) {
            return function(topSlice) {
                return function(mkLeftParent) {
                    return function(leftSlice) {
                        return function(segl) {
                            return function(segr) {
                                return function(tail2) {
                                    var v4 = function(v1) {
                                        if ($a801f2c896bd09f1$var$otherwise) {
                                            var fixRight = function(childm) {
                                                return function(childr) {
                                                    return $a801f2c896bd09f1$var$bind32($a801f2c896bd09f1$var$vertEdgesRight(childr.trans.edges)(childm.rslice))(function(edges$prime) {
                                                        return $a801f2c896bd09f1$var$pure32({
                                                            op: segr.op,
                                                            rslice: segr.rslice,
                                                            trans: {
                                                                id: segr.trans.id,
                                                                is2nd: segr.trans.is2nd,
                                                                edges: edges$prime
                                                            }
                                                        });
                                                    });
                                                };
                                            };
                                            if (segl.op instanceof $a801f2c896bd09f1$var$Freeze) return new $a801f2c896bd09f1$var$Right({
                                                "segl'": segl,
                                                "segr'": segr,
                                                "tail'": tail2,
                                                leftover: new $a801f2c896bd09f1$var$Just(0)
                                            });
                                            if (segl.op instanceof $a801f2c896bd09f1$var$Split2) return $a801f2c896bd09f1$var$bind32(insertDangling(dist)(topSlice)(mkLeftParent)(segl.op.value0.childl.rslice)($a801f2c896bd09f1$var$attachSegment(segl.op.value0.childr)(segl.rslice))(segr)(tail2))(function(v22) {
                                                return $a801f2c896bd09f1$var$bind32(function() {
                                                    var $1342 = dist === 0;
                                                    if ($1342) {
                                                        if (segl.op.value0.childl.rslice.parents instanceof $a801f2c896bd09f1$var$MergeParents) return new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$setParents(new $a801f2c896bd09f1$var$MergeParents({
                                                            left: leftSlice,
                                                            right: topSlice
                                                        }))($a801f2c896bd09f1$var$resetExpls(segl.op.value0.childl)));
                                                        return new $a801f2c896bd09f1$var$Left("invalid derivation structure: non-merge parents on merge slice");
                                                    }
                                                    return $a801f2c896bd09f1$var$pure32(segl.op.value0.childl);
                                                }())(function(childlFixed) {
                                                    if (v22.leftover instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure32({
                                                        "segl'": {
                                                            rslice: segl.rslice,
                                                            op: new $a801f2c896bd09f1$var$Split2({
                                                                childl: childlFixed,
                                                                childr: $a801f2c896bd09f1$var$detachSegment(v22["segl'"])
                                                            }),
                                                            trans: {
                                                                id: segl.trans.id,
                                                                is2nd: segl.trans.is2nd,
                                                                edges: $a801f2c896bd09f1$var$parentEdges(childlFixed.rslice)
                                                            }
                                                        },
                                                        "segr'": v22["segr'"],
                                                        "tail'": v22["tail'"],
                                                        leftover: $a801f2c896bd09f1$var$Nothing.value
                                                    });
                                                    if (v22.leftover instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$bind32(insertDangling((dist + v22.leftover.value0 | 0) + 1 | 0)(topSlice)(mkLeftParent)(leftSlice)(childlFixed)(v22["segl'"])(new $a801f2c896bd09f1$var$Cons(v22["segr'"], v22["tail'"])))(function(v32) {
                                                        if (v32["tail'"] instanceof $a801f2c896bd09f1$var$Cons) {
                                                            var segl$prime = {
                                                                rslice: segl.rslice,
                                                                op: new $a801f2c896bd09f1$var$Split2({
                                                                    childl: v32["segl'"],
                                                                    childr: $a801f2c896bd09f1$var$detachSegment(v32["segr'"])
                                                                }),
                                                                trans: {
                                                                    id: segl.trans.id,
                                                                    is2nd: segl.trans.is2nd,
                                                                    edges: $a801f2c896bd09f1$var$parentEdges(v32["segl'"].rslice)
                                                                }
                                                            };
                                                            return $a801f2c896bd09f1$var$pure32({
                                                                "segl'": segl$prime,
                                                                "segr'": v32["tail'"].value0,
                                                                "tail'": v32["tail'"].value1,
                                                                leftover: $a801f2c896bd09f1$var$map42(function(v42) {
                                                                    return v42 + 1 | 0;
                                                                })(v32.leftover)
                                                            });
                                                        }
                                                        return new $a801f2c896bd09f1$var$Left("Returned tail too short (splitLeft). This is a bug!");
                                                    });
                                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1003, column 13 - line 1029, column 82): " + [
                                                        v22.leftover.constructor.name
                                                    ]);
                                                });
                                            });
                                            if (segl.op instanceof $a801f2c896bd09f1$var$Hori) {
                                                if (segr.op instanceof $a801f2c896bd09f1$var$Hori) return new $a801f2c896bd09f1$var$Left("Not a leftmost derivation (Hori right of Hori)!");
                                                if (segr.op instanceof $a801f2c896bd09f1$var$Split2) return $a801f2c896bd09f1$var$bind32(insertDangling(dist)(topSlice)(mkLeftParent)(leftSlice)(segl)(segr.op.value0.childl)(new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(segr.op.value0.childr)(segr.rslice), tail2)))(function(v22) {
                                                    if (v22["tail'"] instanceof $a801f2c896bd09f1$var$Cons) {
                                                        var splitOp$prime = new $a801f2c896bd09f1$var$Split2({
                                                            childl: v22["segr'"],
                                                            childr: $a801f2c896bd09f1$var$detachSegment(v22["tail'"].value0)
                                                        });
                                                        return $a801f2c896bd09f1$var$pure32({
                                                            "segl'": v22["segl'"],
                                                            "segr'": {
                                                                rslice: segr.rslice,
                                                                op: splitOp$prime,
                                                                trans: {
                                                                    id: segr.trans.id,
                                                                    is2nd: segr.trans.is2nd,
                                                                    edges: $a801f2c896bd09f1$var$parentEdges(v22["segr'"].rslice)
                                                                }
                                                            },
                                                            "tail'": v22["tail'"].value1,
                                                            leftover: v22.leftover
                                                        });
                                                    }
                                                    return new $a801f2c896bd09f1$var$Left("Returned tail too short (splitRight). This is a bug!");
                                                });
                                                if (segr.op instanceof $a801f2c896bd09f1$var$Freeze) {
                                                    if (tail2 instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left("Tail too short (hori). This is a bug!");
                                                    if (tail2 instanceof $a801f2c896bd09f1$var$Cons) return $a801f2c896bd09f1$var$bind32(insertDangling(dist - 1 | 0)(topSlice)(mkLeftParent)(segl.op.value0.childm.rslice)($a801f2c896bd09f1$var$attachSegment(segl.op.value0.childr)(segl.rslice))(tail2.value0)(tail2.value1))(function(v22) {
                                                        var tail$primer = new $a801f2c896bd09f1$var$Cons(v22["segr'"], v22["tail'"]);
                                                        if (v22.leftover instanceof $a801f2c896bd09f1$var$Nothing) {
                                                            var op$prime = new $a801f2c896bd09f1$var$Hori({
                                                                childl: segl.op.value0.childl,
                                                                childm: segl.op.value0.childm,
                                                                childr: $a801f2c896bd09f1$var$detachSegment(v22["segl'"])
                                                            });
                                                            return $a801f2c896bd09f1$var$bind32(fixRight(segl.op.value0.childm)(v22["segl'"]))(function(segr$primer) {
                                                                return $a801f2c896bd09f1$var$pure32({
                                                                    "segl'": {
                                                                        rslice: segl.rslice,
                                                                        trans: segl.trans,
                                                                        op: op$prime
                                                                    },
                                                                    "segr'": segr$primer,
                                                                    "tail'": tail$primer,
                                                                    leftover: $a801f2c896bd09f1$var$Nothing.value
                                                                });
                                                            });
                                                        }
                                                        if (v22.leftover instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$bind32(insertDangling(dist + v22.leftover.value0 | 0)(topSlice)(mkLeftParent)(segl.op.value0.childl.rslice)(segl.op.value0.childm)(v22["segl'"])(tail$primer))(function(v32) {
                                                            if (v32.leftover instanceof $a801f2c896bd09f1$var$Nothing) {
                                                                var op$prime2 = new $a801f2c896bd09f1$var$Hori({
                                                                    childl: segl.op.value0.childl,
                                                                    childm: v32["segl'"],
                                                                    childr: $a801f2c896bd09f1$var$detachSegment(v32["segr'"])
                                                                });
                                                                return $a801f2c896bd09f1$var$bind32(fixRight(v32["segl'"])(v32["segr'"]))(function(segr$primem) {
                                                                    return $a801f2c896bd09f1$var$pure32({
                                                                        "segl'": {
                                                                            rslice: segl.rslice,
                                                                            trans: segl.trans,
                                                                            op: op$prime2
                                                                        },
                                                                        "segr'": segr$primem,
                                                                        "tail'": v32["tail'"],
                                                                        leftover: $a801f2c896bd09f1$var$Nothing.value
                                                                    });
                                                                });
                                                            }
                                                            if (v32.leftover instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$bind32(insertDangling((dist + 1 | 0) + v32.leftover.value0 | 0)(topSlice)(mkLeftParent)(leftSlice)(segl.op.value0.childl)(v32["segl'"])(new $a801f2c896bd09f1$var$Cons(v32["segr'"], v32["tail'"])))(function(v42) {
                                                                if (v42["tail'"] instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left("Returned tail too short (hori). This is a bug!");
                                                                if (v42["tail'"] instanceof $a801f2c896bd09f1$var$Cons) {
                                                                    var op$prime3 = new $a801f2c896bd09f1$var$Hori({
                                                                        childl: v42["segl'"],
                                                                        childm: v42["segr'"],
                                                                        childr: $a801f2c896bd09f1$var$detachSegment(v42["tail'"].value0)
                                                                    });
                                                                    return $a801f2c896bd09f1$var$bind32(fixRight(v42["segr'"])(v42["tail'"].value0))(function(segr$primel) {
                                                                        return $a801f2c896bd09f1$var$pure32({
                                                                            "segl'": {
                                                                                rslice: segl.rslice,
                                                                                trans: segl.trans,
                                                                                op: op$prime3
                                                                            },
                                                                            "segr'": segr$primel,
                                                                            "tail'": v42["tail'"].value1,
                                                                            leftover: $a801f2c896bd09f1$var$map42(function(v5) {
                                                                                return v5 + 2 | 0;
                                                                            })(v42.leftover)
                                                                        });
                                                                    });
                                                                }
                                                                throw new Error("Failed pattern match at ProtoVoices.Model (line 1072, column 25 - line 1078, column 119): " + [
                                                                    v42["tail'"].constructor.name
                                                                ]);
                                                            });
                                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 1062, column 21 - line 1078, column 119): " + [
                                                                v32.leftover.constructor.name
                                                            ]);
                                                        });
                                                        throw new Error("Failed pattern match at ProtoVoices.Model (line 1052, column 17 - line 1078, column 119): " + [
                                                            v22.leftover.constructor.name
                                                        ]);
                                                    });
                                                    throw new Error("Failed pattern match at ProtoVoices.Model (line 1044, column 23 - line 1078, column 119): " + [
                                                        tail2.constructor.name
                                                    ]);
                                                }
                                                throw new Error("Failed pattern match at ProtoVoices.Model (line 1031, column 46 - line 1078, column 119): " + [
                                                    segr.op.constructor.name
                                                ]);
                                            }
                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 988, column 9 - line 1078, column 119): " + [
                                                segl.op.constructor.name
                                            ]);
                                        }
                                        throw new Error("Failed pattern match at ProtoVoices.Model (line 912, column 1 - line 912, column 53): " + [
                                            dist.constructor.name,
                                            topSlice.constructor.name,
                                            mkLeftParent.constructor.name,
                                            leftSlice.constructor.name,
                                            segl.constructor.name,
                                            segr.constructor.name,
                                            tail2.constructor.name
                                        ]);
                                    };
                                    var $1409 = dist === 0;
                                    if ($1409) {
                                        var $1410 = !segl.trans.is2nd;
                                        if ($1410) return $a801f2c896bd09f1$var$bind32(mkLeftParent($a801f2c896bd09f1$var$detachSegment(segl)))(function(segl$prime) {
                                            return $a801f2c896bd09f1$var$pure32({
                                                "segl'": $a801f2c896bd09f1$var$attachSegment(segl$prime)(segl.rslice),
                                                "segr'": segr,
                                                "tail'": tail2,
                                                leftover: $a801f2c896bd09f1$var$Nothing.value
                                            });
                                        });
                                        return v4(true);
                                    }
                                    return v4(true);
                                };
                            };
                        };
                    };
                };
            };
        };
        var tryInsert = function(dist) {
            return function(topSlice) {
                return function(mkLeftParent) {
                    return function(leftSlice) {
                        return function(segl) {
                            return function(segr) {
                                return function(tail2) {
                                    return $a801f2c896bd09f1$var$bind32(insertDangling(dist)(topSlice)(mkLeftParent)(leftSlice)(segl)(segr)(tail2))(function(v4) {
                                        return $a801f2c896bd09f1$var$pure32(function() {
                                            if (v4.leftover instanceof $a801f2c896bd09f1$var$Nothing) return {
                                                "seg'": v4["segl'"],
                                                "tail'": new $a801f2c896bd09f1$var$Cons(v4["segr'"], v4["tail'"]),
                                                dangling: $a801f2c896bd09f1$var$Nothing.value
                                            };
                                            if (v4.leftover instanceof $a801f2c896bd09f1$var$Just) return {
                                                "seg'": v4["segl'"],
                                                "tail'": new $a801f2c896bd09f1$var$Cons(v4["segr'"], v4["tail'"]),
                                                dangling: new $a801f2c896bd09f1$var$Just({
                                                    dist: (dist + 1 | 0) + v4.leftover.value0 | 0,
                                                    mkLeftParent: mkLeftParent,
                                                    topSlice: topSlice
                                                })
                                            };
                                            throw new Error("Failed pattern match at ProtoVoices.Model (line 964, column 10 - line 966, column 120): " + [
                                                v4.leftover.constructor.name
                                            ]);
                                        }());
                                    });
                                };
                            };
                        };
                    };
                };
            };
        };
        var doVert = function(v4) {
            return function(v1) {
                if (v1 instanceof $a801f2c896bd09f1$var$Cons && v1.value1 instanceof $a801f2c896bd09f1$var$Cons && v1.value1.value1 instanceof $a801f2c896bd09f1$var$Cons) {
                    if ($a801f2c896bd09f1$var$eq7(v1.value1.value0.trans.id)(transId)) return $a801f2c896bd09f1$var$bind32($a801f2c896bd09f1$var$mkVert(model.reduction.nextTransId)(model.reduction.nextSliceId)(v1.value0)(v1.value1.value0)(v1.value1.value1.value0))(function(v22) {
                        return tryInsert(0)(v22.topSlice)(v22.mkLeftParent)(v4)({
                            trans: v1.value0.trans,
                            op: v1.value0.op,
                            rslice: v22.topSlice
                        })(v22.rightParent)(v1.value1.value1.value1);
                    });
                    if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$bind32(doVert(v1.value0.rslice)(v1.value1))(function(v22) {
                        if (v22.dangling instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Right({
                            "seg'": v1.value0,
                            "tail'": new $a801f2c896bd09f1$var$Cons(v22["seg'"], v22["tail'"]),
                            dangling: $a801f2c896bd09f1$var$Nothing.value
                        });
                        if (v22.dangling instanceof $a801f2c896bd09f1$var$Just) return tryInsert(v22.dangling.value0.dist)(v22.dangling.value0.topSlice)(v22.dangling.value0.mkLeftParent)(v4)(v1.value0)(v22["seg'"])(v22["tail'"]);
                        throw new Error("Failed pattern match at ProtoVoices.Model (line 944, column 9 - line 946, column 110): " + [
                            v22.dangling.constructor.name
                        ]);
                    });
                }
                return new $a801f2c896bd09f1$var$Left("Cannot hori at " + $a801f2c896bd09f1$var$show24(transId));
            };
        };
        var v3 = doVert(model.reduction.start)(model.reduction.segments);
        if (v3 instanceof $a801f2c896bd09f1$var$Right) {
            if (v3.value0.dangling instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Right({
                piece: model.piece,
                styles: model.styles,
                reduction: {
                    start: model.reduction.start,
                    segments: new $a801f2c896bd09f1$var$Cons(v3["value0"]["seg'"], v3["value0"]["tail'"]),
                    nextTransId: $a801f2c896bd09f1$var$incT($a801f2c896bd09f1$var$incT(model.reduction.nextTransId)),
                    nextSliceId: $a801f2c896bd09f1$var$incS(model.reduction.nextSliceId)
                }
            });
            if (v3.value0.dangling instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Left("Failed to insert hori!");
            throw new Error("Failed pattern match at ProtoVoices.Model (line 914, column 38 - line 924, column 52): " + [
                v3.value0.dangling.constructor.name
            ]);
        }
        if (v3 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(v3.value0);
        throw new Error("Failed pattern match at ProtoVoices.Model (line 913, column 27 - line 925, column 23): " + [
            v3.constructor.name
        ]);
    };
};
// output/App.Common/index.js
var $a801f2c896bd09f1$var$showRecord5 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord()();
var $a801f2c896bd09f1$var$eq17 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqSliceId);
var $a801f2c896bd09f1$var$eq22 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqTransId);
var $a801f2c896bd09f1$var$eq32 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqNoteExplanation);
var $a801f2c896bd09f1$var$eq42 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqPitch($a801f2c896bd09f1$var$eqSInterval));
var $a801f2c896bd09f1$var$eq5 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqParents($a801f2c896bd09f1$var$eqSliceId));
var $a801f2c896bd09f1$var$HelpTab = /* @__PURE__ */ function() {
    function HelpTab2() {}
    HelpTab2.value = new HelpTab2();
    return HelpTab2;
}();
var $a801f2c896bd09f1$var$ImportTab = /* @__PURE__ */ function() {
    function ImportTab2() {}
    ImportTab2.value = new ImportTab2();
    return ImportTab2;
}();
var $a801f2c896bd09f1$var$ExportTab = /* @__PURE__ */ function() {
    function ExportTab2() {}
    ExportTab2.value = new ExportTab2();
    return ExportTab2;
}();
var $a801f2c896bd09f1$var$StyleTab = /* @__PURE__ */ function() {
    function StyleTab2() {}
    StyleTab2.value = new StyleTab2();
    return StyleTab2;
}();
var $a801f2c896bd09f1$var$SettingsTab = /* @__PURE__ */ function() {
    function SettingsTab2() {}
    SettingsTab2.value = new SettingsTab2();
    return SettingsTab2;
}();
var $a801f2c896bd09f1$var$SVGTab = /* @__PURE__ */ function() {
    function SVGTab2() {}
    SVGTab2.value = new SVGTab2();
    return SVGTab2;
}();
var $a801f2c896bd09f1$var$DebugTab = /* @__PURE__ */ function() {
    function DebugTab2() {}
    DebugTab2.value = new DebugTab2();
    return DebugTab2;
}();
var $a801f2c896bd09f1$var$SelNone = /* @__PURE__ */ function() {
    function SelNone2() {}
    SelNone2.value = new SelNone2();
    return SelNone2;
}();
var $a801f2c896bd09f1$var$SelSlice = /* @__PURE__ */ function() {
    function SelSlice2(value0) {
        this.value0 = value0;
    }
    SelSlice2.create = function(value0) {
        return new SelSlice2(value0);
    };
    return SelSlice2;
}();
var $a801f2c896bd09f1$var$SelTrans = /* @__PURE__ */ function() {
    function SelTrans2(value0) {
        this.value0 = value0;
    }
    SelTrans2.create = function(value0) {
        return new SelTrans2(value0);
    };
    return SelTrans2;
}();
var $a801f2c896bd09f1$var$SelNote = /* @__PURE__ */ function() {
    function SelNote2(value0) {
        this.value0 = value0;
    }
    SelNote2.create = function(value0) {
        return new SelNote2(value0);
    };
    return SelNote2;
}();
var $a801f2c896bd09f1$var$ImportPiece = /* @__PURE__ */ function() {
    function ImportPiece2(value0) {
        this.value0 = value0;
    }
    ImportPiece2.create = function(value0) {
        return new ImportPiece2(value0);
    };
    return ImportPiece2;
}();
var $a801f2c896bd09f1$var$ImportModel = /* @__PURE__ */ function() {
    function ImportModel2(value0) {
        this.value0 = value0;
    }
    ImportModel2.create = function(value0) {
        return new ImportModel2(value0);
    };
    return ImportModel2;
}();
var $a801f2c896bd09f1$var$NoOp = /* @__PURE__ */ function() {
    function NoOp2() {}
    NoOp2.value = new NoOp2();
    return NoOp2;
}();
var $a801f2c896bd09f1$var$Init = /* @__PURE__ */ function() {
    function Init2() {}
    Init2.value = new Init2();
    return Init2;
}();
var $a801f2c896bd09f1$var$HandleImport = /* @__PURE__ */ function() {
    function HandleImport2(value0) {
        this.value0 = value0;
    }
    HandleImport2.create = function(value0) {
        return new HandleImport2(value0);
    };
    return HandleImport2;
}();
var $a801f2c896bd09f1$var$HandleSettings = /* @__PURE__ */ function() {
    function HandleSettings2(value0) {
        this.value0 = value0;
    }
    HandleSettings2.create = function(value0) {
        return new HandleSettings2(value0);
    };
    return HandleSettings2;
}();
var $a801f2c896bd09f1$var$HandleStyle = /* @__PURE__ */ function() {
    function HandleStyle2(value0) {
        this.value0 = value0;
    }
    HandleStyle2.create = function(value0) {
        return new HandleStyle2(value0);
    };
    return HandleStyle2;
}();
var $a801f2c896bd09f1$var$SwitchTab = /* @__PURE__ */ function() {
    function SwitchTab2(value0) {
        this.value0 = value0;
    }
    SwitchTab2.create = function(value0) {
        return new SwitchTab2(value0);
    };
    return SwitchTab2;
}();
var $a801f2c896bd09f1$var$HandleKey = /* @__PURE__ */ function() {
    function HandleKey2(value0) {
        this.value0 = value0;
    }
    HandleKey2.create = function(value0) {
        return new HandleKey2(value0);
    };
    return HandleKey2;
}();
var $a801f2c896bd09f1$var$HandleScroll = /* @__PURE__ */ function() {
    function HandleScroll2(value0) {
        this.value0 = value0;
    }
    HandleScroll2.create = function(value0) {
        return new HandleScroll2(value0);
    };
    return HandleScroll2;
}();
var $a801f2c896bd09f1$var$Select = /* @__PURE__ */ function() {
    function Select2(value0) {
        this.value0 = value0;
    }
    Select2.create = function(value0) {
        return new Select2(value0);
    };
    return Select2;
}();
var $a801f2c896bd09f1$var$MergeAtSelected = /* @__PURE__ */ function() {
    function MergeAtSelected2() {}
    MergeAtSelected2.value = new MergeAtSelected2();
    return MergeAtSelected2;
}();
var $a801f2c896bd09f1$var$VertAtSelected = /* @__PURE__ */ function() {
    function VertAtSelected2() {}
    VertAtSelected2.value = new VertAtSelected2();
    return VertAtSelected2;
}();
var $a801f2c896bd09f1$var$UnMergeAtSelected = /* @__PURE__ */ function() {
    function UnMergeAtSelected2() {}
    UnMergeAtSelected2.value = new UnMergeAtSelected2();
    return UnMergeAtSelected2;
}();
var $a801f2c896bd09f1$var$UnVertAtSelected = /* @__PURE__ */ function() {
    function UnVertAtSelected2() {}
    UnVertAtSelected2.value = new UnVertAtSelected2();
    return UnVertAtSelected2;
}();
var $a801f2c896bd09f1$var$CombineAny = /* @__PURE__ */ function() {
    function CombineAny2() {}
    CombineAny2.value = new CombineAny2();
    return CombineAny2;
}();
var $a801f2c896bd09f1$var$RemoveAny = /* @__PURE__ */ function() {
    function RemoveAny2() {}
    RemoveAny2.value = new RemoveAny2();
    return RemoveAny2;
}();
var $a801f2c896bd09f1$var$SetNoteExplanation = /* @__PURE__ */ function() {
    function SetNoteExplanation2(value0) {
        this.value0 = value0;
    }
    SetNoteExplanation2.create = function(value0) {
        return new SetNoteExplanation2(value0);
    };
    return SetNoteExplanation2;
}();
var $a801f2c896bd09f1$var$Undo = /* @__PURE__ */ function() {
    function Undo2() {}
    Undo2.value = new Undo2();
    return Undo2;
}();
var $a801f2c896bd09f1$var$Redo = /* @__PURE__ */ function() {
    function Redo2() {}
    Redo2.value = new Redo2();
    return Redo2;
}();
var $a801f2c896bd09f1$var$RegisterScoreElt = /* @__PURE__ */ function() {
    function RegisterScoreElt2(value0) {
        this.value0 = value0;
    }
    RegisterScoreElt2.create = function(value0) {
        return new RegisterScoreElt2(value0);
    };
    return RegisterScoreElt2;
}();
var $a801f2c896bd09f1$var$removeParent = function(note2) {
    return function(expl) {
        return function(setParent) {
            var mkAction = function(e$prime) {
                return new $a801f2c896bd09f1$var$SetNoteExplanation({
                    noteId: note2.id,
                    expl: e$prime
                });
            };
            return $a801f2c896bd09f1$var$maybe($a801f2c896bd09f1$var$NoOp.value)(mkAction)(setParent(note2.pitch)($a801f2c896bd09f1$var$Nothing.value)(expl));
        };
    };
};
var $a801f2c896bd09f1$var$outerSelected = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$SelSlice) return true;
    if (v3 instanceof $a801f2c896bd09f1$var$SelTrans) return true;
    return false;
};
var $a801f2c896bd09f1$var$noteIsSelected = function(v3) {
    return function(v1) {
        if (v3 instanceof $a801f2c896bd09f1$var$SelNote && v1 instanceof $a801f2c896bd09f1$var$Inner) return v3.value0.note.id === v1.value0.id;
        return false;
    };
};
var $a801f2c896bd09f1$var$getSelTrans = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$SelTrans) return new $a801f2c896bd09f1$var$Just(v3.value0);
    return $a801f2c896bd09f1$var$Nothing.value;
};
var $a801f2c896bd09f1$var$getSelSlice = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$SelSlice) return new $a801f2c896bd09f1$var$Just(v3.value0);
    return $a801f2c896bd09f1$var$Nothing.value;
};
var $a801f2c896bd09f1$var$genericOuterSelection = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$SelNone.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$SelSlice(x4.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$SelTrans(x4.value0.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr) return new $a801f2c896bd09f1$var$SelNote(x4.value0.value0.value0);
        throw new Error("Failed pattern match at App.Common (line 52, column 1 - line 52, column 61): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$SelNone) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$SelSlice) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0));
        if (x4 instanceof $a801f2c896bd09f1$var$SelTrans) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0)));
        if (x4 instanceof $a801f2c896bd09f1$var$SelNote) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(x4.value0)));
        throw new Error("Failed pattern match at App.Common (line 52, column 1 - line 52, column 61): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow6 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericOuterSelection)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsNoArguments)({
    reflectSymbol: function() {
        return "SelNone";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument($a801f2c896bd09f1$var$showSliceId))({
    reflectSymbol: function() {
        return "SelSlice";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument($a801f2c896bd09f1$var$showTransId))({
    reflectSymbol: function() {
        return "SelTrans";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord5(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "expl";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "note";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "parents";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "slice";
    }
})($a801f2c896bd09f1$var$showSliceId))(/* @__PURE__ */ $a801f2c896bd09f1$var$showParents($a801f2c896bd09f1$var$showSliceId)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord5(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "id";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "pitch";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval)))($a801f2c896bd09f1$var$showString))))($a801f2c896bd09f1$var$showNoteExplanation))))({
    reflectSymbol: function() {
        return "SelNote";
    }
})))));
var $a801f2c896bd09f1$var$showOuterSelection = {
    show: function(os) {
        return $a801f2c896bd09f1$var$genericShow6(os);
    }
};
var $a801f2c896bd09f1$var$eqTab = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$HelpTab && y4 instanceof $a801f2c896bd09f1$var$HelpTab) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$ImportTab && y4 instanceof $a801f2c896bd09f1$var$ImportTab) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$ExportTab && y4 instanceof $a801f2c896bd09f1$var$ExportTab) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$StyleTab && y4 instanceof $a801f2c896bd09f1$var$StyleTab) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$SettingsTab && y4 instanceof $a801f2c896bd09f1$var$SettingsTab) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$SVGTab && y4 instanceof $a801f2c896bd09f1$var$SVGTab) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$DebugTab && y4 instanceof $a801f2c896bd09f1$var$DebugTab) return true;
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$eqOuterSelection = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$SelNone && y4 instanceof $a801f2c896bd09f1$var$SelNone) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$SelSlice && y4 instanceof $a801f2c896bd09f1$var$SelSlice) return $a801f2c896bd09f1$var$eq17(x4.value0)(y4.value0);
            if (x4 instanceof $a801f2c896bd09f1$var$SelTrans && y4 instanceof $a801f2c896bd09f1$var$SelTrans) return $a801f2c896bd09f1$var$eq22(x4.value0)(y4.value0);
            if (x4 instanceof $a801f2c896bd09f1$var$SelNote && y4 instanceof $a801f2c896bd09f1$var$SelNote) return $a801f2c896bd09f1$var$eq32(x4.value0.expl)(y4.value0.expl) && x4.value0.note.id === y4.value0.note.id && $a801f2c896bd09f1$var$eq42(x4.value0.note.pitch)(y4.value0.note.pitch) && $a801f2c896bd09f1$var$eq5(x4.value0.parents)(y4.value0.parents) && $a801f2c896bd09f1$var$eq17(x4.value0.slice)(y4.value0.slice);
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$defaultSettings = {
    flatHori: true,
    showAllEdges: true,
    showScore: true,
    xscale: 0,
    yscale: 0
};
var $a801f2c896bd09f1$var$addParentToNote = function(sel) {
    return function(sliceId) {
        return function(parNote) {
            var v3 = function(v12) {
                if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$NoOp.value;
                throw new Error("Failed pattern match at App.Common (line 93, column 1 - line 93, column 63): " + [
                    sel.constructor.name,
                    sliceId.constructor.name,
                    parNote.constructor.name
                ]);
            };
            if (sel instanceof $a801f2c896bd09f1$var$SelNote) {
                var setExpl = function(e) {
                    return new $a801f2c896bd09f1$var$SetNoteExplanation({
                        noteId: sel.value0.note.id,
                        expl: e
                    });
                };
                var v1 = function(v22) {
                    var v32 = function(v4) {
                        if (sel.value0.parents instanceof $a801f2c896bd09f1$var$MergeParents && $a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$NoOp.value;
                        var v5 = function(v6) {
                            if (sel.value0.parents instanceof $a801f2c896bd09f1$var$VertParent && $a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$NoOp.value;
                            if (sel.value0.parents instanceof $a801f2c896bd09f1$var$NoParents) return $a801f2c896bd09f1$var$NoOp.value;
                            throw new Error("Failed pattern match at App.Common (line 93, column 1 - line 93, column 63): " + [
                                sel.value0.parents.constructor.name
                            ]);
                        };
                        if (sel.value0.parents instanceof $a801f2c896bd09f1$var$VertParent) {
                            var $145 = $a801f2c896bd09f1$var$eq17(sliceId)(sel.value0.parents.value0);
                            if ($145) {
                                var $146 = $a801f2c896bd09f1$var$setHoriExplParent(sel.value0.note.pitch)(new $a801f2c896bd09f1$var$Just(parNote))(sel.value0.expl);
                                if ($146 instanceof $a801f2c896bd09f1$var$Just) return setExpl($146.value0);
                                return v5(true);
                            }
                            return v5(true);
                        }
                        return v5(true);
                    };
                    if (sel.value0.parents instanceof $a801f2c896bd09f1$var$MergeParents) {
                        var $150 = $a801f2c896bd09f1$var$eq17(sliceId)(sel.value0.parents.value0.right);
                        if ($150) {
                            var $151 = $a801f2c896bd09f1$var$setRightExplParent(sel.value0.note.pitch)(new $a801f2c896bd09f1$var$Just(parNote))(sel.value0.expl);
                            if ($151 instanceof $a801f2c896bd09f1$var$Just) return setExpl($151.value0);
                            return v32(true);
                        }
                        return v32(true);
                    }
                    return v32(true);
                };
                if (sel.value0.parents instanceof $a801f2c896bd09f1$var$MergeParents) {
                    var $157 = $a801f2c896bd09f1$var$eq17(sliceId)(sel.value0.parents.value0.left);
                    if ($157) {
                        var $158 = $a801f2c896bd09f1$var$setLeftExplParent(sel.value0.note.pitch)(new $a801f2c896bd09f1$var$Just(parNote))(sel.value0.expl);
                        if ($158 instanceof $a801f2c896bd09f1$var$Just) return setExpl($158.value0);
                        return v1(true);
                    }
                    return v1(true);
                }
                return v1(true);
            }
            return v3(true);
        };
    };
};
// output/App.Utils/foreign.js
var $a801f2c896bd09f1$var$import_downloadjs = $a801f2c896bd09f1$var$__toESM($a801f2c896bd09f1$var$require_download(), 1);
// node_modules/@runno/wasi/dist/wasi.js
var $a801f2c896bd09f1$var$lt = Object.defineProperty;
var $a801f2c896bd09f1$var$dt = (e, t2, i2)=>t2 in e ? $a801f2c896bd09f1$var$lt(e, t2, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: i2
    }) : e[t2] = i2;
var $a801f2c896bd09f1$var$m = (e, t2, i2)=>($a801f2c896bd09f1$var$dt(e, typeof t2 != "symbol" ? t2 + "" : t2, i2), i2);
var $a801f2c896bd09f1$var$c;
(function(e) {
    e[e.SUCCESS = 0] = "SUCCESS", e[e.E2BIG = 1] = "E2BIG", e[e.EACCESS = 2] = "EACCESS", e[e.EADDRINUSE = 3] = "EADDRINUSE", e[e.EADDRNOTAVAIL = 4] = "EADDRNOTAVAIL", e[e.EAFNOSUPPORT = 5] = "EAFNOSUPPORT", e[e.EAGAIN = 6] = "EAGAIN", e[e.EALREADY = 7] = "EALREADY", e[e.EBADF = 8] = "EBADF", e[e.EBADMSG = 9] = "EBADMSG", e[e.EBUSY = 10] = "EBUSY", e[e.ECANCELED = 11] = "ECANCELED", e[e.ECHILD = 12] = "ECHILD", e[e.ECONNABORTED = 13] = "ECONNABORTED", e[e.ECONNREFUSED = 14] = "ECONNREFUSED", e[e.ECONNRESET = 15] = "ECONNRESET", e[e.EDEADLK = 16] = "EDEADLK", e[e.EDESTADDRREQ = 17] = "EDESTADDRREQ", e[e.EDOM = 18] = "EDOM", e[e.EDQUOT = 19] = "EDQUOT", e[e.EEXIST = 20] = "EEXIST", e[e.EFAULT = 21] = "EFAULT", e[e.EFBIG = 22] = "EFBIG", e[e.EHOSTUNREACH = 23] = "EHOSTUNREACH", e[e.EIDRM = 24] = "EIDRM", e[e.EILSEQ = 25] = "EILSEQ", e[e.EINPROGRESS = 26] = "EINPROGRESS", e[e.EINTR = 27] = "EINTR", e[e.EINVAL = 28] = "EINVAL", e[e.EIO = 29] = "EIO", e[e.EISCONN = 30] = "EISCONN", e[e.EISDIR = 31] = "EISDIR", e[e.ELOOP = 32] = "ELOOP", e[e.EMFILE = 33] = "EMFILE", e[e.EMLINK = 34] = "EMLINK", e[e.EMSGSIZE = 35] = "EMSGSIZE", e[e.EMULTIHOP = 36] = "EMULTIHOP", e[e.ENAMETOOLONG = 37] = "ENAMETOOLONG", e[e.ENETDOWN = 38] = "ENETDOWN", e[e.ENETRESET = 39] = "ENETRESET", e[e.ENETUNREACH = 40] = "ENETUNREACH", e[e.ENFILE = 41] = "ENFILE", e[e.ENOBUFS = 42] = "ENOBUFS", e[e.ENODEV = 43] = "ENODEV", e[e.ENOENT = 44] = "ENOENT", e[e.ENOEXEC = 45] = "ENOEXEC", e[e.ENOLCK = 46] = "ENOLCK", e[e.ENOLINK = 47] = "ENOLINK", e[e.ENOMEM = 48] = "ENOMEM", e[e.ENOMSG = 49] = "ENOMSG", e[e.ENOPROTOOPT = 50] = "ENOPROTOOPT", e[e.ENOSPC = 51] = "ENOSPC", e[e.ENOSYS = 52] = "ENOSYS", e[e.ENOTCONN = 53] = "ENOTCONN", e[e.ENOTDIR = 54] = "ENOTDIR", e[e.ENOTEMPTY = 55] = "ENOTEMPTY", e[e.ENOTRECOVERABLE = 56] = "ENOTRECOVERABLE", e[e.ENOTSOCK = 57] = "ENOTSOCK", e[e.ENOTSUP = 58] = "ENOTSUP", e[e.ENOTTY = 59] = "ENOTTY", e[e.ENXIO = 60] = "ENXIO", e[e.EOVERFLOW = 61] = "EOVERFLOW", e[e.EOWNERDEAD = 62] = "EOWNERDEAD", e[e.EPERM = 63] = "EPERM", e[e.EPIPE = 64] = "EPIPE", e[e.EPROTO = 65] = "EPROTO", e[e.EPROTONOSUPPORT = 66] = "EPROTONOSUPPORT", e[e.EPROTOTYPE = 67] = "EPROTOTYPE", e[e.ERANGE = 68] = "ERANGE", e[e.EROFS = 69] = "EROFS", e[e.ESPIPE = 70] = "ESPIPE", e[e.ESRCH = 71] = "ESRCH", e[e.ESTALE = 72] = "ESTALE", e[e.ETIMEDOUT = 73] = "ETIMEDOUT", e[e.ETXTBSY = 74] = "ETXTBSY", e[e.EXDEV = 75] = "EXDEV", e[e.ENOTCAPABLE = 76] = "ENOTCAPABLE";
})($a801f2c896bd09f1$var$c || ($a801f2c896bd09f1$var$c = {}));
var $a801f2c896bd09f1$var$G;
(function(e) {
    e[e.REALTIME = 0] = "REALTIME", e[e.MONOTONIC = 1] = "MONOTONIC", e[e.PROCESS_CPUTIME_ID = 2] = "PROCESS_CPUTIME_ID", e[e.THREAD_CPUTIME_ID = 3] = "THREAD_CPUTIME_ID";
})($a801f2c896bd09f1$var$G || ($a801f2c896bd09f1$var$G = {}));
var $a801f2c896bd09f1$var$y;
(function(e) {
    e[e.SET = 0] = "SET", e[e.CUR = 1] = "CUR", e[e.END = 2] = "END";
})($a801f2c896bd09f1$var$y || ($a801f2c896bd09f1$var$y = {}));
var $a801f2c896bd09f1$var$R;
(function(e) {
    e[e.UNKNOWN = 0] = "UNKNOWN", e[e.BLOCK_DEVICE = 1] = "BLOCK_DEVICE", e[e.CHARACTER_DEVICE = 2] = "CHARACTER_DEVICE", e[e.DIRECTORY = 3] = "DIRECTORY", e[e.REGULAR_FILE = 4] = "REGULAR_FILE", e[e.SOCKET_DGRAM = 5] = "SOCKET_DGRAM", e[e.SOCKET_STREAM = 6] = "SOCKET_STREAM", e[e.SYMBOLIC_LINK = 7] = "SYMBOLIC_LINK";
})($a801f2c896bd09f1$var$R || ($a801f2c896bd09f1$var$R = {}));
var $a801f2c896bd09f1$var$Q;
(function(e) {
    e[e.DIR = 0] = "DIR";
})($a801f2c896bd09f1$var$Q || ($a801f2c896bd09f1$var$Q = {}));
var $a801f2c896bd09f1$var$p;
(function(e) {
    e[e.CLOCK = 0] = "CLOCK", e[e.FD_READ = 1] = "FD_READ", e[e.FD_WRITE = 2] = "FD_WRITE";
})($a801f2c896bd09f1$var$p || ($a801f2c896bd09f1$var$p = {}));
var $a801f2c896bd09f1$var$T = {
    CREAT: 1,
    DIRECTORY: 2,
    EXCL: 4,
    TRUNC: 8
};
var $a801f2c896bd09f1$var$E = {
    APPEND: 1,
    DSYNC: 2,
    NONBLOCK: 4,
    RSYNC: 8,
    SYNC: 16
};
var $a801f2c896bd09f1$var$o = {
    FD_DATASYNC: BigInt(1) << BigInt(0),
    FD_READ: BigInt(1) << BigInt(1),
    FD_SEEK: BigInt(1) << BigInt(2),
    FD_FDSTAT_SET_FLAGS: BigInt(1) << BigInt(3),
    FD_SYNC: BigInt(1) << BigInt(4),
    FD_TELL: BigInt(1) << BigInt(5),
    FD_WRITE: BigInt(1) << BigInt(6),
    FD_ADVISE: BigInt(1) << BigInt(7),
    FD_ALLOCATE: BigInt(1) << BigInt(8),
    PATH_CREATE_DIRECTORY: BigInt(1) << BigInt(9),
    PATH_CREATE_FILE: BigInt(1) << BigInt(10),
    PATH_LINK_SOURCE: BigInt(1) << BigInt(11),
    PATH_LINK_TARGET: BigInt(1) << BigInt(12),
    PATH_OPEN: BigInt(1) << BigInt(13),
    FD_READDIR: BigInt(1) << BigInt(14),
    PATH_READLINK: BigInt(1) << BigInt(15),
    PATH_RENAME_SOURCE: BigInt(1) << BigInt(16),
    PATH_RENAME_TARGET: BigInt(1) << BigInt(17),
    PATH_FILESTAT_GET: BigInt(1) << BigInt(18),
    PATH_FILESTAT_SET_SIZE: BigInt(1) << BigInt(19),
    PATH_FILESTAT_SET_TIMES: BigInt(1) << BigInt(20),
    FD_FILESTAT_GET: BigInt(1) << BigInt(21),
    FD_FILESTAT_SET_SIZE: BigInt(1) << BigInt(22),
    FD_FILESTAT_SET_TIMES: BigInt(1) << BigInt(23),
    PATH_SYMLINK: BigInt(1) << BigInt(24),
    PATH_REMOVE_DIRECTORY: BigInt(1) << BigInt(25),
    PATH_UNLINK_FILE: BigInt(1) << BigInt(26),
    POLL_FD_READWRITE: BigInt(1) << BigInt(27),
    SOCK_SHUTDOWN: BigInt(1) << BigInt(28),
    SOCK_ACCEPT: BigInt(1) << BigInt(29)
};
var $a801f2c896bd09f1$var$U = {
    ATIM: 1,
    ATIM_NOW: 2,
    MTIM: 4,
    MTIM_NOW: 8
};
var $a801f2c896bd09f1$var$et = {
    SUBSCRIPTION_CLOCK_ABSTIME: 1
};
var $a801f2c896bd09f1$var$P = 64;
var $a801f2c896bd09f1$var$x = 48;
var $a801f2c896bd09f1$var$z = 32;
var $a801f2c896bd09f1$var$C;
(function(e) {
    e[e.CUR = 0] = "CUR", e[e.END = 1] = "END", e[e.SET = 2] = "SET";
})($a801f2c896bd09f1$var$C || ($a801f2c896bd09f1$var$C = {}));
var $a801f2c896bd09f1$var$Zt = class {
    constructor(t2){
        $a801f2c896bd09f1$var$m(this, "fs");
        $a801f2c896bd09f1$var$m(this, "args");
        $a801f2c896bd09f1$var$m(this, "env");
        $a801f2c896bd09f1$var$m(this, "stdin");
        $a801f2c896bd09f1$var$m(this, "stdout");
        $a801f2c896bd09f1$var$m(this, "stderr");
        $a801f2c896bd09f1$var$m(this, "debug");
        $a801f2c896bd09f1$var$m(this, "isTTY");
        this.fs = (t2 == null ? void 0 : t2.fs) ?? {}, this.args = (t2 == null ? void 0 : t2.args) ?? [], this.env = (t2 == null ? void 0 : t2.env) ?? {}, this.stdin = (t2 == null ? void 0 : t2.stdin) ?? (()=>null), this.stdout = (t2 == null ? void 0 : t2.stdout) ?? (()=>{}), this.stderr = (t2 == null ? void 0 : t2.stderr) ?? (()=>{}), this.debug = t2 == null ? void 0 : t2.debug, this.isTTY = !!(t2 != null && t2.isTTY);
    }
};
var $a801f2c896bd09f1$var$ht = class {
    constructor(t2){
        $a801f2c896bd09f1$var$m(this, "fs");
        $a801f2c896bd09f1$var$m(this, "nextFD", 10);
        $a801f2c896bd09f1$var$m(this, "openMap", /* @__PURE__ */ new Map());
        this.fs = {
            ...t2
        }, this.openMap.set(3, new $a801f2c896bd09f1$var$b(this.fs, "/"));
    }
    //
    // Helpers
    //
    openFile(t2, i2, n) {
        const s2 = new $a801f2c896bd09f1$var$S(t2, n);
        i2 && (s2.buffer = new Uint8Array(new ArrayBuffer(1024), 0, 0));
        const l2 = this.nextFD;
        return this.openMap.set(l2, s2), this.nextFD++, [
            $a801f2c896bd09f1$var$c.SUCCESS,
            l2
        ];
    }
    openDir(t2, i2) {
        const n = new $a801f2c896bd09f1$var$b(t2, i2), s2 = this.nextFD;
        return this.openMap.set(s2, n), this.nextFD++, [
            $a801f2c896bd09f1$var$c.SUCCESS,
            s2
        ];
    }
    hasDir(t2, i2) {
        return i2 === "." ? true : t2.containsDirectory(i2);
    }
    //
    // Public Interface
    //
    open(t2, i2, n, s2) {
        const l2 = !!(n & $a801f2c896bd09f1$var$T.CREAT), d = !!(n & $a801f2c896bd09f1$var$T.DIRECTORY), V = !!(n & $a801f2c896bd09f1$var$T.EXCL), a3 = !!(n & $a801f2c896bd09f1$var$T.TRUNC), Z = this.openMap.get(t2);
        if (!(Z instanceof $a801f2c896bd09f1$var$b)) return [
            $a801f2c896bd09f1$var$c.EBADF
        ];
        if (Z.containsFile(i2)) return d ? [
            $a801f2c896bd09f1$var$c.ENOTDIR
        ] : V ? [
            $a801f2c896bd09f1$var$c.EEXIST
        ] : this.openFile(Z.get(i2), a3, s2);
        if (this.hasDir(Z, i2)) {
            if (i2 === ".") return this.openDir(this.fs, "/");
            const h7 = `/${i2}/`, r = Object.entries(this.fs).filter(([u2])=>u2.startsWith(h7));
            return this.openDir(Object.fromEntries(r), h7);
        } else {
            if (l2) {
                const h7 = Z.fullPath(i2);
                return this.fs[h7] = {
                    path: h7,
                    mode: "binary",
                    content: new Uint8Array(),
                    timestamps: {
                        access: /* @__PURE__ */ new Date(),
                        modification: /* @__PURE__ */ new Date(),
                        change: /* @__PURE__ */ new Date()
                    }
                }, this.openFile(this.fs[h7], a3, s2);
            }
            return [
                $a801f2c896bd09f1$var$c.ENOTCAPABLE
            ];
        }
    }
    close(t2) {
        if (!this.openMap.has(t2)) return $a801f2c896bd09f1$var$c.EBADF;
        const i2 = this.openMap.get(t2);
        return i2 instanceof $a801f2c896bd09f1$var$S && i2.sync(), this.openMap.delete(t2), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    read(t2, i2) {
        const n = this.openMap.get(t2);
        return !n || n instanceof $a801f2c896bd09f1$var$b ? [
            $a801f2c896bd09f1$var$c.EBADF
        ] : [
            $a801f2c896bd09f1$var$c.SUCCESS,
            n.read(i2)
        ];
    }
    pread(t2, i2, n) {
        const s2 = this.openMap.get(t2);
        return !s2 || s2 instanceof $a801f2c896bd09f1$var$b ? [
            $a801f2c896bd09f1$var$c.EBADF
        ] : [
            $a801f2c896bd09f1$var$c.SUCCESS,
            s2.pread(i2, n)
        ];
    }
    write(t2, i2) {
        const n = this.openMap.get(t2);
        return !n || n instanceof $a801f2c896bd09f1$var$b ? $a801f2c896bd09f1$var$c.EBADF : (n.write(i2), $a801f2c896bd09f1$var$c.SUCCESS);
    }
    pwrite(t2, i2, n) {
        const s2 = this.openMap.get(t2);
        return !s2 || s2 instanceof $a801f2c896bd09f1$var$b ? $a801f2c896bd09f1$var$c.EBADF : (s2.pwrite(i2, n), $a801f2c896bd09f1$var$c.SUCCESS);
    }
    sync(t2) {
        const i2 = this.openMap.get(t2);
        return !i2 || i2 instanceof $a801f2c896bd09f1$var$b ? $a801f2c896bd09f1$var$c.EBADF : (i2.sync(), $a801f2c896bd09f1$var$c.SUCCESS);
    }
    seek(t2, i2, n) {
        const s2 = this.openMap.get(t2);
        return !s2 || s2 instanceof $a801f2c896bd09f1$var$b ? [
            $a801f2c896bd09f1$var$c.EBADF
        ] : [
            $a801f2c896bd09f1$var$c.SUCCESS,
            s2.seek(i2, n)
        ];
    }
    tell(t2) {
        const i2 = this.openMap.get(t2);
        return !i2 || i2 instanceof $a801f2c896bd09f1$var$b ? [
            $a801f2c896bd09f1$var$c.EBADF
        ] : [
            $a801f2c896bd09f1$var$c.SUCCESS,
            i2.tell()
        ];
    }
    renumber(t2, i2) {
        return !this.exists(t2) || !this.exists(i2) ? $a801f2c896bd09f1$var$c.EBADF : (t2 === i2 || (this.close(i2), this.openMap.set(i2, this.openMap.get(t2))), $a801f2c896bd09f1$var$c.SUCCESS);
    }
    unlink(t2, i2) {
        const n = this.openMap.get(t2);
        if (!(n instanceof $a801f2c896bd09f1$var$b)) return $a801f2c896bd09f1$var$c.EBADF;
        if (!n.contains(i2)) return $a801f2c896bd09f1$var$c.ENOENT;
        for (const s2 of Object.keys(this.fs))(s2 === n.fullPath(i2) || s2.startsWith(`${n.fullPath(i2)}/`)) && delete this.fs[s2];
        return $a801f2c896bd09f1$var$c.SUCCESS;
    }
    rename(t2, i2, n, s2) {
        const l2 = this.openMap.get(t2), d = this.openMap.get(n);
        if (!(l2 instanceof $a801f2c896bd09f1$var$b) || !(d instanceof $a801f2c896bd09f1$var$b)) return $a801f2c896bd09f1$var$c.EBADF;
        if (!l2.contains(i2)) return $a801f2c896bd09f1$var$c.ENOENT;
        if (d.contains(s2)) return $a801f2c896bd09f1$var$c.EEXIST;
        const V = l2.fullPath(i2), a3 = d.fullPath(s2);
        for (const Z of Object.keys(this.fs))if (Z.startsWith(V)) {
            const h7 = Z.replace(V, a3);
            this.fs[h7] = this.fs[Z], this.fs[h7].path = h7, delete this.fs[Z];
        }
        return $a801f2c896bd09f1$var$c.SUCCESS;
    }
    list(t2) {
        const i2 = this.openMap.get(t2);
        return i2 instanceof $a801f2c896bd09f1$var$b ? [
            $a801f2c896bd09f1$var$c.SUCCESS,
            i2.list()
        ] : [
            $a801f2c896bd09f1$var$c.EBADF
        ];
    }
    stat(t2) {
        const i2 = this.openMap.get(t2);
        return i2 instanceof $a801f2c896bd09f1$var$S ? [
            $a801f2c896bd09f1$var$c.SUCCESS,
            i2.stat()
        ] : [
            $a801f2c896bd09f1$var$c.EBADF
        ];
    }
    pathStat(t2, i2) {
        const n = this.openMap.get(t2);
        if (!(n instanceof $a801f2c896bd09f1$var$b)) return [
            $a801f2c896bd09f1$var$c.EBADF
        ];
        if (n.containsFile(i2)) {
            const s2 = n.fullPath(i2), l2 = new $a801f2c896bd09f1$var$S(this.fs[s2], 0).stat();
            return [
                $a801f2c896bd09f1$var$c.SUCCESS,
                l2
            ];
        } else if (this.hasDir(n, i2)) {
            if (i2 === ".") return [
                $a801f2c896bd09f1$var$c.SUCCESS,
                new $a801f2c896bd09f1$var$b(this.fs, "/").stat()
            ];
            const s2 = `/${i2}/`, l2 = Object.entries(this.fs).filter(([V])=>V.startsWith(s2)), d = new $a801f2c896bd09f1$var$b(Object.fromEntries(l2), s2).stat();
            return [
                $a801f2c896bd09f1$var$c.SUCCESS,
                d
            ];
        } else return [
            $a801f2c896bd09f1$var$c.ENOTCAPABLE
        ];
    }
    setFlags(t2, i2) {
        const n = this.openMap.get(t2);
        return n instanceof $a801f2c896bd09f1$var$S ? (n.setFlags(i2), $a801f2c896bd09f1$var$c.SUCCESS) : $a801f2c896bd09f1$var$c.EBADF;
    }
    setSize(t2, i2) {
        const n = this.openMap.get(t2);
        return n instanceof $a801f2c896bd09f1$var$S ? (n.setSize(Number(i2)), $a801f2c896bd09f1$var$c.SUCCESS) : $a801f2c896bd09f1$var$c.EBADF;
    }
    setAccessTime(t2, i2) {
        const n = this.openMap.get(t2);
        return n instanceof $a801f2c896bd09f1$var$S ? (n.setAccessTime(i2), $a801f2c896bd09f1$var$c.SUCCESS) : $a801f2c896bd09f1$var$c.EBADF;
    }
    setModificationTime(t2, i2) {
        const n = this.openMap.get(t2);
        return n instanceof $a801f2c896bd09f1$var$S ? (n.setModificationTime(i2), $a801f2c896bd09f1$var$c.SUCCESS) : $a801f2c896bd09f1$var$c.EBADF;
    }
    pathSetAccessTime(t2, i2, n) {
        const s2 = this.openMap.get(t2);
        if (!(s2 instanceof $a801f2c896bd09f1$var$b)) return $a801f2c896bd09f1$var$c.EBADF;
        const l2 = s2.get(i2);
        if (!l2) return $a801f2c896bd09f1$var$c.ENOTCAPABLE;
        const d = new $a801f2c896bd09f1$var$S(l2, 0);
        return d.setAccessTime(n), d.sync(), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    pathSetModificationTime(t2, i2, n) {
        const s2 = this.openMap.get(t2);
        if (!(s2 instanceof $a801f2c896bd09f1$var$b)) return $a801f2c896bd09f1$var$c.EBADF;
        const l2 = s2.get(i2);
        if (!l2) return $a801f2c896bd09f1$var$c.ENOTCAPABLE;
        const d = new $a801f2c896bd09f1$var$S(l2, 0);
        return d.setModificationTime(n), d.sync(), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    pathCreateDir(t2, i2) {
        const n = this.openMap.get(t2);
        if (!(n instanceof $a801f2c896bd09f1$var$b)) return $a801f2c896bd09f1$var$c.EBADF;
        if (n.contains(i2)) return $a801f2c896bd09f1$var$c.ENOTCAPABLE;
        const s2 = `${n.fullPath(i2)}/.runno`;
        return this.fs[s2] = {
            path: s2,
            timestamps: {
                access: /* @__PURE__ */ new Date(),
                modification: /* @__PURE__ */ new Date(),
                change: /* @__PURE__ */ new Date()
            },
            mode: "string",
            content: ""
        }, $a801f2c896bd09f1$var$c.SUCCESS;
    }
    //
    // Public Helpers
    //
    exists(t2) {
        return this.openMap.has(t2);
    }
    fileType(t2) {
        const i2 = this.openMap.get(t2);
        return i2 ? i2 instanceof $a801f2c896bd09f1$var$S ? $a801f2c896bd09f1$var$R.REGULAR_FILE : $a801f2c896bd09f1$var$R.DIRECTORY : $a801f2c896bd09f1$var$R.UNKNOWN;
    }
    fileFdflags(t2) {
        const i2 = this.openMap.get(t2);
        return i2 instanceof $a801f2c896bd09f1$var$S ? i2.fdflags : 0;
    }
};
var $a801f2c896bd09f1$var$S = class {
    constructor(t2, i2){
        $a801f2c896bd09f1$var$m(this, "file");
        $a801f2c896bd09f1$var$m(this, "buffer");
        $a801f2c896bd09f1$var$m(this, "_offset", BigInt(0));
        $a801f2c896bd09f1$var$m(this, "isDirty", false);
        $a801f2c896bd09f1$var$m(this, "fdflags");
        $a801f2c896bd09f1$var$m(this, "flagAppend");
        $a801f2c896bd09f1$var$m(this, "flagDSync");
        $a801f2c896bd09f1$var$m(this, "flagNonBlock");
        $a801f2c896bd09f1$var$m(this, "flagRSync");
        $a801f2c896bd09f1$var$m(this, "flagSync");
        if (this.file = t2, this.file.mode === "string") {
            const n = new TextEncoder();
            this.buffer = n.encode(this.file.content);
        } else this.buffer = this.file.content;
        this.fdflags = i2, this.flagAppend = !!(i2 & $a801f2c896bd09f1$var$E.APPEND), this.flagDSync = !!(i2 & $a801f2c896bd09f1$var$E.DSYNC), this.flagNonBlock = !!(i2 & $a801f2c896bd09f1$var$E.NONBLOCK), this.flagRSync = !!(i2 & $a801f2c896bd09f1$var$E.RSYNC), this.flagSync = !!(i2 & $a801f2c896bd09f1$var$E.SYNC);
    }
    get offset() {
        return Number(this._offset);
    }
    read(t2) {
        const i2 = this.buffer.subarray(this.offset, this.offset + t2);
        return this._offset += BigInt(i2.length), i2;
    }
    pread(t2, i2) {
        return this.buffer.subarray(i2, i2 + t2);
    }
    write(t2) {
        if (this.isDirty = true, this.flagAppend) {
            const i2 = this.buffer.length;
            this.resize(i2 + t2.byteLength), this.buffer.set(t2, i2);
        } else {
            const i2 = Math.max(this.offset + t2.byteLength, this.buffer.byteLength);
            this.resize(i2), this.buffer.set(t2, this.offset), this._offset += BigInt(t2.byteLength);
        }
        (this.flagDSync || this.flagSync) && this.sync();
    }
    pwrite(t2, i2) {
        if (this.isDirty = true, this.flagAppend) {
            const n = this.buffer.length;
            this.resize(n + t2.byteLength), this.buffer.set(t2, n);
        } else {
            const n = Math.max(i2 + t2.byteLength, this.buffer.byteLength);
            this.resize(n), this.buffer.set(t2, i2);
        }
        (this.flagDSync || this.flagSync) && this.sync();
    }
    sync() {
        if (!this.isDirty) return;
        if (this.isDirty = false, this.file.mode === "binary") {
            this.file.content = new Uint8Array(this.buffer);
            return;
        }
        const t2 = new TextDecoder();
        this.file.content = t2.decode(this.buffer);
    }
    seek(t2, i2) {
        switch(i2){
            case $a801f2c896bd09f1$var$y.SET:
                this._offset = t2;
                break;
            case $a801f2c896bd09f1$var$y.CUR:
                this._offset += t2;
                break;
            case $a801f2c896bd09f1$var$y.END:
                this._offset = BigInt(this.buffer.length) + t2;
                break;
        }
        return this._offset;
    }
    tell() {
        return this._offset;
    }
    stat() {
        return {
            path: this.file.path,
            timestamps: this.file.timestamps,
            type: $a801f2c896bd09f1$var$R.REGULAR_FILE,
            byteLength: this.buffer.length
        };
    }
    setFlags(t2) {
        this.fdflags = t2;
    }
    setSize(t2) {
        this.resize(t2);
    }
    setAccessTime(t2) {
        this.file.timestamps.access = t2;
    }
    setModificationTime(t2) {
        this.file.timestamps.modification = t2;
    }
    /**
   * Resizes the buffer to be exactly requiredBytes length, while resizing the
   * underlying buffer to be larger if necessary.
   *
   * Resizing will internally double the buffer size to reduce the need for
   * resizing often.
   *
   * @param requiredBytes how many bytes the buffer needs to have available
   */ resize(t2) {
        if (t2 <= this.buffer.buffer.byteLength) {
            this.buffer = new Uint8Array(this.buffer.buffer, 0, t2);
            return;
        }
        let i2;
        this.buffer.buffer.byteLength === 0 ? i2 = new ArrayBuffer(t2 < 1024 ? 1024 : t2 * 2) : t2 > this.buffer.buffer.byteLength * 2 ? i2 = new ArrayBuffer(t2 * 2) : i2 = new ArrayBuffer(this.buffer.buffer.byteLength * 2);
        const n = new Uint8Array(i2, 0, t2);
        n.set(this.buffer), this.buffer = n;
    }
};
function $a801f2c896bd09f1$var$Y(e, t2) {
    const i2 = t2.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&"), n = new RegExp(`^${i2}`);
    return e.replace(n, "");
}
var $a801f2c896bd09f1$var$b = class {
    // full folder path including /
    constructor(t2, i2){
        $a801f2c896bd09f1$var$m(this, "dir");
        $a801f2c896bd09f1$var$m(this, "prefix");
        this.dir = t2, this.prefix = i2;
    }
    containsFile(t2) {
        for (const i2 of Object.keys(this.dir))if ($a801f2c896bd09f1$var$Y(i2, this.prefix) === t2) return true;
        return false;
    }
    containsDirectory(t2) {
        for (const i2 of Object.keys(this.dir))if ($a801f2c896bd09f1$var$Y(i2, this.prefix).startsWith(`${t2}/`)) return true;
        return false;
    }
    contains(t2) {
        for (const i2 of Object.keys(this.dir)){
            const n = $a801f2c896bd09f1$var$Y(i2, this.prefix);
            if (n === t2 || n.startsWith(`${t2}/`)) return true;
        }
        return false;
    }
    get(t2) {
        return this.dir[this.fullPath(t2)];
    }
    fullPath(t2) {
        return `${this.prefix}${t2}`;
    }
    list() {
        const t2 = [], i2 = /* @__PURE__ */ new Set();
        for (const n of Object.keys(this.dir)){
            const s2 = $a801f2c896bd09f1$var$Y(n, this.prefix);
            if (s2.includes("/")) {
                const l2 = s2.split("/")[0];
                if (i2.has(l2)) continue;
                i2.add(l2), t2.push({
                    name: l2,
                    type: $a801f2c896bd09f1$var$R.DIRECTORY
                });
            } else t2.push({
                name: s2,
                type: $a801f2c896bd09f1$var$R.REGULAR_FILE
            });
        }
        return t2;
    }
    stat() {
        return {
            path: this.prefix,
            timestamps: {
                access: /* @__PURE__ */ new Date(),
                modification: /* @__PURE__ */ new Date(),
                change: /* @__PURE__ */ new Date()
            },
            type: $a801f2c896bd09f1$var$R.DIRECTORY,
            byteLength: 0
        };
    }
};
var $a801f2c896bd09f1$var$D = [];
function $a801f2c896bd09f1$var$f(e) {
    $a801f2c896bd09f1$var$D.push(e);
}
function $a801f2c896bd09f1$var$rt() {
    const e = $a801f2c896bd09f1$var$D;
    return $a801f2c896bd09f1$var$D = [], e;
}
var $a801f2c896bd09f1$var$J = class extends Error {
};
var $a801f2c896bd09f1$var$A = class extends Error {
};
var $a801f2c896bd09f1$var$H = class _H {
    constructor(t2){
        $a801f2c896bd09f1$var$m(this, "instance");
        $a801f2c896bd09f1$var$m(this, "module");
        $a801f2c896bd09f1$var$m(this, "memory");
        $a801f2c896bd09f1$var$m(this, "context");
        $a801f2c896bd09f1$var$m(this, "drive");
        $a801f2c896bd09f1$var$m(this, "hasBeenInitialized", false);
        this.context = new $a801f2c896bd09f1$var$Zt(t2), this.drive = new $a801f2c896bd09f1$var$ht(this.context.fs);
    }
    /**
   * Start a WASI command.
   *
   */ static async start(t2, i2 = {}) {
        const n = new _H(i2), s2 = await WebAssembly.instantiateStreaming(t2, n.getImportObject());
        return n.start(s2);
    }
    /**
   * Initialize a WASI reactor.
   *
   * Returns the WebAssembly instance exports.
   */ static async initialize(t2, i2 = {}) {
        const n = new _H(i2), s2 = await WebAssembly.instantiateStreaming(t2, n.getImportObject());
        return n.initialize(s2), s2.instance.exports;
    }
    getImportObject() {
        return {
            wasi_snapshot_preview1: this.getImports("preview1", this.context.debug),
            wasi_unstable: this.getImports("unstable", this.context.debug)
        };
    }
    /**
   * Start a WASI command.
   *
   * See: https://github.com/WebAssembly/WASI/blob/main/legacy/application-abi.md
   */ start(t2, i2 = {}) {
        if (this.hasBeenInitialized) throw new $a801f2c896bd09f1$var$A("This instance has already been initialized");
        if (this.hasBeenInitialized = true, this.instance = t2.instance, this.module = t2.module, this.memory = i2.memory ?? this.instance.exports.memory, "_initialize" in this.instance.exports) throw new $a801f2c896bd09f1$var$J("WebAssembly instance is a reactor and should be started with initialize.");
        if (!("_start" in this.instance.exports)) throw new $a801f2c896bd09f1$var$J("WebAssembly instance doesn't export _start, it may not be WASI or may be a Reactor.");
        const n = this.instance.exports._start;
        try {
            n();
        } catch (s2) {
            if (s2 instanceof $a801f2c896bd09f1$var$v) return {
                exitCode: s2.code,
                fs: this.drive.fs
            };
            if (s2 instanceof WebAssembly.RuntimeError) return {
                exitCode: 134,
                fs: this.drive.fs
            };
            throw s2;
        }
        return {
            exitCode: 0,
            fs: this.drive.fs
        };
    }
    /**
   * Initialize a WASI Reactor.
   *
   * See: https://github.com/WebAssembly/WASI/blob/main/legacy/application-abi.md
   */ initialize(t2, i2 = {}) {
        if (this.hasBeenInitialized) throw new $a801f2c896bd09f1$var$A("This instance has already been initialized");
        if (this.hasBeenInitialized = true, this.instance = t2.instance, this.module = t2.module, this.memory = i2.memory ?? this.instance.exports.memory, "_start" in this.instance.exports) throw new $a801f2c896bd09f1$var$J("WebAssembly instance is a command and should be started with start.");
        if ("_initialize" in this.instance.exports) {
            const n = this.instance.exports._initialize;
            n();
        }
    }
    getImports(t2, i2) {
        const n = {
            args_get: this.args_get.bind(this),
            args_sizes_get: this.args_sizes_get.bind(this),
            clock_res_get: this.clock_res_get.bind(this),
            clock_time_get: this.clock_time_get.bind(this),
            environ_get: this.environ_get.bind(this),
            environ_sizes_get: this.environ_sizes_get.bind(this),
            proc_exit: this.proc_exit.bind(this),
            random_get: this.random_get.bind(this),
            sched_yield: this.sched_yield.bind(this),
            // File Descriptors
            fd_advise: this.fd_advise.bind(this),
            fd_allocate: this.fd_allocate.bind(this),
            fd_close: this.fd_close.bind(this),
            fd_datasync: this.fd_datasync.bind(this),
            fd_fdstat_get: this.fd_fdstat_get.bind(this),
            fd_fdstat_set_flags: this.fd_fdstat_set_flags.bind(this),
            fd_fdstat_set_rights: this.fd_fdstat_set_rights.bind(this),
            fd_filestat_get: this.fd_filestat_get.bind(this),
            fd_filestat_set_size: this.fd_filestat_set_size.bind(this),
            fd_filestat_set_times: this.fd_filestat_set_times.bind(this),
            fd_pread: this.fd_pread.bind(this),
            fd_prestat_dir_name: this.fd_prestat_dir_name.bind(this),
            fd_prestat_get: this.fd_prestat_get.bind(this),
            fd_pwrite: this.fd_pwrite.bind(this),
            fd_read: this.fd_read.bind(this),
            fd_readdir: this.fd_readdir.bind(this),
            fd_renumber: this.fd_renumber.bind(this),
            fd_seek: this.fd_seek.bind(this),
            fd_sync: this.fd_sync.bind(this),
            fd_tell: this.fd_tell.bind(this),
            fd_write: this.fd_write.bind(this),
            // Paths
            path_filestat_get: this.path_filestat_get.bind(this),
            path_filestat_set_times: this.path_filestat_set_times.bind(this),
            path_open: this.path_open.bind(this),
            path_rename: this.path_rename.bind(this),
            path_unlink_file: this.path_unlink_file.bind(this),
            path_create_directory: this.path_create_directory.bind(this),
            // Unimplemented
            path_link: this.path_link.bind(this),
            path_readlink: this.path_readlink.bind(this),
            path_remove_directory: this.path_remove_directory.bind(this),
            path_symlink: this.path_symlink.bind(this),
            poll_oneoff: this.poll_oneoff.bind(this),
            proc_raise: this.proc_raise.bind(this),
            sock_accept: this.sock_accept.bind(this),
            sock_recv: this.sock_recv.bind(this),
            sock_send: this.sock_send.bind(this),
            sock_shutdown: this.sock_shutdown.bind(this),
            // Unimplemented - WASMEdge compatibility
            sock_open: this.sock_open.bind(this),
            sock_listen: this.sock_listen.bind(this),
            sock_connect: this.sock_connect.bind(this),
            sock_setsockopt: this.sock_setsockopt.bind(this),
            sock_bind: this.sock_bind.bind(this),
            sock_getlocaladdr: this.sock_getlocaladdr.bind(this),
            sock_getpeeraddr: this.sock_getpeeraddr.bind(this),
            sock_getaddrinfo: this.sock_getaddrinfo.bind(this)
        };
        t2 === "unstable" && (n.path_filestat_get = this.unstable_path_filestat_get.bind(this), n.fd_filestat_get = this.unstable_fd_filestat_get.bind(this), n.fd_seek = this.unstable_fd_seek.bind(this));
        for (const [s2, l2] of Object.entries(n))n[s2] = function() {
            let d = l2.apply(this, arguments);
            if (i2) {
                const V = $a801f2c896bd09f1$var$rt();
                d = i2(s2, [
                    ...arguments
                ], d, V) ?? d;
            }
            return d;
        };
        return n;
    }
    //
    // Helpers
    //
    get envArray() {
        return Object.entries(this.context.env).map(([t2, i2])=>`${t2}=${i2}`);
    }
    //
    // WASI Implementation
    //
    /**
   * Read command-line argument data. The size of the array should match that
   * returned by args_sizes_get. Each argument is expected to be \0 terminated.
   */ args_get(t2, i2) {
        const n = new DataView(this.memory.buffer);
        for (const s2 of this.context.args){
            n.setUint32(t2, i2, true), t2 += 4;
            const l2 = new TextEncoder().encode(`${s2}\0`);
            new Uint8Array(this.memory.buffer, i2, l2.byteLength).set(l2), i2 += l2.byteLength;
        }
        return $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Return command-line argument data sizes.
   */ args_sizes_get(t2, i2) {
        const n = this.context.args, s2 = n.reduce((d, V)=>d + new TextEncoder().encode(`${V}\0`).byteLength, 0), l2 = new DataView(this.memory.buffer);
        return l2.setUint32(t2, n.length, true), l2.setUint32(i2, s2, true), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Return the resolution of a clock. Implementations are required to provide a
   * non-zero value for supported clocks. For unsupported clocks, return
   * errno::inval. Note: This is similar to clock_getres in POSIX.
   */ clock_res_get(t2, i2) {
        switch(t2){
            case $a801f2c896bd09f1$var$G.REALTIME:
            case $a801f2c896bd09f1$var$G.MONOTONIC:
            case $a801f2c896bd09f1$var$G.PROCESS_CPUTIME_ID:
            case $a801f2c896bd09f1$var$G.THREAD_CPUTIME_ID:
                return new DataView(this.memory.buffer).setBigUint64(i2, BigInt(1e6), true), $a801f2c896bd09f1$var$c.SUCCESS;
        }
        return $a801f2c896bd09f1$var$c.EINVAL;
    }
    /**
   * Return the time value of a clock.
   * Note: This is similar to clock_gettime in POSIX.
   */ clock_time_get(t2, i2, n) {
        switch(t2){
            case $a801f2c896bd09f1$var$G.REALTIME:
            case $a801f2c896bd09f1$var$G.MONOTONIC:
            case $a801f2c896bd09f1$var$G.PROCESS_CPUTIME_ID:
            case $a801f2c896bd09f1$var$G.THREAD_CPUTIME_ID:
                return new DataView(this.memory.buffer).setBigUint64(n, $a801f2c896bd09f1$var$W(/* @__PURE__ */ new Date()), true), $a801f2c896bd09f1$var$c.SUCCESS;
        }
        return $a801f2c896bd09f1$var$c.EINVAL;
    }
    /**
   * Read environment variable data. The sizes of the buffers should match that
   * returned by environ_sizes_get. Key/value pairs are expected to be joined
   * with =s, and terminated with \0s.
   */ environ_get(t2, i2) {
        const n = new DataView(this.memory.buffer);
        for (const s2 of this.envArray){
            n.setUint32(t2, i2, true), t2 += 4;
            const l2 = new TextEncoder().encode(`${s2}\0`);
            new Uint8Array(this.memory.buffer, i2, l2.byteLength).set(l2), i2 += l2.byteLength;
        }
        return $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Return environment variable data sizes.
   */ environ_sizes_get(t2, i2) {
        const n = this.envArray.reduce((l2, d)=>l2 + new TextEncoder().encode(`${d}\0`).byteLength, 0), s2 = new DataView(this.memory.buffer);
        return s2.setUint32(t2, this.envArray.length, true), s2.setUint32(i2, n, true), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Terminate the process normally. An exit code of 0 indicates successful
   * termination of the program. The meanings of other values is dependent on
   * the environment.
   */ proc_exit(t2) {
        throw new $a801f2c896bd09f1$var$v(t2);
    }
    /**
   * Write high-quality random data into a buffer. This function blocks when the
   * implementation is unable to immediately provide sufficient high-quality
   * random data. This function may execute slowly, so when large mounts of
   * random data are required, it's advisable to use this function to seed a
   * pseudo-random number generator, rather than to provide the random data
   * directly.
   */ random_get(t2, i2) {
        const n = new Uint8Array(this.memory.buffer, t2, i2);
        return globalThis.crypto.getRandomValues(n), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Temporarily yield execution of the calling thread.
   * Note: This is similar to sched_yield in POSIX.
   */ sched_yield() {
        return $a801f2c896bd09f1$var$c.SUCCESS;
    }
    //
    // File Descriptors
    //
    /**
   * Read from a file descriptor. Note: This is similar to readv in POSIX.
   */ fd_read(t2, i2, n, s2) {
        if (t2 === 1 || t2 === 2) return $a801f2c896bd09f1$var$c.ENOTSUP;
        const l2 = new DataView(this.memory.buffer), d = $a801f2c896bd09f1$var$K(l2, i2, n), V = new TextEncoder();
        let a3 = 0, Z = $a801f2c896bd09f1$var$c.SUCCESS;
        for (const h7 of d){
            let r;
            if (t2 === 0) {
                const X = this.context.stdin(h7.byteLength);
                if (!X) break;
                r = V.encode(X);
            } else {
                const [X, L23] = this.drive.read(t2, h7.byteLength);
                if (X) {
                    Z = X;
                    break;
                } else r = L23;
            }
            const u2 = Math.min(h7.byteLength, r.byteLength);
            h7.set(r.subarray(0, u2)), a3 += u2;
        }
        return $a801f2c896bd09f1$var$f({
            bytesRead: a3
        }), l2.setUint32(s2, a3, true), Z;
    }
    /**
   * Write to a file descriptor. Note: This is similar to writev in POSIX.
   */ fd_write(t2, i2, n, s2) {
        if (t2 === 0) return $a801f2c896bd09f1$var$c.ENOTSUP;
        const l2 = new DataView(this.memory.buffer), d = $a801f2c896bd09f1$var$K(l2, i2, n), V = new TextDecoder();
        let a3 = 0, Z = $a801f2c896bd09f1$var$c.SUCCESS;
        for (const h7 of d)if (h7.byteLength !== 0) {
            if (t2 === 1 || t2 === 2) {
                const r = t2 === 1 ? this.context.stdout : this.context.stderr, u2 = V.decode(h7);
                r(u2), $a801f2c896bd09f1$var$f({
                    output: u2
                });
            } else if (Z = this.drive.write(t2, h7), Z != $a801f2c896bd09f1$var$c.SUCCESS) break;
            a3 += h7.byteLength;
        }
        return l2.setUint32(s2, a3, true), Z;
    }
    /**
   * Provide file advisory information on a file descriptor.
   * Note: This is similar to posix_fadvise in POSIX.
   */ fd_advise() {
        return $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Force the allocation of space in a file.
   * Note: This is similar to posix_fallocate in POSIX.
   */ fd_allocate(t2, i2, n) {
        return this.drive.pwrite(t2, new Uint8Array(Number(n)), Number(i2));
    }
    /**
   * Close a file descriptor.
   * Note: This is similar to close in POSIX.
   *
   * @param fd
   */ fd_close(t2) {
        return this.drive.close(t2);
    }
    /**
   * Synchronize the data of a file to disk.
   * Note: This is similar to fdatasync in POSIX.
   *
   * @param fd
   */ fd_datasync(t2) {
        return this.drive.sync(t2);
    }
    /**
   * Get the attributes of a file descriptor.
   * Note: This returns similar flags to fsync(fd, F_GETFL) in POSIX,
   * as well as additional fields.
   *
   * Returns fdstat - the buffer where the file descriptor's attributes
   * are stored.
   *
   * @returns Result<fdstat, errno>
   */ fd_fdstat_get(t2, i2) {
        if (t2 < 3) {
            let V;
            if (this.context.isTTY) {
                const Z = $a801f2c896bd09f1$var$O ^ $a801f2c896bd09f1$var$o.FD_SEEK ^ $a801f2c896bd09f1$var$o.FD_TELL;
                V = $a801f2c896bd09f1$var$B($a801f2c896bd09f1$var$R.CHARACTER_DEVICE, 0, Z);
            } else V = $a801f2c896bd09f1$var$B($a801f2c896bd09f1$var$R.CHARACTER_DEVICE, 0);
            return new Uint8Array(this.memory.buffer, i2, V.byteLength).set(V), $a801f2c896bd09f1$var$c.SUCCESS;
        }
        if (!this.drive.exists(t2)) return $a801f2c896bd09f1$var$c.EBADF;
        const n = this.drive.fileType(t2), s2 = this.drive.fileFdflags(t2), l2 = $a801f2c896bd09f1$var$B(n, s2);
        return new Uint8Array(this.memory.buffer, i2, l2.byteLength).set(l2), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Adjust the flags associated with a file descriptor.
   * Note: This is similar to fcntl(fd, F_SETFL, flags) in POSIX.
   */ fd_fdstat_set_flags(t2, i2) {
        return this.drive.setFlags(t2, i2);
    }
    /**
   * Adjust the rights associated with a file descriptor. This can only be used
   * to remove rights, and returns errno::notcapable if called in a way that
   * would attempt to add rights
   */ fd_fdstat_set_rights() {
        return $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Return the attributes of an open file.
   */ fd_filestat_get(t2, i2) {
        return this.shared_fd_filestat_get(t2, i2, "preview1");
    }
    /**
   * Return the attributes of an open file.
   * This version is used
   */ unstable_fd_filestat_get(t2, i2) {
        return this.shared_fd_filestat_get(t2, i2, "unstable");
    }
    /**
   * Return the attributes of an open file.
   */ shared_fd_filestat_get(t2, i2, n) {
        const s2 = n === "unstable" ? $a801f2c896bd09f1$var$$ : $a801f2c896bd09f1$var$j;
        if (t2 < 3) {
            let Z;
            switch(t2){
                case 0:
                    Z = "/dev/stdin";
                    break;
                case 1:
                    Z = "/dev/stdout";
                    break;
                case 2:
                    Z = "/dev/stderr";
                    break;
                default:
                    Z = "/dev/undefined";
                    break;
            }
            const h7 = s2({
                path: Z,
                byteLength: 0,
                timestamps: {
                    access: /* @__PURE__ */ new Date(),
                    modification: /* @__PURE__ */ new Date(),
                    change: /* @__PURE__ */ new Date()
                },
                type: $a801f2c896bd09f1$var$R.CHARACTER_DEVICE
            });
            return new Uint8Array(this.memory.buffer, i2, h7.byteLength).set(h7), $a801f2c896bd09f1$var$c.SUCCESS;
        }
        const [l2, d] = this.drive.stat(t2);
        if (l2 != $a801f2c896bd09f1$var$c.SUCCESS) return l2;
        $a801f2c896bd09f1$var$f({
            resolvedPath: d.path,
            stat: d
        });
        const V = s2(d);
        return new Uint8Array(this.memory.buffer, i2, V.byteLength).set(V), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Adjust the size of an open file. If this increases the file's size, the
   * extra bytes are filled with zeros. Note: This is similar to ftruncate in
   * POSIX.
   */ fd_filestat_set_size(t2, i2) {
        return this.drive.setSize(t2, i2);
    }
    /**
   * Adjust the timestamps of an open file or directory.
   * Note: This is similar to futimens in POSIX.
   */ fd_filestat_set_times(t2, i2, n, s2) {
        let l2 = null;
        s2 & $a801f2c896bd09f1$var$U.ATIM && (l2 = $a801f2c896bd09f1$var$k(i2)), s2 & $a801f2c896bd09f1$var$U.ATIM_NOW && (l2 = /* @__PURE__ */ new Date());
        let d = null;
        if (s2 & $a801f2c896bd09f1$var$U.MTIM && (d = $a801f2c896bd09f1$var$k(n)), s2 & $a801f2c896bd09f1$var$U.MTIM_NOW && (d = /* @__PURE__ */ new Date()), l2) {
            const V = this.drive.setAccessTime(t2, l2);
            if (V != $a801f2c896bd09f1$var$c.SUCCESS) return V;
        }
        if (d) {
            const V = this.drive.setModificationTime(t2, d);
            if (V != $a801f2c896bd09f1$var$c.SUCCESS) return V;
        }
        return $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Read from a file descriptor, without using and updating the file
   * descriptor's offset. Note: This is similar to preadv in POSIX.
   */ fd_pread(t2, i2, n, s2, l2) {
        if (t2 === 1 || t2 === 2) return $a801f2c896bd09f1$var$c.ENOTSUP;
        if (t2 === 0) return this.fd_read(t2, i2, n, l2);
        const d = new DataView(this.memory.buffer), V = $a801f2c896bd09f1$var$K(d, i2, n);
        let a3 = 0, Z = $a801f2c896bd09f1$var$c.SUCCESS;
        for (const h7 of V){
            const [r, u2] = this.drive.pread(t2, h7.byteLength, Number(s2) + a3);
            if (r !== $a801f2c896bd09f1$var$c.SUCCESS) {
                Z = r;
                break;
            }
            const X = Math.min(h7.byteLength, u2.byteLength);
            h7.set(u2.subarray(0, X)), a3 += X;
        }
        return d.setUint32(l2, a3, true), Z;
    }
    /**
   * Return a description of the given preopened file descriptor.
   */ fd_prestat_dir_name(t2, i2, n) {
        if (t2 !== 3) return $a801f2c896bd09f1$var$c.EBADF;
        const s2 = new TextEncoder().encode("/");
        return new Uint8Array(this.memory.buffer, i2, n).set(s2.subarray(0, n)), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Return a description of the given preopened file descriptor.
   */ fd_prestat_get(t2, i2) {
        if (t2 !== 3) return $a801f2c896bd09f1$var$c.EBADF;
        const n = new TextEncoder().encode("."), s2 = new DataView(this.memory.buffer, i2);
        return s2.setUint8(0, $a801f2c896bd09f1$var$Q.DIR), s2.setUint32(4, n.byteLength, true), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Write to a file descriptor, without using and updating the file
   * descriptor's offset. Note: This is similar to pwritev in POSIX.
   */ fd_pwrite(t2, i2, n, s2, l2) {
        if (t2 === 0) return $a801f2c896bd09f1$var$c.ENOTSUP;
        if (t2 === 1 || t2 === 2) return this.fd_write(t2, i2, n, l2);
        const d = new DataView(this.memory.buffer), V = $a801f2c896bd09f1$var$K(d, i2, n);
        let a3 = 0, Z = $a801f2c896bd09f1$var$c.SUCCESS;
        for (const h7 of V)if (h7.byteLength !== 0) {
            if (Z = this.drive.pwrite(t2, h7, Number(s2)), Z != $a801f2c896bd09f1$var$c.SUCCESS) break;
            a3 += h7.byteLength;
        }
        return d.setUint32(l2, a3, true), Z;
    }
    /**
   * Read directory entries from a directory. When successful, the contents of
   * the output buffer consist of a sequence of directory entries. Each
   * directory entry consists of a dirent object, followed by dirent::d_namlen
   * bytes holding the name of the directory entry. This function fills the
   * output buffer as much as possible, potentially truncating the last
   * directory entry. This allows the caller to grow its read buffer size in
   * case it's too small to fit a single large directory entry, or skip the
   * oversized directory entry.
   */ fd_readdir(t2, i2, n, s2, l2) {
        const [d, V] = this.drive.list(t2);
        if (d != $a801f2c896bd09f1$var$c.SUCCESS) return d;
        let a3 = [], Z = 0;
        for (const { name: N, type: F } of V){
            const g2 = $a801f2c896bd09f1$var$ot(N, F, Z);
            a3.push(g2), Z++;
        }
        a3 = a3.slice(Number(s2));
        const h7 = a3.reduce((N, F)=>N + F.byteLength, 0), r = new Uint8Array(h7);
        let u2 = 0;
        for (const N of a3)r.set(N, u2), u2 += N.byteLength;
        const X = new Uint8Array(this.memory.buffer, i2, n), L23 = r.subarray(0, n);
        return X.set(L23), new DataView(this.memory.buffer).setUint32(l2, L23.byteLength, true), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Atomically replace a file descriptor by renumbering another file
   * descriptor. Due to the strong focus on thread safety, this environment does
   * not provide a mechanism to duplicate or renumber a file descriptor to an
   * arbitrary number, like dup2(). This would be prone to race conditions, as
   * an actual file descriptor with the same number could be allocated by a
   * different thread at the same time. This function provides a way to
   * atomically renumber file descriptors, which would disappear if dup2() were
   * to be removed entirely.
   */ fd_renumber(t2, i2) {
        return this.drive.renumber(t2, i2);
    }
    /**
   * Move the offset of a file descriptor.
   *
   * The offset is specified as a bigint here
   * Note: This is similar to lseek in POSIX.
   *
   * The offset, and return type are FileSize (u64) which is represented by
   * bigint in JavaScript.
   */ fd_seek(t2, i2, n, s2) {
        const [l2, d] = this.drive.seek(t2, i2, n);
        return l2 !== $a801f2c896bd09f1$var$c.SUCCESS || ($a801f2c896bd09f1$var$f({
            newOffset: d.toString()
        }), new DataView(this.memory.buffer).setBigUint64(s2, d, true)), l2;
    }
    unstable_fd_seek(t2, i2, n, s2) {
        const l2 = $a801f2c896bd09f1$var$bt[n];
        return this.fd_seek(t2, i2, l2, s2);
    }
    /**
   * Synchronize the data and metadata of a file to disk.
   * Note: This is similar to fsync in POSIX.
   */ fd_sync(t2) {
        return this.drive.sync(t2);
    }
    /**
   * Return the current offset of a file descriptor.
   * Note: This is similar to lseek(fd, 0, SEEK_CUR) in POSIX.
   *
   * The return type is FileSize (u64) which is represented by bigint in JS.
   *
   */ fd_tell(t2, i2) {
        const [n, s2] = this.drive.tell(t2);
        return n !== $a801f2c896bd09f1$var$c.SUCCESS || new DataView(this.memory.buffer).setBigUint64(i2, s2, true), n;
    }
    //
    // Paths
    //
    path_filestat_get(t2, i2, n, s2, l2) {
        return this.shared_path_filestat_get(t2, i2, n, s2, l2, "preview1");
    }
    unstable_path_filestat_get(t2, i2, n, s2, l2) {
        return this.shared_path_filestat_get(t2, i2, n, s2, l2, "unstable");
    }
    /**
   * Return the attributes of a file or directory.
   * Note: This is similar to stat in POSIX.
   */ shared_path_filestat_get(t2, i2, n, s2, l2, d) {
        const V = d === "unstable" ? $a801f2c896bd09f1$var$$ : $a801f2c896bd09f1$var$j, a3 = new TextDecoder().decode(new Uint8Array(this.memory.buffer, n, s2));
        $a801f2c896bd09f1$var$f({
            path: a3
        });
        const [Z, h7] = this.drive.pathStat(t2, a3);
        if (Z != $a801f2c896bd09f1$var$c.SUCCESS) return Z;
        const r = V(h7);
        return new Uint8Array(this.memory.buffer, l2, r.byteLength).set(r), Z;
    }
    /**
   * Adjust the timestamps of a file or directory.
   * Note: This is similar to utimensat in POSIX.
   */ path_filestat_set_times(t2, i2, n, s2, l2, d, V) {
        let a3 = null;
        V & $a801f2c896bd09f1$var$U.ATIM && (a3 = $a801f2c896bd09f1$var$k(l2)), V & $a801f2c896bd09f1$var$U.ATIM_NOW && (a3 = /* @__PURE__ */ new Date());
        let Z = null;
        V & $a801f2c896bd09f1$var$U.MTIM && (Z = $a801f2c896bd09f1$var$k(d)), V & $a801f2c896bd09f1$var$U.MTIM_NOW && (Z = /* @__PURE__ */ new Date());
        const h7 = new TextDecoder().decode(new Uint8Array(this.memory.buffer, n, s2));
        if (a3) {
            const r = this.drive.pathSetAccessTime(t2, h7, a3);
            if (r != $a801f2c896bd09f1$var$c.SUCCESS) return r;
        }
        if (Z) {
            const r = this.drive.pathSetModificationTime(t2, h7, Z);
            if (r != $a801f2c896bd09f1$var$c.SUCCESS) return r;
        }
        return $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Open a file or directory. The returned file descriptor is not guaranteed to
   * be the lowest-numbered file descriptor not currently open; it is randomized
   * to prevent applications from depending on making assumptions about indexes,
   * since this is error-prone in multi-threaded contexts. The returned file
   * descriptor is guaranteed to be less than 2**31.
   * Note: This is similar to openat in POSIX.
   * @param fd: fd
   * @param dirflags: lookupflags Flags determining the method of how the path
   *                  is resolved. Not supported by Runno (symlinks)
   * @param path: string The relative path of the file or directory to open,
   *              relative to the path_open::fd directory.
   * @param oflags: oflags The method by which to open the file.
   * @param fs_rights_base: rights The initial rights of the newly created file
   *                        descriptor. The implementation is allowed to return
   *                        a file descriptor with fewer rights than specified,
   *                        if and only if those rights do not apply to the type
   *                        of file being opened. The base rights are rights
   *                        that will apply to operations using the file
   *                        descriptor itself, while the inheriting rights are
   *                        rights that apply to file descriptors derived from
   *                        it.
   * @param fs_rights_inheriting: rights
   * @param fdflags: fdflags
   *
   */ path_open(t2, i2, n, s2, l2, d, V, a3, Z) {
        const h7 = new DataView(this.memory.buffer), r = $a801f2c896bd09f1$var$I(this.memory, n, s2), u2 = !!(l2 & $a801f2c896bd09f1$var$T.CREAT), X = !!(l2 & $a801f2c896bd09f1$var$T.DIRECTORY), L23 = !!(l2 & $a801f2c896bd09f1$var$T.EXCL), _ = !!(l2 & $a801f2c896bd09f1$var$T.TRUNC), N = !!(a3 & $a801f2c896bd09f1$var$E.APPEND), F = !!(a3 & $a801f2c896bd09f1$var$E.DSYNC), g2 = !!(a3 & $a801f2c896bd09f1$var$E.NONBLOCK), nt = !!(a3 & $a801f2c896bd09f1$var$E.RSYNC), st = !!(a3 & $a801f2c896bd09f1$var$E.SYNC);
        $a801f2c896bd09f1$var$f({
            path: r,
            openFlags: {
                createFileIfNone: u2,
                failIfNotDir: X,
                failIfFileExists: L23,
                truncateFile: _
            },
            fileDescriptorFlags: {
                flagAppend: N,
                flagDSync: F,
                flagNonBlock: g2,
                flagRSync: nt,
                flagSync: st
            }
        });
        const [M, ct] = this.drive.open(t2, r, l2, a3);
        return M || (h7.setUint32(Z, ct, true), M);
    }
    /**
   * Rename a file or directory. Note: This is similar to renameat in POSIX.
   */ path_rename(t2, i2, n, s2, l2, d) {
        const V = $a801f2c896bd09f1$var$I(this.memory, i2, n), a3 = $a801f2c896bd09f1$var$I(this.memory, l2, d);
        return $a801f2c896bd09f1$var$f({
            oldPath: V,
            newPath: a3
        }), this.drive.rename(t2, V, s2, a3);
    }
    /**
   * Unlink a file. Return errno::isdir if the path refers to a directory.
   * Note: This is similar to unlinkat(fd, path, 0) in POSIX.
   */ path_unlink_file(t2, i2, n) {
        const s2 = $a801f2c896bd09f1$var$I(this.memory, i2, n);
        return $a801f2c896bd09f1$var$f({
            path: s2
        }), this.drive.unlink(t2, s2);
    }
    /**
   * Concurrently poll for the occurrence of a set of events.
   */ poll_oneoff(t2, i2, n, s2) {
        for(let d = 0; d < n; d++){
            const V = new Uint8Array(this.memory.buffer, t2 + d * $a801f2c896bd09f1$var$x, $a801f2c896bd09f1$var$x), a3 = $a801f2c896bd09f1$var$mt(V), Z = new Uint8Array(this.memory.buffer, i2 + d * $a801f2c896bd09f1$var$z, $a801f2c896bd09f1$var$z);
            let h7 = 0, r = $a801f2c896bd09f1$var$c.SUCCESS;
            switch(a3.type){
                case $a801f2c896bd09f1$var$p.CLOCK:
                    for(; new Date() < a3.timeout;);
                    Z.set($a801f2c896bd09f1$var$ut(a3.userdata, $a801f2c896bd09f1$var$c.SUCCESS));
                    break;
                case $a801f2c896bd09f1$var$p.FD_READ:
                    if (a3.fd < 3) a3.fd === 0 ? (r = $a801f2c896bd09f1$var$c.SUCCESS, h7 = 32) : r = $a801f2c896bd09f1$var$c.EBADF;
                    else {
                        const [u2, X] = this.drive.stat(a3.fd);
                        r = u2, h7 = X ? X.byteLength : 0;
                    }
                    Z.set($a801f2c896bd09f1$var$q(a3.userdata, r, $a801f2c896bd09f1$var$p.FD_READ, BigInt(h7)));
                    break;
                case $a801f2c896bd09f1$var$p.FD_WRITE:
                    if (h7 = 0, r = $a801f2c896bd09f1$var$c.SUCCESS, a3.fd < 3) a3.fd === 0 ? r = $a801f2c896bd09f1$var$c.EBADF : (r = $a801f2c896bd09f1$var$c.SUCCESS, h7 = 1024);
                    else {
                        const [u2, X] = this.drive.stat(a3.fd);
                        r = u2, h7 = X ? X.byteLength : 0;
                    }
                    Z.set($a801f2c896bd09f1$var$q(a3.userdata, r, $a801f2c896bd09f1$var$p.FD_READ, BigInt(h7)));
                    break;
            }
        }
        return new DataView(this.memory.buffer, s2, 4).setUint32(0, n, true), $a801f2c896bd09f1$var$c.SUCCESS;
    }
    /**
   * Create a directory. Note: This is similar to mkdirat in POSIX.
   */ path_create_directory(t2, i2, n) {
        const s2 = $a801f2c896bd09f1$var$I(this.memory, i2, n);
        return this.drive.pathCreateDir(t2, s2);
    }
    //
    // Unimplemented - these operations are not supported by Runno
    //
    /**
   * Create a hard link. Note: This is similar to linkat in POSIX.
   */ path_link() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    /**
   * Read the contents of a symbolic link.
   * Note: This is similar to readlinkat in POSIX.
   */ path_readlink() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    /**
   * Remove a directory. Return errno::notempty if the directory is not empty.
   * Note: This is similar to unlinkat(fd, path, AT_REMOVEDIR) in POSIX.
   */ path_remove_directory() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    /**
   * Create a symbolic link. Note: This is similar to symlinkat in POSIX.
   */ path_symlink() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    /**
   * Send a signal to the process of the calling thread.
   * Note: This is similar to raise in POSIX.
   */ proc_raise() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    /**
   * Accept a new incoming connection. Note: This is similar to accept in POSIX.
   */ sock_accept() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    /**
   * Receive a message from a socket. Note: This is similar to recv in POSIX,
   * though it also supports reading the data into multiple buffers in the
   * manner of readv.
   */ sock_recv() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    /**
   * Send a message on a socket. Note: This is similar to send in POSIX, though
   * it also supports writing the data from multiple buffers in the manner of
   * writev.
   */ sock_send() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    /**
   * Shut down socket send and receive channels. Note: This is similar to
   * shutdown in POSIX.
   */ sock_shutdown() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    //
    // Unimplemented - these are for compatibility with Wasmedge
    //
    sock_open() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    sock_listen() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    sock_connect() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    sock_setsockopt() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    sock_bind() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    sock_getlocaladdr() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    sock_getpeeraddr() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
    sock_getaddrinfo() {
        return $a801f2c896bd09f1$var$c.ENOSYS;
    }
};
var $a801f2c896bd09f1$var$O = $a801f2c896bd09f1$var$o.FD_DATASYNC | $a801f2c896bd09f1$var$o.FD_READ | $a801f2c896bd09f1$var$o.FD_SEEK | $a801f2c896bd09f1$var$o.FD_FDSTAT_SET_FLAGS | $a801f2c896bd09f1$var$o.FD_SYNC | $a801f2c896bd09f1$var$o.FD_TELL | $a801f2c896bd09f1$var$o.FD_WRITE | $a801f2c896bd09f1$var$o.FD_ADVISE | $a801f2c896bd09f1$var$o.FD_ALLOCATE | $a801f2c896bd09f1$var$o.PATH_CREATE_DIRECTORY | $a801f2c896bd09f1$var$o.PATH_CREATE_FILE | $a801f2c896bd09f1$var$o.PATH_LINK_SOURCE | $a801f2c896bd09f1$var$o.PATH_LINK_TARGET | $a801f2c896bd09f1$var$o.PATH_OPEN | $a801f2c896bd09f1$var$o.FD_READDIR | $a801f2c896bd09f1$var$o.PATH_READLINK | $a801f2c896bd09f1$var$o.PATH_RENAME_SOURCE | $a801f2c896bd09f1$var$o.PATH_RENAME_TARGET | $a801f2c896bd09f1$var$o.PATH_FILESTAT_GET | $a801f2c896bd09f1$var$o.PATH_FILESTAT_SET_SIZE | $a801f2c896bd09f1$var$o.PATH_FILESTAT_SET_TIMES | $a801f2c896bd09f1$var$o.FD_FILESTAT_GET | $a801f2c896bd09f1$var$o.FD_FILESTAT_SET_SIZE | $a801f2c896bd09f1$var$o.FD_FILESTAT_SET_TIMES | $a801f2c896bd09f1$var$o.PATH_SYMLINK | $a801f2c896bd09f1$var$o.PATH_REMOVE_DIRECTORY | $a801f2c896bd09f1$var$o.PATH_UNLINK_FILE | $a801f2c896bd09f1$var$o.POLL_FD_READWRITE | $a801f2c896bd09f1$var$o.SOCK_SHUTDOWN | $a801f2c896bd09f1$var$o.SOCK_ACCEPT;
var $a801f2c896bd09f1$var$v = class extends Error {
    constructor(i2){
        super();
        $a801f2c896bd09f1$var$m(this, "code");
        this.code = i2;
    }
};
function $a801f2c896bd09f1$var$I(e, t2, i2) {
    return new TextDecoder().decode(new Uint8Array(e.buffer, t2, i2));
}
function $a801f2c896bd09f1$var$K(e, t2, i2) {
    let n = Array(i2);
    for(let s2 = 0; s2 < i2; s2++){
        const l2 = e.getUint32(t2, true);
        t2 += 4;
        const d = e.getUint32(t2, true);
        t2 += 4, n[s2] = new Uint8Array(e.buffer, l2, d);
    }
    return n;
}
function $a801f2c896bd09f1$var$mt(e) {
    const t2 = new Uint8Array(8);
    t2.set(e.subarray(0, 8));
    const i2 = e[8], n = new DataView(e.buffer, e.byteOffset + 9);
    switch(i2){
        case $a801f2c896bd09f1$var$p.FD_READ:
        case $a801f2c896bd09f1$var$p.FD_WRITE:
            return {
                userdata: t2,
                type: i2,
                fd: n.getUint32(0, true)
            };
        case $a801f2c896bd09f1$var$p.CLOCK:
            const s2 = n.getUint16(24, true), l2 = $a801f2c896bd09f1$var$W(/* @__PURE__ */ new Date()), d = n.getBigUint64(8, true), V = n.getBigUint64(16, true), a3 = s2 & $a801f2c896bd09f1$var$et.SUBSCRIPTION_CLOCK_ABSTIME ? d : l2 + d;
            return {
                userdata: t2,
                type: i2,
                id: n.getUint32(0, true),
                timeout: $a801f2c896bd09f1$var$k(a3),
                precision: $a801f2c896bd09f1$var$k(a3 + V)
            };
    }
}
function $a801f2c896bd09f1$var$j(e) {
    const t2 = new Uint8Array($a801f2c896bd09f1$var$P), i2 = new DataView(t2.buffer);
    return i2.setBigUint64(0, BigInt(0), true), i2.setBigUint64(8, BigInt($a801f2c896bd09f1$var$w(e.path)), true), i2.setUint8(16, e.type), i2.setBigUint64(24, BigInt(1), true), i2.setBigUint64(32, BigInt(e.byteLength), true), i2.setBigUint64(40, $a801f2c896bd09f1$var$W(e.timestamps.access), true), i2.setBigUint64(48, $a801f2c896bd09f1$var$W(e.timestamps.modification), true), i2.setBigUint64(56, $a801f2c896bd09f1$var$W(e.timestamps.change), true), t2;
}
function $a801f2c896bd09f1$var$$(e) {
    const t2 = new Uint8Array($a801f2c896bd09f1$var$P), i2 = new DataView(t2.buffer);
    return i2.setBigUint64(0, BigInt(0), true), i2.setBigUint64(8, BigInt($a801f2c896bd09f1$var$w(e.path)), true), i2.setUint8(16, e.type), i2.setUint32(20, 1, true), i2.setBigUint64(24, BigInt(e.byteLength), true), i2.setBigUint64(32, $a801f2c896bd09f1$var$W(e.timestamps.access), true), i2.setBigUint64(40, $a801f2c896bd09f1$var$W(e.timestamps.modification), true), i2.setBigUint64(48, $a801f2c896bd09f1$var$W(e.timestamps.change), true), t2;
}
function $a801f2c896bd09f1$var$B(e, t2, i2) {
    const n = i2 ?? $a801f2c896bd09f1$var$O, s2 = i2 ?? $a801f2c896bd09f1$var$O, l2 = new Uint8Array(24), d = new DataView(l2.buffer, 0, 24);
    return d.setUint8(0, e), d.setUint32(2, t2, true), d.setBigUint64(8, n, true), d.setBigUint64(16, s2, true), l2;
}
function $a801f2c896bd09f1$var$ot(e, t2, i2) {
    const n = new TextEncoder().encode(e), s2 = 24 + n.byteLength, l2 = new Uint8Array(s2), d = new DataView(l2.buffer);
    return d.setBigUint64(0, BigInt(i2 + 1), true), d.setBigUint64(8, BigInt($a801f2c896bd09f1$var$w(e)), true), d.setUint32(16, n.length, true), d.setUint8(20, t2), l2.set(n, 24), l2;
}
function $a801f2c896bd09f1$var$ut(e, t2) {
    const i2 = new Uint8Array(32);
    i2.set(e, 0);
    const n = new DataView(i2.buffer);
    return n.setUint16(8, t2, true), n.setUint16(10, $a801f2c896bd09f1$var$p.CLOCK, true), i2;
}
function $a801f2c896bd09f1$var$q(e, t2, i2, n) {
    const s2 = new Uint8Array(32);
    s2.set(e, 0);
    const l2 = new DataView(s2.buffer);
    return l2.setUint16(8, t2, true), l2.setUint16(10, i2, true), l2.setBigUint64(16, n, true), s2;
}
function $a801f2c896bd09f1$var$w(e, t2 = 0) {
    let i2 = 3735928559 ^ t2, n = 1103547991 ^ t2;
    for(let s2 = 0, l2; s2 < e.length; s2++)l2 = e.charCodeAt(s2), i2 = Math.imul(i2 ^ l2, 2654435761), n = Math.imul(n ^ l2, 1597334677);
    return i2 = Math.imul(i2 ^ i2 >>> 16, 2246822507) ^ Math.imul(n ^ n >>> 13, 3266489909), n = Math.imul(n ^ n >>> 16, 2246822507) ^ Math.imul(i2 ^ i2 >>> 13, 3266489909), 4294967296 * (2097151 & n) + (i2 >>> 0);
}
function $a801f2c896bd09f1$var$W(e) {
    return BigInt(e.getTime()) * BigInt(1e6);
}
function $a801f2c896bd09f1$var$k(e) {
    return new Date(Number(e / BigInt(1e6)));
}
var $a801f2c896bd09f1$var$bt = {
    [$a801f2c896bd09f1$var$C.CUR]: $a801f2c896bd09f1$var$y.CUR,
    [$a801f2c896bd09f1$var$C.END]: $a801f2c896bd09f1$var$y.END,
    [$a801f2c896bd09f1$var$C.SET]: $a801f2c896bd09f1$var$y.SET
};
var $a801f2c896bd09f1$var$it = "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";
var $a801f2c896bd09f1$var$tt2 = typeof window < "u" && window.Blob && new Blob([
    atob($a801f2c896bd09f1$var$it)
], {
    type: "text/javascript;charset=utf-8"
});
// output/App.Utils/foreign.js
var $a801f2c896bd09f1$var$copyToClipboard = (str)=>()=>navigator.clipboard.writeText(str);
function $a801f2c896bd09f1$var$download_(data) {
    return function(fileName) {
        return function(mimeType) {
            return function() {
                return Boolean((0, $a801f2c896bd09f1$var$import_downloadjs.default)(data, fileName, mimeType));
            };
        };
    };
}
var $a801f2c896bd09f1$var$examplePieceJSON = [
    {
        time: "0.4.0",
        notes: [
            {
                pitch: "E4",
                id: "slice0.note0"
            },
            {
                pitch: "C4",
                id: "slice0.note1",
                hold: "slice1.note1"
            }
        ]
    },
    {
        time: "1.1.0",
        notes: [
            {
                pitch: "D4",
                id: "slice1.note0",
                hold: "slice2.note0"
            },
            {
                pitch: "C4",
                id: "slice1.note1"
            }
        ]
    },
    {
        time: "1.2.0",
        notes: [
            {
                pitch: "D4",
                id: "slice2.note0"
            },
            {
                pitch: "B3",
                id: "slice2.note1"
            }
        ]
    },
    {
        time: "1.3.0",
        notes: [
            {
                pitch: "C4",
                id: "slice3.note0"
            }
        ]
    }
];
var $a801f2c896bd09f1$var$examplePieceJSONLong = [
    {
        time: "0.4.3/4",
        notes: [
            {
                id: "slice0.note0",
                pitch: "D5"
            }
        ]
    },
    {
        time: "1.1.0",
        notes: [
            {
                id: "slice1.note2",
                pitch: "D5"
            },
            {
                hold: "slice2.note24",
                id: "slice1.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.1.1/4",
        notes: [
            {
                id: "slice2.note3",
                pitch: "A4"
            },
            {
                hold: "slice3.note24",
                id: "slice2.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.1.1/2",
        notes: [
            {
                id: "slice3.note4",
                pitch: "B\u266D4"
            },
            {
                hold: "slice4.note24",
                id: "slice3.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.1.3/4",
        notes: [
            {
                id: "slice4.note5",
                pitch: "G4"
            },
            {
                hold: "slice5.note24",
                id: "slice4.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.2.0",
        notes: [
            {
                id: "slice5.note6",
                pitch: "A4"
            },
            {
                hold: "slice6.note24",
                id: "slice5.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.2.1/4",
        notes: [
            {
                id: "slice6.note7",
                pitch: "F4"
            },
            {
                hold: "slice7.note24",
                id: "slice6.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.2.1/2",
        notes: [
            {
                id: "slice7.note8",
                pitch: "E4"
            },
            {
                hold: "slice8.note24",
                id: "slice7.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.2.3/4",
        notes: [
            {
                id: "slice8.note9",
                pitch: "D4"
            },
            {
                hold: "slice9.note24",
                id: "slice8.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.3.0",
        notes: [
            {
                hold: "slice10.note23",
                id: "slice9.note23",
                pitch: "C\u266F4"
            },
            {
                hold: "slice10.note24",
                id: "slice9.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.3.1/4",
        notes: [
            {
                id: "slice10.note11",
                pitch: "B\u266D4"
            },
            {
                hold: "slice11.note20",
                id: "slice10.note20",
                pitch: "B\u266D4"
            },
            {
                hold: "slice11.note23",
                id: "slice10.note23",
                pitch: "C\u266F4"
            },
            {
                hold: "slice11.note24",
                id: "slice10.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.3.1/2",
        notes: [
            {
                id: "slice11.note12",
                pitch: "E5"
            },
            {
                hold: "slice12.note20",
                id: "slice11.note20",
                pitch: "B\u266D4"
            },
            {
                hold: "slice12.note23",
                id: "slice11.note23",
                pitch: "C\u266F4"
            },
            {
                hold: "slice12.note24",
                id: "slice11.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.3.3/4",
        notes: [
            {
                hold: "slice13.note13",
                id: "slice12.note13",
                pitch: "G5"
            },
            {
                hold: "slice13.note23",
                id: "slice12.note23",
                pitch: "C\u266F4"
            },
            {
                hold: "slice13.note24",
                id: "slice12.note24",
                pitch: "D3"
            },
            {
                id: "slice12.note20",
                pitch: "B\u266D4"
            }
        ]
    },
    {
        time: "1.4.0",
        notes: [
            {
                hold: "slice14.note21",
                id: "slice13.note21",
                pitch: "A4"
            },
            {
                hold: "slice14.note23",
                id: "slice13.note23",
                pitch: "C\u266F4"
            },
            {
                hold: "slice14.note24",
                id: "slice13.note24",
                pitch: "D3"
            },
            {
                id: "slice13.note13",
                pitch: "G5"
            }
        ]
    },
    {
        time: "1.4.1/4",
        notes: [
            {
                id: "slice14.note15",
                pitch: "G5"
            },
            {
                hold: "slice15.note21",
                id: "slice14.note21",
                pitch: "A4"
            },
            {
                hold: "slice15.note23",
                id: "slice14.note23",
                pitch: "C\u266F4"
            },
            {
                hold: "slice15.note24",
                id: "slice14.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.4.1/2",
        notes: [
            {
                id: "slice15.note16",
                pitch: "F5"
            },
            {
                hold: "slice16.note21",
                id: "slice15.note21",
                pitch: "A4"
            },
            {
                hold: "slice16.note23",
                id: "slice15.note23",
                pitch: "C\u266F4"
            },
            {
                hold: "slice16.note24",
                id: "slice15.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "1.4.3/4",
        notes: [
            {
                id: "slice16.note17",
                pitch: "E5"
            },
            {
                hold: "slice17.note21",
                id: "slice16.note21",
                pitch: "A4"
            },
            {
                hold: "slice17.note24",
                id: "slice16.note24",
                pitch: "D3"
            },
            {
                id: "slice16.note23",
                pitch: "C\u266F4"
            }
        ]
    },
    {
        time: "2.1.0",
        notes: [
            {
                id: "slice17.note25",
                pitch: "G5"
            },
            {
                hold: "slice18.note34",
                id: "slice17.note34",
                pitch: "D4"
            },
            {
                hold: "slice18.note21",
                id: "slice17.note21",
                pitch: "A4"
            },
            {
                hold: "slice18.note24",
                id: "slice17.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "2.1.1/4",
        notes: [
            {
                id: "slice18.note26",
                pitch: "F5"
            },
            {
                hold: "slice19.note21",
                id: "slice18.note21",
                pitch: "A4"
            },
            {
                id: "slice18.note34",
                pitch: "D4"
            },
            {
                id: "slice18.note24",
                pitch: "D3"
            }
        ]
    },
    {
        time: "2.1.1/2",
        notes: [
            {
                id: "slice19.note27",
                pitch: "E5"
            },
            {
                hold: "slice20.note39",
                id: "slice19.note39",
                pitch: "A3"
            },
            {
                hold: "slice20.note21",
                id: "slice19.note21",
                pitch: "A4"
            }
        ]
    },
    {
        time: "2.1.3/4",
        notes: [
            {
                id: "slice20.note28",
                pitch: "D5"
            },
            {
                id: "slice20.note39",
                pitch: "A3"
            },
            {
                id: "slice20.note21",
                pitch: "A4"
            }
        ]
    },
    {
        time: "2.2.0",
        notes: [
            {
                id: "slice21.note40",
                pitch: "D4"
            },
            {
                id: "slice21.note29",
                pitch: "F5"
            }
        ]
    }
];

var $a801f2c896bd09f1$var$musicxml2pv = (mkLeft)=>(mkRight)=>(unfold)=>(musicxml)=>async ()=>{
                    var output2 = "";
                    var args = [
                        "musicxml2pv",
                        "/input.musicxml"
                    ];
                    if (unfold) args.splice(1, 0, "-u");
                    console.log(args);
                    const wasi = new $a801f2c896bd09f1$var$H({
                        args: args,
                        stdout: (out)=>output2 += out,
                        stderr: (err)=>console.error("wasm err:", err),
                        fs: {
                            "/input.musicxml": {
                                path: "/input.musicxml",
                                timestamps: {
                                    access: /* @__PURE__ */ new Date(),
                                    change: /* @__PURE__ */ new Date(),
                                    modification: /* @__PURE__ */ new Date()
                                },
                                mode: "string",
                                content: musicxml
                            }
                        }
                    });
                    const wasm = await WebAssembly.instantiateStreaming(fetch(new URL((parcelRequire("cEkdT")))), wasi.getImportObject());
                    const result2 = await wasi.start(wasm, {});
                    console.log(result2);
                    if (output2 == "") return mkLeft("musicxml2pv returned empty string");
                    else if (result2.exitCode != 0) return mkLeft("musicxml2pv returned exit code" + result2.exitCode.toString());
                    else return mkRight(output2);
                };
function $a801f2c896bd09f1$var$eventTargetIsBody(eventTarget) {
    try {
        return eventTarget.tagName.toLowerCase() == "body";
    } catch  {
        return false;
    }
}
function $a801f2c896bd09f1$var$getElementHTML(id4) {
    return ()=>document.getElementById(id4).outerHTML;
}
// output/Control.Promise/foreign.js
function $a801f2c896bd09f1$var$thenImpl(promise2) {
    return function(errCB) {
        return function(succCB) {
            return function() {
                promise2.then(succCB, errCB);
            };
        };
    };
}
// output/Effect.Aff/foreign.js
var $a801f2c896bd09f1$var$Aff = function() {
    var EMPTY = {};
    var PURE = "Pure";
    var THROW = "Throw";
    var CATCH = "Catch";
    var SYNC = "Sync";
    var ASYNC = "Async";
    var BIND = "Bind";
    var BRACKET = "Bracket";
    var FORK = "Fork";
    var SEQ = "Sequential";
    var MAP = "Map";
    var APPLY = "Apply";
    var ALT = "Alt";
    var CONS = "Cons";
    var RESUME = "Resume";
    var RELEASE = "Release";
    var FINALIZER = "Finalizer";
    var FINALIZED = "Finalized";
    var FORKED = "Forked";
    var FIBER = "Fiber";
    var THUNK = "Thunk";
    function Aff2(tag, _1, _2, _3) {
        this.tag = tag;
        this._1 = _1;
        this._2 = _2;
        this._3 = _3;
    }
    function AffCtr(tag) {
        var fn = function(_1, _2, _3) {
            return new Aff2(tag, _1, _2, _3);
        };
        fn.tag = tag;
        return fn;
    }
    function nonCanceler2(error5) {
        return new Aff2(PURE, void 0);
    }
    function runEff(eff) {
        try {
            eff();
        } catch (error5) {
            setTimeout(function() {
                throw error5;
            }, 0);
        }
    }
    function runSync(left, right, eff) {
        try {
            return right(eff());
        } catch (error5) {
            return left(error5);
        }
    }
    function runAsync(left, eff, k2) {
        try {
            return eff(k2)();
        } catch (error5) {
            k2(left(error5))();
            return nonCanceler2;
        }
    }
    var Scheduler = function() {
        var limit = 1024;
        var size6 = 0;
        var ix = 0;
        var queue = new Array(limit);
        var draining = false;
        function drain() {
            var thunk;
            draining = true;
            while(size6 !== 0){
                size6--;
                thunk = queue[ix];
                queue[ix] = void 0;
                ix = (ix + 1) % limit;
                thunk();
            }
            draining = false;
        }
        return {
            isDraining: function() {
                return draining;
            },
            enqueue: function(cb) {
                var i2, tmp;
                if (size6 === limit) {
                    tmp = draining;
                    drain();
                    draining = tmp;
                }
                queue[(ix + size6) % limit] = cb;
                size6++;
                if (!draining) drain();
            }
        };
    }();
    function Supervisor(util) {
        var fibers = {};
        var fiberId = 0;
        var count = 0;
        return {
            register: function(fiber) {
                var fid = fiberId++;
                fiber.onComplete({
                    rethrow: true,
                    handler: function(result2) {
                        return function() {
                            count--;
                            delete fibers[fid];
                        };
                    }
                })();
                fibers[fid] = fiber;
                count++;
            },
            isEmpty: function() {
                return count === 0;
            },
            killAll: function(killError, cb) {
                return function() {
                    if (count === 0) return cb();
                    var killCount = 0;
                    var kills = {};
                    function kill2(fid) {
                        kills[fid] = fibers[fid].kill(killError, function(result2) {
                            return function() {
                                delete kills[fid];
                                killCount--;
                                if (util.isLeft(result2) && util.fromLeft(result2)) setTimeout(function() {
                                    throw util.fromLeft(result2);
                                }, 0);
                                if (killCount === 0) cb();
                            };
                        })();
                    }
                    for(var k2 in fibers)if (fibers.hasOwnProperty(k2)) {
                        killCount++;
                        kill2(k2);
                    }
                    fibers = {};
                    fiberId = 0;
                    count = 0;
                    return function(error5) {
                        return new Aff2(SYNC, function() {
                            for(var k3 in kills)if (kills.hasOwnProperty(k3)) kills[k3]();
                        });
                    };
                };
            }
        };
    }
    var SUSPENDED = 0;
    var CONTINUE = 1;
    var STEP_BIND = 2;
    var STEP_RESULT = 3;
    var PENDING = 4;
    var RETURN = 5;
    var COMPLETED = 6;
    function Fiber(util, supervisor, aff) {
        var runTick = 0;
        var status = SUSPENDED;
        var step4 = aff;
        var fail6 = null;
        var interrupt = null;
        var bhead = null;
        var btail = null;
        var attempts = null;
        var bracketCount = 0;
        var joinId = 0;
        var joins = null;
        var rethrow = true;
        function run3(localRunTick) {
            var tmp, result2, attempt;
            while(true){
                tmp = null;
                result2 = null;
                attempt = null;
                switch(status){
                    case STEP_BIND:
                        status = CONTINUE;
                        try {
                            step4 = bhead(step4);
                            if (btail === null) bhead = null;
                            else {
                                bhead = btail._1;
                                btail = btail._2;
                            }
                        } catch (e) {
                            status = RETURN;
                            fail6 = util.left(e);
                            step4 = null;
                        }
                        break;
                    case STEP_RESULT:
                        if (util.isLeft(step4)) {
                            status = RETURN;
                            fail6 = step4;
                            step4 = null;
                        } else if (bhead === null) status = RETURN;
                        else {
                            status = STEP_BIND;
                            step4 = util.fromRight(step4);
                        }
                        break;
                    case CONTINUE:
                        switch(step4.tag){
                            case BIND:
                                if (bhead) btail = new Aff2(CONS, bhead, btail);
                                bhead = step4._2;
                                status = CONTINUE;
                                step4 = step4._1;
                                break;
                            case PURE:
                                if (bhead === null) {
                                    status = RETURN;
                                    step4 = util.right(step4._1);
                                } else {
                                    status = STEP_BIND;
                                    step4 = step4._1;
                                }
                                break;
                            case SYNC:
                                status = STEP_RESULT;
                                step4 = runSync(util.left, util.right, step4._1);
                                break;
                            case ASYNC:
                                status = PENDING;
                                step4 = runAsync(util.left, step4._1, function(result3) {
                                    return function() {
                                        if (runTick !== localRunTick) return;
                                        runTick++;
                                        Scheduler.enqueue(function() {
                                            if (runTick !== localRunTick + 1) return;
                                            status = STEP_RESULT;
                                            step4 = result3;
                                            run3(runTick);
                                        });
                                    };
                                });
                                return;
                            case THROW:
                                status = RETURN;
                                fail6 = util.left(step4._1);
                                step4 = null;
                                break;
                            // Enqueue the Catch so that we can call the error handler later on
                            // in case of an exception.
                            case CATCH:
                                if (bhead === null) attempts = new Aff2(CONS, step4, attempts, interrupt);
                                else attempts = new Aff2(CONS, step4, new Aff2(CONS, new Aff2(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step4 = step4._1;
                                break;
                            // Enqueue the Bracket so that we can call the appropriate handlers
                            // after resource acquisition.
                            case BRACKET:
                                bracketCount++;
                                if (bhead === null) attempts = new Aff2(CONS, step4, attempts, interrupt);
                                else attempts = new Aff2(CONS, step4, new Aff2(CONS, new Aff2(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step4 = step4._1;
                                break;
                            case FORK:
                                status = STEP_RESULT;
                                tmp = Fiber(util, supervisor, step4._2);
                                if (supervisor) supervisor.register(tmp);
                                if (step4._1) tmp.run();
                                step4 = util.right(tmp);
                                break;
                            case SEQ:
                                status = CONTINUE;
                                step4 = sequential3(util, supervisor, step4._1);
                                break;
                        }
                        break;
                    case RETURN:
                        bhead = null;
                        btail = null;
                        if (attempts === null) {
                            status = COMPLETED;
                            step4 = interrupt || fail6 || step4;
                        } else {
                            tmp = attempts._3;
                            attempt = attempts._1;
                            attempts = attempts._2;
                            switch(attempt.tag){
                                // We cannot recover from an unmasked interrupt. Otherwise we should
                                // continue stepping, or run the exception handler if an exception
                                // was raised.
                                case CATCH:
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) status = RETURN;
                                    else if (fail6) {
                                        status = CONTINUE;
                                        step4 = attempt._2(util.fromLeft(fail6));
                                        fail6 = null;
                                    }
                                    break;
                                // We cannot resume from an unmasked interrupt or exception.
                                case RESUME:
                                    if (interrupt && interrupt !== tmp && bracketCount === 0 || fail6) status = RETURN;
                                    else {
                                        bhead = attempt._1;
                                        btail = attempt._2;
                                        status = STEP_BIND;
                                        step4 = util.fromRight(step4);
                                    }
                                    break;
                                // If we have a bracket, we should enqueue the handlers,
                                // and continue with the success branch only if the fiber has
                                // not been interrupted. If the bracket acquisition failed, we
                                // should not run either.
                                case BRACKET:
                                    bracketCount--;
                                    if (fail6 === null) {
                                        result2 = util.fromRight(step4);
                                        attempts = new Aff2(CONS, new Aff2(RELEASE, attempt._2, result2), attempts, tmp);
                                        if (interrupt === tmp || bracketCount > 0) {
                                            status = CONTINUE;
                                            step4 = attempt._3(result2);
                                        }
                                    }
                                    break;
                                // Enqueue the appropriate handler. We increase the bracket count
                                // because it should not be cancelled.
                                case RELEASE:
                                    attempts = new Aff2(CONS, new Aff2(FINALIZED, step4, fail6), attempts, interrupt);
                                    status = CONTINUE;
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) step4 = attempt._1.killed(util.fromLeft(interrupt))(attempt._2);
                                    else if (fail6) step4 = attempt._1.failed(util.fromLeft(fail6))(attempt._2);
                                    else step4 = attempt._1.completed(util.fromRight(step4))(attempt._2);
                                    fail6 = null;
                                    bracketCount++;
                                    break;
                                case FINALIZER:
                                    bracketCount++;
                                    attempts = new Aff2(CONS, new Aff2(FINALIZED, step4, fail6), attempts, interrupt);
                                    status = CONTINUE;
                                    step4 = attempt._1;
                                    break;
                                case FINALIZED:
                                    bracketCount--;
                                    status = RETURN;
                                    step4 = attempt._1;
                                    fail6 = attempt._2;
                                    break;
                            }
                        }
                        break;
                    case COMPLETED:
                        for(var k2 in joins)if (joins.hasOwnProperty(k2)) {
                            rethrow = rethrow && joins[k2].rethrow;
                            runEff(joins[k2].handler(step4));
                        }
                        joins = null;
                        if (interrupt && fail6) setTimeout(function() {
                            throw util.fromLeft(fail6);
                        }, 0);
                        else if (util.isLeft(step4) && rethrow) setTimeout(function() {
                            if (rethrow) throw util.fromLeft(step4);
                        }, 0);
                        return;
                    case SUSPENDED:
                        status = CONTINUE;
                        break;
                    case PENDING:
                        return;
                }
            }
        }
        function onComplete(join4) {
            return function() {
                if (status === COMPLETED) {
                    rethrow = rethrow && join4.rethrow;
                    join4.handler(step4)();
                    return function() {};
                }
                var jid = joinId++;
                joins = joins || {};
                joins[jid] = join4;
                return function() {
                    if (joins !== null) delete joins[jid];
                };
            };
        }
        function kill2(error5, cb) {
            return function() {
                if (status === COMPLETED) {
                    cb(util.right(void 0))();
                    return function() {};
                }
                var canceler = onComplete({
                    rethrow: false,
                    handler: function() {
                        return cb(util.right(void 0));
                    }
                })();
                switch(status){
                    case SUSPENDED:
                        interrupt = util.left(error5);
                        status = COMPLETED;
                        step4 = interrupt;
                        run3(runTick);
                        break;
                    case PENDING:
                        if (interrupt === null) interrupt = util.left(error5);
                        if (bracketCount === 0) {
                            if (status === PENDING) attempts = new Aff2(CONS, new Aff2(FINALIZER, step4(error5)), attempts, interrupt);
                            status = RETURN;
                            step4 = null;
                            fail6 = null;
                            run3(++runTick);
                        }
                        break;
                    default:
                        if (interrupt === null) interrupt = util.left(error5);
                        if (bracketCount === 0) {
                            status = RETURN;
                            step4 = null;
                            fail6 = null;
                        }
                }
                return canceler;
            };
        }
        function join3(cb) {
            return function() {
                var canceler = onComplete({
                    rethrow: false,
                    handler: cb
                })();
                if (status === SUSPENDED) run3(runTick);
                return canceler;
            };
        }
        return {
            kill: kill2,
            join: join3,
            onComplete: onComplete,
            isSuspended: function() {
                return status === SUSPENDED;
            },
            run: function() {
                if (status === SUSPENDED) {
                    if (!Scheduler.isDraining()) Scheduler.enqueue(function() {
                        run3(runTick);
                    });
                    else run3(runTick);
                }
            }
        };
    }
    function runPar(util, supervisor, par, cb) {
        var fiberId = 0;
        var fibers = {};
        var killId = 0;
        var kills = {};
        var early = new Error("[ParAff] Early exit");
        var interrupt = null;
        var root = EMPTY;
        function kill2(error5, par2, cb2) {
            var step4 = par2;
            var head5 = null;
            var tail2 = null;
            var count = 0;
            var kills2 = {};
            var tmp, kid;
            loop: while(true){
                tmp = null;
                switch(step4.tag){
                    case FORKED:
                        if (step4._3 === EMPTY) {
                            tmp = fibers[step4._1];
                            kills2[count++] = tmp.kill(error5, function(result2) {
                                return function() {
                                    count--;
                                    if (count === 0) cb2(result2)();
                                };
                            });
                        }
                        if (head5 === null) break loop;
                        step4 = head5._2;
                        if (tail2 === null) head5 = null;
                        else {
                            head5 = tail2._1;
                            tail2 = tail2._2;
                        }
                        break;
                    case MAP:
                        step4 = step4._2;
                        break;
                    case APPLY:
                    case ALT:
                        if (head5) tail2 = new Aff2(CONS, head5, tail2);
                        head5 = step4;
                        step4 = step4._1;
                        break;
                }
            }
            if (count === 0) cb2(util.right(void 0))();
            else {
                kid = 0;
                tmp = count;
                for(; kid < tmp; kid++)kills2[kid] = kills2[kid]();
            }
            return kills2;
        }
        function join3(result2, head5, tail2) {
            var fail6, step4, lhs, rhs, tmp, kid;
            if (util.isLeft(result2)) {
                fail6 = result2;
                step4 = null;
            } else {
                step4 = result2;
                fail6 = null;
            }
            loop: while(true){
                lhs = null;
                rhs = null;
                tmp = null;
                kid = null;
                if (interrupt !== null) return;
                if (head5 === null) {
                    cb(fail6 || step4)();
                    return;
                }
                if (head5._3 !== EMPTY) return;
                switch(head5.tag){
                    case MAP:
                        if (fail6 === null) {
                            head5._3 = util.right(head5._1(util.fromRight(step4)));
                            step4 = head5._3;
                        } else head5._3 = fail6;
                        break;
                    case APPLY:
                        lhs = head5._1._3;
                        rhs = head5._2._3;
                        if (fail6) {
                            head5._3 = fail6;
                            tmp = true;
                            kid = killId++;
                            kills[kid] = kill2(early, fail6 === lhs ? head5._2 : head5._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail2 === null) join3(fail6, null, null);
                                    else join3(fail6, tail2._1, tail2._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        } else if (lhs === EMPTY || rhs === EMPTY) return;
                        else {
                            step4 = util.right(util.fromRight(lhs)(util.fromRight(rhs)));
                            head5._3 = step4;
                        }
                        break;
                    case ALT:
                        lhs = head5._1._3;
                        rhs = head5._2._3;
                        if (lhs === EMPTY && util.isLeft(rhs) || rhs === EMPTY && util.isLeft(lhs)) return;
                        if (lhs !== EMPTY && util.isLeft(lhs) && rhs !== EMPTY && util.isLeft(rhs)) {
                            fail6 = step4 === lhs ? rhs : lhs;
                            step4 = null;
                            head5._3 = fail6;
                        } else {
                            head5._3 = step4;
                            tmp = true;
                            kid = killId++;
                            kills[kid] = kill2(early, step4 === lhs ? head5._2 : head5._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail2 === null) join3(step4, null, null);
                                    else join3(step4, tail2._1, tail2._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        }
                        break;
                }
                if (tail2 === null) head5 = null;
                else {
                    head5 = tail2._1;
                    tail2 = tail2._2;
                }
            }
        }
        function resolve(fiber) {
            return function(result2) {
                return function() {
                    delete fibers[fiber._1];
                    fiber._3 = result2;
                    join3(result2, fiber._2._1, fiber._2._2);
                };
            };
        }
        function run3() {
            var status = CONTINUE;
            var step4 = par;
            var head5 = null;
            var tail2 = null;
            var tmp, fid;
            loop: while(true){
                tmp = null;
                fid = null;
                switch(status){
                    case CONTINUE:
                        switch(step4.tag){
                            case MAP:
                                if (head5) tail2 = new Aff2(CONS, head5, tail2);
                                head5 = new Aff2(MAP, step4._1, EMPTY, EMPTY);
                                step4 = step4._2;
                                break;
                            case APPLY:
                                if (head5) tail2 = new Aff2(CONS, head5, tail2);
                                head5 = new Aff2(APPLY, EMPTY, step4._2, EMPTY);
                                step4 = step4._1;
                                break;
                            case ALT:
                                if (head5) tail2 = new Aff2(CONS, head5, tail2);
                                head5 = new Aff2(ALT, EMPTY, step4._2, EMPTY);
                                step4 = step4._1;
                                break;
                            default:
                                fid = fiberId++;
                                status = RETURN;
                                tmp = step4;
                                step4 = new Aff2(FORKED, fid, new Aff2(CONS, head5, tail2), EMPTY);
                                tmp = Fiber(util, supervisor, tmp);
                                tmp.onComplete({
                                    rethrow: false,
                                    handler: resolve(step4)
                                })();
                                fibers[fid] = tmp;
                                if (supervisor) supervisor.register(tmp);
                        }
                        break;
                    case RETURN:
                        if (head5 === null) break loop;
                        if (head5._1 === EMPTY) {
                            head5._1 = step4;
                            status = CONTINUE;
                            step4 = head5._2;
                            head5._2 = EMPTY;
                        } else {
                            head5._2 = step4;
                            step4 = head5;
                            if (tail2 === null) head5 = null;
                            else {
                                head5 = tail2._1;
                                tail2 = tail2._2;
                            }
                        }
                }
            }
            root = step4;
            for(fid = 0; fid < fiberId; fid++)fibers[fid].run();
        }
        function cancel(error5, cb2) {
            interrupt = util.left(error5);
            var innerKills;
            for(var kid in kills)if (kills.hasOwnProperty(kid)) {
                innerKills = kills[kid];
                for(kid in innerKills)if (innerKills.hasOwnProperty(kid)) innerKills[kid]();
            }
            kills = null;
            var newKills = kill2(error5, root, cb2);
            return function(killError) {
                return new Aff2(ASYNC, function(killCb) {
                    return function() {
                        for(var kid2 in newKills)if (newKills.hasOwnProperty(kid2)) newKills[kid2]();
                        return nonCanceler2;
                    };
                });
            };
        }
        run3();
        return function(killError) {
            return new Aff2(ASYNC, function(killCb) {
                return function() {
                    return cancel(killError, killCb);
                };
            });
        };
    }
    function sequential3(util, supervisor, par) {
        return new Aff2(ASYNC, function(cb) {
            return function() {
                return runPar(util, supervisor, par, cb);
            };
        });
    }
    Aff2.EMPTY = EMPTY;
    Aff2.Pure = AffCtr(PURE);
    Aff2.Throw = AffCtr(THROW);
    Aff2.Catch = AffCtr(CATCH);
    Aff2.Sync = AffCtr(SYNC);
    Aff2.Async = AffCtr(ASYNC);
    Aff2.Bind = AffCtr(BIND);
    Aff2.Bracket = AffCtr(BRACKET);
    Aff2.Fork = AffCtr(FORK);
    Aff2.Seq = AffCtr(SEQ);
    Aff2.ParMap = AffCtr(MAP);
    Aff2.ParApply = AffCtr(APPLY);
    Aff2.ParAlt = AffCtr(ALT);
    Aff2.Fiber = Fiber;
    Aff2.Supervisor = Supervisor;
    Aff2.Scheduler = Scheduler;
    Aff2.nonCanceler = nonCanceler2;
    return Aff2;
}();
var $a801f2c896bd09f1$var$_pure = $a801f2c896bd09f1$var$Aff.Pure;
var $a801f2c896bd09f1$var$_throwError = $a801f2c896bd09f1$var$Aff.Throw;
function $a801f2c896bd09f1$var$_catchError(aff) {
    return function(k2) {
        return $a801f2c896bd09f1$var$Aff.Catch(aff, k2);
    };
}
function $a801f2c896bd09f1$var$_map(f2) {
    return function(aff) {
        if (aff.tag === $a801f2c896bd09f1$var$Aff.Pure.tag) return $a801f2c896bd09f1$var$Aff.Pure(f2(aff._1));
        else return $a801f2c896bd09f1$var$Aff.Bind(aff, function(value17) {
            return $a801f2c896bd09f1$var$Aff.Pure(f2(value17));
        });
    };
}
function $a801f2c896bd09f1$var$_bind(aff) {
    return function(k2) {
        return $a801f2c896bd09f1$var$Aff.Bind(aff, k2);
    };
}
function $a801f2c896bd09f1$var$_fork(immediate) {
    return function(aff) {
        return $a801f2c896bd09f1$var$Aff.Fork(immediate, aff);
    };
}
var $a801f2c896bd09f1$var$_liftEffect = $a801f2c896bd09f1$var$Aff.Sync;
function $a801f2c896bd09f1$var$_parAffMap(f2) {
    return function(aff) {
        return $a801f2c896bd09f1$var$Aff.ParMap(f2, aff);
    };
}
function $a801f2c896bd09f1$var$_parAffApply(aff1) {
    return function(aff2) {
        return $a801f2c896bd09f1$var$Aff.ParApply(aff1, aff2);
    };
}
var $a801f2c896bd09f1$var$makeAff = $a801f2c896bd09f1$var$Aff.Async;
function $a801f2c896bd09f1$var$generalBracket(acquire) {
    return function(options2) {
        return function(k2) {
            return $a801f2c896bd09f1$var$Aff.Bracket(acquire, options2, k2);
        };
    };
}
function $a801f2c896bd09f1$var$_makeFiber(util, aff) {
    return function() {
        return $a801f2c896bd09f1$var$Aff.Fiber(util, null, aff);
    };
}
var $a801f2c896bd09f1$var$_sequential = $a801f2c896bd09f1$var$Aff.Seq;
// output/Control.Parallel.Class/index.js
var $a801f2c896bd09f1$var$sequential = function(dict) {
    return dict.sequential;
};
var $a801f2c896bd09f1$var$parallel = function(dict) {
    return dict.parallel;
};
// output/Control.Parallel/index.js
var $a801f2c896bd09f1$var$identity10 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$parTraverse_ = function(dictParallel) {
    var sequential3 = $a801f2c896bd09f1$var$sequential(dictParallel);
    var parallel4 = $a801f2c896bd09f1$var$parallel(dictParallel);
    return function(dictApplicative) {
        var traverse_8 = $a801f2c896bd09f1$var$traverse_(dictApplicative);
        return function(dictFoldable) {
            var traverse_14 = traverse_8(dictFoldable);
            return function(f2) {
                var $51 = traverse_14(function($53) {
                    return parallel4(f2($53));
                });
                return function($52) {
                    return sequential3($51($52));
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$parSequence_ = function(dictParallel) {
    var parTraverse_1 = $a801f2c896bd09f1$var$parTraverse_(dictParallel);
    return function(dictApplicative) {
        var parTraverse_2 = parTraverse_1(dictApplicative);
        return function(dictFoldable) {
            return parTraverse_2(dictFoldable)($a801f2c896bd09f1$var$identity10);
        };
    };
};
// output/Effect.Aff/index.js
var $a801f2c896bd09f1$var$$runtime_lazy5 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$pure11 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$$$void4 = /* @__PURE__ */ $a801f2c896bd09f1$var$$$void($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$map20 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$Canceler = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$suspendAff = /* @__PURE__ */ $a801f2c896bd09f1$var$_fork(false);
var $a801f2c896bd09f1$var$functorParAff = {
    map: $a801f2c896bd09f1$var$_parAffMap
};
var $a801f2c896bd09f1$var$functorAff = {
    map: $a801f2c896bd09f1$var$_map
};
var $a801f2c896bd09f1$var$map111 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorAff);
var $a801f2c896bd09f1$var$forkAff = /* @__PURE__ */ $a801f2c896bd09f1$var$_fork(true);
var $a801f2c896bd09f1$var$ffiUtil = /* @__PURE__ */ function() {
    var unsafeFromRight = function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$Right) return v3.value0;
        if (v3 instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$unsafeCrashWith("unsafeFromRight: Left");
        throw new Error("Failed pattern match at Effect.Aff (line 412, column 21 - line 414, column 54): " + [
            v3.constructor.name
        ]);
    };
    var unsafeFromLeft = function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$Left) return v3.value0;
        if (v3 instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$unsafeCrashWith("unsafeFromLeft: Right");
        throw new Error("Failed pattern match at Effect.Aff (line 407, column 20 - line 409, column 55): " + [
            v3.constructor.name
        ]);
    };
    var isLeft = function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$Left) return true;
        if (v3 instanceof $a801f2c896bd09f1$var$Right) return false;
        throw new Error("Failed pattern match at Effect.Aff (line 402, column 12 - line 404, column 21): " + [
            v3.constructor.name
        ]);
    };
    return {
        isLeft: isLeft,
        fromLeft: unsafeFromLeft,
        fromRight: unsafeFromRight,
        left: $a801f2c896bd09f1$var$Left.create,
        right: $a801f2c896bd09f1$var$Right.create
    };
}();
var $a801f2c896bd09f1$var$makeFiber = function(aff) {
    return $a801f2c896bd09f1$var$_makeFiber($a801f2c896bd09f1$var$ffiUtil, aff);
};
var $a801f2c896bd09f1$var$launchAff = function(aff) {
    return function __do2() {
        var fiber = $a801f2c896bd09f1$var$makeFiber(aff)();
        fiber.run();
        return fiber;
    };
};
var $a801f2c896bd09f1$var$bracket = function(acquire) {
    return function(completed) {
        return $a801f2c896bd09f1$var$generalBracket(acquire)({
            killed: $a801f2c896bd09f1$var$$$const(completed),
            failed: $a801f2c896bd09f1$var$$$const(completed),
            completed: $a801f2c896bd09f1$var$$$const(completed)
        });
    };
};
var $a801f2c896bd09f1$var$applyParAff = {
    apply: $a801f2c896bd09f1$var$_parAffApply,
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorParAff;
    }
};
var $a801f2c896bd09f1$var$monadAff = {
    Applicative0: function() {
        return $a801f2c896bd09f1$var$applicativeAff;
    },
    Bind1: function() {
        return $a801f2c896bd09f1$var$bindAff;
    }
};
var $a801f2c896bd09f1$var$bindAff = {
    bind: $a801f2c896bd09f1$var$_bind,
    Apply0: function() {
        return $a801f2c896bd09f1$var$$lazy_applyAff(0);
    }
};
var $a801f2c896bd09f1$var$applicativeAff = {
    pure: $a801f2c896bd09f1$var$_pure,
    Apply0: function() {
        return $a801f2c896bd09f1$var$$lazy_applyAff(0);
    }
};
var $a801f2c896bd09f1$var$$lazy_applyAff = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy5("applyAff", "Effect.Aff", function() {
    return {
        apply: $a801f2c896bd09f1$var$ap($a801f2c896bd09f1$var$monadAff),
        Functor0: function() {
            return $a801f2c896bd09f1$var$functorAff;
        }
    };
});
var $a801f2c896bd09f1$var$applyAff = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_applyAff(73);
var $a801f2c896bd09f1$var$pure23 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeAff);
var $a801f2c896bd09f1$var$bind13 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$bindFlipped4 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$$$finally = function(fin) {
    return function(a3) {
        return $a801f2c896bd09f1$var$bracket($a801f2c896bd09f1$var$pure23($a801f2c896bd09f1$var$unit))($a801f2c896bd09f1$var$$$const(fin))($a801f2c896bd09f1$var$$$const(a3));
    };
};
var $a801f2c896bd09f1$var$parallelAff = {
    parallel: $a801f2c896bd09f1$var$unsafeCoerce2,
    sequential: $a801f2c896bd09f1$var$_sequential,
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyAff;
    },
    Apply1: function() {
        return $a801f2c896bd09f1$var$applyParAff;
    }
};
var $a801f2c896bd09f1$var$parallel2 = /* @__PURE__ */ $a801f2c896bd09f1$var$parallel($a801f2c896bd09f1$var$parallelAff);
var $a801f2c896bd09f1$var$applicativeParAff = {
    pure: function($76) {
        return $a801f2c896bd09f1$var$parallel2($a801f2c896bd09f1$var$pure23($76));
    },
    Apply0: function() {
        return $a801f2c896bd09f1$var$applyParAff;
    }
};
var $a801f2c896bd09f1$var$parSequence_2 = /* @__PURE__ */ $a801f2c896bd09f1$var$parSequence_($a801f2c896bd09f1$var$parallelAff)($a801f2c896bd09f1$var$applicativeParAff)($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$semigroupCanceler = {
    append: function(v3) {
        return function(v1) {
            return function(err) {
                return $a801f2c896bd09f1$var$parSequence_2([
                    v3(err),
                    v1(err)
                ]);
            };
        };
    }
};
var $a801f2c896bd09f1$var$monadEffectAff = {
    liftEffect: $a801f2c896bd09f1$var$_liftEffect,
    Monad0: function() {
        return $a801f2c896bd09f1$var$monadAff;
    }
};
var $a801f2c896bd09f1$var$liftEffect2 = /* @__PURE__ */ $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectAff);
var $a801f2c896bd09f1$var$effectCanceler = function($77) {
    return $a801f2c896bd09f1$var$Canceler($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$liftEffect2($77)));
};
var $a801f2c896bd09f1$var$joinFiber = function(v3) {
    return $a801f2c896bd09f1$var$makeAff(function(k2) {
        return $a801f2c896bd09f1$var$map20($a801f2c896bd09f1$var$effectCanceler)(v3.join(k2));
    });
};
var $a801f2c896bd09f1$var$functorFiber = {
    map: function(f2) {
        return function(t2) {
            return $a801f2c896bd09f1$var$unsafePerformEffect($a801f2c896bd09f1$var$makeFiber($a801f2c896bd09f1$var$map111(f2)($a801f2c896bd09f1$var$joinFiber(t2))));
        };
    }
};
var $a801f2c896bd09f1$var$killFiber = function(e) {
    return function(v3) {
        return $a801f2c896bd09f1$var$bind13($a801f2c896bd09f1$var$liftEffect2(v3.isSuspended))(function(suspended) {
            if (suspended) return $a801f2c896bd09f1$var$liftEffect2($a801f2c896bd09f1$var$$$void4(v3.kill(e, $a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$pure11($a801f2c896bd09f1$var$unit)))));
            return $a801f2c896bd09f1$var$makeAff(function(k2) {
                return $a801f2c896bd09f1$var$map20($a801f2c896bd09f1$var$effectCanceler)(v3.kill(e, k2));
            });
        });
    };
};
var $a801f2c896bd09f1$var$monadThrowAff = {
    throwError: $a801f2c896bd09f1$var$_throwError,
    Monad0: function() {
        return $a801f2c896bd09f1$var$monadAff;
    }
};
var $a801f2c896bd09f1$var$monadErrorAff = {
    catchError: $a801f2c896bd09f1$var$_catchError,
    MonadThrow0: function() {
        return $a801f2c896bd09f1$var$monadThrowAff;
    }
};
var $a801f2c896bd09f1$var$$$try4 = /* @__PURE__ */ $a801f2c896bd09f1$var$$$try2($a801f2c896bd09f1$var$monadErrorAff);
var $a801f2c896bd09f1$var$runAff = function(k2) {
    return function(aff) {
        return $a801f2c896bd09f1$var$launchAff($a801f2c896bd09f1$var$bindFlipped4(function($83) {
            return $a801f2c896bd09f1$var$liftEffect2(k2($83));
        })($a801f2c896bd09f1$var$$$try4(aff)));
    };
};
var $a801f2c896bd09f1$var$runAff_ = function(k2) {
    return function(aff) {
        return $a801f2c896bd09f1$var$$$void4($a801f2c896bd09f1$var$runAff(k2)(aff));
    };
};
var $a801f2c896bd09f1$var$monadRecAff = {
    tailRecM: function(k2) {
        var go2 = function(a3) {
            return $a801f2c896bd09f1$var$bind13(k2(a3))(function(res) {
                if (res instanceof $a801f2c896bd09f1$var$Done) return $a801f2c896bd09f1$var$pure23(res.value0);
                if (res instanceof $a801f2c896bd09f1$var$Loop) return go2(res.value0);
                throw new Error("Failed pattern match at Effect.Aff (line 104, column 7 - line 106, column 23): " + [
                    res.constructor.name
                ]);
            });
        };
        return go2;
    },
    Monad0: function() {
        return $a801f2c896bd09f1$var$monadAff;
    }
};
var $a801f2c896bd09f1$var$nonCanceler = /* @__PURE__ */ $a801f2c896bd09f1$var$$$const(/* @__PURE__ */ $a801f2c896bd09f1$var$pure23($a801f2c896bd09f1$var$unit));
var $a801f2c896bd09f1$var$monoidCanceler = {
    mempty: $a801f2c896bd09f1$var$nonCanceler,
    Semigroup0: function() {
        return $a801f2c896bd09f1$var$semigroupCanceler;
    }
};
// output/Control.Promise/index.js
var $a801f2c896bd09f1$var$voidRight2 = /* @__PURE__ */ $a801f2c896bd09f1$var$voidRight($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$mempty2 = /* @__PURE__ */ $a801f2c896bd09f1$var$mempty($a801f2c896bd09f1$var$monoidCanceler);
var $a801f2c896bd09f1$var$identity11 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$alt6 = /* @__PURE__ */ $a801f2c896bd09f1$var$alt(/* @__PURE__ */ $a801f2c896bd09f1$var$altExceptT($a801f2c896bd09f1$var$semigroupNonEmptyList)($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$unsafeReadTagged2 = /* @__PURE__ */ $a801f2c896bd09f1$var$unsafeReadTagged($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$map21 = /* @__PURE__ */ $a801f2c896bd09f1$var$map(/* @__PURE__ */ $a801f2c896bd09f1$var$functorExceptT($a801f2c896bd09f1$var$functorIdentity));
var $a801f2c896bd09f1$var$readString3 = /* @__PURE__ */ $a801f2c896bd09f1$var$readString($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$bind8 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$liftEffect3 = /* @__PURE__ */ $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectAff);
var $a801f2c896bd09f1$var$toAff$prime = function(customCoerce) {
    return function(p3) {
        return $a801f2c896bd09f1$var$makeAff(function(cb) {
            return $a801f2c896bd09f1$var$voidRight2($a801f2c896bd09f1$var$mempty2)($a801f2c896bd09f1$var$thenImpl(p3)(function($14) {
                return cb($a801f2c896bd09f1$var$Left.create(customCoerce($14)))();
            })(function($15) {
                return cb($a801f2c896bd09f1$var$Right.create($15))();
            }));
        });
    };
};
var $a801f2c896bd09f1$var$coerce4 = function(fn) {
    return $a801f2c896bd09f1$var$either(function(v3) {
        return $a801f2c896bd09f1$var$error("Promise failed, couldn't extract JS Error or String");
    })($a801f2c896bd09f1$var$identity11)($a801f2c896bd09f1$var$runExcept($a801f2c896bd09f1$var$alt6($a801f2c896bd09f1$var$unsafeReadTagged2("Error")(fn))($a801f2c896bd09f1$var$map21($a801f2c896bd09f1$var$error)($a801f2c896bd09f1$var$readString3(fn)))));
};
var $a801f2c896bd09f1$var$toAff = /* @__PURE__ */ $a801f2c896bd09f1$var$toAff$prime($a801f2c896bd09f1$var$coerce4);
var $a801f2c896bd09f1$var$toAffE = function(f2) {
    return $a801f2c896bd09f1$var$bind8($a801f2c896bd09f1$var$liftEffect3(f2))($a801f2c896bd09f1$var$toAff);
};
// output/DOM.HTML.Indexed.InputAcceptType/index.js
var $a801f2c896bd09f1$var$map23 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$AcceptMediaType = /* @__PURE__ */ function() {
    function AcceptMediaType2(value0) {
        this.value0 = value0;
    }
    AcceptMediaType2.create = function(value0) {
        return new AcceptMediaType2(value0);
    };
    return AcceptMediaType2;
}();
var $a801f2c896bd09f1$var$AcceptFileExtension = /* @__PURE__ */ function() {
    function AcceptFileExtension2(value0) {
        this.value0 = value0;
    }
    AcceptFileExtension2.create = function(value0) {
        return new AcceptFileExtension2(value0);
    };
    return AcceptFileExtension2;
}();
var $a801f2c896bd09f1$var$renderInputAcceptTypeAtom = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$AcceptMediaType) return v3.value0;
    if (v3 instanceof $a801f2c896bd09f1$var$AcceptFileExtension) return v3.value0;
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputAcceptType (line 34, column 29 - line 36, column 33): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$renderInputAcceptType = function(v3) {
    return $a801f2c896bd09f1$var$joinWith(",")($a801f2c896bd09f1$var$map23($a801f2c896bd09f1$var$renderInputAcceptTypeAtom)(v3));
};
// output/DOM.HTML.Indexed.InputType/index.js
var $a801f2c896bd09f1$var$InputButton = /* @__PURE__ */ function() {
    function InputButton2() {}
    InputButton2.value = new InputButton2();
    return InputButton2;
}();
var $a801f2c896bd09f1$var$InputCheckbox = /* @__PURE__ */ function() {
    function InputCheckbox2() {}
    InputCheckbox2.value = new InputCheckbox2();
    return InputCheckbox2;
}();
var $a801f2c896bd09f1$var$InputColor = /* @__PURE__ */ function() {
    function InputColor2() {}
    InputColor2.value = new InputColor2();
    return InputColor2;
}();
var $a801f2c896bd09f1$var$InputDate = /* @__PURE__ */ function() {
    function InputDate2() {}
    InputDate2.value = new InputDate2();
    return InputDate2;
}();
var $a801f2c896bd09f1$var$InputDatetimeLocal = /* @__PURE__ */ function() {
    function InputDatetimeLocal2() {}
    InputDatetimeLocal2.value = new InputDatetimeLocal2();
    return InputDatetimeLocal2;
}();
var $a801f2c896bd09f1$var$InputEmail = /* @__PURE__ */ function() {
    function InputEmail2() {}
    InputEmail2.value = new InputEmail2();
    return InputEmail2;
}();
var $a801f2c896bd09f1$var$InputFile = /* @__PURE__ */ function() {
    function InputFile2() {}
    InputFile2.value = new InputFile2();
    return InputFile2;
}();
var $a801f2c896bd09f1$var$InputHidden = /* @__PURE__ */ function() {
    function InputHidden2() {}
    InputHidden2.value = new InputHidden2();
    return InputHidden2;
}();
var $a801f2c896bd09f1$var$InputImage = /* @__PURE__ */ function() {
    function InputImage2() {}
    InputImage2.value = new InputImage2();
    return InputImage2;
}();
var $a801f2c896bd09f1$var$InputMonth = /* @__PURE__ */ function() {
    function InputMonth2() {}
    InputMonth2.value = new InputMonth2();
    return InputMonth2;
}();
var $a801f2c896bd09f1$var$InputNumber = /* @__PURE__ */ function() {
    function InputNumber2() {}
    InputNumber2.value = new InputNumber2();
    return InputNumber2;
}();
var $a801f2c896bd09f1$var$InputPassword = /* @__PURE__ */ function() {
    function InputPassword2() {}
    InputPassword2.value = new InputPassword2();
    return InputPassword2;
}();
var $a801f2c896bd09f1$var$InputRadio = /* @__PURE__ */ function() {
    function InputRadio2() {}
    InputRadio2.value = new InputRadio2();
    return InputRadio2;
}();
var $a801f2c896bd09f1$var$InputRange = /* @__PURE__ */ function() {
    function InputRange2() {}
    InputRange2.value = new InputRange2();
    return InputRange2;
}();
var $a801f2c896bd09f1$var$InputReset = /* @__PURE__ */ function() {
    function InputReset2() {}
    InputReset2.value = new InputReset2();
    return InputReset2;
}();
var $a801f2c896bd09f1$var$InputSearch = /* @__PURE__ */ function() {
    function InputSearch2() {}
    InputSearch2.value = new InputSearch2();
    return InputSearch2;
}();
var $a801f2c896bd09f1$var$InputSubmit = /* @__PURE__ */ function() {
    function InputSubmit2() {}
    InputSubmit2.value = new InputSubmit2();
    return InputSubmit2;
}();
var $a801f2c896bd09f1$var$InputTel = /* @__PURE__ */ function() {
    function InputTel2() {}
    InputTel2.value = new InputTel2();
    return InputTel2;
}();
var $a801f2c896bd09f1$var$InputText = /* @__PURE__ */ function() {
    function InputText2() {}
    InputText2.value = new InputText2();
    return InputText2;
}();
var $a801f2c896bd09f1$var$InputTime = /* @__PURE__ */ function() {
    function InputTime2() {}
    InputTime2.value = new InputTime2();
    return InputTime2;
}();
var $a801f2c896bd09f1$var$InputUrl = /* @__PURE__ */ function() {
    function InputUrl2() {}
    InputUrl2.value = new InputUrl2();
    return InputUrl2;
}();
var $a801f2c896bd09f1$var$InputWeek = /* @__PURE__ */ function() {
    function InputWeek2() {}
    InputWeek2.value = new InputWeek2();
    return InputWeek2;
}();
var $a801f2c896bd09f1$var$renderInputType = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$InputButton) return "button";
    if (v3 instanceof $a801f2c896bd09f1$var$InputCheckbox) return "checkbox";
    if (v3 instanceof $a801f2c896bd09f1$var$InputColor) return "color";
    if (v3 instanceof $a801f2c896bd09f1$var$InputDate) return "date";
    if (v3 instanceof $a801f2c896bd09f1$var$InputDatetimeLocal) return "datetime-local";
    if (v3 instanceof $a801f2c896bd09f1$var$InputEmail) return "email";
    if (v3 instanceof $a801f2c896bd09f1$var$InputFile) return "file";
    if (v3 instanceof $a801f2c896bd09f1$var$InputHidden) return "hidden";
    if (v3 instanceof $a801f2c896bd09f1$var$InputImage) return "image";
    if (v3 instanceof $a801f2c896bd09f1$var$InputMonth) return "month";
    if (v3 instanceof $a801f2c896bd09f1$var$InputNumber) return "number";
    if (v3 instanceof $a801f2c896bd09f1$var$InputPassword) return "password";
    if (v3 instanceof $a801f2c896bd09f1$var$InputRadio) return "radio";
    if (v3 instanceof $a801f2c896bd09f1$var$InputRange) return "range";
    if (v3 instanceof $a801f2c896bd09f1$var$InputReset) return "reset";
    if (v3 instanceof $a801f2c896bd09f1$var$InputSearch) return "search";
    if (v3 instanceof $a801f2c896bd09f1$var$InputSubmit) return "submit";
    if (v3 instanceof $a801f2c896bd09f1$var$InputTel) return "tel";
    if (v3 instanceof $a801f2c896bd09f1$var$InputText) return "text";
    if (v3 instanceof $a801f2c896bd09f1$var$InputTime) return "time";
    if (v3 instanceof $a801f2c896bd09f1$var$InputUrl) return "url";
    if (v3 instanceof $a801f2c896bd09f1$var$InputWeek) return "week";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 33, column 19 - line 55, column 22): " + [
        v3.constructor.name
    ]);
};
// output/DOM.HTML.Indexed.StepValue/index.js
var $a801f2c896bd09f1$var$show7 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showNumber);
var $a801f2c896bd09f1$var$Any = /* @__PURE__ */ function() {
    function Any2() {}
    Any2.value = new Any2();
    return Any2;
}();
var $a801f2c896bd09f1$var$Step = /* @__PURE__ */ function() {
    function Step3(value0) {
        this.value0 = value0;
    }
    Step3.create = function(value0) {
        return new Step3(value0);
    };
    return Step3;
}();
var $a801f2c896bd09f1$var$renderStepValue = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$Any) return "any";
    if (v3 instanceof $a801f2c896bd09f1$var$Step) return $a801f2c896bd09f1$var$show7(v3.value0);
    throw new Error("Failed pattern match at DOM.HTML.Indexed.StepValue (line 13, column 19 - line 15, column 19): " + [
        v3.constructor.name
    ]);
};
// output/Halogen.Query.Input/index.js
var $a801f2c896bd09f1$var$RefUpdate = /* @__PURE__ */ function() {
    function RefUpdate2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RefUpdate2.create = function(value0) {
        return function(value1) {
            return new RefUpdate2(value0, value1);
        };
    };
    return RefUpdate2;
}();
var $a801f2c896bd09f1$var$Action = /* @__PURE__ */ function() {
    function Action3(value0) {
        this.value0 = value0;
    }
    Action3.create = function(value0) {
        return new Action3(value0);
    };
    return Action3;
}();
// output/Halogen.VDom.Machine/index.js
var $a801f2c896bd09f1$var$Step2 = /* @__PURE__ */ function() {
    function Step3(value0, value1, value22, value32) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
        this.value3 = value32;
    }
    Step3.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return function(value32) {
                    return new Step3(value0, value1, value22, value32);
                };
            };
        };
    };
    return Step3;
}();
var $a801f2c896bd09f1$var$unStep = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$step = function(v3, a3) {
    return v3.value2(v3.value1, a3);
};
var $a801f2c896bd09f1$var$mkStep = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$halt = function(v3) {
    return v3.value3(v3.value1);
};
var $a801f2c896bd09f1$var$extract2 = /* @__PURE__ */ $a801f2c896bd09f1$var$unStep(function(v3) {
    return v3.value0;
});
// output/Halogen.VDom.Types/index.js
var $a801f2c896bd09f1$var$map24 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$map112 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorTuple);
var $a801f2c896bd09f1$var$Text = /* @__PURE__ */ function() {
    function Text2(value0) {
        this.value0 = value0;
    }
    Text2.create = function(value0) {
        return new Text2(value0);
    };
    return Text2;
}();
var $a801f2c896bd09f1$var$Elem = /* @__PURE__ */ function() {
    function Elem2(value0, value1, value22, value32) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
        this.value3 = value32;
    }
    Elem2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return function(value32) {
                    return new Elem2(value0, value1, value22, value32);
                };
            };
        };
    };
    return Elem2;
}();
var $a801f2c896bd09f1$var$Keyed = /* @__PURE__ */ function() {
    function Keyed2(value0, value1, value22, value32) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
        this.value3 = value32;
    }
    Keyed2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return function(value32) {
                    return new Keyed2(value0, value1, value22, value32);
                };
            };
        };
    };
    return Keyed2;
}();
var $a801f2c896bd09f1$var$Widget = /* @__PURE__ */ function() {
    function Widget2(value0) {
        this.value0 = value0;
    }
    Widget2.create = function(value0) {
        return new Widget2(value0);
    };
    return Widget2;
}();
var $a801f2c896bd09f1$var$Grafted = /* @__PURE__ */ function() {
    function Grafted2(value0) {
        this.value0 = value0;
    }
    Grafted2.create = function(value0) {
        return new Grafted2(value0);
    };
    return Grafted2;
}();
var $a801f2c896bd09f1$var$Graft = /* @__PURE__ */ function() {
    function Graft2(value0, value1, value22) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
    }
    Graft2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return new Graft2(value0, value1, value22);
            };
        };
    };
    return Graft2;
}();
var $a801f2c896bd09f1$var$unGraft = function(f2) {
    return function($61) {
        return f2($61);
    };
};
var $a801f2c896bd09f1$var$graft = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$bifunctorGraft = {
    bimap: function(f2) {
        return function(g2) {
            return $a801f2c896bd09f1$var$unGraft(function(v3) {
                return $a801f2c896bd09f1$var$graft(new $a801f2c896bd09f1$var$Graft(function($63) {
                    return f2(v3.value0($63));
                }, function($64) {
                    return g2(v3.value1($64));
                }, v3.value2));
            });
        };
    }
};
var $a801f2c896bd09f1$var$bimap3 = /* @__PURE__ */ $a801f2c896bd09f1$var$bimap($a801f2c896bd09f1$var$bifunctorGraft);
var $a801f2c896bd09f1$var$runGraft = /* @__PURE__ */ $a801f2c896bd09f1$var$unGraft(function(v3) {
    var go2 = function(v22) {
        if (v22 instanceof $a801f2c896bd09f1$var$Text) return new $a801f2c896bd09f1$var$Text(v22.value0);
        if (v22 instanceof $a801f2c896bd09f1$var$Elem) return new $a801f2c896bd09f1$var$Elem(v22.value0, v22.value1, v3.value0(v22.value2), $a801f2c896bd09f1$var$map24(go2)(v22.value3));
        if (v22 instanceof $a801f2c896bd09f1$var$Keyed) return new $a801f2c896bd09f1$var$Keyed(v22.value0, v22.value1, v3.value0(v22.value2), $a801f2c896bd09f1$var$map24($a801f2c896bd09f1$var$map112(go2))(v22.value3));
        if (v22 instanceof $a801f2c896bd09f1$var$Widget) return new $a801f2c896bd09f1$var$Widget(v3.value1(v22.value0));
        if (v22 instanceof $a801f2c896bd09f1$var$Grafted) return new $a801f2c896bd09f1$var$Grafted($a801f2c896bd09f1$var$bimap3(v3.value0)(v3.value1)(v22.value0));
        throw new Error("Failed pattern match at Halogen.VDom.Types (line 86, column 7 - line 86, column 27): " + [
            v22.constructor.name
        ]);
    };
    return go2(v3.value2);
});
// output/Halogen.VDom.Util/foreign.js
function $a801f2c896bd09f1$var$unsafeGetAny(key2, obj) {
    return obj[key2];
}
function $a801f2c896bd09f1$var$unsafeHasAny(key2, obj) {
    return obj.hasOwnProperty(key2);
}
function $a801f2c896bd09f1$var$unsafeSetAny(key2, val, obj) {
    obj[key2] = val;
}
function $a801f2c896bd09f1$var$forE2(a3, f2) {
    var b3 = [];
    for(var i2 = 0; i2 < a3.length; i2++)b3.push(f2(i2, a3[i2]));
    return b3;
}
function $a801f2c896bd09f1$var$forEachE(a3, f2) {
    for(var i2 = 0; i2 < a3.length; i2++)f2(a3[i2]);
}
function $a801f2c896bd09f1$var$forInE(o2, f2) {
    var ks = Object.keys(o2);
    for(var i2 = 0; i2 < ks.length; i2++){
        var k2 = ks[i2];
        f2(k2, o2[k2]);
    }
}
function $a801f2c896bd09f1$var$diffWithIxE(a1, a22, f1, f2, f3) {
    var a3 = [];
    var l1 = a1.length;
    var l2 = a22.length;
    var i2 = 0;
    while(true){
        if (i2 < l1) {
            if (i2 < l2) a3.push(f1(i2, a1[i2], a22[i2]));
            else f2(i2, a1[i2]);
        } else if (i2 < l2) a3.push(f3(i2, a22[i2]));
        else break;
        i2++;
    }
    return a3;
}
function $a801f2c896bd09f1$var$strMapWithIxE(as, fk, f2) {
    var o2 = {};
    for(var i2 = 0; i2 < as.length; i2++){
        var a3 = as[i2];
        var k2 = fk(a3);
        o2[k2] = f2(k2, i2, a3);
    }
    return o2;
}
function $a801f2c896bd09f1$var$diffWithKeyAndIxE(o1, as, fk, f1, f2, f3) {
    var o2 = {};
    for(var i2 = 0; i2 < as.length; i2++){
        var a3 = as[i2];
        var k2 = fk(a3);
        if (o1.hasOwnProperty(k2)) o2[k2] = f1(k2, i2, o1[k2], a3);
        else o2[k2] = f3(k2, i2, a3);
    }
    for(var k2 in o1){
        if (k2 in o2) continue;
        f2(k2, o1[k2]);
    }
    return o2;
}
function $a801f2c896bd09f1$var$refEq2(a3, b3) {
    return a3 === b3;
}
function $a801f2c896bd09f1$var$createTextNode(s2, doc) {
    return doc.createTextNode(s2);
}
function $a801f2c896bd09f1$var$setTextContent(s2, n) {
    n.textContent = s2;
}
function $a801f2c896bd09f1$var$createElement(ns, name17, doc) {
    if (ns != null) return doc.createElementNS(ns, name17);
    else return doc.createElement(name17);
}
function $a801f2c896bd09f1$var$insertChildIx(i2, a3, b3) {
    var n = b3.childNodes.item(i2) || null;
    if (n !== a3) b3.insertBefore(a3, n);
}
function $a801f2c896bd09f1$var$removeChild(a3, b3) {
    if (b3 && a3.parentNode === b3) b3.removeChild(a3);
}
function $a801f2c896bd09f1$var$parentNode(a3) {
    return a3.parentNode;
}
function $a801f2c896bd09f1$var$setAttribute(ns, attr3, val, el) {
    if (ns != null) el.setAttributeNS(ns, attr3, val);
    else el.setAttribute(attr3, val);
}
function $a801f2c896bd09f1$var$removeAttribute(ns, attr3, el) {
    if (ns != null) el.removeAttributeNS(ns, attr3);
    else el.removeAttribute(attr3);
}
function $a801f2c896bd09f1$var$hasAttribute(ns, attr3, el) {
    if (ns != null) return el.hasAttributeNS(ns, attr3);
    else return el.hasAttribute(attr3);
}
function $a801f2c896bd09f1$var$addEventListener(ev, listener, el) {
    el.addEventListener(ev, listener, false);
}
function $a801f2c896bd09f1$var$removeEventListener(ev, listener, el) {
    el.removeEventListener(ev, listener, false);
}
var $a801f2c896bd09f1$var$jsUndefined = void 0;
// output/Halogen.VDom.Util/index.js
var $a801f2c896bd09f1$var$unsafeLookup = $a801f2c896bd09f1$var$unsafeGetAny;
var $a801f2c896bd09f1$var$unsafeFreeze2 = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$pokeMutMap = $a801f2c896bd09f1$var$unsafeSetAny;
var $a801f2c896bd09f1$var$newMutMap = $a801f2c896bd09f1$var$newImpl;
// output/Web.DOM.Element/foreign.js
var $a801f2c896bd09f1$var$getProp = function(name17) {
    return function(doctype) {
        return doctype[name17];
    };
};
var $a801f2c896bd09f1$var$_namespaceURI = $a801f2c896bd09f1$var$getProp("namespaceURI");
var $a801f2c896bd09f1$var$_prefix = $a801f2c896bd09f1$var$getProp("prefix");
var $a801f2c896bd09f1$var$localName = $a801f2c896bd09f1$var$getProp("localName");
var $a801f2c896bd09f1$var$tagName = $a801f2c896bd09f1$var$getProp("tagName");
// output/Web.DOM.ParentNode/foreign.js
var $a801f2c896bd09f1$var$getEffProp = function(name17) {
    return function(node) {
        return function() {
            return node[name17];
        };
    };
};
var $a801f2c896bd09f1$var$children = $a801f2c896bd09f1$var$getEffProp("children");
var $a801f2c896bd09f1$var$_firstElementChild = $a801f2c896bd09f1$var$getEffProp("firstElementChild");
var $a801f2c896bd09f1$var$_lastElementChild = $a801f2c896bd09f1$var$getEffProp("lastElementChild");
var $a801f2c896bd09f1$var$childElementCount = $a801f2c896bd09f1$var$getEffProp("childElementCount");
function $a801f2c896bd09f1$var$_querySelector(selector) {
    return function(node) {
        return function() {
            return node.querySelector(selector);
        };
    };
}
// output/Web.DOM.ParentNode/index.js
var $a801f2c896bd09f1$var$map25 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$querySelector = function(qs) {
    var $2 = $a801f2c896bd09f1$var$map25($a801f2c896bd09f1$var$toMaybe);
    var $3 = $a801f2c896bd09f1$var$_querySelector(qs);
    return function($4) {
        return $2($3($4));
    };
};
// output/Web.Internal.FFI/foreign.js
function $a801f2c896bd09f1$var$_unsafeReadProtoTagged(nothing, just, name17, value17) {
    if (typeof window !== "undefined") {
        var ty = window[name17];
        if (ty != null && value17 instanceof ty) return just(value17);
    }
    var obj = value17;
    while(obj != null){
        var proto = Object.getPrototypeOf(obj);
        var constructorName = proto.constructor.name;
        if (constructorName === name17) return just(value17);
        else if (constructorName === "Object") return nothing;
        obj = proto;
    }
    return nothing;
}
// output/Web.Internal.FFI/index.js
var $a801f2c896bd09f1$var$unsafeReadProtoTagged = function(name17) {
    return function(value17) {
        return $a801f2c896bd09f1$var$_unsafeReadProtoTagged($a801f2c896bd09f1$var$Nothing.value, $a801f2c896bd09f1$var$Just.create, name17, value17);
    };
};
// output/Web.DOM.Element/index.js
var $a801f2c896bd09f1$var$toNode = $a801f2c896bd09f1$var$unsafeCoerce2;
// output/Halogen.VDom.DOM/index.js
var $a801f2c896bd09f1$var$$runtime_lazy6 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$haltWidget = function(v3) {
    return $a801f2c896bd09f1$var$halt(v3.widget);
};
var $a801f2c896bd09f1$var$$lazy_patchWidget = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy6("patchWidget", "Halogen.VDom.DOM", function() {
    return function(state3, vdom) {
        if (vdom instanceof $a801f2c896bd09f1$var$Grafted) return $a801f2c896bd09f1$var$$lazy_patchWidget(291)(state3, $a801f2c896bd09f1$var$runGraft(vdom.value0));
        if (vdom instanceof $a801f2c896bd09f1$var$Widget) {
            var res = $a801f2c896bd09f1$var$step(state3.widget, vdom.value0);
            var res$prime = $a801f2c896bd09f1$var$unStep(function(v3) {
                return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(v3.value0, {
                    build: state3.build,
                    widget: res
                }, $a801f2c896bd09f1$var$$lazy_patchWidget(296), $a801f2c896bd09f1$var$haltWidget));
            })(res);
            return res$prime;
        }
        $a801f2c896bd09f1$var$haltWidget(state3);
        return state3.build(vdom);
    };
});
var $a801f2c896bd09f1$var$patchWidget = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_patchWidget(286);
var $a801f2c896bd09f1$var$haltText = function(v3) {
    var parent2 = $a801f2c896bd09f1$var$parentNode(v3.node);
    return $a801f2c896bd09f1$var$removeChild(v3.node, parent2);
};
var $a801f2c896bd09f1$var$$lazy_patchText = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy6("patchText", "Halogen.VDom.DOM", function() {
    return function(state3, vdom) {
        if (vdom instanceof $a801f2c896bd09f1$var$Grafted) return $a801f2c896bd09f1$var$$lazy_patchText(82)(state3, $a801f2c896bd09f1$var$runGraft(vdom.value0));
        if (vdom instanceof $a801f2c896bd09f1$var$Text) {
            if (state3.value === vdom.value0) return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(state3.node, state3, $a801f2c896bd09f1$var$$lazy_patchText(85), $a801f2c896bd09f1$var$haltText));
            if ($a801f2c896bd09f1$var$otherwise) {
                var nextState = {
                    build: state3.build,
                    node: state3.node,
                    value: vdom.value0
                };
                $a801f2c896bd09f1$var$setTextContent(vdom.value0, state3.node);
                return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(state3.node, nextState, $a801f2c896bd09f1$var$$lazy_patchText(89), $a801f2c896bd09f1$var$haltText));
            }
        }
        $a801f2c896bd09f1$var$haltText(state3);
        return state3.build(vdom);
    };
});
var $a801f2c896bd09f1$var$patchText = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_patchText(77);
var $a801f2c896bd09f1$var$haltKeyed = function(v3) {
    var parent2 = $a801f2c896bd09f1$var$parentNode(v3.node);
    $a801f2c896bd09f1$var$removeChild(v3.node, parent2);
    $a801f2c896bd09f1$var$forInE(v3.children, function(v1, s2) {
        return $a801f2c896bd09f1$var$halt(s2);
    });
    return $a801f2c896bd09f1$var$halt(v3.attrs);
};
var $a801f2c896bd09f1$var$haltElem = function(v3) {
    var parent2 = $a801f2c896bd09f1$var$parentNode(v3.node);
    $a801f2c896bd09f1$var$removeChild(v3.node, parent2);
    $a801f2c896bd09f1$var$forEachE(v3.children, $a801f2c896bd09f1$var$halt);
    return $a801f2c896bd09f1$var$halt(v3.attrs);
};
var $a801f2c896bd09f1$var$eqElemSpec = function(ns1, v3, ns2, v1) {
    var $63 = v3 === v1;
    if ($63) {
        if (ns1 instanceof $a801f2c896bd09f1$var$Just && ns2 instanceof $a801f2c896bd09f1$var$Just && ns1.value0 === ns2.value0) return true;
        if (ns1 instanceof $a801f2c896bd09f1$var$Nothing && ns2 instanceof $a801f2c896bd09f1$var$Nothing) return true;
        return false;
    }
    return false;
};
var $a801f2c896bd09f1$var$$lazy_patchElem = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy6("patchElem", "Halogen.VDom.DOM", function() {
    return function(state3, vdom) {
        if (vdom instanceof $a801f2c896bd09f1$var$Grafted) return $a801f2c896bd09f1$var$$lazy_patchElem(135)(state3, $a801f2c896bd09f1$var$runGraft(vdom.value0));
        if (vdom instanceof $a801f2c896bd09f1$var$Elem && $a801f2c896bd09f1$var$eqElemSpec(state3.ns, state3.name, vdom.value0, vdom.value1)) {
            var v3 = $a801f2c896bd09f1$var$length4(vdom.value3);
            var v1 = $a801f2c896bd09f1$var$length4(state3.children);
            if (v1 === 0 && v3 === 0) {
                var attrs2 = $a801f2c896bd09f1$var$step(state3.attrs, vdom.value2);
                var nextState = {
                    build: state3.build,
                    node: state3.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state3.children
                };
                return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(state3.node, nextState, $a801f2c896bd09f1$var$$lazy_patchElem(149), $a801f2c896bd09f1$var$haltElem));
            }
            var onThis = function(v22, s2) {
                return $a801f2c896bd09f1$var$halt(s2);
            };
            var onThese = function(ix, s2, v22) {
                var res = $a801f2c896bd09f1$var$step(s2, v22);
                $a801f2c896bd09f1$var$insertChildIx(ix, $a801f2c896bd09f1$var$extract2(res), state3.node);
                return res;
            };
            var onThat = function(ix, v22) {
                var res = state3.build(v22);
                $a801f2c896bd09f1$var$insertChildIx(ix, $a801f2c896bd09f1$var$extract2(res), state3.node);
                return res;
            };
            var children2 = $a801f2c896bd09f1$var$diffWithIxE(state3.children, vdom.value3, onThese, onThis, onThat);
            var attrs2 = $a801f2c896bd09f1$var$step(state3.attrs, vdom.value2);
            var nextState = {
                build: state3.build,
                node: state3.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2
            };
            return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(state3.node, nextState, $a801f2c896bd09f1$var$$lazy_patchElem(172), $a801f2c896bd09f1$var$haltElem));
        }
        $a801f2c896bd09f1$var$haltElem(state3);
        return state3.build(vdom);
    };
});
var $a801f2c896bd09f1$var$patchElem = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_patchElem(130);
var $a801f2c896bd09f1$var$$lazy_patchKeyed = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy6("patchKeyed", "Halogen.VDom.DOM", function() {
    return function(state3, vdom) {
        if (vdom instanceof $a801f2c896bd09f1$var$Grafted) return $a801f2c896bd09f1$var$$lazy_patchKeyed(222)(state3, $a801f2c896bd09f1$var$runGraft(vdom.value0));
        if (vdom instanceof $a801f2c896bd09f1$var$Keyed && $a801f2c896bd09f1$var$eqElemSpec(state3.ns, state3.name, vdom.value0, vdom.value1)) {
            var v3 = $a801f2c896bd09f1$var$length4(vdom.value3);
            if (state3.length === 0 && v3 === 0) {
                var attrs2 = $a801f2c896bd09f1$var$step(state3.attrs, vdom.value2);
                var nextState = {
                    build: state3.build,
                    node: state3.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state3.children,
                    length: 0
                };
                return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(state3.node, nextState, $a801f2c896bd09f1$var$$lazy_patchKeyed(237), $a801f2c896bd09f1$var$haltKeyed));
            }
            var onThis = function(v22, s2) {
                return $a801f2c896bd09f1$var$halt(s2);
            };
            var onThese = function(v22, ix$prime, s2, v32) {
                var res = $a801f2c896bd09f1$var$step(s2, v32.value1);
                $a801f2c896bd09f1$var$insertChildIx(ix$prime, $a801f2c896bd09f1$var$extract2(res), state3.node);
                return res;
            };
            var onThat = function(v22, ix, v32) {
                var res = state3.build(v32.value1);
                $a801f2c896bd09f1$var$insertChildIx(ix, $a801f2c896bd09f1$var$extract2(res), state3.node);
                return res;
            };
            var children2 = $a801f2c896bd09f1$var$diffWithKeyAndIxE(state3.children, vdom.value3, $a801f2c896bd09f1$var$fst, onThese, onThis, onThat);
            var attrs2 = $a801f2c896bd09f1$var$step(state3.attrs, vdom.value2);
            var nextState = {
                build: state3.build,
                node: state3.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2,
                length: v3
            };
            return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(state3.node, nextState, $a801f2c896bd09f1$var$$lazy_patchKeyed(261), $a801f2c896bd09f1$var$haltKeyed));
        }
        $a801f2c896bd09f1$var$haltKeyed(state3);
        return state3.build(vdom);
    };
});
var $a801f2c896bd09f1$var$patchKeyed = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_patchKeyed(217);
var $a801f2c896bd09f1$var$buildWidget = function(v3, build2, w2) {
    var res = v3.buildWidget(v3)(w2);
    var res$prime = $a801f2c896bd09f1$var$unStep(function(v1) {
        return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(v1.value0, {
            build: build2,
            widget: res
        }, $a801f2c896bd09f1$var$patchWidget, $a801f2c896bd09f1$var$haltWidget));
    })(res);
    return res$prime;
};
var $a801f2c896bd09f1$var$buildText = function(v3, build2, s2) {
    var node = $a801f2c896bd09f1$var$createTextNode(s2, v3.document);
    var state3 = {
        build: build2,
        node: node,
        value: s2
    };
    return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(node, state3, $a801f2c896bd09f1$var$patchText, $a801f2c896bd09f1$var$haltText));
};
var $a801f2c896bd09f1$var$buildKeyed = function(v3, build2, ns1, name1, as1, ch1) {
    var el = $a801f2c896bd09f1$var$createElement($a801f2c896bd09f1$var$toNullable(ns1), name1, v3.document);
    var node = $a801f2c896bd09f1$var$toNode(el);
    var onChild = function(v1, ix, v22) {
        var res = build2(v22.value1);
        $a801f2c896bd09f1$var$insertChildIx(ix, $a801f2c896bd09f1$var$extract2(res), node);
        return res;
    };
    var children2 = $a801f2c896bd09f1$var$strMapWithIxE(ch1, $a801f2c896bd09f1$var$fst, onChild);
    var attrs = v3.buildAttributes(el)(as1);
    var state3 = {
        build: build2,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children2,
        length: $a801f2c896bd09f1$var$length4(ch1)
    };
    return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(node, state3, $a801f2c896bd09f1$var$patchKeyed, $a801f2c896bd09f1$var$haltKeyed));
};
var $a801f2c896bd09f1$var$buildElem = function(v3, build2, ns1, name1, as1, ch1) {
    var el = $a801f2c896bd09f1$var$createElement($a801f2c896bd09f1$var$toNullable(ns1), name1, v3.document);
    var node = $a801f2c896bd09f1$var$toNode(el);
    var onChild = function(ix, child) {
        var res = build2(child);
        $a801f2c896bd09f1$var$insertChildIx(ix, $a801f2c896bd09f1$var$extract2(res), node);
        return res;
    };
    var children2 = $a801f2c896bd09f1$var$forE2(ch1, onChild);
    var attrs = v3.buildAttributes(el)(as1);
    var state3 = {
        build: build2,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children2
    };
    return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(node, state3, $a801f2c896bd09f1$var$patchElem, $a801f2c896bd09f1$var$haltElem));
};
var $a801f2c896bd09f1$var$buildVDom = function(spec) {
    var $lazy_build = $a801f2c896bd09f1$var$$runtime_lazy6("build", "Halogen.VDom.DOM", function() {
        return function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Text) return $a801f2c896bd09f1$var$buildText(spec, $lazy_build(59), v3.value0);
            if (v3 instanceof $a801f2c896bd09f1$var$Elem) return $a801f2c896bd09f1$var$buildElem(spec, $lazy_build(60), v3.value0, v3.value1, v3.value2, v3.value3);
            if (v3 instanceof $a801f2c896bd09f1$var$Keyed) return $a801f2c896bd09f1$var$buildKeyed(spec, $lazy_build(61), v3.value0, v3.value1, v3.value2, v3.value3);
            if (v3 instanceof $a801f2c896bd09f1$var$Widget) return $a801f2c896bd09f1$var$buildWidget(spec, $lazy_build(62), v3.value0);
            if (v3 instanceof $a801f2c896bd09f1$var$Grafted) return $lazy_build(63)($a801f2c896bd09f1$var$runGraft(v3.value0));
            throw new Error("Failed pattern match at Halogen.VDom.DOM (line 58, column 27 - line 63, column 52): " + [
                v3.constructor.name
            ]);
        };
    });
    var build2 = $lazy_build(58);
    return build2;
};
// output/Web.Event.EventTarget/foreign.js
function $a801f2c896bd09f1$var$eventListener(fn) {
    return function() {
        return function(event) {
            return fn(event)();
        };
    };
}
function $a801f2c896bd09f1$var$addEventListener2(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target6) {
                return function() {
                    return target6.addEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $a801f2c896bd09f1$var$removeEventListener2(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target6) {
                return function() {
                    return target6.removeEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
// output/Halogen.VDom.DOM.Prop/index.js
var $a801f2c896bd09f1$var$$runtime_lazy7 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$Created = /* @__PURE__ */ function() {
    function Created2(value0) {
        this.value0 = value0;
    }
    Created2.create = function(value0) {
        return new Created2(value0);
    };
    return Created2;
}();
var $a801f2c896bd09f1$var$Removed = /* @__PURE__ */ function() {
    function Removed2(value0) {
        this.value0 = value0;
    }
    Removed2.create = function(value0) {
        return new Removed2(value0);
    };
    return Removed2;
}();
var $a801f2c896bd09f1$var$Attribute = /* @__PURE__ */ function() {
    function Attribute2(value0, value1, value22) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
    }
    Attribute2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return new Attribute2(value0, value1, value22);
            };
        };
    };
    return Attribute2;
}();
var $a801f2c896bd09f1$var$Property = /* @__PURE__ */ function() {
    function Property2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Property2.create = function(value0) {
        return function(value1) {
            return new Property2(value0, value1);
        };
    };
    return Property2;
}();
var $a801f2c896bd09f1$var$Handler = /* @__PURE__ */ function() {
    function Handler2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Handler2.create = function(value0) {
        return function(value1) {
            return new Handler2(value0, value1);
        };
    };
    return Handler2;
}();
var $a801f2c896bd09f1$var$Ref = /* @__PURE__ */ function() {
    function Ref2(value0) {
        this.value0 = value0;
    }
    Ref2.create = function(value0) {
        return new Ref2(value0);
    };
    return Ref2;
}();
var $a801f2c896bd09f1$var$unsafeGetProperty = $a801f2c896bd09f1$var$unsafeGetAny;
var $a801f2c896bd09f1$var$setProperty = $a801f2c896bd09f1$var$unsafeSetAny;
var $a801f2c896bd09f1$var$removeProperty = function(key2, el) {
    var v3 = $a801f2c896bd09f1$var$hasAttribute($a801f2c896bd09f1$var$nullImpl, key2, el);
    if (v3) return $a801f2c896bd09f1$var$removeAttribute($a801f2c896bd09f1$var$nullImpl, key2, el);
    var v1 = $a801f2c896bd09f1$var$typeOf($a801f2c896bd09f1$var$unsafeGetAny(key2, el));
    if (v1 === "string") return $a801f2c896bd09f1$var$unsafeSetAny(key2, "", el);
    if (key2 === "rowSpan") return $a801f2c896bd09f1$var$unsafeSetAny(key2, 1, el);
    if (key2 === "colSpan") return $a801f2c896bd09f1$var$unsafeSetAny(key2, 1, el);
    return $a801f2c896bd09f1$var$unsafeSetAny(key2, $a801f2c896bd09f1$var$jsUndefined, el);
};
var $a801f2c896bd09f1$var$propToStrKey = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$Attribute && v3.value0 instanceof $a801f2c896bd09f1$var$Just) return "attr/" + (v3.value0.value0 + (":" + v3.value1));
    if (v3 instanceof $a801f2c896bd09f1$var$Attribute) return "attr/:" + v3.value1;
    if (v3 instanceof $a801f2c896bd09f1$var$Property) return "prop/" + v3.value0;
    if (v3 instanceof $a801f2c896bd09f1$var$Handler) return "handler/" + v3.value0;
    if (v3 instanceof $a801f2c896bd09f1$var$Ref) return "ref";
    throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 182, column 16 - line 187, column 16): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$propFromString = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$propFromNumber = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$propFromBoolean = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$buildProp = function(emit) {
    return function(el) {
        var removeProp = function(prevEvents) {
            return function(v3, v1) {
                if (v1 instanceof $a801f2c896bd09f1$var$Attribute) return $a801f2c896bd09f1$var$removeAttribute($a801f2c896bd09f1$var$toNullable(v1.value0), v1.value1, el);
                if (v1 instanceof $a801f2c896bd09f1$var$Property) return $a801f2c896bd09f1$var$removeProperty(v1.value0, el);
                if (v1 instanceof $a801f2c896bd09f1$var$Handler) {
                    var handler3 = $a801f2c896bd09f1$var$unsafeLookup(v1.value0, prevEvents);
                    return $a801f2c896bd09f1$var$removeEventListener(v1.value0, $a801f2c896bd09f1$var$fst(handler3), el);
                }
                if (v1 instanceof $a801f2c896bd09f1$var$Ref) return $a801f2c896bd09f1$var$unit;
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 169, column 5 - line 179, column 18): " + [
                    v1.constructor.name
                ]);
            };
        };
        var mbEmit = function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Just) return emit(v3.value0)();
            return $a801f2c896bd09f1$var$unit;
        };
        var haltProp = function(state3) {
            var v3 = $a801f2c896bd09f1$var$lookup2("ref")(state3.props);
            if (v3 instanceof $a801f2c896bd09f1$var$Just && v3.value0 instanceof $a801f2c896bd09f1$var$Ref) return mbEmit(v3.value0.value0(new $a801f2c896bd09f1$var$Removed(el)));
            return $a801f2c896bd09f1$var$unit;
        };
        var diffProp = function(prevEvents, events) {
            return function(v3, v1, v11, v22) {
                if (v11 instanceof $a801f2c896bd09f1$var$Attribute && v22 instanceof $a801f2c896bd09f1$var$Attribute) {
                    var $66 = v11.value2 === v22.value2;
                    if ($66) return v22;
                    $a801f2c896bd09f1$var$setAttribute($a801f2c896bd09f1$var$toNullable(v22.value0), v22.value1, v22.value2, el);
                    return v22;
                }
                if (v11 instanceof $a801f2c896bd09f1$var$Property && v22 instanceof $a801f2c896bd09f1$var$Property) {
                    var v4 = $a801f2c896bd09f1$var$refEq2(v11.value1, v22.value1);
                    if (v4) return v22;
                    if (v22.value0 === "value") {
                        var elVal = $a801f2c896bd09f1$var$unsafeGetProperty("value", el);
                        var $75 = $a801f2c896bd09f1$var$refEq2(elVal, v22.value1);
                        if ($75) return v22;
                        $a801f2c896bd09f1$var$setProperty(v22.value0, v22.value1, el);
                        return v22;
                    }
                    $a801f2c896bd09f1$var$setProperty(v22.value0, v22.value1, el);
                    return v22;
                }
                if (v11 instanceof $a801f2c896bd09f1$var$Handler && v22 instanceof $a801f2c896bd09f1$var$Handler) {
                    var handler3 = $a801f2c896bd09f1$var$unsafeLookup(v22.value0, prevEvents);
                    $a801f2c896bd09f1$var$write(v22.value1)($a801f2c896bd09f1$var$snd(handler3))();
                    $a801f2c896bd09f1$var$pokeMutMap(v22.value0, handler3, events);
                    return v22;
                }
                return v22;
            };
        };
        var applyProp = function(events) {
            return function(v3, v1, v22) {
                if (v22 instanceof $a801f2c896bd09f1$var$Attribute) {
                    $a801f2c896bd09f1$var$setAttribute($a801f2c896bd09f1$var$toNullable(v22.value0), v22.value1, v22.value2, el);
                    return v22;
                }
                if (v22 instanceof $a801f2c896bd09f1$var$Property) {
                    $a801f2c896bd09f1$var$setProperty(v22.value0, v22.value1, el);
                    return v22;
                }
                if (v22 instanceof $a801f2c896bd09f1$var$Handler) {
                    var v32 = $a801f2c896bd09f1$var$unsafeGetAny(v22.value0, events);
                    if ($a801f2c896bd09f1$var$unsafeHasAny(v22.value0, events)) {
                        $a801f2c896bd09f1$var$write(v22.value1)($a801f2c896bd09f1$var$snd(v32))();
                        return v22;
                    }
                    var ref3 = $a801f2c896bd09f1$var$$$new(v22.value1)();
                    var listener = $a801f2c896bd09f1$var$eventListener(function(ev) {
                        return function __do2() {
                            var f$prime = $a801f2c896bd09f1$var$read(ref3)();
                            return mbEmit(f$prime(ev));
                        };
                    })();
                    $a801f2c896bd09f1$var$pokeMutMap(v22.value0, new $a801f2c896bd09f1$var$Tuple(listener, ref3), events);
                    $a801f2c896bd09f1$var$addEventListener(v22.value0, listener, el);
                    return v22;
                }
                if (v22 instanceof $a801f2c896bd09f1$var$Ref) {
                    mbEmit(v22.value0(new $a801f2c896bd09f1$var$Created(el)));
                    return v22;
                }
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 113, column 5 - line 135, column 15): " + [
                    v22.constructor.name
                ]);
            };
        };
        var $lazy_patchProp = $a801f2c896bd09f1$var$$runtime_lazy7("patchProp", "Halogen.VDom.DOM.Prop", function() {
            return function(state3, ps2) {
                var events = $a801f2c896bd09f1$var$newMutMap();
                var onThis = removeProp(state3.events);
                var onThese = diffProp(state3.events, events);
                var onThat = applyProp(events);
                var props = $a801f2c896bd09f1$var$diffWithKeyAndIxE(state3.props, ps2, $a801f2c896bd09f1$var$propToStrKey, onThese, onThis, onThat);
                var nextState = {
                    events: $a801f2c896bd09f1$var$unsafeFreeze2(events),
                    props: props
                };
                return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2($a801f2c896bd09f1$var$unit, nextState, $lazy_patchProp(100), haltProp));
            };
        });
        var patchProp = $lazy_patchProp(87);
        var renderProp = function(ps1) {
            var events = $a801f2c896bd09f1$var$newMutMap();
            var ps1$prime = $a801f2c896bd09f1$var$strMapWithIxE(ps1, $a801f2c896bd09f1$var$propToStrKey, applyProp(events));
            var state3 = {
                events: $a801f2c896bd09f1$var$unsafeFreeze2(events),
                props: ps1$prime
            };
            return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2($a801f2c896bd09f1$var$unit, state3, patchProp, haltProp));
        };
        return renderProp;
    };
};
// output/Web.HTML.Common/index.js
var $a801f2c896bd09f1$var$ClassName = function(x4) {
    return x4;
};
// output/Halogen.HTML.Core/index.js
var $a801f2c896bd09f1$var$HTML = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$widget = function($28) {
    return $a801f2c896bd09f1$var$HTML($a801f2c896bd09f1$var$Widget.create($28));
};
var $a801f2c896bd09f1$var$toPropValue = function(dict) {
    return dict.toPropValue;
};
var $a801f2c896bd09f1$var$text = function($29) {
    return $a801f2c896bd09f1$var$HTML($a801f2c896bd09f1$var$Text.create($29));
};
var $a801f2c896bd09f1$var$ref = function(f2) {
    return new $a801f2c896bd09f1$var$Ref(function($30) {
        return f2(function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Created) return new $a801f2c896bd09f1$var$Just(v3.value0);
            if (v3 instanceof $a801f2c896bd09f1$var$Removed) return $a801f2c896bd09f1$var$Nothing.value;
            throw new Error("Failed pattern match at Halogen.HTML.Core (line 109, column 21 - line 111, column 23): " + [
                v3.constructor.name
            ]);
        }($30));
    });
};
var $a801f2c896bd09f1$var$prop = function(dictIsProp) {
    var toPropValue1 = $a801f2c896bd09f1$var$toPropValue(dictIsProp);
    return function(v3) {
        var $31 = $a801f2c896bd09f1$var$Property.create(v3);
        return function($32) {
            return $31(toPropValue1($32));
        };
    };
};
var $a801f2c896bd09f1$var$isPropString = {
    toPropValue: $a801f2c896bd09f1$var$propFromString
};
var $a801f2c896bd09f1$var$isPropStepValue = {
    toPropValue: function($36) {
        return $a801f2c896bd09f1$var$propFromString($a801f2c896bd09f1$var$renderStepValue($36));
    }
};
var $a801f2c896bd09f1$var$isPropNumber = {
    toPropValue: $a801f2c896bd09f1$var$propFromNumber
};
var $a801f2c896bd09f1$var$isPropInputType = {
    toPropValue: function($45) {
        return $a801f2c896bd09f1$var$propFromString($a801f2c896bd09f1$var$renderInputType($45));
    }
};
var $a801f2c896bd09f1$var$isPropInputAcceptType = {
    toPropValue: function($46) {
        return $a801f2c896bd09f1$var$propFromString($a801f2c896bd09f1$var$renderInputAcceptType($46));
    }
};
var $a801f2c896bd09f1$var$isPropBoolean = {
    toPropValue: $a801f2c896bd09f1$var$propFromBoolean
};
var $a801f2c896bd09f1$var$handler = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$Handler.create;
}();
var $a801f2c896bd09f1$var$element = function(ns) {
    return function(name17) {
        return function(props) {
            return function(children2) {
                return new $a801f2c896bd09f1$var$Elem(ns, name17, props, children2);
            };
        };
    };
};
var $a801f2c896bd09f1$var$attr = function(ns) {
    return function(v3) {
        return $a801f2c896bd09f1$var$Attribute.create(ns)(v3);
    };
};
// output/Halogen.HTML.Properties/index.js
var $a801f2c896bd09f1$var$unwrap3 = /* @__PURE__ */ $a801f2c896bd09f1$var$unwrap();
var $a801f2c896bd09f1$var$ref2 = /* @__PURE__ */ function() {
    var go2 = function(p3) {
        return function(mel) {
            return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$RefUpdate(p3, mel));
        };
    };
    return function($29) {
        return $a801f2c896bd09f1$var$ref(go2($29));
    };
}();
var $a801f2c896bd09f1$var$prop2 = function(dictIsProp) {
    return $a801f2c896bd09f1$var$prop(dictIsProp);
};
var $a801f2c896bd09f1$var$prop1 = /* @__PURE__ */ $a801f2c896bd09f1$var$prop2($a801f2c896bd09f1$var$isPropBoolean);
var $a801f2c896bd09f1$var$prop22 = /* @__PURE__ */ $a801f2c896bd09f1$var$prop2($a801f2c896bd09f1$var$isPropString);
var $a801f2c896bd09f1$var$prop4 = /* @__PURE__ */ $a801f2c896bd09f1$var$prop2($a801f2c896bd09f1$var$isPropNumber);
var $a801f2c896bd09f1$var$selected = /* @__PURE__ */ $a801f2c896bd09f1$var$prop1("selected");
var $a801f2c896bd09f1$var$step2 = /* @__PURE__ */ $a801f2c896bd09f1$var$prop2($a801f2c896bd09f1$var$isPropStepValue)("step");
var $a801f2c896bd09f1$var$title = /* @__PURE__ */ $a801f2c896bd09f1$var$prop22("title");
var $a801f2c896bd09f1$var$type_ = function(dictIsProp) {
    return $a801f2c896bd09f1$var$prop2(dictIsProp)("type");
};
var $a801f2c896bd09f1$var$value = function(dictIsProp) {
    return $a801f2c896bd09f1$var$prop2(dictIsProp)("value");
};
var $a801f2c896bd09f1$var$name2 = /* @__PURE__ */ $a801f2c896bd09f1$var$prop22("name");
var $a801f2c896bd09f1$var$min3 = /* @__PURE__ */ $a801f2c896bd09f1$var$prop4("min");
var $a801f2c896bd09f1$var$max4 = /* @__PURE__ */ $a801f2c896bd09f1$var$prop4("max");
var $a801f2c896bd09f1$var$id2 = /* @__PURE__ */ $a801f2c896bd09f1$var$prop22("id");
var $a801f2c896bd09f1$var$href = /* @__PURE__ */ $a801f2c896bd09f1$var$prop22("href");
var $a801f2c896bd09f1$var$$$for2 = /* @__PURE__ */ $a801f2c896bd09f1$var$prop22("htmlFor");
var $a801f2c896bd09f1$var$disabled = /* @__PURE__ */ $a801f2c896bd09f1$var$prop1("disabled");
var $a801f2c896bd09f1$var$enabled = /* @__PURE__ */ function() {
    var $30 = $a801f2c896bd09f1$var$not($a801f2c896bd09f1$var$heytingAlgebraBoolean);
    return function($31) {
        return $a801f2c896bd09f1$var$disabled($30($31));
    };
}();
var $a801f2c896bd09f1$var$class_ = /* @__PURE__ */ function() {
    var $36 = $a801f2c896bd09f1$var$prop22("className");
    return function($37) {
        return $36($a801f2c896bd09f1$var$unwrap3($37));
    };
}();
var $a801f2c896bd09f1$var$checked = /* @__PURE__ */ $a801f2c896bd09f1$var$prop1("checked");
var $a801f2c896bd09f1$var$attr2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$attr($a801f2c896bd09f1$var$Nothing.value);
}();
var $a801f2c896bd09f1$var$style = /* @__PURE__ */ $a801f2c896bd09f1$var$attr2("style");
var $a801f2c896bd09f1$var$accept = /* @__PURE__ */ $a801f2c896bd09f1$var$prop2($a801f2c896bd09f1$var$isPropInputAcceptType)("accept");
// output/ProtoVoices.JSONTransport/foreign.js
function $a801f2c896bd09f1$var$unsafeStringifyPretty(json) {
    return JSON.stringify(json, null, 2);
}
// output/Data.Ratio/index.js
var $a801f2c896bd09f1$var$Ratio = /* @__PURE__ */ function() {
    function Ratio2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Ratio2.create = function(value0) {
        return function(value1) {
            return new Ratio2(value0, value1);
        };
    };
    return Ratio2;
}();
var $a801f2c896bd09f1$var$reduce = function(dictOrd) {
    var gcd2 = $a801f2c896bd09f1$var$gcd(dictOrd.Eq0());
    var signum2 = $a801f2c896bd09f1$var$signum(dictOrd);
    var abs4 = $a801f2c896bd09f1$var$abs(dictOrd);
    return function(dictEuclideanRing) {
        var gcd1 = gcd2(dictEuclideanRing);
        var div6 = $a801f2c896bd09f1$var$div(dictEuclideanRing);
        var Ring0 = dictEuclideanRing.CommutativeRing0().Ring0();
        var mul2 = $a801f2c896bd09f1$var$mul(Ring0.Semiring0());
        var signum1 = signum2(Ring0);
        var abs1 = abs4(Ring0);
        return function(n) {
            return function(d) {
                var g2 = gcd1(n)(d);
                var d$prime = div6(d)(g2);
                return new $a801f2c896bd09f1$var$Ratio(mul2(div6(n)(g2))(signum1(d$prime)), abs1(d$prime));
            };
        };
    };
};
var $a801f2c896bd09f1$var$numerator = function(v3) {
    return v3.value0;
};
var $a801f2c896bd09f1$var$eqRatio = function(dictEq) {
    var eq29 = $a801f2c896bd09f1$var$eq(dictEq);
    return {
        eq: function(v3) {
            return function(v1) {
                return eq29(v3.value0)(v1.value0) && eq29(v3.value1)(v1.value1);
            };
        }
    };
};
var $a801f2c896bd09f1$var$denominator = function(v3) {
    return v3.value1;
};
// output/ProtoVoices.Common/index.js
var $a801f2c896bd09f1$var$show8 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$bind9 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindParser);
var $a801f2c896bd09f1$var$pure13 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeParser);
var $a801f2c896bd09f1$var$foldl7 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableNonEmptyList);
var $a801f2c896bd09f1$var$reduce2 = /* @__PURE__ */ $a801f2c896bd09f1$var$reduce($a801f2c896bd09f1$var$ordInt)($a801f2c896bd09f1$var$euclideanRingInt);
var $a801f2c896bd09f1$var$bind14 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$pure14 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeMaybe);
var $a801f2c896bd09f1$var$showMBS = {
    show: function(v3) {
        return $a801f2c896bd09f1$var$show8(v3.m) + ("." + ($a801f2c896bd09f1$var$show8(v3.b) + ("." + ($a801f2c896bd09f1$var$show8($a801f2c896bd09f1$var$numerator(v3.s)) + ("/" + $a801f2c896bd09f1$var$show8($a801f2c896bd09f1$var$denominator(v3.s)))))));
    }
};
var $a801f2c896bd09f1$var$eqMBS = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec()(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons($a801f2c896bd09f1$var$eqRowNil)()({
    reflectSymbol: function() {
        return "s";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRatio($a801f2c896bd09f1$var$eqInt)))()({
    reflectSymbol: function() {
        return "m";
    }
})($a801f2c896bd09f1$var$eqInt))()({
    reflectSymbol: function() {
        return "b";
    }
})($a801f2c896bd09f1$var$eqInt));
var $a801f2c896bd09f1$var$ascii02 = /* @__PURE__ */ $a801f2c896bd09f1$var$toCharCode2("0");
var $a801f2c896bd09f1$var$digit2 = function(d) {
    return $a801f2c896bd09f1$var$toCharCode2(d) - $a801f2c896bd09f1$var$ascii02 | 0;
};
var $a801f2c896bd09f1$var$$$parseInt = /* @__PURE__ */ $a801f2c896bd09f1$var$bind9(/* @__PURE__ */ $a801f2c896bd09f1$var$option("+")(/* @__PURE__ */ $a801f2c896bd09f1$var$$$char("-")))(function(signChar) {
    var sign2 = function() {
        var $39 = signChar === "-";
        if ($39) return -1;
        return 1;
    }();
    return $a801f2c896bd09f1$var$bind9($a801f2c896bd09f1$var$many1($a801f2c896bd09f1$var$anyDigit))(function(dgts) {
        return $a801f2c896bd09f1$var$pure13(sign2 * $a801f2c896bd09f1$var$foldl7(function(acc) {
            return function(d) {
                return (10 * acc | 0) + $a801f2c896bd09f1$var$digit2(d) | 0;
            };
        })(0)(dgts) | 0);
    });
});
var $a801f2c896bd09f1$var$parseFrac = /* @__PURE__ */ $a801f2c896bd09f1$var$bind9($a801f2c896bd09f1$var$$$parseInt)(function(num) {
    return $a801f2c896bd09f1$var$bind9($a801f2c896bd09f1$var$option(1)($a801f2c896bd09f1$var$bind9($a801f2c896bd09f1$var$$$char("/"))(function() {
        return $a801f2c896bd09f1$var$$$parseInt;
    })))(function(denom) {
        return $a801f2c896bd09f1$var$pure13($a801f2c896bd09f1$var$reduce2(num)(denom));
    });
});
var $a801f2c896bd09f1$var$parseMBS = function(str) {
    var v3 = function(v1) {
        if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$Nothing.value;
        throw new Error("Failed pattern match at ProtoVoices.Common (line 53, column 1 - line 53, column 32): " + [
            str.constructor.name
        ]);
    };
    var $42 = $a801f2c896bd09f1$var$split(".")(str);
    if ($42.length === 3) return $a801f2c896bd09f1$var$bind14($a801f2c896bd09f1$var$hush($a801f2c896bd09f1$var$runParser($a801f2c896bd09f1$var$$$parseInt)($42[0])))(function(m3) {
        return $a801f2c896bd09f1$var$bind14($a801f2c896bd09f1$var$hush($a801f2c896bd09f1$var$runParser($a801f2c896bd09f1$var$$$parseInt)($42[1])))(function(b3) {
            return $a801f2c896bd09f1$var$bind14($a801f2c896bd09f1$var$hush($a801f2c896bd09f1$var$runParser($a801f2c896bd09f1$var$parseFrac)($42[2])))(function(s2) {
                return $a801f2c896bd09f1$var$pure14({
                    m: m3,
                    b: b3,
                    s: s2
                });
            });
        });
    });
    return v3(true);
};
var $a801f2c896bd09f1$var$parseTime = function(str) {
    return $a801f2c896bd09f1$var$maybe(new $a801f2c896bd09f1$var$Left(str))($a801f2c896bd09f1$var$Right.create)($a801f2c896bd09f1$var$parseMBS(str));
};
// output/ProtoVoices.Leftmost/index.js
var $a801f2c896bd09f1$var$append5 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$bind10 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindArray);
var $a801f2c896bd09f1$var$toUnfoldable6 = /* @__PURE__ */ $a801f2c896bd09f1$var$toUnfoldable4($a801f2c896bd09f1$var$unfoldableArray);
var $a801f2c896bd09f1$var$pure15 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeArray);
var $a801f2c896bd09f1$var$map26 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$showRecord6 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord()();
var $a801f2c896bd09f1$var$showRecordFieldsCons9 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "ids";
    }
});
var $a801f2c896bd09f1$var$showRecordFieldsCons12 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "passing";
    }
});
var $a801f2c896bd09f1$var$regularIsSymbol2 = {
    reflectSymbol: function() {
        return "regular";
    }
};
var $a801f2c896bd09f1$var$showRecordFieldsConsNil3 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "unexplained";
    }
});
var $a801f2c896bd09f1$var$showRecord12 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "id";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "pitch";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval)))($a801f2c896bd09f1$var$showString));
var $a801f2c896bd09f1$var$showArray2 = /* @__PURE__ */ $a801f2c896bd09f1$var$showArray($a801f2c896bd09f1$var$showRecord12);
var $a801f2c896bd09f1$var$showRecordFieldsCons23 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "left";
    }
});
var $a801f2c896bd09f1$var$rightIsSymbol2 = {
    reflectSymbol: function() {
        return "right";
    }
};
var $a801f2c896bd09f1$var$showRecordFieldsConsNil12 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$rightIsSymbol2);
var $a801f2c896bd09f1$var$showStartStop2 = /* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop($a801f2c896bd09f1$var$showRecord12);
var $a801f2c896bd09f1$var$showRecord23 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons23(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil12($a801f2c896bd09f1$var$showStartStop2))($a801f2c896bd09f1$var$showStartStop2));
var $a801f2c896bd09f1$var$showMap2 = /* @__PURE__ */ $a801f2c896bd09f1$var$showMap($a801f2c896bd09f1$var$showRecord23);
var $a801f2c896bd09f1$var$showRecordFieldsCons32 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "child";
    }
});
var $a801f2c896bd09f1$var$showRecordFieldsConsNil23 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "orn";
    }
});
var $a801f2c896bd09f1$var$showMaybe2 = /* @__PURE__ */ $a801f2c896bd09f1$var$showMaybe($a801f2c896bd09f1$var$showDoubleOrnament);
var $a801f2c896bd09f1$var$showArray1 = /* @__PURE__ */ $a801f2c896bd09f1$var$showArray($a801f2c896bd09f1$var$showRecord23);
var $a801f2c896bd09f1$var$showRecordFieldsCons42 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$rightIsSymbol2);
var $a801f2c896bd09f1$var$showMap1 = /* @__PURE__ */ $a801f2c896bd09f1$var$showMap($a801f2c896bd09f1$var$showRecord12);
var $a801f2c896bd09f1$var$LMSplitLeftIsSymbol = {
    reflectSymbol: function() {
        return "LMSplitLeft";
    }
};
var $a801f2c896bd09f1$var$LMFreezeLeftIsSymbol = {
    reflectSymbol: function() {
        return "LMFreezeLeft";
    }
};
var $a801f2c896bd09f1$var$LMSplitRightIsSymbol = {
    reflectSymbol: function() {
        return "LMSplitRight";
    }
};
var $a801f2c896bd09f1$var$LMHorizontalizeIsSymbol = {
    reflectSymbol: function() {
        return "LMHorizontalize";
    }
};
var $a801f2c896bd09f1$var$LMSplitOnlyIsSymbol = {
    reflectSymbol: function() {
        return "LMSplitOnly";
    }
};
var $a801f2c896bd09f1$var$LMFreezeOnlyIsSymbol = {
    reflectSymbol: function() {
        return "LMFreezeOnly";
    }
};
var $a801f2c896bd09f1$var$genericShowConstructor3 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument($a801f2c896bd09f1$var$showRecord12));
var $a801f2c896bd09f1$var$showRecord32 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons23(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil12($a801f2c896bd09f1$var$showArray2))($a801f2c896bd09f1$var$showArray2));
var $a801f2c896bd09f1$var$sequence3 = /* @__PURE__ */ $a801f2c896bd09f1$var$sequence($a801f2c896bd09f1$var$traversableArray)($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$bind15 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindEither);
var $a801f2c896bd09f1$var$pure16 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$RootNote = /* @__PURE__ */ function() {
    function RootNote2() {}
    RootNote2.value = new RootNote2();
    return RootNote2;
}();
var $a801f2c896bd09f1$var$LMSplitLeft = /* @__PURE__ */ function() {
    function LMSplitLeft2(value0) {
        this.value0 = value0;
    }
    LMSplitLeft2.create = function(value0) {
        return new LMSplitLeft2(value0);
    };
    return LMSplitLeft2;
}();
var $a801f2c896bd09f1$var$LMFreezeLeft = /* @__PURE__ */ function() {
    function LMFreezeLeft2(value0) {
        this.value0 = value0;
    }
    LMFreezeLeft2.create = function(value0) {
        return new LMFreezeLeft2(value0);
    };
    return LMFreezeLeft2;
}();
var $a801f2c896bd09f1$var$LMSplitRight = /* @__PURE__ */ function() {
    function LMSplitRight2(value0) {
        this.value0 = value0;
    }
    LMSplitRight2.create = function(value0) {
        return new LMSplitRight2(value0);
    };
    return LMSplitRight2;
}();
var $a801f2c896bd09f1$var$LMHorizontalize = /* @__PURE__ */ function() {
    function LMHorizontalize2(value0) {
        this.value0 = value0;
    }
    LMHorizontalize2.create = function(value0) {
        return new LMHorizontalize2(value0);
    };
    return LMHorizontalize2;
}();
var $a801f2c896bd09f1$var$LMSplitOnly = /* @__PURE__ */ function() {
    function LMSplitOnly2(value0) {
        this.value0 = value0;
    }
    LMSplitOnly2.create = function(value0) {
        return new LMSplitOnly2(value0);
    };
    return LMSplitOnly2;
}();
var $a801f2c896bd09f1$var$LMFreezeOnly = /* @__PURE__ */ function() {
    function LMFreezeOnly2(value0) {
        this.value0 = value0;
    }
    LMFreezeOnly2.create = function(value0) {
        return new LMFreezeOnly2(value0);
    };
    return LMFreezeOnly2;
}();
var $a801f2c896bd09f1$var$LeftChild = /* @__PURE__ */ function() {
    function LeftChild2(value0) {
        this.value0 = value0;
    }
    LeftChild2.create = function(value0) {
        return new LeftChild2(value0);
    };
    return LeftChild2;
}();
var $a801f2c896bd09f1$var$RightChild = /* @__PURE__ */ function() {
    function RightChild2(value0) {
        this.value0 = value0;
    }
    RightChild2.create = function(value0) {
        return new RightChild2(value0);
    };
    return RightChild2;
}();
var $a801f2c896bd09f1$var$BothChildren = /* @__PURE__ */ function() {
    function BothChildren2(value0) {
        this.value0 = value0;
    }
    BothChildren2.create = function(value0) {
        return new BothChildren2(value0);
    };
    return BothChildren2;
}();
var $a801f2c896bd09f1$var$TooManyChildren = /* @__PURE__ */ function() {
    function TooManyChildren2(value0) {
        this.value0 = value0;
    }
    TooManyChildren2.create = function(value0) {
        return new TooManyChildren2(value0);
    };
    return TooManyChildren2;
}();
var $a801f2c896bd09f1$var$semigroupHoriChildren = {
    append: function(a3) {
        return function(b3) {
            if (a3 instanceof $a801f2c896bd09f1$var$LeftChild) {
                if (b3 instanceof $a801f2c896bd09f1$var$LeftChild) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: [
                        a3.value0,
                        b3.value0
                    ],
                    right: []
                });
                if (b3 instanceof $a801f2c896bd09f1$var$RightChild) return new $a801f2c896bd09f1$var$BothChildren({
                    left: a3.value0,
                    right: b3.value0
                });
                if (b3 instanceof $a801f2c896bd09f1$var$BothChildren) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: [
                        a3.value0,
                        b3.value0.left
                    ],
                    right: [
                        b3.value0.right
                    ]
                });
                if (b3 instanceof $a801f2c896bd09f1$var$TooManyChildren) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: $a801f2c896bd09f1$var$cons2(a3.value0)(b3.value0.left),
                    right: b3.value0.right
                });
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 105, column 20 - line 109, column 88): " + [
                    b3.constructor.name
                ]);
            }
            if (a3 instanceof $a801f2c896bd09f1$var$RightChild) {
                if (b3 instanceof $a801f2c896bd09f1$var$LeftChild) return new $a801f2c896bd09f1$var$BothChildren({
                    left: b3.value0,
                    right: a3.value0
                });
                if (b3 instanceof $a801f2c896bd09f1$var$RightChild) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: [],
                    right: [
                        a3.value0,
                        b3.value0
                    ]
                });
                if (b3 instanceof $a801f2c896bd09f1$var$BothChildren) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: [
                        b3.value0.left
                    ],
                    right: [
                        a3.value0,
                        b3.value0.right
                    ]
                });
                if (b3 instanceof $a801f2c896bd09f1$var$TooManyChildren) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: b3.value0.left,
                    right: $a801f2c896bd09f1$var$cons2(a3.value0)(b3.value0.right)
                });
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 110, column 21 - line 114, column 89): " + [
                    b3.constructor.name
                ]);
            }
            if (a3 instanceof $a801f2c896bd09f1$var$BothChildren) {
                if (b3 instanceof $a801f2c896bd09f1$var$LeftChild) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: [
                        a3.value0.left,
                        b3.value0
                    ],
                    right: [
                        a3.value0.right
                    ]
                });
                if (b3 instanceof $a801f2c896bd09f1$var$RightChild) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: [
                        a3.value0.left
                    ],
                    right: [
                        a3.value0.right,
                        b3.value0
                    ]
                });
                if (b3 instanceof $a801f2c896bd09f1$var$BothChildren) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: [
                        a3.value0.left,
                        b3.value0.left
                    ],
                    right: [
                        a3.value0.right,
                        b3.value0.right
                    ]
                });
                if (b3 instanceof $a801f2c896bd09f1$var$TooManyChildren) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: $a801f2c896bd09f1$var$cons2(a3.value0.left)(b3.value0.left),
                    right: $a801f2c896bd09f1$var$cons2(a3.value0.right)(b3.value0.right)
                });
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 115, column 43 - line 119, column 104): " + [
                    b3.constructor.name
                ]);
            }
            if (a3 instanceof $a801f2c896bd09f1$var$TooManyChildren) {
                if (b3 instanceof $a801f2c896bd09f1$var$LeftChild) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: $a801f2c896bd09f1$var$snoc2(a3.value0.left)(b3.value0),
                    right: a3.value0.right
                });
                if (b3 instanceof $a801f2c896bd09f1$var$RightChild) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: a3.value0.left,
                    right: $a801f2c896bd09f1$var$snoc2(a3.value0.right)(b3.value0)
                });
                if (b3 instanceof $a801f2c896bd09f1$var$BothChildren) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: $a801f2c896bd09f1$var$snoc2(a3.value0.left)(b3.value0.left),
                    right: $a801f2c896bd09f1$var$snoc2(a3.value0.right)(b3.value0.right)
                });
                if (b3 instanceof $a801f2c896bd09f1$var$TooManyChildren) return new $a801f2c896bd09f1$var$TooManyChildren({
                    left: $a801f2c896bd09f1$var$append5(a3.value0.left)(b3.value0.left),
                    right: $a801f2c896bd09f1$var$append5(a3.value0.right)(b3.value0.right)
                });
                throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 120, column 46 - line 124, column 96): " + [
                    b3.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 104, column 16 - line 124, column 96): " + [
                a3.constructor.name
            ]);
        };
    }
};
var $a801f2c896bd09f1$var$horiRightChildren = function(v3) {
    var unexpl = $a801f2c896bd09f1$var$map26(function(note2) {
        return {
            note: note2,
            expl: $a801f2c896bd09f1$var$NoExpl.value
        };
    })(v3.unexplained.right);
    var getChild = function(v1) {
        if (v1.value1 instanceof $a801f2c896bd09f1$var$RightChild) return [
            {
                note: v1.value1.value0,
                expl: new $a801f2c896bd09f1$var$HoriExpl(v1.value0)
            }
        ];
        if (v1.value1 instanceof $a801f2c896bd09f1$var$LeftChild) return [];
        if (v1.value1 instanceof $a801f2c896bd09f1$var$BothChildren) return [
            {
                note: v1.value1.value0.right,
                expl: new $a801f2c896bd09f1$var$HoriExpl(v1.value0)
            }
        ];
        if (v1.value1 instanceof $a801f2c896bd09f1$var$TooManyChildren) return $a801f2c896bd09f1$var$map26(function(v22) {
            return {
                note: v22,
                expl: new $a801f2c896bd09f1$var$HoriExpl(v1.value0)
            };
        })(v1.value1.value0.right);
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 154, column 34 - line 158, column 78): " + [
            v1.value1.constructor.name
        ]);
    };
    var explained = $a801f2c896bd09f1$var$concatMap(getChild)($a801f2c896bd09f1$var$toUnfoldable6(v3.children));
    return $a801f2c896bd09f1$var$sortNotes($a801f2c896bd09f1$var$append5(unexpl)(explained));
};
var $a801f2c896bd09f1$var$horiLeftChildren = function(v3) {
    var unexpl = $a801f2c896bd09f1$var$map26(function(note2) {
        return {
            note: note2,
            expl: $a801f2c896bd09f1$var$NoExpl.value
        };
    })(v3.unexplained.left);
    var getChild = function(v1) {
        if (v1.value1 instanceof $a801f2c896bd09f1$var$LeftChild) return [
            {
                note: v1.value1.value0,
                expl: new $a801f2c896bd09f1$var$HoriExpl(v1.value0)
            }
        ];
        if (v1.value1 instanceof $a801f2c896bd09f1$var$RightChild) return [];
        if (v1.value1 instanceof $a801f2c896bd09f1$var$BothChildren) return [
            {
                note: v1.value1.value0.left,
                expl: new $a801f2c896bd09f1$var$HoriExpl(v1.value0)
            }
        ];
        if (v1.value1 instanceof $a801f2c896bd09f1$var$TooManyChildren) return $a801f2c896bd09f1$var$map26(function(v22) {
            return {
                note: v22,
                expl: new $a801f2c896bd09f1$var$HoriExpl(v1.value0)
            };
        })(v1.value1.value0.left);
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 141, column 34 - line 145, column 76): " + [
            v1.value1.constructor.name
        ]);
    };
    var explained = $a801f2c896bd09f1$var$concatMap(getChild)($a801f2c896bd09f1$var$toUnfoldable6(v3.children));
    return $a801f2c896bd09f1$var$sortNotes($a801f2c896bd09f1$var$append5(unexpl)(explained));
};
var $a801f2c896bd09f1$var$genericSplitOp = {
    to: function(x4) {
        return x4;
    },
    from: function(x4) {
        return x4;
    }
};
var $a801f2c896bd09f1$var$genericRootOrnament = {
    to: function(x4) {
        return $a801f2c896bd09f1$var$RootNote.value;
    },
    from: function(x4) {
        return $a801f2c896bd09f1$var$NoArguments.value;
    }
};
var $a801f2c896bd09f1$var$genericShow7 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericRootOrnament)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsNoArguments)({
    reflectSymbol: function() {
        return "RootNote";
    }
}));
var $a801f2c896bd09f1$var$showRootOrnament = {
    show: function(ro) {
        return $a801f2c896bd09f1$var$genericShow7(ro);
    }
};
var $a801f2c896bd09f1$var$genericShow12 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericSplitOp)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "fromLeft";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "fromRight";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "keepLeft";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "keepRight";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "passLeft";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "passRight";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons12(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$regularIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil3($a801f2c896bd09f1$var$showArray2))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap2(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons32(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil23(/* @__PURE__ */ $a801f2c896bd09f1$var$showEither($a801f2c896bd09f1$var$showRootOrnament)($a801f2c896bd09f1$var$showMaybe2)))($a801f2c896bd09f1$var$showRecord12))))))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap2(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons32(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil23($a801f2c896bd09f1$var$showMaybe2))($a801f2c896bd09f1$var$showRecord12))))))($a801f2c896bd09f1$var$showArray1))($a801f2c896bd09f1$var$showArray1))($a801f2c896bd09f1$var$showArray1))($a801f2c896bd09f1$var$showArray1))(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons23(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons42(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "slice";
    }
})($a801f2c896bd09f1$var$showSliceId))($a801f2c896bd09f1$var$showTransId))($a801f2c896bd09f1$var$showTransId))))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap1(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons32(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil23(/* @__PURE__ */ $a801f2c896bd09f1$var$showMaybe($a801f2c896bd09f1$var$showLeftOrnament)))($a801f2c896bd09f1$var$showRecord12))))))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap1(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons32(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil23(/* @__PURE__ */ $a801f2c896bd09f1$var$showMaybe($a801f2c896bd09f1$var$showRightOrnament)))($a801f2c896bd09f1$var$showRecord12))))))))({
    reflectSymbol: function() {
        return "SplitOp";
    }
}));
var $a801f2c896bd09f1$var$showSplitOp = {
    show: function(so) {
        return $a801f2c896bd09f1$var$genericShow12(so);
    }
};
var $a801f2c896bd09f1$var$genericLeftmost = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$LMSplitLeft(x4.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$LMFreezeLeft(x4.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$LMSplitRight(x4.value0.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$LMHorizontalize(x4.value0.value0.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$LMSplitOnly(x4.value0.value0.value0.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0.value0.value0 instanceof $a801f2c896bd09f1$var$Inr) return new $a801f2c896bd09f1$var$LMFreezeOnly(x4.value0.value0.value0.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 25, column 1 - line 25, column 62): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$LMSplitLeft) return new $a801f2c896bd09f1$var$Inl(x4.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$LMFreezeLeft) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0));
        if (x4 instanceof $a801f2c896bd09f1$var$LMSplitRight) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0)));
        if (x4 instanceof $a801f2c896bd09f1$var$LMHorizontalize) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0))));
        if (x4 instanceof $a801f2c896bd09f1$var$LMSplitOnly) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0)))));
        if (x4 instanceof $a801f2c896bd09f1$var$LMFreezeOnly) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(x4.value0)))));
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 25, column 1 - line 25, column 62): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow23 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericLeftmost);
var $a801f2c896bd09f1$var$showLeftmost = function(dictShow) {
    var genericShowConstructor1 = $a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsArgument(dictShow));
    var genericShowSum3 = $a801f2c896bd09f1$var$genericShowSum(genericShowConstructor1($a801f2c896bd09f1$var$LMSplitLeftIsSymbol));
    var genericShowSum12 = $a801f2c896bd09f1$var$genericShowSum(genericShowConstructor1($a801f2c896bd09f1$var$LMSplitRightIsSymbol));
    var genericShowSum22 = $a801f2c896bd09f1$var$genericShowSum(genericShowConstructor1($a801f2c896bd09f1$var$LMSplitOnlyIsSymbol));
    return function(dictShow1) {
        var genericShowConstructor22 = $a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsArgument(dictShow1));
        var genericShowSum32 = $a801f2c896bd09f1$var$genericShowSum(genericShowConstructor22($a801f2c896bd09f1$var$LMFreezeLeftIsSymbol));
        var genericShowSum4 = genericShowSum22(genericShowConstructor22($a801f2c896bd09f1$var$LMFreezeOnlyIsSymbol));
        return function(dictShow2) {
            var genericShow62 = $a801f2c896bd09f1$var$genericShow23(genericShowSum3(genericShowSum32(genericShowSum12($a801f2c896bd09f1$var$genericShowSum($a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsArgument(dictShow2))($a801f2c896bd09f1$var$LMHorizontalizeIsSymbol))(genericShowSum4)))));
            return {
                show: function(lm) {
                    return genericShow62(lm);
                }
            };
        };
    };
};
var $a801f2c896bd09f1$var$genericHoriOp = {
    to: function(x4) {
        return x4;
    },
    from: function(x4) {
        return x4;
    }
};
var $a801f2c896bd09f1$var$genericHoriChildren = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$LeftChild(x4.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$RightChild(x4.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inl) return new $a801f2c896bd09f1$var$BothChildren(x4.value0.value0.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr && x4.value0.value0 instanceof $a801f2c896bd09f1$var$Inr) return new $a801f2c896bd09f1$var$TooManyChildren(x4.value0.value0.value0);
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 177, column 1 - line 177, column 62): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$LeftChild) return new $a801f2c896bd09f1$var$Inl(x4.value0);
        if (x4 instanceof $a801f2c896bd09f1$var$RightChild) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0));
        if (x4 instanceof $a801f2c896bd09f1$var$BothChildren) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl(x4.value0)));
        if (x4 instanceof $a801f2c896bd09f1$var$TooManyChildren) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr(x4.value0)));
        throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 177, column 1 - line 177, column 62): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow32 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericHoriChildren)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor3({
    reflectSymbol: function() {
        return "LeftChild";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor3({
    reflectSymbol: function() {
        return "RightChild";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons23(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil12($a801f2c896bd09f1$var$showRecord12))($a801f2c896bd09f1$var$showRecord12))))({
    reflectSymbol: function() {
        return "BothChildren";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument($a801f2c896bd09f1$var$showRecord32))({
    reflectSymbol: function() {
        return "TooManyChildren";
    }
})))));
var $a801f2c896bd09f1$var$showHoriChildren = {
    show: function(hc) {
        return $a801f2c896bd09f1$var$genericShow32(hc);
    }
};
var $a801f2c896bd09f1$var$genericShow42 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericHoriOp)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "children";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "midEdges";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil3($a801f2c896bd09f1$var$showRecord32))(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons12(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$regularIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$showSet($a801f2c896bd09f1$var$showRecord23)))($a801f2c896bd09f1$var$showArray1))))(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons23(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "lslice";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "mid";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons42(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "rslice";
    }
})($a801f2c896bd09f1$var$showSliceId))($a801f2c896bd09f1$var$showTransId))($a801f2c896bd09f1$var$showTransId))($a801f2c896bd09f1$var$showSliceId))($a801f2c896bd09f1$var$showTransId))))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap1($a801f2c896bd09f1$var$showHoriChildren)))))({
    reflectSymbol: function() {
        return "HoriOp";
    }
}));
var $a801f2c896bd09f1$var$showHoriOp = {
    show: function(ho) {
        return $a801f2c896bd09f1$var$genericShow42(ho);
    }
};
var $a801f2c896bd09f1$var$genericFreezeOp = {
    to: function(x4) {
        return x4;
    },
    from: function(x4) {
        return x4;
    }
};
var $a801f2c896bd09f1$var$genericShow52 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericFreezeOp)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowArgsArgument(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "prevTime";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "ties";
    }
})($a801f2c896bd09f1$var$showArray1))(/* @__PURE__ */ $a801f2c896bd09f1$var$showEither($a801f2c896bd09f1$var$showString)($a801f2c896bd09f1$var$showMBS)))))({
    reflectSymbol: function() {
        return "FreezeOp";
    }
}));
var $a801f2c896bd09f1$var$showFreezeOp = {
    show: function(fo) {
        return $a801f2c896bd09f1$var$genericShow52(fo);
    }
};
var $a801f2c896bd09f1$var$extractChildNotes = function(splits) {
    return function(f2) {
        return $a801f2c896bd09f1$var$sequence3($a801f2c896bd09f1$var$bind10($a801f2c896bd09f1$var$toUnfoldable6(splits))(function(v3) {
            return $a801f2c896bd09f1$var$bind10(v3.value1)(function(child) {
                return $a801f2c896bd09f1$var$pure15(function() {
                    var v1 = f2(v3.value0)(child.orn);
                    if (v1 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Left(v1.value0);
                    if (v1 instanceof $a801f2c896bd09f1$var$Right) return new $a801f2c896bd09f1$var$Right({
                        note: child.child,
                        expl: v1.value0
                    });
                    throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 68, column 10 - line 70, column 54): " + [
                        v1.constructor.name
                    ]);
                }());
            });
        }));
    };
};
var $a801f2c896bd09f1$var$splitGetChildNotes = function(v3) {
    return $a801f2c896bd09f1$var$bind15($a801f2c896bd09f1$var$extractChildNotes(v3.regular)(function(p3) {
        return function(o2) {
            if (o2 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$RootExpl.value);
            if (o2 instanceof $a801f2c896bd09f1$var$Right) {
                if (p3.left instanceof $a801f2c896bd09f1$var$Inner) {
                    if (p3.right instanceof $a801f2c896bd09f1$var$Inner) return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$DoubleExpl({
                        leftParent: p3.left.value0,
                        rightParent: p3.right.value0,
                        orn: o2.value0
                    }));
                    return new $a801f2c896bd09f1$var$Left("Parent note cannot be Start or Stop!");
                }
                return new $a801f2c896bd09f1$var$Left("Parent note cannot be Start or Stop!");
            }
            throw new Error("Failed pattern match at ProtoVoices.Leftmost (line 75, column 41 - line 81, column 57): " + [
                o2.constructor.name
            ]);
        };
    }))(function(regular) {
        return $a801f2c896bd09f1$var$bind15($a801f2c896bd09f1$var$extractChildNotes(v3.passing)(function(p3) {
            return function(orn) {
                if (p3.left instanceof $a801f2c896bd09f1$var$Inner) {
                    if (p3.right instanceof $a801f2c896bd09f1$var$Inner) return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$DoubleExpl({
                        leftParent: p3.left.value0,
                        rightParent: p3.right.value0,
                        orn: orn
                    }));
                    return new $a801f2c896bd09f1$var$Left("Parent note cannot be Start or Stop!");
                }
                return new $a801f2c896bd09f1$var$Left("Parent note cannot be Start or Stop!");
            };
        }))(function(passing) {
            return $a801f2c896bd09f1$var$bind15($a801f2c896bd09f1$var$extractChildNotes(v3.fromLeft)(function(p3) {
                return function(orn) {
                    return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$RightExpl({
                        leftParent: p3,
                        orn: orn
                    }));
                };
            }))(function(fromLeft) {
                return $a801f2c896bd09f1$var$bind15($a801f2c896bd09f1$var$extractChildNotes(v3.fromRight)(function(p3) {
                    return function(orn) {
                        return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$LeftExpl({
                            rightParent: p3,
                            orn: orn
                        }));
                    };
                }))(function(fromRight) {
                    var unexplained = $a801f2c896bd09f1$var$map26(function(note2) {
                        return {
                            note: note2,
                            expl: $a801f2c896bd09f1$var$NoExpl.value
                        };
                    })(v3.unexplained);
                    return $a801f2c896bd09f1$var$pure16($a801f2c896bd09f1$var$sortNotes($a801f2c896bd09f1$var$append5(regular)($a801f2c896bd09f1$var$append5(passing)($a801f2c896bd09f1$var$append5(fromLeft)($a801f2c896bd09f1$var$append5(fromRight)(unexplained))))));
                });
            });
        });
    });
};
// output/ProtoVoices.Folding/index.js
var $a801f2c896bd09f1$var$map27 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorStartStop);
var $a801f2c896bd09f1$var$map113 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$discard4 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit);
var $a801f2c896bd09f1$var$bindStateT2 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindStateT($a801f2c896bd09f1$var$monadEither);
var $a801f2c896bd09f1$var$discard1 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard4($a801f2c896bd09f1$var$bindStateT2);
var $a801f2c896bd09f1$var$monadStateStateT2 = /* @__PURE__ */ $a801f2c896bd09f1$var$monadStateStateT($a801f2c896bd09f1$var$monadEither);
var $a801f2c896bd09f1$var$modify_3 = /* @__PURE__ */ $a801f2c896bd09f1$var$modify_2($a801f2c896bd09f1$var$monadStateStateT2);
var $a801f2c896bd09f1$var$max5 = /* @__PURE__ */ $a801f2c896bd09f1$var$max($a801f2c896bd09f1$var$ordTransId);
var $a801f2c896bd09f1$var$bind11 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindStateT2);
var $a801f2c896bd09f1$var$lift3 = /* @__PURE__ */ $a801f2c896bd09f1$var$lift($a801f2c896bd09f1$var$monadTransStateT)($a801f2c896bd09f1$var$monadEither);
var $a801f2c896bd09f1$var$pure17 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure(/* @__PURE__ */ $a801f2c896bd09f1$var$applicativeStateT($a801f2c896bd09f1$var$monadEither));
var $a801f2c896bd09f1$var$max1 = /* @__PURE__ */ $a801f2c896bd09f1$var$max($a801f2c896bd09f1$var$ordSliceId);
var $a801f2c896bd09f1$var$bind16 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$eqRec4 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec();
var $a801f2c896bd09f1$var$eqRowCons3 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons($a801f2c896bd09f1$var$eqRowNil)();
var $a801f2c896bd09f1$var$pitchIsSymbol2 = {
    reflectSymbol: function() {
        return "pitch";
    }
};
var $a801f2c896bd09f1$var$idIsSymbol2 = {
    reflectSymbol: function() {
        return "id";
    }
};
var $a801f2c896bd09f1$var$eqStartStop2 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec4(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons3($a801f2c896bd09f1$var$pitchIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqPitch($a801f2c896bd09f1$var$eqSInterval)))()($a801f2c896bd09f1$var$idIsSymbol2)($a801f2c896bd09f1$var$eqString)));
var $a801f2c896bd09f1$var$eq6 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqStartStop2);
var $a801f2c896bd09f1$var$modify5 = /* @__PURE__ */ $a801f2c896bd09f1$var$modify2($a801f2c896bd09f1$var$monadStateStateT2);
var $a801f2c896bd09f1$var$ordRecord3 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord();
var $a801f2c896bd09f1$var$ordRecordCons3 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons($a801f2c896bd09f1$var$ordRecordNil)();
var $a801f2c896bd09f1$var$rightIsSymbol3 = {
    reflectSymbol: function() {
        return "right";
    }
};
var $a801f2c896bd09f1$var$ordRecord12 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons3($a801f2c896bd09f1$var$pitchIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$ordPitch($a801f2c896bd09f1$var$ordSInterval)))()($a801f2c896bd09f1$var$idIsSymbol2)($a801f2c896bd09f1$var$ordString));
var $a801f2c896bd09f1$var$ordStartStop2 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordStartStop($a801f2c896bd09f1$var$ordRecord12);
var $a801f2c896bd09f1$var$leftIsSymbol2 = {
    reflectSymbol: function() {
        return "left";
    }
};
var $a801f2c896bd09f1$var$ordRecord22 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons3($a801f2c896bd09f1$var$rightIsSymbol3)($a801f2c896bd09f1$var$ordStartStop2))()($a801f2c896bd09f1$var$leftIsSymbol2)($a801f2c896bd09f1$var$ordStartStop2));
var $a801f2c896bd09f1$var$fromFoldable7 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable5($a801f2c896bd09f1$var$foldableArray)($a801f2c896bd09f1$var$ordRecord22);
var $a801f2c896bd09f1$var$bind23 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindEither);
var $a801f2c896bd09f1$var$pure18 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$map28 = /* @__PURE__ */ $a801f2c896bd09f1$var$map(/* @__PURE__ */ $a801f2c896bd09f1$var$functorStateT($a801f2c896bd09f1$var$functorEither));
var $a801f2c896bd09f1$var$fromFoldable12 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$pure24 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure(/* @__PURE__ */ $a801f2c896bd09f1$var$applicativeStateT($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$bindStateT1 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindStateT($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$bind33 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindStateT1);
var $a801f2c896bd09f1$var$discard23 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard4($a801f2c896bd09f1$var$bindStateT1);
var $a801f2c896bd09f1$var$append6 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupList);
var $a801f2c896bd09f1$var$monadStateStateT1 = /* @__PURE__ */ $a801f2c896bd09f1$var$monadStateStateT($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$modify_1 = /* @__PURE__ */ $a801f2c896bd09f1$var$modify_2($a801f2c896bd09f1$var$monadStateStateT1);
var $a801f2c896bd09f1$var$bindFlipped5 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindEither);
var $a801f2c896bd09f1$var$fromFoldable22 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableSet);
var $a801f2c896bd09f1$var$eq18 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqNoteExplanation);
var $a801f2c896bd09f1$var$append12 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$fromFoldableWith2 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldableWith($a801f2c896bd09f1$var$ordRecord12);
var $a801f2c896bd09f1$var$fromFoldableWith1 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldableWith2($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$append23 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupHoriChildren);
var $a801f2c896bd09f1$var$map33 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorList);
var $a801f2c896bd09f1$var$eq23 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqDoubleOrnament));
var $a801f2c896bd09f1$var$bind42 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindArray);
var $a801f2c896bd09f1$var$fromFoldable32 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$discard32 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard4($a801f2c896bd09f1$var$bindArray);
var $a801f2c896bd09f1$var$guard2 = /* @__PURE__ */ $a801f2c896bd09f1$var$guard($a801f2c896bd09f1$var$alternativeArray);
var $a801f2c896bd09f1$var$pure33 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeArray);
var $a801f2c896bd09f1$var$fromFoldableWith22 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldableWith($a801f2c896bd09f1$var$ordRecord22)($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$fromFoldableWith3 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldableWith2($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$difference3 = /* @__PURE__ */ $a801f2c896bd09f1$var$difference(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec4(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons3($a801f2c896bd09f1$var$rightIsSymbol3)($a801f2c896bd09f1$var$eqStartStop2))()($a801f2c896bd09f1$var$leftIsSymbol2)($a801f2c896bd09f1$var$eqStartStop2)));
var $a801f2c896bd09f1$var$passingIsSymbol2 = {
    reflectSymbol: function() {
        return "passing";
    }
};
var $a801f2c896bd09f1$var$regularIsSymbol3 = {
    reflectSymbol: function() {
        return "regular";
    }
};
var $a801f2c896bd09f1$var$append33 = /* @__PURE__ */ $a801f2c896bd09f1$var$append(/* @__PURE__ */ $a801f2c896bd09f1$var$semigroupRecord()(/* @__PURE__ */ $a801f2c896bd09f1$var$semigroupRecordCons($a801f2c896bd09f1$var$passingIsSymbol2)()(/* @__PURE__ */ $a801f2c896bd09f1$var$semigroupRecordCons($a801f2c896bd09f1$var$regularIsSymbol3)()($a801f2c896bd09f1$var$semigroupRecordNil)(/* @__PURE__ */ $a801f2c896bd09f1$var$semigroupSet($a801f2c896bd09f1$var$ordRecord22)))($a801f2c896bd09f1$var$semigroupArray)));
var $a801f2c896bd09f1$var$fold3 = /* @__PURE__ */ $a801f2c896bd09f1$var$fold($a801f2c896bd09f1$var$foldableArray)(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecord()(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecordCons($a801f2c896bd09f1$var$passingIsSymbol2)($a801f2c896bd09f1$var$monoidArray)()(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecordCons($a801f2c896bd09f1$var$regularIsSymbol3)(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidSet($a801f2c896bd09f1$var$ordRecord22))()($a801f2c896bd09f1$var$monoidRecordNil))));
var $a801f2c896bd09f1$var$insert9 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert6($a801f2c896bd09f1$var$ordTransId);
var $a801f2c896bd09f1$var$max22 = /* @__PURE__ */ $a801f2c896bd09f1$var$max($a801f2c896bd09f1$var$ordNumber);
var $a801f2c896bd09f1$var$insert1 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert6($a801f2c896bd09f1$var$ordSliceId);
var $a801f2c896bd09f1$var$gets2 = /* @__PURE__ */ $a801f2c896bd09f1$var$gets($a801f2c896bd09f1$var$monadStateStateT1);
var $a801f2c896bd09f1$var$ET = /* @__PURE__ */ function() {
    function ET2(value0) {
        this.value0 = value0;
    }
    ET2.create = function(value0) {
        return new ET2(value0);
    };
    return ET2;
}();
var $a801f2c896bd09f1$var$EN = /* @__PURE__ */ function() {
    function EN2(value0) {
        this.value0 = value0;
    }
    EN2.create = function(value0) {
        return new EN2(value0);
    };
    return EN2;
}();
var $a801f2c896bd09f1$var$ER = /* @__PURE__ */ function() {
    function ER2(value0) {
        this.value0 = value0;
    }
    ER2.create = function(value0) {
        return new ER2(value0);
    };
    return ER2;
}();
var $a801f2c896bd09f1$var$EL = /* @__PURE__ */ function() {
    function EL2(value0) {
        this.value0 = value0;
    }
    EL2.create = function(value0) {
        return new EL2(value0);
    };
    return EL2;
}();
var $a801f2c896bd09f1$var$partitionElaborations = function(dictFoldable) {
    var select5 = function(v3) {
        return function(v1) {
            if (v1 instanceof $a801f2c896bd09f1$var$ET) return {
                t: new $a801f2c896bd09f1$var$Cons(v1.value0, v3.t),
                n: v3.n,
                r: v3.r,
                l: v3.l
            };
            if (v1 instanceof $a801f2c896bd09f1$var$EN) return {
                t: v3.t,
                n: new $a801f2c896bd09f1$var$Cons(v1.value0, v3.n),
                r: v3.r,
                l: v3.l
            };
            if (v1 instanceof $a801f2c896bd09f1$var$ER) return {
                t: v3.t,
                n: v3.n,
                r: new $a801f2c896bd09f1$var$Cons(v1.value0, v3.r),
                l: v3.l
            };
            if (v1 instanceof $a801f2c896bd09f1$var$EL) return {
                t: v3.t,
                n: v3.n,
                r: v3.r,
                l: new $a801f2c896bd09f1$var$Cons(v1.value0, v3.l)
            };
            throw new Error("Failed pattern match at ProtoVoices.Folding (line 254, column 27 - line 258, column 36): " + [
                v1.constructor.name
            ]);
        };
    };
    return $a801f2c896bd09f1$var$foldl(dictFoldable)(select5)({
        t: $a801f2c896bd09f1$var$Nil.value,
        n: $a801f2c896bd09f1$var$Nil.value,
        r: $a801f2c896bd09f1$var$Nil.value,
        l: $a801f2c896bd09f1$var$Nil.value
    });
};
var $a801f2c896bd09f1$var$partitionElaborations1 = /* @__PURE__ */ $a801f2c896bd09f1$var$partitionElaborations($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$nothingMore = function(seg) {
    return {
        seg: seg,
        more: $a801f2c896bd09f1$var$unit
    };
};
var $a801f2c896bd09f1$var$leftmostToReduction = function(topSegments) {
    return function(deriv) {
        var startSlice2 = {
            id: 0,
            x: 0,
            notes: $a801f2c896bd09f1$var$Start.value,
            parents: $a801f2c896bd09f1$var$NoParents.value
        };
        var prepareTop = function(v3) {
            return {
                transId: v3.trans.id,
                rslice: {
                    id: v3.rslice.id,
                    parents: $a801f2c896bd09f1$var$NoParents.value,
                    notes: $a801f2c896bd09f1$var$map27($a801f2c896bd09f1$var$map113(function(note2) {
                        return {
                            note: note2,
                            expl: $a801f2c896bd09f1$var$NoExpl.value
                        };
                    }))(v3.rslice.notes)
                }
            };
        };
        var prepareSplit = function(leftSliceId) {
            return function(top2) {
                return function(v3) {
                    return $a801f2c896bd09f1$var$discard1($a801f2c896bd09f1$var$modify_3(function(st) {
                        var $230 = {};
                        for(var $231 in st)if (({}).hasOwnProperty.call(st, $231)) $230[$231] = st[$231];
                        $230.maxT = $a801f2c896bd09f1$var$max5(st.maxT)(top2.transId);
                        return $230;
                    }))(function() {
                        return $a801f2c896bd09f1$var$bind11($a801f2c896bd09f1$var$lift3($a801f2c896bd09f1$var$splitGetChildNotes(v3)))(function(childNotes) {
                            var childrTop = {
                                transId: v3.ids.right,
                                rslice: top2.rslice
                            };
                            var childSlice = {
                                id: v3.ids.slice,
                                notes: new $a801f2c896bd09f1$var$Inner(childNotes),
                                parents: new $a801f2c896bd09f1$var$MergeParents({
                                    left: leftSliceId,
                                    right: top2.rslice.id
                                })
                            };
                            var childlTop = {
                                transId: v3.ids.left,
                                rslice: childSlice
                            };
                            return $a801f2c896bd09f1$var$pure17({
                                childlTop: childlTop,
                                childrTop: childrTop
                            });
                        });
                    });
                };
            };
        };
        var prepareHori = function(topl) {
            return function(topr) {
                return function(v3) {
                    return $a801f2c896bd09f1$var$discard1($a801f2c896bd09f1$var$modify_3(function(st) {
                        var $236 = {};
                        for(var $237 in st)if (({}).hasOwnProperty.call(st, $237)) $236[$237] = st[$237];
                        $236.maxT = $a801f2c896bd09f1$var$max5(st.maxT)($a801f2c896bd09f1$var$max5(topl.transId)(topr.transId));
                        $236.maxS = $a801f2c896bd09f1$var$max1(st.maxS)(topl.rslice.id);
                        return $236;
                    }))(function() {
                        var childrTop = {
                            transId: v3.ids.right,
                            rslice: topr.rslice
                        };
                        var childmTop = {
                            transId: v3.ids.mid,
                            rslice: {
                                id: v3.ids.rslice,
                                notes: new $a801f2c896bd09f1$var$Inner($a801f2c896bd09f1$var$horiRightChildren(v3)),
                                parents: new $a801f2c896bd09f1$var$VertParent(topl.rslice.id)
                            }
                        };
                        var childlTop = {
                            transId: v3.ids.left,
                            rslice: {
                                id: v3.ids.lslice,
                                notes: new $a801f2c896bd09f1$var$Inner($a801f2c896bd09f1$var$horiLeftChildren(v3)),
                                parents: new $a801f2c896bd09f1$var$VertParent(topl.rslice.id)
                            }
                        };
                        return $a801f2c896bd09f1$var$pure17({
                            childlTop: childlTop,
                            childmTop: childmTop,
                            childrTop: childrTop
                        });
                    });
                };
            };
        };
        var freeze = function(lslice) {
            return function(v3) {
                return function(v1) {
                    var holdNote = function(v22) {
                        var hold = $a801f2c896bd09f1$var$bind16($a801f2c896bd09f1$var$find2(function(v32) {
                            return $a801f2c896bd09f1$var$eq6(v32.left)(new $a801f2c896bd09f1$var$Inner(v22.note));
                        })(v3.ties))(function(edge) {
                            return $a801f2c896bd09f1$var$bind16($a801f2c896bd09f1$var$getInner(edge.right))(function(right) {
                                return new $a801f2c896bd09f1$var$Just(right.id);
                            });
                        });
                        return {
                            note: v22.note,
                            hold: hold
                        };
                    };
                    var pieceNotes = $a801f2c896bd09f1$var$map113(holdNote)($a801f2c896bd09f1$var$sortNotes($a801f2c896bd09f1$var$getInnerNotes(lslice)));
                    return $a801f2c896bd09f1$var$bind11($a801f2c896bd09f1$var$modify5(function(st) {
                        var $246 = {};
                        for(var $247 in st)if (({}).hasOwnProperty.call(st, $247)) $246[$247] = st[$247];
                        $246.x = st.x + 1;
                        $246.maxT = $a801f2c896bd09f1$var$max5(st.maxT)(v1.transId);
                        $246.maxS = $a801f2c896bd09f1$var$max1(st.maxS)(v1.rslice.id);
                        $246.piece = $a801f2c896bd09f1$var$snoc2(st.piece)({
                            notes: pieceNotes,
                            time: v3.prevTime
                        });
                        return $246;
                    }))(function(st) {
                        return $a801f2c896bd09f1$var$pure17({
                            trans: {
                                id: v1.transId,
                                edges: {
                                    passing: [],
                                    regular: $a801f2c896bd09f1$var$fromFoldable7(v3.ties)
                                },
                                is2nd: false
                            },
                            rslice: {
                                id: v1.rslice.id,
                                notes: v1.rslice.notes,
                                parents: v1.rslice.parents,
                                x: st.x
                            },
                            op: $a801f2c896bd09f1$var$Freeze.value
                        });
                    });
                };
            };
        };
        var completeSplit = function(top2) {
            return function(childl) {
                return function(childr) {
                    return {
                        trans: {
                            id: top2.transId,
                            edges: $a801f2c896bd09f1$var$parentEdges(childl.rslice),
                            is2nd: childl.trans.is2nd
                        },
                        rslice: childr.rslice,
                        op: new $a801f2c896bd09f1$var$Split2({
                            childl: childl,
                            childr: $a801f2c896bd09f1$var$detachSegment(childr)
                        })
                    };
                };
            };
        };
        var completeHori = function(topl) {
            return function(topr) {
                return function(childl) {
                    return function(childm) {
                        return function(childr) {
                            var topSlice = {
                                id: topl.rslice.id,
                                notes: topl.rslice.notes,
                                parents: topl.rslice.parents,
                                x: (childl.rslice.x + childm.rslice.x) / 2
                            };
                            return $a801f2c896bd09f1$var$bind23($a801f2c896bd09f1$var$vertEdgesLeft(childl.trans.edges)(childl.rslice))(function(edgesL) {
                                return $a801f2c896bd09f1$var$bind23($a801f2c896bd09f1$var$vertEdgesRight(childr.trans.edges)(childm.rslice))(function(edgesR) {
                                    var segr = {
                                        trans: {
                                            id: topr.transId,
                                            edges: edgesR,
                                            is2nd: true
                                        },
                                        rslice: childr.rslice,
                                        op: $a801f2c896bd09f1$var$Freeze.value
                                    };
                                    var segl = {
                                        trans: {
                                            id: topl.transId,
                                            edges: edgesL,
                                            is2nd: false
                                        },
                                        rslice: topSlice,
                                        op: new $a801f2c896bd09f1$var$Hori({
                                            childl: childl,
                                            childm: childm,
                                            childr: $a801f2c896bd09f1$var$detachSegment(childr)
                                        })
                                    };
                                    return $a801f2c896bd09f1$var$pure18({
                                        segl: segl,
                                        segr: segr
                                    });
                                });
                            });
                        };
                    };
                };
            };
        };
        var go2 = function(v3) {
            return function(v1) {
                return function(v22) {
                    if (v1 instanceof $a801f2c896bd09f1$var$Nil && v22 instanceof $a801f2c896bd09f1$var$Nil) return $a801f2c896bd09f1$var$pure17($a801f2c896bd09f1$var$Nil.value);
                    if (v1 instanceof $a801f2c896bd09f1$var$Cons && v22 instanceof $a801f2c896bd09f1$var$Cons) {
                        if (v1.value1 instanceof $a801f2c896bd09f1$var$Cons) {
                            if (v22.value0 instanceof $a801f2c896bd09f1$var$LMFreezeLeft) return $a801f2c896bd09f1$var$bind11(freeze(v3)(v22.value0.value0)(v1.value0))(function(top$prime) {
                                return $a801f2c896bd09f1$var$map28($a801f2c896bd09f1$var$Cons.create(top$prime))(go2(top$prime.rslice)(v1.value1)(v22.value1));
                            });
                            if (v22.value0 instanceof $a801f2c896bd09f1$var$LMSplitLeft) return $a801f2c896bd09f1$var$bind11(prepareSplit(v3.id)(v1.value0)(v22.value0.value0))(function(v32) {
                                return $a801f2c896bd09f1$var$bind11(go2(v3)(new $a801f2c896bd09f1$var$Cons(v32.childlTop, new $a801f2c896bd09f1$var$Cons(v32.childrTop, v1.value1)))(v22.value1))(function(segs) {
                                    if (segs instanceof $a801f2c896bd09f1$var$Cons && segs.value1 instanceof $a801f2c896bd09f1$var$Cons) return $a801f2c896bd09f1$var$pure17(new $a801f2c896bd09f1$var$Cons(completeSplit(v1.value0)(segs.value0)(segs.value1.value0), segs.value1.value1));
                                    return $a801f2c896bd09f1$var$lift3(new $a801f2c896bd09f1$var$Left("Operations after splitLeft do not fit!"));
                                });
                            });
                            if (v22.value0 instanceof $a801f2c896bd09f1$var$LMSplitRight) return $a801f2c896bd09f1$var$bind11(prepareSplit(v1.value0.rslice.id)(v1.value1.value0)(v22.value0.value0))(function(v32) {
                                return $a801f2c896bd09f1$var$bind11(go2(v3)(new $a801f2c896bd09f1$var$Cons(v1.value0, new $a801f2c896bd09f1$var$Cons(v32.childlTop, new $a801f2c896bd09f1$var$Cons(v32.childrTop, v1.value1.value1))))(v22.value1))(function(segs) {
                                    if (segs instanceof $a801f2c896bd09f1$var$Cons && segs.value1 instanceof $a801f2c896bd09f1$var$Cons && segs.value1.value1 instanceof $a801f2c896bd09f1$var$Cons) return $a801f2c896bd09f1$var$pure17(new $a801f2c896bd09f1$var$Cons(segs.value0, new $a801f2c896bd09f1$var$Cons(completeSplit(v1.value1.value0)(segs.value1.value0)(segs.value1.value1.value0), segs.value1.value1.value1)));
                                    return $a801f2c896bd09f1$var$lift3(new $a801f2c896bd09f1$var$Left("Operations after splitRight do not fit!"));
                                });
                            });
                            if (v22.value0 instanceof $a801f2c896bd09f1$var$LMHorizontalize) return $a801f2c896bd09f1$var$bind11(prepareHori(v1.value0)(v1.value1.value0)(v22.value0.value0))(function(v32) {
                                return $a801f2c896bd09f1$var$bind11(go2(v3)(new $a801f2c896bd09f1$var$Cons(v32.childlTop, new $a801f2c896bd09f1$var$Cons(v32.childmTop, new $a801f2c896bd09f1$var$Cons(v32.childrTop, v1.value1.value1))))(v22.value1))(function(segs) {
                                    if (segs instanceof $a801f2c896bd09f1$var$Cons && segs.value1 instanceof $a801f2c896bd09f1$var$Cons && segs.value1.value1 instanceof $a801f2c896bd09f1$var$Cons) return $a801f2c896bd09f1$var$bind11($a801f2c896bd09f1$var$lift3(completeHori(v1.value0)(v1.value1.value0)(segs.value0)(segs.value1.value0)(segs.value1.value1.value0)))(function(v4) {
                                        return $a801f2c896bd09f1$var$pure17(new $a801f2c896bd09f1$var$Cons(v4.segl, new $a801f2c896bd09f1$var$Cons(v4.segr, segs.value1.value1.value1)));
                                    });
                                    return $a801f2c896bd09f1$var$lift3(new $a801f2c896bd09f1$var$Left("Operations after hori do not fit!"));
                                });
                            });
                            return $a801f2c896bd09f1$var$lift3(new $a801f2c896bd09f1$var$Left("Applying a single-transition operation while several transitions are left!"));
                        }
                        if (v1.value1 instanceof $a801f2c896bd09f1$var$Nil) {
                            if (v22.value0 instanceof $a801f2c896bd09f1$var$LMFreezeOnly) return $a801f2c896bd09f1$var$bind11(freeze(v3)(v22.value0.value0)(v1.value0))(function(seg) {
                                return $a801f2c896bd09f1$var$pure17(new $a801f2c896bd09f1$var$Cons(seg, $a801f2c896bd09f1$var$Nil.value));
                            });
                            if (v22.value0 instanceof $a801f2c896bd09f1$var$LMSplitOnly) return $a801f2c896bd09f1$var$bind11(prepareSplit(v3.id)(v1.value0)(v22.value0.value0))(function(v32) {
                                return $a801f2c896bd09f1$var$bind11(go2(v3)(new $a801f2c896bd09f1$var$Cons(v32.childlTop, new $a801f2c896bd09f1$var$Cons(v32.childrTop, $a801f2c896bd09f1$var$Nil.value)))(v22.value1))(function(segs) {
                                    if (segs instanceof $a801f2c896bd09f1$var$Cons && segs.value1 instanceof $a801f2c896bd09f1$var$Cons && segs.value1.value1 instanceof $a801f2c896bd09f1$var$Nil) return $a801f2c896bd09f1$var$pure17(new $a801f2c896bd09f1$var$Cons(completeSplit(v1.value0)(segs.value0)(segs.value1.value0), $a801f2c896bd09f1$var$Nil.value));
                                    return $a801f2c896bd09f1$var$lift3(new $a801f2c896bd09f1$var$Left("Operations after splitOnly do not fit!"));
                                });
                            });
                            return $a801f2c896bd09f1$var$lift3(new $a801f2c896bd09f1$var$Left("Applying a non-single operation to a single transition!"));
                        }
                        throw new Error("Failed pattern match at ProtoVoices.Folding (line 420, column 48 - line 458, column 84): " + [
                            v1.value1.constructor.name
                        ]);
                    }
                    return $a801f2c896bd09f1$var$lift3(new $a801f2c896bd09f1$var$Left("Lengths of top-level and derivation do not match!"));
                };
            };
        };
        return $a801f2c896bd09f1$var$bind23($a801f2c896bd09f1$var$runStateT(go2(startSlice2)($a801f2c896bd09f1$var$fromFoldable12($a801f2c896bd09f1$var$map113(prepareTop)(topSegments)))($a801f2c896bd09f1$var$fromFoldable12(deriv)))({
            maxS: 0,
            maxT: 0,
            x: 0,
            piece: []
        }))(function(v3) {
            return $a801f2c896bd09f1$var$pure18({
                reduction: {
                    start: startSlice2,
                    segments: v3.value0,
                    nextSliceId: $a801f2c896bd09f1$var$incS(v3.value1.maxS),
                    nextTransId: $a801f2c896bd09f1$var$incT(v3.value1.maxT)
                },
                piece: $a801f2c896bd09f1$var$fromMaybe([])($a801f2c896bd09f1$var$tail(v3.value1.piece))
            });
        });
    };
};
var $a801f2c896bd09f1$var$foldAgenda = function(v3) {
    return function(v1) {
        return function(v22) {
            if (v22 instanceof $a801f2c896bd09f1$var$Nil) return $a801f2c896bd09f1$var$pure24($a801f2c896bd09f1$var$unit);
            if (v22 instanceof $a801f2c896bd09f1$var$Cons && v22.value1 instanceof $a801f2c896bd09f1$var$Nil) {
                if (v22.value0.seg.op instanceof $a801f2c896bd09f1$var$Freeze) return v3.freezeOnly(v1)(v22.value0);
                if (v22.value0.seg.op instanceof $a801f2c896bd09f1$var$Split2) return $a801f2c896bd09f1$var$bind33(v3.splitOnly(v1)(v22.value0)(v22.value0.seg.op.value0))(function(children2) {
                    return $a801f2c896bd09f1$var$foldAgenda(v3)(v1)(children2);
                });
                if (v22.value0.seg.op instanceof $a801f2c896bd09f1$var$Hori) return $a801f2c896bd09f1$var$pure24($a801f2c896bd09f1$var$unit);
                throw new Error("Failed pattern match at ProtoVoices.Folding (line 59, column 3 - line 64, column 24): " + [
                    v22.value0.seg.op.constructor.name
                ]);
            }
            if (v22 instanceof $a801f2c896bd09f1$var$Cons && v22.value1 instanceof $a801f2c896bd09f1$var$Cons) {
                if (v22.value0.seg.op instanceof $a801f2c896bd09f1$var$Freeze) return $a801f2c896bd09f1$var$discard23(v3.freezeLeft(v1)(v22.value0))(function() {
                    return $a801f2c896bd09f1$var$foldAgenda(v3)(v22.value0.seg.rslice)(v22.value1);
                });
                if (v22.value0.seg.op instanceof $a801f2c896bd09f1$var$Split2) return $a801f2c896bd09f1$var$bind33(v3.splitLeft(v1)(v22.value0)(v22.value0.seg.op.value0))(function(children2) {
                    return $a801f2c896bd09f1$var$foldAgenda(v3)(v1)($a801f2c896bd09f1$var$append6(children2)(v22.value1));
                });
                if (v22.value0.seg.op instanceof $a801f2c896bd09f1$var$Hori) {
                    if (v22.value1.value0.seg.op instanceof $a801f2c896bd09f1$var$Split2) return $a801f2c896bd09f1$var$bind33(v3.splitRight(v1)(v22.value0)(v22.value1.value0)(v22.value1.value0.seg.op.value0))(function(children2) {
                        return $a801f2c896bd09f1$var$foldAgenda(v3)(v1)($a801f2c896bd09f1$var$append6(new $a801f2c896bd09f1$var$Cons(v22.value0, children2))(v22.value1.value1));
                    });
                    return $a801f2c896bd09f1$var$bind33(v3.hori(v1)(v22.value0)(v22.value1.value0)(v22.value0.seg.op.value0))(function(children2) {
                        return $a801f2c896bd09f1$var$foldAgenda(v3)(v1)($a801f2c896bd09f1$var$append6(children2)(v22.value1.value1));
                    });
                }
                throw new Error("Failed pattern match at ProtoVoices.Folding (line 69, column 3 - line 86, column 55): " + [
                    v22.value0.seg.op.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at ProtoVoices.Folding (line 48, column 1 - line 53, column 21): " + [
                v3.constructor.name,
                v1.constructor.name,
                v22.constructor.name
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$walkGraph = function(alg) {
    return function(start2) {
        return function(agenda) {
            return $a801f2c896bd09f1$var$discard23(alg.init(start2))(function() {
                return $a801f2c896bd09f1$var$foldAgenda(alg)(start2)(agenda);
            });
        };
    };
};
var $a801f2c896bd09f1$var$reductionToLeftmost = function(v3) {
    var lmAlg = /* @__PURE__ */ function() {
        var modifyEither = function($483) {
            return $a801f2c896bd09f1$var$modify_1($a801f2c896bd09f1$var$bindFlipped5($483));
        };
        var mkFreeze = function(seg) {
            return function(time3) {
                return {
                    ties: $a801f2c896bd09f1$var$fromFoldable22(seg.trans.edges.regular),
                    prevTime: time3
                };
            };
        };
        var getUnexplained = function(slice4) {
            return $a801f2c896bd09f1$var$map113(function(v1) {
                return v1.note;
            })($a801f2c896bd09f1$var$filter2(function(v1) {
                return $a801f2c896bd09f1$var$eq18(v1.expl)($a801f2c896bd09f1$var$NoExpl.value);
            })($a801f2c896bd09f1$var$getInnerNotes(slice4)));
        };
        var mkHori = function(childl) {
            return function(childm) {
                return function(childr) {
                    var horiChild = function(wrapper) {
                        return function(v1) {
                            if (v1.expl instanceof $a801f2c896bd09f1$var$HoriExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Tuple(v1.expl.value0, wrapper(v1.note)));
                            return $a801f2c896bd09f1$var$Nothing.value;
                        };
                    };
                    var children2 = $a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$append12($a801f2c896bd09f1$var$map113(horiChild($a801f2c896bd09f1$var$LeftChild.create))($a801f2c896bd09f1$var$getInnerNotes(childl.rslice)))($a801f2c896bd09f1$var$map113(horiChild($a801f2c896bd09f1$var$RightChild.create))($a801f2c896bd09f1$var$getInnerNotes(childm.rslice))));
                    return {
                        children: $a801f2c896bd09f1$var$fromFoldableWith1($a801f2c896bd09f1$var$append23)(children2),
                        midEdges: childm.trans.edges,
                        ids: {
                            left: childl.trans.id,
                            lslice: childl.rslice.id,
                            mid: childm.trans.id,
                            rslice: childm.rslice.id,
                            right: childr.trans.id
                        },
                        unexplained: {
                            left: getUnexplained(childl.rslice),
                            right: getUnexplained(childm.rslice)
                        }
                    };
                };
            };
        };
        var hori = function(v1) {
            return function(v22) {
                return function(v32) {
                    return function(v4) {
                        return $a801f2c896bd09f1$var$discard23(modifyEither(function(st) {
                            return new $a801f2c896bd09f1$var$Right(function() {
                                var $349 = {};
                                for(var $350 in st)if (({}).hasOwnProperty.call(st, $350)) $349[$350] = st[$350];
                                $349.lm = new $a801f2c896bd09f1$var$Cons(new $a801f2c896bd09f1$var$LMHorizontalize(mkHori(v4.childl)(v4.childm)(v4.childr)), st.lm);
                                return $349;
                            }());
                        }))(function() {
                            return $a801f2c896bd09f1$var$pure24($a801f2c896bd09f1$var$map33($a801f2c896bd09f1$var$nothingMore)(new $a801f2c896bd09f1$var$Cons(v4.childl, new $a801f2c896bd09f1$var$Cons(v4.childm, new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(v4.childr)(v32.seg.rslice), $a801f2c896bd09f1$var$Nil.value)))));
                        });
                    };
                };
            };
        };
        var mkSplit = function(childl) {
            return function(childr) {
                var getElaboration = function(n) {
                    if (n.expl instanceof $a801f2c896bd09f1$var$DoubleExpl) {
                        var $357 = $a801f2c896bd09f1$var$eq23(n.expl.value0.orn)(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingLeft.value)) || $a801f2c896bd09f1$var$eq23(n.expl.value0.orn)(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingRight.value)) || $a801f2c896bd09f1$var$eq23(n.expl.value0.orn)(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingMid.value));
                        if ($357) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$EN(new $a801f2c896bd09f1$var$Tuple({
                            left: new $a801f2c896bd09f1$var$Inner(n.expl.value0.leftParent),
                            right: new $a801f2c896bd09f1$var$Inner(n.expl.value0.rightParent)
                        }, [
                            {
                                child: n.note,
                                orn: n.expl.value0.orn
                            }
                        ])));
                        return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$ET(new $a801f2c896bd09f1$var$Tuple({
                            left: new $a801f2c896bd09f1$var$Inner(n.expl.value0.leftParent),
                            right: new $a801f2c896bd09f1$var$Inner(n.expl.value0.rightParent)
                        }, [
                            {
                                child: n.note,
                                orn: new $a801f2c896bd09f1$var$Right(n.expl.value0.orn)
                            }
                        ])));
                    }
                    if (n.expl instanceof $a801f2c896bd09f1$var$RightExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$ER(new $a801f2c896bd09f1$var$Tuple(n.expl.value0.leftParent, [
                        {
                            child: n.note,
                            orn: n.expl.value0.orn
                        }
                    ])));
                    if (n.expl instanceof $a801f2c896bd09f1$var$LeftExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$EL(new $a801f2c896bd09f1$var$Tuple(n.expl.value0.rightParent, [
                        {
                            child: n.note,
                            orn: n.expl.value0.orn
                        }
                    ])));
                    if (n.expl instanceof $a801f2c896bd09f1$var$RootExpl) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$ET(new $a801f2c896bd09f1$var$Tuple({
                        left: $a801f2c896bd09f1$var$Start.value,
                        right: $a801f2c896bd09f1$var$Stop.value
                    }, [
                        {
                            child: n.note,
                            orn: new $a801f2c896bd09f1$var$Left($a801f2c896bd09f1$var$RootNote.value)
                        }
                    ])));
                    return $a801f2c896bd09f1$var$Nothing.value;
                };
                var v1 = $a801f2c896bd09f1$var$partitionElaborations1($a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$map113(getElaboration)($a801f2c896bd09f1$var$getInnerNotes(childl.rslice))));
                var prs = $a801f2c896bd09f1$var$bind42($a801f2c896bd09f1$var$fromFoldable32(v1.n))(function(v22) {
                    return $a801f2c896bd09f1$var$bind42(v22.value1)(function(child) {
                        return $a801f2c896bd09f1$var$discard32($a801f2c896bd09f1$var$guard2($a801f2c896bd09f1$var$eq23(child.orn)(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingLeft.value))))(function() {
                            return $a801f2c896bd09f1$var$pure33({
                                left: new $a801f2c896bd09f1$var$Inner(child.child),
                                right: v22.value0.right
                            });
                        });
                    });
                });
                var pls = $a801f2c896bd09f1$var$bind42($a801f2c896bd09f1$var$fromFoldable32(v1.n))(function(v22) {
                    return $a801f2c896bd09f1$var$bind42(v22.value1)(function(child) {
                        return $a801f2c896bd09f1$var$discard32($a801f2c896bd09f1$var$guard2($a801f2c896bd09f1$var$eq23(child.orn)(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingRight.value))))(function() {
                            return $a801f2c896bd09f1$var$pure33({
                                left: v22.value0.left,
                                right: new $a801f2c896bd09f1$var$Inner(child.child)
                            });
                        });
                    });
                });
                return {
                    regular: $a801f2c896bd09f1$var$fromFoldableWith22($a801f2c896bd09f1$var$append12)(v1.t),
                    passing: $a801f2c896bd09f1$var$fromFoldableWith22($a801f2c896bd09f1$var$append12)(v1.n),
                    fromLeft: $a801f2c896bd09f1$var$fromFoldableWith3($a801f2c896bd09f1$var$append12)(v1.r),
                    fromRight: $a801f2c896bd09f1$var$fromFoldableWith3($a801f2c896bd09f1$var$append12)(v1.l),
                    unexplained: getUnexplained(childl.rslice),
                    keepLeft: $a801f2c896bd09f1$var$fromFoldable22(childl.trans.edges.regular),
                    keepRight: $a801f2c896bd09f1$var$fromFoldable22(childr.trans.edges.regular),
                    passLeft: $a801f2c896bd09f1$var$difference3(childl.trans.edges.passing)(pls),
                    passRight: $a801f2c896bd09f1$var$difference3(childr.trans.edges.passing)(prs),
                    ids: {
                        left: childl.trans.id,
                        slice: childl.rslice.id,
                        right: childr.trans.id
                    }
                };
            };
        };
        var splitLeft = function(v1) {
            return function(v22) {
                return function(v32) {
                    return $a801f2c896bd09f1$var$discard23(modifyEither(function(st) {
                        return new $a801f2c896bd09f1$var$Right(function() {
                            var $382 = {};
                            for(var $383 in st)if (({}).hasOwnProperty.call(st, $383)) $382[$383] = st[$383];
                            $382.lm = new $a801f2c896bd09f1$var$Cons(new $a801f2c896bd09f1$var$LMSplitLeft(mkSplit(v32.childl)(v32.childr)), st.lm);
                            return $382;
                        }());
                    }))(function() {
                        return $a801f2c896bd09f1$var$pure24($a801f2c896bd09f1$var$map33($a801f2c896bd09f1$var$nothingMore)(new $a801f2c896bd09f1$var$Cons(v32.childl, new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(v32.childr)(v22.seg.rslice), $a801f2c896bd09f1$var$Nil.value))));
                    });
                };
            };
        };
        var splitOnly = function(v1) {
            return function(v22) {
                return function(v32) {
                    return $a801f2c896bd09f1$var$discard23(modifyEither(function(st) {
                        return new $a801f2c896bd09f1$var$Right(function() {
                            var $391 = {};
                            for(var $392 in st)if (({}).hasOwnProperty.call(st, $392)) $391[$392] = st[$392];
                            $391.lm = new $a801f2c896bd09f1$var$Cons(new $a801f2c896bd09f1$var$LMSplitOnly(mkSplit(v32.childl)(v32.childr)), st.lm);
                            return $391;
                        }());
                    }))(function() {
                        return $a801f2c896bd09f1$var$pure24($a801f2c896bd09f1$var$map33($a801f2c896bd09f1$var$nothingMore)(new $a801f2c896bd09f1$var$Cons(v32.childl, new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(v32.childr)(v22.seg.rslice), $a801f2c896bd09f1$var$Nil.value))));
                    });
                };
            };
        };
        var splitRight = function(v1) {
            return function(v22) {
                return function(v32) {
                    return function(v4) {
                        return $a801f2c896bd09f1$var$discard23(modifyEither(function(st) {
                            return new $a801f2c896bd09f1$var$Right(function() {
                                var $401 = {};
                                for(var $402 in st)if (({}).hasOwnProperty.call(st, $402)) $401[$402] = st[$402];
                                $401.lm = new $a801f2c896bd09f1$var$Cons(new $a801f2c896bd09f1$var$LMSplitRight(mkSplit(v4.childl)(v4.childr)), st.lm);
                                return $401;
                            }());
                        }))(function() {
                            return $a801f2c896bd09f1$var$pure24($a801f2c896bd09f1$var$map33($a801f2c896bd09f1$var$nothingMore)(new $a801f2c896bd09f1$var$Cons(v4.childl, new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(v4.childr)(v32.seg.rslice), $a801f2c896bd09f1$var$Nil.value))));
                        });
                    };
                };
            };
        };
        var freezeOnly = function(_lSlice) {
            return function(v1) {
                return modifyEither(function(st) {
                    if (st.piece instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left("Piece and reduction do not fit together: piece is too short!");
                    if (st.piece instanceof $a801f2c896bd09f1$var$Cons) return new $a801f2c896bd09f1$var$Right(function() {
                        var $410 = {};
                        for(var $411 in st)if (({}).hasOwnProperty.call(st, $411)) $410[$411] = st[$411];
                        $410.lm = new $a801f2c896bd09f1$var$Cons(new $a801f2c896bd09f1$var$LMFreezeOnly(mkFreeze(v1.seg)(st.piece.value0.time)), st.lm);
                        $410.piece = st.piece.value1;
                        return $410;
                    }());
                    throw new Error("Failed pattern match at ProtoVoices.Folding (line 348, column 27 - line 350, column 123): " + [
                        st.piece.constructor.name
                    ]);
                });
            };
        };
        var freezeLeft = function(_lSlice) {
            return function(v1) {
                return modifyEither(function(st) {
                    if (st.piece instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left("Piece and reduction do not fit together: piece is too short!");
                    if (st.piece instanceof $a801f2c896bd09f1$var$Cons) return new $a801f2c896bd09f1$var$Right(function() {
                        var $419 = {};
                        for(var $420 in st)if (({}).hasOwnProperty.call(st, $420)) $419[$420] = st[$420];
                        $419.lm = new $a801f2c896bd09f1$var$Cons(new $a801f2c896bd09f1$var$LMFreezeLeft(mkFreeze(v1.seg)(st.piece.value0.time)), st.lm);
                        $419.piece = st.piece.value1;
                        return $419;
                    }());
                    throw new Error("Failed pattern match at ProtoVoices.Folding (line 353, column 27 - line 355, column 123): " + [
                        st.piece.constructor.name
                    ]);
                });
            };
        };
        return {
            init: function(v1) {
                return $a801f2c896bd09f1$var$pure24($a801f2c896bd09f1$var$unit);
            },
            freezeOnly: freezeOnly,
            freezeLeft: freezeLeft,
            splitOnly: splitOnly,
            splitLeft: splitLeft,
            splitRight: splitRight,
            hori: hori
        };
    }();
    var agenda = $a801f2c896bd09f1$var$map33($a801f2c896bd09f1$var$nothingMore)(v3.reduction.segments);
    return $a801f2c896bd09f1$var$bind23($a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$execState)(new $a801f2c896bd09f1$var$Right({
        lm: $a801f2c896bd09f1$var$Nil.value,
        piece: new $a801f2c896bd09f1$var$Cons({
            time: new $a801f2c896bd09f1$var$Left(""),
            notes: []
        }, $a801f2c896bd09f1$var$fromFoldable12(v3.piece))
    }))($a801f2c896bd09f1$var$walkGraph(lmAlg)(v3.reduction.start)(agenda)))(function(st$prime) {
        return $a801f2c896bd09f1$var$pure18($a801f2c896bd09f1$var$reverse2($a801f2c896bd09f1$var$fromFoldable32(st$prime.lm)));
    });
};
var $a801f2c896bd09f1$var$emptyGraph = /* @__PURE__ */ function() {
    return {
        slices: $a801f2c896bd09f1$var$empty3,
        transitions: $a801f2c896bd09f1$var$empty3,
        horis: $a801f2c896bd09f1$var$Nil.value,
        maxd: 0,
        maxx: 0,
        currentDepth: 0
    };
}();
var $a801f2c896bd09f1$var$addUnusedEdgesRight = function(lslice) {
    return function(segr) {
        var edges$prime = $a801f2c896bd09f1$var$append33(segr.trans.edges)($a801f2c896bd09f1$var$fold3($a801f2c896bd09f1$var$map113($a801f2c896bd09f1$var$explRightEdge)($a801f2c896bd09f1$var$getInnerNotes(lslice))));
        return {
            rslice: segr.rslice,
            op: segr.op,
            trans: {
                id: segr.trans.id,
                is2nd: segr.trans.is2nd,
                edges: edges$prime
            }
        };
    };
};
var $a801f2c896bd09f1$var$addUnusedEdgesLeft = function(segl) {
    var edges$prime = $a801f2c896bd09f1$var$append33(segl.trans.edges)($a801f2c896bd09f1$var$fold3($a801f2c896bd09f1$var$map113($a801f2c896bd09f1$var$explLeftEdge)($a801f2c896bd09f1$var$getInnerNotes(segl.rslice))));
    return {
        rslice: segl.rslice,
        op: segl.op,
        trans: {
            id: segl.trans.id,
            is2nd: segl.trans.is2nd,
            edges: edges$prime
        }
    };
};
var $a801f2c896bd09f1$var$findSurface = function(showAllEdges) {
    return function(red) {
        var split3 = function(ag) {
            return function(v3) {
                var segLeft = function() {
                    if (showAllEdges) return $a801f2c896bd09f1$var$addUnusedEdgesLeft(v3.childl);
                    return v3.childl;
                }();
                var childr$prime = $a801f2c896bd09f1$var$attachSegment(v3.childr)(ag.seg.rslice);
                var segRight = function() {
                    if (showAllEdges) return $a801f2c896bd09f1$var$addUnusedEdgesRight(v3.childl.rslice)(childr$prime);
                    return childr$prime;
                }();
                return $a801f2c896bd09f1$var$pure24($a801f2c896bd09f1$var$map33($a801f2c896bd09f1$var$nothingMore)(new $a801f2c896bd09f1$var$Cons(segLeft, new $a801f2c896bd09f1$var$Cons(segRight, $a801f2c896bd09f1$var$Nil.value))));
            };
        };
        var hori = function(v3) {
            return function(ag1) {
                return function(ag2) {
                    return function(v1) {
                        var childr$prime = function() {
                            var v22 = $a801f2c896bd09f1$var$attachSegment(v1.childr)(ag2.seg.rslice);
                            return {
                                op: v22.op,
                                rslice: v22.rslice,
                                trans: {
                                    id: v22.trans.id,
                                    is2nd: v22.trans.is2nd,
                                    edges: $a801f2c896bd09f1$var$horiEdgesRight(v1.childm.rslice)(ag2.seg.trans.edges)
                                }
                            };
                        }();
                        var childl$prime = {
                            rslice: v1.childl.rslice,
                            op: v1.childl.op,
                            trans: {
                                id: v1.childl.trans.id,
                                is2nd: v1.childl.trans.is2nd,
                                edges: $a801f2c896bd09f1$var$horiEdgesLeft(ag1.seg.trans.edges)(v1.childl.rslice)
                            }
                        };
                        return $a801f2c896bd09f1$var$pure24($a801f2c896bd09f1$var$map33($a801f2c896bd09f1$var$nothingMore)(new $a801f2c896bd09f1$var$Cons(childl$prime, new $a801f2c896bd09f1$var$Cons(v1.childm, new $a801f2c896bd09f1$var$Cons(childr$prime, $a801f2c896bd09f1$var$Nil.value)))));
                    };
                };
            };
        };
        var freeze = function(_lslice) {
            return function(ag) {
                return $a801f2c896bd09f1$var$modify_1(function(st) {
                    return {
                        slices: $a801f2c896bd09f1$var$snoc2(st.slices)(ag.seg.rslice),
                        transs: $a801f2c896bd09f1$var$snoc2(st.transs)(ag.seg.trans)
                    };
                });
            };
        };
        var surfaceAlg = {
            init: function(s2) {
                return $a801f2c896bd09f1$var$modify_1(function(st) {
                    var $440 = {};
                    for(var $441 in st)if (({}).hasOwnProperty.call(st, $441)) $440[$441] = st[$441];
                    $440.slices = $a801f2c896bd09f1$var$snoc2(st.slices)(s2);
                    return $440;
                });
            },
            freezeLeft: freeze,
            freezeOnly: freeze,
            splitLeft: function(v3) {
                return split3;
            },
            splitOnly: function(v3) {
                return split3;
            },
            splitRight: function(v3) {
                return function(v1) {
                    return split3;
                };
            },
            hori: hori
        };
        var agenda = $a801f2c896bd09f1$var$map33($a801f2c896bd09f1$var$nothingMore)(red.segments);
        return $a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$execState)({
            slices: [],
            transs: []
        })($a801f2c896bd09f1$var$walkGraph(surfaceAlg)(red.start)(agenda));
    };
};
var $a801f2c896bd09f1$var$addHoriEdge = function(v3) {
    return function(v1) {
        return $a801f2c896bd09f1$var$modify_1(function(st) {
            var $445 = {};
            for(var $446 in st)if (({}).hasOwnProperty.call(st, $446)) $445[$446] = st[$446];
            $445.horis = new $a801f2c896bd09f1$var$Cons({
                child: v3.id,
                parent: v1.id
            }, st.horis);
            return $445;
        });
    };
};
var $a801f2c896bd09f1$var$addGraphTrans = function(il) {
    return function(v3) {
        return function(ir) {
            return $a801f2c896bd09f1$var$modify_1(function(st) {
                var $453 = {};
                for(var $454 in st)if (({}).hasOwnProperty.call(st, $454)) $453[$454] = st[$454];
                $453.transitions = $a801f2c896bd09f1$var$insert9(v3.id)({
                    left: il,
                    right: ir,
                    id: v3.id,
                    edges: v3.edges
                })(st.transitions);
                return $453;
            });
        };
    };
};
var $a801f2c896bd09f1$var$addGraphSlice = function(slice4) {
    return function(depth) {
        var gslice = {
            depth: depth,
            slice: slice4
        };
        var add1 = function(st) {
            var $458 = {};
            for(var $459 in st)if (({}).hasOwnProperty.call(st, $459)) $458[$459] = st[$459];
            $458.maxd = $a801f2c896bd09f1$var$max22(depth)(st.maxd);
            $458.maxx = $a801f2c896bd09f1$var$max22(slice4.x)(st.maxx);
            $458.slices = $a801f2c896bd09f1$var$insert1(slice4.id)(gslice)(st.slices);
            return $458;
        };
        return $a801f2c896bd09f1$var$modify_1(add1);
    };
};
var $a801f2c896bd09f1$var$graphAlg = function(flatHori) {
    return function(showAllEdges) {
        var split3 = function(lSlice) {
            return function(lDepth) {
                return function(item2) {
                    return function(v3) {
                        return $a801f2c896bd09f1$var$discard23($a801f2c896bd09f1$var$addGraphTrans(lSlice.id)(item2.seg.trans)(item2.seg.rslice.id))(function() {
                            var childr$prime = $a801f2c896bd09f1$var$attachSegment(v3.childr)(item2.seg.rslice);
                            return $a801f2c896bd09f1$var$pure24(new $a801f2c896bd09f1$var$Cons({
                                seg: function() {
                                    if (showAllEdges) return $a801f2c896bd09f1$var$addUnusedEdgesLeft(v3.childl);
                                    return v3.childl;
                                }(),
                                more: {
                                    rdepth: $a801f2c896bd09f1$var$max22(lDepth)(item2.more.rdepth) + 1
                                }
                            }, new $a801f2c896bd09f1$var$Cons({
                                seg: function() {
                                    if (showAllEdges) return $a801f2c896bd09f1$var$addUnusedEdgesRight(v3.childl.rslice)(childr$prime);
                                    return childr$prime;
                                }(),
                                more: {
                                    rdepth: item2.more.rdepth
                                }
                            }, $a801f2c896bd09f1$var$Nil.value)));
                        });
                    };
                };
            };
        };
        var splitRight = function(v3) {
            return function(left) {
                return function(right) {
                    return function(splitop) {
                        return split3(left.seg.rslice)(left.more.rdepth)(right)(splitop);
                    };
                };
            };
        };
        var splitTrans = function(lSlice) {
            return function(item2) {
                return function(splitop) {
                    return $a801f2c896bd09f1$var$bind33($a801f2c896bd09f1$var$gets2(function(v3) {
                        return v3.currentDepth;
                    }))(function(lDepth) {
                        return split3(lSlice)(lDepth)(item2)(splitop);
                    });
                };
            };
        };
        var init3 = function(start2) {
            return $a801f2c896bd09f1$var$addGraphSlice(start2)(0);
        };
        var hori = function(lSlice) {
            return function(left) {
                return function(right) {
                    return function(v3) {
                        return $a801f2c896bd09f1$var$bind33($a801f2c896bd09f1$var$gets2(function(v1) {
                            return v1.currentDepth;
                        }))(function(currentDepth) {
                            return $a801f2c896bd09f1$var$discard23($a801f2c896bd09f1$var$addGraphTrans(lSlice.id)(left.seg.trans)(left.seg.rslice.id))(function() {
                                return $a801f2c896bd09f1$var$discard23($a801f2c896bd09f1$var$addGraphSlice(left.seg.rslice)(left.more.rdepth))(function() {
                                    return $a801f2c896bd09f1$var$discard23($a801f2c896bd09f1$var$addHoriEdge(v3.childl.rslice)(left.seg.rslice))(function() {
                                        return $a801f2c896bd09f1$var$discard23($a801f2c896bd09f1$var$addHoriEdge(v3.childm.rslice)(left.seg.rslice))(function() {
                                            return $a801f2c896bd09f1$var$discard23($a801f2c896bd09f1$var$addGraphTrans(left.seg.rslice.id)(right.seg.trans)(right.seg.rslice.id))(function() {
                                                var dsub = function() {
                                                    if (flatHori) return left.more.rdepth + 1;
                                                    return $a801f2c896bd09f1$var$max22(currentDepth)($a801f2c896bd09f1$var$max22(left.more.rdepth)(right.more.rdepth)) + 1;
                                                }();
                                                var childr$prime = $a801f2c896bd09f1$var$attachSegment(v3.childr)(right.seg.rslice);
                                                return $a801f2c896bd09f1$var$pure24(new $a801f2c896bd09f1$var$Cons({
                                                    seg: function() {
                                                        if (showAllEdges) return {
                                                            rslice: v3.childl.rslice,
                                                            op: v3.childl.op,
                                                            trans: {
                                                                id: v3.childl.trans.id,
                                                                is2nd: v3.childl.trans.is2nd,
                                                                edges: $a801f2c896bd09f1$var$horiEdgesLeft(left.seg.trans.edges)(v3.childl.rslice)
                                                            }
                                                        };
                                                        return v3.childl;
                                                    }(),
                                                    more: {
                                                        rdepth: dsub
                                                    }
                                                }, new $a801f2c896bd09f1$var$Cons({
                                                    seg: function() {
                                                        if (showAllEdges) return {
                                                            rslice: v3.childm.rslice,
                                                            op: v3.childm.op,
                                                            trans: {
                                                                id: v3.childm.trans.id,
                                                                is2nd: v3.childm.trans.is2nd,
                                                                edges: $a801f2c896bd09f1$var$horiEdgesMid(v3.childl.rslice)(v3.childm.trans.edges)(v3.childm.rslice)
                                                            }
                                                        };
                                                        return v3.childm;
                                                    }(),
                                                    more: {
                                                        rdepth: dsub
                                                    }
                                                }, new $a801f2c896bd09f1$var$Cons({
                                                    seg: function() {
                                                        if (showAllEdges) return {
                                                            op: childr$prime.op,
                                                            rslice: childr$prime.rslice,
                                                            trans: {
                                                                id: childr$prime.trans.id,
                                                                is2nd: childr$prime.trans.is2nd,
                                                                edges: $a801f2c896bd09f1$var$horiEdgesRight(v3.childm.rslice)(right.seg.trans.edges)
                                                            }
                                                        };
                                                        return childr$prime;
                                                    }(),
                                                    more: {
                                                        rdepth: right.more.rdepth
                                                    }
                                                }, $a801f2c896bd09f1$var$Nil.value))));
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    };
                };
            };
        };
        var freezeTrans = function(lSlice) {
            return function(item2) {
                return $a801f2c896bd09f1$var$discard23($a801f2c896bd09f1$var$addGraphTrans(lSlice.id)(item2.seg.trans)(item2.seg.rslice.id))(function() {
                    return $a801f2c896bd09f1$var$discard23($a801f2c896bd09f1$var$addGraphSlice(item2.seg.rslice)(item2.more.rdepth))(function() {
                        return $a801f2c896bd09f1$var$modify_1(function(st) {
                            var $480 = {};
                            for(var $481 in st)if (({}).hasOwnProperty.call(st, $481)) $480[$481] = st[$481];
                            $480.currentDepth = item2.more.rdepth;
                            return $480;
                        });
                    });
                });
            };
        };
        return {
            init: init3,
            freezeOnly: freezeTrans,
            freezeLeft: freezeTrans,
            splitOnly: splitTrans,
            splitLeft: splitTrans,
            splitRight: splitRight,
            hori: hori
        };
    };
};
var $a801f2c896bd09f1$var$evalGraph = function(flatHori) {
    return function(showAllEdges) {
        return function(reduction) {
            var agenda = $a801f2c896bd09f1$var$map33(function(seg) {
                return {
                    seg: seg,
                    more: {
                        rdepth: 0
                    }
                };
            })(reduction.segments);
            return $a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$execState)($a801f2c896bd09f1$var$emptyGraph)($a801f2c896bd09f1$var$walkGraph($a801f2c896bd09f1$var$graphAlg(flatHori)(showAllEdges))(reduction.start)(agenda));
        };
    };
};
// output/ProtoVoices.JSONTransport/index.js
var $a801f2c896bd09f1$var$map29 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$lmap2 = /* @__PURE__ */ $a801f2c896bd09f1$var$lmap($a801f2c896bd09f1$var$bifunctorTuple);
var $a801f2c896bd09f1$var$show9 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$fromFoldableWithIndex3 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldableWithIndex($a801f2c896bd09f1$var$foldableWithIndexMap);
var $a801f2c896bd09f1$var$toUnfoldable7 = /* @__PURE__ */ $a801f2c896bd09f1$var$toUnfoldable4($a801f2c896bd09f1$var$unfoldableArray);
var $a801f2c896bd09f1$var$fromFoldable8 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable3($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$bind17 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindEither);
var $a801f2c896bd09f1$var$pure19 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$traverse2 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse($a801f2c896bd09f1$var$traversableArray)($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$map114 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEither);
var $a801f2c896bd09f1$var$fromFoldable13 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable4($a801f2c896bd09f1$var$ordSliceId)($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$toUnfoldable14 = /* @__PURE__ */ $a801f2c896bd09f1$var$toUnfoldable3($a801f2c896bd09f1$var$unfoldableArray);
var $a801f2c896bd09f1$var$fromFoldable23 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable4($a801f2c896bd09f1$var$ordTransId)($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$fromFoldableWithIndex1 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldableWithIndex2($a801f2c896bd09f1$var$ordString)($a801f2c896bd09f1$var$foldableWithIndexObject);
var $a801f2c896bd09f1$var$fromFoldable33 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable4(/* @__PURE__ */ $a801f2c896bd09f1$var$ordTuple($a801f2c896bd09f1$var$ordString)($a801f2c896bd09f1$var$ordString))($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$map210 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$show14 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showDoubleOrnament);
var $a801f2c896bd09f1$var$show25 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showRightOrnament);
var $a801f2c896bd09f1$var$show32 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showLeftOrnament);
var $a801f2c896bd09f1$var$show43 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval));
var $a801f2c896bd09f1$var$identity12 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$show52 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showMBS);
var $a801f2c896bd09f1$var$$$for3 = /* @__PURE__ */ $a801f2c896bd09f1$var$$$for($a801f2c896bd09f1$var$applicativeMaybe)($a801f2c896bd09f1$var$traversableArray);
var $a801f2c896bd09f1$var$bind18 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$parseNotation2 = /* @__PURE__ */ $a801f2c896bd09f1$var$parseNotation(/* @__PURE__ */ $a801f2c896bd09f1$var$notationPitch($a801f2c896bd09f1$var$notationPitchSInterval));
var $a801f2c896bd09f1$var$pure110 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeMaybe);
var $a801f2c896bd09f1$var$discard5 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit);
var $a801f2c896bd09f1$var$sequence4 = /* @__PURE__ */ $a801f2c896bd09f1$var$sequence($a801f2c896bd09f1$var$traversableArray);
var $a801f2c896bd09f1$var$sequence12 = /* @__PURE__ */ $a801f2c896bd09f1$var$sequence4($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$bind24 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind(/* @__PURE__ */ $a801f2c896bd09f1$var$bindStateT($a801f2c896bd09f1$var$monadEither));
var $a801f2c896bd09f1$var$lift4 = /* @__PURE__ */ $a801f2c896bd09f1$var$lift($a801f2c896bd09f1$var$monadTransStateT)($a801f2c896bd09f1$var$monadEither);
var $a801f2c896bd09f1$var$ordRecord4 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord();
var $a801f2c896bd09f1$var$ordRecordCons4 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons($a801f2c896bd09f1$var$ordRecordNil)();
var $a801f2c896bd09f1$var$ordRecord13 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord4(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons4({
    reflectSymbol: function() {
        return "pitch";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$ordPitch($a801f2c896bd09f1$var$ordSInterval)))()({
    reflectSymbol: function() {
        return "id";
    }
})($a801f2c896bd09f1$var$ordString));
var $a801f2c896bd09f1$var$ordStartStop3 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordStartStop($a801f2c896bd09f1$var$ordRecord13);
var $a801f2c896bd09f1$var$ordRecord23 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord4(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons4({
    reflectSymbol: function() {
        return "right";
    }
})($a801f2c896bd09f1$var$ordStartStop3))()({
    reflectSymbol: function() {
        return "left";
    }
})($a801f2c896bd09f1$var$ordStartStop3));
var $a801f2c896bd09f1$var$fromFoldable42 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable4($a801f2c896bd09f1$var$ordRecord23)($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$fromFoldable52 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable4($a801f2c896bd09f1$var$ordRecord13)($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$applicativeStateT2 = /* @__PURE__ */ $a801f2c896bd09f1$var$applicativeStateT($a801f2c896bd09f1$var$monadEither);
var $a801f2c896bd09f1$var$pure25 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeStateT2);
var $a801f2c896bd09f1$var$on4 = /* @__PURE__ */ $a801f2c896bd09f1$var$on2();
var $a801f2c896bd09f1$var$tooManyChildrenIsSymbol = {
    reflectSymbol: function() {
        return "tooManyChildren";
    }
};
var $a801f2c896bd09f1$var$on1 = /* @__PURE__ */ $a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$tooManyChildrenIsSymbol);
var $a801f2c896bd09f1$var$bothChildrenIsSymbol = {
    reflectSymbol: function() {
        return "bothChildren";
    }
};
var $a801f2c896bd09f1$var$on22 = /* @__PURE__ */ $a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$bothChildrenIsSymbol);
var $a801f2c896bd09f1$var$rightChildIsSymbol = {
    reflectSymbol: function() {
        return "rightChild";
    }
};
var $a801f2c896bd09f1$var$on32 = /* @__PURE__ */ $a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$rightChildIsSymbol);
var $a801f2c896bd09f1$var$leftChildIsSymbol = {
    reflectSymbol: function() {
        return "leftChild";
    }
};
var $a801f2c896bd09f1$var$on42 = /* @__PURE__ */ $a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$leftChildIsSymbol);
var $a801f2c896bd09f1$var$fromFoldable62 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable5($a801f2c896bd09f1$var$foldableArray)($a801f2c896bd09f1$var$ordRecord23);
var $a801f2c896bd09f1$var$freezeOnlyIsSymbol = {
    reflectSymbol: function() {
        return "freezeOnly";
    }
};
var $a801f2c896bd09f1$var$map34 = /* @__PURE__ */ $a801f2c896bd09f1$var$map(/* @__PURE__ */ $a801f2c896bd09f1$var$functorStateT($a801f2c896bd09f1$var$functorEither));
var $a801f2c896bd09f1$var$freezeLeftIsSymbol = {
    reflectSymbol: function() {
        return "freezeLeft";
    }
};
var $a801f2c896bd09f1$var$horiIsSymbol = {
    reflectSymbol: function() {
        return "hori";
    }
};
var $a801f2c896bd09f1$var$splitRightIsSymbol = {
    reflectSymbol: function() {
        return "splitRight";
    }
};
var $a801f2c896bd09f1$var$splitOnlyIsSymbol = {
    reflectSymbol: function() {
        return "splitOnly";
    }
};
var $a801f2c896bd09f1$var$splitLeftIsSymbol = {
    reflectSymbol: function() {
        return "splitLeft";
    }
};
var $a801f2c896bd09f1$var$evalStateT2 = /* @__PURE__ */ $a801f2c896bd09f1$var$evalStateT($a801f2c896bd09f1$var$functorEither);
var $a801f2c896bd09f1$var$sequence22 = /* @__PURE__ */ $a801f2c896bd09f1$var$sequence4($a801f2c896bd09f1$var$applicativeStateT2);
var $a801f2c896bd09f1$var$fromFoldable72 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableSet);
var $a801f2c896bd09f1$var$inj3 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj();
var $a801f2c896bd09f1$var$inj1 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$leftChildIsSymbol);
var $a801f2c896bd09f1$var$inj22 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$rightChildIsSymbol);
var $a801f2c896bd09f1$var$inj32 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$bothChildrenIsSymbol);
var $a801f2c896bd09f1$var$inj4 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$tooManyChildrenIsSymbol);
var $a801f2c896bd09f1$var$inj5 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$freezeLeftIsSymbol);
var $a801f2c896bd09f1$var$inj6 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$freezeOnlyIsSymbol);
var $a801f2c896bd09f1$var$inj7 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$splitLeftIsSymbol);
var $a801f2c896bd09f1$var$inj8 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$splitOnlyIsSymbol);
var $a801f2c896bd09f1$var$inj9 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$splitRightIsSymbol);
var $a801f2c896bd09f1$var$inj10 = /* @__PURE__ */ $a801f2c896bd09f1$var$inj3($a801f2c896bd09f1$var$horiIsSymbol);
var $a801f2c896bd09f1$var$map43 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorStartStop);
var $a801f2c896bd09f1$var$fromFoldable82 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$writeJSONPretty = function(dictWriteForeign) {
    var $337 = $a801f2c896bd09f1$var$writeImpl(dictWriteForeign);
    return function($338) {
        return $a801f2c896bd09f1$var$unsafeStringifyPretty($337($338));
    };
};
var $a801f2c896bd09f1$var$stylesToJSON = function(v3) {
    var unwrapTransitions = $a801f2c896bd09f1$var$map29($a801f2c896bd09f1$var$lmap2(function(v1) {
        return $a801f2c896bd09f1$var$show9(v1);
    }));
    var unwrapSlices = $a801f2c896bd09f1$var$map29($a801f2c896bd09f1$var$lmap2(function(v1) {
        return $a801f2c896bd09f1$var$show9(v1);
    }));
    var unwrapEdge = function(v1) {
        return {
            edge: {
                left: v1.value0.value0,
                right: v1.value0.value1
            },
            style: v1.value1
        };
    };
    return {
        noteStyles: $a801f2c896bd09f1$var$fromFoldableWithIndex3(v3.notes),
        edgeStyles: $a801f2c896bd09f1$var$map29(unwrapEdge)($a801f2c896bd09f1$var$toUnfoldable7(v3.edges)),
        sliceStyles: $a801f2c896bd09f1$var$fromFoldable8(unwrapSlices($a801f2c896bd09f1$var$toUnfoldable7(v3.slices))),
        transStyles: $a801f2c896bd09f1$var$fromFoldable8(unwrapTransitions($a801f2c896bd09f1$var$toUnfoldable7(v3.transitions))),
        css: v3.css,
        staffType: function() {
            if (v3.staff instanceof $a801f2c896bd09f1$var$TrebleStaff) return "treble";
            if (v3.staff instanceof $a801f2c896bd09f1$var$BassStaff) return "bass";
            if (v3.staff instanceof $a801f2c896bd09f1$var$GrandStaff) return "grand";
            throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 148, column 16 - line 151, column 28): " + [
                v3.staff.constructor.name
            ]);
        }()
    };
};
var $a801f2c896bd09f1$var$stylesFromJSON = function(v3) {
    var wrapEdges = function(v1) {
        return new $a801f2c896bd09f1$var$Tuple(new $a801f2c896bd09f1$var$Tuple(v1.edge.left, v1.edge.right), v1.style);
    };
    var readId = function(constructor) {
        var parse7 = function(v1) {
            return $a801f2c896bd09f1$var$bind17($a801f2c896bd09f1$var$maybe(new $a801f2c896bd09f1$var$Left("cannot parse " + (v1.value0 + "as integer.")))($a801f2c896bd09f1$var$Right.create)($a801f2c896bd09f1$var$fromString2(v1.value0)))(function(id$prime) {
                return $a801f2c896bd09f1$var$pure19(new $a801f2c896bd09f1$var$Tuple(constructor(id$prime), v1.value1));
            });
        };
        return $a801f2c896bd09f1$var$traverse2(parse7);
    };
    return $a801f2c896bd09f1$var$bind17($a801f2c896bd09f1$var$map114($a801f2c896bd09f1$var$fromFoldable13)(readId($a801f2c896bd09f1$var$SliceId)($a801f2c896bd09f1$var$toUnfoldable14(v3.sliceStyles))))(function(slices) {
        return $a801f2c896bd09f1$var$bind17($a801f2c896bd09f1$var$map114($a801f2c896bd09f1$var$fromFoldable23)(readId($a801f2c896bd09f1$var$TransId)($a801f2c896bd09f1$var$toUnfoldable14(v3.transStyles))))(function(transitions) {
            return $a801f2c896bd09f1$var$bind17(function() {
                if (v3.staffType === "treble") return $a801f2c896bd09f1$var$pure19($a801f2c896bd09f1$var$TrebleStaff.value);
                if (v3.staffType === "bass") return $a801f2c896bd09f1$var$pure19($a801f2c896bd09f1$var$BassStaff.value);
                if (v3.staffType === "grand") return $a801f2c896bd09f1$var$pure19($a801f2c896bd09f1$var$GrandStaff.value);
                return new $a801f2c896bd09f1$var$Left("Unexpected staff type: " + (v3.staffType + " (expected treble, bass, or grand)."));
            }())(function(staff) {
                return $a801f2c896bd09f1$var$pure19({
                    notes: $a801f2c896bd09f1$var$fromFoldableWithIndex1(v3.noteStyles),
                    edges: $a801f2c896bd09f1$var$fromFoldable33($a801f2c896bd09f1$var$map29(wrapEdges)(v3.edgeStyles)),
                    slices: slices,
                    transitions: transitions,
                    css: v3.css,
                    staff: staff
                });
            });
        });
    });
};
var $a801f2c896bd09f1$var$stripJSONIds = /* @__PURE__ */ $a801f2c896bd09f1$var$map29(function(v3) {
    return {
        time: v3.time,
        notes: $a801f2c896bd09f1$var$map29(function(v1) {
            return {
                hold: v1.hold,
                pitch: v1.pitch
            };
        })(v3.notes)
    };
});
var $a801f2c896bd09f1$var$splitToJSON = function(v3) {
    var unwrap5 = function(f2) {
        return function(v1) {
            return {
                parent: v1.value0,
                children: $a801f2c896bd09f1$var$map29(function(v22) {
                    return {
                        child: v22.child,
                        orn: f2(v22.orn)
                    };
                })(v1.value1)
            };
        };
    };
    var regToJSON = function(v1) {
        if (v1 instanceof $a801f2c896bd09f1$var$Left) return new $a801f2c896bd09f1$var$Just("RootNote");
        if (v1 instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$map210($a801f2c896bd09f1$var$show14)(v1.value0);
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 199, column 15 - line 201, column 26): " + [
            v1.constructor.name
        ]);
    };
    return {
        regular: $a801f2c896bd09f1$var$map29(unwrap5(regToJSON))($a801f2c896bd09f1$var$toUnfoldable7(v3.regular)),
        passing: $a801f2c896bd09f1$var$map29(unwrap5($a801f2c896bd09f1$var$map210($a801f2c896bd09f1$var$show14)))($a801f2c896bd09f1$var$toUnfoldable7(v3.passing)),
        fromLeft: $a801f2c896bd09f1$var$map29(unwrap5($a801f2c896bd09f1$var$map210($a801f2c896bd09f1$var$show25)))($a801f2c896bd09f1$var$toUnfoldable7(v3.fromLeft)),
        fromRight: $a801f2c896bd09f1$var$map29(unwrap5($a801f2c896bd09f1$var$map210($a801f2c896bd09f1$var$show32)))($a801f2c896bd09f1$var$toUnfoldable7(v3.fromRight)),
        unexplained: new $a801f2c896bd09f1$var$Just(v3.unexplained),
        keepLeft: v3.keepLeft,
        keepRight: v3.keepRight,
        passLeft: v3.passLeft,
        passRight: v3.passRight,
        ids: new $a801f2c896bd09f1$var$Just(v3.ids)
    };
};
var $a801f2c896bd09f1$var$pieceToJSON = /* @__PURE__ */ function() {
    var noteToJSON = function(v3) {
        return {
            hold: v3.hold,
            id: v3.note.id,
            pitch: $a801f2c896bd09f1$var$show43(v3.note.pitch)
        };
    };
    return $a801f2c896bd09f1$var$map29(function(v3) {
        return {
            time: $a801f2c896bd09f1$var$either($a801f2c896bd09f1$var$identity12)($a801f2c896bd09f1$var$show52)(v3.time),
            notes: $a801f2c896bd09f1$var$map29(noteToJSON)(v3.notes)
        };
    });
}();
var $a801f2c896bd09f1$var$pieceFromJSON = function(piece) {
    return $a801f2c896bd09f1$var$$$for3(piece)(function(slice4) {
        return $a801f2c896bd09f1$var$bind18($a801f2c896bd09f1$var$$$for3(slice4.notes)(function(note2) {
            return $a801f2c896bd09f1$var$map210(function(p3) {
                return {
                    hold: note2.hold,
                    note: {
                        pitch: p3,
                        id: note2.id
                    }
                };
            })($a801f2c896bd09f1$var$parseNotation2(note2.pitch));
        }))(function(notes) {
            return $a801f2c896bd09f1$var$pure110({
                time: $a801f2c896bd09f1$var$parseTime(slice4.time),
                notes: $a801f2c896bd09f1$var$sortNotes(notes)
            });
        });
    });
};
var $a801f2c896bd09f1$var$newTId = function(dictMonad) {
    var bindStateT3 = $a801f2c896bd09f1$var$bindStateT(dictMonad);
    var monadStateStateT3 = $a801f2c896bd09f1$var$monadStateStateT(dictMonad);
    var discard15 = $a801f2c896bd09f1$var$discard5(bindStateT3);
    var put4 = $a801f2c896bd09f1$var$put(monadStateStateT3);
    var pure310 = $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeStateT(dictMonad));
    return $a801f2c896bd09f1$var$bind(bindStateT3)($a801f2c896bd09f1$var$get(monadStateStateT3))(function(v3) {
        return discard15(put4({
            nextT: v3.nextT + 1 | 0,
            nextS: v3.nextS
        }))(function() {
            return pure310(v3.nextT);
        });
    });
};
var $a801f2c896bd09f1$var$newTId1 = /* @__PURE__ */ $a801f2c896bd09f1$var$newTId($a801f2c896bd09f1$var$monadEither);
var $a801f2c896bd09f1$var$newSId = function(dictMonad) {
    var bindStateT3 = $a801f2c896bd09f1$var$bindStateT(dictMonad);
    var monadStateStateT3 = $a801f2c896bd09f1$var$monadStateStateT(dictMonad);
    var discard15 = $a801f2c896bd09f1$var$discard5(bindStateT3);
    var put4 = $a801f2c896bd09f1$var$put(monadStateStateT3);
    var pure310 = $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeStateT(dictMonad));
    return $a801f2c896bd09f1$var$bind(bindStateT3)($a801f2c896bd09f1$var$get(monadStateStateT3))(function(v3) {
        return discard15(put4({
            nextT: v3.nextT,
            nextS: v3.nextS + 1 | 0
        }))(function() {
            return pure310(v3.nextS);
        });
    });
};
var $a801f2c896bd09f1$var$newSId1 = /* @__PURE__ */ $a801f2c896bd09f1$var$newSId($a801f2c896bd09f1$var$monadEither);
var $a801f2c896bd09f1$var$splitFromJSON = function(v3) {
    var wrap3 = function(read4) {
        return function(v1) {
            var children$prime = $a801f2c896bd09f1$var$sequence12($a801f2c896bd09f1$var$map29(function(v22) {
                return $a801f2c896bd09f1$var$map114(function(v32) {
                    return {
                        child: v22.child,
                        orn: v32
                    };
                })(read4(v22.orn));
            })(v1.children));
            return $a801f2c896bd09f1$var$map114($a801f2c896bd09f1$var$Tuple.create(v1.parent))(children$prime);
        };
    };
    var readRightOrnament = function(v1) {
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "RightNeighbor") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$RightNeighbor.value));
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "RightRepeat") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$RightRepeat.value));
        if (v1 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Left("Expected right ornament type but got " + v1.value0);
        if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$Nothing.value);
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 328, column 23 - line 332, column 29): " + [
            v1.constructor.name
        ]);
    };
    var readPassingOrnament = function(v1) {
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "PassingMid") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingMid.value));
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "PassingLeft") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingLeft.value));
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "PassingRight") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingRight.value));
        if (v1 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Left("Expected passing ornament type but got " + v1.value0);
        if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$Nothing.value);
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 321, column 25 - line 326, column 29): " + [
            v1.constructor.name
        ]);
    };
    var readLeftOrnament = function(v1) {
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "LeftNeighbor") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$LeftNeighbor.value));
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "LeftRepeat") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$LeftRepeat.value));
        if (v1 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Left("Expected left ornament type but got " + v1.value0);
        if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$Nothing.value);
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 334, column 22 - line 338, column 29): " + [
            v1.constructor.name
        ]);
    };
    var readDoubleOrnament = function(v1) {
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "RootNote") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Left($a801f2c896bd09f1$var$RootNote.value));
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "FullRepeat") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$FullRepeat.value)));
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "FullNeighbor") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$FullNeighbor.value)));
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "LeftRepeatOfRight") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$LeftRepeatOfRight.value)));
        if (v1 instanceof $a801f2c896bd09f1$var$Just && v1.value0 === "RightRepeatOfLeft") return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$RightRepeatOfLeft.value)));
        if (v1 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Left("Expected double ornament type but got " + v1.value0);
        if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$Nothing.value));
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 312, column 24 - line 319, column 37): " + [
            v1.constructor.name
        ]);
    };
    return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$lift4($a801f2c896bd09f1$var$map114($a801f2c896bd09f1$var$fromFoldable42)($a801f2c896bd09f1$var$sequence12($a801f2c896bd09f1$var$map29(wrap3(readDoubleOrnament))(v3.regular)))))(function(regular) {
        return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$lift4($a801f2c896bd09f1$var$map114($a801f2c896bd09f1$var$fromFoldable42)($a801f2c896bd09f1$var$sequence12($a801f2c896bd09f1$var$map29(wrap3(readPassingOrnament))(v3.passing)))))(function(passing) {
            return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$lift4($a801f2c896bd09f1$var$map114($a801f2c896bd09f1$var$fromFoldable52)($a801f2c896bd09f1$var$sequence12($a801f2c896bd09f1$var$map29(wrap3(readRightOrnament))(v3.fromLeft)))))(function(fromLeft) {
                return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$lift4($a801f2c896bd09f1$var$map114($a801f2c896bd09f1$var$fromFoldable52)($a801f2c896bd09f1$var$sequence12($a801f2c896bd09f1$var$map29(wrap3(readLeftOrnament))(v3.fromRight)))))(function(fromRight) {
                    return $a801f2c896bd09f1$var$bind24(function() {
                        if (v3.ids instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$pure25(v3.ids.value0);
                        if (v3.ids instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$newTId1)(function(left) {
                            return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$newSId1)(function(slice4) {
                                return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$newTId1)(function(right) {
                                    return $a801f2c896bd09f1$var$pure25({
                                        left: left,
                                        slice: slice4,
                                        right: right
                                    });
                                });
                            });
                        });
                        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 280, column 10 - line 286, column 34): " + [
                            v3.ids.constructor.name
                        ]);
                    }())(function(ids) {
                        return $a801f2c896bd09f1$var$pure25({
                            regular: regular,
                            passing: passing,
                            fromLeft: fromLeft,
                            fromRight: fromRight,
                            unexplained: $a801f2c896bd09f1$var$fromMaybe([])(v3.unexplained),
                            keepLeft: v3.keepLeft,
                            keepRight: v3.keepRight,
                            passLeft: v3.passLeft,
                            passRight: v3.passRight,
                            ids: ids
                        });
                    });
                });
            });
        });
    });
};
var $a801f2c896bd09f1$var$horiFromJSON = function(v3) {
    var getDist = $a801f2c896bd09f1$var$on1($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$TooManyChildren.create)($a801f2c896bd09f1$var$on22($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$BothChildren.create)($a801f2c896bd09f1$var$on32($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$RightChild.create)($a801f2c896bd09f1$var$on42($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$LeftChild.create)($a801f2c896bd09f1$var$case_))));
    var childFromJSON = function(v1) {
        return new $a801f2c896bd09f1$var$Tuple(v1.parent, getDist(v1.child));
    };
    return $a801f2c896bd09f1$var$bind24(function() {
        if (v3.ids instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$pure25(v3.ids.value0);
        if (v3.ids instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$newTId1)(function(left) {
            return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$newSId1)(function(lslice) {
                return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$newTId1)(function(mid) {
                    return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$newSId1)(function(rslice) {
                        return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$newTId1)(function(right) {
                            return $a801f2c896bd09f1$var$pure25({
                                left: left,
                                lslice: lslice,
                                mid: mid,
                                rslice: rslice,
                                right: right
                            });
                        });
                    });
                });
            });
        });
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 342, column 10 - line 350, column 48): " + [
            v3.ids.constructor.name
        ]);
    }())(function(ids) {
        return $a801f2c896bd09f1$var$pure25({
            midEdges: {
                regular: $a801f2c896bd09f1$var$fromFoldable62(v3.midEdges.regular),
                passing: v3.midEdges.passing
            },
            children: $a801f2c896bd09f1$var$fromFoldable52($a801f2c896bd09f1$var$map29(childFromJSON)(v3.children)),
            ids: ids,
            unexplained: $a801f2c896bd09f1$var$fromMaybe({
                left: [],
                right: []
            })(v3.unexplained)
        });
    });
};
var $a801f2c896bd09f1$var$freezeToJSON = function(v3) {
    return {
        ties: v3.ties,
        prevTime: new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$either($a801f2c896bd09f1$var$identity12)($a801f2c896bd09f1$var$show52)(v3.prevTime))
    };
};
var $a801f2c896bd09f1$var$freezeFromJSON = function(v3) {
    return new $a801f2c896bd09f1$var$Right({
        ties: v3.ties,
        prevTime: $a801f2c896bd09f1$var$maybe(new $a801f2c896bd09f1$var$Left(""))($a801f2c896bd09f1$var$parseTime)(v3.prevTime)
    });
};
var $a801f2c896bd09f1$var$leftmostFromJSON = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$freezeOnlyIsSymbol)($a801f2c896bd09f1$var$$$Proxy.value)(function() {
        var $339 = $a801f2c896bd09f1$var$map34($a801f2c896bd09f1$var$LMFreezeOnly.create);
        return function($340) {
            return $339($a801f2c896bd09f1$var$lift4($a801f2c896bd09f1$var$freezeFromJSON($340)));
        };
    }())($a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$freezeLeftIsSymbol)($a801f2c896bd09f1$var$$$Proxy.value)(function() {
        var $341 = $a801f2c896bd09f1$var$map34($a801f2c896bd09f1$var$LMFreezeLeft.create);
        return function($342) {
            return $341($a801f2c896bd09f1$var$lift4($a801f2c896bd09f1$var$freezeFromJSON($342)));
        };
    }())($a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$horiIsSymbol)($a801f2c896bd09f1$var$$$Proxy.value)(function() {
        var $343 = $a801f2c896bd09f1$var$map34($a801f2c896bd09f1$var$LMHorizontalize.create);
        return function($344) {
            return $343($a801f2c896bd09f1$var$horiFromJSON($344));
        };
    }())($a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$splitRightIsSymbol)($a801f2c896bd09f1$var$$$Proxy.value)(function() {
        var $345 = $a801f2c896bd09f1$var$map34($a801f2c896bd09f1$var$LMSplitRight.create);
        return function($346) {
            return $345($a801f2c896bd09f1$var$splitFromJSON($346));
        };
    }())($a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$splitOnlyIsSymbol)($a801f2c896bd09f1$var$$$Proxy.value)(function() {
        var $347 = $a801f2c896bd09f1$var$map34($a801f2c896bd09f1$var$LMSplitOnly.create);
        return function($348) {
            return $347($a801f2c896bd09f1$var$splitFromJSON($348));
        };
    }())($a801f2c896bd09f1$var$on4($a801f2c896bd09f1$var$splitLeftIsSymbol)($a801f2c896bd09f1$var$$$Proxy.value)(function() {
        var $349 = $a801f2c896bd09f1$var$map34($a801f2c896bd09f1$var$LMSplitLeft.create);
        return function($350) {
            return $349($a801f2c896bd09f1$var$splitFromJSON($350));
        };
    }())($a801f2c896bd09f1$var$case_))))));
}();
var $a801f2c896bd09f1$var$modelFromJSON = function(v3) {
    var addSliceId = function(v1) {
        return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$maybe($a801f2c896bd09f1$var$newSId1)($a801f2c896bd09f1$var$pure25)(v1.rslice.id))(function(sid) {
            return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$maybe($a801f2c896bd09f1$var$newTId1)($a801f2c896bd09f1$var$pure25)(v1.trans.id))(function(tid) {
                return $a801f2c896bd09f1$var$pure25({
                    trans: {
                        edges: v1.trans.edges,
                        id: tid
                    },
                    rslice: {
                        notes: v1.rslice.notes,
                        id: sid
                    }
                });
            });
        });
    };
    return $a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$evalStateT2)({
        nextS: 1,
        nextT: 0
    })($a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$sequence22($a801f2c896bd09f1$var$map29($a801f2c896bd09f1$var$leftmostFromJSON)(v3.derivation)))(function(deriv) {
        return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$sequence22($a801f2c896bd09f1$var$map29(addSliceId)(v3.topSegments)))(function(topSegments$prime) {
            return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$lift4($a801f2c896bd09f1$var$leftmostToReduction(topSegments$prime)(deriv)))(function(v1) {
                return $a801f2c896bd09f1$var$bind24($a801f2c896bd09f1$var$lift4($a801f2c896bd09f1$var$maybe($a801f2c896bd09f1$var$pure19($a801f2c896bd09f1$var$emptyStyles))($a801f2c896bd09f1$var$stylesFromJSON)(v3.styles)))(function(parsedStyles) {
                    return $a801f2c896bd09f1$var$pure25({
                        piece: v1.piece,
                        reduction: v1.reduction,
                        styles: parsedStyles
                    });
                });
            });
        });
    }));
};
var $a801f2c896bd09f1$var$edgesToJSON = function(edges) {
    return {
        regular: $a801f2c896bd09f1$var$fromFoldable72(edges.regular),
        passing: edges.passing
    };
};
var $a801f2c896bd09f1$var$horiToJSON = function(v3) {
    var childToJSON = function(v1) {
        var child = function() {
            if (v1.value1 instanceof $a801f2c896bd09f1$var$LeftChild) return $a801f2c896bd09f1$var$inj1($a801f2c896bd09f1$var$$$Proxy.value)(v1.value1.value0);
            if (v1.value1 instanceof $a801f2c896bd09f1$var$RightChild) return $a801f2c896bd09f1$var$inj22($a801f2c896bd09f1$var$$$Proxy.value)(v1.value1.value0);
            if (v1.value1 instanceof $a801f2c896bd09f1$var$BothChildren) return $a801f2c896bd09f1$var$inj32($a801f2c896bd09f1$var$$$Proxy.value)(v1.value1.value0);
            if (v1.value1 instanceof $a801f2c896bd09f1$var$TooManyChildren) return $a801f2c896bd09f1$var$inj4($a801f2c896bd09f1$var$$$Proxy.value)(v1.value1.value0);
            throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 213, column 15 - line 217, column 70): " + [
                v1.value1.constructor.name
            ]);
        }();
        return {
            parent: v1.value0,
            child: child
        };
    };
    return {
        midEdges: $a801f2c896bd09f1$var$edgesToJSON(v3.midEdges),
        children: $a801f2c896bd09f1$var$map29(childToJSON)($a801f2c896bd09f1$var$toUnfoldable7(v3.children)),
        ids: new $a801f2c896bd09f1$var$Just(v3.ids),
        unexplained: new $a801f2c896bd09f1$var$Just(v3.unexplained)
    };
};
var $a801f2c896bd09f1$var$leftmostToJSON = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$LMFreezeLeft) return $a801f2c896bd09f1$var$inj5($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$freezeToJSON(v3.value0));
    if (v3 instanceof $a801f2c896bd09f1$var$LMFreezeOnly) return $a801f2c896bd09f1$var$inj6($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$freezeToJSON(v3.value0));
    if (v3 instanceof $a801f2c896bd09f1$var$LMSplitLeft) return $a801f2c896bd09f1$var$inj7($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$splitToJSON(v3.value0));
    if (v3 instanceof $a801f2c896bd09f1$var$LMSplitOnly) return $a801f2c896bd09f1$var$inj8($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$splitToJSON(v3.value0));
    if (v3 instanceof $a801f2c896bd09f1$var$LMSplitRight) return $a801f2c896bd09f1$var$inj9($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$splitToJSON(v3.value0));
    if (v3 instanceof $a801f2c896bd09f1$var$LMHorizontalize) return $a801f2c896bd09f1$var$inj10($a801f2c896bd09f1$var$$$Proxy.value)($a801f2c896bd09f1$var$horiToJSON(v3.value0));
    throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 164, column 18 - line 170, column 66): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$modelToJSON = function(model) {
    var transToJSON = function(v3) {
        return {
            edges: $a801f2c896bd09f1$var$edgesToJSON(v3.edges),
            id: new $a801f2c896bd09f1$var$Just(v3.id)
        };
    };
    var sliceToJSON = function(v3) {
        return {
            id: new $a801f2c896bd09f1$var$Just(v3.id),
            notes: $a801f2c896bd09f1$var$map43($a801f2c896bd09f1$var$map29(function(v1) {
                return v1.note;
            }))(v3.notes)
        };
    };
    return $a801f2c896bd09f1$var$bind17($a801f2c896bd09f1$var$reductionToLeftmost(model))(function(lm) {
        return $a801f2c896bd09f1$var$pure19({
            derivation: $a801f2c896bd09f1$var$map29($a801f2c896bd09f1$var$leftmostToJSON)(lm),
            start: sliceToJSON(model.reduction.start),
            topSegments: $a801f2c896bd09f1$var$map29(function(v3) {
                return {
                    trans: transToJSON(v3.trans),
                    rslice: sliceToJSON(v3.rslice)
                };
            })($a801f2c896bd09f1$var$fromFoldable82(model.reduction.segments)),
            styles: new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$stylesToJSON(model.styles))
        });
    });
};
var $a801f2c896bd09f1$var$addJSONIds = function(piece) {
    var addids = function(s2) {
        return $a801f2c896bd09f1$var$mapWithIndex3(function(n) {
            return function(note2) {
                return {
                    id: "note" + ($a801f2c896bd09f1$var$show9(s2) + ("." + $a801f2c896bd09f1$var$show9(n))),
                    pitch: note2.pitch,
                    hold: note2.hold
                };
            };
        });
    };
    return $a801f2c896bd09f1$var$mapWithIndex3(function(s2) {
        return function(slice4) {
            return {
                time: slice4.time,
                notes: addids(s2)(slice4.notes)
            };
        };
    })(piece);
};
// output/App.Utils/index.js
var $a801f2c896bd09f1$var$fromJust5 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromJust();
var $a801f2c896bd09f1$var$bindFlipped6 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$readRecord2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord();
var $a801f2c896bd09f1$var$read_2 = /* @__PURE__ */ $a801f2c896bd09f1$var$read_(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "notes";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord2(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "hold";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readMaybe($a801f2c896bd09f1$var$readString2))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "id";
    }
})($a801f2c896bd09f1$var$readString2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "pitch";
    }
})($a801f2c896bd09f1$var$readString2)($a801f2c896bd09f1$var$readFieldsNil)()())()())()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "time";
    }
})($a801f2c896bd09f1$var$readString2)($a801f2c896bd09f1$var$readFieldsNil)()())()())));
var $a801f2c896bd09f1$var$bind19 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$pure20 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeAff);
var $a801f2c896bd09f1$var$showJSONErrors = function(dictFoldable) {
    var intercalate7 = $a801f2c896bd09f1$var$intercalate(dictFoldable)($a801f2c896bd09f1$var$monoidString);
    return function(dictFunctor) {
        var map59 = $a801f2c896bd09f1$var$map(dictFunctor);
        return function(errs) {
            return new $a801f2c896bd09f1$var$Left("Errors parsing JSON:\n  " + intercalate7("\n  ")(map59($a801f2c896bd09f1$var$renderForeignError)(errs)));
        };
    };
};
var $a801f2c896bd09f1$var$examplePieceLong = /* @__PURE__ */ $a801f2c896bd09f1$var$fromJust5(/* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped6($a801f2c896bd09f1$var$pieceFromJSON)(/* @__PURE__ */ $a801f2c896bd09f1$var$read_2($a801f2c896bd09f1$var$examplePieceJSONLong)));
var $a801f2c896bd09f1$var$examplePiece = /* @__PURE__ */ $a801f2c896bd09f1$var$fromJust5(/* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped6($a801f2c896bd09f1$var$pieceFromJSON)(/* @__PURE__ */ $a801f2c896bd09f1$var$read_2($a801f2c896bd09f1$var$examplePieceJSON)));
var $a801f2c896bd09f1$var$download = function(str) {
    return function(filename) {
        return function(mimetype) {
            return $a801f2c896bd09f1$var$download_($a801f2c896bd09f1$var$unsafeToForeign(str))(filename)(mimetype);
        };
    };
};
var $a801f2c896bd09f1$var$convertMusicXML = function(unfold) {
    return function(input3) {
        return $a801f2c896bd09f1$var$bind19($a801f2c896bd09f1$var$toAffE($a801f2c896bd09f1$var$musicxml2pv($a801f2c896bd09f1$var$Left.create)($a801f2c896bd09f1$var$Right.create)(unfold)(input3)))(function(result2) {
            return $a801f2c896bd09f1$var$pure20(result2);
        });
    };
};
var $a801f2c896bd09f1$var$class_2 = function(str) {
    return $a801f2c896bd09f1$var$class_(str);
};
// output/Halogen.HTML.Elements/index.js
var $a801f2c896bd09f1$var$pure21 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeMaybe);
var $a801f2c896bd09f1$var$elementNS = function($15) {
    return $a801f2c896bd09f1$var$element($a801f2c896bd09f1$var$pure21($15));
};
var $a801f2c896bd09f1$var$element2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$element($a801f2c896bd09f1$var$Nothing.value);
}();
var $a801f2c896bd09f1$var$h1 = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("h1");
var $a801f2c896bd09f1$var$h2 = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("h2");
var $a801f2c896bd09f1$var$h2_ = /* @__PURE__ */ $a801f2c896bd09f1$var$h2([]);
var $a801f2c896bd09f1$var$h3 = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("h3");
var $a801f2c896bd09f1$var$h3_ = /* @__PURE__ */ $a801f2c896bd09f1$var$h3([]);
var $a801f2c896bd09f1$var$h4 = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("h4");
var $a801f2c896bd09f1$var$h4_ = /* @__PURE__ */ $a801f2c896bd09f1$var$h4([]);
var $a801f2c896bd09f1$var$input = function(props) {
    return $a801f2c896bd09f1$var$element2("input")(props)([]);
};
var $a801f2c896bd09f1$var$label = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("label");
var $a801f2c896bd09f1$var$li = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("li");
var $a801f2c896bd09f1$var$li_ = /* @__PURE__ */ $a801f2c896bd09f1$var$li([]);
var $a801f2c896bd09f1$var$ol = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("ol");
var $a801f2c896bd09f1$var$ol_ = /* @__PURE__ */ $a801f2c896bd09f1$var$ol([]);
var $a801f2c896bd09f1$var$option2 = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("option");
var $a801f2c896bd09f1$var$p2 = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("p");
var $a801f2c896bd09f1$var$p_ = /* @__PURE__ */ $a801f2c896bd09f1$var$p2([]);
var $a801f2c896bd09f1$var$pre = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("pre");
var $a801f2c896bd09f1$var$pre_ = /* @__PURE__ */ $a801f2c896bd09f1$var$pre([]);
var $a801f2c896bd09f1$var$select = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("select");
var $a801f2c896bd09f1$var$select_ = /* @__PURE__ */ $a801f2c896bd09f1$var$select([]);
var $a801f2c896bd09f1$var$style2 = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("style");
var $a801f2c896bd09f1$var$style_ = /* @__PURE__ */ $a801f2c896bd09f1$var$style2([]);
var $a801f2c896bd09f1$var$textarea = function(es) {
    return $a801f2c896bd09f1$var$element2("textarea")(es)([]);
};
var $a801f2c896bd09f1$var$ul = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("ul");
var $a801f2c896bd09f1$var$div5 = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("div");
var $a801f2c896bd09f1$var$div_ = /* @__PURE__ */ $a801f2c896bd09f1$var$div5([]);
var $a801f2c896bd09f1$var$button = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("button");
var $a801f2c896bd09f1$var$a = /* @__PURE__ */ $a801f2c896bd09f1$var$element2("a");
// output/Web.Event.Event/foreign.js
function $a801f2c896bd09f1$var$_currentTarget(e) {
    return e.currentTarget;
}
function $a801f2c896bd09f1$var$_target(e) {
    return e.target;
}
function $a801f2c896bd09f1$var$preventDefault(e) {
    return function() {
        return e.preventDefault();
    };
}
// output/Web.Event.Event/index.js
var $a801f2c896bd09f1$var$target = function($3) {
    return $a801f2c896bd09f1$var$toMaybe($a801f2c896bd09f1$var$_target($3));
};
var $a801f2c896bd09f1$var$currentTarget = function($5) {
    return $a801f2c896bd09f1$var$toMaybe($a801f2c896bd09f1$var$_currentTarget($5));
};
// output/Web.File.FileList/foreign.js
function $a801f2c896bd09f1$var$_item(index5) {
    return function(fileList) {
        return fileList.item(index5);
    };
}
// output/Web.File.FileList/index.js
var $a801f2c896bd09f1$var$map30 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$item = function(i2) {
    var $5 = $a801f2c896bd09f1$var$_item(i2);
    return function($6) {
        return $a801f2c896bd09f1$var$toMaybe($5($6));
    };
};
var $a801f2c896bd09f1$var$items = function(dictUnfoldable) {
    var unfoldr3 = $a801f2c896bd09f1$var$unfoldr(dictUnfoldable);
    return function(fl) {
        return unfoldr3(function(i2) {
            return $a801f2c896bd09f1$var$map30($a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$Tuple.create)(i2 + 1 | 0))($a801f2c896bd09f1$var$item(i2)(fl));
        })(0);
    };
};
// output/Web.HTML.Event.EventTypes/index.js
var $a801f2c896bd09f1$var$load = "load";
var $a801f2c896bd09f1$var$input2 = "input";
var $a801f2c896bd09f1$var$error3 = "error";
var $a801f2c896bd09f1$var$domcontentloaded = "DOMContentLoaded";
var $a801f2c896bd09f1$var$change = "change";
// output/Web.HTML.HTMLInputElement/foreign.js
function $a801f2c896bd09f1$var$_files(input3) {
    return function() {
        return input3.files;
    };
}
// output/Web.HTML.HTMLInputElement/index.js
var $a801f2c896bd09f1$var$map31 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$fromEventTarget = /* @__PURE__ */ $a801f2c896bd09f1$var$unsafeReadProtoTagged("HTMLInputElement");
var $a801f2c896bd09f1$var$files = /* @__PURE__ */ function() {
    var $6 = $a801f2c896bd09f1$var$map31($a801f2c896bd09f1$var$toMaybe);
    return function($7) {
        return $6($a801f2c896bd09f1$var$_files($7));
    };
}();
// output/Web.UIEvent.KeyboardEvent.EventTypes/index.js
var $a801f2c896bd09f1$var$keyup = "keyup";
// output/Web.UIEvent.MouseEvent.EventTypes/index.js
var $a801f2c896bd09f1$var$click = "click";
// output/Web.UIEvent.WheelEvent.EventTypes/index.js
var $a801f2c896bd09f1$var$wheel = "wheel";
// output/Halogen.HTML.Events/index.js
var $a801f2c896bd09f1$var$map35 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$composeKleisli2 = /* @__PURE__ */ $a801f2c896bd09f1$var$composeKleisli($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$composeKleisliFlipped3 = /* @__PURE__ */ $a801f2c896bd09f1$var$composeKleisliFlipped(/* @__PURE__ */ $a801f2c896bd09f1$var$bindExceptT($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$readProp3 = /* @__PURE__ */ $a801f2c896bd09f1$var$readProp($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$readString4 = /* @__PURE__ */ $a801f2c896bd09f1$var$readString($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$wheelHandler = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$mouseHandler = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$handler$prime = function(et2) {
    return function(f2) {
        return $a801f2c896bd09f1$var$handler(et2)(function(ev) {
            return $a801f2c896bd09f1$var$map35($a801f2c896bd09f1$var$Action.create)(f2(ev));
        });
    };
};
var $a801f2c896bd09f1$var$handler2 = function(et2) {
    return function(f2) {
        return $a801f2c896bd09f1$var$handler(et2)(function(ev) {
            return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Action(f2(ev)));
        });
    };
};
var $a801f2c896bd09f1$var$onChange = /* @__PURE__ */ $a801f2c896bd09f1$var$handler2($a801f2c896bd09f1$var$change);
var $a801f2c896bd09f1$var$onClick = /* @__PURE__ */ function() {
    var $15 = $a801f2c896bd09f1$var$handler2($a801f2c896bd09f1$var$click);
    return function($16) {
        return $15($a801f2c896bd09f1$var$mouseHandler($16));
    };
}();
var $a801f2c896bd09f1$var$onFileUpload = function(dictUnfoldable) {
    var none2 = $a801f2c896bd09f1$var$none(dictUnfoldable);
    var items2 = $a801f2c896bd09f1$var$items(dictUnfoldable);
    return function(f2) {
        return $a801f2c896bd09f1$var$handler2($a801f2c896bd09f1$var$change)(function() {
            var $19 = $a801f2c896bd09f1$var$maybe(none2)(items2);
            var $20 = $a801f2c896bd09f1$var$composeKleisli2($a801f2c896bd09f1$var$target)($a801f2c896bd09f1$var$composeKleisli2($a801f2c896bd09f1$var$fromEventTarget)(function($22) {
                return $a801f2c896bd09f1$var$unsafePerformEffect($a801f2c896bd09f1$var$files($22));
            }));
            return function($21) {
                return f2($19($20($21)));
            };
        }());
    };
};
var $a801f2c896bd09f1$var$onWheel = /* @__PURE__ */ function() {
    var $53 = $a801f2c896bd09f1$var$handler2($a801f2c896bd09f1$var$wheel);
    return function($54) {
        return $53($a801f2c896bd09f1$var$wheelHandler($54));
    };
}();
var $a801f2c896bd09f1$var$addForeignPropHandler = function(key2) {
    return function(prop3) {
        return function(reader) {
            return function(f2) {
                var go2 = function(a3) {
                    return $a801f2c896bd09f1$var$composeKleisliFlipped3(reader)($a801f2c896bd09f1$var$readProp3(prop3))($a801f2c896bd09f1$var$unsafeToForeign(a3));
                };
                return $a801f2c896bd09f1$var$handler$prime(key2)($a801f2c896bd09f1$var$composeKleisli2($a801f2c896bd09f1$var$currentTarget)(function(e) {
                    return $a801f2c896bd09f1$var$either($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$Nothing.value))(function($85) {
                        return $a801f2c896bd09f1$var$Just.create(f2($85));
                    })($a801f2c896bd09f1$var$runExcept(go2(e)));
                }));
            };
        };
    };
};
var $a801f2c896bd09f1$var$onValueChange = /* @__PURE__ */ $a801f2c896bd09f1$var$addForeignPropHandler($a801f2c896bd09f1$var$change)("value")($a801f2c896bd09f1$var$readString4);
var $a801f2c896bd09f1$var$onValueInput = /* @__PURE__ */ $a801f2c896bd09f1$var$addForeignPropHandler($a801f2c896bd09f1$var$input2)("value")($a801f2c896bd09f1$var$readString4);
// output/Halogen.Svg.Attributes.Baseline/index.js
var $a801f2c896bd09f1$var$Auto = /* @__PURE__ */ function() {
    function Auto3() {}
    Auto3.value = new Auto3();
    return Auto3;
}();
var $a801f2c896bd09f1$var$UseScript = /* @__PURE__ */ function() {
    function UseScript2() {}
    UseScript2.value = new UseScript2();
    return UseScript2;
}();
var $a801f2c896bd09f1$var$NoChange = /* @__PURE__ */ function() {
    function NoChange2() {}
    NoChange2.value = new NoChange2();
    return NoChange2;
}();
var $a801f2c896bd09f1$var$ResetSize = /* @__PURE__ */ function() {
    function ResetSize2() {}
    ResetSize2.value = new ResetSize2();
    return ResetSize2;
}();
var $a801f2c896bd09f1$var$Ideographic = /* @__PURE__ */ function() {
    function Ideographic2() {}
    Ideographic2.value = new Ideographic2();
    return Ideographic2;
}();
var $a801f2c896bd09f1$var$Alphabetic = /* @__PURE__ */ function() {
    function Alphabetic2() {}
    Alphabetic2.value = new Alphabetic2();
    return Alphabetic2;
}();
var $a801f2c896bd09f1$var$Hanging = /* @__PURE__ */ function() {
    function Hanging2() {}
    Hanging2.value = new Hanging2();
    return Hanging2;
}();
var $a801f2c896bd09f1$var$Mathematical = /* @__PURE__ */ function() {
    function Mathematical2() {}
    Mathematical2.value = new Mathematical2();
    return Mathematical2;
}();
var $a801f2c896bd09f1$var$Central = /* @__PURE__ */ function() {
    function Central2() {}
    Central2.value = new Central2();
    return Central2;
}();
var $a801f2c896bd09f1$var$BaselineMiddle = /* @__PURE__ */ function() {
    function BaselineMiddle2() {}
    BaselineMiddle2.value = new BaselineMiddle2();
    return BaselineMiddle2;
}();
var $a801f2c896bd09f1$var$TextAfterEdge = /* @__PURE__ */ function() {
    function TextAfterEdge2() {}
    TextAfterEdge2.value = new TextAfterEdge2();
    return TextAfterEdge2;
}();
var $a801f2c896bd09f1$var$TextBeforeEdge = /* @__PURE__ */ function() {
    function TextBeforeEdge2() {}
    TextBeforeEdge2.value = new TextBeforeEdge2();
    return TextBeforeEdge2;
}();
var $a801f2c896bd09f1$var$printBaseline = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$Auto) return "auto";
    if (v3 instanceof $a801f2c896bd09f1$var$UseScript) return "use-script";
    if (v3 instanceof $a801f2c896bd09f1$var$NoChange) return "no-change";
    if (v3 instanceof $a801f2c896bd09f1$var$ResetSize) return "reset-size";
    if (v3 instanceof $a801f2c896bd09f1$var$Ideographic) return "ideographic";
    if (v3 instanceof $a801f2c896bd09f1$var$Alphabetic) return "alphabetic";
    if (v3 instanceof $a801f2c896bd09f1$var$Hanging) return "hanging";
    if (v3 instanceof $a801f2c896bd09f1$var$Mathematical) return "mathematical";
    if (v3 instanceof $a801f2c896bd09f1$var$Central) return "central";
    if (v3 instanceof $a801f2c896bd09f1$var$BaselineMiddle) return "middle";
    if (v3 instanceof $a801f2c896bd09f1$var$TextAfterEdge) return "text-after-edge";
    if (v3 instanceof $a801f2c896bd09f1$var$TextBeforeEdge) return "text-before-edge";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Baseline (line 40, column 17 - line 52, column 39): " + [
        v3.constructor.name
    ]);
};
// output/Halogen.Svg.Attributes.Color/index.js
var $a801f2c896bd09f1$var$show10 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$show15 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showNumber);
var $a801f2c896bd09f1$var$RGB = /* @__PURE__ */ function() {
    function RGB2(value0, value1, value22) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
    }
    RGB2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return new RGB2(value0, value1, value22);
            };
        };
    };
    return RGB2;
}();
var $a801f2c896bd09f1$var$RGBA = /* @__PURE__ */ function() {
    function RGBA2(value0, value1, value22, value32) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
        this.value3 = value32;
    }
    RGBA2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return function(value32) {
                    return new RGBA2(value0, value1, value22, value32);
                };
            };
        };
    };
    return RGBA2;
}();
var $a801f2c896bd09f1$var$Named = /* @__PURE__ */ function() {
    function Named2(value0) {
        this.value0 = value0;
    }
    Named2.create = function(value0) {
        return new Named2(value0);
    };
    return Named2;
}();
var $a801f2c896bd09f1$var$NoColor = /* @__PURE__ */ function() {
    function NoColor2() {}
    NoColor2.value = new NoColor2();
    return NoColor2;
}();
var $a801f2c896bd09f1$var$printColor = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$RGB) return "rgb(" + ($a801f2c896bd09f1$var$show10(v3.value0) + ("," + ($a801f2c896bd09f1$var$show10(v3.value1) + ("," + ($a801f2c896bd09f1$var$show10(v3.value2) + ")")))));
    if (v3 instanceof $a801f2c896bd09f1$var$RGBA) return "rgba(" + ($a801f2c896bd09f1$var$show10(v3.value0) + ("," + ($a801f2c896bd09f1$var$show10(v3.value1) + ("," + ($a801f2c896bd09f1$var$show10(v3.value2) + ("," + ($a801f2c896bd09f1$var$show15(v3.value3) + ")")))))));
    if (v3 instanceof $a801f2c896bd09f1$var$Named) return v3.value0;
    if (v3 instanceof $a801f2c896bd09f1$var$NoColor) return "None";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Color (line 24, column 14 - line 28, column 20): " + [
        v3.constructor.name
    ]);
};
// output/Halogen.Svg.Attributes.Path/index.js
var $a801f2c896bd09f1$var$show11 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showNumber);
var $a801f2c896bd09f1$var$Rel = /* @__PURE__ */ function() {
    function Rel2() {}
    Rel2.value = new Rel2();
    return Rel2;
}();
var $a801f2c896bd09f1$var$Abs = /* @__PURE__ */ function() {
    function Abs2() {}
    Abs2.value = new Abs2();
    return Abs2;
}();
var $a801f2c896bd09f1$var$toArrayString = /* @__PURE__ */ $a801f2c896bd09f1$var$coerce();
var $a801f2c896bd09f1$var$renderCommand = function(cmd) {
    return function(s_) {
        if (cmd instanceof $a801f2c896bd09f1$var$Rel) return s_;
        if (cmd instanceof $a801f2c896bd09f1$var$Abs) return $a801f2c896bd09f1$var$toUpper(s_);
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 81, column 24 - line 83, column 20): " + [
            cmd.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$renderCommand2Args = function(s_) {
    return function(ref3) {
        return function(a_2) {
            return function(b3) {
                return $a801f2c896bd09f1$var$renderCommand(ref3)(s_) + ($a801f2c896bd09f1$var$show11(a_2) + (", " + $a801f2c896bd09f1$var$show11(b3)));
            };
        };
    };
};
var $a801f2c896bd09f1$var$m2 = /* @__PURE__ */ $a801f2c896bd09f1$var$renderCommand2Args("m");
var $a801f2c896bd09f1$var$l = /* @__PURE__ */ $a801f2c896bd09f1$var$renderCommand2Args("l");
// output/Halogen.Svg.Attributes.TextAnchor/index.js
var $a801f2c896bd09f1$var$AnchorStart = /* @__PURE__ */ function() {
    function AnchorStart2() {}
    AnchorStart2.value = new AnchorStart2();
    return AnchorStart2;
}();
var $a801f2c896bd09f1$var$AnchorMiddle = /* @__PURE__ */ function() {
    function AnchorMiddle2() {}
    AnchorMiddle2.value = new AnchorMiddle2();
    return AnchorMiddle2;
}();
var $a801f2c896bd09f1$var$AnchorEnd = /* @__PURE__ */ function() {
    function AnchorEnd2() {}
    AnchorEnd2.value = new AnchorEnd2();
    return AnchorEnd2;
}();
var $a801f2c896bd09f1$var$printTextAnchor = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$AnchorStart) return "start";
    if (v3 instanceof $a801f2c896bd09f1$var$AnchorMiddle) return "middle";
    if (v3 instanceof $a801f2c896bd09f1$var$AnchorEnd) return "end";
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.TextAnchor (line 22, column 19 - line 25, column 21): " + [
        v3.constructor.name
    ]);
};
// output/Halogen.Svg.Attributes/index.js
var $a801f2c896bd09f1$var$show16 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showNumber);
var $a801f2c896bd09f1$var$map36 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$y2 = /* @__PURE__ */ function() {
    var $23 = $a801f2c896bd09f1$var$attr2("y2");
    return function($24) {
        return $23($a801f2c896bd09f1$var$show16($24));
    };
}();
var $a801f2c896bd09f1$var$y1 = /* @__PURE__ */ function() {
    var $25 = $a801f2c896bd09f1$var$attr2("y1");
    return function($26) {
        return $25($a801f2c896bd09f1$var$show16($26));
    };
}();
var $a801f2c896bd09f1$var$y3 = /* @__PURE__ */ function() {
    var $27 = $a801f2c896bd09f1$var$attr2("y");
    return function($28) {
        return $27($a801f2c896bd09f1$var$show16($28));
    };
}();
var $a801f2c896bd09f1$var$x2 = /* @__PURE__ */ function() {
    var $29 = $a801f2c896bd09f1$var$attr2("x2");
    return function($30) {
        return $29($a801f2c896bd09f1$var$show16($30));
    };
}();
var $a801f2c896bd09f1$var$x1 = /* @__PURE__ */ function() {
    var $31 = $a801f2c896bd09f1$var$attr2("x1");
    return function($32) {
        return $31($a801f2c896bd09f1$var$show16($32));
    };
}();
var $a801f2c896bd09f1$var$x3 = /* @__PURE__ */ function() {
    var $33 = $a801f2c896bd09f1$var$attr2("x");
    return function($34) {
        return $33($a801f2c896bd09f1$var$show16($34));
    };
}();
var $a801f2c896bd09f1$var$width2 = /* @__PURE__ */ function() {
    var $35 = $a801f2c896bd09f1$var$attr2("width");
    return function($36) {
        return $35($a801f2c896bd09f1$var$show16($36));
    };
}();
var $a801f2c896bd09f1$var$viewBox = function(x_) {
    return function(y_) {
        return function(w2) {
            return function(h_) {
                return $a801f2c896bd09f1$var$attr2("viewBox")($a801f2c896bd09f1$var$joinWith(" ")($a801f2c896bd09f1$var$map36($a801f2c896bd09f1$var$show16)([
                    x_,
                    y_,
                    w2,
                    h_
                ])));
            };
        };
    };
};
var $a801f2c896bd09f1$var$textAnchor = /* @__PURE__ */ function() {
    var $41 = $a801f2c896bd09f1$var$attr2("text-anchor");
    return function($42) {
        return $41($a801f2c896bd09f1$var$printTextAnchor($42));
    };
}();
var $a801f2c896bd09f1$var$strokeWidth = /* @__PURE__ */ function() {
    var $43 = $a801f2c896bd09f1$var$attr2("stroke-width");
    return function($44) {
        return $43($a801f2c896bd09f1$var$show16($44));
    };
}();
var $a801f2c896bd09f1$var$stroke = /* @__PURE__ */ function() {
    var $56 = $a801f2c896bd09f1$var$attr2("stroke");
    return function($57) {
        return $56($a801f2c896bd09f1$var$printColor($57));
    };
}();
var $a801f2c896bd09f1$var$path = /* @__PURE__ */ function() {
    var $77 = $a801f2c896bd09f1$var$attr2("path");
    var $78 = $a801f2c896bd09f1$var$joinWith(" ");
    return function($79) {
        return $77($78($a801f2c896bd09f1$var$toArrayString($79)));
    };
}();
var $a801f2c896bd09f1$var$id3 = /* @__PURE__ */ $a801f2c896bd09f1$var$attr2("id");
var $a801f2c896bd09f1$var$href2 = /* @__PURE__ */ $a801f2c896bd09f1$var$attr2("href");
var $a801f2c896bd09f1$var$height2 = /* @__PURE__ */ function() {
    var $92 = $a801f2c896bd09f1$var$attr2("height");
    return function($93) {
        return $92($a801f2c896bd09f1$var$show16($93));
    };
}();
var $a801f2c896bd09f1$var$fill = /* @__PURE__ */ function() {
    var $108 = $a801f2c896bd09f1$var$attr2("fill");
    return function($109) {
        return $108($a801f2c896bd09f1$var$printColor($109));
    };
}();
var $a801f2c896bd09f1$var$dominantBaseline = /* @__PURE__ */ function() {
    var $112 = $a801f2c896bd09f1$var$attr2("dominant-baseline");
    return function($113) {
        return $112($a801f2c896bd09f1$var$printBaseline($113));
    };
}();
var $a801f2c896bd09f1$var$class_3 = /* @__PURE__ */ function() {
    var $125 = $a801f2c896bd09f1$var$attr2("class");
    var $126 = $a801f2c896bd09f1$var$un()($a801f2c896bd09f1$var$ClassName);
    return function($127) {
        return $125($126($127));
    };
}();
// output/Halogen.Svg.Elements/index.js
var $a801f2c896bd09f1$var$element3 = /* @__PURE__ */ $a801f2c896bd09f1$var$elementNS("http://www.w3.org/2000/svg");
var $a801f2c896bd09f1$var$g = /* @__PURE__ */ $a801f2c896bd09f1$var$element3("g");
var $a801f2c896bd09f1$var$line = function(props) {
    return $a801f2c896bd09f1$var$element3("line")(props)([]);
};
var $a801f2c896bd09f1$var$rect = function(props) {
    return $a801f2c896bd09f1$var$element3("rect")(props)([]);
};
var $a801f2c896bd09f1$var$svg = /* @__PURE__ */ $a801f2c896bd09f1$var$element3("svg");
var $a801f2c896bd09f1$var$text2 = /* @__PURE__ */ $a801f2c896bd09f1$var$element3("text");
var $a801f2c896bd09f1$var$title2 = /* @__PURE__ */ $a801f2c896bd09f1$var$element3("title");
var $a801f2c896bd09f1$var$defs = /* @__PURE__ */ $a801f2c896bd09f1$var$element3("defs");
// node_modules/vexflow/build/esm/src/util.js
var $a801f2c896bd09f1$var$RuntimeError = class extends Error {
    constructor(code3, message2 = ""){
        super("[RuntimeError] " + code3 + ": " + message2);
        this.code = code3;
    }
};
function $a801f2c896bd09f1$var$globalObject() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    return Function("return this")();
}
function $a801f2c896bd09f1$var$defined(x4, code3 = "undefined", message2 = "") {
    if (x4 === void 0) throw new $a801f2c896bd09f1$var$RuntimeError(code3, message2);
    return x4;
}
function $a801f2c896bd09f1$var$log3(block, ...args) {
    if (!args) return;
    const line2 = Array.prototype.slice.call(args).join(" ");
    $a801f2c896bd09f1$var$globalObject().console.log(block + ": " + line2);
}
function $a801f2c896bd09f1$var$warn2(...args) {
    const line2 = args.join(" ");
    const err = new Error();
    $a801f2c896bd09f1$var$globalObject().console.log("Warning: ", line2, err.stack);
}
function $a801f2c896bd09f1$var$roundN(x4, n) {
    return x4 % n >= n / 2 ? parseInt(`${x4 / n}`, 10) * n + n : parseInt(`${x4 / n}`, 10) * n;
}
function $a801f2c896bd09f1$var$midLine(a3, b3) {
    let mid_line = b3 + (a3 - b3) / 2;
    if (mid_line % 2 > 0) mid_line = $a801f2c896bd09f1$var$roundN(mid_line * 10, 5) / 10;
    return mid_line;
}
function $a801f2c896bd09f1$var$prefix(text7) {
    return `vf-${text7}`;
}
function $a801f2c896bd09f1$var$normalizeAngle(a3) {
    a3 = a3 % (2 * Math.PI);
    if (a3 < 0) a3 += 2 * Math.PI;
    return a3;
}
function $a801f2c896bd09f1$var$sumArray(arr) {
    return arr.reduce((a3, b3)=>a3 + b3, 0);
}
// node_modules/vexflow/build/esm/src/fraction.js
var $a801f2c896bd09f1$var$Fraction = class _Fraction {
    static get CATEGORY() {
        return "Fraction";
    }
    static GCD(a3, b3) {
        if (typeof a3 !== "number" || Number.isNaN(a3) || typeof b3 !== "number" || Number.isNaN(b3)) throw new $a801f2c896bd09f1$var$RuntimeError("BadArgument", `Invalid numbers: ${a3}, ${b3}`);
        let t2;
        while(b3 !== 0){
            t2 = b3;
            b3 = a3 % b3;
            a3 = t2;
        }
        return a3;
    }
    static LCM(a3, b3) {
        return a3 * b3 / _Fraction.GCD(a3, b3);
    }
    static LCMM(args) {
        if (args.length === 0) return 0;
        else if (args.length === 1) return args[0];
        else if (args.length === 2) return _Fraction.LCM(args[0], args[1]);
        else return _Fraction.LCM(args.shift(), _Fraction.LCMM(args));
    }
    constructor(numerator2, denominator2){
        this.numerator = 1;
        this.denominator = 1;
        this.set(numerator2, denominator2);
    }
    set(numerator2 = 1, denominator2 = 1) {
        this.numerator = numerator2;
        this.denominator = denominator2;
        return this;
    }
    value() {
        return this.numerator / this.denominator;
    }
    simplify() {
        let u2 = this.numerator;
        let d = this.denominator;
        const gcd2 = _Fraction.GCD(u2, d);
        u2 /= gcd2;
        d /= gcd2;
        if (d < 0) {
            d = -d;
            u2 = -u2;
        }
        return this.set(u2, d);
    }
    add(param1 = 0, param2 = 1) {
        const [otherNumerator, otherDenominator] = $a801f2c896bd09f1$var$getNumeratorAndDenominator(param1, param2);
        const lcm = _Fraction.LCM(this.denominator, otherDenominator);
        const a3 = lcm / this.denominator;
        const b3 = lcm / otherDenominator;
        const u2 = this.numerator * a3 + otherNumerator * b3;
        return this.set(u2, lcm);
    }
    subtract(param1 = 0, param2 = 1) {
        const [otherNumerator, otherDenominator] = $a801f2c896bd09f1$var$getNumeratorAndDenominator(param1, param2);
        const lcm = _Fraction.LCM(this.denominator, otherDenominator);
        const a3 = lcm / this.denominator;
        const b3 = lcm / otherDenominator;
        const u2 = this.numerator * a3 - otherNumerator * b3;
        return this.set(u2, lcm);
    }
    multiply(param1 = 1, param2 = 1) {
        const [otherNumerator, otherDenominator] = $a801f2c896bd09f1$var$getNumeratorAndDenominator(param1, param2);
        return this.set(this.numerator * otherNumerator, this.denominator * otherDenominator);
    }
    divide(param1 = 1, param2 = 1) {
        const [otherNumerator, otherDenominator] = $a801f2c896bd09f1$var$getNumeratorAndDenominator(param1, param2);
        return this.set(this.numerator * otherDenominator, this.denominator * otherNumerator);
    }
    equals(compare6) {
        const a3 = _Fraction.__staticFractionA.copy(compare6).simplify();
        const b3 = _Fraction.__staticFractionB.copy(this).simplify();
        return a3.numerator === b3.numerator && a3.denominator === b3.denominator;
    }
    greaterThan(compare6) {
        const a3 = _Fraction.__staticFractionB.copy(this);
        a3.subtract(compare6);
        return a3.numerator > 0;
    }
    greaterThanEquals(compare6) {
        const a3 = _Fraction.__staticFractionB.copy(this);
        a3.subtract(compare6);
        return a3.numerator >= 0;
    }
    lessThan(compare6) {
        return !this.greaterThanEquals(compare6);
    }
    lessThanEquals(compare6) {
        return !this.greaterThan(compare6);
    }
    clone() {
        return new _Fraction(this.numerator, this.denominator);
    }
    copy(other) {
        if (typeof other === "number") return this.set(other, 1);
        else return this.set(other.numerator, other.denominator);
    }
    quotient() {
        return Math.floor(this.numerator / this.denominator);
    }
    remainder() {
        return this.numerator % this.denominator;
    }
    makeAbs() {
        this.denominator = Math.abs(this.denominator);
        this.numerator = Math.abs(this.numerator);
        return this;
    }
    toString() {
        return `${this.numerator}/${this.denominator}`;
    }
    toSimplifiedString() {
        return _Fraction.__staticFractionTmp.copy(this).simplify().toString();
    }
    toMixedString() {
        let s2 = "";
        const q4 = this.quotient();
        const f2 = _Fraction.__staticFractionTmp.copy(this);
        if (q4 < 0) f2.makeAbs();
        if (q4 !== 0) {
            s2 += q4;
            if (f2.numerator !== 0) s2 += ` ${f2.toSimplifiedString()}`;
        } else if (f2.numerator === 0) s2 = "0";
        else s2 = f2.toSimplifiedString();
        return s2;
    }
    parse(str) {
        const i2 = str.split("/");
        const n = parseInt(i2[0], 10);
        const d = i2[1] ? parseInt(i2[1], 10) : 1;
        return this.set(n, d);
    }
};
$a801f2c896bd09f1$var$Fraction.__staticFractionA = new $a801f2c896bd09f1$var$Fraction();
$a801f2c896bd09f1$var$Fraction.__staticFractionB = new $a801f2c896bd09f1$var$Fraction();
$a801f2c896bd09f1$var$Fraction.__staticFractionTmp = new $a801f2c896bd09f1$var$Fraction();
function $a801f2c896bd09f1$var$getNumeratorAndDenominator(n, d = 1) {
    if (typeof n === "number") return [
        n,
        d
    ];
    else return [
        n.numerator,
        n.denominator
    ];
}
// node_modules/vexflow/build/esm/src/boundingbox.js
var $a801f2c896bd09f1$var$BoundingBox = class _BoundingBox {
    static copy(that) {
        return new _BoundingBox(that.x, that.y, that.w, that.h);
    }
    constructor(x4, y4, w2, h7){
        this.x = x4;
        this.y = y4;
        this.w = w2;
        this.h = h7;
    }
    getX() {
        return this.x;
    }
    getY() {
        return this.y;
    }
    getW() {
        return this.w;
    }
    getH() {
        return this.h;
    }
    setX(x4) {
        this.x = x4;
        return this;
    }
    setY(y4) {
        this.y = y4;
        return this;
    }
    setW(w2) {
        this.w = w2;
        return this;
    }
    setH(h7) {
        this.h = h7;
        return this;
    }
    move(x4, y4) {
        this.x += x4;
        this.y += y4;
        return this;
    }
    clone() {
        return _BoundingBox.copy(this);
    }
    mergeWith(boundingBox) {
        const that = boundingBox;
        const new_x = this.x < that.x ? this.x : that.x;
        const new_y = this.y < that.y ? this.y : that.y;
        const new_w = Math.max(this.x + this.w, that.x + that.w) - new_x;
        const new_h = Math.max(this.y + this.h, that.y + that.h) - new_y;
        this.x = new_x;
        this.y = new_y;
        this.w = new_w;
        this.h = new_h;
        return this;
    }
};
// node_modules/vexflow/build/esm/src/boundingboxcomputation.js
var $a801f2c896bd09f1$var$BoundingBoxComputation = class {
    constructor(){
        this.x1 = Number.NaN;
        this.y1 = Number.NaN;
        this.x2 = Number.NaN;
        this.y2 = Number.NaN;
    }
    getX1() {
        return this.x1;
    }
    getY1() {
        return this.y1;
    }
    width() {
        return this.x2 - this.x1;
    }
    height() {
        return this.y2 - this.y1;
    }
    addPoint(x4, y4) {
        if (isNaN(this.x1) || x4 < this.x1) this.x1 = x4;
        if (isNaN(this.x2) || x4 > this.x2) this.x2 = x4;
        if (isNaN(this.y1) || y4 < this.y1) this.y1 = y4;
        if (isNaN(this.y2) || y4 > this.y2) this.y2 = y4;
    }
    addX(x4) {
        this.addPoint(x4, this.y1);
    }
    addY(y4) {
        this.addPoint(this.x1, y4);
    }
    addQuadraticCurve(p0x, p0y, p1x, p1y, p2x, p2y) {
        this.addPoint(p0x, p0y);
        this.addPoint(p2x, p2y);
        const p01x = p1x - p0x;
        const p12x = p2x - p1x;
        let denom = p01x - p12x;
        if (denom != 0) {
            const t2 = p01x / denom;
            if (t2 > 0 && t2 < 1) {
                const it2 = 1 - t2;
                this.addX(it2 * it2 * p0x + 2 * it2 * t2 * p1x + t2 * t2 * p2x);
            }
        }
        const p01y = p1y - p0y;
        const p12y = p2y - p1y;
        denom = p01y - p12y;
        if (denom != 0) {
            const t2 = p01y / denom;
            if (t2 > 0 && t2 < 1) {
                const it2 = 1 - t2;
                this.addY(it2 * it2 * p0y + 2 * it2 * t2 * p1y + t2 * t2 * p2y);
            }
        }
    }
    addBezierCurve(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
        const p0 = [
            p0x,
            p0y
        ];
        const p1 = [
            p1x,
            p1y
        ];
        const p22 = [
            p2x,
            p2y
        ];
        const p3 = [
            p3x,
            p3y
        ];
        let i2;
        this.addPoint(p0[0], p0[1]);
        this.addPoint(p3[0], p3[1]);
        const f2 = (t2, i3)=>Math.pow(1 - t2, 3) * p0[i3] + 3 * Math.pow(1 - t2, 2) * t2 * p1[i3] + 3 * (1 - t2) * Math.pow(t2, 2) * p22[i3] + Math.pow(t2, 3) * p3[i3];
        for(i2 = 0; i2 <= 1; i2++){
            const b3 = 6 * p0[i2] - 12 * p1[i2] + 6 * p22[i2];
            const a3 = -3 * p0[i2] + 9 * p1[i2] - 9 * p22[i2] + 3 * p3[i2];
            const c3 = 3 * p1[i2] - 3 * p0[i2];
            if (a3 === 0) {
                if (b3 === 0) continue;
                const t3 = -c3 / b3;
                if (0 < t3 && t3 < 1) {
                    if (i2 === 0) this.addX(f2(t3, i2));
                    if (i2 === 1) this.addY(f2(t3, i2));
                }
                continue;
            }
            const b2ac = Math.pow(b3, 2) - 4 * c3 * a3;
            if (b2ac < 0) continue;
            const t1 = (-b3 + Math.sqrt(b2ac)) / (2 * a3);
            if (0 < t1 && t1 < 1) {
                if (i2 === 0) this.addX(f2(t1, i2));
                if (i2 === 1) this.addY(f2(t1, i2));
            }
            const t2 = (-b3 - Math.sqrt(b2ac)) / (2 * a3);
            if (0 < t2 && t2 < 1) {
                if (i2 === 0) this.addX(f2(t2, i2));
                if (i2 === 1) this.addY(f2(t2, i2));
            }
        }
    }
};
// node_modules/vexflow/build/esm/src/font.js
var $a801f2c896bd09f1$var$__awaiter = function(thisArg, _arguments, P2, generator) {
    function adopt(value17) {
        return value17 instanceof P2 ? value17 : new P2(function(resolve) {
            resolve(value17);
        });
    }
    return new (P2 || (P2 = Promise))(function(resolve, reject) {
        function fulfilled(value17) {
            try {
                step4(generator.next(value17));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value17) {
            try {
                step4(generator["throw"](value17));
            } catch (e) {
                reject(e);
            }
        }
        function step4(result2) {
            result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
        }
        step4((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a801f2c896bd09f1$var$FontWeight;
(function(FontWeight2) {
    FontWeight2["NORMAL"] = "normal";
    FontWeight2["BOLD"] = "bold";
})($a801f2c896bd09f1$var$FontWeight || ($a801f2c896bd09f1$var$FontWeight = {}));
var $a801f2c896bd09f1$var$FontStyle;
(function(FontStyle2) {
    FontStyle2["NORMAL"] = "normal";
    FontStyle2["ITALIC"] = "italic";
})($a801f2c896bd09f1$var$FontStyle || ($a801f2c896bd09f1$var$FontStyle = {}));
var $a801f2c896bd09f1$var$fontParser;
var $a801f2c896bd09f1$var$Fonts = {};
var $a801f2c896bd09f1$var$Font = class _Font {
    static convertSizeToPixelValue(fontSize = _Font.SIZE) {
        var _a;
        if (typeof fontSize === "number") return fontSize * _Font.scaleToPxFrom.pt;
        else {
            const value17 = parseFloat(fontSize);
            if (isNaN(value17)) return 0;
            const unit2 = fontSize.replace(/[\d.\s]/g, "").toLowerCase();
            const conversionFactor = (_a = _Font.scaleToPxFrom[unit2]) !== null && _a !== void 0 ? _a : 1;
            return value17 * conversionFactor;
        }
    }
    static convertSizeToPointValue(fontSize = _Font.SIZE) {
        var _a;
        if (typeof fontSize === "number") return fontSize;
        else {
            const value17 = parseFloat(fontSize);
            if (isNaN(value17)) return 0;
            const unit2 = fontSize.replace(/[\d.\s]/g, "").toLowerCase();
            const conversionFactor = ((_a = _Font.scaleToPxFrom[unit2]) !== null && _a !== void 0 ? _a : 1) / _Font.scaleToPxFrom.pt;
            return value17 * conversionFactor;
        }
    }
    static validate(f2, size6, weight, style3) {
        if (typeof f2 === "string" && size6 === void 0 && weight === void 0 && style3 === void 0) return _Font.fromCSSString(f2);
        let family;
        if (typeof f2 === "object") {
            family = f2.family;
            size6 = f2.size;
            weight = f2.weight;
            style3 = f2.style;
        } else family = f2;
        family = family !== null && family !== void 0 ? family : _Font.SANS_SERIF;
        size6 = size6 !== null && size6 !== void 0 ? size6 : _Font.SIZE + "pt";
        weight = weight !== null && weight !== void 0 ? weight : $a801f2c896bd09f1$var$FontWeight.NORMAL;
        style3 = style3 !== null && style3 !== void 0 ? style3 : $a801f2c896bd09f1$var$FontStyle.NORMAL;
        if (weight === "") weight = $a801f2c896bd09f1$var$FontWeight.NORMAL;
        if (style3 === "") style3 = $a801f2c896bd09f1$var$FontStyle.NORMAL;
        if (typeof size6 === "number") size6 = `${size6}pt`;
        if (typeof weight === "number") weight = weight.toString();
        return {
            family: family,
            size: size6,
            weight: weight,
            style: style3
        };
    }
    static fromCSSString(cssFontShorthand) {
        if (!$a801f2c896bd09f1$var$fontParser) $a801f2c896bd09f1$var$fontParser = document.createElement("span");
        $a801f2c896bd09f1$var$fontParser.style.font = cssFontShorthand;
        const { fontFamily: fontFamily, fontSize: fontSize, fontWeight: fontWeight, fontStyle: fontStyle } = $a801f2c896bd09f1$var$fontParser.style;
        return {
            family: fontFamily,
            size: fontSize,
            weight: fontWeight,
            style: fontStyle
        };
    }
    static toCSSString(fontInfo) {
        var _a;
        if (!fontInfo) return "";
        let style3;
        const st = fontInfo.style;
        if (st === $a801f2c896bd09f1$var$FontStyle.NORMAL || st === "" || st === void 0) style3 = "";
        else style3 = st.trim() + " ";
        let weight;
        const wt = fontInfo.weight;
        if (wt === $a801f2c896bd09f1$var$FontWeight.NORMAL || wt === "" || wt === void 0) weight = "";
        else if (typeof wt === "number") weight = wt + " ";
        else weight = wt.trim() + " ";
        let size6;
        const sz = fontInfo.size;
        if (sz === void 0) size6 = _Font.SIZE + "pt ";
        else if (typeof sz === "number") size6 = sz + "pt ";
        else size6 = sz.trim() + " ";
        const family = (_a = fontInfo.family) !== null && _a !== void 0 ? _a : _Font.SANS_SERIF;
        return `${style3}${weight}${size6}${family}`;
    }
    static scaleSize(fontSize, scaleFactor) {
        if (typeof fontSize === "number") return fontSize * scaleFactor;
        else {
            const value17 = parseFloat(fontSize);
            const unit2 = fontSize.replace(/[\d.\s]/g, "");
            return `${value17 * scaleFactor}${unit2}`;
        }
    }
    static isBold(weight) {
        if (!weight) return false;
        else if (typeof weight === "number") return weight >= 600;
        else {
            const parsedWeight = parseInt(weight, 10);
            if (isNaN(parsedWeight)) return weight.toLowerCase() === "bold";
            else return parsedWeight >= 600;
        }
    }
    static isItalic(style3) {
        if (!style3) return false;
        else return style3.toLowerCase() === $a801f2c896bd09f1$var$FontStyle.ITALIC;
    }
    static loadWebFont(fontName, woffURL, includeWoff2 = true) {
        return $a801f2c896bd09f1$var$__awaiter(this, void 0, void 0, function*() {
            const woff2URL = includeWoff2 ? `url(${woffURL}2) format('woff2'), ` : "";
            const woff1URL = `url(${woffURL}) format('woff')`;
            const woffURLs = woff2URL + woff1URL;
            const fontFace = new FontFace(fontName, woffURLs);
            yield fontFace.load();
            document.fonts.add(fontFace);
            return fontFace;
        });
    }
    static loadWebFonts() {
        return $a801f2c896bd09f1$var$__awaiter(this, void 0, void 0, function*() {
            const host3 = _Font.WEB_FONT_HOST;
            const files2 = _Font.WEB_FONT_FILES;
            for(const fontName in files2){
                const fontPath = files2[fontName];
                _Font.loadWebFont(fontName, host3 + fontPath);
            }
        });
    }
    static load(fontName, data, metrics) {
        let font = $a801f2c896bd09f1$var$Fonts[fontName];
        if (!font) {
            font = new _Font(fontName);
            $a801f2c896bd09f1$var$Fonts[fontName] = font;
        }
        if (data) font.setData(data);
        if (metrics) font.setMetrics(metrics);
        return font;
    }
    constructor(fontName){
        this.name = fontName;
    }
    getName() {
        return this.name;
    }
    getData() {
        return $a801f2c896bd09f1$var$defined(this.data, "FontError", "Missing font data");
    }
    getMetrics() {
        return $a801f2c896bd09f1$var$defined(this.metrics, "FontError", "Missing metrics");
    }
    setData(data) {
        this.data = data;
    }
    setMetrics(metrics) {
        this.metrics = metrics;
    }
    hasData() {
        return this.data !== void 0;
    }
    getResolution() {
        return this.getData().resolution;
    }
    getGlyphs() {
        return this.getData().glyphs;
    }
    lookupMetric(key2, defaultValue4) {
        const keyParts = key2.split(".");
        let currObj = this.getMetrics();
        for(let i2 = 0; i2 < keyParts.length; i2++){
            const keyPart = keyParts[i2];
            const value17 = currObj[keyPart];
            if (value17 === void 0) return defaultValue4;
            currObj = value17;
        }
        return currObj;
    }
    toString() {
        return "[" + this.name + " Font]";
    }
};
$a801f2c896bd09f1$var$Font.SANS_SERIF = "Arial, sans-serif";
$a801f2c896bd09f1$var$Font.SERIF = "Times New Roman, serif";
$a801f2c896bd09f1$var$Font.SIZE = 10;
$a801f2c896bd09f1$var$Font.scaleToPxFrom = {
    pt: 4 / 3,
    px: 1,
    em: 16,
    "%": 0.16,
    in: 96,
    mm: 96 / 25.4,
    cm: 96 / 2.54
};
$a801f2c896bd09f1$var$Font.WEB_FONT_HOST = "https://unpkg.com/vexflow-fonts@1.0.3/";
$a801f2c896bd09f1$var$Font.WEB_FONT_FILES = {
    "Roboto Slab": "robotoslab/RobotoSlab-Medium_2.001.woff",
    PetalumaScript: "petaluma/PetalumaScript_1.10_FS.woff"
};
// node_modules/vexflow/build/esm/src/registry.js
var $a801f2c896bd09f1$var$Index = class {
    constructor(){
        this.id = {};
        this.type = {};
        this.class = {};
    }
};
var $a801f2c896bd09f1$var$Registry = class _Registry {
    static getDefaultRegistry() {
        return _Registry.defaultRegistry;
    }
    static enableDefaultRegistry(registry2) {
        _Registry.defaultRegistry = registry2;
    }
    static disableDefaultRegistry() {
        _Registry.defaultRegistry = void 0;
    }
    constructor(){
        this.index = new $a801f2c896bd09f1$var$Index();
    }
    clear() {
        this.index = new $a801f2c896bd09f1$var$Index();
        return this;
    }
    setIndexValue(name17, value17, id4, elem5) {
        const index5 = this.index;
        if (!index5[name17][value17]) index5[name17][value17] = {};
        index5[name17][value17][id4] = elem5;
    }
    updateIndex({ id: id4, name: name17, value: value17, oldValue: oldValue }) {
        const elem5 = this.getElementById(id4);
        if (oldValue !== void 0 && this.index[name17][oldValue]) delete this.index[name17][oldValue][id4];
        if (value17 && elem5) this.setIndexValue(name17, value17, elem5.getAttribute("id"), elem5);
    }
    register(elem5, id4) {
        id4 = id4 || elem5.getAttribute("id");
        if (!id4) throw new $a801f2c896bd09f1$var$RuntimeError("Can't add element without `id` attribute to registry");
        elem5.setAttribute("id", id4);
        this.setIndexValue("id", id4, id4, elem5);
        this.updateIndex({
            id: id4,
            name: "type",
            value: elem5.getAttribute("type"),
            oldValue: void 0
        });
        elem5.onRegister(this);
        return this;
    }
    getElementById(id4) {
        var _a, _b;
        return (_b = (_a = this.index.id) === null || _a === void 0 ? void 0 : _a[id4]) === null || _b === void 0 ? void 0 : _b[id4];
    }
    getElementsByAttribute(attribute, value17) {
        const index_attr = this.index[attribute];
        if (index_attr) {
            const index_attr_val = index_attr[value17];
            if (index_attr_val) {
                const keys3 = Object.keys(index_attr_val);
                return keys3.map((k2)=>index_attr_val[k2]);
            }
        }
        return [];
    }
    getElementsByType(type) {
        return this.getElementsByAttribute("type", type);
    }
    getElementsByClass(className2) {
        return this.getElementsByAttribute("class", className2);
    }
    onUpdate(info2) {
        const allowedNames = [
            "id",
            "type",
            "class"
        ];
        if (allowedNames.includes(info2.name)) this.updateIndex(info2);
        return this;
    }
};
// node_modules/vexflow/build/esm/src/element.js
var $a801f2c896bd09f1$var$Element = class _Element {
    static get CATEGORY() {
        return "Element";
    }
    static newID() {
        return `auto${_Element.ID++}`;
    }
    constructor(){
        var _a;
        this.children = [];
        this.attrs = {
            id: _Element.newID(),
            type: this.getCategory(),
            class: ""
        };
        this.rendered = false;
        (_a = $a801f2c896bd09f1$var$Registry.getDefaultRegistry()) === null || _a === void 0 || _a.register(this);
    }
    addChildElement(child) {
        this.children.push(child);
        return this;
    }
    getCategory() {
        return this.constructor.CATEGORY;
    }
    setStyle(style3) {
        this.style = style3;
        return this;
    }
    setGroupStyle(style3) {
        this.style = style3;
        this.children.forEach((child)=>child.setGroupStyle(style3));
        return this;
    }
    getStyle() {
        return this.style;
    }
    applyStyle(context = this.context, style3 = this.getStyle()) {
        if (!style3) return this;
        if (!context) return this;
        context.save();
        if (style3.shadowColor) context.setShadowColor(style3.shadowColor);
        if (style3.shadowBlur) context.setShadowBlur(style3.shadowBlur);
        if (style3.fillStyle) context.setFillStyle(style3.fillStyle);
        if (style3.strokeStyle) context.setStrokeStyle(style3.strokeStyle);
        if (style3.lineWidth) context.setLineWidth(style3.lineWidth);
        return this;
    }
    restoreStyle(context = this.context, style3 = this.getStyle()) {
        if (!style3) return this;
        if (!context) return this;
        context.restore();
        return this;
    }
    drawWithStyle() {
        this.checkContext();
        this.applyStyle();
        this.draw();
        this.restoreStyle();
    }
    hasClass(className2) {
        var _a;
        if (!this.attrs.class) return false;
        return ((_a = this.attrs.class) === null || _a === void 0 ? void 0 : _a.split(" ").indexOf(className2)) != -1;
    }
    addClass(className2) {
        var _a;
        if (this.hasClass(className2)) return this;
        if (!this.attrs.class) this.attrs.class = `${className2}`;
        else this.attrs.class = `${this.attrs.class} ${className2}`;
        (_a = this.registry) === null || _a === void 0 || _a.onUpdate({
            id: this.attrs.id,
            name: "class",
            value: className2,
            oldValue: void 0
        });
        return this;
    }
    removeClass(className2) {
        var _a, _b;
        if (!this.hasClass(className2)) return this;
        const arr = (_a = this.attrs.class) === null || _a === void 0 ? void 0 : _a.split(" ");
        if (arr) {
            arr.splice(arr.indexOf(className2));
            this.attrs.class = arr.join(" ");
        }
        (_b = this.registry) === null || _b === void 0 || _b.onUpdate({
            id: this.attrs.id,
            name: "class",
            value: void 0,
            oldValue: className2
        });
        return this;
    }
    onRegister(registry2) {
        this.registry = registry2;
        return this;
    }
    isRendered() {
        return this.rendered;
    }
    setRendered(rendered = true) {
        this.rendered = rendered;
        return this;
    }
    getAttributes() {
        return this.attrs;
    }
    getAttribute(name17) {
        return this.attrs[name17];
    }
    getSVGElement(suffix = "") {
        const id4 = $a801f2c896bd09f1$var$prefix(this.attrs.id + suffix);
        const element4 = document.getElementById(id4);
        if (element4) return element4;
    }
    setAttribute(name17, value17) {
        var _a;
        const oldID = this.attrs.id;
        const oldValue = this.attrs[name17];
        this.attrs[name17] = value17;
        (_a = this.registry) === null || _a === void 0 || _a.onUpdate({
            id: oldID,
            name: name17,
            value: value17,
            oldValue: oldValue
        });
        return this;
    }
    getBoundingBox() {
        return this.boundingBox;
    }
    getContext() {
        return this.context;
    }
    setContext(context) {
        this.context = context;
        return this;
    }
    checkContext() {
        return $a801f2c896bd09f1$var$defined(this.context, "NoContext", "No rendering context attached to instance.");
    }
    set font(f2) {
        this.setFont(f2);
    }
    get font() {
        return $a801f2c896bd09f1$var$Font.toCSSString(this.textFont);
    }
    setFont(font, size6, weight, style3) {
        const defaultTextFont = this.constructor.TEXT_FONT;
        const fontIsObject = typeof font === "object";
        const fontIsString = typeof font === "string";
        const fontIsUndefined = font === void 0;
        const sizeWeightStyleAreUndefined = size6 === void 0 && weight === void 0 && style3 === void 0;
        if (fontIsObject) this.textFont = Object.assign(Object.assign({}, defaultTextFont), font);
        else if (fontIsString && sizeWeightStyleAreUndefined) this.textFont = $a801f2c896bd09f1$var$Font.fromCSSString(font);
        else if (fontIsUndefined && sizeWeightStyleAreUndefined) this.textFont = Object.assign({}, defaultTextFont);
        else this.textFont = $a801f2c896bd09f1$var$Font.validate(font !== null && font !== void 0 ? font : defaultTextFont.family, size6 !== null && size6 !== void 0 ? size6 : defaultTextFont.size, weight !== null && weight !== void 0 ? weight : defaultTextFont.weight, style3 !== null && style3 !== void 0 ? style3 : defaultTextFont.style);
        return this;
    }
    getFont() {
        if (!this.textFont) this.resetFont();
        return $a801f2c896bd09f1$var$Font.toCSSString(this.textFont);
    }
    resetFont() {
        this.setFont();
    }
    get fontInfo() {
        if (!this.textFont) this.resetFont();
        return Object.assign({}, this.textFont);
    }
    set fontInfo(fontInfo) {
        this.setFont(fontInfo);
    }
    setFontSize(size6) {
        const fontInfo = this.fontInfo;
        this.setFont(fontInfo.family, size6, fontInfo.weight, fontInfo.style);
        return this;
    }
    getFontSize() {
        return this.fontSize;
    }
    set fontSize(size6) {
        this.setFontSize(size6);
    }
    get fontSize() {
        let size6 = this.fontInfo.size;
        if (typeof size6 === "number") size6 = `${size6}pt`;
        return size6;
    }
    get fontSizeInPoints() {
        return $a801f2c896bd09f1$var$Font.convertSizeToPointValue(this.fontSize);
    }
    get fontSizeInPixels() {
        return $a801f2c896bd09f1$var$Font.convertSizeToPixelValue(this.fontSize);
    }
    get fontStyle() {
        return this.fontInfo.style;
    }
    set fontStyle(style3) {
        const fontInfo = this.fontInfo;
        this.setFont(fontInfo.family, fontInfo.size, fontInfo.weight, style3);
    }
    get fontWeight() {
        return this.fontInfo.weight + "";
    }
    set fontWeight(weight) {
        const fontInfo = this.fontInfo;
        this.setFont(fontInfo.family, fontInfo.size, weight, fontInfo.style);
    }
};
$a801f2c896bd09f1$var$Element.ID = 1e3;
$a801f2c896bd09f1$var$Element.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SANS_SERIF,
    size: $a801f2c896bd09f1$var$Font.SIZE,
    weight: $a801f2c896bd09f1$var$FontWeight.NORMAL,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
// node_modules/vexflow/build/esm/src/tables.js
var $a801f2c896bd09f1$var$RESOLUTION = 16384;
var $a801f2c896bd09f1$var$durations = {
    "1/2": $a801f2c896bd09f1$var$RESOLUTION * 2,
    1: $a801f2c896bd09f1$var$RESOLUTION / 1,
    2: $a801f2c896bd09f1$var$RESOLUTION / 2,
    4: $a801f2c896bd09f1$var$RESOLUTION / 4,
    8: $a801f2c896bd09f1$var$RESOLUTION / 8,
    16: $a801f2c896bd09f1$var$RESOLUTION / 16,
    32: $a801f2c896bd09f1$var$RESOLUTION / 32,
    64: $a801f2c896bd09f1$var$RESOLUTION / 64,
    128: $a801f2c896bd09f1$var$RESOLUTION / 128,
    256: $a801f2c896bd09f1$var$RESOLUTION / 256
};
var $a801f2c896bd09f1$var$durationAliases = {
    w: "1",
    h: "2",
    q: "4",
    b: "256"
};
var $a801f2c896bd09f1$var$keySignatures = {
    C: {
        num: 0
    },
    Am: {
        num: 0
    },
    F: {
        acc: "b",
        num: 1
    },
    Dm: {
        acc: "b",
        num: 1
    },
    Bb: {
        acc: "b",
        num: 2
    },
    Gm: {
        acc: "b",
        num: 2
    },
    Eb: {
        acc: "b",
        num: 3
    },
    Cm: {
        acc: "b",
        num: 3
    },
    Ab: {
        acc: "b",
        num: 4
    },
    Fm: {
        acc: "b",
        num: 4
    },
    Db: {
        acc: "b",
        num: 5
    },
    Bbm: {
        acc: "b",
        num: 5
    },
    Gb: {
        acc: "b",
        num: 6
    },
    Ebm: {
        acc: "b",
        num: 6
    },
    Cb: {
        acc: "b",
        num: 7
    },
    Abm: {
        acc: "b",
        num: 7
    },
    G: {
        acc: "#",
        num: 1
    },
    Em: {
        acc: "#",
        num: 1
    },
    D: {
        acc: "#",
        num: 2
    },
    Bm: {
        acc: "#",
        num: 2
    },
    A: {
        acc: "#",
        num: 3
    },
    "F#m": {
        acc: "#",
        num: 3
    },
    E: {
        acc: "#",
        num: 4
    },
    "C#m": {
        acc: "#",
        num: 4
    },
    B: {
        acc: "#",
        num: 5
    },
    "G#m": {
        acc: "#",
        num: 5
    },
    "F#": {
        acc: "#",
        num: 6
    },
    "D#m": {
        acc: "#",
        num: 6
    },
    "C#": {
        acc: "#",
        num: 7
    },
    "A#m": {
        acc: "#",
        num: 7
    }
};
var $a801f2c896bd09f1$var$clefs = {
    treble: {
        line_shift: 0
    },
    bass: {
        line_shift: 6
    },
    tenor: {
        line_shift: 4
    },
    alto: {
        line_shift: 3
    },
    soprano: {
        line_shift: 1
    },
    percussion: {
        line_shift: 0
    },
    "mezzo-soprano": {
        line_shift: 2
    },
    "baritone-c": {
        line_shift: 5
    },
    "baritone-f": {
        line_shift: 5
    },
    subbass: {
        line_shift: 7
    },
    french: {
        line_shift: -1
    }
};
var $a801f2c896bd09f1$var$notesInfo = {
    C: {
        index: 0,
        int_val: 0
    },
    CN: {
        index: 0,
        int_val: 0,
        accidental: "n"
    },
    "C#": {
        index: 0,
        int_val: 1,
        accidental: "#"
    },
    "C##": {
        index: 0,
        int_val: 2,
        accidental: "##"
    },
    CB: {
        index: 0,
        int_val: 11,
        accidental: "b"
    },
    CBB: {
        index: 0,
        int_val: 10,
        accidental: "bb"
    },
    D: {
        index: 1,
        int_val: 2
    },
    DN: {
        index: 1,
        int_val: 2,
        accidental: "n"
    },
    "D#": {
        index: 1,
        int_val: 3,
        accidental: "#"
    },
    "D##": {
        index: 1,
        int_val: 4,
        accidental: "##"
    },
    DB: {
        index: 1,
        int_val: 1,
        accidental: "b"
    },
    DBB: {
        index: 1,
        int_val: 0,
        accidental: "bb"
    },
    E: {
        index: 2,
        int_val: 4
    },
    EN: {
        index: 2,
        int_val: 4,
        accidental: "n"
    },
    "E#": {
        index: 2,
        int_val: 5,
        accidental: "#"
    },
    "E##": {
        index: 2,
        int_val: 6,
        accidental: "##"
    },
    EB: {
        index: 2,
        int_val: 3,
        accidental: "b"
    },
    EBB: {
        index: 2,
        int_val: 2,
        accidental: "bb"
    },
    F: {
        index: 3,
        int_val: 5
    },
    FN: {
        index: 3,
        int_val: 5,
        accidental: "n"
    },
    "F#": {
        index: 3,
        int_val: 6,
        accidental: "#"
    },
    "F##": {
        index: 3,
        int_val: 7,
        accidental: "##"
    },
    FB: {
        index: 3,
        int_val: 4,
        accidental: "b"
    },
    FBB: {
        index: 3,
        int_val: 3,
        accidental: "bb"
    },
    G: {
        index: 4,
        int_val: 7
    },
    GN: {
        index: 4,
        int_val: 7,
        accidental: "n"
    },
    "G#": {
        index: 4,
        int_val: 8,
        accidental: "#"
    },
    "G##": {
        index: 4,
        int_val: 9,
        accidental: "##"
    },
    GB: {
        index: 4,
        int_val: 6,
        accidental: "b"
    },
    GBB: {
        index: 4,
        int_val: 5,
        accidental: "bb"
    },
    A: {
        index: 5,
        int_val: 9
    },
    AN: {
        index: 5,
        int_val: 9,
        accidental: "n"
    },
    "A#": {
        index: 5,
        int_val: 10,
        accidental: "#"
    },
    "A##": {
        index: 5,
        int_val: 11,
        accidental: "##"
    },
    AB: {
        index: 5,
        int_val: 8,
        accidental: "b"
    },
    ABB: {
        index: 5,
        int_val: 7,
        accidental: "bb"
    },
    B: {
        index: 6,
        int_val: 11
    },
    BN: {
        index: 6,
        int_val: 11,
        accidental: "n"
    },
    "B#": {
        index: 6,
        int_val: 12,
        accidental: "#"
    },
    "B##": {
        index: 6,
        int_val: 13,
        accidental: "##"
    },
    BB: {
        index: 6,
        int_val: 10,
        accidental: "b"
    },
    BBB: {
        index: 6,
        int_val: 9,
        accidental: "bb"
    },
    R: {
        index: 6,
        rest: true
    },
    X: {
        index: 6,
        accidental: "",
        octave: 4,
        code: "noteheadXBlack",
        shift_right: 5.5
    }
};
var $a801f2c896bd09f1$var$validNoteTypes = {
    n: {
        name: "note"
    },
    r: {
        name: "rest"
    },
    h: {
        name: "harmonic"
    },
    m: {
        name: "muted"
    },
    s: {
        name: "slash"
    },
    g: {
        name: "ghost"
    },
    d: {
        name: "diamond"
    },
    x: {
        name: "x"
    },
    ci: {
        name: "circled"
    },
    cx: {
        name: "circle x"
    },
    sf: {
        name: "slashed"
    },
    sb: {
        name: "slashed backward"
    },
    sq: {
        name: "square"
    },
    tu: {
        name: "triangle up"
    },
    td: {
        name: "triangle down"
    }
};
var $a801f2c896bd09f1$var$accidentals = {
    "#": {
        code: "accidentalSharp",
        parenRightPaddingAdjustment: -1
    },
    "##": {
        code: "accidentalDoubleSharp",
        parenRightPaddingAdjustment: -1
    },
    b: {
        code: "accidentalFlat",
        parenRightPaddingAdjustment: -2
    },
    bb: {
        code: "accidentalDoubleFlat",
        parenRightPaddingAdjustment: -2
    },
    n: {
        code: "accidentalNatural",
        parenRightPaddingAdjustment: -1
    },
    "{": {
        code: "accidentalParensLeft",
        parenRightPaddingAdjustment: -1
    },
    "}": {
        code: "accidentalParensRight",
        parenRightPaddingAdjustment: -1
    },
    db: {
        code: "accidentalThreeQuarterTonesFlatZimmermann",
        parenRightPaddingAdjustment: -1
    },
    d: {
        code: "accidentalQuarterToneFlatStein",
        parenRightPaddingAdjustment: 0
    },
    "++": {
        code: "accidentalThreeQuarterTonesSharpStein",
        parenRightPaddingAdjustment: -1
    },
    "+": {
        code: "accidentalQuarterToneSharpStein",
        parenRightPaddingAdjustment: -1
    },
    "+-": {
        code: "accidentalKucukMucennebSharp",
        parenRightPaddingAdjustment: -1
    },
    bs: {
        code: "accidentalBakiyeFlat",
        parenRightPaddingAdjustment: -1
    },
    bss: {
        code: "accidentalBuyukMucennebFlat",
        parenRightPaddingAdjustment: -1
    },
    o: {
        code: "accidentalSori",
        parenRightPaddingAdjustment: -1
    },
    k: {
        code: "accidentalKoron",
        parenRightPaddingAdjustment: -1
    },
    bbs: {
        code: "vexAccidentalMicrotonal1",
        parenRightPaddingAdjustment: -1
    },
    "++-": {
        code: "accidentalBuyukMucennebSharp",
        parenRightPaddingAdjustment: -1
    },
    ashs: {
        code: "vexAccidentalMicrotonal3",
        parenRightPaddingAdjustment: -1
    },
    afhf: {
        code: "vexAccidentalMicrotonal4",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v7KleismaUp: {
        code: "accSagittal5v7KleismaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v7KleismaDown: {
        code: "accSagittal5v7KleismaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5CommaUp: {
        code: "accSagittal5CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5CommaDown: {
        code: "accSagittal5CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7CommaUp: {
        code: "accSagittal7CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7CommaDown: {
        code: "accSagittal7CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal25SmallDiesisUp: {
        code: "accSagittal25SmallDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal25SmallDiesisDown: {
        code: "accSagittal25SmallDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal35MediumDiesisUp: {
        code: "accSagittal35MediumDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal35MediumDiesisDown: {
        code: "accSagittal35MediumDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11MediumDiesisUp: {
        code: "accSagittal11MediumDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11MediumDiesisDown: {
        code: "accSagittal11MediumDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11LargeDiesisUp: {
        code: "accSagittal11LargeDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11LargeDiesisDown: {
        code: "accSagittal11LargeDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal35LargeDiesisUp: {
        code: "accSagittal35LargeDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal35LargeDiesisDown: {
        code: "accSagittal35LargeDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp25SDown: {
        code: "accSagittalSharp25SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat25SUp: {
        code: "accSagittalFlat25SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp7CDown: {
        code: "accSagittalSharp7CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat7CUp: {
        code: "accSagittalFlat7CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5CDown: {
        code: "accSagittalSharp5CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5CUp: {
        code: "accSagittalFlat5CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v7kDown: {
        code: "accSagittalSharp5v7kDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v7kUp: {
        code: "accSagittalFlat5v7kUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp: {
        code: "accSagittalSharp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat: {
        code: "accSagittalFlat",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v7kUp: {
        code: "accSagittalSharp5v7kUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v7kDown: {
        code: "accSagittalFlat5v7kDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5CUp: {
        code: "accSagittalSharp5CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5CDown: {
        code: "accSagittalFlat5CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp7CUp: {
        code: "accSagittalSharp7CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat7CDown: {
        code: "accSagittalFlat7CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp25SUp: {
        code: "accSagittalSharp25SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat25SDown: {
        code: "accSagittalFlat25SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp35MUp: {
        code: "accSagittalSharp35MUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat35MDown: {
        code: "accSagittalFlat35MDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp11MUp: {
        code: "accSagittalSharp11MUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat11MDown: {
        code: "accSagittalFlat11MDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp11LUp: {
        code: "accSagittalSharp11LUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat11LDown: {
        code: "accSagittalFlat11LDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp35LUp: {
        code: "accSagittalSharp35LUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat35LDown: {
        code: "accSagittalFlat35LDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp25SDown: {
        code: "accSagittalDoubleSharp25SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat25SUp: {
        code: "accSagittalDoubleFlat25SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp7CDown: {
        code: "accSagittalDoubleSharp7CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat7CUp: {
        code: "accSagittalDoubleFlat7CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp5CDown: {
        code: "accSagittalDoubleSharp5CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat5CUp: {
        code: "accSagittalDoubleFlat5CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp5v7kDown: {
        code: "accSagittalDoubleSharp5v7kDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat5v7kUp: {
        code: "accSagittalDoubleFlat5v7kUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp: {
        code: "accSagittalDoubleSharp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat: {
        code: "accSagittalDoubleFlat",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7v11KleismaUp: {
        code: "accSagittal7v11KleismaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7v11KleismaDown: {
        code: "accSagittal7v11KleismaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal17CommaUp: {
        code: "accSagittal17CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal17CommaDown: {
        code: "accSagittal17CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal55CommaUp: {
        code: "accSagittal55CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal55CommaDown: {
        code: "accSagittal55CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7v11CommaUp: {
        code: "accSagittal7v11CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7v11CommaDown: {
        code: "accSagittal7v11CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v11SmallDiesisUp: {
        code: "accSagittal5v11SmallDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v11SmallDiesisDown: {
        code: "accSagittal5v11SmallDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v11SDown: {
        code: "accSagittalSharp5v11SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v11SUp: {
        code: "accSagittalFlat5v11SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp7v11CDown: {
        code: "accSagittalSharp7v11CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat7v11CUp: {
        code: "accSagittalFlat7v11CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp55CDown: {
        code: "accSagittalSharp55CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat55CUp: {
        code: "accSagittalFlat55CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp17CDown: {
        code: "accSagittalSharp17CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat17CUp: {
        code: "accSagittalFlat17CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp7v11kDown: {
        code: "accSagittalSharp7v11kDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat7v11kUp: {
        code: "accSagittalFlat7v11kUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp7v11kUp: {
        code: "accSagittalSharp7v11kUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat7v11kDown: {
        code: "accSagittalFlat7v11kDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp17CUp: {
        code: "accSagittalSharp17CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat17CDown: {
        code: "accSagittalFlat17CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp55CUp: {
        code: "accSagittalSharp55CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat55CDown: {
        code: "accSagittalFlat55CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp7v11CUp: {
        code: "accSagittalSharp7v11CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat7v11CDown: {
        code: "accSagittalFlat7v11CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v11SUp: {
        code: "accSagittalSharp5v11SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v11SDown: {
        code: "accSagittalFlat5v11SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp5v11SDown: {
        code: "accSagittalDoubleSharp5v11SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat5v11SUp: {
        code: "accSagittalDoubleFlat5v11SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp7v11CDown: {
        code: "accSagittalDoubleSharp7v11CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat7v11CUp: {
        code: "accSagittalDoubleFlat7v11CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp55CDown: {
        code: "accSagittalDoubleSharp55CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat55CUp: {
        code: "accSagittalDoubleFlat55CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp17CDown: {
        code: "accSagittalDoubleSharp17CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat17CUp: {
        code: "accSagittalDoubleFlat17CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp7v11kDown: {
        code: "accSagittalDoubleSharp7v11kDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat7v11kUp: {
        code: "accSagittalDoubleFlat7v11kUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal23CommaUp: {
        code: "accSagittal23CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal23CommaDown: {
        code: "accSagittal23CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v19CommaUp: {
        code: "accSagittal5v19CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v19CommaDown: {
        code: "accSagittal5v19CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v23SmallDiesisUp: {
        code: "accSagittal5v23SmallDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v23SmallDiesisDown: {
        code: "accSagittal5v23SmallDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v23SDown: {
        code: "accSagittalSharp5v23SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v23SUp: {
        code: "accSagittalFlat5v23SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v19CDown: {
        code: "accSagittalSharp5v19CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v19CUp: {
        code: "accSagittalFlat5v19CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp23CDown: {
        code: "accSagittalSharp23CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat23CUp: {
        code: "accSagittalFlat23CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp23CUp: {
        code: "accSagittalSharp23CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat23CDown: {
        code: "accSagittalFlat23CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v19CUp: {
        code: "accSagittalSharp5v19CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v19CDown: {
        code: "accSagittalFlat5v19CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v23SUp: {
        code: "accSagittalSharp5v23SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v23SDown: {
        code: "accSagittalFlat5v23SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp5v23SDown: {
        code: "accSagittalDoubleSharp5v23SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat5v23SUp: {
        code: "accSagittalDoubleFlat5v23SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp5v19CDown: {
        code: "accSagittalDoubleSharp5v19CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat5v19CUp: {
        code: "accSagittalDoubleFlat5v19CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp23CDown: {
        code: "accSagittalDoubleSharp23CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat23CUp: {
        code: "accSagittalDoubleFlat23CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal19SchismaUp: {
        code: "accSagittal19SchismaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal19SchismaDown: {
        code: "accSagittal19SchismaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal17KleismaUp: {
        code: "accSagittal17KleismaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal17KleismaDown: {
        code: "accSagittal17KleismaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal143CommaUp: {
        code: "accSagittal143CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal143CommaDown: {
        code: "accSagittal143CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11v49CommaUp: {
        code: "accSagittal11v49CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11v49CommaDown: {
        code: "accSagittal11v49CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal19CommaUp: {
        code: "accSagittal19CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal19CommaDown: {
        code: "accSagittal19CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7v19CommaUp: {
        code: "accSagittal7v19CommaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7v19CommaDown: {
        code: "accSagittal7v19CommaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal49SmallDiesisUp: {
        code: "accSagittal49SmallDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal49SmallDiesisDown: {
        code: "accSagittal49SmallDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal23SmallDiesisUp: {
        code: "accSagittal23SmallDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal23SmallDiesisDown: {
        code: "accSagittal23SmallDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v13MediumDiesisUp: {
        code: "accSagittal5v13MediumDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v13MediumDiesisDown: {
        code: "accSagittal5v13MediumDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11v19MediumDiesisUp: {
        code: "accSagittal11v19MediumDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11v19MediumDiesisDown: {
        code: "accSagittal11v19MediumDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal49MediumDiesisUp: {
        code: "accSagittal49MediumDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal49MediumDiesisDown: {
        code: "accSagittal49MediumDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v49MediumDiesisUp: {
        code: "accSagittal5v49MediumDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v49MediumDiesisDown: {
        code: "accSagittal5v49MediumDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal49LargeDiesisUp: {
        code: "accSagittal49LargeDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal49LargeDiesisDown: {
        code: "accSagittal49LargeDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11v19LargeDiesisUp: {
        code: "accSagittal11v19LargeDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal11v19LargeDiesisDown: {
        code: "accSagittal11v19LargeDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v13LargeDiesisUp: {
        code: "accSagittal5v13LargeDiesisUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5v13LargeDiesisDown: {
        code: "accSagittal5v13LargeDiesisDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp23SDown: {
        code: "accSagittalSharp23SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat23SUp: {
        code: "accSagittalFlat23SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp49SDown: {
        code: "accSagittalSharp49SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat49SUp: {
        code: "accSagittalFlat49SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp7v19CDown: {
        code: "accSagittalSharp7v19CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat7v19CUp: {
        code: "accSagittalFlat7v19CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp19CDown: {
        code: "accSagittalSharp19CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat19CUp: {
        code: "accSagittalFlat19CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp11v49CDown: {
        code: "accSagittalSharp11v49CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat11v49CUp: {
        code: "accSagittalFlat11v49CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp143CDown: {
        code: "accSagittalSharp143CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat143CUp: {
        code: "accSagittalFlat143CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp17kDown: {
        code: "accSagittalSharp17kDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat17kUp: {
        code: "accSagittalFlat17kUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp19sDown: {
        code: "accSagittalSharp19sDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat19sUp: {
        code: "accSagittalFlat19sUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp19sUp: {
        code: "accSagittalSharp19sUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat19sDown: {
        code: "accSagittalFlat19sDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp17kUp: {
        code: "accSagittalSharp17kUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat17kDown: {
        code: "accSagittalFlat17kDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp143CUp: {
        code: "accSagittalSharp143CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat143CDown: {
        code: "accSagittalFlat143CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp11v49CUp: {
        code: "accSagittalSharp11v49CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat11v49CDown: {
        code: "accSagittalFlat11v49CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp19CUp: {
        code: "accSagittalSharp19CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat19CDown: {
        code: "accSagittalFlat19CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp7v19CUp: {
        code: "accSagittalSharp7v19CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat7v19CDown: {
        code: "accSagittalFlat7v19CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp49SUp: {
        code: "accSagittalSharp49SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat49SDown: {
        code: "accSagittalFlat49SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp23SUp: {
        code: "accSagittalSharp23SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat23SDown: {
        code: "accSagittalFlat23SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v13MUp: {
        code: "accSagittalSharp5v13MUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v13MDown: {
        code: "accSagittalFlat5v13MDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp11v19MUp: {
        code: "accSagittalSharp11v19MUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat11v19MDown: {
        code: "accSagittalFlat11v19MDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp49MUp: {
        code: "accSagittalSharp49MUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat49MDown: {
        code: "accSagittalFlat49MDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v49MUp: {
        code: "accSagittalSharp5v49MUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v49MDown: {
        code: "accSagittalFlat5v49MDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp49LUp: {
        code: "accSagittalSharp49LUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat49LDown: {
        code: "accSagittalFlat49LDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp11v19LUp: {
        code: "accSagittalSharp11v19LUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat11v19LDown: {
        code: "accSagittalFlat11v19LDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalSharp5v13LUp: {
        code: "accSagittalSharp5v13LUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFlat5v13LDown: {
        code: "accSagittalFlat5v13LDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp23SDown: {
        code: "accSagittalDoubleSharp23SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat23SUp: {
        code: "accSagittalDoubleFlat23SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp49SDown: {
        code: "accSagittalDoubleSharp49SDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat49SUp: {
        code: "accSagittalDoubleFlat49SUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp7v19CDown: {
        code: "accSagittalDoubleSharp7v19CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat7v19CUp: {
        code: "accSagittalDoubleFlat7v19CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp19CDown: {
        code: "accSagittalDoubleSharp19CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat19CUp: {
        code: "accSagittalDoubleFlat19CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp11v49CDown: {
        code: "accSagittalDoubleSharp11v49CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat11v49CUp: {
        code: "accSagittalDoubleFlat11v49CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp143CDown: {
        code: "accSagittalDoubleSharp143CDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat143CUp: {
        code: "accSagittalDoubleFlat143CUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp17kDown: {
        code: "accSagittalDoubleSharp17kDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat17kUp: {
        code: "accSagittalDoubleFlat17kUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleSharp19sDown: {
        code: "accSagittalDoubleSharp19sDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalDoubleFlat19sUp: {
        code: "accSagittalDoubleFlat19sUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalShaftUp: {
        code: "accSagittalShaftUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalShaftDown: {
        code: "accSagittalShaftDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalAcute: {
        code: "accSagittalAcute",
        parenRightPaddingAdjustment: -1
    },
    accSagittalGrave: {
        code: "accSagittalGrave",
        parenRightPaddingAdjustment: -1
    },
    accSagittal1MinaUp: {
        code: "accSagittal1MinaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal1MinaDown: {
        code: "accSagittal1MinaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal2MinasUp: {
        code: "accSagittal2MinasUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal2MinasDown: {
        code: "accSagittal2MinasDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal1TinaUp: {
        code: "accSagittal1TinaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal1TinaDown: {
        code: "accSagittal1TinaDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal2TinasUp: {
        code: "accSagittal2TinasUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal2TinasDown: {
        code: "accSagittal2TinasDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal3TinasUp: {
        code: "accSagittal3TinasUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal3TinasDown: {
        code: "accSagittal3TinasDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal4TinasUp: {
        code: "accSagittal4TinasUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal4TinasDown: {
        code: "accSagittal4TinasDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5TinasUp: {
        code: "accSagittal5TinasUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal5TinasDown: {
        code: "accSagittal5TinasDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal6TinasUp: {
        code: "accSagittal6TinasUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal6TinasDown: {
        code: "accSagittal6TinasDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7TinasUp: {
        code: "accSagittal7TinasUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal7TinasDown: {
        code: "accSagittal7TinasDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal8TinasUp: {
        code: "accSagittal8TinasUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal8TinasDown: {
        code: "accSagittal8TinasDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittal9TinasUp: {
        code: "accSagittal9TinasUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittal9TinasDown: {
        code: "accSagittal9TinasDown",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFractionalTinaUp: {
        code: "accSagittalFractionalTinaUp",
        parenRightPaddingAdjustment: -1
    },
    accSagittalFractionalTinaDown: {
        code: "accSagittalFractionalTinaDown",
        parenRightPaddingAdjustment: -1
    },
    accidentalNarrowReversedFlat: {
        code: "accidentalNarrowReversedFlat",
        parenRightPaddingAdjustment: -1
    },
    accidentalNarrowReversedFlatAndFlat: {
        code: "accidentalNarrowReversedFlatAndFlat",
        parenRightPaddingAdjustment: -1
    },
    accidentalWilsonPlus: {
        code: "accidentalWilsonPlus",
        parenRightPaddingAdjustment: -1
    },
    accidentalWilsonMinus: {
        code: "accidentalWilsonMinus",
        parenRightPaddingAdjustment: -1
    }
};
var $a801f2c896bd09f1$var$accidentalColumns = {
    1: {
        a: [
            1
        ],
        b: [
            1
        ]
    },
    2: {
        a: [
            1,
            2
        ]
    },
    3: {
        a: [
            1,
            3,
            2
        ],
        b: [
            1,
            2,
            1
        ],
        second_on_bottom: [
            1,
            2,
            3
        ]
    },
    4: {
        a: [
            1,
            3,
            4,
            2
        ],
        b: [
            1,
            2,
            3,
            1
        ],
        spaced_out_tetrachord: [
            1,
            2,
            1,
            2
        ]
    },
    5: {
        a: [
            1,
            3,
            5,
            4,
            2
        ],
        b: [
            1,
            2,
            4,
            3,
            1
        ],
        spaced_out_pentachord: [
            1,
            2,
            3,
            2,
            1
        ],
        very_spaced_out_pentachord: [
            1,
            2,
            1,
            2,
            1
        ]
    },
    6: {
        a: [
            1,
            3,
            5,
            6,
            4,
            2
        ],
        b: [
            1,
            2,
            4,
            5,
            3,
            1
        ],
        spaced_out_hexachord: [
            1,
            3,
            2,
            1,
            3,
            2
        ],
        very_spaced_out_hexachord: [
            1,
            2,
            1,
            2,
            1,
            2
        ]
    }
};
var $a801f2c896bd09f1$var$articulations = {
    "a.": {
        code: "augmentationDot",
        between_lines: true
    },
    av: {
        aboveCode: "articStaccatissimoAbove",
        belowCode: "articStaccatissimoBelow",
        between_lines: true
    },
    "a>": {
        aboveCode: "articAccentAbove",
        belowCode: "articAccentBelow",
        between_lines: true
    },
    "a-": {
        aboveCode: "articTenutoAbove",
        belowCode: "articTenutoBelow",
        between_lines: true
    },
    "a^": {
        aboveCode: "articMarcatoAbove",
        belowCode: "articMarcatoBelow",
        between_lines: false
    },
    "a+": {
        code: "pluckedLeftHandPizzicato",
        between_lines: false
    },
    ao: {
        aboveCode: "pluckedSnapPizzicatoAbove",
        belowCode: "pluckedSnapPizzicatoBelow",
        between_lines: false
    },
    ah: {
        code: "stringsHarmonic",
        between_lines: false
    },
    "a@": {
        aboveCode: "fermataAbove",
        belowCode: "fermataBelow",
        between_lines: false
    },
    "a@a": {
        code: "fermataAbove",
        between_lines: false
    },
    "a@u": {
        code: "fermataBelow",
        between_lines: false
    },
    "a@s": {
        aboveCode: "fermataShortAbove",
        belowCode: "fermataShortBelow",
        between_lines: false
    },
    "a@as": {
        code: "fermataShortAbove",
        between_lines: false
    },
    "a@us": {
        code: "fermataShortBelow",
        between_lines: false
    },
    "a@l": {
        aboveCode: "fermataLongAbove",
        belowCode: "fermataLongBelow",
        between_lines: false
    },
    "a@al": {
        code: "fermataLongAbove",
        between_lines: false
    },
    "a@ul": {
        code: "fermataLongBelow",
        between_lines: false
    },
    "a@vl": {
        aboveCode: "fermataVeryLongAbove",
        belowCode: "fermataVeryLongBelow",
        between_lines: false
    },
    "a@avl": {
        code: "fermataVeryLongAbove",
        between_lines: false
    },
    "a@uvl": {
        code: "fermataVeryLongBelow",
        between_lines: false
    },
    "a|": {
        code: "stringsUpBow",
        between_lines: false
    },
    am: {
        code: "stringsDownBow",
        between_lines: false
    },
    "a,": {
        code: "pictChokeCymbal",
        between_lines: false
    }
};
var $a801f2c896bd09f1$var$ornaments = {
    mordent: {
        code: "ornamentShortTrill"
    },
    mordent_inverted: {
        code: "ornamentMordent"
    },
    turn: {
        code: "ornamentTurn"
    },
    turn_inverted: {
        code: "ornamentTurnSlash"
    },
    tr: {
        code: "ornamentTrill"
    },
    upprall: {
        code: "ornamentPrecompSlideTrillDAnglebert"
    },
    downprall: {
        code: "ornamentPrecompDoubleCadenceUpperPrefix"
    },
    prallup: {
        code: "ornamentPrecompTrillSuffixDandrieu"
    },
    pralldown: {
        code: "ornamentPrecompTrillLowerSuffix"
    },
    upmordent: {
        code: "ornamentPrecompSlideTrillBach"
    },
    downmordent: {
        code: "ornamentPrecompDoubleCadenceUpperPrefixTurn"
    },
    lineprall: {
        code: "ornamentPrecompAppoggTrill"
    },
    prallprall: {
        code: "ornamentTremblement"
    },
    scoop: {
        code: "brassScoop"
    },
    doit: {
        code: "brassDoitMedium"
    },
    fall: {
        code: "brassFallLipShort"
    },
    doitLong: {
        code: "brassLiftMedium"
    },
    fallLong: {
        code: "brassFallRoughMedium"
    },
    bend: {
        code: "brassBend"
    },
    plungerClosed: {
        code: "brassMuteClosed"
    },
    plungerOpen: {
        code: "brassMuteOpen"
    },
    flip: {
        code: "brassFlip"
    },
    jazzTurn: {
        code: "brassJazzTurn"
    },
    smear: {
        code: "brassSmear"
    }
};
var $a801f2c896bd09f1$var$Tables = class _Tables {
    static currentMusicFont() {
        if (_Tables.MUSIC_FONT_STACK.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("NoFonts", "The font stack is empty. See: await Flow.fetchMusicFont(...); Flow.setMusicFont(...).");
        else return _Tables.MUSIC_FONT_STACK[0];
    }
    static clefProperties(clef) {
        if (!clef || !(clef in $a801f2c896bd09f1$var$clefs)) throw new $a801f2c896bd09f1$var$RuntimeError("BadArgument", "Invalid clef: " + clef);
        return $a801f2c896bd09f1$var$clefs[clef];
    }
    static keyProperties(keyOctaveGlyph, clef = "treble", params) {
        let options2 = {
            octave_shift: 0,
            duration: "4"
        };
        if (typeof params === "object") options2 = Object.assign(Object.assign({}, options2), params);
        const duration2 = _Tables.sanitizeDuration(options2.duration);
        const pieces = keyOctaveGlyph.split("/");
        if (pieces.length < 2) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `First argument must be note/octave or note/octave/glyph-code: ${keyOctaveGlyph}`);
        const key2 = pieces[0].toUpperCase();
        const value17 = $a801f2c896bd09f1$var$notesInfo[key2];
        if (!value17) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Invalid key name: " + key2);
        if (value17.octave) pieces[1] = value17.octave.toString();
        let octave = parseInt(pieces[1], 10);
        octave -= options2.octave_shift;
        const baseIndex = octave * 7 - 28;
        let line2 = (baseIndex + value17.index) / 2;
        line2 += _Tables.clefProperties(clef).line_shift;
        let stroke2 = 0;
        if (line2 <= 0 && line2 * 2 % 2 === 0) stroke2 = 1;
        if (line2 >= 6 && line2 * 2 % 2 === 0) stroke2 = -1;
        const int_value = typeof value17.int_val !== "undefined" ? octave * 12 + value17.int_val : void 0;
        const code3 = value17.code;
        const shift_right = value17.shift_right;
        let customNoteHeadProps = {};
        if (pieces.length > 2 && pieces[2]) {
            const glyphName = pieces[2].toUpperCase();
            customNoteHeadProps = {
                code: this.codeNoteHead(glyphName, duration2)
            };
        }
        return Object.assign({
            key: key2,
            octave: octave,
            line: line2,
            int_value: int_value,
            accidental: value17.accidental,
            code: code3,
            stroke: stroke2,
            shift_right: shift_right,
            displaced: false
        }, customNoteHeadProps);
    }
    static integerToNote(integer) {
        if (typeof integer === "undefined" || integer < 0 || integer > 11) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `integerToNote() requires an integer in the range [0, 11]: ${integer}`);
        const table2 = {
            0: "C",
            1: "C#",
            2: "D",
            3: "D#",
            4: "E",
            5: "F",
            6: "F#",
            7: "G",
            8: "G#",
            9: "A",
            10: "A#",
            11: "B"
        };
        const noteValue = table2[integer];
        if (!noteValue) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Unknown note value for integer: ${integer}`);
        return noteValue;
    }
    static tabToGlyphProps(fret, scale = 1) {
        let glyph = void 0;
        let width9 = 0;
        let shift_y = 0;
        if (fret.toUpperCase() === "X") {
            const glyphMetrics = new $a801f2c896bd09f1$var$Glyph("accidentalDoubleSharp", _Tables.TABLATURE_FONT_SCALE).getMetrics();
            glyph = "accidentalDoubleSharp";
            if (glyphMetrics.width == void 0 || glyphMetrics.height == void 0) throw new $a801f2c896bd09f1$var$RuntimeError("InvalidMetrics", "Width and height required");
            width9 = glyphMetrics.width;
            shift_y = -glyphMetrics.height / 2;
        } else width9 = _Tables.textWidth(fret);
        return {
            text: fret,
            code: glyph,
            getWidth: ()=>width9 * scale,
            shift_y: shift_y
        };
    }
    static textWidth(text7) {
        return 7 * text7.toString().length;
    }
    static articulationCodes(artic) {
        return $a801f2c896bd09f1$var$articulations[artic];
    }
    static accidentalCodes(acc) {
        return $a801f2c896bd09f1$var$accidentals[acc];
    }
    static ornamentCodes(acc) {
        return $a801f2c896bd09f1$var$ornaments[acc];
    }
    static keySignature(spec) {
        const keySpec = $a801f2c896bd09f1$var$keySignatures[spec];
        if (!keySpec) throw new $a801f2c896bd09f1$var$RuntimeError("BadKeySignature", `Bad key signature spec: '${spec}'`);
        if (!keySpec.acc) return [];
        const accidentalList = {
            b: [
                2,
                0.5,
                2.5,
                1,
                3,
                1.5,
                3.5
            ],
            "#": [
                0,
                1.5,
                -0.5,
                1,
                2.5,
                0.5,
                2
            ]
        };
        const notes = accidentalList[keySpec.acc];
        const acc_list = [];
        for(let i2 = 0; i2 < keySpec.num; ++i2){
            const line2 = notes[i2];
            acc_list.push({
                type: keySpec.acc,
                line: line2
            });
        }
        return acc_list;
    }
    static getKeySignatures() {
        return $a801f2c896bd09f1$var$keySignatures;
    }
    static hasKeySignature(spec) {
        return spec in $a801f2c896bd09f1$var$keySignatures;
    }
    static sanitizeDuration(duration2) {
        const durationNumber = $a801f2c896bd09f1$var$durationAliases[duration2];
        if (durationNumber !== void 0) duration2 = durationNumber;
        if ($a801f2c896bd09f1$var$durations[duration2] === void 0) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `The provided duration is not valid: ${duration2}`);
        return duration2;
    }
    static durationToFraction(duration2) {
        return new $a801f2c896bd09f1$var$Fraction().parse(_Tables.sanitizeDuration(duration2));
    }
    static durationToNumber(duration2) {
        return _Tables.durationToFraction(duration2).value();
    }
    static durationToTicks(duration2) {
        duration2 = _Tables.sanitizeDuration(duration2);
        const ticks = $a801f2c896bd09f1$var$durations[duration2];
        if (ticks === void 0) throw new $a801f2c896bd09f1$var$RuntimeError("InvalidDuration");
        return ticks;
    }
    static codeNoteHead(type, duration2) {
        let code3 = "";
        switch(type){
            case "D0":
                code3 = "noteheadDiamondWhole";
                break;
            case "D1":
                code3 = "noteheadDiamondHalf";
                break;
            case "D2":
                code3 = "noteheadDiamondBlack";
                break;
            case "D3":
                code3 = "noteheadDiamondBlack";
                break;
            case "T0":
                code3 = "noteheadTriangleUpWhole";
                break;
            case "T1":
                code3 = "noteheadTriangleUpHalf";
                break;
            case "T2":
                code3 = "noteheadTriangleUpBlack";
                break;
            case "T3":
                code3 = "noteheadTriangleUpBlack";
                break;
            case "X0":
                code3 = "noteheadXWhole";
                break;
            case "X1":
                code3 = "noteheadXHalf";
                break;
            case "X2":
                code3 = "noteheadXBlack";
                break;
            case "X3":
                code3 = "noteheadCircleX";
                break;
            case "S1":
                code3 = "noteheadSquareWhite";
                break;
            case "S2":
                code3 = "noteheadSquareBlack";
                break;
            case "R1":
                code3 = "vexNoteHeadRectWhite";
                break;
            case "R2":
                code3 = "vexNoteHeadRectBlack";
                break;
            case "DO":
                code3 = "noteheadTriangleUpBlack";
                break;
            case "RE":
                code3 = "noteheadMoonBlack";
                break;
            case "MI":
                code3 = "noteheadDiamondBlack";
                break;
            case "FA":
                code3 = "noteheadTriangleLeftBlack";
                break;
            case "FAUP":
                code3 = "noteheadTriangleRightBlack";
                break;
            case "SO":
                code3 = "noteheadBlack";
                break;
            case "LA":
                code3 = "noteheadSquareBlack";
                break;
            case "TI":
                code3 = "noteheadTriangleRoundDownBlack";
                break;
            case "D":
            case "H":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadDiamondDoubleWhole";
                        break;
                    case "1":
                        code3 = "noteheadDiamondWhole";
                        break;
                    case "2":
                        code3 = "noteheadDiamondHalf";
                        break;
                    default:
                        code3 = "noteheadDiamondBlack";
                        break;
                }
                break;
            case "N":
            case "G":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadDoubleWhole";
                        break;
                    case "1":
                        code3 = "noteheadWhole";
                        break;
                    case "2":
                        code3 = "noteheadHalf";
                        break;
                    default:
                        code3 = "noteheadBlack";
                        break;
                }
                break;
            case "M":
            case "X":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadXDoubleWhole";
                        break;
                    case "1":
                        code3 = "noteheadXWhole";
                        break;
                    case "2":
                        code3 = "noteheadXHalf";
                        break;
                    default:
                        code3 = "noteheadXBlack";
                        break;
                }
                break;
            case "CX":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadCircleXDoubleWhole";
                        break;
                    case "1":
                        code3 = "noteheadCircleXWhole";
                        break;
                    case "2":
                        code3 = "noteheadCircleXHalf";
                        break;
                    default:
                        code3 = "noteheadCircleX";
                        break;
                }
                break;
            case "CI":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadCircledDoubleWhole";
                        break;
                    case "1":
                        code3 = "noteheadCircledWhole";
                        break;
                    case "2":
                        code3 = "noteheadCircledHalf";
                        break;
                    default:
                        code3 = "noteheadCircledBlack";
                        break;
                }
                break;
            case "SQ":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadDoubleWholeSquare";
                        break;
                    case "1":
                        code3 = "noteheadSquareWhite";
                        break;
                    case "2":
                        code3 = "noteheadSquareWhite";
                        break;
                    default:
                        code3 = "noteheadSquareBlack";
                        break;
                }
                break;
            case "TU":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadTriangleUpDoubleWhole";
                        break;
                    case "1":
                        code3 = "noteheadTriangleUpWhole";
                        break;
                    case "2":
                        code3 = "noteheadTriangleUpHalf";
                        break;
                    default:
                        code3 = "noteheadTriangleUpBlack";
                        break;
                }
                break;
            case "TD":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadTriangleDownDoubleWhole";
                        break;
                    case "1":
                        code3 = "noteheadTriangleDownWhole";
                        break;
                    case "2":
                        code3 = "noteheadTriangleDownHalf";
                        break;
                    default:
                        code3 = "noteheadTriangleDownBlack";
                        break;
                }
                break;
            case "SF":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadSlashedDoubleWhole1";
                        break;
                    case "1":
                        code3 = "noteheadSlashedWhole1";
                        break;
                    case "2":
                        code3 = "noteheadSlashedHalf1";
                        break;
                    default:
                        code3 = "noteheadSlashedBlack1";
                }
                break;
            case "SB":
                switch(duration2){
                    case "1/2":
                        code3 = "noteheadSlashedDoubleWhole2";
                        break;
                    case "1":
                        code3 = "noteheadSlashedWhole2";
                        break;
                    case "2":
                        code3 = "noteheadSlashedHalf2";
                        break;
                    default:
                        code3 = "noteheadSlashedBlack2";
                }
                break;
        }
        return code3;
    }
    static getGlyphProps(duration2, type = "n") {
        duration2 = _Tables.sanitizeDuration(duration2);
        let code3 = $a801f2c896bd09f1$var$durationCodes[duration2];
        if (code3 === void 0) code3 = $a801f2c896bd09f1$var$durationCodes["4"];
        let glyphTypeProperties = code3[type];
        const codeNoteHead = _Tables.codeNoteHead(type.toUpperCase(), duration2);
        if (codeNoteHead != "") glyphTypeProperties = Object.assign(Object.assign({}, glyphTypeProperties), {
            code_head: codeNoteHead,
            code: codeNoteHead
        });
        const code_head = glyphTypeProperties.code_head;
        const getWidth = (scale = _Tables.NOTATION_FONT_SCALE)=>$a801f2c896bd09f1$var$Glyph.getWidth(code_head, scale);
        return Object.assign(Object.assign(Object.assign({}, code3.common), {
            getWidth: getWidth
        }), glyphTypeProperties);
    }
};
$a801f2c896bd09f1$var$Tables.UNISON = true;
$a801f2c896bd09f1$var$Tables.SOFTMAX_FACTOR = 10;
$a801f2c896bd09f1$var$Tables.STEM_WIDTH = 1.5;
$a801f2c896bd09f1$var$Tables.STEM_HEIGHT = 35;
$a801f2c896bd09f1$var$Tables.STAVE_LINE_THICKNESS = 1;
$a801f2c896bd09f1$var$Tables.RENDER_PRECISION_PLACES = 3;
$a801f2c896bd09f1$var$Tables.RESOLUTION = $a801f2c896bd09f1$var$RESOLUTION;
$a801f2c896bd09f1$var$Tables.MUSIC_FONT_STACK = [];
$a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE = 39;
$a801f2c896bd09f1$var$Tables.TABLATURE_FONT_SCALE = 39;
$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH = 15;
$a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE = 10;
$a801f2c896bd09f1$var$Tables.TEXT_HEIGHT_OFFSET_HACK = 1;
$a801f2c896bd09f1$var$Tables.accidentalMap = $a801f2c896bd09f1$var$accidentals;
$a801f2c896bd09f1$var$Tables.accidentalColumnsTable = $a801f2c896bd09f1$var$accidentalColumns;
$a801f2c896bd09f1$var$Tables.unicode = {
    sharp: String.fromCharCode(9839),
    flat: String.fromCharCode(9837),
    natural: String.fromCharCode(9838),
    triangle: String.fromCharCode(9651),
    "o-with-slash": String.fromCharCode(248),
    degrees: String.fromCharCode(176),
    circle: String.fromCharCode(9675)
};
$a801f2c896bd09f1$var$Tables.validTypes = $a801f2c896bd09f1$var$validNoteTypes;
$a801f2c896bd09f1$var$Tables.TIME4_4 = {
    num_beats: 4,
    beat_value: 4,
    resolution: $a801f2c896bd09f1$var$RESOLUTION
};
var $a801f2c896bd09f1$var$durationCodes = {
    "1/2": {
        common: {
            code_head: "",
            stem: false,
            flag: false,
            stem_up_extension: -$a801f2c896bd09f1$var$Tables.STEM_HEIGHT,
            stem_down_extension: -$a801f2c896bd09f1$var$Tables.STEM_HEIGHT,
            tabnote_stem_up_extension: -$a801f2c896bd09f1$var$Tables.STEM_HEIGHT,
            tabnote_stem_down_extension: -$a801f2c896bd09f1$var$Tables.STEM_HEIGHT,
            dot_shiftY: 0,
            line_above: 0,
            line_below: 0
        },
        r: {
            code_head: "restDoubleWhole",
            rest: true,
            position: "B/5",
            dot_shiftY: 0.5
        },
        s: {
            getWidth: ()=>$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH,
            position: "B/4"
        }
    },
    1: {
        common: {
            code_head: "",
            stem: false,
            flag: false,
            stem_up_extension: -$a801f2c896bd09f1$var$Tables.STEM_HEIGHT,
            stem_down_extension: -$a801f2c896bd09f1$var$Tables.STEM_HEIGHT,
            tabnote_stem_up_extension: -$a801f2c896bd09f1$var$Tables.STEM_HEIGHT,
            tabnote_stem_down_extension: -$a801f2c896bd09f1$var$Tables.STEM_HEIGHT,
            dot_shiftY: 0,
            line_above: 0,
            line_below: 0
        },
        r: {
            code_head: "restWhole",
            ledger_code_head: "restWholeLegerLine",
            rest: true,
            position: "D/5",
            dot_shiftY: 0.5
        },
        s: {
            getWidth: ()=>$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH,
            position: "B/4"
        }
    },
    2: {
        common: {
            code_head: "",
            stem: true,
            flag: false,
            stem_up_extension: 0,
            stem_down_extension: 0,
            tabnote_stem_up_extension: 0,
            tabnote_stem_down_extension: 0,
            dot_shiftY: 0,
            line_above: 0,
            line_below: 0
        },
        r: {
            code_head: "restHalf",
            ledger_code_head: "restHalfLegerLine",
            stem: false,
            rest: true,
            position: "B/4",
            dot_shiftY: -0.5
        },
        s: {
            getWidth: ()=>$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH,
            position: "B/4"
        }
    },
    4: {
        common: {
            code_head: "",
            stem: true,
            flag: false,
            stem_up_extension: 0,
            stem_down_extension: 0,
            tabnote_stem_up_extension: 0,
            tabnote_stem_down_extension: 0,
            dot_shiftY: 0,
            line_above: 0,
            line_below: 0
        },
        r: {
            code_head: "restQuarter",
            stem: false,
            rest: true,
            position: "B/4",
            dot_shiftY: -0.5,
            line_above: 1.5,
            line_below: 1.5
        },
        s: {
            getWidth: ()=>$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH,
            position: "B/4"
        }
    },
    8: {
        common: {
            code_head: "",
            stem: true,
            flag: true,
            beam_count: 1,
            stem_beam_extension: 0,
            code_flag_upstem: "flag8thUp",
            code_flag_downstem: "flag8thDown",
            stem_up_extension: 0,
            stem_down_extension: 0,
            tabnote_stem_up_extension: 0,
            tabnote_stem_down_extension: 0,
            dot_shiftY: 0,
            line_above: 0,
            line_below: 0
        },
        r: {
            code_head: "rest8th",
            stem: false,
            flag: false,
            rest: true,
            position: "B/4",
            dot_shiftY: -0.5,
            line_above: 1,
            line_below: 1
        },
        s: {
            getWidth: ()=>$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH,
            position: "B/4"
        }
    },
    16: {
        common: {
            code_head: "",
            beam_count: 2,
            stem_beam_extension: 0,
            stem: true,
            flag: true,
            code_flag_upstem: "flag16thUp",
            code_flag_downstem: "flag16thDown",
            stem_up_extension: 0,
            stem_down_extension: 0,
            tabnote_stem_up_extension: 0,
            tabnote_stem_down_extension: 0,
            dot_shiftY: 0,
            line_above: 0,
            line_below: 0
        },
        r: {
            code_head: "rest16th",
            stem: false,
            flag: false,
            rest: true,
            position: "B/4",
            dot_shiftY: -0.5,
            line_above: 1,
            line_below: 2
        },
        s: {
            getWidth: ()=>$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH,
            position: "B/4"
        }
    },
    32: {
        common: {
            code_head: "",
            beam_count: 3,
            stem_beam_extension: 7.5,
            stem: true,
            flag: true,
            code_flag_upstem: "flag32ndUp",
            code_flag_downstem: "flag32ndDown",
            stem_up_extension: 9,
            stem_down_extension: 9,
            tabnote_stem_up_extension: 9,
            tabnote_stem_down_extension: 9,
            dot_shiftY: 0,
            line_above: 0,
            line_below: 0
        },
        r: {
            code_head: "rest32nd",
            stem: false,
            flag: false,
            rest: true,
            position: "B/4",
            dot_shiftY: -1.5,
            line_above: 2,
            line_below: 2
        },
        s: {
            getWidth: ()=>$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH,
            position: "B/4"
        }
    },
    64: {
        common: {
            code_head: "",
            beam_count: 4,
            stem_beam_extension: 15,
            stem: true,
            flag: true,
            code_flag_upstem: "flag64thUp",
            code_flag_downstem: "flag64thDown",
            stem_up_extension: 13,
            stem_down_extension: 13,
            tabnote_stem_up_extension: 13,
            tabnote_stem_down_extension: 13,
            dot_shiftY: 0,
            line_above: 0,
            line_below: 0
        },
        r: {
            code_head: "rest64th",
            stem: false,
            flag: false,
            rest: true,
            position: "B/4",
            dot_shiftY: -1.5,
            line_above: 2,
            line_below: 3
        },
        s: {
            getWidth: ()=>$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH,
            position: "B/4"
        }
    },
    128: {
        common: {
            code_head: "",
            beam_count: 5,
            stem_beam_extension: 22.5,
            stem: true,
            flag: true,
            code_flag_upstem: "flag128thUp",
            code_flag_downstem: "flag128thDown",
            stem_up_extension: 22,
            stem_down_extension: 22,
            tabnote_stem_up_extension: 22,
            tabnote_stem_down_extension: 22,
            dot_shiftY: 0,
            line_above: 0,
            line_below: 0
        },
        r: {
            code_head: "rest128th",
            stem: false,
            flag: false,
            rest: true,
            position: "B/4",
            dot_shiftY: -2.5,
            line_above: 3,
            line_below: 3
        },
        s: {
            getWidth: ()=>$a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH,
            position: "B/4"
        }
    }
};
// node_modules/vexflow/build/esm/src/glyph.js
var $a801f2c896bd09f1$var$GlyphCacheEntry = class {
    constructor(fontStack, code3, category){
        this.point = -1;
        this.metrics = $a801f2c896bd09f1$var$Glyph.loadMetrics(fontStack, code3, category);
        this.bbox = $a801f2c896bd09f1$var$Glyph.getOutlineBoundingBox(this.metrics.outline, this.metrics.scale, this.metrics.x_shift, this.metrics.y_shift);
        if (category) this.point = $a801f2c896bd09f1$var$Glyph.lookupFontMetric(this.metrics.font, category, code3, "point", -1);
    }
};
var $a801f2c896bd09f1$var$GlyphCache = class {
    constructor(){
        this.cache = /* @__PURE__ */ new Map();
    }
    lookup(code3, category) {
        let entries = this.cache.get($a801f2c896bd09f1$var$Glyph.CURRENT_CACHE_KEY);
        if (entries === void 0) {
            entries = {};
            this.cache.set($a801f2c896bd09f1$var$Glyph.CURRENT_CACHE_KEY, entries);
        }
        const key2 = category ? `${code3}%${category}` : code3;
        let entry = entries[key2];
        if (entry === void 0) {
            entry = new $a801f2c896bd09f1$var$GlyphCacheEntry($a801f2c896bd09f1$var$Glyph.MUSIC_FONT_STACK, code3, category);
            entries[key2] = entry;
        }
        return entry;
    }
};
var $a801f2c896bd09f1$var$GlyphOutline = class {
    constructor(outline, originX, originY, scale){
        this.outline = outline;
        this.originX = originX;
        this.originY = originY;
        this.scale = scale;
        this.i = 0;
        this.precision = 1;
        this.precision = Math.pow(10, $a801f2c896bd09f1$var$Tables.RENDER_PRECISION_PLACES);
    }
    done() {
        return this.i >= this.outline.length;
    }
    next() {
        return Math.round(this.outline[this.i++] * this.precision / this.precision);
    }
    nextX() {
        return Math.round((this.originX + this.outline[this.i++] * this.scale) * this.precision) / this.precision;
    }
    nextY() {
        return Math.round((this.originY - this.outline[this.i++] * this.scale) * this.precision) / this.precision;
    }
    static parse(str) {
        const result2 = [];
        const parts = str.split(" ");
        let i2 = 0;
        while(i2 < parts.length)switch(parts[i2++]){
            case "m":
                result2.push(0, parseInt(parts[i2++]), parseInt(parts[i2++]));
                break;
            case "l":
                result2.push(1, parseInt(parts[i2++]), parseInt(parts[i2++]));
                break;
            case "q":
                result2.push(2, parseInt(parts[i2++]), parseInt(parts[i2++]), parseInt(parts[i2++]), parseInt(parts[i2++]));
                break;
            case "b":
                result2.push(3, parseInt(parts[i2++]), parseInt(parts[i2++]), parseInt(parts[i2++]), parseInt(parts[i2++]), parseInt(parts[i2++]), parseInt(parts[i2++]));
                break;
        }
        return result2;
    }
};
var $a801f2c896bd09f1$var$Glyph = class _Glyph extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "Glyph";
    }
    static lookupFontMetric(font, category, code3, key2, defaultValue4) {
        let value17 = font.lookupMetric(`glyphs.${category}.${code3}.${key2}`, void 0);
        if (value17 === void 0) value17 = font.lookupMetric(`glyphs.${category}.${key2}`, defaultValue4);
        return value17;
    }
    static lookupGlyph(fontStack, code3) {
        $a801f2c896bd09f1$var$defined(fontStack, "BadFontStack", "Font stack is misconfigured");
        let glyph;
        let font;
        for(let i2 = 0; i2 < fontStack.length; i2++){
            font = fontStack[i2];
            glyph = font.getGlyphs()[code3];
            if (glyph) return {
                glyph: glyph,
                font: font
            };
        }
        throw new $a801f2c896bd09f1$var$RuntimeError("BadGlyph", `Glyph ${code3} does not exist in font.`);
    }
    static loadMetrics(fontStack, code3, category) {
        const { glyph: glyph, font: font } = _Glyph.lookupGlyph(fontStack, code3);
        if (!glyph.o) throw new $a801f2c896bd09f1$var$RuntimeError("BadGlyph", `Glyph ${code3} has no outline defined.`);
        let x_shift = 0;
        let y_shift = 0;
        let scale = 1;
        if (category && font) {
            x_shift = _Glyph.lookupFontMetric(font, category, code3, "shiftX", 0);
            y_shift = _Glyph.lookupFontMetric(font, category, code3, "shiftY", 0);
            scale = _Glyph.lookupFontMetric(font, category, code3, "scale", 1);
        }
        const x_min = glyph.x_min;
        const x_max = glyph.x_max;
        const ha = glyph.ha;
        if (!glyph.cached_outline) glyph.cached_outline = $a801f2c896bd09f1$var$GlyphOutline.parse(glyph.o);
        return {
            x_min: x_min,
            x_max: x_max,
            x_shift: x_shift,
            y_shift: y_shift,
            scale: scale,
            ha: ha,
            outline: glyph.cached_outline,
            font: font,
            width: x_max - x_min,
            height: ha
        };
    }
    static renderGlyph(ctx, x_pos, y_pos, point, code3, options2) {
        var _a;
        const data = _Glyph.cache.lookup(code3, options2 === null || options2 === void 0 ? void 0 : options2.category);
        const metrics = data.metrics;
        if (data.point != -1) point = data.point;
        const customScale = (_a = options2 === null || options2 === void 0 ? void 0 : options2.scale) !== null && _a !== void 0 ? _a : 1;
        const scale = point * 72 / (metrics.font.getResolution() * 100) * metrics.scale * customScale;
        _Glyph.renderOutline(ctx, metrics.outline, scale, x_pos + metrics.x_shift * customScale, y_pos + metrics.y_shift * customScale);
        return metrics;
    }
    static renderOutline(ctx, outline, scale, x_pos, y_pos) {
        const go2 = new $a801f2c896bd09f1$var$GlyphOutline(outline, x_pos, y_pos, scale);
        ctx.beginPath();
        let x4, y4;
        while(!go2.done())switch(go2.next()){
            case 0:
                ctx.moveTo(go2.nextX(), go2.nextY());
                break;
            case 1:
                ctx.lineTo(go2.nextX(), go2.nextY());
                break;
            case 2:
                x4 = go2.nextX();
                y4 = go2.nextY();
                ctx.quadraticCurveTo(go2.nextX(), go2.nextY(), x4, y4);
                break;
            case 3:
                x4 = go2.nextX();
                y4 = go2.nextY();
                ctx.bezierCurveTo(go2.nextX(), go2.nextY(), go2.nextX(), go2.nextY(), x4, y4);
                break;
        }
        ctx.fill();
    }
    static getOutlineBoundingBox(outline, scale, x_pos, y_pos) {
        const go2 = new $a801f2c896bd09f1$var$GlyphOutline(outline, x_pos, y_pos, scale);
        const bboxComp = new $a801f2c896bd09f1$var$BoundingBoxComputation();
        let penX = x_pos;
        let penY = y_pos;
        let x4, y4;
        while(!go2.done())switch(go2.next()){
            case 0:
                penX = go2.nextX();
                penY = go2.nextY();
                break;
            case 1:
                bboxComp.addPoint(penX, penY);
                penX = go2.nextX();
                penY = go2.nextY();
                bboxComp.addPoint(penX, penY);
                break;
            case 2:
                x4 = go2.nextX();
                y4 = go2.nextY();
                bboxComp.addQuadraticCurve(penX, penY, go2.nextX(), go2.nextY(), x4, y4);
                penX = x4;
                penY = y4;
                break;
            case 3:
                x4 = go2.nextX();
                y4 = go2.nextY();
                bboxComp.addBezierCurve(penX, penY, go2.nextX(), go2.nextY(), go2.nextX(), go2.nextY(), x4, y4);
                penX = x4;
                penY = y4;
                break;
        }
        return new $a801f2c896bd09f1$var$BoundingBox(bboxComp.getX1(), bboxComp.getY1(), bboxComp.width(), bboxComp.height());
    }
    static getWidth(code3, point, category) {
        const data = _Glyph.cache.lookup(code3, category);
        if (data.point != -1) point = data.point;
        const scale = point * 72 / (data.metrics.font.getResolution() * 100);
        return data.bbox.getW() * scale;
    }
    constructor(code3, point, options2){
        super();
        this.bbox = new $a801f2c896bd09f1$var$BoundingBox(0, 0, 0, 0);
        this.topGlyphs = [];
        this.botGlyphs = [];
        this.options = {};
        this.scale = 1;
        this.code = code3;
        this.point = point;
        this.originShift = {
            x: 0,
            y: 0
        };
        this.x_shift = 0;
        this.y_shift = 0;
        if (options2) this.setOptions(options2);
        else this.reset();
    }
    draw(...args) {}
    getCode() {
        return this.code;
    }
    setOptions(options2) {
        this.options = Object.assign(Object.assign({}, this.options), options2);
        this.reset();
    }
    setPoint(point) {
        this.point = point;
        return this;
    }
    setStave(stave) {
        this.stave = stave;
        return this;
    }
    getXShift() {
        return this.x_shift;
    }
    setXShift(x_shift) {
        this.x_shift = x_shift;
        return this;
    }
    getYshift() {
        return this.y_shift;
    }
    setYShift(y_shift) {
        this.y_shift = y_shift;
        return this;
    }
    reset() {
        const data = _Glyph.cache.lookup(this.code, this.options.category);
        this.metrics = data.metrics;
        if (data.point != -1) this.point = data.point;
        this.scale = this.point * 72 / (this.metrics.font.getResolution() * 100);
        this.bbox = new $a801f2c896bd09f1$var$BoundingBox(data.bbox.getX() * this.scale, data.bbox.getY() * this.scale, data.bbox.getW() * this.scale, data.bbox.getH() * this.scale);
    }
    checkMetrics() {
        return $a801f2c896bd09f1$var$defined(this.metrics, "BadGlyph", `Glyph ${this.code} is not initialized.`);
    }
    getMetrics() {
        const metrics = this.checkMetrics();
        const metricsScale = metrics.scale;
        return {
            x_min: metrics.x_min * this.scale * metricsScale,
            x_max: metrics.x_max * this.scale * metricsScale,
            width: this.bbox.getW(),
            height: this.bbox.getH(),
            scale: this.scale * metricsScale,
            x_shift: metrics.x_shift,
            y_shift: metrics.y_shift,
            outline: metrics.outline,
            font: metrics.font,
            ha: metrics.ha
        };
    }
    setOriginX(x4) {
        const { bbox: bbox } = this;
        const originX = Math.abs(bbox.getX() / bbox.getW());
        const xShift = (x4 - originX) * bbox.getW();
        this.originShift.x = -xShift;
    }
    setOriginY(y4) {
        const { bbox: bbox } = this;
        const originY = Math.abs(bbox.getY() / bbox.getH());
        const yShift = (y4 - originY) * bbox.getH();
        this.originShift.y = -yShift;
    }
    setOrigin(x4, y4) {
        this.setOriginX(x4);
        this.setOriginY(y4);
    }
    render(ctx, x4, y4) {
        const metrics = this.checkMetrics();
        const outline = metrics.outline;
        const scale = this.scale * metrics.scale;
        this.setRendered();
        this.applyStyle(ctx);
        const xPos = x4 + this.originShift.x + metrics.x_shift;
        const yPos = y4 + this.originShift.y + metrics.y_shift;
        _Glyph.renderOutline(ctx, outline, scale, xPos, yPos);
        this.restoreStyle(ctx);
    }
    checkStave() {
        return $a801f2c896bd09f1$var$defined(this.stave, "NoStave", "No stave attached to instance.");
    }
    renderToStave(x4) {
        const context = this.checkContext();
        const metrics = this.checkMetrics();
        const stave = this.checkStave();
        const outline = metrics.outline;
        const scale = this.scale * metrics.scale;
        this.setRendered();
        this.applyStyle();
        const xPos = x4 + this.x_shift + metrics.x_shift;
        const yPos = stave.getYForGlyphs() + this.y_shift + metrics.y_shift;
        _Glyph.renderOutline(context, outline, scale, xPos, yPos);
        this.restoreStyle();
    }
};
$a801f2c896bd09f1$var$Glyph.cache = new $a801f2c896bd09f1$var$GlyphCache();
$a801f2c896bd09f1$var$Glyph.CURRENT_CACHE_KEY = "";
$a801f2c896bd09f1$var$Glyph.MUSIC_FONT_STACK = [];
// node_modules/vexflow/build/esm/src/modifier.js
var $a801f2c896bd09f1$var$ModifierPosition;
(function(ModifierPosition2) {
    ModifierPosition2[ModifierPosition2["CENTER"] = 0] = "CENTER";
    ModifierPosition2[ModifierPosition2["LEFT"] = 1] = "LEFT";
    ModifierPosition2[ModifierPosition2["RIGHT"] = 2] = "RIGHT";
    ModifierPosition2[ModifierPosition2["ABOVE"] = 3] = "ABOVE";
    ModifierPosition2[ModifierPosition2["BELOW"] = 4] = "BELOW";
})($a801f2c896bd09f1$var$ModifierPosition || ($a801f2c896bd09f1$var$ModifierPosition = {}));
var $a801f2c896bd09f1$var$Modifier = class _Modifier extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "Modifier";
    }
    static get Position() {
        return $a801f2c896bd09f1$var$ModifierPosition;
    }
    static get PositionString() {
        return {
            center: $a801f2c896bd09f1$var$ModifierPosition.CENTER,
            above: $a801f2c896bd09f1$var$ModifierPosition.ABOVE,
            below: $a801f2c896bd09f1$var$ModifierPosition.BELOW,
            left: $a801f2c896bd09f1$var$ModifierPosition.LEFT,
            right: $a801f2c896bd09f1$var$ModifierPosition.RIGHT
        };
    }
    constructor(){
        super();
        this.width = 0;
        this.text_line = 0;
        this.position = _Modifier.Position.LEFT;
        this.x_shift = 0;
        this.y_shift = 0;
        this.spacingFromNextModifier = 0;
    }
    reset() {}
    getWidth() {
        return this.width;
    }
    setWidth(width9) {
        this.width = width9;
        return this;
    }
    getNote() {
        return $a801f2c896bd09f1$var$defined(this.note, "NoNote", "Modifier has no note.");
    }
    checkAttachedNote() {
        const category = this.getCategory();
        $a801f2c896bd09f1$var$defined(this.index, "NoIndex", `Can't draw ${category} without an index.`);
        return $a801f2c896bd09f1$var$defined(this.note, "NoNote", `Can't draw ${category} without a note.`);
    }
    setNote(note2) {
        this.note = note2;
        return this;
    }
    getIndex() {
        return this.index;
    }
    checkIndex() {
        return $a801f2c896bd09f1$var$defined(this.index, "NoIndex", "Modifier has an invalid index.");
    }
    setIndex(index5) {
        this.index = index5;
        return this;
    }
    getModifierContext() {
        return this.modifierContext;
    }
    checkModifierContext() {
        return $a801f2c896bd09f1$var$defined(this.modifierContext, "NoModifierContext", "Modifier Context Required");
    }
    setModifierContext(c3) {
        this.modifierContext = c3;
        return this;
    }
    getPosition() {
        return this.position;
    }
    setPosition(position2) {
        this.position = typeof position2 === "string" ? _Modifier.PositionString[position2] : position2;
        this.reset();
        return this;
    }
    setTextLine(line2) {
        this.text_line = line2;
        return this;
    }
    setYShift(y4) {
        this.y_shift = y4;
        return this;
    }
    setSpacingFromNextModifier(x4) {
        this.spacingFromNextModifier = x4;
    }
    getSpacingFromNextModifier() {
        return this.spacingFromNextModifier;
    }
    setXShift(x4) {
        this.x_shift = 0;
        if (this.position === _Modifier.Position.LEFT) this.x_shift -= x4;
        else this.x_shift += x4;
        return this;
    }
    getXShift() {
        return this.x_shift;
    }
    draw() {
        this.checkContext();
        throw new $a801f2c896bd09f1$var$RuntimeError("NotImplemented", "draw() not implemented for this modifier.");
    }
    alignSubNotesWithNote(subNotes, note2) {
        const tickContext = note2.getTickContext();
        const metrics = tickContext.getMetrics();
        const stave = note2.getStave();
        const subNoteXOffset = tickContext.getX() - metrics.modLeftPx - metrics.modRightPx + this.getSpacingFromNextModifier();
        subNotes.forEach((subNote)=>{
            const subTickContext = subNote.getTickContext();
            if (stave) subNote.setStave(stave);
            subTickContext.setXOffset(subNoteXOffset);
        });
    }
};
// node_modules/vexflow/build/esm/src/music.js
var $a801f2c896bd09f1$var$Music = class _Music {
    static get NUM_TONES() {
        return this.canonical_notes.length;
    }
    static get roots() {
        return [
            "c",
            "d",
            "e",
            "f",
            "g",
            "a",
            "b"
        ];
    }
    static get root_values() {
        return [
            0,
            2,
            4,
            5,
            7,
            9,
            11
        ];
    }
    static get root_indices() {
        return {
            c: 0,
            d: 1,
            e: 2,
            f: 3,
            g: 4,
            a: 5,
            b: 6
        };
    }
    static get canonical_notes() {
        return [
            "c",
            "c#",
            "d",
            "d#",
            "e",
            "f",
            "f#",
            "g",
            "g#",
            "a",
            "a#",
            "b"
        ];
    }
    static get diatonic_intervals() {
        return [
            "unison",
            "m2",
            "M2",
            "m3",
            "M3",
            "p4",
            "dim5",
            "p5",
            "m6",
            "M6",
            "b7",
            "M7",
            "octave"
        ];
    }
    static get diatonic_accidentals() {
        return {
            unison: {
                note: 0,
                accidental: 0
            },
            m2: {
                note: 1,
                accidental: -1
            },
            M2: {
                note: 1,
                accidental: 0
            },
            m3: {
                note: 2,
                accidental: -1
            },
            M3: {
                note: 2,
                accidental: 0
            },
            p4: {
                note: 3,
                accidental: 0
            },
            dim5: {
                note: 4,
                accidental: -1
            },
            p5: {
                note: 4,
                accidental: 0
            },
            m6: {
                note: 5,
                accidental: -1
            },
            M6: {
                note: 5,
                accidental: 0
            },
            b7: {
                note: 6,
                accidental: -1
            },
            M7: {
                note: 6,
                accidental: 0
            },
            octave: {
                note: 7,
                accidental: 0
            }
        };
    }
    static get intervals() {
        return {
            u: 0,
            unison: 0,
            m2: 1,
            b2: 1,
            min2: 1,
            S: 1,
            H: 1,
            2: 2,
            M2: 2,
            maj2: 2,
            T: 2,
            W: 2,
            m3: 3,
            b3: 3,
            min3: 3,
            M3: 4,
            3: 4,
            maj3: 4,
            4: 5,
            p4: 5,
            "#4": 6,
            b5: 6,
            aug4: 6,
            dim5: 6,
            5: 7,
            p5: 7,
            "#5": 8,
            b6: 8,
            aug5: 8,
            6: 9,
            M6: 9,
            maj6: 9,
            b7: 10,
            m7: 10,
            min7: 10,
            dom7: 10,
            M7: 11,
            maj7: 11,
            8: 12,
            octave: 12
        };
    }
    static get scales() {
        return {
            major: [
                2,
                2,
                1,
                2,
                2,
                2,
                1
            ],
            minor: [
                2,
                1,
                2,
                2,
                1,
                2,
                2
            ],
            ionian: [
                2,
                2,
                1,
                2,
                2,
                2,
                1
            ],
            dorian: [
                2,
                1,
                2,
                2,
                2,
                1,
                2
            ],
            phyrgian: [
                1,
                2,
                2,
                2,
                1,
                2,
                2
            ],
            lydian: [
                2,
                2,
                2,
                1,
                2,
                2,
                1
            ],
            mixolydian: [
                2,
                2,
                1,
                2,
                2,
                1,
                2
            ],
            aeolian: [
                2,
                1,
                2,
                2,
                1,
                2,
                2
            ],
            locrian: [
                1,
                2,
                2,
                1,
                2,
                2,
                2
            ]
        };
    }
    static get scaleTypes() {
        return {
            M: _Music.scales.major,
            m: _Music.scales.minor
        };
    }
    static get accidentals() {
        return [
            "bb",
            "b",
            "n",
            "#",
            "##"
        ];
    }
    static get noteValues() {
        return {
            c: {
                root_index: 0,
                int_val: 0
            },
            cn: {
                root_index: 0,
                int_val: 0
            },
            "c#": {
                root_index: 0,
                int_val: 1
            },
            "c##": {
                root_index: 0,
                int_val: 2
            },
            cb: {
                root_index: 0,
                int_val: 11
            },
            cbb: {
                root_index: 0,
                int_val: 10
            },
            d: {
                root_index: 1,
                int_val: 2
            },
            dn: {
                root_index: 1,
                int_val: 2
            },
            "d#": {
                root_index: 1,
                int_val: 3
            },
            "d##": {
                root_index: 1,
                int_val: 4
            },
            db: {
                root_index: 1,
                int_val: 1
            },
            dbb: {
                root_index: 1,
                int_val: 0
            },
            e: {
                root_index: 2,
                int_val: 4
            },
            en: {
                root_index: 2,
                int_val: 4
            },
            "e#": {
                root_index: 2,
                int_val: 5
            },
            "e##": {
                root_index: 2,
                int_val: 6
            },
            eb: {
                root_index: 2,
                int_val: 3
            },
            ebb: {
                root_index: 2,
                int_val: 2
            },
            f: {
                root_index: 3,
                int_val: 5
            },
            fn: {
                root_index: 3,
                int_val: 5
            },
            "f#": {
                root_index: 3,
                int_val: 6
            },
            "f##": {
                root_index: 3,
                int_val: 7
            },
            fb: {
                root_index: 3,
                int_val: 4
            },
            fbb: {
                root_index: 3,
                int_val: 3
            },
            g: {
                root_index: 4,
                int_val: 7
            },
            gn: {
                root_index: 4,
                int_val: 7
            },
            "g#": {
                root_index: 4,
                int_val: 8
            },
            "g##": {
                root_index: 4,
                int_val: 9
            },
            gb: {
                root_index: 4,
                int_val: 6
            },
            gbb: {
                root_index: 4,
                int_val: 5
            },
            a: {
                root_index: 5,
                int_val: 9
            },
            an: {
                root_index: 5,
                int_val: 9
            },
            "a#": {
                root_index: 5,
                int_val: 10
            },
            "a##": {
                root_index: 5,
                int_val: 11
            },
            ab: {
                root_index: 5,
                int_val: 8
            },
            abb: {
                root_index: 5,
                int_val: 7
            },
            b: {
                root_index: 6,
                int_val: 11
            },
            bn: {
                root_index: 6,
                int_val: 11
            },
            "b#": {
                root_index: 6,
                int_val: 0
            },
            "b##": {
                root_index: 6,
                int_val: 1
            },
            bb: {
                root_index: 6,
                int_val: 10
            },
            bbb: {
                root_index: 6,
                int_val: 9
            }
        };
    }
    isValidNoteValue(note2) {
        return note2 >= 0 && note2 < _Music.canonical_notes.length;
    }
    isValidIntervalValue(interval) {
        return interval >= 0 && interval < _Music.diatonic_intervals.length;
    }
    getNoteParts(noteString) {
        if (!noteString || noteString.length < 1) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Invalid note name: " + noteString);
        if (noteString.length > 3) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Invalid note name: " + noteString);
        const note2 = noteString.toLowerCase();
        const regex2 = /^([cdefgab])(b|bb|n|#|##)?$/;
        const match2 = regex2.exec(note2);
        if (match2 !== null) {
            const root = match2[1];
            const accidental = match2[2];
            return {
                root: root,
                accidental: accidental
            };
        } else throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Invalid note name: " + noteString);
    }
    getKeyParts(keyString) {
        if (!keyString || keyString.length < 1) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Invalid key: " + keyString);
        const key2 = keyString.toLowerCase();
        const regex2 = /^([cdefgab])(b|#)?(mel|harm|m|M)?$/;
        const match2 = regex2.exec(key2);
        if (match2 !== null) {
            const root = match2[1];
            const accidental = match2[2];
            let type = match2[3];
            if (!type) type = "M";
            return {
                root: root,
                accidental: accidental,
                type: type
            };
        } else throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid key: ${keyString}`);
    }
    getNoteValue(noteString) {
        const value17 = _Music.noteValues[noteString];
        if (value17 === void 0) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid note name: ${noteString}`);
        return value17.int_val;
    }
    getIntervalValue(intervalString) {
        const value17 = _Music.intervals[intervalString];
        if (value17 === void 0) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid interval name: ${intervalString}`);
        return value17;
    }
    getCanonicalNoteName(noteValue) {
        if (!this.isValidNoteValue(noteValue)) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid note value: ${noteValue}`);
        return _Music.canonical_notes[noteValue];
    }
    getCanonicalIntervalName(intervalValue) {
        if (!this.isValidIntervalValue(intervalValue)) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid interval value: ${intervalValue}`);
        return _Music.diatonic_intervals[intervalValue];
    }
    getRelativeNoteValue(noteValue, intervalValue, direction3 = 1) {
        if (direction3 !== 1 && direction3 !== -1) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid direction: ${direction3}`);
        let sum2 = (noteValue + direction3 * intervalValue) % _Music.NUM_TONES;
        if (sum2 < 0) sum2 += _Music.NUM_TONES;
        return sum2;
    }
    getRelativeNoteName(root, noteValue) {
        const parts = this.getNoteParts(root);
        const rootValue = this.getNoteValue(parts.root);
        let interval = noteValue - rootValue;
        if (Math.abs(interval) > _Music.NUM_TONES - 3) {
            let multiplier = 1;
            if (interval > 0) multiplier = -1;
            const reverse_interval = (noteValue + 1 + (rootValue + 1)) % _Music.NUM_TONES * multiplier;
            if (Math.abs(reverse_interval) > 2) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Notes not related: ${root}, ${noteValue})`);
            else interval = reverse_interval;
        }
        if (Math.abs(interval) > 2) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Notes not related: ${root}, ${noteValue})`);
        let relativeNoteName = parts.root;
        if (interval > 0) for(let i2 = 1; i2 <= interval; ++i2)relativeNoteName += "#";
        else if (interval < 0) for(let i2 = -1; i2 >= interval; --i2)relativeNoteName += "b";
        return relativeNoteName;
    }
    getScaleTones(key2, intervals) {
        const tones = [
            key2
        ];
        let nextNote = key2;
        for(let i2 = 0; i2 < intervals.length; i2++){
            nextNote = this.getRelativeNoteValue(nextNote, intervals[i2]);
            if (nextNote !== key2) tones.push(nextNote);
        }
        return tones;
    }
    getIntervalBetween(note1, note2, direction3 = 1) {
        if (direction3 !== 1 && direction3 !== -1) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid direction: ${direction3}`);
        if (!this.isValidNoteValue(note1) || !this.isValidNoteValue(note2)) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid notes: ${note1}, ${note2}`);
        let difference4 = direction3 === 1 ? note2 - note1 : note1 - note2;
        if (difference4 < 0) difference4 += _Music.NUM_TONES;
        return difference4;
    }
    createScaleMap(keySignature) {
        const keySigParts = this.getKeyParts(keySignature);
        if (!keySigParts.type) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Unsupported key type: undefined");
        const scaleName = _Music.scaleTypes[keySigParts.type];
        let keySigString = keySigParts.root;
        if (keySigParts.accidental) keySigString += keySigParts.accidental;
        if (!scaleName) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Unsupported key type: " + keySignature);
        const scale = this.getScaleTones(this.getNoteValue(keySigString), scaleName);
        const noteLocation = _Music.root_indices[keySigParts.root];
        const scaleMap = {};
        for(let i2 = 0; i2 < _Music.roots.length; ++i2){
            const index5 = (noteLocation + i2) % _Music.roots.length;
            const rootName = _Music.roots[index5];
            let noteName = this.getRelativeNoteName(rootName, scale[i2]);
            if (noteName.length === 1) noteName += "n";
            scaleMap[rootName] = noteName;
        }
        return scaleMap;
    }
};
// node_modules/vexflow/build/esm/src/typeguard.js
function $a801f2c896bd09f1$var$isCategory(obj, category, checkAncestors = true) {
    if (typeof obj !== "object" || obj === null) return false;
    let constructorFcn = obj.constructor;
    if (checkAncestors) {
        while(obj !== null){
            constructorFcn = obj.constructor;
            if ("CATEGORY" in constructorFcn && constructorFcn.CATEGORY === category) return true;
            obj = Object.getPrototypeOf(obj);
        }
        return false;
    } else return "CATEGORY" in constructorFcn && constructorFcn.CATEGORY === category;
}
var $a801f2c896bd09f1$var$isAccidental = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "Accidental");
var $a801f2c896bd09f1$var$isAnnotation = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "Annotation");
var $a801f2c896bd09f1$var$isBarline = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "Barline");
var $a801f2c896bd09f1$var$isDot = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "Dot");
var $a801f2c896bd09f1$var$isGraceNote = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "GraceNote");
var $a801f2c896bd09f1$var$isGraceNoteGroup = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "GraceNoteGroup");
var $a801f2c896bd09f1$var$isNote = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "Note");
var $a801f2c896bd09f1$var$isRenderContext = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "RenderContext");
var $a801f2c896bd09f1$var$isStaveNote = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "StaveNote");
var $a801f2c896bd09f1$var$isStemmableNote = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "StemmableNote");
var $a801f2c896bd09f1$var$isTabNote = (obj)=>$a801f2c896bd09f1$var$isCategory(obj, "TabNote");
// node_modules/vexflow/build/esm/src/accidental.js
function $a801f2c896bd09f1$var$L(...args) {
    if ($a801f2c896bd09f1$var$Accidental.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Accidental", args);
}
var $a801f2c896bd09f1$var$Accidental = class _Accidental extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Accidental";
    }
    static format(accidentals2, state3) {
        if (!accidentals2 || accidentals2.length === 0) return;
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        const noteheadAccidentalPadding = musicFont.lookupMetric("accidental.noteheadAccidentalPadding");
        const leftShift = state3.left_shift + noteheadAccidentalPadding;
        const accidentalSpacing = musicFont.lookupMetric("accidental.accidentalSpacing");
        const additionalPadding = musicFont.lookupMetric("accidental.leftPadding");
        const accidentalLinePositionsAndSpaceNeeds = [];
        let prevNote = void 0;
        let extraXSpaceNeededForLeftDisplacedNotehead = 0;
        for(let i2 = 0; i2 < accidentals2.length; ++i2){
            const acc = accidentals2[i2];
            const note2 = acc.getNote();
            const stave = note2.getStave();
            const index5 = acc.checkIndex();
            const props = note2.getKeyProps()[index5];
            if (note2 !== prevNote) {
                for(let n = 0; n < note2.keys.length; ++n)extraXSpaceNeededForLeftDisplacedNotehead = Math.max(note2.getLeftDisplacedHeadPx() - note2.getXShift(), extraXSpaceNeededForLeftDisplacedNotehead);
                prevNote = note2;
            }
            if (stave) {
                const lineSpace = stave.getSpacingBetweenLines();
                const y4 = stave.getYForLine(props.line);
                const accLine = Math.round(y4 / lineSpace * 2) / 2;
                accidentalLinePositionsAndSpaceNeeds.push({
                    y: y4,
                    line: accLine,
                    extraXSpaceNeeded: extraXSpaceNeededForLeftDisplacedNotehead,
                    acc: acc,
                    spacingBetweenStaveLines: lineSpace
                });
            } else accidentalLinePositionsAndSpaceNeeds.push({
                line: props.line,
                extraXSpaceNeeded: extraXSpaceNeededForLeftDisplacedNotehead,
                acc: acc
            });
        }
        accidentalLinePositionsAndSpaceNeeds.sort((a3, b3)=>b3.line - a3.line);
        const staveLineAccidentalLayoutMetrics = [];
        let maxExtraXSpaceNeeded = 0;
        for(let i2 = 0; i2 < accidentalLinePositionsAndSpaceNeeds.length; i2++){
            const accidentalLinePositionAndSpaceNeeds = accidentalLinePositionsAndSpaceNeeds[i2];
            const priorLineMetric = staveLineAccidentalLayoutMetrics[staveLineAccidentalLayoutMetrics.length - 1];
            let currentLineMetric;
            if (!priorLineMetric || (priorLineMetric === null || priorLineMetric === void 0 ? void 0 : priorLineMetric.line) !== accidentalLinePositionAndSpaceNeeds.line) {
                currentLineMetric = {
                    line: accidentalLinePositionAndSpaceNeeds.line,
                    flatLine: true,
                    dblSharpLine: true,
                    numAcc: 0,
                    width: 0,
                    column: 0
                };
                staveLineAccidentalLayoutMetrics.push(currentLineMetric);
            } else currentLineMetric = priorLineMetric;
            if (accidentalLinePositionAndSpaceNeeds.acc.type !== "b" && accidentalLinePositionAndSpaceNeeds.acc.type !== "bb") currentLineMetric.flatLine = false;
            if (accidentalLinePositionAndSpaceNeeds.acc.type !== "##") currentLineMetric.dblSharpLine = false;
            currentLineMetric.numAcc++;
            currentLineMetric.width += accidentalLinePositionAndSpaceNeeds.acc.getWidth() + accidentalSpacing;
            maxExtraXSpaceNeeded = Math.max(accidentalLinePositionAndSpaceNeeds.extraXSpaceNeeded, maxExtraXSpaceNeeded);
        }
        let totalColumns = 0;
        for(let i2 = 0; i2 < staveLineAccidentalLayoutMetrics.length; i2++){
            let noFurtherConflicts = false;
            const groupStart = i2;
            let groupEnd2 = i2;
            while(groupEnd2 + 1 < staveLineAccidentalLayoutMetrics.length && !noFurtherConflicts)if (this.checkCollision(staveLineAccidentalLayoutMetrics[groupEnd2], staveLineAccidentalLayoutMetrics[groupEnd2 + 1])) groupEnd2++;
            else noFurtherConflicts = true;
            const getGroupLine = (index5)=>staveLineAccidentalLayoutMetrics[groupStart + index5];
            const getGroupLines = (indexes)=>indexes.map(getGroupLine);
            const lineDifference = (indexA, indexB)=>{
                const [a3, b3] = getGroupLines([
                    indexA,
                    indexB
                ]).map((item2)=>item2.line);
                return a3 - b3;
            };
            const notColliding = (...indexPairs)=>indexPairs.map(getGroupLines).every(([line1, line2])=>!this.checkCollision(line1, line2));
            const groupLength = groupEnd2 - groupStart + 1;
            let endCase = this.checkCollision(staveLineAccidentalLayoutMetrics[groupStart], staveLineAccidentalLayoutMetrics[groupEnd2]) ? "a" : "b";
            switch(groupLength){
                case 3:
                    if (endCase === "a" && lineDifference(1, 2) === 0.5 && lineDifference(0, 1) !== 0.5) endCase = "second_on_bottom";
                    break;
                case 4:
                    if (notColliding([
                        0,
                        2
                    ], [
                        1,
                        3
                    ])) endCase = "spaced_out_tetrachord";
                    break;
                case 5:
                    if (endCase === "b" && notColliding([
                        1,
                        3
                    ])) {
                        endCase = "spaced_out_pentachord";
                        if (notColliding([
                            0,
                            2
                        ], [
                            2,
                            4
                        ])) endCase = "very_spaced_out_pentachord";
                    }
                    break;
                case 6:
                    if (notColliding([
                        0,
                        3
                    ], [
                        1,
                        4
                    ], [
                        2,
                        5
                    ])) endCase = "spaced_out_hexachord";
                    if (notColliding([
                        0,
                        2
                    ], [
                        2,
                        4
                    ], [
                        1,
                        3
                    ], [
                        3,
                        5
                    ])) endCase = "very_spaced_out_hexachord";
                    break;
                default:
                    break;
            }
            let groupMember;
            let column;
            if (groupLength >= 7) {
                let patternLength = 2;
                let collisionDetected = true;
                while(collisionDetected === true){
                    collisionDetected = false;
                    for(let line2 = 0; line2 + patternLength < staveLineAccidentalLayoutMetrics.length; line2++)if (this.checkCollision(staveLineAccidentalLayoutMetrics[line2], staveLineAccidentalLayoutMetrics[line2 + patternLength])) {
                        collisionDetected = true;
                        patternLength++;
                        break;
                    }
                }
                for(groupMember = i2; groupMember <= groupEnd2; groupMember++){
                    column = (groupMember - i2) % patternLength + 1;
                    staveLineAccidentalLayoutMetrics[groupMember].column = column;
                    totalColumns = totalColumns > column ? totalColumns : column;
                }
            } else for(groupMember = i2; groupMember <= groupEnd2; groupMember++){
                column = $a801f2c896bd09f1$var$Tables.accidentalColumnsTable[groupLength][endCase][groupMember - i2];
                staveLineAccidentalLayoutMetrics[groupMember].column = column;
                totalColumns = totalColumns > column ? totalColumns : column;
            }
            i2 = groupEnd2;
        }
        const columnWidths = [];
        const columnXOffsets = [];
        for(let i2 = 0; i2 <= totalColumns; i2++){
            columnWidths[i2] = 0;
            columnXOffsets[i2] = 0;
        }
        columnWidths[0] = leftShift + maxExtraXSpaceNeeded;
        columnXOffsets[0] = leftShift;
        staveLineAccidentalLayoutMetrics.forEach((line2)=>{
            if (line2.width > columnWidths[line2.column]) columnWidths[line2.column] = line2.width;
        });
        for(let i2 = 1; i2 < columnWidths.length; i2++)columnXOffsets[i2] = columnWidths[i2] + columnXOffsets[i2 - 1];
        const totalShift = columnXOffsets[columnXOffsets.length - 1];
        let accCount = 0;
        staveLineAccidentalLayoutMetrics.forEach((line2)=>{
            let lineWidth = 0;
            const lastAccOnLine = accCount + line2.numAcc;
            for(accCount; accCount < lastAccOnLine; accCount++){
                const xShift = columnXOffsets[line2.column - 1] + lineWidth + maxExtraXSpaceNeeded;
                accidentalLinePositionsAndSpaceNeeds[accCount].acc.setXShift(xShift);
                lineWidth += accidentalLinePositionsAndSpaceNeeds[accCount].acc.getWidth() + accidentalSpacing;
                $a801f2c896bd09f1$var$L("Line, accCount, shift: ", line2.line, accCount, xShift);
            }
        });
        state3.left_shift = totalShift + additionalPadding;
    }
    static checkCollision(line1, line2) {
        let clearance = line2.line - line1.line;
        let clearanceRequired = 3;
        if (clearance > 0) {
            clearanceRequired = line2.flatLine || line2.dblSharpLine ? 2.5 : 3;
            if (line1.dblSharpLine) clearance -= 0.5;
        } else {
            clearanceRequired = line1.flatLine || line1.dblSharpLine ? 2.5 : 3;
            if (line2.dblSharpLine) clearance -= 0.5;
        }
        const collision = Math.abs(clearance) < clearanceRequired;
        $a801f2c896bd09f1$var$L("Line_1, Line_2, Collision: ", line1.line, line2.line, collision);
        return collision;
    }
    static applyAccidentals(voices, keySignature) {
        const tickPositions = [];
        const tickNoteMap = {};
        voices.forEach((voice)=>{
            const tickPosition = new $a801f2c896bd09f1$var$Fraction(0, 1);
            const tickable = voice.getTickables();
            tickable.forEach((t2)=>{
                if (t2.shouldIgnoreTicks()) return;
                const notesAtPosition = tickNoteMap[tickPosition.value()];
                if (!notesAtPosition) {
                    tickPositions.push(tickPosition.value());
                    tickNoteMap[tickPosition.value()] = [
                        t2
                    ];
                } else notesAtPosition.push(t2);
                tickPosition.add(t2.getTicks());
            });
        });
        const music = new $a801f2c896bd09f1$var$Music();
        if (!keySignature) keySignature = "C";
        const scaleMapKey = music.createScaleMap(keySignature);
        const scaleMap = {};
        tickPositions.forEach((tickPos)=>{
            const tickables = tickNoteMap[tickPos];
            const modifiedPitches = [];
            const processNote = (t2)=>{
                if (!$a801f2c896bd09f1$var$isStaveNote(t2) || t2.isRest() || t2.shouldIgnoreTicks()) return;
                const staveNote = t2;
                staveNote.keys.forEach((keyString, keyIndex)=>{
                    const key2 = music.getNoteParts(keyString.split("/")[0]);
                    const octave = keyString.split("/")[1];
                    const accidentalString = key2.accidental || "n";
                    const pitch = key2.root + accidentalString;
                    if (!scaleMap[key2.root + octave]) scaleMap[key2.root + octave] = scaleMapKey[key2.root];
                    const sameAccidental = scaleMap[key2.root + octave] === pitch;
                    const previouslyModified = modifiedPitches.indexOf(keyString) > -1;
                    staveNote.getModifiers().forEach((modifier, index5)=>{
                        if ($a801f2c896bd09f1$var$isAccidental(modifier) && modifier.type == accidentalString && modifier.getIndex() == keyIndex) staveNote.getModifiers().splice(index5, 1);
                    });
                    if (!sameAccidental || sameAccidental && previouslyModified) {
                        scaleMap[key2.root + octave] = pitch;
                        const accidental = new _Accidental(accidentalString);
                        staveNote.addModifier(accidental, keyIndex);
                        modifiedPitches.push(keyString);
                    }
                });
                staveNote.getModifiers().forEach((modifier)=>{
                    if ($a801f2c896bd09f1$var$isGraceNoteGroup(modifier)) modifier.getGraceNotes().forEach(processNote);
                });
            };
            tickables.forEach(processNote);
        });
    }
    constructor(type){
        super();
        $a801f2c896bd09f1$var$L("New accidental: ", type);
        this.type = type;
        this.position = $a801f2c896bd09f1$var$Modifier.Position.LEFT;
        this.render_options = {
            font_scale: $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE,
            parenLeftPadding: 2,
            parenRightPadding: 2
        };
        this.accidental = $a801f2c896bd09f1$var$Tables.accidentalCodes(this.type);
        $a801f2c896bd09f1$var$defined(this.accidental, "ArgumentError", `Unknown accidental type: ${type}`);
        this.cautionary = false;
        this.reset();
    }
    reset() {
        const fontScale = this.render_options.font_scale;
        this.glyph = new $a801f2c896bd09f1$var$Glyph(this.accidental.code, fontScale);
        this.glyph.setOriginX(1);
        if (this.cautionary) {
            this.parenLeft = new $a801f2c896bd09f1$var$Glyph($a801f2c896bd09f1$var$Tables.accidentalCodes("{").code, fontScale);
            this.parenRight = new $a801f2c896bd09f1$var$Glyph($a801f2c896bd09f1$var$Tables.accidentalCodes("}").code, fontScale);
            this.parenLeft.setOriginX(1);
            this.parenRight.setOriginX(1);
        }
    }
    getWidth() {
        if (this.cautionary) {
            const parenLeft = $a801f2c896bd09f1$var$defined(this.parenLeft);
            const parenRight = $a801f2c896bd09f1$var$defined(this.parenRight);
            const parenWidth = parenLeft.getMetrics().width + parenRight.getMetrics().width + this.render_options.parenLeftPadding + this.render_options.parenRightPadding;
            return this.glyph.getMetrics().width + parenWidth;
        } else return this.glyph.getMetrics().width;
    }
    setNote(note2) {
        $a801f2c896bd09f1$var$defined(note2, "ArgumentError", `Bad note value: ${note2}`);
        this.note = note2;
        if ($a801f2c896bd09f1$var$isGraceNote(note2)) {
            this.render_options.font_scale = 25;
            this.reset();
        }
        return this;
    }
    setAsCautionary() {
        this.cautionary = true;
        this.render_options.font_scale = 28;
        this.reset();
        return this;
    }
    draw() {
        const { type: type, position: position2, index: index5, cautionary: cautionary, x_shift: x_shift, y_shift: y_shift, glyph: glyph, render_options: { parenLeftPadding: parenLeftPadding, parenRightPadding: parenRightPadding } } = this;
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const start2 = note2.getModifierStartXY(position2, index5);
        let accX = start2.x + x_shift;
        const accY = start2.y + y_shift;
        $a801f2c896bd09f1$var$L("Rendering: ", type, accX, accY);
        if (!cautionary) glyph.render(ctx, accX, accY);
        else {
            const parenLeft = $a801f2c896bd09f1$var$defined(this.parenLeft);
            const parenRight = $a801f2c896bd09f1$var$defined(this.parenRight);
            parenRight.render(ctx, accX, accY);
            accX -= parenRight.getMetrics().width;
            accX -= parenRightPadding;
            accX -= this.accidental.parenRightPaddingAdjustment;
            glyph.render(ctx, accX, accY);
            accX -= glyph.getMetrics().width;
            accX -= parenLeftPadding;
            parenLeft.render(ctx, accX, accY);
        }
    }
};
$a801f2c896bd09f1$var$Accidental.DEBUG = false;
// node_modules/vexflow/build/esm/src/stem.js
function $a801f2c896bd09f1$var$L2(...args) {
    if ($a801f2c896bd09f1$var$Stem.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Stem", args);
}
var $a801f2c896bd09f1$var$Stem = class _Stem extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "Stem";
    }
    static get UP() {
        return 1;
    }
    static get DOWN() {
        return -1;
    }
    static get WIDTH() {
        return $a801f2c896bd09f1$var$Tables.STEM_WIDTH;
    }
    static get HEIGHT() {
        return $a801f2c896bd09f1$var$Tables.STEM_HEIGHT;
    }
    constructor(options2){
        super();
        this.stem_up_y_offset = 0;
        this.stem_down_y_offset = 0;
        this.stem_up_y_base_offset = 0;
        this.stem_down_y_base_offset = 0;
        this.x_begin = (options2 === null || options2 === void 0 ? void 0 : options2.x_begin) || 0;
        this.x_end = (options2 === null || options2 === void 0 ? void 0 : options2.x_end) || 0;
        this.y_top = (options2 === null || options2 === void 0 ? void 0 : options2.y_top) || 0;
        this.y_bottom = (options2 === null || options2 === void 0 ? void 0 : options2.y_bottom) || 0;
        this.stem_extension = (options2 === null || options2 === void 0 ? void 0 : options2.stem_extension) || 0;
        this.stem_direction = (options2 === null || options2 === void 0 ? void 0 : options2.stem_direction) || 0;
        this.hide = (options2 === null || options2 === void 0 ? void 0 : options2.hide) || false;
        this.isStemlet = (options2 === null || options2 === void 0 ? void 0 : options2.isStemlet) || false;
        this.stemletHeight = (options2 === null || options2 === void 0 ? void 0 : options2.stemletHeight) || 0;
        this.renderHeightAdjustment = 0;
        this.setOptions(options2);
    }
    setOptions(options2) {
        this.stem_up_y_offset = (options2 === null || options2 === void 0 ? void 0 : options2.stem_up_y_offset) || 0;
        this.stem_down_y_offset = (options2 === null || options2 === void 0 ? void 0 : options2.stem_down_y_offset) || 0;
        this.stem_up_y_base_offset = (options2 === null || options2 === void 0 ? void 0 : options2.stem_up_y_base_offset) || 0;
        this.stem_down_y_base_offset = (options2 === null || options2 === void 0 ? void 0 : options2.stem_down_y_base_offset) || 0;
    }
    setNoteHeadXBounds(x_begin, x_end) {
        this.x_begin = x_begin;
        this.x_end = x_end;
        return this;
    }
    setDirection(direction3) {
        this.stem_direction = direction3;
    }
    setExtension(ext) {
        this.stem_extension = ext;
    }
    getExtension() {
        return this.stem_extension;
    }
    setYBounds(y_top, y_bottom) {
        this.y_top = y_top;
        this.y_bottom = y_bottom;
    }
    getHeight() {
        const y_offset = this.stem_direction === _Stem.UP ? this.stem_up_y_offset : this.stem_down_y_offset;
        const unsigned_height = this.y_bottom - this.y_top + (_Stem.HEIGHT - y_offset + this.stem_extension);
        return unsigned_height * this.stem_direction;
    }
    getBoundingBox() {
        throw new $a801f2c896bd09f1$var$RuntimeError("NotImplemented", "getBoundingBox() not implemented.");
    }
    getExtents() {
        const isStemUp = this.stem_direction === _Stem.UP;
        const ys = [
            this.y_top,
            this.y_bottom
        ];
        const stemHeight = _Stem.HEIGHT + this.stem_extension;
        const innerMostNoteheadY = (isStemUp ? Math.min : Math.max)(...ys);
        const outerMostNoteheadY = (isStemUp ? Math.max : Math.min)(...ys);
        const stemTipY = innerMostNoteheadY + stemHeight * -this.stem_direction;
        return {
            topY: stemTipY,
            baseY: outerMostNoteheadY
        };
    }
    setVisibility(isVisible) {
        this.hide = !isVisible;
        return this;
    }
    setStemlet(isStemlet, stemletHeight) {
        this.isStemlet = isStemlet;
        this.stemletHeight = stemletHeight;
        return this;
    }
    adjustHeightForFlag() {
        this.renderHeightAdjustment = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("stem.heightAdjustmentForFlag", -3);
    }
    adjustHeightForBeam() {
        this.renderHeightAdjustment = -_Stem.WIDTH / 2;
    }
    draw() {
        this.setRendered();
        if (this.hide) return;
        const ctx = this.checkContext();
        let stem_x;
        let stem_y;
        const stem_direction = this.stem_direction;
        let y_base_offset = 0;
        if (stem_direction === _Stem.DOWN) {
            stem_x = this.x_begin;
            stem_y = this.y_top + this.stem_down_y_offset;
            y_base_offset = this.stem_down_y_base_offset;
        } else {
            stem_x = this.x_end;
            stem_y = this.y_bottom - this.stem_up_y_offset;
            y_base_offset = this.stem_up_y_base_offset;
        }
        const stemHeight = this.getHeight();
        $a801f2c896bd09f1$var$L2("Rendering stem - ", "Top Y: ", this.y_top, "Bottom Y: ", this.y_bottom);
        const stemletYOffset = this.isStemlet ? stemHeight - this.stemletHeight * this.stem_direction : 0;
        ctx.save();
        this.applyStyle();
        ctx.openGroup("stem", this.getAttribute("id"), {
            pointerBBox: true
        });
        ctx.beginPath();
        ctx.setLineWidth(_Stem.WIDTH);
        ctx.moveTo(stem_x, stem_y - stemletYOffset + y_base_offset);
        ctx.lineTo(stem_x, stem_y - stemHeight - this.renderHeightAdjustment * stem_direction);
        ctx.stroke();
        ctx.closeGroup();
        this.restoreStyle();
        ctx.restore();
    }
};
$a801f2c896bd09f1$var$Stem.DEBUG = false;
// node_modules/vexflow/build/esm/src/textformatter.js
function $a801f2c896bd09f1$var$L3(...args) {
    if ($a801f2c896bd09f1$var$TextFormatter.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.TextFormatter", args);
}
var $a801f2c896bd09f1$var$textWidthCache = {};
var $a801f2c896bd09f1$var$textHeightCache = {};
var $a801f2c896bd09f1$var$registry = {};
var $a801f2c896bd09f1$var$TextFormatter = class _TextFormatter {
    static getFontFamilies() {
        const registeredFonts = [];
        for(const fontFamily in $a801f2c896bd09f1$var$registry){
            const formatterInfo = $a801f2c896bd09f1$var$registry[fontFamily];
            registeredFonts.push(Object.assign({}, formatterInfo));
        }
        return registeredFonts;
    }
    static create(requestedFont = {}) {
        $a801f2c896bd09f1$var$L3("create: ", requestedFont);
        if (!requestedFont.family) requestedFont.family = $a801f2c896bd09f1$var$Font.SANS_SERIF;
        const candidates = [];
        const requestedFamilies = requestedFont.family.split(/\s*,\s*/);
        for (const requestedFamily of requestedFamilies){
            for(const fontFamily in $a801f2c896bd09f1$var$registry)if (fontFamily.startsWith(requestedFamily)) candidates.push($a801f2c896bd09f1$var$registry[fontFamily]);
            if (candidates.length > 0) break;
        }
        let formatter;
        if (candidates.length === 0) formatter = new _TextFormatter(Object.values($a801f2c896bd09f1$var$registry)[0]);
        else if (candidates.length === 1) formatter = new _TextFormatter(candidates[0]);
        else {
            const bold = $a801f2c896bd09f1$var$Font.isBold(requestedFont.weight);
            const italic = $a801f2c896bd09f1$var$Font.isItalic(requestedFont.style);
            const perfectMatch = candidates.find((f2)=>f2.bold === bold && f2.italic === italic);
            if (perfectMatch) formatter = new _TextFormatter(perfectMatch);
            else {
                const partialMatch = candidates.find((f2)=>f2.italic === italic || f2.bold === bold);
                if (partialMatch) formatter = new _TextFormatter(partialMatch);
                else formatter = new _TextFormatter(candidates[0]);
            }
        }
        const fontSize = requestedFont.size;
        if (typeof fontSize !== "undefined") {
            const fontSizeInPt = $a801f2c896bd09f1$var$Font.convertSizeToPointValue(fontSize);
            formatter.setFontSize(fontSizeInPt);
        }
        return formatter;
    }
    static getInfo(fontFamily) {
        return $a801f2c896bd09f1$var$registry[fontFamily];
    }
    static registerInfo(info2, overwrite = false) {
        $a801f2c896bd09f1$var$L3("registerInfo: ", info2, overwrite);
        const fontFamily = info2.family;
        const currFontInfo = $a801f2c896bd09f1$var$registry[fontFamily];
        if (currFontInfo === void 0 || overwrite) $a801f2c896bd09f1$var$registry[fontFamily] = info2;
    }
    constructor(formatterInfo){
        this.family = "";
        this.size = 14;
        this.resolution = 1e3;
        this.glyphs = {};
        this.serifs = false;
        this.monospaced = false;
        this.italic = false;
        this.bold = false;
        this.superscriptOffset = 0;
        this.subscriptOffset = 0;
        this.maxSizeGlyph = "@";
        this.cacheKey = "";
        this.updateParams(formatterInfo);
    }
    get localHeightCache() {
        var _a;
        if ($a801f2c896bd09f1$var$textHeightCache[this.cacheKey] === void 0) $a801f2c896bd09f1$var$textHeightCache[this.cacheKey] = {};
        return (_a = $a801f2c896bd09f1$var$textHeightCache[this.cacheKey]) !== null && _a !== void 0 ? _a : {};
    }
    updateParams(params) {
        if (params.family) this.family = params.family;
        if (params.resolution) this.resolution = params.resolution;
        if (params.glyphs) this.glyphs = params.glyphs;
        if (params.serifs) this.serifs = params.serifs;
        if (params.monospaced) this.monospaced = params.monospaced;
        if (params.italic) this.italic = params.italic;
        if (params.bold) this.bold = params.bold;
        if (params.maxSizeGlyph) this.maxSizeGlyph = params.maxSizeGlyph;
        if (params.superscriptOffset) this.superscriptOffset = params.superscriptOffset;
        if (params.subscriptOffset) this.subscriptOffset = params.subscriptOffset;
        this.updateCacheKey();
    }
    updateCacheKey() {
        const family = this.family.replace(/\s+/g, "_");
        const size6 = this.size;
        const weight = this.bold ? $a801f2c896bd09f1$var$FontWeight.BOLD : $a801f2c896bd09f1$var$FontWeight.NORMAL;
        const style3 = this.italic ? $a801f2c896bd09f1$var$FontStyle.ITALIC : $a801f2c896bd09f1$var$FontStyle.NORMAL;
        this.cacheKey = `${family}%${size6}%${weight}%${style3}`;
    }
    getGlyphMetrics(character) {
        if (this.glyphs[character]) return this.glyphs[character];
        else return this.glyphs[this.maxSizeGlyph];
    }
    get maxHeight() {
        const metrics = this.getGlyphMetrics(this.maxSizeGlyph);
        return metrics.ha / this.resolution * this.fontSizeInPixels;
    }
    getWidthForCharacterInEm(c3) {
        var _a;
        const metrics = this.getGlyphMetrics(c3);
        if (!metrics) return 0.65;
        else {
            const advanceWidth = (_a = metrics.advanceWidth) !== null && _a !== void 0 ? _a : 0;
            return advanceWidth / this.resolution;
        }
    }
    getYForCharacterInPx(c3) {
        const metrics = this.getGlyphMetrics(c3);
        const rv = {
            yMin: 0,
            yMax: this.maxHeight,
            height: this.maxHeight
        };
        if (!metrics) return rv;
        else {
            if (typeof metrics.y_min === "number") rv.yMin = metrics.y_min / this.resolution * this.fontSizeInPixels;
            if (typeof metrics.y_max === "number") rv.yMax = metrics.y_max / this.resolution * this.fontSizeInPixels;
            rv.height = rv.yMax - rv.yMin;
            return rv;
        }
    }
    getYForStringInPx(str) {
        const entry = this.localHeightCache;
        const extent = {
            yMin: 0,
            yMax: this.maxHeight,
            height: this.maxHeight
        };
        const cache = entry[str];
        if (cache !== void 0) return cache;
        for(let i2 = 0; i2 < str.length; ++i2){
            const curY = this.getYForCharacterInPx(str[i2]);
            extent.yMin = Math.min(extent.yMin, curY.yMin);
            extent.yMax = Math.max(extent.yMax, curY.yMax);
            extent.height = extent.yMax - extent.yMin;
        }
        entry[str] = extent;
        return extent;
    }
    getWidthForTextInEm(text7) {
        const key2 = this.cacheKey;
        let cachedWidths = $a801f2c896bd09f1$var$textWidthCache[key2];
        if (cachedWidths === void 0) {
            cachedWidths = {};
            $a801f2c896bd09f1$var$textWidthCache[key2] = cachedWidths;
        }
        let width9 = cachedWidths[text7];
        if (width9 === void 0) {
            width9 = 0;
            for(let i2 = 0; i2 < text7.length; ++i2)width9 += this.getWidthForCharacterInEm(text7[i2]);
            cachedWidths[text7] = width9;
        }
        return width9;
    }
    getWidthForTextInPx(text7) {
        return this.getWidthForTextInEm(text7) * this.fontSizeInPixels;
    }
    setFontSize(size6) {
        this.size = size6;
        this.updateCacheKey();
        return this;
    }
    get fontSizeInPixels() {
        return this.size * $a801f2c896bd09f1$var$Font.scaleToPxFrom.pt;
    }
    getResolution() {
        return this.resolution;
    }
};
$a801f2c896bd09f1$var$TextFormatter.DEBUG = false;
// node_modules/vexflow/build/esm/src/annotation.js
function $a801f2c896bd09f1$var$L4(...args) {
    if ($a801f2c896bd09f1$var$Annotation.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Annotation", args);
}
var $a801f2c896bd09f1$var$AnnotationHorizontalJustify;
(function(AnnotationHorizontalJustify2) {
    AnnotationHorizontalJustify2[AnnotationHorizontalJustify2["LEFT"] = 1] = "LEFT";
    AnnotationHorizontalJustify2[AnnotationHorizontalJustify2["CENTER"] = 2] = "CENTER";
    AnnotationHorizontalJustify2[AnnotationHorizontalJustify2["RIGHT"] = 3] = "RIGHT";
    AnnotationHorizontalJustify2[AnnotationHorizontalJustify2["CENTER_STEM"] = 4] = "CENTER_STEM";
})($a801f2c896bd09f1$var$AnnotationHorizontalJustify || ($a801f2c896bd09f1$var$AnnotationHorizontalJustify = {}));
var $a801f2c896bd09f1$var$AnnotationVerticalJustify;
(function(AnnotationVerticalJustify2) {
    AnnotationVerticalJustify2[AnnotationVerticalJustify2["TOP"] = 1] = "TOP";
    AnnotationVerticalJustify2[AnnotationVerticalJustify2["CENTER"] = 2] = "CENTER";
    AnnotationVerticalJustify2[AnnotationVerticalJustify2["BOTTOM"] = 3] = "BOTTOM";
    AnnotationVerticalJustify2[AnnotationVerticalJustify2["CENTER_STEM"] = 4] = "CENTER_STEM";
})($a801f2c896bd09f1$var$AnnotationVerticalJustify || ($a801f2c896bd09f1$var$AnnotationVerticalJustify = {}));
var $a801f2c896bd09f1$var$Annotation = class _Annotation extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Annotation";
    }
    static get minAnnotationPadding() {
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        return musicFont.lookupMetric("noteHead.minPadding");
    }
    static format(annotations, state3) {
        if (!annotations || annotations.length === 0) return false;
        let leftWidth = 0;
        let rightWidth = 0;
        let maxLeftGlyphWidth = 0;
        let maxRightGlyphWidth = 0;
        for(let i2 = 0; i2 < annotations.length; ++i2){
            const annotation = annotations[i2];
            const textFormatter = $a801f2c896bd09f1$var$TextFormatter.create(annotation.textFont);
            const textLines = (2 + textFormatter.getYForStringInPx(annotation.text).height) / $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE;
            let verticalSpaceNeeded = textLines;
            const note2 = annotation.checkAttachedNote();
            const glyphWidth = note2.getGlyphProps().getWidth();
            const textWidth = textFormatter.getWidthForTextInPx(annotation.text);
            if (annotation.horizontalJustification === $a801f2c896bd09f1$var$AnnotationHorizontalJustify.LEFT) {
                maxLeftGlyphWidth = Math.max(glyphWidth, maxLeftGlyphWidth);
                leftWidth = Math.max(leftWidth, textWidth) + _Annotation.minAnnotationPadding;
            } else if (annotation.horizontalJustification === $a801f2c896bd09f1$var$AnnotationHorizontalJustify.RIGHT) {
                maxRightGlyphWidth = Math.max(glyphWidth, maxRightGlyphWidth);
                rightWidth = Math.max(rightWidth, textWidth);
            } else {
                leftWidth = Math.max(leftWidth, textWidth / 2) + _Annotation.minAnnotationPadding;
                rightWidth = Math.max(rightWidth, textWidth / 2);
                maxLeftGlyphWidth = Math.max(glyphWidth / 2, maxLeftGlyphWidth);
                maxRightGlyphWidth = Math.max(glyphWidth / 2, maxRightGlyphWidth);
            }
            const stave = note2.getStave();
            const stemDirection = note2.hasStem() ? note2.getStemDirection() : $a801f2c896bd09f1$var$Stem.UP;
            let stemHeight = 0;
            let lines = 5;
            if ($a801f2c896bd09f1$var$isTabNote(note2)) {
                if (note2.render_options.draw_stem) {
                    const stem = note2.getStem();
                    if (stem) stemHeight = Math.abs(stem.getHeight()) / $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE;
                } else stemHeight = 0;
            } else if ($a801f2c896bd09f1$var$isStemmableNote(note2)) {
                const stem = note2.getStem();
                if (stem && note2.getNoteType() === "n") stemHeight = Math.abs(stem.getHeight()) / $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE;
            }
            if (stave) lines = stave.getNumLines();
            if (annotation.verticalJustification === this.VerticalJustify.TOP) {
                let noteLine = note2.getLineNumber(true);
                if ($a801f2c896bd09f1$var$isTabNote(note2)) noteLine = lines - (note2.leastString() - 0.5);
                if (stemDirection === $a801f2c896bd09f1$var$Stem.UP) noteLine += stemHeight;
                const curTop = noteLine + state3.top_text_line + 0.5;
                if (curTop < lines) {
                    annotation.setTextLine(lines - noteLine);
                    verticalSpaceNeeded += lines - noteLine;
                    state3.top_text_line = verticalSpaceNeeded;
                } else {
                    annotation.setTextLine(state3.top_text_line);
                    state3.top_text_line += verticalSpaceNeeded;
                }
            } else if (annotation.verticalJustification === this.VerticalJustify.BOTTOM) {
                let noteLine = lines - note2.getLineNumber();
                if ($a801f2c896bd09f1$var$isTabNote(note2)) noteLine = note2.greatestString() - 1;
                if (stemDirection === $a801f2c896bd09f1$var$Stem.DOWN) noteLine += stemHeight;
                const curBottom = noteLine + state3.text_line + 1;
                if (curBottom < lines) {
                    annotation.setTextLine(lines - curBottom);
                    verticalSpaceNeeded += lines - curBottom;
                    state3.text_line = verticalSpaceNeeded;
                } else {
                    annotation.setTextLine(state3.text_line);
                    state3.text_line += verticalSpaceNeeded;
                }
            } else annotation.setTextLine(state3.text_line);
        }
        const rightOverlap = Math.min(Math.max(rightWidth - maxRightGlyphWidth, 0), Math.max(rightWidth - state3.right_shift, 0));
        const leftOverlap = Math.min(Math.max(leftWidth - maxLeftGlyphWidth, 0), Math.max(leftWidth - state3.left_shift, 0));
        state3.left_shift += leftOverlap;
        state3.right_shift += rightOverlap;
        return true;
    }
    constructor(text7){
        super();
        this.text = text7;
        this.horizontalJustification = $a801f2c896bd09f1$var$AnnotationHorizontalJustify.CENTER;
        this.verticalJustification = $a801f2c896bd09f1$var$AnnotationVerticalJustify.TOP;
        this.resetFont();
        this.setWidth($a801f2c896bd09f1$var$Tables.textWidth(text7));
    }
    setVerticalJustification(just) {
        this.verticalJustification = typeof just === "string" ? _Annotation.VerticalJustifyString[just] : just;
        return this;
    }
    getJustification() {
        return this.horizontalJustification;
    }
    setJustification(just) {
        this.horizontalJustification = typeof just === "string" ? _Annotation.HorizontalJustifyString[just] : just;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        const stemDirection = note2.hasStem() ? note2.getStemDirection() : $a801f2c896bd09f1$var$Stem.UP;
        const textFormatter = $a801f2c896bd09f1$var$TextFormatter.create(this.textFont);
        const start2 = note2.getModifierStartXY($a801f2c896bd09f1$var$ModifierPosition.ABOVE, this.index);
        this.setRendered();
        ctx.save();
        this.applyStyle();
        ctx.openGroup("annotation", this.getAttribute("id"));
        ctx.setFont(this.textFont);
        const text_width = textFormatter.getWidthForTextInPx(this.text);
        const text_height = textFormatter.getYForStringInPx(this.text).height;
        let x4;
        let y4;
        if (this.horizontalJustification === $a801f2c896bd09f1$var$AnnotationHorizontalJustify.LEFT) x4 = start2.x;
        else if (this.horizontalJustification === $a801f2c896bd09f1$var$AnnotationHorizontalJustify.RIGHT) x4 = start2.x - text_width;
        else if (this.horizontalJustification === $a801f2c896bd09f1$var$AnnotationHorizontalJustify.CENTER) x4 = start2.x - text_width / 2;
        else x4 = note2.getStemX() - text_width / 2;
        let stem_ext = {};
        let spacing = 0;
        const has_stem = note2.hasStem();
        const stave = note2.checkStave();
        if (has_stem) {
            stem_ext = note2.checkStem().getExtents();
            spacing = stave.getSpacingBetweenLines();
        }
        if (this.verticalJustification === $a801f2c896bd09f1$var$AnnotationVerticalJustify.BOTTOM) {
            const ys = note2.getYs();
            y4 = ys.reduce((a3, b3)=>a3 > b3 ? a3 : b3);
            y4 += (this.text_line + 1) * $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE + text_height;
            if (has_stem && stemDirection === $a801f2c896bd09f1$var$Stem.DOWN) y4 = Math.max(y4, stem_ext.topY + text_height + spacing * this.text_line);
        } else if (this.verticalJustification === $a801f2c896bd09f1$var$AnnotationVerticalJustify.CENTER) {
            const yt = note2.getYForTopText(this.text_line) - 1;
            const yb = stave.getYForBottomText(this.text_line);
            y4 = yt + (yb - yt) / 2 + text_height / 2;
        } else if (this.verticalJustification === $a801f2c896bd09f1$var$AnnotationVerticalJustify.TOP) {
            const topY = Math.min(...note2.getYs());
            y4 = topY - (this.text_line + 1) * $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE;
            if (has_stem && stemDirection === $a801f2c896bd09f1$var$Stem.UP) {
                spacing = stem_ext.topY < stave.getTopLineTopY() ? $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE : spacing;
                y4 = Math.min(y4, stem_ext.topY - spacing * (this.text_line + 1));
            }
        } else {
            const extents = note2.getStemExtents();
            y4 = extents.topY + (extents.baseY - extents.topY) / 2 + text_height / 2;
        }
        $a801f2c896bd09f1$var$L4("Rendering annotation: ", this.text, x4, y4);
        ctx.fillText(this.text, x4, y4);
        ctx.closeGroup();
        this.restoreStyle();
        ctx.restore();
    }
};
$a801f2c896bd09f1$var$Annotation.DEBUG = false;
$a801f2c896bd09f1$var$Annotation.TEXT_FONT = Object.assign({}, $a801f2c896bd09f1$var$Element.TEXT_FONT);
$a801f2c896bd09f1$var$Annotation.HorizontalJustify = $a801f2c896bd09f1$var$AnnotationHorizontalJustify;
$a801f2c896bd09f1$var$Annotation.HorizontalJustifyString = {
    left: $a801f2c896bd09f1$var$AnnotationHorizontalJustify.LEFT,
    right: $a801f2c896bd09f1$var$AnnotationHorizontalJustify.RIGHT,
    center: $a801f2c896bd09f1$var$AnnotationHorizontalJustify.CENTER,
    centerStem: $a801f2c896bd09f1$var$AnnotationHorizontalJustify.CENTER_STEM
};
$a801f2c896bd09f1$var$Annotation.VerticalJustify = $a801f2c896bd09f1$var$AnnotationVerticalJustify;
$a801f2c896bd09f1$var$Annotation.VerticalJustifyString = {
    above: $a801f2c896bd09f1$var$AnnotationVerticalJustify.TOP,
    top: $a801f2c896bd09f1$var$AnnotationVerticalJustify.TOP,
    below: $a801f2c896bd09f1$var$AnnotationVerticalJustify.BOTTOM,
    bottom: $a801f2c896bd09f1$var$AnnotationVerticalJustify.BOTTOM,
    center: $a801f2c896bd09f1$var$AnnotationVerticalJustify.CENTER,
    centerStem: $a801f2c896bd09f1$var$AnnotationVerticalJustify.CENTER_STEM
};
// node_modules/vexflow/build/esm/src/articulation.js
function $a801f2c896bd09f1$var$L5(...args) {
    if ($a801f2c896bd09f1$var$Articulation.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Articulation", args);
}
var { ABOVE: $a801f2c896bd09f1$var$ABOVE, BELOW: $a801f2c896bd09f1$var$BELOW } = $a801f2c896bd09f1$var$Modifier.Position;
function $a801f2c896bd09f1$var$roundToNearestHalf(mathFn, value17) {
    return mathFn(value17 / 0.5) * 0.5;
}
function $a801f2c896bd09f1$var$isWithinLines(line2, position2) {
    return position2 === $a801f2c896bd09f1$var$ABOVE ? line2 <= 5 : line2 >= 1;
}
function $a801f2c896bd09f1$var$getRoundingFunction(line2, position2) {
    if ($a801f2c896bd09f1$var$isWithinLines(line2, position2)) {
        if (position2 === $a801f2c896bd09f1$var$ABOVE) return Math.ceil;
        else return Math.floor;
    } else return Math.round;
}
function $a801f2c896bd09f1$var$snapLineToStaff(canSitBetweenLines, line2, position2, offsetDirection) {
    const snappedLine = $a801f2c896bd09f1$var$roundToNearestHalf($a801f2c896bd09f1$var$getRoundingFunction(line2, position2), line2);
    const canSnapToStaffSpace = canSitBetweenLines && $a801f2c896bd09f1$var$isWithinLines(snappedLine, position2);
    const onStaffLine = snappedLine % 1 === 0;
    if (canSnapToStaffSpace && onStaffLine) {
        const HALF_STAFF_SPACE = 0.5;
        return snappedLine + HALF_STAFF_SPACE * -offsetDirection;
    } else return snappedLine;
}
var $a801f2c896bd09f1$var$isStaveOrGraceNote = (note2)=>$a801f2c896bd09f1$var$isStaveNote(note2) || $a801f2c896bd09f1$var$isGraceNote(note2);
function $a801f2c896bd09f1$var$getTopY(note2, textLine) {
    const stemDirection = note2.getStemDirection();
    const { topY: stemTipY, baseY: stemBaseY } = note2.getStemExtents();
    if ($a801f2c896bd09f1$var$isStaveOrGraceNote(note2)) {
        if (note2.hasStem()) {
            if (stemDirection === $a801f2c896bd09f1$var$Stem.UP) return stemTipY;
            else return stemBaseY;
        } else return Math.min(...note2.getYs());
    } else if ($a801f2c896bd09f1$var$isTabNote(note2)) {
        if (note2.hasStem()) {
            if (stemDirection === $a801f2c896bd09f1$var$Stem.UP) return stemTipY;
            else return note2.checkStave().getYForTopText(textLine);
        } else return note2.checkStave().getYForTopText(textLine);
    } else throw new $a801f2c896bd09f1$var$RuntimeError("UnknownCategory", "Only can get the top and bottom ys of stavenotes and tabnotes");
}
function $a801f2c896bd09f1$var$getBottomY(note2, textLine) {
    const stemDirection = note2.getStemDirection();
    const { topY: stemTipY, baseY: stemBaseY } = note2.getStemExtents();
    if ($a801f2c896bd09f1$var$isStaveOrGraceNote(note2)) {
        if (note2.hasStem()) {
            if (stemDirection === $a801f2c896bd09f1$var$Stem.UP) return stemBaseY;
            else return stemTipY;
        } else return Math.max(...note2.getYs());
    } else if ($a801f2c896bd09f1$var$isTabNote(note2)) {
        if (note2.hasStem()) {
            if (stemDirection === $a801f2c896bd09f1$var$Stem.UP) return note2.checkStave().getYForBottomText(textLine);
            else return stemTipY;
        } else return note2.checkStave().getYForBottomText(textLine);
    } else throw new $a801f2c896bd09f1$var$RuntimeError("UnknownCategory", "Only can get the top and bottom ys of stavenotes and tabnotes");
}
function $a801f2c896bd09f1$var$getInitialOffset(note2, position2) {
    const isOnStemTip = position2 === $a801f2c896bd09f1$var$ABOVE && note2.getStemDirection() === $a801f2c896bd09f1$var$Stem.UP || position2 === $a801f2c896bd09f1$var$BELOW && note2.getStemDirection() === $a801f2c896bd09f1$var$Stem.DOWN;
    if ($a801f2c896bd09f1$var$isStaveOrGraceNote(note2)) {
        if (note2.hasStem() && isOnStemTip) return 0.5;
        else return 1;
    } else {
        if (note2.hasStem() && isOnStemTip) return 1;
        else return 0;
    }
}
var $a801f2c896bd09f1$var$Articulation = class _Articulation extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Articulation";
    }
    static format(articulations2, state3) {
        if (!articulations2 || articulations2.length === 0) return false;
        const margin = 0.5;
        let maxGlyphWidth = 0;
        const getIncrement = (articulation, line2, position2)=>$a801f2c896bd09f1$var$roundToNearestHalf($a801f2c896bd09f1$var$getRoundingFunction(line2, position2), $a801f2c896bd09f1$var$defined(articulation.glyph.getMetrics().height) / 10 + margin);
        articulations2.forEach((articulation)=>{
            const note2 = articulation.checkAttachedNote();
            maxGlyphWidth = Math.max(note2.getGlyphProps().getWidth(), maxGlyphWidth);
            let lines = 5;
            const stemDirection = note2.hasStem() ? note2.getStemDirection() : $a801f2c896bd09f1$var$Stem.UP;
            let stemHeight = 0;
            if ($a801f2c896bd09f1$var$isStemmableNote(note2)) {
                const stem = note2.getStem();
                if (stem) stemHeight = Math.abs(stem.getHeight()) / $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE;
            }
            const stave = note2.getStave();
            if (stave) lines = stave.getNumLines();
            if (articulation.getPosition() === $a801f2c896bd09f1$var$ABOVE) {
                let noteLine = note2.getLineNumber(true);
                if (stemDirection === $a801f2c896bd09f1$var$Stem.UP) noteLine += stemHeight;
                let increment = getIncrement(articulation, state3.top_text_line, $a801f2c896bd09f1$var$ABOVE);
                const curTop = noteLine + state3.top_text_line + 0.5;
                if (!articulation.articulation.between_lines && curTop < lines) increment += lines - curTop;
                articulation.setTextLine(state3.top_text_line);
                state3.top_text_line += increment;
            } else if (articulation.getPosition() === $a801f2c896bd09f1$var$BELOW) {
                let noteLine = Math.max(lines - note2.getLineNumber(), 0);
                if (stemDirection === $a801f2c896bd09f1$var$Stem.DOWN) noteLine += stemHeight;
                let increment = getIncrement(articulation, state3.text_line, $a801f2c896bd09f1$var$BELOW);
                const curBottom = noteLine + state3.text_line + 0.5;
                if (!articulation.articulation.between_lines && curBottom < lines) increment += lines - curBottom;
                articulation.setTextLine(state3.text_line);
                state3.text_line += increment;
            }
        });
        const width9 = articulations2.map((articulation)=>articulation.getWidth()).reduce((maxWidth, articWidth)=>Math.max(articWidth, maxWidth));
        const overlap = Math.min(Math.max(width9 - maxGlyphWidth, 0), Math.max(width9 - (state3.left_shift + state3.right_shift), 0));
        state3.left_shift += overlap / 2;
        state3.right_shift += overlap / 2;
        return true;
    }
    static easyScoreHook({ articulations: articulations2 }, note2, builder) {
        if (!articulations2) return;
        const articNameToCode = {
            staccato: "a.",
            tenuto: "a-",
            accent: "a>"
        };
        articulations2.split(",").map((articString)=>articString.trim().split(".")).map(([name17, position2])=>{
            const artic = {
                type: articNameToCode[name17]
            };
            if (position2) artic.position = $a801f2c896bd09f1$var$Modifier.PositionString[position2];
            return builder.getFactory().Articulation(artic);
        }).map((artic)=>note2.addModifier(artic, 0));
    }
    constructor(type){
        super();
        this.type = type;
        this.position = $a801f2c896bd09f1$var$ABOVE;
        this.render_options = {
            font_scale: $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE
        };
        this.reset();
    }
    reset() {
        this.articulation = $a801f2c896bd09f1$var$Tables.articulationCodes(this.type);
        if (!this.articulation) {
            this.articulation = {
                code: this.type,
                between_lines: false
            };
            if (this.type.endsWith("Above")) this.position = $a801f2c896bd09f1$var$ABOVE;
            if (this.type.endsWith("Below")) this.position = $a801f2c896bd09f1$var$BELOW;
        }
        const code3 = (this.position === $a801f2c896bd09f1$var$ABOVE ? this.articulation.aboveCode : this.articulation.belowCode) || this.articulation.code;
        this.glyph = new $a801f2c896bd09f1$var$Glyph(code3 !== null && code3 !== void 0 ? code3 : "", this.render_options.font_scale);
        $a801f2c896bd09f1$var$defined(this.glyph, "ArgumentError", `Articulation not found: ${this.type}`);
        this.setWidth($a801f2c896bd09f1$var$defined(this.glyph.getMetrics().width));
    }
    setBetweenLines(betweenLines = true) {
        this.articulation.between_lines = betweenLines;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const index5 = this.checkIndex();
        const { position: position2, glyph: glyph, text_line: textLine } = this;
        const canSitBetweenLines = this.articulation.between_lines;
        const stave = note2.checkStave();
        const staffSpace = stave.getSpacingBetweenLines();
        const isTab = $a801f2c896bd09f1$var$isTabNote(note2);
        const { x: x4 } = note2.getModifierStartXY(position2, index5);
        const shouldSitOutsideStaff = !canSitBetweenLines || isTab;
        const initialOffset = $a801f2c896bd09f1$var$getInitialOffset(note2, position2);
        const padding = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric(`articulation.${glyph.getCode()}.padding`, 0);
        let y4 = ({
            [$a801f2c896bd09f1$var$ABOVE]: ()=>{
                glyph.setOrigin(0.5, 1);
                const y5 = $a801f2c896bd09f1$var$getTopY(note2, textLine) - (textLine + initialOffset) * staffSpace;
                return shouldSitOutsideStaff ? Math.min(stave.getYForTopText(_Articulation.INITIAL_OFFSET), y5) : y5;
            },
            [$a801f2c896bd09f1$var$BELOW]: ()=>{
                glyph.setOrigin(0.5, 0);
                const y5 = $a801f2c896bd09f1$var$getBottomY(note2, textLine) + (textLine + initialOffset) * staffSpace;
                return shouldSitOutsideStaff ? Math.max(stave.getYForBottomText(_Articulation.INITIAL_OFFSET), y5) : y5;
            }
        })[position2]();
        if (!isTab) {
            const offsetDirection = position2 === $a801f2c896bd09f1$var$ABOVE ? -1 : 1;
            const noteLine = note2.getKeyProps()[index5].line;
            const distanceFromNote = (note2.getYs()[index5] - y4) / staffSpace;
            const articLine = distanceFromNote + Number(noteLine);
            const snappedLine = $a801f2c896bd09f1$var$snapLineToStaff(canSitBetweenLines, articLine, position2, offsetDirection);
            if ($a801f2c896bd09f1$var$isWithinLines(snappedLine, position2)) glyph.setOrigin(0.5, 0.5);
            y4 += Math.abs(snappedLine - articLine) * staffSpace * offsetDirection + padding * offsetDirection;
        }
        $a801f2c896bd09f1$var$L5(`Rendering articulation at (x: ${x4}, y: ${y4})`);
        glyph.render(ctx, x4, y4);
    }
};
$a801f2c896bd09f1$var$Articulation.DEBUG = false;
$a801f2c896bd09f1$var$Articulation.INITIAL_OFFSET = -0.5;
// node_modules/vexflow/build/esm/src/rendercontext.js
var $a801f2c896bd09f1$var$RenderContext = class {
    static get CATEGORY() {
        return "RenderContext";
    }
    set font(f2) {
        this.setFont(f2);
    }
    get font() {
        return this.getFont();
    }
    setRawFont(f2) {
        this.setFont(f2);
        return this;
    }
};
function $a801f2c896bd09f1$var$drawDot(ctx, x4, y4, color = "#F55") {
    ctx.save();
    ctx.setFillStyle(color);
    ctx.beginPath();
    ctx.arc(x4, y4, 3, 0, Math.PI * 2, false);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
}
// node_modules/vexflow/build/esm/src/tickable.js
var $a801f2c896bd09f1$var$Tickable = class extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "Tickable";
    }
    constructor(){
        super();
        this._preFormatted = false;
        this._postFormatted = false;
        this.ticks = new $a801f2c896bd09f1$var$Fraction(0, 1);
        this.intrinsicTicks = 0;
        this.tickMultiplier = new $a801f2c896bd09f1$var$Fraction(1, 1);
        this.width = 0;
        this.x_shift = 0;
        this.modifiers = [];
        this.tupletStack = [];
        this.align_center = false;
        this.center_x_shift = 0;
        this.ignore_ticks = false;
        this.formatterMetrics = {
            freedom: {
                left: 0,
                right: 0
            },
            duration: "",
            iterations: 0,
            space: {
                used: 0,
                mean: 0,
                deviation: 0
            }
        };
    }
    reset() {
        return this;
    }
    getTicks() {
        return this.ticks;
    }
    shouldIgnoreTicks() {
        return this.ignore_ticks;
    }
    setIgnoreTicks(flag) {
        this.ignore_ticks = flag;
        return this;
    }
    setWidth(width9) {
        this.width = width9;
    }
    getWidth() {
        if (!this._preFormatted) throw new $a801f2c896bd09f1$var$RuntimeError("UnformattedNote", "Can't call GetWidth on an unformatted note.");
        return this.width + (this.modifierContext ? this.modifierContext.getWidth() : 0);
    }
    setXShift(x4) {
        this.x_shift = x4;
        return this;
    }
    getXShift() {
        return this.x_shift;
    }
    getX() {
        const tickContext = this.checkTickContext(`Can't getX() without a TickContext.`);
        return tickContext.getX() + this.x_shift;
    }
    getFormatterMetrics() {
        return this.formatterMetrics;
    }
    getCenterXShift() {
        if (this.isCenterAligned()) return this.center_x_shift;
        return 0;
    }
    setCenterXShift(centerXShift) {
        this.center_x_shift = centerXShift;
        return this;
    }
    isCenterAligned() {
        return this.align_center;
    }
    setCenterAlignment(align_center) {
        this.align_center = align_center;
        return this;
    }
    getVoice() {
        return $a801f2c896bd09f1$var$defined(this.voice, "NoVoice", "Tickable has no voice.");
    }
    setVoice(voice) {
        this.voice = voice;
    }
    getTuplet() {
        return this.tuplet;
    }
    getTupletStack() {
        return this.tupletStack;
    }
    resetTuplet(tuplet) {
        let noteCount;
        let notesOccupied;
        if (tuplet) {
            const i2 = this.tupletStack.indexOf(tuplet);
            if (i2 !== -1) {
                this.tupletStack.splice(i2, 1);
                noteCount = tuplet.getNoteCount();
                notesOccupied = tuplet.getNotesOccupied();
                this.applyTickMultiplier(noteCount, notesOccupied);
            }
            return this;
        }
        while(this.tupletStack.length){
            tuplet = this.tupletStack.pop();
            noteCount = tuplet.getNoteCount();
            notesOccupied = tuplet.getNotesOccupied();
            this.applyTickMultiplier(noteCount, notesOccupied);
        }
        return this;
    }
    setTuplet(tuplet) {
        if (tuplet) {
            this.tupletStack.push(tuplet);
            const noteCount = tuplet.getNoteCount();
            const notesOccupied = tuplet.getNotesOccupied();
            this.applyTickMultiplier(notesOccupied, noteCount);
        }
        this.tuplet = tuplet;
        return this;
    }
    addToModifierContext(mc) {
        this.modifierContext = mc;
        for(let i2 = 0; i2 < this.modifiers.length; ++i2)this.modifierContext.addMember(this.modifiers[i2]);
        this.modifierContext.addMember(this);
        this._preFormatted = false;
        return this;
    }
    addModifier(modifier, index5 = 0) {
        this.modifiers.push(modifier);
        this._preFormatted = false;
        return this;
    }
    getModifiers() {
        return this.modifiers;
    }
    setTickContext(tc) {
        this.tickContext = tc;
        this._preFormatted = false;
    }
    checkTickContext(message2 = "Tickable has no tick context.") {
        return $a801f2c896bd09f1$var$defined(this.tickContext, "NoTickContext", message2);
    }
    preFormat() {
        if (this._preFormatted) return;
        this.width = 0;
        if (this.modifierContext) {
            this.modifierContext.preFormat();
            this.width += this.modifierContext.getWidth();
        }
    }
    set preFormatted(value17) {
        this._preFormatted = value17;
    }
    get preFormatted() {
        return this._preFormatted;
    }
    postFormat() {
        if (this._postFormatted) return this;
        this._postFormatted = true;
        return this;
    }
    set postFormatted(value17) {
        this._postFormatted = value17;
    }
    get postFormatted() {
        return this._postFormatted;
    }
    getIntrinsicTicks() {
        return this.intrinsicTicks;
    }
    setIntrinsicTicks(intrinsicTicks) {
        this.intrinsicTicks = intrinsicTicks;
        this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
    }
    getTickMultiplier() {
        return this.tickMultiplier;
    }
    applyTickMultiplier(numerator2, denominator2) {
        this.tickMultiplier.multiply(numerator2, denominator2);
        this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
    }
    setDuration(duration2) {
        const ticks = duration2.numerator * ($a801f2c896bd09f1$var$Tables.RESOLUTION / duration2.denominator);
        this.ticks = this.tickMultiplier.clone().multiply(ticks);
        this.intrinsicTicks = this.ticks.value();
    }
    getAbsoluteX() {
        const tickContext = this.checkTickContext(`Can't getAbsoluteX() without a TickContext.`);
        return tickContext.getX();
    }
    setModifierContext(mc) {
        this.modifierContext = mc;
        return this;
    }
    getModifierContext() {
        return this.modifierContext;
    }
    checkModifierContext() {
        return $a801f2c896bd09f1$var$defined(this.modifierContext, "NoModifierContext", "No modifier context attached to this tickable.");
    }
};
// node_modules/vexflow/build/esm/src/note.js
var $a801f2c896bd09f1$var$Note = class _Note extends $a801f2c896bd09f1$var$Tickable {
    static get CATEGORY() {
        return "Note";
    }
    static plotMetrics(ctx, note2, yPos) {
        const metrics = note2.getMetrics();
        const xStart = note2.getAbsoluteX() - metrics.modLeftPx - metrics.leftDisplacedHeadPx;
        const xPre1 = note2.getAbsoluteX() - metrics.leftDisplacedHeadPx;
        const xAbs = note2.getAbsoluteX();
        const xPost1 = note2.getAbsoluteX() + metrics.notePx;
        const xPost2 = note2.getAbsoluteX() + metrics.notePx + metrics.rightDisplacedHeadPx;
        const xEnd = note2.getAbsoluteX() + metrics.notePx + metrics.rightDisplacedHeadPx + metrics.modRightPx;
        const xFreedomRight = xEnd + (note2.getFormatterMetrics().freedom.right || 0);
        const xWidth = xEnd - xStart;
        ctx.save();
        ctx.setFont($a801f2c896bd09f1$var$Font.SANS_SERIF, 8);
        ctx.fillText(Math.round(xWidth) + "px", xStart + note2.getXShift(), yPos);
        const y4 = yPos + 7;
        function stroke2(x12, x22, color, yy = y4) {
            ctx.beginPath();
            ctx.setStrokeStyle(color);
            ctx.setFillStyle(color);
            ctx.setLineWidth(3);
            ctx.moveTo(x12 + note2.getXShift(), yy);
            ctx.lineTo(x22 + note2.getXShift(), yy);
            ctx.stroke();
        }
        stroke2(xStart, xPre1, "red");
        stroke2(xPre1, xAbs, "#999");
        stroke2(xAbs, xPost1, "green");
        stroke2(xPost1, xPost2, "#999");
        stroke2(xPost2, xEnd, "red");
        stroke2(xEnd, xFreedomRight, "#DD0");
        stroke2(xStart - note2.getXShift(), xStart, "#BBB");
        $a801f2c896bd09f1$var$drawDot(ctx, xAbs + note2.getXShift(), y4, "blue");
        const formatterMetrics = note2.getFormatterMetrics();
        if (formatterMetrics.iterations > 0) {
            const spaceDeviation = formatterMetrics.space.deviation;
            const prefix2 = spaceDeviation >= 0 ? "+" : "";
            ctx.setFillStyle("red");
            ctx.fillText(prefix2 + Math.round(spaceDeviation), xAbs + note2.getXShift(), yPos - 10);
        }
        ctx.restore();
    }
    static parseDuration(durationString) {
        if (!durationString) return void 0;
        const regexp = /(\d*\/?\d+|[a-z])(d*)([nrhms]|$)/;
        const result2 = regexp.exec(durationString);
        if (!result2) return void 0;
        const duration2 = result2[1];
        const dots = result2[2].length;
        const type = result2[3] || "n";
        return {
            duration: duration2,
            dots: dots,
            type: type
        };
    }
    static parseNoteStruct(noteStruct) {
        const durationProps = _Note.parseDuration(noteStruct.duration);
        if (!durationProps) return void 0;
        let type = noteStruct.type;
        if (type && !$a801f2c896bd09f1$var$Tables.validTypes[type]) return void 0;
        const customTypes = [];
        if (!type) {
            type = durationProps.type || "n";
            if (noteStruct.keys !== void 0) noteStruct.keys.forEach((k2, i2)=>{
                const result2 = k2.split("/");
                customTypes[i2] = result2 && result2.length === 3 ? result2[2] : type;
            });
        }
        let ticks = $a801f2c896bd09f1$var$Tables.durationToTicks(durationProps.duration);
        if (!ticks) return void 0;
        const dots = noteStruct.dots ? noteStruct.dots : durationProps.dots;
        if (typeof dots !== "number") return void 0;
        let currentTicks = ticks;
        for(let i2 = 0; i2 < dots; i2++){
            if (currentTicks <= 1) return void 0;
            currentTicks = currentTicks / 2;
            ticks += currentTicks;
        }
        return {
            duration: durationProps.duration,
            type: type,
            customTypes: customTypes,
            dots: dots,
            ticks: ticks
        };
    }
    constructor(noteStruct){
        super();
        if (!noteStruct) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Note must have valid initialization data to identify duration and type.");
        const parsedNoteStruct = _Note.parseNoteStruct(noteStruct);
        if (!parsedNoteStruct) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid note initialization object: ${JSON.stringify(noteStruct)}`);
        this.keys = noteStruct.keys || [];
        this.keyProps = [];
        this.duration = parsedNoteStruct.duration;
        this.noteType = parsedNoteStruct.type;
        this.customTypes = parsedNoteStruct.customTypes;
        if (noteStruct.duration_override) this.setDuration(noteStruct.duration_override);
        else this.setIntrinsicTicks(parsedNoteStruct.ticks);
        this.modifiers = [];
        this.glyphProps = $a801f2c896bd09f1$var$Tables.getGlyphProps(this.duration, this.noteType);
        this.customGlyphs = this.customTypes.map((t2)=>$a801f2c896bd09f1$var$Tables.getGlyphProps(this.duration, t2));
        this.playNote = void 0;
        this.ignore_ticks = false;
        this.width = 0;
        this.leftDisplacedHeadPx = 0;
        this.rightDisplacedHeadPx = 0;
        this.x_shift = 0;
        this.ys = [];
        if (noteStruct.align_center) this.setCenterAlignment(noteStruct.align_center);
        this.render_options = {
            annotation_spacing: 5,
            glyph_font_scale: 1,
            stroke_px: 1,
            scale: 1,
            font: "",
            y_shift: 0
        };
    }
    getPlayNote() {
        return this.playNote;
    }
    setPlayNote(note2) {
        this.playNote = note2;
        return this;
    }
    isRest() {
        return false;
    }
    addStroke(index5, stroke2) {
        stroke2.setNote(this);
        stroke2.setIndex(index5);
        this.modifiers.push(stroke2);
        this.preFormatted = false;
        return this;
    }
    getStave() {
        return this.stave;
    }
    checkStave() {
        return $a801f2c896bd09f1$var$defined(this.stave, "NoStave", "No stave attached to instance.");
    }
    setStave(stave) {
        this.stave = stave;
        this.setYs([
            stave.getYForLine(0)
        ]);
        this.setContext(this.stave.getContext());
        return this;
    }
    getLeftDisplacedHeadPx() {
        return this.leftDisplacedHeadPx;
    }
    getRightDisplacedHeadPx() {
        return this.rightDisplacedHeadPx;
    }
    setLeftDisplacedHeadPx(x4) {
        this.leftDisplacedHeadPx = x4;
        return this;
    }
    setRightDisplacedHeadPx(x4) {
        this.rightDisplacedHeadPx = x4;
        return this;
    }
    shouldIgnoreTicks() {
        return this.ignore_ticks;
    }
    getLineNumber(isTopNote) {
        return 0;
    }
    getLineForRest() {
        return 0;
    }
    getGlyph() {
        return this.glyphProps;
    }
    getGlyphProps() {
        return this.glyphProps;
    }
    getGlyphWidth() {
        return this.glyphProps.getWidth(this.render_options.glyph_font_scale);
    }
    setYs(ys) {
        this.ys = ys;
        return this;
    }
    getYs() {
        if (this.ys.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("NoYValues", "No Y-values calculated for this note.");
        return this.ys;
    }
    getYForTopText(text_line) {
        return this.checkStave().getYForTopText(text_line);
    }
    getVoice() {
        if (!this.voice) throw new $a801f2c896bd09f1$var$RuntimeError("NoVoice", "Note has no voice.");
        return this.voice;
    }
    setVoice(voice) {
        this.voice = voice;
        this.preFormatted = false;
        return this;
    }
    getTickContext() {
        return this.checkTickContext();
    }
    setTickContext(tc) {
        this.tickContext = tc;
        this.preFormatted = false;
        return this;
    }
    getDuration() {
        return this.duration;
    }
    isDotted() {
        return this.getModifiersByType("Dot").length > 0;
    }
    hasStem() {
        return false;
    }
    getNoteType() {
        return this.noteType;
    }
    getBeam() {
        return this.beam;
    }
    checkBeam() {
        return $a801f2c896bd09f1$var$defined(this.beam, "NoBeam", "No beam attached to instance");
    }
    hasBeam() {
        return this.beam != void 0;
    }
    setBeam(beam) {
        this.beam = beam;
        return this;
    }
    addModifier(modifier, index5 = 0) {
        const signature = "Note.addModifier(modifier: Modifier, index: number=0)";
        if (typeof index5 === "string") {
            index5 = parseInt(index5);
            console.warn(signature + " expected a number for `index`, but received a string.");
        }
        if (typeof modifier !== "object" || typeof index5 !== "number") throw new $a801f2c896bd09f1$var$RuntimeError("WrongParams", "Incorrect call signature. Use " + signature + " instead.");
        modifier.setNote(this);
        modifier.setIndex(index5);
        super.addModifier(modifier);
        return this;
    }
    getModifiersByType(type) {
        return this.modifiers.filter((modifier)=>modifier.getCategory() === type);
    }
    getModifierStartXY(position2, index5, options2) {
        if (!this.preFormatted) throw new $a801f2c896bd09f1$var$RuntimeError("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
        return {
            x: this.getAbsoluteX(),
            y: this.ys[0]
        };
    }
    getRightParenthesisPx(index5) {
        const props = this.getKeyProps()[index5];
        return props.displaced ? this.getRightDisplacedHeadPx() : 0;
    }
    getLeftParenthesisPx(index5) {
        const props = this.getKeyProps()[index5];
        return props.displaced ? this.getLeftDisplacedHeadPx() - this.x_shift : -this.x_shift;
    }
    getFirstDotPx() {
        let px = this.getRightDisplacedHeadPx();
        if (this.checkModifierContext().getMembers("Parenthesis").length !== 0) px += $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("parenthesis.default.width");
        return px;
    }
    getMetrics() {
        if (!this.preFormatted) throw new $a801f2c896bd09f1$var$RuntimeError("UnformattedNote", "Can't call getMetrics on an unformatted note.");
        const modLeftPx = this.modifierContext ? this.modifierContext.getState().left_shift : 0;
        const modRightPx = this.modifierContext ? this.modifierContext.getState().right_shift : 0;
        const width9 = this.getWidth();
        const glyphWidth = this.getGlyphWidth();
        const notePx = width9 - modLeftPx - modRightPx - this.leftDisplacedHeadPx - this.rightDisplacedHeadPx;
        return {
            width: width9,
            glyphWidth: glyphWidth,
            notePx: notePx,
            modLeftPx: modLeftPx,
            modRightPx: modRightPx,
            leftDisplacedHeadPx: this.leftDisplacedHeadPx,
            rightDisplacedHeadPx: this.rightDisplacedHeadPx,
            glyphPx: 0
        };
    }
    getAbsoluteX() {
        const tickContext = this.checkTickContext(`Can't getAbsoluteX() without a TickContext.`);
        let x4 = tickContext.getX();
        if (this.stave) x4 += this.stave.getNoteStartX() + $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("stave.padding");
        if (this.isCenterAligned()) x4 += this.getCenterXShift();
        return x4;
    }
    static getPoint(size6) {
        return size6 == "default" ? $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE : $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE / 5 * 3;
    }
    getStemDirection() {
        throw new $a801f2c896bd09f1$var$RuntimeError("NoStem", "No stem attached to this note.");
    }
    getStemExtents() {
        throw new $a801f2c896bd09f1$var$RuntimeError("NoStem", "No stem attached to this note.");
    }
    getTieRightX() {
        let tieStartX = this.getAbsoluteX();
        const note_glyph_width = this.glyphProps.getWidth();
        tieStartX += note_glyph_width / 2;
        tieStartX += -this.width / 2 + this.width + 2;
        return tieStartX;
    }
    getTieLeftX() {
        let tieEndX = this.getAbsoluteX();
        const note_glyph_width = this.glyphProps.getWidth();
        tieEndX += note_glyph_width / 2;
        tieEndX -= this.width / 2 + 2;
        return tieEndX;
    }
    getKeys() {
        return this.keys;
    }
    getKeyProps() {
        return this.keyProps;
    }
};
// node_modules/vexflow/build/esm/src/stavemodifier.js
var $a801f2c896bd09f1$var$StaveModifierPosition;
(function(StaveModifierPosition2) {
    StaveModifierPosition2[StaveModifierPosition2["CENTER"] = 0] = "CENTER";
    StaveModifierPosition2[StaveModifierPosition2["LEFT"] = 1] = "LEFT";
    StaveModifierPosition2[StaveModifierPosition2["RIGHT"] = 2] = "RIGHT";
    StaveModifierPosition2[StaveModifierPosition2["ABOVE"] = 3] = "ABOVE";
    StaveModifierPosition2[StaveModifierPosition2["BELOW"] = 4] = "BELOW";
    StaveModifierPosition2[StaveModifierPosition2["BEGIN"] = 5] = "BEGIN";
    StaveModifierPosition2[StaveModifierPosition2["END"] = 6] = "END";
})($a801f2c896bd09f1$var$StaveModifierPosition || ($a801f2c896bd09f1$var$StaveModifierPosition = {}));
var $a801f2c896bd09f1$var$StaveModifier = class extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "StaveModifier";
    }
    static get Position() {
        return $a801f2c896bd09f1$var$StaveModifierPosition;
    }
    constructor(){
        super();
        this.width = 0;
        this.x = 0;
        this.padding = 10;
        this.position = $a801f2c896bd09f1$var$StaveModifierPosition.ABOVE;
    }
    getPosition() {
        return this.position;
    }
    setPosition(position2) {
        this.position = position2;
        return this;
    }
    getStave() {
        return this.stave;
    }
    checkStave() {
        return $a801f2c896bd09f1$var$defined(this.stave, "NoStave", "No stave attached to instance.");
    }
    setStave(stave) {
        this.stave = stave;
        return this;
    }
    getWidth() {
        return this.width;
    }
    setWidth(width9) {
        this.width = width9;
        return this;
    }
    getX() {
        return this.x;
    }
    setX(x4) {
        this.x = x4;
        return this;
    }
    placeGlyphOnLine(glyph, stave, line2, customShift = 0) {
        glyph.setYShift(stave.getYForLine(line2 !== null && line2 !== void 0 ? line2 : 0) - stave.getYForGlyphs() + customShift);
    }
    getPadding(index5) {
        return index5 !== void 0 && index5 < 2 ? 0 : this.padding;
    }
    setPadding(padding) {
        this.padding = padding;
        return this;
    }
    setLayoutMetrics(layoutMetrics) {
        this.layoutMetrics = layoutMetrics;
        return this;
    }
    getLayoutMetrics() {
        return this.layoutMetrics;
    }
    draw(...args) {}
};
// node_modules/vexflow/build/esm/src/stavebarline.js
var $a801f2c896bd09f1$var$BarlineType;
(function(BarlineType2) {
    BarlineType2[BarlineType2["SINGLE"] = 1] = "SINGLE";
    BarlineType2[BarlineType2["DOUBLE"] = 2] = "DOUBLE";
    BarlineType2[BarlineType2["END"] = 3] = "END";
    BarlineType2[BarlineType2["REPEAT_BEGIN"] = 4] = "REPEAT_BEGIN";
    BarlineType2[BarlineType2["REPEAT_END"] = 5] = "REPEAT_END";
    BarlineType2[BarlineType2["REPEAT_BOTH"] = 6] = "REPEAT_BOTH";
    BarlineType2[BarlineType2["NONE"] = 7] = "NONE";
})($a801f2c896bd09f1$var$BarlineType || ($a801f2c896bd09f1$var$BarlineType = {}));
var $a801f2c896bd09f1$var$Barline = class _Barline extends $a801f2c896bd09f1$var$StaveModifier {
    static get CATEGORY() {
        return "Barline";
    }
    static get type() {
        return $a801f2c896bd09f1$var$BarlineType;
    }
    static get typeString() {
        return {
            single: $a801f2c896bd09f1$var$BarlineType.SINGLE,
            double: $a801f2c896bd09f1$var$BarlineType.DOUBLE,
            end: $a801f2c896bd09f1$var$BarlineType.END,
            repeatBegin: $a801f2c896bd09f1$var$BarlineType.REPEAT_BEGIN,
            repeatEnd: $a801f2c896bd09f1$var$BarlineType.REPEAT_END,
            repeatBoth: $a801f2c896bd09f1$var$BarlineType.REPEAT_BOTH,
            none: $a801f2c896bd09f1$var$BarlineType.NONE
        };
    }
    constructor(type){
        super();
        this.thickness = $a801f2c896bd09f1$var$Tables.STAVE_LINE_THICKNESS;
        const TYPE = $a801f2c896bd09f1$var$BarlineType;
        this.widths = {};
        this.widths[TYPE.SINGLE] = 5;
        this.widths[TYPE.DOUBLE] = 5;
        this.widths[TYPE.END] = 5;
        this.widths[TYPE.REPEAT_BEGIN] = 5;
        this.widths[TYPE.REPEAT_END] = 5;
        this.widths[TYPE.REPEAT_BOTH] = 5;
        this.widths[TYPE.NONE] = 5;
        this.paddings = {};
        this.paddings[TYPE.SINGLE] = 0;
        this.paddings[TYPE.DOUBLE] = 0;
        this.paddings[TYPE.END] = 0;
        this.paddings[TYPE.REPEAT_BEGIN] = 15;
        this.paddings[TYPE.REPEAT_END] = 15;
        this.paddings[TYPE.REPEAT_BOTH] = 15;
        this.paddings[TYPE.NONE] = 0;
        this.layoutMetricsMap = {};
        this.layoutMetricsMap[TYPE.SINGLE] = {
            xMin: 0,
            xMax: 1,
            paddingLeft: 5,
            paddingRight: 5
        };
        this.layoutMetricsMap[TYPE.DOUBLE] = {
            xMin: -3,
            xMax: 1,
            paddingLeft: 5,
            paddingRight: 5
        };
        this.layoutMetricsMap[TYPE.END] = {
            xMin: -5,
            xMax: 1,
            paddingLeft: 5,
            paddingRight: 5
        };
        this.layoutMetricsMap[TYPE.REPEAT_END] = {
            xMin: -10,
            xMax: 1,
            paddingLeft: 5,
            paddingRight: 5
        };
        this.layoutMetricsMap[TYPE.REPEAT_BEGIN] = {
            xMin: -2,
            xMax: 10,
            paddingLeft: 5,
            paddingRight: 5
        };
        this.layoutMetricsMap[TYPE.REPEAT_BOTH] = {
            xMin: -10,
            xMax: 10,
            paddingLeft: 5,
            paddingRight: 5
        };
        this.layoutMetricsMap[TYPE.NONE] = {
            xMin: 0,
            xMax: 0,
            paddingLeft: 5,
            paddingRight: 5
        };
        this.setPosition($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN);
        this.setType(type);
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = typeof type === "string" ? _Barline.typeString[type] : type;
        this.setWidth(this.widths[this.type]);
        this.setPadding(this.paddings[this.type]);
        this.setLayoutMetrics(this.layoutMetricsMap[this.type]);
        return this;
    }
    draw(stave) {
        const ctx = stave.checkContext();
        this.setRendered();
        this.applyStyle(ctx);
        ctx.openGroup("stavebarline", this.getAttribute("id"));
        switch(this.type){
            case $a801f2c896bd09f1$var$BarlineType.SINGLE:
                this.drawVerticalBar(stave, this.x, false);
                break;
            case $a801f2c896bd09f1$var$BarlineType.DOUBLE:
                this.drawVerticalBar(stave, this.x, true);
                break;
            case $a801f2c896bd09f1$var$BarlineType.END:
                this.drawVerticalEndBar(stave, this.x);
                break;
            case $a801f2c896bd09f1$var$BarlineType.REPEAT_BEGIN:
                this.drawRepeatBar(stave, this.x, true);
                if (stave.getX() !== this.x) this.drawVerticalBar(stave, stave.getX());
                break;
            case $a801f2c896bd09f1$var$BarlineType.REPEAT_END:
                this.drawRepeatBar(stave, this.x, false);
                break;
            case $a801f2c896bd09f1$var$BarlineType.REPEAT_BOTH:
                this.drawRepeatBar(stave, this.x, false);
                this.drawRepeatBar(stave, this.x, true);
                break;
            default:
                break;
        }
        ctx.closeGroup();
        this.restoreStyle(ctx);
    }
    drawVerticalBar(stave, x4, double_bar) {
        const staveCtx = stave.checkContext();
        const topY = stave.getTopLineTopY();
        const botY = stave.getBottomLineBottomY();
        if (double_bar) staveCtx.fillRect(x4 - 3, topY, 1, botY - topY);
        staveCtx.fillRect(x4, topY, 1, botY - topY);
    }
    drawVerticalEndBar(stave, x4) {
        const staveCtx = stave.checkContext();
        const topY = stave.getTopLineTopY();
        const botY = stave.getBottomLineBottomY();
        staveCtx.fillRect(x4 - 5, topY, 1, botY - topY);
        staveCtx.fillRect(x4 - 2, topY, 3, botY - topY);
    }
    drawRepeatBar(stave, x4, begin) {
        const staveCtx = stave.checkContext();
        const topY = stave.getTopLineTopY();
        const botY = stave.getBottomLineBottomY();
        let x_shift = 3;
        if (!begin) x_shift = -5;
        staveCtx.fillRect(x4 + x_shift, topY, 1, botY - topY);
        staveCtx.fillRect(x4 - 2, topY, 3, botY - topY);
        const dot_radius = 2;
        if (begin) x_shift += 4;
        else x_shift -= 4;
        const dot_x = x4 + x_shift + dot_radius / 2;
        let y_offset = (stave.getNumLines() - 1) * stave.getSpacingBetweenLines();
        y_offset = y_offset / 2 - stave.getSpacingBetweenLines() / 2;
        let dot_y = topY + y_offset + dot_radius / 2;
        staveCtx.beginPath();
        staveCtx.arc(dot_x, dot_y, dot_radius, 0, Math.PI * 2, false);
        staveCtx.fill();
        dot_y += stave.getSpacingBetweenLines();
        staveCtx.beginPath();
        staveCtx.arc(dot_x, dot_y, dot_radius, 0, Math.PI * 2, false);
        staveCtx.fill();
    }
};
// node_modules/vexflow/build/esm/src/barnote.js
function $a801f2c896bd09f1$var$L6(...args) {
    if ($a801f2c896bd09f1$var$BarNote.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.BarNote", args);
}
var $a801f2c896bd09f1$var$BarNote = class extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "BarNote";
    }
    constructor(type = $a801f2c896bd09f1$var$BarlineType.SINGLE){
        super({
            duration: "b"
        });
        this.metrics = {
            widths: {}
        };
        const TYPE = $a801f2c896bd09f1$var$BarlineType;
        this.metrics.widths = {
            [TYPE.SINGLE]: 8,
            [TYPE.DOUBLE]: 12,
            [TYPE.END]: 15,
            [TYPE.REPEAT_BEGIN]: 14,
            [TYPE.REPEAT_END]: 14,
            [TYPE.REPEAT_BOTH]: 18,
            [TYPE.NONE]: 0
        };
        this.ignore_ticks = true;
        this.setType(type);
        this.barline = new $a801f2c896bd09f1$var$Barline(type);
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = typeof type === "string" ? $a801f2c896bd09f1$var$Barline.typeString[type] : type;
        this.setWidth(this.metrics.widths[this.type]);
        return this;
    }
    addToModifierContext(mc) {
        return this;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        $a801f2c896bd09f1$var$L6("Rendering bar line at: ", this.getAbsoluteX());
        this.applyStyle(ctx);
        ctx.openGroup("barnote", this.getAttribute("id"));
        this.barline.setType(this.type);
        this.barline.setX(this.getAbsoluteX());
        this.barline.draw(this.checkStave());
        ctx.closeGroup();
        this.restoreStyle(ctx);
        this.setRendered();
    }
};
$a801f2c896bd09f1$var$BarNote.DEBUG = false;
// node_modules/vexflow/build/esm/src/beam.js
function $a801f2c896bd09f1$var$calculateStemDirection(notes) {
    let lineSum = 0;
    notes.forEach((note2)=>{
        if (note2.keyProps) note2.keyProps.forEach((keyProp)=>{
            lineSum += keyProp.line - 3;
        });
    });
    if (lineSum >= 0) return $a801f2c896bd09f1$var$Stem.DOWN;
    return $a801f2c896bd09f1$var$Stem.UP;
}
function $a801f2c896bd09f1$var$getStemSlope(firstNote, lastNote) {
    const firstStemTipY = firstNote.getStemExtents().topY;
    const firstStemX = firstNote.getStemX();
    const lastStemTipY = lastNote.getStemExtents().topY;
    const lastStemX = lastNote.getStemX();
    return (lastStemTipY - firstStemTipY) / (lastStemX - firstStemX);
}
var $a801f2c896bd09f1$var$BEAM_LEFT = "L";
var $a801f2c896bd09f1$var$BEAM_RIGHT = "R";
var $a801f2c896bd09f1$var$BEAM_BOTH = "B";
var $a801f2c896bd09f1$var$Beam = class _Beam extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "Beam";
    }
    getStemDirection() {
        return this.stem_direction;
    }
    static getDefaultBeamGroups(time_sig) {
        if (!time_sig || time_sig === "c") time_sig = "4/4";
        const defaults = {
            "1/2": [
                "1/2"
            ],
            "2/2": [
                "1/2"
            ],
            "3/2": [
                "1/2"
            ],
            "4/2": [
                "1/2"
            ],
            "1/4": [
                "1/4"
            ],
            "2/4": [
                "1/4"
            ],
            "3/4": [
                "1/4"
            ],
            "4/4": [
                "1/4"
            ],
            "1/8": [
                "1/8"
            ],
            "2/8": [
                "2/8"
            ],
            "3/8": [
                "3/8"
            ],
            "4/8": [
                "2/8"
            ],
            "1/16": [
                "1/16"
            ],
            "2/16": [
                "2/16"
            ],
            "3/16": [
                "3/16"
            ],
            "4/16": [
                "2/16"
            ]
        };
        const groups = defaults[time_sig];
        if (groups === void 0) {
            const beatTotal = parseInt(time_sig.split("/")[0], 10);
            const beatValue = parseInt(time_sig.split("/")[1], 10);
            const tripleMeter = beatTotal % 3 === 0;
            if (tripleMeter) return [
                new $a801f2c896bd09f1$var$Fraction(3, beatValue)
            ];
            else if (beatValue > 4) return [
                new $a801f2c896bd09f1$var$Fraction(2, beatValue)
            ];
            else if (beatValue <= 4) return [
                new $a801f2c896bd09f1$var$Fraction(1, beatValue)
            ];
        } else return groups.map((group4)=>new $a801f2c896bd09f1$var$Fraction().parse(group4));
        return [
            new $a801f2c896bd09f1$var$Fraction(1, 4)
        ];
    }
    static applyAndGetBeams(voice, stem_direction, groups) {
        return _Beam.generateBeams(voice.getTickables(), {
            groups: groups,
            stem_direction: stem_direction
        });
    }
    static generateBeams(notes, config = {}) {
        if (!config.groups || !config.groups.length) config.groups = [
            new $a801f2c896bd09f1$var$Fraction(2, 8)
        ];
        const tickGroups = config.groups.map((group4)=>{
            if (!group4.multiply) throw new $a801f2c896bd09f1$var$RuntimeError("InvalidBeamGroups", "The beam groups must be an array of Vex.Flow.Fractions");
            return group4.clone().multiply($a801f2c896bd09f1$var$Tables.RESOLUTION, 1);
        });
        const unprocessedNotes = notes;
        let currentTickGroup = 0;
        let noteGroups = [];
        let currentGroup = [];
        function getTotalTicks(vf_notes) {
            return vf_notes.reduce((memo, note2)=>note2.getTicks().clone().add(memo), new $a801f2c896bd09f1$var$Fraction(0, 1));
        }
        function nextTickGroup() {
            if (tickGroups.length - 1 > currentTickGroup) currentTickGroup += 1;
            else currentTickGroup = 0;
        }
        function createGroups() {
            let nextGroup = [];
            let currentGroupTotalTicks = new $a801f2c896bd09f1$var$Fraction(0, 1);
            unprocessedNotes.forEach((unprocessedNote)=>{
                nextGroup = [];
                if (unprocessedNote.shouldIgnoreTicks()) {
                    noteGroups.push(currentGroup);
                    currentGroup = nextGroup;
                    return;
                }
                currentGroup.push(unprocessedNote);
                const ticksPerGroup = tickGroups[currentTickGroup].clone();
                const totalTicks = getTotalTicks(currentGroup).add(currentGroupTotalTicks);
                const unbeamable = $a801f2c896bd09f1$var$Tables.durationToNumber(unprocessedNote.getDuration()) < 8;
                if (unbeamable && unprocessedNote.getTuplet()) ticksPerGroup.numerator *= 2;
                if (totalTicks.greaterThan(ticksPerGroup)) {
                    if (!unbeamable) {
                        const note2 = currentGroup.pop();
                        if (note2) nextGroup.push(note2);
                    }
                    noteGroups.push(currentGroup);
                    do {
                        currentGroupTotalTicks = totalTicks.subtract(tickGroups[currentTickGroup]);
                        nextTickGroup();
                    }while (currentGroupTotalTicks.greaterThanEquals(tickGroups[currentTickGroup]));
                    currentGroup = nextGroup;
                } else if (totalTicks.equals(ticksPerGroup)) {
                    noteGroups.push(currentGroup);
                    currentGroupTotalTicks = new $a801f2c896bd09f1$var$Fraction(0, 1);
                    currentGroup = nextGroup;
                    nextTickGroup();
                }
            });
            if (currentGroup.length > 0) noteGroups.push(currentGroup);
        }
        function getBeamGroups() {
            return noteGroups.filter((group4)=>{
                if (group4.length > 1) {
                    let beamable = true;
                    group4.forEach((note2)=>{
                        if (note2.getIntrinsicTicks() >= $a801f2c896bd09f1$var$Tables.durationToTicks("4")) beamable = false;
                    });
                    return beamable;
                }
                return false;
            });
        }
        function sanitizeGroups() {
            const sanitizedGroups = [];
            noteGroups.forEach((group4)=>{
                let tempGroup = [];
                group4.forEach((note2, index5, group5)=>{
                    const isFirstOrLast = index5 === 0 || index5 === group5.length - 1;
                    const prevNote = group5[index5 - 1];
                    const breaksOnEachRest = !config.beam_rests && note2.isRest();
                    const breaksOnFirstOrLastRest = config.beam_rests && config.beam_middle_only && note2.isRest() && isFirstOrLast;
                    let breakOnStemChange = false;
                    if (config.maintain_stem_directions && prevNote && !note2.isRest() && !prevNote.isRest()) {
                        const prevDirection = prevNote.getStemDirection();
                        const currentDirection = note2.getStemDirection();
                        breakOnStemChange = currentDirection !== prevDirection;
                    }
                    const isUnbeamableDuration = parseInt(note2.getDuration(), 10) < 8;
                    const shouldBreak = breaksOnEachRest || breaksOnFirstOrLastRest || breakOnStemChange || isUnbeamableDuration;
                    if (shouldBreak) {
                        if (tempGroup.length > 0) sanitizedGroups.push(tempGroup);
                        tempGroup = breakOnStemChange ? [
                            note2
                        ] : [];
                    } else tempGroup.push(note2);
                });
                if (tempGroup.length > 0) sanitizedGroups.push(tempGroup);
            });
            noteGroups = sanitizedGroups;
        }
        function formatStems() {
            noteGroups.forEach((group4)=>{
                let stemDirection;
                if (config.maintain_stem_directions) {
                    const note2 = findFirstNote(group4);
                    stemDirection = note2 ? note2.getStemDirection() : $a801f2c896bd09f1$var$Stem.UP;
                } else if (config.stem_direction) stemDirection = config.stem_direction;
                else stemDirection = $a801f2c896bd09f1$var$calculateStemDirection(group4);
                applyStemDirection(group4, stemDirection);
            });
        }
        function findFirstNote(group4) {
            for(let i2 = 0; i2 < group4.length; i2++){
                const note2 = group4[i2];
                if (!note2.isRest()) return note2;
            }
            return false;
        }
        function applyStemDirection(group4, direction3) {
            group4.forEach((note2)=>{
                note2.setStemDirection(direction3);
            });
        }
        function getTuplets() {
            const uniqueTuplets = [];
            noteGroups.forEach((group4)=>{
                let tuplet;
                group4.forEach((note2)=>{
                    const noteTuplet = note2.getTuplet();
                    if (noteTuplet && tuplet !== noteTuplet) {
                        tuplet = noteTuplet;
                        uniqueTuplets.push(tuplet);
                    }
                });
            });
            return uniqueTuplets;
        }
        createGroups();
        sanitizeGroups();
        formatStems();
        const beamedNoteGroups = getBeamGroups();
        const allTuplets = getTuplets();
        const beams = [];
        beamedNoteGroups.forEach((group4)=>{
            const beam = new _Beam(group4);
            if (config.show_stemlets) beam.render_options.show_stemlets = true;
            if (config.secondary_breaks) beam.render_options.secondary_break_ticks = $a801f2c896bd09f1$var$Tables.durationToTicks(config.secondary_breaks);
            if (config.flat_beams === true) {
                beam.render_options.flat_beams = true;
                beam.render_options.flat_beam_offset = config.flat_beam_offset;
            }
            beams.push(beam);
        });
        allTuplets.forEach((tuplet)=>{
            const direction3 = tuplet.notes[0].stem_direction === $a801f2c896bd09f1$var$Stem.DOWN ? -1 : 1;
            tuplet.setTupletLocation(direction3);
            let bracketed = false;
            for(let i2 = 0; i2 < tuplet.notes.length; i2++){
                const note2 = tuplet.notes[i2];
                if (!note2.hasBeam()) {
                    bracketed = true;
                    break;
                }
            }
            tuplet.setBracketed(bracketed);
        });
        return beams;
    }
    constructor(notes, auto_stem = false){
        super();
        this.slope = 0;
        this.y_shift = 0;
        this.forcedPartialDirections = {};
        if (!notes || notes.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "No notes provided for beam.");
        if (notes.length === 1) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Too few notes for beam.");
        this.ticks = notes[0].getIntrinsicTicks();
        if (this.ticks >= $a801f2c896bd09f1$var$Tables.durationToTicks("4")) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Beams can only be applied to notes shorter than a quarter note.");
        let i2;
        let note2;
        this.stem_direction = notes[0].getStemDirection();
        let stem_direction = this.stem_direction;
        if (auto_stem && $a801f2c896bd09f1$var$isStaveNote(notes[0])) stem_direction = $a801f2c896bd09f1$var$calculateStemDirection(notes);
        else if (auto_stem && $a801f2c896bd09f1$var$isTabNote(notes[0])) {
            const stem_weight = notes.reduce((memo, note3)=>memo + note3.getStemDirection(), 0);
            stem_direction = stem_weight > -1 ? $a801f2c896bd09f1$var$Stem.UP : $a801f2c896bd09f1$var$Stem.DOWN;
        }
        for(i2 = 0; i2 < notes.length; ++i2){
            note2 = notes[i2];
            if (auto_stem) {
                note2.setStemDirection(stem_direction);
                this.stem_direction = stem_direction;
            }
            note2.setBeam(this);
        }
        this.postFormatted = false;
        this.notes = notes;
        this.beam_count = this.getBeamCount();
        this.break_on_indices = [];
        this.render_options = {
            beam_width: 5,
            max_slope: 0.25,
            min_slope: -0.25,
            slope_iterations: 20,
            slope_cost: 100,
            show_stemlets: false,
            stemlet_extension: 7,
            partial_beam_length: 10,
            flat_beams: false,
            min_flat_beam_offset: 15
        };
    }
    getNotes() {
        return this.notes;
    }
    getBeamCount() {
        const beamCounts = this.notes.map((note2)=>note2.getGlyphProps().beam_count);
        const maxBeamCount = beamCounts.reduce((max10, beamCount)=>beamCount > max10 ? beamCount : max10);
        return maxBeamCount;
    }
    breakSecondaryAt(indices) {
        this.break_on_indices = indices;
        return this;
    }
    setPartialBeamSideAt(noteIndex, side) {
        this.forcedPartialDirections[noteIndex] = side;
        return this;
    }
    unsetPartialBeamSideAt(noteIndex) {
        delete this.forcedPartialDirections[noteIndex];
        return this;
    }
    getSlopeY(x4, first_x_px, first_y_px, slope) {
        return first_y_px + (x4 - first_x_px) * slope;
    }
    calculateSlope() {
        const { notes: notes, stem_direction: stemDirection, render_options: { max_slope: max_slope, min_slope: min_slope, slope_iterations: slope_iterations, slope_cost: slope_cost } } = this;
        const firstNote = notes[0];
        const initialSlope = $a801f2c896bd09f1$var$getStemSlope(firstNote, notes[notes.length - 1]);
        const increment = (max_slope - min_slope) / slope_iterations;
        let minCost = Number.MAX_VALUE;
        let bestSlope = 0;
        let yShift = 0;
        for(let slope = min_slope; slope <= max_slope; slope += increment){
            let totalStemExtension = 0;
            let yShiftTemp = 0;
            for(let i2 = 1; i2 < notes.length; ++i2){
                const note2 = notes[i2];
                if (note2.hasStem() || note2.isRest()) {
                    const adjustedStemTipY = this.getSlopeY(note2.getStemX(), firstNote.getStemX(), firstNote.getStemExtents().topY, slope) + yShiftTemp;
                    const stemTipY = note2.getStemExtents().topY;
                    if (stemTipY * stemDirection < adjustedStemTipY * stemDirection) {
                        const diff = Math.abs(stemTipY - adjustedStemTipY);
                        yShiftTemp += diff * -stemDirection;
                        totalStemExtension += diff * i2;
                    } else totalStemExtension += (stemTipY - adjustedStemTipY) * stemDirection;
                }
            }
            const idealSlope = initialSlope / 2;
            const distanceFromIdeal = Math.abs(idealSlope - slope);
            const cost = slope_cost * distanceFromIdeal + Math.abs(totalStemExtension);
            if (cost < minCost) {
                minCost = cost;
                bestSlope = slope;
                yShift = yShiftTemp;
            }
        }
        this.slope = bestSlope;
        this.y_shift = yShift;
    }
    calculateFlatSlope() {
        const { notes: notes, stem_direction: stem_direction, render_options: { beam_width: beam_width, min_flat_beam_offset: min_flat_beam_offset, flat_beam_offset: flat_beam_offset } } = this;
        let total = 0;
        let extremeY = 0;
        let extremeBeamCount = 0;
        let currentExtreme = 0;
        for(let i2 = 0; i2 < notes.length; i2++){
            const note2 = notes[i2];
            const stemTipY = note2.getStemExtents().topY;
            total += stemTipY;
            if (stem_direction === $a801f2c896bd09f1$var$Stem.DOWN && currentExtreme < stemTipY) {
                currentExtreme = stemTipY;
                extremeY = Math.max(...note2.getYs());
                extremeBeamCount = note2.getBeamCount();
            } else if (stem_direction === $a801f2c896bd09f1$var$Stem.UP && (currentExtreme === 0 || currentExtreme > stemTipY)) {
                currentExtreme = stemTipY;
                extremeY = Math.min(...note2.getYs());
                extremeBeamCount = note2.getBeamCount();
            }
        }
        let offset2 = total / notes.length;
        const beamWidth = beam_width * 1.5;
        const extremeTest = min_flat_beam_offset + extremeBeamCount * beamWidth;
        const newOffset = extremeY + extremeTest * -stem_direction;
        if (stem_direction === $a801f2c896bd09f1$var$Stem.DOWN && offset2 < newOffset) offset2 = extremeY + extremeTest;
        else if (stem_direction === $a801f2c896bd09f1$var$Stem.UP && offset2 > newOffset) offset2 = extremeY - extremeTest;
        if (!flat_beam_offset) this.render_options.flat_beam_offset = offset2;
        else if (stem_direction === $a801f2c896bd09f1$var$Stem.DOWN && offset2 > flat_beam_offset) this.render_options.flat_beam_offset = offset2;
        else if (stem_direction === $a801f2c896bd09f1$var$Stem.UP && offset2 < flat_beam_offset) this.render_options.flat_beam_offset = offset2;
        this.slope = 0;
        this.y_shift = 0;
    }
    getBeamYToDraw() {
        const firstNote = this.notes[0];
        const firstStemTipY = firstNote.getStemExtents().topY;
        let beamY = firstStemTipY;
        if (this.render_options.flat_beams && this.render_options.flat_beam_offset) beamY = this.render_options.flat_beam_offset;
        return beamY;
    }
    applyStemExtensions() {
        const { notes: notes, slope: slope, y_shift: y_shift, beam_count: beam_count, render_options: { show_stemlets: show_stemlets, stemlet_extension: stemlet_extension, beam_width: beam_width } } = this;
        const firstNote = notes[0];
        const firstStemTipY = this.getBeamYToDraw();
        const firstStemX = firstNote.getStemX();
        for(let i2 = 0; i2 < notes.length; ++i2){
            const note2 = notes[i2];
            const stem = note2.getStem();
            if (stem) {
                const stemX = note2.getStemX();
                const { topY: stemTipY } = note2.getStemExtents();
                const beamedStemTipY = this.getSlopeY(stemX, firstStemX, firstStemTipY, slope) + y_shift;
                const preBeamExtension = stem.getExtension();
                const beamExtension = note2.getStemDirection() === $a801f2c896bd09f1$var$Stem.UP ? stemTipY - beamedStemTipY : beamedStemTipY - stemTipY;
                let crossStemExtension = 0;
                if (note2.getStemDirection() !== this.stem_direction) {
                    const beamCount = note2.getGlyphProps().beam_count;
                    crossStemExtension = (1 + (beamCount - 1) * 1.5) * this.render_options.beam_width;
                }
                stem.setExtension(preBeamExtension + beamExtension + crossStemExtension);
                stem.adjustHeightForBeam();
                if (note2.isRest() && show_stemlets) {
                    const beamWidth = beam_width;
                    const totalBeamWidth = (beam_count - 1) * beamWidth * 1.5 + beamWidth;
                    stem.setVisibility(true).setStemlet(true, totalBeamWidth + stemlet_extension);
                }
            }
        }
    }
    lookupBeamDirection(duration2, prev_tick, tick, next_tick, noteIndex) {
        if (duration2 === "4") return $a801f2c896bd09f1$var$BEAM_LEFT;
        const forcedBeamDirection = this.forcedPartialDirections[noteIndex];
        if (forcedBeamDirection) return forcedBeamDirection;
        const lookup_duration = `${$a801f2c896bd09f1$var$Tables.durationToNumber(duration2) / 2}`;
        const prev_note_gets_beam = prev_tick < $a801f2c896bd09f1$var$Tables.durationToTicks(lookup_duration);
        const next_note_gets_beam = next_tick < $a801f2c896bd09f1$var$Tables.durationToTicks(lookup_duration);
        const note_gets_beam = tick < $a801f2c896bd09f1$var$Tables.durationToTicks(lookup_duration);
        if (prev_note_gets_beam && next_note_gets_beam && note_gets_beam) return $a801f2c896bd09f1$var$BEAM_BOTH;
        else if (prev_note_gets_beam && !next_note_gets_beam && note_gets_beam) return $a801f2c896bd09f1$var$BEAM_LEFT;
        else if (!prev_note_gets_beam && next_note_gets_beam && note_gets_beam) return $a801f2c896bd09f1$var$BEAM_RIGHT;
        return this.lookupBeamDirection(lookup_duration, prev_tick, tick, next_tick, noteIndex);
    }
    getBeamLines(duration2) {
        const tick_of_duration = $a801f2c896bd09f1$var$Tables.durationToTicks(duration2);
        let beam_started = false;
        const beam_lines = [];
        let current_beam = void 0;
        const partial_beam_length = this.render_options.partial_beam_length;
        let previous_should_break = false;
        let tick_tally = 0;
        for(let i2 = 0; i2 < this.notes.length; ++i2){
            const note2 = this.notes[i2];
            const ticks = note2.getTicks().value();
            tick_tally += ticks;
            let should_break = false;
            if (parseInt(duration2, 10) >= 8) {
                should_break = this.break_on_indices.indexOf(i2) !== -1;
                if (this.render_options.secondary_break_ticks && tick_tally >= this.render_options.secondary_break_ticks) {
                    tick_tally = 0;
                    should_break = true;
                }
            }
            const note_gets_beam = note2.getIntrinsicTicks() < tick_of_duration;
            const stem_x = note2.getStemX() - $a801f2c896bd09f1$var$Stem.WIDTH / 2;
            const prev_note = this.notes[i2 - 1];
            const next_note = this.notes[i2 + 1];
            const next_note_gets_beam = next_note && next_note.getIntrinsicTicks() < tick_of_duration;
            const prev_note_gets_beam = prev_note && prev_note.getIntrinsicTicks() < tick_of_duration;
            const beam_alone = prev_note && next_note && note_gets_beam && !prev_note_gets_beam && !next_note_gets_beam;
            if (note_gets_beam) {
                if (beam_started) {
                    current_beam = beam_lines[beam_lines.length - 1];
                    current_beam.end = stem_x;
                    if (should_break) {
                        beam_started = false;
                        if (next_note && !next_note_gets_beam && current_beam.end === void 0) current_beam.end = current_beam.start - partial_beam_length;
                    }
                } else {
                    current_beam = {
                        start: stem_x,
                        end: void 0
                    };
                    beam_started = true;
                    if (beam_alone) {
                        const prev_tick = prev_note.getIntrinsicTicks();
                        const next_tick = next_note.getIntrinsicTicks();
                        const tick = note2.getIntrinsicTicks();
                        const beam_direction = this.lookupBeamDirection(duration2, prev_tick, tick, next_tick, i2);
                        if ([
                            $a801f2c896bd09f1$var$BEAM_LEFT,
                            $a801f2c896bd09f1$var$BEAM_BOTH
                        ].includes(beam_direction)) current_beam.end = current_beam.start - partial_beam_length;
                        else current_beam.end = current_beam.start + partial_beam_length;
                    } else if (!next_note_gets_beam) {
                        if ((previous_should_break || i2 === 0) && next_note) current_beam.end = current_beam.start + partial_beam_length;
                        else current_beam.end = current_beam.start - partial_beam_length;
                    } else if (should_break) {
                        current_beam.end = current_beam.start - partial_beam_length;
                        beam_started = false;
                    }
                    beam_lines.push(current_beam);
                }
            } else beam_started = false;
            previous_should_break = should_break;
        }
        const last_beam = beam_lines[beam_lines.length - 1];
        if (last_beam && last_beam.end === void 0) last_beam.end = last_beam.start - partial_beam_length;
        return beam_lines;
    }
    drawStems(ctx) {
        this.notes.forEach((note2)=>{
            const stem = note2.getStem();
            if (stem) {
                const stem_x = note2.getStemX();
                stem.setNoteHeadXBounds(stem_x, stem_x);
                stem.setContext(ctx).draw();
            }
        }, this);
    }
    drawBeamLines(ctx) {
        const valid_beam_durations = [
            "4",
            "8",
            "16",
            "32",
            "64"
        ];
        const firstNote = this.notes[0];
        let beamY = this.getBeamYToDraw();
        const firstStemX = firstNote.getStemX();
        const beamThickness = this.render_options.beam_width * this.stem_direction;
        for(let i2 = 0; i2 < valid_beam_durations.length; ++i2){
            const duration2 = valid_beam_durations[i2];
            const beamLines = this.getBeamLines(duration2);
            for(let j2 = 0; j2 < beamLines.length; ++j2){
                const beam_line = beamLines[j2];
                const startBeamX = beam_line.start;
                const startBeamY = this.getSlopeY(startBeamX, firstStemX, beamY, this.slope);
                const lastBeamX = beam_line.end;
                if (lastBeamX) {
                    const lastBeamY = this.getSlopeY(lastBeamX, firstStemX, beamY, this.slope);
                    ctx.beginPath();
                    ctx.moveTo(startBeamX, startBeamY);
                    ctx.lineTo(startBeamX, startBeamY + beamThickness);
                    ctx.lineTo(lastBeamX + 1, lastBeamY + beamThickness);
                    ctx.lineTo(lastBeamX + 1, lastBeamY);
                    ctx.closePath();
                    ctx.fill();
                } else throw new $a801f2c896bd09f1$var$RuntimeError("NoLastBeamX", "lastBeamX undefined.");
            }
            beamY += beamThickness * 1.5;
        }
    }
    preFormat() {
        return this;
    }
    postFormat() {
        if (this.postFormatted) return;
        if ($a801f2c896bd09f1$var$isTabNote(this.notes[0]) || this.render_options.flat_beams) this.calculateFlatSlope();
        else this.calculateSlope();
        this.applyStemExtensions();
        this.postFormatted = true;
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        if (this.unbeamable) return;
        if (!this.postFormatted) this.postFormat();
        this.drawStems(ctx);
        this.applyStyle();
        ctx.openGroup("beam", this.getAttribute("id"));
        this.drawBeamLines(ctx);
        ctx.closeGroup();
        this.restoreStyle();
    }
};
// node_modules/vexflow/build/esm/src/bend.js
var $a801f2c896bd09f1$var$Bend = class _Bend extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Bend";
    }
    static get UP() {
        return 0;
    }
    static get DOWN() {
        return 1;
    }
    static format(bends, state3) {
        if (!bends || bends.length === 0) return false;
        let last_width = 0;
        for(let i2 = 0; i2 < bends.length; ++i2){
            const bend = bends[i2];
            const note2 = bend.checkAttachedNote();
            if ($a801f2c896bd09f1$var$isTabNote(note2)) {
                const stringPos = note2.leastString() - 1;
                if (state3.top_text_line < stringPos) state3.top_text_line = stringPos;
            }
            bend.setXShift(last_width);
            last_width = bend.getWidth();
            bend.setTextLine(state3.top_text_line);
        }
        state3.right_shift += last_width;
        state3.top_text_line += 1;
        return true;
    }
    constructor(text7, release = false, phrase){
        super();
        this.text = text7;
        this.x_shift = 0;
        this.release = release;
        this.tap = "";
        this.resetFont();
        this.render_options = {
            line_width: 1.5,
            line_style: "#777777",
            bend_width: 8,
            release_width: 8
        };
        if (phrase) this.phrase = phrase;
        else {
            this.phrase = [
                {
                    type: _Bend.UP,
                    text: this.text
                }
            ];
            if (this.release) this.phrase.push({
                type: _Bend.DOWN,
                text: ""
            });
        }
        this.updateWidth();
    }
    setXShift(value17) {
        this.x_shift = value17;
        this.updateWidth();
        return this;
    }
    setTap(value17) {
        this.tap = value17;
        return this;
    }
    getText() {
        return this.text;
    }
    getTextHeight() {
        const textFormatter = $a801f2c896bd09f1$var$TextFormatter.create(this.textFont);
        return textFormatter.maxHeight;
    }
    updateWidth() {
        const textFormatter = $a801f2c896bd09f1$var$TextFormatter.create(this.textFont);
        const measureText = (text7)=>{
            return textFormatter.getWidthForTextInPx(text7);
        };
        let totalWidth = 0;
        for(let i2 = 0; i2 < this.phrase.length; ++i2){
            const bend = this.phrase[i2];
            if (bend.width !== void 0) totalWidth += bend.width;
            else {
                const additional_width = bend.type === _Bend.UP ? this.render_options.bend_width : this.render_options.release_width;
                bend.width = Math.max(additional_width, measureText(bend.text)) + 3;
                bend.draw_width = bend.width / 2;
                totalWidth += bend.width;
            }
        }
        this.setWidth(totalWidth + this.x_shift);
        return this;
    }
    draw() {
        var _a;
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const start2 = note2.getModifierStartXY($a801f2c896bd09f1$var$Modifier.Position.RIGHT, this.index);
        start2.x += 3;
        start2.y += 0.5;
        const x_shift = this.x_shift;
        const stave = note2.checkStave();
        const spacing = stave.getSpacingBetweenLines();
        const lowestY = note2.getYs().reduce((a3, b3)=>a3 < b3 ? a3 : b3);
        const bend_height = start2.y - ((this.text_line + 1) * spacing + start2.y - lowestY) + 3;
        const annotation_y = start2.y - ((this.text_line + 1) * spacing + start2.y - lowestY) - 1;
        const renderBend = (x4, y4, width9, height9)=>{
            const cp_x = x4 + width9;
            const cp_y = y4;
            ctx.save();
            ctx.beginPath();
            ctx.setLineWidth(this.render_options.line_width);
            ctx.setStrokeStyle(this.render_options.line_style);
            ctx.setFillStyle(this.render_options.line_style);
            ctx.moveTo(x4, y4);
            ctx.quadraticCurveTo(cp_x, cp_y, x4 + width9, height9);
            ctx.stroke();
            ctx.restore();
        };
        const renderRelease = (x4, y4, width9, height9)=>{
            ctx.save();
            ctx.beginPath();
            ctx.setLineWidth(this.render_options.line_width);
            ctx.setStrokeStyle(this.render_options.line_style);
            ctx.setFillStyle(this.render_options.line_style);
            ctx.moveTo(x4, height9);
            ctx.quadraticCurveTo(x4 + width9, height9, x4 + width9, y4);
            ctx.stroke();
            ctx.restore();
        };
        const renderArrowHead = (x4, y4, direction3)=>{
            const width9 = 4;
            const yBase = y4 + width9 * direction3;
            ctx.beginPath();
            ctx.moveTo(x4, y4);
            ctx.lineTo(x4 - width9, yBase);
            ctx.lineTo(x4 + width9, yBase);
            ctx.closePath();
            ctx.fill();
        };
        const renderText = (x4, text7)=>{
            ctx.save();
            ctx.setFont(this.textFont);
            const render_x = x4 - ctx.measureText(text7).width / 2;
            ctx.fillText(text7, render_x, annotation_y);
            ctx.restore();
        };
        let last_bend = void 0;
        let last_bend_draw_width = 0;
        let last_drawn_width = 0;
        if ((_a = this.tap) === null || _a === void 0 ? void 0 : _a.length) {
            const tapStart = note2.getModifierStartXY($a801f2c896bd09f1$var$Modifier.Position.CENTER, this.index);
            renderText(tapStart.x, this.tap);
        }
        for(let i2 = 0; i2 < this.phrase.length; ++i2){
            const bend = this.phrase[i2];
            if (!bend.draw_width) bend.draw_width = 0;
            if (i2 === 0) bend.draw_width += x_shift;
            last_drawn_width = bend.draw_width + last_bend_draw_width - (i2 === 1 ? x_shift : 0);
            if (bend.type === _Bend.UP) {
                if (last_bend && last_bend.type === _Bend.UP) renderArrowHead(start2.x, bend_height, 1);
                renderBend(start2.x, start2.y, last_drawn_width, bend_height);
            }
            if (bend.type === _Bend.DOWN) {
                if (last_bend && last_bend.type === _Bend.UP) renderRelease(start2.x, start2.y, last_drawn_width, bend_height);
                if (last_bend && last_bend.type === _Bend.DOWN) {
                    renderArrowHead(start2.x, start2.y, -1);
                    renderRelease(start2.x, start2.y, last_drawn_width, bend_height);
                }
                if (!last_bend) {
                    last_drawn_width = bend.draw_width;
                    renderRelease(start2.x, start2.y, last_drawn_width, bend_height);
                }
            }
            renderText(start2.x + last_drawn_width, bend.text);
            last_bend = bend;
            last_bend_draw_width = bend.draw_width;
            last_bend.x = start2.x;
            start2.x += last_drawn_width;
        }
        if (!last_bend || last_bend.x == void 0) throw new $a801f2c896bd09f1$var$RuntimeError("NoLastBendForBend", "Internal error.");
        if (last_bend.type === _Bend.UP) renderArrowHead(last_bend.x + last_drawn_width, bend_height, 1);
        else if (last_bend.type === _Bend.DOWN) renderArrowHead(last_bend.x + last_drawn_width, start2.y, -1);
    }
};
$a801f2c896bd09f1$var$Bend.TEXT_FONT = Object.assign({}, $a801f2c896bd09f1$var$Element.TEXT_FONT);
// node_modules/vexflow/build/esm/src/web.js
function $a801f2c896bd09f1$var$isHTMLCanvas(element4) {
    if (!element4) return false;
    const global2 = $a801f2c896bd09f1$var$globalObject();
    return typeof global2.HTMLCanvasElement === "function" && element4 instanceof global2.HTMLCanvasElement || typeof element4.getContext === "function" && typeof element4.toDataURL === "function";
}
function $a801f2c896bd09f1$var$isHTMLDiv(element4) {
    if (!element4) return false;
    const global2 = $a801f2c896bd09f1$var$globalObject();
    return typeof global2.HTMLDivElement === "function" && element4 instanceof global2.HTMLDivElement || typeof element4.appendChild === "function" && typeof element4.style === "object";
}
// node_modules/vexflow/build/esm/src/canvascontext.js
var $a801f2c896bd09f1$var$CanvasContext = class _CanvasContext extends $a801f2c896bd09f1$var$RenderContext {
    static get WIDTH() {
        return 600;
    }
    static get HEIGHT() {
        return 400;
    }
    static get CANVAS_BROWSER_SIZE_LIMIT() {
        return 32767;
    }
    static sanitizeCanvasDims(width9, height9) {
        const limit = this.CANVAS_BROWSER_SIZE_LIMIT;
        if (Math.max(width9, height9) > limit) {
            $a801f2c896bd09f1$var$warn2("Canvas dimensions exceed browser limit. Cropping to " + limit);
            if (width9 > limit) width9 = limit;
            if (height9 > limit) height9 = limit;
        }
        return [
            width9,
            height9
        ];
    }
    constructor(context){
        super();
        this.textHeight = 0;
        this.context2D = context;
        if (!context.canvas) this.canvas = {
            width: _CanvasContext.WIDTH,
            height: _CanvasContext.HEIGHT
        };
        else this.canvas = context.canvas;
    }
    clear() {
        this.context2D.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    openGroup(cls, id4, attrs) {}
    closeGroup() {}
    add(child) {}
    setFillStyle(style3) {
        this.context2D.fillStyle = style3;
        return this;
    }
    setBackgroundFillStyle(style3) {
        return this;
    }
    setStrokeStyle(style3) {
        this.context2D.strokeStyle = style3;
        return this;
    }
    setShadowColor(color) {
        this.context2D.shadowColor = color;
        return this;
    }
    setShadowBlur(blur3) {
        const t2 = this.context2D.getTransform();
        const scale = Math.sqrt(t2.a * t2.a + t2.b * t2.b + t2.c * t2.c + t2.d * t2.d);
        this.context2D.shadowBlur = scale * blur3;
        return this;
    }
    setLineWidth(width9) {
        this.context2D.lineWidth = width9;
        return this;
    }
    setLineCap(capType) {
        this.context2D.lineCap = capType;
        return this;
    }
    setLineDash(dash) {
        this.context2D.setLineDash(dash);
        return this;
    }
    scale(x4, y4) {
        this.context2D.scale(x4, y4);
        return this;
    }
    resize(width9, height9, devicePixelRatio) {
        var _a;
        const canvas2 = this.context2D.canvas;
        const dpr = (_a = devicePixelRatio !== null && devicePixelRatio !== void 0 ? devicePixelRatio : $a801f2c896bd09f1$var$globalObject().devicePixelRatio) !== null && _a !== void 0 ? _a : 1;
        [width9, height9] = _CanvasContext.sanitizeCanvasDims(width9 * dpr, height9 * dpr);
        width9 = width9 / dpr | 0;
        height9 = height9 / dpr | 0;
        canvas2.width = width9 * dpr;
        canvas2.height = height9 * dpr;
        if ($a801f2c896bd09f1$var$isHTMLCanvas(canvas2)) {
            canvas2.style.width = width9 + "px";
            canvas2.style.height = height9 + "px";
        }
        return this.scale(dpr, dpr);
    }
    rect(x4, y4, width9, height9) {
        this.context2D.rect(x4, y4, width9, height9);
        return this;
    }
    fillRect(x4, y4, width9, height9) {
        this.context2D.fillRect(x4, y4, width9, height9);
        return this;
    }
    clearRect(x4, y4, width9, height9) {
        this.context2D.clearRect(x4, y4, width9, height9);
        return this;
    }
    beginPath() {
        this.context2D.beginPath();
        return this;
    }
    moveTo(x4, y4) {
        this.context2D.moveTo(x4, y4);
        return this;
    }
    lineTo(x4, y4) {
        this.context2D.lineTo(x4, y4);
        return this;
    }
    bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x4, y4) {
        this.context2D.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x4, y4);
        return this;
    }
    quadraticCurveTo(cpx, cpy, x4, y4) {
        this.context2D.quadraticCurveTo(cpx, cpy, x4, y4);
        return this;
    }
    arc(x4, y4, radius, startAngle, endAngle, counterclockwise) {
        this.context2D.arc(x4, y4, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    fill() {
        this.context2D.fill();
        return this;
    }
    stroke() {
        this.context2D.stroke();
        return this;
    }
    closePath() {
        this.context2D.closePath();
        return this;
    }
    measureText(text7) {
        const metrics = this.context2D.measureText(text7);
        let y4 = 0;
        let height9 = 0;
        if (metrics.fontBoundingBoxAscent) {
            y4 = -metrics.fontBoundingBoxAscent;
            height9 = metrics.fontBoundingBoxDescent + metrics.fontBoundingBoxAscent;
        } else {
            y4 = -metrics.actualBoundingBoxAscent;
            height9 = metrics.actualBoundingBoxDescent + metrics.actualBoundingBoxAscent;
        }
        return {
            x: 0,
            y: y4,
            width: metrics.width,
            height: height9
        };
    }
    fillText(text7, x4, y4) {
        this.context2D.fillText(text7, x4, y4);
        return this;
    }
    save() {
        this.context2D.save();
        return this;
    }
    restore() {
        this.context2D.restore();
        return this;
    }
    set fillStyle(style3) {
        this.context2D.fillStyle = style3;
    }
    get fillStyle() {
        return this.context2D.fillStyle;
    }
    set strokeStyle(style3) {
        this.context2D.strokeStyle = style3;
    }
    get strokeStyle() {
        return this.context2D.strokeStyle;
    }
    setFont(f2, size6, weight, style3) {
        const fontInfo = $a801f2c896bd09f1$var$Font.validate(f2, size6, weight, style3);
        this.context2D.font = $a801f2c896bd09f1$var$Font.toCSSString(fontInfo);
        this.textHeight = $a801f2c896bd09f1$var$Font.convertSizeToPixelValue(fontInfo.size);
        return this;
    }
    getFont() {
        return this.context2D.font;
    }
};
// node_modules/vexflow/build/esm/src/chordsymbol.js
function $a801f2c896bd09f1$var$L7(...args) {
    if ($a801f2c896bd09f1$var$ChordSymbol.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.ChordSymbol", args);
}
var $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify;
(function(ChordSymbolHorizontalJustify2) {
    ChordSymbolHorizontalJustify2[ChordSymbolHorizontalJustify2["LEFT"] = 1] = "LEFT";
    ChordSymbolHorizontalJustify2[ChordSymbolHorizontalJustify2["CENTER"] = 2] = "CENTER";
    ChordSymbolHorizontalJustify2[ChordSymbolHorizontalJustify2["RIGHT"] = 3] = "RIGHT";
    ChordSymbolHorizontalJustify2[ChordSymbolHorizontalJustify2["CENTER_STEM"] = 4] = "CENTER_STEM";
})($a801f2c896bd09f1$var$ChordSymbolHorizontalJustify || ($a801f2c896bd09f1$var$ChordSymbolHorizontalJustify = {}));
var $a801f2c896bd09f1$var$ChordSymbolVerticalJustify;
(function(ChordSymbolVerticalJustify2) {
    ChordSymbolVerticalJustify2[ChordSymbolVerticalJustify2["TOP"] = 1] = "TOP";
    ChordSymbolVerticalJustify2[ChordSymbolVerticalJustify2["BOTTOM"] = 2] = "BOTTOM";
})($a801f2c896bd09f1$var$ChordSymbolVerticalJustify || ($a801f2c896bd09f1$var$ChordSymbolVerticalJustify = {}));
var $a801f2c896bd09f1$var$SymbolTypes;
(function(SymbolTypes2) {
    SymbolTypes2[SymbolTypes2["GLYPH"] = 1] = "GLYPH";
    SymbolTypes2[SymbolTypes2["TEXT"] = 2] = "TEXT";
    SymbolTypes2[SymbolTypes2["LINE"] = 3] = "LINE";
})($a801f2c896bd09f1$var$SymbolTypes || ($a801f2c896bd09f1$var$SymbolTypes = {}));
var $a801f2c896bd09f1$var$SymbolModifiers;
(function(SymbolModifiers2) {
    SymbolModifiers2[SymbolModifiers2["NONE"] = 1] = "NONE";
    SymbolModifiers2[SymbolModifiers2["SUBSCRIPT"] = 2] = "SUBSCRIPT";
    SymbolModifiers2[SymbolModifiers2["SUPERSCRIPT"] = 3] = "SUPERSCRIPT";
})($a801f2c896bd09f1$var$SymbolModifiers || ($a801f2c896bd09f1$var$SymbolModifiers = {}));
var $a801f2c896bd09f1$var$ChordSymbol = class _ChordSymbol extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "ChordSymbol";
    }
    static get superSubRatio() {
        return _ChordSymbol.metrics.global.superSubRatio;
    }
    static set NO_TEXT_FORMAT(val) {
        _ChordSymbol.noFormat = val;
    }
    static get NO_TEXT_FORMAT() {
        return _ChordSymbol.noFormat;
    }
    static getMetricForGlyph(glyphCode) {
        if (_ChordSymbol.metrics.glyphs[glyphCode]) return _ChordSymbol.metrics.glyphs[glyphCode];
        return void 0;
    }
    static get engravingFontResolution() {
        return $a801f2c896bd09f1$var$Tables.currentMusicFont().getResolution();
    }
    static get spacingBetweenBlocks() {
        return _ChordSymbol.metrics.global.spacing / _ChordSymbol.engravingFontResolution;
    }
    static getWidthForGlyph(glyph) {
        const metric = _ChordSymbol.getMetricForGlyph(glyph.code);
        if (!metric) return 0.65;
        return metric.advanceWidth / _ChordSymbol.engravingFontResolution;
    }
    static getYShiftForGlyph(glyph) {
        const metric = _ChordSymbol.getMetricForGlyph(glyph.code);
        if (!metric) return 0;
        return metric.yOffset / _ChordSymbol.engravingFontResolution;
    }
    static getXShiftForGlyph(glyph) {
        const metric = _ChordSymbol.getMetricForGlyph(glyph.code);
        if (!metric) return 0;
        return -1 * metric.leftSideBearing / _ChordSymbol.engravingFontResolution;
    }
    static get superscriptOffset() {
        return _ChordSymbol.metrics.global.superscriptOffset / _ChordSymbol.engravingFontResolution;
    }
    static get subscriptOffset() {
        return _ChordSymbol.metrics.global.subscriptOffset / _ChordSymbol.engravingFontResolution;
    }
    static get kerningOffset() {
        return _ChordSymbol.metrics.global.kerningOffset / _ChordSymbol.engravingFontResolution;
    }
    static get metrics() {
        const chordSymbol = $a801f2c896bd09f1$var$Tables.currentMusicFont().getMetrics().chordSymbol;
        if (!chordSymbol) throw new $a801f2c896bd09f1$var$RuntimeError("BadMetrics", `chordSymbol missing`);
        return chordSymbol;
    }
    static get lowerKerningText() {
        return _ChordSymbol.metrics.global.lowerKerningText;
    }
    static get upperKerningText() {
        return _ChordSymbol.metrics.global.upperKerningText;
    }
    static isSuperscript(block) {
        return block.symbolModifier !== void 0 && block.symbolModifier === $a801f2c896bd09f1$var$SymbolModifiers.SUPERSCRIPT;
    }
    static isSubscript(block) {
        return block.symbolModifier !== void 0 && block.symbolModifier === $a801f2c896bd09f1$var$SymbolModifiers.SUBSCRIPT;
    }
    static get minPadding() {
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        return musicFont.lookupMetric("noteHead.minPadding");
    }
    static format(symbols, state3) {
        var _a;
        if (!symbols || symbols.length === 0) return false;
        let width9 = 0;
        let nonSuperWidth = 0;
        let leftWidth = 0;
        let rightWidth = 0;
        let maxLeftGlyphWidth = 0;
        let maxRightGlyphWidth = 0;
        for (const symbol of symbols){
            const fontSize = $a801f2c896bd09f1$var$Font.convertSizeToPointValue((_a = symbol.textFont) === null || _a === void 0 ? void 0 : _a.size);
            const fontAdj = $a801f2c896bd09f1$var$Font.scaleSize(fontSize, 0.05);
            const glyphAdj = fontAdj * 2;
            const note2 = symbol.checkAttachedNote();
            let symbolWidth = 0;
            let lineSpaces = 1;
            let vAlign = false;
            for(let j2 = 0; j2 < symbol.symbolBlocks.length; ++j2){
                const block = symbol.symbolBlocks[j2];
                const sup2 = _ChordSymbol.isSuperscript(block);
                const sub3 = _ChordSymbol.isSubscript(block);
                const superSubScale = sup2 || sub3 ? _ChordSymbol.superSubRatio : 1;
                const adj = block.symbolType === $a801f2c896bd09f1$var$SymbolTypes.GLYPH ? glyphAdj * superSubScale : fontAdj * superSubScale;
                if (sup2 || sub3) lineSpaces = 2;
                const fontSize2 = symbol.textFormatter.fontSizeInPixels;
                const superSubFontSize = fontSize2 * superSubScale;
                if (block.symbolType === $a801f2c896bd09f1$var$SymbolTypes.GLYPH && block.glyph !== void 0) {
                    block.width = _ChordSymbol.getWidthForGlyph(block.glyph) * superSubFontSize;
                    block.yShift += _ChordSymbol.getYShiftForGlyph(block.glyph) * superSubFontSize;
                    block.xShift += _ChordSymbol.getXShiftForGlyph(block.glyph) * superSubFontSize;
                    block.glyph.scale = block.glyph.scale * adj;
                } else if (block.symbolType === $a801f2c896bd09f1$var$SymbolTypes.TEXT) {
                    block.width = block.width * superSubFontSize;
                    block.yShift += symbol.getYOffsetForText(block.text) * adj;
                }
                if (block.symbolType === $a801f2c896bd09f1$var$SymbolTypes.GLYPH && block.glyph !== void 0 && block.glyph.code === _ChordSymbol.glyphs.over.code) lineSpaces = 2;
                block.width += _ChordSymbol.spacingBetweenBlocks * fontSize2 * superSubScale;
                if (sup2 && j2 > 0) {
                    const prev = symbol.symbolBlocks[j2 - 1];
                    if (!_ChordSymbol.isSuperscript(prev)) nonSuperWidth = width9;
                }
                if (sub3 && nonSuperWidth > 0) {
                    vAlign = true;
                    block.xShift = block.xShift + (nonSuperWidth - width9);
                    width9 = nonSuperWidth;
                    nonSuperWidth = 0;
                    symbol.setEnableKerning(false);
                }
                if (!sup2 && !sub3) nonSuperWidth = 0;
                block.vAlign = vAlign;
                width9 += block.width;
                symbolWidth = width9;
            }
            symbol.updateKerningAdjustments();
            symbol.updateOverBarAdjustments();
            if (symbol.getVertical() === $a801f2c896bd09f1$var$ChordSymbolVerticalJustify.TOP) {
                symbol.setTextLine(state3.top_text_line);
                state3.top_text_line += lineSpaces;
            } else {
                symbol.setTextLine(state3.text_line + 1);
                state3.text_line += lineSpaces + 1;
            }
            if (symbol.getReportWidth() && $a801f2c896bd09f1$var$isStemmableNote(note2)) {
                const glyphWidth = note2.getGlyphProps().getWidth();
                if (symbol.getHorizontal() === $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.LEFT) {
                    maxLeftGlyphWidth = Math.max(glyphWidth, maxLeftGlyphWidth);
                    leftWidth = Math.max(leftWidth, symbolWidth) + _ChordSymbol.minPadding;
                } else if (symbol.getHorizontal() === $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.RIGHT) {
                    maxRightGlyphWidth = Math.max(glyphWidth, maxRightGlyphWidth);
                    rightWidth = Math.max(rightWidth, symbolWidth);
                } else {
                    leftWidth = Math.max(leftWidth, symbolWidth / 2) + _ChordSymbol.minPadding;
                    rightWidth = Math.max(rightWidth, symbolWidth / 2);
                    maxLeftGlyphWidth = Math.max(glyphWidth / 2, maxLeftGlyphWidth);
                    maxRightGlyphWidth = Math.max(glyphWidth / 2, maxRightGlyphWidth);
                }
            }
            width9 = 0;
        }
        const rightOverlap = Math.min(Math.max(rightWidth - maxRightGlyphWidth, 0), Math.max(rightWidth - state3.right_shift, 0));
        const leftOverlap = Math.min(Math.max(leftWidth - maxLeftGlyphWidth, 0), Math.max(leftWidth - state3.left_shift, 0));
        state3.left_shift += leftOverlap;
        state3.right_shift += rightOverlap;
        return true;
    }
    constructor(){
        super();
        this.symbolBlocks = [];
        this.horizontal = $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.LEFT;
        this.vertical = $a801f2c896bd09f1$var$ChordSymbolVerticalJustify.TOP;
        this.useKerning = true;
        this.reportWidth = true;
        this.resetFont();
    }
    static get TEXT_FONT() {
        let family = "Roboto Slab, Times, serif";
        if ($a801f2c896bd09f1$var$Tables.currentMusicFont().getName() === "Petaluma") family = "PetalumaScript, Arial, sans-serif";
        return {
            family: family,
            size: 12,
            weight: $a801f2c896bd09f1$var$FontWeight.NORMAL,
            style: $a801f2c896bd09f1$var$FontStyle.NORMAL
        };
    }
    get superscriptOffset() {
        return _ChordSymbol.superscriptOffset * this.textFormatter.fontSizeInPixels;
    }
    get subscriptOffset() {
        return _ChordSymbol.subscriptOffset * this.textFormatter.fontSizeInPixels;
    }
    setReportWidth(value17) {
        this.reportWidth = value17;
        return this;
    }
    getReportWidth() {
        return this.reportWidth;
    }
    updateOverBarAdjustments() {
        const barIndex = this.symbolBlocks.findIndex(({ symbolType: symbolType, glyph: glyph })=>symbolType === $a801f2c896bd09f1$var$SymbolTypes.GLYPH && glyph !== void 0 && glyph.code === "csymDiagonalArrangementSlash");
        if (barIndex < 0) return;
        const bar = this.symbolBlocks[barIndex];
        const xoff = bar.width / 4;
        const yoff = 0.25 * this.textFormatter.fontSizeInPixels;
        let symIndex = 0;
        for(symIndex; symIndex < barIndex; ++symIndex){
            const symbol = this.symbolBlocks[symIndex];
            symbol.xShift = symbol.xShift + xoff;
            symbol.yShift = symbol.yShift - yoff;
        }
        for(symIndex = barIndex + 1; symIndex < this.symbolBlocks.length; ++symIndex){
            const symbol = this.symbolBlocks[symIndex];
            symbol.xShift = symbol.xShift - xoff;
            symbol.yShift = symbol.yShift + yoff;
        }
    }
    updateKerningAdjustments() {
        let accum = 0;
        for(let j2 = 0; j2 < this.symbolBlocks.length; ++j2){
            const symbol = this.symbolBlocks[j2];
            accum += this.getKerningAdjustment(j2);
            symbol.xShift += accum;
        }
    }
    getKerningAdjustment(j2) {
        if (!this.useKerning) return 0;
        const currSymbol = this.symbolBlocks[j2];
        const prevSymbol = j2 > 0 ? this.symbolBlocks[j2 - 1] : void 0;
        let adjustment = 0;
        if (currSymbol.symbolType === $a801f2c896bd09f1$var$SymbolTypes.GLYPH && currSymbol.glyph !== void 0 && currSymbol.glyph.code === _ChordSymbol.glyphs.over.code) adjustment += currSymbol.glyph.metrics.x_shift;
        if (prevSymbol !== void 0 && prevSymbol.symbolType === $a801f2c896bd09f1$var$SymbolTypes.GLYPH && prevSymbol.glyph !== void 0 && prevSymbol.glyph.code === _ChordSymbol.glyphs.over.code) adjustment += prevSymbol.glyph.metrics.x_shift;
        let preKernUpper = false;
        let preKernLower = false;
        if (prevSymbol !== void 0 && prevSymbol.symbolType === $a801f2c896bd09f1$var$SymbolTypes.TEXT) {
            preKernUpper = _ChordSymbol.upperKerningText.some((xx)=>xx === prevSymbol.text[prevSymbol.text.length - 1]);
            preKernLower = _ChordSymbol.lowerKerningText.some((xx)=>xx === prevSymbol.text[prevSymbol.text.length - 1]);
        }
        const kerningOffsetPixels = _ChordSymbol.kerningOffset * this.textFormatter.fontSizeInPixels;
        if (preKernUpper && currSymbol.symbolModifier === $a801f2c896bd09f1$var$SymbolModifiers.SUPERSCRIPT) adjustment += kerningOffsetPixels;
        if (preKernLower && currSymbol.symbolType === $a801f2c896bd09f1$var$SymbolTypes.TEXT) {
            if (currSymbol.text[0] >= "a" && currSymbol.text[0] <= "z") adjustment += kerningOffsetPixels / 2;
            if (_ChordSymbol.upperKerningText.some((xx)=>xx === (prevSymbol === null || prevSymbol === void 0 ? void 0 : prevSymbol.text[prevSymbol.text.length - 1]))) adjustment += kerningOffsetPixels / 2;
        }
        return adjustment;
    }
    getSymbolBlock(params = {}) {
        var _a, _b, _c;
        const symbolType = (_a = params.symbolType) !== null && _a !== void 0 ? _a : $a801f2c896bd09f1$var$SymbolTypes.TEXT;
        const symbolBlock = {
            text: (_b = params.text) !== null && _b !== void 0 ? _b : "",
            symbolType: symbolType,
            symbolModifier: (_c = params.symbolModifier) !== null && _c !== void 0 ? _c : $a801f2c896bd09f1$var$SymbolModifiers.NONE,
            xShift: 0,
            yShift: 0,
            vAlign: false,
            width: 0
        };
        if (symbolType === $a801f2c896bd09f1$var$SymbolTypes.GLYPH && typeof params.glyph === "string") {
            const glyphArgs = _ChordSymbol.glyphs[params.glyph];
            const glyphPoints = 20;
            symbolBlock.glyph = new $a801f2c896bd09f1$var$Glyph(glyphArgs.code, glyphPoints, {
                category: "chordSymbol"
            });
        } else if (symbolType === $a801f2c896bd09f1$var$SymbolTypes.TEXT) symbolBlock.width = this.textFormatter.getWidthForTextInEm(symbolBlock.text);
        else if (symbolType === $a801f2c896bd09f1$var$SymbolTypes.LINE) symbolBlock.width = params.width;
        return symbolBlock;
    }
    addSymbolBlock(parameters) {
        this.symbolBlocks.push(this.getSymbolBlock(parameters));
        return this;
    }
    addText(text7, parameters = {}) {
        const symbolType = $a801f2c896bd09f1$var$SymbolTypes.TEXT;
        return this.addSymbolBlock(Object.assign(Object.assign({}, parameters), {
            text: text7,
            symbolType: symbolType
        }));
    }
    addTextSuperscript(text7) {
        const symbolType = $a801f2c896bd09f1$var$SymbolTypes.TEXT;
        const symbolModifier = $a801f2c896bd09f1$var$SymbolModifiers.SUPERSCRIPT;
        return this.addSymbolBlock({
            text: text7,
            symbolType: symbolType,
            symbolModifier: symbolModifier
        });
    }
    addTextSubscript(text7) {
        const symbolType = $a801f2c896bd09f1$var$SymbolTypes.TEXT;
        const symbolModifier = $a801f2c896bd09f1$var$SymbolModifiers.SUBSCRIPT;
        return this.addSymbolBlock({
            text: text7,
            symbolType: symbolType,
            symbolModifier: symbolModifier
        });
    }
    addGlyphSuperscript(glyph) {
        const symbolType = $a801f2c896bd09f1$var$SymbolTypes.GLYPH;
        const symbolModifier = $a801f2c896bd09f1$var$SymbolModifiers.SUPERSCRIPT;
        return this.addSymbolBlock({
            glyph: glyph,
            symbolType: symbolType,
            symbolModifier: symbolModifier
        });
    }
    addGlyph(glyph, params = {}) {
        const symbolType = $a801f2c896bd09f1$var$SymbolTypes.GLYPH;
        return this.addSymbolBlock(Object.assign(Object.assign({}, params), {
            glyph: glyph,
            symbolType: symbolType
        }));
    }
    addGlyphOrText(text7, params = {}) {
        let str = "";
        for(let i2 = 0; i2 < text7.length; ++i2){
            const char2 = text7[i2];
            if (_ChordSymbol.glyphs[char2]) {
                if (str.length > 0) {
                    this.addText(str, params);
                    str = "";
                }
                this.addGlyph(char2, params);
            } else str += char2;
        }
        if (str.length > 0) this.addText(str, params);
        return this;
    }
    addLine(width9, params = {}) {
        const symbolType = $a801f2c896bd09f1$var$SymbolTypes.LINE;
        return this.addSymbolBlock(Object.assign(Object.assign({}, params), {
            symbolType: symbolType,
            width: width9
        }));
    }
    setFont(f2, size6, weight, style3) {
        super.setFont(f2, size6, weight, style3);
        this.textFormatter = $a801f2c896bd09f1$var$TextFormatter.create(this.textFont);
        return this;
    }
    setEnableKerning(val) {
        this.useKerning = val;
        return this;
    }
    setVertical(vj) {
        this.vertical = typeof vj === "string" ? _ChordSymbol.VerticalJustifyString[vj] : vj;
        return this;
    }
    getVertical() {
        return this.vertical;
    }
    setHorizontal(hj) {
        this.horizontal = typeof hj === "string" ? _ChordSymbol.HorizontalJustifyString[hj] : hj;
        return this;
    }
    getHorizontal() {
        return this.horizontal;
    }
    getWidth() {
        let width9 = 0;
        this.symbolBlocks.forEach((symbol)=>{
            width9 += symbol.vAlign ? 0 : symbol.width;
        });
        return width9;
    }
    getYOffsetForText(text7) {
        var _a;
        let acc = 0;
        let i2 = 0;
        for(i2 = 0; i2 < text7.length; ++i2){
            const metrics = this.textFormatter.getGlyphMetrics(text7[i2]);
            if (metrics) {
                const yMax = (_a = metrics.y_max) !== null && _a !== void 0 ? _a : 0;
                acc = yMax < acc ? yMax : acc;
            }
        }
        const resolution = this.textFormatter.getResolution();
        return i2 > 0 ? -1 * (acc / resolution) : 0;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        ctx.save();
        this.applyStyle();
        ctx.openGroup("chordsymbol", this.getAttribute("id"));
        const start2 = note2.getModifierStartXY($a801f2c896bd09f1$var$Modifier.Position.ABOVE, this.index);
        ctx.setFont(this.textFont);
        let y4;
        const hasStem = note2.hasStem();
        const stave = note2.checkStave();
        if (this.vertical === $a801f2c896bd09f1$var$ChordSymbolVerticalJustify.BOTTOM) {
            y4 = stave.getYForBottomText(this.text_line + $a801f2c896bd09f1$var$Tables.TEXT_HEIGHT_OFFSET_HACK);
            if (hasStem) {
                const stem_ext = note2.checkStem().getExtents();
                const spacing = stave.getSpacingBetweenLines();
                const stem_base = note2.getStemDirection() === 1 ? stem_ext.baseY : stem_ext.topY;
                y4 = Math.max(y4, stem_base + spacing * (this.text_line + 2));
            }
        } else {
            const topY = Math.min(...note2.getYs());
            y4 = Math.min(stave.getYForTopText(this.text_line), topY - 10);
            if (hasStem) {
                const stem_ext = note2.checkStem().getExtents();
                const spacing = stave.getSpacingBetweenLines();
                y4 = Math.min(y4, stem_ext.topY - 5 - spacing * this.text_line);
            }
        }
        let x4 = start2.x;
        if (this.horizontal === $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.LEFT) x4 = start2.x;
        else if (this.horizontal === $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.RIGHT) x4 = start2.x + this.getWidth();
        else if (this.horizontal === $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.CENTER) x4 = start2.x - this.getWidth() / 2;
        else x4 = note2.getStemX() - this.getWidth() / 2;
        $a801f2c896bd09f1$var$L7("Rendering ChordSymbol: ", this.textFormatter, x4, y4);
        this.symbolBlocks.forEach((symbol)=>{
            const isSuper = _ChordSymbol.isSuperscript(symbol);
            const isSub = _ChordSymbol.isSubscript(symbol);
            let curY = y4;
            $a801f2c896bd09f1$var$L7("shift was ", symbol.xShift, symbol.yShift);
            $a801f2c896bd09f1$var$L7("curY pre sub ", curY);
            if (isSuper) curY += this.superscriptOffset;
            if (isSub) curY += this.subscriptOffset;
            $a801f2c896bd09f1$var$L7("curY sup/sub ", curY);
            if (symbol.symbolType === $a801f2c896bd09f1$var$SymbolTypes.TEXT) {
                if (isSuper || isSub) {
                    ctx.save();
                    if (this.textFont) {
                        const { family: family, size: size6, weight: weight, style: style3 } = this.textFont;
                        const smallerFontSize = $a801f2c896bd09f1$var$Font.scaleSize(size6, _ChordSymbol.superSubRatio);
                        ctx.setFont(family, smallerFontSize, weight, style3);
                    }
                }
                $a801f2c896bd09f1$var$L7("Rendering Text: ", symbol.text, x4 + symbol.xShift, curY + symbol.yShift);
                ctx.fillText(symbol.text, x4 + symbol.xShift, curY + symbol.yShift);
                if (isSuper || isSub) ctx.restore();
            } else if (symbol.symbolType === $a801f2c896bd09f1$var$SymbolTypes.GLYPH && symbol.glyph) {
                curY += symbol.yShift;
                $a801f2c896bd09f1$var$L7("Rendering Glyph: ", symbol.glyph.code, x4 + symbol.xShift, curY);
                symbol.glyph.render(ctx, x4 + symbol.xShift, curY);
            } else if (symbol.symbolType === $a801f2c896bd09f1$var$SymbolTypes.LINE) {
                $a801f2c896bd09f1$var$L7("Rendering Line : ", symbol.width, x4, curY);
                ctx.beginPath();
                ctx.setLineWidth(1);
                ctx.moveTo(x4, y4);
                ctx.lineTo(x4 + symbol.width, curY);
                ctx.stroke();
            }
            x4 += symbol.width;
            if (symbol.vAlign) x4 += symbol.xShift;
        });
        ctx.closeGroup();
        this.restoreStyle();
        ctx.restore();
    }
};
$a801f2c896bd09f1$var$ChordSymbol.DEBUG = false;
$a801f2c896bd09f1$var$ChordSymbol.HorizontalJustify = $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify;
$a801f2c896bd09f1$var$ChordSymbol.HorizontalJustifyString = {
    left: $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.LEFT,
    right: $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.RIGHT,
    center: $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.CENTER,
    centerStem: $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify.CENTER_STEM
};
$a801f2c896bd09f1$var$ChordSymbol.VerticalJustify = $a801f2c896bd09f1$var$ChordSymbolVerticalJustify;
$a801f2c896bd09f1$var$ChordSymbol.VerticalJustifyString = {
    top: $a801f2c896bd09f1$var$ChordSymbolVerticalJustify.TOP,
    above: $a801f2c896bd09f1$var$ChordSymbolVerticalJustify.TOP,
    below: $a801f2c896bd09f1$var$ChordSymbolVerticalJustify.BOTTOM,
    bottom: $a801f2c896bd09f1$var$ChordSymbolVerticalJustify.BOTTOM
};
$a801f2c896bd09f1$var$ChordSymbol.glyphs = {
    diminished: {
        code: "csymDiminished"
    },
    dim: {
        code: "csymDiminished"
    },
    halfDiminished: {
        code: "csymHalfDiminished"
    },
    "+": {
        code: "csymAugmented"
    },
    augmented: {
        code: "csymAugmented"
    },
    majorSeventh: {
        code: "csymMajorSeventh"
    },
    minor: {
        code: "csymMinor"
    },
    "-": {
        code: "csymMinor"
    },
    "(": {
        code: "csymParensLeftTall"
    },
    leftParen: {
        code: "csymParensLeftTall"
    },
    ")": {
        code: "csymParensRightTall"
    },
    rightParen: {
        code: "csymParensRightTall"
    },
    leftBracket: {
        code: "csymBracketLeftTall"
    },
    rightBracket: {
        code: "csymBracketRightTall"
    },
    leftParenTall: {
        code: "csymParensLeftVeryTall"
    },
    rightParenTall: {
        code: "csymParensRightVeryTall"
    },
    "/": {
        code: "csymDiagonalArrangementSlash"
    },
    over: {
        code: "csymDiagonalArrangementSlash"
    },
    "#": {
        code: "accidentalSharp"
    },
    b: {
        code: "accidentalFlat"
    }
};
$a801f2c896bd09f1$var$ChordSymbol.symbolTypes = $a801f2c896bd09f1$var$SymbolTypes;
$a801f2c896bd09f1$var$ChordSymbol.symbolModifiers = $a801f2c896bd09f1$var$SymbolModifiers;
$a801f2c896bd09f1$var$ChordSymbol.noFormat = false;
// node_modules/vexflow/build/esm/src/clef.js
function $a801f2c896bd09f1$var$L8(...args) {
    if ($a801f2c896bd09f1$var$Clef.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Clef", args);
}
var $a801f2c896bd09f1$var$Clef = class _Clef extends $a801f2c896bd09f1$var$StaveModifier {
    static get CATEGORY() {
        return "Clef";
    }
    static get types() {
        return {
            treble: {
                code: "gClef",
                line: 3
            },
            bass: {
                code: "fClef",
                line: 1
            },
            alto: {
                code: "cClef",
                line: 2
            },
            tenor: {
                code: "cClef",
                line: 1
            },
            percussion: {
                code: "unpitchedPercussionClef1",
                line: 2
            },
            soprano: {
                code: "cClef",
                line: 4
            },
            "mezzo-soprano": {
                code: "cClef",
                line: 3
            },
            "baritone-c": {
                code: "cClef",
                line: 0
            },
            "baritone-f": {
                code: "fClef",
                line: 2
            },
            subbass: {
                code: "fClef",
                line: 0
            },
            french: {
                code: "gClef",
                line: 4
            },
            tab: {
                code: "6stringTabClef",
                line: 2.5
            }
        };
    }
    static get annotationSmufl() {
        return {
            "8va": "timeSig8",
            "8vb": "timeSig8"
        };
    }
    constructor(type, size6, annotation){
        super();
        this.clef = _Clef.types["treble"];
        this.setPosition($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN);
        this.setType(type, size6, annotation);
        this.setWidth($a801f2c896bd09f1$var$Glyph.getWidth(this.clef.code, _Clef.getPoint(this.size), `clef_${this.size}`));
        $a801f2c896bd09f1$var$L8("Creating clef:", type);
    }
    setType(type, size6, annotation) {
        this.type = type;
        this.clef = _Clef.types[type];
        if (size6 === void 0) this.size = "default";
        else this.size = size6;
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        if (annotation !== void 0) {
            const code3 = _Clef.annotationSmufl[annotation];
            const point = _Clef.getPoint(this.size) / 5 * 3;
            const line2 = musicFont.lookupMetric(`clef_${this.size}.annotations.${annotation}.${this.type}.line`);
            const x_shift = musicFont.lookupMetric(`clef_${this.size}.annotations.${annotation}.${this.type}.shiftX`);
            this.annotation = {
                code: code3,
                point: point,
                line: line2,
                x_shift: x_shift
            };
            this.attachment = new $a801f2c896bd09f1$var$Glyph(this.annotation.code, this.annotation.point);
            this.attachment.metrics.x_max = 0;
            this.attachment.setXShift(this.annotation.x_shift);
        } else this.annotation = void 0;
        return this;
    }
    getWidth() {
        if (this.type === "tab") $a801f2c896bd09f1$var$defined(this.stave, "ClefError", "Can't get width without stave.");
        return this.width;
    }
    static getPoint(size6) {
        return size6 == "default" ? $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE : $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE / 3 * 2;
    }
    setStave(stave) {
        this.stave = stave;
        return this;
    }
    draw() {
        const stave = this.checkStave();
        const ctx = stave.checkContext();
        this.setRendered();
        this.applyStyle(ctx);
        ctx.openGroup("clef", this.getAttribute("id"));
        $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, this.x, stave.getYForLine(this.clef.line), _Clef.getPoint(this.size), this.clef.code, {
            category: `clef_${this.size}`
        });
        if (this.annotation !== void 0 && this.attachment !== void 0) {
            this.placeGlyphOnLine(this.attachment, stave, this.annotation.line);
            this.attachment.setStave(stave);
            this.attachment.setContext(ctx);
            this.attachment.renderToStave(this.x);
        }
        ctx.closeGroup();
        this.restoreStyle(ctx);
    }
};
$a801f2c896bd09f1$var$Clef.DEBUG = false;
// node_modules/vexflow/build/esm/src/clefnote.js
var $a801f2c896bd09f1$var$ClefNote = class extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "ClefNote";
    }
    constructor(type, size6, annotation){
        super({
            duration: "b"
        });
        this.type = type;
        const clef = new $a801f2c896bd09f1$var$Clef(type, size6, annotation);
        this.clef = clef.clef;
        this.annotation = clef.annotation;
        this.size = size6 === void 0 ? "default" : size6;
        this.setWidth($a801f2c896bd09f1$var$Glyph.getWidth(this.clef.code, $a801f2c896bd09f1$var$Clef.getPoint(this.size), `clefNote_${this.size}`));
        this.ignore_ticks = true;
    }
    setType(type, size6, annotation) {
        this.type = type;
        this.size = size6;
        const clef = new $a801f2c896bd09f1$var$Clef(type, size6, annotation);
        this.clef = clef.clef;
        this.annotation = clef.annotation;
        this.setWidth($a801f2c896bd09f1$var$Glyph.getWidth(this.clef.code, $a801f2c896bd09f1$var$Clef.getPoint(this.size), `clefNote_${this.size}`));
        return this;
    }
    getClef() {
        return this.clef;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    draw() {
        const stave = this.checkStave();
        const ctx = this.checkContext();
        this.setRendered();
        const abs_x = this.getAbsoluteX();
        $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, abs_x, stave.getYForLine(this.clef.line), $a801f2c896bd09f1$var$Clef.getPoint(this.size), this.clef.code, {
            category: `clefNote_${this.size}`
        });
        if (this.annotation !== void 0) {
            const attachment = new $a801f2c896bd09f1$var$Glyph(this.annotation.code, this.annotation.point);
            attachment.setContext(ctx);
            attachment.setStave(stave);
            attachment.setYShift(stave.getYForLine(this.annotation.line) - stave.getYForGlyphs());
            attachment.setXShift(this.annotation.x_shift);
            attachment.renderToStave(abs_x);
        }
    }
};
// node_modules/vexflow/build/esm/src/tickcontext.js
var $a801f2c896bd09f1$var$TickContext = class {
    static getNextContext(tContext) {
        const contexts = tContext.tContexts;
        const index5 = contexts.indexOf(tContext);
        if (index5 + 1 < contexts.length) return contexts[index5 + 1];
    }
    constructor(options2){
        this.preFormatted = false;
        this.postFormatted = false;
        this.tickID = options2 && options2.tickID ? options2.tickID : 0;
        this.currentTick = new $a801f2c896bd09f1$var$Fraction(0, 1);
        this.maxTicks = new $a801f2c896bd09f1$var$Fraction(0, 1);
        this.maxTickable = void 0;
        this.minTicks = void 0;
        this.minTickable = void 0;
        this.padding = 1;
        this.x = 0;
        this.xBase = 0;
        this.xOffset = 0;
        this.tickables = [];
        this.tickablesByVoice = {};
        this.notePx = 0;
        this.glyphPx = 0;
        this.leftDisplacedHeadPx = 0;
        this.rightDisplacedHeadPx = 0;
        this.modLeftPx = 0;
        this.modRightPx = 0;
        this.totalLeftPx = 0;
        this.totalRightPx = 0;
        this.tContexts = [];
        this.width = 0;
        this.formatterMetrics = {
            freedom: {
                left: 0,
                right: 0
            }
        };
    }
    getTickID() {
        return this.tickID;
    }
    getX() {
        return this.x;
    }
    setX(x4) {
        this.x = x4;
        this.xBase = x4;
        this.xOffset = 0;
        return this;
    }
    getXBase() {
        return this.xBase;
    }
    setXBase(xBase) {
        this.xBase = xBase;
        this.x = xBase + this.xOffset;
    }
    getXOffset() {
        return this.xOffset;
    }
    setXOffset(xOffset) {
        this.xOffset = xOffset;
        this.x = this.xBase + xOffset;
    }
    getWidth() {
        return this.width + this.padding * 2;
    }
    setPadding(padding) {
        this.padding = padding;
        return this;
    }
    getMaxTicks() {
        return this.maxTicks;
    }
    getMinTicks() {
        return this.minTicks;
    }
    getMaxTickable() {
        return this.maxTickable;
    }
    getMinTickable() {
        return this.minTickable;
    }
    getTickables() {
        return this.tickables;
    }
    getTickableForVoice(voiceIndex) {
        return this.tickablesByVoice[voiceIndex];
    }
    getTickablesByVoice() {
        return this.tickablesByVoice;
    }
    getCenterAlignedTickables() {
        return this.tickables.filter((tickable)=>tickable.isCenterAligned());
    }
    getMetrics() {
        const { width: width9, glyphPx: glyphPx, notePx: notePx, leftDisplacedHeadPx: leftDisplacedHeadPx, rightDisplacedHeadPx: rightDisplacedHeadPx, modLeftPx: modLeftPx, modRightPx: modRightPx, totalLeftPx: totalLeftPx, totalRightPx: totalRightPx } = this;
        return {
            width: width9,
            glyphPx: glyphPx,
            notePx: notePx,
            leftDisplacedHeadPx: leftDisplacedHeadPx,
            rightDisplacedHeadPx: rightDisplacedHeadPx,
            modLeftPx: modLeftPx,
            modRightPx: modRightPx,
            totalLeftPx: totalLeftPx,
            totalRightPx: totalRightPx
        };
    }
    getCurrentTick() {
        return this.currentTick;
    }
    setCurrentTick(tick) {
        this.currentTick = tick;
        this.preFormatted = false;
    }
    addTickable(tickable, voiceIndex) {
        if (!tickable) throw new $a801f2c896bd09f1$var$RuntimeError("BadArgument", "Invalid tickable added.");
        if (!tickable.shouldIgnoreTicks()) {
            const ticks = tickable.getTicks();
            if (ticks.greaterThan(this.maxTicks)) {
                this.maxTicks = ticks.clone();
                this.maxTickable = tickable;
            }
            if (this.minTicks == null) {
                this.minTicks = ticks.clone();
                this.minTickable = tickable;
            } else if (ticks.lessThan(this.minTicks)) {
                this.minTicks = ticks.clone();
                this.minTickable = tickable;
            }
        }
        tickable.setTickContext(this);
        this.tickables.push(tickable);
        this.tickablesByVoice[voiceIndex || 0] = tickable;
        this.preFormatted = false;
        return this;
    }
    preFormat() {
        if (this.preFormatted) return this;
        for(let i2 = 0; i2 < this.tickables.length; ++i2){
            const tickable = this.tickables[i2];
            tickable.preFormat();
            const metrics = tickable.getMetrics();
            this.leftDisplacedHeadPx = Math.max(this.leftDisplacedHeadPx, metrics.leftDisplacedHeadPx);
            this.rightDisplacedHeadPx = Math.max(this.rightDisplacedHeadPx, metrics.rightDisplacedHeadPx);
            this.notePx = Math.max(this.notePx, metrics.notePx);
            this.glyphPx = Math.max(this.glyphPx, metrics.glyphWidth || 0);
            this.modLeftPx = Math.max(this.modLeftPx, metrics.modLeftPx);
            this.modRightPx = Math.max(this.modRightPx, metrics.modRightPx);
            this.totalLeftPx = Math.max(this.totalLeftPx, metrics.modLeftPx + metrics.leftDisplacedHeadPx);
            this.totalRightPx = Math.max(this.totalRightPx, metrics.modRightPx + metrics.rightDisplacedHeadPx);
            this.width = this.notePx + this.totalLeftPx + this.totalRightPx;
        }
        return this;
    }
    postFormat() {
        if (this.postFormatted) return this;
        this.postFormatted = true;
        return this;
    }
    getFormatterMetrics() {
        return this.formatterMetrics;
    }
};
// node_modules/vexflow/build/esm/src/crescendo.js
function $a801f2c896bd09f1$var$L9(...args) {
    if ($a801f2c896bd09f1$var$Crescendo.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Crescendo", args);
}
function $a801f2c896bd09f1$var$renderHairpin(ctx, params) {
    const begin_x = params.begin_x;
    const end_x = params.end_x;
    const y4 = params.y;
    const half_height = params.height / 2;
    ctx.beginPath();
    if (params.reverse) {
        ctx.moveTo(begin_x, y4 - half_height);
        ctx.lineTo(end_x, y4);
        ctx.lineTo(begin_x, y4 + half_height);
    } else {
        ctx.moveTo(end_x, y4 - half_height);
        ctx.lineTo(begin_x, y4);
        ctx.lineTo(end_x, y4 + half_height);
    }
    ctx.stroke();
    ctx.closePath();
}
var $a801f2c896bd09f1$var$Crescendo = class extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "Crescendo";
    }
    constructor(noteStruct){
        super(noteStruct);
        this.options = {
            extend_left: 0,
            extend_right: 0,
            y_shift: 0
        };
        this.decrescendo = false;
        this.line = noteStruct.line || 0;
        this.height = 15;
    }
    setLine(line2) {
        this.line = line2;
        return this;
    }
    setHeight(height9) {
        this.height = height9;
        return this;
    }
    setDecrescendo(decresc) {
        this.decrescendo = decresc;
        return this;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const stave = this.checkStave();
        this.setRendered();
        const tick_context = this.getTickContext();
        const next_context = $a801f2c896bd09f1$var$TickContext.getNextContext(tick_context);
        const begin_x = this.getAbsoluteX();
        const end_x = next_context ? next_context.getX() : stave.getX() + stave.getWidth();
        const y4 = stave.getYForLine(this.line + -3) + 1;
        $a801f2c896bd09f1$var$L9("Drawing ", this.decrescendo ? "decrescendo " : "crescendo ", this.height, "x", begin_x - end_x);
        $a801f2c896bd09f1$var$renderHairpin(ctx, {
            begin_x: begin_x - this.options.extend_left,
            end_x: end_x + this.options.extend_right,
            y: y4 + this.options.y_shift,
            height: this.height,
            reverse: this.decrescendo
        });
    }
};
$a801f2c896bd09f1$var$Crescendo.DEBUG = false;
// node_modules/vexflow/build/esm/src/curve.js
var $a801f2c896bd09f1$var$CurvePosition;
(function(CurvePosition2) {
    CurvePosition2[CurvePosition2["NEAR_HEAD"] = 1] = "NEAR_HEAD";
    CurvePosition2[CurvePosition2["NEAR_TOP"] = 2] = "NEAR_TOP";
})($a801f2c896bd09f1$var$CurvePosition || ($a801f2c896bd09f1$var$CurvePosition = {}));
var $a801f2c896bd09f1$var$Curve = class _Curve extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "Curve";
    }
    static get Position() {
        return $a801f2c896bd09f1$var$CurvePosition;
    }
    static get PositionString() {
        return {
            nearHead: $a801f2c896bd09f1$var$CurvePosition.NEAR_HEAD,
            nearTop: $a801f2c896bd09f1$var$CurvePosition.NEAR_TOP
        };
    }
    constructor(from3, to2, options2){
        super();
        this.render_options = Object.assign({
            thickness: 2,
            x_shift: 0,
            y_shift: 10,
            position: $a801f2c896bd09f1$var$CurvePosition.NEAR_HEAD,
            position_end: $a801f2c896bd09f1$var$CurvePosition.NEAR_HEAD,
            invert: false,
            cps: [
                {
                    x: 0,
                    y: 10
                },
                {
                    x: 0,
                    y: 10
                }
            ]
        }, options2);
        this.from = from3;
        this.to = to2;
    }
    setNotes(from3, to2) {
        if (!from3 && !to2) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Curve needs to have either `from` or `to` set.");
        this.from = from3;
        this.to = to2;
        return this;
    }
    isPartial() {
        return !this.from || !this.to;
    }
    renderCurve(params) {
        const ctx = this.checkContext();
        const x_shift = this.render_options.x_shift;
        const y_shift = this.render_options.y_shift * params.direction;
        const first_x = params.first_x + x_shift;
        const first_y = params.first_y + y_shift;
        const last_x = params.last_x - x_shift;
        const last_y = params.last_y + y_shift;
        const thickness = this.render_options.thickness;
        const cps = this.render_options.cps;
        const { x: cp0x, y: cp0y } = cps[0];
        const { x: cp1x, y: cp1y } = cps[1];
        const cp_spacing = (last_x - first_x) / (cps.length + 2);
        ctx.beginPath();
        ctx.moveTo(first_x, first_y);
        ctx.bezierCurveTo(first_x + cp_spacing + cp0x, first_y + cp0y * params.direction, last_x - cp_spacing + cp1x, last_y + cp1y * params.direction, last_x, last_y);
        ctx.bezierCurveTo(last_x - cp_spacing + cp1x, last_y + (cp1y + thickness) * params.direction, first_x + cp_spacing + cp0x, first_y + (cp0y + thickness) * params.direction, first_x, first_y);
        ctx.stroke();
        ctx.closePath();
        ctx.fill();
    }
    draw() {
        this.checkContext();
        this.setRendered();
        const first_note = this.from;
        const last_note = this.to;
        let first_x;
        let last_x;
        let first_y;
        let last_y;
        let stem_direction = 0;
        let metric = "baseY";
        let end_metric = "baseY";
        function getPosition(position3) {
            return typeof position3 === "string" ? _Curve.PositionString[position3] : position3;
        }
        const position2 = getPosition(this.render_options.position);
        const position_end = getPosition(this.render_options.position_end);
        if (position2 === $a801f2c896bd09f1$var$CurvePosition.NEAR_TOP) {
            metric = "topY";
            end_metric = "topY";
        }
        if (position_end === $a801f2c896bd09f1$var$CurvePosition.NEAR_HEAD) end_metric = "baseY";
        else if (position_end === $a801f2c896bd09f1$var$CurvePosition.NEAR_TOP) end_metric = "topY";
        if (first_note) {
            first_x = first_note.getTieRightX();
            stem_direction = first_note.getStemDirection();
            first_y = first_note.getStemExtents()[metric];
        } else {
            const stave = last_note.checkStave();
            first_x = stave.getTieStartX();
            first_y = last_note.getStemExtents()[metric];
        }
        if (last_note) {
            last_x = last_note.getTieLeftX();
            stem_direction = last_note.getStemDirection();
            last_y = last_note.getStemExtents()[end_metric];
        } else {
            const stave = first_note.checkStave();
            last_x = stave.getTieEndX();
            last_y = first_note.getStemExtents()[end_metric];
        }
        this.renderCurve({
            first_x: first_x,
            last_x: last_x,
            first_y: first_y,
            last_y: last_y,
            direction: stem_direction * (this.render_options.invert === true ? -1 : 1)
        });
        return true;
    }
};
// node_modules/vexflow/build/esm/src/dot.js
var $a801f2c896bd09f1$var$Dot = class _Dot extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Dot";
    }
    static getDots(note2) {
        return note2.getModifiersByType(_Dot.CATEGORY);
    }
    static buildAndAttach(notes, options2) {
        for (const note2 of notes){
            if (options2 === null || options2 === void 0 ? void 0 : options2.all) for(let i2 = 0; i2 < note2.keys.length; i2++){
                const dot = new _Dot();
                dot.setDotShiftY(note2.glyphProps.dot_shiftY);
                note2.addModifier(dot, i2);
            }
            else if ((options2 === null || options2 === void 0 ? void 0 : options2.index) != void 0) {
                const dot = new _Dot();
                dot.setDotShiftY(note2.glyphProps.dot_shiftY);
                note2.addModifier(dot, options2 === null || options2 === void 0 ? void 0 : options2.index);
            } else {
                const dot = new _Dot();
                dot.setDotShiftY(note2.glyphProps.dot_shiftY);
                note2.addModifier(dot, 0);
            }
        }
    }
    static format(dots, state3) {
        const right_shift = state3.right_shift;
        const dot_spacing = 1;
        if (!dots || dots.length === 0) return false;
        const dot_list = [];
        const max_shift_map = {};
        for(let i2 = 0; i2 < dots.length; ++i2){
            const dot = dots[i2];
            const note2 = dot.getNote();
            let props;
            let shift;
            if ($a801f2c896bd09f1$var$isStaveNote(note2)) {
                const index5 = dot.checkIndex();
                props = note2.getKeyProps()[index5];
                shift = note2.getFirstDotPx();
            } else if ($a801f2c896bd09f1$var$isTabNote(note2)) {
                props = {
                    line: 0.5
                };
                shift = right_shift;
            } else throw new $a801f2c896bd09f1$var$RuntimeError("Internal", "Unexpected instance.");
            const note_id = note2.getAttribute("id");
            dot_list.push({
                line: props.line,
                note: note2,
                note_id: note_id,
                dot: dot
            });
            max_shift_map[note_id] = Math.max(max_shift_map[note_id] || shift, shift);
        }
        dot_list.sort((a3, b3)=>b3.line - a3.line);
        let dot_shift = right_shift;
        let x_width = 0;
        let last_line = null;
        let last_note = null;
        let prev_dotted_space = null;
        let half_shiftY = 0;
        for(let i2 = 0; i2 < dot_list.length; ++i2){
            const { dot: dot, note: note2, note_id: note_id, line: line2 } = dot_list[i2];
            if (line2 !== last_line || note2 !== last_note) dot_shift = max_shift_map[note_id];
            if (!note2.isRest() && line2 !== last_line) {
                if (Math.abs(line2 % 1) === 0.5) half_shiftY = 0;
                else {
                    half_shiftY = 0.5;
                    if (last_note != null && !last_note.isRest() && last_line != null && last_line - line2 === 0.5) half_shiftY = -0.5;
                    else if (line2 + half_shiftY === prev_dotted_space) half_shiftY = -0.5;
                }
            }
            if (note2.isRest()) dot.dot_shiftY += -half_shiftY;
            else dot.dot_shiftY = -half_shiftY;
            prev_dotted_space = line2 + half_shiftY;
            dot.setXShift(dot_shift);
            dot_shift += dot.getWidth() + dot_spacing;
            x_width = dot_shift > x_width ? dot_shift : x_width;
            last_line = line2;
            last_note = note2;
        }
        state3.right_shift += x_width;
        return true;
    }
    constructor(){
        super();
        this.position = $a801f2c896bd09f1$var$Modifier.Position.RIGHT;
        this.radius = 2;
        this.setWidth(5);
        this.dot_shiftY = 0;
    }
    setNote(note2) {
        this.note = note2;
        if ($a801f2c896bd09f1$var$isGraceNote(note2)) {
            this.radius *= 0.5;
            this.setWidth(3);
        }
        return this;
    }
    setDotShiftY(y4) {
        this.dot_shiftY = y4;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const stave = note2.checkStave();
        const lineSpace = stave.getSpacingBetweenLines();
        const start2 = note2.getModifierStartXY(this.position, this.index, {
            forceFlagRight: true
        });
        if ($a801f2c896bd09f1$var$isTabNote(note2)) start2.y = note2.getStemExtents().baseY;
        const x4 = start2.x + this.x_shift + this.width - this.radius;
        const y4 = start2.y + this.y_shift + this.dot_shiftY * lineSpace;
        ctx.beginPath();
        ctx.arc(x4, y4, this.radius, 0, Math.PI * 2, false);
        ctx.fill();
    }
};
// node_modules/vexflow/build/esm/src/frethandfinger.js
var $a801f2c896bd09f1$var$FretHandFinger = class extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "FretHandFinger";
    }
    static format(nums, state3) {
        const { left_shift: left_shift, right_shift: right_shift } = state3;
        const num_spacing = 1;
        if (!nums || nums.length === 0) return false;
        const nums_list = [];
        let prev_note = null;
        let shiftLeft = 0;
        let shiftRight = 0;
        for(let i2 = 0; i2 < nums.length; ++i2){
            const num = nums[i2];
            const note2 = num.getNote();
            const pos = num.getPosition();
            const index5 = num.checkIndex();
            const props = note2.getKeyProps()[index5];
            const textFormatter = $a801f2c896bd09f1$var$TextFormatter.create(num.textFont);
            const textHeight = textFormatter.maxHeight;
            if (num.position === $a801f2c896bd09f1$var$ModifierPosition.ABOVE) state3.top_text_line += textHeight / $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE + 0.5;
            if (num.position === $a801f2c896bd09f1$var$ModifierPosition.BELOW) state3.text_line += textHeight / $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE + 0.5;
            if (note2 !== prev_note) {
                for(let n = 0; n < note2.keys.length; ++n){
                    if (left_shift === 0) shiftLeft = Math.max(note2.getLeftDisplacedHeadPx(), shiftLeft);
                    if (right_shift === 0) shiftRight = Math.max(note2.getRightDisplacedHeadPx(), shiftRight);
                }
                prev_note = note2;
            }
            nums_list.push({
                note: note2,
                num: num,
                pos: pos,
                line: props.line,
                shiftL: shiftLeft,
                shiftR: shiftRight
            });
        }
        nums_list.sort((a3, b3)=>b3.line - a3.line);
        let numShiftL = 0;
        let numShiftR = 0;
        let xWidthL = 0;
        let xWidthR = 0;
        let lastLine = null;
        let lastNote = null;
        for(let i2 = 0; i2 < nums_list.length; ++i2){
            let num_shift = 0;
            const { note: note2, pos: pos, num: num, line: line2, shiftL: shiftL, shiftR: shiftR } = nums_list[i2];
            if (line2 !== lastLine || note2 !== lastNote) {
                numShiftL = left_shift + shiftL;
                numShiftR = right_shift + shiftR;
            }
            const numWidth = num.getWidth() + num_spacing;
            if (pos === $a801f2c896bd09f1$var$Modifier.Position.LEFT) {
                num.setXShift(left_shift + numShiftL);
                num_shift = left_shift + numWidth;
                xWidthL = num_shift > xWidthL ? num_shift : xWidthL;
            } else if (pos === $a801f2c896bd09f1$var$Modifier.Position.RIGHT) {
                num.setXShift(numShiftR);
                num_shift = shiftRight + numWidth;
                xWidthR = num_shift > xWidthR ? num_shift : xWidthR;
            }
            lastLine = line2;
            lastNote = note2;
        }
        state3.left_shift += xWidthL;
        state3.right_shift += xWidthR;
        return true;
    }
    static easyScoreHook({ fingerings: fingerings } = {}, note2, builder) {
        fingerings === null || fingerings === void 0 || fingerings.split(",").map((fingeringString)=>{
            const split3 = fingeringString.trim().split(".");
            const params = {
                number: split3[0]
            };
            if (split3[1]) params.position = split3[1];
            return builder.getFactory().Fingering(params);
        }).map((fingering, index5)=>note2.addModifier(fingering, index5));
    }
    constructor(finger){
        super();
        this.finger = finger;
        this.width = 7;
        this.position = $a801f2c896bd09f1$var$Modifier.Position.LEFT;
        this.x_shift = 0;
        this.y_shift = 0;
        this.x_offset = 0;
        this.y_offset = 0;
        this.resetFont();
    }
    setFretHandFinger(finger) {
        this.finger = finger;
        return this;
    }
    getFretHandFinger() {
        return this.finger;
    }
    setOffsetX(x4) {
        this.x_offset = x4;
        return this;
    }
    setOffsetY(y4) {
        this.y_offset = y4;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const start2 = note2.getModifierStartXY(this.position, this.index);
        let dot_x = start2.x + this.x_shift + this.x_offset;
        let dot_y = start2.y + this.y_shift + this.y_offset + 5;
        switch(this.position){
            case $a801f2c896bd09f1$var$Modifier.Position.ABOVE:
                dot_x -= 4;
                dot_y -= 12;
                break;
            case $a801f2c896bd09f1$var$Modifier.Position.BELOW:
                dot_x -= 2;
                dot_y += 10;
                break;
            case $a801f2c896bd09f1$var$Modifier.Position.LEFT:
                dot_x -= this.width;
                break;
            case $a801f2c896bd09f1$var$Modifier.Position.RIGHT:
                dot_x += 1;
                break;
            default:
                throw new $a801f2c896bd09f1$var$RuntimeError("InvalidPosition", `The position ${this.position} does not exist`);
        }
        ctx.save();
        ctx.setFont(this.textFont);
        ctx.fillText("" + this.finger, dot_x, dot_y);
        ctx.restore();
    }
};
$a801f2c896bd09f1$var$FretHandFinger.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SANS_SERIF,
    size: 9,
    weight: $a801f2c896bd09f1$var$FontWeight.BOLD,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
// node_modules/vexflow/build/esm/src/parser.js
function $a801f2c896bd09f1$var$L10(...args) {
    if ($a801f2c896bd09f1$var$Parser.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Parser", args);
}
var $a801f2c896bd09f1$var$NO_ERROR_POS = -1;
function $a801f2c896bd09f1$var$flattenMatches(r) {
    if ("matchedString" in r) return r.matchedString;
    if ("results" in r) return $a801f2c896bd09f1$var$flattenMatches(r.results);
    const results = r;
    if (results.length === 1) return $a801f2c896bd09f1$var$flattenMatches(results[0]);
    if (results.length === 0) return null;
    return results.map($a801f2c896bd09f1$var$flattenMatches);
}
var $a801f2c896bd09f1$var$Parser = class {
    constructor(grammar){
        this.grammar = grammar;
        this.line = "";
        this.pos = 0;
        this.errorPos = $a801f2c896bd09f1$var$NO_ERROR_POS;
    }
    parse(line2) {
        this.line = line2;
        this.pos = 0;
        this.errorPos = $a801f2c896bd09f1$var$NO_ERROR_POS;
        const result2 = this.expect(this.grammar.begin());
        result2.errorPos = this.errorPos;
        return result2;
    }
    matchFail(returnPos) {
        if (this.errorPos === $a801f2c896bd09f1$var$NO_ERROR_POS) this.errorPos = this.pos;
        this.pos = returnPos;
    }
    matchSuccess() {
        this.errorPos = $a801f2c896bd09f1$var$NO_ERROR_POS;
    }
    matchToken(token, noSpace = false) {
        const regexp = noSpace ? new RegExp("^((" + token + "))") : new RegExp("^((" + token + ")\\s*)");
        const workingLine = this.line.slice(this.pos);
        const result2 = workingLine.match(regexp);
        if (result2 !== null) return {
            success: true,
            matchedString: result2[2],
            incrementPos: result2[1].length,
            pos: this.pos
        };
        else return {
            success: false,
            pos: this.pos
        };
    }
    expectOne(rule, maybe2 = false) {
        const results = [];
        const pos = this.pos;
        let allMatches = true;
        let oneMatch = false;
        maybe2 = maybe2 === true || rule.maybe === true;
        if (rule.expect) for (const next of rule.expect){
            const localPos = this.pos;
            const result2 = this.expect(next);
            if (result2.success) {
                results.push(result2);
                oneMatch = true;
                if (rule.or) break;
            } else {
                allMatches = false;
                if (!rule.or) {
                    this.pos = localPos;
                    break;
                }
            }
        }
        const gotOne = rule.or && oneMatch || allMatches;
        const success = gotOne || maybe2 === true;
        const numMatches = gotOne ? 1 : 0;
        if (maybe2 && !gotOne) this.pos = pos;
        if (success) this.matchSuccess();
        else this.matchFail(pos);
        return {
            success: success,
            results: results,
            numMatches: numMatches
        };
    }
    expectOneOrMore(rule, maybe2 = false) {
        const results = [];
        const pos = this.pos;
        let numMatches = 0;
        let more = true;
        do {
            const result2 = this.expectOne(rule);
            if (result2.success && result2.results) {
                numMatches++;
                results.push(result2.results);
            } else more = false;
        }while (more);
        const success = numMatches > 0 || maybe2 === true;
        if (maybe2 && !(numMatches > 0)) this.pos = pos;
        if (success) this.matchSuccess();
        else this.matchFail(pos);
        return {
            success: success,
            results: results,
            numMatches: numMatches
        };
    }
    expectZeroOrMore(rule) {
        return this.expectOneOrMore(rule, true);
    }
    expect(ruleFunc) {
        $a801f2c896bd09f1$var$L10("Evaluating rule function:", ruleFunc);
        if (!ruleFunc) throw new $a801f2c896bd09f1$var$RuntimeError("Invalid rule function");
        let result2;
        const rule = ruleFunc.bind(this.grammar)();
        if (rule.token) {
            result2 = this.matchToken(rule.token, rule.noSpace === true);
            if (result2.success) this.pos += result2.incrementPos;
        } else if (rule.expect) {
            if (rule.oneOrMore) result2 = this.expectOneOrMore(rule);
            else if (rule.zeroOrMore) result2 = this.expectZeroOrMore(rule);
            else result2 = this.expectOne(rule);
        } else {
            $a801f2c896bd09f1$var$L10(rule);
            throw new $a801f2c896bd09f1$var$RuntimeError("Bad grammar! No `token` or `expect` property " + rule);
        }
        const matches2 = [];
        result2.matches = matches2;
        if (result2.results) result2.results.forEach((r)=>matches2.push($a801f2c896bd09f1$var$flattenMatches(r)));
        if (rule.run && result2.success) rule.run({
            matches: matches2
        });
        return result2;
    }
};
$a801f2c896bd09f1$var$Parser.DEBUG = false;
// node_modules/vexflow/build/esm/src/easyscore.js
function $a801f2c896bd09f1$var$L11(...args) {
    if ($a801f2c896bd09f1$var$EasyScore.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.EasyScore", args);
}
var $a801f2c896bd09f1$var$EasyScoreGrammar = class {
    constructor(builder){
        this.builder = builder;
    }
    begin() {
        return this.LINE;
    }
    LINE() {
        return {
            expect: [
                this.PIECE,
                this.PIECES,
                this.EOL
            ]
        };
    }
    PIECE() {
        return {
            expect: [
                this.CHORDORNOTE,
                this.PARAMS
            ],
            run: ()=>this.builder.commitPiece()
        };
    }
    PIECES() {
        return {
            expect: [
                this.COMMA,
                this.PIECE
            ],
            zeroOrMore: true
        };
    }
    PARAMS() {
        return {
            expect: [
                this.DURATION,
                this.TYPE,
                this.DOTS,
                this.OPTS
            ]
        };
    }
    CHORDORNOTE() {
        return {
            expect: [
                this.CHORD,
                this.SINGLENOTE
            ],
            or: true
        };
    }
    CHORD() {
        return {
            expect: [
                this.LPAREN,
                this.NOTES,
                this.RPAREN
            ],
            run: (state3)=>this.builder.addChord(state3.matches[1])
        };
    }
    NOTES() {
        return {
            expect: [
                this.NOTE
            ],
            oneOrMore: true
        };
    }
    NOTE() {
        return {
            expect: [
                this.NOTENAME,
                this.ACCIDENTAL,
                this.OCTAVE
            ]
        };
    }
    SINGLENOTE() {
        return {
            expect: [
                this.NOTENAME,
                this.ACCIDENTAL,
                this.OCTAVE
            ],
            run: (state3)=>{
                const s2 = state3;
                this.builder.addSingleNote(s2.matches[0], s2.matches[1], s2.matches[2]);
            }
        };
    }
    ACCIDENTAL() {
        return {
            expect: [
                this.MICROTONES,
                this.ACCIDENTALS
            ],
            maybe: true,
            or: true
        };
    }
    DOTS() {
        return {
            expect: [
                this.DOT
            ],
            zeroOrMore: true,
            run: (state3)=>this.builder.setNoteDots(state3.matches)
        };
    }
    TYPE() {
        return {
            expect: [
                this.SLASH,
                this.MAYBESLASH,
                this.TYPES
            ],
            maybe: true,
            run: (state3)=>this.builder.setNoteType(state3.matches[2])
        };
    }
    DURATION() {
        return {
            expect: [
                this.SLASH,
                this.DURATIONS
            ],
            maybe: true,
            run: (state3)=>this.builder.setNoteDuration(state3.matches[1])
        };
    }
    OPTS() {
        return {
            expect: [
                this.LBRACKET,
                this.KEYVAL,
                this.KEYVALS,
                this.RBRACKET
            ],
            maybe: true
        };
    }
    KEYVALS() {
        return {
            expect: [
                this.COMMA,
                this.KEYVAL
            ],
            zeroOrMore: true
        };
    }
    KEYVAL() {
        const unquote = (str)=>str.slice(1, -1);
        return {
            expect: [
                this.KEY,
                this.EQUALS,
                this.VAL
            ],
            run: (state3)=>this.builder.addNoteOption(state3.matches[0], unquote(state3.matches[2]))
        };
    }
    VAL() {
        return {
            expect: [
                this.SVAL,
                this.DVAL
            ],
            or: true
        };
    }
    KEY() {
        return {
            token: "[a-zA-Z][a-zA-Z0-9]*"
        };
    }
    DVAL() {
        return {
            token: '["][^"]*["]'
        };
    }
    SVAL() {
        return {
            token: "['][^']*[']"
        };
    }
    NOTENAME() {
        return {
            token: "[a-gA-G]"
        };
    }
    OCTAVE() {
        return {
            token: "[0-9]+"
        };
    }
    ACCIDENTALS() {
        return {
            token: "bb|b|##|#|n"
        };
    }
    MICROTONES() {
        return {
            token: "bbs|bss|bs|db|d|\\+\\+-|\\+-|\\+\\+|\\+|k|o"
        };
    }
    DURATIONS() {
        return {
            token: "[0-9whq]+"
        };
    }
    TYPES() {
        return {
            token: "[rRsSmMhHgG]"
        };
    }
    LPAREN() {
        return {
            token: "[(]"
        };
    }
    RPAREN() {
        return {
            token: "[)]"
        };
    }
    COMMA() {
        return {
            token: "[,]"
        };
    }
    DOT() {
        return {
            token: "[.]"
        };
    }
    SLASH() {
        return {
            token: "[/]"
        };
    }
    MAYBESLASH() {
        return {
            token: "[/]?"
        };
    }
    EQUALS() {
        return {
            token: "[=]"
        };
    }
    LBRACKET() {
        return {
            token: "\\["
        };
    }
    RBRACKET() {
        return {
            token: "\\]"
        };
    }
    EOL() {
        return {
            token: "$"
        };
    }
};
var $a801f2c896bd09f1$var$Piece = class {
    constructor(duration2){
        this.chord = [];
        this.dots = 0;
        this.options = {};
        this.duration = duration2;
    }
};
var $a801f2c896bd09f1$var$Builder = class {
    constructor(factory){
        this.commitHooks = [];
        this.factory = factory;
        this.reset();
    }
    reset(options2) {
        this.options = Object.assign({
            stem: "auto",
            clef: "treble"
        }, options2);
        this.elements = {
            notes: [],
            accidentals: []
        };
        this.rollingDuration = "8";
        this.resetPiece();
    }
    getFactory() {
        return this.factory;
    }
    getElements() {
        return this.elements;
    }
    addCommitHook(commitHook) {
        this.commitHooks.push(commitHook);
    }
    resetPiece() {
        $a801f2c896bd09f1$var$L11("resetPiece");
        this.piece = new $a801f2c896bd09f1$var$Piece(this.rollingDuration);
    }
    setNoteDots(dots) {
        $a801f2c896bd09f1$var$L11("setNoteDots:", dots);
        if (dots) this.piece.dots = dots.length;
    }
    setNoteDuration(duration2) {
        $a801f2c896bd09f1$var$L11("setNoteDuration:", duration2);
        this.rollingDuration = this.piece.duration = duration2 || this.rollingDuration;
    }
    setNoteType(type) {
        $a801f2c896bd09f1$var$L11("setNoteType:", type);
        if (type) this.piece.type = type;
    }
    addNoteOption(key2, value17) {
        $a801f2c896bd09f1$var$L11("addNoteOption: key:", key2, "value:", value17);
        this.piece.options[key2] = value17;
    }
    addNote(key2, accid, octave) {
        $a801f2c896bd09f1$var$L11("addNote:", key2, accid, octave);
        this.piece.chord.push({
            key: key2,
            accid: accid,
            octave: octave
        });
    }
    addSingleNote(key2, accid, octave) {
        $a801f2c896bd09f1$var$L11("addSingleNote:", key2, accid, octave);
        this.addNote(key2, accid, octave);
    }
    addChord(notes) {
        $a801f2c896bd09f1$var$L11("startChord");
        if (typeof notes[0] !== "object") this.addSingleNote(notes[0]);
        else notes.forEach((n)=>{
            if (n) this.addNote(...n);
        });
        $a801f2c896bd09f1$var$L11("endChord");
    }
    commitPiece() {
        $a801f2c896bd09f1$var$L11("commitPiece");
        const { factory: factory } = this;
        if (!factory) return;
        const options2 = Object.assign(Object.assign({}, this.options), this.piece.options);
        const stem = $a801f2c896bd09f1$var$defined(options2.stem, "BadArguments", "options.stem is not defined").toLowerCase();
        const clef = $a801f2c896bd09f1$var$defined(options2.clef, "BadArguments", "options.clef is not defined").toLowerCase();
        const { chord: chord, duration: duration2, dots: dots, type: type } = this.piece;
        const standardAccidentals = $a801f2c896bd09f1$var$Music.accidentals;
        const keys3 = chord.map((notePiece)=>{
            var _a;
            return notePiece.key + (standardAccidentals.includes((_a = notePiece.accid) !== null && _a !== void 0 ? _a : "") ? notePiece.accid : "") + "/" + notePiece.octave;
        });
        const auto_stem = stem === "auto";
        const note2 = (type === null || type === void 0 ? void 0 : type.toLowerCase()) == "g" ? factory.GhostNote({
            duration: duration2,
            dots: dots
        }) : factory.StaveNote({
            keys: keys3,
            duration: duration2,
            dots: dots,
            type: type,
            clef: clef,
            auto_stem: auto_stem
        });
        if (!auto_stem) note2.setStemDirection(stem === "up" ? $a801f2c896bd09f1$var$Stem.UP : $a801f2c896bd09f1$var$Stem.DOWN);
        const accidentals2 = [];
        chord.forEach((notePiece, index5)=>{
            const accid = notePiece.accid;
            if (typeof accid === "string") {
                const accidental = factory.Accidental({
                    type: accid
                });
                note2.addModifier(accidental, index5);
                accidentals2.push(accidental);
            } else accidentals2.push(void 0);
        });
        for(let i2 = 0; i2 < dots; i2++)$a801f2c896bd09f1$var$Dot.buildAndAttach([
            note2
        ], {
            all: true
        });
        this.commitHooks.forEach((commitHook)=>commitHook(options2, note2, this));
        this.elements.notes.push(note2);
        this.elements.accidentals.push(accidentals2);
        this.resetPiece();
    }
};
function $a801f2c896bd09f1$var$setId2(options2, note2) {
    if (options2.id === void 0) return;
    note2.setAttribute("id", options2.id);
}
var $a801f2c896bd09f1$var$commaSeparatedRegex = /\s*,\s*/;
function $a801f2c896bd09f1$var$setClass(options2, note2) {
    if (options2.class === void 0) return;
    options2.class.split($a801f2c896bd09f1$var$commaSeparatedRegex).forEach((className2)=>note2.addClass(className2));
}
var $a801f2c896bd09f1$var$EasyScore = class {
    constructor(options2 = {}){
        this.defaults = {
            clef: "treble",
            time: "4/4",
            stem: "auto"
        };
        this.setOptions(options2);
    }
    set(defaults) {
        this.defaults = Object.assign(Object.assign({}, this.defaults), defaults);
        return this;
    }
    setOptions(options2) {
        var _a, _b;
        const factory = options2.factory;
        const builder = (_a = options2.builder) !== null && _a !== void 0 ? _a : new $a801f2c896bd09f1$var$Builder(factory);
        this.options = Object.assign(Object.assign({
            commitHooks: [
                $a801f2c896bd09f1$var$setId2,
                $a801f2c896bd09f1$var$setClass,
                $a801f2c896bd09f1$var$Articulation.easyScoreHook,
                $a801f2c896bd09f1$var$FretHandFinger.easyScoreHook
            ],
            throwOnError: false
        }, options2), {
            factory: factory,
            builder: builder
        });
        this.factory = factory;
        this.builder = builder;
        this.grammar = new $a801f2c896bd09f1$var$EasyScoreGrammar(this.builder);
        this.parser = new $a801f2c896bd09f1$var$Parser(this.grammar);
        (_b = this.options.commitHooks) === null || _b === void 0 || _b.forEach((commitHook)=>this.addCommitHook(commitHook));
        return this;
    }
    setContext(context) {
        this.factory.setContext(context);
        return this;
    }
    parse(line2, options2 = {}) {
        this.builder.reset(options2);
        const result2 = this.parser.parse(line2);
        if (!result2.success && this.options.throwOnError) {
            $a801f2c896bd09f1$var$L11(result2);
            throw new $a801f2c896bd09f1$var$RuntimeError("Error parsing line: " + line2);
        }
        return result2;
    }
    beam(notes, options2) {
        this.factory.Beam({
            notes: notes,
            options: options2
        });
        return notes;
    }
    tuplet(notes, options2) {
        this.factory.Tuplet({
            notes: notes,
            options: options2
        });
        return notes;
    }
    notes(line2, options2 = {}) {
        options2 = Object.assign({
            clef: this.defaults.clef,
            stem: this.defaults.stem
        }, options2);
        this.parse(line2, options2);
        return this.builder.getElements().notes;
    }
    voice(notes, options2 = {}) {
        options2 = Object.assign({
            time: this.defaults.time
        }, options2);
        return this.factory.Voice(options2).addTickables(notes);
    }
    addCommitHook(commitHook) {
        this.builder.addCommitHook(commitHook);
    }
};
$a801f2c896bd09f1$var$EasyScore.DEBUG = false;
// node_modules/vexflow/build/esm/src/notehead.js
function $a801f2c896bd09f1$var$L12(...args) {
    if ($a801f2c896bd09f1$var$NoteHead.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.NoteHead", args);
}
function $a801f2c896bd09f1$var$drawSlashNoteHead(ctx, duration2, x4, y4, stem_direction, staveSpace) {
    const width9 = $a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH;
    ctx.save();
    ctx.setLineWidth($a801f2c896bd09f1$var$Tables.STEM_WIDTH);
    let fill2 = false;
    if ($a801f2c896bd09f1$var$Tables.durationToNumber(duration2) > 2) fill2 = true;
    if (!fill2) x4 -= $a801f2c896bd09f1$var$Tables.STEM_WIDTH / 2 * stem_direction;
    ctx.beginPath();
    ctx.moveTo(x4, y4 + staveSpace);
    ctx.lineTo(x4, y4 + 1);
    ctx.lineTo(x4 + width9, y4 - staveSpace);
    ctx.lineTo(x4 + width9, y4);
    ctx.lineTo(x4, y4 + staveSpace);
    ctx.closePath();
    if (fill2) ctx.fill();
    else ctx.stroke();
    if ($a801f2c896bd09f1$var$Tables.durationToFraction(duration2).equals(0.5)) {
        const breve_lines = [
            -3,
            -1,
            width9 + 1,
            width9 + 3
        ];
        for(let i2 = 0; i2 < breve_lines.length; i2++){
            ctx.beginPath();
            ctx.moveTo(x4 + breve_lines[i2], y4 - 10);
            ctx.lineTo(x4 + breve_lines[i2], y4 + 11);
            ctx.stroke();
        }
    }
    ctx.restore();
}
var $a801f2c896bd09f1$var$NoteHead = class extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "NoteHead";
    }
    constructor(noteStruct){
        super(noteStruct);
        this.custom_glyph = false;
        this.stem_up_x_offset = 0;
        this.stem_down_x_offset = 0;
        this.index = noteStruct.index;
        this.x = noteStruct.x || 0;
        this.y = noteStruct.y || 0;
        if (noteStruct.note_type) this.noteType = noteStruct.note_type;
        this.displaced = noteStruct.displaced || false;
        this.stem_direction = noteStruct.stem_direction || $a801f2c896bd09f1$var$Stem.UP;
        this.line = noteStruct.line || 0;
        this.glyphProps = $a801f2c896bd09f1$var$Tables.getGlyphProps(this.duration, this.noteType);
        $a801f2c896bd09f1$var$defined(this.glyphProps, "BadArguments", `No glyph found for duration '${this.duration}' and type '${this.noteType}'`);
        if ((this.line > 5 || this.line < 0) && this.glyphProps.ledger_code_head) this.glyphProps.code_head = this.glyphProps.ledger_code_head;
        this.glyph_code = this.glyphProps.code_head;
        this.x_shift = noteStruct.x_shift || 0;
        if (noteStruct.custom_glyph_code) {
            this.custom_glyph = true;
            this.glyph_code = noteStruct.custom_glyph_code;
            this.stem_up_x_offset = noteStruct.stem_up_x_offset || 0;
            this.stem_down_x_offset = noteStruct.stem_down_x_offset || 0;
        }
        this.setStyle(noteStruct.style);
        this.slashed = noteStruct.slashed || false;
        this.render_options = Object.assign(Object.assign({}, this.render_options), {
            glyph_font_scale: noteStruct.glyph_font_scale || $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE
        });
        this.setWidth(this.custom_glyph && !this.glyph_code.startsWith("noteheadSlashed") && !this.glyph_code.startsWith("noteheadCircled") ? $a801f2c896bd09f1$var$Glyph.getWidth(this.glyph_code, this.render_options.glyph_font_scale) : this.glyphProps.getWidth(this.render_options.glyph_font_scale));
    }
    getWidth() {
        return this.width;
    }
    isDisplaced() {
        return this.displaced === true;
    }
    setX(x4) {
        this.x = x4;
        return this;
    }
    getY() {
        return this.y;
    }
    setY(y4) {
        this.y = y4;
        return this;
    }
    getLine() {
        return this.line;
    }
    setLine(line2) {
        this.line = line2;
        return this;
    }
    getAbsoluteX() {
        const x4 = !this.preFormatted ? this.x : super.getAbsoluteX();
        const displacementStemAdjustment = $a801f2c896bd09f1$var$Stem.WIDTH / 2;
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        const fontShift = musicFont.lookupMetric("notehead.shiftX", 0) * this.stem_direction;
        const displacedFontShift = musicFont.lookupMetric("noteHead.displacedShiftX", 0) * this.stem_direction;
        return x4 + fontShift + (this.displaced ? (this.width - displacementStemAdjustment) * this.stem_direction + displacedFontShift : 0);
    }
    getBoundingBox() {
        const spacing = this.checkStave().getSpacingBetweenLines();
        const half_spacing = spacing / 2;
        const min_y = this.y - half_spacing;
        return new $a801f2c896bd09f1$var$BoundingBox(this.getAbsoluteX(), min_y, this.width, spacing);
    }
    setStave(stave) {
        const line2 = this.getLine();
        this.stave = stave;
        if (this.stave) {
            this.setY(this.stave.getYForNote(line2));
            this.setContext(this.stave.getContext());
        }
        return this;
    }
    preFormat() {
        if (this.preFormatted) return this;
        const width9 = this.getWidth() + this.leftDisplacedHeadPx + this.rightDisplacedHeadPx;
        this.setWidth(width9);
        this.preFormatted = true;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        let head_x = this.getAbsoluteX();
        if (this.custom_glyph) head_x += this.stem_direction === $a801f2c896bd09f1$var$Stem.UP ? this.stem_up_x_offset + (this.glyphProps.stem ? this.glyphProps.getWidth(this.render_options.glyph_font_scale) - this.width : 0) : this.stem_down_x_offset;
        const y4 = this.y;
        $a801f2c896bd09f1$var$L12("Drawing note head '", this.noteType, this.duration, "' at", head_x, y4);
        const stem_direction = this.stem_direction;
        const glyph_font_scale = this.render_options.glyph_font_scale;
        const categorySuffix = `${this.glyph_code}Stem${stem_direction === $a801f2c896bd09f1$var$Stem.UP ? "Up" : "Down"}`;
        if (this.noteType === "s") {
            const staveSpace = this.checkStave().getSpacingBetweenLines();
            $a801f2c896bd09f1$var$drawSlashNoteHead(ctx, this.duration, head_x, y4, stem_direction, staveSpace);
        } else $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, head_x, y4, glyph_font_scale, this.glyph_code, {
            category: `noteHead.${categorySuffix}`
        });
    }
};
$a801f2c896bd09f1$var$NoteHead.DEBUG = false;
// node_modules/vexflow/build/esm/src/stemmablenote.js
var $a801f2c896bd09f1$var$StemmableNote = class extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "StemmableNote";
    }
    constructor(noteStruct){
        super(noteStruct);
    }
    getStem() {
        return this.stem;
    }
    checkStem() {
        if (!this.stem) throw new $a801f2c896bd09f1$var$RuntimeError("NoStem", "No stem attached to instance");
        return this.stem;
    }
    setStem(stem) {
        this.stem = stem;
        this.addChildElement(stem);
        return this;
    }
    buildStem() {
        const stem = new $a801f2c896bd09f1$var$Stem();
        this.setStem(stem);
        return this;
    }
    buildFlag(category = "flag") {
        const { glyphProps: glyphProps } = this;
        if (this.hasFlag()) {
            const flagCode = this.getStemDirection() === $a801f2c896bd09f1$var$Stem.DOWN ? glyphProps.code_flag_downstem : glyphProps.code_flag_upstem;
            if (flagCode) this.flag = new $a801f2c896bd09f1$var$Glyph(flagCode, this.render_options.glyph_font_scale, {
                category: category
            });
        }
    }
    getBaseCustomNoteHeadGlyphProps() {
        if (this.getStemDirection() === $a801f2c896bd09f1$var$Stem.DOWN) return this.customGlyphs[this.customGlyphs.length - 1];
        else return this.customGlyphs[0];
    }
    getStemLength() {
        return $a801f2c896bd09f1$var$Stem.HEIGHT + this.getStemExtension();
    }
    getBeamCount() {
        const glyphProps = this.getGlyphProps();
        if (glyphProps) return glyphProps.beam_count;
        else return 0;
    }
    getStemMinimumLength() {
        const frac = $a801f2c896bd09f1$var$Tables.durationToFraction(this.duration);
        let length12 = frac.value() <= 1 ? 0 : 20;
        switch(this.duration){
            case "8":
                if (this.beam == void 0) length12 = 35;
                break;
            case "16":
                length12 = this.beam == void 0 ? 35 : 25;
                break;
            case "32":
                length12 = this.beam == void 0 ? 45 : 35;
                break;
            case "64":
                length12 = this.beam == void 0 ? 50 : 40;
                break;
            case "128":
                length12 = this.beam == void 0 ? 55 : 45;
                break;
            default:
                break;
        }
        return length12;
    }
    getStemDirection() {
        if (!this.stem_direction) throw new $a801f2c896bd09f1$var$RuntimeError("NoStem", "No stem attached to this note.");
        return this.stem_direction;
    }
    setStemDirection(direction3) {
        if (!direction3) direction3 = $a801f2c896bd09f1$var$Stem.UP;
        if (direction3 !== $a801f2c896bd09f1$var$Stem.UP && direction3 !== $a801f2c896bd09f1$var$Stem.DOWN) throw new $a801f2c896bd09f1$var$RuntimeError("BadArgument", `Invalid stem direction: ${direction3}`);
        this.stem_direction = direction3;
        this.reset();
        if (this.hasFlag()) this.buildFlag();
        this.beam = void 0;
        if (this.stem) {
            this.stem.setDirection(direction3);
            this.stem.setExtension(this.getStemExtension());
            const glyphProps = this.getBaseCustomNoteHeadGlyphProps() || this.getGlyphProps();
            const offsets = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric(`stem.noteHead.${glyphProps.code_head}`, {
                offsetYBaseStemUp: 0,
                offsetYTopStemUp: 0,
                offsetYBaseStemDown: 0,
                offsetYTopStemDown: 0
            });
            this.stem.setOptions({
                stem_up_y_offset: offsets.offsetYTopStemUp,
                stem_down_y_offset: offsets.offsetYTopStemDown,
                stem_up_y_base_offset: offsets.offsetYBaseStemUp,
                stem_down_y_base_offset: offsets.offsetYBaseStemDown
            });
        }
        if (this.preFormatted) this.preFormat();
        return this;
    }
    getStemX() {
        const x_begin = this.getAbsoluteX() + this.x_shift;
        const x_end = this.getAbsoluteX() + this.x_shift + this.getGlyphWidth();
        const stem_x = this.stem_direction === $a801f2c896bd09f1$var$Stem.DOWN ? x_begin : x_end;
        return stem_x;
    }
    getCenterGlyphX() {
        return this.getAbsoluteX() + this.x_shift + this.getGlyphWidth() / 2;
    }
    getStemExtension() {
        const glyphProps = this.getGlyphProps();
        if (this.stem_extension_override != void 0) return this.stem_extension_override;
        if (this.beam) return glyphProps.stem_beam_extension;
        if (glyphProps) return this.getStemDirection() === $a801f2c896bd09f1$var$Stem.UP ? glyphProps.stem_up_extension : glyphProps.stem_down_extension;
        return 0;
    }
    setStemLength(height9) {
        this.stem_extension_override = height9 - $a801f2c896bd09f1$var$Stem.HEIGHT;
        return this;
    }
    getStemExtents() {
        if (!this.stem) throw new $a801f2c896bd09f1$var$RuntimeError("NoStem", "No stem attached to this note.");
        return this.stem.getExtents();
    }
    getYForTopText(textLine) {
        const stave = this.checkStave();
        if (this.hasStem()) {
            const extents = this.getStemExtents();
            if (!extents) throw new $a801f2c896bd09f1$var$RuntimeError("InvalidState", "Stem does not have extents.");
            return Math.min(stave.getYForTopText(textLine), extents.topY - this.render_options.annotation_spacing * (textLine + 1));
        } else return stave.getYForTopText(textLine);
    }
    getYForBottomText(textLine) {
        const stave = this.checkStave();
        if (this.hasStem()) {
            const extents = this.getStemExtents();
            if (!extents) throw new $a801f2c896bd09f1$var$RuntimeError("InvalidState", "Stem does not have extents.");
            return Math.max(stave.getYForTopText(textLine), extents.baseY + this.render_options.annotation_spacing * textLine);
        } else return stave.getYForBottomText(textLine);
    }
    hasFlag() {
        return $a801f2c896bd09f1$var$Tables.getGlyphProps(this.duration).flag == true && !this.beam;
    }
    postFormat() {
        var _a;
        (_a = this.beam) === null || _a === void 0 || _a.postFormat();
        this.postFormatted = true;
        return this;
    }
    drawStem(stemOptions) {
        var _a;
        this.checkContext();
        this.setRendered();
        this.setStem(new $a801f2c896bd09f1$var$Stem(stemOptions));
        (_a = this.stem) === null || _a === void 0 || _a.setContext(this.getContext()).draw();
    }
};
// node_modules/vexflow/build/esm/src/stavenote.js
function $a801f2c896bd09f1$var$showDeprecationWarningForNoteHeads() {
    console.warn("StaveNote.note_heads is deprecated. Use StaveNote.noteHeads instead.", "This accessor will be removed in VexFlow 5.0.");
}
function $a801f2c896bd09f1$var$L13(...args) {
    if ($a801f2c896bd09f1$var$StaveNote.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.StaveNote", args);
}
var $a801f2c896bd09f1$var$isInnerNoteIndex = (note2, index5)=>index5 === (note2.getStemDirection() === $a801f2c896bd09f1$var$Stem.UP ? note2.keyProps.length - 1 : 0);
function $a801f2c896bd09f1$var$shiftRestVertical(rest, note2, dir2) {
    const delta = dir2;
    rest.line += delta;
    rest.maxLine += delta;
    rest.minLine += delta;
    rest.note.setKeyLine(0, rest.note.getKeyLine(0) + delta);
}
function $a801f2c896bd09f1$var$centerRest(rest, noteU, noteL) {
    const delta = rest.line - $a801f2c896bd09f1$var$midLine(noteU.minLine, noteL.maxLine);
    rest.note.setKeyLine(0, rest.note.getKeyLine(0) - delta);
    rest.line -= delta;
    rest.maxLine -= delta;
    rest.minLine -= delta;
}
var $a801f2c896bd09f1$var$StaveNote = class _StaveNote extends $a801f2c896bd09f1$var$StemmableNote {
    static get CATEGORY() {
        return "StaveNote";
    }
    static get STEM_UP() {
        return $a801f2c896bd09f1$var$Stem.UP;
    }
    static get STEM_DOWN() {
        return $a801f2c896bd09f1$var$Stem.DOWN;
    }
    static get LEDGER_LINE_OFFSET() {
        return 3;
    }
    static get minNoteheadPadding() {
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        return musicFont.lookupMetric("noteHead.minPadding");
    }
    static format(notes, state3) {
        var _a, _b;
        if (!notes || notes.length < 2) return false;
        const notesList = [];
        for(let i2 = 0; i2 < notes.length; i2++){
            const props = notes[i2].sortedKeyProps;
            const line2 = props[0].keyProps.line;
            let minL = props[props.length - 1].keyProps.line;
            const stemDirection = notes[i2].getStemDirection();
            const stemMax = notes[i2].getStemLength() / 10;
            const stemMin = notes[i2].getStemMinimumLength() / 10;
            let maxL;
            if (notes[i2].isRest()) {
                maxL = line2 + notes[i2].glyphProps.line_above;
                minL = line2 - notes[i2].glyphProps.line_below;
            } else {
                maxL = stemDirection === 1 ? props[props.length - 1].keyProps.line + stemMax : props[props.length - 1].keyProps.line;
                minL = stemDirection === 1 ? props[0].keyProps.line : props[0].keyProps.line - stemMax;
            }
            notesList.push({
                line: props[0].keyProps.line,
                maxLine: maxL,
                minLine: minL,
                isrest: notes[i2].isRest(),
                stemDirection: stemDirection,
                stemMax: stemMax,
                stemMin: stemMin,
                voice_shift: notes[i2].getVoiceShiftWidth(),
                is_displaced: notes[i2].isDisplaced(),
                note: notes[i2]
            });
        }
        let voices = 0;
        let noteU = void 0;
        let noteM = void 0;
        let noteL = void 0;
        const draw = [
            false,
            false,
            false
        ];
        for(let i2 = 0; i2 < notesList.length; i2++)draw[i2] = notesList[i2].note.render_options.draw == false ? false : true;
        if (draw[0] && draw[1] && draw[2]) {
            voices = 3;
            noteU = notesList[0];
            noteM = notesList[1];
            noteL = notesList[2];
        } else if (draw[0] && draw[1]) {
            voices = 2;
            noteU = notesList[0];
            noteL = notesList[1];
        } else if (draw[0] && draw[2]) {
            voices = 2;
            noteU = notesList[0];
            noteL = notesList[2];
        } else if (draw[1] && draw[2]) {
            voices = 2;
            noteU = notesList[1];
            noteL = notesList[2];
        } else return true;
        if (voices === 2 && noteU.stemDirection === -1 && noteL.stemDirection === 1) {
            noteU = notesList[1];
            noteL = notesList[0];
        }
        const voiceXShift = Math.max(noteU.voice_shift, noteL.voice_shift);
        let xShift = 0;
        if (voices === 2) {
            const lineSpacing = noteU.note.hasStem() && noteL.note.hasStem() && noteU.stemDirection === noteL.stemDirection ? 0 : 0.5;
            if (noteL.isrest && noteU.isrest && noteU.note.duration === noteL.note.duration) noteL.note.render_options.draw = false;
            else if (noteU.minLine <= noteL.maxLine + lineSpacing) {
                if (noteU.isrest) $a801f2c896bd09f1$var$shiftRestVertical(noteU, noteL, 1);
                else if (noteL.isrest) $a801f2c896bd09f1$var$shiftRestVertical(noteL, noteU, -1);
                else {
                    const lineDiff = Math.abs(noteU.line - noteL.line);
                    if (noteU.note.hasStem() && noteL.note.hasStem()) {
                        const noteUHead = $a801f2c896bd09f1$var$Tables.codeNoteHead((_a = noteU.note.sortedKeyProps[0].keyProps.code) !== null && _a !== void 0 ? _a : "N", noteU.note.duration);
                        const noteLHead = $a801f2c896bd09f1$var$Tables.codeNoteHead((_b = noteL.note.sortedKeyProps[noteL.note.sortedKeyProps.length - 1].keyProps.code) !== null && _b !== void 0 ? _b : "N", noteL.note.duration);
                        if (!$a801f2c896bd09f1$var$Tables.UNISON || noteUHead !== noteLHead || noteU.note.getModifiers().filter((item2)=>item2.getCategory() === "Dot" && item2.getIndex() === 0).length !== noteL.note.getModifiers().filter((item2)=>item2.getCategory() === "Dot" && item2.getIndex() === 0).length || lineDiff < 1 && lineDiff > 0 || JSON.stringify(noteU.note.getStyle()) !== JSON.stringify(noteL.note.getStyle())) {
                            xShift = voiceXShift + 2;
                            if (noteU.stemDirection === noteL.stemDirection) noteU.note.setXShift(xShift);
                            else noteL.note.setXShift(xShift);
                        } else if (noteU.note.voice !== noteL.note.voice) {
                            if (noteU.stemDirection === noteL.stemDirection) {
                                if (noteU.line != noteL.line) {
                                    xShift = voiceXShift + 2;
                                    noteU.note.setXShift(xShift);
                                } else if (noteL.stemDirection === 1) {
                                    noteL.stemDirection = -1;
                                    noteL.note.setStemDirection(-1);
                                }
                            }
                        }
                    } else if (lineDiff < 1) {
                        xShift = voiceXShift + 2;
                        if (noteU.note.duration < noteL.note.duration) noteU.note.setXShift(xShift);
                        else noteL.note.setXShift(xShift);
                    } else if (noteU.note.hasStem()) {
                        noteU.stemDirection = -noteU.note.getStemDirection();
                        noteU.note.setStemDirection(noteU.stemDirection);
                    } else if (noteL.note.hasStem()) {
                        noteL.stemDirection = -noteL.note.getStemDirection();
                        noteL.note.setStemDirection(noteL.stemDirection);
                    }
                }
            }
            state3.right_shift += xShift;
            return true;
        }
        if (!noteM) throw new $a801f2c896bd09f1$var$RuntimeError("InvalidState", "noteM not defined.");
        if (noteM.isrest && !noteU.isrest && !noteL.isrest) {
            if (noteU.minLine <= noteM.maxLine || noteM.minLine <= noteL.maxLine) {
                const restHeight = noteM.maxLine - noteM.minLine;
                const space = noteU.minLine - noteL.maxLine;
                if (restHeight < space) $a801f2c896bd09f1$var$centerRest(noteM, noteU, noteL);
                else {
                    xShift = voiceXShift + 2;
                    noteM.note.setXShift(xShift);
                    if (noteL.note.hasBeam() === false) {
                        noteL.stemDirection = -1;
                        noteL.note.setStemDirection(-1);
                    }
                    if (noteU.minLine <= noteL.maxLine && noteU.note.hasBeam() === false) {
                        noteU.stemDirection = 1;
                        noteU.note.setStemDirection(1);
                    }
                }
                state3.right_shift += xShift;
                return true;
            }
        }
        if (noteU.isrest && noteM.isrest && noteL.isrest) {
            noteU.note.render_options.draw = false;
            noteL.note.render_options.draw = false;
            state3.right_shift += xShift;
            return true;
        }
        if (noteM.isrest && noteU.isrest && noteM.minLine <= noteL.maxLine) noteM.note.render_options.draw = false;
        if (noteM.isrest && noteL.isrest && noteU.minLine <= noteM.maxLine) noteM.note.render_options.draw = false;
        if (noteU.isrest && noteU.minLine <= noteM.maxLine) $a801f2c896bd09f1$var$shiftRestVertical(noteU, noteM, 1);
        if (noteL.isrest && noteM.minLine <= noteL.maxLine) $a801f2c896bd09f1$var$shiftRestVertical(noteL, noteM, -1);
        if (noteU.minLine <= noteM.maxLine + 0.5 || noteM.minLine <= noteL.maxLine) {
            xShift = voiceXShift + 2;
            noteM.note.setXShift(xShift);
            if (noteL.note.hasBeam() === false) {
                noteL.stemDirection = -1;
                noteL.note.setStemDirection(-1);
            }
            if (noteU.minLine <= noteL.maxLine && noteU.note.hasBeam() === false) {
                noteU.stemDirection = 1;
                noteU.note.setStemDirection(1);
            }
        }
        state3.right_shift += xShift;
        return true;
    }
    static postFormat(notes) {
        if (!notes) return false;
        notes.forEach((note2)=>note2.postFormat());
        return true;
    }
    constructor(noteStruct){
        var _a, _b, _c;
        super(noteStruct);
        this.minLine = 0;
        this.maxLine = 0;
        this.sortedKeyProps = [];
        this.ledgerLineStyle = {};
        this.clef = (_a = noteStruct.clef) !== null && _a !== void 0 ? _a : "treble";
        this.octave_shift = (_b = noteStruct.octave_shift) !== null && _b !== void 0 ? _b : 0;
        this.glyphProps = $a801f2c896bd09f1$var$Tables.getGlyphProps(this.duration, this.noteType);
        $a801f2c896bd09f1$var$defined(this.glyphProps, "BadArguments", `No glyph found for duration '${this.duration}' and type '${this.noteType}'`);
        this.displaced = false;
        this.dot_shiftY = 0;
        this.use_default_head_x = false;
        this._noteHeads = [];
        this.modifiers = [];
        this.render_options = Object.assign(Object.assign({}, this.render_options), {
            glyph_font_scale: noteStruct.glyph_font_scale || $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE,
            stroke_px: noteStruct.stroke_px || _StaveNote.LEDGER_LINE_OFFSET
        });
        this.calculateKeyProps();
        this.buildStem();
        if (noteStruct.auto_stem) this.autoStem();
        else this.setStemDirection((_c = noteStruct.stem_direction) !== null && _c !== void 0 ? _c : $a801f2c896bd09f1$var$Stem.UP);
        this.reset();
        this.buildFlag();
    }
    reset() {
        super.reset();
        const noteHeadStyles = this._noteHeads.map((noteHead)=>noteHead.getStyle());
        this.buildNoteHeads();
        this._noteHeads.forEach((noteHead, index5)=>{
            const noteHeadStyle = noteHeadStyles[index5];
            if (noteHeadStyle) noteHead.setStyle(noteHeadStyle);
        });
        const stave = this.stave;
        if (stave) this.setStave(stave);
        this.calcNoteDisplacements();
        return this;
    }
    setBeam(beam) {
        this.beam = beam;
        this.calcNoteDisplacements();
        if (this.stem) this.stem.setExtension(this.getStemExtension());
        return this;
    }
    buildStem() {
        this.setStem(new $a801f2c896bd09f1$var$Stem({
            hide: !!this.isRest()
        }));
        return this;
    }
    buildNoteHeads() {
        this._noteHeads = [];
        const stemDirection = this.getStemDirection();
        const keys3 = this.getKeys();
        let lastLine = void 0;
        let lineDiff = void 0;
        let displaced = false;
        let start2;
        let end;
        let step4;
        if (stemDirection === $a801f2c896bd09f1$var$Stem.UP) {
            start2 = 0;
            end = keys3.length;
            step4 = 1;
        } else {
            start2 = keys3.length - 1;
            end = -1;
            step4 = -1;
        }
        for(let i2 = start2; i2 !== end; i2 += step4){
            const noteProps = this.sortedKeyProps[i2].keyProps;
            const line2 = noteProps.line;
            if (lastLine === void 0) lastLine = line2;
            else {
                lineDiff = Math.abs(lastLine - line2);
                if (lineDiff === 0 || lineDiff === 0.5) displaced = !displaced;
                else {
                    displaced = false;
                    this.use_default_head_x = true;
                }
            }
            lastLine = line2;
            const notehead = new $a801f2c896bd09f1$var$NoteHead({
                duration: this.duration,
                note_type: this.noteType,
                displaced: displaced,
                stem_direction: stemDirection,
                custom_glyph_code: noteProps.code,
                glyph_font_scale: this.render_options.glyph_font_scale,
                x_shift: noteProps.shift_right,
                stem_up_x_offset: noteProps.stem_up_x_offset,
                stem_down_x_offset: noteProps.stem_down_x_offset,
                line: noteProps.line
            });
            this.addChildElement(notehead);
            this._noteHeads[this.sortedKeyProps[i2].index] = notehead;
        }
        return this._noteHeads;
    }
    autoStem() {
        this.setStemDirection(this.calculateOptimalStemDirection());
    }
    calculateOptimalStemDirection() {
        this.minLine = this.sortedKeyProps[0].keyProps.line;
        this.maxLine = this.sortedKeyProps[this.keyProps.length - 1].keyProps.line;
        const MIDDLE_LINE = 3;
        const decider = (this.minLine + this.maxLine) / 2;
        const stemDirection = decider < MIDDLE_LINE ? $a801f2c896bd09f1$var$Stem.UP : $a801f2c896bd09f1$var$Stem.DOWN;
        return stemDirection;
    }
    calculateKeyProps() {
        let lastLine;
        for(let i2 = 0; i2 < this.keys.length; ++i2){
            const key2 = this.keys[i2];
            if (this.glyphProps.rest) this.glyphProps.position = key2;
            const options2 = {
                octave_shift: this.octave_shift || 0,
                duration: this.duration
            };
            const props = $a801f2c896bd09f1$var$Tables.keyProperties(key2, this.clef, options2);
            if (!props) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid key for note properties: ${key2}`);
            if (props.key === "R") {
                if (this.duration === "1" || this.duration === "w") props.line = 4;
                else props.line = 3;
            }
            const line2 = props.line;
            if (lastLine == void 0) lastLine = line2;
            else if (Math.abs(lastLine - line2) === 0.5) {
                this.displaced = true;
                props.displaced = true;
                if (this.keyProps.length > 0) this.keyProps[i2 - 1].displaced = true;
            }
            lastLine = line2;
            this.keyProps.push(props);
        }
        this.keyProps.forEach((keyProps, index5)=>{
            this.sortedKeyProps.push({
                keyProps: keyProps,
                index: index5
            });
        });
        this.sortedKeyProps.sort((a3, b3)=>a3.keyProps.line - b3.keyProps.line);
    }
    getBoundingBox() {
        var _a, _b;
        if (!this.preFormatted) throw new $a801f2c896bd09f1$var$RuntimeError("UnformattedNote", "Can't call getBoundingBox on an unformatted note.");
        const { width: w2, modLeftPx: modLeftPx, leftDisplacedHeadPx: leftDisplacedHeadPx } = this.getMetrics();
        const x4 = this.getAbsoluteX() - modLeftPx - leftDisplacedHeadPx;
        let minY = 0;
        let maxY = 0;
        const halfLineSpacing = ((_b = (_a = this.getStave()) === null || _a === void 0 ? void 0 : _a.getSpacingBetweenLines()) !== null && _b !== void 0 ? _b : 0) / 2;
        const lineSpacing = halfLineSpacing * 2;
        if (this.isRest()) {
            const y4 = this.ys[0];
            const frac = $a801f2c896bd09f1$var$Tables.durationToFraction(this.duration);
            if (frac.equals(1) || frac.equals(2)) {
                minY = y4 - halfLineSpacing;
                maxY = y4 + halfLineSpacing;
            } else {
                minY = y4 - this.glyphProps.line_above * lineSpacing;
                maxY = y4 + this.glyphProps.line_below * lineSpacing;
            }
        } else if (this.glyphProps.stem) {
            const ys = this.getStemExtents();
            ys.baseY += halfLineSpacing * this.getStemDirection();
            minY = Math.min(ys.topY, ys.baseY);
            maxY = Math.max(ys.topY, ys.baseY);
        } else {
            minY = 0;
            maxY = 0;
            for(let i2 = 0; i2 < this.ys.length; ++i2){
                const yy = this.ys[i2];
                if (i2 === 0) {
                    minY = yy;
                    maxY = yy;
                } else {
                    minY = Math.min(yy, minY);
                    maxY = Math.max(yy, maxY);
                }
            }
            minY -= halfLineSpacing;
            maxY += halfLineSpacing;
        }
        return new $a801f2c896bd09f1$var$BoundingBox(x4, minY, w2, maxY - minY);
    }
    getLineNumber(isTopNote) {
        if (!this.keyProps.length) throw new $a801f2c896bd09f1$var$RuntimeError("NoKeyProps", "Can't get bottom note line, because note is not initialized properly.");
        let resultLine = this.keyProps[0].line;
        for(let i2 = 0; i2 < this.keyProps.length; i2++){
            const thisLine = this.keyProps[i2].line;
            if (isTopNote) {
                if (thisLine > resultLine) resultLine = thisLine;
            } else if (thisLine < resultLine) resultLine = thisLine;
        }
        return resultLine;
    }
    isRest() {
        return this.glyphProps.rest;
    }
    isChord() {
        return !this.isRest() && this.keys.length > 1;
    }
    hasStem() {
        return this.glyphProps.stem;
    }
    hasFlag() {
        return super.hasFlag() && !this.isRest();
    }
    getStemX() {
        if (this.noteType === "r") return this.getCenterGlyphX();
        else return super.getStemX() + (this.stem_direction ? $a801f2c896bd09f1$var$Stem.WIDTH / (2 * -this.stem_direction) : 0);
    }
    getYForTopText(textLine) {
        const extents = this.getStemExtents();
        return Math.min(this.checkStave().getYForTopText(textLine), extents.topY - this.render_options.annotation_spacing * (textLine + 1));
    }
    getYForBottomText(textLine) {
        const extents = this.getStemExtents();
        return Math.max(this.checkStave().getYForTopText(textLine), extents.baseY + this.render_options.annotation_spacing * textLine);
    }
    setStave(stave) {
        super.setStave(stave);
        const ys = this._noteHeads.map((notehead)=>{
            notehead.setStave(stave);
            return notehead.getY();
        });
        this.setYs(ys);
        if (this.stem) {
            const { y_top: y_top, y_bottom: y_bottom } = this.getNoteHeadBounds();
            this.stem.setYBounds(y_top, y_bottom);
        }
        return this;
    }
    isDisplaced() {
        return this.displaced;
    }
    setNoteDisplaced(displaced) {
        this.displaced = displaced;
        return this;
    }
    getTieRightX() {
        let tieStartX = this.getAbsoluteX();
        tieStartX += this.getGlyphWidth() + this.x_shift + this.rightDisplacedHeadPx;
        if (this.modifierContext) tieStartX += this.modifierContext.getRightShift();
        return tieStartX;
    }
    getTieLeftX() {
        let tieEndX = this.getAbsoluteX();
        tieEndX += this.x_shift - this.leftDisplacedHeadPx;
        return tieEndX;
    }
    getLineForRest() {
        let restLine = this.keyProps[0].line;
        if (this.keyProps.length > 1) {
            const lastLine = this.keyProps[this.keyProps.length - 1].line;
            const top2 = Math.max(restLine, lastLine);
            const bot = Math.min(restLine, lastLine);
            restLine = $a801f2c896bd09f1$var$midLine(top2, bot);
        }
        return restLine;
    }
    getModifierStartXY(position2, index5, options2 = {}) {
        var _a, _b;
        if (!this.preFormatted) throw new $a801f2c896bd09f1$var$RuntimeError("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
        if (this.ys.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("NoYValues", "No Y-Values calculated for this note.");
        const { ABOVE: ABOVE2, BELOW: BELOW2, LEFT: LEFT, RIGHT: RIGHT } = $a801f2c896bd09f1$var$Modifier.Position;
        let x4 = 0;
        if (position2 === LEFT) x4 = -2;
        else if (position2 === RIGHT) {
            x4 = this.getGlyphWidth() + this.x_shift + 2;
            if (this.stem_direction === $a801f2c896bd09f1$var$Stem.UP && this.hasFlag() && (options2.forceFlagRight || $a801f2c896bd09f1$var$isInnerNoteIndex(this, index5))) x4 += (_b = (_a = this === null || this === void 0 ? void 0 : this.flag) === null || _a === void 0 ? void 0 : _a.getMetrics().width) !== null && _b !== void 0 ? _b : 0;
        } else if (position2 === BELOW2 || position2 === ABOVE2) x4 = this.getGlyphWidth() / 2;
        return {
            x: this.getAbsoluteX() + x4,
            y: this.ys[index5]
        };
    }
    setStyle(style3) {
        return super.setGroupStyle(style3);
    }
    setStemStyle(style3) {
        const stem = this.getStem();
        if (stem) stem.setStyle(style3);
        return this;
    }
    getStemStyle() {
        var _a;
        return (_a = this.stem) === null || _a === void 0 ? void 0 : _a.getStyle();
    }
    setLedgerLineStyle(style3) {
        this.ledgerLineStyle = style3;
    }
    getLedgerLineStyle() {
        return this.ledgerLineStyle;
    }
    setFlagStyle(style3) {
        var _a;
        (_a = this.flag) === null || _a === void 0 || _a.setStyle(style3);
    }
    getFlagStyle() {
        var _a;
        return (_a = this.flag) === null || _a === void 0 ? void 0 : _a.getStyle();
    }
    setKeyStyle(index5, style3) {
        this._noteHeads[index5].setStyle(style3);
        return this;
    }
    setKeyLine(index5, line2) {
        this.keyProps[index5].line = line2;
        this.reset();
        return this;
    }
    getKeyLine(index5) {
        return this.keyProps[index5].line;
    }
    getVoiceShiftWidth() {
        return this.getGlyphWidth() * (this.displaced ? 2 : 1);
    }
    calcNoteDisplacements() {
        this.setLeftDisplacedHeadPx(this.displaced && this.stem_direction === $a801f2c896bd09f1$var$Stem.DOWN ? this.getGlyphWidth() : 0);
        this.setRightDisplacedHeadPx(!this.hasFlag() && this.displaced && this.stem_direction === $a801f2c896bd09f1$var$Stem.UP ? this.getGlyphWidth() : 0);
    }
    preFormat() {
        if (this.preFormatted) return;
        let noteHeadPadding = 0;
        if (this.modifierContext) {
            this.modifierContext.preFormat();
            if (this.modifierContext.getWidth() === 0) noteHeadPadding = _StaveNote.minNoteheadPadding;
        }
        let width9 = this.getGlyphWidth() + this.leftDisplacedHeadPx + this.rightDisplacedHeadPx + noteHeadPadding;
        if (this.shouldDrawFlag() && this.stem_direction === $a801f2c896bd09f1$var$Stem.UP) width9 += this.getGlyphWidth();
        this.setWidth(width9);
        this.preFormatted = true;
    }
    getNoteHeadBounds() {
        let yTop = Infinity;
        let yBottom = -Infinity;
        let nonDisplacedX;
        let displacedX;
        let highestLine = this.checkStave().getNumLines();
        let lowestLine = 1;
        let highestDisplacedLine;
        let lowestDisplacedLine;
        let highestNonDisplacedLine = highestLine;
        let lowestNonDisplacedLine = lowestLine;
        this._noteHeads.forEach((notehead)=>{
            const line2 = notehead.getLine();
            const y4 = notehead.getY();
            yTop = Math.min(y4, yTop);
            yBottom = Math.max(y4, yBottom);
            if (displacedX === void 0 && notehead.isDisplaced()) displacedX = notehead.getAbsoluteX();
            if (nonDisplacedX === void 0 && !notehead.isDisplaced()) nonDisplacedX = notehead.getAbsoluteX();
            highestLine = Math.max(line2, highestLine);
            lowestLine = Math.min(line2, lowestLine);
            if (notehead.isDisplaced()) {
                highestDisplacedLine = highestDisplacedLine === void 0 ? line2 : Math.max(line2, highestDisplacedLine);
                lowestDisplacedLine = lowestDisplacedLine === void 0 ? line2 : Math.min(line2, lowestDisplacedLine);
            } else {
                highestNonDisplacedLine = Math.max(line2, highestNonDisplacedLine);
                lowestNonDisplacedLine = Math.min(line2, lowestNonDisplacedLine);
            }
        }, this);
        return {
            y_top: yTop,
            y_bottom: yBottom,
            displaced_x: displacedX,
            non_displaced_x: nonDisplacedX,
            highest_line: highestLine,
            lowest_line: lowestLine,
            highest_displaced_line: highestDisplacedLine,
            lowest_displaced_line: lowestDisplacedLine,
            highest_non_displaced_line: highestNonDisplacedLine,
            lowest_non_displaced_line: lowestNonDisplacedLine
        };
    }
    getNoteHeadBeginX() {
        return this.getAbsoluteX() + this.x_shift;
    }
    getNoteHeadEndX() {
        const xBegin = this.getNoteHeadBeginX();
        return xBegin + this.getGlyphWidth();
    }
    get noteHeads() {
        return this._noteHeads.slice();
    }
    get note_heads() {
        $a801f2c896bd09f1$var$showDeprecationWarningForNoteHeads();
        return this.noteHeads;
    }
    drawLedgerLines() {
        const stave = this.checkStave();
        const { glyphProps: glyphProps, render_options: { stroke_px: stroke_px } } = this;
        const ctx = this.checkContext();
        const width9 = glyphProps.getWidth() + stroke_px * 2;
        const doubleWidth = 2 * (glyphProps.getWidth() + stroke_px) - $a801f2c896bd09f1$var$Stem.WIDTH / 2;
        if (this.isRest()) return;
        if (!ctx) throw new $a801f2c896bd09f1$var$RuntimeError("NoCanvasContext", "Can't draw without a canvas context.");
        const { highest_line: highest_line, lowest_line: lowest_line, highest_displaced_line: highest_displaced_line, highest_non_displaced_line: highest_non_displaced_line, lowest_displaced_line: lowest_displaced_line, lowest_non_displaced_line: lowest_non_displaced_line, displaced_x: displaced_x, non_displaced_x: non_displaced_x } = this.getNoteHeadBounds();
        if (highest_line < 6 && lowest_line > 0) return;
        const min_x = Math.min(displaced_x !== null && displaced_x !== void 0 ? displaced_x : 0, non_displaced_x !== null && non_displaced_x !== void 0 ? non_displaced_x : 0);
        const drawLedgerLine = (y4, normal, displaced)=>{
            let x4;
            if (displaced && normal) x4 = min_x - stroke_px;
            else if (normal) x4 = (non_displaced_x !== null && non_displaced_x !== void 0 ? non_displaced_x : 0) - stroke_px;
            else x4 = (displaced_x !== null && displaced_x !== void 0 ? displaced_x : 0) - stroke_px;
            const ledgerWidth = normal && displaced ? doubleWidth : width9;
            ctx.beginPath();
            ctx.moveTo(x4, y4);
            ctx.lineTo(x4 + ledgerWidth, y4);
            ctx.stroke();
        };
        const style3 = Object.assign(Object.assign({}, stave.getDefaultLedgerLineStyle()), this.getLedgerLineStyle());
        this.applyStyle(ctx, style3);
        for(let line2 = 6; line2 <= highest_line; ++line2){
            const normal = non_displaced_x !== void 0 && line2 <= highest_non_displaced_line;
            const displaced = highest_displaced_line !== void 0 && line2 <= highest_displaced_line;
            drawLedgerLine(stave.getYForNote(line2), normal, displaced);
        }
        for(let line2 = 0; line2 >= lowest_line; --line2){
            const normal = non_displaced_x !== void 0 && line2 >= lowest_non_displaced_line;
            const displaced = lowest_displaced_line !== void 0 && line2 >= lowest_displaced_line;
            drawLedgerLine(stave.getYForNote(line2), normal, displaced);
        }
        this.restoreStyle(ctx, style3);
    }
    drawModifiers(noteheadParam) {
        const ctx = this.checkContext();
        for(let i2 = 0; i2 < this.modifiers.length; i2++){
            const modifier = this.modifiers[i2];
            const index5 = modifier.checkIndex();
            const notehead = this._noteHeads[index5];
            if (notehead == noteheadParam) {
                const noteheadStyle = notehead.getStyle();
                notehead.applyStyle(ctx, noteheadStyle);
                modifier.setContext(ctx);
                modifier.drawWithStyle();
                notehead.restoreStyle(ctx, noteheadStyle);
            }
        }
    }
    shouldDrawFlag() {
        const hasStem = this.stem !== void 0;
        const hasFlag = this.glyphProps.flag == true;
        const hasNoBeam = this.beam === void 0;
        return hasStem && hasFlag && hasNoBeam;
    }
    drawFlag() {
        var _a, _b, _c, _d, _e;
        const ctx = this.checkContext();
        if (!ctx) throw new $a801f2c896bd09f1$var$RuntimeError("NoCanvasContext", "Can't draw without a canvas context.");
        if (this.shouldDrawFlag()) {
            const { y_top: y_top, y_bottom: y_bottom } = this.getNoteHeadBounds();
            const noteStemHeight = this.stem.getHeight();
            const flagX = this.getStemX();
            const flagY = this.getStemDirection() === $a801f2c896bd09f1$var$Stem.DOWN ? y_top - noteStemHeight + 2 - (this.glyphProps ? this.glyphProps.stem_down_extension : 0) * this.getStaveNoteScale() - ((_b = (_a = this.flag) === null || _a === void 0 ? void 0 : _a.getMetrics().y_shift) !== null && _b !== void 0 ? _b : 0) * (1 - this.getStaveNoteScale()) : y_bottom - noteStemHeight - 2 + (this.glyphProps ? this.glyphProps.stem_up_extension : 0) * this.getStaveNoteScale() - ((_d = (_c = this.flag) === null || _c === void 0 ? void 0 : _c.getMetrics().y_shift) !== null && _d !== void 0 ? _d : 0) * (1 - this.getStaveNoteScale());
            (_e = this.flag) === null || _e === void 0 || _e.render(ctx, flagX, flagY);
        }
    }
    drawNoteHeads() {
        const ctx = this.checkContext();
        this._noteHeads.forEach((notehead)=>{
            notehead.applyStyle(ctx);
            ctx.openGroup("notehead", notehead.getAttribute("id"), {
                pointerBBox: true
            });
            notehead.setContext(ctx).draw();
            this.drawModifiers(notehead);
            ctx.closeGroup();
            notehead.restoreStyle(ctx);
        });
    }
    drawStem(stemOptions) {
        const ctx = this.checkContext();
        if (stemOptions) this.setStem(new $a801f2c896bd09f1$var$Stem(stemOptions));
        if (this.shouldDrawFlag() && this.stem) this.stem.adjustHeightForFlag();
        if (this.stem) this.stem.setContext(ctx).draw();
    }
    getStaveNoteScale() {
        return 1;
    }
    getStemExtension() {
        const super_stem_extension = super.getStemExtension();
        if (!this.glyphProps.stem) return super_stem_extension;
        const stem_direction = this.getStemDirection();
        if (stem_direction !== this.calculateOptimalStemDirection()) return super_stem_extension;
        let mid_line_distance;
        const MIDDLE_LINE = 3;
        if (stem_direction === $a801f2c896bd09f1$var$Stem.UP) mid_line_distance = MIDDLE_LINE - this.maxLine;
        else mid_line_distance = this.minLine - MIDDLE_LINE;
        const lines_over_octave_from_mid_line = mid_line_distance - 3.5;
        if (lines_over_octave_from_mid_line <= 0) return super_stem_extension;
        const stave = this.getStave();
        let spacing_between_lines = 10;
        if (stave != void 0) spacing_between_lines = stave.getSpacingBetweenLines();
        return super_stem_extension + lines_over_octave_from_mid_line * spacing_between_lines;
    }
    draw() {
        if (this.render_options.draw === false) return;
        if (this.ys.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("NoYValues", "Can't draw note without Y values.");
        const ctx = this.checkContext();
        const xBegin = this.getNoteHeadBeginX();
        const shouldRenderStem = this.hasStem() && !this.beam;
        this._noteHeads.forEach((notehead)=>notehead.setX(xBegin));
        if (this.stem) {
            const stemX = this.getStemX();
            this.stem.setNoteHeadXBounds(stemX, stemX);
        }
        $a801f2c896bd09f1$var$L13("Rendering ", this.isChord() ? "chord :" : "note :", this.keys);
        this.applyStyle();
        ctx.openGroup("stavenote", this.getAttribute("id"));
        this.drawLedgerLines();
        if (shouldRenderStem) this.drawStem();
        this.drawNoteHeads();
        this.drawFlag();
        ctx.closeGroup();
        this.restoreStyle();
        this.setRendered();
    }
};
$a801f2c896bd09f1$var$StaveNote.DEBUG = false;
// node_modules/vexflow/build/esm/src/stavetie.js
var $a801f2c896bd09f1$var$StaveTie = class extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "StaveTie";
    }
    constructor(notes, text7){
        super();
        this.setNotes(notes);
        this.text = text7;
        this.render_options = {
            cp1: 8,
            cp2: 12,
            text_shift_x: 0,
            first_x_shift: 0,
            last_x_shift: 0,
            y_shift: 7,
            tie_spacing: 0
        };
        this.resetFont();
    }
    setDirection(direction3) {
        this.direction = direction3;
        return this;
    }
    setNotes(notes) {
        if (!notes.first_note && !notes.last_note) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Tie needs to have either first_note or last_note set.");
        if (!notes.first_indices) notes.first_indices = [
            0
        ];
        if (!notes.last_indices) notes.last_indices = [
            0
        ];
        if (notes.first_indices.length !== notes.last_indices.length) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Tied notes must have same number of indices.");
        this.notes = notes;
        return this;
    }
    isPartial() {
        return !this.notes.first_note || !this.notes.last_note;
    }
    renderTie(params) {
        if (params.first_ys.length === 0 || params.last_ys.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "No Y-values to render");
        const ctx = this.checkContext();
        let cp1 = this.render_options.cp1;
        let cp2 = this.render_options.cp2;
        if (Math.abs(params.last_x_px - params.first_x_px) < 10) {
            cp1 = 2;
            cp2 = 8;
        }
        const first_x_shift = this.render_options.first_x_shift;
        const last_x_shift = this.render_options.last_x_shift;
        const y_shift = this.render_options.y_shift * params.direction;
        const first_indices = this.notes.first_indices;
        const last_indices = this.notes.last_indices;
        this.applyStyle();
        ctx.openGroup("stavetie", this.getAttribute("id"));
        for(let i2 = 0; i2 < first_indices.length; ++i2){
            const cp_x = (params.last_x_px + last_x_shift + (params.first_x_px + first_x_shift)) / 2;
            const first_y_px = params.first_ys[first_indices[i2]] + y_shift;
            const last_y_px = params.last_ys[last_indices[i2]] + y_shift;
            if (isNaN(first_y_px) || isNaN(last_y_px)) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Bad indices for tie rendering.");
            const top_cp_y = (first_y_px + last_y_px) / 2 + cp1 * params.direction;
            const bottom_cp_y = (first_y_px + last_y_px) / 2 + cp2 * params.direction;
            ctx.beginPath();
            ctx.moveTo(params.first_x_px + first_x_shift, first_y_px);
            ctx.quadraticCurveTo(cp_x, top_cp_y, params.last_x_px + last_x_shift, last_y_px);
            ctx.quadraticCurveTo(cp_x, bottom_cp_y, params.first_x_px + first_x_shift, first_y_px);
            ctx.closePath();
            ctx.fill();
        }
        ctx.closeGroup();
        this.restoreStyle();
    }
    renderText(first_x_px, last_x_px) {
        var _a, _b, _c;
        if (!this.text) return;
        const ctx = this.checkContext();
        let center_x = (first_x_px + last_x_px) / 2;
        center_x -= ctx.measureText(this.text).width / 2;
        const stave = (_b = (_a = this.notes.first_note) === null || _a === void 0 ? void 0 : _a.checkStave()) !== null && _b !== void 0 ? _b : (_c = this.notes.last_note) === null || _c === void 0 ? void 0 : _c.checkStave();
        if (stave) {
            ctx.save();
            ctx.setFont(this.textFont);
            ctx.fillText(this.text, center_x + this.render_options.text_shift_x, stave.getYForTopText() - 1);
            ctx.restore();
        }
    }
    getNotes() {
        return this.notes;
    }
    draw() {
        this.checkContext();
        this.setRendered();
        const first_note = this.notes.first_note;
        const last_note = this.notes.last_note;
        let first_x_px = 0;
        let last_x_px = 0;
        let first_ys = [
            0
        ];
        let last_ys = [
            0
        ];
        let stem_direction = 0;
        if (first_note) {
            first_x_px = first_note.getTieRightX() + this.render_options.tie_spacing;
            stem_direction = first_note.getStemDirection();
            first_ys = first_note.getYs();
        } else if (last_note) {
            const stave = last_note.checkStave();
            first_x_px = stave.getTieStartX();
            first_ys = last_note.getYs();
            this.notes.first_indices = this.notes.last_indices;
        }
        if (last_note) {
            last_x_px = last_note.getTieLeftX() + this.render_options.tie_spacing;
            stem_direction = last_note.getStemDirection();
            last_ys = last_note.getYs();
        } else if (first_note) {
            const stave = first_note.checkStave();
            last_x_px = stave.getTieEndX();
            last_ys = first_note.getYs();
            this.notes.last_indices = this.notes.first_indices;
        }
        if (this.direction) stem_direction = this.direction;
        this.renderTie({
            first_x_px: first_x_px,
            last_x_px: last_x_px,
            first_ys: first_ys,
            last_ys: last_ys,
            direction: stem_direction
        });
        this.renderText(first_x_px, last_x_px);
        return true;
    }
};
$a801f2c896bd09f1$var$StaveTie.TEXT_FONT = Object.assign({}, $a801f2c896bd09f1$var$Element.TEXT_FONT);
// node_modules/vexflow/build/esm/src/tabtie.js
var $a801f2c896bd09f1$var$TabTie = class _TabTie extends $a801f2c896bd09f1$var$StaveTie {
    static get CATEGORY() {
        return "TabTie";
    }
    static createHammeron(notes) {
        return new _TabTie(notes, "H");
    }
    static createPulloff(notes) {
        return new _TabTie(notes, "P");
    }
    constructor(notes, text7){
        super(notes, text7);
        this.render_options.cp1 = 9;
        this.render_options.cp2 = 11;
        this.render_options.y_shift = 3;
        this.direction = -1;
    }
};
// node_modules/vexflow/build/esm/src/voice.js
var $a801f2c896bd09f1$var$VoiceMode;
(function(VoiceMode2) {
    VoiceMode2[VoiceMode2["STRICT"] = 1] = "STRICT";
    VoiceMode2[VoiceMode2["SOFT"] = 2] = "SOFT";
    VoiceMode2[VoiceMode2["FULL"] = 3] = "FULL";
})($a801f2c896bd09f1$var$VoiceMode || ($a801f2c896bd09f1$var$VoiceMode = {}));
var $a801f2c896bd09f1$var$Voice = class extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "Voice";
    }
    static get Mode() {
        return $a801f2c896bd09f1$var$VoiceMode;
    }
    constructor(time3){
        super();
        this.resolutionMultiplier = 1;
        this.mode = $a801f2c896bd09f1$var$VoiceMode.STRICT;
        this.preFormatted = false;
        this.ticksUsed = new $a801f2c896bd09f1$var$Fraction(0, 1);
        this.largestTickWidth = 0;
        this.tickables = [];
        this.options = {
            softmaxFactor: $a801f2c896bd09f1$var$Tables.SOFTMAX_FACTOR
        };
        let voiceTime;
        if (typeof time3 === "string") {
            const match2 = time3.match(/(\d+)\/(\d+)/);
            if (match2) voiceTime = {
                num_beats: parseInt(match2[1]),
                beat_value: parseInt(match2[2])
            };
        } else voiceTime = time3;
        this.time = Object.assign({
            num_beats: 4,
            beat_value: 4,
            resolution: $a801f2c896bd09f1$var$Tables.RESOLUTION
        }, voiceTime);
        this.totalTicks = new $a801f2c896bd09f1$var$Fraction(this.time.num_beats * (this.time.resolution / this.time.beat_value), 1);
        this.smallestTickCount = this.totalTicks.clone();
    }
    getTotalTicks() {
        return this.totalTicks;
    }
    getTicksUsed() {
        return this.ticksUsed;
    }
    getLargestTickWidth() {
        return this.largestTickWidth;
    }
    getSmallestTickCount() {
        return this.smallestTickCount;
    }
    getTickables() {
        return this.tickables;
    }
    getMode() {
        return this.mode;
    }
    setMode(mode) {
        this.mode = mode;
        return this;
    }
    getResolutionMultiplier() {
        return this.resolutionMultiplier;
    }
    getActualResolution() {
        return this.resolutionMultiplier * this.time.resolution;
    }
    setStave(stave) {
        this.stave = stave;
        this.boundingBox = void 0;
        return this;
    }
    getStave() {
        return this.stave;
    }
    getBoundingBox() {
        if (!this.boundingBox) {
            const stave = this.checkStave();
            let boundingBox = void 0;
            for(let i2 = 0; i2 < this.tickables.length; ++i2){
                const tickable = this.tickables[i2];
                if (!tickable.getStave()) tickable.setStave(stave);
                const bb = tickable.getBoundingBox();
                if (bb) boundingBox = boundingBox ? boundingBox.mergeWith(bb) : bb;
            }
            this.boundingBox = boundingBox;
        }
        return this.boundingBox;
    }
    setStrict(strict) {
        this.mode = strict ? $a801f2c896bd09f1$var$VoiceMode.STRICT : $a801f2c896bd09f1$var$VoiceMode.SOFT;
        return this;
    }
    isComplete() {
        if (this.mode === $a801f2c896bd09f1$var$VoiceMode.STRICT || this.mode === $a801f2c896bd09f1$var$VoiceMode.FULL) return this.ticksUsed.equals(this.totalTicks);
        else return true;
    }
    setSoftmaxFactor(factor) {
        this.options.softmaxFactor = factor;
        this.expTicksUsed = 0;
        return this;
    }
    reCalculateExpTicksUsed() {
        const totalTicks = this.ticksUsed.value();
        const exp2 = (tickable)=>Math.pow(this.options.softmaxFactor, tickable.getTicks().value() / totalTicks);
        this.expTicksUsed = $a801f2c896bd09f1$var$sumArray(this.tickables.map(exp2));
        return this.expTicksUsed;
    }
    softmax(tickValue) {
        if (!this.expTicksUsed) this.expTicksUsed = this.reCalculateExpTicksUsed();
        const totalTicks = this.ticksUsed.value();
        const exp2 = (v3)=>Math.pow(this.options.softmaxFactor, v3 / totalTicks);
        const sm = exp2(tickValue) / this.expTicksUsed;
        return sm;
    }
    addTickable(tickable) {
        if (!tickable.shouldIgnoreTicks()) {
            const ticks = tickable.getTicks();
            this.ticksUsed.add(ticks);
            this.expTicksUsed = 0;
            if ((this.mode === $a801f2c896bd09f1$var$VoiceMode.STRICT || this.mode === $a801f2c896bd09f1$var$VoiceMode.FULL) && this.ticksUsed.greaterThan(this.totalTicks)) {
                this.ticksUsed.subtract(ticks);
                throw new $a801f2c896bd09f1$var$RuntimeError("BadArgument", "Too many ticks.");
            }
            if (ticks.lessThan(this.smallestTickCount)) this.smallestTickCount = ticks.clone();
            this.resolutionMultiplier = this.ticksUsed.denominator;
            this.totalTicks.add(0, this.ticksUsed.denominator);
        }
        this.tickables.push(tickable);
        tickable.setVoice(this);
        return this;
    }
    addTickables(tickables) {
        for(let i2 = 0; i2 < tickables.length; ++i2)this.addTickable(tickables[i2]);
        return this;
    }
    preFormat() {
        if (this.preFormatted) return this;
        const stave = this.checkStave();
        this.tickables.forEach((tickable)=>{
            if (!tickable.getStave()) tickable.setStave(stave);
        });
        this.preFormatted = true;
        return this;
    }
    checkStave() {
        return $a801f2c896bd09f1$var$defined(this.stave, "NoStave", "No stave attached to instance.");
    }
    draw(context = this.checkContext(), stave) {
        stave = stave !== null && stave !== void 0 ? stave : this.stave;
        this.setRendered();
        let boundingBox = void 0;
        for(let i2 = 0; i2 < this.tickables.length; ++i2){
            const tickable = this.tickables[i2];
            if (stave) tickable.setStave(stave);
            $a801f2c896bd09f1$var$defined(tickable.getStave(), "MissingStave", "The voice cannot draw tickables without staves.");
            const bb = tickable.getBoundingBox();
            if (bb) boundingBox = boundingBox ? boundingBox.mergeWith(bb) : bb;
            tickable.setContext(context);
            tickable.drawWithStyle();
        }
        this.boundingBox = boundingBox;
    }
};
// node_modules/vexflow/build/esm/src/gracenotegroup.js
function $a801f2c896bd09f1$var$L14(...args) {
    if ($a801f2c896bd09f1$var$GraceNoteGroup.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.GraceNoteGroup", args);
}
var $a801f2c896bd09f1$var$GraceNoteGroup = class extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "GraceNoteGroup";
    }
    static format(gracenote_groups, state3) {
        const group_spacing_stave = 4;
        const group_spacing_tab = 0;
        if (!gracenote_groups || gracenote_groups.length === 0) return false;
        const group_list = [];
        let prev_note = null;
        let shiftL = 0;
        for(let i2 = 0; i2 < gracenote_groups.length; ++i2){
            const gracenote_group = gracenote_groups[i2];
            const note2 = gracenote_group.getNote();
            const is_stavenote = $a801f2c896bd09f1$var$isStaveNote(note2);
            const spacing = is_stavenote ? group_spacing_stave : group_spacing_tab;
            if (is_stavenote && note2 !== prev_note) {
                for(let n = 0; n < note2.keys.length; ++n)shiftL = Math.max(note2.getLeftDisplacedHeadPx(), shiftL);
                prev_note = note2;
            }
            group_list.push({
                shift: shiftL,
                gracenote_group: gracenote_group,
                spacing: spacing
            });
        }
        let group_shift = group_list[0].shift;
        let formatWidth;
        for(let i2 = 0; i2 < group_list.length; ++i2){
            const gracenote_group = group_list[i2].gracenote_group;
            gracenote_group.preFormat();
            formatWidth = gracenote_group.getWidth() + group_list[i2].spacing;
            group_shift = Math.max(formatWidth, group_shift);
        }
        for(let i2 = 0; i2 < group_list.length; ++i2){
            const gracenote_group = group_list[i2].gracenote_group;
            formatWidth = gracenote_group.getWidth() + group_list[i2].spacing;
            gracenote_group.setSpacingFromNextModifier(group_shift - Math.min(formatWidth, group_shift) + $a801f2c896bd09f1$var$StaveNote.minNoteheadPadding);
        }
        state3.left_shift += group_shift;
        return true;
    }
    constructor(grace_notes, show_slur){
        super();
        this.preFormatted = false;
        this.position = $a801f2c896bd09f1$var$Modifier.Position.LEFT;
        this.grace_notes = grace_notes;
        this.width = 0;
        this.show_slur = show_slur;
        this.slur = void 0;
        this.voice = new $a801f2c896bd09f1$var$Voice({
            num_beats: 4,
            beat_value: 4,
            resolution: $a801f2c896bd09f1$var$Tables.RESOLUTION
        }).setStrict(false);
        this.render_options = {
            slur_y_shift: 0
        };
        this.beams = [];
        this.voice.addTickables(this.grace_notes);
        return this;
    }
    preFormat() {
        if (this.preFormatted) return;
        if (!this.formatter) this.formatter = new $a801f2c896bd09f1$var$Formatter();
        this.formatter.joinVoices([
            this.voice
        ]).format([
            this.voice
        ], 0, {});
        this.setWidth(this.formatter.getMinTotalWidth());
        this.preFormatted = true;
    }
    beamNotes(grace_notes) {
        grace_notes = grace_notes || this.grace_notes;
        if (grace_notes.length > 1) {
            const beam = new $a801f2c896bd09f1$var$Beam(grace_notes);
            beam.render_options.beam_width = 3;
            beam.render_options.partial_beam_length = 4;
            this.beams.push(beam);
        }
        return this;
    }
    setWidth(width9) {
        this.width = width9;
        return this;
    }
    getWidth() {
        return this.width + $a801f2c896bd09f1$var$StaveNote.minNoteheadPadding;
    }
    getGraceNotes() {
        return this.grace_notes;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        $a801f2c896bd09f1$var$L14("Drawing grace note group for:", note2);
        this.alignSubNotesWithNote(this.getGraceNotes(), note2);
        this.grace_notes.forEach((graceNote)=>graceNote.setContext(ctx).draw());
        this.beams.forEach((beam)=>beam.setContext(ctx).draw());
        if (this.show_slur) {
            const is_stavenote = $a801f2c896bd09f1$var$isStaveNote(note2);
            const TieClass = is_stavenote ? $a801f2c896bd09f1$var$StaveTie : $a801f2c896bd09f1$var$TabTie;
            this.slur = new TieClass({
                last_note: this.grace_notes[0],
                first_note: note2,
                first_indices: [
                    0
                ],
                last_indices: [
                    0
                ]
            });
            this.slur.render_options.cp2 = 12;
            this.slur.render_options.y_shift = (is_stavenote ? 7 : 5) + this.render_options.slur_y_shift;
            this.slur.setContext(ctx).draw();
        }
    }
};
$a801f2c896bd09f1$var$GraceNoteGroup.DEBUG = false;
// node_modules/vexflow/build/esm/src/notesubgroup.js
var $a801f2c896bd09f1$var$NoteSubGroup = class extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "NoteSubGroup";
    }
    static format(groups, state3) {
        if (!groups || groups.length === 0) return false;
        let width9 = 0;
        for(let i2 = 0; i2 < groups.length; ++i2){
            const group4 = groups[i2];
            group4.preFormat();
            width9 += group4.getWidth();
        }
        state3.left_shift += width9;
        return true;
    }
    constructor(subNotes){
        super();
        this.preFormatted = false;
        this.position = $a801f2c896bd09f1$var$Modifier.Position.LEFT;
        this.subNotes = subNotes;
        this.subNotes.forEach((subNote)=>{
            subNote.setIgnoreTicks(false);
        });
        this.width = 0;
        this.formatter = new $a801f2c896bd09f1$var$Formatter();
        this.voice = new $a801f2c896bd09f1$var$Voice({
            num_beats: 4,
            beat_value: 4,
            resolution: $a801f2c896bd09f1$var$Tables.RESOLUTION
        }).setStrict(false);
        this.voice.addTickables(this.subNotes);
    }
    preFormat() {
        if (this.preFormatted) return;
        this.formatter.joinVoices([
            this.voice
        ]).format([
            this.voice
        ], 0);
        this.setWidth(this.formatter.getMinTotalWidth());
        this.preFormatted = true;
    }
    setWidth(width9) {
        this.width = width9;
        return this;
    }
    getWidth() {
        return this.width;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        this.alignSubNotesWithNote(this.subNotes, note2);
        this.subNotes.forEach((subNote)=>subNote.setContext(ctx).drawWithStyle());
    }
};
// node_modules/vexflow/build/esm/src/ornament.js
function $a801f2c896bd09f1$var$L15(...args) {
    if ($a801f2c896bd09f1$var$Ornament.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Ornament", args);
}
var $a801f2c896bd09f1$var$Ornament = class _Ornament extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Ornament";
    }
    static get minPadding() {
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        return musicFont.lookupMetric("noteHead.minPadding");
    }
    static format(ornaments2, state3) {
        if (!ornaments2 || ornaments2.length === 0) return false;
        let width9 = 0;
        let right_shift = state3.right_shift;
        let left_shift = state3.left_shift;
        let yOffset = 0;
        for(let i2 = 0; i2 < ornaments2.length; ++i2){
            const ornament = ornaments2[i2];
            const increment = 2;
            if (_Ornament.ornamentRelease.indexOf(ornament.type) >= 0) ornament.x_shift += right_shift + 2;
            if (_Ornament.ornamentAttack.indexOf(ornament.type) >= 0) ornament.x_shift -= left_shift + 2;
            if (ornament.reportedWidth && ornament.x_shift < 0) left_shift += ornament.reportedWidth;
            else if (ornament.reportedWidth && ornament.x_shift >= 0) right_shift += ornament.reportedWidth + _Ornament.minPadding;
            else width9 = Math.max(ornament.getWidth(), width9);
            if (_Ornament.ornamentArticulation.indexOf(ornament.type) >= 0) {
                const ornamentNote = $a801f2c896bd09f1$var$defined(ornament.note, "NoAttachedNote");
                if (ornamentNote.getLineNumber() >= 3 || ornament.getPosition() === $a801f2c896bd09f1$var$Modifier.Position.ABOVE) {
                    state3.top_text_line += increment;
                    ornament.y_shift += yOffset;
                    yOffset -= ornament.glyph.bbox.getH();
                } else {
                    state3.text_line += increment;
                    ornament.y_shift += yOffset;
                    yOffset += ornament.glyph.bbox.getH();
                }
            } else if (ornament.getPosition() === $a801f2c896bd09f1$var$Modifier.Position.ABOVE) {
                ornament.setTextLine(state3.top_text_line);
                state3.top_text_line += increment;
            } else {
                ornament.setTextLine(state3.text_line);
                state3.text_line += increment;
            }
        }
        state3.left_shift = left_shift + width9 / 2;
        state3.right_shift = right_shift + width9 / 2;
        return true;
    }
    static get ornamentNoteTransition() {
        return [
            "flip",
            "jazzTurn",
            "smear"
        ];
    }
    static get ornamentAttack() {
        return [
            "scoop"
        ];
    }
    static get ornamentAlignWithNoteHead() {
        return [
            "doit",
            "fall",
            "fallLong",
            "doitLong",
            "bend",
            "plungerClosed",
            "plungerOpen",
            "scoop"
        ];
    }
    static get ornamentRelease() {
        return [
            "doit",
            "fall",
            "fallLong",
            "doitLong",
            "jazzTurn",
            "smear",
            "flip"
        ];
    }
    static get ornamentArticulation() {
        return [
            "bend",
            "plungerClosed",
            "plungerOpen"
        ];
    }
    getMetrics() {
        const ornamentMetrics = $a801f2c896bd09f1$var$Tables.currentMusicFont().getMetrics().ornament;
        if (!ornamentMetrics) throw new $a801f2c896bd09f1$var$RuntimeError("BadMetrics", `ornament missing`);
        return ornamentMetrics[this.ornament.code];
    }
    constructor(type){
        super();
        this.type = type;
        this.delayed = false;
        this.render_options = {
            font_scale: $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE,
            accidentalLowerPadding: 3,
            accidentalUpperPadding: 3
        };
        this.ornament = $a801f2c896bd09f1$var$Tables.ornamentCodes(this.type);
        const metrics = this.getMetrics();
        this.adjustForStemDirection = false;
        this.reportedWidth = metrics && metrics.reportedWidth ? metrics.reportedWidth : 0;
        this.stemUpYOffset = metrics && metrics.stemUpYOffset ? metrics.stemUpYOffset : 0;
        this.ornamentAlignWithNoteHead = _Ornament.ornamentAlignWithNoteHead.indexOf(this.type) >= 0;
        if (!this.ornament) throw new $a801f2c896bd09f1$var$RuntimeError("ArgumentError", `Ornament not found: '${this.type}'`);
        this.x_shift = metrics ? metrics.xOffset : 0;
        this.y_shift = metrics ? metrics.yOffset : 0;
        this.glyph = new $a801f2c896bd09f1$var$Glyph(this.ornament.code, this.render_options.font_scale, {
            category: `ornament.${this.ornament.code}`
        });
        if (_Ornament.ornamentNoteTransition.indexOf(this.type) >= 0) this.delayed = true;
        if (!metrics) this.glyph.setOrigin(0.5, 1);
    }
    setDelayed(delayed) {
        this.delayed = delayed;
        return this;
    }
    setUpperAccidental(accid) {
        const scale = this.render_options.font_scale / 1.3;
        this.accidentalUpper = new $a801f2c896bd09f1$var$Glyph($a801f2c896bd09f1$var$Tables.accidentalCodes(accid).code, scale);
        this.accidentalUpper.setOrigin(0.5, 1);
        return this;
    }
    setLowerAccidental(accid) {
        const scale = this.render_options.font_scale / 1.3;
        this.accidentalLower = new $a801f2c896bd09f1$var$Glyph($a801f2c896bd09f1$var$Tables.accidentalCodes(accid).code, scale);
        this.accidentalLower.setOrigin(0.5, 1);
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const stemDir = note2.getStemDirection();
        const stave = note2.checkStave();
        this.applyStyle();
        ctx.openGroup("ornament", this.getAttribute("id"));
        const stemExtents = note2.checkStem().getExtents();
        let y4 = stemDir === $a801f2c896bd09f1$var$Stem.DOWN ? stemExtents.baseY : stemExtents.topY;
        if ($a801f2c896bd09f1$var$isTabNote(note2)) {
            if (note2.hasStem()) {
                if (stemDir === $a801f2c896bd09f1$var$Stem.DOWN) y4 = stave.getYForTopText(this.text_line);
            } else y4 = stave.getYForTopText(this.text_line);
        }
        const isPlacedOnNoteheadSide = stemDir === $a801f2c896bd09f1$var$Stem.DOWN;
        const spacing = stave.getSpacingBetweenLines();
        let lineSpacing = 1;
        if (!isPlacedOnNoteheadSide && note2.hasBeam()) lineSpacing += 0.5;
        const totalSpacing = spacing * (this.text_line + lineSpacing);
        const glyphYBetweenLines = y4 - totalSpacing;
        const start2 = note2.getModifierStartXY(this.position, this.index);
        let glyphX = start2.x;
        let glyphY = this.ornamentAlignWithNoteHead ? start2.y : Math.min(stave.getYForTopText(this.text_line), glyphYBetweenLines);
        glyphY += this.y_shift;
        if (this.delayed) {
            let delayXShift = 0;
            const startX = glyphX - stave.getNoteStartX();
            if (this.delayXShift !== void 0) delayXShift = this.delayXShift;
            else {
                delayXShift += this.glyph.getMetrics().width / 2;
                const tickables = note2.getVoice().getTickables();
                const index5 = tickables.indexOf(note2);
                const nextContext = index5 + 1 < tickables.length ? tickables[index5 + 1].checkTickContext() : void 0;
                if (nextContext) delayXShift += (nextContext.getX() - startX) * 0.5;
                else delayXShift += (stave.getX() + stave.getWidth() - glyphX) * 0.5;
                this.delayXShift = delayXShift;
            }
            glyphX += delayXShift;
        }
        $a801f2c896bd09f1$var$L15("Rendering ornament: ", this.ornament, glyphX, glyphY);
        if (this.accidentalLower) {
            this.accidentalLower.render(ctx, glyphX, glyphY);
            glyphY -= this.accidentalLower.getMetrics().height;
            glyphY -= this.render_options.accidentalLowerPadding;
        }
        if (this.stemUpYOffset && note2.hasStem() && note2.getStemDirection() === 1) glyphY += this.stemUpYOffset;
        if (note2.getLineNumber() < 5 && _Ornament.ornamentNoteTransition.indexOf(this.type) >= 0) glyphY = note2.checkStave().getBoundingBox().getY() + 40;
        this.glyph.render(ctx, glyphX + this.x_shift, glyphY);
        if (this.accidentalUpper) {
            glyphY -= this.glyph.getMetrics().height + this.render_options.accidentalUpperPadding;
            this.accidentalUpper.render(ctx, glyphX, glyphY);
        }
        ctx.closeGroup();
        this.restoreStyle();
    }
};
$a801f2c896bd09f1$var$Ornament.DEBUG = false;
// node_modules/vexflow/build/esm/src/parenthesis.js
var $a801f2c896bd09f1$var$Parenthesis = class _Parenthesis extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Parenthesis";
    }
    static buildAndAttach(notes) {
        for (const note2 of notes)for(let i2 = 0; i2 < note2.keys.length; i2++){
            note2.addModifier(new _Parenthesis($a801f2c896bd09f1$var$ModifierPosition.LEFT), i2);
            note2.addModifier(new _Parenthesis($a801f2c896bd09f1$var$ModifierPosition.RIGHT), i2);
        }
    }
    static format(parentheses, state3) {
        if (!parentheses || parentheses.length === 0) return false;
        let x_widthL = 0;
        let x_widthR = 0;
        for(let i2 = 0; i2 < parentheses.length; ++i2){
            const parenthesis = parentheses[i2];
            const note2 = parenthesis.getNote();
            const pos = parenthesis.getPosition();
            const index5 = parenthesis.checkIndex();
            let shift = 0;
            if (pos === $a801f2c896bd09f1$var$ModifierPosition.RIGHT) {
                shift = note2.getRightParenthesisPx(index5);
                x_widthR = x_widthR > shift + parenthesis.width ? x_widthR : shift + parenthesis.width;
            }
            if (pos === $a801f2c896bd09f1$var$ModifierPosition.LEFT) {
                shift = note2.getLeftParenthesisPx(index5);
                x_widthL = x_widthL > shift + parenthesis.width ? x_widthL : shift + parenthesis.width;
            }
            parenthesis.setXShift(shift);
        }
        state3.left_shift += x_widthL;
        state3.right_shift += x_widthR;
        return true;
    }
    constructor(position2){
        var _a;
        super();
        this.position = position2 !== null && position2 !== void 0 ? position2 : $a801f2c896bd09f1$var$Modifier.Position.LEFT;
        this.point = (_a = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("parenthesis.default.point")) !== null && _a !== void 0 ? _a : $a801f2c896bd09f1$var$Note.getPoint("default");
        this.setWidth($a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("parenthesis.default.width"));
    }
    setNote(note2) {
        var _a, _b;
        this.note = note2;
        this.point = (_a = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("parenthesis.default.point")) !== null && _a !== void 0 ? _a : $a801f2c896bd09f1$var$Note.getPoint("default");
        this.setWidth($a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("parenthesis.default.width"));
        if ($a801f2c896bd09f1$var$isGraceNote(note2)) {
            this.point = (_b = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("parenthesis.gracenote.point")) !== null && _b !== void 0 ? _b : $a801f2c896bd09f1$var$Note.getPoint("gracenote");
            this.setWidth($a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("parenthesis.gracenote.width"));
        }
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const start2 = note2.getModifierStartXY(this.position, this.index, {
            forceFlagRight: true
        });
        const x4 = start2.x + this.x_shift;
        const y4 = start2.y + this.y_shift;
        if (this.position == $a801f2c896bd09f1$var$Modifier.Position.RIGHT) $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, x4 + 1, y4, this.point, "noteheadParenthesisRight", {
            category: `noteHead.standard.noteheadParenthesisRight`
        });
        else if (this.position == $a801f2c896bd09f1$var$Modifier.Position.LEFT) $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, x4 - 2, y4, this.point, "noteheadParenthesisLeft", {
            category: `noteHead.standard.noteheadParenthesisLeft`
        });
    }
};
// node_modules/vexflow/build/esm/src/svgcontext.js
var $a801f2c896bd09f1$var$ATTRIBUTES_TO_IGNORE = {
    path: {
        x: true,
        y: true,
        width: true,
        height: true,
        "font-family": true,
        "font-weight": true,
        "font-style": true,
        "font-size": true
    },
    rect: {
        "font-family": true,
        "font-weight": true,
        "font-style": true,
        "font-size": true
    },
    text: {
        width: true,
        height: true
    }
};
var $a801f2c896bd09f1$var$SVG_NS = "http://www.w3.org/2000/svg";
var $a801f2c896bd09f1$var$TWO_PI = 2 * Math.PI;
var $a801f2c896bd09f1$var$MeasureTextCache = class {
    constructor(){
        this.cache = {};
    }
    lookup(text7, svg2, attributes) {
        let entries = this.cache[text7];
        if (entries === void 0) {
            entries = {};
            this.cache[text7] = entries;
        }
        const family = attributes["font-family"];
        const size6 = attributes["font-size"];
        const weight = attributes["font-weight"];
        const style3 = attributes["font-style"];
        const key2 = `${family}%${size6}%${weight}%${style3}`;
        let entry = entries[key2];
        if (entry === void 0) {
            entry = this.measureImpl(text7, svg2, attributes);
            entries[key2] = entry;
        }
        return entry;
    }
    measureImpl(text7, svg2, attributes) {
        let txt = this.txt;
        if (!txt) {
            txt = document.createElementNS($a801f2c896bd09f1$var$SVG_NS, "text");
            this.txt = txt;
        }
        txt.textContent = text7;
        if (attributes["font-family"]) txt.setAttributeNS(null, "font-family", attributes["font-family"]);
        if (attributes["font-size"]) txt.setAttributeNS(null, "font-size", `${attributes["font-size"]}`);
        if (attributes["font-style"]) txt.setAttributeNS(null, "font-style", attributes["font-style"]);
        if (attributes["font-weight"]) txt.setAttributeNS(null, "font-weight", `${attributes["font-weight"]}`);
        svg2.appendChild(txt);
        const bbox = txt.getBBox();
        svg2.removeChild(txt);
        return {
            x: bbox.x,
            y: bbox.y,
            width: bbox.width,
            height: bbox.height
        };
    }
};
var $a801f2c896bd09f1$var$SVGContext = class _SVGContext extends $a801f2c896bd09f1$var$RenderContext {
    constructor(element4){
        super();
        this.width = 0;
        this.height = 0;
        this.precision = 1;
        this.backgroundFillStyle = "white";
        this.fontCSSString = "";
        this.element = element4;
        this.precision = Math.pow(10, $a801f2c896bd09f1$var$Tables.RENDER_PRECISION_PLACES);
        const svg2 = this.create("svg");
        this.element.appendChild(svg2);
        this.svg = svg2;
        this.parent = this.svg;
        this.groups = [
            this.svg
        ];
        this.path = "";
        this.pen = {
            x: NaN,
            y: NaN
        };
        this.lineWidth = 1;
        const defaultFontAttributes = {
            "font-family": $a801f2c896bd09f1$var$Font.SANS_SERIF,
            "font-size": $a801f2c896bd09f1$var$Font.SIZE + "pt",
            "font-weight": $a801f2c896bd09f1$var$FontWeight.NORMAL,
            "font-style": $a801f2c896bd09f1$var$FontStyle.NORMAL
        };
        this.state = Object.assign({
            scaleX: 1,
            scaleY: 1
        }, defaultFontAttributes);
        this.attributes = Object.assign({
            "stroke-width": 0.3,
            "stroke-dasharray": "none",
            fill: "black",
            stroke: "black"
        }, defaultFontAttributes);
        this.groupAttributes = [];
        this.applyAttributes(svg2, this.attributes);
        this.groupAttributes.push(Object.assign({}, this.attributes));
        this.shadow_attributes = {
            width: 0,
            color: "black"
        };
        this.state_stack = [];
    }
    round(n) {
        return Math.round(n * this.precision) / this.precision;
    }
    create(svgElementType) {
        return document.createElementNS($a801f2c896bd09f1$var$SVG_NS, svgElementType);
    }
    openGroup(cls, id4, attrs) {
        const group4 = this.create("g");
        this.groups.push(group4);
        this.parent.appendChild(group4);
        this.parent = group4;
        if (cls) group4.setAttribute("class", $a801f2c896bd09f1$var$prefix(cls));
        if (id4) group4.setAttribute("id", $a801f2c896bd09f1$var$prefix(id4));
        if (attrs && attrs.pointerBBox) group4.setAttribute("pointer-events", "bounding-box");
        this.applyAttributes(group4, this.attributes);
        this.groupAttributes.push(Object.assign(Object.assign({}, this.groupAttributes[this.groupAttributes.length - 1]), this.attributes));
        return group4;
    }
    closeGroup() {
        this.groups.pop();
        this.groupAttributes.pop();
        this.parent = this.groups[this.groups.length - 1];
    }
    add(elem5) {
        this.parent.appendChild(elem5);
    }
    setFillStyle(style3) {
        this.attributes.fill = style3;
        return this;
    }
    setBackgroundFillStyle(style3) {
        this.backgroundFillStyle = style3;
        return this;
    }
    setStrokeStyle(style3) {
        this.attributes.stroke = style3;
        return this;
    }
    setShadowColor(color) {
        this.shadow_attributes.color = color;
        return this;
    }
    setShadowBlur(blur3) {
        this.shadow_attributes.width = blur3;
        return this;
    }
    setLineWidth(width9) {
        this.attributes["stroke-width"] = width9;
        this.lineWidth = width9;
        return this;
    }
    setLineDash(lineDash) {
        if (Object.prototype.toString.call(lineDash) === "[object Array]") {
            this.attributes["stroke-dasharray"] = lineDash.join(",");
            return this;
        } else throw new $a801f2c896bd09f1$var$RuntimeError("ArgumentError", "lineDash must be an array of integers.");
    }
    setLineCap(capType) {
        this.attributes["stroke-linecap"] = capType;
        return this;
    }
    resize(width9, height9) {
        this.width = width9;
        this.height = height9;
        this.element.style.width = width9.toString();
        this.svg.style.width = width9.toString();
        this.svg.style.height = height9.toString();
        const attributes = {
            width: width9,
            height: height9
        };
        this.applyAttributes(this.svg, attributes);
        this.scale(this.state.scaleX, this.state.scaleY);
        return this;
    }
    scale(x4, y4) {
        this.state.scaleX = this.state.scaleX ? this.state.scaleX * x4 : x4;
        this.state.scaleY = this.state.scaleY ? this.state.scaleY * y4 : y4;
        const visibleWidth = this.width / this.state.scaleX;
        const visibleHeight = this.height / this.state.scaleY;
        this.setViewBox(0, 0, visibleWidth, visibleHeight);
        return this;
    }
    setViewBox(viewBox_or_minX, minY, width9, height9) {
        if (typeof viewBox_or_minX === "string") this.svg.setAttribute("viewBox", viewBox_or_minX);
        else {
            const viewBoxString = viewBox_or_minX + " " + minY + " " + width9 + " " + height9;
            this.svg.setAttribute("viewBox", viewBoxString);
        }
    }
    applyAttributes(element4, attributes) {
        const attrNamesToIgnore = $a801f2c896bd09f1$var$ATTRIBUTES_TO_IGNORE[element4.nodeName];
        for(const attrName in attributes){
            if (attrNamesToIgnore && attrNamesToIgnore[attrName]) continue;
            if (attributes[attrName] && (this.groupAttributes.length == 0 || attributes[attrName] != this.groupAttributes[this.groupAttributes.length - 1][attrName])) element4.setAttributeNS(null, attrName, attributes[attrName]);
        }
        return element4;
    }
    clear() {
        while(this.svg.lastChild)this.svg.removeChild(this.svg.lastChild);
        this.scale(this.state.scaleX, this.state.scaleY);
    }
    rect(x4, y4, width9, height9, attributes) {
        if (height9 < 0) {
            y4 += height9;
            height9 *= -1;
        }
        const rectangle = this.create("rect");
        attributes = attributes !== null && attributes !== void 0 ? attributes : {
            fill: "none",
            "stroke-width": this.lineWidth,
            stroke: "black"
        };
        x4 = this.round(x4);
        y4 = this.round(y4);
        width9 = this.round(width9);
        height9 = this.round(height9);
        this.applyAttributes(rectangle, Object.assign({
            x: x4,
            y: y4,
            width: width9,
            height: height9
        }, attributes));
        this.add(rectangle);
        return this;
    }
    fillRect(x4, y4, width9, height9) {
        const attributes = {
            fill: this.attributes.fill,
            stroke: "none"
        };
        this.rect(x4, y4, width9, height9, attributes);
        return this;
    }
    clearRect(x4, y4, width9, height9) {
        this.rect(x4, y4, width9, height9, {
            fill: this.backgroundFillStyle,
            stroke: "none"
        });
        return this;
    }
    beginPath() {
        this.path = "";
        this.pen.x = NaN;
        this.pen.y = NaN;
        return this;
    }
    moveTo(x4, y4) {
        x4 = this.round(x4);
        y4 = this.round(y4);
        this.path += "M" + x4 + " " + y4;
        this.pen.x = x4;
        this.pen.y = y4;
        return this;
    }
    lineTo(x4, y4) {
        x4 = this.round(x4);
        y4 = this.round(y4);
        this.path += "L" + x4 + " " + y4;
        this.pen.x = x4;
        this.pen.y = y4;
        return this;
    }
    bezierCurveTo(x12, y12, x22, y22, x4, y4) {
        x4 = this.round(x4);
        y4 = this.round(y4);
        x12 = this.round(x12);
        y12 = this.round(y12);
        x22 = this.round(x22);
        y22 = this.round(y22);
        this.path += "C" + x12 + " " + y12 + "," + x22 + " " + y22 + "," + x4 + " " + y4;
        this.pen.x = x4;
        this.pen.y = y4;
        return this;
    }
    quadraticCurveTo(x12, y12, x4, y4) {
        x4 = this.round(x4);
        y4 = this.round(y4);
        x12 = this.round(x12);
        y12 = this.round(y12);
        this.path += "Q" + x12 + " " + y12 + "," + x4 + " " + y4;
        this.pen.x = x4;
        this.pen.y = y4;
        return this;
    }
    arc(x4, y4, radius, startAngle, endAngle, counterclockwise) {
        let x0 = x4 + radius * Math.cos(startAngle);
        let y0 = y4 + radius * Math.sin(startAngle);
        x0 = this.round(x0);
        y0 = this.round(y0);
        const tmpStartTest = $a801f2c896bd09f1$var$normalizeAngle(startAngle);
        const tmpEndTest = $a801f2c896bd09f1$var$normalizeAngle(endAngle);
        if (!counterclockwise && endAngle - startAngle >= $a801f2c896bd09f1$var$TWO_PI || counterclockwise && startAngle - endAngle >= $a801f2c896bd09f1$var$TWO_PI || tmpStartTest === tmpEndTest) {
            let x12 = x4 + radius * Math.cos(startAngle + Math.PI);
            let y12 = y4 + radius * Math.sin(startAngle + Math.PI);
            x12 = this.round(x12);
            y12 = this.round(y12);
            radius = this.round(radius);
            this.path += `M${x0} ${y0} A${radius} ${radius} 0 0 0 ${x12} ${y12} `;
            this.path += `A${radius} ${radius} 0 0 0 ${x0} ${y0}`;
            this.pen.x = x0;
            this.pen.y = y0;
        } else {
            let x12 = x4 + radius * Math.cos(endAngle);
            let y12 = y4 + radius * Math.sin(endAngle);
            startAngle = tmpStartTest;
            endAngle = tmpEndTest;
            let large;
            if (Math.abs(endAngle - startAngle) < Math.PI) large = counterclockwise;
            else large = !counterclockwise;
            if (startAngle > endAngle) large = !large;
            const sweep = !counterclockwise;
            x12 = this.round(x12);
            y12 = this.round(y12);
            radius = this.round(radius);
            this.path += `M${x0} ${y0} A${radius} ${radius} 0 ${+large} ${+sweep} ${x12} ${y12}`;
            this.pen.x = x12;
            this.pen.y = y12;
        }
        return this;
    }
    closePath() {
        this.path += "Z";
        return this;
    }
    getShadowStyle() {
        const sa = this.shadow_attributes;
        return `filter: drop-shadow(0 0 ${sa.width / 1.5}px ${sa.color})`;
    }
    fill(attributes) {
        const path2 = this.create("path");
        if (typeof attributes === "undefined") attributes = Object.assign(Object.assign({}, this.attributes), {
            stroke: "none"
        });
        attributes.d = this.path;
        if (this.shadow_attributes.width > 0) attributes.style = this.getShadowStyle();
        this.applyAttributes(path2, attributes);
        this.add(path2);
        return this;
    }
    stroke() {
        const path2 = this.create("path");
        const attributes = Object.assign(Object.assign({}, this.attributes), {
            fill: "none",
            "stroke-width": this.lineWidth,
            d: this.path
        });
        if (this.shadow_attributes.width > 0) attributes.style = this.getShadowStyle();
        this.applyAttributes(path2, attributes);
        this.add(path2);
        return this;
    }
    measureText(text7) {
        return _SVGContext.measureTextCache.lookup(text7, this.svg, this.attributes);
    }
    fillText(text7, x4, y4) {
        if (!text7 || text7.length <= 0) return this;
        x4 = this.round(x4);
        y4 = this.round(y4);
        const attributes = Object.assign(Object.assign({}, this.attributes), {
            stroke: "none",
            x: x4,
            y: y4
        });
        const txt = this.create("text");
        txt.textContent = text7;
        this.applyAttributes(txt, attributes);
        this.add(txt);
        return this;
    }
    save() {
        this.state_stack.push({
            state: {
                "font-family": this.state["font-family"],
                "font-weight": this.state["font-weight"],
                "font-style": this.state["font-style"],
                "font-size": this.state["font-size"],
                scale: this.state.scale
            },
            attributes: {
                "font-family": this.attributes["font-family"],
                "font-weight": this.attributes["font-weight"],
                "font-style": this.attributes["font-style"],
                "font-size": this.attributes["font-size"],
                fill: this.attributes.fill,
                stroke: this.attributes.stroke,
                "stroke-width": this.attributes["stroke-width"],
                "stroke-dasharray": this.attributes["stroke-dasharray"]
            },
            shadow_attributes: {
                width: this.shadow_attributes.width,
                color: this.shadow_attributes.color
            },
            lineWidth: this.lineWidth
        });
        return this;
    }
    restore() {
        const savedState = this.state_stack.pop();
        if (savedState) {
            const state3 = savedState;
            this.state["font-family"] = state3.state["font-family"];
            this.state["font-weight"] = state3.state["font-weight"];
            this.state["font-style"] = state3.state["font-style"];
            this.state["font-size"] = state3.state["font-size"];
            this.state.scale = state3.state.scale;
            this.attributes["font-family"] = state3.attributes["font-family"];
            this.attributes["font-weight"] = state3.attributes["font-weight"];
            this.attributes["font-style"] = state3.attributes["font-style"];
            this.attributes["font-size"] = state3.attributes["font-size"];
            this.attributes.fill = state3.attributes.fill;
            this.attributes.stroke = state3.attributes.stroke;
            this.attributes["stroke-width"] = state3.attributes["stroke-width"];
            this.attributes["stroke-dasharray"] = state3.attributes["stroke-dasharray"];
            this.shadow_attributes.width = state3.shadow_attributes.width;
            this.shadow_attributes.color = state3.shadow_attributes.color;
            this.lineWidth = state3.lineWidth;
        }
        return this;
    }
    set fillStyle(style3) {
        this.setFillStyle(style3);
    }
    get fillStyle() {
        return this.attributes.fill;
    }
    set strokeStyle(style3) {
        this.setStrokeStyle(style3);
    }
    get strokeStyle() {
        return this.attributes.stroke;
    }
    setFont(f2, size6, weight, style3) {
        const fontInfo = $a801f2c896bd09f1$var$Font.validate(f2, size6, weight, style3);
        this.fontCSSString = $a801f2c896bd09f1$var$Font.toCSSString(fontInfo);
        const fontAttributes = {
            "font-family": fontInfo.family,
            "font-size": fontInfo.size,
            "font-weight": fontInfo.weight,
            "font-style": fontInfo.style
        };
        this.attributes = Object.assign(Object.assign({}, this.attributes), fontAttributes);
        this.state = Object.assign(Object.assign({}, this.state), fontAttributes);
        return this;
    }
    getFont() {
        return this.fontCSSString;
    }
};
$a801f2c896bd09f1$var$SVGContext.measureTextCache = new $a801f2c896bd09f1$var$MeasureTextCache();
// node_modules/vexflow/build/esm/src/renderer.js
var $a801f2c896bd09f1$var$RendererBackends;
(function(RendererBackends2) {
    RendererBackends2[RendererBackends2["CANVAS"] = 1] = "CANVAS";
    RendererBackends2[RendererBackends2["SVG"] = 2] = "SVG";
})($a801f2c896bd09f1$var$RendererBackends || ($a801f2c896bd09f1$var$RendererBackends = {}));
var $a801f2c896bd09f1$var$RendererLineEndType;
(function(RendererLineEndType2) {
    RendererLineEndType2[RendererLineEndType2["NONE"] = 1] = "NONE";
    RendererLineEndType2[RendererLineEndType2["UP"] = 2] = "UP";
    RendererLineEndType2[RendererLineEndType2["DOWN"] = 3] = "DOWN";
})($a801f2c896bd09f1$var$RendererLineEndType || ($a801f2c896bd09f1$var$RendererLineEndType = {}));
var $a801f2c896bd09f1$var$Renderer = class _Renderer {
    static buildContext(elementId, backend, width9, height9, background = "#FFF") {
        const renderer = new _Renderer(elementId, backend);
        if (width9 && height9) renderer.resize(width9, height9);
        const ctx = renderer.getContext();
        ctx.setBackgroundFillStyle(background);
        _Renderer.lastContext = ctx;
        return ctx;
    }
    static getCanvasContext(elementId, width9, height9, background) {
        return _Renderer.buildContext(elementId, _Renderer.Backends.CANVAS, width9, height9, background);
    }
    static getSVGContext(elementId, width9, height9, background) {
        return _Renderer.buildContext(elementId, _Renderer.Backends.SVG, width9, height9, background);
    }
    static drawDashedLine(context, fromX, fromY, toX, toY, dashPattern) {
        context.beginPath();
        const dx = toX - fromX;
        const dy = toY - fromY;
        const angle = Math.atan2(dy, dx);
        let x4 = fromX;
        let y4 = fromY;
        context.moveTo(fromX, fromY);
        let idx = 0;
        let draw = true;
        while(!((dx < 0 ? x4 <= toX : x4 >= toX) && (dy < 0 ? y4 <= toY : y4 >= toY))){
            const dashLength = dashPattern[idx++ % dashPattern.length];
            const nx = x4 + Math.cos(angle) * dashLength;
            x4 = dx < 0 ? Math.max(toX, nx) : Math.min(toX, nx);
            const ny = y4 + Math.sin(angle) * dashLength;
            y4 = dy < 0 ? Math.max(toY, ny) : Math.min(toY, ny);
            if (draw) context.lineTo(x4, y4);
            else context.moveTo(x4, y4);
            draw = !draw;
        }
        context.closePath();
        context.stroke();
    }
    constructor(arg0, arg1){
        if ($a801f2c896bd09f1$var$isRenderContext(arg0)) this.ctx = arg0;
        else {
            if (arg1 === void 0) throw new $a801f2c896bd09f1$var$RuntimeError("InvalidArgument", "Missing backend argument");
            const backend = arg1;
            let element4;
            if (typeof arg0 == "string") {
                const maybeElement = document.getElementById(arg0);
                if (!maybeElement) throw new $a801f2c896bd09f1$var$RuntimeError("BadElementId", `Can't find element with ID "${maybeElement}"`);
                element4 = maybeElement;
            } else element4 = arg0;
            if (backend === _Renderer.Backends.CANVAS) {
                if (!$a801f2c896bd09f1$var$isHTMLCanvas(element4)) throw new $a801f2c896bd09f1$var$RuntimeError("BadElement", "CANVAS context requires an HTMLCanvasElement.");
                const context = element4.getContext("2d", {
                    willReadFrequently: true
                });
                if (!context) throw new $a801f2c896bd09f1$var$RuntimeError("BadElement", "Can't get canvas context");
                this.ctx = new $a801f2c896bd09f1$var$CanvasContext(context);
            } else if (backend === _Renderer.Backends.SVG) {
                if (!$a801f2c896bd09f1$var$isHTMLDiv(element4)) throw new $a801f2c896bd09f1$var$RuntimeError("BadElement", "SVG context requires an HTMLDivElement.");
                this.ctx = new $a801f2c896bd09f1$var$SVGContext(element4);
            } else throw new $a801f2c896bd09f1$var$RuntimeError("InvalidBackend", `No support for backend: ${backend}`);
        }
    }
    resize(width9, height9) {
        this.ctx.resize(width9, height9);
        return this;
    }
    getContext() {
        return this.ctx;
    }
};
$a801f2c896bd09f1$var$Renderer.Backends = $a801f2c896bd09f1$var$RendererBackends;
$a801f2c896bd09f1$var$Renderer.LineEndType = $a801f2c896bd09f1$var$RendererLineEndType;
$a801f2c896bd09f1$var$Renderer.lastContext = void 0;
// node_modules/vexflow/build/esm/src/stringnumber.js
var $a801f2c896bd09f1$var$StringNumber = class _StringNumber extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "StringNumber";
    }
    static get metrics() {
        var _a;
        return (_a = $a801f2c896bd09f1$var$Tables.currentMusicFont().getMetrics().stringNumber) !== null && _a !== void 0 ? _a : {
            verticalPadding: 0,
            stemPadding: 0,
            leftPadding: 0,
            rightPadding: 0
        };
    }
    static format(nums, state3) {
        const left_shift = state3.left_shift;
        const right_shift = state3.right_shift;
        const num_spacing = 1;
        if (!nums || nums.length === 0) return false;
        const nums_list = [];
        let prev_note = null;
        let extraXSpaceForDisplacedNotehead = 0;
        let shift_right = 0;
        const modLines = 0;
        for(let i2 = 0; i2 < nums.length; ++i2){
            const num = nums[i2];
            const note2 = num.getNote();
            const pos = num.getPosition();
            if (!$a801f2c896bd09f1$var$isStaveNote(note2)) throw new $a801f2c896bd09f1$var$RuntimeError("NoStaveNote");
            const index5 = num.checkIndex();
            const props = note2.getKeyProps()[index5];
            const mc = note2.getModifierContext();
            const verticalSpaceNeeded = num.radius * 2 / $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE + 0.5;
            if (mc) {
                if (pos === $a801f2c896bd09f1$var$ModifierPosition.ABOVE) {
                    num.text_line = mc.getState().top_text_line;
                    state3.top_text_line += verticalSpaceNeeded;
                } else if (pos === $a801f2c896bd09f1$var$ModifierPosition.BELOW) {
                    num.text_line = mc.getState().text_line;
                    state3.text_line += verticalSpaceNeeded;
                }
            }
            if (note2 !== prev_note) {
                for(let n = 0; n < note2.keys.length; ++n){
                    if (pos === $a801f2c896bd09f1$var$Modifier.Position.LEFT) extraXSpaceForDisplacedNotehead = Math.max(note2.getLeftDisplacedHeadPx(), extraXSpaceForDisplacedNotehead);
                    if (right_shift === 0) shift_right = Math.max(note2.getRightDisplacedHeadPx(), shift_right);
                }
                prev_note = note2;
            }
            const glyphLine = modLines === 0 ? props.line : modLines;
            nums_list.push({
                pos: pos,
                note: note2,
                num: num,
                line: glyphLine,
                shiftL: extraXSpaceForDisplacedNotehead,
                shiftR: shift_right
            });
        }
        nums_list.sort((a3, b3)=>b3.line - a3.line);
        let num_shiftR = 0;
        let x_widthL = 0;
        let x_widthR = 0;
        let last_line = null;
        let last_note = null;
        for(let i2 = 0; i2 < nums_list.length; ++i2){
            const note2 = nums_list[i2].note;
            const pos = nums_list[i2].pos;
            const num = nums_list[i2].num;
            const line2 = nums_list[i2].line;
            const shiftR = nums_list[i2].shiftR;
            if (line2 !== last_line || note2 !== last_note) num_shiftR = right_shift + shiftR;
            const num_width = num.getWidth() + num_spacing;
            let num_x_shift = 0;
            if (pos === $a801f2c896bd09f1$var$Modifier.Position.LEFT) {
                num.setXShift(left_shift + extraXSpaceForDisplacedNotehead);
                num_x_shift = num_width;
                x_widthL = Math.max(num_x_shift, x_widthL);
            } else if (pos === $a801f2c896bd09f1$var$Modifier.Position.RIGHT) {
                num.setXShift(num_shiftR);
                num_x_shift += num_width;
                x_widthR = num_x_shift > x_widthR ? num_x_shift : x_widthR;
            }
            last_line = line2;
            last_note = note2;
        }
        state3.left_shift += x_widthL;
        state3.right_shift += x_widthR;
        return true;
    }
    constructor(number){
        super();
        this.string_number = number;
        this.position = $a801f2c896bd09f1$var$Modifier.Position.ABOVE;
        this.x_shift = 0;
        this.y_shift = 0;
        this.text_line = 0;
        this.stem_offset = 0;
        this.x_offset = 0;
        this.y_offset = 0;
        this.dashed = true;
        this.leg = $a801f2c896bd09f1$var$Renderer.LineEndType.NONE;
        this.radius = 8;
        this.drawCircle = true;
        this.setWidth(this.radius * 2 + 4);
        this.resetFont();
    }
    setLineEndType(leg) {
        if (leg >= $a801f2c896bd09f1$var$Renderer.LineEndType.NONE && leg <= $a801f2c896bd09f1$var$Renderer.LineEndType.DOWN) this.leg = leg;
        return this;
    }
    setStringNumber(number) {
        this.string_number = number;
        return this;
    }
    setOffsetX(x4) {
        this.x_offset = x4;
        return this;
    }
    setOffsetY(y4) {
        this.y_offset = y4;
        return this;
    }
    setLastNote(note2) {
        this.last_note = note2;
        return this;
    }
    setDashed(dashed) {
        this.dashed = dashed;
        return this;
    }
    setDrawCircle(drawCircle) {
        this.drawCircle = drawCircle;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const start2 = note2.getModifierStartXY(this.position, this.index);
        const stemDirection = note2.hasStem() ? note2.getStemDirection() : $a801f2c896bd09f1$var$Stem.UP;
        let dot_x = start2.x + this.x_shift + this.x_offset;
        let stem_ext = {};
        if (note2.hasStem()) stem_ext = note2.checkStem().getExtents();
        let dot_y = start2.y + this.y_shift + this.y_offset;
        switch(this.position){
            case $a801f2c896bd09f1$var$Modifier.Position.ABOVE:
                {
                    const ys = note2.getYs();
                    dot_y = ys.reduce((a3, b3)=>a3 < b3 ? a3 : b3);
                    if (note2.hasStem() && stemDirection == $a801f2c896bd09f1$var$Stem.UP) dot_y = stem_ext.topY + _StringNumber.metrics.stemPadding;
                    dot_y -= this.radius + _StringNumber.metrics.verticalPadding + this.text_line * $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE;
                }
                break;
            case $a801f2c896bd09f1$var$Modifier.Position.BELOW:
                {
                    const ys = note2.getYs();
                    dot_y = ys.reduce((a3, b3)=>a3 > b3 ? a3 : b3);
                    if (note2.hasStem() && stemDirection == $a801f2c896bd09f1$var$Stem.DOWN) dot_y = stem_ext.topY - _StringNumber.metrics.stemPadding;
                    dot_y += this.radius + _StringNumber.metrics.verticalPadding + this.text_line * $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE;
                }
                break;
            case $a801f2c896bd09f1$var$Modifier.Position.LEFT:
                dot_x -= this.radius / 2 + _StringNumber.metrics.leftPadding;
                break;
            case $a801f2c896bd09f1$var$Modifier.Position.RIGHT:
                dot_x += this.radius / 2 + _StringNumber.metrics.rightPadding;
                break;
            default:
                throw new $a801f2c896bd09f1$var$RuntimeError("InvalidPosition", `The position ${this.position} is invalid`);
        }
        ctx.save();
        if (this.drawCircle) {
            ctx.beginPath();
            ctx.arc(dot_x, dot_y, this.radius, 0, Math.PI * 2, false);
            ctx.setLineWidth(1.5);
            ctx.stroke();
        }
        ctx.setFont(this.textFont);
        const x4 = dot_x - ctx.measureText(this.string_number).width / 2;
        ctx.fillText("" + this.string_number, x4, dot_y + 4.5);
        const lastNote = this.last_note;
        if ($a801f2c896bd09f1$var$isStemmableNote(lastNote)) {
            const end = lastNote.getStemX() - note2.getX() + 5;
            ctx.setStrokeStyle("#000000");
            ctx.setLineCap("round");
            ctx.setLineWidth(0.6);
            if (this.dashed) $a801f2c896bd09f1$var$Renderer.drawDashedLine(ctx, dot_x + 10, dot_y, dot_x + end, dot_y, [
                3,
                3
            ]);
            else $a801f2c896bd09f1$var$Renderer.drawDashedLine(ctx, dot_x + 10, dot_y, dot_x + end, dot_y, [
                3,
                0
            ]);
            let len;
            let pattern2;
            switch(this.leg){
                case $a801f2c896bd09f1$var$Renderer.LineEndType.UP:
                    len = -10;
                    pattern2 = this.dashed ? [
                        3,
                        3
                    ] : [
                        3,
                        0
                    ];
                    $a801f2c896bd09f1$var$Renderer.drawDashedLine(ctx, dot_x + end, dot_y, dot_x + end, dot_y + len, pattern2);
                    break;
                case $a801f2c896bd09f1$var$Renderer.LineEndType.DOWN:
                    len = 10;
                    pattern2 = this.dashed ? [
                        3,
                        3
                    ] : [
                        3,
                        0
                    ];
                    $a801f2c896bd09f1$var$Renderer.drawDashedLine(ctx, dot_x + end, dot_y, dot_x + end, dot_y + len, pattern2);
                    break;
                default:
                    break;
            }
        }
        ctx.restore();
    }
};
$a801f2c896bd09f1$var$StringNumber.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SANS_SERIF,
    size: $a801f2c896bd09f1$var$Font.SIZE,
    weight: $a801f2c896bd09f1$var$FontWeight.BOLD,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
// node_modules/vexflow/build/esm/src/strokes.js
var $a801f2c896bd09f1$var$Stroke = class _Stroke extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Stroke";
    }
    static format(strokes, state3) {
        const left_shift = state3.left_shift;
        const stroke_spacing = 0;
        if (!strokes || strokes.length === 0) return false;
        const strokeList = strokes.map((stroke2)=>{
            const note2 = stroke2.getNote();
            const index5 = stroke2.checkIndex();
            if ($a801f2c896bd09f1$var$isStaveNote(note2)) {
                const { line: line2 } = note2.getKeyProps()[index5];
                const shift = note2.getLeftDisplacedHeadPx();
                return {
                    line: line2,
                    shift: shift,
                    stroke: stroke2
                };
            } else if ($a801f2c896bd09f1$var$isTabNote(note2)) {
                const { str: string } = note2.getPositions()[index5];
                return {
                    line: string,
                    shift: 0,
                    stroke: stroke2
                };
            } else throw new $a801f2c896bd09f1$var$RuntimeError("Internal", "Unexpected instance.");
        });
        const strokeShift = left_shift;
        const xShift = strokeList.reduce((xShift2, { stroke: stroke2, shift: shift })=>{
            stroke2.setXShift(strokeShift + shift);
            return Math.max(stroke2.getWidth() + stroke_spacing, xShift2);
        }, 0);
        state3.left_shift += xShift;
        return true;
    }
    constructor(type, options2){
        super();
        this.options = Object.assign({
            all_voices: true
        }, options2);
        this.all_voices = this.options.all_voices;
        this.type = type;
        this.position = $a801f2c896bd09f1$var$Modifier.Position.LEFT;
        this.render_options = {
            font_scale: $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE
        };
        this.resetFont();
        this.setXShift(0);
        this.setWidth(10);
    }
    getPosition() {
        return this.position;
    }
    addEndNote(note2) {
        this.note_end = note2;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const start2 = note2.getModifierStartXY(this.position, this.index);
        let ys = note2.getYs();
        let topY = start2.y;
        let botY = start2.y;
        const x4 = start2.x - 5;
        const line_space = note2.checkStave().getSpacingBetweenLines();
        const notes = this.checkModifierContext().getMembers(note2.getCategory());
        for(let i2 = 0; i2 < notes.length; i2++){
            const note3 = notes[i2];
            if ($a801f2c896bd09f1$var$isNote(note3)) {
                ys = note3.getYs();
                for(let n = 0; n < ys.length; n++)if (this.note === notes[i2] || this.all_voices) {
                    topY = Math.min(topY, ys[n]);
                    botY = Math.max(botY, ys[n]);
                }
            }
        }
        let arrow = "";
        let arrow_shift_x = 0;
        let arrow_y = 0;
        let text_shift_x = 0;
        let text_y = 0;
        switch(this.type){
            case _Stroke.Type.BRUSH_DOWN:
                arrow = "arrowheadBlackUp";
                arrow_shift_x = -3;
                arrow_y = topY - line_space / 2 + 10;
                botY += line_space / 2;
                break;
            case _Stroke.Type.BRUSH_UP:
                arrow = "arrowheadBlackDown";
                arrow_shift_x = 0.5;
                arrow_y = botY + line_space / 2;
                topY -= line_space / 2;
                break;
            case _Stroke.Type.ROLL_DOWN:
            case _Stroke.Type.RASQUEDO_DOWN:
                arrow = "arrowheadBlackUp";
                arrow_shift_x = -3;
                text_shift_x = this.x_shift + arrow_shift_x - 2;
                if ($a801f2c896bd09f1$var$isStaveNote(note2)) {
                    topY += 1.5 * line_space;
                    if ((botY - topY) % 2 !== 0) botY += 0.5 * line_space;
                    else botY += line_space;
                    arrow_y = topY - line_space;
                    text_y = botY + line_space + 2;
                } else {
                    topY += 1.5 * line_space;
                    botY += line_space;
                    arrow_y = topY - 0.75 * line_space;
                    text_y = botY + 0.25 * line_space;
                }
                break;
            case _Stroke.Type.ROLL_UP:
            case _Stroke.Type.RASQUEDO_UP:
                arrow = "arrowheadBlackDown";
                arrow_shift_x = -4;
                text_shift_x = this.x_shift + arrow_shift_x - 1;
                if ($a801f2c896bd09f1$var$isStaveNote(note2)) {
                    arrow_y = line_space / 2;
                    topY += 0.5 * line_space;
                    if ((botY - topY) % 2 === 0) botY += line_space / 2;
                    arrow_y = botY + 0.5 * line_space;
                    text_y = topY - 1.25 * line_space;
                } else {
                    topY += 0.25 * line_space;
                    botY += 0.5 * line_space;
                    arrow_y = botY + 0.25 * line_space;
                    text_y = topY - line_space;
                }
                break;
            case _Stroke.Type.ARPEGGIO_DIRECTIONLESS:
                topY += 0.5 * line_space;
                botY += line_space;
                break;
            default:
                throw new $a801f2c896bd09f1$var$RuntimeError("InvalidType", `The stroke type ${this.type} does not exist`);
        }
        let strokeLine = "straight";
        if (this.type === _Stroke.Type.BRUSH_DOWN || this.type === _Stroke.Type.BRUSH_UP) ctx.fillRect(x4 + this.x_shift, topY, 1, botY - topY);
        else {
            strokeLine = "wiggly";
            if ($a801f2c896bd09f1$var$isStaveNote(note2)) for(let i2 = topY; i2 <= botY; i2 += line_space)$a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, x4 + this.x_shift - 4, i2, this.render_options.font_scale, "vexWiggleArpeggioUp");
            else {
                let i2;
                for(i2 = topY; i2 <= botY; i2 += 10)$a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, x4 + this.x_shift - 4, i2, this.render_options.font_scale, "vexWiggleArpeggioUp");
                if (this.type === _Stroke.Type.RASQUEDO_DOWN) text_y = i2 + 0.25 * line_space;
            }
        }
        if (this.type === _Stroke.Type.ARPEGGIO_DIRECTIONLESS) return;
        $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, x4 + this.x_shift + arrow_shift_x, arrow_y, this.render_options.font_scale, arrow, {
            category: `stroke_${strokeLine}.${arrow}`
        });
        if (this.type === _Stroke.Type.RASQUEDO_DOWN || this.type === _Stroke.Type.RASQUEDO_UP) {
            ctx.save();
            ctx.setFont(this.textFont);
            ctx.fillText("R", x4 + text_shift_x, text_y);
            ctx.restore();
        }
    }
};
$a801f2c896bd09f1$var$Stroke.Type = {
    BRUSH_DOWN: 1,
    BRUSH_UP: 2,
    ROLL_DOWN: 3,
    ROLL_UP: 4,
    RASQUEDO_DOWN: 5,
    RASQUEDO_UP: 6,
    ARPEGGIO_DIRECTIONLESS: 7
};
$a801f2c896bd09f1$var$Stroke.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SERIF,
    size: $a801f2c896bd09f1$var$Font.SIZE,
    weight: $a801f2c896bd09f1$var$FontWeight.BOLD,
    style: $a801f2c896bd09f1$var$FontStyle.ITALIC
};
// node_modules/vexflow/build/esm/src/vibrato.js
var $a801f2c896bd09f1$var$Vibrato = class _Vibrato extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Vibrato";
    }
    static format(vibratos, state3, context) {
        if (!vibratos || vibratos.length === 0) return false;
        let text_line = state3.top_text_line;
        let width9 = 0;
        let shift = state3.right_shift - 7;
        const bends = context.getMembers($a801f2c896bd09f1$var$Bend.CATEGORY);
        if (bends && bends.length > 0) {
            const bendHeight = bends.map((bb)=>bb.getTextHeight()).reduce((a3, b3)=>a3 > b3 ? a3 : b3) / $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE;
            text_line = text_line - (bendHeight + 1);
        } else state3.top_text_line += 1;
        for(let i2 = 0; i2 < vibratos.length; ++i2){
            const vibrato = vibratos[i2];
            vibrato.setXShift(shift);
            vibrato.setTextLine(text_line);
            width9 += vibrato.getWidth();
            shift += width9;
        }
        state3.right_shift += width9;
        return true;
    }
    constructor(){
        super();
        this.position = $a801f2c896bd09f1$var$Modifier.Position.RIGHT;
        this.render_options = {
            harsh: false,
            vibrato_width: 20,
            wave_height: 6,
            wave_width: 4,
            wave_girth: 2
        };
        this.setVibratoWidth(this.render_options.vibrato_width);
    }
    setHarsh(harsh) {
        this.render_options.harsh = harsh;
        return this;
    }
    setVibratoWidth(width9) {
        this.render_options.vibrato_width = width9;
        this.setWidth(width9);
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const start2 = note2.getModifierStartXY($a801f2c896bd09f1$var$Modifier.Position.RIGHT, this.index);
        const vx = start2.x + this.x_shift;
        const vy = note2.getYForTopText(this.text_line) + 2;
        _Vibrato.renderVibrato(ctx, vx, vy, this.render_options);
    }
    static renderVibrato(ctx, x4, y4, opts) {
        const { harsh: harsh, vibrato_width: vibrato_width, wave_width: wave_width, wave_girth: wave_girth, wave_height: wave_height } = opts;
        const num_waves = vibrato_width / wave_width;
        ctx.beginPath();
        let i2;
        if (harsh) {
            ctx.moveTo(x4, y4 + wave_girth + 1);
            for(i2 = 0; i2 < num_waves / 2; ++i2){
                ctx.lineTo(x4 + wave_width, y4 - wave_height / 2);
                x4 += wave_width;
                ctx.lineTo(x4 + wave_width, y4 + wave_height / 2);
                x4 += wave_width;
            }
            for(i2 = 0; i2 < num_waves / 2; ++i2){
                ctx.lineTo(x4 - wave_width, y4 - wave_height / 2 + wave_girth + 1);
                x4 -= wave_width;
                ctx.lineTo(x4 - wave_width, y4 + wave_height / 2 + wave_girth + 1);
                x4 -= wave_width;
            }
            ctx.fill();
        } else {
            ctx.moveTo(x4, y4 + wave_girth);
            for(i2 = 0; i2 < num_waves / 2; ++i2){
                ctx.quadraticCurveTo(x4 + wave_width / 2, y4 - wave_height / 2, x4 + wave_width, y4);
                x4 += wave_width;
                ctx.quadraticCurveTo(x4 + wave_width / 2, y4 + wave_height / 2, x4 + wave_width, y4);
                x4 += wave_width;
            }
            for(i2 = 0; i2 < num_waves / 2; ++i2){
                ctx.quadraticCurveTo(x4 - wave_width / 2, y4 + wave_height / 2 + wave_girth, x4 - wave_width, y4 + wave_girth);
                x4 -= wave_width;
                ctx.quadraticCurveTo(x4 - wave_width / 2, y4 - wave_height / 2 + wave_girth, x4 - wave_width, y4 + wave_girth);
                x4 -= wave_width;
            }
            ctx.fill();
        }
    }
};
// node_modules/vexflow/build/esm/src/modifiercontext.js
function $a801f2c896bd09f1$var$L16(...args) {
    if ($a801f2c896bd09f1$var$ModifierContext.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.ModifierContext", args);
}
var $a801f2c896bd09f1$var$ModifierContext = class {
    constructor(){
        this.state = {
            left_shift: 0,
            right_shift: 0,
            text_line: 0,
            top_text_line: 0
        };
        this.members = {};
        this.preFormatted = false;
        this.postFormatted = false;
        this.formatted = false;
        this.width = 0;
        this.spacing = 0;
    }
    addModifier(member4) {
        $a801f2c896bd09f1$var$L16("addModifier is deprecated, use addMember instead.");
        return this.addMember(member4);
    }
    addMember(member4) {
        const category = member4.getCategory();
        if (!this.members[category]) this.members[category] = [];
        this.members[category].push(member4);
        member4.setModifierContext(this);
        this.preFormatted = false;
        return this;
    }
    getModifiers(category) {
        $a801f2c896bd09f1$var$L16("getModifiers is deprecated, use getMembers instead.");
        return this.getMembers(category);
    }
    getMembers(category) {
        var _a;
        return (_a = this.members[category]) !== null && _a !== void 0 ? _a : [];
    }
    getWidth() {
        return this.width;
    }
    getLeftShift() {
        return this.state.left_shift;
    }
    getRightShift() {
        return this.state.right_shift;
    }
    getState() {
        return this.state;
    }
    getMetrics() {
        if (!this.formatted) throw new $a801f2c896bd09f1$var$RuntimeError("UnformattedMember", "Unformatted member has no metrics.");
        return {
            width: this.state.left_shift + this.state.right_shift + this.spacing,
            spacing: this.spacing
        };
    }
    preFormat() {
        if (this.preFormatted) return;
        $a801f2c896bd09f1$var$L16("Preformatting ModifierContext");
        const state3 = this.state;
        const members = this.members;
        $a801f2c896bd09f1$var$StaveNote.format(members["StaveNote"], state3);
        $a801f2c896bd09f1$var$Parenthesis.format(members["Parenthesis"], state3);
        $a801f2c896bd09f1$var$Dot.format(members["Dot"], state3);
        $a801f2c896bd09f1$var$FretHandFinger.format(members["FretHandFinger"], state3);
        $a801f2c896bd09f1$var$Accidental.format(members["Accidental"], state3);
        $a801f2c896bd09f1$var$Stroke.format(members["Stroke"], state3);
        $a801f2c896bd09f1$var$GraceNoteGroup.format(members["GraceNoteGroup"], state3);
        $a801f2c896bd09f1$var$NoteSubGroup.format(members["NoteSubGroup"], state3);
        $a801f2c896bd09f1$var$StringNumber.format(members["StringNumber"], state3);
        $a801f2c896bd09f1$var$Articulation.format(members["Articulation"], state3);
        $a801f2c896bd09f1$var$Ornament.format(members["Ornament"], state3);
        $a801f2c896bd09f1$var$Annotation.format(members["Annotation"], state3);
        $a801f2c896bd09f1$var$ChordSymbol.format(members["ChordSymbol"], state3);
        $a801f2c896bd09f1$var$Bend.format(members["Bend"], state3);
        $a801f2c896bd09f1$var$Vibrato.format(members["Vibrato"], state3, this);
        this.width = state3.left_shift + state3.right_shift;
        this.preFormatted = true;
    }
    postFormat() {
        if (this.postFormatted) return;
        $a801f2c896bd09f1$var$L16("Postformatting ModifierContext");
        $a801f2c896bd09f1$var$StaveNote.postFormat(this.getMembers("StaveNote"));
    }
};
$a801f2c896bd09f1$var$ModifierContext.DEBUG = false;
// node_modules/vexflow/build/esm/src/keysignature.js
var $a801f2c896bd09f1$var$KeySignature = class _KeySignature extends $a801f2c896bd09f1$var$StaveModifier {
    static get CATEGORY() {
        return "KeySignature";
    }
    constructor(keySpec, cancelKeySpec, alterKeySpec){
        super();
        this.accList = [];
        this.setKeySig(keySpec, cancelKeySpec, alterKeySpec);
        this.setPosition($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN);
        this.glyphFontScale = $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE;
        this.glyphs = [];
        this.xPositions = [];
        this.paddingForced = false;
    }
    convertToGlyph(acc, nextAcc) {
        const accGlyphData = $a801f2c896bd09f1$var$Tables.accidentalCodes(acc.type);
        const glyph = new $a801f2c896bd09f1$var$Glyph(accGlyphData.code, this.glyphFontScale);
        let extraWidth = 1;
        if (acc.type === "n" && nextAcc) {
            const spacing = _KeySignature.accidentalSpacing[nextAcc.type];
            if (spacing) {
                const isAbove = nextAcc.line >= acc.line;
                extraWidth = isAbove ? spacing.above : spacing.below;
            }
        }
        this.placeGlyphOnLine(glyph, this.checkStave(), acc.line);
        this.glyphs.push(glyph);
        const xPosition = this.xPositions[this.xPositions.length - 1];
        const glyphWidth = glyph.getMetrics().width + extraWidth;
        this.xPositions.push(xPosition + glyphWidth);
        this.width += glyphWidth;
    }
    cancelKey(spec) {
        this.formatted = false;
        this.cancelKeySpec = spec;
        return this;
    }
    convertToCancelAccList(spec) {
        const cancel_accList = $a801f2c896bd09f1$var$Tables.keySignature(spec);
        const different_types = this.accList.length > 0 && cancel_accList.length > 0 && cancel_accList[0].type !== this.accList[0].type;
        const naturals = different_types ? cancel_accList.length : cancel_accList.length - this.accList.length;
        if (naturals < 1) return void 0;
        const cancelled = [];
        for(let i2 = 0; i2 < naturals; i2++){
            let index5 = i2;
            if (!different_types) index5 = cancel_accList.length - naturals + i2;
            const acc = cancel_accList[index5];
            cancelled.push({
                type: "n",
                line: acc.line
            });
        }
        this.accList = cancelled.concat(this.accList);
        return {
            accList: cancelled,
            type: cancel_accList[0].type
        };
    }
    addToStave(stave) {
        this.paddingForced = true;
        stave.addModifier(this);
        return this;
    }
    convertAccLines(clef, type, accList = this.accList) {
        let offset2 = 0;
        let customLines;
        switch(clef){
            case "soprano":
                if (type === "#") customLines = [
                    2.5,
                    0.5,
                    2,
                    0,
                    1.5,
                    -0.5,
                    1
                ];
                else offset2 = -1;
                break;
            case "mezzo-soprano":
                if (type === "b") customLines = [
                    0,
                    2,
                    0.5,
                    2.5,
                    1,
                    3,
                    1.5
                ];
                else offset2 = 1.5;
                break;
            case "alto":
                offset2 = 0.5;
                break;
            case "tenor":
                if (type === "#") customLines = [
                    3,
                    1,
                    2.5,
                    0.5,
                    2,
                    0,
                    1.5
                ];
                else offset2 = -0.5;
                break;
            case "baritone-f":
            case "baritone-c":
                if (type === "b") customLines = [
                    0.5,
                    2.5,
                    1,
                    3,
                    1.5,
                    3.5,
                    2
                ];
                else offset2 = 2;
                break;
            case "bass":
            case "french":
                offset2 = 1;
                break;
            default:
                break;
        }
        let i2;
        if (typeof customLines !== "undefined") for(i2 = 0; i2 < accList.length; ++i2)accList[i2].line = customLines[i2];
        else if (offset2 !== 0) for(i2 = 0; i2 < accList.length; ++i2)accList[i2].line += offset2;
    }
    getPadding(index5) {
        if (!this.formatted) this.format();
        return this.glyphs.length === 0 || !this.paddingForced && index5 < 2 ? 0 : this.padding;
    }
    getWidth() {
        if (!this.formatted) this.format();
        return this.width;
    }
    setKeySig(keySpec, cancelKeySpec, alterKeySpec) {
        this.formatted = false;
        this.keySpec = keySpec;
        this.cancelKeySpec = cancelKeySpec;
        this.alterKeySpec = alterKeySpec;
        return this;
    }
    alterKey(alterKeySpec) {
        this.formatted = false;
        this.alterKeySpec = alterKeySpec;
        return this;
    }
    convertToAlterAccList(alterKeySpec) {
        const max10 = Math.min(alterKeySpec.length, this.accList.length);
        for(let i2 = 0; i2 < max10; ++i2)if (alterKeySpec[i2]) this.accList[i2].type = alterKeySpec[i2];
    }
    format() {
        const stave = this.checkStave();
        this.width = 0;
        this.glyphs = [];
        this.xPositions = [
            0
        ];
        this.accList = $a801f2c896bd09f1$var$Tables.keySignature($a801f2c896bd09f1$var$defined(this.keySpec));
        const accList = this.accList;
        const firstAccidentalType = accList.length > 0 ? accList[0].type : void 0;
        let cancelAccList;
        if (this.cancelKeySpec) cancelAccList = this.convertToCancelAccList(this.cancelKeySpec);
        if (this.alterKeySpec) this.convertToAlterAccList(this.alterKeySpec);
        if (this.accList.length > 0) {
            const clef = (this.position === $a801f2c896bd09f1$var$StaveModifierPosition.END ? stave.getEndClef() : stave.getClef()) || stave.getClef();
            if (cancelAccList) this.convertAccLines(clef, cancelAccList.type, cancelAccList.accList);
            this.convertAccLines(clef, firstAccidentalType, accList);
            for(let i2 = 0; i2 < this.accList.length; ++i2)this.convertToGlyph(this.accList[i2], this.accList[i2 + 1]);
        }
        this.formatted = true;
    }
    getGlyphs() {
        if (!this.formatted) this.format();
        return this.glyphs;
    }
    draw() {
        const stave = this.checkStave();
        const ctx = stave.checkContext();
        if (!this.formatted) this.format();
        this.setRendered();
        this.applyStyle(ctx);
        ctx.openGroup("keysignature", this.getAttribute("id"));
        for(let i2 = 0; i2 < this.glyphs.length; i2++){
            const glyph = this.glyphs[i2];
            const x4 = this.x + this.xPositions[i2];
            glyph.setStave(stave);
            glyph.setContext(ctx);
            glyph.renderToStave(x4);
        }
        ctx.closeGroup();
        this.restoreStyle(ctx);
    }
};
$a801f2c896bd09f1$var$KeySignature.accidentalSpacing = {
    "#": {
        above: 6,
        below: 4
    },
    b: {
        above: 4,
        below: 7
    },
    n: {
        above: 4,
        below: 1
    },
    "##": {
        above: 6,
        below: 4
    },
    bb: {
        above: 4,
        below: 7
    },
    db: {
        above: 4,
        below: 7
    },
    d: {
        above: 4,
        below: 7
    },
    bbs: {
        above: 4,
        below: 7
    },
    "++": {
        above: 6,
        below: 4
    },
    "+": {
        above: 6,
        below: 4
    },
    "+-": {
        above: 6,
        below: 4
    },
    "++-": {
        above: 6,
        below: 4
    },
    bs: {
        above: 4,
        below: 10
    },
    bss: {
        above: 4,
        below: 10
    }
};
// node_modules/vexflow/build/esm/src/staverepetition.js
var $a801f2c896bd09f1$var$Repetition = class _Repetition extends $a801f2c896bd09f1$var$StaveModifier {
    static get CATEGORY() {
        return "Repetition";
    }
    constructor(type, x4, y_shift){
        super();
        this.symbol_type = type;
        this.x = x4;
        this.x_shift = 0;
        this.y_shift = y_shift;
        this.resetFont();
    }
    setShiftX(x4) {
        this.x_shift = x4;
        return this;
    }
    setShiftY(y4) {
        this.y_shift = y4;
        return this;
    }
    draw(stave, x4) {
        this.setRendered();
        switch(this.symbol_type){
            case _Repetition.type.CODA_RIGHT:
                this.drawCodaFixed(stave, x4 + stave.getWidth());
                break;
            case _Repetition.type.CODA_LEFT:
                this.drawSymbolText(stave, x4, "Coda", true);
                break;
            case _Repetition.type.SEGNO_LEFT:
                this.drawSignoFixed(stave, x4);
                break;
            case _Repetition.type.SEGNO_RIGHT:
                this.drawSignoFixed(stave, x4 + stave.getWidth());
                break;
            case _Repetition.type.DC:
                this.drawSymbolText(stave, x4, "D.C.", false);
                break;
            case _Repetition.type.DC_AL_CODA:
                this.drawSymbolText(stave, x4, "D.C. al", true);
                break;
            case _Repetition.type.DC_AL_FINE:
                this.drawSymbolText(stave, x4, "D.C. al Fine", false);
                break;
            case _Repetition.type.DS:
                this.drawSymbolText(stave, x4, "D.S.", false);
                break;
            case _Repetition.type.DS_AL_CODA:
                this.drawSymbolText(stave, x4, "D.S. al", true);
                break;
            case _Repetition.type.DS_AL_FINE:
                this.drawSymbolText(stave, x4, "D.S. al Fine", false);
                break;
            case _Repetition.type.FINE:
                this.drawSymbolText(stave, x4, "Fine", false);
                break;
            case _Repetition.type.TO_CODA:
                this.drawSymbolText(stave, x4, "To", true);
                break;
            default:
                break;
        }
        return this;
    }
    drawCodaFixed(stave, x4) {
        const y4 = stave.getYForTopText(stave.getNumLines()) + this.y_shift;
        $a801f2c896bd09f1$var$Glyph.renderGlyph(stave.checkContext(), this.x + x4 + this.x_shift, y4 + $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("staveRepetition.coda.offsetY"), 40, "coda", {
            category: "coda"
        });
        return this;
    }
    drawSignoFixed(stave, x4) {
        const y4 = stave.getYForTopText(stave.getNumLines()) + this.y_shift;
        $a801f2c896bd09f1$var$Glyph.renderGlyph(stave.checkContext(), this.x + x4 + this.x_shift, y4 + $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("staveRepetition.segno.offsetY"), 30, "segno", {
            category: "segno"
        });
        return this;
    }
    drawSymbolText(stave, x4, text7, draw_coda) {
        var _a;
        const ctx = stave.checkContext();
        ctx.save();
        ctx.setFont(this.textFont);
        let text_x = 0;
        let symbol_x = 0;
        const modifierWidth = stave.getNoteStartX() - this.x;
        switch(this.symbol_type){
            case _Repetition.type.CODA_LEFT:
                text_x = this.x + stave.getVerticalBarWidth();
                symbol_x = text_x + ctx.measureText(text7).width + $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetX");
                break;
            case _Repetition.type.DC:
            case _Repetition.type.DC_AL_FINE:
            case _Repetition.type.DS:
            case _Repetition.type.DS_AL_FINE:
            case _Repetition.type.FINE:
                text_x = this.x + x4 + this.x_shift + stave.getWidth() - $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("staveRepetition.symbolText.spacing") - modifierWidth - ctx.measureText(text7).width;
                break;
            default:
                text_x = this.x + x4 + this.x_shift + stave.getWidth() - $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("staveRepetition.symbolText.spacing") - modifierWidth - ctx.measureText(text7).width - $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetX");
                symbol_x = text_x + ctx.measureText(text7).width + $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetX");
                break;
        }
        const y4 = stave.getYForTopText(stave.getNumLines()) + this.y_shift + $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetY");
        if (draw_coda) $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, symbol_x, y4, $a801f2c896bd09f1$var$Font.convertSizeToPointValue((_a = this.textFont) === null || _a === void 0 ? void 0 : _a.size) * 2, "coda", {
            category: "coda"
        });
        ctx.fillText(text7, text_x, y4 + 5);
        ctx.restore();
        return this;
    }
};
$a801f2c896bd09f1$var$Repetition.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SERIF,
    size: $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE / 3,
    weight: $a801f2c896bd09f1$var$FontWeight.BOLD,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
$a801f2c896bd09f1$var$Repetition.type = {
    NONE: 1,
    CODA_LEFT: 2,
    CODA_RIGHT: 3,
    SEGNO_LEFT: 4,
    SEGNO_RIGHT: 5,
    DC: 6,
    DC_AL_CODA: 7,
    DC_AL_FINE: 8,
    DS: 9,
    DS_AL_CODA: 10,
    DS_AL_FINE: 11,
    FINE: 12,
    TO_CODA: 13
};
// node_modules/vexflow/build/esm/src/stavesection.js
var $a801f2c896bd09f1$var$StaveSection = class extends $a801f2c896bd09f1$var$StaveModifier {
    static get CATEGORY() {
        return "StaveSection";
    }
    constructor(section2, x4, shift_y, drawRect = true){
        super();
        this.setWidth(16);
        this.section = section2;
        this.x = x4;
        this.shift_x = 0;
        this.shift_y = shift_y;
        this.drawRect = drawRect;
        this.resetFont();
    }
    setStaveSection(section2) {
        this.section = section2;
        return this;
    }
    setShiftX(x4) {
        this.shift_x = x4;
        return this;
    }
    setShiftY(y4) {
        this.shift_y = y4;
        return this;
    }
    draw(stave, shift_x) {
        const borderWidth = 2;
        const padding = 2;
        const ctx = stave.checkContext();
        this.setRendered();
        ctx.save();
        ctx.setLineWidth(borderWidth);
        ctx.setFont(this.textFont);
        const textFormatter = $a801f2c896bd09f1$var$TextFormatter.create(this.textFont);
        const textWidth = textFormatter.getWidthForTextInPx(this.section);
        const textY = textFormatter.getYForStringInPx(this.section);
        const textHeight = textY.height;
        const headroom = -1 * textY.yMin;
        const width9 = textWidth + 2 * padding;
        const height9 = textHeight + 2 * padding;
        const y4 = stave.getYForTopText(1.5) + this.shift_y;
        const x4 = this.x + shift_x;
        if (this.drawRect) {
            ctx.beginPath();
            ctx.rect(x4, y4 - height9 + headroom, width9, height9);
            ctx.stroke();
        }
        ctx.fillText(this.section, x4 + padding, y4 - padding);
        ctx.restore();
        return this;
    }
};
$a801f2c896bd09f1$var$StaveSection.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SANS_SERIF,
    size: 10,
    weight: $a801f2c896bd09f1$var$FontWeight.BOLD,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
// node_modules/vexflow/build/esm/src/stavetempo.js
var $a801f2c896bd09f1$var$StaveTempo = class extends $a801f2c896bd09f1$var$StaveModifier {
    static get CATEGORY() {
        return "StaveTempo";
    }
    constructor(tempo, x4, shift_y){
        super();
        this.render_options = {
            glyph_font_scale: 30
        };
        this.tempo = tempo;
        this.position = $a801f2c896bd09f1$var$StaveModifierPosition.ABOVE;
        this.x = x4;
        this.shift_x = 10;
        this.shift_y = shift_y;
        this.resetFont();
    }
    setTempo(tempo) {
        this.tempo = tempo;
        return this;
    }
    setShiftX(x4) {
        this.shift_x = x4;
        return this;
    }
    setShiftY(y4) {
        this.shift_y = y4;
        return this;
    }
    draw(stave, shift_x) {
        const ctx = stave.checkContext();
        this.setRendered();
        const options2 = this.render_options;
        const scale = options2.glyph_font_scale / $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE;
        const name17 = this.tempo.name;
        const duration2 = this.tempo.duration;
        const dots = this.tempo.dots || 0;
        const bpm = this.tempo.bpm;
        let x4 = this.x + this.shift_x + shift_x;
        const y4 = stave.getYForTopText(1) + this.shift_y;
        ctx.save();
        const textFormatter = $a801f2c896bd09f1$var$TextFormatter.create(this.textFont);
        if (name17) {
            ctx.setFont(this.textFont);
            ctx.fillText(name17, x4, y4);
            x4 += textFormatter.getWidthForTextInPx(name17);
        }
        if (duration2 && bpm) {
            const noteTextFont = Object.assign(Object.assign({}, this.textFont), {
                weight: "normal",
                style: "normal"
            });
            ctx.setFont(noteTextFont);
            const noteTextFormatter = $a801f2c896bd09f1$var$TextFormatter.create(noteTextFont);
            if (name17) {
                x4 += noteTextFormatter.getWidthForTextInPx("|");
                ctx.fillText("(", x4, y4);
                x4 += noteTextFormatter.getWidthForTextInPx("(");
            }
            const glyphProps = $a801f2c896bd09f1$var$Tables.getGlyphProps(duration2);
            x4 += 3 * scale;
            $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, x4, y4, options2.glyph_font_scale, glyphProps.code_head);
            x4 += $a801f2c896bd09f1$var$Glyph.getWidth(glyphProps.code_head, options2.glyph_font_scale);
            if (glyphProps.stem) {
                let stem_height = 30;
                if (glyphProps.beam_count) stem_height += 3 * (glyphProps.beam_count - 1);
                stem_height *= scale;
                const y_top = y4 - stem_height;
                ctx.fillRect(x4 - scale, y_top, scale, stem_height);
                if (glyphProps.code && glyphProps.code_flag_upstem) {
                    const flagMetrics = $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, x4, y_top, options2.glyph_font_scale, glyphProps.code_flag_upstem, {
                        category: "flag.staveTempo"
                    });
                    x4 += flagMetrics.width * $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE / flagMetrics.font.getData().resolution;
                }
            }
            for(let i2 = 0; i2 < dots; i2++){
                x4 += 6 * scale;
                ctx.beginPath();
                ctx.arc(x4, y4 + 2 * scale, 2 * scale, 0, Math.PI * 2, false);
                ctx.fill();
            }
            ctx.fillText(" = " + bpm + (name17 ? ")" : ""), x4 + 3 * scale, y4);
        }
        ctx.restore();
        return this;
    }
};
$a801f2c896bd09f1$var$StaveTempo.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SERIF,
    size: 14,
    weight: $a801f2c896bd09f1$var$FontWeight.BOLD,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
// node_modules/vexflow/build/esm/src/textnote.js
var $a801f2c896bd09f1$var$TextJustification;
(function(TextJustification2) {
    TextJustification2[TextJustification2["LEFT"] = 1] = "LEFT";
    TextJustification2[TextJustification2["CENTER"] = 2] = "CENTER";
    TextJustification2[TextJustification2["RIGHT"] = 3] = "RIGHT";
})($a801f2c896bd09f1$var$TextJustification || ($a801f2c896bd09f1$var$TextJustification = {}));
var $a801f2c896bd09f1$var$TextNote = class _TextNote extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "TextNote";
    }
    static get GLYPHS() {
        return {
            segno: {
                code: "segno"
            },
            tr: {
                code: "ornamentTrill"
            },
            mordent: {
                code: "ornamentMordent"
            },
            mordent_upper: {
                code: "ornamentShortTrill"
            },
            mordent_lower: {
                code: "ornamentMordent"
            },
            f: {
                code: "dynamicForte"
            },
            p: {
                code: "dynamicPiano"
            },
            m: {
                code: "dynamicMezzo"
            },
            s: {
                code: "dynamicSforzando"
            },
            z: {
                code: "dynamicZ"
            },
            coda: {
                code: "coda"
            },
            pedal_open: {
                code: "keyboardPedalPed"
            },
            pedal_close: {
                code: "keyboardPedalUp"
            },
            caesura_straight: {
                code: "caesura"
            },
            caesura_curved: {
                code: "caesuraCurved"
            },
            breath: {
                code: "breathMarkComma"
            },
            tick: {
                code: "breathMarkTick"
            },
            turn: {
                code: "ornamentTurn"
            },
            turn_inverted: {
                code: "ornamentTurnSlash"
            }
        };
    }
    constructor(noteStruct){
        super(noteStruct);
        this.text = noteStruct.text || "";
        this.superscript = noteStruct.superscript;
        this.subscript = noteStruct.subscript;
        this.setFont(noteStruct.font);
        this.line = noteStruct.line || 0;
        this.smooth = noteStruct.smooth || false;
        this.ignore_ticks = noteStruct.ignore_ticks || false;
        this.justification = $a801f2c896bd09f1$var$TextJustification.LEFT;
        if (noteStruct.glyph) {
            const struct = _TextNote.GLYPHS[noteStruct.glyph];
            if (!struct) throw new $a801f2c896bd09f1$var$RuntimeError("Invalid glyph type: " + noteStruct.glyph);
            this.glyph = new $a801f2c896bd09f1$var$Glyph(struct.code, $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE, {
                category: "textNote"
            });
            this.setWidth(this.glyph.getMetrics().width);
        } else this.glyph = void 0;
    }
    setJustification(just) {
        this.justification = just;
        return this;
    }
    setLine(line2) {
        this.line = line2;
        return this;
    }
    getLine() {
        return this.line;
    }
    getText() {
        return this.text;
    }
    preFormat() {
        if (this.preFormatted) return;
        const tickContext = this.checkTickContext(`Can't preformat without a TickContext.`);
        if (this.smooth) this.setWidth(0);
        else {
            if (this.glyph) ;
            else {
                const ctx = this.checkContext();
                ctx.setFont(this.textFont);
                this.setWidth(ctx.measureText(this.text).width);
            }
        }
        if (this.justification === $a801f2c896bd09f1$var$TextJustification.CENTER) this.leftDisplacedHeadPx = this.width / 2;
        else if (this.justification === $a801f2c896bd09f1$var$TextJustification.RIGHT) this.leftDisplacedHeadPx = this.width;
        this.rightDisplacedHeadPx = tickContext.getMetrics().glyphPx / 2;
        this.preFormatted = true;
    }
    draw() {
        const ctx = this.checkContext();
        const stave = this.checkStave();
        const tickContext = this.checkTickContext(`Can't draw without a TickContext.`);
        this.setRendered();
        let x4 = this.getAbsoluteX() + tickContext.getMetrics().glyphPx / 2;
        const width9 = this.getWidth();
        if (this.justification === $a801f2c896bd09f1$var$TextJustification.CENTER) x4 -= width9 / 2;
        else if (this.justification === $a801f2c896bd09f1$var$TextJustification.RIGHT) x4 -= width9;
        let y4;
        if (this.glyph) {
            y4 = stave.getYForLine(this.line + -3);
            this.glyph.render(ctx, x4, y4);
        } else {
            y4 = stave.getYForLine(this.line + -3);
            this.applyStyle(ctx);
            ctx.setFont(this.textFont);
            ctx.fillText(this.text, x4, y4);
            const height9 = ctx.measureText(this.text).height;
            const { family: family, size: size6, weight: weight, style: style3 } = this.textFont;
            const smallerFontSize = $a801f2c896bd09f1$var$Font.scaleSize(size6, 0.769231);
            if (this.superscript) {
                ctx.setFont(family, smallerFontSize, weight, style3);
                ctx.fillText(this.superscript, x4 + this.width + 2, y4 - height9 / 2.2);
            }
            if (this.subscript) {
                ctx.setFont(family, smallerFontSize, weight, style3);
                ctx.fillText(this.subscript, x4 + this.width + 2, y4 + height9 / 2.2 - 1);
            }
            this.restoreStyle(ctx);
        }
    }
};
$a801f2c896bd09f1$var$TextNote.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SANS_SERIF,
    size: 12,
    weight: $a801f2c896bd09f1$var$FontWeight.NORMAL,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
$a801f2c896bd09f1$var$TextNote.Justification = $a801f2c896bd09f1$var$TextJustification;
// node_modules/vexflow/build/esm/src/stavetext.js
var $a801f2c896bd09f1$var$StaveText = class extends $a801f2c896bd09f1$var$StaveModifier {
    static get CATEGORY() {
        return "StaveText";
    }
    constructor(text7, position2, options2 = {}){
        super();
        this.setWidth(16);
        this.text = text7;
        this.position = position2;
        this.options = Object.assign({
            shift_x: 0,
            shift_y: 0,
            justification: $a801f2c896bd09f1$var$TextNote.Justification.CENTER
        }, options2);
        this.resetFont();
    }
    setStaveText(text7) {
        this.text = text7;
        return this;
    }
    setShiftX(x4) {
        this.shift_x = x4;
        return this;
    }
    setShiftY(y4) {
        this.shift_y = y4;
        return this;
    }
    setText(text7) {
        this.text = text7;
        return this;
    }
    draw(stave) {
        const ctx = stave.checkContext();
        this.setRendered();
        ctx.save();
        ctx.setLineWidth(2);
        ctx.setFont(this.textFont);
        const text_width = ctx.measureText("" + this.text).width;
        let x4;
        let y4;
        switch(this.position){
            case $a801f2c896bd09f1$var$StaveModifierPosition.LEFT:
            case $a801f2c896bd09f1$var$StaveModifierPosition.RIGHT:
                y4 = (stave.getYForLine(0) + stave.getBottomLineY()) / 2 + this.options.shift_y;
                if (this.position === $a801f2c896bd09f1$var$StaveModifierPosition.LEFT) x4 = stave.getX() - text_width - 24 + this.options.shift_x;
                else x4 = stave.getX() + stave.getWidth() + 24 + this.options.shift_x;
                break;
            case $a801f2c896bd09f1$var$StaveModifierPosition.ABOVE:
            case $a801f2c896bd09f1$var$StaveModifierPosition.BELOW:
                x4 = stave.getX() + this.options.shift_x;
                if (this.options.justification === $a801f2c896bd09f1$var$TextJustification.CENTER) x4 += stave.getWidth() / 2 - text_width / 2;
                else if (this.options.justification === $a801f2c896bd09f1$var$TextJustification.RIGHT) x4 += stave.getWidth() - text_width;
                if (this.position === $a801f2c896bd09f1$var$StaveModifierPosition.ABOVE) y4 = stave.getYForTopText(2) + this.options.shift_y;
                else y4 = stave.getYForBottomText(2) + this.options.shift_y;
                break;
            default:
                throw new $a801f2c896bd09f1$var$RuntimeError("InvalidPosition", "Value Must be in Modifier.Position.");
        }
        ctx.fillText("" + this.text, x4, y4 + 4);
        ctx.restore();
        return this;
    }
};
$a801f2c896bd09f1$var$StaveText.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SERIF,
    size: 16,
    weight: $a801f2c896bd09f1$var$FontWeight.NORMAL,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
// node_modules/vexflow/build/esm/src/stavevolta.js
var $a801f2c896bd09f1$var$VoltaType;
(function(VoltaType2) {
    VoltaType2[VoltaType2["NONE"] = 1] = "NONE";
    VoltaType2[VoltaType2["BEGIN"] = 2] = "BEGIN";
    VoltaType2[VoltaType2["MID"] = 3] = "MID";
    VoltaType2[VoltaType2["END"] = 4] = "END";
    VoltaType2[VoltaType2["BEGIN_END"] = 5] = "BEGIN_END";
})($a801f2c896bd09f1$var$VoltaType || ($a801f2c896bd09f1$var$VoltaType = {}));
var $a801f2c896bd09f1$var$Volta = class extends $a801f2c896bd09f1$var$StaveModifier {
    static get CATEGORY() {
        return "Volta";
    }
    static get type() {
        return $a801f2c896bd09f1$var$VoltaType;
    }
    constructor(type, number, x4, y_shift){
        super();
        this.volta = type;
        this.x = x4;
        this.y_shift = y_shift;
        this.number = number;
        this.resetFont();
    }
    setShiftY(y4) {
        this.y_shift = y4;
        return this;
    }
    draw(stave, x4) {
        const ctx = stave.checkContext();
        this.setRendered();
        let width9 = stave.getWidth() - x4;
        const top_y = stave.getYForTopText(stave.getNumLines()) + this.y_shift;
        const vert_height = 1.5 * stave.getSpacingBetweenLines();
        switch(this.volta){
            case $a801f2c896bd09f1$var$VoltaType.BEGIN:
                ctx.fillRect(this.x + x4, top_y, 1, vert_height);
                break;
            case $a801f2c896bd09f1$var$VoltaType.END:
                width9 -= 5;
                ctx.fillRect(this.x + x4 + width9, top_y, 1, vert_height);
                break;
            case $a801f2c896bd09f1$var$VoltaType.BEGIN_END:
                width9 -= 3;
                ctx.fillRect(this.x + x4, top_y, 1, vert_height);
                ctx.fillRect(this.x + x4 + width9, top_y, 1, vert_height);
                break;
            default:
                break;
        }
        if (this.volta === $a801f2c896bd09f1$var$VoltaType.BEGIN || this.volta === $a801f2c896bd09f1$var$VoltaType.BEGIN_END) {
            ctx.save();
            ctx.setFont(this.textFont);
            ctx.fillText(this.number, this.x + x4 + 5, top_y + 15);
            ctx.restore();
        }
        ctx.fillRect(this.x + x4, top_y, width9, 1);
        return this;
    }
};
$a801f2c896bd09f1$var$Volta.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SANS_SERIF,
    size: 9,
    weight: $a801f2c896bd09f1$var$FontWeight.BOLD,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
// node_modules/vexflow/build/esm/src/timesigglyph.js
var $a801f2c896bd09f1$var$TimeSignatureGlyph = class extends $a801f2c896bd09f1$var$Glyph {
    constructor(timeSignature, topDigits, botDigits, code3, point, options2){
        var _a;
        super(code3, point, options2);
        this.timeSignature = timeSignature;
        this.topGlyphs = [];
        this.botGlyphs = [];
        let topWidth = 0;
        let height9 = 0;
        for(let i2 = 0; i2 < topDigits.length; ++i2){
            let timeSigType = topDigits[i2];
            switch(topDigits[i2]){
                case "-":
                    timeSigType = "Minus";
                    break;
                case "+":
                    timeSigType = botDigits.length > 0 ? "PlusSmall" : "Plus";
                    break;
                case "(":
                    timeSigType = botDigits.length > 0 ? "ParensLeftSmall" : "ParensLeft";
                    break;
                case ")":
                    timeSigType = botDigits.length > 0 ? "ParensRightSmall" : "ParensRight";
                    break;
            }
            const topGlyph = new $a801f2c896bd09f1$var$Glyph("timeSig" + timeSigType, this.timeSignature.point);
            this.topGlyphs.push(topGlyph);
            topWidth += (_a = topGlyph.getMetrics().width) !== null && _a !== void 0 ? _a : 0;
            height9 = Math.max(height9, topGlyph.getMetrics().height);
        }
        let botWidth = 0;
        for(let i2 = 0; i2 < botDigits.length; ++i2){
            let timeSigType = botDigits[i2];
            switch(botDigits[i2]){
                case "+":
                    timeSigType = "PlusSmall";
                    break;
                case "(":
                    timeSigType = "ParensLeftSmall";
                    break;
                case ")":
                    timeSigType = "ParensRightSmall";
                    break;
            }
            const botGlyph = new $a801f2c896bd09f1$var$Glyph("timeSig" + timeSigType, this.timeSignature.point);
            this.botGlyphs.push(botGlyph);
            botWidth += $a801f2c896bd09f1$var$defined(botGlyph.getMetrics().width);
            height9 = Math.max(height9, botGlyph.getMetrics().height);
        }
        this.lineShift = height9 > 22 ? 1 : 0;
        this.width = Math.max(topWidth, botWidth);
        this.xMin = this.getMetrics().x_min;
        this.topStartX = (this.width - topWidth) / 2;
        this.botStartX = (this.width - botWidth) / 2;
        this.reset();
    }
    getMetrics() {
        return {
            x_min: this.xMin,
            x_max: this.xMin + this.width,
            width: this.width
        };
    }
    renderToStave(x4) {
        const stave = this.checkStave();
        const ctx = this.checkContext();
        let start_x = x4 + this.topStartX;
        let y4 = 0;
        if (this.botGlyphs.length > 0) y4 = stave.getYForLine(this.timeSignature.topLine - this.lineShift);
        else y4 = (stave.getYForLine(this.timeSignature.topLine) + stave.getYForLine(this.timeSignature.bottomLine)) / 2;
        for(let i2 = 0; i2 < this.topGlyphs.length; ++i2){
            const glyph = this.topGlyphs[i2];
            $a801f2c896bd09f1$var$Glyph.renderOutline(ctx, glyph.getMetrics().outline, this.scale, start_x + this.x_shift, y4);
            start_x += $a801f2c896bd09f1$var$defined(glyph.getMetrics().width);
        }
        start_x = x4 + this.botStartX;
        y4 = stave.getYForLine(this.timeSignature.bottomLine + this.lineShift);
        for(let i2 = 0; i2 < this.botGlyphs.length; ++i2){
            const glyph = this.botGlyphs[i2];
            this.timeSignature.placeGlyphOnLine(glyph, stave, this.timeSignature.getLine());
            $a801f2c896bd09f1$var$Glyph.renderOutline(ctx, glyph.getMetrics().outline, this.scale, start_x + glyph.getMetrics().x_shift, y4);
            start_x += $a801f2c896bd09f1$var$defined(glyph.getMetrics().width);
        }
    }
};
// node_modules/vexflow/build/esm/src/timesignature.js
var $a801f2c896bd09f1$var$assertIsValidTimeSig = (timeSpec)=>{
    const numbers = timeSpec.split("/");
    if (numbers.length !== 2 && numbers[0] !== "+" && numbers[0] !== "-") throw new $a801f2c896bd09f1$var$RuntimeError("BadTimeSignature", `Invalid time spec: ${timeSpec}. Must be in the form "<numerator>/<denominator>"`);
    numbers.forEach((number)=>{
        if (/^[0-9+\-()]+$/.test(number) == false) throw new $a801f2c896bd09f1$var$RuntimeError("BadTimeSignature", `Invalid time spec: ${timeSpec}. Must contain valid signatures.`);
    });
};
var $a801f2c896bd09f1$var$TimeSignature = class _TimeSignature extends $a801f2c896bd09f1$var$StaveModifier {
    static get CATEGORY() {
        return "TimeSignature";
    }
    static get glyphs() {
        return {
            C: {
                code: "timeSigCommon",
                line: 2
            },
            "C|": {
                code: "timeSigCutCommon",
                line: 2
            }
        };
    }
    constructor(timeSpec = "4/4", customPadding = 15, validate_args = true){
        super();
        this.timeSpec = "4/4";
        this.line = 0;
        this.is_numeric = true;
        this.validate_args = validate_args;
        const padding = customPadding;
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        this.point = musicFont.lookupMetric("digits.point") || $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE;
        const fontLineShift = musicFont.lookupMetric("digits.shiftLine", 0);
        this.topLine = 2 + fontLineShift;
        this.bottomLine = 4 + fontLineShift;
        this.setPosition($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN);
        this.setTimeSig(timeSpec);
        this.setPadding(padding);
    }
    parseTimeSpec(timeSpec) {
        var _a, _b;
        if (timeSpec === "C" || timeSpec === "C|") {
            const { line: line2, code: code3 } = _TimeSignature.glyphs[timeSpec];
            return {
                line: line2,
                num: false,
                glyph: new $a801f2c896bd09f1$var$Glyph(code3, $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE)
            };
        }
        if (this.validate_args) $a801f2c896bd09f1$var$assertIsValidTimeSig(timeSpec);
        const parts = timeSpec.split("/");
        return {
            line: 0,
            num: true,
            glyph: this.makeTimeSignatureGlyph((_a = parts[0]) !== null && _a !== void 0 ? _a : "", (_b = parts[1]) !== null && _b !== void 0 ? _b : "")
        };
    }
    makeTimeSignatureGlyph(topDigits, botDigits) {
        return new $a801f2c896bd09f1$var$TimeSignatureGlyph(this, topDigits, botDigits, "timeSig0", this.point);
    }
    getInfo() {
        const { line: line2, is_numeric: is_numeric, glyph: glyph } = this;
        return {
            line: line2,
            num: is_numeric,
            glyph: glyph
        };
    }
    setTimeSig(timeSpec) {
        this.timeSpec = timeSpec;
        const info2 = this.parseTimeSpec(timeSpec);
        this.setGlyph(info2.glyph);
        this.is_numeric = info2.num;
        this.line = info2.line;
        return this;
    }
    getTimeSpec() {
        return this.timeSpec;
    }
    getLine() {
        return this.line;
    }
    setLine(line2) {
        this.line = line2;
    }
    getGlyph() {
        return this.glyph;
    }
    setGlyph(glyph) {
        this.glyph = glyph;
        this.setWidth($a801f2c896bd09f1$var$defined(this.glyph.getMetrics().width));
    }
    getIsNumeric() {
        return this.is_numeric;
    }
    setIsNumeric(isNumeric) {
        this.is_numeric = isNumeric;
    }
    draw() {
        const stave = this.checkStave();
        const ctx = stave.checkContext();
        this.setRendered();
        this.applyStyle(ctx);
        ctx.openGroup("timesignature", this.getAttribute("id"));
        this.glyph.setStave(stave);
        this.glyph.setContext(ctx);
        this.placeGlyphOnLine(this.glyph, stave, this.line);
        this.glyph.renderToStave(this.x);
        ctx.closeGroup();
        this.restoreStyle(ctx);
    }
};
// node_modules/vexflow/build/esm/src/stave.js
var $a801f2c896bd09f1$var$SORT_ORDER_BEG_MODIFIERS = {
    [$a801f2c896bd09f1$var$Barline.CATEGORY]: 0,
    [$a801f2c896bd09f1$var$Clef.CATEGORY]: 1,
    [$a801f2c896bd09f1$var$KeySignature.CATEGORY]: 2,
    [$a801f2c896bd09f1$var$TimeSignature.CATEGORY]: 3
};
var $a801f2c896bd09f1$var$SORT_ORDER_END_MODIFIERS = {
    [$a801f2c896bd09f1$var$TimeSignature.CATEGORY]: 0,
    [$a801f2c896bd09f1$var$KeySignature.CATEGORY]: 1,
    [$a801f2c896bd09f1$var$Barline.CATEGORY]: 2,
    [$a801f2c896bd09f1$var$Clef.CATEGORY]: 3
};
var $a801f2c896bd09f1$var$Stave = class extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "Stave";
    }
    static get defaultPadding() {
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        return musicFont.lookupMetric("stave.padding") + musicFont.lookupMetric("stave.endPaddingMax");
    }
    static get rightPadding() {
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        return musicFont.lookupMetric("stave.endPaddingMax");
    }
    constructor(x4, y4, width9, options2){
        super();
        this.height = 0;
        this.x = x4;
        this.y = y4;
        this.width = width9;
        this.formatted = false;
        this.start_x = x4 + 5;
        this.end_x = x4 + width9;
        this.modifiers = [];
        this.measure = 0;
        this.clef = "treble";
        this.endClef = void 0;
        this.resetFont();
        this.options = Object.assign({
            vertical_bar_width: 10,
            num_lines: 5,
            fill_style: "#999999",
            left_bar: true,
            right_bar: true,
            spacing_between_lines_px: $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE,
            space_above_staff_ln: 4,
            space_below_staff_ln: 4,
            top_text_position: 1,
            bottom_text_position: 4,
            line_config: []
        }, options2);
        this.bounds = {
            x: this.x,
            y: this.y,
            w: this.width,
            h: 0
        };
        this.defaultLedgerLineStyle = {
            strokeStyle: "#444",
            lineWidth: 1.4
        };
        this.resetLines();
        this.addModifier(new $a801f2c896bd09f1$var$Barline(this.options.left_bar ? $a801f2c896bd09f1$var$BarlineType.SINGLE : $a801f2c896bd09f1$var$BarlineType.NONE));
        this.addEndModifier(new $a801f2c896bd09f1$var$Barline(this.options.right_bar ? $a801f2c896bd09f1$var$BarlineType.SINGLE : $a801f2c896bd09f1$var$BarlineType.NONE));
    }
    setDefaultLedgerLineStyle(style3) {
        this.defaultLedgerLineStyle = style3;
    }
    getDefaultLedgerLineStyle() {
        return Object.assign(Object.assign({}, this.getStyle()), this.defaultLedgerLineStyle);
    }
    space(spacing) {
        return this.options.spacing_between_lines_px * spacing;
    }
    resetLines() {
        this.options.line_config = [];
        for(let i2 = 0; i2 < this.options.num_lines; i2++)this.options.line_config.push({
            visible: true
        });
        this.height = (this.options.num_lines + this.options.space_above_staff_ln) * this.options.spacing_between_lines_px;
        this.options.bottom_text_position = this.options.num_lines;
    }
    setNoteStartX(x4) {
        if (!this.formatted) this.format();
        this.start_x = x4;
        return this;
    }
    getNoteStartX() {
        if (!this.formatted) this.format();
        return this.start_x;
    }
    getNoteEndX() {
        if (!this.formatted) this.format();
        return this.end_x;
    }
    getTieStartX() {
        return this.start_x;
    }
    getTieEndX() {
        return this.end_x;
    }
    getX() {
        return this.x;
    }
    getNumLines() {
        return this.options.num_lines;
    }
    setNumLines(n) {
        this.options.num_lines = n;
        this.resetLines();
        return this;
    }
    setY(y4) {
        this.y = y4;
        return this;
    }
    getY() {
        return this.y;
    }
    getTopLineTopY() {
        return this.getYForLine(0) - $a801f2c896bd09f1$var$Tables.STAVE_LINE_THICKNESS / 2;
    }
    getBottomLineBottomY() {
        return this.getYForLine(this.getNumLines() - 1) + $a801f2c896bd09f1$var$Tables.STAVE_LINE_THICKNESS / 2;
    }
    setX(x4) {
        const shift = x4 - this.x;
        this.formatted = false;
        this.x = x4;
        this.start_x += shift;
        this.end_x += shift;
        for(let i2 = 0; i2 < this.modifiers.length; i2++){
            const mod5 = this.modifiers[i2];
            mod5.setX(mod5.getX() + shift);
        }
        return this;
    }
    setWidth(width9) {
        this.formatted = false;
        this.width = width9;
        this.end_x = this.x + width9;
        return this;
    }
    getWidth() {
        return this.width;
    }
    getStyle() {
        return Object.assign({
            fillStyle: this.options.fill_style,
            strokeStyle: this.options.fill_style,
            lineWidth: $a801f2c896bd09f1$var$Tables.STAVE_LINE_THICKNESS
        }, super.getStyle());
    }
    setMeasure(measure) {
        this.measure = measure;
        return this;
    }
    getMeasure() {
        return this.measure;
    }
    getModifierXShift(index5 = 0) {
        if (typeof index5 !== "number") throw new $a801f2c896bd09f1$var$RuntimeError("InvalidIndex", "Must be of number type");
        if (!this.formatted) this.format();
        if (this.getModifiers($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN).length === 1) return 0;
        if (this.modifiers[index5].getPosition() === $a801f2c896bd09f1$var$StaveModifierPosition.RIGHT) return 0;
        let start_x = this.start_x - this.x;
        const begBarline = this.modifiers[0];
        if (begBarline.getType() === $a801f2c896bd09f1$var$BarlineType.REPEAT_BEGIN && start_x > begBarline.getWidth()) start_x -= begBarline.getWidth();
        return start_x;
    }
    setRepetitionType(type, yShift = 0) {
        this.modifiers.push(new $a801f2c896bd09f1$var$Repetition(type, this.x, yShift));
        return this;
    }
    setVoltaType(type, number_t, y4) {
        this.modifiers.push(new $a801f2c896bd09f1$var$Volta(type, number_t, this.x, y4));
        return this;
    }
    setSection(section2, y4, xOffset = 0, fontSize, drawRect = true) {
        const staveSection = new $a801f2c896bd09f1$var$StaveSection(section2, this.x + xOffset, y4, drawRect);
        if (fontSize) staveSection.setFontSize(fontSize);
        this.modifiers.push(staveSection);
        return this;
    }
    setTempo(tempo, y4) {
        this.modifiers.push(new $a801f2c896bd09f1$var$StaveTempo(tempo, this.x, y4));
        return this;
    }
    setText(text7, position2, options2 = {}) {
        this.modifiers.push(new $a801f2c896bd09f1$var$StaveText(text7, position2, options2));
        return this;
    }
    getHeight() {
        return this.height;
    }
    getSpacingBetweenLines() {
        return this.options.spacing_between_lines_px;
    }
    getBoundingBox() {
        return new $a801f2c896bd09f1$var$BoundingBox(this.x, this.y, this.width, this.getBottomY() - this.y);
    }
    getBottomY() {
        const options2 = this.options;
        const spacing = options2.spacing_between_lines_px;
        const score_bottom = this.getYForLine(options2.num_lines) + options2.space_below_staff_ln * spacing;
        return score_bottom;
    }
    getBottomLineY() {
        return this.getYForLine(this.options.num_lines);
    }
    getYForLine(line2) {
        const options2 = this.options;
        const spacing = options2.spacing_between_lines_px;
        const headroom = options2.space_above_staff_ln;
        const y4 = this.y + line2 * spacing + headroom * spacing;
        return y4;
    }
    getLineForY(y4) {
        const options2 = this.options;
        const spacing = options2.spacing_between_lines_px;
        const headroom = options2.space_above_staff_ln;
        return (y4 - this.y) / spacing - headroom;
    }
    getYForTopText(line2 = 0) {
        return this.getYForLine(-line2 - this.options.top_text_position);
    }
    getYForBottomText(line2 = 0) {
        return this.getYForLine(this.options.bottom_text_position + line2);
    }
    getYForNote(line2) {
        const options2 = this.options;
        const spacing = options2.spacing_between_lines_px;
        const headroom = options2.space_above_staff_ln;
        return this.y + headroom * spacing + 5 * spacing - line2 * spacing;
    }
    getYForGlyphs() {
        return this.getYForLine(3);
    }
    addModifier(modifier, position2) {
        if (position2 !== void 0) modifier.setPosition(position2);
        modifier.setStave(this);
        this.formatted = false;
        this.modifiers.push(modifier);
        return this;
    }
    addEndModifier(modifier) {
        this.addModifier(modifier, $a801f2c896bd09f1$var$StaveModifierPosition.END);
        return this;
    }
    setBegBarType(type) {
        const { SINGLE: SINGLE, REPEAT_BEGIN: REPEAT_BEGIN, NONE: NONE } = $a801f2c896bd09f1$var$BarlineType;
        if (type === SINGLE || type === REPEAT_BEGIN || type === NONE) {
            this.modifiers[0].setType(type);
            this.formatted = false;
        }
        return this;
    }
    setEndBarType(type) {
        if (type !== $a801f2c896bd09f1$var$BarlineType.REPEAT_BEGIN) {
            this.modifiers[1].setType(type);
            this.formatted = false;
        }
        return this;
    }
    setClefLines(clefSpec) {
        this.clef = clefSpec;
        return this;
    }
    setClef(clefSpec, size6, annotation, position2) {
        if (position2 === void 0) position2 = $a801f2c896bd09f1$var$StaveModifierPosition.BEGIN;
        if (position2 === $a801f2c896bd09f1$var$StaveModifierPosition.END) this.endClef = clefSpec;
        else this.clef = clefSpec;
        const clefs2 = this.getModifiers(position2, $a801f2c896bd09f1$var$Clef.CATEGORY);
        if (clefs2.length === 0) this.addClef(clefSpec, size6, annotation, position2);
        else clefs2[0].setType(clefSpec, size6, annotation);
        return this;
    }
    getClef() {
        return this.clef;
    }
    setEndClef(clefSpec, size6, annotation) {
        this.setClef(clefSpec, size6, annotation, $a801f2c896bd09f1$var$StaveModifierPosition.END);
        return this;
    }
    getEndClef() {
        return this.endClef;
    }
    setKeySignature(keySpec, cancelKeySpec, position2) {
        if (position2 === void 0) position2 = $a801f2c896bd09f1$var$StaveModifierPosition.BEGIN;
        const keySignatures2 = this.getModifiers(position2, $a801f2c896bd09f1$var$KeySignature.CATEGORY);
        if (keySignatures2.length === 0) this.addKeySignature(keySpec, cancelKeySpec, position2);
        else keySignatures2[0].setKeySig(keySpec, cancelKeySpec);
        return this;
    }
    setEndKeySignature(keySpec, cancelKeySpec) {
        this.setKeySignature(keySpec, cancelKeySpec, $a801f2c896bd09f1$var$StaveModifierPosition.END);
        return this;
    }
    setTimeSignature(timeSpec, customPadding, position2) {
        if (position2 === void 0) position2 = $a801f2c896bd09f1$var$StaveModifierPosition.BEGIN;
        const timeSignatures = this.getModifiers(position2, $a801f2c896bd09f1$var$TimeSignature.CATEGORY);
        if (timeSignatures.length === 0) this.addTimeSignature(timeSpec, customPadding, position2);
        else timeSignatures[0].setTimeSig(timeSpec);
        return this;
    }
    setEndTimeSignature(timeSpec, customPadding) {
        this.setTimeSignature(timeSpec, customPadding, $a801f2c896bd09f1$var$StaveModifierPosition.END);
        return this;
    }
    addKeySignature(keySpec, cancelKeySpec, position2) {
        if (position2 === void 0) position2 = $a801f2c896bd09f1$var$StaveModifierPosition.BEGIN;
        this.addModifier(new $a801f2c896bd09f1$var$KeySignature(keySpec, cancelKeySpec).setPosition(position2), position2);
        return this;
    }
    addClef(clef, size6, annotation, position2) {
        if (position2 === void 0 || position2 === $a801f2c896bd09f1$var$StaveModifierPosition.BEGIN) this.clef = clef;
        else if (position2 === $a801f2c896bd09f1$var$StaveModifierPosition.END) this.endClef = clef;
        this.addModifier(new $a801f2c896bd09f1$var$Clef(clef, size6, annotation), position2);
        return this;
    }
    addEndClef(clef, size6, annotation) {
        this.addClef(clef, size6, annotation, $a801f2c896bd09f1$var$StaveModifierPosition.END);
        return this;
    }
    addTimeSignature(timeSpec, customPadding, position2) {
        this.addModifier(new $a801f2c896bd09f1$var$TimeSignature(timeSpec, customPadding), position2);
        return this;
    }
    addEndTimeSignature(timeSpec, customPadding) {
        this.addTimeSignature(timeSpec, customPadding, $a801f2c896bd09f1$var$StaveModifierPosition.END);
        return this;
    }
    addTrebleGlyph() {
        this.addClef("treble");
        return this;
    }
    getModifiers(position2, category) {
        const noPosition = position2 === void 0;
        const noCategory = category === void 0;
        if (noPosition && noCategory) return this.modifiers;
        else if (noPosition) return this.modifiers.filter((m3)=>category === m3.getCategory());
        else if (noCategory) return this.modifiers.filter((m3)=>position2 === m3.getPosition());
        else return this.modifiers.filter((m3)=>position2 === m3.getPosition() && category === m3.getCategory());
    }
    sortByCategory(items2, order) {
        for(let i2 = items2.length - 1; i2 >= 0; i2--){
            for(let j2 = 0; j2 < i2; j2++)if (order[items2[j2].getCategory()] > order[items2[j2 + 1].getCategory()]) {
                const temp = items2[j2];
                items2[j2] = items2[j2 + 1];
                items2[j2 + 1] = temp;
            }
        }
    }
    format() {
        const begBarline = this.modifiers[0];
        const endBarline = this.modifiers[1];
        const begModifiers = this.getModifiers($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN);
        const endModifiers = this.getModifiers($a801f2c896bd09f1$var$StaveModifierPosition.END);
        this.sortByCategory(begModifiers, $a801f2c896bd09f1$var$SORT_ORDER_BEG_MODIFIERS);
        this.sortByCategory(endModifiers, $a801f2c896bd09f1$var$SORT_ORDER_END_MODIFIERS);
        if (begModifiers.length > 1 && begBarline.getType() === $a801f2c896bd09f1$var$BarlineType.REPEAT_BEGIN) {
            begModifiers.push(begModifiers.splice(0, 1)[0]);
            begModifiers.splice(0, 0, new $a801f2c896bd09f1$var$Barline($a801f2c896bd09f1$var$BarlineType.SINGLE));
        }
        if (endModifiers.indexOf(endBarline) > 0) endModifiers.splice(0, 0, new $a801f2c896bd09f1$var$Barline($a801f2c896bd09f1$var$BarlineType.NONE));
        let width9;
        let padding;
        let modifier;
        let offset2 = 0;
        let x4 = this.x;
        for(let i2 = 0; i2 < begModifiers.length; i2++){
            modifier = begModifiers[i2];
            padding = modifier.getPadding(i2 + offset2);
            width9 = modifier.getWidth();
            x4 += padding;
            modifier.setX(x4);
            x4 += width9;
            if (padding + width9 === 0) offset2--;
        }
        this.start_x = x4;
        x4 = this.x + this.width;
        const widths = {
            left: 0,
            right: 0,
            paddingRight: 0,
            paddingLeft: 0
        };
        let lastBarlineIdx = 0;
        for(let i2 = 0; i2 < endModifiers.length; i2++){
            modifier = endModifiers[i2];
            lastBarlineIdx = $a801f2c896bd09f1$var$isBarline(modifier) ? i2 : lastBarlineIdx;
            widths.right = 0;
            widths.left = 0;
            widths.paddingRight = 0;
            widths.paddingLeft = 0;
            const layoutMetrics = modifier.getLayoutMetrics();
            if (layoutMetrics) {
                if (i2 !== 0) {
                    widths.right = layoutMetrics.xMax || 0;
                    widths.paddingRight = layoutMetrics.paddingRight || 0;
                }
                widths.left = -layoutMetrics.xMin || 0;
                widths.paddingLeft = layoutMetrics.paddingLeft || 0;
                if (i2 === endModifiers.length - 1) widths.paddingLeft = 0;
            } else {
                widths.paddingRight = modifier.getPadding(i2 - lastBarlineIdx);
                if (i2 !== 0) widths.right = modifier.getWidth();
                if (i2 === 0) widths.left = modifier.getWidth();
            }
            x4 -= widths.paddingRight;
            x4 -= widths.right;
            modifier.setX(x4);
            x4 -= widths.left;
            x4 -= widths.paddingLeft;
        }
        this.end_x = endModifiers.length === 1 ? this.x + this.width : x4;
        this.formatted = true;
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        this.applyStyle();
        ctx.openGroup("stave", this.getAttribute("id"));
        if (!this.formatted) this.format();
        const num_lines = this.options.num_lines;
        const width9 = this.width;
        const x4 = this.x;
        let y4;
        for(let line2 = 0; line2 < num_lines; line2++){
            y4 = this.getYForLine(line2);
            if (this.options.line_config[line2].visible) {
                ctx.beginPath();
                ctx.moveTo(x4, y4);
                ctx.lineTo(x4 + width9, y4);
                ctx.stroke();
            }
        }
        ctx.closeGroup();
        this.restoreStyle();
        for(let i2 = 0; i2 < this.modifiers.length; i2++){
            const modifier = this.modifiers[i2];
            if (typeof modifier.draw === "function") {
                modifier.applyStyle(ctx);
                modifier.draw(this, this.getModifierXShift(i2));
                modifier.restoreStyle(ctx);
            }
        }
        if (this.measure > 0) {
            ctx.save();
            ctx.setFont(this.textFont);
            const textWidth = ctx.measureText("" + this.measure).width;
            y4 = this.getYForTopText(0) + 3;
            ctx.fillText("" + this.measure, this.x - textWidth / 2, y4);
            ctx.restore();
        }
        return this;
    }
    getVerticalBarWidth() {
        return this.options.vertical_bar_width;
    }
    getConfigForLines() {
        return this.options.line_config;
    }
    setConfigForLine(line_number, line_config) {
        if (line_number >= this.options.num_lines || line_number < 0) throw new $a801f2c896bd09f1$var$RuntimeError("StaveConfigError", "The line number must be within the range of the number of lines in the Stave.");
        if (line_config.visible === void 0) throw new $a801f2c896bd09f1$var$RuntimeError("StaveConfigError", "The line configuration object is missing the 'visible' property.");
        if (typeof line_config.visible !== "boolean") throw new $a801f2c896bd09f1$var$RuntimeError("StaveConfigError", "The line configuration objects 'visible' property must be true or false.");
        this.options.line_config[line_number] = line_config;
        return this;
    }
    setConfigForLines(lines_configuration) {
        if (lines_configuration.length !== this.options.num_lines) throw new $a801f2c896bd09f1$var$RuntimeError("StaveConfigError", "The length of the lines configuration array must match the number of lines in the Stave");
        for(const line_config in lines_configuration){
            if (lines_configuration[line_config].visible == void 0) lines_configuration[line_config] = this.options.line_config[line_config];
            this.options.line_config[line_config] = Object.assign(Object.assign({}, this.options.line_config[line_config]), lines_configuration[line_config]);
        }
        this.options.line_config = lines_configuration;
        return this;
    }
    static formatBegModifiers(staves) {
        const adjustCategoryStartX = (category)=>{
            let minStartX = 0;
            staves.forEach((stave)=>{
                const modifiers = stave.getModifiers($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN, category);
                if (modifiers.length > 0 && modifiers[0].getX() > minStartX) minStartX = modifiers[0].getX();
            });
            let adjustX = 0;
            staves.forEach((stave)=>{
                adjustX = 0;
                const modifiers = stave.getModifiers($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN, category);
                modifiers.forEach((modifier)=>{
                    if (minStartX - modifier.getX() > adjustX) adjustX = minStartX - modifier.getX();
                });
                const allModifiers = stave.getModifiers($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN);
                let bAdjust = false;
                allModifiers.forEach((modifier)=>{
                    if (modifier.getCategory() === category) bAdjust = true;
                    if (bAdjust && adjustX > 0) modifier.setX(modifier.getX() + adjustX);
                });
                stave.setNoteStartX(stave.getNoteStartX() + adjustX);
            });
        };
        staves.forEach((stave)=>{
            if (!stave.formatted) stave.format();
        });
        adjustCategoryStartX("Clef");
        adjustCategoryStartX("KeySignature");
        adjustCategoryStartX("TimeSignature");
        let maxX = 0;
        staves.forEach((stave)=>{
            if (stave.getNoteStartX() > maxX) maxX = stave.getNoteStartX();
        });
        staves.forEach((stave)=>{
            stave.setNoteStartX(maxX);
        });
        maxX = 0;
        staves.forEach((stave)=>{
            const modifiers = stave.getModifiers($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN, "Barline");
            modifiers.forEach((modifier)=>{
                if (modifier.getType() == $a801f2c896bd09f1$var$BarlineType.REPEAT_BEGIN) {
                    if (modifier.getX() > maxX) maxX = modifier.getX();
                }
            });
        });
        staves.forEach((stave)=>{
            const modifiers = stave.getModifiers($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN, "Barline");
            modifiers.forEach((modifier)=>{
                if (modifier.getType() == $a801f2c896bd09f1$var$BarlineType.REPEAT_BEGIN) modifier.setX(maxX);
            });
        });
    }
};
$a801f2c896bd09f1$var$Stave.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SANS_SERIF,
    size: 8,
    weight: $a801f2c896bd09f1$var$FontWeight.NORMAL,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
// node_modules/vexflow/build/esm/src/staveconnector.js
function $a801f2c896bd09f1$var$drawBoldDoubleLine(ctx, type, topX, topY, botY) {
    if (type !== $a801f2c896bd09f1$var$StaveConnector.type.BOLD_DOUBLE_LEFT && type !== $a801f2c896bd09f1$var$StaveConnector.type.BOLD_DOUBLE_RIGHT) throw new $a801f2c896bd09f1$var$RuntimeError("InvalidConnector", "A REPEAT_BEGIN or REPEAT_END type must be provided.");
    let x_shift = 3;
    let variableWidth = 3.5;
    const thickLineOffset = 2;
    if (type === $a801f2c896bd09f1$var$StaveConnector.type.BOLD_DOUBLE_RIGHT) {
        x_shift = -5;
        variableWidth = 3;
    }
    ctx.fillRect(topX + x_shift, topY, 1, botY - topY);
    ctx.fillRect(topX - thickLineOffset, topY, variableWidth, botY - topY);
}
var $a801f2c896bd09f1$var$StaveConnector = class _StaveConnector extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "StaveConnector";
    }
    constructor(top_stave, bottom_stave){
        super();
        this.thickness = $a801f2c896bd09f1$var$Tables.STAVE_LINE_THICKNESS;
        this.width = 3;
        this.top_stave = top_stave;
        this.bottom_stave = bottom_stave;
        this.type = _StaveConnector.type.DOUBLE;
        this.resetFont();
        this.x_shift = 0;
        this.texts = [];
    }
    setType(type) {
        const newType = typeof type === "string" ? _StaveConnector.typeString[type] : type;
        if (Object.values(_StaveConnector.type).includes(newType)) this.type = newType;
        return this;
    }
    getType() {
        return this.type;
    }
    setText(text7, options2 = {}) {
        this.texts.push({
            content: text7,
            options: Object.assign({
                shift_x: 0,
                shift_y: 0
            }, options2)
        });
        return this;
    }
    setXShift(x_shift) {
        if (typeof x_shift !== "number") throw new $a801f2c896bd09f1$var$RuntimeError("InvalidType", "x_shift must be a Number");
        this.x_shift = x_shift;
        return this;
    }
    getXShift() {
        return this.x_shift;
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        let topY = this.top_stave.getYForLine(0);
        let botY = this.bottom_stave.getYForLine(this.bottom_stave.getNumLines() - 1) + this.thickness;
        let width9 = this.width;
        let topX = this.top_stave.getX();
        const isRightSidedConnector = this.type === _StaveConnector.type.SINGLE_RIGHT || this.type === _StaveConnector.type.BOLD_DOUBLE_RIGHT || this.type === _StaveConnector.type.THIN_DOUBLE;
        if (isRightSidedConnector) topX = this.top_stave.getX() + this.top_stave.getWidth();
        let attachment_height = botY - topY;
        switch(this.type){
            case _StaveConnector.type.SINGLE:
                width9 = 1;
                break;
            case _StaveConnector.type.SINGLE_LEFT:
                width9 = 1;
                break;
            case _StaveConnector.type.SINGLE_RIGHT:
                width9 = 1;
                break;
            case _StaveConnector.type.DOUBLE:
                topX -= this.width + 2;
                topY -= this.thickness;
                attachment_height += 0.5;
                break;
            case _StaveConnector.type.BRACE:
                {
                    width9 = 12;
                    const x12 = this.top_stave.getX() - 2 + this.x_shift;
                    const y12 = topY;
                    const x32 = x12;
                    const y32 = botY;
                    const x22 = x12 - width9;
                    const y22 = y12 + attachment_height / 2;
                    const cpx1 = x22 - 0.9 * width9;
                    const cpy1 = y12 + 0.2 * attachment_height;
                    const cpx2 = x12 + 1.1 * width9;
                    const cpy2 = y22 - 0.135 * attachment_height;
                    const cpx3 = cpx2;
                    const cpy3 = y22 + 0.135 * attachment_height;
                    const cpx4 = cpx1;
                    const cpy4 = y32 - 0.2 * attachment_height;
                    const cpx5 = x22 - width9;
                    const cpy5 = cpy4;
                    const cpx6 = x12 + 0.4 * width9;
                    const cpy6 = y22 + 0.135 * attachment_height;
                    const cpx7 = cpx6;
                    const cpy7 = y22 - 0.135 * attachment_height;
                    const cpx8 = cpx5;
                    const cpy8 = cpy1;
                    ctx.beginPath();
                    ctx.moveTo(x12, y12);
                    ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x22, y22);
                    ctx.bezierCurveTo(cpx3, cpy3, cpx4, cpy4, x32, y32);
                    ctx.bezierCurveTo(cpx5, cpy5, cpx6, cpy6, x22, y22);
                    ctx.bezierCurveTo(cpx7, cpy7, cpx8, cpy8, x12, y12);
                    ctx.fill();
                    ctx.stroke();
                    break;
                }
            case _StaveConnector.type.BRACKET:
                topY -= 6;
                botY += 6;
                attachment_height = botY - topY;
                $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, topX - 5, topY, 40, "bracketTop");
                $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, topX - 5, botY, 40, "bracketBottom");
                topX -= this.width + 2;
                break;
            case _StaveConnector.type.BOLD_DOUBLE_LEFT:
                $a801f2c896bd09f1$var$drawBoldDoubleLine(ctx, this.type, topX + this.x_shift, topY, botY - this.thickness);
                break;
            case _StaveConnector.type.BOLD_DOUBLE_RIGHT:
                $a801f2c896bd09f1$var$drawBoldDoubleLine(ctx, this.type, topX, topY, botY - this.thickness);
                break;
            case _StaveConnector.type.THIN_DOUBLE:
                width9 = 1;
                attachment_height -= this.thickness;
                break;
            case _StaveConnector.type.NONE:
                break;
            default:
                throw new $a801f2c896bd09f1$var$RuntimeError("InvalidType", `The provided StaveConnector.type (${this.type}) is invalid.`);
        }
        if (this.type !== _StaveConnector.type.BRACE && this.type !== _StaveConnector.type.BOLD_DOUBLE_LEFT && this.type !== _StaveConnector.type.BOLD_DOUBLE_RIGHT && this.type !== _StaveConnector.type.NONE) ctx.fillRect(topX, topY, width9, attachment_height);
        if (this.type === _StaveConnector.type.THIN_DOUBLE) ctx.fillRect(topX - 3, topY, width9, attachment_height);
        ctx.save();
        ctx.setLineWidth(2);
        ctx.setFont(this.textFont);
        for(let i2 = 0; i2 < this.texts.length; i2++){
            const text7 = this.texts[i2];
            const text_width = ctx.measureText("" + text7.content).width;
            const x4 = this.top_stave.getX() - text_width - 24 + text7.options.shift_x;
            const y4 = (this.top_stave.getYForLine(0) + this.bottom_stave.getBottomLineY()) / 2 + text7.options.shift_y;
            ctx.fillText("" + text7.content, x4, y4 + 4);
        }
        ctx.restore();
    }
};
$a801f2c896bd09f1$var$StaveConnector.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SERIF,
    size: 16,
    weight: $a801f2c896bd09f1$var$FontWeight.NORMAL,
    style: $a801f2c896bd09f1$var$FontStyle.NORMAL
};
$a801f2c896bd09f1$var$StaveConnector.type = {
    SINGLE_RIGHT: 0,
    SINGLE_LEFT: 1,
    SINGLE: 1,
    DOUBLE: 2,
    BRACE: 3,
    BRACKET: 4,
    BOLD_DOUBLE_LEFT: 5,
    BOLD_DOUBLE_RIGHT: 6,
    THIN_DOUBLE: 7,
    NONE: 8
};
$a801f2c896bd09f1$var$StaveConnector.typeString = {
    singleRight: $a801f2c896bd09f1$var$StaveConnector.type.SINGLE_RIGHT,
    singleLeft: $a801f2c896bd09f1$var$StaveConnector.type.SINGLE_LEFT,
    single: $a801f2c896bd09f1$var$StaveConnector.type.SINGLE,
    double: $a801f2c896bd09f1$var$StaveConnector.type.DOUBLE,
    brace: $a801f2c896bd09f1$var$StaveConnector.type.BRACE,
    bracket: $a801f2c896bd09f1$var$StaveConnector.type.BRACKET,
    boldDoubleLeft: $a801f2c896bd09f1$var$StaveConnector.type.BOLD_DOUBLE_LEFT,
    boldDoubleRight: $a801f2c896bd09f1$var$StaveConnector.type.BOLD_DOUBLE_RIGHT,
    thinDouble: $a801f2c896bd09f1$var$StaveConnector.type.THIN_DOUBLE,
    none: $a801f2c896bd09f1$var$StaveConnector.type.NONE
};
// node_modules/vexflow/build/esm/src/formatter.js
function $a801f2c896bd09f1$var$createContexts(voices, makeContext, addToContext) {
    if (voices.length == 0) return {
        map: {},
        array: [],
        list: [],
        resolutionMultiplier: 0
    };
    const tickToContextMap = {};
    const tickList = [];
    const contexts = [];
    const resolutionMultiplier = $a801f2c896bd09f1$var$Formatter.getResolutionMultiplier(voices);
    voices.forEach((voice, voiceIndex)=>{
        const ticksUsed = new $a801f2c896bd09f1$var$Fraction(0, resolutionMultiplier);
        voice.getTickables().forEach((tickable)=>{
            const integerTicks = ticksUsed.numerator;
            if (!tickToContextMap[integerTicks]) {
                const newContext = makeContext({
                    tickID: integerTicks
                });
                contexts.push(newContext);
                tickToContextMap[integerTicks] = newContext;
                tickList.push(integerTicks);
            }
            addToContext(tickable, tickToContextMap[integerTicks], voiceIndex);
            ticksUsed.add(tickable.getTicks());
        });
    });
    return {
        map: tickToContextMap,
        array: contexts,
        list: tickList.sort((a3, b3)=>a3 - b3),
        resolutionMultiplier: resolutionMultiplier
    };
}
function $a801f2c896bd09f1$var$L17(...args) {
    if ($a801f2c896bd09f1$var$Formatter.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Formatter", args);
}
function $a801f2c896bd09f1$var$getRestLineForNextNoteGroup(notes, currRestLine, currNoteIndex, compare6) {
    let nextRestLine = currRestLine;
    for(let noteIndex = currNoteIndex + 1; noteIndex < notes.length; noteIndex++){
        const note2 = notes[noteIndex];
        if ($a801f2c896bd09f1$var$isNote(note2) && !note2.isRest() && !note2.shouldIgnoreTicks()) {
            nextRestLine = note2.getLineForRest();
            break;
        }
    }
    if (compare6 && currRestLine !== nextRestLine) {
        const top2 = Math.max(currRestLine, nextRestLine);
        const bot = Math.min(currRestLine, nextRestLine);
        nextRestLine = $a801f2c896bd09f1$var$midLine(top2, bot);
    }
    return nextRestLine;
}
var $a801f2c896bd09f1$var$Formatter = class _Formatter {
    static SimpleFormat(notes, x4 = 0, { paddingBetween: paddingBetween = 10 } = {}) {
        notes.reduce((accumulator, note2)=>{
            note2.addToModifierContext(new $a801f2c896bd09f1$var$ModifierContext());
            const tick = new $a801f2c896bd09f1$var$TickContext().addTickable(note2).preFormat();
            const metrics = tick.getMetrics();
            tick.setX(accumulator + metrics.totalLeftPx);
            return accumulator + tick.getWidth() + metrics.totalRightPx + paddingBetween;
        }, x4);
    }
    static plotDebugging(ctx, formatter, xPos, y12, y22, options2) {
        options2 = Object.assign({
            stavePadding: $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("stave.padding")
        }, options2);
        const x4 = xPos + options2.stavePadding;
        const contextGaps = formatter.contextGaps;
        function stroke2(x12, x22, color) {
            ctx.beginPath();
            ctx.setStrokeStyle(color);
            ctx.setFillStyle(color);
            ctx.setLineWidth(1);
            ctx.fillRect(x12, y12, Math.max(x22 - x12, 0), y22 - y12);
        }
        ctx.save();
        ctx.setFont($a801f2c896bd09f1$var$Font.SANS_SERIF, 8);
        contextGaps.gaps.forEach((gap)=>{
            stroke2(x4 + gap.x1, x4 + gap.x2, "rgba(100,200,100,0.4)");
            ctx.setFillStyle("green");
            ctx.fillText(Math.round(gap.x2 - gap.x1).toString(), x4 + gap.x1, y22 + 12);
        });
        ctx.setFillStyle("red");
        ctx.fillText(`Loss: ${(formatter.totalCost || 0).toFixed(2)} Shift: ${(formatter.totalShift || 0).toFixed(2)} Gap: ${contextGaps.total.toFixed(2)}`, x4 - 20, y22 + 27);
        ctx.restore();
    }
    static FormatAndDraw(ctx, stave, notes, params) {
        let options2 = {
            auto_beam: false,
            align_rests: false
        };
        if (typeof params === "object") options2 = Object.assign(Object.assign({}, options2), params);
        else if (typeof params === "boolean") options2.auto_beam = params;
        const voice = new $a801f2c896bd09f1$var$Voice($a801f2c896bd09f1$var$Tables.TIME4_4).setMode($a801f2c896bd09f1$var$Voice.Mode.SOFT).addTickables(notes);
        const beams = options2.auto_beam ? $a801f2c896bd09f1$var$Beam.applyAndGetBeams(voice) : [];
        new _Formatter().joinVoices([
            voice
        ]).formatToStave([
            voice
        ], stave, {
            align_rests: options2.align_rests,
            stave: stave
        });
        voice.setStave(stave).draw(ctx, stave);
        beams.forEach((beam)=>beam.setContext(ctx).draw());
        return voice.getBoundingBox();
    }
    static FormatAndDrawTab(ctx, tabstave, stave, tabnotes, notes, autobeam, params) {
        let opts = {
            auto_beam: autobeam,
            align_rests: false
        };
        if (typeof params === "object") opts = Object.assign(Object.assign({}, opts), params);
        else if (typeof params === "boolean") opts.auto_beam = params;
        const notevoice = new $a801f2c896bd09f1$var$Voice($a801f2c896bd09f1$var$Tables.TIME4_4).setMode($a801f2c896bd09f1$var$Voice.Mode.SOFT).addTickables(notes);
        const tabvoice = new $a801f2c896bd09f1$var$Voice($a801f2c896bd09f1$var$Tables.TIME4_4).setMode($a801f2c896bd09f1$var$Voice.Mode.SOFT).addTickables(tabnotes);
        const beams = opts.auto_beam ? $a801f2c896bd09f1$var$Beam.applyAndGetBeams(notevoice) : [];
        new _Formatter().joinVoices([
            notevoice
        ]).joinVoices([
            tabvoice
        ]).formatToStave([
            notevoice,
            tabvoice
        ], stave, {
            align_rests: opts.align_rests
        });
        notevoice.draw(ctx, stave);
        tabvoice.draw(ctx, tabstave);
        beams.forEach((beam)=>beam.setContext(ctx).draw());
        new $a801f2c896bd09f1$var$StaveConnector(stave, tabstave).setContext(ctx).draw();
    }
    static AlignRestsToNotes(tickables, alignAllNotes, alignTuplets) {
        tickables.forEach((currTickable, index5)=>{
            if ($a801f2c896bd09f1$var$isStaveNote(currTickable) && currTickable.isRest()) {
                if (currTickable.getTuplet() && !alignTuplets) return;
                const position2 = currTickable.getGlyphProps().position.toUpperCase();
                if (position2 !== "R/4" && position2 !== "B/4") return;
                if (alignAllNotes || currTickable.getBeam()) {
                    const props = currTickable.getKeyProps()[0];
                    if (index5 === 0) props.line = $a801f2c896bd09f1$var$getRestLineForNextNoteGroup(tickables, props.line, index5, false);
                    else if (index5 > 0 && index5 < tickables.length) {
                        const prevTickable = tickables[index5 - 1];
                        if ($a801f2c896bd09f1$var$isStaveNote(prevTickable)) {
                            if (prevTickable.isRest()) props.line = prevTickable.getKeyProps()[0].line;
                            else {
                                const restLine = prevTickable.getLineForRest();
                                props.line = $a801f2c896bd09f1$var$getRestLineForNextNoteGroup(tickables, restLine, index5, true);
                            }
                        }
                    }
                    currTickable.setKeyLine(0, props.line);
                }
            }
        });
    }
    constructor(options2){
        this.formatterOptions = Object.assign({
            globalSoftmax: false,
            softmaxFactor: $a801f2c896bd09f1$var$Tables.SOFTMAX_FACTOR,
            maxIterations: 5
        }, options2);
        this.justifyWidth = 0;
        this.totalCost = 0;
        this.totalShift = 0;
        this.durationStats = {};
        this.minTotalWidth = 0;
        this.hasMinTotalWidth = false;
        this.tickContexts = {
            map: {},
            array: [],
            list: [],
            resolutionMultiplier: 0
        };
        this.modifierContexts = [];
        this.contextGaps = {
            total: 0,
            gaps: []
        };
        this.voices = [];
        this.lossHistory = [];
    }
    alignRests(voices, alignAllNotes) {
        if (!voices || !voices.length) throw new $a801f2c896bd09f1$var$RuntimeError("BadArgument", "No voices to format rests");
        voices.forEach((voice)=>_Formatter.AlignRestsToNotes(voice.getTickables(), alignAllNotes));
    }
    preCalculateMinTotalWidth(voices) {
        const unalignedPadding = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("stave.unalignedNotePadding");
        let unalignedCtxCount = 0;
        let wsum = 0;
        let dsum = 0;
        const widths = [];
        const durations2 = [];
        if (this.hasMinTotalWidth) return this.minTotalWidth;
        if (!voices) throw new $a801f2c896bd09f1$var$RuntimeError("BadArgument", "'voices' required to run preCalculateMinTotalWidth");
        this.createTickContexts(voices);
        const { list: contextList, map: contextMap } = this.tickContexts;
        this.minTotalWidth = 0;
        contextList.forEach((tick)=>{
            const context = contextMap[tick];
            context.preFormat();
            if (context.getTickables().length < voices.length) unalignedCtxCount += 1;
            context.getTickables().forEach((t2)=>{
                wsum += t2.getMetrics().width;
                dsum += t2.getTicks().value();
                widths.push(t2.getMetrics().width);
                durations2.push(t2.getTicks().value());
            });
            const width9 = context.getWidth();
            this.minTotalWidth += width9;
        });
        this.hasMinTotalWidth = true;
        const wavg = wsum > 0 ? wsum / widths.length : 1 / widths.length;
        const wvar = $a801f2c896bd09f1$var$sumArray(widths.map((ll)=>Math.pow(ll - wavg, 2)));
        const wpads = Math.pow(wvar / widths.length, 0.5) / wavg;
        const davg = dsum / durations2.length;
        const dvar = $a801f2c896bd09f1$var$sumArray(durations2.map((ll)=>Math.pow(ll - davg, 2)));
        const dpads = Math.pow(dvar / durations2.length, 0.5) / davg;
        const padmax = Math.max(dpads, wpads) * contextList.length * unalignedPadding;
        const unalignedPad = unalignedPadding * unalignedCtxCount;
        return this.minTotalWidth + Math.max(unalignedPad, padmax);
    }
    getMinTotalWidth() {
        if (!this.hasMinTotalWidth) throw new $a801f2c896bd09f1$var$RuntimeError("NoMinTotalWidth", "Call 'preCalculateMinTotalWidth' or 'preFormat' before calling 'getMinTotalWidth'");
        return this.minTotalWidth;
    }
    static getResolutionMultiplier(voices) {
        if (!voices || !voices.length) throw new $a801f2c896bd09f1$var$RuntimeError("BadArgument", "No voices to format");
        const totalTicks = voices[0].getTotalTicks();
        const resolutionMultiplier = voices.reduce((accumulator, voice)=>{
            if (!voice.getTotalTicks().equals(totalTicks)) throw new $a801f2c896bd09f1$var$RuntimeError("TickMismatch", "Voices should have same total note duration in ticks.");
            if (voice.getMode() === $a801f2c896bd09f1$var$Voice.Mode.STRICT && !voice.isComplete()) throw new $a801f2c896bd09f1$var$RuntimeError("IncompleteVoice", "Voice does not have enough notes.");
            return Math.max(accumulator, $a801f2c896bd09f1$var$Fraction.LCM(accumulator, voice.getResolutionMultiplier()));
        }, 1);
        return resolutionMultiplier;
    }
    createModifierContexts(voices) {
        if (voices.length == 0) return;
        const resolutionMultiplier = _Formatter.getResolutionMultiplier(voices);
        const tickToContextMap = /* @__PURE__ */ new Map();
        const contexts = [];
        voices.forEach((voice)=>{
            const ticksUsed = new $a801f2c896bd09f1$var$Fraction(0, resolutionMultiplier);
            voice.getTickables().forEach((tickable)=>{
                const integerTicks = ticksUsed.numerator;
                let staveTickToContextMap = tickToContextMap.get(tickable.getStave());
                if (!staveTickToContextMap) {
                    tickToContextMap.set(tickable.getStave(), {});
                    staveTickToContextMap = tickToContextMap.get(tickable.getStave());
                }
                if (!(staveTickToContextMap ? staveTickToContextMap[integerTicks] : void 0)) {
                    const newContext = new $a801f2c896bd09f1$var$ModifierContext();
                    contexts.push(newContext);
                    staveTickToContextMap[integerTicks] = newContext;
                }
                tickable.addToModifierContext(staveTickToContextMap[integerTicks]);
                ticksUsed.add(tickable.getTicks());
            });
        });
        this.modifierContexts.push({
            map: tickToContextMap,
            array: contexts,
            resolutionMultiplier: resolutionMultiplier
        });
    }
    createTickContexts(voices) {
        const fn = (tickable, context, voiceIndex)=>context.addTickable(tickable, voiceIndex);
        const contexts = $a801f2c896bd09f1$var$createContexts(voices, (tick)=>new $a801f2c896bd09f1$var$TickContext(tick), fn);
        this.tickContexts = contexts;
        const contextArray = this.tickContexts.array;
        contextArray.forEach((context)=>{
            context.tContexts = contextArray;
        });
        return contexts;
    }
    getTickContexts() {
        return this.tickContexts;
    }
    preFormat(justifyWidth = 0, renderingContext, voicesParam, stave) {
        const contexts = this.tickContexts;
        if (!contexts) throw new $a801f2c896bd09f1$var$RuntimeError("NoTickContexts", "preFormat requires TickContexts");
        const { list: contextList, map: contextMap } = contexts;
        this.lossHistory = [];
        if (voicesParam && stave) voicesParam.forEach((voice)=>voice.setStave(stave).preFormat());
        let x4 = 0;
        let shift = 0;
        this.minTotalWidth = 0;
        let totalTicks = 0;
        contextList.forEach((tick)=>{
            const context = contextMap[tick];
            context.preFormat();
            const width9 = context.getWidth();
            this.minTotalWidth += width9;
            const maxTicks = context.getMaxTicks().value();
            totalTicks += maxTicks;
            const metrics = context.getMetrics();
            x4 = x4 + shift + metrics.totalLeftPx;
            context.setX(x4);
            shift = width9 - metrics.totalLeftPx;
        });
        const { globalSoftmax: globalSoftmax, softmaxFactor: softmaxFactor, maxIterations: maxIterations } = this.formatterOptions;
        const exp2 = (tick)=>Math.pow(softmaxFactor, contextMap[tick].getMaxTicks().value() / totalTicks);
        const expTicksUsed = $a801f2c896bd09f1$var$sumArray(contextList.map(exp2));
        this.minTotalWidth = x4 + shift;
        this.hasMinTotalWidth = true;
        if (justifyWidth <= 0) return this.evaluate();
        const firstContext = contextMap[contextList[0]];
        const lastContext = contextMap[contextList[contextList.length - 1]];
        function calculateIdealDistances(adjustedJustifyWidth2) {
            const distances2 = contextList.map((tick, i2)=>{
                const context = contextMap[tick];
                const voices = context.getTickablesByVoice();
                let backTickable;
                if (i2 > 0) {
                    const prevContext = contextMap[contextList[i2 - 1]];
                    for(let j2 = i2 - 1; j2 >= 0; j2--){
                        const backTick = contextMap[contextList[j2]];
                        const backVoices = backTick.getTickablesByVoice();
                        const matchingVoices = [];
                        Object.keys(voices).forEach((v3)=>{
                            if (backVoices[v3]) matchingVoices.push(v3);
                        });
                        if (matchingVoices.length > 0) {
                            let maxTicks = 0;
                            let maxNegativeShiftPx = Infinity;
                            let expectedDistance = 0;
                            matchingVoices.forEach((v3)=>{
                                const ticks = backVoices[v3].getTicks().value();
                                if (ticks > maxTicks) {
                                    backTickable = backVoices[v3];
                                    maxTicks = ticks;
                                }
                                const thisTickable = voices[v3];
                                const insideLeftEdge = thisTickable.getX() - (thisTickable.getMetrics().modLeftPx + thisTickable.getMetrics().leftDisplacedHeadPx);
                                const backMetrics = backVoices[v3].getMetrics();
                                const insideRightEdge = backVoices[v3].getX() + backMetrics.notePx + backMetrics.modRightPx + backMetrics.rightDisplacedHeadPx;
                                maxNegativeShiftPx = Math.min(maxNegativeShiftPx, insideLeftEdge - insideRightEdge);
                            });
                            maxNegativeShiftPx = Math.min(maxNegativeShiftPx, context.getX() - (prevContext.getX() + adjustedJustifyWidth2 * 0.05));
                            if (globalSoftmax) {
                                const t2 = totalTicks;
                                expectedDistance = Math.pow(softmaxFactor, maxTicks / t2) / expTicksUsed * adjustedJustifyWidth2;
                            } else if (typeof backTickable !== "undefined") expectedDistance = backTickable.getVoice().softmax(maxTicks) * adjustedJustifyWidth2;
                            return {
                                expectedDistance: expectedDistance,
                                maxNegativeShiftPx: maxNegativeShiftPx,
                                fromTickable: backTickable
                            };
                        }
                    }
                }
                return {
                    expectedDistance: 0,
                    fromTickablePx: 0,
                    maxNegativeShiftPx: 0
                };
            });
            return distances2;
        }
        function shiftToIdealDistances(idealDistances) {
            const centerX = adjustedJustifyWidth / 2;
            let spaceAccum = 0;
            contextList.forEach((tick, index5)=>{
                const context = contextMap[tick];
                if (index5 > 0) {
                    const contextX = context.getX();
                    const ideal = idealDistances[index5];
                    const errorPx = $a801f2c896bd09f1$var$defined(ideal.fromTickable).getX() + ideal.expectedDistance - (contextX + spaceAccum);
                    let negativeShiftPx = 0;
                    if (errorPx > 0) spaceAccum += errorPx;
                    else if (errorPx < 0) {
                        negativeShiftPx = Math.min(ideal.maxNegativeShiftPx, Math.abs(errorPx));
                        spaceAccum += -negativeShiftPx;
                    }
                    context.setX(contextX + spaceAccum);
                }
                context.getCenterAlignedTickables().forEach((tickable)=>{
                    tickable.setCenterXShift(centerX - context.getX());
                });
            });
            return lastContext.getX() - firstContext.getX();
        }
        const adjustedJustifyWidth = justifyWidth - lastContext.getMetrics().notePx - lastContext.getMetrics().totalRightPx - firstContext.getMetrics().totalLeftPx;
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        const configMinPadding = musicFont.lookupMetric("stave.endPaddingMin");
        const configMaxPadding = musicFont.lookupMetric("stave.endPaddingMax");
        const leftPadding = musicFont.lookupMetric("stave.padding");
        let targetWidth = adjustedJustifyWidth;
        const distances = calculateIdealDistances(targetWidth);
        let actualWidth = shiftToIdealDistances(distances);
        if (contextList.length === 1) return 0;
        const calcMinDistance = (targetWidth2, distances2)=>{
            let mdCalc = targetWidth2 / 2;
            if (distances2.length > 1) for(let di = 1; di < distances2.length; ++di)mdCalc = Math.min(distances2[di].expectedDistance / 2, mdCalc);
            return mdCalc;
        };
        const minDistance = calcMinDistance(targetWidth, distances);
        const paddingMaxCalc = (curTargetWidth)=>{
            let lastTickablePadding = 0;
            const lastTickable = lastContext && lastContext.getMaxTickable();
            if (lastTickable) {
                const voice = lastTickable.getVoice();
                if (voice.getTicksUsed().value() > voice.getTotalTicks().value()) return configMaxPadding * 2 < minDistance ? minDistance : configMaxPadding;
                const tickWidth = lastTickable.getWidth();
                lastTickablePadding = voice.softmax(lastContext.getMaxTicks().value()) * curTargetWidth - (tickWidth + leftPadding);
            }
            return configMaxPadding * 2 < lastTickablePadding ? lastTickablePadding : configMaxPadding;
        };
        let paddingMax = paddingMaxCalc(targetWidth);
        let paddingMin = paddingMax - (configMaxPadding - configMinPadding);
        const maxX = adjustedJustifyWidth - paddingMin;
        let iterations = maxIterations;
        while(actualWidth > maxX && iterations > 0 || actualWidth + paddingMax < maxX && iterations > 1){
            targetWidth -= actualWidth - maxX;
            paddingMax = paddingMaxCalc(targetWidth);
            paddingMin = paddingMax - (configMaxPadding - configMinPadding);
            actualWidth = shiftToIdealDistances(calculateIdealDistances(targetWidth));
            iterations--;
        }
        this.justifyWidth = justifyWidth;
        return this.evaluate();
    }
    evaluate() {
        const contexts = this.tickContexts;
        const justifyWidth = this.justifyWidth;
        this.contextGaps = {
            total: 0,
            gaps: []
        };
        contexts.list.forEach((tick, index5)=>{
            if (index5 === 0) return;
            const prevTick = contexts.list[index5 - 1];
            const prevContext = contexts.map[prevTick];
            const context = contexts.map[tick];
            const prevMetrics = prevContext.getMetrics();
            const currMetrics = context.getMetrics();
            const insideRightEdge = prevContext.getX() + prevMetrics.notePx + prevMetrics.totalRightPx;
            const insideLeftEdge = context.getX() - currMetrics.totalLeftPx;
            const gap = insideLeftEdge - insideRightEdge;
            this.contextGaps.total += gap;
            this.contextGaps.gaps.push({
                x1: insideRightEdge,
                x2: insideLeftEdge
            });
            context.getFormatterMetrics().freedom.left = gap;
            prevContext.getFormatterMetrics().freedom.right = gap;
        });
        this.durationStats = {};
        const durationStats = this.durationStats;
        function updateStats(duration2, space) {
            const stats = durationStats[duration2];
            if (stats === void 0) durationStats[duration2] = {
                mean: space,
                count: 1
            };
            else {
                stats.count += 1;
                stats.mean = (stats.mean + space) / 2;
            }
        }
        this.voices.forEach((voice)=>{
            voice.getTickables().forEach((note2, i2, notes)=>{
                const duration2 = note2.getTicks().clone().simplify().toString();
                const metrics = note2.getMetrics();
                const formatterMetrics = note2.getFormatterMetrics();
                const leftNoteEdge = note2.getX() + metrics.notePx + metrics.modRightPx + metrics.rightDisplacedHeadPx;
                let space = 0;
                if (i2 < notes.length - 1) {
                    const rightNote = notes[i2 + 1];
                    const rightMetrics = rightNote.getMetrics();
                    const rightNoteEdge = rightNote.getX() - rightMetrics.modLeftPx - rightMetrics.leftDisplacedHeadPx;
                    space = rightNoteEdge - leftNoteEdge;
                    formatterMetrics.space.used = rightNote.getX() - note2.getX();
                    rightNote.getFormatterMetrics().freedom.left = space;
                } else {
                    space = justifyWidth - leftNoteEdge;
                    formatterMetrics.space.used = justifyWidth - note2.getX();
                }
                formatterMetrics.freedom.right = space;
                updateStats(duration2, formatterMetrics.space.used);
            });
        });
        let totalDeviation = 0;
        this.voices.forEach((voice)=>{
            voice.getTickables().forEach((note2)=>{
                const duration2 = note2.getTicks().clone().simplify().toString();
                const metrics = note2.getFormatterMetrics();
                metrics.space.mean = durationStats[duration2].mean;
                metrics.duration = duration2;
                metrics.iterations += 1;
                metrics.space.deviation = metrics.space.used - metrics.space.mean;
                totalDeviation += Math.pow(metrics.space.deviation, 2);
            });
        });
        this.totalCost = Math.sqrt(totalDeviation);
        this.lossHistory.push(this.totalCost);
        return this.totalCost;
    }
    tune(options2) {
        var _a;
        const contexts = this.tickContexts;
        if (!contexts) return 0;
        const alpha = (_a = options2 === null || options2 === void 0 ? void 0 : options2.alpha) !== null && _a !== void 0 ? _a : 0.5;
        function move(current, shift2, prev, next) {
            current.setX(current.getX() + shift2);
            current.getFormatterMetrics().freedom.left += shift2;
            current.getFormatterMetrics().freedom.right -= shift2;
            if (prev) prev.getFormatterMetrics().freedom.right += shift2;
            if (next) next.getFormatterMetrics().freedom.left -= shift2;
        }
        let shift = 0;
        this.totalShift = 0;
        contexts.list.forEach((tick, index5, list)=>{
            const context = contexts.map[tick];
            const prevContext = index5 > 0 ? contexts.map[list[index5 - 1]] : void 0;
            const nextContext = index5 < list.length - 1 ? contexts.map[list[index5 + 1]] : void 0;
            move(context, shift, prevContext, nextContext);
            const cost = -$a801f2c896bd09f1$var$sumArray(context.getTickables().map((t2)=>t2.getFormatterMetrics().space.deviation));
            if (cost > 0) shift = -Math.min(context.getFormatterMetrics().freedom.right, Math.abs(cost));
            else if (cost < 0) {
                if (nextContext) shift = Math.min(nextContext.getFormatterMetrics().freedom.right, Math.abs(cost));
                else shift = 0;
            }
            shift *= alpha;
            this.totalShift += shift;
        });
        return this.evaluate();
    }
    postFormat() {
        this.modifierContexts.forEach((modifierContexts)=>{
            modifierContexts.array.forEach((mc)=>mc.postFormat());
        });
        this.tickContexts.list.forEach((tick)=>{
            this.tickContexts.map[tick].postFormat();
        });
        return this;
    }
    joinVoices(voices) {
        this.createModifierContexts(voices);
        this.hasMinTotalWidth = false;
        return this;
    }
    format(voices, justifyWidth, options2) {
        const opts = Object.assign({
            align_rests: false
        }, options2);
        this.voices = voices;
        const softmaxFactor = this.formatterOptions.softmaxFactor;
        if (softmaxFactor) this.voices.forEach((v3)=>v3.setSoftmaxFactor(softmaxFactor));
        this.alignRests(voices, opts.align_rests);
        this.createTickContexts(voices);
        this.preFormat(justifyWidth, opts.context, voices, opts.stave);
        if (opts.stave) this.postFormat();
        return this;
    }
    formatToStave(voices, stave, optionsParam) {
        const options2 = Object.assign({
            context: stave.getContext()
        }, optionsParam);
        const justifyWidth = stave.getNoteEndX() - stave.getNoteStartX() - $a801f2c896bd09f1$var$Stave.defaultPadding;
        $a801f2c896bd09f1$var$L17("Formatting voices to width: ", justifyWidth);
        return this.format(voices, justifyWidth, options2);
    }
    getTickContext(tick) {
        var _a;
        return (_a = this.tickContexts) === null || _a === void 0 ? void 0 : _a.map[tick];
    }
};
$a801f2c896bd09f1$var$Formatter.DEBUG = false;
// node_modules/vexflow/build/esm/src/ghostnote.js
var $a801f2c896bd09f1$var$ERROR_MSG = "Ghost note must have valid initialization data to identify duration.";
var $a801f2c896bd09f1$var$GhostNote = class extends $a801f2c896bd09f1$var$StemmableNote {
    static get CATEGORY() {
        return "GhostNote";
    }
    constructor(parameter){
        if (!parameter) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", $a801f2c896bd09f1$var$ERROR_MSG);
        let noteStruct;
        if (typeof parameter === "string") noteStruct = {
            duration: parameter
        };
        else if (typeof parameter === "object") noteStruct = parameter;
        else throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", $a801f2c896bd09f1$var$ERROR_MSG);
        super(noteStruct);
        this.setWidth(0);
    }
    isRest() {
        return true;
    }
    setStave(stave) {
        super.setStave(stave);
        return this;
    }
    addToModifierContext(mc) {
        return this;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    draw() {
        this.setRendered();
        for(let i2 = 0; i2 < this.modifiers.length; ++i2){
            const modifier = this.modifiers[i2];
            if ($a801f2c896bd09f1$var$isAnnotation(modifier)) {
                modifier.setContext(this.getContext());
                modifier.drawWithStyle();
            }
        }
    }
};
// node_modules/vexflow/build/esm/src/glyphnote.js
var $a801f2c896bd09f1$var$GlyphNote = class extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "GlyphNote";
    }
    constructor(glyph, noteStruct, options2){
        super(noteStruct);
        this.options = Object.assign({
            ignoreTicks: false,
            line: 2
        }, options2);
        this.ignore_ticks = this.options.ignoreTicks;
        this.setGlyph(glyph);
    }
    setGlyph(glyph) {
        this.glyph = glyph;
        this.setWidth(this.glyph.getMetrics().width);
        return this;
    }
    getBoundingBox() {
        return this.glyph.getBoundingBox();
    }
    preFormat() {
        if (!this.preFormatted && this.modifierContext) this.modifierContext.preFormat();
        this.preFormatted = true;
        return this;
    }
    drawModifiers() {
        const ctx = this.checkContext();
        for(let i2 = 0; i2 < this.modifiers.length; i2++){
            const modifier = this.modifiers[i2];
            modifier.setContext(ctx);
            modifier.drawWithStyle();
        }
    }
    getGlyphWidth() {
        return this.glyph.getMetrics().width;
    }
    draw() {
        const stave = this.checkStave();
        const ctx = stave.checkContext();
        this.setRendered();
        this.applyStyle(ctx);
        ctx.openGroup("glyphNote", this.getAttribute("id"));
        const glyph = this.glyph;
        if (!glyph.getContext()) glyph.setContext(ctx);
        glyph.setStave(stave);
        glyph.setYShift(stave.getYForLine(this.options.line) - stave.getYForGlyphs());
        const x4 = this.isCenterAligned() ? this.getAbsoluteX() - this.getWidth() / 2 : this.getAbsoluteX();
        glyph.renderToStave(x4);
        this.drawModifiers();
        ctx.closeGroup();
        this.restoreStyle(ctx);
    }
};
// node_modules/vexflow/build/esm/src/gracenote.js
var $a801f2c896bd09f1$var$GraceNote = class _GraceNote extends $a801f2c896bd09f1$var$StaveNote {
    static get CATEGORY() {
        return "GraceNote";
    }
    static get LEDGER_LINE_OFFSET() {
        return 2;
    }
    static get SCALE() {
        return 0.66;
    }
    constructor(noteStruct){
        super(Object.assign({
            glyph_font_scale: $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE * _GraceNote.SCALE,
            stroke_px: _GraceNote.LEDGER_LINE_OFFSET
        }, noteStruct));
        this.slash = noteStruct.slash || false;
        this.slur = true;
        this.buildNoteHeads();
        this.width = 3;
    }
    getStemExtension() {
        if (this.stem_extension_override) return this.stem_extension_override;
        const glyphProps = this.getGlyphProps();
        if (glyphProps) {
            let ret = super.getStemExtension();
            if (glyphProps.stem) {
                const staveNoteScale = this.getStaveNoteScale();
                ret = ($a801f2c896bd09f1$var$Stem.HEIGHT + ret) * staveNoteScale - $a801f2c896bd09f1$var$Stem.HEIGHT;
            }
            return ret;
        }
        return 0;
    }
    getStaveNoteScale() {
        return this.render_options.glyph_font_scale / $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE;
    }
    draw() {
        super.draw();
        this.setRendered();
        const stem = this.stem;
        if (this.slash && stem) {
            const staveNoteScale = this.getStaveNoteScale();
            const offsetScale = staveNoteScale / 0.66;
            let slashBBox = void 0;
            const beam = this.beam;
            if (beam) {
                if (!beam.postFormatted) beam.postFormat();
                slashBBox = this.calcBeamedNotesSlashBBox(8 * offsetScale, 8 * offsetScale, {
                    stem: 6 * offsetScale,
                    beam: 5 * offsetScale
                });
            } else {
                const stem_direction = this.getStemDirection();
                const noteHeadBounds = this.getNoteHeadBounds();
                const noteStemHeight = stem.getHeight();
                let x4 = this.getAbsoluteX();
                let y4 = stem_direction === $a801f2c896bd09f1$var$Stem.DOWN ? noteHeadBounds.y_top - noteStemHeight : noteHeadBounds.y_bottom - noteStemHeight;
                const defaultStemExtention = stem_direction === $a801f2c896bd09f1$var$Stem.DOWN ? this.glyphProps.stem_down_extension : this.glyphProps.stem_up_extension;
                let defaultOffsetY = $a801f2c896bd09f1$var$Tables.STEM_HEIGHT;
                defaultOffsetY -= defaultOffsetY / 2.8;
                defaultOffsetY += defaultStemExtention;
                y4 += defaultOffsetY * staveNoteScale * stem_direction;
                const offsets = stem_direction === $a801f2c896bd09f1$var$Stem.UP ? {
                    x1: 1,
                    y1: 0,
                    x2: 13,
                    y2: -9
                } : {
                    x1: -4,
                    y1: 1,
                    x2: 13,
                    y2: 9
                };
                x4 += offsets.x1 * offsetScale;
                y4 += offsets.y1 * offsetScale;
                slashBBox = {
                    x1: x4,
                    y1: y4,
                    x2: x4 + offsets.x2 * offsetScale,
                    y2: y4 + offsets.y2 * offsetScale
                };
            }
            const ctx = this.checkContext();
            ctx.save();
            ctx.setLineWidth(1 * offsetScale);
            ctx.beginPath();
            ctx.moveTo(slashBBox.x1, slashBBox.y1);
            ctx.lineTo(slashBBox.x2, slashBBox.y2);
            ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    }
    calcBeamedNotesSlashBBox(slashStemOffset, slashBeamOffset, protrusions) {
        const beam = this.beam;
        if (!beam) throw new $a801f2c896bd09f1$var$RuntimeError("NoBeam", "Can't calculate without a beam.");
        const beam_slope = beam.slope;
        const isBeamEndNote = beam.notes[beam.notes.length - 1] === this;
        const scaleX = isBeamEndNote ? -1 : 1;
        const beam_angle = Math.atan(beam_slope * scaleX);
        const iPointOnBeam = {
            dx: Math.cos(beam_angle) * slashBeamOffset,
            dy: Math.sin(beam_angle) * slashBeamOffset
        };
        slashStemOffset *= this.getStemDirection();
        const slash_angle = Math.atan((iPointOnBeam.dy - slashStemOffset) / iPointOnBeam.dx);
        const protrusion_stem_dx = Math.cos(slash_angle) * protrusions.stem * scaleX;
        const protrusion_stem_dy = Math.sin(slash_angle) * protrusions.stem;
        const protrusion_beam_dx = Math.cos(slash_angle) * protrusions.beam * scaleX;
        const protrusion_beam_dy = Math.sin(slash_angle) * protrusions.beam;
        const stemX = this.getStemX();
        const stem0X = beam.notes[0].getStemX();
        const stemY = beam.getBeamYToDraw() + (stemX - stem0X) * beam_slope;
        const ret = {
            x1: stemX - protrusion_stem_dx,
            y1: stemY + slashStemOffset - protrusion_stem_dy,
            x2: stemX + iPointOnBeam.dx * scaleX + protrusion_beam_dx,
            y2: stemY + iPointOnBeam.dy + protrusion_beam_dy
        };
        return ret;
    }
};
// node_modules/vexflow/build/esm/src/keysignote.js
var $a801f2c896bd09f1$var$KeySigNote = class extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "KeySigNote";
    }
    constructor(keySpec, cancelKeySpec, alterKeySpec){
        super({
            duration: "b"
        });
        this.keySignature = new $a801f2c896bd09f1$var$KeySignature(keySpec, cancelKeySpec, alterKeySpec);
        this.ignore_ticks = true;
    }
    addToModifierContext(mc) {
        return this;
    }
    preFormat() {
        this.preFormatted = true;
        this.keySignature.setStave(this.checkStave());
        this.setWidth(this.keySignature.getWidth());
        return this;
    }
    draw() {
        const ctx = this.checkStave().checkContext();
        this.setRendered();
        this.keySignature.setX(this.getAbsoluteX());
        this.keySignature.setContext(ctx);
        this.keySignature.draw();
    }
};
// node_modules/vexflow/build/esm/src/multimeasurerest.js
var $a801f2c896bd09f1$var$semibreve_rest;
function $a801f2c896bd09f1$var$get_semibreve_rest() {
    if (!$a801f2c896bd09f1$var$semibreve_rest) {
        const noteHead = new $a801f2c896bd09f1$var$NoteHead({
            duration: "w",
            note_type: "r"
        });
        $a801f2c896bd09f1$var$semibreve_rest = {
            glyph_font_scale: noteHead.render_options.glyph_font_scale,
            glyph_code: noteHead.glyph_code,
            width: noteHead.getWidth()
        };
    }
    return $a801f2c896bd09f1$var$semibreve_rest;
}
var $a801f2c896bd09f1$var$MultiMeasureRest = class extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "MultiMeasureRest";
    }
    constructor(number_of_measures, options2){
        var _a;
        super();
        this.xs = {
            left: NaN,
            right: NaN
        };
        this.hasPaddingLeft = false;
        this.hasPaddingRight = false;
        this.hasLineThickness = false;
        this.hasSymbolSpacing = false;
        this.number_of_measures = number_of_measures;
        this.hasPaddingLeft = typeof options2.padding_left === "number";
        this.hasPaddingRight = typeof options2.padding_right === "number";
        this.hasLineThickness = typeof options2.line_thickness === "number";
        this.hasSymbolSpacing = typeof options2.symbol_spacing === "number";
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        this.render_options = Object.assign({
            use_symbols: false,
            show_number: true,
            number_line: -0.5,
            number_glyph_point: (_a = musicFont.lookupMetric("digits.point")) !== null && _a !== void 0 ? _a : $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE,
            line: 2,
            spacing_between_lines_px: $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE,
            serif_thickness: 2,
            semibreve_rest_glyph_scale: $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE,
            padding_left: 0,
            padding_right: 0,
            line_thickness: 5,
            symbol_spacing: 0
        }, options2);
        const fontLineShift = musicFont.lookupMetric("digits.shiftLine", 0);
        this.render_options.number_line += fontLineShift;
    }
    getXs() {
        return this.xs;
    }
    setStave(stave) {
        this.stave = stave;
        return this;
    }
    getStave() {
        return this.stave;
    }
    checkStave() {
        return $a801f2c896bd09f1$var$defined(this.stave, "NoStave", "No stave attached to instance.");
    }
    drawLine(stave, ctx, left, right, spacingBetweenLines) {
        const options2 = this.render_options;
        const y4 = stave.getYForLine(options2.line);
        const padding = (right - left) * 0.1;
        left += padding;
        right -= padding;
        let lineThicknessHalf;
        if (this.hasLineThickness) lineThicknessHalf = options2.line_thickness * 0.5;
        else lineThicknessHalf = spacingBetweenLines * 0.25;
        const serifThickness = options2.serif_thickness;
        const top2 = y4 - spacingBetweenLines;
        const bot = y4 + spacingBetweenLines;
        const leftIndented = left + serifThickness;
        const rightIndented = right - serifThickness;
        const lineTop = y4 - lineThicknessHalf;
        const lineBottom = y4 + lineThicknessHalf;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(left, top2);
        ctx.lineTo(leftIndented, top2);
        ctx.lineTo(leftIndented, lineTop);
        ctx.lineTo(rightIndented, lineTop);
        ctx.lineTo(rightIndented, top2);
        ctx.lineTo(right, top2);
        ctx.lineTo(right, bot);
        ctx.lineTo(rightIndented, bot);
        ctx.lineTo(rightIndented, lineBottom);
        ctx.lineTo(leftIndented, lineBottom);
        ctx.lineTo(leftIndented, bot);
        ctx.lineTo(left, bot);
        ctx.closePath();
        ctx.fill();
    }
    drawSymbols(stave, ctx, left, right, spacingBetweenLines) {
        const n4 = Math.floor(this.number_of_measures / 4);
        const n = this.number_of_measures % 4;
        const n2 = Math.floor(n / 2);
        const n1 = n % 2;
        const options2 = this.render_options;
        $a801f2c896bd09f1$var$semibreve_rest = void 0;
        const rest = $a801f2c896bd09f1$var$get_semibreve_rest();
        const rest_scale = options2.semibreve_rest_glyph_scale;
        const rest_width = rest.width * (rest_scale / rest.glyph_font_scale);
        const glyphs = {
            2: {
                width: rest_width * 0.5,
                height: spacingBetweenLines
            },
            1: {
                width: rest_width
            }
        };
        const spacing = this.hasSymbolSpacing ? options2.symbol_spacing : 10;
        const width9 = n4 * glyphs[2].width + n2 * glyphs[2].width + n1 * glyphs[1].width + (n4 + n2 + n1 - 1) * spacing;
        let x4 = left + (right - left) * 0.5 - width9 * 0.5;
        const line2 = options2.line;
        const yTop = stave.getYForLine(line2 - 1);
        const yMiddle = stave.getYForLine(line2);
        const yBottom = stave.getYForLine(line2 + 1);
        ctx.save();
        ctx.setStrokeStyle("none");
        ctx.setLineWidth(0);
        for(let i2 = 0; i2 < n4; ++i2){
            ctx.fillRect(x4, yMiddle - glyphs[2].height, glyphs[2].width, glyphs[2].height);
            ctx.fillRect(x4, yBottom - glyphs[2].height, glyphs[2].width, glyphs[2].height);
            x4 += glyphs[2].width + spacing;
        }
        for(let i2 = 0; i2 < n2; ++i2){
            ctx.fillRect(x4, yMiddle - glyphs[2].height, glyphs[2].width, glyphs[2].height);
            x4 += glyphs[2].width + spacing;
        }
        for(let i2 = 0; i2 < n1; ++i2){
            $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, x4, yTop, rest_scale, rest.glyph_code);
            x4 += glyphs[1].width + spacing;
        }
        ctx.restore();
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        const stave = this.checkStave();
        let left = stave.getNoteStartX();
        let right = stave.getNoteEndX();
        const begModifiers = stave.getModifiers($a801f2c896bd09f1$var$StaveModifierPosition.BEGIN);
        if (begModifiers.length === 1 && $a801f2c896bd09f1$var$isBarline(begModifiers[0])) left -= begModifiers[0].getWidth();
        const options2 = this.render_options;
        if (this.hasPaddingLeft) left = stave.getX() + options2.padding_left;
        if (this.hasPaddingRight) right = stave.getX() + stave.getWidth() - options2.padding_right;
        this.xs.left = left;
        this.xs.right = right;
        const spacingBetweenLines = options2.spacing_between_lines_px;
        if (options2.use_symbols) this.drawSymbols(stave, ctx, left, right, spacingBetweenLines);
        else this.drawLine(stave, ctx, left, right, spacingBetweenLines);
        if (options2.show_number) {
            const timeSpec = "/" + this.number_of_measures;
            const timeSig = new $a801f2c896bd09f1$var$TimeSignature(timeSpec, 0, false);
            timeSig.point = options2.number_glyph_point;
            timeSig.setTimeSig(timeSpec);
            timeSig.setStave(stave);
            timeSig.setX(left + (right - left) * 0.5 - timeSig.getInfo().glyph.getMetrics().width * 0.5);
            timeSig.bottomLine = options2.number_line;
            timeSig.setContext(ctx).draw();
        }
    }
};
// node_modules/vexflow/build/esm/src/pedalmarking.js
function $a801f2c896bd09f1$var$L18(...args) {
    if ($a801f2c896bd09f1$var$PedalMarking.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.PedalMarking", args);
}
function $a801f2c896bd09f1$var$drawPedalGlyph(name17, context, x4, y4, point) {
    const glyph_data = $a801f2c896bd09f1$var$PedalMarking.GLYPHS[name17];
    const glyph = new $a801f2c896bd09f1$var$Glyph(glyph_data.code, point, {
        category: "pedalMarking"
    });
    glyph.render(context, x4 - (glyph.getMetrics().width - $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE) / 2, y4);
}
var $a801f2c896bd09f1$var$PedalMarking = class _PedalMarking extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "PedalMarking";
    }
    static createSustain(notes) {
        const pedal = new _PedalMarking(notes);
        return pedal;
    }
    static createSostenuto(notes) {
        const pedal = new _PedalMarking(notes);
        pedal.setType(_PedalMarking.type.MIXED);
        pedal.setCustomText("Sost. Ped.");
        return pedal;
    }
    static createUnaCorda(notes) {
        const pedal = new _PedalMarking(notes);
        pedal.setType(_PedalMarking.type.TEXT);
        pedal.setCustomText("una corda", "tre corda");
        return pedal;
    }
    constructor(notes){
        super();
        this.notes = notes;
        this.type = _PedalMarking.type.TEXT;
        this.line = 0;
        this.custom_depress_text = "";
        this.custom_release_text = "";
        this.resetFont();
        this.render_options = {
            bracket_height: 10,
            text_margin_right: 6,
            bracket_line_width: 1,
            color: "black"
        };
    }
    setType(type) {
        type = typeof type === "string" ? _PedalMarking.typeString[type] : type;
        if (type >= _PedalMarking.type.TEXT && type <= _PedalMarking.type.MIXED) this.type = type;
        return this;
    }
    setCustomText(depress, release) {
        this.custom_depress_text = depress || "";
        this.custom_release_text = release || "";
        return this;
    }
    setLine(line2) {
        this.line = line2;
        return this;
    }
    drawBracketed() {
        const ctx = this.checkContext();
        let is_pedal_depressed = false;
        let prev_x;
        let prev_y;
        this.notes.forEach((note2, index5, notes)=>{
            var _a;
            is_pedal_depressed = !is_pedal_depressed;
            const x4 = note2.getAbsoluteX();
            const y4 = note2.checkStave().getYForBottomText(this.line + 3);
            if (x4 < prev_x) throw new $a801f2c896bd09f1$var$RuntimeError("InvalidConfiguration", "The notes provided must be in order of ascending x positions");
            const next_is_same = notes[index5 + 1] === note2;
            const prev_is_same = notes[index5 - 1] === note2;
            let x_shift = 0;
            const point = (_a = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric(`pedalMarking.${is_pedal_depressed ? "down" : "up"}.point`)) !== null && _a !== void 0 ? _a : $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE;
            if (is_pedal_depressed) {
                x_shift = prev_is_same ? 5 : 0;
                if (this.type === _PedalMarking.type.MIXED && !prev_is_same) {
                    if (this.custom_depress_text) {
                        const text_width = ctx.measureText(this.custom_depress_text).width;
                        ctx.fillText(this.custom_depress_text, x4 - text_width / 2, y4);
                        x_shift = text_width / 2 + this.render_options.text_margin_right;
                    } else {
                        $a801f2c896bd09f1$var$drawPedalGlyph("pedal_depress", ctx, x4, y4, point);
                        x_shift = 20 + this.render_options.text_margin_right;
                    }
                } else {
                    ctx.beginPath();
                    ctx.moveTo(x4, y4 - this.render_options.bracket_height);
                    ctx.lineTo(x4 + x_shift, y4);
                    ctx.stroke();
                    ctx.closePath();
                }
            } else {
                x_shift = next_is_same ? -5 : 0;
                ctx.beginPath();
                ctx.moveTo(prev_x, prev_y);
                ctx.lineTo(x4 + x_shift, y4);
                ctx.lineTo(x4, y4 - this.render_options.bracket_height);
                ctx.stroke();
                ctx.closePath();
            }
            prev_x = x4 + x_shift;
            prev_y = y4;
        });
    }
    drawText() {
        const ctx = this.checkContext();
        let is_pedal_depressed = false;
        this.notes.forEach((note2)=>{
            var _a;
            is_pedal_depressed = !is_pedal_depressed;
            const stave = note2.checkStave();
            const x4 = note2.getAbsoluteX();
            const y4 = stave.getYForBottomText(this.line + 3);
            const point = (_a = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric(`pedalMarking.${is_pedal_depressed ? "down" : "up"}.point`)) !== null && _a !== void 0 ? _a : $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE;
            let text_width = 0;
            if (is_pedal_depressed) {
                if (this.custom_depress_text) {
                    text_width = ctx.measureText(this.custom_depress_text).width;
                    ctx.fillText(this.custom_depress_text, x4 - text_width / 2, y4);
                } else $a801f2c896bd09f1$var$drawPedalGlyph("pedal_depress", ctx, x4, y4, point);
            } else if (this.custom_release_text) {
                text_width = ctx.measureText(this.custom_release_text).width;
                ctx.fillText(this.custom_release_text, x4 - text_width / 2, y4);
            } else $a801f2c896bd09f1$var$drawPedalGlyph("pedal_release", ctx, x4, y4, point);
        });
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        ctx.save();
        ctx.setStrokeStyle(this.render_options.color);
        ctx.setFillStyle(this.render_options.color);
        ctx.setFont(this.textFont);
        $a801f2c896bd09f1$var$L18("Rendering Pedal Marking");
        if (this.type === _PedalMarking.type.BRACKET || this.type === _PedalMarking.type.MIXED) {
            ctx.setLineWidth(this.render_options.bracket_line_width);
            this.drawBracketed();
        } else if (this.type === _PedalMarking.type.TEXT) this.drawText();
        ctx.restore();
    }
};
$a801f2c896bd09f1$var$PedalMarking.DEBUG = false;
$a801f2c896bd09f1$var$PedalMarking.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SERIF,
    size: 12,
    weight: $a801f2c896bd09f1$var$FontWeight.BOLD,
    style: $a801f2c896bd09f1$var$FontStyle.ITALIC
};
$a801f2c896bd09f1$var$PedalMarking.GLYPHS = {
    pedal_depress: {
        code: "keyboardPedalPed"
    },
    pedal_release: {
        code: "keyboardPedalUp"
    }
};
$a801f2c896bd09f1$var$PedalMarking.type = {
    TEXT: 1,
    BRACKET: 2,
    MIXED: 3
};
$a801f2c896bd09f1$var$PedalMarking.typeString = {
    text: $a801f2c896bd09f1$var$PedalMarking.type.TEXT,
    bracket: $a801f2c896bd09f1$var$PedalMarking.type.BRACKET,
    mixed: $a801f2c896bd09f1$var$PedalMarking.type.MIXED
};
// node_modules/vexflow/build/esm/src/repeatnote.js
var $a801f2c896bd09f1$var$CODES = {
    "1": "repeat1Bar",
    "2": "repeat2Bars",
    "4": "repeat4Bars",
    slash: "repeatBarSlash"
};
var $a801f2c896bd09f1$var$RepeatNote = class extends $a801f2c896bd09f1$var$GlyphNote {
    static get CATEGORY() {
        return "RepeatNote";
    }
    constructor(type, noteStruct, options2){
        const glyphCode = $a801f2c896bd09f1$var$CODES[type] || "repeat1Bar";
        const glyph = new $a801f2c896bd09f1$var$Glyph(glyphCode, $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("repeatNote.point", 40), {
            category: "repeatNote"
        });
        super(glyph, Object.assign({
            duration: "q",
            align_center: type !== "slash"
        }, noteStruct), options2);
    }
};
// node_modules/vexflow/build/esm/src/staveline.js
function $a801f2c896bd09f1$var$drawArrowHead(ctx, x0, y0, x12, y12, x22, y22) {
    ctx.beginPath();
    ctx.moveTo(x0, y0);
    ctx.lineTo(x12, y12);
    ctx.lineTo(x22, y22);
    ctx.lineTo(x0, y0);
    ctx.closePath();
    ctx.fill();
}
var $a801f2c896bd09f1$var$StaveLine = class _StaveLine extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "StaveLine";
    }
    constructor(notes){
        super();
        this.setNotes(notes);
        this.text = "";
        this.resetFont();
        this.render_options = {
            padding_left: 4,
            padding_right: 3,
            line_width: 1,
            line_dash: void 0,
            rounded_end: true,
            color: void 0,
            draw_start_arrow: false,
            draw_end_arrow: false,
            arrowhead_length: 10,
            arrowhead_angle: Math.PI / 8,
            text_position_vertical: _StaveLine.TextVerticalPosition.TOP,
            text_justification: _StaveLine.TextJustification.CENTER
        };
    }
    setText(text7) {
        this.text = text7;
        return this;
    }
    setNotes(notes) {
        if (!notes.first_note && !notes.last_note) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Notes needs to have either first_note or last_note set.");
        if (!notes.first_indices) notes.first_indices = [
            0
        ];
        if (!notes.last_indices) notes.last_indices = [
            0
        ];
        if (notes.first_indices.length !== notes.last_indices.length) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Connected notes must have same number of indices.");
        this.notes = notes;
        this.first_note = notes.first_note;
        this.first_indices = notes.first_indices;
        this.last_note = notes.last_note;
        this.last_indices = notes.last_indices;
        return this;
    }
    applyLineStyle() {
        const ctx = this.checkContext();
        const render_options = this.render_options;
        if (render_options.line_dash) ctx.setLineDash(render_options.line_dash);
        if (render_options.line_width) ctx.setLineWidth(render_options.line_width);
        if (render_options.rounded_end) ctx.setLineCap("round");
        else ctx.setLineCap("square");
    }
    applyFontStyle() {
        const ctx = this.checkContext();
        ctx.setFont(this.textFont);
        const render_options = this.render_options;
        const color = render_options.color;
        if (color) {
            ctx.setStrokeStyle(color);
            ctx.setFillStyle(color);
        }
    }
    drawArrowLine(ctx, pt1, pt2) {
        const both_arrows = this.render_options.draw_start_arrow && this.render_options.draw_end_arrow;
        const x12 = pt1.x;
        const y12 = pt1.y;
        const x22 = pt2.x;
        const y22 = pt2.y;
        const distance = Math.sqrt((x22 - x12) * (x22 - x12) + (y22 - y12) * (y22 - y12));
        const ratio = (distance - this.render_options.arrowhead_length / 3) / distance;
        let end_x;
        let end_y;
        let start_x;
        let start_y;
        if (this.render_options.draw_end_arrow || both_arrows) {
            end_x = Math.round(x12 + (x22 - x12) * ratio);
            end_y = Math.round(y12 + (y22 - y12) * ratio);
        } else {
            end_x = x22;
            end_y = y22;
        }
        if (this.render_options.draw_start_arrow || both_arrows) {
            start_x = x12 + (x22 - x12) * (1 - ratio);
            start_y = y12 + (y22 - y12) * (1 - ratio);
        } else {
            start_x = x12;
            start_y = y12;
        }
        if (this.render_options.color) {
            ctx.setStrokeStyle(this.render_options.color);
            ctx.setFillStyle(this.render_options.color);
        }
        ctx.beginPath();
        ctx.moveTo(start_x, start_y);
        ctx.lineTo(end_x, end_y);
        ctx.stroke();
        ctx.closePath();
        const line_angle = Math.atan2(y22 - y12, x22 - x12);
        const h7 = Math.abs(this.render_options.arrowhead_length / Math.cos(this.render_options.arrowhead_angle));
        let angle1;
        let angle2;
        let top_x;
        let top_y;
        let bottom_x;
        let bottom_y;
        if (this.render_options.draw_end_arrow || both_arrows) {
            angle1 = line_angle + Math.PI + this.render_options.arrowhead_angle;
            top_x = x22 + Math.cos(angle1) * h7;
            top_y = y22 + Math.sin(angle1) * h7;
            angle2 = line_angle + Math.PI - this.render_options.arrowhead_angle;
            bottom_x = x22 + Math.cos(angle2) * h7;
            bottom_y = y22 + Math.sin(angle2) * h7;
            $a801f2c896bd09f1$var$drawArrowHead(ctx, top_x, top_y, x22, y22, bottom_x, bottom_y);
        }
        if (this.render_options.draw_start_arrow || both_arrows) {
            angle1 = line_angle + this.render_options.arrowhead_angle;
            top_x = x12 + Math.cos(angle1) * h7;
            top_y = y12 + Math.sin(angle1) * h7;
            angle2 = line_angle - this.render_options.arrowhead_angle;
            bottom_x = x12 + Math.cos(angle2) * h7;
            bottom_y = y12 + Math.sin(angle2) * h7;
            $a801f2c896bd09f1$var$drawArrowHead(ctx, top_x, top_y, x12, y12, bottom_x, bottom_y);
        }
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        const first_note = this.first_note;
        const last_note = this.last_note;
        const render_options = this.render_options;
        ctx.save();
        this.applyLineStyle();
        let start_position = {
            x: 0,
            y: 0
        };
        let end_position = {
            x: 0,
            y: 0
        };
        this.first_indices.forEach((first_index, i2)=>{
            const last_index = this.last_indices[i2];
            start_position = first_note.getModifierStartXY(2, first_index);
            end_position = last_note.getModifierStartXY(1, last_index);
            const upwards_slope = start_position.y > end_position.y;
            start_position.x += first_note.getMetrics().modRightPx + render_options.padding_left;
            end_position.x -= last_note.getMetrics().modLeftPx + render_options.padding_right;
            const notehead_width = first_note.getGlyphProps().getWidth();
            const first_displaced = first_note.getKeyProps()[first_index].displaced;
            if (first_displaced && first_note.getStemDirection() === 1) start_position.x += notehead_width + render_options.padding_left;
            const last_displaced = last_note.getKeyProps()[last_index].displaced;
            if (last_displaced && last_note.getStemDirection() === -1) end_position.x -= notehead_width + render_options.padding_right;
            start_position.y += upwards_slope ? -3 : 1;
            end_position.y += upwards_slope ? 2 : 0;
            this.drawArrowLine(ctx, start_position, end_position);
        });
        ctx.restore();
        const text_width = ctx.measureText(this.text).width;
        const justification = render_options.text_justification;
        let x4 = 0;
        if (justification === _StaveLine.TextJustification.LEFT) x4 = start_position.x;
        else if (justification === _StaveLine.TextJustification.CENTER) {
            const delta_x = end_position.x - start_position.x;
            const center_x = delta_x / 2 + start_position.x;
            x4 = center_x - text_width / 2;
        } else if (justification === _StaveLine.TextJustification.RIGHT) x4 = end_position.x - text_width;
        let y4 = 0;
        const vertical_position = render_options.text_position_vertical;
        if (vertical_position === _StaveLine.TextVerticalPosition.TOP) y4 = first_note.checkStave().getYForTopText();
        else if (vertical_position === _StaveLine.TextVerticalPosition.BOTTOM) y4 = first_note.checkStave().getYForBottomText($a801f2c896bd09f1$var$Tables.TEXT_HEIGHT_OFFSET_HACK);
        ctx.save();
        this.applyFontStyle();
        ctx.fillText(this.text, x4, y4);
        ctx.restore();
        return this;
    }
};
$a801f2c896bd09f1$var$StaveLine.TEXT_FONT = Object.assign({}, $a801f2c896bd09f1$var$Element.TEXT_FONT);
$a801f2c896bd09f1$var$StaveLine.TextVerticalPosition = {
    TOP: 1,
    BOTTOM: 2
};
$a801f2c896bd09f1$var$StaveLine.TextJustification = $a801f2c896bd09f1$var$TextJustification;
// node_modules/vexflow/build/esm/src/system.js
var $a801f2c896bd09f1$var$System = class extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "System";
    }
    constructor(params = {}){
        super();
        this.setOptions(params);
        this.partStaves = [];
        this.partStaveInfos = [];
        this.partVoices = [];
    }
    setOptions(options2 = {}) {
        if (!options2.factory) throw new $a801f2c896bd09f1$var$RuntimeError("NoFactory", "System.setOptions(options) requires a factory.");
        this.factory = options2.factory;
        this.options = Object.assign(Object.assign({
            factory: this.factory,
            x: 10,
            y: 10,
            width: 500,
            spaceBetweenStaves: 12,
            autoWidth: false,
            noJustification: false,
            debugFormatter: false,
            formatIterations: 0,
            noPadding: false
        }, options2), {
            details: Object.assign({
                alpha: 0.5
            }, options2.details),
            formatOptions: Object.assign({}, options2.formatOptions)
        });
        if (this.options.noJustification === false && typeof options2.width === "undefined") this.options.autoWidth = true;
    }
    getX() {
        return this.options.x;
    }
    setX(x4) {
        this.options.x = x4;
        this.partStaves.forEach((s2)=>{
            s2.setX(x4);
        });
    }
    getY() {
        return this.options.y;
    }
    setY(y4) {
        this.options.y = y4;
        this.partStaves.forEach((s2)=>{
            s2.setY(y4);
        });
    }
    getStaves() {
        return this.partStaves;
    }
    getVoices() {
        return this.partVoices;
    }
    setContext(context) {
        super.setContext(context);
        this.factory.setContext(context);
        return this;
    }
    addConnector(type = "double") {
        this.connector = this.factory.StaveConnector({
            top_stave: this.partStaves[0],
            bottom_stave: this.partStaves[this.partStaves.length - 1],
            type: type
        });
        return this.connector;
    }
    addStave(params) {
        var _a;
        const staveOptions = Object.assign({
            left_bar: false
        }, params.options);
        const stave = (_a = params.stave) !== null && _a !== void 0 ? _a : this.factory.Stave({
            x: this.options.x,
            y: this.options.y,
            width: this.options.width,
            options: staveOptions
        });
        const p3 = Object.assign(Object.assign({
            spaceAbove: 0,
            spaceBelow: 0,
            debugNoteMetrics: false,
            noJustification: false
        }, params), {
            options: staveOptions
        });
        const ctx = this.getContext();
        p3.voices.forEach((voice)=>{
            voice.setContext(ctx).setStave(stave).getTickables().forEach((tickable)=>tickable.setStave(stave));
            this.partVoices.push(voice);
        });
        this.partStaves.push(stave);
        this.partStaveInfos.push(p3);
        return stave;
    }
    addVoices(voices) {
        const ctx = this.getContext();
        voices.forEach((voice)=>{
            voice.setContext(ctx);
            this.partVoices.push(voice);
        });
    }
    format() {
        const options_details = this.options.details;
        let justifyWidth = 0;
        const formatter = new $a801f2c896bd09f1$var$Formatter(options_details);
        this.formatter = formatter;
        let y4 = this.options.y;
        let startX = 0;
        const debugNoteMetricsYs = [];
        this.partStaves.forEach((part, index5)=>{
            y4 = y4 + part.space(this.partStaveInfos[index5].spaceAbove);
            part.setY(y4);
            y4 = y4 + part.space(this.partStaveInfos[index5].spaceBelow);
            y4 = y4 + part.space(this.options.spaceBetweenStaves);
            if (this.partStaveInfos[index5].debugNoteMetrics) {
                debugNoteMetricsYs.push({
                    y: y4,
                    stave: part
                });
                y4 += 15;
            }
            startX = Math.max(startX, part.getNoteStartX());
        });
        this.partVoices.forEach((voice)=>{
            voice.getTickables().forEach((tickable)=>{
                const stave = tickable.getStave();
                if (stave) tickable.setStave(stave);
            });
        });
        formatter.joinVoices(this.partVoices);
        this.partStaves.forEach((part)=>part.setNoteStartX(startX));
        if (this.options.autoWidth && this.partVoices.length > 0) {
            justifyWidth = formatter.preCalculateMinTotalWidth(this.partVoices);
            this.options.width = justifyWidth + $a801f2c896bd09f1$var$Stave.rightPadding + (startX - this.options.x);
            this.partStaves.forEach((part)=>{
                part.setWidth(this.options.width);
            });
        } else justifyWidth = this.options.noPadding ? this.options.width - (startX - this.options.x) : this.options.width - (startX - this.options.x) - $a801f2c896bd09f1$var$Stave.defaultPadding;
        if (this.partVoices.length > 0) formatter.format(this.partVoices, this.options.noJustification ? 0 : justifyWidth, this.options.formatOptions);
        formatter.postFormat();
        for(let i2 = 0; i2 < this.options.formatIterations; i2++)formatter.tune(options_details);
        this.startX = startX;
        this.debugNoteMetricsYs = debugNoteMetricsYs;
        this.lastY = y4;
        this.boundingBox = new $a801f2c896bd09f1$var$BoundingBox(this.options.x, this.options.y, this.options.width, this.lastY - this.options.y);
        $a801f2c896bd09f1$var$Stave.formatBegModifiers(this.partStaves);
    }
    draw() {
        const ctx = this.checkContext();
        if (!this.formatter || !this.startX || !this.lastY || !this.debugNoteMetricsYs) throw new $a801f2c896bd09f1$var$RuntimeError("NoFormatter", "format() must be called before draw()");
        this.setRendered();
        if (this.options.debugFormatter) $a801f2c896bd09f1$var$Formatter.plotDebugging(ctx, this.formatter, this.startX, this.options.y, this.lastY);
        this.debugNoteMetricsYs.forEach((d)=>{
            this.partVoices.forEach((voice)=>{
                voice.getTickables().forEach((tickable)=>{
                    if (tickable.getStave() === d.stave) $a801f2c896bd09f1$var$Note.plotMetrics(ctx, tickable, d.y);
                });
            });
        });
    }
};
// node_modules/vexflow/build/esm/src/tabnote.js
function $a801f2c896bd09f1$var$getUnusedStringGroups(num_lines, strings_used) {
    const stem_through = [];
    let group4 = [];
    for(let string = 1; string <= num_lines; string++){
        const is_used = strings_used.indexOf(string) > -1;
        if (!is_used) group4.push(string);
        else {
            stem_through.push(group4);
            group4 = [];
        }
    }
    if (group4.length > 0) stem_through.push(group4);
    return stem_through;
}
function $a801f2c896bd09f1$var$getPartialStemLines(stem_y, unused_strings, stave, stem_direction) {
    const up_stem = stem_direction !== 1;
    const down_stem = stem_direction !== -1;
    const line_spacing = stave.getSpacingBetweenLines();
    const total_lines = stave.getNumLines();
    const stem_lines = [];
    unused_strings.forEach((strings)=>{
        const containsLastString = strings.indexOf(total_lines) > -1;
        const containsFirstString = strings.indexOf(1) > -1;
        if (up_stem && containsFirstString || down_stem && containsLastString) return;
        if (strings.length === 1) strings.push(strings[0]);
        const line_ys = [];
        strings.forEach((string, index5, strings2)=>{
            const isTopBound = string === 1;
            const isBottomBound = string === total_lines;
            let y4 = stave.getYForLine(string - 1);
            if (index5 === 0 && !isTopBound) y4 -= line_spacing / 2 - 1;
            else if (index5 === strings2.length - 1 && !isBottomBound) y4 += line_spacing / 2 - 1;
            line_ys.push(y4);
            if (stem_direction === 1 && isTopBound) line_ys.push(stem_y - 2);
            else if (stem_direction === -1 && isBottomBound) line_ys.push(stem_y + 2);
        });
        stem_lines.push(line_ys.sort((a3, b3)=>a3 - b3));
    });
    return stem_lines;
}
var $a801f2c896bd09f1$var$TabNote = class extends $a801f2c896bd09f1$var$StemmableNote {
    static get CATEGORY() {
        return "TabNote";
    }
    constructor(noteStruct, draw_stem = false){
        super(noteStruct);
        this.glyphPropsArr = [];
        this.greatestString = ()=>{
            return this.positions.map((x4)=>x4.str).reduce((a3, b3)=>a3 > b3 ? a3 : b3);
        };
        this.leastString = ()=>{
            return this.positions.map((x4)=>x4.str).reduce((a3, b3)=>a3 < b3 ? a3 : b3);
        };
        this.ghost = false;
        this.positions = noteStruct.positions || [];
        this.render_options = Object.assign(Object.assign({}, this.render_options), {
            glyph_font_scale: $a801f2c896bd09f1$var$Tables.TABLATURE_FONT_SCALE,
            draw_stem: draw_stem,
            draw_dots: draw_stem,
            draw_stem_through_stave: false,
            y_shift: 0,
            scale: 1,
            font: `${$a801f2c896bd09f1$var$Font.SIZE}pt ${$a801f2c896bd09f1$var$Font.SANS_SERIF}`
        });
        this.glyphProps = $a801f2c896bd09f1$var$Tables.getGlyphProps(this.duration, this.noteType);
        $a801f2c896bd09f1$var$defined(this.glyphProps, "BadArguments", `No glyph found for duration '${this.duration}' and type '${this.noteType}'`);
        this.buildStem();
        if (noteStruct.stem_direction) this.setStemDirection(noteStruct.stem_direction);
        else this.setStemDirection($a801f2c896bd09f1$var$Stem.UP);
        this.ghost = false;
        this.updateWidth();
    }
    reset() {
        super.reset();
        if (this.stave) this.setStave(this.stave);
        return this;
    }
    setGhost(ghost) {
        this.ghost = ghost;
        this.updateWidth();
        return this;
    }
    hasStem() {
        if (this.render_options.draw_stem) return true;
        return false;
    }
    getStemExtension() {
        const glyphProps = this.getGlyphProps();
        if (this.stem_extension_override != null) return this.stem_extension_override;
        if (glyphProps) return this.getStemDirection() === $a801f2c896bd09f1$var$Stem.UP ? glyphProps.tabnote_stem_up_extension : glyphProps.tabnote_stem_down_extension;
        return 0;
    }
    updateWidth() {
        this.glyphPropsArr = [];
        this.width = 0;
        for(let i2 = 0; i2 < this.positions.length; ++i2){
            let fret = this.positions[i2].fret;
            if (this.ghost) fret = "(" + fret + ")";
            const glyphProps = $a801f2c896bd09f1$var$Tables.tabToGlyphProps(fret.toString(), this.render_options.scale);
            this.glyphPropsArr.push(glyphProps);
            this.width = Math.max(glyphProps.getWidth(), this.width);
        }
        this.glyphProps.getWidth = ()=>this.width;
    }
    setStave(stave) {
        super.setStave(stave);
        const ctx = stave.getContext();
        this.setContext(ctx);
        if (ctx) {
            this.width = 0;
            for(let i2 = 0; i2 < this.glyphPropsArr.length; ++i2){
                const glyphProps = this.glyphPropsArr[i2];
                const text7 = "" + glyphProps.text;
                if (text7.toUpperCase() !== "X") {
                    ctx.save();
                    ctx.setFont(this.render_options.font);
                    glyphProps.width = ctx.measureText(text7).width;
                    ctx.restore();
                    glyphProps.getWidth = ()=>glyphProps.width;
                }
                this.width = Math.max(glyphProps.getWidth(), this.width);
            }
            this.glyphProps.getWidth = ()=>this.width;
        }
        const ys = this.positions.map(({ str: line2 })=>stave.getYForLine(Number(line2) - 1));
        this.setYs(ys);
        if (this.stem) this.stem.setYBounds(this.getStemY(), this.getStemY());
        return this;
    }
    getPositions() {
        return this.positions;
    }
    getModifierStartXY(position2, index5) {
        if (!this.preFormatted) throw new $a801f2c896bd09f1$var$RuntimeError("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
        if (this.ys.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("NoYValues", "No Y-Values calculated for this note.");
        let x4 = 0;
        if (position2 === $a801f2c896bd09f1$var$Modifier.Position.LEFT) x4 = -2;
        else if (position2 === $a801f2c896bd09f1$var$Modifier.Position.RIGHT) x4 = this.width + 2;
        else if (position2 === $a801f2c896bd09f1$var$Modifier.Position.BELOW || position2 === $a801f2c896bd09f1$var$Modifier.Position.ABOVE) {
            const note_glyph_width = this.glyphProps.getWidth();
            x4 = note_glyph_width / 2;
        }
        return {
            x: this.getAbsoluteX() + x4,
            y: this.ys[index5]
        };
    }
    getLineForRest() {
        return Number(this.positions[0].str);
    }
    preFormat() {
        if (this.preFormatted) return;
        if (this.modifierContext) this.modifierContext.preFormat();
        this.preFormatted = true;
    }
    getStemX() {
        return this.getCenterGlyphX();
    }
    getStemY() {
        const num_lines = this.checkStave().getNumLines();
        const stemUpLine = -0.5;
        const stemDownLine = num_lines - 0.5;
        const stemStartLine = $a801f2c896bd09f1$var$Stem.UP === this.stem_direction ? stemUpLine : stemDownLine;
        return this.checkStave().getYForLine(stemStartLine);
    }
    getStemExtents() {
        return this.checkStem().getExtents();
    }
    drawFlag() {
        var _a;
        const { beam: beam, glyphProps: glyphProps, render_options: { draw_stem: draw_stem } } = this;
        const context = this.checkContext();
        const shouldDrawFlag = beam == void 0 && draw_stem;
        if (glyphProps.flag && shouldDrawFlag) {
            const flag_x = this.getStemX();
            const flag_y = this.getStemDirection() === $a801f2c896bd09f1$var$Stem.DOWN ? this.getStemY() - this.checkStem().getHeight() - (this.glyphProps ? this.glyphProps.stem_down_extension : 0) : this.getStemY() - this.checkStem().getHeight() + (this.glyphProps ? this.glyphProps.stem_up_extension : 0);
            (_a = this.flag) === null || _a === void 0 || _a.render(context, flag_x, flag_y);
        }
    }
    drawModifiers() {
        this.modifiers.forEach((modifier)=>{
            if ($a801f2c896bd09f1$var$isDot(modifier) && !this.render_options.draw_dots) return;
            modifier.setContext(this.getContext());
            modifier.drawWithStyle();
        });
    }
    drawStemThrough() {
        const stemX = this.getStemX();
        const stemY = this.getStemY();
        const ctx = this.checkContext();
        const drawStem = this.render_options.draw_stem;
        const stemThrough = this.render_options.draw_stem_through_stave;
        if (drawStem && stemThrough) {
            const numLines = this.checkStave().getNumLines();
            const stringsUsed = this.positions.map((position2)=>Number(position2.str));
            const unusedStrings = $a801f2c896bd09f1$var$getUnusedStringGroups(numLines, stringsUsed);
            const stemLines = $a801f2c896bd09f1$var$getPartialStemLines(stemY, unusedStrings, this.checkStave(), this.getStemDirection());
            ctx.save();
            ctx.setLineWidth($a801f2c896bd09f1$var$Stem.WIDTH);
            stemLines.forEach((bounds)=>{
                if (bounds.length === 0) return;
                ctx.beginPath();
                ctx.moveTo(stemX, bounds[0]);
                ctx.lineTo(stemX, bounds[bounds.length - 1]);
                ctx.stroke();
                ctx.closePath();
            });
            ctx.restore();
        }
    }
    drawPositions() {
        var _a;
        const ctx = this.checkContext();
        const x4 = this.getAbsoluteX();
        const ys = this.ys;
        for(let i2 = 0; i2 < this.positions.length; ++i2){
            const y4 = ys[i2] + this.render_options.y_shift;
            const glyphProps = this.glyphPropsArr[i2];
            const note_glyph_width = this.glyphProps.getWidth();
            const tab_x = x4 + note_glyph_width / 2 - glyphProps.getWidth() / 2;
            ctx.clearRect(tab_x - 2, y4 - 3, glyphProps.getWidth() + 4, 6);
            if (glyphProps.code) $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, tab_x, y4, this.render_options.glyph_font_scale * this.render_options.scale, glyphProps.code);
            else {
                ctx.save();
                ctx.setFont(this.render_options.font);
                const text7 = (_a = glyphProps.text) !== null && _a !== void 0 ? _a : "";
                ctx.fillText(text7, tab_x, y4 + 5 * this.render_options.scale);
                ctx.restore();
            }
        }
    }
    draw() {
        const ctx = this.checkContext();
        if (this.ys.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("NoYValues", "Can't draw note without Y values.");
        this.setRendered();
        const render_stem = this.beam == void 0 && this.render_options.draw_stem;
        this.applyStyle();
        ctx.openGroup("tabnote", this.getAttribute("id"), {
            pointerBBox: true
        });
        this.drawPositions();
        this.drawStemThrough();
        if (this.stem && render_stem) {
            const stem_x = this.getStemX();
            this.stem.setNoteHeadXBounds(stem_x, stem_x);
            this.stem.setContext(ctx).draw();
        }
        this.drawFlag();
        this.drawModifiers();
        ctx.closeGroup();
        this.restoreStyle();
    }
};
// node_modules/vexflow/build/esm/src/tabstave.js
var $a801f2c896bd09f1$var$TabStave = class extends $a801f2c896bd09f1$var$Stave {
    static get CATEGORY() {
        return "TabStave";
    }
    constructor(x4, y4, width9, options2){
        const tab_options = Object.assign({
            spacing_between_lines_px: 13,
            num_lines: 6,
            top_text_position: 1
        }, options2);
        super(x4, y4, width9, tab_options);
    }
    getYForGlyphs() {
        return this.getYForLine(2.5);
    }
    addTabGlyph() {
        this.addClef("tab");
        return this;
    }
};
// node_modules/vexflow/build/esm/src/textbracket.js
function $a801f2c896bd09f1$var$L19(...args) {
    if ($a801f2c896bd09f1$var$TextBracket.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.TextBracket", args);
}
var $a801f2c896bd09f1$var$TextBracketPosition;
(function(TextBracketPosition2) {
    TextBracketPosition2[TextBracketPosition2["TOP"] = 1] = "TOP";
    TextBracketPosition2[TextBracketPosition2["BOTTOM"] = -1] = "BOTTOM";
})($a801f2c896bd09f1$var$TextBracketPosition || ($a801f2c896bd09f1$var$TextBracketPosition = {}));
var $a801f2c896bd09f1$var$TextBracket = class _TextBracket extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "TextBracket";
    }
    static get Position() {
        return $a801f2c896bd09f1$var$TextBracketPosition;
    }
    static get PositionString() {
        return {
            top: $a801f2c896bd09f1$var$TextBracketPosition.TOP,
            bottom: $a801f2c896bd09f1$var$TextBracketPosition.BOTTOM
        };
    }
    static get Positions() {
        $a801f2c896bd09f1$var$L19("Positions is deprecated, use TextBracketPosition instead.");
        return $a801f2c896bd09f1$var$TextBracketPosition;
    }
    static get PositionsString() {
        $a801f2c896bd09f1$var$L19("PositionsString is deprecated, use PositionString instead.");
        return _TextBracket.PositionString;
    }
    constructor({ start: start2, stop: stop, text: text7 = "", superscript: superscript = "", position: position2 = $a801f2c896bd09f1$var$TextBracketPosition.TOP }){
        super();
        this.start = start2;
        this.stop = stop;
        this.text = text7;
        this.superscript = superscript;
        this.position = typeof position2 === "string" ? _TextBracket.PositionString[position2] : position2;
        this.line = 1;
        this.resetFont();
        this.render_options = {
            dashed: true,
            dash: [
                5
            ],
            color: "black",
            line_width: 1,
            show_bracket: true,
            bracket_height: 8,
            underline_superscript: true
        };
    }
    applyStyle(ctx) {
        ctx.setFont(this.font);
        const options2 = this.render_options;
        ctx.setStrokeStyle(options2.color);
        ctx.setFillStyle(options2.color);
        ctx.setLineWidth(options2.line_width);
        return this;
    }
    setDashed(dashed, dash) {
        this.render_options.dashed = dashed;
        if (dash) this.render_options.dash = dash;
        return this;
    }
    setLine(line2) {
        this.line = line2;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        let y4 = 0;
        switch(this.position){
            case $a801f2c896bd09f1$var$TextBracketPosition.TOP:
                y4 = this.start.checkStave().getYForTopText(this.line);
                break;
            case $a801f2c896bd09f1$var$TextBracketPosition.BOTTOM:
                y4 = this.start.checkStave().getYForBottomText(this.line + $a801f2c896bd09f1$var$Tables.TEXT_HEIGHT_OFFSET_HACK);
                break;
            default:
                throw new $a801f2c896bd09f1$var$RuntimeError("InvalidPosition", `The position ${this.position} is invalid.`);
        }
        const start2 = {
            x: this.start.getAbsoluteX(),
            y: y4
        };
        const stop = {
            x: this.stop.getAbsoluteX(),
            y: y4
        };
        $a801f2c896bd09f1$var$L19("Rendering TextBracket: start:", start2, "stop:", stop, "y:", y4);
        const bracket_height = this.render_options.bracket_height * this.position;
        ctx.save();
        this.applyStyle(ctx);
        ctx.fillText(this.text, start2.x, start2.y);
        const main_measure = ctx.measureText(this.text);
        const main_width = main_measure.width;
        const main_height = main_measure.height;
        const super_y = start2.y - main_height / 2.5;
        const { family: family, size: size6, weight: weight, style: style3 } = this.textFont;
        const smallerFontSize = $a801f2c896bd09f1$var$Font.scaleSize(size6, 0.714286);
        ctx.setFont(family, smallerFontSize, weight, style3);
        ctx.fillText(this.superscript, start2.x + main_width + 1, super_y);
        const super_measure = ctx.measureText(this.superscript);
        const super_width = super_measure.width;
        const super_height = super_measure.height;
        let start_x = start2.x;
        let line_y = super_y;
        const end_x = stop.x + this.stop.getGlyphProps().getWidth();
        if (this.position === $a801f2c896bd09f1$var$TextBracketPosition.TOP) {
            start_x += main_width + super_width + 5;
            line_y -= super_height / 2.7;
        } else if (this.position === $a801f2c896bd09f1$var$TextBracketPosition.BOTTOM) {
            line_y += super_height / 2.7;
            start_x += main_width + 2;
            if (!this.render_options.underline_superscript) start_x += super_width;
        }
        if (this.render_options.dashed) {
            $a801f2c896bd09f1$var$Renderer.drawDashedLine(ctx, start_x, line_y, end_x, line_y, this.render_options.dash);
            if (this.render_options.show_bracket) $a801f2c896bd09f1$var$Renderer.drawDashedLine(ctx, end_x, line_y + 1 * this.position, end_x, line_y + bracket_height, this.render_options.dash);
        } else {
            ctx.beginPath();
            ctx.moveTo(start_x, line_y);
            ctx.lineTo(end_x, line_y);
            if (this.render_options.show_bracket) ctx.lineTo(end_x, line_y + bracket_height);
            ctx.stroke();
            ctx.closePath();
        }
        ctx.restore();
    }
};
$a801f2c896bd09f1$var$TextBracket.DEBUG = false;
$a801f2c896bd09f1$var$TextBracket.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SERIF,
    size: 15,
    weight: $a801f2c896bd09f1$var$FontWeight.NORMAL,
    style: $a801f2c896bd09f1$var$FontStyle.ITALIC
};
// node_modules/vexflow/build/esm/src/textdynamics.js
function $a801f2c896bd09f1$var$L20(...args) {
    if ($a801f2c896bd09f1$var$TextDynamics.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.TextDynamics", args);
}
var $a801f2c896bd09f1$var$TextDynamics = class _TextDynamics extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "TextDynamics";
    }
    static get GLYPHS() {
        return {
            f: {
                code: "dynamicForte",
                width: 12
            },
            p: {
                code: "dynamicPiano",
                width: 14
            },
            m: {
                code: "dynamicMezzo",
                width: 17
            },
            s: {
                code: "dynamicSforzando",
                width: 10
            },
            z: {
                code: "dynamicZ",
                width: 12
            },
            r: {
                code: "dynamicRinforzando",
                width: 12
            }
        };
    }
    constructor(noteStruct){
        super(noteStruct);
        this.sequence = (noteStruct.text || "").toLowerCase();
        this.line = noteStruct.line || 0;
        this.glyphs = [];
        this.render_options = Object.assign(Object.assign({}, this.render_options), {
            glyph_font_size: $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE
        });
        $a801f2c896bd09f1$var$L20("New Dynamics Text: ", this.sequence);
    }
    setLine(line2) {
        this.line = line2;
        return this;
    }
    preFormat() {
        let total_width = 0;
        this.glyphs = [];
        this.sequence.split("").forEach((letter4)=>{
            const glyph_data = _TextDynamics.GLYPHS[letter4];
            if (!glyph_data) throw new $a801f2c896bd09f1$var$RuntimeError("Invalid dynamics character: " + letter4);
            const size6 = $a801f2c896bd09f1$var$defined(this.render_options.glyph_font_size);
            const glyph = new $a801f2c896bd09f1$var$Glyph(glyph_data.code, size6, {
                category: "textNote"
            });
            this.glyphs.push(glyph);
            total_width += glyph_data.width;
        });
        this.setWidth(total_width);
        this.preFormatted = true;
        return this;
    }
    draw() {
        this.setRendered();
        const x4 = this.getAbsoluteX();
        const y4 = this.checkStave().getYForLine(this.line + -3);
        $a801f2c896bd09f1$var$L20("Rendering Dynamics: ", this.sequence);
        let letter_x = x4;
        this.glyphs.forEach((glyph, index5)=>{
            const current_letter = this.sequence[index5];
            glyph.render(this.checkContext(), letter_x, y4);
            letter_x += _TextDynamics.GLYPHS[current_letter].width;
        });
    }
};
$a801f2c896bd09f1$var$TextDynamics.DEBUG = false;
// node_modules/vexflow/build/esm/src/timesignote.js
var $a801f2c896bd09f1$var$TimeSigNote = class extends $a801f2c896bd09f1$var$Note {
    static get CATEGORY() {
        return "TimeSigNote";
    }
    constructor(timeSpec, customPadding){
        super({
            duration: "b"
        });
        this.timeSig = new $a801f2c896bd09f1$var$TimeSignature(timeSpec, customPadding);
        this.setWidth(this.timeSig.getGlyph().getMetrics().width);
        this.ignore_ticks = true;
    }
    addToModifierContext(mc) {
        return this;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    draw() {
        const stave = this.checkStave();
        const ctx = this.checkContext();
        this.setRendered();
        const tsGlyph = this.timeSig.getGlyph();
        if (!tsGlyph.getContext()) tsGlyph.setContext(ctx);
        tsGlyph.setStave(stave);
        tsGlyph.setYShift(stave.getYForLine(2) - stave.getYForGlyphs());
        tsGlyph.renderToStave(this.getAbsoluteX());
    }
};
// node_modules/vexflow/build/esm/src/tuplet.js
var $a801f2c896bd09f1$var$Tuplet = class _Tuplet extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "Tuplet";
    }
    static get LOCATION_TOP() {
        return 1;
    }
    static get LOCATION_BOTTOM() {
        return -1;
    }
    static get NESTING_OFFSET() {
        return 15;
    }
    static get metrics() {
        const tupletMetrics = $a801f2c896bd09f1$var$Tables.currentMusicFont().getMetrics().tuplet;
        if (!tupletMetrics) throw new $a801f2c896bd09f1$var$RuntimeError("BadMetrics", `tuplet missing`);
        return tupletMetrics;
    }
    constructor(notes, options2 = {}){
        super();
        this.numerator_glyphs = [];
        this.denom_glyphs = [];
        if (!notes || !notes.length) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "No notes provided for tuplet.");
        this.options = options2;
        this.notes = notes;
        this.num_notes = this.options.num_notes != void 0 ? this.options.num_notes : notes.length;
        if (this.options.beats_occupied) this.beatsOccupiedDeprecationWarning();
        this.notes_occupied = this.options.notes_occupied || this.options.beats_occupied || 2;
        if (this.options.bracketed != void 0) this.bracketed = this.options.bracketed;
        else this.bracketed = notes.some((note2)=>!note2.hasBeam());
        this.ratioed = this.options.ratioed != void 0 ? this.options.ratioed : Math.abs(this.notes_occupied - this.num_notes) > 1;
        this.point = $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE * 3 / 5;
        this.y_pos = 16;
        this.x_pos = 100;
        this.width = 200;
        this.setTupletLocation(this.options.location || _Tuplet.LOCATION_TOP);
        $a801f2c896bd09f1$var$Formatter.AlignRestsToNotes(notes, true, true);
        this.resolveGlyphs();
        this.attach();
    }
    attach() {
        for(let i2 = 0; i2 < this.notes.length; i2++){
            const note2 = this.notes[i2];
            note2.setTuplet(this);
        }
    }
    detach() {
        for(let i2 = 0; i2 < this.notes.length; i2++){
            const note2 = this.notes[i2];
            note2.resetTuplet(this);
        }
    }
    setBracketed(bracketed) {
        this.bracketed = !!bracketed;
        return this;
    }
    setRatioed(ratioed) {
        this.ratioed = !!ratioed;
        return this;
    }
    setTupletLocation(location3) {
        if (location3 !== _Tuplet.LOCATION_TOP && location3 !== _Tuplet.LOCATION_BOTTOM) {
            console.warn(`Invalid tuplet location [${location3}]. Using Tuplet.LOCATION_TOP.`);
            location3 = _Tuplet.LOCATION_TOP;
        }
        this.location = location3;
        return this;
    }
    getNotes() {
        return this.notes;
    }
    getNoteCount() {
        return this.num_notes;
    }
    beatsOccupiedDeprecationWarning() {
        console.warn("beats_occupied has been deprecated as an option for tuplets. Please use notes_occupied instead.", "Calls to getBeatsOccupied / setBeatsOccupied should now be routed to getNotesOccupied / setNotesOccupied.", "The old methods will be removed in VexFlow 5.0.");
    }
    getBeatsOccupied() {
        this.beatsOccupiedDeprecationWarning();
        return this.getNotesOccupied();
    }
    setBeatsOccupied(beats) {
        this.beatsOccupiedDeprecationWarning();
        return this.setNotesOccupied(beats);
    }
    getNotesOccupied() {
        return this.notes_occupied;
    }
    setNotesOccupied(notes) {
        this.detach();
        this.notes_occupied = notes;
        this.resolveGlyphs();
        this.attach();
    }
    resolveGlyphs() {
        this.numerator_glyphs = [];
        let n = this.num_notes;
        while(n >= 1){
            this.numerator_glyphs.unshift(new $a801f2c896bd09f1$var$Glyph("timeSig" + n % 10, this.point));
            n = parseInt((n / 10).toString(), 10);
        }
        this.denom_glyphs = [];
        n = this.notes_occupied;
        while(n >= 1){
            this.denom_glyphs.unshift(new $a801f2c896bd09f1$var$Glyph("timeSig" + n % 10, this.point));
            n = parseInt((n / 10).toString(), 10);
        }
    }
    getNestedTupletCount() {
        const location3 = this.location;
        const first_note = this.notes[0];
        let maxTupletCount = countTuplets(first_note, location3);
        let minTupletCount = countTuplets(first_note, location3);
        function countTuplets(note2, location4) {
            return note2.getTupletStack().filter((tuplet)=>tuplet.location === location4).length;
        }
        this.notes.forEach((note2)=>{
            const tupletCount = countTuplets(note2, location3);
            maxTupletCount = tupletCount > maxTupletCount ? tupletCount : maxTupletCount;
            minTupletCount = tupletCount < minTupletCount ? tupletCount : minTupletCount;
        });
        return maxTupletCount - minTupletCount;
    }
    getYPosition() {
        const nested_tuplet_y_offset = this.getNestedTupletCount() * _Tuplet.NESTING_OFFSET * -this.location;
        const y_offset = this.options.y_offset || 0;
        const first_note = this.notes[0];
        let y_pos;
        if (this.location === _Tuplet.LOCATION_TOP) {
            y_pos = first_note.checkStave().getYForLine(0) - _Tuplet.metrics.topModifierOffset;
            for(let i2 = 0; i2 < this.notes.length; ++i2){
                const note2 = this.notes[i2];
                let modLines = 0;
                const mc = note2.getModifierContext();
                if (mc) modLines = Math.max(modLines, mc.getState().top_text_line);
                const modY = note2.getYForTopText(modLines) - _Tuplet.metrics.noteHeadOffset;
                if (note2.hasStem() || note2.isRest()) {
                    const top_y = note2.getStemDirection() === $a801f2c896bd09f1$var$Stem.UP ? note2.getStemExtents().topY - _Tuplet.metrics.stemOffset : note2.getStemExtents().baseY - _Tuplet.metrics.noteHeadOffset;
                    y_pos = Math.min(top_y, y_pos);
                    if (modLines > 0) y_pos = Math.min(modY, y_pos);
                }
            }
        } else {
            let lineCheck = _Tuplet.metrics.bottomLine;
            this.notes.forEach((nn)=>{
                const mc = nn.getModifierContext();
                if (mc) lineCheck = Math.max(lineCheck, mc.getState().text_line + 1);
            });
            y_pos = first_note.checkStave().getYForLine(lineCheck) + _Tuplet.metrics.noteHeadOffset;
            for(let i2 = 0; i2 < this.notes.length; ++i2)if (this.notes[i2].hasStem() || this.notes[i2].isRest()) {
                const bottom_y = this.notes[i2].getStemDirection() === $a801f2c896bd09f1$var$Stem.UP ? this.notes[i2].getStemExtents().baseY + _Tuplet.metrics.noteHeadOffset : this.notes[i2].getStemExtents().topY + _Tuplet.metrics.stemOffset;
                if (bottom_y > y_pos) y_pos = bottom_y;
            }
        }
        return y_pos + nested_tuplet_y_offset + y_offset;
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        const first_note = this.notes[0];
        const last_note = this.notes[this.notes.length - 1];
        if (!this.bracketed) {
            this.x_pos = first_note.getStemX();
            this.width = last_note.getStemX() - this.x_pos;
        } else {
            this.x_pos = first_note.getTieLeftX() - 5;
            this.width = last_note.getTieRightX() - this.x_pos + 5;
        }
        this.y_pos = this.getYPosition();
        const addGlyphWidth = (width10, glyph)=>width10 + $a801f2c896bd09f1$var$defined(glyph.getMetrics().width);
        let width9 = this.numerator_glyphs.reduce(addGlyphWidth, 0);
        if (this.ratioed) {
            width9 = this.denom_glyphs.reduce(addGlyphWidth, width9);
            width9 += this.point * 0.32;
        }
        const notation_center_x = this.x_pos + this.width / 2;
        const notation_start_x = notation_center_x - width9 / 2;
        if (this.bracketed) {
            const line_width = this.width / 2 - width9 / 2 - 5;
            if (line_width > 0) {
                ctx.fillRect(this.x_pos, this.y_pos, line_width, 1);
                ctx.fillRect(this.x_pos + this.width / 2 + width9 / 2 + 5, this.y_pos, line_width, 1);
                ctx.fillRect(this.x_pos, this.y_pos + (this.location === _Tuplet.LOCATION_BOTTOM ? 1 : 0), 1, this.location * 10);
                ctx.fillRect(this.x_pos + this.width, this.y_pos + (this.location === _Tuplet.LOCATION_BOTTOM ? 1 : 0), 1, this.location * 10);
            }
        }
        const shiftY = $a801f2c896bd09f1$var$Tables.currentMusicFont().lookupMetric("digits.shiftY", 0);
        let x_offset = 0;
        this.numerator_glyphs.forEach((glyph)=>{
            glyph.render(ctx, notation_start_x + x_offset, this.y_pos + this.point / 3 - 2 + shiftY);
            x_offset += $a801f2c896bd09f1$var$defined(glyph.getMetrics().width);
        });
        if (this.ratioed) {
            const colon_x = notation_start_x + x_offset + this.point * 0.16;
            const colon_radius = this.point * 0.06;
            ctx.beginPath();
            ctx.arc(colon_x, this.y_pos - this.point * 0.08, colon_radius, 0, Math.PI * 2, false);
            ctx.closePath();
            ctx.fill();
            ctx.beginPath();
            ctx.arc(colon_x, this.y_pos + this.point * 0.12, colon_radius, 0, Math.PI * 2, false);
            ctx.closePath();
            ctx.fill();
            x_offset += this.point * 0.32;
            this.denom_glyphs.forEach((glyph)=>{
                glyph.render(ctx, notation_start_x + x_offset, this.y_pos + this.point / 3 - 2 + shiftY);
                x_offset += $a801f2c896bd09f1$var$defined(glyph.getMetrics().width);
            });
        }
    }
};
// node_modules/vexflow/build/esm/src/vibratobracket.js
function $a801f2c896bd09f1$var$L21(...args) {
    if ($a801f2c896bd09f1$var$VibratoBracket.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.VibratoBracket", args);
}
var $a801f2c896bd09f1$var$VibratoBracket = class extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "VibratoBracket";
    }
    constructor(bracket_data){
        super();
        if (bracket_data.start) this.start = bracket_data.start;
        if (bracket_data.stop) this.stop = bracket_data.stop;
        this.line = 1;
        this.render_options = {
            harsh: false,
            wave_height: 6,
            wave_width: 4,
            wave_girth: 2,
            vibrato_width: 0
        };
    }
    setLine(line2) {
        this.line = line2;
        return this;
    }
    setHarsh(harsh) {
        this.render_options.harsh = harsh;
        return this;
    }
    draw() {
        const ctx = this.checkContext();
        this.setRendered();
        const y4 = this.start && this.start.checkStave().getYForTopText(this.line) || this.stop && this.stop.checkStave().getYForTopText(this.line) || 0;
        const start_x = this.start && this.start.getAbsoluteX() || this.stop && this.stop.checkStave().getTieStartX() || 0;
        const stop_x = this.stop && this.stop.getAbsoluteX() - this.stop.getWidth() - 5 || this.start && this.start.checkStave().getTieEndX() - 10 || 0;
        this.render_options.vibrato_width = stop_x - start_x;
        $a801f2c896bd09f1$var$L21("Rendering VibratoBracket: start_x:", start_x, "stop_x:", stop_x, "y:", y4);
        $a801f2c896bd09f1$var$Vibrato.renderVibrato(ctx, start_x, y4, this.render_options);
    }
};
$a801f2c896bd09f1$var$VibratoBracket.DEBUG = false;
// node_modules/vexflow/build/esm/src/factory.js
function $a801f2c896bd09f1$var$L22(...args) {
    if ($a801f2c896bd09f1$var$Factory.DEBUG) $a801f2c896bd09f1$var$log3("Vex.Flow.Factory", args);
}
var $a801f2c896bd09f1$var$Factory = class _Factory {
    static newFromElementId(elementId, width9 = 500, height9 = 200) {
        return new _Factory({
            renderer: {
                elementId: elementId,
                width: width9,
                height: height9
            }
        });
    }
    constructor(options2 = {}){
        $a801f2c896bd09f1$var$L22("New factory: ", options2);
        this.options = {
            stave: {
                space: 10
            },
            renderer: {
                elementId: "",
                width: 500,
                height: 200,
                background: "#FFF"
            },
            font: _Factory.TEXT_FONT
        };
        this.setOptions(options2);
    }
    reset() {
        this.renderQ = [];
        this.systems = [];
        this.staves = [];
        this.voices = [];
        this.stave = void 0;
    }
    setOptions(options2) {
        this.options = Object.assign(Object.assign({}, this.options), options2);
        this.initRenderer();
        this.reset();
    }
    initRenderer() {
        const { elementId: elementId, width: width9, height: height9, background: background } = this.options.renderer;
        if (elementId == null) return;
        if (elementId == "") {
            $a801f2c896bd09f1$var$L22(this);
            throw new $a801f2c896bd09f1$var$RuntimeError("renderer.elementId not set in FactoryOptions");
        }
        let backend = this.options.renderer.backend;
        if (backend === void 0) {
            const elem5 = document.getElementById(elementId);
            if ($a801f2c896bd09f1$var$isHTMLCanvas(elem5)) backend = $a801f2c896bd09f1$var$Renderer.Backends.CANVAS;
            else backend = $a801f2c896bd09f1$var$Renderer.Backends.SVG;
        }
        this.context = $a801f2c896bd09f1$var$Renderer.buildContext(elementId, backend, width9, height9, background);
    }
    getContext() {
        return this.context;
    }
    setContext(context) {
        this.context = context;
        return this;
    }
    getStave() {
        return this.stave;
    }
    getVoices() {
        return this.voices;
    }
    Stave(params) {
        const staveSpace = this.options.stave.space;
        const p3 = Object.assign({
            x: 0,
            y: 0,
            width: this.options.renderer.width - staveSpace * 1,
            options: {
                spacing_between_lines_px: staveSpace * 1
            }
        }, params);
        const stave = new $a801f2c896bd09f1$var$Stave(p3.x, p3.y, p3.width, p3.options);
        this.staves.push(stave);
        stave.setContext(this.context);
        this.stave = stave;
        return stave;
    }
    TabStave(params) {
        const staveSpace = this.options.stave.space;
        const p3 = Object.assign({
            x: 0,
            y: 0,
            width: this.options.renderer.width - staveSpace * 1,
            options: {
                spacing_between_lines_px: staveSpace * 1.3
            }
        }, params);
        const stave = new $a801f2c896bd09f1$var$TabStave(p3.x, p3.y, p3.width, p3.options);
        this.staves.push(stave);
        stave.setContext(this.context);
        this.stave = stave;
        return stave;
    }
    StaveNote(noteStruct) {
        const note2 = new $a801f2c896bd09f1$var$StaveNote(noteStruct);
        if (this.stave) note2.setStave(this.stave);
        note2.setContext(this.context);
        this.renderQ.push(note2);
        return note2;
    }
    GlyphNote(glyph, noteStruct, options2) {
        const note2 = new $a801f2c896bd09f1$var$GlyphNote(glyph, noteStruct, options2);
        if (this.stave) note2.setStave(this.stave);
        note2.setContext(this.context);
        this.renderQ.push(note2);
        return note2;
    }
    RepeatNote(type, noteStruct, options2) {
        const note2 = new $a801f2c896bd09f1$var$RepeatNote(type, noteStruct, options2);
        if (this.stave) note2.setStave(this.stave);
        note2.setContext(this.context);
        this.renderQ.push(note2);
        return note2;
    }
    GhostNote(noteStruct) {
        const ghostNote = new $a801f2c896bd09f1$var$GhostNote(noteStruct);
        if (this.stave) ghostNote.setStave(this.stave);
        ghostNote.setContext(this.context);
        this.renderQ.push(ghostNote);
        return ghostNote;
    }
    TextNote(noteStruct) {
        const textNote = new $a801f2c896bd09f1$var$TextNote(noteStruct);
        if (this.stave) textNote.setStave(this.stave);
        textNote.setContext(this.context);
        this.renderQ.push(textNote);
        return textNote;
    }
    BarNote(params = {}) {
        const barNote = new $a801f2c896bd09f1$var$BarNote(params.type);
        if (this.stave) barNote.setStave(this.stave);
        barNote.setContext(this.context);
        this.renderQ.push(barNote);
        return barNote;
    }
    ClefNote(params) {
        const p3 = Object.assign({
            type: "treble",
            options: {
                size: "default",
                annotation: void 0
            }
        }, params);
        const clefNote = new $a801f2c896bd09f1$var$ClefNote(p3.type, p3.options.size, p3.options.annotation);
        if (this.stave) clefNote.setStave(this.stave);
        clefNote.setContext(this.context);
        this.renderQ.push(clefNote);
        return clefNote;
    }
    TimeSigNote(params) {
        const p3 = Object.assign({
            time: "4/4"
        }, params);
        const timeSigNote = new $a801f2c896bd09f1$var$TimeSigNote(p3.time);
        if (this.stave) timeSigNote.setStave(this.stave);
        timeSigNote.setContext(this.context);
        this.renderQ.push(timeSigNote);
        return timeSigNote;
    }
    KeySigNote(params) {
        const keySigNote = new $a801f2c896bd09f1$var$KeySigNote(params.key, params.cancelKey, params.alterKey);
        if (this.stave) keySigNote.setStave(this.stave);
        keySigNote.setContext(this.context);
        this.renderQ.push(keySigNote);
        return keySigNote;
    }
    TabNote(noteStruct) {
        const note2 = new $a801f2c896bd09f1$var$TabNote(noteStruct);
        if (this.stave) note2.setStave(this.stave);
        note2.setContext(this.context);
        this.renderQ.push(note2);
        return note2;
    }
    GraceNote(noteStruct) {
        const note2 = new $a801f2c896bd09f1$var$GraceNote(noteStruct);
        if (this.stave) note2.setStave(this.stave);
        note2.setContext(this.context);
        return note2;
    }
    GraceNoteGroup(params) {
        const group4 = new $a801f2c896bd09f1$var$GraceNoteGroup(params.notes, params.slur);
        group4.setContext(this.context);
        return group4;
    }
    Accidental(params) {
        const accid = new $a801f2c896bd09f1$var$Accidental(params.type);
        accid.setContext(this.context);
        return accid;
    }
    Annotation(params) {
        const p3 = Object.assign({
            text: "p",
            hJustify: $a801f2c896bd09f1$var$AnnotationHorizontalJustify.CENTER,
            vJustify: $a801f2c896bd09f1$var$AnnotationVerticalJustify.BOTTOM
        }, params);
        const annotation = new $a801f2c896bd09f1$var$Annotation(p3.text);
        annotation.setJustification(p3.hJustify);
        annotation.setVerticalJustification(p3.vJustify);
        annotation.setFont(p3.font);
        annotation.setContext(this.context);
        return annotation;
    }
    ChordSymbol(params) {
        const p3 = Object.assign({
            vJustify: "top",
            hJustify: "center",
            kerning: true,
            reportWidth: true
        }, params);
        const chordSymbol = new $a801f2c896bd09f1$var$ChordSymbol();
        chordSymbol.setHorizontal(p3.hJustify);
        chordSymbol.setVertical(p3.vJustify);
        chordSymbol.setEnableKerning(p3.kerning);
        chordSymbol.setReportWidth(p3.reportWidth);
        if (typeof p3.fontFamily === "string" && typeof p3.fontSize === "number") {
            if (typeof p3.fontWeight === "string") chordSymbol.setFont(p3.fontFamily, p3.fontSize, p3.fontWeight);
            else chordSymbol.setFont(p3.fontFamily, p3.fontSize, "");
        } else if (typeof p3.fontSize === "number") chordSymbol.setFontSize(p3.fontSize);
        chordSymbol.setContext(this.context);
        return chordSymbol;
    }
    Articulation(params) {
        var _a;
        const articulation = new $a801f2c896bd09f1$var$Articulation((_a = params === null || params === void 0 ? void 0 : params.type) !== null && _a !== void 0 ? _a : "a.");
        if ((params === null || params === void 0 ? void 0 : params.position) != void 0) articulation.setPosition(params.position);
        if ((params === null || params === void 0 ? void 0 : params.betweenLines) != void 0) articulation.setBetweenLines(params.betweenLines);
        articulation.setContext(this.context);
        return articulation;
    }
    Ornament(type, params) {
        const options2 = Object.assign({
            type: type,
            position: 0,
            accidental: ""
        }, params);
        const ornament = new $a801f2c896bd09f1$var$Ornament(type);
        ornament.setPosition(options2.position);
        if (options2.upperAccidental) ornament.setUpperAccidental(options2.upperAccidental);
        if (options2.lowerAccidental) ornament.setLowerAccidental(options2.lowerAccidental);
        if (typeof options2.delayed !== "undefined") ornament.setDelayed(options2.delayed);
        ornament.setContext(this.context);
        return ornament;
    }
    TextDynamics(params) {
        const p3 = Object.assign({
            text: "p",
            duration: "q",
            dots: 0,
            line: 0
        }, params);
        const text7 = new $a801f2c896bd09f1$var$TextDynamics({
            text: p3.text,
            line: p3.line,
            duration: p3.duration,
            dots: p3.dots
        });
        if (this.stave) text7.setStave(this.stave);
        text7.setContext(this.context);
        this.renderQ.push(text7);
        return text7;
    }
    Fingering(params) {
        const p3 = Object.assign({
            number: "0",
            position: "left"
        }, params);
        const fingering = new $a801f2c896bd09f1$var$FretHandFinger(p3.number);
        fingering.setPosition(p3.position);
        fingering.setContext(this.context);
        return fingering;
    }
    StringNumber(params, drawCircle = true) {
        const stringNumber = new $a801f2c896bd09f1$var$StringNumber(params.number);
        stringNumber.setPosition(params.position);
        stringNumber.setContext(this.context);
        stringNumber.setDrawCircle(drawCircle);
        return stringNumber;
    }
    TickContext() {
        return new $a801f2c896bd09f1$var$TickContext();
    }
    ModifierContext() {
        return new $a801f2c896bd09f1$var$ModifierContext();
    }
    MultiMeasureRest(params) {
        const numMeasures = $a801f2c896bd09f1$var$defined(params.number_of_measures, "NoNumberOfMeasures");
        const multiMeasureRest = new $a801f2c896bd09f1$var$MultiMeasureRest(numMeasures, params);
        multiMeasureRest.setContext(this.context);
        this.renderQ.push(multiMeasureRest);
        return multiMeasureRest;
    }
    Voice(params) {
        const p3 = Object.assign({
            time: "4/4"
        }, params);
        const voice = new $a801f2c896bd09f1$var$Voice(p3.time);
        this.voices.push(voice);
        return voice;
    }
    StaveConnector(params) {
        const connector = new $a801f2c896bd09f1$var$StaveConnector(params.top_stave, params.bottom_stave);
        connector.setType(params.type).setContext(this.context);
        this.renderQ.push(connector);
        return connector;
    }
    Formatter(options2) {
        return new $a801f2c896bd09f1$var$Formatter(options2);
    }
    Tuplet(params) {
        const p3 = Object.assign({
            notes: [],
            options: {}
        }, params);
        const tuplet = new $a801f2c896bd09f1$var$Tuplet(p3.notes, p3.options).setContext(this.context);
        this.renderQ.push(tuplet);
        return tuplet;
    }
    Beam(params) {
        var _a, _b, _c, _d, _e;
        const beam = new $a801f2c896bd09f1$var$Beam(params.notes, (_a = params.options) === null || _a === void 0 ? void 0 : _a.autoStem).setContext(this.context);
        beam.breakSecondaryAt((_c = (_b = params.options) === null || _b === void 0 ? void 0 : _b.secondaryBeamBreaks) !== null && _c !== void 0 ? _c : []);
        if ((_d = params.options) === null || _d === void 0 ? void 0 : _d.partialBeamDirections) Object.entries((_e = params.options) === null || _e === void 0 ? void 0 : _e.partialBeamDirections).forEach(([noteIndex, direction3])=>{
            beam.setPartialBeamSideAt(Number(noteIndex), direction3);
        });
        this.renderQ.push(beam);
        return beam;
    }
    Curve(params) {
        const curve = new $a801f2c896bd09f1$var$Curve(params.from, params.to, params.options).setContext(this.context);
        this.renderQ.push(curve);
        return curve;
    }
    StaveTie(params) {
        var _a;
        const tie = new $a801f2c896bd09f1$var$StaveTie({
            first_note: params.from,
            last_note: params.to,
            first_indices: params.first_indices,
            last_indices: params.last_indices
        }, params.text);
        if ((_a = params.options) === null || _a === void 0 ? void 0 : _a.direction) tie.setDirection(params.options.direction);
        tie.setContext(this.context);
        this.renderQ.push(tie);
        return tie;
    }
    StaveLine(params) {
        var _a, _b;
        const line2 = new $a801f2c896bd09f1$var$StaveLine({
            first_note: params.from,
            last_note: params.to,
            first_indices: params.first_indices,
            last_indices: params.last_indices
        });
        if ((_a = params.options) === null || _a === void 0 ? void 0 : _a.text) line2.setText(params.options.text);
        if ((_b = params.options) === null || _b === void 0 ? void 0 : _b.font) line2.setFont(params.options.font);
        line2.setContext(this.context);
        this.renderQ.push(line2);
        return line2;
    }
    VibratoBracket(params) {
        const vibratoBracket = new $a801f2c896bd09f1$var$VibratoBracket({
            start: params.from,
            stop: params.to
        });
        if (params.options.line) vibratoBracket.setLine(params.options.line);
        if (params.options.harsh) vibratoBracket.setHarsh(params.options.harsh);
        vibratoBracket.setContext(this.context);
        this.renderQ.push(vibratoBracket);
        return vibratoBracket;
    }
    TextBracket(params) {
        const textBracket = new $a801f2c896bd09f1$var$TextBracket({
            start: params.from,
            stop: params.to,
            text: params.text,
            superscript: params.options.superscript,
            position: params.options.position
        });
        if (params.options.line) textBracket.setLine(params.options.line);
        if (params.options.font) textBracket.setFont(params.options.font);
        textBracket.setContext(this.context);
        this.renderQ.push(textBracket);
        return textBracket;
    }
    System(params = {}) {
        params.factory = this;
        const system = new $a801f2c896bd09f1$var$System(params).setContext(this.context);
        this.systems.push(system);
        return system;
    }
    EasyScore(options2 = {}) {
        options2.factory = this;
        return new $a801f2c896bd09f1$var$EasyScore(options2);
    }
    PedalMarking(params) {
        const p3 = Object.assign({
            notes: [],
            options: {
                style: "mixed"
            }
        }, params);
        const pedal = new $a801f2c896bd09f1$var$PedalMarking(p3.notes);
        pedal.setType($a801f2c896bd09f1$var$PedalMarking.typeString[p3.options.style]);
        pedal.setContext(this.context);
        this.renderQ.push(pedal);
        return pedal;
    }
    NoteSubGroup(params) {
        const p3 = Object.assign({
            notes: []
        }, params);
        const group4 = new $a801f2c896bd09f1$var$NoteSubGroup(p3.notes);
        group4.setContext(this.context);
        return group4;
    }
    draw() {
        const ctx = this.context;
        this.systems.forEach((s2)=>s2.setContext(ctx).format());
        this.staves.forEach((s2)=>s2.setContext(ctx).draw());
        this.voices.forEach((v3)=>v3.setContext(ctx).draw());
        this.renderQ.forEach((e)=>{
            if (!e.isRendered()) e.setContext(ctx).draw();
        });
        this.systems.forEach((s2)=>s2.setContext(ctx).draw());
        this.reset();
    }
};
$a801f2c896bd09f1$var$Factory.DEBUG = false;
$a801f2c896bd09f1$var$Factory.TEXT_FONT = Object.assign({}, $a801f2c896bd09f1$var$Element.TEXT_FONT);
// node_modules/vexflow/build/esm/src/gracetabnote.js
var $a801f2c896bd09f1$var$GraceTabNote = class extends $a801f2c896bd09f1$var$TabNote {
    static get CATEGORY() {
        return "GraceTabNote";
    }
    constructor(noteStruct){
        super(noteStruct, false);
        this.render_options = Object.assign(Object.assign({}, this.render_options), {
            y_shift: 0.3,
            scale: 0.6,
            font: `7.5pt ${$a801f2c896bd09f1$var$Font.SANS_SERIF}`
        });
        this.updateWidth();
    }
};
// node_modules/vexflow/build/esm/src/keymanager.js
var $a801f2c896bd09f1$var$KeyManager = class {
    constructor(key2){
        this.music = new $a801f2c896bd09f1$var$Music();
        this.setKey(key2);
    }
    setKey(key2) {
        this.key = key2;
        this.reset();
        return this;
    }
    getKey() {
        return this.key;
    }
    reset() {
        this.keyParts = this.music.getKeyParts(this.key);
        this.keyString = this.keyParts.root;
        if (this.keyParts.accidental) this.keyString += this.keyParts.accidental;
        const is_supported_type = $a801f2c896bd09f1$var$Music.scaleTypes[this.keyParts.type];
        if (!is_supported_type) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Unsupported key type: ${this.key}`);
        this.scale = this.music.getScaleTones(this.music.getNoteValue(this.keyString), $a801f2c896bd09f1$var$Music.scaleTypes[this.keyParts.type]);
        this.scaleMap = {};
        this.scaleMapByValue = {};
        this.originalScaleMapByValue = {};
        const noteLocation = $a801f2c896bd09f1$var$Music.root_indices[this.keyParts.root];
        for(let i2 = 0; i2 < $a801f2c896bd09f1$var$Music.roots.length; ++i2){
            const index5 = (noteLocation + i2) % $a801f2c896bd09f1$var$Music.roots.length;
            const rootName = $a801f2c896bd09f1$var$Music.roots[index5];
            const noteName = this.music.getRelativeNoteName(rootName, this.scale[i2]);
            this.scaleMap[rootName] = noteName;
            this.scaleMapByValue[this.scale[i2]] = noteName;
            this.originalScaleMapByValue[this.scale[i2]] = noteName;
        }
        return this;
    }
    getAccidental(key2) {
        const root = this.music.getKeyParts(key2).root;
        const parts = this.music.getNoteParts(this.scaleMap[root]);
        return {
            note: this.scaleMap[root],
            accidental: parts.accidental
        };
    }
    selectNote(note2) {
        note2 = note2.toLowerCase();
        const parts = this.music.getNoteParts(note2);
        const scaleNote = this.scaleMap[parts.root];
        const modparts = this.music.getNoteParts(scaleNote);
        if (scaleNote === note2) return {
            note: scaleNote,
            accidental: parts.accidental,
            change: false
        };
        const valueNote = this.scaleMapByValue[this.music.getNoteValue(note2)];
        if (valueNote != null) return {
            note: valueNote,
            accidental: this.music.getNoteParts(valueNote).accidental,
            change: false
        };
        const originalValueNote = this.originalScaleMapByValue[this.music.getNoteValue(note2)];
        if (originalValueNote != null) {
            this.scaleMap[modparts.root] = originalValueNote;
            delete this.scaleMapByValue[this.music.getNoteValue(scaleNote)];
            this.scaleMapByValue[this.music.getNoteValue(note2)] = originalValueNote;
            return {
                note: originalValueNote,
                accidental: this.music.getNoteParts(originalValueNote).accidental,
                change: true
            };
        }
        if (modparts.root === note2) {
            delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[parts.root])];
            this.scaleMapByValue[this.music.getNoteValue(modparts.root)] = modparts.root;
            this.scaleMap[modparts.root] = modparts.root;
            return {
                note: modparts.root,
                accidental: void 0,
                change: true
            };
        }
        delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[parts.root])];
        this.scaleMapByValue[this.music.getNoteValue(note2)] = note2;
        delete this.scaleMap[modparts.root];
        this.scaleMap[modparts.root] = note2;
        return {
            note: note2,
            accidental: parts.accidental,
            change: true
        };
    }
};
// node_modules/vexflow/build/esm/src/stavehairpin.js
var $a801f2c896bd09f1$var$StaveHairpin = class _StaveHairpin extends $a801f2c896bd09f1$var$Element {
    static get CATEGORY() {
        return "StaveHairpin";
    }
    static FormatByTicksAndDraw(ctx, formatter, notes, type, position2, options2) {
        var _a, _b;
        const ppt = formatter.pixelsPerTick;
        if (ppt == null) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "A valid Formatter must be provide to draw offsets by ticks.");
        const l_shift_px = ppt * ((_a = options2.left_shift_ticks) !== null && _a !== void 0 ? _a : 0);
        const r_shift_px = ppt * ((_b = options2.right_shift_ticks) !== null && _b !== void 0 ? _b : 0);
        const hairpin_options = {
            height: options2.height,
            y_shift: options2.y_shift,
            left_shift_px: l_shift_px,
            right_shift_px: r_shift_px,
            right_shift_ticks: 0,
            left_shift_ticks: 0
        };
        new _StaveHairpin({
            first_note: notes.first_note,
            last_note: notes.last_note
        }, type).setContext(ctx).setRenderOptions(hairpin_options).setPosition(position2).draw();
    }
    constructor(notes, type){
        super();
        this.setNotes(notes);
        this.hairpin = type;
        this.position = $a801f2c896bd09f1$var$Modifier.Position.BELOW;
        this.render_options = {
            height: 10,
            y_shift: 0,
            left_shift_px: 0,
            right_shift_px: 0,
            right_shift_ticks: 0,
            left_shift_ticks: 0
        };
    }
    setPosition(position2) {
        if (position2 === $a801f2c896bd09f1$var$Modifier.Position.ABOVE || position2 === $a801f2c896bd09f1$var$Modifier.Position.BELOW) this.position = position2;
        return this;
    }
    setRenderOptions(options2) {
        if (options2.height != null && options2.y_shift != null && options2.left_shift_px != null && options2.right_shift_px != null) this.render_options = options2;
        return this;
    }
    setNotes(notes) {
        if (!notes.first_note && !notes.last_note) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Hairpin needs to have either first_note or last_note set.");
        this.notes = notes;
        this.first_note = notes.first_note;
        this.last_note = notes.last_note;
        return this;
    }
    renderHairpin(params) {
        const ctx = this.checkContext();
        let dis = this.render_options.y_shift + 20;
        let y_shift = params.first_y;
        if (this.position === $a801f2c896bd09f1$var$Modifier.Position.ABOVE) {
            dis = -dis + 30;
            y_shift = params.first_y - params.staff_height;
        }
        const l_shift = this.render_options.left_shift_px;
        const r_shift = this.render_options.right_shift_px;
        ctx.beginPath();
        switch(this.hairpin){
            case _StaveHairpin.type.CRESC:
                ctx.moveTo(params.last_x + r_shift, y_shift + dis);
                ctx.lineTo(params.first_x + l_shift, y_shift + this.render_options.height / 2 + dis);
                ctx.lineTo(params.last_x + r_shift, y_shift + this.render_options.height + dis);
                break;
            case _StaveHairpin.type.DECRESC:
                ctx.moveTo(params.first_x + l_shift, y_shift + dis);
                ctx.lineTo(params.last_x + r_shift, y_shift + this.render_options.height / 2 + dis);
                ctx.lineTo(params.first_x + l_shift, y_shift + this.render_options.height + dis);
                break;
            default:
                break;
        }
        ctx.stroke();
        ctx.closePath();
    }
    draw() {
        this.checkContext();
        this.setRendered();
        const firstNote = this.first_note;
        const lastNote = this.last_note;
        if (!firstNote || !lastNote) throw new $a801f2c896bd09f1$var$RuntimeError("NoNote", "Notes required to draw");
        const start2 = firstNote.getModifierStartXY(this.position, 0);
        const end = lastNote.getModifierStartXY(this.position, 0);
        this.renderHairpin({
            first_x: start2.x,
            last_x: end.x,
            first_y: firstNote.checkStave().getY() + firstNote.checkStave().getHeight(),
            last_y: lastNote.checkStave().getY() + lastNote.checkStave().getHeight(),
            staff_height: firstNote.checkStave().getHeight()
        });
    }
};
$a801f2c896bd09f1$var$StaveHairpin.type = {
    CRESC: 1,
    DECRESC: 2
};
// node_modules/vexflow/build/esm/src/tabslide.js
var $a801f2c896bd09f1$var$TabSlide = class _TabSlide extends $a801f2c896bd09f1$var$TabTie {
    static get CATEGORY() {
        return "TabSlide";
    }
    static get SLIDE_UP() {
        return 1;
    }
    static get SLIDE_DOWN() {
        return -1;
    }
    static createSlideUp(notes) {
        return new _TabSlide(notes, _TabSlide.SLIDE_UP);
    }
    static createSlideDown(notes) {
        return new _TabSlide(notes, _TabSlide.SLIDE_DOWN);
    }
    constructor(notes, direction3){
        super(notes, "sl.");
        if (!direction3) {
            let first_fret = notes.first_note.getPositions()[0].fret;
            if (typeof first_fret === "string") first_fret = parseInt(first_fret, 10);
            let last_fret = notes.last_note.getPositions()[0].fret;
            if (typeof last_fret === "string") last_fret = parseInt(last_fret, 10);
            if (isNaN(first_fret) || isNaN(last_fret)) direction3 = _TabSlide.SLIDE_UP;
            else direction3 = first_fret > last_fret ? _TabSlide.SLIDE_DOWN : _TabSlide.SLIDE_UP;
        }
        this.direction = direction3;
        this.render_options.cp1 = 11;
        this.render_options.cp2 = 14;
        this.render_options.y_shift = 0.5;
        this.resetFont();
    }
    renderTie(params) {
        if (params.first_ys.length === 0 || params.last_ys.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "No Y-values to render");
        const ctx = this.checkContext();
        const first_x_px = params.first_x_px;
        const first_ys = params.first_ys;
        const last_x_px = params.last_x_px;
        const direction3 = params.direction;
        if (direction3 !== _TabSlide.SLIDE_UP && direction3 !== _TabSlide.SLIDE_DOWN) throw new $a801f2c896bd09f1$var$RuntimeError("BadSlide", "Invalid slide direction");
        const first_indices = this.notes.first_indices;
        for(let i2 = 0; i2 < first_indices.length; ++i2){
            const slide_y = first_ys[first_indices[i2]] + this.render_options.y_shift;
            if (isNaN(slide_y)) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", "Bad indices for slide rendering.");
            ctx.beginPath();
            ctx.moveTo(first_x_px, slide_y + 3 * direction3);
            ctx.lineTo(last_x_px, slide_y - 3 * direction3);
            ctx.closePath();
            ctx.stroke();
        }
        this.setRendered();
    }
};
$a801f2c896bd09f1$var$TabSlide.TEXT_FONT = {
    family: $a801f2c896bd09f1$var$Font.SERIF,
    size: 10,
    weight: $a801f2c896bd09f1$var$FontWeight.BOLD,
    style: $a801f2c896bd09f1$var$FontStyle.ITALIC
};
// node_modules/vexflow/build/esm/src/tremolo.js
var $a801f2c896bd09f1$var$Tremolo = class extends $a801f2c896bd09f1$var$Modifier {
    static get CATEGORY() {
        return "Tremolo";
    }
    constructor(num){
        super();
        this.num = num;
        this.position = $a801f2c896bd09f1$var$Modifier.Position.CENTER;
        this.code = "tremolo1";
        this.y_spacing_scale = 1;
        this.extra_stroke_scale = 1;
    }
    draw() {
        var _a;
        const ctx = this.checkContext();
        const note2 = this.checkAttachedNote();
        this.setRendered();
        const stemDirection = note2.getStemDirection();
        const start2 = note2.getModifierStartXY(this.position, this.index);
        let x4 = start2.x;
        const gn = $a801f2c896bd09f1$var$isGraceNote(note2);
        const scale = gn ? $a801f2c896bd09f1$var$GraceNote.SCALE : 1;
        const category = `tremolo.${gn ? "grace" : "default"}`;
        const musicFont = $a801f2c896bd09f1$var$Tables.currentMusicFont();
        let y_spacing = musicFont.lookupMetric(`${category}.spacing`) * stemDirection;
        y_spacing *= this.y_spacing_scale;
        const height9 = this.num * y_spacing;
        let y4 = note2.getStemExtents().baseY - height9;
        if (stemDirection < 0) y4 += musicFont.lookupMetric(`${category}.offsetYStemDown`) * scale;
        else y4 += musicFont.lookupMetric(`${category}.offsetYStemUp`) * scale;
        const fontScale = (_a = musicFont.lookupMetric(`${category}.point`)) !== null && _a !== void 0 ? _a : $a801f2c896bd09f1$var$Note.getPoint(gn ? "grace" : "default");
        x4 += musicFont.lookupMetric(`${category}.offsetXStem${stemDirection === $a801f2c896bd09f1$var$Stem.UP ? "Up" : "Down"}`);
        for(let i2 = 0; i2 < this.num; ++i2){
            $a801f2c896bd09f1$var$Glyph.renderGlyph(ctx, x4, y4, fontScale, this.code, {
                category: category,
                scale: this.extra_stroke_scale
            });
            y4 += y_spacing;
        }
    }
};
// node_modules/vexflow/build/esm/src/tuning.js
var $a801f2c896bd09f1$var$Tuning = class _Tuning {
    static get names() {
        return {
            standard: "E/5,B/4,G/4,D/4,A/3,E/3",
            dagdad: "D/5,A/4,G/4,D/4,A/3,D/3",
            dropd: "E/5,B/4,G/4,D/4,A/3,D/3",
            eb: "Eb/5,Bb/4,Gb/4,Db/4,Ab/3,Db/3",
            standardBanjo: "D/5,B/4,G/4,D/4,G/5"
        };
    }
    constructor(tuningString = "E/5,B/4,G/4,D/4,A/3,E/3,B/2,E/2"){
        this.tuningValues = [];
        this.setTuning(tuningString);
    }
    noteToInteger(noteString) {
        var _a;
        return (_a = $a801f2c896bd09f1$var$Tables.keyProperties(noteString).int_value) !== null && _a !== void 0 ? _a : -1;
    }
    setTuning(tuningString) {
        if (_Tuning.names[tuningString]) tuningString = _Tuning.names[tuningString];
        this.tuningValues = [];
        const keys3 = tuningString.split(/\s*,\s*/);
        if (keys3.length === 0) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Invalid tuning string: ${tuningString}`);
        for(let i2 = 0; i2 < keys3.length; ++i2)this.tuningValues[i2] = this.noteToInteger(keys3[i2]);
    }
    getValueForString(stringNum) {
        const s2 = Number(stringNum);
        if (s2 < 1 || s2 > this.tuningValues.length) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `String number must be between 1 and ${this.tuningValues.length}:${stringNum}`);
        return this.tuningValues[s2 - 1];
    }
    getValueForFret(fretNum, stringNum) {
        const stringValue = this.getValueForString(stringNum);
        const f2 = Number(fretNum);
        if (f2 < 0) throw new $a801f2c896bd09f1$var$RuntimeError("BadArguments", `Fret number must be 0 or higher: ${fretNum}`);
        return stringValue + f2;
    }
    getNoteForFret(fretNum, stringNum) {
        const noteValue = this.getValueForFret(fretNum, stringNum);
        const octave = Math.floor(noteValue / 12);
        const value17 = noteValue % 12;
        return `${$a801f2c896bd09f1$var$Tables.integerToNote(value17)}/${octave}`;
    }
};
// node_modules/vexflow/build/esm/src/version.js
var $a801f2c896bd09f1$var$VERSION = "4.2.5";
var $a801f2c896bd09f1$var$ID = "5b5b43b18254cc5cf607a0977823900a375b48ed";
var $a801f2c896bd09f1$var$DATE = "2024-05-12T08:56:23.690Z";
// node_modules/vexflow/build/esm/src/flow.js
var $a801f2c896bd09f1$var$__awaiter2 = function(thisArg, _arguments, P2, generator) {
    function adopt(value17) {
        return value17 instanceof P2 ? value17 : new P2(function(resolve) {
            resolve(value17);
        });
    }
    return new (P2 || (P2 = Promise))(function(resolve, reject) {
        function fulfilled(value17) {
            try {
                step4(generator.next(value17));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value17) {
            try {
                step4(generator["throw"](value17));
            } catch (e) {
                reject(e);
            }
        }
        function step4(result2) {
            result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
        }
        step4((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a801f2c896bd09f1$var$Flow = class {
    static get BUILD() {
        return {
            VERSION: $a801f2c896bd09f1$var$VERSION,
            ID: $a801f2c896bd09f1$var$ID,
            DATE: $a801f2c896bd09f1$var$DATE
        };
    }
    static setMusicFont(...fontNames) {
        const fonts = fontNames.map((fontName)=>$a801f2c896bd09f1$var$Font.load(fontName));
        $a801f2c896bd09f1$var$Tables.MUSIC_FONT_STACK = fonts;
        $a801f2c896bd09f1$var$Glyph.MUSIC_FONT_STACK = fonts.slice();
        $a801f2c896bd09f1$var$Glyph.CURRENT_CACHE_KEY = fontNames.join(",");
        return fonts;
    }
    static fetchMusicFont(fontName, fontModuleOrPath) {
        return $a801f2c896bd09f1$var$__awaiter2(this, void 0, void 0, function*() {});
    }
    static getMusicFont() {
        const fonts = $a801f2c896bd09f1$var$Tables.MUSIC_FONT_STACK;
        return fonts.map((font)=>font.getName());
    }
    static getMusicFontStack() {
        return $a801f2c896bd09f1$var$Tables.MUSIC_FONT_STACK;
    }
    static get RENDER_PRECISION_PLACES() {
        return $a801f2c896bd09f1$var$Tables.RENDER_PRECISION_PLACES;
    }
    static set RENDER_PRECISION_PLACES(precision) {
        $a801f2c896bd09f1$var$Tables.RENDER_PRECISION_PLACES = precision;
    }
    static get SOFTMAX_FACTOR() {
        return $a801f2c896bd09f1$var$Tables.SOFTMAX_FACTOR;
    }
    static set SOFTMAX_FACTOR(factor) {
        $a801f2c896bd09f1$var$Tables.SOFTMAX_FACTOR = factor;
    }
    static get NOTATION_FONT_SCALE() {
        return $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE;
    }
    static set NOTATION_FONT_SCALE(value17) {
        $a801f2c896bd09f1$var$Tables.NOTATION_FONT_SCALE = value17;
    }
    static get TABLATURE_FONT_SCALE() {
        return $a801f2c896bd09f1$var$Tables.TABLATURE_FONT_SCALE;
    }
    static set TABLATURE_FONT_SCALE(value17) {
        $a801f2c896bd09f1$var$Tables.TABLATURE_FONT_SCALE = value17;
    }
    static get RESOLUTION() {
        return $a801f2c896bd09f1$var$Tables.RESOLUTION;
    }
    static set RESOLUTION(value17) {
        $a801f2c896bd09f1$var$Tables.RESOLUTION = value17;
    }
    static get SLASH_NOTEHEAD_WIDTH() {
        return $a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH;
    }
    static set SLASH_NOTEHEAD_WIDTH(value17) {
        $a801f2c896bd09f1$var$Tables.SLASH_NOTEHEAD_WIDTH = value17;
    }
    static get STAVE_LINE_DISTANCE() {
        return $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE;
    }
    static set STAVE_LINE_DISTANCE(value17) {
        $a801f2c896bd09f1$var$Tables.STAVE_LINE_DISTANCE = value17;
    }
    static get STAVE_LINE_THICKNESS() {
        return $a801f2c896bd09f1$var$Tables.STAVE_LINE_THICKNESS;
    }
    static set STAVE_LINE_THICKNESS(value17) {
        $a801f2c896bd09f1$var$Tables.STAVE_LINE_THICKNESS = value17;
    }
    static get STEM_HEIGHT() {
        return $a801f2c896bd09f1$var$Tables.STEM_HEIGHT;
    }
    static set STEM_HEIGHT(value17) {
        $a801f2c896bd09f1$var$Tables.STEM_HEIGHT = value17;
    }
    static get STEM_WIDTH() {
        return $a801f2c896bd09f1$var$Tables.STEM_WIDTH;
    }
    static set STEM_WIDTH(value17) {
        $a801f2c896bd09f1$var$Tables.STEM_WIDTH = value17;
    }
    static get TIME4_4() {
        return $a801f2c896bd09f1$var$Tables.TIME4_4;
    }
    static get accidentalMap() {
        return $a801f2c896bd09f1$var$Tables.accidentalMap;
    }
    static get unicode() {
        return $a801f2c896bd09f1$var$Tables.unicode;
    }
    static keySignature(spec) {
        return $a801f2c896bd09f1$var$Tables.keySignature(spec);
    }
    static hasKeySignature(spec) {
        return $a801f2c896bd09f1$var$Tables.hasKeySignature(spec);
    }
    static getKeySignatures() {
        return $a801f2c896bd09f1$var$Tables.getKeySignatures();
    }
    static clefProperties(clef) {
        return $a801f2c896bd09f1$var$Tables.clefProperties(clef);
    }
    static keyProperties(key2, clef, params) {
        return $a801f2c896bd09f1$var$Tables.keyProperties(key2, clef, params);
    }
    static durationToTicks(duration2) {
        return $a801f2c896bd09f1$var$Tables.durationToTicks(duration2);
    }
};
$a801f2c896bd09f1$var$Flow.Accidental = $a801f2c896bd09f1$var$Accidental;
$a801f2c896bd09f1$var$Flow.Annotation = $a801f2c896bd09f1$var$Annotation;
$a801f2c896bd09f1$var$Flow.Articulation = $a801f2c896bd09f1$var$Articulation;
$a801f2c896bd09f1$var$Flow.Barline = $a801f2c896bd09f1$var$Barline;
$a801f2c896bd09f1$var$Flow.BarNote = $a801f2c896bd09f1$var$BarNote;
$a801f2c896bd09f1$var$Flow.Beam = $a801f2c896bd09f1$var$Beam;
$a801f2c896bd09f1$var$Flow.Bend = $a801f2c896bd09f1$var$Bend;
$a801f2c896bd09f1$var$Flow.BoundingBox = $a801f2c896bd09f1$var$BoundingBox;
$a801f2c896bd09f1$var$Flow.BoundingBoxComputation = $a801f2c896bd09f1$var$BoundingBoxComputation;
$a801f2c896bd09f1$var$Flow.CanvasContext = $a801f2c896bd09f1$var$CanvasContext;
$a801f2c896bd09f1$var$Flow.ChordSymbol = $a801f2c896bd09f1$var$ChordSymbol;
$a801f2c896bd09f1$var$Flow.Clef = $a801f2c896bd09f1$var$Clef;
$a801f2c896bd09f1$var$Flow.ClefNote = $a801f2c896bd09f1$var$ClefNote;
$a801f2c896bd09f1$var$Flow.Crescendo = $a801f2c896bd09f1$var$Crescendo;
$a801f2c896bd09f1$var$Flow.Curve = $a801f2c896bd09f1$var$Curve;
$a801f2c896bd09f1$var$Flow.Dot = $a801f2c896bd09f1$var$Dot;
$a801f2c896bd09f1$var$Flow.EasyScore = $a801f2c896bd09f1$var$EasyScore;
$a801f2c896bd09f1$var$Flow.Element = $a801f2c896bd09f1$var$Element;
$a801f2c896bd09f1$var$Flow.Factory = $a801f2c896bd09f1$var$Factory;
$a801f2c896bd09f1$var$Flow.Font = $a801f2c896bd09f1$var$Font;
$a801f2c896bd09f1$var$Flow.Formatter = $a801f2c896bd09f1$var$Formatter;
$a801f2c896bd09f1$var$Flow.Fraction = $a801f2c896bd09f1$var$Fraction;
$a801f2c896bd09f1$var$Flow.FretHandFinger = $a801f2c896bd09f1$var$FretHandFinger;
$a801f2c896bd09f1$var$Flow.GhostNote = $a801f2c896bd09f1$var$GhostNote;
$a801f2c896bd09f1$var$Flow.Glyph = $a801f2c896bd09f1$var$Glyph;
$a801f2c896bd09f1$var$Flow.GlyphNote = $a801f2c896bd09f1$var$GlyphNote;
$a801f2c896bd09f1$var$Flow.GraceNote = $a801f2c896bd09f1$var$GraceNote;
$a801f2c896bd09f1$var$Flow.GraceNoteGroup = $a801f2c896bd09f1$var$GraceNoteGroup;
$a801f2c896bd09f1$var$Flow.GraceTabNote = $a801f2c896bd09f1$var$GraceTabNote;
$a801f2c896bd09f1$var$Flow.KeyManager = $a801f2c896bd09f1$var$KeyManager;
$a801f2c896bd09f1$var$Flow.KeySignature = $a801f2c896bd09f1$var$KeySignature;
$a801f2c896bd09f1$var$Flow.KeySigNote = $a801f2c896bd09f1$var$KeySigNote;
$a801f2c896bd09f1$var$Flow.Modifier = $a801f2c896bd09f1$var$Modifier;
$a801f2c896bd09f1$var$Flow.ModifierContext = $a801f2c896bd09f1$var$ModifierContext;
$a801f2c896bd09f1$var$Flow.MultiMeasureRest = $a801f2c896bd09f1$var$MultiMeasureRest;
$a801f2c896bd09f1$var$Flow.Music = $a801f2c896bd09f1$var$Music;
$a801f2c896bd09f1$var$Flow.Note = $a801f2c896bd09f1$var$Note;
$a801f2c896bd09f1$var$Flow.NoteHead = $a801f2c896bd09f1$var$NoteHead;
$a801f2c896bd09f1$var$Flow.NoteSubGroup = $a801f2c896bd09f1$var$NoteSubGroup;
$a801f2c896bd09f1$var$Flow.Ornament = $a801f2c896bd09f1$var$Ornament;
$a801f2c896bd09f1$var$Flow.Parenthesis = $a801f2c896bd09f1$var$Parenthesis;
$a801f2c896bd09f1$var$Flow.Parser = $a801f2c896bd09f1$var$Parser;
$a801f2c896bd09f1$var$Flow.PedalMarking = $a801f2c896bd09f1$var$PedalMarking;
$a801f2c896bd09f1$var$Flow.Registry = $a801f2c896bd09f1$var$Registry;
$a801f2c896bd09f1$var$Flow.RenderContext = $a801f2c896bd09f1$var$RenderContext;
$a801f2c896bd09f1$var$Flow.Renderer = $a801f2c896bd09f1$var$Renderer;
$a801f2c896bd09f1$var$Flow.RepeatNote = $a801f2c896bd09f1$var$RepeatNote;
$a801f2c896bd09f1$var$Flow.Repetition = $a801f2c896bd09f1$var$Repetition;
$a801f2c896bd09f1$var$Flow.Stave = $a801f2c896bd09f1$var$Stave;
$a801f2c896bd09f1$var$Flow.StaveConnector = $a801f2c896bd09f1$var$StaveConnector;
$a801f2c896bd09f1$var$Flow.StaveHairpin = $a801f2c896bd09f1$var$StaveHairpin;
$a801f2c896bd09f1$var$Flow.StaveLine = $a801f2c896bd09f1$var$StaveLine;
$a801f2c896bd09f1$var$Flow.StaveModifier = $a801f2c896bd09f1$var$StaveModifier;
$a801f2c896bd09f1$var$Flow.StaveNote = $a801f2c896bd09f1$var$StaveNote;
$a801f2c896bd09f1$var$Flow.StaveTempo = $a801f2c896bd09f1$var$StaveTempo;
$a801f2c896bd09f1$var$Flow.StaveText = $a801f2c896bd09f1$var$StaveText;
$a801f2c896bd09f1$var$Flow.StaveTie = $a801f2c896bd09f1$var$StaveTie;
$a801f2c896bd09f1$var$Flow.Stem = $a801f2c896bd09f1$var$Stem;
$a801f2c896bd09f1$var$Flow.StringNumber = $a801f2c896bd09f1$var$StringNumber;
$a801f2c896bd09f1$var$Flow.Stroke = $a801f2c896bd09f1$var$Stroke;
$a801f2c896bd09f1$var$Flow.SVGContext = $a801f2c896bd09f1$var$SVGContext;
$a801f2c896bd09f1$var$Flow.System = $a801f2c896bd09f1$var$System;
$a801f2c896bd09f1$var$Flow.TabNote = $a801f2c896bd09f1$var$TabNote;
$a801f2c896bd09f1$var$Flow.TabSlide = $a801f2c896bd09f1$var$TabSlide;
$a801f2c896bd09f1$var$Flow.TabStave = $a801f2c896bd09f1$var$TabStave;
$a801f2c896bd09f1$var$Flow.TabTie = $a801f2c896bd09f1$var$TabTie;
$a801f2c896bd09f1$var$Flow.TextBracket = $a801f2c896bd09f1$var$TextBracket;
$a801f2c896bd09f1$var$Flow.TextDynamics = $a801f2c896bd09f1$var$TextDynamics;
$a801f2c896bd09f1$var$Flow.TextFormatter = $a801f2c896bd09f1$var$TextFormatter;
$a801f2c896bd09f1$var$Flow.TextNote = $a801f2c896bd09f1$var$TextNote;
$a801f2c896bd09f1$var$Flow.TickContext = $a801f2c896bd09f1$var$TickContext;
$a801f2c896bd09f1$var$Flow.TimeSignature = $a801f2c896bd09f1$var$TimeSignature;
$a801f2c896bd09f1$var$Flow.TimeSigNote = $a801f2c896bd09f1$var$TimeSigNote;
$a801f2c896bd09f1$var$Flow.Tremolo = $a801f2c896bd09f1$var$Tremolo;
$a801f2c896bd09f1$var$Flow.Tuning = $a801f2c896bd09f1$var$Tuning;
$a801f2c896bd09f1$var$Flow.Tuplet = $a801f2c896bd09f1$var$Tuplet;
$a801f2c896bd09f1$var$Flow.Vibrato = $a801f2c896bd09f1$var$Vibrato;
$a801f2c896bd09f1$var$Flow.VibratoBracket = $a801f2c896bd09f1$var$VibratoBracket;
$a801f2c896bd09f1$var$Flow.Voice = $a801f2c896bd09f1$var$Voice;
$a801f2c896bd09f1$var$Flow.Volta = $a801f2c896bd09f1$var$Volta;
$a801f2c896bd09f1$var$Flow.AnnotationHorizontalJustify = $a801f2c896bd09f1$var$AnnotationHorizontalJustify;
$a801f2c896bd09f1$var$Flow.AnnotationVerticalJustify = $a801f2c896bd09f1$var$AnnotationVerticalJustify;
$a801f2c896bd09f1$var$Flow.ChordSymbolHorizontalJustify = $a801f2c896bd09f1$var$ChordSymbolHorizontalJustify;
$a801f2c896bd09f1$var$Flow.ChordSymbolVerticalJustify = $a801f2c896bd09f1$var$ChordSymbolVerticalJustify;
$a801f2c896bd09f1$var$Flow.SymbolTypes = $a801f2c896bd09f1$var$SymbolTypes;
$a801f2c896bd09f1$var$Flow.SymbolModifiers = $a801f2c896bd09f1$var$SymbolModifiers;
$a801f2c896bd09f1$var$Flow.CurvePosition = $a801f2c896bd09f1$var$CurvePosition;
$a801f2c896bd09f1$var$Flow.FontWeight = $a801f2c896bd09f1$var$FontWeight;
$a801f2c896bd09f1$var$Flow.FontStyle = $a801f2c896bd09f1$var$FontStyle;
$a801f2c896bd09f1$var$Flow.ModifierPosition = $a801f2c896bd09f1$var$ModifierPosition;
$a801f2c896bd09f1$var$Flow.RendererBackends = $a801f2c896bd09f1$var$RendererBackends;
$a801f2c896bd09f1$var$Flow.RendererLineEndType = $a801f2c896bd09f1$var$RendererLineEndType;
$a801f2c896bd09f1$var$Flow.BarlineType = $a801f2c896bd09f1$var$BarlineType;
$a801f2c896bd09f1$var$Flow.StaveModifierPosition = $a801f2c896bd09f1$var$StaveModifierPosition;
$a801f2c896bd09f1$var$Flow.VoltaType = $a801f2c896bd09f1$var$VoltaType;
$a801f2c896bd09f1$var$Flow.TextBracketPosition = $a801f2c896bd09f1$var$TextBracketPosition;
$a801f2c896bd09f1$var$Flow.TextJustification = $a801f2c896bd09f1$var$TextJustification;
$a801f2c896bd09f1$var$Flow.VoiceMode = $a801f2c896bd09f1$var$VoiceMode;
// node_modules/vexflow/build/esm/src/fonts/bravura_glyphs.js
var $a801f2c896bd09f1$var$BravuraFont = {
    glyphs: {
        bracketTop: {
            x_min: 0,
            x_max: 469,
            y_min: 0,
            y_max: 295,
            ha: 295,
            o: "m 0 0 l 180 0 b 674 390 410 43 616 150 b 675 405 675 396 675 400 b 664 425 675 416 671 422 b 628 405 651 425 635 415 b 157 179 613 389 432 199 l 12 179 b 0 168 3 179 0 177 z"
        },
        bracketBottom: {
            x_min: 0,
            x_max: 469,
            y_min: -295,
            y_max: 0,
            ha: 295,
            o: "m 0 -168 b 12 -179 0 -177 3 -179 l 157 -179 b 628 -405 432 -199 613 -389 b 664 -425 635 -415 651 -425 b 675 -405 671 -422 675 -416 b 674 -390 675 -400 675 -396 b 180 0 616 -150 410 -43 l 0 0 z"
        },
        barlineTick: {
            x_min: 0,
            x_max: 36,
            y_min: 868,
            y_max: 1120,
            ha: 252,
            o: "m 52 1250 l 52 1613 l 0 1613 l 0 1250 z"
        },
        breathMarkTick: {
            x_min: 0,
            x_max: 500,
            y_min: 0,
            y_max: 502,
            ha: 502,
            o: "m 9 367 b 0 374 6 372 3 374 b 9 334 0 367 0 343 b 179 19 40 312 164 121 b 192 0 179 3 186 0 b 210 19 197 0 207 6 b 698 701 245 197 507 658 b 720 714 714 704 720 711 b 698 723 720 720 711 723 b 197 186 455 714 210 202 b 186 176 194 179 189 176 b 176 186 179 176 176 186 b 9 367 143 266 27 359 z"
        },
        segno: {
            x_min: 4,
            x_max: 550,
            y_min: -27,
            y_max: 759,
            ha: 786,
            o: "m 194 958 b 217 939 203 958 213 955 l 220 929 b 325 805 230 890 252 805 b 425 901 384 805 425 840 b 413 969 425 923 420 946 b 220 1060 390 1035 294 1060 b 6 793 120 1060 6 936 b 29 687 6 759 13 723 b 295 449 75 582 284 454 b 304 438 301 446 304 444 b 295 415 304 432 301 425 b 78 22 285 395 78 22 b 73 3 75 16 73 9 b 114 -39 73 -20 91 -39 b 150 -17 128 -39 143 -30 b 377 395 150 -17 373 386 b 395 402 377 393 389 402 b 704 176 416 397 704 312 b 621 75 704 120 670 82 l 616 73 b 562 138 586 73 562 94 l 562 154 b 485 249 562 209 526 249 b 468 246 480 249 474 248 b 366 153 415 233 366 210 b 540 -12 366 65 455 -12 b 600 -1 559 -12 579 -9 b 792 251 716 37 792 131 b 789 292 792 264 791 278 b 523 588 768 451 540 579 b 498 611 505 598 498 603 b 501 619 498 613 500 616 b 732 1032 508 631 732 1032 b 737 1053 736 1040 737 1045 b 697 1093 737 1076 719 1093 b 661 1073 683 1093 668 1086 b 423 647 661 1073 432 660 b 410 635 419 639 416 635 b 396 639 406 635 402 636 b 128 792 383 644 166 727 b 108 868 120 808 108 838 b 186 958 108 907 125 948 z m 598 671 b 680 589 598 626 635 589 b 762 671 726 589 762 626 b 680 753 762 717 726 753 b 598 671 635 753 598 717 z m 202 380 b 120 462 202 425 166 462 b 37 380 75 462 37 425 b 120 298 37 334 75 298 b 202 380 166 298 202 334 z"
        },
        coda: {
            x_min: -4,
            x_max: 955,
            y_min: -158,
            y_max: 898,
            ha: 1056,
            o: "m 1349 576 l 1178 576 b 729 1083 1164 847 962 1064 l 729 1269 b 694 1293 729 1287 713 1293 b 660 1269 675 1293 660 1287 l 660 1083 b 210 576 426 1064 226 848 l 20 576 b -6 541 0 576 -6 560 b 20 507 -6 523 0 507 l 210 507 b 660 0 226 238 426 19 l 660 -202 b 694 -228 660 -222 675 -228 b 729 -202 713 -228 729 -222 l 729 0 b 1178 507 962 19 1164 238 l 1349 507 b 1375 541 1369 507 1375 523 b 1349 576 1375 560 1369 576 z m 940 576 l 729 576 l 729 1002 b 940 576 930 985 940 809 z m 660 1002 l 660 576 l 455 576 b 660 1002 455 809 455 985 z m 455 507 l 660 507 l 660 69 b 455 507 474 91 456 285 z m 729 69 l 729 507 l 940 507 b 729 69 936 287 909 91 z"
        },
        gClef: {
            x_min: 0,
            x_max: 671,
            y_min: -658,
            y_max: 1098,
            ha: 1756,
            o: "m 541 598 b 550 625 539 615 541 616 b 824 1174 706 770 824 953 b 730 1509 824 1299 789 1423 b 655 1581 708 1541 671 1581 b 562 1512 635 1581 590 1544 b 420 1064 455 1394 420 1214 b 441 828 420 981 431 887 b 428 793 444 811 445 808 b 0 125 220 622 0 416 b 524 -363 0 -125 171 -363 b 624 -354 557 -363 595 -360 b 645 -367 639 -351 642 -350 b 684 -657 662 -464 684 -589 b 455 -896 684 -870 540 -896 b 340 -854 377 -896 340 -873 b 386 -829 340 -844 353 -840 b 482 -694 431 -816 482 -778 b 344 -547 482 -615 432 -547 b 190 -713 248 -547 190 -624 b 464 -948 190 -806 246 -948 b 747 -660 560 -948 747 -904 b 706 -351 747 -577 721 -441 b 724 -327 703 -334 704 -336 b 966 16 870 -269 966 -147 b 619 363 966 200 831 363 b 577 389 582 363 582 363 z m 677 1358 b 763 1240 724 1358 763 1319 b 513 851 763 1080 626 950 b 494 863 503 842 497 844 b 485 995 488 900 485 949 b 677 1358 485 1220 589 1358 z m 520 377 b 498 343 524 350 524 351 b 289 63 372 300 289 186 b 455 -192 289 -66 357 -158 b 494 -200 467 -196 484 -200 b 511 -184 505 -200 511 -193 b 490 -166 511 -174 500 -170 b 386 -12 429 -140 386 -78 b 530 157 386 71 442 132 b 559 145 553 163 556 161 l 631 -284 b 611 -304 634 -300 632 -300 b 530 -311 588 -308 559 -311 b 115 29 278 -311 115 -171 b 249 363 115 114 130 228 b 469 567 336 459 402 513 b 490 562 484 579 487 577 z m 619 148 b 635 168 616 166 618 170 b 848 -66 752 158 848 60 b 713 -271 848 -157 793 -230 b 690 -262 696 -279 693 -279 z"
        },
        cClef: {
            x_min: 0,
            x_max: 699,
            y_min: -506,
            y_max: 506,
            ha: 1012,
            o: "m 331 694 b 301 724 331 714 321 724 l 300 724 b 269 694 279 724 269 714 l 269 -694 b 300 -724 269 -714 279 -724 l 301 -724 b 331 -694 321 -724 331 -714 l 331 -63 b 344 -55 331 -52 338 -53 b 472 -265 382 -65 442 -102 b 500 -301 477 -288 485 -301 b 530 -262 516 -301 523 -287 b 684 -128 549 -199 582 -128 b 804 -409 778 -128 804 -220 b 651 -683 804 -598 770 -683 b 528 -644 631 -683 528 -674 b 567 -622 528 -636 552 -628 b 625 -528 596 -612 625 -583 b 527 -429 625 -465 583 -429 b 416 -547 465 -429 416 -471 b 667 -729 416 -638 495 -729 b 1007 -413 903 -729 1007 -563 b 706 -76 1007 -215 897 -76 b 618 -89 664 -76 636 -84 b 576 -88 603 -94 589 -96 b 524 0 556 -75 524 -29 b 576 88 524 29 556 75 b 618 89 589 96 603 94 b 706 76 636 84 664 76 b 1007 413 897 76 1007 215 b 667 729 1007 563 903 729 b 416 547 495 729 416 638 b 527 429 416 471 465 429 b 625 528 583 429 625 465 b 567 622 625 583 596 612 b 528 644 552 628 528 636 b 651 683 528 674 631 683 b 804 409 770 683 804 598 b 684 128 804 220 778 128 b 530 262 582 128 549 199 b 500 301 523 287 516 301 b 472 265 485 301 477 288 b 344 55 442 102 382 65 b 331 63 338 53 331 52 z m 30 724 b 0 694 10 724 0 714 l 0 -694 b 30 -724 0 -714 10 -724 l 154 -724 b 184 -694 174 -724 184 -714 l 184 694 b 154 724 184 714 174 724 z"
        },
        fClef: {
            x_min: -5,
            x_max: 684,
            y_min: -635,
            y_max: 262,
            ha: 897,
            o: "m 363 377 b 0 56 112 377 0 194 b 177 -158 0 -59 60 -158 b 330 -6 268 -158 330 -95 b 192 144 330 86 262 144 b 120 134 153 144 138 134 b 96 160 101 134 96 145 b 330 323 96 217 183 323 b 549 -53 482 323 549 173 b 14 -871 549 -455 350 -680 b -7 -897 1 -878 -7 -886 b 12 -914 -7 -906 -1 -914 b 36 -907 19 -914 27 -912 b 765 -40 390 -734 765 -478 b 363 377 765 210 612 377 z m 906 259 b 827 180 861 259 827 225 b 906 101 827 135 861 101 b 985 180 950 101 985 135 b 906 259 985 225 950 259 z m 907 -102 b 829 -180 863 -102 829 -135 b 907 -258 829 -225 863 -258 b 985 -180 952 -258 985 -225 b 907 -102 985 -135 952 -102 z"
        },
        unpitchedPercussionClef1: {
            x_min: 0,
            x_max: 382,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m 230 -338 l 230 338 b 210 360 230 350 222 360 l 20 360 b 0 338 9 360 0 350 l 0 -338 b 20 -360 0 -350 9 -360 l 210 -360 b 230 -338 222 -360 230 -350 z m 550 338 b 530 360 550 350 541 360 l 340 360 b 320 338 328 360 320 350 l 320 -338 b 340 -360 320 -350 328 -360 l 530 -360 b 550 -338 541 -360 550 -350 z"
        },
        "6stringTabClef": {
            x_min: -3,
            x_max: 408,
            y_min: -748,
            y_max: 764,
            ha: 1512,
            o: "m 557 1024 l 557 1100 l 26 1100 l 26 1024 l 249 1024 l 249 422 l 336 422 l 336 1024 z m 588 -328 l 350 348 l 238 348 l -4 -328 l 88 -328 l 160 -125 l 420 -125 l 491 -328 z m 397 -52 l 181 -52 l 292 256 z m 544 -883 b 420 -719 544 -802 507 -752 b 514 -572 482 -690 514 -639 b 314 -399 514 -472 442 -399 l 39 -399 l 39 -1077 l 344 -1077 b 544 -883 467 -1077 544 -995 z m 428 -583 b 292 -691 428 -652 389 -691 l 125 -691 l 125 -475 l 292 -475 b 428 -583 389 -475 428 -514 z m 458 -884 b 337 -1001 458 -949 418 -1001 l 125 -1001 l 125 -768 l 337 -768 b 458 -884 418 -768 458 -818 z"
        },
        timeSig0: {
            x_min: 20,
            x_max: 450,
            y_min: -250,
            y_max: 251,
            ha: 501,
            o: "m 648 0 b 338 361 648 200 510 361 b 29 0 167 361 29 200 b 338 -360 29 -199 167 -360 b 648 0 510 -360 648 -199 z m 338 317 b 446 10 397 317 446 180 b 338 -295 446 -158 397 -295 b 230 10 278 -295 230 -158 b 338 317 230 180 278 317 z"
        },
        timeSig1: {
            x_min: 20,
            x_max: 314,
            y_min: -250,
            y_max: 251,
            ha: 501,
            o: "m 35 19 b 29 0 35 19 29 10 b 45 -20 29 -7 33 -16 b 58 -23 50 -22 56 -23 b 78 -10 72 -23 78 -10 b 156 117 78 -10 140 89 b 170 131 161 127 167 131 b 179 111 176 131 179 120 l 179 -261 b 115 -315 179 -294 145 -315 b 91 -337 105 -315 91 -320 b 122 -360 91 -353 104 -360 l 429 -360 b 452 -337 452 -360 452 -337 b 431 -315 452 -337 452 -315 b 384 -265 410 -315 384 -289 l 384 328 b 356 361 384 351 376 360 b 281 356 336 361 300 356 b 206 360 253 356 228 357 b 199 361 203 360 200 361 b 173 334 184 361 179 347 z"
        },
        timeSig2: {
            x_min: 20,
            x_max: 426,
            y_min: -257,
            y_max: 254,
            ha: 511,
            o: "m 606 -131 b 589 -111 606 -114 599 -111 b 570 -127 577 -111 573 -117 l 569 -128 b 513 -192 554 -164 543 -192 b 488 -187 505 -192 498 -190 b 445 -171 469 -180 459 -179 b 289 -137 416 -160 348 -137 b 236 -145 271 -137 252 -140 b 422 -42 268 -94 390 -50 b 613 147 523 -14 613 27 b 330 366 613 300 464 366 b 69 275 229 366 140 357 b 29 170 45 245 29 209 b 42 108 29 150 33 130 b 160 29 63 63 108 29 b 261 156 248 29 261 120 b 161 275 261 242 161 246 b 275 330 164 295 190 330 b 405 192 403 330 405 233 b 193 -102 405 60 297 -39 b 33 -317 114 -153 58 -223 l 32 -321 b 69 -370 32 -340 48 -370 b 203 -282 101 -370 118 -282 b 410 -360 261 -282 282 -360 b 606 -131 472 -360 583 -354 z"
        },
        timeSig3: {
            x_min: 20,
            x_max: 401,
            y_min: -251,
            y_max: 249,
            ha: 500,
            o: "m 307 357 b 301 357 305 357 304 357 l 291 359 b 285 359 289 359 287 359 b 37 200 161 359 37 276 b 154 84 37 153 65 89 l 161 84 b 256 177 225 84 256 130 l 256 189 b 209 248 252 242 216 245 b 180 268 202 251 180 248 l 180 274 b 240 310 183 298 228 310 b 374 199 363 310 374 233 l 374 189 b 199 36 374 82 289 40 b 164 12 184 35 164 27 b 200 -6 164 -6 189 -6 b 379 -137 366 -6 379 -118 b 269 -307 379 -289 301 -307 b 256 -305 264 -307 258 -305 b 216 -282 245 -304 217 -304 l 216 -275 b 249 -180 216 -243 248 -222 b 145 -76 249 -120 207 -76 b 130 -78 140 -76 135 -76 b 60 -115 105 -82 78 -96 b 29 -203 36 -137 29 -171 b 275 -361 32 -315 134 -359 l 288 -361 b 577 -161 431 -361 577 -288 l 577 -151 b 537 -50 575 -109 564 -82 b 503 -20 528 -39 517 -29 l 472 -3 l 425 10 b 410 17 418 12 413 12 b 409 24 409 20 409 22 b 415 37 409 30 410 36 b 459 50 431 42 446 43 b 547 181 517 78 547 115 b 307 357 547 314 367 353 z"
        },
        timeSig4: {
            x_min: 20,
            x_max: 450,
            y_min: -250,
            y_max: 251,
            ha: 501,
            o: "m 521 -107 l 521 202 b 504 226 521 213 520 226 b 475 213 491 226 484 223 l 338 48 b 325 14 333 40 325 32 l 325 -107 l 131 -107 b 481 336 246 -9 477 318 l 482 340 b 461 361 482 353 472 361 b 363 359 448 361 389 359 b 261 361 337 359 272 361 b 228 334 248 361 228 357 b 43 -105 228 156 86 -45 l 35 -117 b 35 -118 35 -117 35 -118 l 33 -120 b 29 -137 30 -127 29 -132 b 58 -161 29 -151 40 -161 l 325 -161 l 325 -252 b 268 -302 325 -291 294 -302 b 235 -330 245 -302 235 -315 b 262 -360 235 -344 240 -360 l 569 -360 b 598 -330 583 -360 598 -350 b 566 -301 598 -310 580 -301 b 521 -246 552 -301 521 -292 l 521 -161 l 626 -161 b 648 -134 641 -161 648 -151 b 626 -107 648 -117 642 -107 z"
        },
        timeSig5: {
            x_min: 20,
            x_max: 383,
            y_min: -251,
            y_max: 246,
            ha: 497,
            o: "m 109 85 b 117 179 109 85 115 166 b 138 197 118 190 125 197 l 144 197 b 285 184 158 194 226 184 b 492 323 485 184 492 300 b 472 353 492 341 488 353 b 295 340 454 353 341 340 b 101 354 249 340 125 351 b 66 330 75 354 68 341 l 50 10 l 50 7 b 79 -14 50 -12 65 -14 b 111 14 94 -14 95 -1 b 209 62 125 29 160 62 b 357 -125 258 62 357 35 b 235 -304 357 -284 272 -304 b 202 -300 223 -304 212 -304 b 184 -279 194 -295 186 -289 b 202 -259 184 -269 194 -264 b 256 -163 235 -239 256 -203 b 144 -50 256 -99 206 -50 b 30 -157 66 -50 35 -107 b 29 -183 29 -166 29 -174 b 284 -361 29 -302 107 -361 b 552 -125 456 -361 552 -255 b 314 112 552 6 445 112 b 122 71 230 112 168 98 b 115 69 120 69 117 69 b 109 79 109 69 109 75 z"
        },
        timeSig6: {
            x_min: 20,
            x_max: 414,
            y_min: -249,
            y_max: 251,
            ha: 500,
            o: "m 439 120 b 554 229 500 120 554 167 b 553 245 554 235 554 239 b 348 361 539 337 426 361 b 85 209 239 360 137 307 b 29 4 53 148 29 72 l 29 -1 b 73 -200 30 -68 42 -143 b 324 -359 132 -307 203 -359 b 513 -307 389 -359 461 -348 b 596 -137 563 -266 596 -202 b 379 72 596 -24 490 72 b 248 22 333 72 285 55 b 239 19 245 19 242 19 b 226 53 230 19 226 30 b 346 327 230 320 315 327 b 393 305 374 327 393 320 b 357 251 393 285 366 268 b 347 209 350 238 347 223 b 369 150 347 187 354 166 b 439 120 379 131 420 120 z m 320 3 b 405 -158 366 3 405 -69 b 320 -320 405 -248 366 -320 b 236 -158 274 -320 236 -248 b 320 3 236 -69 274 3 z"
        },
        timeSig7: {
            x_min: 20,
            x_max: 421,
            y_min: -250,
            y_max: 249,
            ha: 499,
            o: "m 606 294 b 582 351 606 333 606 351 b 552 336 580 351 557 346 b 485 236 541 318 521 236 b 262 359 449 236 382 359 b 137 307 179 359 157 325 b 98 281 117 288 108 282 b 60 315 86 281 68 301 b 43 325 58 321 50 325 b 29 308 36 325 29 321 l 29 71 b 45 48 29 71 30 48 b 66 76 56 48 60 60 b 164 196 81 112 99 196 b 374 88 222 196 291 88 b 446 118 415 88 435 109 b 459 124 451 121 456 124 b 469 111 465 124 468 120 b 272 -112 469 71 359 -10 b 173 -315 217 -176 173 -259 b 200 -360 173 -346 173 -360 b 294 -347 226 -360 258 -347 b 412 -360 330 -347 397 -360 b 435 -307 426 -360 435 -348 b 606 288 435 -66 606 140 z"
        },
        timeSig8: {
            x_min: 20,
            x_max: 416,
            y_min: -259,
            y_max: 259,
            ha: 518,
            o: "m 481 52 b 567 204 533 85 567 132 b 317 373 567 351 356 373 b 36 176 150 373 36 297 b 161 -16 36 76 92 23 b 29 -190 86 -52 29 -99 b 301 -373 29 -315 158 -373 b 599 -117 445 -373 599 -311 b 481 52 599 -30 549 17 z m 406 85 b 168 240 291 125 168 150 b 314 331 168 301 251 331 b 482 207 360 331 482 308 b 406 85 482 150 454 112 z m 295 -325 b 111 -183 199 -325 111 -276 b 225 -48 111 -125 161 -72 b 436 -219 330 -94 436 -124 b 295 -325 436 -276 392 -325 z"
        },
        timeSig9: {
            x_min: 20,
            x_max: 414,
            y_min: -249,
            y_max: 251,
            ha: 500,
            o: "m 186 -117 b 71 -226 125 -117 71 -164 b 72 -242 71 -232 71 -236 b 276 -359 86 -334 199 -359 b 540 -206 386 -357 488 -304 b 596 -1 572 -145 596 -69 l 596 4 b 552 203 595 71 583 145 b 301 361 492 310 422 361 b 112 310 236 361 164 351 b 29 140 62 269 29 204 b 246 -69 29 27 135 -69 b 377 -19 292 -69 340 -52 b 386 -16 380 -16 383 -16 b 399 -50 395 -16 399 -27 b 279 -324 395 -317 310 -324 b 232 -302 251 -324 232 -317 b 268 -248 232 -282 259 -265 b 278 -206 275 -235 278 -220 b 256 -147 278 -184 271 -163 b 186 -117 246 -128 204 -117 z m 305 0 b 220 161 259 0 220 72 b 305 323 220 251 259 323 b 389 161 351 323 389 251 b 305 0 389 72 351 0 z"
        },
        timeSigCommon: {
            x_min: 5,
            x_max: 424,
            y_min: -249,
            y_max: 251,
            ha: 500,
            o: "m 336 361 b 7 -14 131 361 7 180 b 101 -262 7 -108 42 -190 b 321 -359 156 -328 235 -359 b 611 -88 573 -359 611 -130 b 589 -56 611 -56 595 -56 b 567 -82 577 -56 567 -58 b 363 -311 567 -268 409 -311 b 184 40 246 -311 184 -197 b 372 327 184 278 294 327 b 477 278 446 327 477 292 b 451 246 477 265 472 246 b 360 140 393 246 360 184 b 471 32 360 58 431 32 b 580 156 471 32 580 36 b 336 361 580 344 363 361 z"
        },
        timeSigCutCommon: {
            x_min: 0,
            x_max: 418,
            y_min: -359,
            y_max: 361,
            ha: 720,
            o: "m 573 -58 b 559 -82 567 -58 559 -60 b 354 -310 559 -266 400 -310 b 317 -305 340 -310 328 -308 b 302 -284 311 -304 302 -295 l 302 287 b 338 323 302 297 328 321 b 363 324 347 324 356 324 b 468 275 436 324 468 289 b 442 243 468 264 464 243 b 351 137 384 243 351 181 b 462 30 351 56 422 30 b 572 154 462 30 572 35 b 318 357 572 295 441 357 b 302 390 310 359 302 383 l 302 495 b 276 520 302 507 292 520 b 252 495 265 520 252 507 l 252 369 b 235 346 252 359 238 346 l 196 331 b 0 -14 66 275 0 122 b 225 -346 0 -150 86 -310 b 252 -382 235 -350 252 -369 l 252 -492 b 276 -517 252 -505 265 -517 b 302 -492 292 -517 302 -505 l 302 -379 b 318 -359 302 -370 308 -363 b 602 -85 563 -354 602 -130 b 579 -58 600 -58 586 -58 z m 252 -235 b 243 -252 252 -248 248 -252 b 236 -248 240 -252 238 -251 b 177 37 197 -193 177 -96 b 232 259 177 147 200 215 b 236 262 233 262 235 262 b 252 239 243 262 252 251 z"
        },
        timeSigPlus: {
            x_min: -1,
            x_max: 499,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m 432 53 b 413 79 420 53 413 65 l 413 340 b 392 360 413 350 405 360 l 325 360 b 305 340 312 360 305 350 l 305 79 b 284 53 305 66 292 53 l 19 53 b -1 33 9 53 -1 46 l -1 -33 b 19 -55 -1 -46 9 -55 l 284 -55 b 305 -75 298 -55 305 -68 l 305 -340 b 325 -360 305 -350 312 -360 l 392 -360 b 413 -340 405 -360 413 -350 l 413 -78 b 433 -55 413 -63 423 -55 l 698 -55 b 719 -33 708 -55 719 -46 l 719 33 b 698 53 719 46 708 53 z"
        },
        timeSigPlusSmall: {
            x_min: -1,
            x_max: 255,
            y_min: -133,
            y_max: 123,
            ha: 256,
            o: "m 220 20 b 210 33 215 20 210 26 l 210 166 b 200 177 210 171 206 177 l 166 177 b 156 166 160 177 156 171 l 156 33 b 145 20 156 27 150 20 l 10 20 b -1 10 4 20 -1 16 l -1 -24 b 10 -35 -1 -30 4 -35 l 145 -35 b 156 -46 153 -35 156 -42 l 156 -180 b 166 -192 156 -186 160 -192 l 200 -192 b 210 -180 206 -192 210 -186 l 210 -48 b 222 -35 210 -39 216 -35 l 356 -35 b 367 -24 361 -35 367 -30 l 367 10 b 356 20 367 16 361 20 z"
        },
        timeSigMinus: {
            x_min: 0,
            x_max: 448,
            y_min: -35,
            y_max: 40,
            ha: 75,
            o: "m 645 39 b 619 58 645 49 634 58 l 27 58 b 0 39 12 58 0 49 l 0 -32 b 27 -50 0 -42 12 -50 l 619 -50 b 645 -32 634 -50 645 -42 z"
        },
        timeSigParensRight: {
            x_min: 0,
            x_max: 184,
            y_min: -489,
            y_max: 491,
            ha: 980,
            o: "m 0 -696 b 3 -704 0 -698 1 -704 b 7 -703 4 -704 6 -704 b 265 1 187 -530 265 -282 b 12 701 265 289 187 531 b 4 707 12 701 6 707 b 0 696 1 707 0 703 l 0 665 b 4 644 0 665 0 651 b 167 1 112 503 167 315 b 6 -641 167 -311 109 -497 b 0 -658 3 -644 0 -651 z"
        },
        timeSigParensRightSmall: {
            x_min: 0,
            x_max: 110,
            y_min: -251,
            y_max: 249,
            ha: 500,
            o: "m 0 -356 b 3 -361 0 -357 1 -361 b 158 0 112 -272 158 -145 b 4 359 158 147 109 272 b 0 353 3 359 0 357 l 0 338 b 3 327 0 338 0 330 b 91 0 60 246 91 160 b 4 -328 91 -160 62 -249 b 0 -337 3 -330 0 -333 z"
        },
        timeSigParensLeft: {
            x_min: 0,
            x_max: 184,
            y_min: -489,
            y_max: 491,
            ha: 980,
            o: "m 265 -658 b 259 -641 265 -651 262 -644 b 98 1 156 -497 98 -311 b 261 644 98 315 153 503 b 265 665 265 651 265 665 l 265 696 b 261 707 265 703 264 707 b 253 701 259 707 253 701 b 0 1 78 531 0 289 b 258 -703 0 -282 78 -530 b 262 -704 259 -704 261 -704 b 265 -696 264 -704 265 -698 z"
        },
        timeSigParensLeftSmall: {
            x_min: 0,
            x_max: 110,
            y_min: -251,
            y_max: 249,
            ha: 500,
            o: "m 158 -337 b 154 -328 158 -333 156 -330 b 68 0 96 -249 68 -160 b 156 327 68 160 98 246 b 158 338 158 330 158 338 l 158 353 b 154 359 158 357 156 359 b 0 0 49 272 0 147 b 156 -361 0 -145 46 -272 b 158 -356 157 -361 158 -357 z"
        },
        noteheadDoubleWhole: {
            x_min: 0,
            x_max: 599,
            y_min: -155,
            y_max: 155,
            ha: 310,
            o: "m 13 223 b 0 212 4 223 0 217 l 0 -213 b 13 -223 0 -219 4 -223 l 32 -223 b 45 -213 39 -223 45 -219 l 45 212 b 32 223 45 217 39 223 z m 96 223 b 82 212 88 223 82 217 l 82 -213 b 96 -223 82 -219 88 -223 l 114 -223 b 128 -213 121 -223 128 -219 l 128 212 b 114 223 128 217 121 223 z m 747 223 b 733 212 740 223 733 217 l 733 -213 b 747 -223 733 -219 740 -223 l 766 -223 b 780 -213 773 -223 780 -219 l 780 212 b 766 223 780 217 773 223 z m 829 223 b 815 212 824 223 815 217 l 815 -213 b 829 -223 815 -219 824 -223 l 848 -223 b 863 -213 857 -223 863 -219 l 863 212 b 848 223 863 217 857 223 z m 438 180 b 130 1 248 180 130 101 b 423 -180 130 -92 210 -180 b 733 1 657 -180 733 -98 b 438 180 733 104 572 180 z m 469 -145 b 331 -71 409 -145 369 -112 b 284 58 305 -37 284 12 b 400 147 284 131 333 147 b 577 -45 498 147 577 42 b 469 -145 577 -115 533 -145 z"
        },
        noteheadWhole: {
            x_min: 0,
            x_max: 422,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 311 180 b 0 3 120 180 0 101 b 297 -180 0 -94 82 -180 b 608 3 533 -180 608 -98 b 311 180 608 105 445 180 z m 160 91 b 274 148 176 141 229 148 b 452 -45 373 148 452 42 b 386 -141 452 -89 433 -130 b 341 -147 372 -145 356 -147 b 206 -72 289 -147 236 -112 b 156 56 177 -39 156 10 b 160 91 156 68 157 79 z"
        },
        noteheadHalf: {
            x_min: 0,
            x_max: 295,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 140 -180 b 425 60 377 -180 425 13 b 282 180 425 134 366 180 b 0 -60 68 180 0 14 b 140 -180 0 -137 60 -180 z m 108 -125 b 50 -92 78 -125 60 -109 b 42 -63 46 -84 42 -73 b 318 121 42 7 251 121 b 372 91 346 121 361 108 b 380 63 376 82 380 73 b 108 -125 380 1 177 -125 z"
        },
        noteheadBlack: {
            x_min: 0,
            x_max: 295,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 140 -180 b 425 60 268 -180 425 -62 b 285 180 425 134 367 180 b 0 -60 127 180 0 63 b 140 -180 0 -135 62 -180 z"
        },
        noteheadXDoubleWhole: {
            x_min: 0,
            x_max: 546,
            y_min: -155,
            y_max: 155,
            ha: 310,
            o: "m 43 213 b 30 223 43 217 39 223 l 13 223 b 0 213 6 223 0 217 l 0 -215 b 13 -223 0 -219 6 -223 l 30 -223 b 43 -215 39 -223 43 -219 z m 704 213 b 693 223 704 217 698 223 l 672 223 b 660 213 667 223 660 217 l 660 163 b 634 180 655 173 645 180 l 505 180 b 484 173 498 180 490 177 l 393 95 l 300 173 b 279 180 294 177 287 180 l 151 180 b 125 163 141 180 130 173 l 125 213 b 112 223 125 217 118 223 l 94 223 b 82 213 86 223 82 217 l 82 -215 b 94 -223 82 -219 86 -223 l 112 -223 b 125 -215 118 -223 125 -219 l 125 -163 b 151 -180 130 -173 140 -180 l 279 -180 b 300 -171 287 -180 294 -177 l 393 -95 l 485 -171 b 505 -180 491 -177 498 -180 l 632 -180 b 660 -163 645 -180 655 -173 l 660 -215 b 672 -223 660 -219 667 -223 l 693 -223 b 704 -215 698 -223 704 -219 z m 786 213 b 772 223 786 217 780 223 l 755 223 b 740 213 747 223 740 217 l 740 -215 b 755 -223 740 -219 747 -223 l 772 -223 b 786 -215 780 -223 786 -219 z m 507 -141 l 393 -45 l 276 -141 l 207 -141 l 364 0 l 207 141 l 276 141 l 393 45 l 507 141 l 577 141 l 420 0 l 577 -141 z m 660 -132 l 518 0 l 660 132 z m 125 131 l 266 0 l 125 -131 z"
        },
        noteheadXWhole: {
            x_min: 0,
            x_max: 377,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 272 -95 l 364 -171 b 384 -180 370 -177 377 -180 l 511 -180 b 543 -148 528 -180 543 -164 b 531 -124 543 -140 539 -131 l 412 0 l 531 124 b 541 148 539 131 541 140 b 513 180 541 164 528 180 l 384 180 b 364 171 377 180 370 177 l 272 94 l 179 171 b 158 180 173 177 166 180 l 30 180 b 0 148 16 180 0 164 b 12 124 0 140 4 131 l 132 0 l 12 -124 b 1 -148 4 -131 1 -140 b 32 -180 1 -164 14 -180 l 158 -180 b 179 -171 166 -180 173 -177 z m 386 -141 l 272 -45 l 157 -141 l 88 -141 l 245 0 l 88 141 l 157 141 l 272 45 l 386 141 l 456 141 l 300 0 l 456 -141 z"
        },
        noteheadXHalf: {
            x_min: 0,
            x_max: 334,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 295 180 b 271 170 287 180 278 177 l 209 98 l 115 171 b 95 180 109 177 104 180 l 36 180 b 4 148 19 180 4 164 b 14 124 4 140 7 132 l 140 22 l 7 -127 b 0 -148 3 -131 0 -138 b 32 -180 0 -166 14 -180 l 184 -180 b 209 -170 193 -180 203 -177 l 271 -99 l 363 -171 b 384 -180 370 -176 377 -180 l 445 -180 b 478 -147 461 -180 478 -163 b 465 -125 478 -138 474 -131 l 341 -22 l 474 127 b 481 148 480 131 481 138 b 448 180 481 166 468 180 z m 36 148 l 95 148 l 233 33 l 334 148 l 410 148 l 274 -6 l 445 -148 l 384 -148 l 248 -35 l 147 -148 l 71 -148 l 206 4 z"
        },
        noteheadXBlack: {
            x_min: 0,
            x_max: 290,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 410 -143 l 239 0 l 410 144 b 418 160 415 147 418 154 b 399 180 418 171 408 180 b 389 177 396 180 392 179 l 207 26 l 29 177 b 17 180 26 179 22 180 b 0 161 7 180 0 170 b 7 144 0 156 3 148 l 179 0 l 7 -143 b 0 -158 1 -147 0 -153 b 19 -180 0 -170 7 -180 b 29 -176 23 -180 26 -179 l 207 -24 l 389 -176 b 399 -180 392 -179 396 -180 b 418 -160 410 -180 418 -168 b 410 -143 418 -153 415 -147 z"
        },
        noteheadCircleXDoubleWhole: {
            x_min: 0,
            x_max: 422,
            y_min: -155,
            y_max: 155,
            ha: 310,
            o: "m 576 223 b 563 213 570 223 563 219 l 563 -215 b 576 -223 563 -219 570 -223 l 595 -223 b 608 -215 602 -223 608 -219 l 608 213 b 595 223 608 219 602 223 z m 497 223 b 484 213 491 223 484 219 l 484 -215 b 497 -223 484 -219 491 -223 l 516 -223 b 528 -215 523 -223 528 -219 l 528 213 b 516 223 528 219 523 223 z m 94 223 b 81 213 86 223 81 219 l 81 -215 b 94 -223 81 -219 86 -223 l 111 -223 b 124 -215 118 -223 124 -219 l 124 213 b 111 223 124 219 118 223 z m 13 223 b 0 213 6 223 0 219 l 0 -215 b 13 -223 0 -219 6 -223 l 30 -223 b 45 -215 37 -223 45 -219 l 45 213 b 30 223 45 219 37 223 z m 304 180 b 127 0 206 180 127 101 b 304 -180 127 -99 206 -180 b 482 0 405 -180 482 -99 b 304 180 482 101 405 180 z m 305 32 l 225 112 b 304 140 248 130 275 140 b 387 112 336 140 364 130 z m 278 1 l 193 -82 b 216 0 199 -59 216 -30 b 194 85 216 33 203 50 z m 334 1 l 418 84 b 389 0 402 50 389 23 b 418 -81 389 -30 409 -60 z m 305 -27 l 389 -109 b 304 -138 364 -128 336 -138 b 222 -109 274 -138 246 -128 z"
        },
        noteheadCircleXWhole: {
            x_min: 0,
            x_max: 249,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 179 180 b 0 0 81 180 0 101 b 179 -180 0 -99 81 -180 b 359 0 278 -180 359 -99 b 179 180 359 101 278 180 z m 180 32 l 99 112 b 179 140 121 130 150 140 b 262 112 210 140 238 130 z m 151 1 l 68 -82 b 86 0 73 -59 86 -30 b 68 85 86 33 78 50 z m 209 1 l 291 84 b 269 0 276 50 269 32 b 291 -79 269 -26 282 -58 z m 180 -27 l 264 -111 b 179 -138 239 -128 210 -138 b 96 -111 148 -138 120 -128 z"
        },
        noteheadCircleXHalf: {
            x_min: 0,
            x_max: 250,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 179 180 b 0 0 81 180 0 101 b 179 -180 0 -99 81 -180 b 360 0 278 -180 360 -99 b 179 180 360 101 278 180 z m 186 37 l 131 92 b 220 124 153 109 189 124 b 262 112 236 124 249 121 z m 215 7 l 291 84 b 304 42 300 71 304 58 b 271 -49 304 10 288 -26 z m 145 -6 l 68 -82 b 56 -42 59 -71 56 -58 b 89 52 56 -9 72 27 z m 174 -33 l 230 -89 b 140 -124 206 -108 171 -124 b 96 -111 122 -124 109 -121 z"
        },
        noteheadCircleX: {
            x_min: 0,
            x_max: 249,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 179 180 b 0 0 81 180 0 99 b 179 -180 0 -99 81 -180 b 359 0 278 -180 359 -99 b 179 180 359 99 278 180 z m 261 112 l 180 30 l 98 112 b 179 138 121 128 148 138 b 261 112 210 138 238 128 z m 317 0 b 292 -82 317 -30 308 -59 l 209 1 l 291 84 b 317 0 307 60 317 30 z m 40 0 b 69 84 40 32 50 60 l 151 1 l 68 -84 b 40 0 49 -60 40 -30 z m 95 -111 l 180 -27 l 262 -111 b 179 -138 239 -128 210 -138 b 95 -111 148 -138 120 -128 z"
        },
        noteheadCircledDoubleWhole: {
            x_min: 0,
            x_max: 603,
            y_min: -218,
            y_max: 213,
            ha: 431,
            o: "m 770 223 l 752 223 b 737 213 744 223 737 219 l 737 59 b 435 307 710 203 582 307 b 128 48 281 307 156 197 l 128 213 b 115 223 128 219 122 223 l 96 223 b 84 213 89 223 84 219 l 84 -215 b 96 -223 84 -220 89 -223 l 115 -223 b 128 -215 122 -223 128 -220 l 128 -56 b 435 -314 156 -206 282 -314 b 654 -223 517 -314 595 -282 b 737 -66 697 -180 726 -125 l 737 -215 b 752 -223 737 -220 744 -223 l 770 -223 b 785 -215 778 -223 785 -220 l 785 213 b 770 223 785 219 778 223 z m 435 274 b 698 85 556 274 661 194 b 439 180 641 143 534 180 b 176 99 320 180 228 148 b 435 274 217 203 318 274 z m 32 223 l 13 223 b 0 213 6 223 0 219 l 0 -215 b 13 -223 0 -220 6 -223 l 32 -223 b 45 -215 40 -223 45 -220 l 45 213 b 32 223 45 219 40 223 z m 852 223 l 835 223 b 819 213 828 223 819 219 l 819 -215 b 835 -223 819 -220 828 -223 l 852 -223 b 868 -215 861 -223 868 -220 l 868 213 b 852 223 868 219 861 223 z m 580 -46 b 514 -143 580 -91 562 -131 b 472 -148 501 -147 487 -148 b 364 -105 433 -148 395 -131 l 334 -73 b 285 58 307 -39 285 10 b 289 91 285 69 287 79 b 403 145 305 140 357 145 b 580 -46 501 145 580 42 z m 435 -282 b 176 -108 318 -282 217 -209 b 425 -180 222 -151 301 -180 b 691 -109 563 -180 647 -153 b 435 -282 651 -210 550 -282 z"
        },
        noteheadCircledWhole: {
            x_min: 0,
            x_max: 437,
            y_min: -225,
            y_max: 211,
            ha: 436,
            o: "m 314 304 b 0 -10 140 304 0 164 b 314 -324 0 -183 141 -324 b 629 -10 487 -324 629 -183 b 314 304 629 164 488 304 z m 314 275 b 588 73 441 275 549 193 b 321 180 536 137 420 180 b 48 88 190 180 95 143 b 314 275 85 199 199 275 z m 393 -141 b 350 -147 379 -145 364 -147 b 314 -141 337 -147 325 -145 b 167 55 235 -120 167 -26 b 173 91 167 66 168 79 b 284 145 187 138 239 145 b 459 -48 382 145 459 39 b 393 -141 459 -91 438 -131 z m 314 -294 b 40 -86 187 -294 75 -207 b 305 -180 81 -141 164 -180 b 588 -86 464 -180 550 -143 b 314 -294 554 -209 442 -294 z"
        },
        noteheadCircledHalf: {
            x_min: -18,
            x_max: 311,
            y_min: -162,
            y_max: 167,
            ha: 329,
            o: "m 212 240 b -26 3 81 240 -26 134 b 212 -233 -26 -127 81 -233 b 448 3 341 -233 448 -127 b 212 240 448 134 341 240 z m 212 220 b 363 160 271 220 324 197 b 281 180 341 173 312 180 b 0 -52 76 180 6 26 b -6 3 -4 -35 -6 -16 b 212 220 -6 122 92 220 z m 50 -92 b 42 -63 46 -84 42 -73 b 173 63 42 -33 73 7 b 317 120 243 105 288 120 b 369 89 344 120 359 107 b 377 62 374 81 377 72 b 248 -66 377 33 348 -1 b 108 -125 183 -109 138 -125 b 50 -92 78 -125 60 -109 z m 212 -215 b 84 -171 164 -215 120 -199 b 138 -180 101 -179 120 -180 b 422 56 372 -180 420 7 b 429 3 426 40 429 22 b 212 -215 429 -117 333 -215 z"
        },
        noteheadCircledBlack: {
            x_min: -21,
            x_max: 321,
            y_min: -171,
            y_max: 167,
            ha: 338,
            o: "m 216 240 b -30 -3 82 240 -30 131 b 216 -246 -30 -137 82 -246 b 462 -3 351 -246 462 -137 b 216 240 462 131 351 240 z m 216 220 b 372 160 276 220 331 197 b 284 180 348 174 317 180 b 0 -59 127 180 0 65 l 0 -66 b -10 -3 -6 -45 -10 -24 b 216 220 -10 120 92 220 z m 216 -226 b 56 -158 153 -226 96 -200 b 140 -180 79 -171 107 -180 b 425 60 268 -180 425 -60 b 422 88 425 71 425 79 b 442 -3 435 60 442 29 b 216 -226 442 -125 341 -226 z"
        },
        noteheadDoubleWholeSquare: {
            x_min: 0,
            x_max: 416,
            y_min: -190,
            y_max: 198,
            ha: 388,
            o: "m 563 217 b 528 180 563 192 544 180 l 62 180 b 36 215 52 180 36 192 l 36 268 b 17 285 36 278 27 285 b 0 268 7 285 0 278 l 0 -255 b 17 -274 0 -264 7 -274 b 36 -255 27 -274 36 -264 l 36 -213 b 66 -180 36 -197 53 -180 l 528 -180 b 563 -209 549 -180 563 -196 l 563 -255 b 580 -274 563 -264 570 -274 b 599 -255 590 -274 599 -264 l 599 268 b 580 285 599 278 590 285 b 563 268 570 285 563 278 z m 36 23 b 111 71 36 55 58 71 l 487 71 b 563 30 533 71 563 53 l 563 -22 b 487 -68 563 -53 533 -68 l 117 -68 b 36 -22 66 -68 36 -49 z"
        },
        noteheadSquareWhite: {
            x_min: 0,
            x_max: 313,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 451 -180 l 451 180 l 0 180 l 0 -180 z m 40 -138 l 40 140 l 410 140 l 410 -138 z"
        },
        noteheadSquareBlack: {
            x_min: 0,
            x_max: 313,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 451 -180 l 451 180 l 0 180 l 0 -180 z"
        },
        noteheadTriangleDownDoubleWhole: {
            x_min: 0,
            x_max: 483,
            y_min: -155,
            y_max: 155,
            ha: 310,
            o: "m 696 213 b 681 223 696 219 690 223 l 662 223 b 648 213 655 223 648 219 l 648 -213 b 662 -223 648 -217 655 -223 l 681 -223 b 696 -213 690 -223 696 -217 z m 619 213 b 605 223 619 219 613 223 l 588 223 b 573 213 580 223 573 219 l 573 174 b 562 180 570 177 566 180 l 134 180 b 122 174 130 180 125 177 l 122 213 b 108 223 122 219 117 223 l 91 223 b 76 213 84 223 76 219 l 76 -213 b 91 -223 76 -217 84 -223 l 108 -223 b 122 -213 117 -223 122 -217 l 122 154 l 334 -173 b 346 -180 337 -177 341 -180 b 357 -173 351 -180 354 -177 l 573 154 l 573 -213 b 588 -223 573 -217 580 -223 l 605 -223 b 619 -213 613 -223 619 -217 z m 32 -223 b 46 -213 40 -223 46 -217 l 46 213 b 32 223 46 219 40 223 l 14 223 b 0 213 7 223 0 219 l 0 -213 b 14 -223 0 -217 7 -223 z m 428 98 b 346 -107 428 17 377 -53 b 265 96 315 -55 265 17 b 289 137 265 109 275 137 l 406 137 b 428 98 419 137 428 111 z"
        },
        noteheadTriangleDownWhole: {
            x_min: 0,
            x_max: 319,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 14 180 b 0 166 6 180 0 173 b 1 158 0 163 1 160 l 216 -173 b 228 -180 219 -177 225 -180 b 239 -173 233 -180 238 -177 l 458 158 b 459 166 458 160 459 163 b 445 180 459 173 454 180 z m 288 137 b 310 98 301 137 310 111 b 228 -108 310 17 259 -55 b 145 96 197 -56 145 17 b 170 137 145 109 157 137 z"
        },
        noteheadTriangleDownHalf: {
            x_min: 0,
            x_max: 285,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 196 -180 b 209 -173 200 -180 206 -177 l 408 157 b 410 166 409 160 410 163 b 396 180 410 173 403 180 l 14 180 b 0 166 4 180 0 173 b 1 158 0 163 0 161 l 183 -173 b 196 -180 184 -174 190 -180 z m 164 138 l 295 138 l 179 -76 l 114 37 z"
        },
        noteheadTriangleDownBlack: {
            x_min: 0,
            x_max: 292,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 207 -180 l 420 180 l 0 180 z"
        },
        noteheadTriangleUpDoubleWhole: {
            x_min: 0,
            x_max: 483,
            y_min: -155,
            y_max: 155,
            ha: 310,
            o: "m 696 213 b 681 223 696 217 690 223 l 662 223 b 648 213 655 223 648 217 l 648 -213 b 662 -223 648 -219 655 -223 l 681 -223 b 696 -213 690 -223 696 -219 z m 619 213 b 605 223 619 217 613 223 l 588 223 b 573 213 580 223 573 217 l 573 -154 l 357 173 b 346 180 354 177 351 180 b 334 173 341 180 337 177 l 122 -154 l 122 213 b 108 223 122 217 117 223 l 91 223 b 76 213 84 223 76 217 l 76 -213 b 91 -223 76 -219 84 -223 l 108 -223 b 122 -213 117 -223 122 -219 l 122 -174 b 134 -180 125 -177 130 -180 l 562 -180 b 573 -174 566 -180 570 -177 l 573 -213 b 588 -223 573 -219 580 -223 l 605 -223 b 619 -213 613 -223 619 -219 z m 32 223 l 14 223 b 0 213 7 223 0 217 l 0 -213 b 14 -223 0 -219 7 -223 l 32 -223 b 46 -213 40 -223 46 -219 l 46 213 b 32 223 46 217 40 223 z m 428 -98 b 406 -137 428 -111 419 -137 l 289 -137 b 265 -96 275 -137 265 -109 b 346 107 265 -17 315 55 b 428 -98 377 53 428 -17 z"
        },
        noteheadTriangleUpWhole: {
            x_min: 0,
            x_max: 319,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 445 -180 b 459 -166 454 -180 459 -173 b 458 -158 459 -163 458 -160 l 239 173 b 228 180 238 177 233 180 b 216 173 225 180 219 177 l 1 -158 b 0 -166 1 -160 0 -163 b 14 -180 0 -173 6 -180 z m 170 -137 b 145 -96 157 -137 145 -109 b 228 108 145 -17 197 56 b 310 -98 259 55 310 -17 b 288 -137 310 -111 301 -137 z"
        },
        noteheadTriangleUpHalf: {
            x_min: 0,
            x_max: 285,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 215 180 b 202 173 210 180 204 177 l 3 -157 b 0 -166 1 -160 0 -163 b 14 -180 0 -173 7 -180 l 396 -180 b 410 -166 406 -180 410 -173 b 409 -158 410 -163 410 -161 l 228 173 b 215 180 226 174 220 180 z m 246 -138 l 115 -138 l 232 76 l 297 -37 z"
        },
        noteheadTriangleUpBlack: {
            x_min: 0,
            x_max: 293,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 422 -180 l 207 180 l 0 -180 z"
        },
        noteheadSlashedDoubleWhole1: {
            x_min: 0,
            x_max: 596,
            y_min: -179,
            y_max: 168,
            ha: 347,
            o: "m 618 135 l 697 206 b 704 222 703 210 704 216 b 698 236 704 226 703 232 b 683 242 694 239 688 242 b 670 238 677 242 674 240 l 575 153 b 435 180 531 168 481 180 b 128 0 246 180 128 98 b 236 -148 128 -58 160 -114 l 153 -222 b 145 -238 148 -226 145 -232 b 151 -252 145 -242 148 -248 b 167 -258 156 -256 161 -258 b 181 -253 171 -258 177 -256 l 282 -164 b 420 -180 320 -173 366 -180 b 729 0 654 -180 729 -98 b 618 135 729 55 681 104 z m 114 223 l 95 223 b 82 212 88 223 82 217 l 82 -215 b 95 -223 82 -219 88 -223 l 114 -223 b 127 -215 121 -223 127 -219 l 127 212 b 114 223 127 217 121 223 z m 32 223 l 13 223 b 0 212 6 223 0 217 l 0 -215 b 13 -223 0 -219 6 -223 l 32 -223 b 45 -215 39 -223 45 -219 l 45 212 b 32 223 45 217 39 223 z m 844 223 l 825 223 b 811 212 819 223 811 217 l 811 -215 b 825 -223 811 -219 819 -223 l 844 -223 b 858 -215 851 -223 858 -219 l 858 212 b 844 223 858 217 851 223 z m 763 223 l 743 223 b 730 212 736 223 730 217 l 730 -215 b 743 -223 730 -219 736 -223 l 763 -223 b 776 -215 769 -223 776 -219 l 776 212 b 763 223 776 217 769 223 z m 282 56 b 285 89 282 68 284 79 b 399 144 301 137 354 144 b 510 95 441 144 480 124 l 327 -68 b 282 56 301 -35 282 13 z m 572 -72 b 508 -141 564 -108 544 -132 b 467 -147 495 -145 481 -147 b 360 -104 428 -147 389 -128 l 356 -98 l 537 63 b 575 -46 560 30 575 -9 b 572 -72 575 -55 573 -65 z"
        },
        noteheadSlashedWhole1: {
            x_min: -22,
            x_max: 433,
            y_min: -157,
            y_max: 148,
            ha: 305,
            o: "m 484 140 b 308 180 431 166 367 180 b 0 1 118 180 0 99 b 73 -128 0 -48 22 -95 l -22 -190 b -32 -206 -27 -194 -32 -200 b -27 -217 -32 -210 -30 -215 b -12 -226 -23 -223 -17 -226 b 0 -223 -7 -226 -4 -225 l 112 -150 b 294 -180 157 -168 217 -180 b 602 1 526 -180 602 -98 b 523 118 602 48 570 86 l 613 177 b 624 193 619 181 624 187 b 619 204 624 197 622 200 b 603 213 615 209 609 213 b 592 209 599 213 596 212 z m 190 -52 b 154 56 170 -20 154 19 b 160 91 154 68 156 79 b 271 147 174 138 226 147 b 396 82 321 147 364 121 z m 419 50 b 446 -48 436 19 446 -14 b 337 -147 446 -120 402 -147 b 301 -141 327 -147 314 -144 b 235 -104 276 -134 253 -120 b 215 -84 226 -98 220 -91 z"
        },
        noteheadSlashedHalf1: {
            x_min: -67,
            x_max: 386,
            y_min: -142,
            y_max: 160,
            ha: 302,
            o: "m 552 222 b 536 230 549 228 543 230 b 524 228 533 230 528 230 l 389 140 b 281 180 364 164 327 180 b 0 -60 65 180 0 13 b 7 -105 0 -78 3 -92 l -88 -167 b -96 -184 -94 -171 -96 -177 b -94 -194 -96 -187 -95 -192 b -76 -204 -89 -202 -84 -204 b -66 -202 -73 -204 -69 -203 l 29 -140 b 137 -180 55 -167 92 -180 b 420 59 374 -180 420 13 b 412 107 420 76 419 92 l 546 194 b 556 210 552 197 556 204 b 552 222 556 213 554 217 z m 315 120 b 347 112 328 120 338 117 l 46 -82 b 42 -63 43 -76 42 -69 b 315 120 42 6 248 120 z m 108 -124 b 69 -114 91 -124 79 -120 l 372 81 b 376 63 374 75 376 69 b 108 -124 376 0 174 -124 z"
        },
        noteheadSlashedBlack1: {
            x_min: -80,
            x_max: 375,
            y_min: -165,
            y_max: 167,
            ha: 332,
            o: "m 518 240 b 507 236 514 240 510 239 l 384 148 b 284 180 359 168 324 180 b 0 -62 127 180 0 63 b 13 -115 0 -82 4 -99 l -107 -202 b -115 -217 -111 -204 -115 -212 b -111 -229 -115 -222 -114 -225 b -95 -238 -108 -235 -101 -238 b -84 -235 -91 -238 -86 -236 l 39 -148 b 140 -180 63 -170 99 -180 b 425 59 268 -180 425 -62 b 410 117 425 81 420 101 l 530 203 b 540 219 536 207 540 213 b 518 240 540 229 528 240 z"
        },
        noteheadSlashedDoubleWhole2: {
            x_min: 0,
            x_max: 596,
            y_min: -178,
            y_max: 169,
            ha: 347,
            o: "m 729 0 b 435 180 729 102 569 180 b 278 156 374 180 321 170 l 184 239 b 170 243 181 242 176 243 b 154 238 166 243 158 240 b 150 223 151 233 150 228 b 156 207 150 217 153 212 l 233 138 b 128 0 167 107 128 56 b 420 -180 128 -94 210 -180 b 575 -164 482 -180 533 -174 l 672 -252 b 687 -256 677 -255 681 -256 b 703 -251 691 -256 698 -255 b 707 -236 706 -246 707 -240 b 701 -220 707 -230 706 -225 l 619 -150 b 729 0 700 -117 729 -62 z m 114 223 l 95 223 b 82 213 88 223 82 217 l 82 -213 b 95 -223 82 -219 88 -223 l 114 -223 b 127 -213 121 -223 127 -219 l 127 213 b 114 223 127 217 121 223 z m 32 223 l 13 223 b 0 213 6 223 0 217 l 0 -213 b 13 -223 0 -219 6 -223 l 32 -223 b 45 -213 39 -223 45 -219 l 45 213 b 32 223 45 217 39 223 z m 844 223 l 825 223 b 811 213 819 223 811 217 l 811 -213 b 825 -223 811 -219 819 -223 l 844 -223 b 858 -213 851 -223 858 -219 l 858 213 b 844 223 858 217 851 223 z m 763 223 l 743 223 b 730 213 736 223 730 217 l 730 -213 b 743 -223 730 -219 736 -223 l 763 -223 b 776 -213 769 -223 776 -219 l 776 213 b 763 223 776 217 769 223 z m 312 124 b 399 144 336 141 369 144 b 575 -46 495 144 575 40 b 563 -98 575 -65 570 -81 z m 508 -141 b 467 -147 495 -145 481 -147 b 360 -104 428 -147 389 -128 b 330 -72 350 -95 340 -82 b 282 56 304 -37 282 10 b 285 89 282 68 284 79 b 536 -130 287 89 304 75 z"
        },
        noteheadSlashedWhole2: {
            x_min: -18,
            x_max: 436,
            y_min: -154,
            y_max: 151,
            ha: 305,
            o: "m 531 -128 b 602 1 582 -96 602 -49 b 308 180 602 104 441 180 b 114 144 230 180 164 166 l 4 215 b -6 217 1 217 -3 217 b -22 209 -13 217 -19 215 b -26 197 -24 204 -26 200 b -16 181 -26 192 -22 184 l 75 121 b 0 1 27 91 0 49 b 294 -180 0 -94 82 -180 b 491 -150 379 -180 444 -168 l 598 -219 b 608 -222 600 -222 605 -222 b 624 -213 615 -222 621 -219 b 628 -202 626 -209 628 -206 b 618 -186 628 -196 624 -189 z m 168 108 b 271 147 190 141 233 147 b 446 -48 369 147 446 40 b 445 -72 446 -56 446 -63 z m 154 69 l 429 -109 b 382 -141 419 -125 402 -135 b 337 -147 367 -144 351 -147 b 301 -141 327 -147 314 -144 b 235 -104 276 -134 253 -120 b 203 -72 223 -94 213 -82 b 154 58 177 -39 154 12 z"
        },
        noteheadSlashedHalf2: {
            x_min: -73,
            x_max: 380,
            y_min: -134,
            y_max: 168,
            ha: 302,
            o: "m 537 -156 l 383 -58 b 422 60 413 -9 422 39 b 281 180 422 134 364 180 b 101 127 203 180 144 157 l -75 239 b -85 242 -78 242 -82 242 b -102 233 -92 242 -98 239 b -105 222 -104 229 -105 225 b -95 206 -105 216 -102 209 l 69 99 b 0 -59 19 46 0 -20 b 138 -180 0 -135 60 -180 b 359 -88 248 -180 317 -138 l 516 -190 b 527 -193 520 -192 524 -193 b 543 -183 534 -193 540 -190 b 547 -173 546 -180 547 -176 b 537 -156 547 -166 543 -160 z m 367 92 b 377 63 374 82 377 73 b 318 -14 377 43 361 20 l 184 72 b 317 121 248 108 289 121 b 367 92 344 121 357 109 z m 248 -66 b 108 -124 181 -108 138 -124 b 50 -92 78 -124 60 -109 b 42 -63 46 -84 42 -73 b 145 49 42 -35 68 0 l 285 -40 b 248 -66 274 -49 261 -56 z"
        },
        noteheadSlashedBlack2: {
            x_min: -79,
            x_max: 376,
            y_min: -164,
            y_max: 168,
            ha: 332,
            o: "m 531 -200 l 363 -78 b 425 59 402 -37 425 10 b 285 180 425 132 367 180 b 92 114 210 180 144 154 l -81 238 b -94 242 -85 240 -89 242 b -111 232 -99 242 -107 238 b -114 220 -112 229 -114 225 b -105 204 -114 215 -111 207 l 62 85 b 0 -62 23 43 0 -9 b 140 -180 0 -137 62 -180 b 331 -108 204 -180 275 -153 l 507 -233 b 520 -236 511 -236 517 -236 b 537 -228 527 -236 533 -233 b 541 -216 540 -225 541 -220 b 531 -200 541 -210 537 -203 z"
        },
        noteheadDiamondDoubleWhole: {
            x_min: 0,
            x_max: 432,
            y_min: -155,
            y_max: 155,
            ha: 310,
            o: "m 592 223 b 580 215 585 223 580 219 l 580 -215 b 592 -223 580 -219 585 -223 l 608 -223 b 622 -215 615 -223 622 -219 l 622 215 b 608 223 622 219 615 223 z m 517 223 b 504 215 510 223 504 219 l 504 -215 b 517 -223 504 -219 510 -223 l 533 -223 b 544 -215 540 -223 544 -219 l 544 215 b 533 223 544 219 540 223 z m 246 179 b 240 180 243 179 242 180 b 232 176 236 180 233 179 l 118 22 b 117 17 117 20 117 19 l 117 215 b 104 223 117 219 111 223 l 88 223 b 75 215 81 223 75 219 l 75 -215 b 88 -223 75 -219 81 -223 l 104 -223 b 117 -215 111 -223 117 -219 l 117 14 l 118 14 b 122 7 118 12 120 10 l 374 -179 b 382 -180 376 -180 379 -180 b 390 -177 384 -180 387 -180 l 503 -23 l 503 -17 b 500 -9 503 -13 503 -10 z m 12 223 b 0 215 4 223 0 219 l 0 -215 b 12 -223 0 -219 4 -223 l 29 -223 b 40 -215 36 -223 40 -219 l 40 215 b 29 223 40 219 36 223 z m 183 39 b 179 46 181 39 179 43 b 229 112 226 112 228 112 b 236 109 229 112 233 111 l 436 -39 b 439 -46 438 -39 439 -42 b 390 -112 393 -111 392 -112 b 383 -109 389 -112 386 -111 z"
        },
        noteheadDiamondWhole: {
            x_min: 0,
            x_max: 270,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 386 -23 b 389 -16 387 -20 389 -19 b 383 -7 389 -13 386 -9 l 130 179 b 122 180 128 180 125 180 b 115 177 120 180 117 180 l 3 23 b 0 17 1 20 0 19 b 4 7 0 16 3 10 l 258 -179 b 264 -180 261 -179 262 -180 b 272 -176 268 -180 271 -179 z m 66 40 b 62 48 65 42 62 45 l 109 111 b 112 112 109 112 111 112 b 118 111 115 112 117 111 l 320 -37 b 324 -46 323 -39 324 -42 b 275 -111 278 -111 276 -111 b 268 -108 272 -111 271 -109 z"
        },
        noteheadDiamondHalf: {
            x_min: 0,
            x_max: 251,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 359 -7 b 361 0 360 -6 361 -3 b 359 7 361 3 360 4 l 189 177 b 180 180 186 179 183 180 b 174 177 179 180 176 179 l 4 7 b 0 0 1 4 0 3 b 4 -7 0 -3 1 -6 l 174 -177 b 180 -180 176 -180 179 -180 b 189 -177 183 -180 186 -180 z m 266 26 b 138 -71 266 -12 176 -71 b 96 -50 121 -71 108 -63 b 88 -24 89 -43 88 -32 b 215 73 88 13 177 73 b 266 26 238 73 266 50 z"
        },
        noteheadDiamondBlack: {
            x_min: 0,
            x_max: 250,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 357 -6 b 360 1 359 -4 360 -1 b 357 9 360 4 359 7 l 189 177 b 180 180 187 179 184 180 b 171 177 177 180 173 179 l 3 9 b 0 1 0 6 0 4 b 4 -7 0 -1 1 -4 l 173 -177 b 180 -180 176 -180 177 -180 b 187 -177 181 -180 184 -180 z"
        },
        noteheadParenthesis: {
            x_min: -73,
            x_max: 368,
            y_min: -180,
            y_max: 182,
            ha: 362,
            o: "m 52 -249 b -30 -144 3 -212 -14 -190 b -52 4 -45 -102 -52 -56 b 52 252 -52 118 -36 179 l 46 262 b -105 3 -49 197 -105 124 b 45 -259 -105 -109 -48 -200 z m 382 -259 b 530 3 474 -202 530 -108 b 379 262 530 122 474 200 l 373 252 b 478 4 462 180 478 118 b 456 -144 478 -56 471 -102 b 373 -249 439 -190 422 -212 z"
        },
        noteheadParenthesisRight: {
            x_min: -36,
            x_max: 73,
            y_min: -181,
            y_max: 181,
            ha: 362,
            o: "m -43 -261 b 105 1 49 -203 105 -109 b -46 261 105 121 49 199 l -52 251 b 53 3 37 179 53 117 b 32 -145 53 -58 46 -104 b -52 -251 14 -192 -3 -213 z"
        },
        noteheadParenthesisLeft: {
            x_min: 0,
            x_max: 109,
            y_min: -181,
            y_max: 181,
            ha: 362,
            o: "m 157 -251 b 75 -145 108 -213 91 -192 b 53 3 60 -104 53 -58 b 157 251 53 117 69 177 l 151 261 b 0 1 56 196 0 122 b 150 -261 0 -111 58 -202 z"
        },
        noteheadMoonBlack: {
            x_min: 0,
            x_max: 315,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 228 -180 b 454 0 343 -180 454 -130 l 454 180 l 0 180 l 0 0 b 228 -180 0 -131 112 -180 z"
        },
        noteheadTriangleLeftBlack: {
            x_min: 0,
            x_max: 339,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 488 -180 l 0 180 l 0 -180 z"
        },
        noteheadTriangleRightBlack: {
            x_min: 0,
            x_max: 339,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 488 180 l 0 -180 l 488 -180 z"
        },
        noteheadTriangleRoundDownBlack: {
            x_min: 0,
            x_max: 278,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 200 -180 l 400 112 l 383 124 b 199 180 327 161 264 180 b 16 124 135 180 73 161 l 0 112 z"
        },
        augmentationDot: {
            x_min: 0,
            x_max: 100,
            y_min: -50,
            y_max: 50,
            ha: 100,
            o: "m 144 0 b 72 72 144 40 112 72 b 0 0 32 72 0 40 b 72 -72 0 -40 32 -72 b 144 0 112 -72 144 -40 z"
        },
        tremolo1: {
            x_min: -150,
            x_max: 150,
            y_min: -93,
            y_max: 94,
            ha: 187,
            o: "m 216 -45 l 216 135 l -216 46 l -216 -134 z"
        },
        flag8thUp: {
            x_min: 0,
            x_max: 264,
            y_min: -810,
            y_max: 9,
            ha: 819,
            o: "m 343 -1138 b 380 -888 343 -1138 380 -1001 b 215 -395 380 -708 305 -539 b 58 -19 141 -281 81 -157 b 27 13 53 4 42 13 b 0 -9 12 13 0 9 l 0 -353 b 284 -688 95 -370 232 -566 b 318 -904 305 -737 318 -819 b 284 -1102 318 -969 308 -1037 b 279 -1123 281 -1110 279 -1117 b 302 -1165 279 -1146 294 -1159 b 343 -1138 311 -1171 336 -1162 z"
        },
        flag8thDown: {
            x_min: 0,
            x_max: 306,
            y_min: -14,
            y_max: 808,
            ha: 822,
            o: "m 346 1094 b 376 897 366 1034 376 962 b 318 642 376 812 340 691 b 0 340 265 521 193 405 l 0 1 b 23 -20 0 -13 12 -20 b 58 12 36 -20 55 -12 b 262 387 82 148 189 274 b 441 881 353 530 441 701 b 400 1142 441 994 412 1096 b 377 1164 396 1158 387 1164 b 346 1094 356 1164 331 1136 z"
        },
        flag16thUp: {
            x_min: 0,
            x_max: 279,
            y_min: -813,
            y_max: 2,
            ha: 815,
            o: "m 392 -1146 b 402 -988 397 -1139 402 -1057 l 402 -956 b 360 -783 402 -896 386 -837 b 359 -770 360 -779 359 -776 b 360 -760 359 -768 359 -765 b 396 -577 364 -752 396 -665 b 392 -526 396 -559 395 -543 b 236 -275 377 -428 340 -387 b 53 -16 158 -192 78 -168 b 24 3 50 0 33 3 b 0 -12 16 3 0 -1 l 0 -570 l 7 -570 b 298 -778 96 -573 199 -576 b 344 -992 331 -847 344 -917 b 333 -1120 344 -1034 340 -1077 b 331 -1133 331 -1126 331 -1129 b 363 -1171 331 -1152 343 -1171 b 392 -1146 373 -1171 383 -1165 z m 301 -661 b 223 -562 278 -625 253 -596 b 59 -331 156 -484 89 -449 b 58 -327 58 -330 58 -328 b 78 -312 58 -321 66 -312 l 89 -312 b 302 -464 177 -312 255 -393 b 341 -592 328 -501 341 -546 b 340 -621 341 -602 341 -611 b 330 -658 337 -632 337 -647 b 311 -667 328 -662 318 -667 b 301 -661 307 -667 304 -665 z"
        },
        flag16thDown: {
            x_min: 0,
            x_max: 291,
            y_min: -9,
            y_max: 812,
            ha: 821,
            o: "m 346 1132 b 312 768 367 1011 367 880 b 7 559 213 566 96 562 l 0 559 l 0 1 b 24 -13 0 -6 10 -13 b 53 6 35 -13 50 -10 b 406 516 88 228 372 289 b 410 567 409 531 410 549 b 374 750 410 655 379 742 b 373 760 373 753 373 756 b 374 773 373 766 374 769 b 405 1138 426 881 428 1022 b 370 1169 397 1171 387 1169 b 346 1132 353 1168 341 1156 z m 325 657 b 344 647 333 657 343 652 b 354 611 351 636 351 622 b 356 582 356 600 356 590 b 317 454 356 534 343 491 b 89 302 269 383 177 302 l 78 302 b 58 317 66 302 58 310 b 59 321 58 318 58 320 b 238 552 89 439 170 472 b 315 651 268 585 292 613 b 325 657 318 655 321 657 z"
        },
        flag32ndUp: {
            x_min: 0,
            x_max: 261,
            y_min: -812,
            y_max: 149,
            ha: 961,
            o: "m 374 -969 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 366 -289 369 -315 369 -302 b 220 -58 350 -202 317 -163 b 46 187 148 20 71 43 b 20 215 45 200 35 215 b 0 197 12 215 0 207 l 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 315 -657 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 56 -390 147 -527 88 -495 b 73 -367 53 -380 60 -367 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 z"
        },
        flag32ndDown: {
            x_min: 0,
            x_max: 273,
            y_min: -172,
            y_max: 812,
            ha: 984,
            o: "m 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -229 b 20 -248 0 -242 9 -248 b 48 -219 35 -248 46 -232 b 229 36 72 -69 154 -46 b 380 278 330 145 364 186 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 356 783 356 782 356 783 l 351 791 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z m 330 350 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 z"
        },
        flag64thUp: {
            x_min: 0,
            x_max: 261,
            y_min: -812,
            y_max: 347,
            ha: 1159,
            o: "m 374 -969 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 337 -203 369 -287 359 -242 b 369 -43 350 -167 369 -104 b 366 -4 369 -30 367 -17 b 220 228 350 84 317 122 b 46 472 148 305 71 328 b 20 500 45 485 32 500 b 0 482 10 500 0 492 l 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 z m 300 24 b 321 -45 315 -4 321 -26 b 317 -75 321 -56 318 -65 l 298 -145 b 220 -58 278 -121 253 -94 b 58 187 148 20 82 43 b 56 193 58 189 58 192 b 300 24 138 193 220 157 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 315 -657 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 55 -386 147 -527 84 -497 b 73 -367 52 -376 63 -367 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 z"
        },
        flag64thDown: {
            x_min: 0,
            x_max: 273,
            y_min: -376,
            y_max: 812,
            ha: 1188,
            o: "m 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -523 b 20 -541 0 -534 9 -541 b 48 -513 35 -541 46 -526 b 229 -258 72 -363 154 -340 b 380 -16 330 -148 364 -108 b 384 27 383 -1 384 13 b 351 189 384 88 366 151 b 380 278 366 216 374 243 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 356 783 356 782 356 783 l 351 791 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z m 330 350 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 z m 330 56 b 334 26 331 46 334 37 b 311 -46 334 7 328 -16 b 56 -222 229 -184 137 -222 b 229 36 75 -86 145 -55 b 311 128 264 73 289 102 z"
        },
        flag128thUp: {
            x_min: 0,
            x_max: 261,
            y_min: -812,
            y_max: 533,
            ha: 1345,
            o: "m 374 -969 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 337 -203 369 -287 359 -242 b 369 -43 350 -167 369 -104 b 366 -4 369 -30 367 -17 b 341 75 360 26 353 50 b 369 222 354 111 369 167 b 366 264 369 236 369 251 b 220 495 350 351 317 390 b 46 740 148 573 71 596 b 22 768 45 753 35 768 b 0 750 10 768 0 760 l 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 z m 300 292 b 321 223 315 264 321 242 b 317 193 321 212 318 203 b 301 135 314 180 308 158 b 220 228 281 161 255 190 b 55 461 151 304 79 327 b 300 292 134 461 220 426 z m 300 24 b 321 -45 315 -4 321 -26 b 317 -75 321 -56 318 -65 l 298 -145 b 220 -58 278 -121 253 -94 b 56 187 148 20 81 43 b 55 193 56 189 56 192 b 300 24 137 193 220 157 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 315 -657 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 55 -386 147 -527 84 -497 b 73 -367 53 -376 62 -367 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 z"
        },
        flag128thDown: {
            x_min: 0,
            x_max: 273,
            y_min: -580,
            y_max: 812,
            ha: 1392,
            o: "m 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -816 b 20 -835 0 -828 7 -835 b 48 -806 33 -835 46 -819 b 229 -552 72 -657 154 -634 b 380 -310 330 -442 364 -402 b 384 -266 383 -295 384 -281 b 351 -105 384 -206 366 -143 b 384 27 372 -66 384 -16 b 351 189 384 88 366 151 b 380 278 366 216 374 243 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 356 783 356 782 356 783 l 351 791 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z m 330 350 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 z m 330 56 b 334 26 331 46 334 37 b 311 -46 334 7 328 -16 b 56 -222 229 -184 137 -222 b 229 36 75 -86 145 -55 b 311 128 264 73 289 102 z m 330 -238 b 334 -268 331 -248 334 -256 b 311 -340 334 -287 328 -310 b 56 -516 229 -478 137 -516 b 229 -258 75 -380 145 -348 b 311 -166 264 -220 289 -192 z"
        },
        accidentalFlat: {
            x_min: 0,
            x_max: 226,
            y_min: -175,
            y_max: 439,
            ha: 614,
            o: "m 17 -245 b 30 -252 22 -251 26 -252 b 39 -249 35 -252 39 -249 b 153 -161 82 -225 117 -186 b 325 82 281 -72 325 16 b 196 220 325 164 262 216 b 117 196 171 220 137 209 b 85 176 108 189 92 176 b 78 177 82 176 81 176 b 62 202 68 181 62 192 b 72 608 63 233 72 579 b 45 632 72 624 59 632 b 0 592 24 632 1 618 b 17 -245 0 592 6 -230 z m 68 -117 b 63 27 68 -117 63 -30 b 66 73 63 50 65 68 b 167 144 76 102 134 144 b 226 60 209 144 226 96 b 98 -134 226 -17 160 -95 b 84 -138 92 -137 88 -138 b 68 -117 71 -138 68 -124 z"
        },
        accidentalNatural: {
            x_min: 0,
            x_max: 168,
            y_min: -335,
            y_max: 341,
            ha: 676,
            o: "m 203 261 b 197 259 200 261 199 259 b 68 226 197 259 105 226 b 53 233 59 226 53 228 l 53 474 b 36 491 53 484 45 491 l 17 491 b 0 474 7 491 0 484 l 0 -268 b 13 -281 0 -276 4 -281 l 16 -279 b 22 -278 17 -279 20 -279 b 164 -235 42 -269 122 -235 b 189 -251 179 -235 189 -239 l 189 -465 b 206 -482 189 -475 196 -482 l 225 -482 b 242 -465 233 -482 242 -475 l 242 258 b 230 269 242 265 236 269 b 225 268 229 269 226 269 z m 53 56 b 176 114 53 76 141 114 b 189 107 184 114 189 112 l 189 -42 b 71 -101 189 -68 107 -101 b 53 -92 60 -101 53 -98 z"
        },
        accidentalSharp: {
            x_min: 0,
            x_max: 249,
            y_min: -348,
            y_max: 350,
            ha: 698,
            o: "m 341 170 b 359 194 351 174 359 186 l 359 297 b 348 308 359 304 354 308 b 341 307 346 308 344 308 b 305 294 341 307 312 295 b 285 312 295 294 285 301 l 285 488 b 265 504 285 497 276 504 b 242 488 251 504 242 497 l 242 301 b 223 259 240 287 236 268 b 132 223 206 249 157 229 b 115 252 120 223 115 240 l 115 425 b 95 441 115 433 105 441 b 72 425 81 441 72 433 l 72 230 b 55 192 72 210 63 196 b 17 176 46 187 17 176 b 0 153 7 173 0 161 l 0 50 b 13 37 0 42 4 37 l 16 39 b 50 53 17 39 39 48 l 52 55 b 72 29 63 55 72 40 l 72 -114 b 56 -147 72 -130 65 -143 b 17 -163 48 -150 17 -163 b 0 -186 7 -166 0 -177 l 0 -288 b 13 -301 0 -297 4 -301 l 16 -300 b 50 -287 17 -300 37 -291 b 55 -285 52 -285 53 -285 b 72 -308 65 -285 72 -301 l 72 -485 b 91 -501 72 -494 81 -501 b 115 -485 105 -501 115 -494 l 115 -285 b 130 -253 115 -266 122 -256 l 217 -217 b 219 -217 217 -217 219 -217 l 222 -216 b 242 -242 235 -216 242 -233 l 242 -422 b 261 -438 242 -431 251 -438 b 285 -422 276 -438 285 -431 l 285 -217 b 301 -184 285 -206 291 -189 b 341 -168 311 -180 341 -168 b 359 -144 351 -164 359 -153 l 359 -42 b 348 -30 359 -35 354 -30 b 341 -32 346 -30 344 -30 l 304 -46 b 285 -20 295 -46 285 -37 l 285 114 b 304 156 285 124 292 151 z m 242 -65 b 132 -122 233 -94 166 -122 b 115 -115 124 -122 117 -120 b 111 -43 112 -109 111 -78 b 115 63 111 1 112 52 b 220 118 118 88 184 118 b 242 109 230 118 239 115 b 248 27 245 102 248 66 b 242 -65 248 -12 245 -52 z"
        },
        accidentalDoubleSharp: {
            x_min: 0,
            x_max: 247,
            y_min: -125,
            y_max: 127,
            ha: 252,
            o: "m 274 -46 b 206 1 258 -37 206 -9 b 274 50 206 22 253 43 b 278 50 275 50 276 50 l 287 49 b 346 63 304 49 331 52 b 356 115 353 71 356 92 b 292 183 356 174 351 183 b 233 173 266 183 240 180 b 226 117 228 168 226 143 b 179 49 219 101 196 49 b 130 117 158 49 135 96 b 118 173 130 141 125 167 b 66 183 112 180 89 183 b 7 173 42 183 16 180 b 0 120 3 170 0 145 b 7 63 0 94 3 68 b 68 49 17 55 43 49 b 82 50 73 49 78 50 b 150 3 98 42 150 13 b 84 -46 150 -16 104 -39 l 69 -46 b 7 -56 43 -46 16 -49 b 0 -111 3 -60 0 -85 b 7 -166 0 -137 3 -163 b 65 -180 17 -174 40 -180 b 118 -166 86 -180 109 -176 b 130 -111 127 -158 130 -134 b 132 -105 130 -109 131 -107 b 177 -45 141 -85 158 -45 b 226 -111 196 -45 220 -91 b 233 -166 226 -137 228 -161 b 291 -180 243 -174 266 -180 b 356 -114 346 -180 356 -166 b 346 -56 356 -89 351 -63 b 288 -46 338 -49 312 -46 z"
        },
        accidentalDoubleFlat: {
            x_min: 0,
            x_max: 411,
            y_min: -175,
            y_max: 437,
            ha: 612,
            o: "m 452 217 b 384 194 426 217 408 207 b 350 176 374 189 363 176 b 343 177 347 176 344 176 b 328 202 333 180 328 190 b 337 606 328 232 337 579 b 310 629 337 622 324 629 b 265 592 291 629 268 616 b 269 194 265 592 266 395 b 196 217 248 209 223 217 l 187 217 b 120 194 160 217 143 207 b 85 176 108 189 98 176 b 78 177 82 176 81 176 b 62 202 68 180 62 190 b 72 606 62 232 72 579 b 45 629 72 622 59 629 b 0 592 24 629 1 616 b 17 -245 0 592 7 -232 b 30 -252 22 -251 26 -252 b 39 -249 35 -252 39 -249 b 153 -161 84 -226 120 -186 b 274 -50 206 -124 246 -85 b 284 -245 276 -158 279 -240 b 295 -252 288 -251 292 -252 b 304 -249 300 -252 304 -249 b 416 -163 348 -226 383 -186 b 592 82 546 -72 592 16 b 461 217 592 163 528 216 z m 96 -134 b 84 -138 92 -137 86 -138 b 68 -115 72 -138 68 -124 b 63 26 68 -115 63 -30 b 66 72 63 49 65 66 b 168 144 75 101 134 144 b 226 59 212 144 226 95 b 96 -134 226 -22 161 -94 z m 361 -134 b 348 -138 356 -137 351 -138 b 333 -115 337 -138 333 -124 b 328 39 333 -115 328 -16 b 330 72 328 55 328 68 b 433 144 338 101 399 144 b 468 130 448 144 459 140 b 490 59 481 112 490 88 b 361 -134 490 -22 426 -94 z"
        },
        accidentalParensLeft: {
            x_min: 0,
            x_max: 141,
            y_min: -248,
            y_max: 247,
            ha: 495,
            o: "m 203 331 l 203 351 b 202 356 203 354 203 356 b 0 0 60 281 0 140 b 199 -357 0 -144 60 -269 b 203 -354 200 -357 203 -356 l 203 -333 b 200 -327 203 -330 202 -328 b 86 0 118 -253 86 -160 b 200 324 86 158 120 251 b 203 331 202 325 203 327 z"
        },
        accidentalParensRight: {
            x_min: 0,
            x_max: 141,
            y_min: -248,
            y_max: 247,
            ha: 495,
            o: "m 0 331 b 3 324 0 327 1 325 b 117 0 84 251 117 158 b 3 -327 117 -160 85 -253 b 0 -333 1 -328 0 -330 l 0 -354 b 4 -357 0 -356 3 -357 b 203 0 143 -269 203 -144 b 1 356 203 140 143 281 b 0 351 0 356 0 354 z"
        },
        accidentalQuarterToneFlatStein: {
            x_min: 1,
            x_max: 227,
            y_min: -175,
            y_max: 439,
            ha: 614,
            o: "m 310 -245 b 327 592 321 -230 327 592 b 282 632 325 618 302 632 b 255 608 268 632 255 624 b 265 202 255 579 264 233 b 249 177 265 192 259 181 b 242 176 246 176 245 176 b 210 196 235 176 219 189 b 131 220 190 209 156 220 b 1 85 65 216 1 164 b 174 -161 1 16 46 -72 b 288 -249 210 -186 245 -225 b 297 -252 288 -249 292 -252 b 310 -245 301 -252 305 -251 z m 259 -117 b 243 -138 259 -124 256 -138 b 229 -134 239 -138 235 -137 b 101 60 167 -95 101 -17 b 160 144 101 96 118 144 b 261 73 193 144 251 102 b 264 27 262 68 264 50 b 259 -117 264 -30 259 -117 z"
        },
        accidentalThreeQuarterTonesFlatZimmermann: {
            x_min: 1,
            x_max: 466,
            y_min: -175,
            y_max: 439,
            ha: 614,
            o: "m 363 -245 b 376 -252 367 -251 372 -252 b 384 -249 380 -252 384 -249 b 497 -161 428 -226 464 -186 b 671 84 625 -72 671 16 b 541 220 671 164 606 217 b 513 217 531 220 523 219 b 464 196 495 212 480 206 b 431 176 452 189 442 176 b 423 177 428 176 426 176 b 408 202 413 180 408 190 l 419 608 b 392 632 419 625 406 632 b 346 592 372 632 347 618 b 363 -245 346 592 351 -230 z m 289 -249 b 297 -252 289 -249 292 -252 b 310 -245 300 -252 305 -251 b 328 592 321 -230 328 592 b 282 631 327 618 302 631 b 255 608 268 631 255 624 l 266 202 b 251 177 266 190 261 180 b 243 176 248 176 246 176 b 210 196 232 176 222 189 b 164 216 196 204 180 210 l 163 217 b 132 220 151 219 143 220 b 1 84 65 217 1 163 b 177 -163 1 16 48 -72 b 289 -249 210 -186 245 -226 z m 262 72 b 265 26 264 66 265 49 b 261 -115 265 -30 261 -115 b 245 -138 261 -124 258 -138 b 230 -134 240 -138 236 -137 b 102 60 166 -92 102 -20 b 124 128 102 88 111 112 b 161 144 134 138 147 144 b 199 134 173 144 184 141 b 262 72 219 122 256 92 z m 413 -115 b 409 26 413 -115 409 -30 b 412 72 409 49 410 66 b 514 144 420 102 480 144 b 570 60 557 144 570 96 b 442 -134 570 -23 508 -91 b 429 -138 436 -137 433 -138 b 413 -115 418 -138 413 -124 z"
        },
        accidentalQuarterToneSharpStein: {
            x_min: 0,
            x_max: 179,
            y_min: -353,
            y_max: 307,
            ha: 660,
            o: "m 258 240 b 246 252 258 248 252 252 b 240 251 245 252 242 252 b 168 225 240 251 171 225 b 150 253 156 225 150 240 l 150 426 b 130 442 150 435 141 442 b 105 418 108 442 105 429 l 105 230 b 91 193 105 219 101 202 b 17 161 65 183 42 171 b 0 138 9 158 0 147 l 0 36 b 13 23 0 27 4 23 l 16 24 b 86 53 17 24 73 49 l 88 55 b 107 30 98 55 107 42 l 107 -114 b 92 -145 107 -130 101 -143 l 17 -177 b 0 -200 9 -180 0 -192 l 0 -302 b 13 -315 0 -311 4 -315 l 16 -314 b 85 -285 17 -314 72 -291 b 105 -312 92 -282 105 -301 l 105 -492 b 125 -508 105 -501 114 -508 b 150 -484 147 -508 150 -498 l 150 -285 b 151 -274 150 -281 150 -278 b 164 -253 153 -265 158 -256 b 240 -225 176 -251 240 -225 b 258 -202 249 -222 258 -210 l 258 -99 b 245 -86 258 -91 253 -86 l 242 -88 b 240 -88 242 -88 240 -88 l 240 -86 b 168 -115 240 -86 174 -114 b 148 -91 158 -115 148 -107 l 148 43 b 167 85 148 55 156 81 b 240 114 180 91 240 114 b 258 138 249 118 258 128 z"
        },
        accidentalThreeQuarterTonesSharpStein: {
            x_min: 3,
            x_max: 317,
            y_min: -347,
            y_max: 369,
            ha: 716,
            o: "m 456 324 b 448 336 456 330 454 336 b 393 317 445 336 400 320 b 389 315 392 315 390 315 b 383 325 386 315 383 318 l 383 508 b 360 531 383 528 379 531 b 337 508 341 531 337 527 l 337 318 b 325 291 337 300 334 294 b 268 268 320 288 287 276 b 253 281 256 268 253 274 l 253 464 b 230 487 253 484 249 487 b 207 464 212 487 207 482 l 207 264 b 194 240 207 253 204 245 l 132 217 b 131 217 132 217 132 217 l 130 216 b 118 229 122 216 118 220 l 118 420 b 95 444 118 439 114 444 b 72 420 76 444 72 439 l 72 212 b 60 190 72 197 68 193 l 16 173 b 4 161 9 170 4 167 l 4 50 b 13 39 4 45 9 39 b 58 55 16 39 46 49 b 63 56 60 56 62 56 b 72 42 71 56 72 50 l 72 -125 b 58 -150 72 -137 65 -147 l 16 -166 b 4 -177 9 -168 4 -171 l 4 -289 b 14 -301 4 -295 9 -301 b 53 -287 16 -301 40 -291 b 62 -285 56 -285 59 -285 b 72 -298 69 -285 72 -289 l 72 -477 b 95 -500 72 -495 76 -500 b 118 -477 114 -500 118 -495 l 118 -278 b 127 -259 118 -269 121 -261 l 196 -232 b 207 -243 204 -232 207 -235 l 207 -432 b 230 -455 207 -452 212 -455 b 253 -432 249 -455 253 -451 l 253 -228 b 268 -204 253 -216 259 -207 l 320 -186 b 328 -183 323 -184 325 -183 b 337 -194 334 -183 337 -187 l 337 -387 b 360 -410 337 -408 341 -410 b 383 -387 379 -410 383 -406 l 383 -174 b 395 -157 383 -166 390 -158 l 445 -138 b 456 -127 452 -135 456 -132 l 456 -14 b 448 -3 456 -10 454 -3 b 397 -22 445 -3 408 -17 l 396 -23 b 383 -6 387 -23 383 -16 l 383 163 b 392 181 383 173 384 179 b 445 202 397 183 445 202 b 456 213 452 203 456 207 z m 337 -45 b 266 -78 333 -56 287 -78 b 258 -75 262 -78 259 -76 b 253 19 255 -71 253 -27 b 258 130 253 69 255 122 b 333 163 264 141 315 163 b 337 161 334 163 337 161 b 341 78 340 157 341 120 b 337 -45 341 24 340 -37 z m 118 -127 b 114 -48 114 -121 114 -86 b 118 78 114 6 115 68 b 200 114 122 91 180 114 b 207 111 204 114 206 112 b 212 22 210 107 212 66 b 207 -94 212 -29 210 -85 b 127 -130 203 -108 148 -130 b 118 -127 122 -130 120 -128 z"
        },
        accidentalBuyukMucennebFlat: {
            x_min: 1,
            x_max: 287,
            y_min: -174,
            y_max: 438,
            ha: 612,
            o: "m 379 452 b 370 464 379 458 377 464 b 164 389 366 464 170 392 b 156 396 163 389 156 393 b 157 436 157 409 157 428 b 167 452 157 445 161 449 b 366 526 173 455 366 526 b 379 540 374 528 379 534 l 379 611 b 370 622 379 616 377 622 b 170 550 366 622 174 552 b 160 557 163 550 160 554 b 161 608 160 585 161 602 b 134 631 161 624 148 631 b 89 590 114 631 91 616 l 89 528 b 81 517 89 526 88 518 b 16 491 76 514 16 491 b 1 480 6 490 1 485 l 1 406 b 13 395 1 400 4 395 l 14 396 b 79 419 16 396 72 415 b 89 412 86 419 89 415 b 91 376 89 399 89 386 b 82 359 91 364 89 361 b 16 331 76 356 16 331 b 1 321 6 331 1 328 l 1 248 b 13 236 1 242 4 236 b 79 262 16 236 71 258 b 92 251 89 262 92 256 b 107 -242 95 23 101 -236 b 120 -251 111 -249 115 -251 b 128 -248 124 -251 128 -248 b 240 -160 171 -225 207 -184 b 413 84 367 -71 413 16 b 284 220 413 166 350 216 b 207 196 259 220 229 209 b 170 176 196 190 184 176 l 168 177 b 151 203 157 181 151 192 b 153 269 151 210 151 236 b 163 292 153 275 153 289 b 366 367 173 297 366 367 b 379 383 374 370 379 376 z m 186 -132 b 173 -137 180 -135 176 -137 b 157 -114 161 -137 157 -122 b 153 35 157 -114 153 -22 b 154 73 153 53 153 68 b 219 135 160 92 197 124 b 255 144 232 141 243 144 b 292 130 269 144 282 140 b 314 62 305 114 314 91 b 186 -132 314 -17 251 -94 z"
        },
        accidentalBuyukMucennebSharp: {
            x_min: 0,
            x_max: 341,
            y_min: -350,
            y_max: 348,
            ha: 698,
            o: "m 403 167 b 420 192 413 171 420 183 l 420 294 b 410 305 420 301 416 305 b 403 304 408 305 406 305 b 367 291 403 304 374 292 b 347 310 357 291 347 298 l 347 485 b 327 501 347 494 338 501 b 304 485 312 501 304 494 l 304 298 b 285 256 302 284 298 265 b 194 220 268 246 219 226 b 177 249 181 220 177 238 l 177 422 b 157 438 177 431 167 438 b 134 422 143 438 134 431 l 134 228 b 117 189 134 207 125 193 b 79 173 108 184 79 173 b 62 150 69 170 62 158 l 62 48 b 75 35 62 39 66 35 l 78 36 b 111 50 79 36 101 45 b 127 55 117 52 122 55 b 132 50 130 55 132 53 l 132 29 b 128 22 132 26 132 23 b 17 -20 125 20 17 -20 b 0 -35 7 -23 0 -26 l 0 -130 b 13 -144 0 -137 4 -144 b 127 -104 17 -144 120 -107 l 128 -102 b 134 -109 134 -102 134 -107 l 134 -127 b 122 -147 134 -138 132 -143 b 79 -166 114 -151 79 -166 b 62 -189 69 -168 62 -180 l 62 -291 b 75 -304 62 -300 66 -304 l 78 -302 b 112 -289 79 -302 99 -294 b 117 -288 114 -288 115 -288 b 134 -311 127 -288 134 -304 l 134 -488 b 153 -504 134 -497 143 -504 b 177 -488 167 -504 177 -497 l 177 -288 b 192 -256 177 -269 184 -259 l 279 -220 b 281 -220 279 -220 281 -220 l 284 -219 b 304 -245 297 -219 304 -236 l 304 -425 b 323 -441 304 -433 312 -441 b 347 -425 338 -441 347 -433 l 347 -220 b 363 -187 347 -209 353 -192 b 403 -171 373 -183 403 -171 b 420 -147 413 -167 420 -156 l 420 -45 b 410 -33 420 -37 416 -33 b 403 -35 408 -33 406 -33 l 366 -49 b 353 -53 360 -52 356 -53 b 347 -40 348 -53 347 -49 l 347 -26 b 351 -19 347 -23 347 -20 l 474 27 b 491 46 485 30 491 37 l 491 137 b 478 153 491 143 488 153 l 475 150 b 474 150 475 150 474 150 l 474 151 b 351 105 474 151 354 107 b 347 109 348 105 347 107 b 346 128 347 117 346 127 b 366 153 346 143 348 145 z m 177 72 b 301 122 196 89 262 122 b 305 111 305 122 305 117 b 307 94 305 105 305 96 b 304 88 307 92 307 89 b 179 40 284 81 180 42 b 174 43 177 40 174 42 b 177 72 176 50 174 69 z m 305 -65 b 184 -121 301 -85 210 -121 b 177 -118 180 -121 179 -120 b 173 -92 174 -115 174 -105 b 179 -84 173 -86 174 -85 b 302 -37 180 -84 279 -46 b 307 -42 304 -37 307 -40 b 305 -65 307 -52 307 -59 z"
        },
        accidentalBakiyeFlat: {
            x_min: -1,
            x_max: 286,
            y_min: -175,
            y_max: 439,
            ha: 614,
            o: "m 377 454 b 369 467 377 458 376 467 b 363 465 367 467 364 467 b 161 390 363 465 167 393 b 153 399 154 390 153 395 b 157 608 154 494 157 593 b 130 632 157 624 144 632 b 86 592 111 632 88 618 b 88 377 86 592 86 501 b 76 356 88 373 88 360 l 12 331 b -1 320 3 330 -1 327 l -1 248 b 9 236 -1 242 1 236 b 81 264 12 236 78 261 b 89 258 86 264 89 261 b 104 -245 92 30 96 -236 b 115 -252 108 -251 112 -252 b 124 -249 120 -252 124 -249 b 239 -161 167 -226 203 -186 b 412 84 367 -72 412 17 b 282 220 412 166 348 216 b 255 216 274 220 264 219 b 203 196 238 212 222 206 b 171 177 193 189 177 177 b 163 179 168 177 166 177 b 147 202 153 181 147 192 b 147 216 147 204 147 209 l 150 262 b 150 276 150 269 150 275 b 158 291 150 287 154 289 b 363 370 163 292 363 370 b 377 384 373 373 377 379 z m 181 -134 b 167 -138 176 -137 171 -138 b 153 -117 156 -138 153 -125 b 148 27 153 -117 148 -30 b 151 73 148 50 150 68 b 255 144 161 105 219 144 b 312 62 298 144 312 99 b 181 -134 312 -19 249 -96 z"
        },
        accidentalKomaSharp: {
            x_min: 0,
            x_max: 229,
            y_min: -337,
            y_max: 322,
            ha: 659,
            o: "m 312 151 b 330 176 323 156 330 166 l 330 278 b 320 289 330 285 327 289 b 312 288 318 289 315 289 b 200 246 312 288 203 248 b 181 275 187 246 181 264 l 181 448 b 163 464 181 456 173 464 b 138 441 140 464 138 452 l 138 253 b 122 215 137 240 132 225 b 17 177 92 203 45 177 b 0 153 7 173 0 163 l 0 50 b 10 39 0 43 4 39 b 17 40 13 39 14 39 l 128 81 b 138 52 138 81 138 63 l 138 -91 b 124 -124 138 -107 132 -120 b 17 -167 115 -127 17 -167 b 0 -192 7 -171 0 -181 l 0 -294 b 10 -305 0 -301 4 -305 b 17 -304 13 -305 14 -305 b 128 -261 17 -304 117 -264 l 130 -259 b 138 -276 137 -259 138 -268 l 138 -469 b 157 -485 138 -478 147 -485 b 181 -462 179 -485 181 -475 l 181 -262 b 183 -252 181 -258 181 -255 b 197 -232 186 -243 190 -235 b 312 -187 207 -228 312 -187 b 330 -163 323 -183 330 -173 l 330 -60 b 320 -49 330 -53 327 -49 b 312 -50 318 -49 315 -49 l 200 -94 b 193 -95 197 -95 194 -95 b 181 -68 183 -95 181 -85 l 181 66 b 200 108 181 92 189 104 z"
        },
        accidentalKucukMucennebSharp: {
            x_min: -1,
            x_max: 339,
            y_min: -338,
            y_max: 321,
            ha: 659,
            o: "m 264 92 b 271 102 264 98 265 99 l 395 150 b 412 174 405 154 412 164 l 412 276 b 402 288 412 284 409 288 b 395 287 400 288 397 288 b 282 245 395 287 285 246 b 264 274 269 245 264 262 l 264 446 b 245 462 264 455 255 462 b 220 439 222 462 220 451 l 220 252 b 204 213 219 239 215 223 b 99 176 174 202 127 176 b 82 151 89 171 82 161 l 82 49 b 92 37 82 42 86 37 b 99 39 95 37 96 37 l 210 79 b 216 81 212 81 215 81 b 220 78 219 81 220 79 l 220 56 b 216 46 220 52 220 48 b 16 -29 210 45 16 -29 b -1 -45 4 -32 -1 -36 l -1 -138 b 12 -154 -1 -145 3 -154 l 215 -79 b 220 -84 219 -79 220 -81 l 220 -105 b 210 -122 220 -115 219 -120 b 99 -168 202 -127 99 -168 b 82 -193 89 -173 82 -183 l 82 -295 b 92 -307 82 -302 86 -307 b 99 -305 95 -307 96 -307 b 210 -262 99 -305 199 -265 l 212 -261 b 220 -278 219 -261 220 -269 l 220 -471 b 239 -487 220 -480 229 -487 b 264 -464 261 -487 264 -477 l 264 -264 b 265 -253 264 -259 264 -256 b 279 -233 268 -245 272 -236 b 395 -189 289 -229 395 -189 b 412 -164 405 -184 412 -174 l 412 -62 b 402 -50 412 -55 409 -50 b 395 -52 400 -50 397 -50 l 278 -96 b 264 -86 268 -96 264 -94 l 264 -68 b 269 -59 264 -62 265 -60 b 471 17 274 -58 471 17 b 488 36 484 22 488 27 l 488 127 b 475 144 488 134 487 144 l 472 141 b 471 141 472 141 471 141 l 471 143 b 272 68 471 143 282 71 l 269 66 b 264 71 264 66 264 69 z"
        },
        accidentalKoron: {
            x_min: 0,
            x_max: 300,
            y_min: -472,
            y_max: 157,
            ha: 629,
            o: "m 432 -4 b 415 10 432 1 418 9 l 4 226 b 0 223 1 226 0 225 l 0 -672 b 7 -680 0 -677 3 -680 l 45 -680 b 52 -672 49 -680 52 -677 l 52 -193 l 415 -22 b 432 -4 418 -20 432 -13 z m 52 -137 l 52 144 l 327 -7 z"
        },
        accidentalSori: {
            x_min: 0,
            x_max: 421,
            y_min: -318,
            y_max: 328,
            ha: 646,
            o: "m 606 10 b 589 23 606 16 592 22 l 382 109 l 382 465 b 374 472 382 469 379 472 l 337 472 b 330 465 333 472 330 469 l 330 132 l 183 194 l 183 425 b 176 432 183 429 180 432 l 138 432 b 131 425 134 432 131 429 l 131 216 l 3 269 b 0 265 0 269 0 266 l 0 223 b 3 213 0 216 0 215 l 131 160 l 131 -150 l 3 -203 b 0 -212 0 -204 0 -206 l 0 -255 b 3 -259 0 -258 1 -259 l 131 -204 l 131 -451 b 138 -458 131 -455 134 -458 l 176 -458 b 183 -451 180 -458 183 -455 l 183 -183 l 330 -120 l 330 -410 b 337 -418 330 -415 333 -418 l 374 -418 b 382 -410 379 -418 382 -415 l 382 -98 l 589 -9 b 606 10 592 -9 606 0 z m 183 -128 l 183 138 l 330 76 l 330 -66 z m 382 -45 l 382 55 l 501 6 z"
        },
        articAccentAbove: {
            x_min: 0,
            x_max: 339,
            y_min: 1,
            y_max: 245,
            ha: 244,
            o: "m 469 151 b 488 177 488 156 488 166 b 469 203 488 189 488 197 l 37 350 b 24 353 32 351 26 353 b 3 333 12 353 7 344 b 0 318 1 327 0 323 b 20 298 0 311 4 304 b 346 187 20 298 331 193 b 356 177 353 186 356 181 b 344 167 356 173 353 170 b 20 58 328 163 20 58 b 0 36 4 50 0 43 b 3 23 0 32 1 27 b 23 1 7 13 13 1 b 29 3 24 1 27 1 z"
        },
        articAccentBelow: {
            x_min: 0,
            x_max: 339,
            y_min: -244,
            y_max: 0,
            ha: 244,
            o: "m 469 -202 b 488 -176 488 -197 488 -187 b 469 -150 488 -164 488 -156 l 37 -3 b 24 0 32 -1 26 0 b 3 -20 12 0 7 -9 b 0 -35 1 -26 0 -30 b 20 -55 0 -42 4 -49 b 346 -166 20 -55 331 -160 b 356 -176 353 -167 356 -171 b 344 -186 356 -180 353 -183 b 20 -295 328 -190 20 -295 b 0 -317 4 -302 0 -310 b 3 -330 0 -321 1 -325 b 23 -351 7 -340 13 -351 b 29 -350 24 -351 27 -351 z"
        },
        articTenutoAbove: {
            x_min: -1,
            x_max: 338,
            y_min: 0,
            y_max: 48,
            ha: 48,
            o: "m 452 0 b 487 35 485 0 487 16 b 452 69 487 53 487 69 l 33 69 b -1 35 -1 69 -1 53 b 33 0 -1 16 -1 0 z"
        },
        articTenutoBelow: {
            x_min: -1,
            x_max: 338,
            y_min: -48,
            y_max: 0,
            ha: 48,
            o: "m 452 -69 b 487 -35 485 -69 487 -53 b 452 0 487 -16 487 0 l 33 0 b -1 -35 -1 0 -1 -16 b 33 -69 -1 -53 -1 -69 z"
        },
        articStaccatoAbove: {
            x_min: 0,
            x_max: 84,
            y_min: 0,
            y_max: 84,
            ha: 84,
            o: "m 121 60 b 60 121 121 94 94 121 b 0 60 27 121 0 94 b 60 0 0 27 27 0 b 121 60 94 0 121 27 z"
        },
        articStaccatoBelow: {
            x_min: 0,
            x_max: 84,
            y_min: -84,
            y_max: 0,
            ha: 84,
            o: "m 121 -60 b 60 0 121 -27 94 0 b 0 -60 27 0 0 -27 b 60 -121 0 -94 27 -121 b 121 -60 94 -121 121 -94 z"
        },
        articStaccatissimoAbove: {
            x_min: 1,
            x_max: 100,
            y_min: -2,
            y_max: 293,
            ha: 295,
            o: "m 72 422 b 1 390 35 422 3 409 b 72 -3 1 369 39 -3 b 144 389 108 -3 144 356 b 72 422 144 410 111 422 z"
        },
        articStaccatissimoBelow: {
            x_min: 1,
            x_max: 100,
            y_min: -295,
            y_max: 0,
            ha: 295,
            o: "m 72 -425 b 144 -392 111 -425 144 -413 b 72 0 144 -359 108 0 b 1 -393 39 0 1 -372 b 72 -425 3 -412 35 -425 z"
        },
        articMarcatoAbove: {
            x_min: -1,
            x_max: 235,
            y_min: -1,
            y_max: 253,
            ha: 254,
            o: "m 181 356 b 167 364 177 361 173 364 b 153 356 157 364 153 356 l 0 23 b -1 16 -1 20 -1 19 b 9 0 -1 9 1 1 b 16 -1 10 -1 14 -1 b 32 9 22 -1 29 1 b 112 186 32 9 109 180 b 118 190 114 189 115 190 b 127 186 121 190 124 189 b 209 9 128 180 209 9 b 225 0 213 3 219 0 l 323 0 b 338 16 333 1 338 7 b 337 23 338 19 338 22 z"
        },
        articMarcatoBelow: {
            x_min: -1,
            x_max: 235,
            y_min: -254,
            y_max: 0,
            ha: 254,
            o: "m 156 -357 b 170 -366 160 -363 164 -366 b 184 -357 180 -366 184 -357 l 337 -24 b 338 -17 338 -22 338 -20 b 328 -1 338 -10 336 -3 b 321 0 327 0 323 0 b 305 -10 315 0 308 -3 b 225 -187 305 -10 228 -181 b 219 -192 223 -190 222 -192 b 210 -187 216 -192 213 -190 b 128 -10 209 -181 128 -10 b 112 -1 124 -4 118 -1 l 14 -1 b -1 -17 4 -3 -1 -9 b 0 -24 -1 -20 -1 -23 z"
        },
        fermataAbove: {
            x_min: 3,
            x_max: 605,
            y_min: -3,
            y_max: 329,
            ha: 332,
            o: "m 435 318 b 818 36 742 318 804 91 b 821 26 819 32 819 27 b 851 -4 831 6 837 -4 b 871 16 864 -4 871 1 b 870 30 871 20 871 24 b 438 474 780 471 480 474 b 6 30 392 474 94 471 b 4 14 4 24 4 19 b 23 -4 4 0 12 -4 b 52 26 36 -4 43 6 b 56 39 53 27 55 33 b 435 318 73 98 138 318 z m 516 75 b 436 153 516 117 480 153 b 359 75 395 153 359 117 b 436 -4 359 32 395 -4 b 516 75 480 -4 516 32 z"
        },
        fermataBelow: {
            x_min: 3,
            x_max: 605,
            y_min: -332,
            y_max: 0,
            ha: 332,
            o: "m 435 -323 b 56 -43 138 -323 73 -102 b 52 -30 55 -37 53 -32 b 23 0 43 -10 36 0 b 4 -19 12 0 4 -4 b 6 -35 4 -23 4 -29 b 438 -478 94 -475 392 -478 b 870 -35 480 -478 780 -475 b 871 -20 871 -29 871 -24 b 851 0 871 -6 864 0 b 821 -30 837 0 831 -10 b 818 -40 819 -32 819 -36 b 435 -323 804 -95 742 -323 z m 516 -79 b 436 0 516 -36 480 0 b 359 -79 395 0 359 -36 b 436 -157 359 -121 395 -157 b 516 -79 480 -157 516 -121 z"
        },
        fermataLongAbove: {
            x_min: 0,
            x_max: 603,
            y_min: -1,
            y_max: 333,
            ha: 334,
            o: "m 72 480 b 0 441 32 480 0 462 l 0 19 b 35 0 0 9 16 0 b 71 19 55 0 71 9 l 71 289 b 433 315 71 307 252 315 b 798 289 615 315 798 307 l 798 19 b 832 0 798 9 814 0 b 868 19 852 0 868 9 l 868 441 b 796 480 868 462 837 480 z m 513 78 b 433 156 513 121 478 156 b 356 78 390 156 356 121 b 433 -1 356 35 390 -1 b 513 78 478 -1 513 35 z"
        },
        fermataLongBelow: {
            x_min: 0,
            x_max: 603,
            y_min: -333,
            y_max: 1,
            ha: 334,
            o: "m 513 -78 b 433 1 513 -35 478 1 b 356 -78 390 1 356 -35 b 433 -156 356 -121 390 -156 b 513 -78 478 -156 513 -121 z m 796 -480 b 868 -441 837 -480 868 -462 l 868 -19 b 832 0 868 -9 852 0 b 798 -19 814 0 798 -9 l 798 -289 b 433 -315 798 -307 615 -315 b 71 -289 252 -315 71 -307 l 71 -19 b 35 0 71 -9 55 0 b 0 -19 16 0 0 -9 l 0 -441 b 72 -480 0 -462 32 -480 z"
        },
        fermataVeryLongAbove: {
            x_min: 0,
            x_max: 715,
            y_min: 0,
            y_max: 408,
            ha: 408,
            o: "m 76 588 b 0 546 35 588 0 569 l 0 22 b 37 1 0 10 17 1 b 75 22 59 1 75 10 l 75 431 b 514 458 75 449 294 458 b 955 431 734 458 955 449 l 955 22 b 991 1 955 10 971 1 b 1030 22 1012 1 1030 10 l 1030 546 b 953 588 1030 569 995 588 z m 215 389 b 138 347 171 389 138 370 l 138 22 b 174 1 138 10 154 1 b 213 22 196 1 213 10 l 213 217 b 514 245 213 235 363 245 b 816 217 665 245 816 235 l 816 22 b 854 1 816 10 834 1 b 891 22 876 1 891 10 l 891 347 b 815 389 891 370 858 389 z m 606 84 b 521 167 606 130 569 167 b 439 84 475 167 439 130 b 521 0 439 39 475 0 b 606 84 569 0 606 39 z"
        },
        fermataVeryLongBelow: {
            x_min: 0,
            x_max: 715,
            y_min: -408,
            y_max: 0,
            ha: 408,
            o: "m 606 -84 b 521 0 606 -39 569 0 b 439 -84 475 0 439 -39 b 521 -167 439 -130 475 -167 b 606 -84 569 -167 606 -130 z m 815 -389 b 891 -347 858 -389 891 -370 l 891 -22 b 854 -1 891 -10 876 -1 b 816 -22 834 -1 816 -10 l 816 -217 b 514 -245 816 -235 665 -245 b 213 -217 363 -245 213 -235 l 213 -22 b 174 -1 213 -10 196 -1 b 138 -22 154 -1 138 -10 l 138 -347 b 215 -389 138 -370 171 -389 z m 953 -588 b 1030 -546 995 -588 1030 -569 l 1030 -22 b 991 -1 1030 -10 1012 -1 b 955 -22 971 -1 955 -10 l 955 -431 b 514 -458 955 -449 734 -458 b 75 -431 294 -458 75 -449 l 75 -22 b 37 -1 75 -10 59 -1 b 0 -22 17 -1 0 -10 l 0 -546 b 76 -588 0 -569 35 -588 z"
        },
        fermataVeryShortAbove: {
            x_min: 0,
            x_max: 726,
            y_min: 0,
            y_max: 449,
            ha: 449,
            o: "m 46 0 b 59 7 50 0 52 4 b 516 517 120 59 507 517 b 975 4 527 517 920 52 b 988 0 979 1 988 0 l 1041 0 b 1045 6 1041 0 1045 1 b 1043 13 1045 7 1045 10 b 516 647 962 91 536 647 b 3 13 504 647 91 98 b 0 7 0 10 0 9 b 6 0 0 3 6 0 z m 238 0 b 248 6 240 0 242 3 b 516 236 292 43 494 236 b 786 3 539 236 746 37 b 796 0 789 1 796 0 l 865 0 b 870 4 865 0 870 1 b 867 10 870 6 868 9 b 516 409 806 68 531 409 b 166 10 497 409 229 73 b 163 4 164 9 163 6 b 167 0 163 1 167 0 z m 592 91 b 516 167 592 132 557 167 b 438 91 472 167 438 132 b 516 13 438 48 472 13 b 592 91 557 13 592 48 z"
        },
        fermataVeryShortBelow: {
            x_min: 0,
            x_max: 726,
            y_min: -449,
            y_max: 0,
            ha: 449,
            o: "m 167 0 b 163 -4 167 0 163 -1 b 166 -10 163 -6 164 -9 b 516 -409 229 -73 497 -409 b 867 -10 531 -409 806 -68 b 870 -4 868 -9 870 -6 b 865 0 870 -1 865 0 l 796 0 b 786 -3 796 0 789 -1 b 516 -236 746 -37 539 -236 b 248 -6 494 -236 292 -43 b 238 0 242 -3 240 0 z m 6 0 b 0 -7 6 0 0 -3 b 3 -13 0 -9 0 -10 b 516 -647 91 -98 504 -647 b 1043 -13 536 -647 962 -91 b 1045 -6 1045 -10 1045 -7 b 1041 0 1045 -1 1041 0 l 988 0 b 975 -4 988 0 979 -1 b 516 -517 920 -52 527 -517 b 59 -7 507 -517 120 -59 b 46 0 52 -4 50 0 z m 592 -91 b 516 -13 592 -48 557 -13 b 438 -91 472 -13 438 -48 b 516 -167 438 -132 472 -167 b 592 -91 557 -167 592 -132 z"
        },
        fermataShortAbove: {
            x_min: 0,
            x_max: 604,
            y_min: 0,
            y_max: 341,
            ha: 341,
            o: "m 78 0 b 88 6 81 0 82 3 b 435 328 134 45 412 328 b 783 3 458 328 742 39 b 793 0 786 1 793 0 l 865 0 b 870 4 865 0 870 1 b 867 10 870 6 868 9 b 435 491 805 69 474 491 b 3 10 397 491 69 75 b 0 4 1 9 0 6 b 4 0 0 1 4 0 z m 513 94 b 433 171 513 135 477 171 b 354 94 390 171 354 135 b 433 13 354 49 390 13 b 513 94 477 13 513 49 z"
        },
        fermataShortBelow: {
            x_min: 0,
            x_max: 604,
            y_min: -341,
            y_max: 0,
            ha: 341,
            o: "m 4 0 b 0 -4 4 0 0 -1 b 3 -10 0 -6 1 -9 b 435 -491 69 -75 397 -491 b 867 -10 474 -491 805 -69 b 870 -4 868 -9 870 -6 b 865 0 870 -1 865 0 l 793 0 b 783 -3 793 0 786 -1 b 435 -328 742 -39 458 -328 b 88 -6 412 -328 134 -45 b 78 0 82 -3 81 0 z m 513 -94 b 433 -13 513 -49 477 -13 b 354 -94 390 -13 354 -49 b 433 -171 354 -135 390 -171 b 513 -94 477 -171 513 -135 z"
        },
        breathMarkComma: {
            x_min: 1,
            x_max: 152,
            y_min: 2,
            y_max: 251,
            ha: 249,
            o: "m 104 361 b 1 271 42 361 1 321 b 82 190 1 222 35 190 b 122 160 118 190 122 160 b 125 144 124 154 125 150 b 102 88 125 124 115 105 b 37 32 78 56 40 35 b 26 17 32 29 26 26 l 27 16 b 37 3 29 6 33 3 b 181 102 85 3 158 66 b 219 239 210 147 219 197 l 219 249 b 104 361 219 317 170 361 z"
        },
        breathMarkUpbow: {
            x_min: 1,
            x_max: 249,
            y_min: 1,
            y_max: 495,
            ha: 494,
            o: "m 181 1 b 206 22 193 1 203 10 l 359 683 l 359 688 b 338 713 359 700 351 710 l 333 713 b 308 694 321 713 311 706 l 180 140 l 53 694 b 27 713 49 706 39 713 l 22 713 b 1 690 10 710 1 700 b 3 683 1 687 1 685 l 154 22 b 181 1 157 10 167 1 z"
        },
        caesura: {
            x_min: 0,
            x_max: 384,
            y_min: -1,
            y_max: 532,
            ha: 533,
            o: "m 40 -1 b 78 26 58 -1 72 9 l 321 713 b 323 726 323 717 323 721 b 282 766 323 747 304 766 b 245 739 265 766 251 756 l 3 52 b 0 37 1 48 0 42 b 27 1 0 22 10 7 b 40 -1 32 -1 36 -1 z m 308 26 l 552 713 b 553 726 553 717 553 721 b 513 766 553 747 534 766 b 475 739 495 766 481 756 l 232 52 b 230 39 230 48 230 43 b 258 1 230 23 240 7 b 271 -1 262 -1 266 -1 b 308 26 287 -1 302 9 z"
        },
        caesuraCurved: {
            x_min: 0,
            x_max: 373,
            y_min: 0,
            y_max: 530,
            ha: 530,
            o: "m 491 763 b 445 719 468 763 446 744 b 252 98 432 507 340 295 l 226 39 b 223 27 225 35 223 32 b 252 0 223 13 233 0 b 276 16 262 0 272 6 b 537 716 386 230 537 478 b 491 763 537 742 518 763 z m 29 0 b 53 16 39 0 48 6 l 82 69 b 314 716 187 264 314 498 b 268 763 314 742 295 763 b 222 719 245 763 223 744 b 29 98 209 507 117 295 l 3 39 b 0 29 1 36 0 33 b 29 0 0 14 12 0 z"
        },
        restMaxima: {
            x_min: 0,
            x_max: 381,
            y_min: -249,
            y_max: 250,
            ha: 499,
            o: "m 180 -330 l 180 331 b 156 360 180 356 170 360 l 23 360 b 0 331 10 360 0 356 l 0 -330 b 23 -359 0 -354 10 -359 l 156 -359 b 180 -330 170 -359 180 -354 z m 549 -330 l 549 331 b 524 360 549 356 539 360 l 392 360 b 369 331 379 360 369 356 l 369 -330 b 392 -359 369 -354 379 -359 l 524 -359 b 549 -330 539 -359 549 -354 z"
        },
        restDoubleWhole: {
            x_min: 0,
            x_max: 125,
            y_min: 0,
            y_max: 250,
            ha: 250,
            o: "m 180 22 l 180 338 b 156 360 180 350 170 360 l 23 360 b 0 338 10 360 0 350 l 0 22 b 23 0 0 10 10 0 l 156 0 b 180 22 170 0 180 10 z"
        },
        restWhole: {
            x_min: 0,
            x_max: 282,
            y_min: -135,
            y_max: 9,
            ha: 144,
            o: "m 406 -157 l 406 -24 b 369 13 406 -3 389 13 l 37 13 b 0 -24 16 13 0 -3 l 0 -157 b 37 -194 0 -177 16 -194 l 369 -194 b 406 -157 389 -194 406 -177 z"
        },
        restWholeLegerLine: {
            x_min: -117,
            x_max: 399,
            y_min: -135,
            y_max: 20,
            ha: 155,
            o: "m -143 29 b -168 3 -157 29 -168 17 b -143 -23 -168 -12 -157 -23 l 0 -23 l 0 -157 b 37 -194 0 -177 16 -194 l 369 -194 b 406 -157 389 -194 406 -177 l 406 -24 b 549 -23 406 -23 406 -23 b 575 3 563 -23 575 -12 b 549 29 575 17 563 29 z"
        },
        restHalf: {
            x_min: 0,
            x_max: 282,
            y_min: -2,
            y_max: 142,
            ha: 144,
            o: "m 406 35 l 406 167 b 369 204 406 189 389 204 l 37 204 b 0 167 16 204 0 189 l 0 35 b 37 -3 0 14 16 -3 l 369 -3 b 406 35 389 -3 406 14 z"
        },
        restHalfLegerLine: {
            x_min: -117,
            x_max: 399,
            y_min: -13,
            y_max: 142,
            ha: 155,
            o: "m 549 -19 b 575 7 563 -19 575 -7 b 549 33 575 22 563 33 b 406 35 406 33 406 33 l 406 167 b 369 204 406 187 389 204 l 37 204 b 0 167 16 204 0 187 l 0 33 l -143 33 b -168 7 -157 33 -168 22 b -143 -19 -168 -7 -157 -19 z"
        },
        restQuarter: {
            x_min: 1,
            x_max: 270,
            y_min: -375,
            y_max: 373,
            ha: 748,
            o: "m 112 -55 b 174 -141 135 -84 156 -111 b 183 -161 177 -147 183 -158 b 181 -167 183 -163 183 -166 b 166 -174 179 -173 173 -174 b 143 -170 160 -174 148 -171 b 137 -170 141 -170 138 -170 l 125 -166 b 1 -304 50 -166 1 -233 b 168 -527 1 -376 63 -446 b 206 -540 180 -536 194 -540 b 228 -531 216 -540 226 -537 b 230 -521 229 -527 230 -524 b 207 -487 230 -508 219 -497 b 170 -435 189 -487 173 -448 b 164 -397 166 -423 164 -410 b 255 -292 164 -338 194 -292 b 369 -317 297 -292 344 -308 l 370 -318 b 382 -320 376 -320 379 -320 b 389 -314 386 -320 389 -318 b 336 -232 389 -297 351 -249 b 236 -32 281 -166 236 -112 b 236 -27 236 -30 236 -29 l 238 -17 b 238 -13 238 -16 238 -14 b 333 199 243 71 295 140 b 338 220 337 206 338 213 b 333 248 338 235 333 248 b 95 526 333 248 120 501 b 69 537 88 533 78 537 b 40 507 55 537 40 527 b 46 484 40 500 42 492 b 134 291 52 468 134 395 b 48 108 134 238 112 176 b 27 66 33 94 27 78 b 42 32 27 46 42 32 z"
        },
        rest8th: {
            x_min: 0,
            x_max: 247,
            y_min: -251,
            y_max: 174,
            ha: 425,
            o: "m 193 154 b 96 251 193 207 150 251 b 0 154 43 251 0 207 b 39 81 0 124 17 98 b 117 56 62 65 89 56 b 173 66 137 56 157 60 b 225 88 193 72 206 78 b 232 89 228 89 230 89 b 239 76 238 89 239 84 b 238 60 239 72 239 66 b 104 -343 233 39 130 -248 b 145 -361 104 -360 137 -361 b 196 -347 161 -361 181 -359 b 341 161 200 -344 341 161 b 356 217 347 187 354 210 b 338 240 356 232 341 239 b 323 235 336 240 331 240 b 193 140 312 226 240 140 z"
        },
        rest16th: {
            x_min: 0,
            x_max: 320,
            y_min: -500,
            y_max: 179,
            ha: 679,
            o: "m 300 160 b 202 258 300 215 256 258 b 104 160 148 258 104 215 b 219 62 104 101 164 62 b 331 94 258 62 298 75 b 341 96 336 95 338 96 b 348 86 346 96 348 94 b 265 -173 348 63 275 -151 b 194 -217 253 -200 215 -217 b 196 -203 196 -212 196 -207 b 98 -105 196 -148 151 -105 b 0 -203 43 -105 0 -148 b 115 -301 0 -262 60 -301 b 223 -271 153 -301 190 -288 b 229 -279 226 -271 229 -274 l 228 -281 b 228 -282 228 -282 228 -282 l 91 -690 b 91 -691 91 -690 91 -691 l 89 -693 b 134 -720 89 -706 102 -720 b 189 -687 176 -720 183 -703 l 356 -138 b 420 81 393 -16 420 81 b 459 226 420 81 456 207 b 461 232 459 229 461 230 b 446 248 461 240 449 246 b 431 242 439 248 435 245 b 300 145 420 233 348 147 z"
        },
        rest32nd: {
            x_min: 0,
            x_max: 363,
            y_min: -500,
            y_max: 426,
            ha: 926,
            o: "m 508 603 b 492 598 501 603 497 600 b 361 503 482 590 410 503 l 361 516 b 264 613 361 570 318 613 b 166 516 210 613 166 570 b 206 444 166 487 183 461 b 246 423 217 433 232 428 b 284 418 258 420 269 418 b 393 449 321 418 360 432 b 399 451 395 451 397 451 b 415 426 409 451 415 436 l 413 423 b 413 422 413 423 413 422 l 357 192 b 279 140 350 168 302 140 b 281 153 281 144 281 148 b 183 251 281 207 236 251 b 85 153 128 251 85 207 b 125 81 85 124 102 98 b 164 60 137 71 150 65 b 203 55 176 58 189 55 b 311 86 240 55 278 69 b 315 88 312 88 314 88 b 325 69 323 88 325 76 l 268 -167 b 194 -217 261 -197 216 -216 b 196 -203 196 -212 196 -207 b 98 -105 196 -148 153 -105 b 0 -203 45 -105 0 -148 b 115 -301 0 -262 60 -301 b 228 -269 154 -301 194 -288 b 232 -268 229 -268 230 -268 b 240 -276 236 -268 240 -272 b 138 -688 240 -282 141 -678 b 137 -697 137 -691 137 -694 b 176 -720 137 -708 145 -720 b 232 -690 222 -720 226 -706 b 484 436 236 -672 484 436 b 521 582 484 436 518 564 b 523 588 521 585 523 586 b 508 603 523 600 511 603 z"
        },
        rest64th: {
            x_min: 0,
            x_max: 423,
            y_min: -753,
            y_max: 430,
            ha: 1183,
            o: "m 596 609 b 580 603 589 609 585 606 b 448 507 569 595 497 507 b 449 521 449 511 449 516 b 351 619 449 575 405 619 b 253 521 297 619 253 575 b 372 422 253 461 317 422 b 481 454 410 422 446 438 b 491 456 484 455 488 456 b 504 441 498 456 504 451 b 501 426 504 436 503 432 b 445 202 500 422 451 217 b 359 144 435 174 383 144 l 359 158 b 261 256 359 212 315 256 b 163 158 207 256 163 212 b 243 65 163 112 202 78 b 279 60 255 62 266 60 b 397 91 320 60 360 73 b 403 92 400 92 402 92 b 412 79 409 92 412 86 b 410 72 412 76 412 75 b 351 -161 408 59 356 -150 b 281 -212 340 -199 301 -212 l 281 -197 b 183 -99 281 -144 238 -99 b 85 -197 130 -99 85 -144 b 125 -271 85 -228 102 -253 b 166 -291 138 -279 151 -287 b 204 -297 177 -294 192 -297 b 262 -287 225 -297 245 -292 b 305 -265 282 -279 287 -274 b 310 -264 307 -264 308 -264 b 318 -284 317 -264 318 -275 b 317 -295 318 -288 317 -294 b 259 -524 315 -302 265 -508 b 194 -567 251 -554 213 -567 b 196 -554 196 -563 196 -559 b 98 -456 196 -500 153 -456 b 0 -554 45 -456 0 -500 b 40 -626 0 -583 17 -609 b 118 -652 60 -644 92 -652 b 210 -629 145 -652 186 -642 b 216 -628 213 -628 215 -628 b 228 -647 226 -628 228 -639 l 226 -651 b 226 -652 226 -651 226 -652 l 122 -1054 b 121 -1064 121 -1058 121 -1061 b 167 -1084 121 -1077 134 -1084 b 215 -1060 202 -1084 209 -1076 b 402 -278 217 -1047 229 -1021 b 436 -135 403 -278 431 -161 l 570 441 b 609 588 570 441 605 569 b 596 609 609 603 602 608 z"
        },
        rest128th: {
            x_min: 0,
            x_max: 485,
            y_min: -750,
            y_max: 689,
            ha: 1439,
            o: "m 537 894 b 439 992 537 949 494 992 b 341 894 386 992 341 949 b 382 822 341 865 359 840 b 459 796 402 805 433 796 b 518 806 480 796 501 801 l 520 808 b 569 828 539 814 552 819 b 580 831 572 829 577 831 b 598 812 589 831 598 825 b 596 801 598 809 598 805 b 540 575 590 773 546 595 b 448 510 534 553 475 510 l 448 524 b 350 622 448 577 405 622 b 252 524 297 622 252 577 b 292 451 252 494 269 468 b 369 426 318 433 337 426 b 429 435 389 426 412 429 b 494 464 449 442 475 455 b 498 465 495 465 497 465 b 505 446 504 465 505 456 b 503 426 505 439 504 432 l 446 202 b 366 144 439 173 389 144 l 366 158 b 268 256 366 212 323 256 b 170 158 215 256 170 212 b 289 59 170 98 235 59 b 347 69 310 59 330 63 b 397 91 367 76 379 82 b 406 94 400 92 403 94 b 415 79 412 94 415 88 b 412 63 415 75 413 69 b 357 -157 408 42 364 -134 b 281 -212 346 -196 302 -212 b 282 -197 281 -207 282 -203 b 184 -99 282 -144 238 -99 b 86 -197 130 -99 86 -144 b 204 -297 86 -258 150 -297 b 262 -287 225 -297 245 -292 b 312 -265 282 -279 294 -274 b 318 -264 314 -264 317 -264 b 327 -275 324 -264 327 -269 b 266 -517 324 -287 278 -490 b 200 -569 248 -566 220 -567 l 196 -554 b 98 -456 196 -500 153 -456 b 0 -554 45 -456 0 -500 b 118 -652 0 -615 63 -652 b 177 -642 138 -652 160 -648 l 179 -641 b 229 -621 197 -635 210 -629 l 230 -619 b 239 -626 236 -619 239 -622 b 238 -632 239 -628 239 -631 b 131 -1057 235 -642 134 -1050 b 173 -1080 131 -1071 140 -1080 b 230 -1057 219 -1080 225 -1074 l 658 815 b 697 960 658 815 694 942 b 698 966 697 963 698 965 b 684 982 698 975 687 981 b 668 976 677 982 672 979 b 537 880 658 969 586 881 z"
        },
        dynamicPiano: {
            x_min: -89,
            x_max: 366,
            y_min: -142,
            y_max: 274,
            ha: 416,
            o: "m 395 395 b 292 357 350 395 318 380 b 262 328 272 340 268 328 b 246 363 255 328 259 338 b 177 393 236 380 215 393 b 1 251 92 393 46 333 b -9 223 -6 238 -9 230 b 7 207 -9 213 -1 207 b 30 229 17 207 23 216 b 127 338 72 301 101 338 b 143 321 138 338 143 331 b 134 285 143 310 138 295 l -43 -154 b -65 -168 -48 -166 -50 -168 l -109 -168 b -128 -187 -122 -168 -128 -174 b -111 -204 -128 -199 -122 -204 l 167 -204 b 186 -186 180 -204 186 -199 b 168 -168 186 -174 180 -168 l 111 -168 b 98 -164 102 -168 98 -168 b 101 -154 98 -163 99 -158 l 166 7 b 179 24 168 14 171 24 b 213 -1 186 24 190 10 b 276 -14 233 -12 252 -14 b 527 266 415 -14 527 130 b 395 395 527 350 475 395 z m 356 341 b 389 288 380 341 389 320 b 243 35 389 217 312 35 b 207 81 219 35 207 50 b 235 180 207 111 219 140 l 264 251 b 356 341 284 300 321 341 z"
        },
        dynamicMezzo: {
            x_min: -20,
            x_max: 446,
            y_min: -10,
            y_max: 274,
            ha: 284,
            o: "m 528 395 b 431 350 487 395 454 374 b 409 330 416 336 415 330 b 397 360 402 330 406 341 b 334 395 389 379 370 395 b 236 350 292 395 259 374 b 215 330 222 336 220 330 b 203 360 207 330 212 340 b 147 393 194 379 174 393 b -19 251 71 393 26 331 b -29 223 -26 238 -29 230 b -13 207 -29 213 -22 207 b 9 226 -3 207 1 215 b 107 338 52 300 81 338 b 122 321 118 338 122 331 b 114 285 122 310 118 295 l 9 24 b 4 9 6 17 4 13 b 20 0 4 3 9 0 l 91 0 b 114 17 104 0 108 3 l 207 251 b 287 323 225 292 255 323 b 308 302 304 323 308 314 b 294 249 308 285 302 269 b 203 24 294 248 292 248 b 199 9 200 17 199 13 b 215 0 199 3 203 0 l 285 0 b 308 17 298 0 302 3 l 402 251 b 481 323 419 292 449 323 b 503 302 498 323 503 314 b 413 43 503 252 413 104 b 478 -14 413 6 436 -14 b 629 102 533 -14 583 26 b 642 132 638 117 642 125 b 629 145 642 141 636 145 b 608 127 619 145 615 138 b 534 49 580 84 553 49 b 523 62 526 49 523 53 b 606 317 523 112 606 238 b 528 395 606 353 588 395 z"
        },
        dynamicForte: {
            x_min: -141,
            x_max: 364,
            y_min: -152,
            y_max: 444,
            ha: 596,
            o: "m 23 380 b 0 357 7 380 0 373 b 22 336 0 343 7 336 l 105 336 b 117 330 114 336 117 336 b 114 315 117 327 115 323 l 23 0 b -101 -187 -17 -141 -43 -187 b -127 -174 -120 -187 -127 -181 b -92 -156 -127 -163 -114 -170 b -63 -102 -75 -144 -63 -125 b -128 -43 -63 -65 -89 -43 b -203 -122 -171 -43 -203 -78 b -95 -219 -203 -186 -156 -219 b 161 17 14 -219 82 -145 b 269 317 203 105 235 194 l 271 318 b 289 336 271 323 282 336 l 383 336 b 406 359 399 336 406 343 b 384 380 406 373 399 380 l 298 380 b 284 387 288 380 284 380 b 287 405 284 392 285 396 b 419 606 315 530 347 606 b 442 595 431 606 442 603 b 419 580 442 586 435 588 b 389 526 400 572 389 552 b 454 465 389 485 418 465 b 524 543 491 465 524 490 b 400 639 524 596 491 639 b 135 402 261 639 183 540 b 107 380 128 380 127 380 z"
        },
        dynamicRinforzando: {
            x_min: -20,
            x_max: 277,
            y_min: 0,
            y_max: 274,
            ha: 274,
            o: "m 324 395 b 235 350 287 395 256 374 b 215 330 222 336 220 330 b 203 360 207 330 213 337 b 145 393 194 379 174 393 b -19 251 75 393 27 337 b -29 223 -26 238 -29 230 b -13 207 -29 213 -22 207 b 9 226 -3 207 3 215 b 107 338 52 301 81 338 b 122 321 118 338 122 331 b 114 285 122 310 118 295 l 9 24 b 4 9 6 17 4 13 b 20 0 4 3 9 0 l 91 0 b 114 17 104 0 108 3 l 207 251 b 304 351 226 298 272 351 b 318 343 312 351 318 348 b 287 285 318 330 287 325 b 338 239 287 256 308 239 b 399 318 373 239 399 268 b 324 395 399 360 377 395 z"
        },
        dynamicSforzando: {
            x_min: 0,
            x_max: 229,
            y_min: -10,
            y_max: 273,
            ha: 283,
            o: "m 212 393 b 68 274 127 393 68 350 b 145 161 68 223 95 196 b 200 85 187 132 200 114 b 127 20 200 53 173 20 b 66 42 91 20 66 32 b 91 56 66 49 75 46 b 111 98 104 65 111 79 b 59 145 111 127 86 145 b 0 78 24 145 0 117 b 125 -14 0 30 49 -14 b 291 120 219 -14 291 36 b 220 232 291 160 276 190 b 151 314 168 271 151 287 b 213 361 151 337 168 361 b 258 346 238 361 258 356 b 240 333 258 340 251 340 b 226 298 232 325 226 314 b 276 252 226 269 248 252 b 330 307 311 252 330 279 b 212 393 330 360 285 393 z"
        },
        dynamicZ: {
            x_min: -30,
            x_max: 244,
            y_min: -10,
            y_max: 268,
            ha: 278,
            o: "m 333 386 b 298 377 321 386 314 382 b 239 370 282 373 259 370 b 94 383 153 370 111 383 b 68 364 79 383 72 377 l 33 264 b 29 242 30 255 29 248 b 45 228 29 232 36 228 b 66 249 55 228 60 236 l 81 279 b 96 297 85 288 88 297 b 168 292 102 297 127 292 b 223 302 194 292 215 302 b 196 269 229 302 197 271 l -26 45 b -43 16 -37 33 -43 27 b -24 -1 -43 6 -36 -1 b 4 16 -12 -1 -3 10 b 39 30 16 24 27 30 b 179 -14 79 30 108 -14 b 297 102 259 -14 297 43 b 245 166 297 147 271 166 b 197 115 219 166 197 145 b 236 72 197 88 216 72 b 259 79 251 72 255 79 b 264 75 262 79 264 78 b 258 60 264 72 261 66 b 229 45 252 50 242 45 b 117 95 186 45 173 95 b 85 86 98 95 89 86 b 102 111 85 86 95 104 l 333 338 b 351 370 344 350 351 359 b 333 386 351 380 343 386 z"
        },
        ornamentTrill: {
            x_min: 0,
            x_max: 521,
            y_min: -10,
            y_max: 390,
            ha: 400,
            o: "m 383 562 b 364 557 377 562 369 559 l 294 534 b 269 511 281 530 275 526 l 217 384 b 206 367 212 370 210 367 b 179 380 200 367 192 374 b 118 393 158 389 140 393 b 0 292 50 393 0 353 b 95 210 0 248 30 210 b 140 213 112 210 131 213 b 144 209 143 213 144 212 b 140 194 144 206 143 202 l 124 156 b 96 58 108 117 96 88 b 179 -14 96 17 124 -14 b 325 153 253 -14 325 46 b 307 251 325 187 320 219 b 302 265 304 258 302 261 b 334 294 302 274 311 281 l 343 298 b 455 348 393 328 428 348 b 474 327 468 348 474 344 b 465 285 474 312 469 295 l 360 24 b 356 9 357 17 356 13 b 372 0 356 3 360 0 l 442 0 b 465 17 455 0 459 3 l 559 251 b 655 351 577 298 624 351 b 670 343 664 351 670 348 b 638 285 670 330 638 325 b 690 239 638 256 660 239 b 750 318 724 239 750 268 b 675 395 750 360 729 395 b 586 350 638 395 608 374 b 566 330 573 336 572 330 b 553 361 559 330 564 340 b 490 393 543 380 521 393 b 347 348 432 393 377 364 b 312 333 328 338 320 333 b 308 337 310 333 308 334 b 315 359 308 343 312 351 l 387 537 b 392 553 390 544 392 549 b 383 562 392 559 389 562 z m 118 360 b 192 325 134 360 192 347 b 186 307 192 321 189 314 l 180 292 b 148 265 173 274 167 269 b 98 258 130 261 112 258 b 39 301 50 258 39 281 b 118 360 39 327 60 360 z m 272 240 b 292 151 285 240 292 164 b 212 30 292 88 253 30 b 196 48 200 30 196 37 b 207 92 196 59 202 78 b 264 230 207 94 209 94 b 272 240 266 238 268 240 z"
        },
        ornamentTurn: {
            x_min: 0,
            x_max: 460,
            y_min: 0,
            y_max: 218,
            ha: 218,
            o: "m 534 314 b 454 251 490 314 454 294 b 505 199 454 219 475 199 b 579 232 547 199 549 232 b 626 164 603 232 626 202 b 533 72 626 102 583 72 b 377 180 487 72 439 111 b 150 312 307 258 243 312 b 0 148 55 312 0 240 b 128 0 0 45 66 0 b 209 63 173 0 209 20 b 157 115 209 95 187 115 b 84 82 115 115 114 82 b 36 150 59 82 36 112 b 130 242 36 212 79 242 b 285 134 176 242 223 203 b 513 1 356 56 419 1 b 662 166 608 1 662 73 b 534 314 662 269 596 314 z"
        },
        ornamentTurnSlash: {
            x_min: 0,
            x_max: 460,
            y_min: -90,
            y_max: 306,
            ha: 396,
            o: "m 333 441 b 310 418 315 441 310 433 l 310 274 b 302 252 310 258 308 252 b 261 278 294 252 287 262 b 150 311 228 298 192 311 b 0 147 55 311 0 239 b 128 -1 0 43 66 -1 b 209 62 173 -1 209 19 b 157 114 209 94 187 114 b 84 81 115 114 114 81 b 36 148 59 81 36 111 b 130 240 36 210 79 240 b 285 128 176 240 222 197 b 307 79 304 108 307 105 l 307 -107 b 330 -130 307 -122 312 -130 b 353 -107 347 -130 353 -122 l 353 37 b 360 59 353 53 353 59 b 402 33 369 59 376 49 b 513 0 435 13 471 0 b 662 164 608 0 662 72 b 534 312 662 268 596 312 b 454 249 490 312 454 292 b 505 197 454 217 475 197 b 579 230 547 197 549 230 b 626 163 603 230 626 200 b 533 71 626 101 583 71 b 377 183 487 71 441 114 b 356 232 359 203 356 206 l 356 418 b 333 441 356 433 350 441 z"
        },
        ornamentMordent: {
            x_min: 1,
            x_max: 729,
            y_min: -73,
            y_max: 319,
            ha: 392,
            o: "m 546 265 l 546 459 l 501 459 l 501 216 l 459 167 b 439 167 454 160 445 160 b 302 327 387 228 310 317 b 258 353 291 338 282 351 b 226 340 245 353 238 348 l 20 107 b 1 73 12 98 1 84 b 30 59 1 65 9 59 b 88 94 53 59 73 79 b 144 143 107 109 124 127 b 176 161 158 154 168 161 b 197 144 183 161 189 156 l 323 10 b 351 0 328 3 340 0 b 377 9 361 0 372 3 b 498 114 392 17 475 94 l 498 -105 l 544 -105 l 544 153 b 562 160 550 157 556 160 b 585 144 569 160 576 156 b 710 10 590 135 697 24 b 737 0 716 3 727 0 b 765 9 749 0 759 3 b 1030 295 776 17 1011 274 l 1032 300 b 1050 328 1041 308 1050 318 b 1012 353 1050 343 1024 353 b 986 343 1002 353 994 348 b 854 190 971 330 871 206 b 828 176 842 180 835 176 b 802 190 818 176 809 183 b 681 333 791 202 696 320 b 645 353 668 344 657 353 b 613 340 634 353 626 350 b 580 304 600 330 590 315 z"
        },
        ornamentShortTrill: {
            x_min: 0,
            x_max: 725,
            y_min: 0,
            y_max: 245,
            ha: 245,
            o: "m 429 167 l 301 325 b 256 353 291 338 282 350 b 225 340 246 353 238 350 b 16 105 158 268 88 186 b 0 72 9 96 0 86 b 29 58 0 63 7 58 b 71 76 42 58 55 62 l 158 154 b 174 160 163 158 168 160 b 197 143 181 160 187 154 b 321 10 203 135 310 24 b 350 0 327 3 338 0 b 377 7 361 0 372 3 l 533 148 b 554 160 543 158 550 160 b 577 143 562 160 566 156 b 703 10 585 135 690 24 b 732 0 708 3 720 0 b 759 7 743 0 753 3 b 1024 294 769 16 1005 272 b 1044 327 1032 305 1044 321 b 1005 353 1044 341 1018 353 b 979 343 996 353 988 348 b 848 189 963 330 864 204 b 821 174 837 179 828 174 b 796 189 811 174 804 181 b 674 331 783 202 688 318 b 641 351 662 343 651 351 b 606 340 628 351 619 350 b 573 304 593 328 583 315 b 444 167 533 259 491 213 b 429 167 439 161 433 161 z"
        },
        ornamentTremblement: {
            x_min: 1,
            x_max: 985,
            y_min: 0,
            y_max: 244,
            ha: 244,
            o: "m 678 325 b 634 351 667 338 657 350 b 602 338 621 351 613 348 l 448 167 b 439 167 446 164 441 164 l 302 325 b 258 351 291 338 281 350 b 228 338 245 351 238 348 b 193 304 215 328 204 315 l 19 107 b 1 72 13 96 1 76 b 30 58 1 63 9 58 b 89 92 52 58 73 78 l 144 141 b 148 144 145 143 147 143 b 176 160 160 153 170 160 b 199 143 183 160 189 154 b 324 10 204 134 311 23 b 351 0 330 3 340 0 b 379 7 363 0 373 3 l 530 148 b 552 160 536 154 546 160 b 575 143 559 160 564 154 b 698 10 580 134 687 23 b 727 0 704 3 716 0 b 755 7 739 0 749 3 l 907 147 b 930 160 922 158 923 160 b 952 143 937 160 943 154 l 1077 10 b 1107 0 1084 3 1096 0 b 1133 7 1117 0 1128 3 b 1398 294 1143 16 1380 272 b 1418 327 1407 305 1418 321 b 1381 351 1418 343 1394 351 b 1354 341 1371 351 1362 348 b 1223 189 1338 328 1238 204 b 1195 174 1211 179 1202 174 b 1171 189 1185 174 1178 181 b 1048 331 1158 200 1063 318 b 1012 351 1035 343 1024 351 b 981 338 1002 351 994 350 b 948 304 968 328 958 315 b 827 166 907 258 865 212 b 815 166 824 163 818 163 b 678 325 760 226 732 264 z"
        },
        ornamentPrecompAppoggTrill: {
            x_min: 0,
            x_max: 1119,
            y_min: 0,
            y_max: 481,
            ha: 481,
            o: "m 1015 163 b 873 328 963 223 880 318 b 828 354 860 344 847 353 b 796 341 816 354 809 351 b 763 305 783 331 773 317 b 642 168 721 261 681 215 b 636 163 641 167 639 164 b 494 328 585 223 501 318 b 449 354 481 344 468 353 b 418 341 438 354 431 351 b 384 305 405 331 395 317 b 264 168 343 261 302 215 l 242 144 b 144 88 232 124 171 88 b 79 197 81 88 79 189 l 79 648 b 60 693 79 683 71 693 b 52 691 58 693 55 693 b 0 616 3 672 0 625 l 0 207 b 121 0 0 40 68 0 b 249 68 168 0 232 53 b 279 94 262 75 271 86 b 336 144 298 111 315 128 b 367 163 350 156 360 163 b 389 145 374 163 380 157 b 514 12 395 137 501 26 b 543 1 520 4 531 1 b 569 9 553 1 563 4 b 636 73 576 14 605 43 l 658 94 b 714 144 677 111 694 128 b 746 163 729 156 739 163 b 768 145 753 163 759 157 b 893 12 773 137 880 26 b 922 1 899 4 910 1 b 948 9 932 1 942 4 l 1012 71 b 1037 94 1022 78 1030 86 b 1092 144 1054 111 1073 128 b 1123 161 1106 156 1115 161 b 1146 145 1130 161 1136 157 b 1270 12 1152 137 1259 26 b 1299 1 1276 4 1287 1 b 1326 9 1310 1 1320 4 b 1591 297 1336 19 1572 275 b 1611 328 1600 307 1611 320 b 1574 354 1611 343 1585 354 b 1548 344 1565 354 1555 350 b 1416 192 1532 331 1431 206 b 1388 177 1404 181 1395 177 b 1365 190 1380 177 1371 184 b 1243 333 1352 203 1256 321 b 1205 354 1228 346 1217 354 b 1174 341 1195 354 1187 351 b 1140 305 1161 330 1152 317 z"
        },
        ornamentPrecompSlideTrillDAnglebert: {
            x_min: 2,
            x_max: 1150,
            y_min: -367,
            y_max: 245,
            ha: 612,
            o: "m 1058 160 b 916 327 1007 220 923 317 b 871 353 903 343 890 351 b 840 340 860 353 852 350 b 806 304 827 330 816 315 b 685 167 765 259 724 213 l 680 160 l 615 235 b 419 344 582 275 523 344 b 3 -144 258 344 3 26 b 4 -168 3 -153 3 -160 b 246 -482 24 -315 99 -422 b 458 -528 340 -521 410 -528 b 514 -526 485 -528 504 -526 b 552 -508 531 -526 552 -517 b 514 -497 552 -503 541 -498 l 503 -497 b 194 -390 432 -494 298 -488 b 69 -151 194 -390 69 -279 b 184 96 69 -60 128 27 b 328 183 202 118 258 183 b 477 96 413 183 454 118 b 559 10 510 62 552 19 b 588 0 566 3 576 0 b 613 7 598 0 609 3 b 723 112 622 14 681 73 b 789 161 733 122 776 161 b 811 144 796 161 802 156 b 936 10 816 135 923 24 b 965 0 942 3 953 0 b 991 7 975 0 985 3 b 1051 66 996 12 1022 37 b 1081 92 1063 73 1073 84 b 1136 143 1099 109 1117 127 b 1168 160 1151 154 1159 160 b 1191 144 1175 160 1181 156 b 1315 10 1197 135 1303 24 b 1344 0 1320 3 1332 0 b 1371 7 1355 0 1365 3 b 1636 295 1381 17 1617 274 b 1656 327 1644 305 1656 318 b 1619 353 1656 341 1630 353 b 1593 343 1610 353 1600 348 b 1460 190 1577 330 1476 204 b 1433 176 1449 180 1440 176 b 1410 189 1424 176 1416 183 b 1287 331 1397 202 1300 320 b 1250 353 1273 344 1261 353 b 1218 340 1240 353 1231 350 b 1185 304 1205 328 1197 315 z"
        },
        ornamentPrecompSlideTrillBach: {
            x_min: 0,
            x_max: 1048,
            y_min: -367,
            y_max: 331,
            ha: 698,
            o: "m 1038 477 l 979 477 l 979 238 l 912 160 b 769 327 858 220 775 317 b 724 353 756 343 743 351 b 693 340 713 353 706 350 b 660 304 680 330 670 315 b 539 167 618 259 577 213 b 533 161 536 166 534 163 b 390 327 480 220 396 317 b 346 353 377 343 364 351 l 340 353 b 308 340 330 353 321 350 b 275 304 295 330 285 315 b 117 122 220 243 168 186 b 0 -144 68 62 0 -48 b 1 -168 0 -153 0 -160 b 243 -482 22 -315 96 -422 b 455 -528 337 -521 408 -528 b 511 -526 482 -528 501 -526 b 549 -508 528 -526 549 -517 b 511 -497 549 -503 539 -498 l 500 -497 b 192 -390 429 -494 295 -488 b 68 -177 192 -390 84 -298 b 66 -151 66 -168 66 -160 b 189 105 66 -58 127 35 b 232 143 203 118 216 131 b 264 161 246 154 256 161 b 285 144 271 161 276 156 b 410 10 291 135 397 24 b 439 0 416 3 428 0 b 465 7 449 0 459 3 l 531 72 b 554 92 540 78 547 86 b 611 143 573 109 590 127 b 642 161 625 154 635 161 b 664 144 649 161 655 156 b 789 10 670 135 776 24 b 818 0 795 3 806 0 b 844 7 828 0 838 3 b 904 66 850 12 876 37 b 935 92 916 73 924 84 b 979 134 949 107 963 121 l 979 -88 l 1037 -88 l 1037 151 l 1044 144 b 1168 10 1050 135 1156 24 b 1197 0 1174 3 1185 0 b 1224 7 1208 0 1218 3 b 1489 295 1234 17 1470 274 b 1509 327 1498 305 1509 318 b 1472 353 1509 341 1483 353 b 1446 343 1463 353 1453 348 b 1313 190 1430 330 1329 204 b 1286 176 1302 180 1293 176 b 1263 189 1277 176 1269 183 b 1140 331 1250 202 1153 320 b 1103 353 1126 344 1115 353 b 1071 340 1093 353 1084 350 b 1038 304 1058 328 1050 315 z"
        },
        ornamentPrecompTrillSuffixDandrieu: {
            x_min: 0,
            x_max: 949,
            y_min: 0,
            y_max: 381,
            ha: 381,
            o: "m 1367 314 b 1250 521 1367 419 1318 482 b 1107 549 1211 537 1145 549 b 1083 546 1096 549 1087 549 b 1066 528 1071 540 1066 534 b 1079 520 1066 524 1070 520 b 1323 351 1187 517 1323 487 b 1201 171 1323 269 1260 219 b 1194 166 1201 171 1198 168 b 1056 327 1142 226 1063 317 b 1011 353 1043 343 1030 351 b 979 340 999 353 992 350 b 946 304 966 330 956 315 b 825 167 904 259 864 213 l 821 161 b 678 327 768 222 685 317 b 634 353 665 343 652 351 b 602 340 622 353 615 350 b 569 304 589 330 579 315 b 448 167 527 259 487 213 l 444 161 b 301 327 390 222 308 317 b 256 353 288 343 275 351 b 225 340 245 353 238 350 b 192 304 212 330 202 315 b 71 167 150 259 109 213 b 17 105 52 147 36 127 b 0 73 10 98 0 84 b 29 58 0 65 7 58 b 86 92 56 59 72 79 b 143 143 105 109 122 127 b 174 161 157 154 167 161 b 196 144 181 161 187 156 b 321 10 202 135 308 24 b 350 0 327 3 338 0 b 376 7 360 0 370 3 b 485 112 384 14 444 73 b 552 161 495 122 539 161 b 573 144 559 161 564 156 b 698 10 579 135 685 24 b 727 0 704 3 716 0 b 753 7 737 0 747 3 b 863 112 762 14 821 73 b 929 161 873 122 916 161 b 950 144 936 161 942 156 b 1076 10 956 135 1063 24 b 1104 0 1081 3 1093 0 b 1130 7 1115 0 1125 3 b 1236 108 1139 14 1195 69 b 1367 314 1297 160 1367 233 z"
        },
        ornamentPrecompDoubleCadenceUpperPrefix: {
            x_min: 0,
            x_max: 1278,
            y_min: 0,
            y_max: 247,
            ha: 247,
            o: "m 1801 356 b 1776 346 1793 356 1783 351 b 1642 192 1760 333 1659 206 b 1614 177 1630 181 1621 177 b 1591 190 1606 177 1597 184 b 1469 334 1578 203 1482 323 b 1430 356 1453 347 1441 356 b 1398 343 1420 356 1411 353 b 1365 307 1385 331 1377 318 l 1240 164 b 1097 330 1187 226 1104 320 b 1053 356 1084 346 1071 354 b 1021 343 1041 356 1034 353 b 988 307 1008 333 998 318 b 865 168 946 262 904 216 l 861 163 b 717 330 808 223 724 320 b 672 356 704 346 691 354 b 641 343 661 356 654 353 b 608 307 628 333 618 318 b 485 168 566 262 524 216 l 455 134 b 284 46 409 88 351 46 b 16 285 148 46 32 265 b 3 295 9 292 4 295 b 0 291 1 295 0 292 b 1 285 0 288 1 285 b 308 0 42 190 157 0 b 530 120 415 1 482 63 b 559 144 539 128 549 137 b 590 163 573 156 583 163 b 612 145 598 163 603 157 b 739 10 618 137 724 24 b 768 0 744 3 756 0 b 793 7 778 0 788 3 b 903 114 802 14 861 75 l 939 144 b 971 163 953 156 963 163 b 992 145 978 163 984 157 b 1119 10 998 137 1106 24 b 1148 0 1125 3 1136 0 b 1174 7 1158 0 1168 3 b 1284 114 1182 14 1241 75 b 1316 144 1282 115 1312 141 b 1348 161 1331 156 1339 161 b 1371 145 1355 161 1361 157 b 1496 10 1377 137 1485 24 b 1525 0 1502 3 1513 0 b 1552 7 1536 0 1547 3 b 1819 298 1562 17 1800 276 b 1840 330 1829 308 1840 320 b 1832 344 1840 334 1837 340 b 1801 356 1820 351 1810 356 z"
        },
        ornamentPrecompDoubleCadenceUpperPrefixTurn: {
            x_min: 0,
            x_max: 1277,
            y_min: -62,
            y_max: 333,
            ha: 395,
            o: "m 1273 202 l 1273 480 l 1230 480 l 1230 174 l 1097 328 b 1053 354 1084 344 1071 353 b 1021 341 1041 354 1034 351 b 988 305 1008 331 998 317 b 865 167 945 261 904 215 l 861 161 b 717 328 808 222 724 318 b 672 354 704 344 691 353 b 641 341 661 354 654 351 b 608 305 628 331 618 317 b 485 167 564 261 524 215 b 455 132 474 156 465 144 b 284 45 410 88 350 45 b 14 284 148 45 30 264 b 3 294 9 291 4 294 b 0 289 1 294 0 291 b 1 284 0 287 1 284 b 308 -1 42 189 157 -1 b 530 118 415 0 481 62 b 557 143 539 127 547 135 b 590 161 572 154 582 161 b 612 144 598 161 603 156 b 737 9 618 135 724 24 b 768 -1 743 1 755 -1 b 793 6 778 -1 788 1 b 903 112 802 13 861 73 l 937 143 b 971 161 953 154 963 161 b 992 144 978 161 984 156 b 1117 9 998 135 1104 24 b 1148 -1 1123 1 1136 -1 b 1174 6 1158 -1 1168 1 l 1230 60 l 1230 -89 l 1273 -89 l 1273 102 l 1283 112 b 1348 160 1295 125 1332 160 b 1371 144 1355 160 1361 156 b 1496 9 1377 135 1483 24 b 1525 -1 1502 1 1513 -1 b 1552 6 1536 -1 1547 1 b 1819 297 1562 16 1800 275 b 1839 328 1827 307 1839 320 b 1801 354 1839 343 1813 354 b 1776 344 1793 354 1783 350 b 1642 190 1760 331 1657 206 b 1614 176 1630 180 1621 176 b 1591 189 1606 176 1597 183 b 1467 333 1578 203 1480 321 b 1430 354 1453 346 1441 354 b 1398 341 1420 354 1411 351 b 1365 305 1385 330 1377 317 z"
        },
        ornamentPrecompTrillLowerSuffix: {
            x_min: 0,
            x_max: 859,
            y_min: -222,
            y_max: 246,
            ha: 468,
            o: "m 1164 217 b 1031 351 1138 259 1063 351 b 1011 337 1020 351 1024 347 b 828 167 952 291 886 217 l 824 164 b 683 328 772 225 690 318 b 638 354 670 344 657 353 b 606 341 626 354 619 351 b 573 305 593 331 583 317 b 451 167 530 261 490 215 l 446 161 b 302 328 393 222 310 318 b 258 354 289 344 276 353 b 226 341 246 354 239 351 b 193 305 213 331 203 317 b 71 167 150 261 109 215 b 17 105 52 147 36 127 b 0 73 10 98 0 84 b 29 58 0 65 7 58 b 86 92 56 59 72 79 b 143 143 105 109 122 127 b 176 161 157 154 168 161 b 197 144 183 161 189 156 b 323 9 203 135 310 23 b 353 -1 328 1 340 -1 b 379 6 363 -1 373 1 b 488 112 387 13 446 73 l 523 143 b 556 161 539 154 549 161 b 577 144 563 161 569 156 b 703 9 583 135 690 23 b 733 -1 708 1 721 -1 b 759 6 743 -1 753 1 b 868 112 768 13 827 73 b 955 183 878 122 943 183 b 1081 107 965 183 1031 153 b 1156 -89 1128 63 1156 6 l 1156 -102 b 948 -297 1156 -204 1048 -297 b 806 -271 904 -297 850 -282 l 792 -266 b 801 -288 792 -268 795 -282 b 948 -320 809 -297 880 -320 b 1237 -50 1092 -320 1237 -199 b 1164 217 1237 75 1218 122 z"
        },
        brassScoop: {
            x_min: 1,
            x_max: 320,
            y_min: -373,
            y_max: 13,
            ha: 386,
            o: "m 35 -537 b 461 -12 194 -518 461 -289 b 438 19 461 13 451 19 b 410 -9 425 19 413 9 b 35 -425 357 -366 92 -403 b 1 -482 13 -433 1 -438 l 1 -505 b 26 -537 1 -526 3 -537 z"
        },
        brassDoitMedium: {
            x_min: 0,
            x_max: 489,
            y_min: -40,
            y_max: 346,
            ha: 386,
            o: "m 33 -58 b 704 468 255 -58 683 186 b 681 498 704 494 693 498 b 654 471 668 498 658 488 b 33 55 550 118 91 76 b 0 -3 12 46 0 42 l 0 -26 b 24 -58 0 -46 1 -58 z"
        },
        brassFallLipShort: {
            x_min: 1,
            x_max: 293,
            y_min: -345,
            y_max: 42,
            ha: 387,
            o: "m 22 60 b 1 35 4 60 1 52 l 1 6 b 26 -50 3 -40 10 -43 b 32 -52 27 -50 30 -50 b 376 -469 85 -73 327 -111 b 400 -497 379 -487 387 -497 b 422 -467 412 -497 422 -491 b 32 60 422 -187 177 40 z"
        },
        brassLiftMedium: {
            x_min: 0,
            x_max: 811,
            y_min: 0,
            y_max: 852,
            ha: 852,
            o: "m 1138 1220 b 1135 1225 1135 1223 1135 1224 b 1129 1227 1133 1227 1130 1227 b 1117 1207 1122 1227 1117 1212 l 1117 1201 b 1109 1164 1117 1187 1117 1172 b 1100 1156 1107 1161 1104 1158 b 959 1104 1058 1128 995 1140 b 929 1032 936 1081 929 1056 b 932 1007 929 1024 930 1015 b 923 976 932 995 930 985 l 914 971 b 773 919 873 942 809 955 b 743 847 750 896 743 870 b 746 821 743 838 744 829 b 737 791 746 809 744 799 l 729 783 b 588 733 687 756 624 769 b 557 661 564 710 557 684 b 560 635 557 652 559 644 b 552 605 560 624 559 612 l 543 598 b 402 547 501 570 438 583 b 372 475 379 524 372 498 b 374 449 372 467 373 458 b 366 419 374 438 373 426 l 357 412 b 216 361 315 384 252 397 b 186 289 193 338 186 312 b 189 264 186 281 187 272 b 180 233 189 252 187 240 b 171 226 177 232 174 229 b 30 176 130 199 66 212 b 0 104 7 153 0 128 b 33 0 0 88 14 0 b 49 17 40 0 49 10 b 71 63 52 35 56 49 b 212 115 102 95 154 59 b 239 186 230 134 239 160 b 236 210 239 194 238 202 b 256 249 239 225 243 236 b 397 301 288 281 340 245 b 425 372 416 320 425 346 b 422 396 425 380 423 387 b 442 435 425 410 429 422 b 583 487 474 467 526 431 b 611 557 602 505 611 531 b 608 582 611 566 609 573 b 628 621 611 596 615 608 b 769 672 660 652 711 618 b 796 743 788 691 796 717 b 793 768 796 752 795 759 b 814 806 796 782 801 793 b 955 858 845 838 897 804 b 982 929 973 877 982 903 b 979 953 982 937 981 945 b 999 992 982 968 986 979 b 1140 1045 1031 1024 1083 989 b 1168 1116 1161 1066 1168 1090 b 1138 1220 1168 1162 1145 1207 z"
        },
        brassFallRoughMedium: {
            x_min: 0,
            x_max: 811,
            y_min: 0,
            y_max: 852,
            ha: 852,
            o: "m 30 1220 b 0 1116 23 1207 0 1162 b 27 1045 0 1090 7 1066 b 168 992 85 989 137 1024 b 189 953 181 979 186 968 b 186 929 187 945 186 937 b 213 858 186 903 194 877 b 354 806 271 804 323 838 b 374 768 367 793 372 782 b 372 743 373 759 372 752 b 399 672 372 717 380 691 b 540 621 456 618 508 652 b 560 582 553 608 557 596 b 557 557 559 573 557 566 b 585 487 557 531 566 505 b 726 435 642 431 694 467 b 746 396 739 422 743 410 b 743 372 744 387 743 380 b 770 301 743 346 752 320 b 912 249 828 245 880 281 b 932 210 924 236 929 225 b 929 186 930 202 929 194 b 956 115 929 160 937 134 b 1097 63 1014 59 1066 95 b 1119 17 1112 49 1116 35 b 1135 0 1119 10 1128 0 b 1168 104 1153 0 1168 91 b 1138 176 1168 128 1161 153 b 996 226 1102 212 1038 199 b 988 233 994 229 991 232 b 979 264 981 240 979 252 b 982 289 981 272 982 281 b 952 361 982 312 975 338 b 811 412 916 397 852 384 l 802 419 b 793 449 795 426 793 438 b 796 475 795 458 796 467 b 766 547 796 498 789 524 b 625 598 730 583 667 570 l 616 605 b 608 635 609 612 608 624 b 611 661 609 644 611 652 b 580 733 611 684 603 710 b 439 783 544 769 481 756 l 431 791 b 422 821 423 799 422 809 b 425 847 423 829 425 838 b 395 919 425 870 418 896 b 253 971 359 955 295 942 l 245 976 b 236 1007 238 985 236 995 b 239 1032 238 1015 239 1024 b 209 1104 239 1056 232 1081 b 68 1156 173 1140 109 1128 b 59 1164 63 1158 60 1161 b 50 1201 50 1172 50 1187 l 50 1207 b 39 1227 50 1212 46 1227 b 33 1225 37 1227 35 1227 b 30 1220 33 1224 33 1223 z"
        },
        brassBend: {
            x_min: 0,
            x_max: 392,
            y_min: 0,
            y_max: 282,
            ha: 282,
            o: "m 282 0 b 552 72 369 0 456 23 b 564 92 560 75 564 84 l 564 383 b 541 406 564 395 554 406 b 518 383 528 406 518 395 l 518 107 b 282 46 435 65 357 46 b 46 107 207 46 130 65 l 46 383 b 23 406 46 395 36 406 b 0 383 10 406 0 395 l 0 92 b 13 72 0 84 4 75 b 282 0 108 23 196 0 z"
        },
        brassMuteClosed: {
            x_min: 0,
            x_max: 272,
            y_min: 0,
            y_max: 272,
            ha: 272,
            o: "m 392 219 l 219 219 l 219 392 l 173 392 l 173 219 l 0 219 l 0 173 l 173 173 l 173 0 l 219 0 l 219 173 l 392 173 z"
        },
        brassMuteOpen: {
            x_min: 0,
            x_max: 304,
            y_min: 0,
            y_max: 304,
            ha: 304,
            o: "m 219 0 b 438 219 340 0 438 98 b 219 438 438 340 340 438 b 0 219 98 438 0 340 b 219 0 0 98 98 0 z m 219 392 b 392 219 314 392 392 314 b 219 46 392 124 314 46 b 46 219 124 46 46 124 b 219 392 46 314 124 392 z"
        },
        brassFlip: {
            x_min: 0,
            x_max: 379,
            y_min: 0,
            y_max: 282,
            ha: 282,
            o: "m 523 0 b 541 9 530 0 536 3 b 546 22 544 13 546 17 b 536 42 546 29 541 36 l 36 402 b 23 406 33 405 27 406 b 0 383 12 406 0 395 l 0 23 b 23 0 0 10 10 0 b 46 23 36 0 46 10 l 46 337 l 508 4 b 523 0 513 1 517 0 z"
        },
        brassJazzTurn: {
            x_min: 0,
            x_max: 620,
            y_min: 0,
            y_max: 245,
            ha: 245,
            o: "m 792 190 b 765 176 780 179 772 176 b 740 190 755 176 747 183 b 629 325 727 202 644 312 b 593 347 616 338 605 347 b 562 334 583 346 575 344 b 528 298 549 323 539 310 l 406 176 b 389 168 406 176 399 168 b 374 176 384 168 379 170 b 245 325 360 192 245 325 b 200 353 232 343 219 351 b 168 340 190 353 181 350 l 17 156 b 0 121 10 147 0 132 b 16 107 0 114 4 108 b 84 143 26 107 76 137 b 118 160 92 150 108 160 b 141 143 125 160 131 154 b 265 10 147 135 253 24 b 294 0 271 3 282 0 b 321 7 305 0 315 3 b 498 160 321 7 478 158 b 521 143 505 160 513 154 b 647 10 528 135 635 24 b 675 0 652 3 664 0 b 703 7 687 0 697 3 b 874 186 713 16 855 164 b 893 220 881 196 893 212 b 873 245 890 235 883 243 b 796 194 847 245 815 213 z"
        },
        brassSmear: {
            x_min: 1,
            x_max: 306,
            y_min: 0,
            y_max: 170,
            ha: 170,
            o: "m 193 79 b 308 0 219 50 264 0 b 439 117 396 0 438 102 b 439 120 439 118 439 118 l 441 125 b 441 128 441 127 441 127 b 433 141 441 135 439 141 b 416 130 429 141 423 137 b 343 94 390 107 370 94 b 269 153 315 94 294 121 l 265 158 b 144 245 239 190 180 245 b 6 134 62 245 10 143 b 1 114 3 125 1 118 b 7 107 1 108 4 107 b 36 122 13 107 22 112 b 92 151 55 137 65 151 b 183 89 125 151 161 112 b 189 84 184 88 187 86 z"
        },
        stringsDownBow: {
            x_min: 0,
            x_max: 312,
            y_min: 0,
            y_max: 318,
            ha: 318,
            o: "m 37 458 b 0 420 17 458 0 441 l 0 17 b 17 0 0 7 9 0 l 37 0 b 55 17 46 0 55 7 l 55 253 b 225 278 55 269 140 278 b 395 253 310 278 395 269 l 395 17 b 413 0 395 7 403 0 l 432 0 b 449 17 441 0 449 7 l 449 420 b 412 458 449 441 432 458 z"
        },
        stringsUpBow: {
            x_min: 1,
            x_max: 249,
            y_min: 1,
            y_max: 495,
            ha: 494,
            o: "m 181 1 b 206 22 193 1 203 10 l 359 683 l 359 688 b 338 713 359 700 351 710 l 333 713 b 308 694 321 713 311 706 l 180 140 l 53 694 b 27 713 49 706 39 713 l 22 713 b 1 690 10 710 1 700 b 3 683 1 687 1 685 l 154 22 b 181 1 157 10 167 1 z"
        },
        stringsHarmonic: {
            x_min: 0,
            x_max: 200,
            y_min: 0,
            y_max: 200,
            ha: 200,
            o: "m 288 144 b 144 288 288 225 223 288 b 0 144 65 288 0 225 b 144 0 0 65 65 0 b 288 144 223 0 288 65 z m 144 249 b 249 144 203 249 249 203 b 144 39 249 86 203 39 b 39 144 86 39 39 86 b 144 249 39 203 86 249 z"
        },
        pluckedSnapPizzicatoAbove: {
            x_min: 0,
            x_max: 200,
            y_min: 0,
            y_max: 300,
            ha: 300,
            o: "m 0 144 b 144 0 0 63 65 0 b 288 144 223 0 288 63 b 167 285 288 215 235 275 l 167 432 l 121 432 l 121 285 b 0 144 52 275 0 215 z m 121 246 l 121 144 l 167 144 l 167 246 b 249 144 213 236 249 193 b 144 39 249 85 202 39 b 39 144 85 39 39 85 b 121 246 39 193 73 236 z"
        },
        pluckedSnapPizzicatoBelow: {
            x_min: 0,
            x_max: 200,
            y_min: 0,
            y_max: 300,
            ha: 300,
            o: "m 288 288 b 144 432 288 369 223 432 b 0 288 65 432 0 369 b 121 145 0 216 52 157 l 121 0 l 167 0 l 167 145 b 288 288 235 157 288 216 z m 167 186 l 167 288 l 121 288 l 121 186 b 39 288 75 196 39 238 b 144 393 39 347 86 393 b 249 288 203 393 249 347 b 167 186 249 238 215 196 z"
        },
        pluckedLeftHandPizzicato: {
            x_min: 0,
            x_max: 272,
            y_min: 0,
            y_max: 272,
            ha: 272,
            o: "m 392 219 l 219 219 l 219 392 l 173 392 l 173 219 l 0 219 l 0 173 l 173 173 l 173 0 l 219 0 l 219 173 l 392 173 z"
        },
        keyboardPedalPed: {
            x_min: 0,
            x_max: 1019,
            y_min: -8,
            y_max: 555,
            ha: 563,
            o: "m 413 799 b 179 749 327 798 261 789 b 0 517 107 713 0 632 b 122 376 0 454 37 376 b 240 540 189 376 240 452 b 225 586 240 579 233 586 b 204 549 213 586 212 573 b 138 480 199 527 181 480 b 85 549 96 480 85 517 l 85 554 b 353 762 89 690 230 762 b 373 752 364 762 373 760 b 351 708 373 740 360 723 b 274 546 330 675 274 585 b 353 416 274 508 333 444 b 412 304 372 390 412 351 b 382 228 412 275 403 256 b 334 190 363 202 361 200 b 147 29 271 167 147 88 b 196 -12 147 4 171 -12 b 343 108 239 -12 279 33 l 363 132 b 387 150 370 141 376 150 b 543 -4 445 150 467 -4 b 631 42 567 -4 586 0 l 668 78 b 685 89 674 84 680 89 b 696 75 688 89 690 86 b 809 -9 717 29 753 -9 b 946 66 854 -9 894 13 b 988 107 971 92 981 107 b 1002 89 994 107 996 99 b 1152 -4 1030 36 1077 -4 b 1329 248 1238 -4 1329 82 b 792 717 1329 556 1047 665 b 766 720 785 719 775 720 b 747 703 752 720 747 711 b 780 680 747 693 756 685 b 1223 222 1028 621 1223 504 b 1152 39 1223 122 1205 39 b 1073 229 1104 39 1073 132 b 1132 423 1073 314 1086 377 b 1142 442 1140 432 1142 436 b 1126 458 1142 451 1136 458 b 1093 446 1119 458 1109 455 b 975 216 1022 408 975 337 l 975 190 b 943 121 975 160 972 150 b 852 69 899 76 877 69 b 776 148 816 69 786 117 b 773 163 775 154 773 158 b 786 177 773 167 776 170 l 801 187 b 937 366 867 235 937 284 b 844 454 937 422 900 454 b 665 217 711 454 665 331 b 671 153 665 197 667 176 l 671 147 b 662 134 671 143 670 140 b 605 111 639 118 625 111 b 521 160 572 111 546 135 b 451 203 497 184 474 197 b 426 212 435 207 426 206 b 436 230 426 216 429 220 b 510 389 464 269 510 340 b 429 521 510 435 480 462 b 369 629 387 570 369 599 b 402 720 369 648 384 691 b 462 763 425 759 446 763 b 611 624 540 763 611 704 b 564 575 611 592 590 575 b 501 602 540 575 520 582 b 474 622 492 611 487 622 b 459 603 465 622 459 615 b 603 471 459 570 510 471 b 711 588 670 471 711 524 b 422 799 711 742 554 799 z m 815 403 b 848 343 838 403 848 383 b 780 226 848 295 824 261 b 765 217 773 220 768 217 b 759 228 762 217 759 220 b 756 282 757 245 756 262 b 815 403 756 346 772 403 z m 1405 124 b 1344 62 1369 124 1344 98 b 1405 0 1344 26 1369 0 b 1467 62 1441 0 1467 26 b 1405 124 1467 98 1441 124 z"
        },
        keyboardPedalUp: {
            x_min: 0,
            x_max: 450,
            y_min: 0,
            y_max: 450,
            ha: 450,
            o: "m 582 396 b 516 367 554 396 533 384 b 465 340 495 347 487 340 l 458 340 b 412 377 432 340 412 348 b 432 409 412 387 419 396 l 438 415 b 490 429 451 428 464 429 b 575 501 534 429 575 452 b 501 575 575 541 541 575 b 429 490 452 575 429 534 b 415 438 429 464 428 451 l 409 432 b 377 412 396 419 387 412 b 340 458 348 412 340 432 l 340 465 b 367 516 340 487 347 495 b 396 582 384 533 396 554 b 324 648 396 625 363 648 b 252 582 285 648 252 625 b 281 516 252 554 264 533 b 308 465 301 495 308 487 l 308 458 b 271 412 308 432 300 412 b 239 432 261 412 252 419 l 233 438 b 219 490 220 451 219 464 b 147 575 219 534 196 575 b 73 501 107 575 73 541 b 158 429 73 452 114 429 b 210 415 184 429 197 428 l 216 409 b 236 377 229 396 236 387 b 190 340 236 348 216 340 l 183 340 b 132 367 161 340 153 347 b 66 396 115 384 94 396 b 0 324 23 396 0 363 b 66 252 0 285 23 252 b 132 281 94 252 115 264 b 183 308 153 301 161 308 l 190 308 b 236 271 216 308 236 300 b 216 239 236 261 229 252 l 210 233 b 158 219 197 220 184 219 b 73 147 114 219 73 196 b 147 73 73 107 107 73 b 219 158 196 73 219 114 b 233 210 219 184 220 197 l 239 216 b 271 236 252 229 261 236 b 308 190 300 236 308 216 l 308 183 b 281 132 308 161 301 153 b 252 66 264 115 252 94 b 324 0 252 23 285 0 b 396 66 363 0 396 23 b 367 132 396 94 384 115 b 340 183 347 153 340 161 l 340 190 b 377 236 340 216 348 236 b 409 216 387 236 396 229 l 415 210 b 429 158 428 197 429 184 b 501 73 429 114 452 73 b 575 147 541 73 575 107 b 490 219 575 196 534 219 b 438 233 464 219 451 220 l 432 239 b 412 271 419 252 412 261 b 458 308 412 300 432 308 l 465 308 b 516 281 487 308 495 301 b 582 252 533 264 554 252 b 648 324 625 252 648 285 b 582 396 648 363 625 396 z m 324 271 b 271 324 291 271 271 291 b 324 377 271 357 291 377 b 377 324 357 377 377 357 b 324 271 377 291 357 271 z"
        },
        pictChokeCymbal: {
            x_min: 1,
            x_max: 152,
            y_min: 2,
            y_max: 251,
            ha: 249,
            o: "m 104 361 b 1 271 42 361 1 321 b 82 190 1 222 35 190 b 122 160 118 190 122 160 b 125 144 124 154 125 150 b 102 88 125 124 115 105 b 37 32 78 56 40 35 b 26 17 32 29 26 26 l 27 16 b 37 3 29 6 33 3 b 181 102 85 3 158 66 b 219 239 210 147 219 197 l 219 249 b 104 361 219 317 170 361 z"
        },
        wiggleArpeggiatoUp: {
            x_min: -33,
            x_max: 292,
            y_min: 0,
            y_max: 119,
            ha: 119,
            o: "m 130 171 b -39 68 16 171 -14 91 b -48 53 -45 62 -48 58 b -29 42 -48 46 -39 42 b -10 46 -23 42 -16 43 b 56 63 12 56 29 63 b 248 0 121 63 135 0 b 419 127 361 0 410 104 b 420 132 420 130 420 131 b 412 140 420 137 416 140 b 386 130 403 140 392 134 b 334 107 367 117 353 107 b 318 108 330 107 324 107 b 240 138 289 112 265 128 b 130 171 209 153 168 171 z"
        },
        arrowheadBlackUp: {
            x_min: 0,
            x_max: 228,
            y_min: 0,
            y_max: 299,
            ha: 299,
            o: "m 166 431 b 0 20 111 274 0 30 b 16 0 0 12 6 0 l 17 1 b 166 50 43 16 160 50 b 310 1 171 50 289 13 l 311 0 b 328 20 321 0 328 12 b 166 431 328 30 220 274 z"
        },
        arrowheadBlackDown: {
            x_min: 0,
            x_max: 228,
            y_min: 0,
            y_max: 299,
            ha: 299,
            o: "m 166 0 b 328 410 220 157 328 400 b 311 431 328 419 321 431 l 310 429 b 166 380 289 418 171 380 b 17 429 160 380 43 415 l 16 431 b 0 410 6 431 0 419 b 166 0 0 400 111 157 z"
        },
        arpeggiatoUp: {
            x_min: 1,
            x_max: 229,
            y_min: 7,
            y_max: 1511,
            ha: 1504,
            o: "m 219 1848 l 330 1848 l 164 2176 l 1 1848 l 121 1848 b 92 1778 115 1822 101 1800 l 89 1773 b 59 1668 75 1741 59 1702 b 96 1555 59 1614 76 1580 b 99 1551 98 1554 99 1551 l 102 1547 b 124 1496 115 1531 124 1515 b 122 1482 124 1492 124 1488 b 92 1404 118 1453 102 1428 b 59 1293 78 1372 59 1332 b 105 1172 59 1234 81 1198 b 124 1120 118 1155 124 1143 l 122 1113 b 122 1110 122 1113 122 1112 b 92 1032 118 1081 102 1057 b 59 922 78 1001 59 960 b 115 792 59 855 86 816 b 124 760 121 782 124 773 b 122 744 124 756 124 750 b 92 667 118 716 102 693 b 59 556 78 635 59 595 b 108 433 59 495 82 458 b 124 389 117 420 124 408 b 122 374 124 384 124 379 b 92 298 118 346 102 323 l 89 292 b 59 186 75 261 59 222 b 163 19 59 73 140 42 b 177 10 168 13 173 10 b 189 29 184 10 189 19 b 184 48 189 35 187 42 b 167 114 174 69 167 85 b 230 305 167 179 229 193 b 181 423 230 357 209 396 b 167 484 173 442 167 458 b 230 675 167 547 229 563 b 179 796 230 729 206 769 b 167 850 171 812 167 827 b 230 1040 167 913 229 929 b 183 1158 230 1092 209 1130 b 167 1220 173 1178 167 1194 b 230 1411 167 1284 229 1300 b 186 1526 230 1462 210 1499 b 167 1594 176 1529 167 1584 b 230 1786 167 1659 229 1673 b 219 1848 230 1809 226 1829 z"
        },
        arpeggiatoDown: {
            x_min: 1,
            x_max: 229,
            y_min: -4,
            y_max: 1500,
            ha: 1504,
            o: "m 219 323 b 230 384 226 341 230 361 b 167 576 229 497 167 511 b 186 644 167 586 176 641 b 230 759 210 671 230 708 b 167 950 229 870 167 886 b 183 1012 167 976 173 992 b 230 1130 209 1040 230 1079 b 167 1320 229 1241 167 1257 b 179 1374 167 1344 171 1358 b 230 1495 206 1401 230 1441 b 167 1686 229 1607 167 1623 b 181 1747 167 1712 173 1728 b 230 1865 209 1774 230 1813 b 167 2056 229 1977 167 1992 b 184 2123 167 2085 174 2101 b 189 2141 187 2128 189 2136 b 177 2160 189 2151 184 2160 b 163 2151 173 2160 168 2157 b 59 1984 140 2128 59 2097 b 89 1878 59 1948 75 1909 l 92 1872 b 122 1796 102 1848 118 1824 b 124 1781 124 1791 124 1786 b 108 1737 124 1763 117 1750 b 59 1614 82 1712 59 1675 b 92 1503 59 1575 78 1535 b 122 1426 102 1477 118 1454 b 124 1410 124 1420 124 1414 b 115 1378 124 1397 121 1388 b 59 1248 86 1354 59 1315 b 92 1138 59 1210 78 1169 b 122 1060 102 1113 118 1089 b 122 1057 122 1058 122 1058 l 124 1050 b 105 998 124 1027 118 1015 b 59 877 81 972 59 936 b 92 766 59 838 78 798 b 122 688 102 742 118 717 b 124 674 124 683 124 678 b 102 624 124 655 115 639 l 99 619 b 96 615 99 619 98 616 b 59 503 76 590 59 556 b 89 397 59 468 75 429 l 92 392 b 121 323 101 370 115 348 l 1 323 l 164 -6 l 330 323 z"
        },
        repeat1Bar: {
            x_min: 0,
            x_max: 532,
            y_min: -250,
            y_max: 279,
            ha: 529,
            o: "m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z m 89 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 z m 675 -71 b 586 -161 626 -71 586 -111 b 675 -251 586 -210 626 -251 b 766 -161 726 -251 766 -210 b 675 -71 766 -111 726 -71 z"
        },
        repeat2Bars: {
            x_min: 0,
            x_max: 762,
            y_min: -250,
            y_max: 279,
            ha: 529,
            o: "m 1090 380 b 1097 395 1094 386 1097 390 b 1089 402 1097 399 1094 402 l 936 402 b 910 380 927 402 920 393 l 336 -340 b 331 -350 333 -343 331 -347 b 343 -360 331 -356 336 -360 l 485 -360 b 516 -340 498 -360 508 -348 z m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z m 89 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 z m 1007 -71 b 917 -161 958 -71 917 -111 b 1007 -251 917 -210 958 -251 b 1097 -161 1057 -251 1097 -210 b 1007 -71 1097 -111 1057 -71 z"
        },
        repeat4Bars: {
            x_min: 0,
            x_max: 1232,
            y_min: -250,
            y_max: 279,
            ha: 529,
            o: "m 1767 380 b 1774 395 1771 386 1774 390 b 1765 402 1774 399 1771 402 l 1613 402 b 1587 380 1604 402 1597 393 l 1012 -340 b 1008 -350 1009 -343 1008 -347 b 1020 -360 1008 -356 1012 -360 l 1162 -360 b 1192 -340 1175 -360 1185 -348 z m 1436 380 b 1443 395 1440 386 1443 390 b 1434 402 1443 399 1440 402 l 1282 402 b 1256 380 1273 402 1266 393 l 681 -340 b 677 -350 678 -343 677 -347 b 688 -360 677 -356 681 -360 l 831 -360 b 861 -340 844 -360 854 -348 z m 1090 380 b 1097 395 1094 386 1097 390 b 1089 402 1097 399 1094 402 l 936 402 b 910 380 927 402 920 393 l 336 -340 b 331 -350 333 -343 331 -347 b 343 -360 331 -356 336 -360 l 485 -360 b 516 -340 498 -360 508 -348 z m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z m 89 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 z m 1683 -71 b 1594 -161 1634 -71 1594 -111 b 1683 -251 1594 -210 1634 -251 b 1774 -161 1734 -251 1774 -210 b 1683 -71 1774 -111 1734 -71 z"
        },
        repeatBarSlash: {
            x_min: 0,
            x_max: 532,
            y_min: -250,
            y_max: 279,
            ha: 529,
            o: "m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z"
        },
        csymDiminished: {
            x_min: 0,
            x_max: 473,
            y_min: 0,
            y_max: 473,
            ha: 473,
            o: "m 341 681 b 0 341 153 681 0 530 b 341 0 0 153 153 0 b 681 341 530 0 681 153 b 341 681 681 530 530 681 z m 341 618 b 618 341 495 618 618 495 b 341 63 618 189 494 63 b 63 341 187 63 63 187 b 341 618 63 494 189 618 z"
        },
        csymHalfDiminished: {
            x_min: -16,
            x_max: 488,
            y_min: -15,
            y_max: 489,
            ha: 504,
            o: "m 703 660 l 658 704 l 557 603 b 340 681 498 652 422 681 b -1 341 151 681 -1 530 b 78 124 -1 259 29 183 l -23 23 l 22 -22 l 122 79 b 340 0 181 30 258 0 b 680 341 528 0 680 153 b 602 559 680 423 651 500 z m 62 341 b 340 618 62 494 187 618 b 513 559 403 618 464 598 l 122 168 b 62 341 84 217 62 278 z m 616 341 b 340 63 616 189 492 63 b 167 124 276 63 216 85 l 557 514 b 616 341 596 465 616 405 z"
        },
        csymAugmented: {
            x_min: 0,
            x_max: 395,
            y_min: 1,
            y_max: 396,
            ha: 395,
            o: "m 569 318 l 317 318 l 317 570 l 253 570 l 253 318 l 0 318 l 0 255 l 253 255 l 253 1 l 317 1 l 317 255 l 569 255 z"
        },
        csymMajorSeventh: {
            x_min: 0,
            x_max: 558,
            y_min: 1,
            y_max: 477,
            ha: 476,
            o: "m 402 687 l 0 1 l 804 1 z m 402 562 l 693 65 l 111 65 z"
        },
        csymMinor: {
            x_min: 0,
            x_max: 325,
            y_min: 216,
            y_max: 260,
            ha: 44,
            o: "m 468 374 l 0 374 l 0 311 l 468 311 z"
        },
        csymParensLeftTall: {
            x_min: 1,
            x_max: 185,
            y_min: 0,
            y_max: 997,
            ha: 997,
            o: "m 266 48 b 261 65 266 55 264 62 b 92 719 157 212 92 400 b 262 1371 92 1037 154 1228 b 266 1394 266 1378 266 1394 l 266 1424 b 264 1436 266 1431 266 1436 b 259 1434 262 1436 259 1434 b 1 719 84 1261 1 1011 b 259 1 1 429 79 177 b 264 0 261 0 262 0 b 266 9 265 0 266 6 z"
        },
        csymParensRightTall: {
            x_min: -20,
            x_max: 164,
            y_min: 0,
            y_max: 997,
            ha: 997,
            o: "m -29 9 b -26 0 -29 6 -27 0 b -22 1 -24 0 -23 0 b 236 719 158 177 236 429 b -22 1434 236 1011 154 1261 b -26 1436 -22 1434 -24 1436 b -29 1424 -29 1436 -29 1431 l -29 1394 b -24 1371 -29 1394 -29 1378 b 145 719 84 1228 145 1037 b -23 65 145 400 81 212 b -29 48 -26 62 -29 55 z"
        },
        csymBracketLeftTall: {
            x_min: 0,
            x_max: 155,
            y_min: 0,
            y_max: 1e3,
            ha: 1e3,
            o: "m 217 0 b 223 9 220 0 223 4 l 223 37 b 217 46 223 42 220 46 l 92 46 l 92 1394 l 217 1394 b 223 1403 220 1394 223 1398 l 223 1431 b 217 1440 223 1436 220 1440 l 6 1440 b 0 1436 3 1440 0 1439 l 0 4 b 6 0 0 1 3 0 z"
        },
        csymBracketRightTall: {
            x_min: 1,
            x_max: 156,
            y_min: 0,
            y_max: 1e3,
            ha: 1e3,
            o: "m 219 0 b 225 4 222 0 225 1 l 225 1436 b 219 1440 225 1439 222 1440 l 7 1440 b 1 1431 4 1440 1 1436 l 1 1403 b 7 1394 1 1398 4 1394 l 132 1394 l 132 46 l 7 46 b 1 37 4 46 1 42 l 1 9 b 7 0 1 4 4 0 z"
        },
        csymParensLeftVeryTall: {
            x_min: 0,
            x_max: 122,
            y_min: 0,
            y_max: 993,
            ha: 993,
            o: "m 176 32 b 171 49 176 39 174 46 b 60 716 104 194 60 399 b 173 1382 60 1032 101 1241 b 176 1405 176 1390 176 1405 l 176 1427 b 173 1430 176 1428 174 1430 b 0 716 40 1297 0 978 b 170 3 0 428 50 179 b 171 0 170 1 170 0 b 176 6 173 0 176 4 z"
        },
        csymParensRightVeryTall: {
            x_min: -15,
            x_max: 107,
            y_min: 0,
            y_max: 993,
            ha: 993,
            o: "m -22 6 b -17 0 -22 4 -19 0 b -16 3 -16 0 -16 1 b 154 716 104 179 154 428 b -19 1430 154 978 114 1297 b -22 1427 -20 1430 -22 1428 l -22 1405 b -19 1382 -22 1405 -22 1390 b 94 716 53 1241 94 1032 b -17 49 94 399 50 194 b -22 32 -20 46 -22 39 z"
        },
        csymDiagonalArrangementSlash: {
            x_min: 0,
            x_max: 999,
            y_min: 0,
            y_max: 1e3,
            ha: 1e3,
            o: "m 1439 1380 l 1377 1440 l 0 60 l 62 0 z"
        },
        accSagittal5v7KleismaUp: {
            x_min: 0,
            x_max: 156,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 -35 b 135 -112 68 -86 99 -112 b 225 68 194 -112 225 -53 l 180 68 b 144 -4 180 20 168 -4 b 122 0 138 -4 131 -3 b 23 248 86 14 52 96 l 0 248 z"
        },
        accSagittal5v7KleismaDown: {
            x_min: 0,
            x_max: 156,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 23 -248 b 122 0 52 -96 86 -14 b 144 4 131 3 138 4 b 180 -68 168 4 180 -20 l 225 -68 b 135 112 225 53 194 112 b 45 35 99 112 68 86 l 45 517 l 0 517 z"
        },
        accSagittal5CommaUp: {
            x_min: 0,
            x_max: 156,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 225 -517 l 225 248 l 203 248 l 0 -112 l 0 -284 l 180 33 l 180 -517 z"
        },
        accSagittal5CommaDown: {
            x_min: 0,
            x_max: 156,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 180 517 l 180 -33 l 0 284 l 0 112 l 203 -248 l 225 -248 l 225 517 z"
        },
        accSagittal7CommaUp: {
            x_min: 0,
            x_max: 156,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 248 l 0 -517 l 45 -517 l 45 112 l 89 112 b 180 -68 150 112 180 53 l 180 -248 l 225 -248 l 225 68 b 135 248 225 187 194 248 z"
        },
        accSagittal7CommaDown: {
            x_min: 0,
            x_max: 156,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 135 -248 b 225 -68 194 -248 225 -187 l 225 248 l 180 248 l 180 68 b 89 -112 180 -53 150 -112 l 45 -112 l 45 517 l 0 517 l 0 -248 z"
        },
        accSagittal25SmallDiesisUp: {
            x_min: 0,
            x_max: 250,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -157 l 0 -259 l 315 -89 l 315 -517 l 360 -517 l 360 248 l 337 248 l 0 68 l 0 -33 l 315 135 l 315 10 z"
        },
        accSagittal25SmallDiesisDown: {
            x_min: 0,
            x_max: 250,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 315 -10 l 315 -135 l 0 33 l 0 -68 l 337 -248 l 360 -248 l 360 517 l 315 517 l 315 89 l 0 259 l 0 157 z"
        },
        accSagittal35MediumDiesisUp: {
            x_min: 0,
            x_max: 281,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -68 330 112 360 53 l 360 -248 l 405 -248 l 405 68 b 315 248 405 187 374 248 l 203 248 l 0 -112 z"
        },
        accSagittal35MediumDiesisDown: {
            x_min: 0,
            x_max: 281,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 112 l 203 -248 l 315 -248 b 405 -68 374 -248 405 -187 l 405 248 l 360 248 l 360 68 b 271 -112 360 -53 330 -112 l 225 -112 l 225 517 l 180 517 l 180 -33 l 0 284 z"
        },
        accSagittal11MediumDiesisUp: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 225 53 l 225 -517 l 271 -517 l 271 53 l 495 -248 l 495 -89 l 248 248 l 0 -89 l 0 -248 z"
        },
        accSagittal11MediumDiesisDown: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 248 l 0 89 l 248 -248 l 495 89 l 495 248 l 271 -53 l 271 517 l 225 517 l 225 -53 z"
        },
        accSagittal11LargeDiesisUp: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 112 l 315 112 b 449 -68 405 112 449 53 l 449 -248 l 495 -248 l 495 68 b 360 248 495 187 449 248 l 135 248 b 0 68 45 248 0 187 z"
        },
        accSagittal11LargeDiesisDown: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 135 -248 0 -187 45 -248 l 360 -248 b 495 -68 449 -248 495 -187 l 495 248 l 449 248 l 449 68 b 315 -112 449 -53 405 -112 l 271 -112 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
        },
        accSagittal35LargeDiesisUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 135 -248 0 -187 45 -248 l 248 -248 l 540 112 l 540 274 l 271 -58 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
        },
        accSagittal35LargeDiesisDown: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 135 -248 0 -187 45 -248 l 248 -248 l 540 112 l 540 274 l 269 -58 l 269 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
        },
        accSagittalSharp25SDown: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 b 112 -112 0 -53 36 -112 l 135 -112 l 135 -517 l 180 -517 l 180 -89 b 248 26 206 -65 229 -27 b 315 -89 264 -27 287 -65 l 315 -517 l 360 -517 l 360 -112 l 383 -112 b 495 68 458 -112 495 -53 l 449 68 b 399 -4 449 20 433 -4 b 248 248 297 -4 261 171 b 122 0 216 96 176 14 b 94 -4 112 -3 102 -4 b 45 68 60 -4 45 20 z"
        },
        accSagittalFlat25SUp: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 45 -68 b 94 4 45 -20 60 4 b 122 0 102 4 112 3 b 248 -248 176 -14 216 -96 b 399 4 261 -171 297 4 b 449 -68 433 4 449 -20 l 495 -68 b 383 112 495 53 458 112 l 360 112 l 360 517 l 315 517 l 315 89 b 248 -26 287 65 264 27 b 180 89 229 27 206 65 l 180 517 l 135 517 l 135 112 l 112 112 b 0 -68 36 112 0 53 z"
        },
        accSagittalSharp7CDown: {
            x_min: 0,
            x_max: 250,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 112 l 89 112 b 180 104 124 112 154 109 l 180 -517 l 225 -517 l 225 89 b 315 -68 285 60 315 9 l 315 -248 l 360 -248 l 360 68 b 135 248 360 187 285 248 l 0 248 z"
        },
        accSagittalFlat7CUp: {
            x_min: 0,
            x_max: 250,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 135 -248 b 360 -68 285 -248 360 -187 l 360 248 l 315 248 l 315 68 b 225 -89 315 -9 285 -60 l 225 517 l 180 517 l 180 -104 b 89 -112 154 -109 124 -112 l 45 -112 l 45 517 l 0 517 z"
        },
        accSagittalSharp5CDown: {
            x_min: 0,
            x_max: 281,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -517 l 45 71 l 180 -56 l 180 -517 l 225 -517 l 225 -98 l 405 -268 l 405 -112 l 23 248 l 0 248 l 0 -517 z"
        },
        accSagittalFlat5CUp: {
            x_min: 0,
            x_max: 281,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 517 l 0 -248 l 23 -248 l 405 112 l 405 268 l 225 98 l 225 517 l 180 517 l 180 56 l 45 -71 l 45 517 z"
        },
        accSagittalSharp5v7kDown: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -112 l 0 -276 l 135 -82 l 135 -517 l 180 -517 l 180 -17 l 271 112 l 315 112 l 315 -517 l 360 -517 l 360 107 b 449 -68 420 89 449 30 l 449 -248 l 495 -248 l 495 68 b 360 248 495 189 449 248 l 248 248 z"
        },
        accSagittalFlat5v7kUp: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 248 -248 l 360 -248 b 495 -68 449 -248 495 -189 l 495 248 l 449 248 l 449 68 b 360 -107 449 -30 420 -89 l 360 517 l 315 517 l 315 -112 l 271 -112 l 180 17 l 180 517 l 135 517 l 135 82 l 0 276 l 0 112 z"
        },
        accSagittalSharp: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 180 -53 l 180 -517 l 225 -517 l 225 0 l 292 85 l 360 0 l 360 -517 l 405 -517 l 405 -53 l 585 -274 l 585 -112 l 292 248 l 0 -112 l 0 -274 z"
        },
        accSagittalFlat: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 274 l 0 112 l 292 -248 l 585 112 l 585 274 l 405 53 l 405 517 l 360 517 l 360 0 l 292 -85 l 225 0 l 225 517 l 180 517 l 180 53 z"
        },
        accSagittalSharp5v7kUp: {
            x_min: 0,
            x_max: 312,
            y_min: -361,
            y_max: 172,
            ha: 533,
            o: "m 45 -517 l 45 -10 b 135 -92 68 -48 98 -75 l 135 -520 l 180 -520 l 180 -108 b 248 -115 203 -112 225 -115 b 271 -112 256 -115 264 -115 l 271 -517 l 315 -517 l 315 -107 b 449 68 405 -89 449 -30 l 405 68 b 297 -4 405 19 369 -4 b 23 248 131 -4 56 85 l 0 248 l 0 -517 z"
        },
        accSagittalFlat5v7kDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 361,
            ha: 533,
            o: "m 0 517 l 0 -248 l 23 -248 b 297 4 56 -85 131 4 b 405 -68 369 4 405 -19 l 449 -68 b 315 107 449 30 405 89 l 315 517 l 271 517 l 271 112 b 248 115 264 115 256 115 b 180 108 225 115 203 112 l 180 520 l 135 520 l 135 92 b 45 10 98 75 68 48 l 45 517 z"
        },
        accSagittalSharp5CUp: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -266 l 135 -153 l 135 -517 l 180 -517 l 180 -115 l 271 -39 l 271 -517 l 315 -517 l 315 0 l 405 75 l 405 -517 l 449 -517 l 449 248 l 428 248 l 0 -112 z"
        },
        accSagittalFlat5CDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 112 l 428 -248 l 449 -248 l 449 517 l 405 517 l 405 -75 l 315 0 l 315 517 l 271 517 l 271 39 l 180 115 l 180 517 l 135 517 l 135 153 l 0 266 z"
        },
        accSagittalSharp7CUp: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 112 l 135 112 l 135 -517 l 180 -517 l 180 108 b 271 89 213 105 243 99 l 271 -517 l 315 -517 l 315 73 b 405 -68 374 45 405 -3 l 405 -248 l 449 -248 l 449 68 b 135 248 449 187 346 248 l 0 248 z"
        },
        accSagittalFlat7CDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 135 -248 b 449 -68 346 -248 449 -187 l 449 248 l 405 248 l 405 68 b 315 -73 405 3 374 -45 l 315 517 l 271 517 l 271 -89 b 180 -108 243 -99 213 -105 l 180 517 l 135 517 l 135 -112 l 45 -112 l 45 517 l 0 517 z"
        },
        accSagittalSharp25SUp: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -30 l 495 143 l 495 14 l 0 -157 l 0 -255 l 225 -177 l 225 -517 l 271 -517 l 271 -161 l 360 -130 l 360 -517 l 405 -517 l 405 -115 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 517 248 l 0 68 z"
        },
        accSagittalFlat25SDown: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 l 517 -248 l 540 -248 l 540 517 l 495 517 l 495 84 l 405 115 l 405 517 l 360 517 l 360 130 l 271 161 l 271 517 l 225 517 l 225 177 l 0 255 l 0 157 l 495 -14 l 495 -143 l 0 30 z"
        },
        accSagittalSharp35MUp: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -112 l 0 -274 l 135 -108 l 135 -517 l 180 -517 l 180 -53 l 271 58 l 271 -517 l 315 -517 l 315 112 l 360 112 b 405 109 376 112 390 112 l 405 -517 l 449 -517 l 449 96 b 540 -68 510 72 540 17 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 z"
        },
        accSagittalFlat35MDown: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 292 -248 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 449 -96 540 -17 510 -72 l 449 517 l 405 517 l 405 -109 b 360 -112 390 -112 376 -112 l 315 -112 l 315 517 l 271 517 l 271 -58 l 180 53 l 180 517 l 135 517 l 135 108 l 0 274 l 0 112 z"
        },
        accSagittalSharp11MUp: {
            x_min: 0,
            x_max: 469,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -112 l 0 -271 l 180 -79 l 180 -517 l 225 -517 l 225 -30 l 315 65 l 315 -517 l 360 -517 l 360 65 l 449 -30 l 449 -517 l 495 -517 l 495 -79 l 675 -271 l 675 -112 l 337 248 z"
        },
        accSagittalFlat11MDown: {
            x_min: 0,
            x_max: 469,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 337 -248 l 675 112 l 675 271 l 495 79 l 495 517 l 449 517 l 449 30 l 360 -65 l 360 517 l 315 517 l 315 -65 l 225 30 l 225 517 l 180 517 l 180 79 l 0 271 l 0 112 z"
        },
        accSagittalSharp11LUp: {
            x_min: 0,
            x_max: 469,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 112 l 449 112 l 449 -517 l 495 -517 l 495 104 b 631 -68 585 82 631 26 l 631 -248 l 675 -248 l 675 68 b 449 248 675 187 600 248 l 225 248 b 0 68 75 248 0 187 z"
        },
        accSagittalFlat11LDown: {
            x_min: 0,
            x_max: 469,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 225 -248 0 -187 75 -248 l 449 -248 b 675 -68 600 -248 675 -187 l 675 248 l 631 248 l 631 68 b 495 -104 631 -26 585 -82 l 495 517 l 449 517 l 449 -112 l 360 -112 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
        },
        accSagittalSharp35LUp: {
            x_min: 0,
            x_max: 500,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 71 l 452 -17 l 452 -517 l 495 -517 l 495 -56 l 720 -268 l 720 -112 l 337 248 l 225 248 b 0 68 75 248 0 187 z"
        },
        accSagittalFlat35LDown: {
            x_min: 0,
            x_max: 500,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 225 -248 0 -187 75 -248 l 337 -248 l 720 112 l 720 268 l 495 56 l 495 517 l 452 517 l 452 17 l 360 -71 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
        },
        accSagittalDoubleSharp25SDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 b 135 -112 0 -53 45 -112 b 243 -62 180 -112 215 -95 l 89 -503 l 143 -517 l 292 -82 l 445 -517 l 495 -503 l 343 -62 b 449 -112 372 -95 408 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 315 148 b 112 -4 274 148 236 -4 b 45 68 68 -4 45 20 z"
        },
        accSagittalDoubleFlat25SUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 45 -68 b 112 4 45 -20 68 4 b 292 -248 236 4 274 -148 b 475 4 315 -148 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 b 343 62 408 112 372 95 l 495 503 l 445 517 l 292 82 l 143 517 l 89 503 l 243 62 b 135 112 215 95 180 112 b 0 -68 45 112 0 53 z"
        },
        accSagittalDoubleSharp7CDown: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -503 l 52 -517 l 203 -82 l 354 -517 l 405 -503 l 230 0 l 271 108 b 495 -68 420 92 495 35 l 495 -248 l 540 -248 l 540 68 b 225 248 540 187 435 248 l 89 248 l 89 112 l 135 112 l 174 0 z m 213 112 l 203 82 l 192 112 z"
        },
        accSagittalDoubleFlat7CUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 174 0 l 135 -112 l 89 -112 l 89 -248 l 225 -248 b 540 -68 435 -248 540 -187 l 540 248 l 495 248 l 495 68 b 271 -108 495 -35 420 -92 l 230 0 l 405 503 l 354 517 l 203 82 l 52 517 l 0 503 z m 192 -112 l 203 -82 l 213 -112 z"
        },
        accSagittalDoubleSharp5CDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 405 -503 l 230 0 l 232 4 l 585 -264 l 585 -112 l 112 248 l 89 248 l 89 112 l 151 68 l 174 0 l 0 -503 l 52 -517 l 203 -82 l 354 -517 z"
        },
        accSagittalDoubleFlat5CUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 354 517 l 203 82 l 52 517 l 0 503 l 174 0 l 151 -68 l 89 -112 l 89 -248 l 112 -248 l 585 112 l 585 264 l 232 -4 l 230 0 l 405 503 z"
        },
        accSagittalDoubleSharp5v7kDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -274 l 252 35 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 360 112 b 540 -68 480 112 540 53 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 l 0 -112 z"
        },
        accSagittalDoubleFlat5v7kUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 112 l 292 -248 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 360 -112 540 -53 480 -112 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 252 -35 l 0 274 z"
        },
        accSagittalDoubleSharp: {
            x_min: 0,
            x_max: 469,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 540 -503 l 366 0 l 380 45 l 675 -271 l 675 -112 l 337 248 l 0 -112 l 0 -271 l 295 45 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 z"
        },
        accSagittalDoubleFlat: {
            x_min: 0,
            x_max: 469,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 488 517 l 337 82 l 186 517 l 135 503 l 310 0 l 295 -45 l 0 271 l 0 112 l 337 -248 l 675 112 l 675 271 l 380 -45 l 366 0 l 540 503 z"
        },
        accSagittal7v11KleismaUp: {
            x_min: 0,
            x_max: 219,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 68 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 -45 b 248 -112 200 -89 225 -112 b 315 68 292 -112 315 -53 l 271 68 b 248 -4 271 20 264 -4 b 236 0 245 -4 240 -3 b 157 248 213 14 187 96 b 78 0 127 96 101 14 b 65 -4 73 -3 68 -4 b 45 68 50 -4 45 20 l 0 68 b 68 -112 0 -53 23 -112 z"
        },
        accSagittal7v11KleismaDown: {
            x_min: 0,
            x_max: 219,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 68 112 b 0 -68 23 112 0 53 l 45 -68 b 65 4 45 -20 50 4 b 78 0 68 4 73 3 b 157 -248 101 -14 127 -96 b 236 0 187 -96 213 -14 b 248 4 240 3 245 4 b 271 -68 264 4 271 -20 l 315 -68 b 248 112 315 53 292 112 b 180 45 225 112 200 89 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 z"
        },
        accSagittal17CommaUp: {
            x_min: 0,
            x_max: 281,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 -40 b 315 -118 248 -92 279 -118 b 405 62 374 -118 405 -59 l 360 62 b 324 -10 360 14 348 -10 b 302 -6 318 -10 311 -9 b 206 217 268 9 235 84 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
        },
        accSagittal17CommaDown: {
            x_min: 0,
            x_max: 281,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 206 -217 b 302 6 235 -84 268 -9 b 324 10 311 9 318 10 b 360 -62 348 10 360 -14 l 405 -62 b 315 118 405 59 374 118 b 225 40 279 118 248 92 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
        },
        accSagittal55CommaUp: {
            x_min: 0,
            x_max: 219,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 248 l 0 -517 l 45 -517 l 45 58 l 315 -274 l 315 -112 l 23 248 z"
        },
        accSagittal55CommaDown: {
            x_min: 0,
            x_max: 219,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 23 -248 l 315 112 l 315 274 l 45 -58 l 45 517 l 0 517 l 0 -248 z"
        },
        accSagittal7v11CommaUp: {
            x_min: 0,
            x_max: 188,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 248 l 135 248 b 0 68 45 248 0 187 z"
        },
        accSagittal7v11CommaDown: {
            x_min: 0,
            x_max: 188,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 135 -248 0 -187 45 -248 l 271 -248 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
        },
        accSagittal5v11SmallDiesisUp: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 73 l 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 -40 b 360 -118 295 -92 325 -118 b 449 62 420 -118 449 -59 l 405 62 b 369 -10 405 14 393 -10 b 348 -6 363 -10 356 -9 b 251 217 312 9 279 84 l 248 248 l 135 248 b 0 73 45 248 0 189 z"
        },
        accSagittal5v11SmallDiesisDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -73 b 135 -248 0 -189 45 -248 l 248 -248 l 251 -217 b 348 6 279 -84 312 -9 b 369 10 356 9 363 10 b 405 -62 393 10 405 -14 l 449 -62 b 360 118 449 59 420 118 b 271 40 325 118 295 92 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
        },
        accSagittalSharp5v11SDown: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 242 37 203 -23 225 -3 b 315 -89 262 -23 285 -63 l 315 -517 l 360 -517 l 360 -112 l 383 -112 b 495 68 458 -112 495 -53 l 449 68 b 399 -4 449 20 433 -4 b 248 248 297 -4 261 171 b 157 68 222 127 192 68 l 89 68 b 0 -203 30 68 0 -23 z"
        },
        accSagittalFlat5v11SUp: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 89 -68 0 23 30 -68 l 157 -68 b 248 -248 192 -68 222 -127 b 399 4 261 -171 297 4 b 449 -68 433 4 449 -20 l 495 -68 b 383 112 495 53 458 112 l 360 112 l 360 517 l 315 517 l 315 89 b 242 -37 285 63 262 23 b 180 23 225 3 203 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 84 z"
        },
        accSagittalSharp7v11CDown: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 89 -112 l 89 -517 l 135 -517 l 135 -95 b 206 37 163 -73 187 -30 b 271 -23 225 -3 248 -23 l 271 -517 l 315 -517 l 315 -23 l 383 -23 b 449 -203 428 -23 449 -84 l 495 -203 b 405 68 495 -23 465 68 l 292 68 b 203 248 258 68 228 127 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 20 l 0 68 b 89 -112 0 -52 30 -112 z"
        },
        accSagittalFlat7v11CUp: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 89 112 b 0 -68 30 112 0 52 l 45 -68 b 81 3 45 -20 56 3 b 101 0 86 3 94 0 b 203 -248 138 -16 173 -98 b 292 -68 228 -127 258 -68 l 405 -68 b 495 203 465 -68 495 23 l 449 203 b 383 23 449 84 428 23 l 315 23 l 315 517 l 271 517 l 271 23 b 206 -37 248 23 225 3 b 135 95 187 30 163 73 l 135 517 l 89 517 z"
        },
        accSagittalSharp55CDown: {
            x_min: 0,
            x_max: 250,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -271 l 135 -125 l 135 -517 l 180 -517 l 180 -78 l 315 65 l 315 -517 l 360 -517 l 360 248 l 337 248 l 0 -112 z"
        },
        accSagittalFlat55CUp: {
            x_min: 0,
            x_max: 250,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 112 l 337 -248 l 360 -248 l 360 517 l 315 517 l 315 -65 l 180 78 l 180 517 l 135 517 l 135 125 l 0 271 z"
        },
        accSagittalSharp17CDown: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -248 l 45 -68 b 180 109 45 36 89 95 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -89 292 13 321 -55 l 360 -517 l 405 -517 l 405 -112 l 428 -112 b 540 68 504 -112 540 -53 l 495 68 b 445 -4 495 20 480 -4 b 292 248 343 -4 307 171 l 180 248 b 0 68 60 248 0 187 l 0 -248 z"
        },
        accSagittalFlat17CUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 248 l 0 -68 b 180 -248 0 -187 60 -248 l 292 -248 b 445 4 307 -171 343 4 b 495 -68 480 4 495 -20 l 540 -68 b 428 112 540 53 504 112 l 405 112 l 405 517 l 360 517 l 360 89 b 271 -112 321 55 292 -13 l 225 -112 l 225 517 l 180 517 l 180 -109 b 45 68 89 -95 45 -36 l 45 248 z"
        },
        accSagittalSharp7v11kDown: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -32 l 405 138 l 405 13 l 0 -157 l 0 -256 l 225 -161 l 225 -517 l 271 -517 l 271 -144 l 405 -86 l 405 -517 l 449 -517 l 449 248 l 428 248 l 0 68 z"
        },
        accSagittalFlat7v11kUp: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 l 428 -248 l 449 -248 l 449 517 l 405 517 l 405 86 l 271 144 l 271 517 l 225 517 l 225 161 l 0 256 l 0 157 l 405 -13 l 405 -138 l 0 32 z"
        },
        accSagittalSharp7v11kUp: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 135 -112 l 135 -517 l 180 -517 l 180 -105 b 271 -23 217 -94 248 -65 l 271 -517 l 315 -517 l 315 -23 b 405 -105 337 -65 369 -94 l 405 -517 l 449 -517 l 449 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 315 148 b 112 -4 274 148 236 -4 b 45 68 68 -4 45 20 l 0 68 b 135 -112 0 -53 45 -112 z"
        },
        accSagittalFlat7v11kDown: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 135 112 b 0 -68 45 112 0 53 l 45 -68 b 112 4 45 -20 68 4 b 292 -248 236 4 274 -148 b 475 4 315 -148 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 l 449 517 l 405 517 l 405 105 b 315 23 369 94 337 65 l 315 517 l 271 517 l 271 23 b 180 105 248 65 217 94 l 180 517 l 135 517 z"
        },
        accSagittalSharp17CUp: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 -23 b 405 -105 337 -65 369 -94 l 405 -517 l 449 -517 l 449 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 312 150 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
        },
        accSagittalFlat17CDown: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 b 475 4 312 -150 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 l 449 517 l 405 517 l 405 105 b 315 23 369 94 337 65 l 315 517 l 271 517 l 271 -14 b 203 23 251 10 229 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
        },
        accSagittalSharp55CUp: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -517 l 45 78 l 135 10 l 135 -517 l 180 -517 l 180 -23 l 271 -92 l 271 -517 l 315 -517 l 315 -127 l 495 -264 l 495 -112 l 23 248 l 0 248 l 0 -517 z"
        },
        accSagittalFlat55CDown: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 517 l 0 -248 l 23 -248 l 495 112 l 495 264 l 315 127 l 315 517 l 271 517 l 271 92 l 180 23 l 180 517 l 135 517 l 135 -10 l 45 -78 l 45 517 z"
        },
        accSagittalSharp7v11CUp: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 86 45 6 89 58 l 180 -517 l 225 -517 l 225 98 b 315 109 252 104 282 108 l 315 -517 l 360 -517 l 360 112 l 449 112 l 449 -517 l 495 -517 l 495 248 l 360 248 b 0 68 121 248 0 189 z"
        },
        accSagittalFlat7v11CDown: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 360 -248 0 -189 121 -248 l 495 -248 l 495 517 l 449 517 l 449 -112 l 360 -112 l 360 517 l 315 517 l 315 -109 b 225 -98 282 -108 252 -104 l 225 517 l 180 517 l 180 -86 b 45 68 89 -58 45 -6 l 45 248 l 0 248 z"
        },
        accSagittalSharp5v11SUp: {
            x_min: 0,
            x_max: 438,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 -23 b 449 -105 383 -65 415 -94 l 449 -517 l 495 -517 l 495 -112 b 631 68 585 -112 631 -53 l 585 68 b 520 -4 585 20 563 -4 b 337 248 396 -4 360 150 l 225 248 b 0 68 76 248 0 187 z"
        },
        accSagittalFlat5v11SDown: {
            x_min: 0,
            x_max: 438,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 225 -248 0 -187 76 -248 l 337 -248 b 520 4 360 -150 396 4 b 585 -68 563 4 585 -20 l 631 -68 b 495 112 631 53 585 112 l 495 517 l 449 517 l 449 105 b 360 23 415 94 383 65 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
        },
        accSagittalDoubleSharp5v11SDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 341 -60 b 449 -112 370 -95 405 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 312 150 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
        },
        accSagittalDoubleFlat5v11SUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 b 475 4 312 -150 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 b 341 60 405 112 370 95 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 262 -4 b 203 23 245 13 225 23 l 135 23 b 45 203 75 23 45 84 z"
        },
        accSagittalDoubleSharp7v11CDown: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 112 -112 b 193 -73 143 -112 170 -99 l 45 -501 l 95 -517 l 248 -81 l 397 -517 l 449 -503 l 275 0 l 278 4 b 337 -23 295 -13 315 -23 l 405 -23 b 495 -203 465 -23 495 -84 l 540 -203 b 428 68 540 -23 503 68 l 360 68 b 248 248 310 68 271 127 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 112 -112 0 -52 36 -112 z"
        },
        accSagittalDoubleFlat7v11CUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 112 112 b 0 -68 36 112 0 52 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 b 360 -68 271 -127 310 -68 l 428 -68 b 540 203 503 -68 540 23 l 495 203 b 405 23 495 84 465 23 l 337 23 b 278 -4 315 23 295 13 l 275 0 l 449 503 l 397 517 l 248 81 l 95 517 l 45 501 l 193 73 b 112 112 170 99 143 112 z"
        },
        accSagittalDoubleSharp55CDown: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 428 248 l 0 -112 l 0 -266 l 307 -7 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 386 59 l 449 112 l 449 248 z"
        },
        accSagittalDoubleFlat55CUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 449 -248 l 449 -112 l 386 -59 l 366 0 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 307 7 l 0 266 l 0 112 l 428 -248 z"
        },
        accSagittalDoubleSharp17CDown: {
            x_min: 0,
            x_max: 438,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -248 l 45 -68 b 271 112 45 53 120 112 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 387 -62 b 495 -112 416 -95 452 -112 b 631 68 585 -112 631 -53 l 585 68 b 520 -4 585 20 563 -4 b 337 248 396 -4 360 150 l 225 248 b 0 68 76 248 0 187 l 0 -248 z"
        },
        accSagittalDoubleFlat17CUp: {
            x_min: 0,
            x_max: 438,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 248 l 0 -68 b 225 -248 0 -187 76 -248 l 337 -248 b 520 4 360 -150 396 4 b 585 -68 563 4 585 -20 l 631 -68 b 495 112 631 53 585 112 b 387 62 452 112 416 95 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 310 0 l 271 -112 b 45 68 120 -112 45 -53 l 45 248 z"
        },
        accSagittalDoubleSharp7v11kDown: {
            x_min: 0,
            x_max: 438,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 l 0 -30 l 366 96 l 399 0 l 392 -23 l 0 -157 l 0 -255 l 353 -135 l 225 -503 l 276 -517 l 428 -82 l 579 -517 l 631 -503 l 455 0 l 507 145 l 540 157 l 540 248 l 517 248 z m 416 115 l 442 124 l 428 82 z"
        },
        accSagittalDoubleFlat7v11kUp: {
            x_min: 0,
            x_max: 438,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 517 -248 l 540 -248 l 540 -157 l 507 -145 l 455 0 l 631 503 l 579 517 l 428 82 l 276 517 l 225 503 l 353 135 l 0 255 l 0 157 l 392 23 l 399 0 l 366 -96 l 0 30 l 0 -68 z m 428 -82 l 442 -124 l 416 -115 z"
        },
        accSagittal23CommaUp: {
            x_min: 0,
            x_max: 188,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 -4 b 68 -23 53 -17 60 -23 l 180 -23 b 225 -203 210 -23 225 -82 l 271 -203 b 206 68 271 -23 248 68 l 89 68 b 23 248 71 68 48 127 l 0 248 z"
        },
        accSagittal23CommaDown: {
            x_min: 0,
            x_max: 188,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 23 -248 b 89 -68 48 -127 71 -68 l 206 -68 b 271 203 248 -68 271 23 l 225 203 b 180 23 225 82 210 23 l 68 23 b 45 4 60 23 53 17 l 45 517 l 0 517 z"
        },
        accSagittal5v19CommaUp: {
            x_min: 0,
            x_max: 156,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 248 l 203 248 b 86 112 151 157 112 112 b 45 157 59 112 45 127 l 0 157 b 76 23 0 72 26 27 l 0 -112 z"
        },
        accSagittal5v19CommaDown: {
            x_min: 0,
            x_max: 156,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 112 l 76 -23 b 0 -157 26 -27 0 -72 l 45 -157 b 86 -112 45 -127 59 -112 b 203 -248 112 -112 151 -157 l 225 -248 l 225 517 l 180 517 l 180 -33 l 0 284 z"
        },
        accSagittal5v23SmallDiesisUp: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 -4 b 248 -23 233 -17 240 -23 l 360 -23 b 405 -203 390 -23 405 -82 l 449 -203 b 386 68 449 -23 428 68 l 271 68 b 203 248 251 68 228 127 l 0 -112 z"
        },
        accSagittal5v23SmallDiesisDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 112 l 203 -248 b 271 -68 228 -127 251 -68 l 386 -68 b 449 203 428 -68 449 23 l 405 203 b 360 23 405 82 390 23 l 248 23 b 225 4 240 23 233 17 l 225 517 l 180 517 l 180 -33 l 0 284 z"
        },
        accSagittalSharp5v23SDown: {
            x_min: 0,
            x_max: 281,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 6 b 89 -23 59 -13 73 -23 l 180 -23 l 180 -517 l 225 -517 l 225 -23 l 292 -23 b 360 -203 337 -23 360 -84 l 405 -203 b 315 68 405 -23 374 68 l 112 68 b 23 248 78 68 48 127 l 0 248 z"
        },
        accSagittalFlat5v23SUp: {
            x_min: 0,
            x_max: 281,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 23 -248 b 112 -68 48 -127 78 -68 l 315 -68 b 405 203 374 -68 405 23 l 360 203 b 292 23 360 84 337 23 l 225 23 l 225 517 l 180 517 l 180 23 l 89 23 b 45 -6 73 23 59 13 l 45 517 l 0 517 z"
        },
        accSagittalSharp5v19CDown: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 b 89 -112 0 -52 30 -112 l 89 -517 l 135 -517 l 135 -95 b 225 112 173 -65 203 4 l 271 112 l 271 -517 l 315 -517 l 315 107 b 405 -68 374 89 405 30 l 405 -248 l 449 -248 l 449 68 b 315 248 449 189 405 248 l 203 248 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 23 z"
        },
        accSagittalFlat5v19CUp: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 45 -68 b 81 3 45 -23 56 3 b 101 0 86 3 94 0 b 203 -248 138 -16 173 -98 l 315 -248 b 449 -68 405 -248 449 -189 l 449 248 l 405 248 l 405 68 b 315 -107 405 -30 374 -89 l 315 517 l 271 517 l 271 -112 l 225 -112 b 135 95 203 -4 173 65 l 135 517 l 89 517 l 89 112 b 0 -68 30 112 0 52 z"
        },
        accSagittalSharp23CDown: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 135 -82 l 135 -517 l 180 -517 l 180 -17 l 239 68 b 315 -23 261 7 287 -23 l 315 -517 l 360 -517 l 360 -23 l 428 -23 b 495 -203 472 -23 495 -84 l 540 -203 b 449 68 540 -23 510 68 l 337 68 b 248 248 302 68 271 127 l 0 -112 l 0 -276 z"
        },
        accSagittalFlat23CUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 276 l 0 112 l 248 -248 b 337 -68 271 -127 302 -68 l 449 -68 b 540 203 510 -68 540 23 l 495 203 b 428 23 495 84 472 23 l 360 23 l 360 517 l 315 517 l 315 23 b 239 -68 287 23 261 -7 l 180 17 l 180 517 l 135 517 l 135 82 z"
        },
        accSagittalSharp23CUp: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 14 b 112 -23 63 -10 86 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 360 -23 b 449 -203 420 -23 449 -84 l 495 -203 b 383 68 495 -23 458 68 l 135 68 b 23 248 85 68 48 127 l 0 248 z"
        },
        accSagittalFlat23CDown: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 23 -248 b 135 -68 48 -127 85 -68 l 383 -68 b 495 203 458 -68 495 23 l 449 203 b 360 23 449 84 420 23 l 315 23 l 315 517 l 271 517 l 271 23 l 180 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 -14 86 23 63 10 l 45 517 l 0 517 z"
        },
        accSagittalSharp5v19CUp: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -112 l 0 -266 l 135 -153 l 135 -517 l 180 -517 l 180 -115 l 271 -39 l 271 -517 l 315 -517 l 315 0 l 405 75 l 405 -517 l 449 -517 l 449 248 l 428 248 b 130 68 285 127 186 68 b 45 157 73 68 45 98 l 0 157 b 112 -20 0 53 37 -6 z"
        },
        accSagittalFlat5v19CDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 112 20 b 0 -157 37 6 0 -53 l 45 -157 b 130 -68 45 -98 73 -68 b 428 -248 186 -68 285 -127 l 449 -248 l 449 517 l 405 517 l 405 -75 l 315 0 l 315 517 l 271 517 l 271 39 l 180 115 l 180 517 l 135 517 l 135 153 l 0 266 l 0 112 z"
        },
        accSagittalSharp5v23SUp: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 135 -108 l 135 -517 l 180 -517 l 180 -53 l 271 58 l 271 -517 l 315 -517 l 315 14 b 383 -23 334 -10 357 -23 l 405 -23 l 405 -517 l 449 -517 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 405 68 b 292 248 356 68 318 127 l 0 -112 l 0 -274 z"
        },
        accSagittalFlat5v23SDown: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 274 l 0 112 l 292 -248 b 405 -68 318 -127 356 -68 l 472 -68 b 585 203 547 -68 585 23 l 540 203 b 449 23 540 84 510 23 l 449 517 l 405 517 l 405 23 l 383 23 b 315 -14 357 23 334 10 l 315 517 l 271 517 l 271 -58 l 180 53 l 180 517 l 135 517 l 135 108 z"
        },
        accSagittalDoubleSharp5v23SDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 52 -517 l 203 -81 l 354 -517 l 405 -503 l 239 -23 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 225 68 b 112 248 176 68 138 127 l 89 248 l 89 112 b 170 -14 109 45 135 0 l 0 -501 z"
        },
        accSagittalDoubleFlat5v23SUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 501 l 170 14 b 89 -112 135 0 109 -45 l 89 -248 l 112 -248 b 225 -68 138 -127 176 -68 l 472 -68 b 585 203 547 -68 585 23 l 540 203 b 449 23 540 84 510 23 l 239 23 l 405 503 l 354 517 l 203 81 l 52 517 z"
        },
        accSagittalDoubleSharp5v19CDown: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 b 112 -112 0 -52 36 -112 b 193 -73 143 -112 170 -99 l 45 -501 l 95 -517 l 248 -81 l 397 -517 l 449 -501 l 275 0 l 315 112 b 495 -68 435 112 495 53 l 495 -248 l 540 -248 l 540 68 b 360 248 540 189 480 248 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 z"
        },
        accSagittalDoubleFlat5v19CUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 l 360 -248 b 540 -68 480 -248 540 -189 l 540 248 l 495 248 l 495 68 b 315 -112 495 -53 435 -112 l 275 0 l 449 501 l 397 517 l 248 81 l 95 517 l 45 501 l 193 73 b 112 112 170 99 143 112 b 0 -68 36 112 0 52 z"
        },
        accSagittalDoubleSharp23CDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 252 35 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 323 4 b 383 -23 340 -13 360 -23 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 405 68 b 292 248 356 68 318 127 l 0 -112 l 0 -274 z"
        },
        accSagittalDoubleFlat23CUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 274 l 0 112 l 292 -248 b 405 -68 318 -127 356 -68 l 472 -68 b 585 203 547 -68 585 23 l 540 203 b 449 23 540 84 510 23 l 383 23 b 323 -4 360 23 340 13 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 252 -35 z"
        },
        accSagittal19SchismaUp: {
            x_min: 0,
            x_max: 125,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 68 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 248 l 157 248 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 l 0 68 b 68 -112 0 -52 23 -112 z"
        },
        accSagittal19SchismaDown: {
            x_min: 0,
            x_max: 125,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 68 112 b 0 -68 23 112 0 52 l 45 -68 b 68 3 45 -20 52 3 b 79 0 68 3 73 0 b 157 -248 101 -16 127 -98 l 180 -248 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 z"
        },
        accSagittal17KleismaUp: {
            x_min: 0,
            x_max: 156,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 248 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
        },
        accSagittal17KleismaDown: {
            x_min: 0,
            x_max: 156,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 225 -248 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
        },
        accSagittal143CommaUp: {
            x_min: 0,
            x_max: 156,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -203 l 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 248 l 203 248 b 135 68 177 127 154 68 l 105 68 b 45 157 65 68 45 98 l 0 157 b 23 20 0 95 7 50 b 0 -203 7 -23 0 -98 z"
        },
        accSagittal143CommaDown: {
            x_min: 0,
            x_max: 156,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 23 -20 0 98 7 23 b 0 -157 7 -50 0 -95 l 45 -157 b 105 -68 45 -98 65 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 225 -248 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
        },
        accSagittal11v49CommaUp: {
            x_min: 0,
            x_max: 188,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -292 b 89 -157 45 -203 60 -157 l 203 -157 b 225 -143 210 -157 217 -153 l 225 -517 l 271 -517 l 271 248 l 248 248 b 180 157 233 187 210 157 l 68 157 b 0 -68 23 157 0 82 l 45 -68 b 89 68 45 23 60 68 l 203 68 b 225 84 209 68 216 72 l 225 -36 b 180 -68 213 -58 199 -68 l 68 -68 b 0 -292 23 -68 0 -143 z"
        },
        accSagittal11v49CommaDown: {
            x_min: 0,
            x_max: 188,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 292 b 68 68 0 143 23 68 l 180 68 b 225 36 199 68 213 58 l 225 -84 b 203 -68 216 -72 209 -68 l 89 -68 b 45 68 60 -68 45 -23 l 0 68 b 68 -157 0 -82 23 -157 l 180 -157 b 248 -248 210 -157 233 -187 l 271 -248 l 271 517 l 225 517 l 225 143 b 203 157 217 153 210 157 l 89 157 b 45 292 60 157 45 203 z"
        },
        accSagittal19CommaUp: {
            x_min: 0,
            x_max: 281,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 b 68 -112 0 -52 23 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 -4 b 203 -23 187 -17 196 -23 l 315 -23 b 360 -203 346 -23 360 -82 l 405 -203 b 341 68 405 -23 383 68 l 225 68 b 157 248 206 68 183 127 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 z"
        },
        accSagittal19CommaDown: {
            x_min: 0,
            x_max: 281,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 45 -68 b 68 3 45 -20 52 3 b 79 0 68 3 73 0 b 157 -248 101 -16 127 -98 b 225 -68 183 -127 206 -68 l 341 -68 b 405 203 383 -68 405 23 l 360 203 b 315 23 360 82 346 23 l 203 23 b 180 4 196 23 187 17 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 b 0 -68 23 112 0 52 z"
        },
        accSagittal7v19CommaUp: {
            x_min: 0,
            x_max: 250,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 b 68 -112 0 -52 23 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 112 l 225 112 b 315 -68 285 112 315 53 l 315 -248 l 360 -248 l 360 68 b 271 248 360 187 330 248 l 157 248 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 z"
        },
        accSagittal7v19CommaDown: {
            x_min: 0,
            x_max: 250,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 45 -68 b 68 3 45 -20 52 3 b 79 0 68 3 73 0 b 157 -248 101 -16 127 -98 l 271 -248 b 360 -68 330 -248 360 -187 l 360 248 l 315 248 l 315 68 b 225 -112 315 -53 285 -112 l 180 -112 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 b 0 -68 23 112 0 52 z"
        },
        accSagittal49SmallDiesisUp: {
            x_min: 0,
            x_max: 281,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -203 l 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -68 330 112 360 53 l 360 -248 l 405 -248 l 405 68 b 315 248 405 187 374 248 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
        },
        accSagittal49SmallDiesisDown: {
            x_min: 0,
            x_max: 281,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 315 -248 b 405 -68 374 -248 405 -187 l 405 248 l 360 248 l 360 68 b 271 -112 360 -53 330 -112 l 225 -112 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
        },
        accSagittal23SmallDiesisUp: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 58 l 495 -274 l 495 -112 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
        },
        accSagittal23SmallDiesisDown: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 495 112 l 495 274 l 225 -58 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
        },
        accSagittal5v13MediumDiesisUp: {
            x_min: 0,
            x_max: 250,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -259 l 315 -89 l 315 -517 l 360 -517 l 360 248 l 337 248 b 128 180 253 203 184 180 b 45 248 73 180 45 203 l 0 248 b 52 95 0 170 17 120 l 0 68 l 0 -33 l 315 135 l 315 10 l 0 -157 z"
        },
        accSagittal5v13MediumDiesisDown: {
            x_min: 0,
            x_max: 250,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 157 l 315 -10 l 315 -135 l 0 33 l 0 -68 l 52 -95 b 0 -248 17 -120 0 -170 l 45 -248 b 128 -180 45 -203 73 -180 b 337 -248 184 -180 253 -203 l 360 -248 l 360 517 l 315 517 l 315 89 l 0 259 z"
        },
        accSagittal11v19MediumDiesisUp: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 -4 b 292 -23 278 -17 285 -23 l 405 -23 b 449 -203 435 -23 449 -82 l 495 -203 b 431 68 495 -23 472 68 l 315 68 b 248 248 295 68 271 127 l 135 248 b 0 68 45 248 0 187 l 0 -248 z"
        },
        accSagittal11v19MediumDiesisDown: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 248 l 0 -68 b 135 -248 0 -187 45 -248 l 248 -248 b 315 -68 271 -127 295 -68 l 431 -68 b 495 203 472 -68 495 23 l 449 203 b 405 23 449 82 435 23 l 292 23 b 271 4 285 23 278 17 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 z"
        },
        accSagittal49MediumDiesisUp: {
            x_min: 0,
            x_max: 250,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -68 l 0 -248 l 45 -248 l 315 -94 l 315 -517 l 360 -517 l 360 248 l 225 248 b 0 -68 75 248 0 143 z m 45 -68 b 225 112 45 53 105 112 l 315 112 l 315 10 l 45 -145 z"
        },
        accSagittal49MediumDiesisDown: {
            x_min: 0,
            x_max: 250,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 68 b 225 -248 0 -143 75 -248 l 360 -248 l 360 517 l 315 517 l 315 94 l 45 248 l 0 248 z m 45 145 l 315 -10 l 315 -112 l 225 -112 b 45 68 105 -112 45 -53 z"
        },
        accSagittal5v49MediumDiesisUp: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -89 l 0 -248 l 225 53 l 225 -517 l 271 -517 l 271 53 l 495 -248 l 495 -89 l 248 248 b 89 89 170 143 118 89 b 45 157 60 89 45 112 l 0 157 b 68 3 0 68 23 16 z"
        },
        accSagittal5v49MediumDiesisDown: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 68 -3 b 0 -157 23 -16 0 -68 l 45 -157 b 89 -89 45 -112 60 -89 b 248 -248 118 -89 170 -143 l 495 89 l 495 248 l 271 -53 l 271 517 l 225 517 l 225 -53 l 0 248 l 0 89 z"
        },
        accSagittal49LargeDiesisUp: {
            x_min: 0,
            x_max: 281,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 -89 l 360 -248 l 405 -248 l 405 -68 b 180 248 405 143 330 248 l 0 248 z m 45 12 l 45 112 l 180 112 b 360 -68 300 112 360 53 l 360 -147 z"
        },
        accSagittal49LargeDiesisDown: {
            x_min: 0,
            x_max: 281,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 180 -248 b 405 68 330 -248 405 -143 l 405 248 l 360 248 l 45 89 l 45 517 l 0 517 z m 360 147 l 360 68 b 180 -112 360 -53 300 -112 l 45 -112 l 45 -12 z"
        },
        accSagittal11v19LargeDiesisUp: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 -86 l 449 -256 l 449 -157 l 45 13 l 45 138 l 449 -30 l 449 68 l 23 248 l 0 248 z"
        },
        accSagittal11v19LargeDiesisDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 23 -248 l 449 -68 l 449 30 l 45 -138 l 45 -13 l 449 157 l 449 256 l 45 86 l 45 517 l 0 517 z"
        },
        accSagittal5v13LargeDiesisUp: {
            x_min: 0,
            x_max: 438,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 b 89 -112 0 -52 30 -112 b 180 -35 125 -112 157 -86 l 180 -517 l 225 -517 l 225 -86 l 631 -256 l 631 -157 l 225 13 l 225 138 l 631 -30 l 631 68 l 203 248 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 20 z"
        },
        accSagittal5v13LargeDiesisDown: {
            x_min: 0,
            x_max: 438,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 45 -68 b 81 3 45 -20 56 3 b 101 0 86 3 94 0 b 203 -248 138 -16 173 -98 l 631 -68 l 631 30 l 225 -138 l 225 -13 l 631 157 l 631 256 l 225 86 l 225 517 l 180 517 l 180 35 b 89 112 157 86 125 112 b 0 -68 30 112 0 52 z"
        },
        accSagittalSharp23SDown: {
            x_min: 0,
            x_max: 250,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -203 l 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 b 315 6 287 -23 301 -13 l 315 -517 l 360 -517 l 360 248 l 337 248 b 248 68 312 127 282 68 l 194 68 b 89 157 125 68 89 98 l 45 157 b 60 59 45 118 50 85 b 0 -203 20 30 0 -56 z"
        },
        accSagittalFlat23SUp: {
            x_min: 0,
            x_max: 250,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 60 -59 0 56 20 -30 b 45 -157 50 -85 45 -118 l 89 -157 b 194 -68 89 -98 125 -68 l 248 -68 b 337 -248 282 -68 312 -127 l 360 -248 l 360 517 l 315 517 l 315 -6 b 271 23 301 13 287 23 l 180 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 84 z"
        },
        accSagittalSharp49SDown: {
            x_min: 0,
            x_max: 250,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -292 l 45 -292 b 112 -157 45 -203 68 -157 l 135 -157 l 135 -517 l 180 -517 l 180 -157 l 271 -157 b 315 -135 285 -157 300 -150 l 315 -517 l 360 -517 l 360 248 l 337 248 b 248 157 323 187 292 157 l 89 157 b 0 -68 30 157 0 82 l 45 -68 b 112 68 45 23 68 68 l 271 68 b 315 89 284 68 300 75 l 315 -32 b 248 -68 298 -56 275 -68 l 89 -68 b 0 -292 29 -68 0 -143 z"
        },
        accSagittalFlat49SUp: {
            x_min: 0,
            x_max: 250,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 292 b 89 68 0 143 29 68 l 248 68 b 315 32 275 68 298 56 l 315 -89 b 271 -68 300 -75 284 -68 l 112 -68 b 45 68 68 -68 45 -23 l 0 68 b 89 -157 0 -82 30 -157 l 248 -157 b 337 -248 292 -157 323 -187 l 360 -248 l 360 517 l 315 517 l 315 135 b 271 157 300 150 285 157 l 180 157 l 180 517 l 135 517 l 135 157 l 112 157 b 45 292 68 157 45 203 z"
        },
        accSagittalSharp7v19CDown: {
            x_min: 0,
            x_max: 250,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -112 l 0 -271 l 135 -125 l 135 -517 l 180 -517 l 180 -78 l 315 65 l 315 -517 l 360 -517 l 360 248 l 337 248 b 118 89 239 143 166 89 b 45 157 68 89 45 112 l 0 157 b 89 -20 0 53 29 -6 z"
        },
        accSagittalFlat7v19CUp: {
            x_min: 0,
            x_max: 250,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 89 20 b 0 -157 29 6 0 -53 l 45 -157 b 118 -89 45 -112 68 -89 b 337 -248 166 -89 239 -143 l 360 -248 l 360 517 l 315 517 l 315 -65 l 180 78 l 180 517 l 135 517 l 135 125 l 0 271 l 0 112 z"
        },
        accSagittalSharp19CDown: {
            x_min: 0,
            x_max: 281,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -248 l 45 -248 l 45 -68 b 180 96 45 17 89 72 l 180 -517 l 225 -517 l 225 107 b 315 112 252 112 282 112 l 360 112 l 360 -517 l 405 -517 l 405 248 l 271 248 b 0 68 89 248 0 187 z"
        },
        accSagittalFlat19CUp: {
            x_min: 0,
            x_max: 281,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 271 -248 0 -187 89 -248 l 405 -248 l 405 517 l 360 517 l 360 -112 l 315 -112 b 225 -107 282 -112 252 -112 l 225 517 l 180 517 l 180 -96 b 45 68 89 -72 45 -17 l 45 248 l 0 248 z"
        },
        accSagittalSharp11v49CDown: {
            x_min: 0,
            x_max: 344,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 112 -23 45 -82 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 271 112 215 -23 245 23 l 315 112 l 315 -517 l 360 -517 l 360 107 b 449 -68 420 89 449 30 l 449 -248 l 495 -248 l 495 68 b 360 248 495 189 449 248 l 248 248 b 157 68 222 128 192 68 l 89 68 b 0 -203 30 68 0 -23 z"
        },
        accSagittalFlat11v49CUp: {
            x_min: 0,
            x_max: 344,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 89 -68 0 23 30 -68 l 157 -68 b 248 -248 192 -68 222 -128 l 360 -248 b 495 -68 449 -248 495 -189 l 495 248 l 449 248 l 449 68 b 360 -107 449 -30 420 -89 l 360 517 l 315 517 l 315 -112 l 271 -112 b 180 23 245 -23 215 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 82 z"
        },
        accSagittalSharp143CDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 259 76 210 -23 236 10 l 315 17 l 315 -517 l 360 -517 l 360 -30 l 585 -271 l 585 -112 l 248 248 b 157 68 222 127 192 68 l 89 68 b 0 -203 30 68 0 -23 z"
        },
        accSagittalFlat143CUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 89 -68 0 23 30 -68 l 157 -68 b 248 -248 192 -68 222 -127 l 585 112 l 585 271 l 360 30 l 360 517 l 315 517 l 315 -17 l 259 -76 b 180 23 236 -10 210 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 84 z"
        },
        accSagittalSharp17kDown: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -157 l 0 -256 l 225 -161 l 225 -517 l 271 -517 l 271 -144 l 405 -86 l 405 -517 l 449 -517 l 449 248 l 428 248 b 145 171 305 196 210 171 b 45 248 78 171 45 196 l 0 248 b 79 101 0 170 26 121 l 0 68 l 0 -32 l 405 138 l 405 13 z"
        },
        accSagittalFlat17kUp: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 405 -13 l 405 -138 l 0 32 l 0 -68 l 79 -101 b 0 -248 26 -121 0 -170 l 45 -248 b 145 -171 45 -196 78 -171 b 428 -248 210 -171 305 -196 l 449 -248 l 449 517 l 405 517 l 405 86 l 271 144 l 271 517 l 225 517 l 225 161 l 0 256 l 0 157 z"
        },
        accSagittalSharp19sDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -248 l 45 -248 l 45 -68 b 180 109 45 36 89 95 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -23 295 23 325 -23 l 360 -517 l 405 -517 l 405 -23 l 472 -23 b 540 -203 517 -23 540 -84 l 585 -203 b 495 68 585 -23 554 68 l 383 68 b 292 248 348 68 318 127 l 180 248 b 0 68 60 248 0 187 z"
        },
        accSagittalFlat19sUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 180 -248 0 -187 60 -248 l 292 -248 b 383 -68 318 -127 348 -68 l 495 -68 b 585 203 554 -68 585 23 l 540 203 b 472 23 540 84 517 23 l 405 23 l 405 517 l 360 517 l 360 23 b 271 -112 325 23 295 -23 l 225 -112 l 225 517 l 180 517 l 180 -109 b 45 68 89 -95 45 -36 l 45 248 l 0 248 z"
        },
        accSagittalSharp19sUp: {
            x_min: 0,
            x_max: 281,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 89 -96 l 89 -517 l 135 -517 l 135 -108 b 180 -112 148 -112 163 -112 b 225 -108 196 -112 210 -112 l 225 -517 l 271 -517 l 271 -94 b 360 -12 305 -78 337 -50 l 360 -517 l 405 -517 l 405 248 l 383 248 b 190 0 353 98 288 16 b 138 -3 171 0 153 -3 b 45 68 75 -3 45 20 l 0 68 b 89 -96 0 -17 30 -72 z"
        },
        accSagittalFlat19sDown: {
            x_min: 0,
            x_max: 281,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 89 96 b 0 -68 30 72 0 17 l 45 -68 b 138 3 45 -20 75 3 b 190 0 153 3 171 0 b 383 -248 288 -16 353 -98 l 405 -248 l 405 517 l 360 517 l 360 12 b 271 94 337 50 305 78 l 271 517 l 225 517 l 225 108 b 180 112 210 112 196 112 b 135 108 163 112 148 112 l 135 517 l 89 517 z"
        },
        accSagittalSharp17kUp: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 337 -23 b 405 14 363 -23 386 -10 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 68 402 127 364 68 l 112 68 b 0 -203 37 68 0 -23 z"
        },
        accSagittalFlat17kDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 112 -68 0 23 37 -68 l 315 -68 b 428 -248 364 -68 402 -127 l 449 -248 l 449 517 l 405 517 l 405 -14 b 337 23 386 10 363 23 l 315 23 l 315 517 l 271 517 l 271 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
        },
        accSagittalSharp143CUp: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 337 -23 b 405 14 363 -23 386 -10 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 68 402 127 364 68 l 240 68 b 89 157 140 68 89 98 l 45 157 b 68 53 45 115 52 81 b 0 -203 23 23 0 -63 z"
        },
        accSagittalFlat143CDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 68 -53 0 63 23 -23 b 45 -157 52 -81 45 -115 l 89 -157 b 240 -68 89 -98 140 -68 l 315 -68 b 428 -248 364 -68 402 -127 l 449 -248 l 449 517 l 405 517 l 405 -14 b 337 23 386 10 363 23 l 315 23 l 315 517 l 271 517 l 271 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
        },
        accSagittalSharp11v49CUp: {
            x_min: 0,
            x_max: 312,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -68 b 135 68 45 23 76 68 l 337 68 b 405 95 363 68 386 76 l 405 -27 b 315 -68 386 -55 356 -68 l 112 -68 b 0 -292 37 -68 0 -143 l 45 -292 b 135 -157 45 -203 75 -157 l 135 -517 l 180 -517 l 180 -157 l 271 -157 l 271 -517 l 315 -517 l 315 -157 l 337 -157 b 405 -130 360 -157 383 -148 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 157 413 187 376 157 l 112 157 b 0 -68 37 157 0 82 z"
        },
        accSagittalFlat11v49CDown: {
            x_min: 0,
            x_max: 312,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 68 b 112 -157 0 -82 37 -157 l 315 -157 b 428 -248 376 -157 413 -187 l 449 -248 l 449 517 l 405 517 l 405 130 b 337 157 383 148 360 157 l 315 157 l 315 517 l 271 517 l 271 157 l 180 157 l 180 517 l 135 517 l 135 157 b 45 292 75 157 45 203 l 0 292 b 112 68 0 143 37 68 l 315 68 b 405 27 356 68 386 55 l 405 -95 b 337 -68 386 -76 363 -68 l 135 -68 b 45 68 76 -68 45 -23 z"
        },
        accSagittalSharp19CUp: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 14 b 337 -23 289 -10 311 -23 l 360 -23 l 360 -517 l 405 -517 l 405 -23 b 495 -203 465 -23 495 -82 l 540 -203 b 428 68 540 -23 503 68 l 360 68 b 248 248 310 68 271 128 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z"
        },
        accSagittalFlat19CDown: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 89 109 b 0 -68 30 98 0 39 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 b 360 -68 271 -128 310 -68 l 428 -68 b 540 203 503 -68 540 23 l 495 203 b 405 23 495 82 465 23 l 405 517 l 360 517 l 360 23 l 337 23 b 271 -14 311 23 289 10 l 271 517 l 225 517 l 225 27 b 135 109 200 75 170 102 l 135 517 l 89 517 z"
        },
        accSagittalSharp7v19CUp: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 112 l 315 112 b 360 109 331 112 346 112 l 360 -517 l 405 -517 l 405 98 b 495 -68 465 73 495 19 l 495 -248 l 540 -248 l 540 68 b 360 248 540 189 480 248 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z"
        },
        accSagittalFlat7v19CDown: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 89 109 b 0 -68 30 98 0 39 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 l 360 -248 b 540 -68 480 -248 540 -189 l 540 248 l 495 248 l 495 68 b 405 -98 495 -19 465 -73 l 405 517 l 360 517 l 360 -109 b 315 -112 346 -112 331 -112 l 271 -112 l 271 517 l 225 517 l 225 27 b 135 109 200 75 170 102 l 135 517 l 89 517 z"
        },
        accSagittalSharp49SUp: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 112 l 360 112 b 405 109 376 112 390 112 l 405 -517 l 449 -517 l 449 96 b 540 -68 510 72 540 17 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
        },
        accSagittalFlat49SDown: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 449 -96 540 -17 510 -72 l 449 517 l 405 517 l 405 -109 b 360 -112 390 -112 376 -112 l 315 -112 l 315 517 l 271 517 l 271 -14 b 203 23 251 10 229 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
        },
        accSagittalSharp23SUp: {
            x_min: 0,
            x_max: 469,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 71 l 405 -14 l 405 -517 l 449 -517 l 449 -56 l 675 -268 l 675 -112 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
        },
        accSagittalFlat23SDown: {
            x_min: 0,
            x_max: 469,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 675 112 l 675 268 l 449 56 l 449 517 l 405 517 l 405 14 l 315 -71 l 315 517 l 271 517 l 271 -14 b 203 23 251 10 229 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
        },
        accSagittalSharp5v13MUp: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 495 141 l 495 14 l 0 -157 l 0 -256 l 225 -180 l 225 -517 l 271 -517 l 271 -161 l 360 -130 l 360 -517 l 405 -517 l 405 -115 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 517 248 b 167 168 366 194 248 168 b 45 248 85 168 45 194 l 0 248 b 95 99 0 170 30 120 l 0 68 l 0 -30 z"
        },
        accSagittalFlat5v13MDown: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 30 l 0 -68 l 95 -99 b 0 -248 30 -120 0 -170 l 45 -248 b 167 -168 45 -194 85 -168 b 517 -248 248 -168 366 -194 l 540 -248 l 540 517 l 495 517 l 495 84 l 405 115 l 405 517 l 360 517 l 360 130 l 271 161 l 271 517 l 225 517 l 225 180 l 0 256 l 0 157 l 495 -14 l 495 -141 z"
        },
        accSagittalSharp11v19MUp: {
            x_min: 0,
            x_max: 438,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 14 b 428 -23 379 -10 402 -23 l 449 -23 l 449 -517 l 495 -517 l 495 -23 b 585 -203 554 -23 585 -84 l 631 -203 b 517 68 631 -23 593 68 l 449 68 b 337 248 400 68 363 127 l 225 248 b 0 68 75 248 0 187 z"
        },
        accSagittalFlat11v19MDown: {
            x_min: 0,
            x_max: 438,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 225 -248 0 -187 75 -248 l 337 -248 b 449 -68 363 -127 400 -68 l 517 -68 b 631 203 593 -68 631 23 l 585 203 b 495 23 585 84 554 23 l 495 517 l 449 517 l 449 23 l 428 23 b 360 -14 402 23 379 10 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
        },
        accSagittalSharp49MUp: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -248 l 45 -248 l 225 -180 l 225 -517 l 271 -517 l 271 -166 l 360 -132 l 360 -517 l 405 -517 l 405 -117 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 360 248 b 0 -68 120 248 0 143 z m 45 -145 l 45 -68 b 360 112 45 53 150 112 l 495 112 l 495 14 z"
        },
        accSagittalFlat49MDown: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 68 b 360 -248 0 -143 120 -248 l 540 -248 l 540 517 l 495 517 l 495 84 l 405 117 l 405 517 l 360 517 l 360 132 l 271 166 l 271 517 l 225 517 l 225 180 l 45 248 l 0 248 z m 495 -14 l 495 -112 l 360 -112 b 45 68 150 -112 45 -53 l 45 145 z"
        },
        accSagittalSharp5v49MUp: {
            x_min: 0,
            x_max: 469,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -271 l 180 -79 l 180 -517 l 225 -517 l 225 -30 l 315 65 l 315 -517 l 360 -517 l 360 65 l 449 -30 l 449 -517 l 495 -517 l 495 -79 l 675 -271 l 675 -112 l 337 248 b 118 89 239 143 166 89 b 45 157 68 89 45 112 l 0 157 b 107 0 0 62 36 10 l 0 -112 z"
        },
        accSagittalFlat5v49MDown: {
            x_min: 0,
            x_max: 469,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 112 l 107 0 b 0 -157 36 -10 0 -62 l 45 -157 b 118 -89 45 -112 68 -89 b 337 -248 166 -89 239 -143 l 675 112 l 675 271 l 495 79 l 495 517 l 449 517 l 449 30 l 360 -65 l 360 517 l 315 517 l 315 -65 l 225 30 l 225 517 l 180 517 l 180 79 l 0 271 z"
        },
        accSagittalSharp49LUp: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 -82 l 135 -112 l 135 -517 l 180 -517 l 180 -127 l 271 -157 l 271 -517 l 315 -517 l 315 -173 l 540 -248 l 585 -248 l 585 -68 b 180 248 585 143 449 248 l 0 248 z m 45 112 l 180 112 b 540 -68 420 112 540 53 l 540 -145 l 45 16 z"
        },
        accSagittalFlat49LDown: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 180 -248 b 585 68 449 -248 585 -143 l 585 248 l 540 248 l 315 173 l 315 517 l 271 517 l 271 157 l 180 127 l 180 517 l 135 517 l 135 112 l 45 82 l 45 517 l 0 517 z m 45 -16 l 540 145 l 540 68 b 180 -112 540 -53 420 -112 l 45 -112 z"
        },
        accSagittalSharp11v19LUp: {
            x_min: 0,
            x_max: 438,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -517 l 45 -517 l 45 -81 l 135 -108 l 135 -517 l 180 -517 l 180 -121 l 271 -148 l 271 -517 l 315 -517 l 315 -161 l 631 -255 l 631 -157 l 45 16 l 45 144 l 631 -30 l 631 68 l 23 248 l 0 248 z"
        },
        accSagittalFlat11v19LDown: {
            x_min: 0,
            x_max: 438,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -248 l 23 -248 l 631 -68 l 631 30 l 45 -144 l 45 -16 l 631 157 l 631 255 l 315 161 l 315 517 l 271 517 l 271 148 l 180 121 l 180 517 l 135 517 l 135 108 l 45 81 l 45 517 l 0 517 z"
        },
        accSagittalSharp5v13LUp: {
            x_min: 0,
            x_max: 500,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 -85 l 360 -120 l 360 -517 l 405 -517 l 405 -135 l 720 -256 l 720 -157 l 271 14 l 271 141 l 720 -30 l 720 68 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z"
        },
        accSagittalFlat5v13LDown: {
            x_min: 0,
            x_max: 500,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 89 109 b 0 -68 30 98 0 39 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 l 720 -68 l 720 30 l 271 -141 l 271 -14 l 720 157 l 720 256 l 405 135 l 405 517 l 360 517 l 360 120 l 271 85 l 271 517 l 225 517 l 225 27 b 135 109 200 75 170 102 l 135 517 l 89 517 z"
        },
        accSagittalDoubleSharp23SDown: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -203 l 45 -203 b 135 -23 45 -82 76 -23 l 301 -23 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 370 -14 b 449 112 423 10 449 53 l 449 248 l 428 248 b 315 68 402 127 364 68 l 240 68 b 89 157 140 68 89 98 l 45 157 b 68 53 45 115 52 81 b 0 -203 23 23 0 -63 z"
        },
        accSagittalDoubleFlat23SUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 68 -53 0 63 23 -23 b 45 -157 52 -81 45 -115 l 89 -157 b 240 -68 89 -98 140 -68 l 315 -68 b 428 -248 364 -68 402 -127 l 449 -248 l 449 -112 b 370 14 449 -53 423 -10 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 301 23 l 135 23 b 45 203 76 23 45 82 z"
        },
        accSagittalDoubleSharp49SDown: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -292 l 45 -292 b 112 -157 45 -203 68 -157 l 256 -157 l 135 -503 l 187 -517 l 337 -82 l 490 -517 l 540 -503 l 366 0 l 396 89 b 449 157 416 102 435 125 l 449 248 l 428 248 b 315 157 413 187 376 157 l 112 157 b 0 -68 39 157 0 82 l 45 -68 b 135 68 45 23 76 68 l 287 68 l 311 0 l 288 -68 l 89 -68 b 0 -292 32 -68 0 -144 z"
        },
        accSagittalDoubleFlat49SUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 292 b 89 68 0 144 32 68 l 288 68 l 311 0 l 287 -68 l 135 -68 b 45 68 76 -68 45 -23 l 0 68 b 112 -157 0 -82 39 -157 l 315 -157 b 428 -248 376 -157 413 -187 l 449 -248 l 449 -157 b 396 -89 435 -125 416 -102 l 366 0 l 540 503 l 490 517 l 337 82 l 187 517 l 135 503 l 256 157 l 112 157 b 45 292 68 157 45 203 z"
        },
        accSagittalDoubleSharp7v19CDown: {
            x_min: 0,
            x_max: 375,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -112 l 0 -266 l 307 -7 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 386 59 l 449 112 l 449 248 l 428 248 b 130 68 285 127 186 68 b 45 157 73 68 45 98 l 0 157 b 112 -20 0 53 37 -6 z"
        },
        accSagittalDoubleFlat7v19CUp: {
            x_min: 0,
            x_max: 375,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 112 20 b 0 -157 37 6 0 -53 l 45 -157 b 130 -68 45 -98 73 -68 b 428 -248 186 -68 285 -127 l 449 -248 l 449 -112 l 386 -59 l 366 0 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 307 7 l 0 266 l 0 112 z"
        },
        accSagittalDoubleSharp19CDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 315 109 45 36 135 95 l 354 0 l 180 -503 l 232 -517 l 383 -82 l 534 -517 l 585 -503 l 410 0 l 449 112 l 495 112 l 495 248 l 360 248 b 0 68 120 248 0 187 z m 372 112 l 393 112 l 383 82 z"
        },
        accSagittalDoubleFlat19CUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 360 -248 0 -187 120 -248 l 495 -248 l 495 -112 l 449 -112 l 410 0 l 585 503 l 534 517 l 383 82 l 232 517 l 180 503 l 354 0 l 315 -109 b 45 68 135 -95 45 -36 l 45 248 l 0 248 z m 383 -82 l 393 -112 l 372 -112 z"
        },
        accSagittalDoubleSharp11v49CDown: {
            x_min: 0,
            x_max: 406,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 360 112 b 540 -68 480 112 540 53 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
        },
        accSagittalDoubleFlat11v49CUp: {
            x_min: 0,
            x_max: 406,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 360 -112 540 -53 480 -112 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 262 -4 b 203 23 245 13 225 23 l 135 23 b 45 203 75 23 45 84 z"
        },
        accSagittalDoubleSharp143CDown: {
            x_min: 0,
            x_max: 469,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 337 49 l 675 -268 l 675 -112 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
        },
        accSagittalDoubleFlat143CUp: {
            x_min: 0,
            x_max: 469,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 675 112 l 675 268 l 337 -49 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 262 -4 b 203 23 245 13 225 23 l 135 23 b 45 203 75 23 45 84 z"
        },
        accSagittalDoubleSharp17kDown: {
            x_min: 0,
            x_max: 438,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 248 b 95 101 0 170 30 121 l 0 68 l 0 -30 l 364 96 l 399 0 l 390 -23 l 0 -157 l 0 -255 l 353 -135 l 225 -503 l 275 -517 l 428 -82 l 577 -517 l 631 -503 l 455 0 l 507 145 l 540 157 l 540 248 l 517 248 b 167 168 366 194 248 168 b 45 248 85 168 45 194 z m 416 115 l 442 124 l 428 82 z"
        },
        accSagittalDoubleFlat17kUp: {
            x_min: 0,
            x_max: 438,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 45 -248 b 167 -168 45 -194 85 -168 b 517 -248 248 -168 366 -194 l 540 -248 l 540 -157 l 507 -145 l 455 0 l 631 503 l 577 517 l 428 82 l 275 517 l 225 503 l 353 135 l 0 255 l 0 157 l 390 23 l 399 0 l 364 -96 l 0 30 l 0 -68 l 95 -101 b 0 -248 30 -121 0 -170 z m 428 -82 l 442 -124 l 416 -115 z"
        },
        accSagittalDoubleSharp19sDown: {
            x_min: 0,
            x_max: 438,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 -248 l 45 -248 l 45 -68 b 271 112 45 53 120 112 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 367 4 b 428 -23 386 -13 405 -23 l 495 -23 b 585 -203 554 -23 585 -84 l 631 -203 b 517 68 631 -23 593 68 l 449 68 b 337 248 400 68 363 127 l 225 248 b 0 68 75 248 0 187 z"
        },
        accSagittalDoubleFlat19sUp: {
            x_min: 0,
            x_max: 438,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 0 -68 b 225 -248 0 -187 75 -248 l 337 -248 b 449 -68 363 -127 400 -68 l 517 -68 b 631 203 593 -68 631 23 l 585 203 b 495 23 585 84 554 23 l 428 23 b 367 -4 405 23 386 13 l 366 0 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 310 0 l 271 -112 b 45 68 120 -112 45 -53 l 45 248 l 0 248 z"
        },
        accSagittalShaftUp: {
            x_min: 0,
            x_max: 31,
            y_min: -359,
            y_max: 172,
            ha: 531,
            o: "m 0 112 l 0 -517 l 45 -517 l 45 112 l 23 248 z"
        },
        accSagittalShaftDown: {
            x_min: 0,
            x_max: 31,
            y_min: -172,
            y_max: 359,
            ha: 531,
            o: "m 23 -248 l 45 -112 l 45 517 l 0 517 l 0 -112 z"
        },
        accSagittalAcute: {
            x_min: 0,
            x_max: 125,
            y_min: -62,
            y_max: 125,
            ha: 187,
            o: "m 0 0 l 0 -89 l 180 89 l 180 180 z"
        },
        accSagittalGrave: {
            x_min: 0,
            x_max: 125,
            y_min: -125,
            y_max: 62,
            ha: 187,
            o: "m 180 -180 l 180 -89 l 0 89 l 0 0 z"
        },
        accSagittal1MinaUp: {
            x_min: -7,
            x_max: 124,
            y_min: 16,
            y_max: 106,
            ha: 90,
            o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 134 150 179 112 163 135 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
        },
        accSagittal1MinaDown: {
            x_min: -7,
            x_max: 124,
            y_min: -106,
            y_max: -16,
            ha: 90,
            o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 179 -23 163 -135 179 -112 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
        },
        accSagittal2MinasUp: {
            x_min: -7,
            x_max: 218,
            y_min: 16,
            y_max: 106,
            ha: 90,
            o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 207 65 179 23 200 55 b 252 107 223 86 240 107 b 271 23 264 107 272 86 l 314 23 b 269 150 314 112 298 135 b 203 130 252 158 220 150 b 173 92 190 115 181 104 b 134 150 167 127 154 140 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
        },
        accSagittal2MinasDown: {
            x_min: -7,
            x_max: 218,
            y_min: -106,
            y_max: -16,
            ha: 90,
            o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 173 -92 154 -140 167 -127 b 203 -130 181 -104 190 -115 b 269 -150 220 -150 252 -158 b 314 -23 298 -135 314 -112 l 271 -23 b 252 -107 272 -86 264 -107 b 207 -65 240 -107 223 -86 b 179 -23 200 -55 179 -23 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
        },
        accSagittal1TinaUp: {
            x_min: 0,
            x_max: 93,
            y_min: 16,
            y_max: 107,
            ha: 91,
            o: "m 134 154 l 91 154 b 81 76 91 101 91 86 b 0 68 73 69 48 68 l 0 23 b 134 154 122 23 134 36 z"
        },
        accSagittal1TinaDown: {
            x_min: 0,
            x_max: 93,
            y_min: -107,
            y_max: -16,
            ha: 91,
            o: "m 134 -154 b 0 -23 134 -36 122 -23 l 0 -68 b 81 -76 48 -68 73 -69 b 91 -154 91 -86 91 -101 z"
        },
        accSagittal2TinasUp: {
            x_min: 0,
            x_max: 94,
            y_min: 16,
            y_max: 107,
            ha: 91,
            o: "m 135 68 b 89 154 94 68 89 124 l 46 154 b 36 92 45 131 42 105 b 0 68 32 82 23 68 l 0 23 b 68 63 29 23 53 40 b 135 23 84 39 104 23 z"
        },
        accSagittal2TinasDown: {
            x_min: 0,
            x_max: 94,
            y_min: -107,
            y_max: -16,
            ha: 91,
            o: "m 135 -23 b 68 -63 104 -23 84 -39 b 0 -23 53 -40 29 -23 l 0 -68 b 36 -92 23 -68 32 -82 b 46 -154 42 -105 45 -131 l 89 -154 b 135 -68 89 -124 94 -68 z"
        },
        accSagittal3TinasUp: {
            x_min: -7,
            x_max: 124,
            y_min: 16,
            y_max: 106,
            ha: 90,
            o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 134 150 179 112 163 135 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
        },
        accSagittal3TinasDown: {
            x_min: -7,
            x_max: 124,
            y_min: -106,
            y_max: -16,
            ha: 90,
            o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 179 -23 163 -135 179 -112 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
        },
        accSagittal4TinasUp: {
            x_min: 0,
            x_max: 187,
            y_min: 16,
            y_max: 107,
            ha: 91,
            o: "m 0 68 l 0 23 b 143 45 105 23 124 26 b 203 107 153 55 183 107 b 226 23 216 107 226 86 l 269 23 b 225 150 269 112 253 135 b 160 132 207 158 181 153 b 115 81 138 112 124 88 b 0 68 104 71 94 68 z"
        },
        accSagittal4TinasDown: {
            x_min: 0,
            x_max: 187,
            y_min: -107,
            y_max: -16,
            ha: 91,
            o: "m 0 -68 b 115 -81 94 -68 104 -71 b 160 -132 124 -88 138 -112 b 225 -150 181 -153 207 -158 b 269 -23 253 -135 269 -112 l 226 -23 b 203 -107 226 -86 216 -107 b 143 -45 183 -107 153 -55 b 0 -23 124 -26 105 -23 z"
        },
        accSagittal5TinasUp: {
            x_min: 0,
            x_max: 218,
            y_min: 16,
            y_max: 107,
            ha: 91,
            o: "m 135 23 b 187 45 156 23 168 26 b 249 107 197 55 228 107 b 271 23 262 107 271 86 l 314 23 b 269 150 314 112 298 135 b 204 132 252 158 226 153 b 160 81 183 112 168 88 b 135 68 148 71 147 68 b 89 154 94 68 89 124 l 46 154 b 36 92 45 131 42 105 b 0 68 32 82 23 68 l 0 23 b 68 63 29 23 53 40 b 135 23 84 39 104 23 z"
        },
        accSagittal5TinasDown: {
            x_min: 0,
            x_max: 218,
            y_min: -107,
            y_max: -16,
            ha: 91,
            o: "m 135 -23 b 68 -63 104 -23 84 -39 b 0 -23 53 -40 29 -23 l 0 -68 b 36 -92 23 -68 32 -82 b 46 -154 42 -105 45 -131 l 89 -154 b 135 -68 89 -124 94 -68 b 160 -81 147 -68 148 -71 b 204 -132 168 -88 183 -112 b 269 -150 226 -153 252 -158 b 314 -23 298 -135 314 -112 l 271 -23 b 249 -107 271 -86 262 -107 b 187 -45 228 -107 197 -55 b 135 -23 168 -26 156 -23 z"
        },
        accSagittal6TinasUp: {
            x_min: -7,
            x_max: 218,
            y_min: 16,
            y_max: 106,
            ha: 90,
            o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 207 65 179 23 200 55 b 252 107 223 86 240 107 b 271 23 264 107 272 86 l 314 23 b 269 150 314 112 298 135 b 203 130 252 158 220 150 b 173 92 190 115 181 104 b 134 150 167 127 154 140 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
        },
        accSagittal6TinasDown: {
            x_min: -7,
            x_max: 218,
            y_min: -106,
            y_max: -16,
            ha: 90,
            o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 173 -92 154 -140 167 -127 b 203 -130 181 -104 190 -115 b 269 -150 220 -150 252 -158 b 314 -23 298 -135 314 -112 l 271 -23 b 252 -107 272 -86 264 -107 b 207 -65 240 -107 223 -86 b 179 -23 200 -55 179 -23 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
        },
        accSagittal7TinasUp: {
            x_min: 0,
            x_max: 281,
            y_min: 16,
            y_max: 107,
            ha: 91,
            o: "m 0 68 l 0 23 b 143 45 105 23 124 26 b 203 107 153 55 183 107 b 226 23 216 107 226 86 l 269 23 b 298 65 269 23 291 55 b 343 107 314 86 331 107 b 361 23 354 107 363 86 l 405 23 b 360 150 405 112 389 135 b 294 130 343 158 311 150 b 264 92 281 115 272 104 b 225 150 258 127 245 140 b 160 132 207 158 181 153 b 115 81 138 112 124 88 b 0 68 104 71 94 68 z"
        },
        accSagittal7TinasDown: {
            x_min: 0,
            x_max: 281,
            y_min: -107,
            y_max: -16,
            ha: 91,
            o: "m 0 -68 b 115 -81 94 -68 104 -71 b 160 -132 124 -88 138 -112 b 225 -150 181 -153 207 -158 b 264 -92 245 -140 258 -127 b 294 -130 272 -104 281 -115 b 360 -150 311 -150 343 -158 b 405 -23 389 -135 405 -112 l 361 -23 b 343 -107 363 -86 354 -107 b 298 -65 331 -107 314 -86 b 269 -23 291 -55 269 -23 l 226 -23 b 203 -107 226 -86 216 -107 b 143 -45 183 -107 153 -55 b 0 -23 124 -26 105 -23 z"
        },
        accSagittal8TinasUp: {
            x_min: 0,
            x_max: 312,
            y_min: 16,
            y_max: 107,
            ha: 91,
            o: "m 135 23 b 187 45 156 23 168 26 b 249 107 197 55 228 107 b 271 23 262 107 271 86 l 314 23 b 343 65 314 23 336 55 b 387 107 359 86 376 107 b 406 23 399 107 408 86 l 449 23 b 405 150 449 112 433 135 b 338 130 387 158 356 150 b 308 92 325 115 317 104 b 269 150 302 127 289 140 b 204 132 252 158 226 153 b 160 81 183 112 168 88 b 135 68 148 71 147 68 b 89 154 94 68 89 124 l 46 154 b 36 92 45 131 42 105 b 0 68 32 82 23 68 l 0 23 b 68 63 29 23 53 40 b 135 23 84 39 104 23 z"
        },
        accSagittal8TinasDown: {
            x_min: 0,
            x_max: 312,
            y_min: -107,
            y_max: -16,
            ha: 91,
            o: "m 135 -23 b 68 -63 104 -23 84 -39 b 0 -23 53 -40 29 -23 l 0 -68 b 36 -92 23 -68 32 -82 b 46 -154 42 -105 45 -131 l 89 -154 b 135 -68 89 -124 94 -68 b 160 -81 147 -68 148 -71 b 204 -132 168 -88 183 -112 b 269 -150 226 -153 252 -158 b 308 -92 289 -140 302 -127 b 338 -130 317 -104 325 -115 b 405 -150 356 -150 387 -158 b 449 -23 433 -135 449 -112 l 406 -23 b 387 -107 408 -86 399 -107 b 343 -65 376 -107 359 -86 b 314 -23 336 -55 314 -23 l 271 -23 b 249 -107 271 -86 262 -107 b 187 -45 228 -107 197 -55 b 135 -23 168 -26 156 -23 z"
        },
        accSagittal9TinasUp: {
            x_min: -7,
            x_max: 312,
            y_min: 16,
            y_max: 106,
            ha: 90,
            o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 207 65 179 23 200 55 b 252 107 223 86 240 107 b 271 23 264 107 272 86 l 314 23 b 343 65 314 23 336 55 b 387 107 359 86 376 107 b 406 23 399 107 408 86 l 449 23 b 405 150 449 112 433 135 b 338 130 387 158 356 150 b 308 92 325 115 317 104 b 269 150 302 127 289 140 b 203 130 252 158 220 150 b 173 92 190 115 181 104 b 134 150 167 127 154 140 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
        },
        accSagittal9TinasDown: {
            x_min: -7,
            x_max: 312,
            y_min: -106,
            y_max: -16,
            ha: 90,
            o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 173 -92 154 -140 167 -127 b 203 -130 181 -104 190 -115 b 269 -150 220 -150 252 -158 b 308 -92 289 -140 302 -127 b 338 -130 317 -104 325 -115 b 405 -150 356 -150 387 -158 b 449 -23 433 -135 449 -112 l 406 -23 b 387 -107 408 -86 399 -107 b 343 -65 376 -107 359 -86 b 314 -23 336 -55 314 -23 l 271 -23 b 252 -107 272 -86 264 -107 b 207 -65 240 -107 223 -86 b 179 -23 200 -55 179 -23 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
        },
        accSagittalFractionalTinaUp: {
            x_min: -3,
            x_max: 35,
            y_min: 73,
            y_max: 111,
            ha: 38,
            o: "m -4 132 b 23 105 -4 118 9 105 b 50 132 37 105 50 118 b 23 160 50 147 37 160 b -4 132 9 160 -4 147 z"
        },
        accSagittalFractionalTinaDown: {
            x_min: -3,
            x_max: 35,
            y_min: -111,
            y_max: -73,
            ha: 38,
            o: "m -4 -132 b 23 -160 -4 -147 9 -160 b 50 -132 37 -160 50 -147 b 23 -105 50 -118 37 -105 b -4 -132 9 -105 -4 -118 z"
        },
        accidentalNarrowReversedFlat: {
            x_min: 0,
            x_max: 164,
            y_min: -194,
            y_max: 421,
            ha: 615,
            o: "m 236 -279 l 236 606 l 192 606 l 192 179 b 85 243 150 222 114 243 b 0 84 23 243 0 134 b 112 -158 0 3 37 -78 z m 192 112 l 192 -163 l 135 -98 b 82 40 101 -50 82 -3 b 138 144 82 73 96 144 b 192 112 153 144 170 132 z"
        },
        accidentalNarrowReversedFlatAndFlat: {
            x_min: 0,
            x_max: 414,
            y_min: -194,
            y_max: 421,
            ha: 615,
            o: "m 281 606 l 281 -268 l 438 -158 b 596 84 547 -82 596 3 b 475 243 596 154 556 243 b 325 179 435 243 384 222 l 325 606 z m 235 -279 l 235 606 l 190 606 l 190 179 b 85 243 148 222 114 243 b 12 158 52 243 27 215 b 0 84 3 134 0 108 b 112 -158 0 3 37 -78 z m 325 111 b 410 144 359 132 386 144 b 498 36 462 144 498 84 b 413 -107 498 -9 469 -58 l 325 -173 z m 192 112 l 192 -163 l 135 -98 b 81 40 99 -50 81 -3 b 91 94 81 59 84 76 b 137 144 102 127 118 144 b 192 112 153 144 170 132 z"
        },
        accidentalWilsonPlus: {
            x_min: 0,
            x_max: 281,
            y_min: -203,
            y_max: 203,
            ha: 406,
            o: "m 405 268 l 225 98 l 225 292 l 180 292 l 180 56 l 0 -112 l 0 -268 l 180 -98 l 180 -292 l 225 -292 l 225 -56 l 405 112 z"
        },
        accidentalWilsonMinus: {
            x_min: 0,
            x_max: 281,
            y_min: -186,
            y_max: 186,
            ha: 372,
            o: "m 0 112 l 405 -268 l 405 -112 l 0 268 z"
        }
    },
    fontFamily: "Bravura",
    resolution: 1e3,
    generatedOn: "2022-12-18T09:06:51.407Z"
};
// node_modules/vexflow/build/esm/src/fonts/common_metrics.js
var $a801f2c896bd09f1$var$CommonMetrics = {
    smufl: true,
    stave: {
        padding: 12,
        endPaddingMax: 10,
        endPaddingMin: 5,
        unalignedNotePadding: 10
    },
    accidental: {
        noteheadAccidentalPadding: 1,
        leftPadding: 2,
        accidentalSpacing: 3
    },
    chordSymbol: {
        global: {
            superscriptOffset: -400,
            subscriptOffset: 300,
            kerningOffset: -250,
            lowerKerningText: [
                "D",
                "F",
                "P",
                "T",
                "V",
                "Y"
            ],
            upperKerningText: [
                "A",
                "L"
            ],
            spacing: 100,
            superSubRatio: 0.66
        },
        glyphs: {
            csymDiminished: {
                leftSideBearing: -32,
                advanceWidth: 506,
                yOffset: 0
            },
            csymHalfDiminished: {
                leftSideBearing: -32,
                advanceWidth: 506,
                yOffset: 0
            },
            csymAugmented: {
                leftSideBearing: 0,
                advanceWidth: 530,
                yOffset: 0
            },
            csymParensLeftTall: {
                leftSideBearing: -20,
                advanceWidth: 184,
                yOffset: 250
            },
            csymParensRightTall: {
                leftSideBearing: 0,
                advanceWidth: 189,
                yOffset: 250
            },
            csymBracketLeftTall: {
                leftSideBearing: 0,
                advanceWidth: 328,
                yOffset: 0
            },
            csymBracketRightTall: {
                leftSideBearing: 1,
                advanceWidth: 600,
                yOffset: 0
            },
            csymParensLeftVeryTall: {
                leftSideBearing: 50,
                advanceWidth: 121,
                yOffset: 350
            },
            csymParensRightVeryTall: {
                leftSideBearing: 0,
                advanceWidth: 111,
                yOffset: 350
            },
            csymDiagonalArrangementSlash: {
                leftSideBearing: 250,
                advanceWidth: 990,
                yOffset: 300
            },
            csymMinor: {
                leftSideBearing: 0,
                advanceWidth: 482,
                yOffset: 0
            },
            csymMajorSeventh: {
                leftSideBearing: 200,
                yOffset: 0,
                advanceWidth: 600
            },
            accidentalSharp: {
                leftSideBearing: 20,
                advanceWidth: 250,
                yOffset: -302
            },
            accidentalFlat: {
                leftSideBearing: -20,
                advanceWidth: 226,
                yOffset: -184
            }
        }
    },
    clef_default: {
        width: 26,
        annotations: {
            "8va": {
                treble: {
                    line: -2,
                    shiftX: 12
                }
            },
            "8vb": {
                treble: {
                    line: 6.5,
                    shiftX: 10
                },
                bass: {
                    line: 4,
                    shiftX: 1
                }
            }
        }
    },
    clef_small: {
        width: 20,
        annotations: {
            "8va": {
                treble: {
                    line: -0.2,
                    shiftX: 8
                }
            },
            "8vb": {
                treble: {
                    line: 5.3,
                    shiftX: 6
                },
                bass: {
                    line: 3.1,
                    shiftX: 0.5
                }
            }
        }
    },
    ornament: {
        brassScoop: {
            xOffset: -12,
            yOffset: 0,
            stemUpYOffset: 0,
            reportedWidth: 20
        },
        brassDoitMedium: {
            xOffset: 16,
            yOffset: 0,
            stemUpYOffset: 0,
            reportedWidth: 22
        },
        brassFallLipShort: {
            xOffset: 16,
            yOffset: 0,
            stemUpYOffset: 0,
            reportedWidth: 15
        },
        brassLiftMedium: {
            xOffset: 16,
            yOffset: 5,
            stemUpYOffset: 0,
            reportedWidth: 5
        },
        brassFallRoughMedium: {
            xOffset: 16,
            yOffset: 28,
            stemUpYOffset: 0,
            reportedWidth: 5
        },
        brassBend: {
            xOffset: 2,
            yOffset: -8,
            stemUpYOffset: 25,
            reportedWidth: 5
        },
        brassMuteClosed: {
            xOffset: 3,
            yOffset: -8,
            stemUpYOffset: 25,
            reportedWidth: 5
        },
        brassMuteOpen: {
            xOffset: 3,
            yOffset: -7,
            stemUpYOffset: 25,
            reportedWidth: 5
        },
        brassFlip: {
            xOffset: 10,
            yOffset: 0,
            stemUpYOffset: 7,
            reportedWidth: 10
        },
        brassJazzTurn: {
            xOffset: 0,
            yOffset: 0,
            stemUpYOffset: 8,
            reportedWidth: 31
        },
        brassSmear: {
            xOffset: 10,
            yOffset: 0,
            stemUpYOffset: 8,
            reportedWidth: 5
        }
    },
    parenthesis: {
        default: {
            width: 7
        },
        gracenote: {
            width: 3
        }
    },
    pedalMarking: {},
    digits: {
        shiftLine: -1,
        shiftY: -6
    },
    articulation: {
        articStaccatissimoAbove: {
            padding: 2
        },
        articStaccatissimoBelow: {
            padding: 2
        }
    },
    tremolo: {
        default: {
            spacing: 7,
            offsetYStemUp: -8,
            offsetYStemDown: 8,
            offsetXStemUp: 11,
            offsetXStemDown: 1
        },
        grace: {
            spacing: 4.2,
            offsetYStemUp: -4.8,
            offsetYStemDown: 4.8,
            offsetXStemUp: 7,
            offsetXStemDown: 1
        }
    },
    staveRepetition: {
        symbolText: {
            offsetX: 12,
            offsetY: 25,
            spacing: 5
        },
        coda: {
            offsetY: 25
        },
        segno: {
            offsetY: 10
        }
    },
    noteHead: {
        minPadding: 2
    },
    stem: {
        heightAdjustmentForFlag: -3,
        noteHead: {
            noteheadTriangleUpHalf: {
                offsetYBaseStemUp: 5,
                offsetYBaseStemDown: 4
            },
            noteheadTriangleUpBlack: {
                offsetYBaseStemUp: 5,
                offsetYBaseStemDown: 4
            },
            noteheadTriangleUpWhole: {
                offsetYBaseStemUp: 5,
                offsetYBaseStemDown: 4
            },
            noteheadXHalf: {
                offsetYBaseStemUp: -4,
                offsetYBaseStemDown: 4
            },
            noteheadXBlack: {
                offsetYBaseStemUp: -4,
                offsetYBaseStemDown: 4
            },
            noteheadXWhole: {
                offsetYBaseStemUp: -4,
                offsetYBaseStemDown: 4
            },
            noteheadHalf: {
                offsetYBaseStemUp: -2.55,
                offsetYBaseStemDown: 2.65
            },
            noteheadBlack: {
                offsetYBaseStemUp: -2,
                offsetYBaseStemDown: 2
            },
            noteheadSquareWhite: {
                offsetYBaseStemDown: -5,
                offsetYBaseStemUp: 5
            }
        }
    },
    stringNumber: {
        verticalPadding: 8,
        stemPadding: 2,
        leftPadding: 5,
        rightPadding: 6
    },
    tuplet: {
        noteHeadOffset: 20,
        stemOffset: 10,
        bottomLine: 4,
        topModifierOffset: 15
    },
    glyphs: {
        coda: {
            shiftX: -7,
            shiftY: 8
        },
        segno: {
            shiftX: -7
        },
        flag: {
            shiftX: -0.75,
            staveTempo: {
                shiftX: -1
            }
        },
        clef_default: {},
        clef_small: {
            gClef: {
                shiftY: 1.5
            }
        },
        clefNote_default: {},
        clefNote_small: {},
        stroke_straight: {
            arrowheadBlackDown: {
                shiftX: -4.5
            },
            arrowheadBlackUp: {
                shiftX: -0.85
            }
        },
        stroke_wiggly: {
            arrowheadBlackDown: {
                shiftX: -1,
                shiftY: 1
            },
            arrowheadBlackUp: {
                shiftX: -1,
                shiftY: 1
            }
        },
        textNote: {
            breathMarkTick: {
                shiftY: 9
            },
            breathMarkComma: {},
            segno: {
                shiftX: -7,
                shiftY: 8
            },
            coda: {
                shiftX: -7,
                shiftY: 8
            },
            ornamentTrill: {
                shiftX: -8,
                shiftY: 8
            },
            ornamentTurn: {},
            ornamentTurnSlash: {},
            ornamentMordent: {
                shiftX: -8
            },
            ornamentShortTrill: {
                shiftX: -8
            }
        },
        noteHead: {},
        chordSymbol: {
            scale: 0.8
        }
    }
};
// node_modules/vexflow/build/esm/src/fonts/load_bravura.js
function $a801f2c896bd09f1$var$loadBravura() {
    $a801f2c896bd09f1$var$Font.load("Bravura", $a801f2c896bd09f1$var$BravuraFont, $a801f2c896bd09f1$var$CommonMetrics);
}
// node_modules/vexflow/build/esm/src/fonts/custom_glyphs.js
var $a801f2c896bd09f1$var$CustomFont = {
    resolution: 1e3,
    fontFamily: "VexFlowCustom",
    glyphs: {
        vexAccidentalMicrotonal1: {
            x_min: -171.5,
            x_max: 483.1875,
            ha: 493,
            o: "m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 495 20 616 20 616 b 20 373 20 427 20 373 b 115 410 20 373 63 390 l 210 448 l 210 531 b 212 620 210 614 210 616 b 231 632 215 628 223 632 b 246 627 236 632 242 631 b 251 541 251 620 251 628 l 251 463 l 315 489 b 387 514 368 509 381 514 b 393 513 390 514 392 514 b 406 494 402 510 406 502 b 397 476 406 487 404 480 b 323 446 396 474 363 462 l 251 417 l 251 283 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -19 -217 -9 -229 -16 -224 l -20 -215 l -21 48 l -21 310 l -83 287 b -152 262 -133 266 -145 262 b -157 263 -153 262 -155 262 b -171 283 -166 266 -171 274 b -161 301 -171 290 -167 297 b -91 328 -160 302 -129 315 l -21 356 l -21 487 l -20 617 l -19 621 b -8 631 -17 626 -12 630 m 210 288 b 210 401 210 351 210 401 b 114 365 209 401 167 384 l 20 327 l 20 238 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 180 164 199 187 192 l 209 177 b 209 177 209 177 209 177 b 210 288 210 177 210 199 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "
        },
        vexAccidentalMicrotonal3: {
            x_min: 0,
            x_max: 430.75,
            ha: 360,
            o: "m -146 537 b -138 538 -143 538 -141 538 b -118 525 -129 538 -121 533 b -117 390 -117 522 -117 521 b -115 259 -117 268 -117 259 b -115 259 -115 259 -115 259 b -59 272 -104 263 -62 272 b -39 259 -50 272 -42 267 b -37 209 -38 257 -37 233 b -39 159 -37 185 -38 162 b -85 138 -43 149 -44 149 l -117 131 l -117 21 b -115 -88 -117 -80 -117 -88 b -115 -88 -115 -88 -115 -88 b -59 -75 -104 -84 -62 -75 b -44 -81 -52 -75 -48 -77 b -38 -124 -38 -87 -38 -85 b -38 -138 -38 -124 -38 -138 b -38 -152 -38 -138 -38 -152 b -44 -195 -38 -191 -38 -190 b -85 -209 -48 -200 -48 -200 l -117 -217 l -117 -349 b -118 -486 -117 -481 -117 -482 b -138 -499 -121 -494 -129 -499 b -153 -493 -143 -499 -149 -497 b -159 -415 -158 -487 -159 -496 b -159 -355 -159 -398 -159 -379 b -159 -227 -159 -284 -159 -227 b -205 -238 -159 -227 -180 -232 b -250 -249 -230 -244 -250 -249 b -251 -386 -251 -249 -251 -311 b -252 -525 -251 -521 -251 -522 b -272 -538 -255 -534 -264 -538 b -287 -532 -277 -538 -283 -536 b -293 -452 -292 -527 -293 -536 b -293 -391 -293 -436 -293 -415 b -294 -260 -293 -269 -293 -260 b -294 -260 -294 -260 -294 -260 b -348 -272 -306 -264 -345 -272 b -368 -259 -357 -272 -365 -267 b -369 -209 -369 -257 -369 -233 b -368 -159 -369 -185 -369 -162 b -323 -139 -364 -149 -362 -148 l -293 -131 l -293 -22 b -294 87 -293 80 -293 87 b -294 87 -294 87 -294 87 b -348 75 -306 84 -345 75 b -368 88 -357 75 -365 80 b -369 138 -369 91 -369 114 b -368 188 -369 162 -369 186 b -323 209 -364 198 -362 199 l -293 216 l -293 349 b -292 486 -293 481 -293 482 b -272 499 -288 494 -280 499 b -257 493 -266 499 -261 497 b -251 414 -251 487 -251 496 b -251 354 -251 398 -251 378 b -251 226 -251 284 -251 226 b -205 238 -250 226 -230 231 b -159 249 -180 244 -159 249 b -159 385 -159 249 -159 310 b -157 525 -159 521 -159 522 b -146 537 -156 530 -151 535 z m -159 11 b -159 120 -159 98 -159 120 l -159 120 b -175 116 -160 120 -167 119 b -221 105 -184 114 -204 109 l -251 98 l -251 -12 b -251 -121 -251 -72 -251 -121 b -205 -110 -250 -121 -230 -116 b -159 -99 -180 -104 -159 -99 b -159 11 -159 -99 -159 -49 z m 89 517 b 97 519 92 518 94 519 b 117 505 106 519 114 513 b 119 376 119 502 119 501 l 119 249 l 145 258 b 176 267 169 266 172 267 b 177 267 176 267 177 267 b 196 255 186 267 192 263 l 197 252 l 197 205 b 197 181 197 195 197 187 b 193 149 197 153 197 153 b 152 131 190 144 187 143 l 119 120 l 119 10 b 119 -100 119 -62 119 -100 b 145 -91 120 -100 131 -96 b 173 -82 159 -86 171 -82 b 176 -81 174 -81 175 -81 b 196 -94 185 -81 193 -87 b 198 -151 197 -97 198 -125 b 197 -194 198 -172 197 -192 b 153 -218 193 -203 192 -204 l 119 -230 l 119 -367 l 118 -504 l 117 -507 b 97 -519 113 -514 105 -519 b 82 -512 92 -519 87 -517 b 76 -434 77 -507 76 -516 b 76 -374 76 -418 76 -398 b 76 -245 76 -303 76 -245 b 52 -254 76 -245 65 -249 b 19 -263 34 -260 25 -263 b 6 -257 13 -263 10 -261 b 0 -214 0 -251 0 -253 b 0 -200 0 -210 0 -205 b 0 -188 0 -196 0 -192 b 6 -143 0 -147 0 -149 b 46 -126 10 -139 10 -139 l 76 -115 l 76 -5 b 76 106 76 56 76 106 b 51 98 76 106 64 102 b 18 89 34 92 25 89 b 6 95 13 89 10 91 b 0 139 0 101 0 99 b 0 153 0 143 0 148 b 0 179 0 163 0 172 b 44 225 0 215 3 211 l 76 236 l 76 369 b 78 505 76 501 76 502 b 89 517 80 510 85 515 z "
        },
        vexAccidentalMicrotonal4: {
            x_min: 0,
            x_max: 430.75,
            ha: 360,
            o: "m 283 633 b 291 634 286 634 289 634 b 311 621 300 634 308 629 b 313 505 313 618 313 617 b 313 393 313 443 313 393 b 378 425 313 393 343 407 l 443 458 l 448 458 b 449 458 449 458 449 458 b 471 437 462 458 471 448 b 469 429 471 434 470 432 b 387 382 466 421 469 423 l 313 344 l 313 247 l 313 150 l 315 152 b 433 201 353 184 394 201 b 479 193 448 201 464 198 b 549 86 524 177 549 135 b 526 1 549 59 541 29 b 395 -143 504 -39 475 -71 b 316 -214 351 -182 341 -191 b 292 -229 302 -228 300 -229 b 272 -216 283 -229 275 -224 b 271 55 271 -212 271 -212 b 270 323 271 203 270 323 b 205 291 270 323 241 308 l 140 258 l 135 258 b 134 258 135 258 134 258 b 112 279 121 258 112 267 b 114 287 112 281 113 284 b 196 334 117 295 114 293 l 271 371 l 271 495 b 272 621 271 617 271 618 b 283 633 274 626 279 631 z m 404 133 b 391 134 400 134 395 134 b 384 134 388 134 386 134 b 318 88 358 130 335 114 l 313 81 l 313 -37 l 313 -156 l 316 -152 b 439 83 391 -71 439 22 l 439 84 b 404 133 439 115 430 128 z m -8 633 l -8 633 b 0 634 -6 634 -3 634 b 20 621 8 634 17 629 b 21 384 21 618 21 617 l 21 150 l 24 152 b 141 201 62 184 102 201 b 187 193 157 201 172 198 b 257 86 232 177 257 135 b 234 1 257 59 250 29 b 103 -143 212 -39 183 -71 b 24 -214 60 -182 49 -191 b 0 -229 10 -228 8 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 203 l -21 618 l -20 621 b -8 633 -18 626 -13 631 z m 113 133 l 113 133 b 99 134 109 134 103 134 b 93 134 97 134 94 134 b 26 88 66 130 43 114 l 21 81 l 21 -37 l 21 -156 l 25 -152 b 148 83 99 -71 148 22 l 148 84 b 113 133 148 115 138 128 z "
        },
        vexNoteHeadRectBlack: {
            x_min: 0,
            x_max: 430.75,
            ha: 360,
            o: "m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 "
        },
        vexNoteHeadRectWhite: {
            x_min: 0,
            x_max: 430.75,
            ha: 360,
            o: "m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 l 50 100 l 380 100 l 380 -100 l 50 -100 l 50 100"
        },
        vexWiggleArpeggioUp: {
            x_min: 58.53125,
            x_max: 228.671875,
            ha: 294,
            o: "m 138 371 b 142 373 140 371 141 373 b 178 342 149 373 156 366 b 228 251 217 297 228 278 b 228 244 228 248 228 247 b 176 147 227 212 212 184 b 123 73 152 122 132 93 b 121 62 122 70 121 66 b 145 13 121 48 129 31 b 153 -2 151 6 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 145 -11 b 129 -1 140 -11 136 -8 b 61 87 89 37 68 68 b 58 113 59 95 58 105 b 110 215 58 144 74 177 b 163 287 134 240 155 269 b 166 299 166 291 166 295 b 141 348 166 313 157 330 b 133 360 134 356 133 358 b 133 363 133 362 133 362 b 138 371 133 367 136 370 "
        }
    }
};
// node_modules/vexflow/build/esm/src/fonts/load_custom.js
function $a801f2c896bd09f1$var$loadCustom() {
    $a801f2c896bd09f1$var$Font.load("Custom", $a801f2c896bd09f1$var$CustomFont, $a801f2c896bd09f1$var$CommonMetrics);
}
// node_modules/vexflow/build/esm/src/fonts/gonville_glyphs.js
var $a801f2c896bd09f1$var$GonvilleSmuflFont = {
    glyphs: {
        bracketTop: {
            x_min: 0,
            x_max: 412,
            y_min: -18,
            y_max: 223,
            ha: 241,
            o: "m 569 315 b 583 321 575 319 579 321 b 591 316 586 321 589 319 b 593 310 592 314 593 312 b 579 289 593 306 589 301 b 385 111 517 219 449 156 b 372 101 379 106 373 102 b 244 28 340 78 285 46 b 21 -26 168 -6 88 -26 b 2 -21 6 -26 5 -25 b 0 47 1 -19 0 14 b 2 114 0 79 1 112 b 29 120 5 119 6 119 b 569 315 209 124 395 191 z"
        },
        bracketBottom: {
            x_min: 0,
            x_max: 412,
            y_min: -223,
            y_max: 18,
            ha: 241,
            o: "m 5 24 b 21 26 7 25 12 26 b 63 23 32 26 47 25 b 342 -81 155 13 249 -22 b 388 -113 353 -89 382 -108 b 400 -122 389 -114 395 -118 b 578 -289 459 -166 522 -225 b 593 -310 589 -301 593 -306 b 591 -316 593 -312 592 -314 b 583 -321 588 -319 586 -321 b 568 -315 579 -321 575 -319 b 29 -120 395 -191 209 -124 b 1 -114 5 -119 5 -119 b 0 -47 0 -112 0 -111 b 0 -22 0 -37 0 -29 b 5 24 0 25 0 21 z"
        },
        barlineTick: {
            x_min: -59,
            x_max: 59,
            y_min: -139,
            y_max: 139,
            ha: 279,
            o: "m 24 200 b 34 201 26 200 30 201 b 51 198 40 201 47 200 b 84 152 72 191 84 174 b 84 149 84 151 84 150 b 68 103 84 139 83 137 b -64 -195 3 -44 -63 -194 b -74 -201 -66 -199 -70 -201 b -83 -195 -77 -201 -81 -199 b -84 -191 -84 -194 -84 -193 b -78 -155 -84 -186 -83 -177 b -25 104 -45 8 -35 53 b -11 167 -18 136 -12 164 b 24 200 -6 183 6 195 z"
        },
        breathMarkTick: {
            x_min: -151,
            x_max: 272,
            y_min: 0,
            y_max: 429,
            ha: 429,
            o: "m 367 613 b 382 618 373 616 378 618 b 392 607 388 618 392 614 b 376 592 392 601 390 599 b 309 546 354 580 331 565 b 46 47 185 439 88 256 b 0 0 39 14 26 0 b -44 39 -23 0 -36 12 b -203 270 -68 118 -125 202 b -217 288 -213 279 -217 284 b -215 294 -217 290 -217 292 b -208 299 -213 297 -211 299 b -193 293 -204 299 -199 297 b -19 144 -124 249 -66 199 b -14 138 -16 141 -14 138 b -9 149 -14 138 -11 143 b 367 613 72 359 220 541 z"
        },
        segno: {
            x_min: 7,
            x_max: 493,
            y_min: -50,
            y_max: 650,
            ha: 699,
            o: "m 218 934 b 237 935 224 935 231 935 b 394 820 306 935 371 889 b 398 794 397 811 398 802 b 333 730 398 758 372 730 b 269 777 302 730 280 746 b 183 851 254 823 219 851 b 158 846 175 851 166 849 b 120 786 133 835 120 815 b 122 766 120 780 121 773 b 347 511 138 672 227 570 b 368 500 356 506 366 501 l 371 499 l 372 501 b 485 672 373 502 404 550 b 560 786 506 704 540 755 b 617 873 581 818 607 857 b 645 910 639 906 640 907 b 660 915 650 914 655 915 b 687 888 674 915 687 904 b 687 886 687 887 687 887 b 665 844 687 878 687 878 b 610 761 655 830 631 792 b 462 537 551 672 501 595 b 425 480 443 508 426 482 l 422 476 l 431 472 b 628 269 521 423 591 352 b 658 136 649 225 658 179 b 518 -68 658 36 606 -48 b 484 -71 507 -70 495 -71 b 327 43 415 -71 351 -26 b 322 70 324 52 322 61 b 387 134 322 106 348 134 b 451 86 419 134 440 118 b 537 13 466 41 501 13 b 563 18 545 13 554 15 b 600 78 587 29 600 49 b 598 98 600 84 599 91 b 374 353 582 192 493 293 b 352 363 364 358 354 363 l 349 365 l 348 363 b 235 192 347 361 315 313 b 160 77 214 160 180 109 b 103 -9 139 46 113 7 b 75 -47 81 -42 80 -43 b 60 -51 70 -50 65 -51 b 33 -24 46 -51 33 -40 b 33 -22 33 -23 33 -23 b 55 19 33 -14 33 -14 b 259 329 84 63 162 181 b 297 386 279 360 296 385 l 298 388 l 290 392 b 92 594 200 441 130 512 b 62 728 71 639 62 685 b 218 934 62 834 121 922 z m 630 616 b 643 618 634 617 639 618 b 699 589 665 618 687 607 b 709 552 706 578 709 565 b 699 515 709 539 706 526 b 644 486 686 496 665 486 b 596 507 626 486 609 493 b 578 551 584 520 578 536 b 630 616 578 581 598 609 z m 62 376 b 75 378 67 377 71 378 b 124 357 93 378 112 370 b 142 312 136 344 142 328 b 131 275 142 299 138 286 b 76 246 118 256 97 246 b 28 267 59 246 41 253 b 11 311 16 280 11 296 b 62 376 11 341 30 369 z"
        },
        coda: {
            x_min: 22,
            x_max: 478,
            y_min: -31,
            y_max: 531,
            ha: 563,
            o: "m 350 764 b 359 765 352 765 355 765 b 367 764 362 765 365 765 b 381 753 373 762 378 758 b 386 706 386 746 386 747 b 387 670 386 672 386 670 b 448 647 396 670 430 657 b 597 395 532 601 587 507 l 598 386 l 632 386 b 677 382 670 386 670 386 b 689 359 685 376 689 367 b 677 336 689 350 685 341 b 632 331 670 331 670 331 l 598 331 l 597 322 b 396 50 585 186 504 77 b 387 48 392 49 388 48 b 386 12 386 48 386 46 l 386 8 b 380 -36 386 -29 386 -28 b 359 -45 375 -42 367 -45 b 338 -36 351 -45 342 -42 b 331 8 331 -28 331 -29 l 331 12 b 330 48 331 46 331 48 b 269 70 321 48 288 60 b 120 322 186 117 130 210 l 119 331 l 86 331 b 43 336 50 331 50 331 b 31 359 35 341 31 350 b 50 385 31 370 38 381 b 86 386 53 386 60 386 l 119 386 l 120 395 b 269 647 130 508 186 601 b 330 670 288 657 321 670 b 331 706 331 670 331 672 b 332 746 331 736 332 744 b 350 764 335 754 342 762 z m 331 502 b 331 617 331 565 331 617 b 310 599 329 617 317 607 b 229 393 266 555 235 477 l 229 386 l 280 386 l 331 386 z m 393 613 b 386 617 390 615 387 617 b 386 502 386 617 386 565 l 386 386 l 437 386 l 488 386 l 488 393 b 393 613 482 486 443 575 z m 331 216 l 331 331 l 280 331 l 229 331 l 229 324 b 310 118 235 241 266 162 b 331 100 317 111 329 100 b 331 216 331 100 331 152 z m 488 324 l 488 331 l 437 331 l 386 331 l 386 216 b 386 100 386 152 386 100 b 408 118 388 100 400 111 b 488 324 452 162 482 241 z"
        },
        gClef: {
            x_min: 0,
            x_max: 623,
            y_min: -632,
            y_max: 1082,
            ha: 1713,
            o: "m 521 1558 b 524 1558 522 1558 523 1558 b 579 1515 537 1558 556 1543 b 718 1118 662 1415 718 1254 b 717 1089 718 1108 718 1098 b 505 667 707 930 639 793 b 470 633 493 655 477 640 l 456 620 l 483 495 b 510 369 498 426 510 369 b 510 369 510 369 510 369 b 519 370 511 369 514 370 b 558 372 525 371 542 372 b 590 371 572 372 585 371 b 897 45 760 350 885 217 b 898 22 897 38 898 30 b 666 -316 898 -120 805 -256 b 657 -320 661 -318 657 -320 b 675 -403 657 -320 665 -357 b 695 -500 685 -448 694 -491 b 704 -596 701 -534 704 -566 b 642 -796 704 -677 683 -744 b 407 -909 582 -871 495 -909 b 176 -804 323 -909 238 -874 b 137 -704 150 -774 137 -739 b 168 -612 137 -672 147 -640 b 291 -550 198 -571 245 -550 b 405 -604 333 -550 376 -568 b 437 -694 427 -632 437 -663 b 305 -834 437 -764 384 -831 l 294 -835 l 298 -836 b 405 -861 330 -853 367 -861 b 539 -823 453 -861 501 -848 b 655 -596 617 -774 655 -699 b 644 -490 655 -564 651 -528 b 611 -336 640 -471 611 -336 b 611 -336 611 -336 611 -336 b 598 -339 610 -336 605 -337 b 536 -349 579 -343 558 -347 b 498 -350 529 -350 514 -350 b 449 -349 478 -350 457 -350 b 0 149 189 -320 0 -110 b 102 460 0 264 33 364 b 342 742 175 562 250 650 l 374 774 l 360 839 b 342 922 352 874 344 912 b 321 1024 329 983 323 1013 b 312 1124 315 1057 312 1091 b 477 1523 312 1275 371 1420 b 521 1558 501 1546 513 1556 z m 591 1349 b 574 1351 586 1350 580 1351 b 471 1297 542 1351 506 1332 b 376 1044 410 1236 376 1145 b 383 967 376 1019 378 993 b 415 814 385 956 414 814 b 415 814 415 814 415 814 b 460 860 416 814 450 848 b 644 1242 578 991 644 1132 b 639 1295 644 1261 643 1278 b 591 1349 632 1327 618 1342 z m 418 565 b 415 577 417 571 416 577 b 290 431 412 577 327 479 b 160 220 210 331 182 284 b 135 74 143 172 135 122 b 209 -162 135 -11 160 -94 b 495 -314 278 -259 385 -314 b 550 -310 514 -314 532 -313 b 602 -296 570 -306 602 -298 b 574 -164 602 -295 590 -236 b 522 81 559 -92 535 18 b 497 196 508 144 497 196 b 497 196 497 196 497 196 b 457 179 493 196 469 186 b 358 16 391 144 358 79 b 438 -128 358 -40 384 -95 b 455 -151 449 -135 455 -143 b 448 -165 455 -156 452 -160 b 434 -172 444 -169 440 -172 b 401 -159 427 -172 417 -168 b 256 82 305 -110 256 -15 b 386 322 256 172 299 264 b 462 358 408 337 453 358 b 462 359 462 358 462 358 b 462 360 462 359 462 359 b 418 565 462 362 422 547 z m 581 203 b 558 204 576 204 565 204 l 545 204 l 546 202 b 589 -1 546 201 565 109 b 634 -214 613 -112 633 -208 b 642 -251 636 -220 639 -237 l 648 -277 l 651 -275 b 776 -137 710 -241 752 -195 b 795 -42 789 -106 795 -73 b 581 203 795 78 707 188 z"
        },
        cClef: {
            x_min: 0,
            x_max: 643,
            y_min: -508,
            y_max: 508,
            ha: 1016,
            o: "m 0 0 l 0 731 l 87 731 l 175 731 l 175 0 l 175 -731 l 87 -731 l 0 -731 z m 240 0 l 240 731 l 262 731 l 284 731 l 284 382 l 284 32 l 291 38 b 374 145 318 61 351 104 b 439 314 402 196 423 251 b 458 341 444 338 447 341 b 475 319 470 341 474 335 b 647 120 483 206 560 120 b 665 122 653 120 659 121 b 771 330 741 132 766 181 b 772 404 772 357 772 381 b 707 662 772 557 753 630 b 615 687 684 679 651 687 b 517 666 582 687 548 680 b 504 660 509 663 504 660 b 504 660 504 660 504 660 b 578 578 545 658 578 621 b 578 575 578 577 578 576 b 492 494 576 524 534 494 b 419 534 465 494 437 506 b 403 584 408 550 403 567 b 434 651 403 608 413 632 b 616 721 485 698 550 721 b 884 565 720 721 826 665 b 925 406 912 515 925 460 b 719 99 925 272 846 140 b 648 87 694 91 671 87 b 543 122 610 87 576 99 b 536 126 540 124 536 126 b 535 126 535 126 535 126 b 497 63 535 126 518 98 l 459 0 l 497 -63 b 535 -126 518 -98 535 -126 b 536 -126 535 -126 535 -126 b 543 -122 536 -126 540 -124 b 648 -87 575 -99 610 -87 b 677 -89 657 -87 667 -88 b 924 -382 811 -110 913 -230 b 925 -407 925 -391 925 -399 b 639 -720 925 -570 803 -706 b 615 -721 631 -720 623 -721 b 430 -647 545 -721 478 -694 b 403 -585 412 -629 403 -607 b 492 -494 403 -538 439 -494 b 497 -494 493 -494 495 -494 b 578 -578 545 -496 578 -536 b 564 -625 578 -594 574 -610 b 504 -660 551 -644 525 -659 b 504 -660 504 -660 504 -660 b 517 -666 504 -660 509 -663 b 615 -687 548 -680 582 -687 b 707 -662 651 -687 684 -679 b 772 -404 753 -630 772 -557 b 771 -330 772 -381 772 -357 b 665 -122 766 -181 741 -132 b 647 -120 659 -121 653 -120 b 475 -319 560 -120 483 -206 b 458 -341 474 -335 470 -341 b 439 -314 447 -341 444 -338 b 374 -145 423 -251 402 -196 b 291 -38 351 -104 317 -61 l 284 -32 l 284 -382 l 284 -731 l 262 -731 l 240 -731 z"
        },
        fClef: {
            x_min: 0,
            x_max: 661,
            y_min: -545,
            y_max: 254,
            ha: 798,
            o: "m 326 364 b 356 365 336 365 346 365 b 647 278 464 365 575 332 b 788 -2 740 207 788 112 b 785 -51 788 -18 787 -34 b 161 -747 750 -356 500 -634 b 16 -784 110 -764 31 -784 b 0 -768 7 -784 0 -778 b 24 -747 0 -758 3 -755 b 601 -72 353 -625 575 -364 b 603 -10 602 -51 603 -30 b 469 298 603 133 556 243 b 346 332 432 321 389 332 b 100 185 248 332 146 277 b 89 161 97 178 89 162 b 89 161 89 161 89 161 b 95 164 90 161 92 162 b 169 185 118 179 144 185 b 308 74 232 185 293 142 b 311 42 310 63 311 53 b 167 -101 311 -36 248 -101 b 147 -99 161 -101 154 -100 b 9 79 65 -88 9 -15 l 9 79 b 326 364 9 228 148 353 z m 888 225 b 894 225 889 225 891 225 b 914 223 901 225 910 224 b 952 171 940 214 952 192 b 914 118 952 149 939 127 b 898 116 910 117 904 116 b 881 118 892 116 886 117 b 843 170 856 127 843 149 b 888 225 843 195 859 219 z m 888 -116 b 894 -116 889 -116 891 -116 b 914 -118 901 -116 910 -117 b 952 -170 940 -127 952 -149 b 914 -223 952 -192 939 -214 b 898 -225 910 -224 904 -225 b 881 -223 892 -225 886 -224 b 843 -171 856 -214 843 -193 b 888 -116 843 -146 859 -122 z"
        },
        unpitchedPercussionClef1: {
            x_min: -4,
            x_max: 337,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m -6 0 l -6 360 l 75 360 l 157 360 l 157 0 l 157 -360 l 75 -360 l -6 -360 z m 321 0 l 321 360 l 403 360 l 485 360 l 485 0 l 485 -360 l 403 -360 l 321 -360 z"
        },
        "6stringTabClef": {
            x_min: 0,
            x_max: 501,
            y_min: -735,
            y_max: 753,
            ha: 1487,
            o: "m 633 1083 b 639 1084 635 1084 637 1084 b 669 1072 650 1084 661 1079 b 681 1043 677 1063 681 1053 b 657 1004 681 1028 673 1013 b 467 964 609 980 535 964 l 452 964 l 452 959 b 456 874 455 932 456 903 b 418 611 456 781 443 686 b 245 415 380 495 327 435 b 195 409 228 411 214 409 b 147 412 182 409 167 410 b 110 453 124 414 110 433 b 122 482 110 464 114 474 b 151 494 130 490 141 494 b 184 478 163 494 175 489 b 194 475 186 476 190 475 b 224 486 202 475 213 479 b 283 575 246 500 263 527 b 335 871 317 657 335 760 b 331 967 335 903 334 935 l 330 980 l 321 982 b 260 992 301 989 280 992 b 139 927 206 992 160 968 b 90 895 128 906 109 895 b 42 933 70 895 49 908 b 40 947 40 937 40 942 b 105 1020 40 972 61 996 b 263 1058 150 1045 207 1058 b 350 1047 293 1058 323 1054 b 465 1030 389 1036 429 1030 b 612 1073 526 1030 579 1045 b 633 1083 618 1078 625 1082 z m 441 376 b 448 376 443 376 445 376 b 470 374 456 376 465 375 b 511 321 494 366 509 346 b 534 155 515 283 525 210 b 621 -190 556 21 589 -109 b 668 -253 632 -220 651 -245 l 672 -254 l 676 -253 b 687 -252 680 -252 683 -252 b 721 -287 707 -252 721 -269 b 705 -316 721 -298 716 -309 b 676 -321 699 -320 689 -321 b 650 -319 668 -321 659 -321 b 506 -206 588 -312 533 -269 b 444 0 487 -163 460 -72 b 441 8 443 4 441 8 b 441 8 441 8 441 8 b 436 -3 441 7 438 2 b 381 -99 422 -33 400 -72 b 375 -109 377 -105 375 -107 b 381 -114 375 -111 377 -112 b 435 -133 398 -126 415 -132 b 452 -138 446 -134 448 -134 b 457 -150 455 -141 457 -145 b 446 -166 457 -156 453 -163 b 406 -174 434 -171 420 -174 b 344 -160 385 -174 363 -169 l 337 -156 l 334 -159 b 49 -314 250 -255 145 -311 b 39 -315 45 -315 42 -315 b 10 -305 23 -315 18 -312 b 0 -281 3 -298 0 -290 b 34 -247 0 -264 14 -247 b 40 -248 36 -247 38 -247 b 46 -248 42 -248 44 -248 b 144 -208 69 -248 108 -233 b 390 306 283 -115 381 90 b 394 334 391 320 392 328 b 441 376 401 356 419 372 z m 376 -371 b 408 -371 383 -371 395 -371 b 451 -372 425 -371 444 -371 b 529 -388 482 -376 502 -380 b 689 -546 621 -417 689 -484 b 563 -696 689 -599 639 -658 l 552 -701 l 561 -705 b 700 -882 646 -748 700 -818 b 699 -896 700 -887 700 -892 b 503 -1054 689 -974 608 -1039 b 451 -1058 486 -1057 468 -1058 b 272 -1010 389 -1058 329 -1042 b 248 -972 257 -1001 248 -987 b 249 -963 248 -969 248 -966 l 250 -959 l 249 -960 b 241 -966 248 -961 244 -964 b 124 -1015 208 -992 168 -1009 b 90 -1017 118 -1016 104 -1017 b 48 -1015 72 -1017 52 -1016 b 19 -977 30 -1009 19 -993 b 31 -949 19 -967 23 -957 b 59 -937 39 -941 49 -937 b 85 -947 68 -937 77 -941 l 88 -951 l 94 -951 b 210 -845 134 -951 183 -906 b 220 -821 212 -840 216 -830 b 286 -526 264 -724 286 -623 b 283 -469 286 -507 285 -488 b 282 -459 283 -463 282 -459 b 282 -459 282 -459 282 -459 b 256 -469 281 -459 266 -464 b 141 -563 201 -491 160 -526 b 94 -592 130 -583 112 -592 b 43 -540 68 -592 43 -573 b 88 -476 43 -518 51 -505 b 376 -371 158 -418 261 -381 z m 432 -437 b 411 -437 427 -437 418 -437 l 399 -437 l 400 -440 b 406 -505 402 -448 405 -478 b 407 -527 407 -512 407 -520 b 334 -840 407 -628 382 -737 b 284 -925 315 -881 304 -901 b 280 -930 281 -928 280 -929 b 281 -930 280 -930 280 -930 b 284 -930 281 -930 282 -930 b 291 -929 286 -929 288 -929 b 320 -941 300 -929 310 -933 b 452 -991 362 -975 405 -991 l 452 -991 b 580 -883 531 -991 580 -941 b 538 -791 580 -852 566 -820 b 421 -733 508 -761 470 -742 b 392 -715 405 -730 397 -724 b 388 -698 389 -709 388 -703 b 420 -665 388 -681 401 -667 b 567 -563 490 -658 555 -613 b 569 -546 568 -557 569 -552 b 432 -437 569 -493 510 -444 z"
        },
        timeSig0: {
            x_min: 0,
            x_max: 380,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 249 313 b 272 314 256 314 264 314 b 428 259 325 314 385 293 b 547 0 505 196 547 105 b 544 -49 547 -16 546 -32 b 273 -314 526 -197 407 -314 b 32 -149 175 -314 81 -250 b 0 0 11 -105 0 -53 b 32 150 0 53 11 106 b 249 313 78 242 158 302 z m 293 279 b 273 281 286 280 280 281 b 203 251 242 281 216 270 b 170 -3 185 224 170 102 b 172 -59 170 -23 171 -42 b 203 -251 178 -163 189 -231 b 273 -281 216 -270 243 -281 b 306 -277 284 -281 295 -280 b 366 -160 344 -267 356 -243 b 376 0 373 -103 376 -51 b 366 160 376 51 373 103 b 293 279 355 250 341 272 z m 273 -360 l 275 -360 l 272 -360 z m 273 340 l 275 340 l 272 340 z"
        },
        timeSig1: {
            x_min: 0,
            x_max: 254,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 135 302 b 210 303 137 303 141 303 b 235 303 219 303 228 303 b 290 298 290 303 286 303 b 295 70 295 293 295 314 b 300 -219 295 -201 295 -202 b 352 -269 307 -239 324 -255 b 366 -287 361 -274 366 -280 b 361 -298 366 -291 364 -295 b 266 -303 357 -303 367 -303 b 210 -303 250 -303 232 -303 b 154 -303 188 -303 170 -303 b 59 -298 53 -303 63 -303 b 54 -287 55 -295 54 -291 b 68 -269 54 -280 59 -274 b 120 -219 96 -255 113 -239 b 125 -50 124 -205 125 -193 b 125 24 125 -29 125 -4 l 125 189 l 120 181 b 90 136 116 176 103 156 b 48 72 77 116 58 87 b 16 38 26 38 26 38 b 0 54 6 38 0 45 b 0 56 0 55 0 55 l 0 60 l 64 178 b 135 302 128 296 130 299 z m 183 -360 l 184 -360 l 182 -360 z m 183 340 l 184 340 l 182 340 z"
        },
        timeSig2: {
            x_min: 0,
            x_max: 337,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 210 313 b 232 314 217 314 224 314 b 317 303 261 314 293 310 b 459 147 407 277 459 217 b 441 77 459 124 453 101 b 258 -67 409 10 349 -37 b 76 -181 173 -95 117 -130 l 73 -185 l 77 -182 b 226 -128 121 -146 174 -128 b 322 -152 260 -128 293 -136 b 378 -173 346 -165 359 -170 b 395 -174 383 -174 389 -174 b 454 -149 421 -174 446 -164 b 470 -139 457 -142 464 -139 b 486 -155 478 -139 486 -145 b 462 -217 486 -165 474 -197 b 319 -313 428 -276 373 -313 l 318 -313 b 273 -300 296 -313 290 -311 b 133 -256 226 -271 178 -256 b 93 -260 119 -256 106 -257 b 32 -294 68 -265 41 -280 b 15 -303 28 -300 21 -303 b 1 -292 9 -303 3 -299 b 0 -284 0 -291 0 -288 b 6 -234 0 -271 3 -249 b 180 -36 28 -147 90 -75 b 303 122 246 -7 290 50 b 305 146 305 130 305 138 b 272 225 305 177 294 204 b 185 259 249 248 220 259 b 163 257 178 259 170 258 b 152 256 155 257 152 256 b 155 253 152 255 153 254 b 191 188 180 238 191 213 b 138 112 191 156 173 124 b 112 108 129 109 120 108 b 29 191 67 108 29 146 b 33 214 29 199 30 206 b 210 313 46 263 122 305 z m 243 -360 l 244 -360 l 241 -360 z m 243 340 l 244 340 l 241 340 z"
        },
        timeSig3: {
            x_min: 0,
            x_max: 302,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 179 313 b 209 314 189 314 199 314 b 429 163 327 314 429 247 b 282 29 429 110 369 56 l 272 26 l 275 25 b 430 -111 354 -1 413 -53 b 435 -147 433 -123 435 -136 b 268 -308 435 -222 369 -288 b 211 -314 249 -312 230 -314 b 24 -241 140 -314 72 -288 b 0 -185 7 -224 0 -204 b 82 -100 0 -142 35 -100 b 97 -101 87 -100 92 -100 b 162 -180 140 -109 162 -145 b 113 -251 162 -209 146 -239 b 110 -253 111 -252 110 -252 b 120 -256 110 -253 113 -254 b 164 -261 136 -260 150 -261 b 248 -228 197 -261 226 -250 b 281 -145 270 -206 281 -178 b 278 -112 281 -135 280 -123 b 157 10 264 -42 215 7 b 135 27 141 11 135 16 b 157 44 135 39 141 43 b 272 137 210 47 257 85 b 276 162 275 145 276 154 b 194 256 276 206 244 245 b 167 258 188 258 178 258 b 124 255 152 258 136 257 l 119 254 l 123 252 b 162 186 149 238 162 212 b 108 110 162 154 144 121 b 83 105 100 107 91 105 b 0 189 37 105 0 144 b 8 224 0 200 3 212 b 179 313 28 266 103 305 z m 217 -360 l 219 -360 l 216 -360 z m 217 340 l 219 340 l 216 340 z"
        },
        timeSig4: {
            x_min: 0,
            x_max: 345,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 184 302 b 304 303 186 303 247 303 b 403 302 354 303 401 303 b 412 286 409 299 412 294 b 392 256 412 280 411 278 b 260 108 374 236 318 173 b 222 67 243 89 226 71 b 165 3 218 62 193 34 b 90 -82 138 -28 104 -66 b 65 -111 77 -97 65 -110 b 64 -111 64 -111 64 -111 b 160 -112 64 -112 74 -112 l 257 -112 l 257 -43 b 259 27 257 24 257 25 b 307 82 259 28 281 53 b 373 156 332 110 362 144 b 409 188 402 189 401 188 b 425 179 416 188 422 185 b 426 32 426 176 426 171 l 426 -112 l 452 -112 b 481 -113 476 -112 477 -112 b 494 -134 489 -116 494 -125 b 488 -149 494 -139 492 -145 b 452 -156 482 -155 481 -156 l 426 -156 l 426 -162 b 427 -183 427 -165 427 -175 b 484 -269 428 -227 441 -248 b 497 -287 493 -274 497 -280 b 493 -298 497 -291 496 -295 b 397 -303 488 -303 499 -303 b 341 -303 382 -303 363 -303 b 285 -303 320 -303 301 -303 b 190 -298 184 -303 195 -303 b 185 -287 187 -295 185 -291 b 199 -269 185 -280 190 -274 b 256 -183 242 -248 255 -227 b 256 -162 256 -175 256 -165 l 257 -156 l 135 -156 b 90 -156 117 -156 102 -156 b 5 -151 2 -156 9 -155 b 0 -140 2 -148 0 -144 b 9 -122 0 -135 3 -129 b 174 272 110 -9 170 134 b 184 302 175 295 176 298 z m 249 -360 l 250 -360 l 247 -360 z m 249 340 l 250 340 l 247 340 z"
        },
        timeSig5: {
            x_min: 0,
            x_max: 302,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 51 302 b 57 303 53 302 55 303 b 71 300 61 303 65 302 b 224 275 117 283 170 275 b 391 300 279 275 336 283 b 406 303 398 302 402 303 b 417 298 411 303 414 301 b 421 288 420 295 421 292 b 411 260 421 282 418 274 b 278 157 378 194 340 165 b 226 154 262 155 244 154 b 78 175 177 154 124 161 b 66 179 72 177 66 179 b 56 64 66 178 56 68 b 56 64 56 64 56 64 b 56 64 56 64 56 64 b 63 67 57 64 60 65 b 159 96 89 81 124 92 b 201 98 168 97 185 98 b 227 97 212 98 222 98 b 434 -104 351 80 434 -1 l 434 -105 b 239 -312 434 -208 353 -294 b 212 -314 230 -313 221 -314 b 23 -229 148 -314 76 -282 b 0 -174 7 -213 0 -193 b 82 -89 0 -131 35 -89 b 97 -90 87 -89 92 -89 b 162 -168 140 -98 162 -133 b 108 -242 162 -199 145 -230 l 102 -244 l 109 -247 b 159 -259 127 -255 143 -259 b 215 -241 178 -259 197 -253 b 281 -99 258 -212 281 -161 b 277 -51 281 -84 280 -68 b 211 62 267 6 241 51 l 205 64 l 189 64 b 57 24 142 64 96 50 b 37 14 43 14 42 14 b 20 30 26 14 20 20 b 43 293 20 41 42 290 b 51 302 44 297 48 300 z m 222 -276 b 222 -276 222 -276 222 -276 b 218 -277 221 -276 221 -276 b 216 -279 217 -278 216 -279 b 216 -279 216 -279 216 -279 b 222 -276 217 -279 222 -276 z m 217 -360 l 219 -360 l 216 -360 z m 217 340 l 219 340 l 216 340 z"
        },
        timeSig6: {
            x_min: 0,
            x_max: 349,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 272 313 b 295 314 278 314 286 314 b 350 308 314 314 336 312 b 473 226 402 295 458 259 b 481 191 479 215 481 203 b 399 108 481 147 444 108 b 373 112 390 108 382 109 b 319 187 337 124 319 156 b 372 260 319 218 337 249 b 378 263 375 262 378 263 b 378 263 378 263 378 263 b 347 275 378 264 358 271 b 305 280 333 278 319 280 b 220 242 270 280 239 267 b 178 110 201 217 187 173 b 170 31 175 88 170 41 b 170 29 170 30 170 29 b 170 29 170 29 170 29 b 180 32 171 29 175 30 b 273 52 213 45 243 52 b 364 33 302 52 332 45 b 487 -64 422 11 466 -24 b 502 -128 497 -83 502 -105 b 479 -208 502 -156 494 -185 b 272 -314 439 -268 345 -314 b 239 -310 260 -314 249 -313 b 9 -77 129 -284 35 -188 b 0 6 3 -53 0 -23 b 5 65 0 26 2 47 b 272 313 27 193 137 296 z m 290 17 b 273 19 284 18 279 19 b 227 2 254 19 236 13 b 198 -122 209 -17 198 -69 b 201 -175 198 -140 199 -158 b 274 -280 214 -258 229 -280 l 274 -280 b 341 -193 315 -280 329 -262 b 349 -123 346 -166 349 -145 b 344 -66 349 -105 347 -87 b 290 17 334 -9 321 12 z m 251 -360 l 253 -360 l 250 -360 z m 251 340 l 253 340 l 250 340 z"
        },
        timeSig7: {
            x_min: 0,
            x_max: 326,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 162 314 b 179 315 168 315 174 315 b 333 260 232 315 290 294 b 361 249 343 252 350 249 b 370 250 364 249 367 249 b 435 291 395 253 417 267 b 453 303 442 299 447 303 b 460 302 455 303 457 303 b 469 288 466 299 469 296 b 456 233 469 279 465 263 b 369 16 433 146 396 56 b 290 -268 322 -53 293 -159 b 280 -302 289 -295 289 -298 b 192 -303 278 -303 235 -303 b 105 -302 150 -303 107 -303 b 96 -281 98 -298 96 -294 b 96 -280 96 -280 96 -280 b 178 -54 96 -212 128 -124 b 279 57 207 -12 235 18 b 399 198 335 107 368 146 b 404 207 402 204 404 206 b 403 207 404 207 404 207 b 400 205 403 207 402 206 b 258 155 357 172 306 155 b 132 201 212 155 167 171 b 90 222 117 215 103 222 b 58 201 78 222 67 215 b 33 141 49 187 41 168 b 16 128 30 133 23 128 b 1 138 10 128 4 131 b 0 216 0 140 0 178 b 1 293 0 253 0 291 b 15 303 4 300 9 303 b 30 298 20 303 25 301 b 52 289 37 292 43 289 b 96 300 62 289 75 293 b 162 314 124 309 140 312 z m 234 -360 l 236 -360 l 233 -360 z m 234 340 l 236 340 l 233 340 z"
        },
        timeSig8: {
            x_min: 0,
            x_max: 360,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 246 314 b 260 314 252 314 258 314 b 261 314 261 314 261 314 b 275 313 263 314 269 314 b 399 276 317 312 363 298 b 486 136 456 242 486 189 b 441 29 486 99 471 61 l 435 23 l 441 19 b 518 -119 492 -16 518 -67 b 483 -217 518 -153 507 -187 b 259 -314 435 -279 349 -314 b 138 -291 218 -314 176 -307 b 0 -118 48 -256 0 -187 b 76 18 0 -69 25 -20 l 83 23 l 77 30 b 32 137 48 61 32 99 b 42 189 32 155 36 172 b 246 314 70 260 152 310 z m 282 267 b 260 269 276 269 268 269 b 228 266 249 269 237 268 b 168 214 192 258 168 235 b 171 202 168 210 169 206 b 354 62 190 162 270 101 l 359 60 l 362 65 b 380 136 375 88 380 112 b 282 267 380 196 342 254 z m 148 -20 b 139 -16 144 -18 139 -16 b 139 -16 139 -16 139 -16 b 119 -36 137 -16 124 -29 b 91 -118 100 -62 91 -90 b 188 -255 91 -174 126 -229 b 257 -269 210 -265 234 -269 b 356 -229 298 -269 336 -255 b 368 -196 364 -218 368 -208 b 350 -151 368 -183 362 -168 b 166 -28 317 -101 256 -61 b 148 -20 161 -26 153 -23 z m 259 -360 l 261 -360 l 258 -360 z m 259 340 l 261 340 l 258 340 z"
        },
        timeSig9: {
            x_min: 0,
            x_max: 349,
            y_min: -250,
            y_max: 236,
            ha: 486,
            o: "m 208 313 b 227 314 214 314 220 314 b 332 284 259 314 295 304 b 497 61 420 236 480 155 b 503 -4 501 42 503 19 b 498 -65 503 -26 501 -47 b 279 -303 479 -176 393 -269 b 204 -314 253 -310 228 -314 b 98 -287 166 -314 130 -305 b 25 -216 58 -265 33 -241 b 22 -191 23 -208 22 -199 b 104 -108 22 -146 59 -108 b 130 -112 112 -108 121 -109 b 184 -187 166 -124 184 -156 b 131 -260 184 -218 166 -249 b 125 -263 128 -262 125 -263 b 125 -263 125 -263 125 -263 b 156 -275 125 -264 144 -271 b 197 -280 170 -278 184 -280 b 279 -247 231 -280 260 -269 b 324 -117 300 -223 313 -182 b 333 -31 328 -93 333 -42 b 332 -29 333 -30 333 -29 b 332 -29 332 -29 332 -29 b 323 -32 332 -29 328 -30 b 230 -52 289 -45 260 -52 b 173 -44 211 -52 192 -49 b 23 50 108 -27 51 9 b 0 128 8 74 0 101 b 34 222 0 161 11 194 b 208 313 70 266 142 304 z m 248 278 b 231 281 243 280 237 281 b 195 272 217 281 203 277 b 156 156 176 259 163 221 b 154 124 154 146 154 135 b 183 -2 154 72 166 16 b 230 -19 194 -13 212 -19 b 276 -2 248 -19 266 -13 b 305 122 294 17 305 69 b 301 175 305 140 304 158 b 248 278 290 246 278 270 z m 251 -360 l 253 -360 l 250 -360 z m 251 340 l 253 340 l 250 340 z"
        },
        timeSigCommon: {
            x_min: 0,
            x_max: 409,
            y_min: -233,
            y_max: 233,
            ha: 466,
            o: "m 315 334 b 343 336 324 335 334 336 b 558 227 431 336 512 296 b 575 174 570 210 575 192 b 475 74 575 122 533 74 b 472 74 474 74 473 74 b 380 167 417 76 380 120 b 402 225 380 187 387 207 b 469 256 418 244 444 256 b 484 254 474 256 479 255 b 487 254 485 254 487 254 b 488 254 488 254 488 254 b 479 260 488 254 485 256 b 346 302 439 289 398 302 l 345 302 b 154 -3 205 302 154 220 b 154 -3 154 -3 154 -3 b 316 -302 154 -225 195 -300 b 321 -302 318 -302 320 -302 b 556 -108 438 -302 536 -221 b 573 -87 558 -92 562 -87 b 589 -105 584 -87 589 -93 b 582 -144 589 -114 587 -127 b 393 -327 556 -233 484 -302 b 321 -336 371 -333 346 -336 b 248 -327 296 -336 271 -333 b 7 -69 125 -296 32 -196 b 0 -1 2 -46 0 -24 b 315 334 0 170 131 317 z"
        },
        timeSigCutCommon: {
            x_min: 0,
            x_max: 409,
            y_min: -394,
            y_max: 394,
            ha: 788,
            o: "m 308 566 b 316 568 311 567 314 568 b 337 554 325 568 334 562 b 338 446 338 550 338 549 l 338 341 l 355 341 b 558 232 437 339 514 298 b 575 179 570 216 575 197 b 475 79 575 128 533 79 b 472 79 474 79 473 79 b 380 172 417 81 380 126 b 402 231 380 192 387 213 b 469 261 418 250 444 261 b 484 260 474 261 479 261 b 487 259 485 259 487 259 b 488 259 488 259 488 259 b 479 266 488 260 485 262 b 354 307 442 292 400 306 l 338 308 l 338 6 l 338 -297 l 340 -296 b 347 -296 341 -296 344 -296 b 555 -103 449 -288 538 -205 b 573 -82 558 -87 562 -82 b 589 -100 584 -82 589 -87 b 582 -138 589 -109 587 -121 b 374 -326 554 -234 473 -307 b 342 -330 366 -327 356 -328 l 338 -330 l 338 -440 b 339 -489 338 -460 339 -476 b 332 -561 339 -563 338 -555 b 317 -568 328 -566 322 -568 b 296 -554 308 -568 299 -563 b 295 -440 295 -550 295 -549 l 295 -330 l 293 -329 b 282 -328 291 -329 287 -328 b 7 -63 146 -310 35 -203 b 0 4 2 -41 0 -18 b 259 331 0 156 103 291 b 294 338 269 333 292 338 b 295 444 295 338 295 385 b 296 554 295 549 295 550 b 308 566 298 559 303 564 z m 295 4 b 294 303 295 288 295 303 b 284 301 293 303 288 302 b 154 3 190 276 154 192 l 154 2 b 291 -295 154 -204 190 -283 l 295 -295 z"
        },
        timeSigPlus: {
            x_min: 0,
            x_max: 235,
            y_min: -118,
            y_max: 118,
            ha: 235,
            o: "m 159 168 b 169 169 162 169 166 169 b 198 153 180 169 192 163 b 202 97 202 146 202 147 l 202 87 l 202 33 l 257 33 l 267 33 b 322 29 317 33 315 33 b 339 0 333 22 339 11 b 323 -28 339 -11 333 -22 b 266 -33 315 -33 317 -33 l 257 -33 l 202 -33 l 202 -87 l 202 -97 b 198 -153 202 -148 202 -146 b 169 -169 191 -164 180 -169 b 141 -153 158 -169 147 -164 b 137 -97 137 -146 137 -147 l 137 -87 l 137 -33 l 82 -33 l 72 -33 b 16 -28 22 -33 23 -33 b 0 0 5 -22 0 -11 b 16 28 0 11 5 22 b 72 33 23 33 22 33 l 82 33 l 137 33 l 137 87 l 137 97 b 141 153 137 148 137 146 b 159 168 145 160 151 165 z"
        },
        timeSigPlusSmall: {
            x_min: 0,
            x_max: 235,
            y_min: -118,
            y_max: 118,
            ha: 235,
            o: "m 159 168 b 169 169 162 169 166 169 b 198 153 180 169 192 163 b 202 97 202 146 202 147 l 202 87 l 202 33 l 257 33 l 267 33 b 322 29 317 33 315 33 b 339 0 333 22 339 11 b 323 -28 339 -11 333 -22 b 266 -33 315 -33 317 -33 l 257 -33 l 202 -33 l 202 -87 l 202 -97 b 198 -153 202 -148 202 -146 b 169 -169 191 -164 180 -169 b 141 -153 158 -169 147 -164 b 137 -97 137 -146 137 -147 l 137 -87 l 137 -33 l 82 -33 l 72 -33 b 16 -28 22 -33 23 -33 b 0 0 5 -22 0 -11 b 16 28 0 11 5 22 b 72 33 23 33 22 33 l 82 33 l 137 33 l 137 87 l 137 97 b 141 153 137 148 137 146 b 159 168 145 160 151 165 z"
        },
        timeSigMinus: {
            x_min: 0,
            x_max: 235,
            y_min: -23,
            y_max: 23,
            ha: 46,
            o: "m 23 32 b 177 33 26 32 103 33 b 315 32 246 33 312 32 b 338 0 331 27 338 14 b 315 -32 338 -14 331 -27 b 169 -33 312 -33 241 -33 b 23 -32 98 -33 26 -33 b 0 0 8 -27 0 -14 b 23 32 0 13 8 26 z"
        },
        timeSigParensRight: {
            x_min: 19,
            x_max: 122,
            y_min: -267,
            y_max: 267,
            ha: 535,
            o: "m 36 384 b 44 385 38 385 41 385 b 65 367 52 385 55 383 b 176 0 139 251 176 126 b 65 -367 176 -125 139 -250 b 44 -385 56 -380 51 -385 b 36 -383 42 -385 39 -384 b 27 -370 30 -380 27 -377 b 33 -349 27 -365 29 -359 b 99 0 77 -242 99 -121 b 33 350 99 122 77 243 b 27 371 29 359 27 366 b 36 384 27 377 30 381 z"
        },
        timeSigParensRightSmall: {
            x_min: 19,
            x_max: 122,
            y_min: -267,
            y_max: 267,
            ha: 535,
            o: "m 36 384 b 44 385 38 385 41 385 b 65 367 52 385 55 383 b 176 0 139 251 176 126 b 65 -367 176 -125 139 -250 b 44 -385 56 -380 51 -385 b 36 -383 42 -385 39 -384 b 27 -370 30 -380 27 -377 b 33 -349 27 -365 29 -359 b 99 0 77 -242 99 -121 b 33 350 99 122 77 243 b 27 371 29 359 27 366 b 36 384 27 377 30 381 z"
        },
        timeSigParensLeft: {
            x_min: -122,
            x_max: -19,
            y_min: -267,
            y_max: 267,
            ha: 534,
            o: "m -51 383 b -44 385 -49 384 -46 385 b -29 375 -38 385 -31 381 b -27 369 -28 373 -27 372 b -33 349 -27 365 -29 360 b -98 54 -71 259 -91 167 b -99 0 -98 44 -99 22 b -98 -54 -99 -22 -98 -45 b -33 -349 -91 -167 -71 -259 b -27 -368 -28 -363 -27 -365 b -44 -385 -27 -378 -34 -385 b -65 -367 -52 -385 -55 -383 b -176 0 -139 -251 -176 -125 b -65 367 -176 125 -139 251 b -51 383 -57 379 -55 381 z"
        },
        timeSigParensLeftSmall: {
            x_min: -122,
            x_max: -19,
            y_min: -267,
            y_max: 267,
            ha: 534,
            o: "m -51 383 b -44 385 -49 384 -46 385 b -29 375 -38 385 -31 381 b -27 369 -28 373 -27 372 b -33 349 -27 365 -29 360 b -98 54 -71 259 -91 167 b -99 0 -98 44 -99 22 b -98 -54 -99 -22 -98 -45 b -33 -349 -91 -167 -71 -259 b -27 -368 -28 -363 -27 -365 b -44 -385 -27 -378 -34 -385 b -65 -367 -52 -385 -55 -383 b -176 0 -139 -251 -176 -125 b -65 367 -176 125 -139 251 b -51 383 -57 379 -55 381 z"
        },
        noteheadDoubleWhole: {
            x_min: 0,
            x_max: 663,
            y_min: -174,
            y_max: 174,
            ha: 349,
            o: "m 19 250 b 27 251 21 251 24 251 b 36 250 31 251 34 251 b 50 239 41 248 47 244 b 55 93 54 233 55 247 b 55 0 55 67 55 37 b 55 -93 55 -37 55 -67 b 50 -239 55 -247 54 -233 b 28 -251 45 -247 36 -251 b 1 -232 16 -251 5 -244 b 0 4 0 -230 0 -112 b 1 232 0 117 0 230 b 19 250 4 240 11 247 z m 117 250 b 126 251 119 251 122 251 b 134 250 129 251 132 251 b 152 232 142 247 149 240 b 153 128 153 229 153 214 b 154 31 153 48 153 31 b 154 31 154 31 154 31 b 417 191 176 112 281 176 b 478 194 437 193 458 194 b 801 31 636 194 776 127 b 801 31 801 31 801 31 b 802 128 802 31 802 48 b 805 237 802 235 802 232 b 830 251 811 246 821 251 b 852 239 839 251 847 247 b 857 93 857 233 857 247 b 857 0 857 67 857 37 b 857 -93 857 -37 857 -67 b 852 -239 857 -247 857 -233 b 830 -251 847 -247 838 -251 b 807 -239 821 -251 812 -247 b 802 -128 802 -232 802 -239 b 801 -31 802 -48 802 -31 b 801 -31 801 -31 801 -31 b 539 -191 779 -112 675 -176 b 477 -194 518 -193 498 -194 b 154 -31 319 -194 180 -127 b 154 -31 154 -31 154 -31 b 153 -128 153 -31 153 -48 b 148 -239 153 -239 153 -232 b 126 -251 143 -247 134 -251 b 99 -232 114 -251 103 -244 b 98 4 99 -230 98 -112 b 99 232 98 117 99 230 b 117 250 102 240 109 247 z m 458 168 b 439 169 452 169 445 169 b 332 44 375 169 332 116 b 344 -25 332 22 336 -1 b 517 -169 377 -116 452 -169 b 613 -101 558 -169 595 -148 b 623 -44 620 -83 623 -64 b 458 168 623 50 549 154 z m 919 250 b 928 251 921 251 924 251 b 936 250 931 251 934 251 b 951 239 942 248 947 244 b 955 93 955 233 955 247 b 955 0 955 67 955 36 b 955 -93 955 -37 955 -67 b 951 -239 955 -247 955 -233 b 928 -251 945 -247 937 -251 b 902 -232 917 -251 905 -244 b 900 4 901 -230 900 -112 b 901 232 900 117 901 230 b 919 250 904 240 911 247 z"
        },
        noteheadWhole: {
            x_min: 0,
            x_max: 455,
            y_min: -135,
            y_max: 135,
            ha: 269,
            o: "m 291 193 b 326 194 303 194 315 194 b 649 38 482 194 619 129 b 655 0 653 25 655 12 b 327 -194 655 -106 513 -194 b 0 0 144 -194 0 -109 b 291 193 0 100 124 182 z m 308 168 b 289 169 301 169 295 169 b 181 44 224 169 181 116 b 194 -26 181 22 185 -1 b 366 -169 226 -116 302 -169 b 463 -101 408 -169 445 -148 b 473 -45 470 -83 473 -64 b 308 168 473 50 398 154 z"
        },
        noteheadHalf: {
            x_min: 0,
            x_max: 316,
            y_min: -135,
            y_max: 135,
            ha: 269,
            o: "m 270 193 b 281 194 272 194 276 194 b 322 192 294 194 315 193 b 455 53 411 178 455 120 b 307 -156 455 -20 405 -104 b 166 -194 260 -182 211 -194 b 3 -81 84 -194 17 -153 b 0 -52 1 -72 0 -62 b 270 193 0 62 123 178 z m 388 139 b 372 141 383 140 378 141 b 99 -26 307 141 174 61 b 50 -116 68 -62 50 -96 b 60 -136 50 -125 53 -132 b 83 -141 66 -139 74 -141 b 367 40 152 -141 296 -52 b 405 115 392 72 405 98 b 388 139 405 127 399 135 z"
        },
        noteheadBlack: {
            x_min: 0,
            x_max: 316,
            y_min: -135,
            y_max: 135,
            ha: 269,
            o: "m 270 193 b 281 194 272 194 276 194 b 322 192 294 194 315 193 b 455 53 411 178 455 120 b 307 -156 455 -20 405 -104 b 166 -194 260 -182 211 -194 b 3 -81 84 -194 17 -153 b 0 -52 1 -72 0 -62 b 270 193 0 62 123 178 z"
        },
        noteheadXWhole: {
            x_min: 0,
            x_max: 440,
            y_min: -133,
            y_max: 133,
            ha: 265,
            o: "m 67 190 b 82 191 71 191 76 191 b 97 190 88 191 94 191 b 216 138 108 188 116 184 l 317 91 l 417 138 b 548 191 529 190 532 191 b 551 191 549 191 550 191 b 634 109 601 191 634 151 b 611 52 634 89 627 69 b 549 17 601 41 597 39 b 513 0 529 8 513 0 b 549 -17 513 0 529 -8 b 611 -52 597 -39 601 -41 b 634 -109 627 -69 634 -89 b 551 -191 634 -151 601 -191 b 548 -191 550 -191 549 -191 b 417 -138 532 -191 529 -190 l 317 -91 l 216 -138 b 86 -191 105 -190 102 -191 b 83 -191 85 -191 84 -191 b 0 -109 33 -191 0 -151 b 23 -52 0 -89 7 -69 b 85 -17 33 -41 37 -39 b 121 0 105 -8 121 0 b 85 17 121 0 105 8 b 23 52 37 39 33 41 b 0 109 7 69 0 89 b 67 190 0 146 26 182 z m 91 141 b 82 142 88 142 85 142 b 49 109 63 142 49 126 b 59 86 49 101 52 92 b 159 37 64 81 55 85 b 238 0 202 17 238 0 b 159 -37 238 0 202 -17 b 59 -86 55 -85 64 -81 b 49 -109 52 -92 49 -101 b 82 -142 49 -126 62 -142 l 82 -142 b 206 -88 91 -142 91 -141 b 317 -37 267 -60 317 -37 b 428 -88 317 -37 367 -60 b 551 -142 542 -141 543 -142 l 552 -142 b 584 -109 572 -142 584 -126 b 574 -86 584 -101 581 -92 b 475 -37 569 -81 578 -85 b 396 0 431 -17 396 0 b 475 37 396 0 431 17 b 574 86 578 85 569 81 b 584 109 581 92 584 101 b 552 142 584 126 572 142 l 551 142 b 428 88 543 142 542 141 b 317 37 367 60 317 37 b 206 88 317 37 267 60 b 91 141 145 117 93 140 z"
        },
        noteheadXHalf: {
            x_min: 0,
            x_max: 300,
            y_min: -133,
            y_max: 133,
            ha: 265,
            o: "m 60 189 b 76 191 65 190 71 191 b 118 179 91 191 106 187 b 169 138 121 177 144 159 l 216 100 l 262 138 b 325 185 312 179 314 181 b 355 191 335 189 345 191 b 431 115 397 191 431 156 b 426 86 431 105 430 96 b 372 29 419 69 415 64 b 337 0 353 14 337 0 b 372 -29 337 0 353 -14 b 426 -86 415 -64 419 -69 b 431 -115 430 -96 431 -105 b 355 -191 431 -156 397 -191 b 325 -185 345 -191 335 -189 b 262 -138 314 -181 312 -179 l 216 -100 l 169 -138 b 106 -185 120 -179 117 -181 b 76 -191 96 -189 86 -191 b 0 -115 35 -191 0 -156 b 6 -86 0 -105 2 -96 b 59 -29 12 -69 17 -64 b 94 0 78 -14 94 0 b 59 29 94 0 78 14 b 20 63 40 45 22 61 b 0 114 6 78 0 97 b 60 189 0 148 23 181 z m 88 140 b 77 142 85 141 81 142 b 56 133 69 142 61 139 b 49 115 51 128 49 121 b 55 98 49 109 51 103 b 114 48 56 96 82 74 b 171 0 146 22 171 0 b 114 -48 171 0 146 -22 b 55 -98 82 -74 56 -96 b 49 -114 51 -103 49 -109 b 65 -140 49 -125 55 -135 b 77 -142 68 -141 72 -142 b 88 -140 81 -142 85 -141 b 154 -87 91 -138 114 -120 b 216 -36 188 -59 216 -36 b 278 -87 216 -36 244 -59 b 343 -140 318 -120 341 -138 b 355 -142 346 -141 350 -142 b 367 -140 359 -142 364 -141 b 382 -114 377 -135 382 -125 b 377 -98 382 -109 381 -103 b 317 -48 376 -96 349 -74 b 260 0 286 -22 260 0 b 317 48 260 0 286 22 b 377 98 349 74 376 96 b 382 114 381 103 382 109 b 367 140 382 125 377 135 b 355 142 364 141 359 142 b 343 140 350 142 346 141 b 278 87 341 138 318 120 b 216 36 244 59 216 36 b 154 87 216 36 188 59 b 88 140 112 121 91 138 z"
        },
        noteheadXBlack: {
            x_min: 0,
            x_max: 300,
            y_min: -133,
            y_max: 133,
            ha: 265,
            o: "m 24 190 b 32 191 26 191 29 191 b 46 189 37 191 43 190 b 135 114 52 186 50 187 b 216 44 179 76 216 44 b 296 114 216 44 252 76 b 396 191 392 197 384 190 b 398 191 397 191 398 191 b 432 158 418 191 432 175 b 422 135 432 150 429 142 b 343 66 420 133 384 102 b 267 0 301 30 267 0 b 343 -66 267 0 301 -30 b 422 -135 384 -102 420 -133 b 432 -158 429 -142 432 -150 b 398 -191 432 -175 418 -191 b 396 -191 398 -191 397 -191 b 296 -114 384 -190 392 -197 b 216 -44 252 -76 216 -44 b 135 -114 216 -44 179 -76 b 35 -191 40 -197 48 -190 b 33 -191 35 -191 34 -191 b 0 -158 13 -191 0 -175 b 10 -135 0 -150 3 -142 b 89 -66 12 -133 48 -102 b 164 0 131 -30 164 0 b 89 66 164 0 131 30 b 10 135 48 102 12 133 b 0 158 3 142 0 150 b 24 190 0 172 9 186 z"
        },
        noteheadCircleX: {
            x_min: 0,
            x_max: 357,
            y_min: -178,
            y_max: 178,
            ha: 357,
            o: "m 242 256 b 256 257 249 257 253 257 b 270 256 260 257 263 257 b 514 0 412 248 514 131 b 496 -95 514 -31 508 -63 b 255 -257 454 -200 355 -257 b 61 -166 184 -257 112 -228 b 0 -2 19 -117 0 -58 b 242 256 0 126 96 248 z m 267 190 b 257 191 262 190 259 191 b 245 190 254 191 251 190 b 153 159 212 188 179 177 l 147 156 l 202 101 l 257 46 l 311 101 l 366 156 l 361 159 b 267 190 334 177 302 188 z m 155 -55 l 210 0 l 155 54 l 101 109 l 97 104 b 66 0 77 74 66 37 b 71 -44 66 -15 68 -30 b 97 -105 77 -66 86 -87 l 101 -110 z m 416 104 b 413 109 414 107 413 109 b 358 54 413 109 388 84 l 304 0 l 358 -55 l 413 -110 l 416 -105 b 447 0 437 -74 447 -37 b 416 104 447 36 437 73 z m 312 -102 b 257 -47 282 -72 257 -47 b 202 -102 257 -47 232 -72 l 147 -156 l 153 -160 b 257 -191 183 -180 220 -191 b 361 -160 294 -191 330 -180 l 366 -156 z"
        },
        noteheadTriangleUpWhole: {
            x_min: 0,
            x_max: 462,
            y_min: -149,
            y_max: 149,
            ha: 297,
            o: "m 326 213 b 333 214 327 214 330 214 b 355 194 342 214 344 212 b 647 -174 447 44 562 -101 b 659 -184 652 -178 657 -182 b 666 -198 664 -188 666 -193 b 650 -214 666 -207 660 -214 b 598 -200 645 -214 641 -213 b 333 -161 514 -174 423 -161 b 68 -200 242 -161 152 -174 b 16 -214 25 -213 20 -214 b 0 -198 7 -214 0 -208 b 12 -179 0 -190 1 -189 b 311 194 100 -106 216 40 b 326 213 320 208 322 211 z m 338 141 b 333 153 336 147 333 153 b 327 141 333 153 330 147 b 190 -130 285 41 232 -63 b 185 -138 187 -134 185 -138 b 185 -138 185 -138 185 -138 b 185 -138 185 -138 185 -138 b 195 -137 187 -138 190 -138 b 224 -134 201 -136 214 -135 b 333 -128 260 -130 296 -128 b 410 -131 359 -128 384 -129 b 470 -137 425 -132 454 -135 b 480 -138 475 -138 479 -138 b 481 -138 481 -138 481 -138 b 481 -138 481 -138 481 -138 b 478 -133 481 -138 479 -135 b 338 141 436 -67 381 40 z"
        },
        noteheadTriangleUpHalf: {
            x_min: 0,
            x_max: 323,
            y_min: -149,
            y_max: 149,
            ha: 298,
            o: "m 225 213 b 232 214 227 214 230 214 b 253 191 242 214 245 212 b 447 -169 316 42 385 -85 b 465 -198 461 -187 465 -193 b 463 -204 465 -200 464 -202 b 450 -214 461 -211 457 -214 b 431 -208 446 -214 439 -212 b 233 -162 368 -178 300 -162 b 33 -208 165 -162 97 -178 b 15 -214 25 -212 19 -214 b 5 -209 11 -214 8 -213 b 0 -199 2 -206 0 -203 b 9 -181 0 -194 3 -188 b 213 194 67 -109 149 42 b 225 213 218 208 220 211 z m 280 51 b 264 85 274 62 267 78 l 258 98 l 248 83 b 93 -135 201 9 143 -73 b 87 -143 90 -139 87 -143 b 87 -144 87 -144 87 -144 b 87 -144 87 -144 87 -144 b 94 -141 87 -144 90 -142 b 297 -98 162 -113 233 -98 b 354 -102 317 -98 336 -99 b 363 -104 359 -103 363 -104 b 363 -104 363 -104 363 -104 b 360 -97 363 -103 361 -101 b 280 51 337 -60 304 2 z"
        },
        noteheadTriangleUpBlack: {
            x_min: 0,
            x_max: 322,
            y_min: -149,
            y_max: 149,
            ha: 297,
            o: "m 224 213 b 232 214 226 213 229 214 b 250 197 241 214 244 211 b 277 135 269 152 270 149 b 288 111 280 127 285 117 b 336 12 296 92 330 23 b 344 -3 336 12 340 5 b 376 -60 360 -32 363 -38 b 452 -177 406 -112 430 -148 b 463 -198 463 -191 463 -191 b 447 -214 463 -208 458 -214 l 447 -214 l 441 -214 l 430 -208 b 232 -163 368 -178 300 -163 b 33 -208 163 -163 95 -178 l 22 -214 l 16 -214 l 16 -214 b 0 -198 6 -214 0 -208 b 11 -177 0 -191 0 -191 b 75 -81 29 -154 52 -120 b 119 -3 93 -52 102 -36 b 127 12 123 5 127 12 b 176 111 133 23 167 92 b 186 135 178 117 183 127 b 213 197 193 149 194 152 b 224 213 218 207 220 210 z"
        },
        noteheadDiamondWhole: {
            x_min: 0,
            x_max: 462,
            y_min: -138,
            y_max: 138,
            ha: 277,
            o: "m 326 198 b 333 199 328 199 330 199 b 350 189 340 199 342 198 b 638 20 417 112 517 53 b 654 16 645 19 652 17 b 666 0 662 14 666 7 b 654 -16 666 -7 662 -14 b 638 -20 652 -17 645 -19 b 352 -186 518 -53 419 -110 b 333 -199 342 -198 340 -199 b 316 -189 326 -199 324 -198 b 28 -20 249 -112 149 -53 b 12 -16 21 -19 14 -17 b 0 0 4 -14 0 -7 b 12 16 0 7 4 14 b 28 20 14 17 21 19 b 316 189 149 53 249 112 b 326 198 321 194 324 197 z m 338 143 b 333 149 335 146 333 149 b 328 143 333 149 331 146 b 172 4 290 85 233 35 b 165 0 168 2 165 0 b 172 -4 165 0 168 -2 b 328 -143 233 -35 290 -85 b 333 -149 331 -147 332 -149 b 335 -146 334 -149 334 -148 b 494 -4 370 -91 432 -35 b 501 0 498 -2 501 0 b 494 4 501 0 498 2 b 338 143 433 35 376 85 z"
        },
        noteheadDiamondHalf: {
            x_min: 0,
            x_max: 322,
            y_min: -138,
            y_max: 138,
            ha: 277,
            o: "m 225 198 b 232 199 227 199 229 199 b 251 183 240 199 243 197 b 445 19 295 109 362 52 b 464 0 461 13 464 10 b 447 -18 464 -9 460 -13 b 251 -183 365 -49 294 -109 b 232 -199 243 -197 240 -199 b 213 -183 224 -199 221 -197 b 19 -19 169 -109 102 -52 b 0 0 3 -13 0 -10 b 17 18 0 9 3 13 b 213 183 99 50 169 109 b 225 198 218 193 221 196 z m 255 119 b 251 122 253 121 252 122 b 244 114 250 122 249 120 b 98 -17 208 61 151 10 l 95 -19 l 98 -21 b 211 -120 138 -44 176 -78 b 213 -123 212 -122 212 -123 b 213 -122 213 -123 213 -122 b 366 17 244 -72 311 -11 l 369 19 l 366 21 b 255 119 327 44 283 82 z"
        },
        noteheadDiamondBlack: {
            x_min: 0,
            x_max: 322,
            y_min: -138,
            y_max: 138,
            ha: 277,
            o: "m 225 198 b 232 199 227 199 229 199 b 253 180 241 199 243 197 b 444 19 297 107 363 52 b 464 0 461 13 464 10 b 444 -19 464 -10 461 -13 b 253 -180 363 -52 297 -107 b 232 -199 243 -197 241 -199 b 211 -180 223 -199 221 -197 b 19 -19 167 -107 101 -52 b 0 0 3 -13 0 -10 b 19 19 0 10 3 13 b 211 180 101 52 167 107 b 225 198 219 194 221 196 z"
        },
        augmentationDot: {
            x_min: -63,
            x_max: 63,
            y_min: -63,
            y_max: 63,
            ha: 126,
            o: "m -18 89 b 0 90 -12 90 -6 90 b 90 0 49 90 90 49 b 89 -18 90 -6 90 -12 b -1 -90 79 -64 39 -90 b -70 -57 -26 -90 -52 -80 b -90 -1 -84 -40 -90 -20 b -18 89 -90 40 -63 79 z"
        },
        tremolo1: {
            x_min: -252,
            x_max: 216,
            y_min: -185,
            y_max: 148,
            ha: 333,
            o: "m 265 211 b 275 213 269 212 272 213 b 311 175 295 213 311 194 b 301 151 311 166 308 158 b 243 110 297 147 295 145 b 175 64 224 97 194 77 b 107 18 156 52 126 31 b 40 -27 89 6 58 -15 b -28 -73 21 -40 -9 -60 b -95 -119 -46 -86 -77 -106 b -162 -164 -113 -131 -144 -152 b -230 -210 -181 -177 -211 -197 b -285 -247 -249 -223 -274 -240 b -310 -263 -297 -255 -308 -263 b -326 -267 -315 -266 -321 -267 b -363 -230 -346 -267 -363 -250 b -357 -212 -363 -224 -361 -218 b -309 -174 -353 -205 -350 -202 b -203 -103 -287 -160 -240 -128 b -68 -11 -167 -78 -106 -37 b 67 80 -30 14 31 55 b 194 166 104 105 161 143 b 265 211 255 207 259 210 z"
        },
        flag8thUp: {
            x_min: -17,
            x_max: 234,
            y_min: -745,
            y_max: -4,
            ha: 741,
            o: "m -25 -167 l -25 -5 l -21 -5 b 1 -29 -9 -5 -3 -12 b 183 -326 32 -144 91 -241 b 336 -686 285 -421 336 -551 b 219 -1028 336 -802 298 -923 b 172 -1072 191 -1065 183 -1072 b 150 -1052 158 -1072 150 -1063 b 158 -1032 150 -1046 153 -1039 b 284 -707 241 -935 284 -818 b 185 -446 284 -610 251 -517 b -24 -328 144 -402 72 -361 b -25 -167 -24 -328 -25 -295 z"
        },
        flag8thDown: {
            x_min: -15,
            x_max: 271,
            y_min: 4,
            y_max: 745,
            ha: 741,
            o: "m 242 1071 b 252 1073 246 1072 249 1073 b 277 1051 260 1073 267 1066 b 390 687 352 938 390 810 b 343 464 390 609 374 533 b 248 331 319 413 285 365 b 60 125 166 256 110 194 b 0 21 35 90 10 47 b -19 5 -4 11 -12 5 l -22 5 l -22 167 l -22 328 l -17 328 b 105 350 13 328 69 338 b 334 722 241 396 334 547 b 240 1027 334 826 301 934 b 229 1050 230 1041 229 1044 b 242 1071 229 1060 234 1068 z"
        },
        flag16thUp: {
            x_min: -17,
            x_max: 234,
            y_min: -847,
            y_max: -4,
            ha: 843,
            o: "m -25 -151 l -25 -5 l -21 -5 b 0 -23 -11 -5 -5 -11 b 208 -289 31 -96 103 -189 b 336 -592 292 -369 336 -477 b 311 -740 336 -641 328 -691 l 308 -751 l 312 -762 b 336 -906 328 -808 336 -857 b 241 -1185 336 -1004 304 -1103 b 202 -1220 218 -1215 213 -1220 b 180 -1198 188 -1220 180 -1210 b 187 -1181 180 -1193 182 -1187 b 286 -923 252 -1106 286 -1015 b 283 -873 286 -906 285 -890 b 278 -844 281 -861 279 -849 b 274 -830 277 -842 276 -836 b 152 -651 255 -758 210 -692 b -10 -612 119 -628 51 -612 b -22 -611 -16 -612 -21 -612 l -25 -611 l -25 -465 l -25 -319 l -21 -319 b 0 -336 -11 -319 -5 -325 b 207 -602 31 -410 105 -504 b 275 -685 235 -628 260 -658 b 277 -688 276 -687 277 -688 b 280 -680 278 -688 279 -685 b 286 -609 284 -657 286 -633 b 280 -541 286 -586 284 -563 b 278 -530 280 -537 279 -532 b 274 -516 277 -528 276 -522 b 152 -337 255 -444 210 -378 b -10 -298 119 -315 51 -298 b -22 -298 -16 -298 -21 -298 l -25 -297 z"
        },
        flag16thDown: {
            x_min: -15,
            x_max: 267,
            y_min: 4,
            y_max: 745,
            ha: 741,
            o: "m 319 1071 b 328 1073 322 1072 325 1073 b 350 1054 337 1073 344 1067 b 384 901 373 1008 384 955 b 360 766 384 856 376 810 l 356 756 l 360 745 b 384 615 376 703 384 659 b 273 336 384 516 346 416 b 217 282 258 319 241 302 b -1 19 125 204 42 104 b -19 5 -5 11 -13 5 l -22 5 l -22 146 l -22 287 l -12 288 b 212 369 90 304 162 330 b 339 620 294 433 339 524 b 330 691 339 644 336 668 l 329 699 l 323 690 b 217 569 296 645 265 610 b -1 305 125 491 42 390 b -19 292 -5 297 -13 292 l -22 292 l -22 433 l -22 573 l -12 575 b 194 643 78 589 147 611 b 339 908 286 704 339 806 b 313 1030 339 950 330 991 b 306 1050 306 1045 306 1045 b 319 1071 306 1060 311 1068 z"
        },
        flag32ndUp: {
            x_min: -17,
            x_max: 233,
            y_min: -1005,
            y_max: 96,
            ha: 1101,
            o: "m -25 -6 l -25 139 l -21 139 b 1 121 -11 139 -6 134 b 172 -93 31 61 97 -21 b 201 -121 182 -103 195 -115 b 328 -375 266 -184 311 -274 b 335 -464 333 -404 335 -434 b 317 -612 335 -513 329 -564 l 313 -626 l 315 -632 b 328 -689 320 -647 325 -670 b 335 -778 333 -717 335 -747 b 317 -926 335 -827 329 -878 l 313 -940 l 315 -946 b 328 -1002 320 -961 325 -984 b 335 -1092 333 -1032 335 -1062 b 280 -1346 335 -1177 316 -1264 b 228 -1441 265 -1380 236 -1432 b 213 -1447 224 -1445 218 -1447 b 191 -1425 202 -1447 191 -1438 b 198 -1406 191 -1419 192 -1416 b 284 -1118 254 -1317 284 -1215 b 281 -1072 284 -1103 283 -1087 b 118 -798 269 -948 207 -844 b 6 -778 93 -785 60 -779 l -25 -778 l -25 -634 l -25 -489 l -21 -489 b 1 -507 -11 -489 -6 -494 b 172 -720 31 -567 97 -649 b 275 -848 229 -774 249 -800 l 281 -858 l 282 -849 b 284 -806 283 -834 284 -820 b 118 -484 284 -663 220 -537 b 6 -465 93 -471 60 -465 l -25 -464 l -25 -320 l -25 -175 l -21 -175 b 1 -193 -11 -175 -6 -180 b 172 -406 31 -253 97 -335 b 275 -534 229 -460 249 -486 l 281 -544 l 282 -535 b 284 -492 283 -521 284 -506 b 118 -170 284 -349 220 -223 b 6 -151 93 -157 60 -151 l -25 -151 z"
        },
        flag32ndDown: {
            x_min: -15,
            x_max: 270,
            y_min: -96,
            y_max: 895,
            ha: 991,
            o: "m 292 1287 b 300 1288 294 1288 297 1288 b 309 1287 303 1288 306 1288 b 374 1151 324 1281 359 1209 b 388 1039 383 1115 388 1077 b 368 904 388 993 381 947 l 365 896 l 368 886 b 374 864 370 881 372 871 b 388 752 383 828 388 790 b 368 618 388 706 381 660 l 365 609 l 368 599 b 374 578 370 594 372 584 b 388 467 384 541 388 504 b 236 128 388 339 334 215 b 201 99 226 119 226 119 b 0 -122 110 27 36 -55 b -19 -139 -5 -133 -12 -139 l -22 -139 l -22 0 l -22 138 l -16 138 b 200 215 66 150 144 178 b 340 485 287 273 340 376 b 336 531 340 501 339 516 l 335 540 l 333 537 b 236 415 306 488 275 449 b 201 385 226 406 226 405 b 0 164 110 313 36 231 b -19 148 -5 153 -12 148 l -22 148 l -22 286 l -22 424 l -16 425 b 200 501 66 437 144 464 b 340 772 287 559 340 663 b 336 818 340 787 339 803 l 335 827 l 333 823 b 236 701 306 774 275 735 b 201 672 226 692 226 692 b 0 451 110 600 36 518 b -19 434 -5 440 -12 434 l -22 434 l -22 572 l -22 711 l -16 711 b 219 802 77 725 165 759 b 339 1058 298 865 339 959 b 286 1246 339 1122 322 1187 b 278 1267 279 1258 278 1260 b 292 1287 278 1276 284 1284 z"
        },
        flag64thUp: {
            x_min: -17,
            x_max: 233,
            y_min: -933,
            y_max: 296,
            ha: 1230,
            o: "m -25 282 l -25 427 l -21 427 b 2 404 -9 427 -4 421 b 148 203 25 333 72 268 b 313 -42 230 134 277 64 b 335 -182 328 -86 335 -134 b 309 -332 335 -233 327 -284 l 307 -339 l 312 -354 b 335 -496 328 -399 335 -447 b 309 -646 335 -547 327 -598 l 307 -653 l 312 -668 b 335 -809 328 -713 335 -761 b 309 -960 335 -860 327 -911 l 307 -966 l 312 -981 b 335 -1122 328 -1027 335 -1075 b 288 -1325 335 -1191 320 -1260 b 265 -1344 281 -1340 276 -1344 b 243 -1322 252 -1344 243 -1335 b 251 -1300 243 -1317 243 -1316 b 289 -1125 276 -1244 289 -1184 b 173 -854 289 -1018 248 -915 b 34 -798 127 -816 83 -798 b -9 -802 20 -798 5 -800 b -21 -804 -14 -803 -20 -804 l -25 -804 l -25 -659 l -25 -515 l -21 -515 b 2 -537 -9 -515 -4 -520 b 148 -738 25 -609 72 -673 b 274 -892 204 -785 247 -838 b 279 -900 277 -898 279 -900 b 280 -898 280 -900 280 -899 b 282 -886 280 -897 281 -892 b 289 -811 287 -861 289 -836 b 173 -540 289 -703 246 -600 b 34 -484 127 -502 83 -484 b -9 -489 20 -484 5 -486 b -21 -490 -14 -489 -20 -490 l -25 -490 l -25 -346 l -25 -201 l -21 -201 b 2 -224 -9 -201 -4 -207 b 148 -424 25 -295 72 -360 b 274 -578 204 -471 247 -524 b 279 -586 277 -584 279 -586 b 280 -584 280 -586 280 -585 b 282 -573 280 -583 281 -578 b 289 -497 287 -548 289 -522 b 173 -226 289 -389 246 -286 b 34 -171 127 -188 83 -171 b -9 -175 20 -171 5 -172 b -21 -176 -14 -176 -20 -176 l -25 -176 l -25 -32 l -25 113 l -21 113 b 2 90 -9 113 -4 107 b 148 -110 25 19 72 -46 b 274 -264 204 -158 247 -210 b 279 -272 277 -270 279 -272 b 280 -270 280 -272 280 -272 b 282 -259 280 -269 281 -264 b 289 -184 287 -234 289 -208 b 173 88 289 -75 246 28 b 34 143 127 125 83 143 b -9 139 20 143 5 142 b -21 137 -14 138 -20 137 l -25 137 z"
        },
        flag64thDown: {
            x_min: -15,
            x_max: 271,
            y_min: -296,
            y_max: 820,
            ha: 1116,
            o: "m 272 1179 b 281 1181 275 1180 278 1181 b 297 1174 286 1181 292 1178 b 359 1098 322 1154 344 1127 b 390 972 380 1059 390 1016 b 357 836 390 926 379 879 l 351 825 l 353 823 b 359 812 354 822 357 817 b 390 685 380 773 390 729 b 357 549 390 639 379 593 l 351 539 l 353 536 b 359 526 354 535 357 530 b 390 399 380 486 390 443 b 357 263 390 353 379 306 l 351 252 l 353 250 b 390 113 374 218 390 162 b 390 113 390 113 390 113 b 246 -148 390 9 339 -84 b -1 -411 129 -228 30 -334 b -18 -426 -4 -420 -11 -426 l -22 -427 l -22 -291 l -22 -156 l -13 -155 b 156 -124 51 -152 115 -140 b 338 126 266 -80 338 23 b 326 195 338 150 334 173 b 321 207 324 204 323 207 b 318 203 321 207 319 205 b 246 139 299 180 276 159 b -1 -125 129 59 30 -48 b -18 -140 -4 -134 -11 -139 l -22 -140 l -22 -5 l -22 131 l -13 131 b 156 163 51 134 115 146 b 338 413 266 206 338 310 b 326 482 338 436 334 459 b 321 493 324 490 323 493 b 318 489 321 493 319 492 b 246 425 299 466 276 446 b -1 162 129 345 30 239 b -18 147 -4 153 -11 147 l -22 146 l -22 282 l -22 417 l -13 418 b 156 449 51 421 115 433 b 338 699 266 493 338 596 b 326 768 338 723 334 746 b 321 780 324 777 323 780 b 318 776 320 780 319 778 b 246 712 299 753 276 732 b -1 448 129 632 30 525 b -19 433 -4 439 -11 434 l -22 433 l -22 568 l -22 704 l -13 704 b 156 736 51 707 115 719 b 338 985 264 778 337 879 l 338 985 b 272 1137 338 1045 313 1103 b 259 1159 262 1146 259 1150 b 272 1179 259 1168 265 1176 z"
        },
        flag128thUp: {
            x_min: -17,
            x_max: 231,
            y_min: -987,
            y_max: 496,
            ha: 1484,
            o: "m -25 582 l -25 715 l -21 715 b 3 693 -11 715 -6 710 b 150 501 30 639 82 570 b 237 396 191 459 212 434 b 333 93 300 302 333 195 b 311 -46 333 45 326 -2 b 307 -60 308 -54 307 -57 b 310 -72 307 -63 308 -65 b 332 -220 325 -121 332 -171 b 311 -359 332 -269 325 -316 b 307 -374 308 -368 307 -371 b 310 -386 307 -377 308 -379 b 332 -534 325 -434 332 -485 b 311 -673 332 -583 325 -630 b 307 -688 308 -682 307 -685 b 310 -700 307 -690 308 -693 b 332 -848 325 -748 332 -799 b 311 -987 332 -896 325 -944 b 307 -1001 308 -995 307 -998 b 310 -1013 307 -1004 308 -1007 b 333 -1161 325 -1062 333 -1113 b 268 -1391 333 -1246 311 -1326 b 235 -1422 251 -1417 246 -1422 b 213 -1402 221 -1422 213 -1413 b 220 -1382 213 -1396 215 -1389 b 286 -1176 265 -1322 286 -1250 b 163 -883 286 -1073 244 -966 b -16 -806 122 -841 54 -812 b -23 -805 -19 -806 -22 -806 l -25 -805 l -25 -673 l -25 -541 l -21 -541 b 3 -562 -11 -541 -6 -545 b 150 -754 30 -617 82 -685 b 273 -921 209 -814 242 -860 l 280 -933 l 281 -927 b 287 -861 285 -906 287 -884 b 163 -569 287 -756 243 -650 b -16 -492 122 -527 54 -498 b -23 -492 -19 -492 -22 -492 l -25 -491 l -25 -359 l -25 -227 l -21 -227 b 3 -248 -11 -227 -6 -231 b 150 -441 30 -303 82 -372 b 273 -608 209 -500 242 -546 l 280 -620 l 281 -614 b 287 -548 285 -592 287 -570 b 163 -255 287 -442 243 -336 b -16 -179 122 -213 54 -184 b -23 -178 -19 -178 -22 -178 l -25 -178 l -25 -45 l -25 87 l -21 87 b 3 66 -11 87 -6 83 b 150 -127 30 11 82 -58 b 273 -294 209 -186 242 -232 l 280 -306 l 281 -300 b 287 -234 285 -278 287 -256 b 163 59 287 -129 243 -23 b -16 135 122 100 54 129 b -23 136 -19 135 -22 136 l -25 136 l -25 268 l -25 401 l -21 401 b 3 379 -11 401 -6 397 b 150 187 30 325 82 256 b 273 20 209 127 242 82 l 280 8 l 281 14 b 287 80 285 36 287 58 b 163 372 287 185 243 291 b -16 449 122 414 54 443 b -23 450 -19 449 -22 449 l -25 450 z"
        },
        flag128thDown: {
            x_min: -15,
            x_max: 270,
            y_min: -496,
            y_max: 870,
            ha: 1366,
            o: "m 292 1251 b 301 1253 295 1252 298 1253 b 325 1235 309 1253 316 1247 b 389 1031 368 1174 389 1103 b 364 898 389 986 381 941 l 359 888 l 364 876 b 389 745 381 834 389 789 b 364 612 389 700 381 654 l 359 601 l 364 589 b 389 458 381 547 389 503 b 364 325 389 413 381 368 l 359 315 l 364 303 b 389 172 381 261 389 216 b 364 39 389 127 381 81 l 359 28 l 364 16 b 390 -115 381 -26 390 -71 b 260 -391 390 -219 344 -320 b 0 -698 135 -495 36 -613 b -19 -715 -5 -709 -11 -715 l -22 -715 l -22 -582 l -21 -449 l -14 -447 b 124 -400 25 -439 79 -420 b 213 -349 168 -379 189 -367 b 340 -101 294 -288 340 -196 b 332 -36 340 -79 337 -57 b 330 -27 331 -30 331 -27 b 326 -31 329 -27 328 -29 b 260 -104 309 -57 286 -82 b 0 -412 135 -209 36 -326 b -19 -428 -5 -422 -11 -428 l -22 -428 l -22 -295 l -21 -162 l -14 -161 b 124 -113 25 -153 79 -134 b 213 -63 168 -92 189 -81 b 340 186 294 -2 340 91 b 332 251 340 207 337 229 b 330 259 331 257 331 259 b 326 255 329 259 328 258 b 260 182 309 229 286 204 b 0 -125 135 78 36 -40 b -19 -142 -5 -136 -11 -142 l -22 -142 l -22 -9 l -21 124 l -14 126 b 124 173 25 134 79 152 b 213 224 168 194 189 206 b 340 472 294 285 340 377 b 332 537 340 494 337 516 b 330 546 331 543 331 546 b 326 542 329 546 328 544 b 255 465 307 514 286 491 b 0 161 135 364 35 245 b -19 145 -4 151 -11 145 l -22 145 l -22 278 l -21 411 l -14 412 b 124 460 25 420 79 439 b 213 510 168 481 189 492 b 340 759 294 571 340 664 b 332 824 340 780 337 802 b 330 832 331 830 331 832 b 326 828 329 832 328 831 b 255 751 308 801 286 777 b 0 448 135 650 35 532 b -19 431 -4 437 -11 431 l -22 431 l -22 564 l -21 697 l -14 699 b 124 746 25 707 79 725 b 213 797 168 767 189 779 b 340 1046 295 859 340 953 b 285 1213 340 1105 322 1163 b 278 1232 281 1220 278 1226 b 292 1251 278 1241 283 1248 z"
        },
        accidentalFlat: {
            x_min: -15,
            x_max: 185,
            y_min: -165,
            y_max: 457,
            ha: 622,
            o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 398 22 640 22 640 l 22 155 l 24 158 b 146 208 64 191 106 208 b 194 200 163 208 179 205 b 267 89 241 183 267 140 b 243 1 267 61 259 30 b 107 -148 220 -41 190 -73 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 l -22 -220 l -22 210 l -22 640 l -20 644 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z"
        },
        accidentalNatural: {
            x_min: 0,
            x_max: 176,
            y_min: -334,
            y_max: 334,
            ha: 667,
            o: "m 13 479 b 21 480 16 480 19 480 b 42 467 30 480 39 475 b 44 339 44 463 44 462 b 44 214 44 250 44 214 b 136 237 45 214 86 224 b 234 259 209 255 227 259 b 240 258 237 259 238 259 b 252 246 245 256 251 251 l 254 242 l 254 -111 l 254 -463 l 252 -467 b 232 -480 249 -475 241 -480 b 216 -474 226 -480 221 -478 b 210 -392 211 -468 210 -477 b 210 -336 210 -377 210 -358 b 209 -209 210 -245 210 -209 b 117 -231 209 -209 168 -219 b 19 -254 45 -249 27 -254 b 13 -252 17 -254 15 -253 b 1 -240 8 -251 3 -245 l 0 -237 l 0 113 l 0 463 l 1 467 b 13 479 3 472 8 477 z m 210 23 b 210 74 210 44 210 61 b 209 121 210 118 210 121 l 209 121 b 126 101 208 121 171 112 l 44 81 l 44 -18 b 44 -62 44 -35 44 -50 b 44 -116 44 -104 44 -116 b 128 -96 45 -116 82 -107 l 210 -75 z"
        },
        accidentalSharp: {
            x_min: 0,
            x_max: 239,
            y_min: -388,
            y_max: 388,
            ha: 775,
            o: "m 232 557 b 240 558 234 558 237 558 b 261 545 249 558 258 553 b 262 405 262 541 262 540 b 263 269 262 278 262 269 b 263 269 263 269 263 269 b 322 282 275 273 319 282 b 343 269 331 282 340 277 b 344 217 344 266 344 241 b 343 165 344 192 344 168 b 295 144 339 155 337 154 l 262 136 l 262 22 b 263 -91 262 -83 262 -91 b 263 -91 263 -91 263 -91 b 322 -78 275 -88 319 -78 b 338 -84 329 -78 333 -80 b 344 -129 344 -90 344 -88 b 344 -143 344 -133 344 -138 b 344 -157 344 -148 344 -153 b 338 -203 344 -198 344 -197 b 295 -217 333 -207 333 -207 l 262 -225 l 262 -362 b 261 -504 262 -499 262 -500 b 240 -517 258 -512 249 -517 b 225 -511 235 -517 229 -515 b 218 -430 219 -505 218 -514 b 218 -368 218 -413 218 -393 b 218 -235 218 -295 218 -235 b 171 -247 218 -235 197 -241 b 123 -259 145 -253 123 -259 b 123 -400 123 -259 123 -322 b 122 -545 123 -540 123 -541 b 101 -558 118 -553 110 -558 b 86 -552 95 -558 90 -556 b 79 -469 80 -546 79 -556 b 79 -405 79 -452 79 -431 b 78 -270 79 -279 79 -270 b 78 -270 78 -270 78 -270 b 22 -282 65 -273 25 -282 b 2 -269 13 -282 5 -277 b 0 -217 1 -266 0 -242 b 2 -165 0 -192 1 -168 b 48 -144 5 -155 7 -154 l 79 -136 l 79 -23 b 78 90 79 83 79 90 b 78 90 78 90 78 90 b 22 78 65 87 25 78 b 2 91 13 78 5 83 b 0 143 1 94 0 119 b 2 195 0 168 1 192 b 48 216 5 205 7 206 l 79 224 l 79 362 b 81 504 79 499 79 500 b 101 517 84 512 93 517 b 117 511 107 517 112 515 b 123 430 123 505 123 515 b 123 367 123 413 123 392 b 123 235 123 294 123 235 b 171 246 123 235 145 240 b 218 258 197 253 218 258 b 218 399 218 258 218 322 b 220 545 218 540 218 541 b 232 557 222 549 227 555 z m 218 11 b 218 125 218 102 218 125 l 218 125 b 201 121 217 125 210 123 b 154 109 193 119 171 113 l 123 102 l 123 -12 b 123 -126 123 -74 123 -126 b 171 -114 123 -126 145 -120 b 218 -102 197 -107 218 -102 b 218 11 218 -102 218 -51 z"
        },
        accidentalDoubleSharp: {
            x_min: 0,
            x_max: 271,
            y_min: -135,
            y_max: 135,
            ha: 271,
            o: "m 0 130 l 0 195 l 65 195 l 131 195 l 131 145 l 131 96 l 163 64 l 195 32 l 227 64 l 259 96 l 259 145 l 259 195 l 325 195 l 390 195 l 390 130 l 390 64 l 341 64 l 291 64 l 259 32 l 227 0 l 259 -32 l 291 -64 l 341 -64 l 390 -64 l 390 -130 l 390 -195 l 325 -195 l 259 -195 l 259 -145 l 259 -96 l 227 -64 l 195 -32 l 163 -64 l 131 -96 l 131 -145 l 131 -195 l 65 -195 l 0 -195 l 0 -130 l 0 -64 l 50 -64 l 99 -64 l 131 -32 l 163 0 l 131 32 l 99 64 l 50 64 l 0 64 z"
        },
        accidentalDoubleFlat: {
            x_min: -15,
            x_max: 356,
            y_min: -165,
            y_max: 457,
            ha: 622,
            o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 398 22 640 22 640 l 22 155 l 24 158 b 149 208 64 191 109 208 b 220 187 175 208 200 201 l 223 184 l 224 413 l 224 642 l 226 645 b 246 657 229 653 237 657 b 266 644 254 657 263 653 b 267 398 267 640 267 640 l 267 155 l 270 158 b 392 208 309 191 351 208 b 440 200 408 208 424 205 b 512 89 486 183 512 140 b 488 1 512 61 505 30 b 352 -148 466 -41 436 -73 b 271 -222 307 -188 297 -198 b 246 -237 256 -236 254 -237 b 230 -231 239 -237 234 -236 b 224 -164 224 -225 224 -232 b 224 -125 224 -153 224 -140 l 224 -29 l 218 -36 b 107 -148 194 -67 170 -91 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 l -22 -220 l -22 210 l -22 640 l -20 644 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z m 364 137 b 347 139 360 138 352 139 b 342 139 345 139 343 139 b 272 92 315 135 290 118 l 267 84 l 267 -39 l 267 -161 l 271 -157 b 399 88 349 -73 399 24 b 397 107 399 95 398 101 b 364 137 394 122 382 134 z"
        },
        accidentalParensLeft: {
            x_min: -122,
            x_max: -19,
            y_min: -267,
            y_max: 267,
            ha: 534,
            o: "m -51 383 b -44 385 -49 384 -46 385 b -29 375 -38 385 -31 381 b -27 369 -28 373 -27 372 b -33 349 -27 365 -29 360 b -98 54 -71 259 -91 167 b -99 0 -98 44 -99 22 b -98 -54 -99 -22 -98 -45 b -33 -349 -91 -167 -71 -259 b -27 -368 -28 -363 -27 -365 b -44 -385 -27 -378 -34 -385 b -65 -367 -52 -385 -55 -383 b -176 0 -139 -251 -176 -125 b -65 367 -176 125 -139 251 b -51 383 -57 379 -55 381 z"
        },
        accidentalParensRight: {
            x_min: 19,
            x_max: 122,
            y_min: -267,
            y_max: 267,
            ha: 535,
            o: "m 36 384 b 44 385 38 385 41 385 b 65 367 52 385 55 383 b 176 0 139 251 176 126 b 65 -367 176 -125 139 -250 b 44 -385 56 -380 51 -385 b 36 -383 42 -385 39 -384 b 27 -370 30 -380 27 -377 b 33 -349 27 -365 29 -359 b 99 0 77 -242 99 -121 b 33 350 99 122 77 243 b 27 371 29 359 27 366 b 36 384 27 377 30 381 z"
        },
        accidentalQuarterToneFlatStein: {
            x_min: 0,
            x_max: 200,
            y_min: -165,
            y_max: 457,
            ha: 622,
            o: "m 258 656 b 266 658 261 657 264 658 b 287 644 275 658 284 652 l 289 640 l 289 210 l 289 -220 l 287 -224 b 267 -237 284 -232 276 -237 b 241 -222 258 -237 256 -236 b 163 -151 216 -199 200 -183 b 24 2 78 -75 47 -41 b 0 88 8 31 0 61 b 73 200 0 140 26 183 b 120 208 88 205 104 208 b 242 158 161 208 203 191 l 245 155 l 245 398 b 246 644 245 640 245 640 b 258 656 248 649 253 654 z m 179 137 b 159 139 174 138 165 139 b 155 139 157 139 156 139 b 115 107 131 134 118 124 b 113 88 114 101 113 95 b 241 -157 113 24 163 -73 l 245 -161 l 245 -39 l 245 84 l 240 92 b 179 137 224 116 203 131 z"
        },
        accidentalThreeQuarterTonesFlatZimmermann: {
            x_min: 0,
            x_max: 446,
            y_min: -165,
            y_max: 457,
            ha: 622,
            o: "m 258 656 b 266 658 261 657 264 658 b 287 644 275 658 284 652 l 289 640 l 289 210 l 289 -220 l 287 -224 b 267 -237 284 -232 276 -237 b 241 -222 258 -237 256 -236 b 163 -151 216 -199 200 -183 b 24 2 78 -75 47 -41 b 0 88 8 31 0 61 b 73 200 0 140 26 183 b 120 208 88 205 104 208 b 242 158 161 208 203 191 l 245 155 l 245 398 b 246 644 245 640 245 640 b 258 656 248 649 253 654 z m 179 137 b 159 139 174 138 165 139 b 155 139 157 139 156 139 b 115 107 131 134 118 124 b 113 88 114 101 113 95 b 241 -157 113 24 163 -73 l 245 -161 l 245 -39 l 245 84 l 240 92 b 179 137 224 116 203 131 z m 367 656 b 375 658 370 657 373 658 b 396 644 384 658 393 652 b 398 398 398 640 398 640 l 398 155 l 400 158 b 522 208 440 191 482 208 b 570 200 538 208 554 205 b 643 89 617 183 643 140 b 619 1 643 61 635 30 b 483 -148 596 -41 566 -73 b 401 -222 438 -188 427 -198 b 376 -237 386 -236 384 -237 b 355 -224 366 -237 358 -232 l 354 -220 l 354 210 l 354 640 l 355 644 b 367 656 357 649 362 654 z m 495 137 b 477 139 491 138 482 139 b 472 139 475 139 473 139 b 403 92 445 135 420 118 l 398 84 l 398 -39 l 398 -161 l 401 -157 b 529 88 479 -73 529 24 b 528 107 529 95 529 101 b 495 137 525 122 512 134 z"
        },
        accidentalQuarterToneSharpStein: {
            x_min: 0,
            x_max: 142,
            y_min: -373,
            y_max: 373,
            ha: 747,
            o: "m 92 536 b 101 538 95 537 98 538 b 122 524 110 538 118 532 b 123 390 123 520 123 519 l 123 259 l 151 268 b 182 277 175 276 178 277 b 184 277 183 277 183 277 b 203 265 193 276 199 272 l 204 262 l 205 213 b 205 187 205 202 205 194 b 201 154 205 159 204 159 b 158 136 197 149 194 148 l 123 125 l 123 10 b 124 -104 123 -64 123 -104 b 150 -94 124 -104 136 -100 b 179 -85 164 -89 177 -85 b 183 -84 181 -84 182 -84 b 203 -98 192 -84 200 -90 b 205 -157 204 -101 205 -130 b 204 -201 205 -179 205 -199 b 158 -226 200 -211 199 -212 l 123 -239 l 123 -380 l 123 -522 l 121 -525 b 101 -538 117 -533 109 -538 b 85 -531 95 -538 90 -536 b 79 -450 80 -526 79 -535 b 79 -387 79 -433 79 -413 b 79 -254 79 -314 79 -254 b 54 -263 79 -254 67 -258 b 19 -273 36 -270 26 -273 b 6 -267 14 -273 10 -271 b 0 -222 0 -261 0 -263 b 0 -207 0 -217 0 -213 b 0 -195 0 -203 0 -199 b 6 -148 0 -152 0 -154 b 47 -131 10 -144 10 -144 l 79 -120 l 79 -5 b 79 110 79 58 79 110 b 53 101 79 110 67 106 b 19 93 35 95 25 93 b 6 99 14 93 10 95 b 0 144 0 105 0 103 b 0 158 0 148 0 153 b 0 185 0 169 0 178 b 45 233 0 222 3 219 l 79 244 l 79 382 b 81 524 79 519 79 520 b 92 536 82 529 88 534 z"
        },
        accidentalThreeQuarterTonesSharpStein: {
            x_min: 0,
            x_max: 335,
            y_min: -391,
            y_max: 391,
            ha: 782,
            o: "m 373 562 b 379 563 375 563 377 563 b 399 551 388 563 395 559 l 401 548 l 401 410 l 401 272 l 403 273 b 432 278 403 273 417 275 b 463 282 448 281 457 282 b 477 276 470 282 473 280 b 483 241 482 271 483 271 b 483 216 483 234 483 226 l 483 167 l 481 164 b 471 153 479 160 475 155 b 402 140 469 152 405 140 b 401 25 401 140 401 88 l 401 -91 l 403 -90 b 432 -85 403 -90 417 -88 b 463 -80 448 -82 457 -80 b 477 -87 470 -80 473 -83 b 483 -122 482 -92 483 -91 b 483 -147 483 -128 483 -137 l 483 -196 l 481 -199 b 471 -209 479 -203 475 -207 b 402 -223 469 -210 405 -223 b 401 -359 401 -223 401 -284 l 401 -496 l 399 -500 b 379 -512 395 -507 388 -512 b 359 -500 371 -512 363 -507 l 357 -496 l 357 -363 b 356 -231 357 -240 357 -231 b 356 -231 356 -231 356 -231 b 309 -240 356 -232 334 -235 l 262 -249 l 262 -384 b 262 -448 262 -410 262 -431 b 256 -531 262 -535 261 -526 b 240 -538 251 -536 246 -538 b 220 -525 232 -538 224 -533 l 219 -522 l 218 -389 l 218 -257 l 171 -265 b 123 -274 144 -270 123 -274 b 123 -411 123 -274 123 -336 l 122 -548 l 121 -551 b 101 -563 116 -559 109 -563 b 81 -551 93 -563 85 -559 l 79 -548 l 79 -415 b 79 -282 79 -342 79 -282 b 52 -287 78 -282 66 -285 b 20 -292 36 -290 26 -292 b 6 -286 13 -292 10 -290 b 0 -241 0 -280 0 -282 b 0 -226 0 -236 0 -232 b 0 -212 0 -221 0 -216 b 6 -167 0 -171 0 -173 b 48 -155 11 -162 13 -162 l 79 -150 l 79 -35 b 79 80 79 29 79 80 b 52 76 78 80 66 78 b 20 71 36 73 26 71 b 6 77 13 71 10 73 b 0 122 0 83 0 81 b 0 136 0 126 0 131 b 0 151 0 142 0 146 b 6 196 0 192 0 190 b 48 207 11 201 13 201 l 79 213 l 79 354 l 79 496 l 81 500 b 101 512 85 508 93 512 b 121 500 109 512 116 508 l 122 497 l 123 359 l 123 221 l 171 230 b 218 239 197 235 218 239 b 218 380 218 239 218 302 b 220 524 218 519 218 520 b 240 538 223 533 231 538 b 256 531 246 538 251 536 b 262 448 261 526 262 535 b 262 384 262 431 262 410 b 263 247 262 295 262 247 b 310 255 263 247 284 251 b 357 264 335 260 357 264 b 358 406 357 264 357 328 l 358 548 l 359 551 b 373 562 362 557 367 561 z m 357 16 b 357 132 357 108 357 132 l 357 132 b 309 123 356 132 335 128 l 262 114 l 262 -1 b 263 -116 262 -76 262 -116 b 310 -107 263 -116 284 -112 b 357 -99 335 -103 357 -99 b 357 16 357 -99 357 -48 z m 218 -124 b 218 -56 218 -124 218 -96 b 218 -9 218 -42 218 -26 l 218 106 l 171 97 b 123 88 145 93 123 89 b 123 21 123 88 123 61 b 123 -27 123 6 123 -10 l 123 -142 l 170 -133 b 218 -124 196 -128 218 -124 z"
        },
        accidentalBuyukMucennebFlat: {
            x_min: -125,
            x_max: 185,
            y_min: -165,
            y_max: 457,
            ha: 622,
            o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 575 22 640 22 639 b 23 510 22 524 22 510 b 23 510 23 510 23 510 b 164 557 49 520 160 557 b 186 534 177 557 186 546 b 176 516 186 527 183 520 b 98 489 175 515 140 503 l 22 463 l 22 405 b 22 378 22 394 22 386 b 23 347 22 354 22 347 b 23 347 23 347 23 347 b 164 393 49 356 160 393 b 186 371 177 393 186 382 b 176 352 186 364 183 357 b 98 325 175 352 140 339 l 22 300 l 22 228 l 22 155 l 24 158 b 146 208 64 191 106 208 b 194 200 163 208 179 205 b 267 89 241 183 267 140 b 243 1 267 61 259 30 b 107 -148 220 -41 190 -73 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 b -22 32 -22 -220 -22 -220 b -22 284 -22 171 -22 284 b -88 262 -23 284 -52 274 b -160 240 -141 245 -154 240 b -167 241 -163 240 -164 241 b -180 262 -175 245 -180 254 b -169 281 -180 270 -176 278 b -30 329 -168 282 -92 308 l -22 332 l -22 390 b -22 448 -22 422 -22 448 b -88 426 -23 448 -52 438 b -160 404 -141 408 -154 404 b -167 405 -163 404 -164 404 b -180 426 -175 408 -180 417 b -169 445 -180 434 -176 441 b -30 493 -168 446 -92 472 l -22 495 l -22 568 b -20 644 -22 639 -22 641 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z"
        },
        accidentalBuyukMucennebSharp: {
            x_min: 0,
            x_max: 284,
            y_min: -388,
            y_max: 388,
            ha: 775,
            o: "m 264 557 b 272 558 267 558 269 558 b 293 545 281 558 290 553 b 294 435 294 541 294 540 b 295 329 294 337 294 329 b 296 329 296 329 296 329 b 355 342 308 333 351 342 b 375 329 364 342 372 337 b 376 277 376 326 376 302 b 375 225 376 252 376 228 b 327 204 371 215 369 214 l 294 196 l 294 142 b 295 89 294 94 294 89 b 296 89 295 89 296 89 b 389 110 314 94 384 110 b 389 110 389 110 389 110 b 407 98 397 110 403 105 l 409 95 l 409 45 b 409 25 409 37 409 30 b 404 -13 409 -11 408 -8 b 345 -32 400 -18 398 -19 b 295 -44 317 -39 295 -44 b 294 -98 294 -44 294 -68 b 295 -151 294 -147 294 -151 b 296 -151 295 -151 296 -151 b 355 -138 308 -148 351 -138 b 375 -151 364 -138 372 -143 b 376 -203 376 -154 376 -179 b 375 -255 376 -228 376 -252 b 327 -277 371 -265 369 -266 l 294 -285 l 294 -392 b 293 -504 294 -499 294 -500 b 272 -517 290 -512 281 -517 b 257 -511 267 -517 261 -515 b 251 -443 251 -505 251 -512 b 251 -398 251 -430 251 -416 b 250 -295 251 -341 251 -295 b 203 -307 250 -295 229 -301 b 156 -319 177 -313 156 -319 b 155 -430 155 -319 155 -369 b 154 -545 155 -540 155 -541 b 133 -558 151 -553 142 -558 b 118 -552 128 -558 122 -556 b 112 -482 112 -546 112 -553 b 112 -435 112 -469 112 -454 b 110 -330 112 -337 111 -330 b 110 -330 110 -330 110 -330 b 54 -342 98 -333 58 -342 b 34 -329 45 -342 37 -337 b 32 -277 33 -326 32 -302 b 34 -225 32 -252 33 -228 b 80 -204 38 -215 39 -214 l 112 -196 l 112 -143 b 111 -90 112 -94 111 -90 b 110 -90 110 -90 110 -90 b 20 -110 89 -96 25 -110 b 20 -110 20 -110 20 -110 b 2 -98 12 -110 5 -105 l 0 -95 l 0 -45 b 0 -25 0 -37 0 -30 b 5 13 0 11 0 8 b 62 32 9 18 10 19 b 111 44 89 38 111 44 b 112 97 111 44 112 68 b 111 150 112 146 111 150 b 110 150 110 150 110 150 b 54 138 98 147 58 138 b 34 151 45 138 37 143 b 32 203 33 154 32 179 b 34 255 32 228 33 252 b 80 276 38 265 39 266 l 112 284 l 112 392 b 113 504 112 499 112 500 b 133 517 116 512 125 517 b 149 511 139 517 145 515 b 155 443 155 505 155 512 b 155 397 155 430 155 415 b 155 295 155 341 155 295 b 203 306 156 295 177 300 b 250 318 229 313 250 318 b 251 429 251 318 251 368 b 252 545 251 540 251 541 b 264 557 254 549 259 555 z m 251 131 b 250 185 251 174 250 185 l 250 185 b 233 181 249 185 242 183 b 186 169 225 179 204 173 l 155 162 l 155 108 b 155 55 155 79 155 55 b 203 66 156 55 177 60 b 250 78 229 73 250 78 b 251 131 251 78 251 102 z m 251 -109 b 250 -55 251 -67 250 -55 l 250 -55 b 233 -59 249 -55 242 -57 b 186 -71 225 -62 204 -67 l 155 -79 l 155 -132 b 155 -186 155 -161 155 -186 b 203 -174 156 -186 177 -180 b 250 -162 229 -168 250 -162 b 251 -109 251 -162 251 -138 z"
        },
        accidentalBakiyeFlat: {
            x_min: -129,
            x_max: 185,
            y_min: -165,
            y_max: 457,
            ha: 622,
            o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 524 22 640 22 639 b 22 407 22 460 22 407 b 90 441 22 407 53 422 l 157 474 l 163 475 b 164 475 163 475 163 475 b 186 453 177 475 186 465 b 184 445 186 450 185 447 b 99 396 181 436 184 438 l 22 357 l 22 256 l 22 155 l 24 158 b 146 208 64 191 106 208 b 194 200 163 208 179 205 b 267 89 241 183 267 140 b 243 1 267 61 259 30 b 107 -148 220 -41 190 -73 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 b -22 57 -22 -220 -22 -220 b -22 335 -22 210 -22 335 b -90 301 -22 335 -53 320 l -157 268 l -163 268 b -164 268 -163 268 -163 268 b -186 289 -177 268 -186 277 b -184 298 -186 292 -185 295 b -99 347 -181 306 -184 304 l -22 385 l -22 513 b -20 644 -22 639 -22 640 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z"
        },
        accidentalKomaSharp: {
            x_min: 0,
            x_max: 142,
            y_min: -373,
            y_max: 373,
            ha: 747,
            o: "m 92 536 b 101 538 95 537 98 538 b 122 524 110 538 118 532 b 123 390 123 520 123 519 l 123 259 l 151 268 b 182 277 175 276 178 277 b 184 277 183 277 183 277 b 203 265 193 276 199 272 l 204 262 l 205 213 b 205 187 205 202 205 194 b 201 154 205 159 204 159 b 158 136 197 149 194 148 l 123 125 l 123 10 b 124 -104 123 -64 123 -104 b 150 -94 124 -104 136 -100 b 179 -85 164 -89 177 -85 b 183 -84 181 -84 182 -84 b 203 -98 192 -84 200 -90 b 205 -157 204 -101 205 -130 b 204 -201 205 -179 205 -199 b 158 -226 200 -211 199 -212 l 123 -239 l 123 -380 l 123 -522 l 121 -525 b 101 -538 117 -533 109 -538 b 85 -531 95 -538 90 -536 b 79 -450 80 -526 79 -535 b 79 -387 79 -433 79 -413 b 79 -254 79 -314 79 -254 b 54 -263 79 -254 67 -258 b 19 -273 36 -270 26 -273 b 6 -267 14 -273 10 -271 b 0 -222 0 -261 0 -263 b 0 -207 0 -217 0 -213 b 0 -195 0 -203 0 -199 b 6 -148 0 -152 0 -154 b 47 -131 10 -144 10 -144 l 79 -120 l 79 -5 b 79 110 79 58 79 110 b 53 101 79 110 67 106 b 19 93 35 95 25 93 b 6 99 14 93 10 95 b 0 144 0 105 0 103 b 0 158 0 148 0 153 b 0 185 0 169 0 178 b 45 233 0 222 3 219 l 79 244 l 79 382 b 81 524 79 519 79 520 b 92 536 82 529 88 534 z"
        },
        accidentalKucukMucennebSharp: {
            x_min: 0,
            x_max: 188,
            y_min: -373,
            y_max: 373,
            ha: 747,
            o: "m 127 536 b 135 538 129 537 132 538 b 156 524 144 538 153 532 b 157 420 157 520 157 519 l 157 319 l 185 328 b 216 337 209 336 212 337 b 218 337 217 337 217 337 b 237 325 227 336 233 332 l 239 322 l 239 273 b 239 247 239 262 239 254 b 235 214 239 219 238 219 b 192 196 231 209 229 208 l 157 185 l 157 129 b 158 75 157 86 157 75 b 158 75 158 75 158 75 b 202 89 158 75 178 81 l 245 103 l 250 103 b 268 91 258 102 265 98 l 270 88 l 270 39 b 270 13 270 28 270 20 b 266 -20 270 -15 270 -15 b 208 -43 262 -25 261 -25 l 157 -60 l 157 -112 b 157 -127 157 -117 157 -122 b 158 -164 157 -151 157 -164 b 184 -154 158 -164 170 -160 b 214 -145 198 -149 212 -145 b 217 -144 215 -144 216 -144 b 238 -158 226 -144 235 -150 b 239 -217 239 -161 239 -190 b 238 -261 239 -239 239 -259 b 192 -286 235 -271 233 -272 l 157 -299 l 157 -410 b 155 -525 157 -522 157 -522 b 135 -538 152 -533 143 -538 b 120 -531 130 -538 124 -536 b 113 -463 114 -525 113 -532 b 113 -417 113 -450 113 -435 b 113 -314 113 -361 113 -314 b 88 -323 113 -314 102 -318 b 53 -333 70 -330 60 -333 b 41 -327 48 -333 45 -331 b 34 -282 35 -321 34 -323 b 34 -267 34 -277 34 -273 b 34 -255 34 -263 34 -259 b 40 -208 34 -212 35 -214 b 81 -191 44 -204 44 -204 l 113 -180 l 113 -127 b 113 -75 113 -86 113 -75 b 113 -75 113 -75 113 -75 b 69 -89 112 -75 92 -81 l 26 -103 l 21 -103 b 1 -89 12 -102 4 -97 b 0 -43 0 -86 0 -65 b 2 15 0 -16 1 12 b 63 43 5 24 4 24 l 113 60 l 113 115 b 113 130 113 120 113 125 b 113 170 113 153 113 170 b 87 161 113 170 101 166 b 53 153 69 156 60 153 b 41 159 48 153 45 155 b 34 204 35 165 34 163 b 34 218 34 208 34 213 b 34 245 34 229 34 238 b 79 293 34 282 38 279 l 113 304 l 113 412 b 115 524 113 519 113 520 b 127 536 117 529 122 534 z"
        },
        articAccentAbove: {
            x_min: -256,
            x_max: 19,
            y_min: -114,
            y_max: 114,
            ha: 227,
            o: "m -350 163 b -341 164 -348 163 -344 164 b -333 163 -338 164 -335 163 b -312 151 -330 162 -327 160 b -9 30 -231 99 -122 56 b 13 24 8 27 11 26 b 28 0 23 18 28 9 b 3 -28 28 -12 19 -24 b -19 -33 -1 -29 -11 -31 b -315 -153 -129 -58 -238 -102 b -341 -164 -331 -163 -333 -164 b -369 -136 -357 -164 -369 -151 b -364 -121 -369 -131 -367 -126 b -346 -107 -361 -117 -358 -114 b -135 -8 -285 -67 -213 -34 b -111 0 -122 -4 -111 0 b -135 8 -111 0 -122 4 b -346 107 -213 34 -285 67 b -364 121 -358 114 -361 116 b -368 136 -367 126 -368 131 b -350 163 -368 148 -361 159 z"
        },
        articAccentBelow: {
            x_min: -256,
            x_max: 19,
            y_min: -114,
            y_max: 114,
            ha: 227,
            o: "m -350 163 b -341 164 -348 163 -344 164 b -333 163 -338 164 -335 163 b -312 151 -330 162 -327 160 b -9 30 -231 99 -122 56 b 13 24 8 27 11 26 b 28 0 23 18 28 9 b 3 -28 28 -12 19 -24 b -19 -33 -1 -29 -11 -31 b -315 -153 -129 -58 -238 -102 b -341 -164 -331 -163 -333 -164 b -369 -136 -357 -164 -369 -151 b -364 -121 -369 -131 -367 -126 b -346 -107 -361 -117 -358 -114 b -135 -8 -285 -67 -213 -34 b -111 0 -122 -4 -111 0 b -135 8 -111 0 -122 4 b -346 107 -213 34 -285 67 b -364 121 -358 114 -361 116 b -368 136 -367 126 -368 131 b -350 163 -368 148 -361 159 z"
        },
        articTenutoAbove: {
            x_min: -154,
            x_max: 154,
            y_min: -15,
            y_max: 15,
            ha: 30,
            o: "m -208 20 b 2 22 -205 21 -101 22 b 208 20 104 22 205 21 b 221 0 216 17 221 9 b 215 -16 221 -6 219 -11 b 101 -22 209 -21 225 -22 b 0 -22 75 -22 41 -22 b -101 -22 -41 -22 -75 -22 b -215 -16 -225 -22 -209 -21 b -221 0 -219 -11 -221 -6 b -208 20 -221 8 -216 17 z"
        },
        articTenutoBelow: {
            x_min: -154,
            x_max: 154,
            y_min: -15,
            y_max: 15,
            ha: 30,
            o: "m -208 20 b 2 22 -205 21 -101 22 b 208 20 104 22 205 21 b 221 0 216 17 221 9 b 215 -16 221 -6 219 -11 b 101 -22 209 -21 225 -22 b 0 -22 75 -22 41 -22 b -101 -22 -41 -22 -75 -22 b -215 -16 -225 -22 -209 -21 b -221 0 -219 -11 -221 -6 b -208 20 -221 8 -216 17 z"
        },
        articStaccatoAbove: {
            x_min: -49,
            x_max: 49,
            y_min: -49,
            y_max: 49,
            ha: 99,
            o: "m -13 70 b -1 71 -9 71 -5 71 b 59 40 23 71 46 59 b 71 0 67 28 71 14 b 40 -59 71 -23 60 -46 b 0 -71 28 -67 14 -71 b -59 -40 -23 -71 -46 -60 b -71 0 -67 -28 -71 -14 b -13 70 -71 32 -48 64 z"
        },
        articStaccatoBelow: {
            x_min: -49,
            x_max: 49,
            y_min: -49,
            y_max: 49,
            ha: 99,
            o: "m -13 70 b -1 71 -9 71 -5 71 b 59 40 23 71 46 59 b 71 0 67 28 71 14 b 40 -59 71 -23 60 -46 b 0 -71 28 -67 14 -71 b -59 -40 -23 -71 -46 -60 b -71 0 -67 -28 -71 -14 b -13 70 -71 32 -48 64 z"
        },
        articStaccatissimoAbove: {
            x_min: -53,
            x_max: 53,
            y_min: 0,
            y_max: 184,
            ha: 184,
            o: "m -76 263 l -77 265 l 0 265 l 77 265 l 76 263 b 0 0 75 259 0 0 b -76 263 0 0 -75 259 z"
        },
        articStaccatissimoBelow: {
            x_min: -53,
            x_max: 53,
            y_min: -184,
            y_max: 0,
            ha: 184,
            o: "m -38 -131 b 0 0 -17 -59 0 0 b 76 -263 0 0 75 -259 l 77 -265 l 0 -265 l -77 -265 l -76 -263 b -38 -131 -76 -262 -59 -203 z"
        },
        articMarcatoAbove: {
            x_min: -114,
            x_max: 114,
            y_min: -256,
            y_max: 19,
            ha: 275,
            o: "m -9 26 b 0 28 -6 27 -3 28 b 28 3 13 28 24 18 b 33 -19 29 -1 31 -11 b 153 -315 58 -129 102 -238 b 164 -341 163 -331 164 -333 b 136 -368 164 -357 152 -368 b 107 -346 124 -368 118 -364 b 8 -135 67 -285 34 -213 b 0 -111 4 -122 0 -111 b -8 -135 0 -111 -4 -122 b -107 -346 -34 -213 -67 -285 b -136 -368 -118 -364 -124 -368 b -164 -341 -152 -368 -164 -357 b -151 -312 -164 -333 -163 -332 b -30 -9 -99 -231 -56 -122 b -21 18 -26 11 -26 12 b -9 26 -19 21 -13 25 z"
        },
        articMarcatoBelow: {
            x_min: -114,
            x_max: 114,
            y_min: -19,
            y_max: 256,
            ha: 275,
            o: "m -145 367 b -136 369 -142 368 -139 369 b -107 346 -125 369 -117 362 b -8 135 -67 285 -34 213 b 0 111 -4 122 0 111 b 8 135 0 111 4 122 b 107 346 34 213 67 285 b 121 364 114 358 117 361 b 136 369 126 367 131 369 b 164 341 151 369 164 357 b 153 315 164 333 163 331 b 30 9 101 235 56 124 b 21 -18 26 -11 26 -12 b 0 -27 16 -24 8 -27 b -21 -18 -8 -27 -16 -24 b -30 9 -26 -12 -26 -11 b -151 312 -56 122 -99 231 b -164 341 -163 332 -164 333 b -145 367 -164 353 -156 364 z"
        },
        fermataAbove: {
            x_min: -324,
            x_max: 324,
            y_min: 0,
            y_max: 353,
            ha: 353,
            o: "m -33 507 b 0 508 -22 508 -11 508 b 459 112 228 508 419 345 b 467 31 464 85 467 51 b 465 14 467 22 466 16 b 445 0 462 5 453 0 b 429 7 439 0 433 2 b 422 32 424 12 423 15 b 0 365 414 221 231 365 b -63 362 -33 365 -39 365 b -422 32 -265 338 -415 200 b -429 7 -423 15 -424 12 b -445 0 -433 2 -439 0 b -465 14 -453 0 -462 5 b -467 31 -466 16 -467 22 b -459 112 -467 51 -464 85 b -33 507 -422 332 -249 492 z m -15 196 b 0 197 -10 197 -5 197 b 74 163 27 197 56 184 b 98 99 91 145 98 121 b 55 17 98 67 83 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -65 187 z"
        },
        fermataBelow: {
            x_min: -324,
            x_max: 324,
            y_min: -353,
            y_max: 0,
            ha: 353,
            o: "m -453 -2 b -445 0 -451 -1 -448 0 b -429 -7 -439 0 -433 -3 b -422 -33 -424 -12 -423 -15 b 0 -365 -414 -221 -231 -365 b 63 -362 33 -365 39 -365 b 422 -33 265 -338 415 -201 b 429 -7 423 -15 424 -12 b 445 0 433 -2 439 0 b 465 -14 453 0 462 -5 b 467 -31 466 -17 467 -23 b 463 -87 467 -46 465 -68 b 35 -507 434 -319 259 -490 b -1 -508 23 -508 11 -508 b -459 -112 -228 -508 -419 -345 b -467 -31 -464 -85 -467 -51 b -465 -14 -467 -23 -466 -17 b -453 -2 -463 -9 -458 -4 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
        },
        fermataLongAbove: {
            x_min: -286,
            x_max: 286,
            y_min: 0,
            y_max: 364,
            ha: 364,
            o: "m -399 523 b 0 524 -395 524 -392 524 l 395 524 l 399 523 b 411 511 404 521 409 516 b 412 262 412 507 412 507 b 412 141 412 213 412 173 b 406 7 412 -8 412 12 b 390 0 402 2 396 0 b 382 2 387 0 385 1 b 370 14 377 4 372 9 b 368 183 368 17 368 18 l 368 350 l 0 350 l -368 350 l -368 183 b -370 14 -368 18 -368 17 b -390 0 -373 5 -381 0 b -411 14 -399 0 -407 5 b -412 262 -412 17 -412 139 b -411 511 -412 385 -412 508 b -399 523 -409 516 -403 521 z m -15 196 b 0 197 -10 197 -5 197 b 75 163 27 197 56 184 b 98 99 91 145 98 121 b 56 17 98 67 84 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -64 187 z"
        },
        fermataLongBelow: {
            x_min: -286,
            x_max: 286,
            y_min: -364,
            y_max: 0,
            ha: 364,
            o: "m -399 -2 b -391 0 -396 -1 -393 0 b -370 -14 -382 0 -373 -6 b -368 -184 -368 -18 -368 -18 l -368 -350 l 0 -350 l 368 -350 l 368 -184 b 370 -14 368 -18 368 -18 b 390 0 373 -5 382 0 b 411 -14 399 0 407 -5 b 412 -262 412 -17 412 -140 b 411 -511 412 -385 412 -508 b 399 -523 409 -516 404 -521 l 395 -524 l 0 -524 l -395 -524 l -399 -523 b -411 -511 -404 -521 -409 -516 b -412 -262 -412 -508 -412 -385 b -411 -14 -412 -140 -412 -17 b -399 -2 -409 -9 -404 -4 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
        },
        fermataVeryLongAbove: {
            x_min: -286,
            x_max: 286,
            y_min: 0,
            y_max: 438,
            ha: 438,
            o: "m -399 629 b 0 631 -395 631 -392 631 l 395 631 l 399 629 b 411 617 404 627 409 622 b 412 315 412 614 412 465 b 411 14 412 166 412 17 b 390 0 407 5 399 0 b 370 14 382 0 373 5 b 368 237 368 17 368 18 l 368 456 l 0 456 l -368 456 l -368 237 b -370 14 -368 18 -368 17 b -390 0 -373 5 -382 0 b -411 14 -399 0 -407 5 b -412 315 -412 17 -412 166 b -411 617 -412 465 -412 614 b -399 629 -409 622 -404 627 z m -290 384 b 3 385 -287 385 -141 385 b 289 384 145 385 287 385 b 301 372 294 382 300 377 b 303 193 303 369 303 281 b 301 14 303 105 303 17 b 281 0 298 5 290 0 b 265 7 275 0 270 2 b 259 80 260 12 259 4 b 259 130 259 94 259 111 l 259 243 l 0 243 l -259 243 l -259 130 b -259 80 -259 111 -259 94 b -265 7 -259 4 -260 12 b -281 0 -270 2 -275 0 b -301 14 -290 0 -298 5 b -303 193 -303 17 -303 105 b -301 372 -303 281 -303 369 b -290 384 -300 376 -294 382 z m -15 196 b 0 197 -10 197 -5 197 b 74 163 27 197 56 184 b 98 99 91 145 98 121 b 55 17 98 67 83 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -65 187 z"
        },
        fermataVeryLongBelow: {
            x_min: -286,
            x_max: 286,
            y_min: -438,
            y_max: 0,
            ha: 438,
            o: "m -399 -2 b -391 0 -396 -1 -393 0 b -370 -14 -382 0 -373 -6 b -368 -237 -368 -18 -368 -18 l -368 -456 l 0 -456 l 368 -456 l 368 -237 b 370 -14 368 -18 368 -18 b 390 0 373 -5 382 0 b 411 -14 399 0 407 -5 b 412 -316 412 -17 412 -166 b 411 -617 412 -465 412 -614 b 399 -629 409 -622 404 -628 l 395 -631 l 0 -631 l -395 -631 l -399 -629 b -411 -617 -404 -628 -409 -622 b -412 -316 -412 -614 -412 -465 b -411 -14 -412 -166 -412 -17 b -399 -2 -409 -9 -404 -4 z m -290 -2 b -281 0 -287 -1 -284 0 b -261 -14 -272 0 -264 -6 b -259 -130 -259 -18 -259 -19 l -259 -243 l 0 -243 l 259 -243 l 259 -130 b 259 -81 259 -111 259 -94 b 265 -7 259 -5 260 -13 b 281 0 270 -2 275 0 b 301 -14 290 0 298 -5 b 303 -193 303 -17 303 -105 b 301 -372 303 -281 303 -369 b 289 -384 300 -377 294 -382 b 0 -385 287 -385 143 -385 b -289 -384 -143 -385 -287 -385 b -301 -372 -294 -382 -300 -377 b -303 -193 -303 -369 -303 -281 b -301 -14 -303 -105 -303 -17 b -290 -2 -300 -9 -294 -4 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
        },
        fermataVeryShortAbove: {
            x_min: -351,
            x_max: 351,
            y_min: 0,
            y_max: 571,
            ha: 571,
            o: "m -9 820 b 0 822 -6 821 -3 822 b 8 820 3 822 6 821 b 35 785 15 818 17 815 b 68 733 45 770 59 747 b 98 684 76 720 90 698 b 146 606 107 670 128 635 b 193 532 164 578 185 544 b 227 477 200 519 216 495 b 313 337 277 396 301 358 b 362 260 321 325 343 290 b 406 188 380 230 400 197 b 436 140 412 179 425 157 b 505 25 500 37 505 30 b 505 22 505 24 505 23 b 491 2 505 13 499 5 b 450 0 488 1 469 0 b 409 2 431 0 412 1 b 382 37 403 4 400 7 b 350 89 373 52 358 75 b 319 138 342 102 328 124 b 271 216 311 152 289 187 b 225 290 253 244 232 278 b 191 345 217 302 202 327 b 104 485 142 424 117 464 b 8 639 73 534 24 613 b -21 686 -2 655 -15 676 b -33 704 -27 696 -33 704 b -44 686 -33 704 -38 696 b -73 639 -51 676 -64 655 b -170 485 -89 614 -133 543 b -203 430 -177 472 -192 448 b -290 290 -253 351 -277 311 b -337 216 -298 278 -319 244 b -385 138 -355 187 -376 152 b -415 89 -393 124 -407 102 b -448 37 -424 75 -438 52 b -474 2 -466 7 -468 4 b -483 0 -477 1 -480 0 b -505 22 -495 0 -505 9 b -505 25 -505 23 -505 24 b -436 140 -505 30 -500 37 b -406 188 -425 157 -412 179 b -362 260 -400 197 -380 230 b -313 337 -343 290 -321 325 b -227 477 -301 358 -277 396 b -193 532 -216 495 -200 519 b -146 606 -185 544 -164 578 b -98 684 -128 635 -107 670 b -68 733 -90 697 -76 720 b -35 785 -59 747 -45 770 b -9 820 -17 814 -14 818 z m -36 506 b -28 508 -33 507 -30 508 b -12 502 -22 508 -16 506 b 280 30 -8 498 278 36 b 281 22 281 28 281 25 b 268 2 281 14 276 5 b 226 0 265 1 246 0 b 185 2 207 0 188 1 b 58 199 178 4 182 -1 b -60 389 -7 304 -60 389 b -178 199 -60 389 -114 304 b -305 2 -302 -1 -298 4 b -314 0 -308 1 -311 0 b -336 22 -326 0 -336 10 b -334 30 -336 25 -335 27 b -43 502 -332 36 -46 498 b -36 506 -41 504 -38 506 z m -56 196 b -41 197 -51 197 -46 197 b 33 163 -14 197 15 184 b 57 99 50 145 57 121 b 15 17 57 67 43 36 b -41 0 -3 5 -22 0 b -139 99 -92 0 -139 40 b -56 196 -139 148 -105 187 z"
        },
        fermataVeryShortBelow: {
            x_min: -351,
            x_max: 351,
            y_min: -571,
            y_max: 0,
            ha: 571,
            o: "m 9 -820 b 0 -822 6 -821 3 -822 b -8 -820 -3 -822 -6 -821 b -35 -785 -15 -818 -17 -815 b -68 -733 -45 -770 -59 -747 b -98 -684 -76 -720 -90 -698 b -146 -606 -107 -670 -128 -635 b -193 -532 -164 -578 -185 -544 b -227 -477 -200 -519 -216 -495 b -313 -337 -277 -396 -301 -358 b -362 -260 -321 -325 -343 -290 b -406 -188 -380 -230 -400 -197 b -436 -140 -412 -179 -425 -157 b -505 -25 -500 -37 -505 -30 b -505 -22 -505 -24 -505 -23 b -491 -2 -505 -13 -499 -5 b -450 0 -488 -1 -469 0 b -409 -2 -431 0 -412 -1 b -382 -37 -403 -4 -400 -7 b -350 -89 -373 -52 -358 -75 b -319 -138 -342 -102 -328 -124 b -271 -216 -311 -152 -289 -187 b -225 -290 -253 -244 -232 -278 b -191 -345 -217 -302 -202 -327 b -104 -485 -142 -424 -117 -464 b -8 -639 -73 -534 -24 -613 b 21 -686 2 -655 15 -676 b 33 -704 27 -696 33 -704 b 44 -686 33 -704 38 -696 b 73 -639 51 -676 64 -655 b 170 -485 89 -614 133 -543 b 203 -430 177 -472 192 -448 b 290 -290 253 -351 277 -311 b 337 -216 298 -278 319 -244 b 385 -138 355 -187 376 -152 b 415 -89 393 -124 407 -102 b 448 -37 424 -75 438 -52 b 474 -2 466 -7 468 -4 b 483 0 477 -1 480 0 b 505 -22 495 0 505 -9 b 505 -25 505 -23 505 -24 b 436 -140 505 -30 500 -37 b 406 -188 425 -157 412 -179 b 362 -260 400 -197 380 -230 b 313 -337 343 -290 321 -325 b 227 -477 301 -358 277 -396 b 193 -532 216 -495 200 -519 b 146 -606 185 -544 164 -578 b 98 -684 128 -635 107 -670 b 68 -733 90 -697 76 -720 b 35 -785 59 -747 45 -770 b 9 -820 17 -814 14 -818 z m 36 -506 b 28 -508 33 -507 30 -508 b 12 -502 22 -508 16 -506 b -280 -30 8 -498 -278 -36 b -281 -22 -281 -28 -281 -25 b -268 -2 -281 -14 -276 -5 b -226 0 -265 -1 -246 0 b -185 -2 -207 0 -188 -1 b -58 -199 -178 -4 -182 1 b 60 -389 7 -304 60 -389 b 178 -199 60 -389 114 -304 b 305 -2 302 1 298 -4 b 314 0 308 -1 311 0 b 336 -22 326 0 336 -10 b 334 -30 336 -25 335 -27 b 43 -502 332 -36 46 -498 b 36 -506 41 -504 38 -506 z m 56 -196 b 41 -197 51 -197 46 -197 b -33 -163 14 -197 -15 -184 b -57 -99 -50 -145 -57 -121 b -15 -17 -57 -67 -43 -36 b 41 0 3 -5 22 0 b 139 -99 92 0 139 -40 b 56 -196 139 -148 105 -187 z"
        },
        fermataShortAbove: {
            x_min: -286,
            x_max: 286,
            y_min: 0,
            y_max: 469,
            ha: 469,
            o: "m -9 674 b 0 676 -6 675 -3 676 b 15 670 6 676 11 674 b 74 576 17 667 37 637 b 233 319 105 526 176 410 b 373 92 290 227 353 125 b 411 30 393 59 410 31 b 412 23 412 27 412 25 b 398 2 412 14 407 5 b 357 0 396 1 376 0 b 316 2 338 0 319 1 b 250 100 309 4 309 4 b 91 357 220 150 148 266 b -22 541 35 449 -17 532 b -33 558 -28 550 -33 558 b -42 544 -33 558 -37 551 b -137 389 -47 536 -89 467 b -240 223 -185 312 -231 237 b -382 2 -387 -16 -374 4 b -390 0 -385 1 -387 0 b -412 22 -402 0 -412 9 l -412 22 b -375 90 -412 29 -412 29 b -253 286 -285 236 -269 261 b -182 402 -244 301 -212 354 b -34 641 -127 491 -64 593 b -9 674 -17 668 -15 672 z m -15 196 b -1 197 -10 197 -5 197 b 74 163 27 197 56 184 b 98 99 90 145 98 121 b 55 17 98 67 83 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -65 187 z"
        },
        fermataShortBelow: {
            x_min: -286,
            x_max: 286,
            y_min: -469,
            y_max: 0,
            ha: 469,
            o: "m -399 -2 b -390 0 -396 -1 -393 0 b -375 -6 -385 0 -379 -3 b -316 -100 -373 -9 -353 -39 b -157 -358 -285 -150 -214 -266 b -43 -541 -100 -449 -49 -532 b -33 -558 -38 -550 -33 -558 b -24 -544 -32 -558 -28 -552 b 20 -473 -19 -536 1 -505 b 72 -390 39 -442 62 -405 b 143 -274 81 -375 113 -322 b 291 -35 198 -185 261 -83 b 316 -2 308 -8 310 -4 b 357 0 319 -1 338 0 b 399 -2 377 0 396 -1 b 412 -23 407 -5 412 -14 b 411 -30 412 -25 412 -27 b 392 -62 410 -31 402 -46 b 355 -122 382 -78 365 -105 b 253 -287 345 -138 299 -212 b 152 -451 207 -361 162 -435 b 76 -573 142 -467 108 -522 b 4 -676 16 -671 13 -676 b 0 -676 3 -676 1 -676 b -4 -676 -1 -676 -3 -676 b -74 -576 -13 -676 -16 -671 b -233 -319 -105 -526 -176 -411 b -373 -92 -290 -227 -353 -125 b -411 -30 -393 -59 -410 -31 b -412 -23 -412 -27 -412 -25 b -399 -2 -412 -14 -407 -5 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
        },
        breathMarkComma: {
            x_min: 0,
            x_max: 168,
            y_min: -155,
            y_max: 155,
            ha: 311,
            o: "m 96 223 b 107 224 100 224 103 224 b 236 104 164 224 218 174 b 242 55 240 88 242 71 b 66 -209 242 -42 175 -144 b 33 -224 48 -219 39 -224 b 25 -219 30 -224 28 -222 b 23 -213 24 -216 23 -215 b 36 -199 23 -208 28 -204 b 130 -56 96 -166 130 -110 b 111 8 130 -34 124 -12 l 110 10 l 100 11 b 6 82 58 12 19 42 b 0 117 2 94 0 105 b 96 223 0 170 40 217 z"
        },
        breathMarkUpbow: {
            x_min: -125,
            x_max: 125,
            y_min: 0,
            y_max: 409,
            ha: 409,
            o: "m -171 588 b -130 589 -168 589 -166 589 l -123 589 b -83 585 -87 589 -88 589 b -23 385 -80 581 -84 594 b 34 193 8 280 34 193 b 91 385 34 193 60 280 b 149 580 122 491 148 579 b 164 590 151 586 157 590 b 179 580 170 590 176 586 b 180 577 179 579 180 579 b 99 292 180 569 169 533 b 13 6 18 16 15 6 b 13 6 13 6 13 6 b 12 5 13 6 13 6 b 0 0 9 2 5 0 b -16 11 -7 0 -13 4 b -180 573 -25 41 -180 570 b -171 588 -180 580 -177 586 z"
        },
        caesura: {
            x_min: 0,
            x_max: 457,
            y_min: -202,
            y_max: 303,
            ha: 504,
            o: "m 423 434 b 431 436 426 435 428 436 b 453 414 443 436 453 426 b 452 406 453 411 453 409 b 37 -284 450 401 41 -281 b 23 -290 33 -289 28 -290 b 0 -268 11 -290 0 -281 b 1 -261 0 -266 0 -263 b 416 430 3 -256 413 427 b 423 434 418 431 421 433 z m 627 434 b 636 436 630 435 633 436 b 658 414 648 436 658 426 b 657 406 658 411 658 409 b 242 -284 655 401 245 -281 b 227 -290 238 -289 232 -290 b 205 -268 216 -290 205 -281 b 206 -261 205 -266 205 -263 b 621 430 208 -256 618 427 b 627 434 623 431 625 433 z"
        },
        caesuraCurved: {
            x_min: 0,
            x_max: 370,
            y_min: -207,
            y_max: 310,
            ha: 517,
            o: "m 291 447 b 296 447 293 447 294 447 b 328 410 314 447 328 431 b 328 403 328 408 328 406 b 325 384 328 401 326 392 b 44 -284 299 206 196 -38 b 22 -298 38 -293 30 -298 b 7 -291 16 -298 11 -296 b 0 -278 2 -287 0 -283 b 11 -251 0 -272 3 -264 b 262 409 146 -12 245 246 b 291 447 264 433 273 444 z m 496 447 b 501 447 498 447 499 447 b 533 410 519 447 533 431 b 533 403 533 408 533 406 b 530 384 532 401 531 392 b 248 -284 504 206 401 -38 b 226 -298 242 -293 234 -298 b 211 -291 221 -298 216 -296 b 205 -278 207 -287 205 -283 b 215 -251 205 -272 208 -264 b 466 409 351 -12 449 246 b 496 447 469 433 477 444 z"
        },
        restMaxima: {
            x_min: 0,
            x_max: 853,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m 0 0 l 0 360 l 205 360 l 409 360 l 409 0 l 409 -360 l 205 -360 l 0 -360 z m 819 0 l 819 360 l 1023 360 l 1228 360 l 1228 0 l 1228 -360 l 1023 -360 l 819 -360 z"
        },
        restDoubleWhole: {
            x_min: 0,
            x_max: 284,
            y_min: 0,
            y_max: 250,
            ha: 250,
            o: "m 0 180 l 0 360 l 205 360 l 409 360 l 409 180 l 409 0 l 205 0 l 0 0 z"
        },
        restWhole: {
            x_min: 0,
            x_max: 330,
            y_min: -125,
            y_max: 0,
            ha: 125,
            o: "m 0 -90 l 0 0 l 237 0 l 475 0 l 475 -90 l 475 -180 l 237 -180 l 0 -180 z"
        },
        restWholeLegerLine: {
            x_min: 0,
            x_max: 542,
            y_min: -125,
            y_max: 11,
            ha: 137,
            o: "m 9 15 b 427 17 11 16 226 17 b 771 15 603 17 769 16 b 780 0 777 13 780 6 b 771 -15 780 -6 777 -13 b 698 -16 768 -16 760 -16 l 628 -16 l 628 -98 l 628 -180 l 390 -180 l 153 -180 l 153 -98 l 153 -16 l 83 -16 b 10 -15 21 -16 12 -16 b 0 0 3 -13 0 -6 b 9 15 0 6 3 12 z"
        },
        restHalf: {
            x_min: 0,
            x_max: 330,
            y_min: 0,
            y_max: 125,
            ha: 125,
            o: "m 0 90 l 0 180 l 237 180 l 475 180 l 475 90 l 475 0 l 237 0 l 0 0 z"
        },
        restHalfLegerLine: {
            x_min: 0,
            x_max: 542,
            y_min: -11,
            y_max: 125,
            ha: 137,
            o: "m 153 98 l 153 180 l 390 180 l 628 180 l 628 98 l 628 16 l 698 16 b 771 15 760 16 769 16 b 781 0 777 13 781 6 b 771 -15 781 -6 777 -13 b 427 -17 769 -16 603 -17 b 9 -15 226 -17 11 -16 b 0 0 3 -12 0 -6 b 4 12 0 4 1 8 b 58 16 9 16 5 16 b 83 16 65 16 73 16 l 153 16 z"
        },
        restQuarter: {
            x_min: 0,
            x_max: 221,
            y_min: -365,
            y_max: 365,
            ha: 730,
            o: "m 50 524 b 56 526 52 525 54 526 b 74 516 62 526 67 523 b 96 497 78 513 88 504 b 118 478 105 489 115 481 b 181 423 143 456 154 447 b 311 305 302 317 311 310 b 310 302 311 304 310 303 b 310 299 310 301 310 300 b 298 278 310 295 310 294 b 234 132 268 233 245 181 b 222 39 226 100 222 69 b 306 -177 222 -46 251 -123 b 319 -198 318 -190 319 -191 b 303 -214 319 -208 313 -214 b 291 -212 299 -214 295 -213 b 260 -208 281 -209 270 -208 b 155 -260 221 -208 181 -227 b 122 -353 133 -287 122 -320 b 185 -490 122 -400 143 -450 b 197 -510 193 -498 197 -505 b 191 -521 197 -514 195 -517 b 181 -526 188 -524 185 -526 b 136 -495 173 -526 161 -517 b 0 -270 48 -420 0 -340 l 0 -270 l 0 -253 l 2 -243 b 157 -146 19 -182 78 -146 b 217 -152 176 -146 196 -148 l 228 -155 l 226 -152 b 124 -62 223 -150 168 -101 b 19 37 23 27 19 31 b 19 39 19 38 19 39 l 19 40 b 29 59 19 46 19 47 b 117 312 87 138 117 229 b 53 489 117 382 96 446 b 41 509 42 500 41 503 b 50 524 41 516 44 521 z"
        },
        rest8th: {
            x_min: 0,
            x_max: 258,
            y_min: -197,
            y_max: 219,
            ha: 416,
            o: "m 98 315 b 110 316 102 315 106 316 b 177 293 132 316 159 307 b 218 207 204 271 218 239 b 191 137 218 182 209 157 l 187 132 l 193 134 b 326 260 251 150 302 198 b 331 270 328 264 330 269 b 349 279 336 276 343 279 b 371 257 360 279 371 270 b 213 -273 371 253 216 -267 b 194 -283 209 -280 202 -283 b 173 -270 185 -283 176 -279 b 172 -265 172 -268 172 -268 b 230 -62 172 -257 180 -228 b 289 134 263 46 289 134 b 289 134 289 134 289 134 b 280 128 289 134 285 131 b 149 84 241 98 194 84 b 39 121 108 84 69 96 b 0 204 13 142 0 173 b 31 282 0 232 10 260 b 98 315 48 300 69 311 z"
        },
        rest16th: {
            x_min: 0,
            x_max: 331,
            y_min: -443,
            y_max: 219,
            ha: 662,
            o: "m 205 315 b 216 316 208 315 212 316 b 283 293 239 316 265 307 b 324 207 310 271 324 239 b 298 137 324 182 316 157 l 293 132 l 299 134 b 433 260 358 150 409 198 b 438 270 434 264 437 269 b 455 279 443 276 449 279 b 477 257 467 279 477 270 b 213 -627 477 253 216 -621 b 194 -638 209 -635 202 -638 b 173 -625 185 -638 176 -634 b 172 -620 172 -623 172 -622 b 230 -417 172 -612 180 -583 b 289 -221 263 -309 289 -221 b 289 -221 289 -221 289 -221 b 280 -227 289 -221 285 -223 b 149 -271 241 -256 194 -271 b 39 -234 108 -271 69 -259 b 0 -150 13 -213 0 -182 b 31 -73 0 -123 10 -95 b 110 -39 52 -50 81 -39 b 207 -100 149 -39 188 -60 b 218 -147 214 -114 218 -131 b 191 -218 218 -173 209 -199 l 187 -223 l 193 -221 b 326 -96 251 -205 302 -157 b 395 134 328 -91 395 133 b 395 134 395 134 395 134 b 387 128 395 134 391 131 b 256 84 347 98 301 84 b 145 121 215 84 175 96 b 106 204 119 142 106 173 b 137 282 106 232 116 260 b 205 315 155 300 176 311 z"
        },
        rest32nd: {
            x_min: 0,
            x_max: 405,
            y_min: -443,
            y_max: 466,
            ha: 909,
            o: "m 311 670 b 322 670 315 670 318 670 b 390 647 345 670 371 662 b 431 562 417 626 431 594 b 404 492 431 536 422 511 l 400 487 l 406 488 b 539 614 464 504 515 552 b 544 625 541 619 543 623 b 562 633 549 631 555 633 b 584 612 573 633 584 625 b 213 -627 584 607 216 -621 b 194 -638 209 -635 202 -638 b 173 -625 185 -638 176 -634 b 172 -620 172 -623 172 -622 b 230 -417 172 -612 180 -583 b 289 -221 263 -309 289 -221 b 289 -221 289 -221 289 -221 b 280 -227 289 -221 285 -223 b 149 -271 241 -256 194 -271 b 39 -234 108 -271 69 -259 b 0 -150 13 -213 0 -182 b 31 -73 0 -123 10 -95 b 110 -39 52 -50 81 -39 b 207 -100 149 -39 188 -60 b 218 -147 214 -114 218 -131 b 191 -218 218 -173 209 -199 l 187 -223 l 193 -221 b 326 -96 251 -205 302 -157 b 395 134 328 -91 395 133 b 395 134 395 134 395 134 b 387 128 395 134 391 131 b 256 84 347 98 301 84 b 145 121 215 84 175 96 b 106 204 119 142 106 173 b 137 282 106 232 116 260 b 216 315 159 304 187 315 b 314 255 255 315 295 294 b 324 208 321 240 324 224 b 298 137 324 182 315 156 l 293 132 l 299 134 b 432 258 357 149 409 198 b 502 489 434 264 502 487 b 502 489 502 489 502 489 b 493 483 502 489 498 486 b 362 438 454 453 407 438 b 251 475 321 438 282 451 b 213 559 226 496 213 528 b 243 636 213 587 223 615 b 311 670 261 655 282 665 z"
        },
        rest64th: {
            x_min: 0,
            x_max: 479,
            y_min: -689,
            y_max: 466,
            ha: 1155,
            o: "m 417 670 b 429 670 421 670 425 670 b 496 647 451 670 478 662 b 537 562 523 626 537 594 b 510 492 537 536 529 511 l 506 487 l 512 488 b 646 614 570 504 621 552 b 651 625 647 619 650 623 b 668 633 655 631 662 633 b 690 612 679 633 690 625 b 213 -982 690 607 216 -976 b 194 -993 209 -989 202 -993 b 173 -979 185 -993 176 -988 b 172 -974 172 -978 172 -977 b 230 -771 172 -966 180 -938 b 289 -575 263 -664 289 -575 b 289 -575 289 -575 289 -575 b 280 -582 289 -575 285 -578 b 149 -626 241 -611 194 -626 b 39 -589 108 -626 69 -613 b 0 -505 13 -568 0 -537 b 31 -428 0 -477 10 -449 b 110 -394 52 -405 81 -394 b 207 -454 149 -394 188 -415 b 218 -502 214 -469 218 -485 b 191 -572 218 -528 209 -553 l 187 -577 l 193 -576 b 326 -451 251 -560 302 -512 b 395 -221 328 -446 395 -222 b 395 -221 395 -221 395 -221 b 387 -227 395 -221 391 -223 b 256 -271 347 -256 301 -271 b 145 -234 215 -271 175 -259 b 106 -150 119 -213 106 -182 b 137 -73 106 -123 116 -95 b 216 -39 159 -50 187 -39 b 314 -100 255 -39 295 -60 b 324 -147 321 -114 324 -131 b 298 -218 324 -173 315 -199 l 293 -223 l 299 -221 b 432 -96 357 -205 409 -157 b 502 134 434 -91 502 133 b 502 134 502 134 502 134 b 493 128 502 134 498 131 b 362 84 454 98 407 84 b 251 121 321 84 282 96 b 213 204 226 142 213 173 b 243 282 213 232 223 260 b 322 315 265 304 294 315 b 420 255 362 315 401 294 b 431 208 427 240 431 224 b 404 137 431 182 422 156 l 400 132 l 406 134 b 539 258 463 149 515 198 b 608 489 541 264 608 487 b 608 489 608 489 608 489 b 599 483 608 489 604 486 b 468 438 560 453 513 438 b 358 475 428 438 388 451 b 319 559 332 496 319 528 b 350 636 319 587 329 615 b 417 670 368 655 388 665 z"
        },
        rest128th: {
            x_min: 0,
            x_max: 553,
            y_min: -689,
            y_max: 712,
            ha: 1401,
            o: "m 524 1024 b 535 1025 527 1025 531 1025 b 603 1002 558 1025 584 1016 b 644 916 630 981 644 949 b 617 846 644 891 635 866 l 612 841 l 619 843 b 752 969 677 859 728 907 b 757 979 754 973 756 978 b 775 988 762 985 768 988 b 797 966 786 988 797 980 b 213 -982 797 962 216 -976 b 194 -993 209 -989 202 -993 b 173 -979 185 -993 176 -988 b 172 -974 172 -978 172 -977 b 230 -771 172 -966 180 -938 b 289 -575 263 -664 289 -575 b 289 -575 289 -575 289 -575 b 280 -582 289 -575 285 -578 b 149 -626 241 -611 194 -626 b 39 -589 108 -626 69 -613 b 0 -505 13 -568 0 -537 b 31 -428 0 -477 10 -449 b 110 -394 52 -405 81 -394 b 207 -454 149 -394 188 -415 b 218 -502 214 -469 218 -485 b 191 -572 218 -528 209 -553 l 187 -577 l 193 -576 b 326 -451 251 -560 302 -512 b 395 -221 328 -446 395 -222 b 395 -221 395 -221 395 -221 b 387 -227 395 -221 391 -223 b 256 -271 347 -256 301 -271 b 145 -234 215 -271 175 -259 b 106 -150 119 -213 106 -182 b 137 -73 106 -123 116 -95 b 216 -39 159 -50 187 -39 b 314 -100 255 -39 295 -60 b 324 -147 321 -114 324 -131 b 298 -218 324 -173 315 -199 l 293 -223 l 299 -221 b 432 -96 357 -205 409 -157 b 502 134 434 -91 502 133 b 502 134 502 134 502 134 b 493 128 502 134 498 131 b 362 84 454 98 407 84 b 251 121 321 84 282 96 b 213 204 226 142 213 173 b 243 282 213 232 223 260 b 322 315 265 304 294 315 b 420 255 362 315 401 294 b 431 208 427 240 431 224 b 404 137 431 182 422 156 l 400 132 l 406 134 b 539 258 463 149 515 198 b 608 489 541 264 608 487 b 608 489 608 489 608 489 b 599 483 608 489 604 486 b 468 438 560 453 513 438 b 358 475 428 438 388 451 b 319 559 332 496 319 528 b 350 636 319 587 329 615 b 429 670 372 659 400 670 b 526 610 468 670 507 649 b 537 563 534 595 537 579 b 511 492 537 536 528 511 l 506 487 l 512 488 b 645 613 570 504 621 553 b 715 843 647 618 715 842 b 715 843 715 843 715 843 b 706 837 714 843 711 841 b 575 793 667 808 620 793 b 464 830 534 793 495 805 b 426 914 439 851 426 882 b 456 991 426 941 436 969 b 524 1024 474 1010 495 1020 z"
        },
        dynamicPiano: {
            x_min: -39,
            x_max: 378,
            y_min: -178,
            y_max: 277,
            ha: 455,
            o: "m 197 399 b 208 399 201 399 205 399 b 305 314 255 399 298 362 l 306 308 l 312 315 b 405 382 339 346 376 373 b 430 386 413 385 421 386 b 494 362 451 386 474 378 b 544 249 526 336 544 296 b 377 -30 544 116 475 1 b 334 -37 362 -34 347 -37 b 291 -25 316 -37 300 -33 b 281 -17 289 -23 285 -20 b 240 43 262 -1 248 20 b 237 52 238 47 237 52 b 237 53 237 52 237 53 b 198 -74 236 53 229 30 b 159 -207 166 -181 159 -202 b 160 -209 159 -208 160 -208 b 194 -221 165 -213 179 -218 b 206 -224 198 -222 204 -224 b 217 -240 213 -226 217 -233 b 208 -255 217 -246 214 -252 b 81 -257 206 -256 144 -257 b -46 -255 18 -257 -44 -256 b -56 -240 -52 -252 -56 -246 b -51 -229 -56 -236 -54 -232 b -33 -222 -48 -225 -46 -225 b 29 -191 9 -213 24 -206 b 174 291 34 -177 173 286 b 176 303 174 294 175 299 b 178 317 177 308 178 313 b 163 336 178 329 173 336 b 157 336 161 336 159 336 b 70 239 124 326 90 288 b 56 224 65 225 63 224 b 46 233 49 224 46 227 b 49 248 46 237 47 242 b 149 376 70 302 105 347 b 161 385 154 379 160 383 b 197 399 168 391 184 397 z m 399 318 b 389 320 396 320 393 320 b 318 285 370 320 340 306 b 302 263 306 273 304 270 b 297 253 301 260 299 256 b 273 176 296 250 288 226 l 251 104 l 252 97 b 266 51 253 81 258 64 b 296 29 274 39 288 29 b 298 29 297 29 297 29 b 309 34 299 30 304 32 b 429 230 370 62 420 144 b 431 256 430 240 431 249 b 399 318 431 289 421 307 z"
        },
        dynamicMezzo: {
            x_min: 35,
            x_max: 493,
            y_min: -19,
            y_max: 272,
            ha: 291,
            o: "m 191 390 b 206 392 196 391 201 392 b 282 350 235 392 265 376 b 291 331 285 345 291 333 b 292 330 291 330 292 330 b 297 337 292 330 294 331 b 329 371 306 350 317 362 b 339 380 332 374 336 377 b 376 392 347 388 361 392 b 434 372 395 392 418 385 b 463 331 447 362 461 341 b 464 330 463 330 463 330 b 469 337 464 330 466 331 b 501 371 478 350 489 362 b 511 380 504 374 508 377 b 548 392 519 388 533 392 b 606 372 567 392 589 385 b 641 295 628 354 641 323 b 633 260 641 282 639 270 b 576 69 631 256 576 72 b 574 59 576 68 575 63 b 573 47 573 55 573 51 b 585 25 573 35 577 25 b 586 26 585 25 585 25 b 684 127 621 30 664 74 b 699 145 690 143 692 145 b 709 135 706 145 709 142 b 696 98 709 128 705 116 b 595 -12 672 47 640 12 b 582 -20 590 -15 584 -19 b 552 -27 573 -25 563 -27 b 481 18 524 -27 495 -10 b 470 63 474 31 470 47 b 478 98 470 76 473 88 b 535 289 480 102 535 285 b 537 298 535 290 536 294 b 538 311 538 303 538 307 b 522 339 538 324 533 333 b 516 341 519 340 517 341 b 507 337 514 341 512 340 b 468 282 491 329 470 300 b 462 261 467 276 464 264 b 422 133 461 259 444 203 b 380 2 383 1 384 4 l 378 0 l 333 0 b 321 0 329 0 324 0 b 283 5 284 0 286 0 b 282 8 282 6 282 7 b 322 149 282 15 288 37 b 363 289 344 224 363 287 b 365 299 364 292 364 296 b 367 311 366 303 367 307 b 350 339 367 324 361 333 b 344 341 347 340 346 341 b 336 337 342 341 340 340 b 296 282 319 329 298 300 b 290 261 295 276 292 264 b 251 133 289 259 272 203 b 208 2 211 1 212 4 l 206 0 l 161 0 b 149 0 157 0 152 0 b 111 5 112 0 114 0 b 110 8 110 6 110 7 b 150 149 110 15 116 37 b 191 289 172 224 191 287 b 193 299 192 292 193 296 b 195 311 194 303 195 307 b 179 338 195 323 189 333 b 171 340 176 339 174 340 b 150 333 166 340 160 338 b 75 240 120 318 92 283 b 60 224 69 225 67 224 b 50 233 53 224 50 227 b 53 248 50 237 51 242 b 162 378 75 306 117 355 b 170 383 164 379 168 381 b 191 390 176 386 183 389 z"
        },
        dynamicForte: {
            x_min: -87,
            x_max: 440,
            y_min: -182,
            y_max: 415,
            ha: 597,
            o: "m 486 597 b 491 597 487 597 489 597 b 515 596 499 597 512 597 b 528 595 517 596 523 595 b 631 522 576 591 622 559 b 633 506 632 516 633 511 b 559 433 633 466 598 433 b 532 439 550 433 541 435 b 493 499 506 450 493 475 b 518 548 493 517 501 536 b 519 550 519 549 519 549 b 519 550 519 550 519 550 b 496 537 518 550 504 542 b 371 353 445 503 399 436 b 367 341 369 347 367 341 b 407 341 367 341 385 341 b 414 341 410 341 412 341 b 459 335 452 341 451 341 b 468 314 465 330 468 322 b 459 293 468 306 465 298 b 411 286 451 287 453 286 b 399 286 407 286 404 286 l 353 286 l 351 279 b 174 -146 320 120 253 -41 b -24 -262 120 -218 45 -262 b -28 -262 -25 -262 -26 -262 b -125 -165 -83 -260 -125 -217 b -122 -140 -125 -157 -124 -148 b -53 -89 -113 -106 -83 -89 b 17 -142 -23 -89 8 -107 b 19 -158 18 -147 19 -153 b -13 -214 19 -181 7 -202 b -16 -217 -15 -216 -16 -216 b -16 -217 -16 -217 -16 -217 b -10 -215 -15 -217 -13 -216 b 80 -130 25 -205 58 -173 b 102 -74 88 -115 93 -102 b 186 245 126 -3 146 72 b 196 285 191 267 196 285 b 196 285 196 285 196 285 b 151 286 196 286 192 286 b 98 290 103 286 102 287 b 83 314 88 296 83 305 b 98 338 83 323 88 332 b 157 341 102 341 102 341 l 211 341 l 215 353 b 486 597 264 491 372 588 z"
        },
        dynamicRinforzando: {
            x_min: 58,
            x_max: 357,
            y_min: 0,
            y_max: 275,
            ha: 275,
            o: "m 383 395 b 401 396 389 395 395 396 b 508 352 446 396 495 377 b 515 327 513 344 515 336 b 490 285 515 310 506 293 b 465 278 482 280 474 278 b 423 301 450 278 434 286 b 365 332 408 322 386 332 b 299 281 335 332 307 314 b 296 272 298 277 297 273 b 294 266 295 271 294 269 b 291 260 293 264 292 261 b 252 133 290 259 273 201 b 210 2 213 1 214 4 l 207 0 l 163 0 b 150 0 158 0 154 0 b 112 5 113 0 115 0 b 111 8 112 6 111 7 b 152 149 111 15 118 37 b 193 289 174 225 192 287 b 195 300 193 292 194 296 b 197 315 196 305 197 310 b 175 344 197 331 189 342 b 170 344 173 344 172 344 b 109 316 149 344 127 334 b 95 306 100 306 99 306 b 84 316 88 306 84 310 b 87 325 84 319 85 322 b 149 372 99 341 127 363 b 211 388 168 381 197 388 b 215 388 213 388 214 388 b 283 349 245 385 267 372 b 285 345 284 347 285 345 b 285 345 285 345 285 345 b 291 350 286 345 288 347 b 383 395 316 374 349 390 z"
        },
        dynamicSforzando: {
            x_min: 52,
            x_max: 278,
            y_min: -22,
            y_max: 270,
            ha: 292,
            o: "m 259 388 b 271 388 263 388 267 388 b 370 362 305 388 338 379 b 396 338 385 354 391 348 b 401 315 399 331 401 323 b 359 261 401 290 384 266 b 349 260 356 260 352 260 b 300 306 322 260 300 282 b 305 327 300 313 302 320 b 308 332 307 330 308 332 b 308 332 308 332 308 332 b 287 334 308 334 297 334 b 269 333 279 334 272 334 b 220 300 245 329 226 316 b 219 295 219 299 219 297 b 273 232 219 278 243 249 b 301 215 289 223 295 219 b 373 95 347 181 373 136 b 361 49 373 79 369 63 b 219 -32 332 -4 277 -32 b 101 7 179 -32 138 -19 b 75 51 84 19 75 34 b 85 82 75 61 78 71 b 129 106 94 98 112 106 b 164 92 142 106 154 102 b 178 59 173 83 178 71 b 170 34 178 50 175 42 l 166 29 l 168 28 b 203 22 178 24 190 22 b 226 25 211 22 219 23 b 275 68 253 31 275 52 b 274 75 275 70 274 73 b 217 132 264 98 249 114 b 122 262 161 163 127 210 b 122 270 122 265 122 267 b 259 388 122 329 184 384 z"
        },
        dynamicZ: {
            x_min: 23,
            x_max: 309,
            y_min: 2,
            y_max: 250,
            ha: 248,
            o: "m 124 360 b 222 360 125 360 168 360 b 435 359 312 360 434 360 b 445 344 442 356 445 350 b 440 331 445 339 444 335 b 314 227 438 330 382 283 b 190 124 247 172 191 125 l 188 123 l 201 123 b 205 123 202 123 204 123 b 268 101 231 123 249 117 b 320 79 284 88 305 79 b 326 80 322 79 324 79 b 340 93 330 81 334 84 b 342 97 341 96 342 97 b 342 98 342 98 342 98 b 340 97 342 98 341 97 b 330 96 336 96 333 96 b 294 134 311 96 294 113 b 295 142 294 136 294 139 b 340 176 299 163 320 176 b 371 163 351 176 363 172 b 383 124 380 154 383 139 b 359 60 383 100 375 74 b 322 30 350 51 329 35 b 239 3 295 12 266 3 b 179 21 218 3 197 9 b 117 39 161 33 138 39 b 86 35 106 39 95 38 b 67 23 79 32 76 31 b 49 14 58 15 55 14 b 33 30 39 14 33 21 b 38 42 33 34 34 38 b 73 72 41 46 60 62 b 303 262 80 77 299 258 b 303 262 303 262 303 262 b 246 263 303 262 277 263 b 146 261 203 263 150 262 b 102 239 131 259 117 252 b 88 231 94 232 92 231 b 85 230 87 230 86 230 b 69 246 76 230 69 237 l 69 247 l 69 252 l 92 302 b 116 355 104 330 115 354 b 124 360 118 357 122 359 z"
        },
        ornamentTrill: {
            x_min: -249,
            x_max: 249,
            y_min: 0,
            y_max: 376,
            ha: 376,
            o: "m -92 502 b -29 542 -33 541 -33 542 b -21 534 -25 542 -21 539 b -70 366 -21 532 -65 383 l -71 364 l -47 364 b 125 383 13 366 71 372 b 149 387 136 386 143 387 b 167 382 156 387 160 385 b 181 370 171 380 179 373 b 182 370 181 370 181 370 b 230 380 185 370 195 372 b 304 394 286 393 290 394 b 305 394 305 394 305 394 b 357 353 330 394 349 379 b 359 336 358 349 359 342 b 354 314 359 326 357 316 b 257 291 352 312 263 291 b 257 291 257 291 257 291 b 250 299 252 292 250 294 b 251 305 250 301 250 303 b 251 314 251 308 251 311 b 234 350 251 329 245 343 l 230 353 l 224 349 b 169 287 202 334 183 313 b 127 156 163 276 166 286 b 88 37 92 43 91 39 b -8 15 84 35 -4 15 b -8 15 -8 15 -8 15 b -14 22 -12 16 -14 17 b -8 47 -14 26 -12 33 b -2 69 -5 59 -2 69 b -2 69 -2 69 -2 69 b -45 44 -2 69 -22 58 b -122 4 -102 10 -105 9 b -151 0 -132 1 -142 0 b -256 105 -208 0 -256 46 b -255 119 -256 110 -256 114 b -223 231 -254 129 -256 121 b -195 325 -208 282 -195 325 b -195 325 -195 325 -195 325 b -198 325 -196 325 -196 325 b -274 324 -206 325 -237 325 b -340 324 -310 324 -329 324 b -354 325 -351 324 -353 324 b -359 332 -357 326 -359 329 b -356 338 -359 334 -358 336 b -308 351 -355 340 -353 340 l -261 361 l -222 362 l -182 363 l -168 411 b -152 461 -160 438 -153 460 b -92 502 -152 462 -125 480 z m 62 348 b 57 349 60 349 59 349 b 40 346 55 349 51 348 b -62 330 8 339 -30 333 b -83 321 -84 329 -82 330 b -115 211 -83 318 -93 283 b -148 88 -149 94 -148 99 b -148 87 -148 88 -148 88 b -123 53 -148 67 -137 53 b -113 55 -120 53 -117 54 b 18 133 -111 57 17 132 b 46 227 19 134 46 225 b 53 251 46 231 48 239 b 78 334 57 261 78 331 b 62 348 78 340 71 347 z"
        },
        ornamentTurn: {
            x_min: -310,
            x_max: 310,
            y_min: -143,
            y_max: 143,
            ha: 286,
            o: "m -272 205 b -264 206 -270 206 -267 206 b -202 198 -249 206 -221 202 b 44 48 -119 177 -37 127 b 261 -91 117 -24 191 -71 b 307 -100 285 -97 297 -100 b 318 -99 311 -100 314 -99 b 401 2 362 -92 396 -51 b 402 11 401 5 402 8 b 321 87 402 58 366 87 b 258 70 301 87 279 81 b 221 60 246 63 233 60 b 157 125 186 60 157 86 b 213 194 157 158 175 179 b 277 206 234 202 256 206 b 437 90 348 206 413 162 b 447 24 444 69 447 47 b 365 -163 447 -46 416 -120 b 257 -206 331 -192 297 -206 b 178 -192 233 -206 207 -201 b -47 -48 101 -168 28 -121 b -250 86 -116 20 -180 62 b -312 99 -275 94 -295 99 b -361 83 -331 99 -346 94 b -402 6 -388 65 -402 36 b -349 -77 -402 -28 -384 -62 b -314 -85 -337 -82 -326 -85 b -260 -70 -297 -85 -280 -80 b -224 -60 -247 -63 -235 -60 b -188 -71 -211 -60 -199 -64 b -160 -126 -169 -84 -160 -105 b -189 -181 -160 -147 -169 -168 b -272 -204 -211 -195 -242 -204 b -293 -202 -279 -204 -286 -203 b -447 -6 -385 -189 -447 -103 b -435 68 -447 18 -443 43 b -280 204 -411 141 -349 196 b -272 205 -277 205 -273 205 z"
        },
        ornamentTurnSlash: {
            x_min: -310,
            x_max: 310,
            y_min: -201,
            y_max: 201,
            ha: 402,
            o: "m -10 288 b -2 289 -7 289 -4 289 b 19 276 8 289 16 284 b 21 171 21 272 21 271 l 21 71 l 43 49 b 261 -90 120 -26 191 -71 b 307 -100 285 -97 297 -100 b 318 -99 311 -100 314 -99 b 401 2 362 -91 396 -50 b 402 12 402 5 402 8 b 321 87 402 58 367 87 b 258 70 301 87 280 82 b 221 60 246 63 233 60 b 157 125 187 60 157 86 b 214 194 157 158 175 180 b 277 206 235 202 256 206 b 431 106 342 206 402 169 b 447 24 442 82 447 54 b 443 -24 447 9 446 -7 b 258 -206 423 -127 344 -206 b 257 -206 258 -206 258 -206 b 23 -109 190 -205 102 -169 l 21 -107 l 21 -190 b 21 -223 21 -203 21 -214 b 14 -283 21 -282 20 -277 b -1 -289 10 -287 5 -289 b -22 -276 -10 -289 -18 -284 b -23 -171 -23 -272 -23 -271 l -23 -71 l -46 -49 b -250 86 -119 22 -179 62 b -312 99 -275 95 -295 99 b -360 84 -330 99 -345 94 b -401 7 -388 66 -401 36 b -349 -77 -401 -28 -383 -62 b -314 -85 -337 -82 -326 -85 b -260 -69 -297 -85 -279 -80 b -223 -60 -247 -63 -235 -60 b -177 -81 -206 -60 -190 -67 b -159 -125 -165 -93 -159 -109 b -188 -180 -159 -147 -169 -168 b -268 -203 -212 -196 -240 -203 b -376 -165 -306 -203 -345 -190 b -447 -7 -425 -124 -447 -65 b -293 202 -447 86 -390 180 b -260 206 -283 204 -272 206 b -25 109 -194 206 -105 170 l -23 107 l -23 189 b -22 276 -23 271 -23 272 b -10 288 -20 281 -15 286 z"
        },
        ornamentMordent: {
            x_min: -296,
            x_max: 296,
            y_min: -215,
            y_max: 198,
            ha: 413,
            o: "m -11 284 b -3 285 -9 285 -6 285 b 17 273 5 285 14 280 b 19 164 19 270 19 269 l 19 59 l 68 118 b 118 179 98 155 117 178 b 131 182 122 181 127 182 b 143 179 136 182 140 181 b 307 18 145 177 232 92 l 326 -1 l 356 36 b 404 81 393 81 393 81 l 404 81 b 426 59 417 81 426 71 b 424 50 426 56 426 53 b 236 -179 421 44 241 -176 b 224 -182 233 -181 228 -182 b 211 -178 219 -182 215 -181 b 119 -89 210 -178 169 -137 b 29 0 70 -40 30 0 b 29 0 29 0 29 0 b 24 -6 29 0 27 -3 l 19 -12 l 19 -152 b 19 -218 19 -179 19 -200 b 13 -303 19 -308 19 -298 b -3 -310 9 -308 3 -310 b -23 -297 -11 -310 -19 -305 b -25 -180 -24 -294 -24 -294 l -25 -66 l -70 -121 b -118 -178 -99 -156 -116 -177 b -131 -182 -122 -181 -127 -182 b -144 -178 -135 -182 -140 -181 b -307 -18 -145 -177 -233 -91 l -326 1 l -356 -36 b -404 -81 -393 -81 -393 -81 l -404 -81 b -426 -59 -417 -81 -426 -71 b -424 -50 -426 -56 -426 -53 b -236 179 -421 -44 -241 176 b -224 182 -233 181 -228 182 b -211 179 -219 182 -215 181 b -48 18 -209 177 -116 86 l -29 0 l -27 2 l -25 5 l -25 137 b -23 272 -25 267 -25 268 b -11 284 -21 277 -16 282 z"
        },
        ornamentShortTrill: {
            x_min: -296,
            x_max: 296,
            y_min: -127,
            y_max: 127,
            ha: 253,
            o: "m -231 181 b -225 182 -229 182 -227 182 b -211 179 -220 182 -215 181 b -119 89 -210 178 -169 137 b -29 0 -70 40 -30 0 b 44 88 -29 0 4 40 b 118 179 89 144 117 178 b 131 182 122 181 127 182 b 143 179 136 182 140 181 b 307 18 145 177 232 92 l 326 -1 l 356 36 b 404 81 393 81 393 81 l 404 81 b 426 59 417 81 426 71 b 424 50 426 56 426 53 b 236 -179 421 44 241 -176 b 224 -182 233 -181 228 -182 b 211 -178 219 -182 215 -181 b 119 -89 210 -178 169 -137 b 29 0 70 -40 30 0 b -44 -88 29 0 -4 -40 b -118 -179 -89 -144 -117 -178 b -131 -182 -122 -181 -127 -182 b -144 -178 -135 -182 -140 -181 b -307 -18 -145 -177 -233 -91 l -326 1 l -356 -36 b -404 -81 -393 -81 -393 -81 l -404 -81 b -426 -59 -417 -81 -426 -71 b -424 -50 -426 -56 -426 -53 b -236 179 -421 -44 -241 176 b -231 181 -235 179 -233 181 z"
        },
        ornamentTremblement: {
            x_min: -419,
            x_max: 419,
            y_min: -127,
            y_max: 127,
            ha: 253,
            o: "m -409 181 b -402 182 -407 182 -404 182 b -389 179 -397 182 -392 181 b -297 89 -387 178 -346 137 b -207 0 -248 40 -207 0 l -207 0 b -134 88 -206 0 -174 40 b -59 179 -88 144 -61 178 b -46 182 -55 181 -51 182 b -34 179 -42 182 -37 181 b 58 89 -33 178 9 137 b 148 0 107 40 148 0 l 148 0 b 221 88 148 0 181 40 b 296 179 267 144 294 178 b 308 182 300 181 304 182 b 321 179 313 182 317 181 b 485 18 323 177 409 92 l 503 -1 l 533 36 b 581 81 570 81 570 81 l 582 81 b 604 59 594 81 604 71 b 602 50 604 56 603 53 b 414 -179 599 44 418 -176 b 401 -182 410 -181 406 -182 b 388 -178 397 -182 392 -181 b 297 -89 387 -178 346 -137 b 207 0 248 -40 207 0 l 207 0 b 134 -88 206 0 174 -40 b 59 -179 88 -144 61 -178 b 46 -182 55 -181 51 -182 b 34 -178 42 -182 37 -181 b -58 -89 33 -178 -9 -137 b -148 0 -107 -40 -148 0 l -148 0 b -221 -88 -148 0 -181 -40 b -296 -179 -267 -144 -294 -178 b -308 -182 -300 -181 -304 -182 b -321 -178 -313 -182 -317 -181 b -485 -18 -323 -177 -411 -91 l -503 1 l -533 -36 b -581 -81 -570 -81 -570 -81 l -582 -81 b -604 -59 -594 -81 -604 -71 b -602 -50 -604 -56 -603 -53 b -414 179 -599 -44 -418 176 b -409 181 -412 179 -410 181 z"
        },
        ornamentPrecompAppoggTrill: {
            x_min: -419,
            x_max: 419,
            y_min: -127,
            y_max: 255,
            ha: 381,
            o: "m -591 365 b -582 367 -588 366 -585 367 b -561 352 -573 367 -564 361 b -560 176 -560 351 -560 303 l -559 2 l -527 41 b -456 128 -509 63 -477 102 b -414 177 -435 154 -416 176 b -400 182 -411 181 -405 182 b -388 179 -396 182 -392 181 b -296 89 -387 178 -346 137 b -206 0 -247 40 -207 0 b -133 88 -206 0 -173 40 b -59 179 -88 144 -60 178 b -46 182 -55 181 -50 182 b -33 179 -41 182 -37 181 b 58 89 -32 178 9 137 b 148 0 108 40 148 0 l 148 0 b 221 88 149 0 182 40 b 296 179 267 144 295 178 b 309 182 300 181 304 182 b 321 179 313 182 318 181 b 485 18 323 177 410 92 l 503 -1 l 533 36 b 581 81 570 81 571 81 l 582 81 b 604 59 595 81 604 71 b 602 50 604 56 603 53 b 414 -179 599 44 419 -176 b 402 -182 410 -181 406 -182 b 389 -178 397 -182 393 -181 b 297 -89 388 -178 346 -137 b 207 0 248 -40 207 0 l 207 0 b 134 -88 207 0 174 -40 b 59 -179 89 -144 61 -178 b 47 -182 56 -181 51 -182 b 34 -178 42 -182 38 -181 b -58 -89 33 -178 -8 -137 b -148 0 -107 -40 -147 0 b -220 -88 -148 0 -181 -40 b -295 -179 -266 -144 -294 -178 b -308 -182 -299 -181 -303 -182 b -321 -178 -312 -182 -317 -181 b -484 -18 -322 -177 -426 -76 l -503 1 l -535 -38 b -570 -79 -558 -67 -567 -77 b -582 -83 -573 -81 -578 -83 b -602 -70 -590 -83 -598 -78 l -604 -67 l -604 141 l -604 349 l -603 353 b -591 365 -601 358 -596 363 z"
        },
        ornamentPrecompSlideTrillDAnglebert: {
            x_min: -433,
            x_max: 433,
            y_min: -243,
            y_max: 127,
            ha: 370,
            o: "m -388 181 b -382 182 -386 182 -384 182 b -368 179 -377 182 -372 181 b -277 89 -367 178 -326 137 b -187 0 -227 40 -187 0 l -187 0 b -114 88 -186 0 -153 40 b -39 179 -68 144 -40 178 b -26 182 -35 181 -30 182 b -14 179 -22 182 -17 181 b 78 89 -12 178 29 137 b 168 0 127 40 168 0 b 241 88 169 0 201 40 b 316 179 287 144 314 178 b 329 182 320 181 324 182 b 341 179 333 182 337 181 b 505 18 343 177 430 92 l 523 -1 l 553 36 b 601 81 590 81 590 81 l 602 81 b 624 59 614 81 624 71 b 622 50 624 56 623 53 b 434 -179 619 44 439 -176 b 421 -182 430 -181 426 -182 b 409 -178 417 -182 412 -181 b 317 -89 407 -178 366 -137 b 227 0 268 -40 227 0 b 154 -88 227 0 194 -40 b 79 -179 108 -144 81 -178 b 67 -182 75 -181 71 -182 b 54 -178 62 -182 58 -181 b -38 -89 53 -178 12 -137 b -128 0 -87 -40 -127 0 b -201 -88 -128 0 -161 -40 b -276 -179 -246 -144 -274 -178 b -288 -182 -279 -181 -284 -182 b -301 -178 -293 -182 -297 -181 b -393 -88 -302 -178 -343 -137 b -483 0 -442 -40 -483 0 b -483 0 -483 0 -483 0 b -505 -27 -484 0 -497 -15 b -579 -235 -554 -92 -579 -166 b -567 -315 -579 -263 -575 -290 b -564 -330 -565 -320 -564 -325 b -585 -351 -564 -342 -572 -351 b -610 -326 -598 -351 -604 -345 b -624 -235 -619 -297 -624 -267 b -547 -8 -624 -159 -597 -79 b -492 60 -538 4 -533 10 b -426 140 -472 84 -443 120 b -388 181 -396 176 -394 179 z"
        },
        ornamentPrecompSlideTrillBach: {
            x_min: -433,
            x_max: 433,
            y_min: -243,
            y_max: 198,
            ha: 442,
            o: "m 186 284 b 194 285 189 285 192 285 b 215 273 203 285 211 280 b 217 164 216 270 216 269 l 217 59 l 265 118 b 316 179 295 155 314 178 b 329 182 320 181 324 182 b 341 179 333 182 337 181 b 505 18 343 177 430 92 l 523 -1 l 553 36 b 601 81 590 81 590 81 l 602 81 b 624 59 614 81 624 71 b 622 50 624 56 623 53 b 434 -179 619 44 439 -176 b 421 -182 430 -181 426 -182 b 409 -178 417 -182 412 -181 b 317 -89 407 -178 366 -137 b 227 0 268 -40 227 0 b 227 0 227 0 227 0 b 222 -6 227 0 224 -3 l 217 -12 l 217 -152 b 217 -218 217 -179 217 -200 b 210 -303 217 -308 216 -298 b 195 -310 206 -308 201 -310 b 175 -297 187 -310 178 -305 b 173 -180 173 -294 173 -294 l 173 -66 l 127 -121 b 79 -178 99 -156 81 -177 b 67 -182 76 -181 71 -182 b 54 -178 62 -182 58 -181 b -38 -89 53 -178 12 -137 b -128 0 -87 -40 -127 0 b -201 -88 -128 0 -161 -40 b -276 -179 -246 -144 -274 -178 b -288 -182 -279 -181 -284 -182 b -301 -178 -293 -182 -297 -181 b -393 -88 -302 -178 -343 -137 b -483 0 -442 -40 -483 0 b -483 0 -483 0 -483 0 b -505 -27 -484 0 -497 -15 b -579 -235 -554 -92 -579 -166 b -567 -315 -579 -263 -575 -290 b -564 -330 -565 -320 -564 -325 b -586 -351 -564 -342 -572 -351 b -610 -326 -598 -351 -604 -345 b -624 -235 -619 -297 -624 -267 b -547 -8 -624 -159 -597 -79 b -492 60 -538 4 -533 10 b -426 140 -472 84 -443 120 b -393 179 -408 162 -395 178 b -381 182 -390 181 -385 182 b -368 179 -376 182 -372 181 b -277 89 -367 178 -326 137 b -187 0 -227 40 -187 0 l -187 0 b -114 88 -186 0 -153 40 b -39 179 -68 144 -40 178 b -26 182 -35 181 -30 182 b -14 179 -22 182 -17 181 b 150 18 -12 177 81 86 l 168 0 l 171 2 l 173 5 l 173 137 b 174 272 173 267 173 268 b 186 284 176 277 181 282 z"
        },
        ornamentPrecompTrillSuffixDandrieu: {
            x_min: -433,
            x_max: 433,
            y_min: -127,
            y_max: 244,
            ha: 370,
            o: "m 577 349 b 585 351 580 350 582 351 b 601 345 591 351 597 349 b 624 229 613 332 624 275 b 622 204 624 220 623 211 b 559 27 615 139 595 83 b 492 -60 546 6 541 0 b 426 -140 472 -84 443 -120 b 393 -179 408 -162 395 -178 b 381 -182 390 -181 385 -182 b 368 -178 376 -182 372 -181 b 277 -89 367 -178 326 -137 b 187 0 227 -40 187 0 l 187 0 b 114 -88 186 0 153 -40 b 39 -179 68 -144 40 -178 b 26 -182 35 -181 31 -182 b 13 -178 22 -182 17 -181 b -78 -89 12 -178 -29 -137 b -168 0 -127 -40 -168 0 b -241 -88 -169 0 -201 -40 b -316 -179 -287 -144 -314 -178 b -329 -182 -320 -181 -324 -182 b -341 -178 -333 -182 -337 -181 b -505 -18 -343 -177 -431 -91 l -523 1 l -553 -36 b -601 -81 -590 -81 -590 -81 l -602 -81 b -624 -59 -614 -81 -624 -71 b -622 -50 -624 -56 -623 -53 b -434 179 -619 -44 -439 176 b -421 182 -430 181 -426 182 b -409 179 -417 182 -412 181 b -317 89 -408 178 -366 137 b -227 0 -268 40 -227 0 b -154 88 -227 0 -194 40 b -79 179 -108 144 -81 178 b -66 182 -75 181 -71 182 b -54 179 -62 182 -58 181 b 38 89 -53 178 -12 137 b 128 0 87 40 127 0 b 201 88 128 0 161 40 b 276 179 246 144 274 178 b 288 182 279 181 284 182 b 301 179 293 182 297 181 b 393 88 302 178 343 137 b 483 0 442 40 483 0 b 483 0 483 0 483 0 b 505 27 484 0 497 15 b 579 235 554 92 579 166 b 567 315 579 263 575 290 b 564 330 565 321 564 326 b 577 349 564 339 568 346 z"
        },
        ornamentPrecompDoubleCadenceUpperPrefix: {
            x_min: -439,
            x_max: 439,
            y_min: -127,
            y_max: 236,
            ha: 363,
            o: "m -564 338 b -555 340 -561 339 -558 340 b -534 318 -544 340 -534 331 b -534 317 -534 318 -534 317 b -541 296 -534 311 -534 311 b -588 116 -572 236 -588 175 b -583 62 -588 98 -586 80 b -554 -21 -578 34 -566 -2 l -552 -24 l -511 26 b -430 126 -488 54 -452 99 b -386 177 -407 153 -388 176 b -372 182 -382 181 -377 182 b -360 179 -368 182 -364 181 b -268 89 -359 178 -318 137 b -178 0 -219 40 -179 0 b -105 88 -178 0 -145 40 b -30 179 -60 144 -32 178 b -18 182 -27 181 -22 182 b -5 179 -13 182 -9 181 b 86 89 -4 178 37 137 b 176 0 136 40 176 0 l 176 0 b 249 88 177 0 210 40 b 324 179 295 144 323 178 b 337 182 328 181 333 182 b 349 179 341 182 346 181 b 513 18 351 177 438 92 l 532 -1 l 562 36 b 610 81 599 81 599 81 l 610 81 b 632 59 623 81 632 71 b 630 50 632 56 631 53 b 442 -179 627 44 447 -176 b 430 -182 438 -181 434 -182 b 417 -178 425 -182 421 -181 b 325 -89 416 -178 375 -137 b 235 0 276 -40 236 0 l 235 0 b 162 -88 235 0 202 -40 b 87 -179 117 -144 89 -178 b 75 -182 84 -181 79 -182 b 62 -178 70 -182 66 -181 b -29 -89 61 -178 20 -137 b -119 0 -79 -40 -119 0 b -192 -88 -120 0 -153 -40 b -267 -179 -238 -144 -266 -178 b -280 -182 -271 -181 -275 -182 b -293 -178 -284 -182 -289 -181 b -456 -18 -294 -177 -398 -76 l -475 1 l -507 -38 b -554 -83 -543 -82 -543 -83 l -554 -83 b -576 -68 -562 -83 -568 -79 b -632 115 -613 -19 -632 46 b -593 292 -632 173 -619 233 b -564 338 -579 323 -571 335 z"
        },
        ornamentPrecompDoubleCadenceUpperPrefixTurn: {
            x_min: -439,
            x_max: 439,
            y_min: -215,
            y_max: 236,
            ha: 451,
            o: "m -564 338 b -555 340 -561 339 -558 340 b -534 318 -544 340 -534 331 b -534 317 -534 318 -534 317 b -541 296 -534 311 -534 311 b -588 116 -572 236 -588 175 b -583 62 -588 98 -586 80 b -554 -21 -578 34 -566 -2 l -552 -24 l -511 26 b -430 126 -488 54 -452 99 b -386 177 -407 153 -388 176 b -372 182 -382 181 -377 182 b -360 179 -368 182 -364 181 b -268 89 -359 178 -318 137 b -178 0 -219 40 -179 0 b -105 88 -178 0 -145 40 b -30 179 -60 144 -32 178 b -18 182 -27 181 -22 182 b -5 179 -13 182 -9 181 b 158 18 -4 177 89 86 l 177 0 l 179 2 l 181 5 l 181 137 b 183 272 181 267 181 268 b 203 285 186 280 195 285 b 218 279 209 285 214 283 b 225 164 225 273 225 284 l 225 59 l 274 118 b 324 179 304 155 323 178 b 337 182 328 181 333 182 b 349 179 341 182 346 181 b 513 18 351 177 438 92 l 532 -1 l 562 36 b 610 81 599 81 599 81 l 610 81 b 632 59 623 81 632 71 b 630 50 632 56 631 53 b 442 -179 627 44 447 -176 b 430 -182 438 -181 434 -182 b 417 -178 425 -182 421 -181 b 325 -89 416 -178 375 -137 b 235 0 276 -40 236 0 b 235 0 235 0 235 0 b 230 -6 235 0 232 -3 l 225 -12 l 225 -152 b 225 -218 225 -179 225 -200 b 219 -303 225 -308 224 -298 b 203 -310 214 -308 209 -310 b 183 -297 195 -310 187 -305 b 181 -180 182 -294 182 -294 l 181 -66 l 136 -121 b 88 -178 107 -156 89 -177 b 75 -182 84 -181 79 -182 b 62 -178 70 -182 66 -181 b -29 -89 61 -178 20 -137 b -119 0 -79 -40 -119 0 b -192 -88 -120 0 -153 -40 b -267 -179 -238 -144 -266 -178 b -280 -182 -271 -181 -275 -182 b -293 -178 -284 -182 -289 -181 b -456 -18 -294 -177 -398 -76 l -475 1 l -507 -38 b -554 -83 -543 -82 -543 -83 l -554 -83 b -576 -68 -562 -83 -568 -79 b -632 115 -613 -19 -632 46 b -593 292 -632 173 -619 233 b -564 338 -579 323 -571 335 z"
        },
        ornamentPrecompTrillLowerSuffix: {
            x_min: -439,
            x_max: 439,
            y_min: -236,
            y_max: 127,
            ha: 362,
            o: "m -437 181 b -430 182 -435 182 -433 182 b -417 179 -426 182 -420 181 b -325 89 -416 178 -375 137 b -235 0 -276 40 -235 0 l -235 0 b -162 88 -235 0 -202 40 b -87 179 -117 144 -89 178 b -75 182 -84 181 -79 182 b -62 179 -70 182 -66 181 b 29 89 -61 178 -20 137 b 119 0 79 40 119 0 b 192 88 120 0 153 40 b 267 179 238 144 266 178 b 280 182 271 181 276 182 b 292 179 284 182 289 181 b 456 18 294 177 396 77 l 475 -1 l 507 38 b 554 83 543 82 543 83 l 554 83 b 576 68 563 83 568 79 b 632 -116 613 19 632 -46 b 607 -257 632 -162 624 -210 b 571 -334 596 -287 578 -327 b 556 -340 567 -338 561 -340 b 535 -326 547 -340 538 -335 b 533 -319 534 -323 533 -321 b 541 -296 533 -314 536 -308 b 588 -117 572 -236 588 -175 b 579 -40 588 -91 585 -65 b 554 21 573 -19 563 7 l 552 24 l 511 -26 b 430 -126 488 -54 452 -99 b 386 -177 407 -153 388 -176 b 373 -182 382 -181 377 -182 b 360 -178 368 -182 364 -181 b 268 -89 359 -178 318 -137 b 178 0 219 -40 179 0 l 178 0 b 105 -88 178 0 145 -40 b 30 -179 60 -144 32 -178 b 18 -182 27 -181 22 -182 b 5 -178 13 -182 9 -181 b -86 -89 4 -178 -37 -137 b -176 0 -136 -40 -176 0 l -176 0 b -249 -88 -177 0 -210 -40 b -324 -179 -295 -144 -323 -178 b -337 -182 -328 -181 -332 -182 b -349 -178 -341 -182 -346 -181 b -513 -18 -351 -177 -439 -91 l -532 1 l -562 -36 b -610 -81 -599 -81 -599 -81 l -610 -81 b -632 -59 -623 -81 -632 -71 b -630 -50 -632 -56 -631 -53 b -442 179 -627 -44 -447 176 b -437 181 -441 179 -438 181 z"
        },
        stringsDownBow: {
            x_min: -168,
            x_max: 168,
            y_min: 0,
            y_max: 353,
            ha: 353,
            o: "m -228 506 b 3 508 -225 507 -111 508 b 228 506 114 508 225 507 b 240 494 233 504 238 499 b 242 254 241 491 242 373 b 240 14 242 135 241 16 b 220 0 237 5 228 0 b 204 6 214 0 208 2 b 198 89 198 12 198 3 b 198 145 198 104 198 123 l 198 273 l 0 273 l -198 273 l -198 145 b -198 89 -198 123 -198 104 b -204 6 -198 3 -198 12 b -220 0 -208 2 -214 0 b -240 14 -228 0 -237 5 b -242 254 -241 16 -242 135 b -240 494 -242 373 -241 491 b -228 506 -238 499 -233 504 z"
        },
        stringsUpBow: {
            x_min: -110,
            x_max: 110,
            y_min: 0,
            y_max: 277,
            ha: 277,
            o: "m -144 397 b -137 398 -142 398 -140 398 b -117 387 -129 398 -120 394 b -58 234 -116 385 -90 317 b 0 84 -26 152 0 84 b 58 234 0 84 26 152 b 117 387 90 317 116 385 b 136 398 121 395 128 398 b 158 376 147 398 158 390 l 158 370 l 89 191 b 20 11 51 93 20 12 b 0 0 16 4 8 0 b -19 11 -8 0 -16 4 b -158 375 -25 21 -158 370 b -158 376 -158 375 -158 376 b -144 397 -158 386 -153 394 z"
        },
        stringsHarmonic: {
            x_min: -82,
            x_max: 82,
            y_min: -82,
            y_max: 82,
            ha: 163,
            o: "m -19 116 b 1 118 -12 117 -6 118 b 118 0 65 118 118 63 b 114 -30 118 -10 116 -20 b -1 -118 100 -85 50 -118 b -83 -83 -30 -118 -60 -107 b -118 -1 -107 -60 -118 -30 b -19 116 -118 53 -81 105 z m 14 99 b 0 100 9 100 4 100 b -101 0 -57 100 -101 53 b -90 -45 -101 -15 -97 -30 b 0 -100 -71 -82 -36 -100 b 90 -45 36 -100 71 -82 b 101 -1 97 -30 101 -15 b 14 99 101 47 65 92 z"
        },
        pluckedSnapPizzicatoAbove: {
            x_min: -110,
            x_max: 110,
            y_min: -110,
            y_max: 205,
            ha: 315,
            o: "m -9 293 b 0 295 -6 294 -3 295 b 20 281 9 295 17 290 b 22 217 22 278 22 276 l 22 157 l 25 157 b 153 40 85 148 138 100 b 158 0 157 26 158 13 b 40 -153 158 -71 111 -135 b 0 -158 26 -157 13 -158 b -154 -40 -71 -158 -136 -111 b -158 -1 -157 -27 -158 -14 b -25 157 -158 76 -102 146 l -22 157 l -22 217 b -21 281 -22 276 -22 278 b -9 293 -19 286 -13 291 z m -22 54 b -23 112 -22 108 -22 112 b -23 112 -23 112 -23 112 b -81 80 -37 111 -65 96 b -114 1 -104 57 -114 29 b 0 -114 -114 -58 -69 -114 b 114 1 68 -114 114 -58 b 80 80 114 29 104 57 b 22 112 65 96 35 112 b 22 54 22 112 22 92 b 20 -8 22 -3 22 -5 b 0 -22 17 -17 9 -22 b -16 -16 -6 -22 -11 -20 b -22 34 -22 -10 -22 -12 b -22 54 -22 40 -22 46 z"
        },
        pluckedSnapPizzicatoBelow: {
            x_min: -110,
            x_max: 110,
            y_min: -205,
            y_max: 110,
            ha: 315,
            o: "m 9 -293 b 0 -295 6 -294 3 -295 b -20 -281 -9 -295 -17 -290 b -22 -217 -22 -278 -22 -276 l -22 -157 l -25 -157 b -153 -40 -85 -148 -138 -100 b -158 0 -157 -26 -158 -13 b -40 153 -158 71 -111 135 b 0 158 -26 157 -13 158 b 154 40 71 158 136 111 b 158 1 157 27 158 14 b 25 -157 158 -76 102 -146 l 22 -157 l 22 -217 b 21 -281 22 -276 22 -278 b 9 -293 19 -286 13 -291 z m 22 -54 b 23 -112 22 -108 22 -112 b 23 -112 23 -112 23 -112 b 81 -80 37 -111 65 -96 b 114 -1 104 -57 114 -29 b 0 114 114 58 69 114 b -114 -1 -68 114 -114 58 b -80 -80 -114 -29 -104 -57 b -22 -112 -65 -96 -35 -112 b -22 -54 -22 -112 -22 -92 b -20 8 -22 3 -22 5 b 0 22 -17 17 -9 22 b 16 16 6 22 11 20 b 22 -34 22 10 22 12 b 22 -54 22 -40 22 -46 z"
        },
        pluckedLeftHandPizzicato: {
            x_min: -155,
            x_max: 155,
            y_min: -157,
            y_max: 157,
            ha: 315,
            o: "m -9 225 b 0 227 -6 226 -3 227 b 20 213 9 227 17 221 b 22 116 22 209 22 208 l 22 22 l 114 22 b 152 22 129 22 141 22 b 218 16 218 22 212 21 b 224 0 222 11 224 6 b 210 -20 224 -9 219 -17 b 114 -22 207 -22 205 -22 l 22 -22 l 22 -116 b 22 -154 22 -131 22 -143 b 16 -220 22 -221 21 -214 b 0 -227 11 -225 6 -227 b -20 -213 -9 -227 -17 -222 b -22 -116 -22 -209 -22 -208 l -22 -22 l -114 -22 b -210 -20 -205 -22 -207 -22 b -224 0 -219 -17 -224 -9 b -218 16 -224 6 -222 11 b -152 22 -212 21 -218 22 b -114 22 -141 22 -129 22 l -22 22 l -22 116 b -20 213 -22 208 -22 209 b -9 225 -19 218 -13 223 z"
        },
        keyboardPedalPed: {
            x_min: 0,
            x_max: 782,
            y_min: -1,
            y_max: 500,
            ha: 501,
            o: "m 309 719 b 335 720 318 720 327 720 b 521 650 409 720 473 696 b 582 517 561 610 582 560 b 528 423 582 476 564 441 b 483 411 513 415 498 411 b 392 480 443 411 406 437 b 384 516 386 496 384 508 b 400 535 384 529 389 535 b 417 520 409 535 414 530 b 458 494 421 503 438 494 b 498 507 472 494 486 498 b 520 552 513 517 520 533 b 469 645 520 582 502 619 b 349 687 437 670 389 687 l 344 687 l 335 671 b 286 544 299 609 286 577 b 286 543 286 544 286 543 b 341 449 286 511 298 491 b 371 411 359 430 364 424 b 385 358 380 394 385 377 b 378 317 385 345 383 331 b 302 165 365 271 336 212 b 298 159 300 162 298 159 b 298 159 298 159 298 159 b 305 160 299 159 302 159 b 336 162 315 161 326 162 b 486 106 392 162 445 143 l 492 101 l 512 117 b 533 134 523 126 532 133 b 534 136 534 135 534 135 b 533 144 534 138 534 140 b 530 188 531 159 530 174 b 571 320 530 238 544 283 b 657 390 587 342 634 380 b 686 397 666 395 676 397 b 763 335 721 397 755 372 b 766 315 765 328 766 321 b 740 251 766 291 756 267 b 699 219 736 247 702 221 b 636 172 697 218 662 192 b 614 153 618 158 614 154 b 614 153 614 153 614 153 b 645 91 621 129 636 100 b 694 73 657 78 675 73 b 797 123 728 73 769 91 l 800 127 l 799 134 b 795 176 796 148 795 162 b 947 403 795 266 851 351 b 950 405 949 404 950 405 b 944 414 950 407 948 409 b 659 583 875 496 774 556 b 636 603 641 587 636 591 b 654 620 636 614 642 620 b 666 619 658 620 662 620 b 1113 282 884 577 1062 442 b 1126 198 1122 253 1126 225 b 954 -1 1126 87 1054 -1 b 930 1 946 -1 938 0 b 817 83 883 7 841 37 b 815 87 816 85 815 87 b 808 79 814 87 812 84 b 664 0 772 29 717 0 b 620 7 649 0 634 2 b 546 92 584 19 565 40 l 544 99 l 540 97 b 480 49 539 95 512 74 b 414 1 419 0 420 1 l 414 1 b 396 17 404 1 399 5 b 284 110 381 72 333 110 b 266 108 278 110 272 110 l 258 107 l 247 94 b 164 2 213 53 169 4 b 156 0 161 0 159 0 b 139 17 147 0 139 8 b 140 23 139 19 140 21 b 144 34 141 24 142 29 b 234 137 158 79 189 114 b 260 164 244 143 244 142 b 319 290 300 217 319 259 b 281 349 319 312 313 322 b 223 453 250 376 229 414 b 222 472 223 459 222 466 b 296 673 222 522 246 587 l 303 685 l 300 685 b 290 684 299 685 294 684 b 60 496 171 668 77 591 b 59 477 59 490 59 483 b 76 426 59 453 66 431 b 100 420 84 422 92 420 b 162 487 131 420 160 448 b 179 507 163 502 168 507 b 196 479 192 507 196 501 b 196 478 196 478 196 478 b 88 335 195 397 151 338 b 83 335 86 335 84 335 b 0 443 31 335 0 375 l 0 443 b 309 719 0 583 138 706 z m 981 361 b 976 368 978 366 977 368 b 968 362 974 368 972 366 b 872 175 908 318 872 247 b 877 131 872 160 874 145 b 943 34 887 82 914 43 b 949 34 945 34 947 34 b 1018 127 973 34 1004 75 b 1027 198 1024 151 1027 174 b 981 361 1027 253 1011 309 z m 665 338 b 657 339 662 339 660 339 b 641 336 652 339 647 338 b 614 293 635 333 622 312 b 602 221 607 274 602 246 b 604 198 602 213 603 205 b 606 191 605 193 605 191 b 608 193 606 191 607 192 b 666 238 613 197 642 219 b 695 264 690 256 691 257 b 702 290 700 272 702 281 b 665 338 702 312 688 334 z"
        },
        keyboardPedalUp: {
            x_min: 0,
            x_max: 435,
            y_min: 65,
            y_max: 500,
            ha: 435,
            o: "m 300 719 b 311 720 303 720 307 720 b 332 718 319 720 327 719 b 379 654 361 709 379 685 b 354 601 379 632 374 620 b 331 558 338 585 331 572 b 336 536 331 551 333 544 b 374 512 344 521 358 512 b 389 514 379 512 384 513 b 422 575 414 523 422 538 b 474 646 422 614 441 639 b 489 648 479 647 484 648 b 555 581 527 648 555 615 b 535 535 555 565 549 549 b 479 515 520 520 508 516 b 450 512 462 515 458 514 b 418 468 429 505 418 487 b 438 433 418 455 425 441 b 464 424 447 427 455 424 b 509 449 477 424 491 432 b 557 473 526 466 538 472 b 561 473 558 473 560 473 b 627 407 599 473 627 442 b 620 378 627 397 625 387 b 561 341 609 354 588 341 l 560 341 b 508 365 538 341 527 346 b 465 390 491 383 478 390 b 457 389 462 390 460 390 b 418 347 433 384 418 367 b 424 325 418 340 420 332 b 479 299 433 306 446 300 b 535 279 509 298 520 294 b 555 233 549 266 555 249 b 489 166 555 199 527 166 b 474 167 484 166 480 166 b 422 239 441 175 422 200 b 393 298 422 273 414 289 b 374 302 386 301 380 302 b 332 266 354 302 337 288 b 331 255 331 262 331 258 b 355 213 331 242 338 230 b 379 160 374 193 379 182 l 379 160 b 313 93 379 120 348 93 b 272 108 299 93 285 98 b 247 160 256 121 247 140 b 259 198 247 173 251 187 b 272 213 260 200 266 206 b 296 255 289 230 296 242 b 295 266 296 258 296 262 b 253 302 290 288 273 302 b 234 298 247 302 241 301 b 205 239 213 289 205 273 b 153 167 205 200 186 175 b 138 166 148 166 143 166 b 73 232 101 166 73 197 b 82 267 73 244 76 256 b 148 299 95 289 113 298 b 182 304 168 299 171 300 b 197 315 189 307 192 309 b 209 346 205 325 209 336 b 179 386 209 364 198 379 b 162 390 173 389 167 390 b 119 365 148 390 136 382 b 104 352 113 360 107 354 b 67 341 92 344 79 341 b 2 390 38 341 10 359 b 0 407 1 396 0 401 b 66 473 0 443 30 473 b 83 471 72 473 77 473 b 118 449 96 468 104 463 b 161 424 136 432 149 424 b 163 424 161 424 162 424 b 209 467 191 427 209 445 b 203 489 209 474 207 482 b 148 515 193 509 180 515 b 92 535 119 516 107 520 b 72 581 78 549 72 565 b 138 648 72 615 100 648 b 153 646 143 648 148 647 b 205 575 186 639 205 614 b 238 514 205 538 213 523 b 253 512 243 513 248 512 b 291 536 269 512 283 521 b 296 558 294 544 296 551 b 273 601 296 572 289 584 b 254 624 261 612 258 616 b 247 654 249 634 247 644 b 300 719 247 684 268 712 z m 327 475 b 313 476 322 476 318 476 b 244 407 274 476 244 443 b 252 376 244 396 247 386 b 313 338 265 350 289 338 b 375 376 338 338 362 350 b 383 407 380 386 383 396 b 327 475 383 438 361 468 z"
        },
        pictChokeCymbal: {
            x_min: 0,
            x_max: 168,
            y_min: -155,
            y_max: 155,
            ha: 311,
            o: "m 96 223 b 107 224 100 224 103 224 b 236 104 164 224 218 174 b 242 55 240 88 242 71 b 66 -209 242 -42 175 -144 b 33 -224 48 -219 39 -224 b 25 -219 30 -224 28 -222 b 23 -213 24 -216 23 -215 b 36 -199 23 -208 28 -204 b 130 -56 96 -166 130 -110 b 111 8 130 -34 124 -12 l 110 10 l 100 11 b 6 82 58 12 19 42 b 0 117 2 94 0 105 b 96 223 0 170 40 217 z"
        },
        wiggleArpeggiatoUp: {
            x_min: -8,
            x_max: 269,
            y_min: 0,
            y_max: 126,
            ha: 126,
            o: "m 103 180 b 118 181 108 181 113 181 b 223 126 151 181 184 164 b 299 69 250 100 280 78 b 311 67 303 68 307 67 b 359 90 325 67 342 75 b 376 102 372 101 372 102 l 376 102 b 388 91 383 102 388 96 b 385 84 388 88 387 86 b 322 25 379 76 342 42 b 258 0 301 8 280 0 b 153 56 226 0 192 18 b 78 112 127 81 97 103 b 65 114 74 114 70 114 b 17 91 51 114 35 106 b 1 80 5 80 5 80 l 0 80 b -11 91 -7 80 -11 85 b -9 97 -11 93 -10 95 b 55 156 -3 105 34 140 b 103 180 71 170 88 178 z"
        },
        arrowheadBlackUp: {
            x_min: 11,
            x_max: 239,
            y_min: -6,
            y_max: 269,
            ha: 275,
            o: "m 171 386 b 179 387 174 387 176 387 b 201 378 187 387 196 384 b 212 345 206 372 206 372 b 333 45 237 235 282 123 b 344 19 343 29 344 27 b 317 -8 344 2 332 -8 b 299 -3 312 -8 305 -7 b 180 30 262 19 221 30 b 74 4 144 30 108 21 b 61 -3 70 2 64 -1 b 43 -8 55 -7 48 -8 b 16 19 28 -8 16 2 b 27 45 16 27 17 29 b 148 344 78 123 122 233 b 159 378 155 373 154 372 b 171 386 161 381 167 385 z"
        },
        arrowheadBlackDown: {
            x_min: 11,
            x_max: 239,
            y_min: 6,
            y_max: 281,
            ha: 275,
            o: "m 35 403 b 43 405 37 404 40 405 b 62 398 49 405 55 403 b 79 390 65 396 73 392 b 180 367 111 374 145 367 b 298 398 221 367 262 377 b 318 404 305 402 312 404 b 344 377 332 404 344 394 b 333 351 344 369 343 367 b 212 51 282 273 237 161 b 204 23 207 28 206 26 b 180 8 199 13 189 8 b 156 23 171 8 162 13 b 150 44 154 25 153 28 b 27 351 125 158 80 271 b 16 377 17 367 16 369 b 35 403 16 389 24 400 z"
        }
    },
    fontFamily: "GonvilleSmufl",
    resolution: 1e3,
    generatedOn: "2023-04-20T22:11:26.009Z"
};
// node_modules/vexflow/build/esm/src/fonts/load_gonville.js
function $a801f2c896bd09f1$var$loadGonville() {
    $a801f2c896bd09f1$var$Font.load("Gonville", $a801f2c896bd09f1$var$GonvilleSmuflFont, $a801f2c896bd09f1$var$CommonMetrics);
}
// node_modules/vexflow/build/esm/src/fonts/leland_glyphs.js
var $a801f2c896bd09f1$var$LelandFont = {
    glyphs: {
        bracketTop: {
            x_min: 0,
            x_max: 491,
            y_min: 0,
            y_max: 279,
            ha: 279,
            o: "m 697 399 b 687 402 694 400 690 402 b 671 395 681 402 674 400 b 249 168 668 390 524 168 l 20 168 b 0 150 9 168 0 161 l 0 20 l 0 0 l 176 0 b 706 374 619 0 704 370 b 707 382 706 376 707 379 b 697 399 707 389 703 395 z"
        },
        bracketBottom: {
            x_min: 0,
            x_max: 491,
            y_min: -279,
            y_max: 0,
            ha: 279,
            o: "m 697 -399 b 707 -382 703 -395 707 -389 b 706 -374 707 -379 706 -376 b 176 0 704 -370 619 0 l 0 0 l 0 -20 l 0 -150 b 20 -168 0 -161 9 -168 l 249 -168 b 671 -395 524 -168 668 -390 b 687 -402 674 -400 681 -402 b 697 -399 690 -402 694 -400 z"
        },
        segno: {
            x_min: 0,
            x_max: 654,
            y_min: 0,
            y_max: 869,
            ha: 869,
            o: "m 546 690 l 838 1207 b 841 1215 840 1210 841 1212 b 832 1233 841 1221 837 1230 l 809 1248 b 798 1251 806 1250 801 1251 b 780 1241 792 1251 783 1247 l 487 721 l 217 860 b 99 995 147 897 99 924 b 236 1165 99 1120 179 1165 b 343 1073 288 1165 325 1130 b 454 988 357 1022 405 988 b 477 991 461 988 469 989 b 541 1076 526 1002 541 1045 b 540 1089 541 1080 541 1084 b 294 1225 534 1116 514 1225 b 0 939 72 1225 0 1053 b 125 706 0 825 42 753 l 397 563 l 104 45 b 102 35 102 42 102 37 b 111 19 102 29 107 22 l 132 3 b 144 0 135 1 141 0 b 148 0 145 0 147 0 b 161 10 153 1 158 6 l 456 531 l 704 403 b 842 256 780 361 842 318 b 706 86 842 131 763 86 b 599 177 654 86 616 120 b 488 262 585 228 537 262 b 465 259 481 262 472 261 b 402 177 418 248 402 206 b 403 163 402 171 402 167 b 649 26 409 135 429 26 b 942 312 871 26 942 199 b 821 549 942 426 901 507 z m 52 444 b 118 416 69 426 95 416 b 183 444 141 416 166 426 b 210 508 200 461 210 485 b 183 573 210 531 200 556 b 118 600 166 590 141 600 b 52 573 95 600 69 590 b 24 508 35 556 24 531 b 52 444 24 485 35 461 z m 760 730 b 825 703 778 713 802 703 b 890 730 848 703 873 713 b 917 795 907 747 917 772 b 890 861 917 818 907 844 b 825 888 873 878 848 888 b 760 861 802 888 778 878 b 733 795 743 844 733 818 b 760 730 733 772 743 747 z"
        },
        coda: {
            x_min: 0,
            x_max: 745,
            y_min: -113,
            y_max: 735,
            ha: 848,
            o: "m 924 467 b 560 896 916 697 757 881 l 560 1038 b 540 1058 560 1050 552 1058 l 524 1058 b 505 1038 513 1058 505 1050 l 505 896 b 150 467 311 877 158 693 l 20 467 b 0 446 9 467 0 458 l 0 432 b 20 412 0 420 9 412 l 150 412 b 505 0 166 193 317 17 l 505 -143 b 524 -163 505 -154 513 -163 l 540 -163 b 560 -143 552 -163 560 -154 l 560 0 b 923 412 753 13 907 190 l 1054 412 b 1073 432 1066 412 1073 420 l 1073 446 b 1054 467 1073 458 1066 467 z m 560 467 l 560 852 b 773 467 716 837 773 671 z m 505 467 l 301 467 b 505 851 301 668 357 831 z m 505 412 l 505 45 b 301 412 366 65 301 219 z m 560 412 l 772 412 b 560 45 772 215 706 60 z"
        },
        gClef: {
            x_min: 0,
            x_max: 640,
            y_min: -666,
            y_max: 1112,
            ha: 1778,
            o: "m 809 -30 b 665 -279 809 -132 768 -238 b 586 186 635 -107 596 122 b 809 -30 716 186 809 98 z m 605 -297 b 521 -305 576 -302 549 -305 b 140 56 315 -305 140 -161 b 390 498 140 232 264 389 b 459 562 415 520 438 540 b 492 357 472 484 482 416 b 272 45 361 318 272 180 b 467 -194 272 -56 351 -194 b 491 -176 478 -194 491 -189 b 459 -144 491 -163 477 -156 b 372 -1 403 -109 372 -72 b 521 177 372 86 436 157 z m 478 1184 b 632 1392 491 1241 557 1392 b 688 1223 654 1392 688 1322 b 478 863 688 1073 577 960 b 462 1037 469 920 462 976 b 478 1184 462 1090 467 1139 z m 176 -739 b 444 -959 176 -834 249 -959 b 622 -910 511 -959 570 -942 b 720 -670 700 -855 720 -760 b 697 -467 720 -613 711 -549 b 675 -338 693 -438 684 -395 b 922 3 816 -292 922 -145 b 557 367 922 220 768 367 b 516 619 543 454 528 539 b 773 1188 668 779 773 959 b 710 1477 773 1319 733 1426 b 608 1601 675 1551 634 1601 b 505 1528 598 1601 553 1584 b 387 1113 413 1418 387 1234 b 419 804 387 1035 395 965 b 312 701 418 802 343 726 b 0 117 181 579 0 405 b 503 -364 0 -153 235 -364 b 616 -354 544 -364 583 -360 b 660 -670 644 -492 660 -593 b 438 -899 660 -819 583 -899 b 370 -891 403 -899 373 -891 b 366 -887 369 -890 366 -888 b 373 -881 366 -884 369 -883 b 508 -721 441 -871 508 -814 b 341 -562 508 -644 449 -562 b 176 -739 240 -562 176 -644 z"
        },
        cClef: {
            x_min: 0,
            x_max: 627,
            y_min: -480,
            y_max: 482,
            ha: 962,
            o: "m 19 675 b 0 657 9 675 0 667 l 0 -654 b 19 -672 0 -664 9 -672 l 122 -672 b 141 -654 132 -672 141 -664 l 141 657 b 122 675 141 667 132 675 z m 903 -376 b 619 -58 903 -197 808 -58 b 505 -95 586 -58 562 -60 b 426 1 503 -89 474 -32 b 505 98 474 35 503 92 b 641 60 560 65 579 60 b 903 379 816 60 903 223 b 580 694 903 580 755 694 b 318 517 472 694 318 649 b 438 400 318 446 367 400 b 546 510 501 400 546 446 b 425 615 546 589 494 615 b 547 651 458 638 503 651 b 723 400 698 651 723 530 b 593 128 723 289 720 128 b 438 279 467 128 441 265 b 418 300 438 281 438 300 b 396 279 397 300 396 281 b 264 29 383 200 344 62 l 264 657 b 246 675 264 667 256 675 b 228 657 236 675 228 667 l 228 -654 b 246 -672 228 -664 236 -672 b 264 -654 256 -672 264 -664 l 264 -26 b 396 -278 348 -60 380 -197 b 418 -297 396 -279 397 -297 b 438 -278 438 -297 438 -279 b 593 -125 441 -262 467 -125 b 723 -397 720 -125 723 -287 b 547 -648 723 -527 698 -648 b 425 -612 503 -648 458 -635 b 441 -613 426 -612 432 -613 b 546 -507 504 -613 546 -569 b 438 -397 546 -444 501 -397 b 318 -514 367 -397 318 -444 b 580 -691 318 -647 472 -691 b 903 -376 755 -691 903 -577 z"
        },
        fClef: {
            x_min: 0,
            x_max: 664,
            y_min: -617,
            y_max: 251,
            ha: 868,
            o: "m 366 361 b 167 298 256 361 168 298 b 37 112 84 236 50 163 b 27 36 30 86 27 60 b 46 -58 27 1 33 -30 b 140 -138 63 -96 96 -124 b 194 -147 157 -144 176 -147 b 287 -122 226 -147 259 -138 b 359 10 331 -98 359 -46 b 289 134 359 60 333 107 b 206 160 259 154 230 160 b 160 153 189 160 173 157 b 109 122 145 147 121 132 b 147 215 114 150 131 192 b 219 279 163 238 194 266 b 351 308 255 300 301 308 b 570 -52 498 308 570 190 b 477 -399 570 -186 520 -314 b 310 -635 429 -494 366 -585 b 17 -837 160 -772 19 -837 b 0 -864 17 -837 0 -847 b 1 -871 0 -867 1 -868 b 27 -888 6 -886 19 -888 b 35 -887 29 -888 33 -887 b 331 -717 36 -887 200 -819 b 528 -544 405 -664 471 -606 b 661 -367 580 -488 625 -428 b 760 -50 724 -259 760 -147 b 670 239 760 69 729 168 b 366 361 602 320 500 361 z m 818 179 b 887 107 818 138 850 107 b 956 179 924 107 956 138 b 887 252 956 219 924 252 b 818 179 850 252 818 219 z m 818 -177 b 887 -251 818 -217 850 -251 b 956 -177 924 -251 956 -217 b 887 -104 956 -137 924 -104 b 818 -177 850 -104 818 -137 z"
        },
        unpitchedPercussionClef1: {
            x_min: 0,
            x_max: 352,
            y_min: -252,
            y_max: 252,
            ha: 504,
            o: "m 19 363 b 0 344 9 363 0 354 l 0 -344 b 19 -363 0 -354 9 -363 l 177 -363 b 196 -344 187 -363 196 -354 l 196 344 b 177 363 196 354 187 363 z m 330 363 b 311 344 320 363 311 354 l 311 -344 b 330 -363 311 -354 320 -363 l 488 -363 b 507 -344 498 -363 507 -354 l 507 344 b 488 363 507 354 498 363 z"
        },
        "6stringTabClef": {
            x_min: 0,
            x_max: 439,
            y_min: -743,
            y_max: 746,
            ha: 1489,
            o: "m 52 1074 l 52 958 l 249 958 l 249 419 l 387 419 l 387 958 l 583 958 l 583 1074 z m 0 -333 l 145 -333 l 192 -196 l 436 -196 l 481 -333 l 632 -333 l 396 334 l 238 334 z m 315 181 l 400 -81 l 229 -81 z m 566 -474 b 393 -402 531 -428 475 -403 l 71 -402 l 71 -1070 l 372 -1070 b 374 -1070 373 -1070 373 -1070 b 465 -1061 405 -1070 435 -1067 b 541 -1027 494 -1056 520 -1043 b 588 -975 560 -1012 575 -995 b 618 -868 608 -943 618 -907 b 592 -770 618 -829 609 -798 b 514 -711 575 -743 549 -724 b 566 -674 537 -700 554 -688 b 596 -576 586 -649 596 -616 b 566 -474 596 -536 586 -503 z m 348 -518 b 428 -528 380 -518 408 -521 b 464 -590 452 -539 464 -559 b 436 -649 464 -619 455 -638 b 366 -665 418 -661 395 -665 l 203 -665 l 203 -518 z m 367 -776 b 435 -788 396 -776 419 -780 b 477 -858 464 -801 477 -824 b 433 -942 477 -900 462 -927 b 366 -953 418 -949 395 -953 l 203 -953 l 203 -776 z"
        },
        timeSig0: {
            x_min: 15,
            x_max: 389,
            y_min: -254,
            y_max: 255,
            ha: 509,
            o: "m 291 367 b 22 0 138 367 22 209 b 291 -366 22 -209 138 -366 b 560 0 444 -366 560 -209 b 291 367 560 209 444 367 z m 376 -200 b 291 -308 376 -252 353 -308 b 206 -200 229 -308 206 -252 l 206 200 b 291 308 206 252 229 308 b 376 200 353 308 376 252 z"
        },
        timeSig1: {
            x_min: 15,
            x_max: 336,
            y_min: -243,
            y_max: 245,
            ha: 488,
            o: "m 359 -284 l 359 336 b 341 353 359 346 351 353 l 199 353 b 190 350 196 353 193 351 b 184 344 189 348 186 346 l 23 65 b 22 56 22 62 22 59 b 30 42 22 50 26 45 l 58 26 b 66 23 60 24 63 23 b 81 32 72 23 78 27 l 183 207 l 183 -284 l 73 -284 b 56 -301 63 -284 56 -291 l 56 -333 b 73 -350 56 -343 63 -350 l 468 -350 b 484 -333 478 -350 484 -343 l 484 -301 b 468 -284 484 -291 478 -284 z"
        },
        timeSig2: {
            x_min: 15,
            x_max: 377,
            y_min: -243,
            y_max: 245,
            ha: 488,
            o: "m 492 -56 b 382 -192 481 -88 452 -192 b 190 -134 288 -192 268 -134 b 153 -138 179 -134 167 -135 b 341 -36 153 -138 189 -84 b 533 173 494 12 533 86 b 288 353 533 233 505 353 b 30 156 71 353 30 222 b 138 49 30 96 79 49 b 245 156 197 49 245 96 b 179 255 245 196 216 240 b 168 271 174 256 168 264 b 202 297 168 279 176 289 b 251 304 209 300 229 304 b 311 288 271 304 294 300 b 348 180 338 271 348 245 b 65 -150 348 12 148 -24 b 22 -278 65 -150 22 -210 b 73 -350 22 -346 56 -350 b 121 -305 96 -350 121 -331 b 117 -287 121 -300 120 -294 b 105 -239 108 -266 105 -251 b 107 -226 105 -235 105 -230 b 154 -203 108 -217 120 -203 b 238 -289 196 -203 212 -252 b 350 -350 264 -327 304 -350 b 484 -264 396 -350 458 -317 b 543 -63 510 -210 543 -102 b 518 -36 543 -45 531 -36 b 492 -56 508 -36 498 -42 z"
        },
        timeSig3: {
            x_min: 15,
            x_max: 364,
            y_min: -244,
            y_max: 244,
            ha: 488,
            o: "m 392 23 b 514 168 507 68 514 143 b 514 176 514 171 514 174 b 262 351 514 189 510 351 b 22 176 14 351 22 176 l 23 176 l 22 173 b 115 81 22 121 63 81 b 207 173 167 81 207 121 b 135 264 207 215 176 255 b 140 268 137 265 138 266 b 215 289 160 282 187 289 b 340 176 275 289 340 253 b 255 69 340 85 272 72 b 140 60 238 66 157 60 b 121 40 122 60 121 40 l 121 12 b 140 -6 121 12 124 -4 b 243 -14 164 -7 197 -7 b 340 -167 307 -23 340 -66 b 215 -289 340 -264 275 -289 b 121 -266 174 -289 137 -278 b 207 -174 168 -264 207 -222 b 115 -81 207 -122 167 -81 b 22 -174 63 -81 22 -122 b 22 -180 22 -174 22 -177 b 78 -298 22 -199 26 -251 b 236 -351 134 -350 204 -351 b 524 -147 374 -351 524 -304 b 389 23 524 -42 452 3 z"
        },
        timeSig4: {
            x_min: 14,
            x_max: 442,
            y_min: -248,
            y_max: 249,
            ha: 497,
            o: "m 300 -183 l 300 -289 l 180 -289 b 160 -310 170 -289 160 -298 l 160 -337 b 180 -357 160 -348 170 -357 l 616 -357 b 636 -337 628 -357 636 -348 l 636 -310 b 616 -289 636 -298 628 -289 l 487 -289 l 487 -183 l 616 -183 b 636 -161 628 -183 636 -173 l 636 -134 b 616 -114 636 -124 628 -114 l 487 -114 l 487 115 b 477 134 487 124 482 131 l 459 143 b 452 144 456 144 455 144 b 449 144 451 144 451 144 b 436 140 445 144 439 143 l 305 20 b 300 4 301 16 300 10 l 300 -114 l 132 -114 b 464 287 132 -114 294 59 b 471 307 469 294 471 301 b 467 321 471 314 468 320 l 435 353 b 420 359 431 356 426 359 b 206 359 412 359 217 359 b 187 341 196 359 189 350 b 143 118 187 341 180 235 b 24 -124 105 1 62 -71 b 20 -140 24 -124 20 -131 b 22 -148 20 -143 20 -145 b 36 -174 26 -158 36 -174 b 52 -183 36 -174 39 -183 z"
        },
        timeSig5: {
            x_min: 15,
            x_max: 362,
            y_min: -244,
            y_max: 246,
            ha: 490,
            o: "m 39 314 b 46 170 39 314 46 245 b 46 151 46 164 46 157 b 39 -24 45 71 39 -24 b 39 -29 39 -24 39 -26 b 49 -48 39 -35 40 -46 b 99 -59 62 -50 92 -58 b 107 -59 102 -59 104 -59 b 121 -49 112 -59 118 -58 b 235 45 128 -30 144 45 b 356 -112 337 45 356 -43 b 238 -292 356 -184 333 -288 b 226 -292 233 -292 230 -292 b 166 -282 193 -292 174 -288 b 158 -274 161 -281 158 -276 b 164 -264 158 -269 160 -266 b 222 -168 177 -255 222 -239 b 117 -71 222 -98 173 -71 b 22 -171 60 -71 22 -122 b 111 -318 22 -220 36 -275 b 252 -351 147 -338 199 -351 b 456 -275 325 -351 405 -328 b 521 -109 503 -228 521 -167 b 433 79 521 -32 487 43 b 271 124 397 104 336 124 b 131 84 223 124 173 112 b 125 82 130 82 127 82 b 115 92 120 82 115 86 l 115 183 b 131 199 115 192 122 199 l 132 199 b 252 192 154 197 202 192 b 372 209 295 192 340 196 b 474 320 439 236 462 289 b 477 334 475 324 477 330 b 451 354 477 346 469 354 b 431 351 445 354 439 353 b 252 328 360 334 305 328 b 88 343 200 328 150 334 b 71 344 88 343 81 344 b 39 320 56 344 39 340 b 39 314 39 317 39 315 z"
        },
        timeSig6: {
            x_min: 15,
            x_max: 387,
            y_min: -244,
            y_max: 245,
            ha: 489,
            o: "m 356 69 b 216 22 268 69 236 43 b 209 98 212 52 209 75 b 216 167 209 121 212 141 b 338 287 225 220 261 287 b 410 259 374 287 396 275 b 356 174 380 246 356 207 b 448 82 356 122 396 82 b 541 174 500 82 541 122 l 541 177 b 541 179 541 177 541 177 b 533 225 541 192 539 213 b 310 353 514 276 454 353 b 58 163 180 353 86 229 b 22 -23 43 128 22 58 b 131 -285 22 -111 46 -210 b 318 -351 215 -348 268 -351 b 557 -125 369 -351 557 -292 b 356 69 557 16 446 69 z m 302 -291 b 216 -145 255 -291 216 -226 b 302 1 216 -65 255 1 b 390 -145 350 1 390 -65 b 302 -291 390 -226 350 -291 z"
        },
        timeSig7: {
            x_min: 15,
            x_max: 366,
            y_min: -250,
            y_max: 251,
            ha: 501,
            o: "m 233 -177 b 160 -336 202 -225 160 -282 b 180 -360 160 -351 164 -360 b 264 -351 203 -360 217 -354 b 278 -350 268 -351 274 -350 b 369 -360 320 -350 359 -360 b 405 -331 382 -360 406 -344 b 405 -327 405 -330 405 -328 b 396 -226 405 -324 396 -279 b 408 -130 396 -196 399 -161 b 503 151 425 -62 471 60 b 527 308 518 196 527 275 b 526 341 527 321 527 327 b 510 361 524 356 518 361 b 484 361 503 361 491 361 b 467 341 477 361 467 356 b 406 228 467 327 464 228 b 235 351 346 228 328 351 b 86 252 145 351 91 261 l 86 321 b 71 337 86 330 79 337 l 37 337 b 22 321 29 337 22 330 l 22 55 b 37 39 22 46 29 39 l 71 39 b 86 55 79 39 86 46 l 86 101 b 158 179 86 134 108 179 b 328 124 209 179 213 124 b 425 143 357 124 410 128 b 233 -177 413 120 266 -130 z"
        },
        timeSig8: {
            x_min: 15,
            x_max: 393,
            y_min: -248,
            y_max: 246,
            ha: 494,
            o: "m 467 26 b 547 166 514 62 547 108 b 294 354 547 269 433 354 b 40 166 154 354 40 269 b 122 13 40 108 55 56 b 22 -147 58 -24 22 -78 b 294 -357 22 -264 144 -357 b 566 -147 444 -357 566 -264 b 467 26 566 -78 541 -13 z m 294 -276 b 122 -145 202 -276 122 -226 b 197 -26 122 -49 197 -26 b 435 -187 295 -59 435 -108 b 294 -276 435 -226 384 -276 z m 386 65 b 180 209 288 96 180 144 b 294 288 180 265 232 288 b 444 180 383 288 444 246 b 386 65 444 111 412 78 z"
        },
        timeSig9: {
            x_min: 15,
            x_max: 387,
            y_min: -244,
            y_max: 245,
            ha: 489,
            o: "m 223 -68 b 363 -20 311 -68 343 -42 b 370 -96 367 -50 370 -73 b 363 -166 370 -120 367 -140 b 240 -285 354 -219 318 -285 b 168 -258 204 -285 183 -274 b 223 -173 199 -245 223 -206 b 131 -81 223 -121 183 -81 b 37 -173 79 -81 37 -121 l 37 -176 b 37 -177 37 -176 37 -176 b 46 -223 37 -190 40 -212 b 269 -351 65 -275 125 -351 b 521 -161 399 -351 492 -228 b 557 24 536 -127 557 -56 b 448 287 557 112 533 212 b 261 353 364 350 311 353 b 22 127 210 353 22 294 b 223 -68 22 -14 132 -68 z m 276 294 b 363 147 324 294 363 228 b 276 1 363 66 324 1 b 189 147 229 1 189 66 b 276 294 189 228 229 294 z"
        },
        timeSigCommon: {
            x_min: 0,
            x_max: 463,
            y_min: -256,
            y_max: 258,
            ha: 514,
            o: "m 468 258 b 406 147 432 235 406 193 b 408 130 406 141 406 135 b 521 17 415 71 462 24 b 537 17 526 17 533 17 b 667 147 609 17 667 75 b 667 156 667 147 667 151 b 664 177 667 161 665 171 b 350 372 651 239 595 372 b 0 17 36 372 0 111 b 382 -369 0 -154 22 -369 b 641 -131 524 -369 635 -285 b 629 -120 641 -124 636 -120 l 611 -120 b 599 -131 605 -120 599 -125 b 382 -323 593 -251 508 -323 b 196 -128 256 -323 196 -255 l 196 147 b 356 320 196 228 228 320 b 469 271 423 320 454 295 b 471 264 471 268 471 266 b 468 258 471 262 471 259 z"
        },
        timeSigCutCommon: {
            x_min: 0,
            x_max: 463,
            y_min: -376,
            y_max: 388,
            ha: 764,
            o: "m 611 -120 b 599 -131 605 -120 599 -125 b 382 -323 593 -251 508 -323 b 369 -323 377 -323 373 -323 l 369 320 b 469 269 428 317 455 292 b 471 264 471 266 471 265 b 468 258 471 261 471 259 b 406 147 432 235 406 193 b 408 130 406 141 406 135 b 523 17 415 71 464 24 b 537 17 527 17 533 17 b 667 147 609 17 667 75 b 667 156 667 147 667 151 b 664 177 667 161 665 171 b 369 370 651 236 598 364 l 369 543 b 353 559 369 552 361 559 l 314 559 b 298 543 305 559 298 552 l 298 369 b 0 17 32 341 0 105 b 298 -364 0 -140 17 -334 l 298 -526 b 314 -541 298 -534 305 -541 l 353 -541 b 369 -526 361 -541 369 -534 l 369 -369 b 382 -369 373 -369 377 -369 b 641 -131 524 -369 635 -285 b 629 -120 641 -124 636 -120 z m 196 147 b 298 312 196 215 216 289 l 298 -310 b 196 -128 229 -285 196 -223 z"
        },
        timeSigPlus: {
            x_min: 0,
            x_max: 408,
            y_min: -204,
            y_max: 204,
            ha: 408,
            o: "m 327 33 l 327 275 b 308 294 327 285 318 294 l 279 294 b 261 275 269 294 261 285 l 261 33 l 19 33 b 0 14 9 33 0 24 l 0 -13 b 19 -33 0 -23 9 -33 l 261 -33 l 261 -274 b 279 -294 261 -284 269 -294 l 308 -294 b 327 -274 318 -294 327 -284 l 327 -33 l 567 -33 b 588 -13 577 -33 588 -23 l 588 14 b 567 33 588 24 577 33 z"
        },
        noteheadDoubleWhole: {
            x_min: 0,
            x_max: 538,
            y_min: -178,
            y_max: 179,
            ha: 357,
            o: "m 33 258 b 20 258 27 258 26 258 b 0 238 9 258 0 249 b 0 -236 0 226 0 -226 b 20 -256 0 -246 9 -256 b 33 -256 26 -256 27 -256 b 53 -236 43 -256 53 -245 b 53 238 53 -228 53 226 b 33 258 53 249 45 258 z m 649 258 b 636 258 644 258 642 258 b 616 238 625 258 616 249 b 616 125 616 235 616 187 b 389 196 573 167 500 196 b 160 125 276 196 203 167 b 160 238 160 187 160 235 b 140 258 160 249 151 258 b 127 258 134 258 132 258 b 107 238 115 258 107 249 b 107 -236 107 226 107 -226 b 127 -256 107 -246 115 -256 b 140 -256 132 -256 134 -256 b 160 -236 150 -256 160 -245 b 160 -122 160 -233 160 -186 b 389 -194 203 -166 276 -194 b 616 -122 500 -194 573 -166 b 616 -236 616 -186 616 -233 b 636 -256 616 -246 625 -256 b 649 -256 642 -256 644 -256 b 670 -236 660 -256 670 -245 b 670 238 670 -228 670 226 b 649 258 670 249 661 258 z m 462 -140 b 400 -148 445 -144 422 -148 b 314 -101 360 -148 333 -135 b 268 68 295 -65 269 29 b 268 76 268 71 268 73 b 314 141 268 109 282 130 b 377 150 331 145 354 150 b 462 102 416 150 442 140 b 510 -66 482 63 510 -29 b 462 -140 510 -104 497 -128 z m 755 258 b 742 258 749 258 747 258 b 721 238 730 258 721 249 b 721 -236 721 226 721 -226 b 742 -256 721 -246 730 -256 b 755 -256 747 -256 749 -256 b 775 -236 765 -256 775 -245 b 775 238 775 -228 775 226 b 755 258 775 249 766 258 z"
        },
        noteheadWhole: {
            x_min: 0,
            x_max: 373,
            y_min: -134,
            y_max: 136,
            ha: 270,
            o: "m 269 196 b 0 1 71 196 0 95 b 269 -193 0 -92 71 -193 b 537 1 468 -193 537 -92 b 269 196 537 95 468 196 z m 343 -138 b 281 -147 325 -144 302 -147 b 194 -99 240 -147 213 -135 b 148 68 176 -63 150 29 b 194 141 145 107 160 130 b 256 150 212 147 235 150 b 343 102 297 150 323 141 b 389 -65 363 63 389 -29 b 343 -138 389 -102 377 -128 z"
        },
        noteheadHalf: {
            x_min: 0,
            x_max: 325,
            y_min: -133,
            y_max: 132,
            ha: 265,
            o: "m 307 190 b 0 -60 167 190 0 73 b 161 -192 0 -122 45 -192 b 468 58 311 -192 468 -69 b 307 190 468 143 396 190 z m 268 -63 b 108 -124 264 -66 158 -124 b 50 -72 60 -124 50 -85 b 200 62 50 -12 194 59 b 360 122 206 65 308 122 b 418 71 395 122 418 102 b 268 -63 418 9 272 -60 z"
        },
        noteheadBlack: {
            x_min: 0,
            x_max: 325,
            y_min: -133,
            y_max: 132,
            ha: 265,
            o: "m 0 -60 b 161 -192 0 -122 45 -192 b 468 58 311 -192 468 -69 b 307 190 468 143 396 190 b 0 -60 167 190 0 72 z"
        },
        noteheadXBlack: {
            x_min: 0,
            x_max: 325,
            y_min: -132,
            y_max: 132,
            ha: 264,
            o: "m 461 138 b 468 153 465 141 468 147 l 468 154 b 462 167 468 160 465 164 l 445 184 b 431 190 441 187 436 190 b 418 186 426 190 420 189 l 235 40 l 50 186 b 37 190 48 189 42 190 b 24 184 32 190 29 187 l 6 167 b 0 153 3 164 0 158 b 7 138 0 147 3 141 l 183 0 l 7 -138 b 0 -153 3 -141 0 -147 b 6 -166 0 -157 3 -163 l 23 -184 b 37 -190 26 -189 32 -190 b 50 -186 42 -190 48 -189 l 235 -40 l 418 -186 b 431 -190 420 -189 426 -190 b 445 -184 436 -190 442 -189 l 462 -166 b 468 -153 465 -163 468 -157 b 461 -138 468 -147 465 -141 l 285 0 z"
        },
        noteheadCircleX: {
            x_min: 0,
            x_max: 325,
            y_min: -162,
            y_max: 163,
            ha: 325,
            o: "m 265 0 l 395 105 b 426 0 415 75 426 39 b 387 -115 426 -43 412 -84 z m 233 -27 l 360 -145 b 235 -192 327 -174 282 -192 b 99 -137 183 -192 134 -171 z m 202 1 l 73 -105 b 42 0 53 -75 42 -39 b 81 115 42 43 56 84 z m 235 29 l 108 145 b 233 193 141 174 186 193 b 369 138 285 193 334 173 z m 233 235 b 0 0 104 235 0 130 b 233 -233 0 -130 104 -233 b 468 0 363 -233 468 -130 b 233 235 468 130 363 235 z"
        },
        noteheadDoubleWholeSquare: {
            x_min: 0,
            x_max: 432,
            y_min: -179,
            y_max: 177,
            ha: 356,
            o: "m 590 255 b 570 235 579 255 570 246 l 570 203 l 53 203 l 53 235 b 33 255 53 246 45 255 l 20 255 b 0 235 9 255 0 246 l 0 -230 b 20 -251 0 -242 9 -251 l 33 -251 b 53 -230 45 -251 53 -242 l 53 -200 l 570 -200 l 570 -238 b 590 -258 570 -249 579 -258 l 603 -258 b 622 -238 615 -258 622 -249 l 622 235 b 603 255 622 246 615 255 z m 570 -101 l 53 -101 l 53 105 l 570 105 z"
        },
        noteheadSquareWhite: {
            x_min: 0,
            x_max: 310,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 395 128 l 395 -128 l 52 -128 l 52 128 z m 446 180 l 0 180 l 0 -180 l 446 -180 z"
        },
        noteheadSquareBlack: {
            x_min: 0,
            x_max: 310,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 446 180 l 0 180 l 0 -180 l 446 -180 z"
        },
        noteheadTriangleUpBlack: {
            x_min: 0,
            x_max: 310,
            y_min: -136,
            y_max: 122,
            ha: 258,
            o: "m 223 176 l 0 -196 l 446 -196 z"
        },
        noteheadSlashedDoubleWhole1: {
            x_min: -66,
            x_max: 456,
            y_min: -213,
            y_max: 212,
            ha: 425,
            o: "m 652 298 b 638 305 649 304 644 305 b 626 301 634 305 629 304 l 560 248 b 543 256 557 253 550 256 b 530 256 537 256 536 256 b 510 236 518 256 510 248 b 510 204 510 235 510 223 l 455 161 b 281 194 413 181 356 194 b 53 124 168 194 96 166 b 53 236 53 186 53 233 b 29 256 53 253 42 256 b 20 256 26 256 23 256 b 0 236 9 256 0 248 b 0 -204 0 228 0 -98 l -88 -272 b -95 -288 -92 -276 -95 -282 b -91 -300 -95 -291 -94 -295 b -76 -307 -86 -304 -82 -307 b -65 -302 -72 -307 -68 -305 l 3 -248 b 20 -258 6 -253 12 -258 b 53 -238 33 -258 52 -255 b 53 -206 53 -236 53 -225 l 107 -161 b 281 -196 148 -183 206 -196 b 510 -124 393 -196 465 -166 b 510 -238 510 -187 510 -235 b 530 -258 510 -248 518 -258 b 563 -238 543 -258 563 -255 b 563 204 563 -229 563 98 l 649 272 b 657 288 655 276 657 282 b 652 298 657 291 655 295 z m 160 75 b 269 148 160 138 219 148 b 356 101 310 148 334 140 b 363 85 357 96 360 91 l 189 -56 b 160 66 174 -14 161 40 b 160 75 160 69 160 72 z m 53 -163 b 53 -124 53 -151 53 -138 b 76 -144 60 -131 68 -138 z m 402 -68 b 292 -148 402 -138 351 -148 b 207 -101 252 -150 226 -137 b 199 -84 204 -96 202 -91 l 373 56 b 402 -68 389 13 402 -40 z m 510 124 b 485 144 503 131 494 137 l 510 163 b 510 124 510 151 510 137 z"
        },
        noteheadSlashedWhole1: {
            x_min: -75,
            x_max: 448,
            y_min: -211,
            y_max: 214,
            ha: 425,
            o: "m 641 301 b 625 308 636 305 631 308 b 613 304 621 307 618 307 l 439 160 b 269 196 399 181 343 196 b 0 1 71 196 0 95 b 69 -138 0 -49 20 -101 l -101 -271 b -108 -287 -105 -275 -108 -281 b -104 -298 -107 -291 -107 -294 b -88 -304 -99 -302 -94 -304 b -76 -301 -85 -304 -81 -304 l 98 -157 b 269 -193 138 -179 194 -193 b 537 1 468 -193 537 -92 b 468 141 537 52 517 104 l 638 274 b 645 289 642 278 645 284 b 641 301 644 292 644 297 z m 148 68 b 148 78 148 72 148 75 b 194 141 148 111 163 131 b 256 150 212 147 235 150 b 343 102 297 150 323 141 b 350 86 346 98 348 92 l 177 -55 b 148 68 163 -12 150 42 z m 389 -65 b 343 -138 389 -102 377 -128 b 281 -147 325 -144 302 -147 b 194 -99 240 -147 213 -135 b 187 -82 192 -95 190 -89 l 279 -6 l 361 58 b 389 -65 376 16 389 -39 z"
        },
        noteheadSlashedHalf1: {
            x_min: -98,
            x_max: 424,
            y_min: -213,
            y_max: 212,
            ha: 425,
            o: "m 606 298 b 592 305 602 302 598 305 b 580 301 588 305 583 304 l 412 163 b 307 190 383 180 347 190 b 153 148 258 190 204 176 b 0 -60 58 98 0 13 b 14 -120 0 -81 4 -101 b 32 -143 20 -128 26 -135 l -134 -274 b -141 -288 -138 -276 -141 -282 b -137 -300 -141 -292 -140 -297 b -122 -307 -134 -304 -128 -307 b -111 -302 -118 -307 -114 -305 l 56 -164 b 161 -192 85 -181 121 -192 b 315 -151 210 -192 264 -179 b 468 58 410 -101 468 -16 b 454 117 468 78 464 98 b 436 141 449 125 444 134 l 603 272 b 611 287 608 275 611 281 b 606 298 611 291 609 295 z m 56 -98 b 49 -73 52 -91 49 -82 b 75 -23 49 -58 59 -39 b 199 60 99 1 147 32 b 337 118 251 89 302 111 b 359 121 344 120 351 121 b 361 121 360 121 360 121 l 225 9 l 69 -114 b 56 -98 65 -109 60 -104 z m 410 94 b 416 69 415 86 416 78 b 392 19 416 53 408 36 b 266 -65 367 -6 318 -36 b 128 -122 215 -94 163 -115 b 107 -125 121 -124 114 -125 b 104 -125 107 -125 105 -125 l 245 -9 l 396 111 b 410 94 402 107 408 101 z"
        },
        noteheadSlashedBlack1: {
            x_min: -98,
            x_max: 424,
            y_min: -213,
            y_max: 212,
            ha: 425,
            o: "m 606 298 b 592 305 602 302 598 305 b 580 301 588 305 583 304 l 412 161 b 307 190 383 180 347 190 b 0 -60 167 190 0 72 b 32 -144 0 -89 10 -120 l -134 -274 b -141 -288 -138 -278 -141 -284 b -137 -301 -141 -292 -140 -297 b -122 -307 -134 -305 -128 -307 b -111 -304 -118 -307 -114 -307 l 56 -164 b 161 -192 82 -181 117 -192 b 468 58 311 -192 468 -71 b 436 141 468 91 456 120 l 603 271 b 611 285 608 275 611 281 b 606 298 611 289 609 294 z"
        },
        noteheadSlashedDoubleWhole2: {
            x_min: -66,
            x_max: 456,
            y_min: -213,
            y_max: 212,
            ha: 425,
            o: "m 563 -204 b 563 236 563 -98 563 228 b 543 256 563 249 554 256 b 530 256 537 256 536 256 b 510 236 518 256 510 248 b 510 124 510 233 510 187 b 281 194 467 166 393 194 b 107 161 207 194 150 181 l 53 204 b 53 236 53 223 53 235 b 33 256 53 249 45 256 b 20 256 27 256 26 256 b 3 246 12 256 6 253 l -63 301 b -76 305 -68 304 -72 305 b -91 298 -81 305 -86 304 b -95 287 -94 295 -95 291 b -88 272 -95 281 -92 276 l 0 204 b 0 -238 0 98 0 -229 b 20 -258 0 -248 9 -258 b 33 -258 26 -258 27 -258 b 53 -238 43 -258 53 -246 b 53 -124 53 -235 53 -187 b 281 -196 96 -166 170 -196 b 456 -161 356 -196 413 -183 l 510 -206 b 510 -238 510 -225 510 -236 b 530 -258 510 -248 518 -258 b 543 -258 536 -258 537 -258 b 560 -246 549 -258 556 -252 l 626 -302 b 638 -307 631 -305 634 -307 b 654 -300 645 -307 649 -304 b 657 -288 655 -295 657 -292 b 651 -272 657 -282 655 -276 z m 207 140 b 269 148 225 144 248 148 b 356 101 310 148 336 140 b 402 -68 376 62 402 -30 b 402 -78 402 -71 402 -75 l 292 9 l 168 109 b 207 140 176 124 189 134 z m 78 144 b 53 124 69 137 60 131 b 53 163 53 137 53 150 z m 356 -141 b 294 -148 338 -145 315 -148 b 207 -101 253 -148 226 -137 b 161 66 189 -66 163 27 b 160 72 161 69 160 71 b 161 78 160 75 160 76 l 271 -9 l 395 -109 b 356 -141 387 -124 374 -134 z m 485 -144 b 510 -124 494 -138 503 -131 b 510 -163 510 -138 510 -151 z"
        },
        noteheadSlashedWhole2: {
            x_min: -75,
            x_max: 448,
            y_min: -212,
            y_max: 214,
            ha: 426,
            o: "m 468 -138 b 537 1 517 -101 537 -49 b 269 196 537 95 468 196 b 98 160 196 196 140 181 l -76 304 b -88 308 -81 307 -84 307 b -104 301 -94 308 -99 305 b -108 289 -107 297 -107 292 b -101 274 -108 284 -105 278 l 69 141 b 0 1 20 104 0 52 b 269 -193 0 -92 71 -193 b 441 -157 343 -193 399 -179 l 613 -301 b 625 -305 618 -304 622 -305 b 641 -298 631 -305 636 -302 b 645 -287 644 -294 644 -291 b 638 -271 645 -281 642 -275 z m 194 141 b 256 150 212 147 235 150 b 343 102 297 150 323 141 b 389 -65 363 63 389 -29 b 389 -76 389 -69 389 -73 l 279 10 l 156 112 b 194 141 163 125 176 135 z m 343 -138 b 281 -147 325 -144 302 -147 b 194 -99 240 -147 213 -135 b 148 68 176 -63 150 29 b 148 76 148 71 148 73 b 148 81 148 78 148 79 l 258 -6 l 382 -108 b 343 -138 374 -122 361 -132 z"
        },
        noteheadSlashedHalf2: {
            x_min: -98,
            x_max: 424,
            y_min: -213,
            y_max: 212,
            ha: 425,
            o: "m 386 -102 b 468 58 438 -55 468 4 b 454 117 468 78 464 98 b 307 190 428 164 373 190 b 153 148 258 190 204 176 b 108 120 137 140 122 130 l -111 301 b -122 305 -114 304 -118 305 b -137 298 -128 305 -134 302 b -141 287 -140 295 -141 291 b -134 272 -141 281 -138 275 l 85 101 b 0 -60 32 53 0 -7 b 14 -120 0 -81 4 -101 b 161 -192 40 -167 95 -192 b 315 -151 210 -192 264 -179 b 361 -122 333 -143 347 -132 l 580 -302 b 592 -307 583 -305 588 -307 b 606 -300 598 -307 602 -304 b 611 -288 609 -297 611 -292 b 603 -274 611 -282 608 -276 z m 199 60 b 337 118 251 89 302 111 b 359 121 344 120 351 121 b 410 94 382 121 400 112 b 416 69 415 86 416 78 b 392 19 416 53 408 36 b 308 -42 374 0 343 -20 l 245 7 l 189 55 b 199 60 192 56 196 58 z m 266 -65 b 128 -122 215 -94 163 -115 b 107 -125 121 -124 114 -125 b 56 -98 84 -125 66 -117 b 49 -73 52 -91 49 -82 b 75 -23 49 -58 59 -39 b 163 39 94 -4 125 17 l 225 -9 l 282 -56 b 266 -65 276 -59 272 -62 z"
        },
        noteheadSlashedBlack2: {
            x_min: -98,
            x_max: 424,
            y_min: -213,
            y_max: 212,
            ha: 425,
            o: "m 384 -102 b 468 58 435 -58 468 0 b 307 190 468 143 396 190 b 108 121 239 190 167 163 l -111 301 b -124 305 -115 304 -120 305 b -138 298 -128 305 -134 302 b -141 289 -140 295 -141 292 b -141 287 -141 288 -143 288 b -135 272 -141 281 -140 275 l 84 101 b 0 -60 35 56 0 0 b 161 -192 0 -122 45 -192 b 361 -122 232 -192 304 -164 l 579 -302 b 590 -307 583 -305 588 -307 b 606 -300 596 -307 602 -304 b 611 -288 609 -297 611 -292 b 603 -274 609 -282 608 -276 z"
        },
        noteheadDiamondDoubleWhole: {
            x_min: 0,
            x_max: 373,
            y_min: -178,
            y_max: 179,
            ha: 357,
            o: "m 504 258 b 484 238 494 258 484 248 l 484 46 b 282 187 415 95 285 186 b 268 192 279 190 275 192 b 255 187 262 192 258 190 l 52 45 l 52 238 b 33 258 52 248 43 258 l 20 258 b 0 238 9 258 0 248 l 0 -236 b 20 -256 0 -248 9 -256 l 33 -256 b 52 -236 43 -256 52 -248 l 52 -45 l 249 -181 b 268 -190 258 -189 264 -190 b 282 -186 274 -190 279 -189 b 484 -43 285 -184 413 -94 l 484 -236 b 504 -256 484 -248 494 -256 l 517 -256 b 537 -236 528 -256 537 -248 l 537 238 b 517 258 537 248 528 258 z m 220 -115 l 102 -33 l 317 117 l 435 35 z"
        },
        noteheadDiamondWhole: {
            x_min: 0,
            x_max: 373,
            y_min: -133,
            y_max: 132,
            ha: 265,
            o: "m 282 -187 b 530 -13 285 -186 530 -13 b 537 0 534 -10 537 -6 b 530 13 537 4 534 10 b 282 186 530 13 287 183 b 268 190 279 189 275 190 b 255 186 262 190 258 189 l 7 12 b 0 -1 3 9 0 4 b 4 -13 0 -6 1 -10 l 249 -183 b 268 -192 258 -190 264 -192 b 282 -187 274 -192 279 -190 z m 220 -117 l 102 -35 l 317 115 l 435 33 z"
        },
        noteheadDiamondHalf: {
            x_min: 0,
            x_max: 335,
            y_min: -132,
            y_max: 133,
            ha: 265,
            o: "m 475 -13 b 482 0 480 -10 482 -6 b 475 13 482 4 480 10 l 253 187 b 240 192 251 190 246 192 b 229 187 236 192 232 190 l 7 13 b 0 0 3 10 0 6 b 7 -13 0 -4 3 -10 l 229 -186 b 240 -190 232 -189 236 -190 b 253 -186 246 -190 251 -189 z m 284 -115 l 92 33 l 199 117 l 390 -33 z"
        },
        noteheadDiamondBlack: {
            x_min: 0,
            x_max: 335,
            y_min: -132,
            y_max: 133,
            ha: 265,
            o: "m 475 -14 b 482 -1 480 -10 482 -6 b 475 13 482 4 480 10 l 253 187 b 240 192 251 190 246 192 b 229 187 236 192 232 190 l 7 13 b 0 0 3 10 0 4 b 7 -14 0 -6 3 -10 l 229 -186 b 240 -190 232 -189 236 -190 b 253 -186 246 -190 251 -189 z"
        },
        noteheadParenthesisRight: {
            x_min: 0,
            x_max: 75,
            y_min: -209,
            y_max: 212,
            ha: 421,
            o: "m 10 305 b 4 302 7 304 6 304 b 0 295 1 301 0 298 b 1 289 0 294 0 292 b 68 -10 1 288 68 160 b 1 -288 68 -95 50 -192 b 0 -292 0 -289 0 -291 b 4 -300 0 -295 1 -298 b 12 -301 7 -301 9 -302 b 17 -298 14 -301 16 -300 b 108 0 22 -292 108 -174 b 17 301 108 174 22 295 b 10 305 16 304 13 305 z"
        },
        noteheadParenthesisLeft: {
            x_min: 0,
            x_max: 75,
            y_min: -212,
            y_max: 209,
            ha: 421,
            o: "m 98 -305 b 104 -302 101 -304 102 -304 b 108 -295 107 -301 108 -298 b 107 -289 108 -294 108 -292 b 40 10 107 -288 40 -160 b 107 288 40 95 58 192 b 108 292 108 289 108 291 b 104 300 108 295 107 298 b 96 301 101 301 99 302 b 91 298 94 301 92 300 b 0 0 86 292 0 174 b 91 -301 0 -174 86 -295 b 98 -305 92 -304 95 -305 z"
        },
        noteheadMoonBlack: {
            x_min: 0,
            x_max: 310,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 0 180 l 0 0 b 223 -180 0 -99 99 -180 b 446 0 347 -180 446 -99 l 446 180 z"
        },
        noteheadTriangleLeftBlack: {
            x_min: 0,
            x_max: 339,
            y_min: -136,
            y_max: 122,
            ha: 258,
            o: "m 0 176 l 0 -196 l 488 -196 z"
        },
        noteheadTriangleRightBlack: {
            x_min: 0,
            x_max: 339,
            y_min: -136,
            y_max: 122,
            ha: 258,
            o: "m 488 176 l 0 -196 l 488 -196 z"
        },
        noteheadTriangleRoundDownBlack: {
            x_min: 0,
            x_max: 310,
            y_min: -136,
            y_max: 122,
            ha: 258,
            o: "m 226 -196 l 446 63 b 226 176 446 63 384 176 b 0 63 68 176 0 63 z"
        },
        augmentationDot: {
            x_min: 0,
            x_max: 100,
            y_min: -50,
            y_max: 50,
            ha: 100,
            o: "m 0 0 b 72 -72 0 -40 32 -72 b 144 0 112 -72 144 -40 b 72 72 144 40 112 72 b 0 0 32 72 0 40 z"
        },
        tremolo1: {
            x_min: 0,
            x_max: 290,
            y_min: -93,
            y_max: 96,
            ha: 189,
            o: "m 0 48 l 0 -134 l 418 -43 l 418 138 z"
        },
        flag8thUp: {
            x_min: 0,
            x_max: 289,
            y_min: -817,
            y_max: 12,
            ha: 829,
            o: "m 0 -327 b 12 -343 0 -331 1 -338 b 291 -600 73 -363 197 -441 b 359 -827 317 -645 359 -707 b 294 -1140 359 -930 331 -1037 b 289 -1162 291 -1149 288 -1156 b 297 -1175 289 -1168 291 -1172 b 304 -1176 300 -1176 302 -1176 b 327 -1161 314 -1176 321 -1171 b 416 -798 395 -1041 418 -888 b 416 -780 416 -791 416 -786 b 302 -458 409 -595 302 -458 b 131 -220 307 -458 170 -281 b 50 -50 78 -138 53 -56 b 36 6 49 -46 36 6 b 19 17 35 12 27 17 b 0 -1 9 17 0 9 z"
        },
        flag8thDown: {
            x_min: 0,
            x_max: 309,
            y_min: -12,
            y_max: 817,
            ha: 829,
            o: "m 0 1 b 19 -17 0 -9 9 -17 b 36 -6 26 -17 35 -12 b 50 50 36 -4 49 46 b 117 196 52 56 65 111 b 331 458 173 289 259 357 b 445 780 402 559 445 654 b 338 1161 445 912 415 1021 b 317 1176 334 1171 325 1176 b 310 1175 314 1176 311 1176 b 300 1158 302 1172 300 1166 b 304 1140 300 1153 301 1146 b 384 827 361 1007 384 930 b 317 600 384 707 343 645 b 12 343 223 441 72 363 b 0 327 1 338 0 331 z"
        },
        flag16thUp: {
            x_min: 0,
            x_max: 279,
            y_min: -820,
            y_max: 12,
            ha: 832,
            o: "m 301 -681 b 148 -514 262 -631 219 -585 b 56 -372 92 -458 66 -409 b 52 -343 55 -364 53 -354 b 271 -510 125 -343 219 -442 b 340 -696 327 -583 340 -641 b 337 -739 340 -710 338 -724 b 301 -681 325 -716 312 -697 z m 0 -549 b 22 -563 0 -553 12 -559 b 258 -776 59 -576 171 -648 b 318 -950 307 -850 318 -901 b 317 -975 318 -959 318 -966 b 285 -1140 317 -1009 307 -1083 b 279 -1164 284 -1148 279 -1156 b 289 -1179 279 -1169 282 -1175 b 297 -1181 292 -1181 294 -1181 b 318 -1161 307 -1181 312 -1169 b 382 -962 344 -1120 382 -1043 b 374 -855 382 -920 379 -886 b 402 -678 389 -802 402 -749 b 333 -471 402 -603 382 -536 b 137 -228 265 -382 192 -307 b 42 0 82 -148 42 0 b 22 17 39 10 37 17 b 0 0 4 17 0 10 z"
        },
        flag16thDown: {
            x_min: 0,
            x_max: 309,
            y_min: -26,
            y_max: 803,
            ha: 829,
            o: "m 53 346 b 56 363 55 353 56 359 b 163 517 66 399 78 452 b 384 732 246 582 346 662 b 317 503 382 621 354 552 b 53 346 229 395 122 364 z m 0 -14 b 22 -37 0 -26 10 -37 b 43 -14 33 -37 40 -26 b 167 232 65 134 109 177 b 445 683 243 305 445 416 b 432 837 445 730 441 783 b 441 919 438 855 441 881 b 327 1149 441 1032 374 1112 b 304 1156 321 1153 312 1156 b 287 1152 298 1156 292 1155 b 279 1145 281 1149 279 1148 b 294 1129 279 1140 288 1135 b 382 930 344 1076 382 1027 b 374 876 382 912 380 893 l 373 871 b 373 871 373 871 373 871 b 327 789 366 842 350 815 b 22 598 226 672 86 612 b 0 559 12 593 0 562 z"
        },
        flag32ndUp: {
            x_min: 0,
            x_max: 279,
            y_min: -821,
            y_max: 186,
            ha: 1007,
            o: "m 301 -683 b 148 -516 262 -632 219 -588 b 56 -373 92 -459 66 -410 b 50 -343 55 -366 53 -354 b 271 -500 125 -343 219 -432 b 340 -687 327 -575 340 -632 b 337 -739 340 -704 338 -721 b 301 -683 325 -716 312 -698 z m 271 -259 b 340 -446 327 -333 340 -392 b 338 -469 340 -455 338 -462 b 333 -461 337 -467 334 -464 b 91 -192 265 -372 145 -271 b 50 -92 69 -160 58 -124 b 271 -259 124 -92 219 -192 z m 0 -550 b 22 -564 0 -554 12 -560 b 258 -778 59 -577 171 -649 b 318 -952 307 -851 318 -903 b 317 -976 318 -960 318 -968 b 285 -1142 317 -1011 307 -1084 b 279 -1165 284 -1149 279 -1158 b 289 -1181 279 -1171 282 -1176 b 297 -1182 292 -1182 294 -1182 b 318 -1162 307 -1182 312 -1171 b 382 -963 344 -1122 382 -1044 b 374 -857 382 -922 379 -887 b 402 -668 389 -802 402 -740 b 386 -563 402 -632 396 -596 b 402 -441 395 -526 402 -487 b 402 -428 402 -436 402 -432 b 333 -220 402 -353 382 -285 b 137 23 265 -131 192 -56 b 42 251 82 102 42 251 b 22 268 39 261 37 268 b 0 251 4 268 0 261 z"
        },
        flag32ndDown: {
            x_min: 0,
            x_max: 309,
            y_min: -216,
            y_max: 803,
            ha: 1019,
            o: "m 50 73 b 91 171 58 105 71 141 b 347 402 145 251 272 317 b 384 454 361 418 374 435 b 324 239 384 347 361 287 b 50 73 235 130 122 94 z m 163 517 b 366 693 248 589 327 642 b 382 716 372 700 377 708 b 383 693 383 708 383 700 b 314 505 383 621 359 562 b 53 343 258 436 179 390 b 56 363 55 351 56 359 b 163 517 66 400 81 449 z m 0 -288 b 22 -311 0 -298 10 -311 b 43 -288 33 -311 40 -300 b 167 -40 65 -138 109 -95 b 445 409 243 32 445 143 b 431 577 445 462 439 520 b 441 651 435 602 439 626 b 441 675 441 658 441 667 b 441 687 441 680 441 684 b 425 808 441 730 433 772 b 441 919 435 840 441 876 b 327 1149 441 1032 374 1112 b 305 1156 321 1153 314 1156 b 287 1152 300 1156 292 1155 b 279 1145 281 1149 279 1148 b 294 1129 279 1140 288 1136 b 382 930 344 1076 382 1027 b 327 789 382 877 364 832 b 22 598 226 672 86 612 b 0 559 12 593 0 562 z"
        },
        flag64thUp: {
            x_min: 0,
            x_max: 279,
            y_min: -822,
            y_max: 373,
            ha: 1195,
            o: "m 333 -461 b 91 -192 265 -372 145 -271 b 50 -92 69 -161 58 -125 b 271 -251 125 -92 219 -183 b 340 -438 327 -324 340 -383 b 338 -469 340 -448 338 -459 b 333 -461 337 -467 334 -464 z m 301 -683 b 148 -517 262 -632 219 -588 b 56 -374 92 -461 66 -410 b 50 -343 55 -366 53 -356 b 271 -501 125 -343 219 -433 b 340 -688 327 -575 340 -634 b 337 -739 340 -706 338 -721 b 301 -683 325 -717 312 -698 z m 271 10 b 340 -176 327 -63 340 -121 b 337 -217 340 -190 338 -204 b 333 -212 336 -216 334 -213 b 91 65 265 -122 145 -16 b 48 177 66 101 53 143 l 50 177 b 271 10 124 177 217 78 z m 0 -552 b 22 -564 0 -554 12 -562 b 258 -778 59 -579 171 -649 b 318 -952 307 -851 317 -903 b 317 -976 318 -960 318 -968 b 285 -1142 317 -1012 307 -1084 b 279 -1165 284 -1149 279 -1158 b 289 -1181 279 -1172 282 -1178 b 297 -1184 292 -1182 295 -1184 b 318 -1164 307 -1182 312 -1172 b 382 -963 344 -1122 382 -1044 b 374 -857 382 -923 379 -887 b 402 -668 389 -804 402 -740 b 386 -563 402 -632 396 -596 b 402 -432 395 -523 402 -480 b 402 -418 402 -428 402 -423 b 383 -304 402 -379 396 -341 b 402 -170 393 -264 402 -222 b 402 -158 402 -166 402 -163 b 333 49 402 -84 382 -16 b 137 292 265 138 192 213 b 42 520 82 372 42 520 b 22 537 39 530 37 537 b 0 520 4 537 0 530 z"
        },
        flag64thDown: {
            x_min: 0,
            x_max: 309,
            y_min: -403,
            y_max: 804,
            ha: 1207,
            o: "m 52 -196 b 91 -102 59 -166 71 -131 b 347 128 145 -23 272 45 b 384 180 361 145 374 163 b 324 -30 384 76 361 16 b 52 -196 235 -140 124 -176 z m 163 517 b 366 693 248 589 327 644 b 382 717 372 701 377 708 b 383 693 383 708 383 701 b 314 505 383 621 359 562 b 53 343 258 438 179 390 b 56 363 55 351 56 359 b 163 517 66 400 81 449 z m 314 232 b 50 69 258 163 179 117 b 91 171 56 102 69 140 b 347 402 145 251 272 318 b 382 449 360 416 372 432 b 383 420 383 439 383 429 b 314 232 383 348 359 288 z m 0 -557 b 22 -580 0 -567 10 -580 b 43 -557 33 -580 40 -567 b 167 -310 65 -408 109 -364 b 445 140 243 -238 445 -125 b 431 307 445 192 439 249 b 441 377 436 331 439 354 b 441 406 441 387 441 397 b 441 418 441 410 441 413 b 423 546 441 464 432 507 b 441 651 432 582 438 618 b 441 675 441 660 441 667 b 441 688 441 680 441 684 b 425 808 441 730 433 772 b 441 919 435 840 441 876 b 327 1149 441 1032 374 1112 b 305 1158 321 1153 314 1156 b 287 1152 300 1158 292 1156 b 279 1145 281 1151 279 1148 b 294 1129 279 1140 288 1136 b 382 930 344 1076 382 1027 b 327 789 382 877 364 832 b 22 598 226 672 86 612 b 0 559 12 593 0 563 z"
        },
        flag128thUp: {
            x_min: 0,
            x_max: 279,
            y_min: -821,
            y_max: 573,
            ha: 1394,
            o: "m 0 -550 b 22 -563 0 -553 12 -560 b 258 -776 59 -576 171 -648 b 318 -950 307 -850 318 -901 b 317 -975 318 -959 318 -966 b 285 -1140 317 -1011 307 -1083 b 279 -1164 284 -1148 279 -1156 b 289 -1179 279 -1171 282 -1176 b 297 -1182 292 -1181 294 -1181 b 318 -1162 307 -1182 312 -1169 b 382 -962 344 -1120 382 -1043 b 374 -857 382 -922 379 -887 b 402 -668 389 -802 402 -740 b 383 -554 402 -629 396 -590 b 402 -399 396 -503 402 -452 b 382 -284 402 -359 396 -321 b 402 -125 396 -230 402 -180 b 383 -14 402 -86 396 -49 b 402 130 396 35 402 81 b 333 348 402 204 382 284 b 137 592 265 438 192 513 b 42 808 82 671 46 793 b 22 825 39 818 37 825 b 0 808 4 825 0 818 z m 271 310 b 340 111 328 235 340 170 b 338 73 340 98 338 86 b 333 81 336 76 334 79 b 91 357 265 170 145 276 b 48 469 66 393 53 435 l 50 469 b 271 310 124 469 217 377 z m 301 -681 b 148 -523 262 -631 219 -593 b 56 -383 92 -465 66 -420 b 49 -343 55 -374 52 -359 l 50 -343 b 271 -500 124 -343 217 -432 b 340 -688 327 -575 340 -634 b 337 -737 340 -706 338 -721 b 301 -681 325 -716 312 -697 z m 333 -461 b 91 -192 265 -372 145 -271 b 48 -73 66 -154 53 -111 l 48 -73 l 50 -73 b 271 -232 124 -73 217 -163 b 340 -419 327 -305 340 -364 b 337 -468 340 -435 338 -452 b 333 -461 336 -465 334 -464 z m 333 -192 b 91 84 265 -102 145 4 b 48 200 65 121 53 164 l 48 200 l 50 200 b 271 42 124 200 217 109 b 340 -147 327 -32 340 -92 b 337 -197 340 -164 338 -181 b 333 -192 336 -196 334 -194 z"
        },
        flag128thDown: {
            x_min: 0,
            x_max: 309,
            y_min: -591,
            y_max: 803,
            ha: 1394,
            o: "m 0 -828 b 22 -851 0 -838 10 -851 b 43 -828 33 -851 40 -840 b 167 -580 65 -678 109 -635 b 445 -131 243 -508 445 -397 b 431 36 445 -79 439 -22 b 441 108 436 60 439 85 b 441 137 441 117 441 127 b 441 147 441 140 441 144 b 423 275 441 193 432 236 b 441 377 433 310 438 344 b 441 406 441 387 441 396 b 441 418 441 410 441 413 b 423 546 441 464 432 507 b 441 649 432 582 438 616 b 441 675 441 658 441 667 b 441 687 441 680 441 684 b 425 808 441 730 433 772 b 441 919 435 840 441 876 b 327 1149 441 1032 374 1112 b 304 1156 321 1153 312 1156 b 287 1152 298 1156 292 1155 b 279 1145 281 1149 279 1148 b 294 1129 279 1140 288 1135 b 382 930 344 1076 382 1027 b 327 789 382 877 364 832 b 22 598 226 672 86 612 b 0 559 12 593 0 562 z m 314 -37 b 50 -200 258 -107 179 -153 b 91 -102 58 -168 71 -132 b 347 128 145 -23 272 45 b 382 176 360 143 372 160 b 383 151 383 167 383 160 b 314 -37 383 79 359 19 z m 314 232 b 50 69 258 163 179 117 b 91 171 56 101 69 138 b 347 402 145 251 272 317 b 382 449 360 416 372 432 b 383 420 383 439 383 429 b 314 232 383 347 359 288 z m 163 517 b 366 693 248 589 327 642 b 382 716 372 700 377 708 b 383 693 383 708 383 700 b 314 505 382 621 359 560 b 53 343 258 436 179 390 b 56 363 55 350 56 357 b 163 517 66 399 81 449 z m 52 -467 b 91 -372 59 -435 71 -402 b 347 -141 145 -292 272 -225 b 384 -89 361 -125 374 -108 b 324 -301 382 -194 361 -255 b 52 -467 235 -410 122 -446 z"
        },
        accidentalFlat: {
            x_min: 0,
            x_max: 203,
            y_min: -176,
            y_max: 453,
            ha: 629,
            o: "m 289 114 b 173 223 281 170 246 223 b 52 170 101 223 59 179 l 58 632 b 37 652 58 644 49 652 l 20 652 b 0 632 9 652 0 644 l 7 -233 b 27 -253 7 -245 16 -253 b 39 -251 30 -253 36 -252 b 216 -114 45 -248 138 -202 b 292 78 271 -52 292 19 b 289 114 292 91 291 102 z m 190 58 b 148 -85 190 36 184 -30 b 48 -183 124 -122 75 -161 l 52 98 b 134 153 55 111 76 153 b 190 73 186 153 190 104 b 190 58 190 66 190 62 z"
        },
        accidentalNatural: {
            x_min: 0,
            x_max: 171,
            y_min: -323,
            y_max: 325,
            ha: 648,
            o: "m 239 264 b 228 268 236 266 232 268 b 222 266 226 268 223 266 l 40 216 l 40 468 l 0 468 l 0 -245 b 20 -264 0 -256 9 -264 b 26 -264 22 -264 24 -264 l 207 -213 l 207 -465 l 246 -465 b 246 248 246 -226 246 1 b 239 264 246 253 243 261 z m 40 -140 l 40 96 l 207 144 l 207 -94 z"
        },
        accidentalSharp: {
            x_min: 0,
            x_max: 244,
            y_min: -333,
            y_max: 334,
            ha: 667,
            o: "m 336 151 b 351 171 344 153 351 163 l 351 256 b 331 276 351 268 343 276 b 328 276 330 276 330 276 l 281 266 l 281 481 l 240 481 l 240 258 l 112 232 l 112 435 l 72 435 l 72 223 l 16 212 b 0 192 7 210 0 200 l 0 189 l 0 105 l 0 108 b 20 88 0 96 9 88 b 24 88 22 88 23 88 l 72 98 l 72 -140 l 16 -151 b 0 -171 7 -153 0 -163 l 0 -255 b 20 -275 0 -266 9 -275 b 24 -275 22 -275 23 -275 l 72 -265 l 72 -480 l 112 -480 l 112 -256 l 240 -230 l 240 -433 l 281 -433 l 281 -222 l 336 -212 b 351 -192 344 -210 351 -200 l 351 -107 b 331 -86 351 -95 343 -86 b 328 -86 330 -86 330 -86 l 281 -96 l 281 141 z m 112 107 l 240 132 l 240 -105 l 112 -132 z"
        },
        accidentalDoubleSharp: {
            x_min: 0,
            x_max: 275,
            y_min: -137,
            y_max: 138,
            ha: 275,
            o: "m 360 73 l 376 73 b 396 94 387 73 396 82 l 396 179 b 376 199 396 190 387 199 l 291 199 b 271 179 279 199 271 190 l 271 161 l 271 102 l 200 30 l 196 30 l 124 102 l 124 179 b 105 199 124 190 117 199 l 20 199 b 0 179 9 199 0 190 l 0 94 b 20 73 0 82 9 73 l 35 73 l 36 73 l 96 73 l 167 3 l 167 -1 l 96 -73 l 36 -73 l 35 -73 l 20 -73 b 0 -92 9 -73 0 -81 l 0 -177 b 20 -197 0 -189 9 -197 l 105 -197 b 124 -177 117 -197 124 -189 l 124 -101 l 196 -32 l 200 -32 l 271 -101 l 271 -161 l 271 -163 l 271 -177 b 291 -197 271 -189 279 -197 l 376 -197 b 396 -177 387 -197 396 -189 l 396 -92 b 376 -73 396 -81 387 -73 l 361 -73 l 360 -73 l 300 -73 l 228 -1 l 228 1 l 300 73 z"
        },
        accidentalDoubleFlat: {
            x_min: 0,
            x_max: 371,
            y_min: -176,
            y_max: 453,
            ha: 629,
            o: "m 531 115 b 415 223 523 171 488 223 b 294 171 343 223 301 180 l 300 632 b 279 652 300 644 291 652 l 262 652 b 242 632 251 652 242 644 l 246 199 b 173 223 228 213 204 223 b 52 170 101 223 59 179 l 58 632 b 37 652 58 644 49 652 l 20 652 b 0 632 9 652 0 644 l 7 -233 b 27 -253 7 -245 16 -253 b 39 -249 30 -253 36 -251 b 216 -114 45 -246 138 -202 b 248 -69 226 -102 239 -82 l 249 -233 b 269 -253 249 -245 258 -253 b 281 -249 272 -253 278 -251 b 458 -112 287 -246 380 -200 b 534 79 513 -50 534 20 b 531 115 534 92 533 104 z m 190 58 b 148 -85 190 36 184 -30 b 48 -183 124 -122 75 -161 l 52 98 b 134 153 55 111 76 153 b 190 73 186 153 190 104 b 190 58 190 66 190 62 z m 432 58 b 390 -85 432 36 426 -30 b 289 -183 366 -122 317 -161 l 294 98 b 376 153 297 111 318 153 b 432 73 428 153 432 104 b 432 58 432 66 432 62 z"
        },
        accidentalParensLeft: {
            x_min: 0,
            x_max: 75,
            y_min: -212,
            y_max: 209,
            ha: 421,
            o: "m 98 -305 b 104 -302 101 -304 102 -304 b 108 -295 107 -301 108 -298 b 107 -289 108 -294 108 -292 b 40 10 107 -288 40 -160 b 107 288 40 95 58 192 b 108 292 108 289 108 291 b 104 300 108 295 107 298 b 96 301 101 301 99 302 b 91 298 94 301 92 300 b 0 0 86 292 0 174 b 91 -301 0 -174 86 -295 b 98 -305 92 -304 95 -305 z"
        },
        accidentalParensRight: {
            x_min: 0,
            x_max: 75,
            y_min: -209,
            y_max: 212,
            ha: 421,
            o: "m 10 305 b 4 302 7 304 6 304 b 0 295 1 301 0 298 b 1 289 0 294 0 292 b 68 -10 1 288 68 160 b 1 -288 68 -95 50 -192 b 0 -292 0 -289 0 -291 b 4 -300 0 -295 1 -298 b 12 -301 7 -301 9 -302 b 17 -298 14 -301 16 -300 b 108 0 22 -292 108 -174 b 17 301 108 174 22 295 b 10 305 16 304 13 305 z"
        },
        accidentalQuarterToneFlatStein: {
            x_min: 0,
            x_max: 193,
            y_min: -176,
            y_max: 452,
            ha: 628,
            o: "m 0 84 b 107 -145 0 -26 65 -105 b 245 -249 166 -202 245 -249 b 253 -253 248 -251 249 -253 b 272 -235 264 -253 272 -245 l 278 632 b 259 651 278 642 269 651 l 248 651 b 229 632 238 651 229 642 l 232 174 b 125 217 223 186 192 217 b 0 84 53 217 0 173 z m 148 154 b 232 102 212 154 232 115 b 233 107 232 99 233 102 l 235 -179 b 134 -72 207 -156 160 -111 b 92 58 98 -17 92 36 b 92 75 92 62 92 68 b 148 154 92 105 96 154 z"
        },
        accidentalThreeQuarterTonesFlatZimmermann: {
            x_min: 0,
            x_max: 422,
            y_min: -176,
            y_max: 452,
            ha: 628,
            o: "m 608 84 b 482 217 608 173 554 217 b 376 174 416 217 384 186 l 379 632 b 360 651 379 642 370 651 l 348 651 b 330 632 338 651 330 642 l 336 -235 b 354 -253 336 -245 344 -253 b 363 -249 359 -253 360 -251 b 501 -145 363 -249 442 -202 b 608 84 543 -105 608 -26 z m 459 154 b 516 75 511 154 516 105 b 516 58 516 68 516 62 b 474 -72 516 36 510 -17 b 373 -179 448 -111 400 -156 l 374 107 b 376 102 374 102 376 99 b 459 154 376 115 396 154 z m 0 84 b 107 -145 0 -26 65 -105 b 245 -249 166 -202 245 -249 b 253 -253 248 -251 249 -253 b 272 -235 264 -253 272 -245 l 278 632 b 259 651 278 642 269 651 l 248 651 b 229 632 238 651 229 642 l 232 174 b 125 217 223 186 192 217 b 0 84 53 217 0 173 z m 148 154 b 232 102 212 154 232 115 b 233 107 232 99 233 102 l 235 -179 b 134 -72 207 -156 160 -111 b 92 58 98 -17 92 36 b 92 75 92 62 92 68 b 148 154 92 105 96 154 z"
        },
        accidentalQuarterToneSharpStein: {
            x_min: 0,
            x_max: 180,
            y_min: -316,
            y_max: 320,
            ha: 636,
            o: "m 243 144 b 259 164 252 145 259 156 l 259 249 b 239 269 259 261 251 269 b 235 268 238 269 236 268 l 150 251 l 150 461 l 109 461 l 109 242 l 16 222 b 0 203 7 220 0 212 l 0 120 b 20 99 0 108 9 99 b 24 99 22 99 23 99 l 109 117 l 109 -121 l 16 -141 b 0 -160 7 -143 0 -151 l 0 -243 b 20 -264 0 -255 9 -264 b 24 -264 22 -264 23 -264 l 109 -246 l 109 -455 l 150 -455 l 150 -238 l 243 -219 b 259 -199 252 -217 259 -207 l 259 -114 b 239 -95 259 -102 251 -95 b 235 -95 238 -95 236 -95 l 150 -112 l 150 125 z"
        },
        accidentalThreeQuarterTonesSharpStein: {
            x_min: 0,
            x_max: 290,
            y_min: -328,
            y_max: 339,
            ha: 667,
            o: "m 400 158 b 416 179 409 160 416 170 l 416 264 b 397 284 416 275 409 284 b 393 284 396 284 395 284 l 348 274 l 348 488 l 308 488 l 308 265 l 223 248 l 223 465 l 184 465 l 184 240 l 108 225 l 108 442 l 69 442 l 69 216 l 16 204 b 0 186 7 203 0 194 l 0 102 b 20 82 0 91 9 82 b 24 82 22 82 23 82 l 69 92 l 69 -147 l 16 -158 b 0 -177 7 -160 0 -168 l 0 -261 b 20 -281 0 -272 9 -281 b 24 -281 22 -281 23 -281 l 69 -272 l 69 -472 l 108 -472 l 108 -264 l 184 -248 l 184 -451 l 223 -451 l 223 -240 l 308 -223 l 308 -426 l 348 -426 l 348 -215 l 400 -204 b 418 -184 409 -203 418 -193 l 418 -99 b 397 -79 418 -88 409 -79 b 393 -79 396 -79 395 -79 l 348 -89 l 348 148 z m 184 -122 l 108 -138 l 108 99 l 184 115 z m 223 122 l 308 140 l 308 -98 l 223 -115 z"
        },
        accidentalBuyukMucennebFlat: {
            x_min: 0,
            x_max: 277,
            y_min: -176,
            y_max: 454,
            ha: 630,
            o: "m 396 115 b 279 225 387 173 354 225 b 158 171 204 225 164 179 l 160 317 l 336 419 l 336 482 l 161 380 l 161 488 l 336 590 l 336 654 l 163 552 l 164 634 b 144 654 164 645 156 654 l 127 654 b 107 634 115 654 107 645 l 108 520 l 0 456 l 0 393 l 108 456 l 109 350 l 0 285 l 0 222 l 109 287 l 114 -235 b 134 -253 114 -246 122 -253 b 145 -251 138 -253 141 -252 b 323 -114 145 -251 242 -204 b 399 79 377 -52 399 20 b 396 115 399 92 397 104 z m 297 58 b 255 -85 297 36 291 -30 b 154 -184 230 -122 181 -163 l 158 96 b 240 153 161 109 181 153 b 297 73 292 153 297 104 b 297 58 297 66 297 62 z"
        },
        accidentalBuyukMucennebSharp: {
            x_min: 0,
            x_max: 348,
            y_min: -332,
            y_max: 334,
            ha: 666,
            o: "m 494 121 b 482 125 491 122 485 125 b 478 125 481 125 480 125 l 354 91 l 354 148 l 412 164 b 425 183 419 166 425 176 l 425 268 b 408 287 425 278 418 287 b 402 285 406 287 403 285 l 354 272 l 354 481 l 317 481 l 317 262 l 186 226 l 186 436 l 148 436 l 148 216 l 89 200 b 76 183 82 199 76 190 l 76 98 b 84 84 76 92 79 86 b 95 81 86 82 92 81 b 99 81 96 81 98 81 l 148 94 l 148 35 l 14 -1 b 0 -20 7 -3 0 -13 l 0 -104 b 7 -118 0 -109 3 -115 b 19 -122 10 -120 16 -122 b 23 -121 20 -122 22 -121 l 148 -88 l 148 -147 l 89 -163 b 76 -180 82 -164 76 -173 l 76 -181 l 76 -265 b 95 -282 76 -275 85 -282 b 99 -282 96 -282 98 -282 l 148 -269 l 148 -478 l 186 -478 l 186 -259 l 317 -225 l 317 -433 l 354 -433 l 354 -215 l 412 -199 b 425 -181 419 -197 425 -189 l 425 -95 b 418 -81 425 -89 422 -84 b 406 -76 415 -79 409 -76 b 402 -78 405 -76 403 -78 l 354 -91 l 354 -32 l 488 4 b 501 22 495 6 501 14 l 501 107 b 494 121 501 112 498 118 z m 317 138 l 317 81 l 186 45 l 186 104 z m 186 -137 l 186 -78 l 317 -42 l 317 -101 z"
        },
        accidentalBakiyeFlat: {
            x_min: 0,
            x_max: 277,
            y_min: -176,
            y_max: 454,
            ha: 630,
            o: "m 396 115 b 279 225 387 173 354 225 b 158 171 204 225 164 179 l 161 348 l 336 452 l 336 516 l 161 413 l 164 634 b 144 654 164 645 156 654 l 127 654 b 107 634 115 654 107 645 l 109 382 l 0 318 l 0 255 l 109 318 l 114 -235 b 134 -253 114 -246 122 -253 b 145 -251 138 -253 143 -252 b 323 -114 145 -251 242 -204 b 399 79 377 -52 399 20 b 396 115 399 92 397 104 z m 297 58 b 255 -85 297 36 291 -30 b 156 -184 230 -122 183 -163 l 158 96 b 240 153 161 109 181 153 b 297 73 292 153 297 104 b 297 58 297 66 297 62 z"
        },
        accidentalKucukMucennebSharp: {
            x_min: 0,
            x_max: 348,
            y_min: -316,
            y_max: 318,
            ha: 634,
            o: "m 494 121 b 482 125 491 124 487 125 b 478 124 481 125 480 124 l 269 68 l 269 127 l 412 164 b 425 181 420 167 425 173 l 425 266 b 418 282 425 272 422 279 b 406 285 415 285 410 285 b 402 285 405 285 403 285 l 269 249 l 269 458 l 232 458 l 232 239 l 89 200 b 76 181 81 197 76 190 l 76 98 b 84 84 76 92 79 86 b 95 79 86 81 91 79 b 99 81 96 79 98 81 l 232 115 l 232 58 l 14 -3 b 0 -20 6 -6 0 -12 l 0 -104 b 7 -118 0 -109 3 -115 b 19 -122 10 -121 14 -122 b 23 -122 20 -122 22 -122 l 232 -66 l 232 -124 l 89 -163 b 76 -180 81 -166 76 -171 l 76 -264 b 84 -279 76 -269 79 -276 b 95 -282 86 -282 91 -282 b 99 -282 96 -282 98 -282 l 232 -246 l 232 -455 l 269 -455 l 269 -236 l 412 -199 b 425 -180 420 -196 425 -189 l 425 -95 b 418 -81 425 -89 422 -84 b 406 -76 415 -78 410 -76 b 402 -78 405 -76 403 -78 l 269 -114 l 269 -55 l 487 4 b 501 22 495 7 501 13 l 501 107 b 494 121 501 112 498 118 z"
        },
        articAccentAbove: {
            x_min: 0,
            x_max: 361,
            y_min: 0,
            y_max: 235,
            ha: 235,
            o: "m 26 337 b 20 338 24 337 22 338 b 0 318 9 338 0 330 l 0 285 b 14 266 0 276 7 269 l 323 170 l 14 72 b 0 53 7 69 0 62 l 0 20 b 20 0 0 9 9 0 b 26 1 22 0 24 1 l 505 150 b 520 170 513 153 520 161 b 505 189 520 179 513 186 z"
        },
        articAccentBelow: {
            x_min: 0,
            x_max: 361,
            y_min: -235,
            y_max: 0,
            ha: 235,
            o: "m 26 -1 b 20 0 24 -1 22 0 b 0 -20 9 0 0 -9 l 0 -53 b 14 -72 0 -62 7 -69 l 323 -168 l 14 -266 b 0 -285 7 -269 0 -276 l 0 -318 b 20 -338 0 -330 9 -338 b 26 -337 22 -338 24 -337 l 505 -189 b 520 -168 513 -186 520 -177 b 505 -150 520 -160 513 -153 z"
        },
        articTenutoAbove: {
            x_min: 0,
            x_max: 316,
            y_min: 0,
            y_max: 46,
            ha: 46,
            o: "m 20 66 b 0 46 9 66 0 58 l 0 20 b 20 0 0 9 9 0 l 435 0 b 455 20 446 0 455 9 l 455 46 b 435 66 455 58 446 66 z"
        },
        articTenutoBelow: {
            x_min: 0,
            x_max: 316,
            y_min: -46,
            y_max: 0,
            ha: 46,
            o: "m 20 0 b 0 -20 9 0 0 -9 l 0 -46 b 20 -66 0 -58 9 -66 l 435 -66 b 455 -46 446 -66 455 -58 l 455 -20 b 435 0 455 -9 446 0 z"
        },
        articStaccatoAbove: {
            x_min: 0,
            x_max: 78,
            y_min: 0,
            y_max: 78,
            ha: 78,
            o: "m 16 16 b 96 16 39 -6 73 -6 b 96 95 118 39 118 73 b 16 95 73 118 39 118 b 16 16 -6 73 -6 39 z"
        },
        articStaccatoBelow: {
            x_min: 0,
            x_max: 78,
            y_min: -78,
            y_max: 0,
            ha: 78,
            o: "m 16 -96 b 96 -96 39 -118 73 -118 b 96 -17 118 -73 118 -39 b 16 -17 73 6 39 6 b 16 -96 -6 -39 -6 -73 z"
        },
        articStaccatissimoAbove: {
            x_min: 0,
            x_max: 127,
            y_min: 0,
            y_max: 248,
            ha: 248,
            o: "m 163 357 b 150 353 154 357 150 353 l 99 300 b 92 295 96 297 95 295 b 85 300 89 295 88 297 l 35 353 b 22 357 35 353 30 357 b 0 338 13 357 0 351 b 73 22 0 323 73 22 b 92 0 75 16 78 0 b 111 22 107 0 109 16 b 183 338 111 22 183 323 b 163 357 183 351 171 357 z"
        },
        articStaccatissimoBelow: {
            x_min: 0,
            x_max: 127,
            y_min: -248,
            y_max: 0,
            ha: 248,
            o: "m 20 -357 b 33 -353 29 -357 33 -353 l 84 -300 b 91 -295 86 -297 88 -295 b 98 -300 94 -295 95 -297 l 148 -353 b 161 -357 148 -353 153 -357 b 183 -338 170 -357 183 -351 b 109 -22 183 -323 109 -22 b 91 0 108 -16 105 0 b 72 -22 76 0 73 -16 b 0 -338 72 -22 0 -323 b 20 -357 0 -351 12 -357 z"
        },
        articMarcatoAbove: {
            x_min: 1,
            x_max: 296,
            y_min: 0,
            y_max: 253,
            ha: 253,
            o: "m 36 10 l 173 239 l 298 10 b 317 0 301 4 310 0 l 408 0 b 426 20 419 0 426 9 b 425 30 426 23 426 27 l 230 356 b 213 364 226 361 222 363 b 196 356 207 364 199 361 l 1 30 z"
        },
        articMarcatoBelow: {
            x_min: 0,
            x_max: 295,
            y_min: -253,
            y_max: 0,
            ha: 253,
            o: "m 390 -10 l 253 -239 l 128 -10 b 109 0 125 -4 117 0 l 19 0 b 0 -20 7 0 0 -9 b 1 -30 0 -23 0 -27 l 196 -356 b 213 -364 200 -361 204 -363 b 230 -356 219 -364 228 -361 l 425 -30 z"
        },
        fermataAbove: {
            x_min: 0,
            x_max: 622,
            y_min: 0,
            y_max: 368,
            ha: 368,
            o: "m 778 374 b 448 530 642 521 523 530 b 120 374 373 530 255 521 b 0 65 49 297 0 143 b 20 19 0 37 6 19 b 161 265 60 19 40 143 b 445 373 268 372 410 373 b 448 373 446 373 446 373 b 451 373 449 373 449 373 b 734 265 485 373 628 372 b 876 19 855 143 835 19 b 896 65 890 19 896 36 b 778 374 896 143 848 298 z m 348 99 b 448 0 348 45 393 0 b 547 99 503 0 547 45 b 448 199 547 154 503 199 b 348 99 393 199 348 154 z"
        },
        fermataBelow: {
            x_min: 0,
            x_max: 622,
            y_min: -368,
            y_max: 0,
            ha: 368,
            o: "m 778 -374 b 896 -65 848 -298 896 -143 b 876 -19 896 -36 890 -19 b 734 -265 835 -19 855 -143 b 451 -373 628 -372 485 -373 b 448 -373 449 -373 449 -373 b 445 -373 446 -373 446 -373 b 161 -265 410 -373 268 -372 b 20 -19 40 -143 60 -19 b 0 -65 6 -19 0 -37 b 120 -374 0 -143 49 -297 b 448 -530 255 -521 373 -530 b 778 -374 523 -530 642 -521 z m 348 -99 b 448 -199 348 -154 393 -199 b 547 -99 503 -199 547 -154 b 448 0 547 -45 503 0 b 348 -99 393 0 348 -45 z"
        },
        fermataLongAbove: {
            x_min: 0,
            x_max: 623,
            y_min: 0,
            y_max: 368,
            ha: 368,
            o: "m 40 0 l 40 399 l 858 399 l 858 0 l 897 0 l 897 510 b 877 530 897 521 888 530 l 20 530 b 0 510 9 530 0 521 l 0 0 z m 350 148 b 449 49 350 94 395 49 b 547 148 504 49 547 94 b 449 248 547 203 504 248 b 350 148 395 248 350 203 z"
        },
        fermataLongBelow: {
            x_min: 0,
            x_max: 623,
            y_min: -368,
            y_max: 0,
            ha: 368,
            o: "m 0 -510 b 20 -530 0 -521 9 -530 l 877 -530 b 897 -510 888 -530 897 -521 l 897 0 l 858 0 l 858 -399 l 40 -399 l 40 0 l 0 0 z m 350 -148 b 449 -248 350 -203 395 -248 b 547 -148 504 -248 547 -203 b 449 -49 547 -94 504 -49 b 350 -148 395 -49 350 -94 z"
        },
        fermataVeryLongAbove: {
            x_min: 0,
            x_max: 842,
            y_min: 0,
            y_max: 549,
            ha: 549,
            o: "m 276 0 l 276 399 l 936 399 l 936 0 l 976 0 l 976 510 b 956 530 976 521 968 530 l 256 530 b 236 510 245 530 236 521 l 236 0 z m 507 148 b 606 49 507 94 552 49 b 706 148 661 49 706 94 b 606 248 706 203 661 248 b 507 148 552 248 507 203 z m 40 0 l 40 661 l 1172 661 l 1172 0 l 1212 0 l 1212 772 b 1192 791 1212 783 1204 791 l 20 791 b 0 772 9 791 0 783 l 0 0 z"
        },
        fermataVeryLongBelow: {
            x_min: 0,
            x_max: 842,
            y_min: -549,
            y_max: 0,
            ha: 549,
            o: "m 236 -510 b 256 -530 236 -521 245 -530 l 956 -530 b 976 -510 968 -530 976 -521 l 976 0 l 936 0 l 936 -399 l 276 -399 l 276 0 l 236 0 z m 507 -148 b 606 -248 507 -203 552 -248 b 706 -148 661 -248 706 -203 b 606 -49 706 -94 661 -49 b 507 -148 552 -49 507 -94 z m 0 -772 b 20 -791 0 -783 9 -791 l 1192 -791 b 1212 -772 1204 -791 1212 -783 l 1212 0 l 1172 0 l 1172 -661 l 40 -661 l 40 0 l 0 0 z"
        },
        fermataShortAbove: {
            x_min: 0,
            x_max: 642,
            y_min: 0,
            y_max: 454,
            ha: 454,
            o: "m 363 148 b 462 49 363 94 408 49 b 562 148 517 49 562 94 b 462 248 562 203 517 248 b 363 148 408 248 363 203 z m 477 645 b 461 654 474 649 467 654 b 445 645 455 654 448 649 l 4 32 b 0 20 3 29 0 23 b 20 0 0 9 9 0 l 82 0 b 98 9 88 0 95 4 l 461 514 l 827 9 b 842 0 829 4 837 0 l 904 0 b 924 20 916 0 924 9 b 920 32 924 23 922 29 z"
        },
        fermataShortBelow: {
            x_min: 0,
            x_max: 642,
            y_min: -454,
            y_max: 0,
            ha: 454,
            o: "m 363 -148 b 462 -248 363 -203 408 -248 b 562 -148 517 -248 562 -203 b 462 -49 562 -94 517 -49 b 363 -148 408 -49 363 -94 z m 920 -32 b 924 -20 922 -29 924 -23 b 904 0 924 -9 916 0 l 842 0 b 827 -9 837 0 829 -4 l 461 -514 l 98 -9 b 82 0 95 -4 88 0 l 20 0 b 0 -20 9 0 0 -9 b 4 -32 0 -23 3 -29 l 445 -645 b 461 -654 448 -649 455 -654 b 477 -645 467 -654 474 -649 z"
        },
        breathMarkComma: {
            x_min: 0,
            x_max: 191,
            y_min: 0,
            y_max: 321,
            ha: 321,
            o: "m 82 0 b 275 285 215 92 275 183 b 115 462 275 396 212 462 b 0 356 46 462 0 413 b 115 246 0 294 53 246 b 181 258 157 246 177 256 b 192 261 184 259 189 261 b 199 259 194 261 196 261 b 203 245 202 258 203 253 b 48 43 203 183 147 112 z"
        },
        caesura: {
            x_min: 0,
            x_max: 380,
            y_min: 0,
            y_max: 490,
            ha: 490,
            o: "m 285 706 b 285 706 285 706 285 706 b 271 696 279 706 274 701 l 1 22 b 0 16 0 20 0 17 b 16 0 0 7 7 0 l 50 0 b 65 10 56 0 62 4 l 334 684 b 336 690 334 685 336 688 b 320 706 336 698 328 706 z m 213 22 b 212 16 213 20 212 17 b 228 0 212 7 219 0 l 262 0 b 276 10 268 0 274 4 l 546 684 b 547 690 547 685 547 688 b 531 706 547 698 540 706 l 497 706 b 482 696 491 706 485 701 z"
        },
        caesuraCurved: {
            x_min: 0,
            x_max: 368,
            y_min: 0,
            y_max: 491,
            ha: 491,
            o: "m 262 707 b 245 693 253 707 246 701 b 1 26 233 603 177 348 b 0 17 0 23 0 20 b 16 0 0 9 6 0 b 30 7 22 0 27 3 b 318 687 259 341 304 602 b 318 690 318 688 318 688 b 301 707 318 698 310 707 z m 474 707 b 458 693 465 707 459 701 b 213 26 446 603 389 348 b 212 19 212 23 212 20 b 229 0 212 9 219 0 b 243 7 235 0 240 3 b 530 687 472 341 516 602 b 530 690 530 688 530 688 b 514 707 530 698 523 707 z"
        },
        restMaxima: {
            x_min: 0,
            x_max: 450,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m 158 -360 b 180 -338 170 -360 180 -350 l 180 338 b 158 360 180 350 170 360 l 22 360 b 0 338 9 360 0 350 l 0 -338 b 22 -360 0 -350 9 -360 z m 626 -360 b 648 -338 638 -360 648 -350 l 648 338 b 626 360 648 350 638 360 l 490 360 b 468 338 477 360 468 350 l 468 -338 b 490 -360 468 -350 477 -360 z"
        },
        restDoubleWhole: {
            x_min: 0,
            x_max: 125,
            y_min: -11,
            y_max: 262,
            ha: 273,
            o: "m 158 -16 b 180 6 171 -16 180 -6 l 180 356 b 158 377 180 367 171 377 l 22 377 b 0 356 10 377 0 367 l 0 6 b 22 -16 0 -6 10 -16 z"
        },
        restWhole: {
            x_min: 0,
            x_max: 325,
            y_min: -131,
            y_max: 5,
            ha: 136,
            o: "m 20 7 b 0 -13 9 7 0 -1 l 0 -168 b 20 -189 0 -180 9 -189 l 448 -189 b 468 -168 459 -189 468 -180 l 468 -13 b 448 7 468 -1 459 7 z"
        },
        restWholeLegerLine: {
            x_min: -139,
            x_max: 464,
            y_min: -122,
            y_max: 14,
            ha: 136,
            o: "m 449 20 l 19 20 l -200 20 l -200 -20 l 0 -20 l 0 -156 b 19 -176 0 -167 7 -176 l 449 -176 b 468 -156 461 -176 468 -167 l 468 -20 l 668 -20 l 668 20 z"
        },
        restHalf: {
            x_min: 0,
            x_max: 325,
            y_min: -4,
            y_max: 132,
            ha: 136,
            o: "m 0 14 b 20 -6 0 -6 0 -6 l 448 -6 b 468 14 468 -6 468 -6 l 468 170 b 448 190 468 190 468 190 l 20 190 b 0 170 0 190 0 190 z"
        },
        restHalfLegerLine: {
            x_min: -139,
            x_max: 464,
            y_min: -14,
            y_max: 122,
            ha: 136,
            o: "m 668 20 l 468 20 l 468 156 b 449 176 468 167 461 176 l 19 176 b 0 156 7 176 0 167 l 0 20 l -200 20 l -200 -20 l 19 -20 l 449 -20 l 668 -20 z"
        },
        restQuarter: {
            x_min: 0,
            x_max: 235,
            y_min: -331,
            y_max: 401,
            ha: 732,
            o: "m 331 -239 b 323 -229 330 -238 327 -235 l 157 -24 b 154 -16 156 -23 154 -19 b 157 -3 154 -12 156 -6 l 304 219 b 307 229 305 222 307 226 l 307 242 b 302 253 307 246 305 251 l 69 569 b 55 577 69 569 63 577 b 43 573 50 577 48 576 b 36 559 37 569 36 563 b 40 543 36 550 40 543 l 150 393 b 154 376 153 389 154 383 b 150 359 154 370 153 363 l 4 137 b 1 125 3 134 1 128 l 1 112 b 6 101 1 108 3 104 l 167 -99 b 131 -95 161 -98 148 -95 b 49 -124 107 -95 75 -101 b 0 -229 17 -153 0 -193 b 16 -285 0 -249 4 -269 b 154 -468 46 -331 154 -468 b 171 -477 154 -468 161 -477 b 180 -474 174 -477 177 -477 b 190 -456 187 -468 190 -462 b 186 -444 190 -451 187 -446 b 135 -353 181 -436 135 -353 b 125 -307 135 -353 125 -333 b 150 -246 125 -288 131 -265 b 206 -223 167 -229 187 -223 b 252 -236 225 -223 240 -229 l 308 -272 b 320 -275 308 -272 314 -275 b 334 -268 325 -275 330 -274 b 338 -255 337 -262 338 -259 b 334 -243 338 -251 337 -248 z"
        },
        rest8th: {
            x_min: 0,
            x_max: 276,
            y_min: -255,
            y_max: 204,
            ha: 459,
            o: "m 384 292 b 379 294 383 292 380 294 b 360 282 370 294 363 289 b 245 141 354 274 310 189 b 180 112 226 127 203 117 b 206 181 196 131 206 154 b 104 284 206 238 160 284 b 0 181 46 284 0 238 b 65 85 0 137 27 101 b 144 68 86 75 115 68 b 269 109 186 68 230 81 b 320 157 287 122 304 140 l 156 -356 l 194 -367 l 396 268 b 397 275 397 269 397 272 b 384 292 397 282 393 288 z"
        },
        rest16th: {
            x_min: 1,
            x_max: 344,
            y_min: -507,
            y_max: 204,
            ha: 711,
            o: "m 494 268 b 495 275 495 271 495 272 b 482 292 495 282 491 289 b 475 294 480 294 477 294 b 456 282 467 294 461 289 b 285 115 422 213 364 135 b 310 184 302 135 310 158 b 203 284 310 240 259 284 b 104 177 145 281 104 233 b 171 84 105 134 134 98 b 252 69 197 72 225 69 b 423 164 324 72 380 108 l 423 164 l 359 -65 b 183 -245 338 -132 256 -226 b 207 -176 199 -225 207 -200 b 102 -76 207 -118 158 -76 b 1 -183 45 -76 1 -125 b 69 -275 1 -226 32 -262 b 150 -289 96 -287 121 -289 b 321 -194 222 -287 278 -251 l 174 -720 l 213 -730 z"
        },
        rest32nd: {
            x_min: 0,
            x_max: 391,
            y_min: -507,
            y_max: 460,
            ha: 967,
            o: "m 217 71 b 408 171 348 71 402 161 l 354 -46 b 184 -240 323 -121 268 -217 b 204 -171 200 -220 204 -197 b 102 -76 204 -114 158 -76 b 0 -177 46 -76 0 -120 b 140 -288 0 -252 63 -288 b 320 -186 216 -288 276 -246 l 189 -721 l 228 -730 l 562 638 b 563 644 563 639 563 642 b 549 661 563 652 557 658 b 543 662 547 662 544 662 b 524 649 534 662 528 657 b 361 487 497 589 431 504 b 383 556 379 508 383 530 b 282 652 383 611 338 652 b 179 549 226 652 179 609 b 249 451 179 505 210 464 b 311 439 268 444 288 441 b 330 441 317 439 323 439 b 498 541 400 445 458 485 l 442 310 b 271 117 413 238 351 137 b 292 186 288 138 292 160 b 189 282 292 243 245 282 b 88 180 132 282 88 238 b 217 71 88 112 153 71 z"
        },
        rest64th: {
            x_min: 0,
            x_max: 423,
            y_min: -758,
            y_max: 464,
            ha: 1222,
            o: "m 207 -1083 l 246 -1092 b 608 644 282 -919 605 634 b 609 649 608 647 609 648 b 595 667 609 658 603 665 b 589 668 593 668 592 668 b 569 654 577 668 575 664 b 474 521 563 644 530 573 b 412 487 456 505 435 494 b 432 546 425 503 432 526 b 328 649 432 606 382 649 b 226 546 275 649 226 608 b 360 438 226 465 300 438 b 501 492 419 438 474 465 b 546 546 527 518 533 526 l 547 547 l 500 323 b 399 161 491 300 452 209 b 337 125 382 144 360 132 b 357 184 350 143 357 134 b 253 288 357 235 317 288 b 151 187 190 288 151 236 b 285 76 151 138 183 76 b 471 184 412 76 465 173 l 423 -45 b 324 -204 413 -69 374 -158 b 262 -240 305 -222 284 -233 b 281 -180 274 -223 281 -212 b 177 -78 281 -147 258 -78 b 75 -180 98 -78 75 -153 b 209 -289 75 -207 88 -289 b 395 -181 330 -289 389 -193 l 350 -397 b 248 -564 337 -449 285 -530 b 186 -599 229 -580 207 -592 b 204 -540 197 -583 204 -563 b 102 -438 204 -501 174 -438 b 0 -540 29 -438 0 -501 b 132 -648 0 -579 24 -648 b 320 -540 266 -648 315 -552 z"
        },
        rest128th: {
            x_min: -1,
            x_max: 475,
            y_min: -759,
            y_max: 717,
            ha: 1476,
            o: "m 677 1028 b 664 1032 672 1031 667 1032 b 644 1018 654 1032 649 1028 b 549 886 638 1008 605 937 b 487 851 531 870 510 858 b 507 910 500 868 507 890 b 403 1014 507 971 456 1014 b 301 910 350 1014 301 972 b 435 802 301 829 374 802 b 576 857 494 802 549 829 b 621 910 602 883 608 890 l 622 912 l 575 687 b 474 526 566 664 527 573 b 412 490 456 508 435 497 b 432 549 425 507 432 498 b 328 652 432 599 392 652 b 226 552 265 652 226 600 b 360 441 226 503 258 441 b 546 549 487 441 540 537 l 498 320 b 399 160 488 295 449 207 b 337 125 380 143 359 131 b 356 184 348 141 356 153 b 252 287 356 217 333 287 b 150 184 173 287 150 212 b 284 76 150 157 163 76 b 469 183 405 76 464 171 l 425 -33 b 323 -200 412 -85 360 -166 b 261 -235 304 -216 282 -228 b 279 -176 272 -219 279 -199 b 177 -72 279 -137 249 -72 b 75 -176 104 -72 75 -137 b 207 -284 75 -215 99 -284 b 395 -176 341 -284 390 -187 l 347 -409 b 248 -566 330 -461 282 -533 b 186 -600 229 -582 207 -593 b 204 -541 197 -583 204 -564 b 102 -438 204 -501 174 -438 b -1 -541 29 -438 -1 -503 b 132 -649 -1 -580 24 -649 b 318 -546 256 -649 307 -567 l 206 -1084 l 245 -1093 b 683 1008 281 -920 680 996 b 684 1015 683 1009 684 1014 b 677 1028 684 1020 683 1024 z"
        },
        dynamicPiano: {
            x_min: -95,
            x_max: 317,
            y_min: -163,
            y_max: 263,
            ha: 426,
            o: "m 186 -235 l 186 -206 l 78 -206 l 161 26 l 166 16 b 229 -29 166 16 180 -16 b 256 -32 238 -32 248 -32 b 445 166 336 -32 415 49 b 456 246 454 197 456 223 b 374 373 456 343 396 367 b 356 376 369 374 361 376 b 242 314 311 376 266 338 l 238 310 l 235 315 b 154 377 235 315 204 370 b 138 379 148 377 144 379 b 0 226 91 379 42 346 l 26 213 b 63 301 32 232 46 278 b 102 328 72 314 89 325 b 108 328 104 328 107 328 b 120 325 112 328 117 327 b 127 304 125 321 127 314 b 94 192 127 269 101 206 l -49 -206 l -137 -206 l -137 -235 z m 226 17 b 215 19 223 17 217 17 b 187 81 193 27 187 53 b 204 180 187 125 203 177 b 297 317 217 235 259 295 b 324 325 307 323 315 325 b 336 324 328 325 333 325 b 350 311 341 323 347 317 b 356 278 354 302 356 291 b 333 161 356 239 341 187 b 242 20 314 105 278 37 b 226 17 238 17 230 17 z"
        },
        dynamicMezzo: {
            x_min: -7,
            x_max: 374,
            y_min: -2,
            y_max: 251,
            ha: 253,
            o: "m 488 63 b 467 48 481 50 474 48 b 459 49 464 48 462 48 b 449 65 452 52 449 58 b 461 112 449 76 455 94 b 474 157 464 121 471 150 b 492 281 482 183 492 242 b 491 301 492 288 492 295 b 436 359 484 340 467 359 b 340 307 399 359 359 331 l 337 301 l 334 308 b 272 359 334 308 311 359 b 177 310 232 359 202 343 l 173 304 l 171 311 b 117 360 171 311 153 353 b 96 361 109 361 102 361 b 29 328 60 361 39 340 b -10 252 20 318 0 284 l 12 240 b 68 318 12 240 36 318 b 75 317 71 318 72 318 b 86 295 84 314 86 307 b 59 194 86 275 75 240 b 1 20 59 193 6 33 b 0 13 1 17 0 16 b 3 4 0 10 1 7 b 14 -1 6 1 9 -1 l 36 -1 b 91 -1 58 -1 86 -1 b 107 22 94 -1 101 -1 b 127 99 114 53 121 79 b 235 310 132 121 186 310 b 243 305 238 310 242 308 b 248 289 246 302 248 297 b 216 160 248 265 233 219 b 173 22 194 89 173 22 b 173 16 173 20 173 19 b 176 3 173 12 173 6 b 187 -1 179 0 183 -1 l 266 -1 b 282 16 272 -1 279 0 b 284 26 282 17 284 22 b 392 302 312 228 359 288 b 396 304 393 302 395 304 l 397 304 b 400 302 399 304 399 302 b 408 289 403 301 408 297 b 369 140 408 275 399 217 b 356 75 360 117 356 95 b 370 23 356 55 360 37 b 428 -3 382 6 408 -3 b 536 99 492 -3 517 49 b 539 108 537 102 537 105 l 514 120 b 488 63 514 120 498 81 z"
        },
        dynamicForte: {
            x_min: -137,
            x_max: 334,
            y_min: -193,
            y_max: 421,
            ha: 614,
            o: "m -122 -86 b -197 -161 -161 -86 -197 -122 b -81 -278 -197 -236 -147 -278 b 35 -228 -35 -278 -1 -264 b 202 173 98 -164 167 50 b 238 297 215 219 228 264 l 238 300 l 341 300 b 356 314 350 300 356 305 l 356 346 b 341 360 356 354 350 360 l 256 360 l 256 364 b 330 554 297 511 308 537 b 359 566 341 563 351 566 b 366 564 361 566 364 564 b 380 553 373 563 377 559 b 382 546 382 550 382 549 b 373 528 382 539 379 531 b 351 478 359 517 351 498 b 354 458 351 471 353 465 b 384 426 359 445 370 432 b 410 420 390 423 400 420 b 445 431 420 420 432 423 b 478 472 459 438 474 456 b 481 497 481 480 481 488 b 467 550 481 514 477 533 b 376 605 455 572 422 598 b 351 606 369 606 360 606 b 225 553 317 606 272 595 b 122 363 187 520 154 456 l 122 360 l 13 360 b -1 346 4 360 -1 354 l -1 314 b 13 300 -1 305 4 300 l 102 300 l 102 294 b 66 140 88 236 76 187 b 24 -35 55 86 42 32 l 20 -52 b -53 -235 -10 -170 -19 -212 b -78 -242 -60 -239 -69 -242 b -98 -235 -85 -242 -92 -239 b -105 -222 -102 -232 -105 -228 b -105 -219 -105 -220 -105 -220 b -94 -204 -104 -213 -101 -207 b -58 -144 -66 -193 -58 -167 b -122 -86 -58 -124 -71 -86 z"
        },
        dynamicRinforzando: {
            x_min: -12,
            x_max: 230,
            y_min: 0,
            y_max: 254,
            ha: 254,
            o: "m 272 364 b 200 341 239 364 212 348 b 168 310 187 333 177 321 l 164 304 b 109 363 164 304 151 353 b 88 366 102 364 95 366 b 22 331 52 366 32 343 b -17 255 13 321 -7 287 l 4 243 b 60 321 4 243 29 321 b 68 320 63 321 65 321 b 78 297 75 317 78 308 b 49 180 78 272 65 230 l 0 23 b 0 17 0 22 0 20 b 3 4 0 13 0 7 b 14 0 6 1 10 0 l 94 0 b 109 17 99 0 107 1 b 111 27 109 19 111 23 b 209 302 140 230 186 279 b 225 311 215 308 220 311 b 229 310 226 311 228 311 b 233 304 233 307 233 305 b 233 301 233 302 233 301 b 216 268 220 291 216 279 b 225 243 216 259 219 249 b 262 229 235 232 249 229 b 304 242 279 229 295 235 b 331 308 320 255 331 275 b 272 364 331 341 304 364 z"
        },
        dynamicSforzando: {
            x_min: 0,
            x_max: 208,
            y_min: -5,
            y_max: 263,
            ha: 268,
            o: "m 242 328 b 217 289 222 317 217 300 b 258 249 217 274 230 249 b 298 284 285 249 295 269 b 300 295 300 287 300 291 b 189 379 300 328 272 379 b 49 259 92 379 49 315 b 99 173 49 229 59 196 b 164 137 117 163 140 151 b 194 88 189 122 194 102 b 124 24 194 73 177 24 b 72 46 82 24 72 39 b 73 49 72 48 72 49 b 96 96 78 52 96 62 b 50 150 96 134 72 150 b 0 91 29 150 0 134 b 124 -7 0 26 49 -7 b 282 111 199 -7 282 24 b 171 239 282 197 207 219 b 128 292 135 259 128 268 b 193 347 128 317 156 347 b 242 328 230 347 242 328 z"
        },
        dynamicZ: {
            x_min: -42,
            x_max: 239,
            y_min: -1,
            y_max: 258,
            ha: 259,
            o: "m 229 292 b 235 288 232 292 233 291 b 236 284 236 285 236 285 b 233 278 236 281 235 279 b -42 55 232 276 -4 85 b -60 24 -56 43 -60 33 b -50 4 -60 12 -50 4 b -35 0 -45 1 -40 0 b 9 29 -14 0 1 19 b 50 69 17 43 26 69 b 89 35 75 69 81 50 b 170 -1 104 10 137 -1 b 243 22 197 -1 223 6 b 304 147 288 56 304 118 b 264 196 304 176 294 196 b 226 156 239 196 226 174 b 251 117 226 128 249 122 b 251 108 251 114 251 111 b 243 79 251 98 249 88 b 212 56 236 68 223 56 b 202 59 209 56 204 56 b 163 92 194 63 186 75 b 108 122 140 109 114 120 b 105 125 105 124 105 124 b 107 128 105 127 107 128 b 312 304 107 128 302 294 b 341 340 324 315 336 327 b 344 347 343 341 344 346 l 344 356 b 333 369 343 367 336 369 l 331 369 l 262 363 b 217 361 245 361 230 361 b 156 366 193 361 174 363 b 114 372 147 367 125 372 b 107 370 111 372 108 370 b 86 344 98 367 89 360 b 37 222 72 265 42 232 b 37 219 37 220 37 220 b 50 207 37 213 43 207 l 66 207 b 81 225 75 207 76 215 b 108 291 85 235 105 285 b 118 297 111 297 112 297 b 167 289 125 295 144 291 b 181 289 171 289 177 289 b 229 292 202 289 222 291 z"
        },
        ornamentTrill: {
            x_min: -12,
            x_max: 383,
            y_min: 0,
            y_max: 383,
            ha: 383,
            o: "m 464 396 b 376 359 408 396 376 359 l 364 370 b 346 377 357 377 346 377 l 197 377 l 246 528 b 246 531 246 530 246 531 b 226 552 246 541 236 552 l 213 552 b 199 544 209 552 202 547 b 124 482 196 541 130 487 b 117 471 118 478 117 471 b 84 377 117 471 102 431 l 3 377 b -17 360 -14 377 -17 360 l -17 341 b 3 324 -17 325 3 324 l 66 324 b 0 85 35 229 0 117 b 92 0 0 16 48 0 b 186 35 137 0 186 35 b 194 13 186 35 190 24 b 212 0 199 1 212 0 l 276 0 b 298 16 295 0 298 16 l 298 43 b 321 147 298 75 321 147 l 382 284 b 412 325 382 284 396 311 b 446 341 425 336 438 341 b 452 340 448 341 451 341 b 428 288 432 327 428 305 b 485 233 428 271 446 233 b 552 308 534 233 552 264 b 464 396 552 353 520 396 z m 222 143 b 147 78 210 104 171 78 b 137 79 143 78 140 78 b 121 115 125 85 121 99 b 137 190 121 148 137 190 l 180 324 l 275 324 b 279 320 279 324 279 320 b 222 143 279 320 235 187 z"
        },
        ornamentTurn: {
            x_min: 0,
            x_max: 456,
            y_min: 0,
            y_max: 232,
            ha: 232,
            o: "m 527 334 b 442 269 488 334 442 312 b 501 204 442 228 468 204 b 570 226 533 204 540 226 b 613 164 598 226 613 204 l 613 163 b 550 98 613 127 586 98 b 448 143 508 98 485 109 l 328 255 l 298 284 b 174 334 262 317 223 334 b 0 170 92 334 0 278 b 131 0 0 68 58 0 b 215 65 170 0 215 22 b 156 130 215 107 189 130 b 86 108 124 130 117 108 b 43 170 59 108 43 130 l 43 171 b 108 236 43 207 72 236 b 209 192 150 236 171 225 l 328 79 l 360 50 b 482 0 396 17 433 0 b 657 164 564 0 657 56 b 527 334 657 266 600 334 z"
        },
        ornamentTurnSlash: {
            x_min: 0,
            x_max: 456,
            y_min: -80,
            y_max: 313,
            ha: 393,
            o: "m 527 334 b 442 269 488 334 442 312 b 501 204 442 228 468 204 b 570 226 533 204 540 226 b 613 164 598 226 613 204 l 613 163 b 550 98 613 127 586 98 b 448 143 508 98 485 109 l 354 230 l 354 431 b 336 451 354 442 347 451 l 323 451 b 302 431 311 451 302 442 l 302 279 l 298 284 b 174 334 262 317 223 334 b 0 170 92 334 0 278 b 131 0 0 68 58 0 b 215 65 170 0 215 22 b 156 130 215 107 189 130 b 86 108 124 130 117 108 b 43 170 59 108 43 130 l 43 171 b 108 236 43 207 72 236 b 209 192 150 236 171 225 l 302 104 l 302 -96 b 323 -115 302 -108 311 -115 l 336 -115 b 354 -96 347 -115 354 -108 l 354 55 l 360 50 b 482 0 396 17 433 0 b 657 164 564 0 657 56 b 527 334 657 266 600 334 z"
        },
        ornamentMordent: {
            x_min: 0,
            x_max: 473,
            y_min: -77,
            y_max: 316,
            ha: 393,
            o: "m 647 302 l 562 166 l 446 347 b 429 357 444 353 435 357 b 413 347 423 357 416 353 l 363 262 l 363 435 b 343 455 363 446 354 455 l 331 455 b 311 435 320 455 311 446 l 311 173 l 310 171 l 203 347 b 186 357 200 353 192 357 b 168 347 180 357 171 353 l 0 69 l 35 48 l 120 189 l 226 10 b 243 0 229 4 238 0 b 261 10 249 0 258 4 l 311 95 l 311 -91 b 331 -111 311 -102 320 -111 l 343 -111 b 363 -91 354 -111 363 -102 l 363 184 l 366 189 l 478 10 b 495 0 481 4 490 0 b 513 10 501 0 510 4 l 681 281 z"
        },
        ornamentShortTrill: {
            x_min: 0,
            x_max: 473,
            y_min: 0,
            y_max: 248,
            ha: 248,
            o: "m 647 302 l 562 166 l 446 347 b 431 357 444 353 436 357 b 413 347 425 357 416 353 l 310 171 l 203 347 b 186 357 200 353 192 357 b 168 347 180 357 173 353 l 0 69 l 35 48 l 120 189 l 226 10 b 243 0 229 4 238 0 b 261 10 249 0 258 4 l 366 189 l 478 9 b 495 0 481 3 490 0 b 513 10 501 0 510 4 l 681 281 z"
        },
        ornamentTremblement: {
            x_min: 0,
            x_max: 654,
            y_min: 0,
            y_max: 248,
            ha: 248,
            o: "m 907 302 l 822 166 l 708 348 b 691 357 704 354 701 357 b 674 347 685 357 677 353 l 648 302 l 563 166 l 449 348 b 432 357 446 354 438 357 b 415 347 426 357 418 353 l 415 346 l 311 171 l 203 348 b 186 357 200 354 192 357 b 168 348 177 357 171 354 l 168 347 l 0 69 l 35 48 l 120 190 l 226 10 b 243 0 229 4 238 0 l 245 0 b 261 10 251 0 258 4 l 367 189 l 480 10 b 497 0 482 4 491 0 b 513 10 503 0 510 4 l 625 192 l 739 10 b 756 0 742 4 750 0 b 772 10 762 0 769 4 l 942 282 z"
        },
        ornamentPrecompAppoggTrill: {
            x_min: 0,
            x_max: 680,
            y_min: 0,
            y_max: 388,
            ha: 388,
            o: "m 860 170 l 746 353 b 729 361 743 359 737 361 b 713 351 723 361 716 357 l 685 307 l 600 170 l 487 353 b 481 359 485 356 484 357 b 469 361 478 360 472 361 b 452 351 464 361 455 357 l 348 176 l 240 353 b 223 361 238 359 229 361 b 206 353 215 361 209 359 l 40 76 l 40 541 b 20 559 39 552 30 559 b 0 541 10 559 1 552 l 0 26 b 19 1 0 16 9 4 b 26 0 20 1 24 0 b 48 13 35 0 43 6 l 72 52 l 157 194 l 265 14 b 282 4 268 9 276 4 b 298 14 288 4 295 9 l 405 193 l 517 14 b 534 4 520 9 528 4 b 550 14 540 4 547 9 l 664 196 l 776 14 b 793 4 779 9 788 4 b 811 14 799 4 808 9 l 979 287 l 945 307 z"
        },
        ornamentPrecompSlideTrillDAnglebert: {
            x_min: 0,
            x_max: 662,
            y_min: -158,
            y_max: 248,
            ha: 406,
            o: "m 834 166 l 720 348 b 704 357 717 354 713 357 b 687 348 697 357 690 353 l 661 302 l 660 302 l 575 166 l 461 348 b 455 354 459 350 456 353 b 444 357 452 356 448 357 b 428 347 438 357 431 353 l 323 171 l 215 347 b 213 350 215 348 215 350 b 213 350 213 350 213 350 l 213 351 l 212 351 l 212 353 l 210 353 l 210 353 l 209 354 b 207 354 209 354 207 354 b 197 357 206 356 200 357 b 197 357 197 357 197 357 b 194 357 196 357 196 357 b 180 347 187 357 183 353 l 180 346 l 69 164 b 0 -50 23 88 0 17 b 49 -219 0 -108 16 -163 b 66 -228 52 -223 59 -228 b 76 -225 69 -228 73 -226 b 86 -207 82 -222 86 -215 b 84 -197 86 -204 85 -200 b 40 -52 55 -150 40 -102 b 104 143 40 10 62 73 l 131 190 l 239 10 b 256 0 242 4 249 0 l 256 0 b 272 10 262 0 269 4 l 379 189 l 491 10 b 508 0 494 4 503 0 b 508 0 508 0 508 0 l 508 0 b 526 10 514 0 521 4 l 638 192 l 750 10 b 768 0 755 4 762 0 l 768 0 b 785 10 773 0 782 4 l 785 10 l 953 282 l 919 302 z"
        },
        ornamentPrecompSlideTrillBach: {
            x_min: 0,
            x_max: 662,
            y_min: -158,
            y_max: 321,
            ha: 479,
            o: "m 834 166 l 720 348 b 704 357 716 354 713 357 b 687 348 698 357 690 354 l 660 304 l 660 302 l 632 259 l 632 442 b 612 462 632 454 624 462 l 599 462 b 579 442 588 462 579 454 l 579 173 l 575 166 l 461 348 b 455 356 459 351 458 354 b 445 359 452 357 448 359 b 428 348 439 359 431 354 l 323 171 l 215 347 b 213 350 215 348 213 350 l 213 351 l 212 353 l 210 353 l 210 354 l 207 354 b 197 357 204 356 200 357 b 180 348 189 357 183 354 l 179 346 l 69 164 b 0 -49 23 88 0 19 b 49 -217 0 -107 17 -163 b 66 -228 52 -223 60 -228 b 76 -225 69 -228 73 -226 b 86 -207 82 -222 86 -213 b 84 -197 86 -204 85 -200 b 42 -50 56 -148 42 -101 b 104 144 42 12 62 75 l 131 190 l 239 10 b 256 0 242 4 251 0 b 274 10 262 0 271 4 l 379 190 l 491 10 b 508 0 494 4 503 0 b 526 10 514 0 523 4 l 579 98 l 579 -84 b 599 -104 579 -95 588 -104 l 612 -104 b 632 -84 624 -104 632 -95 l 632 183 l 638 192 l 750 10 b 768 0 753 4 762 0 b 785 10 773 0 782 4 l 953 282 l 919 302 z"
        },
        ornamentPrecompTrillSuffixDandrieu: {
            x_min: 0,
            x_max: 662,
            y_min: 0,
            y_max: 406,
            ha: 406,
            o: "m 904 575 b 887 585 901 580 893 585 b 877 582 884 585 880 583 b 867 564 871 579 867 570 b 870 554 867 562 868 557 b 912 408 897 505 912 458 b 850 213 912 346 891 282 l 822 167 l 714 348 b 697 357 711 354 703 357 b 680 348 691 357 683 354 l 575 168 l 462 348 b 445 357 459 354 451 357 b 428 348 439 357 431 354 l 315 167 l 203 348 b 186 357 200 354 192 357 b 168 348 180 357 171 354 l 0 76 l 35 55 l 120 192 l 233 10 b 249 0 238 4 240 0 b 266 10 255 0 264 4 l 294 55 l 379 192 l 492 9 b 498 3 494 6 495 4 b 508 0 501 1 505 0 b 526 10 514 0 523 4 l 631 186 l 737 13 b 746 3 739 10 743 4 b 756 0 749 1 753 0 b 773 9 762 0 770 3 l 884 193 b 953 406 930 269 953 338 b 904 575 953 464 936 520 z"
        },
        ornamentPrecompDoubleCadenceUpperPrefix: {
            x_min: 0,
            x_max: 857,
            y_min: 0,
            y_max: 248,
            ha: 248,
            o: "m 383 140 b 413 189 399 166 412 187 b 520 10 423 171 516 16 b 537 0 523 4 530 0 b 554 10 543 0 550 4 b 660 189 557 16 649 171 b 772 10 671 173 766 19 b 791 0 778 1 785 0 b 806 10 796 0 802 4 b 919 192 809 16 907 174 l 1031 10 b 1048 0 1035 4 1043 0 l 1048 0 b 1066 10 1054 1 1063 4 l 1066 10 l 1234 282 l 1200 302 l 1115 166 l 1002 348 b 985 357 998 354 994 357 b 968 348 978 357 971 353 l 855 166 b 742 348 845 183 746 341 b 726 357 737 354 732 357 b 708 348 719 357 711 354 b 603 171 704 341 613 189 b 495 348 593 189 498 343 b 478 357 492 353 487 357 b 461 348 469 357 464 353 b 357 173 459 346 393 235 b 213 79 320 111 284 79 b 66 176 143 79 95 112 b 40 279 43 228 40 275 b 20 300 40 291 30 300 b 0 278 9 300 0 289 b 29 161 0 276 3 219 b 213 39 65 81 130 39 b 383 140 297 39 346 73 z"
        },
        ornamentPrecompTrillLowerSuffix: {
            x_min: 0,
            x_max: 565,
            y_min: -171,
            y_max: 249,
            ha: 420,
            o: "m 347 168 l 235 348 b 217 359 230 354 226 359 b 200 348 209 359 203 353 b 3 30 197 344 6 35 b 0 20 0 26 0 24 b 22 0 0 9 10 0 b 37 9 27 0 35 3 l 151 192 b 265 10 161 174 262 13 b 281 0 268 6 272 0 b 298 10 289 0 295 3 l 403 186 l 511 10 b 528 0 516 4 521 0 b 546 10 537 0 541 4 l 698 265 b 775 22 744 202 775 112 b 700 -215 775 -60 752 -144 b 696 -226 697 -219 696 -222 b 704 -243 696 -232 700 -239 b 717 -246 708 -246 713 -246 b 733 -239 723 -246 729 -243 b 814 20 789 -160 814 -69 b 711 312 814 132 773 242 b 696 320 707 317 700 320 b 680 310 691 320 684 318 b 595 168 671 297 602 181 l 488 348 b 471 359 484 354 478 359 b 454 348 464 359 456 353 b 347 168 449 343 357 186 z"
        },
        brassMuteClosed: {
            x_min: 0,
            x_max: 312,
            y_min: 0,
            y_max: 312,
            ha: 312,
            o: "m 22 256 b 0 225 7 256 0 240 b 22 193 0 209 7 193 l 193 193 l 193 22 b 225 0 193 7 209 0 b 256 22 240 0 256 7 l 256 193 l 428 193 b 449 225 442 193 449 209 b 428 256 449 240 442 256 l 256 256 l 256 428 b 225 449 256 442 240 449 b 193 428 209 449 193 442 l 193 256 z"
        },
        brassMuteOpen: {
            x_min: 0,
            x_max: 280,
            y_min: 0,
            y_max: 280,
            ha: 280,
            o: "m 202 403 b 0 202 91 403 0 312 b 202 0 0 91 91 0 b 403 202 312 0 403 91 b 202 403 403 312 312 403 z m 202 40 b 40 202 112 40 40 112 b 202 363 40 291 112 363 b 363 202 291 363 363 291 b 202 40 363 112 291 40 z"
        },
        stringsDownBow: {
            x_min: 0,
            x_max: 315,
            y_min: 0,
            y_max: 293,
            ha: 293,
            o: "m 40 0 l 40 291 l 413 291 l 413 0 l 454 0 l 454 402 b 433 422 454 413 445 422 l 20 422 b 0 402 9 422 0 402 l 0 0 z"
        },
        stringsUpBow: {
            x_min: 0,
            x_max: 262,
            y_min: 0,
            y_max: 343,
            ha: 343,
            o: "m 374 485 b 357 494 372 490 363 494 l 337 494 b 318 481 330 494 321 488 l 189 118 l 59 481 b 40 494 56 488 48 494 l 20 494 b 0 474 9 494 0 485 b 1 467 0 472 1 468 l 170 13 b 189 0 173 6 181 0 b 207 13 196 0 204 6 l 376 467 b 377 474 376 468 377 472 b 374 485 377 477 376 482 z"
        },
        stringsHarmonic: {
            x_min: 0,
            x_max: 181,
            y_min: 0,
            y_max: 181,
            ha: 181,
            o: "m 131 220 b 220 131 181 220 220 181 b 131 40 220 81 181 40 b 40 131 81 40 40 81 b 131 220 40 181 81 220 z m 131 261 b 0 131 59 261 0 203 b 131 0 0 59 59 0 b 261 131 203 0 261 59 b 131 261 261 203 203 261 z"
        },
        pluckedSnapPizzicatoAbove: {
            x_min: 0,
            x_max: 269,
            y_min: 0,
            y_max: 389,
            ha: 389,
            o: "m 213 540 b 194 560 213 552 204 560 b 174 540 183 560 174 552 l 174 386 b 0 193 76 376 0 294 b 194 0 0 86 86 0 b 387 193 301 0 387 86 b 213 386 387 294 311 376 z m 194 40 b 40 193 109 40 40 109 b 174 346 40 271 98 336 l 174 193 b 194 173 174 183 183 173 b 213 193 204 173 213 183 l 213 346 b 347 193 289 336 347 271 b 194 40 347 109 278 40 z"
        },
        pluckedSnapPizzicatoBelow: {
            x_min: 0,
            x_max: 269,
            y_min: 0,
            y_max: 389,
            ha: 389,
            o: "m 213 174 b 387 367 311 184 387 266 b 193 560 387 474 301 560 b 0 367 86 560 0 474 b 174 174 0 266 76 184 l 174 20 b 194 0 174 9 183 0 b 213 20 204 0 213 9 z m 194 520 b 347 367 278 520 347 452 b 213 215 347 289 289 225 l 213 367 b 194 387 213 377 204 387 b 174 367 183 387 174 377 l 174 215 b 40 367 98 225 40 289 b 194 520 40 452 109 520 z"
        },
        keyboardPedalPed: {
            x_min: 0,
            x_max: 981,
            y_min: -10,
            y_max: 545,
            ha: 555,
            o: "m 1354 12 b 1413 78 1385 12 1413 42 b 1354 145 1413 115 1385 145 b 1293 78 1320 145 1293 115 b 1354 12 1293 42 1320 12 z m 1092 88 b 1080 86 1089 86 1084 86 b 1004 203 1037 86 1004 137 b 1107 376 1004 360 1097 374 b 1149 209 1129 336 1149 287 b 1092 88 1149 117 1130 95 z m 752 393 b 795 344 779 393 795 372 b 770 285 795 325 788 304 b 693 203 737 249 697 207 b 688 264 690 225 688 245 b 752 393 688 347 714 393 z m 245 507 b 220 544 245 533 235 544 b 217 544 219 544 219 544 b 186 510 206 546 192 537 b 143 464 179 478 163 464 b 134 465 140 464 137 464 b 102 516 117 467 102 487 b 141 613 102 541 112 576 b 347 721 212 711 315 721 b 356 721 351 721 354 721 b 275 560 344 701 297 616 b 259 495 274 557 259 528 b 272 452 259 480 264 465 b 373 323 297 416 350 354 b 387 284 382 311 387 298 b 350 222 387 265 376 245 b 230 140 301 180 252 154 b 128 39 215 130 128 92 b 134 12 128 30 130 22 b 173 -14 144 -7 157 -14 b 264 40 204 -14 243 17 b 333 98 281 58 302 98 b 389 39 357 98 373 60 b 478 -10 416 1 435 -10 b 622 96 527 -10 559 43 b 740 -10 626 86 667 -10 b 929 95 827 -10 917 85 b 1086 -12 950 37 1018 -12 b 1120 -7 1097 -12 1109 -10 b 1264 213 1212 17 1264 111 b 1263 248 1264 225 1263 236 b 815 664 1228 544 907 647 b 785 668 805 665 795 668 b 779 668 783 668 782 668 b 757 654 769 668 760 665 b 757 649 757 652 757 651 b 786 618 759 629 783 619 b 818 606 796 613 808 611 b 1071 435 1007 534 1066 445 b 909 181 930 386 909 256 b 910 141 909 164 909 151 b 786 78 899 127 844 78 b 708 151 726 78 710 144 b 799 230 711 154 742 181 b 864 350 845 271 864 312 b 757 456 864 410 815 456 b 599 222 644 456 599 328 b 609 141 599 192 602 164 b 563 104 608 140 595 122 b 540 98 556 99 549 98 b 459 140 513 98 480 118 b 397 184 413 189 399 184 b 475 279 403 189 454 226 b 482 311 480 289 482 300 b 449 410 482 359 452 405 b 361 533 442 419 383 503 b 354 560 356 541 354 550 b 386 651 353 588 372 622 b 429 713 405 693 426 710 b 557 592 521 688 557 628 b 549 569 557 582 554 573 b 523 559 540 562 531 559 b 459 592 495 559 469 583 b 425 613 451 600 438 613 b 409 608 419 613 415 612 b 399 586 402 602 399 595 b 399 583 397 585 399 585 b 409 552 399 573 405 562 b 541 458 441 487 492 458 b 608 480 564 458 588 465 b 648 572 632 497 648 531 b 429 778 648 649 589 749 b 351 785 402 782 376 785 b 0 507 130 785 0 615 b 127 366 0 399 68 366 b 245 507 186 366 245 429 z"
        },
        keyboardPedalUp: {
            x_min: 0,
            x_max: 473,
            y_min: 0,
            y_max: 473,
            ha: 473,
            o: "m 99 99 b 164 69 120 79 143 69 b 199 82 177 69 190 73 b 210 114 206 89 210 102 b 206 137 210 122 209 130 b 200 160 203 145 200 154 b 210 179 200 166 203 171 l 245 215 b 285 213 255 225 272 219 l 287 213 l 288 212 b 318 183 301 206 318 196 l 318 134 b 291 102 318 112 308 112 b 258 58 274 92 258 76 b 340 0 258 26 294 0 b 423 58 386 0 423 26 b 390 102 423 76 408 92 b 361 134 373 112 361 112 l 361 183 b 392 212 361 196 379 206 b 395 213 393 212 393 213 b 436 215 408 219 426 225 l 471 179 b 480 161 478 171 480 167 b 474 137 480 154 477 147 b 471 115 472 130 471 122 b 482 82 471 102 474 91 b 517 69 491 73 504 69 b 582 99 539 69 562 79 b 612 164 602 120 612 143 b 599 199 612 177 608 190 b 567 210 592 206 579 210 b 544 206 559 210 552 209 b 521 200 536 203 528 200 b 501 210 514 200 508 203 l 467 245 b 468 285 456 255 462 272 l 468 287 b 469 288 468 287 469 287 b 498 318 475 301 485 318 l 547 318 b 579 291 569 318 569 308 b 624 258 589 274 605 258 b 681 340 655 258 681 294 b 624 423 681 386 655 423 b 579 390 605 423 589 408 b 547 361 569 373 569 361 l 498 361 b 469 392 485 361 475 379 b 468 395 469 393 468 393 b 467 436 462 408 456 426 l 501 471 b 520 480 508 478 514 480 b 544 474 527 480 534 477 b 566 471 552 472 559 471 b 599 482 579 471 590 474 b 612 516 608 491 612 503 b 582 580 612 536 602 560 b 516 612 562 600 537 612 b 482 599 503 612 491 608 b 471 566 474 590 471 579 b 474 544 471 559 472 552 b 480 520 477 534 480 527 b 471 501 480 514 478 508 l 436 467 b 395 468 426 456 408 462 b 392 469 393 468 393 469 b 361 498 379 475 361 485 l 361 547 b 390 579 361 569 373 569 b 423 624 408 589 423 605 b 340 681 423 655 386 681 b 258 624 294 681 258 655 b 291 579 258 605 274 589 b 318 547 308 569 318 569 l 318 498 b 288 469 318 485 301 475 l 287 468 l 285 468 b 245 467 272 462 255 456 l 210 501 b 200 521 203 508 200 514 b 206 544 200 528 203 536 b 210 567 209 552 210 559 b 199 599 210 579 206 592 b 164 612 190 608 177 612 b 99 582 143 612 120 602 b 69 517 79 562 69 539 b 82 482 69 504 73 491 b 115 471 91 474 102 471 b 137 474 122 471 130 472 b 161 480 147 477 154 480 b 180 471 167 480 173 478 l 215 436 b 213 395 225 426 219 408 b 212 392 213 393 212 393 b 183 361 206 379 196 361 l 134 361 b 102 390 112 361 112 373 b 58 423 92 408 76 423 b 0 340 26 423 0 386 b 58 258 0 294 26 258 b 102 291 76 258 92 274 b 134 318 112 308 112 318 l 183 318 b 212 288 196 318 206 301 b 213 287 212 287 213 288 l 213 285 b 215 245 219 272 225 255 l 179 210 b 160 200 171 203 166 200 b 137 206 154 200 145 203 b 114 210 130 209 122 210 b 82 199 102 210 89 206 b 69 164 73 190 69 177 b 99 99 69 143 79 120 z m 276 276 b 249 340 262 291 249 320 b 340 432 249 390 289 432 b 432 340 390 432 432 390 b 405 276 432 320 419 291 b 340 249 390 262 360 249 b 276 276 320 249 291 262 z"
        },
        wiggleArpeggiatoUp: {
            x_min: -22,
            x_max: 242,
            y_min: 0,
            y_max: 164,
            ha: 164,
            o: "m 343 122 b 323 143 343 122 334 132 b 308 148 318 147 312 148 b 298 144 304 148 301 147 b 282 128 295 141 291 137 b 274 124 279 125 276 124 b 265 128 268 124 265 128 b 158 220 265 128 173 207 b 112 236 143 232 127 236 b 43 206 82 236 55 219 l -26 137 b -32 125 -30 132 -32 130 b -26 112 -32 118 -26 112 b -6 92 -26 112 -17 102 b 7 86 -1 88 3 86 b 17 91 12 86 14 88 b 33 107 20 94 24 98 b 42 111 36 109 39 111 b 52 107 48 111 52 107 b 158 16 52 107 144 29 b 204 0 174 4 190 0 b 274 30 235 0 262 17 l 343 99 b 348 111 347 104 348 108 b 343 122 348 118 343 122 z"
        },
        repeat1Bar: {
            x_min: 0,
            x_max: 481,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m 183 180 b 92 271 183 230 141 271 b 1 180 42 271 1 230 b 92 89 1 130 42 89 b 183 180 141 89 183 130 z m 693 360 l 511 360 l 0 -360 l 181 -360 z m 693 -181 b 602 -91 693 -131 651 -91 b 511 -181 552 -91 511 -131 b 602 -272 511 -232 552 -272 b 693 -181 651 -272 693 -232 z"
        },
        repeat2Bars: {
            x_min: 0,
            x_max: 735,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m 1058 -181 b 968 -91 1058 -131 1017 -91 b 877 -181 917 -91 877 -131 b 968 -272 877 -232 917 -272 b 1058 -181 1017 -272 1058 -232 z m 183 180 b 92 271 183 230 141 271 b 1 180 42 271 1 230 b 92 89 1 130 42 89 b 183 180 141 89 183 130 z m 693 360 l 511 360 l 0 -360 l 181 -360 z m 1058 360 l 877 360 l 366 -360 l 547 -360 z"
        },
        repeat4Bars: {
            x_min: 0,
            x_max: 1243,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m 183 180 b 92 271 183 230 141 271 b 1 180 42 271 1 230 b 92 89 1 130 42 89 b 183 180 141 89 183 130 z m 693 360 l 511 360 l 0 -360 l 181 -360 z m 1058 360 l 877 360 l 366 -360 l 547 -360 z m 1424 360 l 1243 360 l 732 -360 l 913 -360 z m 1790 360 l 1608 360 l 1097 -360 l 1279 -360 z m 1790 -181 b 1699 -91 1790 -131 1748 -91 b 1608 -181 1649 -91 1608 -131 b 1699 -272 1608 -232 1649 -272 b 1790 -181 1748 -272 1790 -232 z"
        },
        repeatBarSlash: {
            x_min: 0,
            x_max: 481,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m 693 360 l 511 360 l 0 -360 l 181 -360 z"
        },
        csymDiminished: {
            x_min: 0,
            x_max: 501,
            y_min: 0,
            y_max: 501,
            ha: 501,
            o: "m 361 721 b 0 361 161 721 0 560 b 361 0 0 161 161 0 b 721 361 560 0 721 161 b 361 721 721 560 560 721 z m 557 164 b 361 82 505 111 435 82 b 164 164 287 82 216 111 b 82 361 111 216 82 287 b 164 557 82 436 111 505 b 361 639 216 611 287 639 b 557 557 436 639 505 611 b 639 361 611 505 639 436 b 557 164 639 287 609 216 z"
        },
        csymHalfDiminished: {
            x_min: -1,
            x_max: 502,
            y_min: -1,
            y_max: 502,
            ha: 503,
            o: "m 723 684 l 684 723 l 596 634 b 361 721 533 688 451 721 b 0 361 161 721 0 560 b 88 125 0 271 33 189 l -1 36 l 36 -1 l 125 88 b 361 0 189 33 271 0 b 721 361 560 0 721 161 b 634 596 721 451 688 533 z m 82 361 b 164 557 82 436 111 505 b 361 639 216 611 287 639 b 537 576 426 639 488 616 l 145 184 b 82 361 105 233 82 295 z m 639 361 b 557 164 639 287 609 216 b 361 82 505 111 435 82 b 184 145 295 82 233 105 l 576 537 b 639 361 616 488 639 426 z"
        },
        csymAugmented: {
            x_min: 1,
            x_max: 321,
            y_min: 90,
            y_max: 410,
            ha: 320,
            o: "m 462 400 l 272 400 l 272 590 l 192 590 l 192 400 l 1 400 l 1 320 l 192 320 l 192 130 l 272 130 l 272 320 l 462 320 z"
        },
        csymMajorSeventh: {
            x_min: 0,
            x_max: 500,
            y_min: 10,
            y_max: 490,
            ha: 480,
            o: "m 360 528 l 585 96 l 135 96 z m 360 706 l 0 14 l 720 14 z"
        },
        accidentalNarrowReversedFlat: {
            x_min: 0,
            x_max: 160,
            y_min: -176,
            y_max: 452,
            ha: 628,
            o: "m 0 84 b 101 -153 0 -26 65 -107 b 196 -249 153 -217 196 -249 b 206 -253 199 -251 202 -253 b 225 -235 216 -253 225 -245 l 230 632 b 212 651 230 642 222 651 l 199 651 b 180 632 189 651 180 642 l 184 204 b 125 217 184 204 171 217 b 0 84 53 217 0 173 z m 145 154 b 184 107 181 154 184 120 l 187 -179 b 114 -72 167 -158 132 -112 b 82 58 86 -13 82 36 b 145 154 82 79 82 154 z"
        },
        accidentalNarrowReversedFlatAndFlat: {
            x_min: 0,
            x_max: 416,
            y_min: -176,
            y_max: 452,
            ha: 628,
            o: "m 462 217 b 330 174 374 217 338 181 l 334 632 b 315 651 334 642 325 651 l 302 651 b 284 632 292 651 284 642 l 289 -235 b 308 -253 289 -245 298 -253 b 320 -249 312 -253 317 -251 b 492 -138 320 -249 433 -194 b 599 84 534 -98 599 -26 b 462 217 599 173 534 217 z m 501 58 b 459 -72 501 36 498 -19 b 327 -179 431 -111 359 -164 l 330 85 l 330 91 b 422 154 330 125 359 154 b 501 58 503 154 501 79 z m 0 84 b 101 -153 0 -26 65 -107 b 196 -249 153 -217 196 -249 b 206 -253 199 -251 202 -253 b 225 -235 216 -253 225 -245 l 230 632 b 212 651 230 642 222 651 l 199 651 b 180 632 189 651 180 642 l 184 204 b 125 217 184 204 171 217 b 0 84 53 217 0 173 z m 145 154 b 184 107 181 154 184 120 l 187 -179 b 114 -72 167 -158 132 -112 b 82 58 86 -13 82 36 b 145 154 82 79 82 154 z"
        }
    },
    fontFamily: "Leland",
    resolution: 1e3,
    generatedOn: "2022-12-19T23:52:37.756Z"
};
// node_modules/vexflow/build/esm/src/fonts/load_leland.js
function $a801f2c896bd09f1$var$loadLeland() {
    $a801f2c896bd09f1$var$Font.load("Leland", $a801f2c896bd09f1$var$LelandFont, $a801f2c896bd09f1$var$CommonMetrics);
}
// node_modules/vexflow/build/esm/src/fonts/petaluma_glyphs.js
var $a801f2c896bd09f1$var$PetalumaFont = {
    glyphs: {
        bracketTop: {
            x_min: 0,
            x_max: 508,
            y_min: 0,
            y_max: 370,
            ha: 370,
            o: "m 22 0 b 122 0 55 1 89 0 l 157 0 b 713 376 425 0 622 137 b 732 467 724 406 732 436 b 726 514 732 482 730 498 b 711 533 723 528 719 533 b 693 526 707 533 700 530 b 674 498 683 520 678 508 b 635 406 662 467 652 435 b 310 164 560 281 458 193 b 154 151 258 154 206 151 b 39 154 117 151 78 154 b 1 120 17 154 4 145 b 0 84 0 108 0 96 b 0 20 0 63 1 40 b 22 0 0 4 7 0 z"
        },
        bracketBottom: {
            x_min: 0,
            x_max: 496,
            y_min: -393,
            y_max: 0,
            ha: 393,
            o: "m 696 -566 b 711 -539 713 -566 708 -549 b 714 -521 713 -533 714 -527 b 713 -508 714 -517 713 -513 b 661 -327 706 -445 688 -384 b 392 -42 603 -203 513 -109 b 206 0 331 -7 266 0 b 160 -1 190 0 174 -1 b 26 -1 107 -1 66 -3 b 0 -19 12 -1 0 -4 l 0 -23 b 3 -50 1 -32 3 -42 b 1 -86 3 -62 1 -73 b 4 -118 1 -96 1 -108 b 45 -151 10 -145 23 -154 b 180 -143 89 -144 135 -145 b 621 -419 392 -135 523 -236 b 662 -539 641 -456 655 -497 b 696 -566 667 -557 680 -566 z"
        },
        barlineTick: {
            x_min: 0,
            x_max: 56,
            y_min: 877,
            y_max: 1122,
            ha: 245,
            o: "m 42 1263 b 66 1287 62 1261 66 1272 b 81 1583 65 1387 72 1485 b 35 1614 82 1610 53 1610 b 14 1591 17 1619 16 1604 b 0 1408 7 1525 0 1459 l 0 1292 b 42 1263 1 1263 23 1266 z"
        },
        breathMarkTick: {
            x_min: 0,
            x_max: 568,
            y_min: 0,
            y_max: 621,
            ha: 621,
            o: "m 258 0 b 278 39 276 0 274 24 b 279 56 279 45 279 50 l 279 73 b 278 117 279 88 278 102 b 281 148 278 127 279 138 b 536 600 312 330 387 487 b 744 719 600 651 670 690 b 815 779 775 730 808 740 b 818 824 818 793 818 808 b 815 868 818 838 818 852 b 796 894 814 881 808 894 b 779 888 791 894 786 893 b 719 864 760 878 739 871 b 372 602 580 806 459 724 b 229 252 298 498 251 383 b 220 268 225 262 222 264 b 209 302 217 279 213 291 b 75 527 181 387 143 467 b 16 563 58 543 39 573 b 0 539 3 557 0 549 b 12 492 0 524 9 507 b 56 400 19 459 22 425 b 163 269 104 367 138 323 b 238 36 197 194 216 115 b 258 0 242 22 243 0 z"
        },
        segno: {
            x_min: 0,
            x_max: 798,
            y_min: -65,
            y_max: 806,
            ha: 871,
            o: "m 16 -94 b 66 -69 39 -92 53 -85 b 177 59 102 -26 138 17 b 543 456 298 192 420 324 b 726 300 615 420 680 373 b 753 217 744 271 753 243 b 655 112 753 170 719 131 b 599 104 636 107 618 104 b 461 173 544 104 495 128 b 432 190 454 183 444 190 b 409 179 425 190 418 187 b 359 118 390 160 373 141 b 341 72 347 101 341 86 b 373 24 341 56 351 40 b 409 6 384 17 396 10 b 550 -13 454 -12 501 -14 b 599 -6 566 -12 583 -10 b 864 213 720 27 806 104 b 886 300 878 242 886 271 b 857 395 886 331 877 363 b 799 467 840 420 821 445 b 648 572 755 513 704 546 b 1110 1083 802 743 955 914 b 1140 1129 1123 1097 1136 1110 b 1149 1148 1142 1135 1149 1142 b 1145 1153 1149 1149 1148 1152 b 1123 1161 1139 1158 1130 1161 b 1109 1156 1119 1161 1113 1159 b 1089 1138 1102 1151 1094 1145 b 946 988 1040 1089 989 1041 b 595 602 834 855 711 732 l 590 598 l 549 615 b 432 793 462 647 432 723 b 534 888 432 851 474 888 b 671 834 588 888 631 864 b 710 818 684 824 696 818 b 724 821 714 818 719 819 b 809 883 757 834 788 852 b 816 901 814 890 816 896 b 802 923 816 910 812 916 b 706 984 770 945 742 971 b 593 1011 668 998 631 1011 b 516 991 567 1011 541 1005 b 333 799 433 949 380 876 b 302 693 312 765 302 729 b 330 589 302 658 311 624 b 469 488 360 533 415 511 b 485 482 475 487 480 485 b 266 249 412 405 338 327 b 121 88 217 196 170 141 b 9 -65 78 40 37 -7 b 0 -85 4 -72 0 -79 b 16 -94 0 -91 4 -94 z m 861 536 b 927 575 890 539 909 557 b 965 628 952 598 965 613 b 926 680 965 644 952 658 b 865 713 900 701 883 713 b 805 667 845 713 828 698 b 768 611 791 649 770 631 b 812 564 766 589 798 582 b 861 536 824 550 840 537 z m 251 350 b 363 436 285 348 353 403 b 354 456 366 448 360 452 b 271 518 327 477 298 497 b 243 528 261 526 252 528 b 210 513 232 528 222 523 b 157 454 190 494 176 472 b 141 428 147 444 141 436 b 158 406 141 420 147 413 b 216 361 180 393 197 376 b 245 350 225 356 235 350 z"
        },
        coda: {
            x_min: 0,
            x_max: 1380,
            y_min: -196,
            y_max: 1037,
            ha: 1233,
            o: "m 1028 -282 b 1057 -245 1045 -282 1053 -261 b 1060 -203 1060 -232 1060 -217 b 1063 9 1060 -132 1061 -62 b 1390 194 1192 22 1303 81 b 1531 543 1467 298 1512 415 b 1532 556 1531 547 1532 552 b 1904 559 1656 557 1780 559 b 1950 582 1920 559 1941 569 b 1987 674 1970 609 1987 638 b 1984 698 1987 681 1986 690 b 1950 700 1973 698 1961 700 l 1941 700 l 1545 696 b 1535 776 1545 723 1541 749 b 1103 1113 1477 996 1326 1107 b 1080 1115 1096 1115 1087 1115 b 1081 1322 1080 1184 1080 1253 b 1079 1467 1083 1371 1081 1418 b 1061 1493 1079 1476 1080 1493 l 1060 1493 b 1028 1467 1044 1490 1031 1485 b 1020 1403 1025 1446 1020 1424 b 1017 1110 1020 1305 1018 1208 l 962 1106 b 569 914 808 1087 671 1035 b 451 683 510 844 472 766 l 161 678 b 118 680 148 678 132 680 b 79 670 101 680 86 678 b 0 544 48 636 29 592 l 37 544 l 429 549 b 428 518 428 539 428 528 b 488 285 428 435 458 360 b 681 81 526 192 593 124 b 946 9 763 40 854 19 b 1008 6 966 7 988 6 b 1005 -137 1008 -42 1005 -89 b 1012 -243 1005 -173 1005 -209 b 1028 -282 1015 -258 1011 -282 z m 1074 690 b 1079 935 1077 772 1077 852 b 1326 855 1166 932 1250 909 b 1446 694 1385 814 1426 759 b 1269 693 1387 694 1328 693 b 1074 690 1204 693 1139 691 z m 577 684 b 766 874 618 763 678 828 b 989 932 837 912 913 923 b 1015 933 998 932 1007 933 b 1014 822 1015 896 1014 860 b 1011 688 1012 791 1012 743 z m 1067 184 b 1071 553 1070 307 1068 429 b 1439 556 1194 553 1316 554 b 1437 554 1439 554 1437 554 b 1341 337 1413 478 1387 402 b 1119 192 1286 261 1211 212 b 1067 184 1102 189 1084 186 z m 1008 180 b 660 264 886 181 770 212 b 524 471 570 305 524 374 b 528 524 524 488 526 505 l 533 549 b 792 552 619 550 706 550 b 1009 553 865 553 937 552 b 1008 180 1009 428 1008 288 z"
        },
        gClef: {
            x_min: 0,
            x_max: 664,
            y_min: -559,
            y_max: 1009,
            ha: 1568,
            o: "m 343 -805 b 366 -801 350 -805 357 -804 b 409 -773 383 -795 397 -786 b 582 -328 528 -648 577 -497 b 583 -294 582 -315 583 -294 b 612 -279 583 -294 603 -282 b 747 -197 660 -256 706 -230 b 949 143 857 -109 920 10 b 956 206 955 164 956 186 b 791 384 956 297 906 363 b 704 393 762 390 733 393 b 498 336 632 393 563 374 b 481 325 490 331 481 325 l 444 465 b 442 485 442 472 442 485 b 609 880 442 485 589 746 b 619 996 616 919 619 958 b 613 1084 619 1027 618 1056 b 534 1387 599 1188 560 1286 b 482 1453 527 1417 517 1453 b 422 1407 456 1453 438 1428 b 305 1063 348 1305 312 1188 b 304 1002 304 1043 304 1022 b 338 654 304 886 323 769 b 343 629 338 645 341 636 b 144 356 278 537 206 451 b 23 144 101 288 53 220 b 0 20 7 107 0 63 b 82 -210 0 -69 30 -160 b 207 -288 112 -239 160 -271 b 410 -328 274 -312 340 -328 b 474 -324 431 -328 452 -327 l 491 -321 b 491 -341 491 -321 492 -334 b 402 -585 475 -428 454 -513 b 294 -668 374 -622 348 -664 b 271 -693 278 -670 271 -680 b 274 -708 271 -698 272 -703 b 302 -775 282 -730 292 -753 b 343 -805 311 -795 325 -805 z m 400 717 b 382 922 389 786 382 854 b 481 1286 382 1047 408 1169 b 507 1125 498 1233 507 1179 b 500 1040 507 1097 504 1068 b 400 717 481 927 455 818 z m 252 -135 b 196 -121 232 -134 215 -127 b 117 -69 158 -108 127 -94 b 111 -32 112 -58 111 -45 b 117 19 111 -16 114 1 b 130 56 118 27 127 52 b 324 337 186 156 253 246 l 384 416 l 395 384 b 416 291 406 348 416 291 b 350 213 416 291 376 239 b 243 -42 278 143 243 55 b 251 -117 243 -66 246 -91 b 252 -135 252 -122 252 -127 z m 563 -91 b 510 168 552 3 530 78 b 513 192 508 179 508 186 b 624 202 550 199 586 202 b 730 192 660 202 694 199 b 850 141 773 183 816 176 b 858 134 852 138 855 135 b 595 -121 801 19 716 -68 l 569 -131 z m 410 -160 b 311 -147 360 -160 311 -147 b 307 -98 311 -147 307 -127 b 314 -33 307 -79 308 -56 b 429 131 328 36 377 85 b 441 138 433 135 438 138 b 449 122 446 138 448 132 b 490 -131 462 37 484 -46 b 490 -153 491 -140 490 -153 b 410 -160 490 -153 452 -163 z"
        },
        cClef: {
            x_min: 0,
            x_max: 731,
            y_min: -543,
            y_max: 543,
            ha: 1086,
            o: "m 131 -782 b 141 -755 138 -782 140 -773 b 147 -490 143 -667 145 -577 b 160 207 150 -258 153 -24 b 168 618 164 344 158 481 b 81 768 173 690 132 732 b 45 782 66 778 55 782 b 3 740 26 782 13 768 b 0 724 1 736 0 730 l 1 710 b 4 596 4 672 4 634 l 4 382 b 9 102 4 288 4 196 b 17 -301 13 -32 10 -166 l 17 -672 b 50 -736 17 -701 27 -720 b 109 -772 69 -749 91 -759 b 131 -782 120 -778 127 -782 z m 615 -770 b 881 -684 710 -770 801 -739 b 1020 -395 986 -612 1020 -510 b 1017 -334 1020 -374 1018 -354 b 769 -62 1007 -209 896 -75 b 746 -60 762 -60 755 -60 b 639 -73 710 -60 675 -69 b 524 -109 598 -79 560 -92 b 528 -36 526 -85 528 -60 b 527 -4 528 -26 528 -14 b 528 39 527 10 528 24 b 526 99 528 59 527 79 b 592 94 549 95 570 94 b 648 99 611 94 629 95 b 912 157 744 94 844 117 b 1053 377 1009 215 1053 284 b 1050 425 1053 393 1053 409 b 914 665 1037 521 986 602 b 717 753 855 717 791 753 b 626 734 688 753 658 747 l 462 665 b 347 500 374 628 347 580 b 350 449 347 484 348 468 b 392 419 353 428 367 416 b 492 438 425 425 459 428 b 541 498 524 448 541 468 b 540 514 541 503 541 508 b 537 546 537 524 537 536 b 573 639 537 580 550 611 b 606 657 582 649 593 657 l 609 657 b 716 622 647 652 684 647 b 834 372 801 556 834 469 b 831 323 834 356 832 338 b 743 187 825 266 795 217 b 710 176 732 180 720 176 b 694 179 704 176 700 177 b 527 223 638 193 582 206 b 495 229 516 228 505 229 b 454 220 481 229 468 225 b 395 189 432 213 415 200 b 363 180 384 186 374 181 b 348 168 356 179 348 176 b 340 161 343 167 340 164 b 347 150 340 157 343 154 b 356 147 348 148 353 147 b 364 92 361 130 363 111 b 369 -37 367 49 369 6 b 363 -154 369 -76 367 -115 b 357 -236 360 -183 357 -210 b 376 -264 357 -253 361 -259 b 456 -289 402 -284 429 -289 b 521 -282 478 -289 500 -285 b 549 -255 537 -279 546 -271 b 598 -177 556 -225 577 -202 b 622 -164 605 -168 613 -164 b 636 -167 626 -164 631 -166 b 749 -225 678 -177 714 -199 b 848 -405 814 -276 848 -337 b 824 -507 848 -436 840 -471 b 657 -657 792 -582 730 -625 b 608 -668 638 -664 622 -668 b 534 -602 572 -668 547 -645 b 513 -575 530 -589 523 -575 b 507 -576 510 -575 508 -575 b 478 -582 497 -580 488 -582 b 405 -570 454 -582 428 -570 b 389 -572 399 -570 395 -570 l 363 -572 b 321 -575 348 -572 333 -569 l 321 631 b 323 662 323 641 323 652 b 315 716 323 681 321 698 b 304 736 314 723 317 736 l 302 736 b 281 716 294 734 285 729 b 275 665 276 700 275 683 l 275 382 b 276 99 275 288 275 193 b 279 -170 278 10 276 -81 b 284 -399 282 -246 284 -323 b 282 -629 284 -475 282 -553 b 289 -721 282 -660 289 -690 b 300 -736 289 -727 291 -736 b 312 -724 307 -736 310 -730 b 321 -667 323 -706 321 -687 l 321 -632 l 328 -644 l 340 -657 b 510 -757 386 -707 445 -740 b 615 -770 546 -766 580 -770 z"
        },
        fClef: {
            x_min: 0,
            x_max: 776,
            y_min: -496,
            y_max: 216,
            ha: 712,
            o: "m 402 -706 b 804 -405 592 -678 716 -566 b 876 -53 861 -298 874 -183 b 868 33 876 -32 873 1 b 560 311 845 217 723 311 b 524 310 549 311 536 311 b 131 134 373 297 239 242 b 17 -29 84 86 37 39 b 9 -89 12 -50 9 -71 b 112 -238 9 -154 43 -206 b 124 -243 117 -239 120 -242 b 186 -261 145 -255 166 -261 b 268 -228 215 -261 242 -249 b 351 -59 325 -181 351 -124 b 343 10 351 -36 348 -13 b 340 36 341 19 340 27 b 409 105 340 75 363 102 b 441 107 420 107 431 107 b 624 36 510 107 573 86 b 744 -200 688 -27 724 -109 b 747 -230 747 -210 747 -222 b 717 -323 747 -264 736 -292 b 608 -445 688 -370 654 -410 b 307 -541 518 -513 415 -541 l 213 -541 b 39 -521 154 -541 96 -539 b 0 -552 17 -514 0 -531 b 1 -564 0 -556 0 -560 b 17 -611 6 -580 10 -596 b 101 -694 35 -648 50 -684 b 288 -714 164 -707 225 -714 b 402 -706 325 -714 363 -711 z m 1018 92 b 1080 118 1041 91 1068 96 b 1117 219 1099 150 1117 180 b 1113 252 1117 229 1116 240 b 1045 288 1102 297 1068 276 b 1017 262 1028 297 1024 274 b 984 124 989 220 996 170 b 1008 91 979 108 986 91 z m 972 -281 b 1070 -148 1024 -279 1070 -210 b 1025 -105 1070 -105 1045 -112 b 989 -127 1004 -96 998 -114 b 949 -249 963 -164 963 -209 b 969 -281 943 -265 949 -281 z"
        },
        unpitchedPercussionClef1: {
            x_min: 0,
            x_max: 379,
            y_min: -250,
            y_max: 250,
            ha: 500,
            o: "m 481 -360 b 507 -357 491 -360 500 -360 b 546 -295 541 -346 547 -325 b 536 79 543 -170 540 -46 b 523 311 533 157 534 235 b 475 359 518 340 508 359 b 425 360 459 359 442 360 b 400 359 416 360 409 360 b 337 294 348 353 340 347 l 337 -73 b 336 -264 337 -137 337 -200 b 343 -294 336 -274 338 -284 b 481 -360 359 -330 431 -360 z m 144 -341 b 207 -320 167 -341 189 -331 b 217 -301 215 -315 217 -308 b 210 -262 217 -289 210 -275 b 228 187 212 -112 209 37 b 228 287 228 220 229 253 b 174 353 228 336 222 343 b 120 359 157 357 138 359 b 48 357 96 359 72 356 b 17 323 29 357 19 344 b 7 120 16 255 9 187 b 6 -109 6 43 6 -33 l 6 -204 b 0 -251 6 -220 0 -235 b 3 -269 0 -256 0 -262 b 127 -340 24 -330 79 -328 b 144 -341 132 -341 138 -341 z"
        },
        "6stringTabClef": {
            x_min: 0,
            x_max: 438,
            y_min: -768,
            y_max: 767,
            ha: 1535,
            o: "m 369 438 b 374 439 370 438 372 438 b 384 462 383 444 384 452 l 384 474 b 390 697 386 547 390 622 b 373 1002 390 799 390 901 l 533 1002 b 560 1001 541 1004 552 1001 b 573 1007 567 1001 572 1002 b 546 1050 579 1025 559 1038 b 536 1056 543 1053 539 1053 b 324 1104 472 1102 397 1104 b 72 1090 238 1104 154 1099 b 55 1093 66 1090 60 1092 b 37 1073 46 1093 37 1089 b 60 1045 37 1061 48 1051 b 203 1001 105 1022 151 1001 b 233 1004 213 1001 223 1002 b 246 1005 238 1004 243 1005 b 272 975 264 1005 272 996 l 272 965 b 258 596 264 842 265 719 b 315 474 253 540 272 504 l 343 455 b 369 438 351 448 357 438 z m 114 -320 b 127 -304 120 -320 124 -315 b 171 -174 141 -261 158 -219 b 222 -135 179 -147 196 -137 b 426 -122 289 -131 359 -128 b 498 -164 462 -120 482 -127 b 628 -301 521 -226 575 -264 b 631 -288 631 -295 631 -291 b 628 -269 631 -281 629 -276 b 569 -134 616 -220 589 -179 b 408 225 514 -14 462 107 b 314 357 384 274 351 318 b 278 380 298 372 288 379 b 251 351 268 380 261 372 b 4 -209 156 171 75 -17 b 0 -228 1 -215 0 -222 b 19 -258 0 -240 7 -249 b 102 -314 45 -279 75 -294 b 114 -320 107 -318 111 -320 z m 425 6 b 360 20 403 17 382 20 b 274 14 331 20 302 14 l 246 14 l 340 206 b 425 6 369 137 395 75 z m 245 -1106 b 281 -1104 256 -1106 269 -1106 b 511 -888 400 -1094 511 -1035 b 454 -688 511 -814 504 -744 b 448 -678 449 -685 448 -681 b 454 -667 448 -675 449 -671 b 504 -497 503 -619 507 -559 b 324 -288 500 -383 436 -308 b 295 -287 314 -287 304 -287 l 282 -287 b 115 -330 223 -287 168 -307 b 94 -366 102 -336 94 -348 l 94 -370 b 96 -435 96 -392 96 -413 b 73 -858 89 -576 71 -717 b 78 -919 73 -878 78 -899 b 72 -950 78 -930 76 -940 b 63 -992 66 -965 63 -978 b 66 -1015 63 -999 65 -1008 b 173 -1104 84 -1106 84 -1106 b 245 -1106 197 -1104 220 -1104 z m 161 -622 b 147 -618 156 -622 151 -621 b 140 -600 141 -612 140 -606 b 144 -564 140 -589 144 -575 b 143 -554 144 -560 144 -557 l 143 -546 b 220 -451 144 -467 143 -465 b 278 -445 239 -446 259 -444 b 418 -497 328 -445 376 -461 b 429 -516 426 -504 429 -510 b 415 -533 429 -521 423 -527 b 219 -608 357 -579 287 -590 b 215 -609 217 -608 216 -609 b 161 -622 197 -609 177 -622 z m 154 -953 b 130 -933 135 -953 130 -948 l 130 -865 l 128 -865 b 135 -788 130 -838 124 -808 b 203 -769 145 -769 180 -776 b 259 -762 223 -765 242 -762 b 441 -852 330 -762 386 -805 b 449 -867 446 -858 449 -863 b 436 -884 449 -874 444 -878 b 318 -942 402 -914 363 -935 b 154 -953 264 -950 209 -953 z"
        },
        timeSig0: {
            x_min: 20,
            x_max: 513,
            y_min: -358,
            y_max: 359,
            ha: 717,
            o: "m 341 -516 b 420 -510 367 -516 395 -514 b 675 -338 533 -494 622 -448 b 737 -92 716 -256 734 -171 b 739 -35 739 -73 739 -53 b 680 305 739 86 720 207 b 400 517 622 449 537 517 b 337 514 380 517 359 517 b 289 507 321 511 305 513 b 91 317 192 477 127 412 b 29 9 50 212 29 108 b 217 -458 29 -157 88 -312 b 341 -516 251 -494 291 -518 z m 412 -452 b 359 -425 393 -452 376 -444 b 187 14 242 -301 179 -158 b 268 334 193 127 212 235 b 387 448 295 383 330 428 b 406 452 395 451 400 452 b 428 444 413 452 420 449 b 517 324 471 413 497 372 b 586 -29 560 222 586 86 b 556 -271 586 -112 585 -193 b 468 -422 536 -327 508 -377 b 412 -452 449 -442 431 -452 z"
        },
        timeSig1: {
            x_min: 20,
            x_max: 283,
            y_min: -364,
            y_max: 366,
            ha: 730,
            o: "m 264 -524 b 357 -510 297 -524 325 -516 b 374 -490 369 -508 374 -501 b 380 -438 376 -472 380 -455 l 406 246 b 408 301 408 265 408 282 b 400 445 408 348 405 396 b 288 527 395 491 338 527 b 253 520 276 527 264 526 b 240 508 249 517 245 513 b 49 409 192 445 127 413 b 29 396 33 408 29 403 b 32 380 29 392 30 386 b 59 363 36 366 49 364 b 164 348 95 356 130 348 b 222 357 183 348 203 351 b 238 361 228 360 233 360 b 252 334 248 361 252 353 b 243 59 252 242 249 150 b 219 -490 229 -124 233 -307 b 264 -524 217 -516 232 -524 z"
        },
        timeSig2: {
            x_min: 20,
            x_max: 660,
            y_min: -379,
            y_max: 382,
            ha: 761,
            o: "m 99 -543 b 130 -533 111 -550 121 -540 b 255 -448 168 -501 213 -475 b 338 -425 282 -431 310 -425 b 392 -431 356 -425 374 -426 b 485 -462 423 -438 454 -451 b 648 -497 540 -482 595 -497 b 834 -441 711 -497 773 -480 b 950 -242 906 -395 958 -334 b 942 -210 950 -230 950 -215 b 912 -220 932 -204 920 -213 b 861 -264 894 -235 877 -248 b 775 -317 835 -289 808 -305 b 675 -334 742 -328 708 -334 b 510 -295 619 -334 563 -318 b 372 -264 465 -278 420 -264 b 305 -272 350 -264 328 -266 b 331 -242 318 -256 324 -249 b 490 -73 386 -187 438 -131 b 675 340 595 43 664 180 b 677 369 677 350 677 360 b 556 536 677 461 638 508 b 468 550 526 546 497 550 b 297 508 409 550 353 533 b 111 354 220 475 168 412 b 29 197 65 308 29 261 b 32 164 29 187 29 176 b 29 140 33 157 29 147 b 43 125 29 132 32 125 b 73 147 55 125 65 138 b 86 163 79 153 82 158 b 238 320 134 219 183 272 b 425 389 292 367 360 389 b 575 341 480 389 531 373 b 606 298 590 330 606 317 b 600 278 606 292 603 285 b 501 107 576 217 544 158 b 304 -104 439 33 372 -35 b 111 -356 230 -180 167 -265 b 84 -446 92 -386 84 -415 b 86 -481 84 -458 85 -469 b 88 -514 88 -491 88 -503 b 99 -543 89 -526 91 -537 z"
        },
        timeSig3: {
            x_min: 20,
            x_max: 540,
            y_min: -392,
            y_max: 392,
            ha: 784,
            o: "m 216 -540 b 354 -564 264 -556 310 -564 b 605 -465 445 -564 530 -530 b 729 -161 697 -383 729 -275 b 724 -82 729 -135 727 -108 b 589 95 716 -1 670 62 b 523 114 567 102 546 108 b 750 418 606 213 677 315 b 778 503 769 444 778 472 b 773 540 778 514 776 527 b 750 564 769 557 762 564 b 736 562 746 564 742 563 b 641 552 704 553 672 552 b 402 554 562 552 481 554 l 346 554 b 84 546 258 554 170 554 b 36 501 55 543 40 531 b 29 412 30 472 32 442 b 52 384 27 393 32 384 l 56 384 b 210 392 107 389 158 392 l 602 392 b 354 108 523 285 445 192 b 246 -65 300 58 246 12 b 252 -108 246 -78 248 -92 l 252 -111 b 264 -141 251 -122 251 -135 b 291 -132 274 -145 284 -140 b 425 -72 328 -95 377 -84 b 475 -65 442 -68 459 -65 b 592 -108 517 -65 557 -79 b 645 -179 615 -125 645 -147 b 642 -194 645 -184 644 -189 b 485 -376 616 -278 569 -344 b 361 -399 444 -392 402 -399 b 151 -340 289 -399 219 -376 b 88 -275 122 -323 98 -310 b 71 -249 86 -268 85 -249 b 63 -251 68 -249 66 -249 b 36 -288 48 -255 36 -266 b 55 -423 33 -336 45 -377 b 101 -482 60 -448 78 -468 b 216 -540 138 -504 174 -526 z"
        },
        timeSig4: {
            x_min: 20,
            x_max: 633,
            y_min: -490,
            y_max: 491,
            ha: 981,
            o: "m 608 -704 b 641 -684 622 -708 634 -696 b 667 -602 660 -660 662 -631 b 685 -190 683 -465 680 -327 l 685 -176 b 831 -127 736 -166 783 -148 b 912 0 901 -94 913 -76 b 886 53 912 36 904 52 b 848 40 877 53 864 49 l 838 36 b 687 -13 789 14 739 -3 b 681 177 687 50 684 114 b 672 338 678 230 677 285 b 654 373 671 350 672 373 b 622 340 636 373 624 361 b 615 262 621 314 613 288 b 619 -22 616 167 619 72 b 569 -22 602 -23 585 -23 b 305 -3 481 -16 395 -1 b 210 -9 274 -3 242 -4 b 301 163 242 52 268 108 b 513 552 377 288 459 412 b 536 652 526 585 536 618 b 533 683 536 662 534 672 b 520 707 531 691 531 707 b 487 693 508 708 494 704 b 474 668 482 684 477 677 b 384 490 454 603 418 547 b 253 281 343 419 295 351 b 73 -13 194 181 145 78 b 29 -108 50 -42 29 -72 b 37 -147 29 -121 32 -134 b 50 -186 43 -160 50 -173 b 68 -216 52 -207 56 -215 b 92 -207 73 -216 82 -213 b 288 -166 156 -180 220 -166 b 556 -186 377 -166 467 -180 b 586 -189 566 -187 576 -187 b 616 -186 596 -189 606 -189 b 606 -432 613 -268 612 -350 b 596 -625 603 -495 596 -559 b 598 -670 596 -641 596 -655 b 608 -704 598 -683 596 -700 z"
        },
        timeSig5: {
            x_min: 20,
            x_max: 583,
            y_min: -389,
            y_max: 389,
            ha: 778,
            o: "m 132 -536 b 249 -560 168 -553 209 -559 b 507 -462 351 -560 454 -514 b 677 -183 588 -384 642 -289 b 694 -85 688 -150 694 -117 b 540 138 694 12 642 94 b 422 173 501 154 462 167 b 400 187 408 174 400 177 b 405 202 400 190 402 196 b 428 284 416 228 426 255 b 469 312 431 307 442 312 b 757 372 569 312 662 343 b 840 490 821 392 840 432 b 812 560 840 540 834 560 b 763 546 801 560 785 556 b 757 543 762 546 759 544 b 465 484 665 505 570 484 b 396 484 452 484 425 487 b 353 454 377 482 366 474 b 281 300 323 405 304 351 b 245 164 262 255 245 212 b 246 144 245 158 246 151 b 233 63 249 115 243 89 b 225 35 228 50 225 40 b 264 14 225 22 236 19 b 445 -26 325 7 387 0 b 569 -151 501 -52 547 -89 b 575 -180 573 -161 575 -170 b 527 -275 575 -217 547 -245 b 347 -367 484 -334 419 -367 b 261 -351 318 -367 289 -363 b 95 -300 206 -333 154 -307 b 55 -321 73 -297 65 -302 b 29 -468 29 -367 40 -419 b 56 -505 26 -482 36 -500 b 132 -536 82 -514 108 -524 z"
        },
        timeSig6: {
            x_min: 20,
            x_max: 565,
            y_min: -363,
            y_max: 363,
            ha: 726,
            o: "m 390 -518 b 621 -458 469 -507 549 -494 b 814 -134 753 -390 814 -281 b 652 59 814 -16 750 58 b 580 48 629 59 606 55 b 233 -334 392 -9 276 -138 b 115 -228 181 -314 143 -278 b 98 -160 104 -206 98 -183 b 107 -109 98 -144 101 -127 b 167 37 124 -59 145 -12 b 508 340 236 189 347 292 b 575 353 530 347 553 353 b 648 327 600 353 625 346 b 665 320 654 321 661 320 b 687 336 674 320 681 325 b 703 405 697 359 703 382 b 684 472 703 429 697 451 b 593 523 664 504 631 521 b 576 521 588 523 582 523 b 297 403 472 508 380 465 b 115 177 217 344 164 264 b 29 -121 60 82 29 -17 b 53 -278 29 -173 36 -225 b 226 -497 82 -374 131 -454 b 347 -523 265 -514 305 -523 b 390 -518 361 -523 376 -521 z m 351 -357 b 312 -351 337 -356 320 -363 b 325 -315 304 -340 320 -327 b 543 -120 373 -222 448 -158 b 622 -104 570 -108 596 -102 b 717 -132 655 -104 687 -112 b 740 -167 732 -143 740 -153 b 730 -196 740 -176 737 -184 b 563 -321 690 -258 634 -300 b 359 -357 497 -341 428 -354 z"
        },
        timeSig7: {
            x_min: 20,
            x_max: 592,
            y_min: -345,
            y_max: 345,
            ha: 690,
            o: "m 253 -497 b 318 -485 276 -497 297 -487 b 366 -441 348 -482 360 -468 b 487 -104 390 -323 433 -210 b 835 403 580 82 701 246 b 852 436 847 416 852 428 b 815 467 852 451 840 461 b 762 474 798 471 779 474 b 674 445 732 474 701 465 b 603 410 652 431 628 420 b 383 360 533 379 459 360 b 200 435 315 360 249 382 b 88 494 168 469 131 485 b 66 497 81 495 73 497 b 33 484 52 497 39 492 b 50 436 22 469 39 451 b 295 310 114 360 199 324 b 406 301 331 304 369 301 b 593 324 468 301 530 308 b 585 307 589 314 588 310 b 265 -249 451 137 338 -46 b 207 -442 242 -312 223 -377 b 204 -462 206 -449 204 -456 b 253 -497 204 -487 220 -497 z"
        },
        timeSig8: {
            x_min: 20,
            x_max: 504,
            y_min: -428,
            y_max: 428,
            ha: 856,
            o: "m 265 -616 b 289 -615 274 -616 281 -616 b 710 -271 492 -592 657 -485 b 726 -148 721 -229 727 -187 b 585 108 726 -48 687 42 b 572 127 576 114 573 120 b 576 144 572 132 575 138 b 598 301 590 196 598 249 b 586 413 598 338 593 376 b 356 616 559 531 467 616 b 233 582 317 616 275 606 b 29 233 101 505 29 384 b 104 9 29 153 46 72 b 189 -48 127 -16 160 -27 b 92 -158 141 -73 114 -114 b 37 -343 63 -217 50 -279 b 33 -390 35 -359 33 -374 b 265 -616 33 -524 148 -616 z m 258 105 b 124 148 215 105 167 117 b 96 196 105 163 96 177 b 99 217 96 202 96 209 b 197 384 120 281 151 337 b 350 451 242 429 297 451 b 516 364 412 451 472 422 b 530 331 523 354 530 343 l 530 327 l 530 320 b 468 151 520 261 507 200 b 419 122 455 135 442 125 b 258 105 370 117 320 105 z m 328 -438 b 158 -276 233 -436 160 -359 b 166 -239 158 -264 161 -252 b 230 -157 176 -203 202 -179 b 367 -72 274 -125 320 -98 b 448 -49 396 -56 423 -49 b 562 -118 491 -49 528 -72 b 611 -251 590 -157 611 -199 b 569 -341 611 -288 595 -318 b 328 -438 500 -402 416 -432 z"
        },
        timeSig9: {
            x_min: 20,
            x_max: 494,
            y_min: -421,
            y_max: 421,
            ha: 842,
            o: "m 235 -606 b 361 -564 275 -606 318 -593 b 619 -229 487 -482 566 -366 b 706 127 664 -114 694 4 b 711 233 708 163 711 197 b 700 346 711 271 708 308 b 389 606 658 517 530 606 b 351 605 376 606 364 606 b 56 272 171 586 56 441 b 96 98 56 216 69 156 b 334 -53 144 -3 238 -53 b 544 36 408 -53 484 -24 b 652 176 586 78 622 124 b 631 71 645 141 639 105 b 467 -302 599 -63 562 -196 b 271 -442 412 -364 354 -422 b 225 -448 255 -446 239 -448 b 95 -305 148 -448 98 -395 b 89 -255 95 -288 94 -271 b 73 -233 86 -246 85 -233 b 52 -248 65 -233 56 -239 b 29 -317 42 -271 30 -291 b 49 -448 29 -361 40 -405 b 235 -606 69 -541 144 -606 z m 340 104 b 144 209 264 108 194 141 b 127 258 132 225 127 240 b 137 297 127 271 130 284 b 366 449 184 396 269 449 b 517 408 415 449 467 436 b 595 348 546 392 572 372 b 616 305 608 336 616 321 b 609 281 616 298 613 289 b 340 104 557 184 477 104 z"
        },
        timeSigCommon: {
            x_min: 20,
            x_max: 585,
            y_min: -298,
            y_max: 294,
            ha: 592,
            o: "m 444 -405 b 829 -45 626 -346 740 -207 b 842 26 842 -23 842 1 b 821 58 842 39 841 58 b 795 40 811 58 802 48 b 765 3 785 29 773 16 b 469 -223 690 -104 596 -183 b 354 -242 431 -235 392 -242 b 180 -177 292 -242 235 -223 b 135 -99 154 -157 140 -131 b 132 -59 134 -85 132 -72 b 141 7 132 -37 135 -16 b 449 274 189 160 297 243 b 477 278 459 276 468 276 b 546 203 517 278 539 253 b 517 157 550 177 533 166 b 485 143 507 153 497 143 l 482 143 b 467 148 478 143 472 144 b 374 183 438 170 406 181 b 264 118 333 183 292 161 b 238 48 246 92 238 69 b 261 -9 238 29 245 10 b 383 -73 287 -39 337 -73 b 412 -68 392 -73 402 -72 b 631 164 526 -27 586 59 b 649 252 644 193 649 222 b 636 328 649 278 645 304 b 504 423 615 400 579 429 b 242 318 408 415 317 387 b 29 -158 104 190 29 33 b 30 -176 29 -164 29 -170 b 115 -364 42 -246 52 -315 b 307 -429 177 -410 240 -429 b 444 -405 351 -429 397 -420 z"
        },
        timeSigCutCommon: {
            x_min: 20,
            x_max: 695,
            y_min: -687,
            y_max: 687,
            ha: 1374,
            o: "m 564 -989 b 595 -945 585 -991 589 -963 l 599 -922 b 605 -628 600 -824 603 -726 l 609 -399 b 878 -251 706 -363 798 -320 b 996 -85 932 -204 976 -153 b 1001 -63 998 -78 1001 -71 b 989 -46 1001 -56 998 -49 b 978 -43 985 -45 982 -43 b 950 -59 968 -43 959 -49 b 733 -216 894 -132 815 -177 b 611 -259 694 -235 652 -249 b 616 -20 612 -179 615 -99 b 680 29 642 -7 665 9 b 698 43 685 36 690 40 b 870 251 792 82 840 160 b 877 294 874 265 877 279 b 818 410 877 338 855 382 b 683 458 779 442 730 448 b 625 468 664 462 644 465 l 625 514 b 638 958 626 662 636 811 b 626 989 638 979 635 989 b 603 981 621 989 613 986 b 422 840 534 945 481 888 b 412 805 412 832 413 818 b 426 713 410 773 420 743 b 445 678 429 690 435 678 b 474 691 452 678 461 683 b 563 755 503 710 530 732 b 564 724 564 740 564 733 b 559 469 563 639 560 554 b 462 454 526 469 494 464 b 112 143 302 399 199 281 b 33 -94 66 71 45 -10 b 29 -148 30 -112 29 -131 b 105 -351 29 -223 52 -291 b 359 -455 171 -426 258 -451 b 517 -431 409 -451 464 -446 l 539 -422 l 539 -477 b 533 -739 536 -563 539 -651 b 530 -824 531 -768 530 -795 b 546 -948 530 -865 533 -907 b 564 -989 552 -962 543 -989 z m 410 -288 b 193 -197 328 -288 253 -264 b 141 -60 160 -161 141 -108 b 157 6 141 -35 147 -12 b 259 158 189 58 217 112 b 438 291 311 215 364 266 b 528 305 468 301 498 305 b 554 304 537 305 546 304 b 553 212 554 274 554 242 b 426 115 498 199 446 164 b 416 68 419 99 416 84 b 425 12 416 49 420 30 b 474 -39 432 -17 448 -32 b 513 -43 487 -42 498 -43 b 547 -40 524 -43 536 -42 l 543 -272 b 461 -285 516 -278 488 -281 b 410 -288 444 -287 426 -288 z m 694 197 b 668 203 685 197 677 199 b 621 216 654 210 638 215 b 622 294 622 242 622 268 b 706 268 651 287 678 278 b 746 235 721 261 734 249 b 752 222 749 230 752 226 b 743 213 752 219 749 215 b 694 197 727 206 711 197 z"
        },
        timeSigPlus: {
            x_min: 0,
            x_max: 661,
            y_min: -358,
            y_max: 358,
            ha: 716,
            o: "m 605 -516 b 629 -490 624 -516 629 -507 b 628 -475 629 -485 628 -481 b 613 -131 624 -405 616 -174 b 612 -96 612 -114 612 -96 l 647 -98 b 897 -115 730 -99 814 -109 b 940 -89 919 -117 935 -109 b 952 -24 946 -69 952 -46 b 948 9 952 -14 950 -3 b 912 39 942 26 933 37 b 609 60 822 48 609 60 b 616 392 609 60 608 291 b 567 488 619 436 605 467 b 511 516 550 498 531 514 b 498 511 507 516 503 514 b 478 446 475 501 480 469 b 467 150 474 348 469 249 b 465 59 465 121 465 59 l 372 49 b 73 14 272 36 173 24 b 49 13 65 13 56 13 b 0 -33 9 13 0 6 b 60 -141 0 -117 6 -140 b 112 -135 73 -141 91 -140 b 413 -102 213 -125 314 -112 b 464 -98 441 -99 464 -98 l 464 -145 b 477 -456 464 -249 468 -353 b 526 -510 478 -488 491 -507 b 589 -513 546 -511 569 -510 b 605 -516 595 -514 600 -516 z"
        },
        timeSigPlusSmall: {
            x_min: 0,
            x_max: 418,
            y_min: -197,
            y_max: 199,
            ha: 396,
            o: "m 301 -284 b 330 -238 320 -284 324 -255 b 348 -46 350 -176 341 -111 b 374 -20 351 -27 356 -23 b 481 -17 409 -16 445 -17 b 566 -9 510 -17 537 -16 b 602 3 579 -7 602 -16 b 566 29 602 19 582 24 b 526 33 553 32 539 33 b 384 39 478 36 432 39 b 356 62 363 39 356 42 l 356 68 b 359 177 359 104 359 141 l 359 251 b 341 287 359 264 361 285 b 311 255 324 287 314 272 b 310 228 311 246 310 236 l 301 69 b 275 39 301 49 295 39 l 271 39 b 210 40 251 40 230 40 b 167 39 196 40 181 40 b 89 40 141 37 115 40 b 24 30 68 40 46 37 b 0 17 17 27 0 30 l 0 13 b 27 -17 3 0 7 -13 b 91 -22 49 -22 71 -22 b 153 -22 115 -22 137 -20 l 275 -22 b 295 -40 289 -22 295 -27 l 295 -48 b 288 -235 288 -109 287 -171 b 287 -264 288 -243 287 -253 b 301 -284 287 -275 289 -284 z"
        },
        timeSigMinus: {
            x_min: 0,
            x_max: 662,
            y_min: -54,
            y_max: 55,
            ha: 109,
            o: "m 39 -78 b 49 -76 42 -78 45 -76 b 452 -75 94 -75 272 -75 b 861 -76 632 -75 814 -76 b 953 -20 927 -79 953 -66 b 948 27 953 -7 950 9 b 946 37 948 30 948 35 b 896 79 940 63 929 79 b 471 78 827 78 648 78 l 42 78 b 0 37 14 78 0 69 b 23 -66 0 0 17 -32 b 39 -78 24 -75 32 -76 z"
        },
        timeSigParensRight: {
            x_min: 0,
            x_max: 274,
            y_min: -723,
            y_max: 725,
            ha: 1448,
            o: "m 37 -1038 b 69 -1031 48 -1044 59 -1038 b 88 -1015 76 -1027 82 -1021 b 164 -886 120 -976 147 -933 b 333 -351 233 -711 292 -534 b 395 118 366 -204 399 -59 b 389 245 392 144 392 194 b 120 996 369 521 265 766 b 68 1044 99 1030 84 1044 b 19 988 50 1044 36 1024 b 0 922 7 965 0 945 b 20 858 0 901 6 881 b 259 215 141 660 236 449 b 271 -1 266 143 271 71 b 252 -239 271 -82 265 -161 b 148 -667 228 -384 183 -524 b 39 -1009 120 -785 66 -893 b 33 -1031 37 -1017 33 -1024 b 37 -1038 33 -1034 35 -1037 z"
        },
        timeSigParensRightSmall: {
            x_min: 0,
            x_max: 154,
            y_min: -422,
            y_max: 422,
            ha: 844,
            o: "m 43 -608 b 60 -598 48 -608 53 -605 b 117 -511 82 -572 102 -543 b 222 23 193 -350 219 -177 b 213 166 225 55 216 109 b 115 531 206 294 174 416 b 45 603 99 562 76 588 b 30 608 39 606 35 608 b 10 598 23 608 17 603 b 0 546 3 590 0 570 b 23 451 0 507 9 458 b 102 351 66 429 84 390 b 167 42 150 252 167 148 b 163 -49 167 12 166 -19 b 35 -449 151 -192 121 -330 b 14 -504 22 -467 14 -485 b 17 -527 14 -511 16 -520 l 30 -590 b 43 -608 33 -603 37 -608 z"
        },
        timeSigParensLeft: {
            x_min: 1,
            x_max: 400,
            y_min: -728,
            y_max: 728,
            ha: 1456,
            o: "m 562 -1048 b 573 -1043 566 -1048 570 -1047 b 553 -988 582 -1025 564 -1004 b 472 -884 527 -952 497 -920 b 210 -354 366 -717 275 -541 b 148 -6 170 -240 148 -124 b 160 148 148 45 153 96 b 315 678 189 331 242 508 b 431 901 350 755 380 834 b 459 950 451 926 461 939 b 435 995 459 962 451 972 b 364 1048 405 1034 383 1048 b 305 996 343 1048 325 1028 b 127 624 226 881 174 753 b 1 30 56 432 9 235 b 1 -32 1 9 0 -12 b 180 -629 13 -245 92 -438 b 363 -936 230 -739 298 -835 b 526 -1041 402 -995 448 -1041 b 562 -1048 537 -1040 552 -1048 z"
        },
        timeSigParensLeftSmall: {
            x_min: 0,
            x_max: 173,
            y_min: -405,
            y_max: 404,
            ha: 809,
            o: "m 197 -583 b 222 -553 212 -582 219 -566 b 229 -497 226 -534 229 -516 b 213 -425 229 -472 225 -448 b 102 -177 173 -344 132 -262 b 62 30 78 -111 58 -42 b 91 183 66 82 75 134 b 215 426 118 271 156 356 b 249 552 246 465 252 505 b 230 582 249 563 246 582 b 197 563 219 582 206 576 b 71 356 144 500 105 429 b 0 50 26 259 3 158 b 13 -112 4 -3 7 -58 b 176 -559 29 -275 105 -416 b 196 -583 180 -569 186 -583 z"
        },
        noteheadDoubleWhole: {
            x_min: 0,
            x_max: 614,
            y_min: -223,
            y_max: 223,
            ha: 446,
            o: "m 35 -321 b 62 -266 58 -318 58 -288 l 62 -194 b 63 50 62 -114 63 -32 b 60 189 63 96 63 143 b 43 300 59 226 60 265 b 29 321 40 308 39 321 l 26 321 b 0 292 13 318 0 310 b 0 248 0 278 -1 262 b 6 147 4 215 6 181 b 4 48 6 114 4 81 b 6 0 4 32 6 16 b 7 -36 7 -12 7 -24 l 7 -52 b 6 -156 7 -86 6 -121 b 19 -275 6 -196 9 -236 b 35 -321 23 -291 16 -323 z m 847 -314 b 871 -288 860 -315 867 -300 b 884 -187 881 -255 886 -222 b 876 115 878 -86 876 14 b 877 255 876 161 876 209 b 868 291 877 268 873 279 b 855 304 867 301 863 304 b 844 301 852 304 848 304 b 822 265 825 292 822 278 b 824 251 822 259 822 255 b 822 170 822 225 822 197 l 822 -20 b 835 -284 827 -86 825 -186 b 847 -314 837 -295 835 -311 z m 757 -291 b 793 -171 796 -255 792 -212 b 795 -49 795 -131 795 -91 b 786 207 795 36 791 121 b 779 240 786 217 783 229 b 766 258 776 246 776 258 b 762 256 765 258 763 256 b 739 236 752 253 740 252 b 733 177 737 216 732 197 b 737 20 737 125 739 73 l 737 -107 b 740 -202 737 -138 739 -170 b 757 -291 740 -230 743 -261 z m 128 -261 b 144 -251 135 -264 141 -256 b 158 -203 156 -236 157 -220 b 161 -137 161 -181 161 -158 b 157 30 161 -81 157 -26 b 158 76 157 45 157 60 l 158 101 b 156 225 158 141 158 183 b 137 253 156 235 154 253 l 134 253 b 109 222 120 251 109 242 b 104 91 108 179 104 134 b 108 -58 104 42 109 -9 b 107 -105 108 -73 108 -89 b 105 -127 107 -112 107 -120 b 118 -245 105 -167 114 -204 b 128 -261 118 -252 121 -259 z m 488 -242 b 693 -79 595 -249 685 -166 l 693 -55 b 690 0 693 -36 691 -17 b 540 187 684 84 621 164 b 449 200 508 196 480 200 b 210 104 363 200 282 163 b 186 56 196 92 186 76 b 207 -82 186 9 192 -37 b 300 -204 225 -132 248 -181 b 488 -242 356 -229 415 -240 z m 490 -88 b 449 -86 477 -88 464 -88 b 287 -56 399 -85 341 -78 b 258 -33 275 -52 258 -48 b 282 -7 258 -20 272 -13 b 458 43 340 23 399 43 b 580 14 497 43 537 35 b 618 -20 606 1 619 -9 b 592 -58 618 -30 609 -42 b 490 -88 562 -82 528 -88 z"
        },
        noteheadWhole: {
            x_min: 0,
            x_max: 380,
            y_min: -186,
            y_max: 165,
            ha: 351,
            o: "m 547 40 b 223 -268 543 -151 367 -259 b 102 -233 180 -271 143 -248 l 62 -216 b 0 -127 22 -197 0 -166 b 6 -91 0 -115 1 -104 b 122 141 33 -9 69 71 b 327 238 170 204 249 238 b 514 158 397 238 467 212 b 547 40 544 125 549 84 z m 248 -107 b 384 -63 295 -102 341 -88 b 426 -23 402 -53 415 -40 b 435 3 432 -14 435 -6 b 413 32 435 14 428 24 b 301 73 376 49 343 73 b 272 69 291 73 282 72 b 121 -35 207 53 157 20 b 111 -58 117 -42 111 -50 b 125 -75 111 -65 115 -71 b 248 -107 164 -89 202 -107 z"
        },
        noteheadHalf: {
            x_min: 0,
            x_max: 334,
            y_min: -174,
            y_max: 175,
            ha: 349,
            o: "m 480 56 b 167 -251 478 -115 331 -251 b 94 -242 143 -251 118 -248 b 9 -141 43 -229 20 -192 b 0 -68 3 -115 0 -91 b 284 249 0 95 127 200 b 304 252 289 251 297 252 b 481 78 374 252 481 170 b 480 56 481 71 481 63 z m 213 -102 b 399 6 274 -81 341 -48 b 402 17 400 7 402 13 b 399 27 402 22 400 26 b 311 94 373 53 353 88 b 292 95 305 95 300 95 b 130 27 230 95 181 55 b 69 -62 98 9 62 -29 b 161 -98 76 -98 128 -91 b 213 -102 174 -101 186 -101 z"
        },
        noteheadBlack: {
            x_min: 0,
            x_max: 334,
            y_min: -164,
            y_max: 164,
            ha: 328,
            o: "m 112 -233 b 141 -236 122 -235 131 -236 b 481 104 279 -236 485 -48 b 403 222 477 141 478 192 b 334 236 382 232 359 236 b 1 -59 180 236 13 59 b 0 -85 1 -68 0 -76 b 112 -233 0 -157 32 -215 z"
        },
        noteheadXDoubleWhole: {
            x_min: 0,
            x_max: 730,
            y_min: -266,
            y_max: 267,
            ha: 533,
            o: "m 1018 -373 b 1032 -361 1025 -376 1028 -367 b 1051 -287 1047 -338 1051 -314 b 1050 -252 1051 -276 1051 -264 b 1030 186 1031 -107 1037 40 b 1031 266 1028 213 1031 239 b 1018 363 1031 300 1028 331 b 1005 384 1015 373 1017 384 l 1004 384 b 984 363 992 384 986 373 b 982 343 982 356 982 348 b 981 235 982 307 981 271 b 996 -285 981 60 986 -112 b 1009 -360 998 -311 1005 -336 b 1018 -373 1011 -364 1014 -373 z m 16 -383 b 49 -328 39 -367 48 -350 b 69 56 58 -202 62 -73 b 75 212 72 107 72 160 b 78 278 76 233 78 255 b 59 382 78 312 73 347 b 29 328 33 372 29 350 b 13 -29 29 209 23 88 b 3 -222 7 -95 10 -157 b 0 -265 1 -236 0 -252 b 16 -383 0 -304 6 -343 z m 923 -314 b 955 -240 948 -289 952 -265 b 965 -65 962 -181 965 -125 b 963 0 965 -45 965 -22 b 962 111 960 37 962 73 b 953 240 962 154 960 197 b 939 275 952 253 952 275 b 913 239 924 274 913 258 b 913 173 914 217 913 194 b 914 135 913 160 913 147 b 920 27 919 98 920 63 b 909 -128 920 -26 917 -78 b 906 -179 906 -147 906 -163 b 923 -314 906 -223 913 -266 z m 121 -301 b 143 -272 134 -301 138 -284 b 147 -255 145 -268 145 -261 b 173 160 161 -117 166 22 b 173 233 173 184 174 209 b 157 264 171 243 171 264 b 137 235 143 264 138 249 b 132 207 135 226 132 216 b 121 43 128 153 124 96 b 105 -186 117 -36 105 -111 b 111 -269 105 -215 107 -242 b 121 -301 114 -281 104 -300 z m 210 -238 b 376 -193 274 -239 327 -226 b 471 -134 406 -173 439 -154 b 534 -94 491 -120 513 -107 b 671 -192 579 -127 624 -161 b 733 -226 691 -204 708 -228 b 746 -225 737 -228 742 -226 b 845 -204 782 -226 814 -213 b 868 -194 854 -203 865 -203 b 852 -173 871 -183 860 -179 b 661 -40 789 -128 724 -84 b 642 -27 654 -36 648 -32 b 861 114 716 17 791 63 b 886 132 870 120 886 121 l 886 137 b 852 164 883 151 867 161 b 776 176 827 170 801 176 b 685 145 744 176 714 168 b 530 45 638 107 583 76 b 403 132 487 73 444 101 b 279 176 364 161 324 171 b 223 160 259 176 229 176 b 258 115 215 141 242 127 b 431 -17 314 71 372 26 b 173 -196 341 -73 253 -130 b 157 -209 168 -200 157 -203 b 158 -215 157 -212 157 -215 b 183 -236 166 -223 168 -235 b 210 -238 194 -236 206 -239 z m 768 -207 b 533 -40 687 -150 609 -94 b 321 -173 462 -85 392 -130 b 261 -194 304 -184 287 -196 b 239 -193 253 -196 246 -194 b 387 -95 294 -157 340 -125 b 505 -20 426 -71 465 -45 l 484 -4 b 353 89 441 27 396 56 b 320 115 341 96 330 107 b 297 141 311 124 297 132 b 300 148 297 144 298 145 b 336 135 311 164 324 143 b 528 -4 400 89 464 42 l 723 121 b 770 140 737 131 753 138 b 792 132 779 140 789 141 b 778 115 795 122 783 120 b 586 -6 714 75 651 35 b 557 -24 576 -13 567 -19 b 726 -147 613 -66 670 -109 b 768 -207 744 -161 765 -173 z"
        },
        noteheadXWhole: {
            x_min: 0,
            x_max: 506,
            y_min: -143,
            y_max: 144,
            ha: 287,
            o: "m 53 -206 b 219 -163 117 -207 170 -196 b 314 -102 249 -141 282 -122 b 377 -63 334 -89 356 -76 b 514 -161 422 -96 468 -128 b 576 -196 534 -174 552 -196 b 589 -193 580 -196 585 -196 b 688 -174 625 -194 657 -181 b 711 -158 698 -171 711 -173 b 696 -143 711 -151 701 -147 b 503 -9 632 -98 567 -52 l 485 4 b 704 145 559 49 634 95 b 729 164 711 150 729 151 l 729 168 b 696 196 726 183 710 193 b 621 207 671 202 645 207 b 528 177 589 207 557 200 b 373 76 480 140 426 108 b 246 164 330 104 287 132 b 122 206 207 193 167 203 b 66 192 102 207 72 207 b 99 147 58 173 85 158 b 274 14 157 102 215 58 b 16 -164 184 -42 96 -98 b 0 -179 12 -168 0 -170 b 1 -183 0 -180 0 -183 b 26 -204 6 -193 12 -204 b 53 -206 37 -206 49 -206 z m 611 -177 b 376 -9 530 -118 452 -63 l 164 -143 b 104 -164 147 -154 130 -164 b 82 -161 96 -164 89 -164 b 230 -65 137 -125 183 -95 l 347 12 b 327 26 341 16 334 22 l 196 121 b 163 147 184 128 173 137 b 140 173 154 154 140 163 b 143 180 140 176 141 177 b 179 166 154 194 167 174 l 372 27 l 566 153 b 613 171 580 161 596 170 b 635 160 624 171 635 174 b 621 147 635 153 626 150 l 429 24 b 400 6 419 19 409 13 b 569 -117 456 -35 513 -75 b 611 -177 588 -130 608 -143 z"
        },
        noteheadXHalf: {
            x_min: 0,
            x_max: 421,
            y_min: -146,
            y_max: 151,
            ha: 297,
            o: "m 490 -209 b 539 -207 505 -207 521 -207 b 606 -209 560 -207 583 -209 b 598 -196 602 -203 600 -199 l 406 -19 l 540 130 b 547 144 546 135 547 140 b 536 156 547 148 543 153 b 488 192 518 166 503 176 b 416 217 471 209 444 217 b 323 180 380 217 344 204 l 264 115 b 239 138 256 122 248 131 b 33 197 180 196 108 200 b 3 186 23 197 6 193 b 19 154 -1 174 10 163 b 171 12 69 107 120 59 b 19 -157 120 -45 69 -101 b 0 -177 14 -163 0 -166 b 1 -181 0 -179 0 -180 b 39 -203 9 -197 22 -203 l 186 -203 b 197 -202 190 -202 193 -200 l 213 -202 b 262 -180 228 -202 246 -199 l 314 -122 b 490 -209 363 -170 412 -216 z m 435 -148 b 291 -30 379 -112 337 -69 l 213 -118 b 190 -137 207 -125 202 -137 b 145 -111 173 -130 154 -127 b 160 -79 137 -98 151 -88 b 238 16 184 -48 212 -16 b 141 99 204 43 173 72 l 124 117 b 115 132 121 121 115 127 b 118 137 115 134 117 137 b 141 132 127 147 135 138 l 253 36 b 347 150 285 75 315 112 b 370 164 354 160 363 163 b 403 145 382 164 393 156 b 416 127 412 140 416 132 b 405 102 416 118 412 111 l 307 -10 b 413 -105 343 -42 379 -73 b 435 -148 425 -115 436 -125 z"
        },
        noteheadXBlack: {
            x_min: 0,
            x_max: 289,
            y_min: -156,
            y_max: 157,
            ha: 313,
            o: "m 23 -225 b 69 -204 40 -223 56 -219 b 137 -131 92 -180 115 -157 l 209 -50 b 377 -197 264 -101 321 -148 b 403 -210 384 -203 393 -210 l 408 -210 b 416 -192 416 -207 416 -199 l 416 -186 b 403 -148 416 -171 413 -158 b 344 -81 384 -125 367 -101 b 252 -1 312 -55 282 -29 b 377 157 297 49 340 101 b 402 202 387 170 402 187 b 395 217 402 207 400 213 b 376 226 389 223 382 226 b 334 192 360 226 346 204 b 206 42 289 143 248 94 b 96 161 167 81 131 120 b 60 193 86 174 76 189 b 33 206 52 196 42 206 b 22 199 29 206 26 204 b 10 173 14 190 10 181 b 22 147 10 166 14 157 b 148 7 62 98 104 52 b 164 -7 154 1 158 -3 b 10 -189 111 -66 55 -122 b 0 -212 6 -197 0 -203 b 1 -217 0 -213 0 -216 b 23 -225 4 -226 14 -222 z"
        },
        noteheadCircleXDoubleWhole: {
            x_min: 0,
            x_max: 437,
            y_min: -220,
            y_max: 219,
            ha: 439,
            o: "m 10 -304 b 40 -206 43 -275 37 -239 b 55 168 48 -81 50 45 b 53 269 56 202 55 236 b 33 315 52 287 46 314 b 3 269 9 317 4 291 b 0 239 1 259 0 249 l 0 -196 b 10 -304 1 -232 7 -268 z m 592 -317 b 621 -220 619 -287 621 -253 b 622 -121 622 -187 622 -154 b 625 -20 622 -88 622 -55 b 629 101 628 20 629 60 b 628 220 629 141 628 181 b 618 253 628 232 625 243 b 608 275 613 259 616 274 b 602 272 606 275 603 275 b 575 249 590 269 575 266 l 575 246 b 573 222 575 239 573 230 l 573 -50 b 592 -317 575 -137 570 -225 z m 79 -285 b 114 -6 96 -261 109 -131 b 117 -63 114 -24 114 -45 b 249 -242 124 -151 166 -212 b 324 -256 275 -252 300 -256 b 504 -137 406 -256 478 -209 b 505 -265 504 -180 505 -222 b 513 -282 505 -269 510 -275 b 533 -248 526 -272 528 -261 b 540 -174 539 -223 540 -199 l 540 -127 b 553 207 546 -16 549 95 b 543 232 553 216 554 232 b 518 207 530 233 518 222 b 511 118 520 177 510 148 l 511 92 b 330 216 488 174 420 223 b 301 215 320 216 311 216 b 122 65 202 204 151 163 b 114 9 117 46 114 27 b 115 75 114 32 115 53 b 101 248 115 157 109 228 b 76 206 78 242 76 225 l 76 91 b 75 -26 76 52 76 13 b 69 -189 72 -81 66 -134 b 79 -285 71 -219 76 -249 z m 317 4 b 219 109 285 40 252 75 l 209 120 b 331 153 248 141 289 151 b 420 137 360 153 390 147 b 446 120 435 131 442 127 l 436 108 l 328 -7 z m 215 -131 b 216 -101 215 -122 215 -114 b 219 -45 217 -82 219 -63 b 197 94 219 3 213 49 l 197 95 b 199 94 199 95 199 94 l 310 -27 b 233 -108 285 -55 259 -81 z m 442 -141 b 432 -122 441 -134 436 -128 l 344 -26 l 426 58 l 445 81 b 444 75 445 78 444 76 b 428 -13 433 46 428 16 b 446 -104 428 -45 433 -75 b 452 -122 449 -111 452 -117 b 442 -141 452 -131 448 -137 z m 323 -190 b 272 -180 305 -187 288 -184 b 217 -158 239 -173 225 -168 l 327 -45 b 330 -48 328 -46 328 -48 b 432 -150 363 -82 393 -121 b 323 -190 400 -174 364 -189 z"
        },
        noteheadCircleXWhole: {
            x_min: 0,
            x_max: 323,
            y_min: -190,
            y_max: 184,
            ha: 374,
            o: "m 156 -258 b 240 -274 184 -268 213 -274 b 455 -101 347 -274 441 -202 b 465 19 462 -60 465 -22 b 464 71 465 36 465 52 b 246 265 455 194 370 274 b 216 264 236 265 226 264 b 12 94 102 251 45 203 b 0 13 3 66 1 40 b 4 -55 0 -10 3 -32 b 156 -258 14 -154 60 -222 z m 245 10 b 233 23 242 14 238 19 b 121 144 196 65 158 104 l 109 154 b 249 192 156 179 202 192 b 351 174 284 192 317 186 b 380 154 366 168 376 163 b 379 153 380 154 380 153 b 369 141 376 148 372 145 b 245 10 327 98 287 53 z m 115 -131 b 118 -96 117 -121 117 -111 b 121 -27 120 -73 121 -50 b 98 124 121 24 115 75 b 96 127 96 125 98 125 b 99 125 98 127 98 125 b 225 -12 140 79 181 33 l 138 -105 b 115 -131 131 -114 122 -121 z m 376 -143 b 363 -121 374 -134 369 -128 b 265 -12 331 -85 298 -48 l 357 85 b 379 111 364 94 372 101 b 377 102 379 108 377 105 b 359 4 364 71 359 37 b 382 -99 359 -32 366 -66 b 387 -121 384 -108 386 -115 b 376 -143 387 -130 382 -135 z m 239 -197 b 181 -187 220 -194 200 -192 b 121 -161 145 -177 128 -173 b 243 -33 161 -118 203 -75 l 248 -36 b 364 -153 285 -75 320 -118 b 239 -197 327 -180 287 -197 z"
        },
        noteheadCircleXHalf: {
            x_min: 0,
            x_max: 309,
            y_min: -179,
            y_max: 179,
            ha: 358,
            o: "m 232 -258 b 435 -94 328 -258 412 -196 b 445 6 444 -60 445 -27 b 444 69 445 27 445 48 b 258 258 439 170 374 258 l 230 258 l 207 256 b 14 107 111 248 45 202 b 0 12 4 75 0 43 b 12 -82 0 -20 4 -50 b 144 -242 27 -160 69 -212 b 232 -258 174 -252 203 -258 z m 192 60 b 115 141 166 88 141 115 l 108 150 b 226 189 141 173 186 189 b 253 186 236 189 245 187 b 305 180 271 183 288 183 b 192 60 268 140 229 101 z m 56 -78 b 45 6 43 -56 45 -23 b 65 84 49 39 50 45 b 85 121 72 96 78 107 b 95 124 88 124 92 127 b 171 39 120 95 145 68 z m 360 -132 b 348 -112 359 -124 353 -118 l 300 -58 l 387 37 b 410 63 397 48 405 56 b 413 26 412 52 413 40 b 360 -132 413 -42 393 -95 z m 232 -183 b 184 -177 217 -183 202 -181 l 281 -78 b 348 -143 301 -101 323 -122 b 232 -183 318 -168 279 -183 z"
        },
        noteheadCircleX: {
            x_min: 0,
            x_max: 344,
            y_min: -179,
            y_max: 175,
            ha: 354,
            o: "m 99 -210 b 236 -258 137 -242 186 -258 b 418 -183 305 -258 374 -230 b 495 33 475 -120 495 -48 b 494 66 495 45 494 55 b 302 252 487 183 405 256 b 181 243 262 249 222 248 b 46 171 128 236 79 219 b 0 19 14 127 0 73 b 99 -210 0 -68 35 -156 z m 245 42 l 124 156 b 200 176 145 166 170 173 b 337 183 245 181 291 184 b 377 176 351 183 364 180 b 245 42 333 131 288 86 z m 392 -99 l 285 3 l 400 121 b 418 154 409 131 418 140 b 465 50 448 130 465 94 b 405 -112 462 -17 439 -73 z m 89 -120 b 48 0 56 -82 48 -42 b 89 112 48 35 59 76 b 109 101 96 111 102 108 l 210 7 l 187 -17 b 89 -120 151 -53 125 -82 z m 176 -183 b 127 -163 158 -179 141 -171 l 252 -32 l 372 -144 b 233 -189 334 -173 285 -189 b 176 -183 215 -189 196 -187 z"
        },
        noteheadCircledDoubleWhole: {
            x_min: 0,
            x_max: 672,
            y_min: -291,
            y_max: 291,
            ha: 582,
            o: "m 27 -419 b 43 -369 37 -403 43 -387 b 49 -82 45 -272 49 -177 b 50 370 50 69 50 219 b 30 419 50 389 50 419 b 7 369 7 419 7 389 b 0 -284 4 151 1 -66 b 16 -418 0 -328 10 -373 z m 945 -374 b 968 -282 963 -343 968 -312 b 966 -245 968 -269 968 -258 b 958 -45 959 -179 962 -111 b 948 262 949 56 952 160 b 936 377 946 301 946 340 b 922 399 933 386 933 399 l 919 397 b 897 374 909 396 899 389 b 894 308 897 353 893 331 b 904 120 899 246 903 183 b 913 -111 907 43 909 -35 b 927 -297 916 -173 919 -235 b 945 -374 930 -320 927 -347 z m 95 -347 b 120 -292 115 -325 117 -310 b 124 -223 122 -269 124 -246 b 122 -141 124 -196 122 -168 b 121 -85 121 -122 121 -104 b 462 -297 170 -209 300 -297 b 727 -219 543 -294 639 -271 b 828 -118 773 -190 808 -157 b 842 -268 831 -168 834 -219 b 851 -288 844 -275 840 -287 b 865 -272 861 -289 863 -279 b 873 -225 871 -256 873 -240 b 873 -171 873 -207 871 -190 b 858 196 868 -48 863 75 b 848 295 857 229 854 262 b 840 315 848 301 850 315 l 837 315 b 816 295 827 314 816 307 b 809 216 815 268 808 243 b 815 102 812 179 814 140 b 672 295 780 176 733 240 b 500 370 621 340 566 370 b 436 361 480 370 459 367 b 120 95 288 321 183 233 l 120 256 b 115 287 120 266 118 276 b 104 305 112 292 115 305 l 101 305 b 82 284 91 304 82 297 b 76 216 81 262 76 239 b 84 -253 78 59 79 -96 b 95 -347 84 -282 89 -311 z m 780 -33 b 779 -24 780 -30 779 -27 b 704 92 766 22 743 62 b 544 173 655 128 599 147 b 400 206 497 194 448 204 b 307 193 369 206 338 202 b 202 118 264 181 226 153 b 235 168 212 135 222 151 b 505 337 302 262 396 312 b 523 338 511 337 517 338 b 611 288 559 338 586 312 b 763 62 678 225 733 151 b 780 -33 776 26 782 -4 z m 435 -88 b 337 -23 387 -88 354 -65 b 333 6 334 -14 333 -6 b 366 86 333 35 344 66 b 456 122 390 111 423 121 b 602 27 517 122 582 88 b 606 1 605 19 606 10 b 575 -49 606 -20 596 -36 b 435 -88 530 -76 481 -82 z m 441 -269 b 194 -96 327 -262 249 -194 b 167 1 176 -62 167 -30 b 177 59 167 22 171 42 b 174 39 176 52 174 46 b 266 -104 174 -27 210 -73 b 511 -151 346 -148 435 -144 l 552 -151 b 740 -104 616 -145 683 -141 b 776 -66 756 -94 769 -81 b 700 -174 766 -105 740 -140 b 441 -269 632 -232 533 -268 z"
        },
        noteheadCircledWhole: {
            x_min: -50,
            x_max: 472,
            y_min: -231,
            y_max: 232,
            ha: 463,
            o: "m 289 -333 b 553 -255 370 -330 465 -307 b 680 -62 635 -206 680 -138 b 662 22 680 -36 674 -7 b 500 259 626 112 573 193 b 327 334 448 304 393 334 b 264 325 307 334 287 331 b -59 49 111 284 4 193 b -72 -19 -68 26 -72 4 b 289 -333 -72 -192 84 -334 z m 608 -69 b 605 -60 606 -66 606 -63 b 530 56 592 -14 570 26 b 372 137 482 92 425 111 b 228 170 324 158 275 168 b 134 157 196 170 166 166 b 29 82 91 145 53 117 b 60 132 37 99 49 115 b 333 301 128 226 223 276 b 350 302 338 301 344 302 b 438 252 386 302 413 276 b 590 26 505 189 560 115 b 608 -69 603 -10 608 -40 z m 262 -124 b 164 -59 215 -124 180 -101 b 160 -32 161 -50 160 -42 b 193 50 160 -3 171 30 b 284 86 217 75 251 85 b 429 -9 344 86 409 52 b 433 -36 432 -17 433 -26 b 402 -85 433 -56 423 -72 b 262 -124 357 -112 307 -118 z m 268 -305 b 22 -132 154 -298 76 -230 b -6 -33 3 -98 -6 -65 b 3 23 -6 -14 -3 6 b 1 3 1 16 1 10 b 94 -140 1 -63 37 -109 b 338 -187 173 -184 261 -180 l 379 -187 b 566 -140 444 -181 510 -177 b 602 -102 582 -130 595 -117 b 526 -210 592 -141 567 -176 b 268 -305 459 -268 360 -304 z"
        },
        noteheadCircledHalf: {
            x_min: -50,
            x_max: 393,
            y_min: -175,
            y_max: 175,
            ha: 350,
            o: "m 540 39 b 408 187 503 94 464 148 b 259 252 356 223 301 252 b 35 192 160 252 95 229 b -68 50 -17 160 -53 112 b -72 13 -71 37 -72 24 b 69 -204 -72 -79 -1 -161 b 246 -252 125 -238 186 -252 b 500 -164 336 -252 426 -219 b 566 -42 543 -132 566 -88 b 540 39 566 -14 557 14 z m 9 -42 b 12 -68 10 -50 10 -59 b -7 6 3 -46 -4 -22 b 131 189 1 98 55 153 b 243 220 167 206 204 215 b 261 222 249 222 255 222 b 377 161 308 222 341 189 b 435 89 402 141 420 117 b 431 92 433 89 432 91 b 346 120 402 102 372 107 b 253 143 314 135 282 143 b 85 79 193 143 138 115 b 9 -42 45 52 10 13 z m 356 39 b 343 1 356 24 351 12 b 206 -111 304 -46 259 -84 b 181 -118 196 -115 189 -118 b 156 -71 163 -118 154 -102 b 238 35 164 -22 199 9 b 324 66 264 52 294 59 b 356 39 348 71 356 62 z m 488 -78 b 392 -176 471 -125 433 -154 b 246 -225 346 -200 297 -217 b 230 -226 240 -226 235 -226 b 157 -204 203 -226 180 -215 b 78 -154 128 -190 101 -174 b 232 -184 128 -171 180 -184 b 344 -161 269 -184 307 -179 b 491 -39 405 -135 455 -94 b 500 -23 495 -33 497 -29 b 488 -78 500 -40 494 -59 z"
        },
        noteheadCircledBlack: {
            x_min: -70,
            x_max: 326,
            y_min: -168,
            y_max: 192,
            ha: 360,
            o: "m 176 -239 b 190 -242 180 -240 186 -240 b 262 -232 213 -242 238 -235 b 469 -19 384 -225 469 -131 b 467 22 469 -6 468 9 b 383 194 455 86 436 151 b 183 276 315 249 251 275 b 32 236 134 276 85 264 b -94 88 -30 207 -75 160 b -101 30 -98 69 -101 49 b 176 -239 -101 -107 9 -251 z m 177 -212 b -30 -27 81 -213 -13 -131 b -33 17 -33 -13 -33 3 b 127 226 -33 111 14 187 b 194 239 151 233 173 238 b 301 203 232 239 266 226 b 364 134 330 184 350 160 b 233 181 341 160 279 180 b 192 171 216 181 202 179 b 13 1 117 131 46 86 b 3 -48 6 -17 3 -33 b 60 -115 3 -79 20 -101 b 203 -135 105 -131 151 -138 b 229 -138 212 -137 220 -137 b 295 -122 251 -138 274 -135 b 400 -33 337 -99 373 -71 b 228 -206 393 -125 330 -192 b 177 -212 209 -209 192 -213 z"
        },
        noteheadDoubleWholeSquare: {
            x_min: 0,
            x_max: 474,
            y_min: -209,
            y_max: 211,
            ha: 420,
            o: "m 648 -301 b 668 -287 658 -304 665 -295 b 683 -209 678 -262 683 -235 b 677 258 681 -55 678 102 b 672 284 677 266 677 276 b 661 304 670 291 672 304 l 658 304 b 635 279 647 301 635 297 b 629 240 635 266 629 252 l 629 236 b 631 225 629 232 631 228 b 583 194 631 197 611 194 l 528 194 b 125 207 393 194 259 202 b 89 207 114 209 101 206 b 63 210 79 207 71 207 b 52 229 55 213 52 220 b 55 258 52 238 55 248 b 53 266 55 261 55 264 b 36 298 48 276 53 298 l 35 298 b 4 264 14 298 7 284 b 0 187 0 238 0 213 b 4 50 0 143 3 96 b 6 -10 6 30 6 10 b 4 -130 6 -50 4 -91 b 12 -268 4 -176 6 -222 b 19 -287 13 -275 10 -284 b 35 -275 26 -288 30 -281 b 52 -220 50 -261 48 -239 b 75 -199 55 -206 58 -199 l 141 -197 l 274 -197 l 634 -197 b 639 -281 635 -219 636 -251 b 648 -301 641 -288 638 -300 z m 72 -66 b 55 -56 59 -69 55 -65 l 55 -50 b 53 53 55 -16 55 20 b 69 73 53 69 60 72 l 79 72 b 330 65 163 66 246 63 l 592 65 b 634 81 606 65 618 71 b 635 -30 634 39 635 6 b 605 -58 635 -49 628 -58 b 451 -60 553 -60 503 -60 b 219 -59 373 -60 295 -59 l 166 -59 b 72 -66 134 -59 104 -60 z"
        },
        noteheadSquareWhite: {
            x_min: 0,
            x_max: 350,
            y_min: -131,
            y_max: 131,
            ha: 262,
            o: "m 468 -189 b 485 -187 474 -189 480 -189 b 500 -176 495 -187 500 -183 b 498 -168 500 -174 498 -171 b 497 -166 498 -167 497 -167 l 498 -164 b 504 -154 503 -163 504 -158 b 503 -138 504 -150 503 -144 l 503 -135 l 503 -94 b 492 66 500 -45 494 10 b 488 135 492 89 488 112 b 484 150 488 141 485 145 b 482 154 482 151 482 153 b 429 189 472 177 456 189 b 53 184 304 186 179 186 l 39 184 b 33 181 36 183 35 183 b 12 160 20 181 12 177 b 0 -109 9 71 4 -19 b 19 -137 0 -125 7 -134 b 23 -151 19 -141 20 -145 b 85 -187 37 -173 55 -187 b 468 -189 212 -187 340 -187 z m 246 -125 l 63 -125 b 66 -111 65 -122 66 -117 b 73 72 69 -50 71 10 l 73 130 b 88 128 78 128 82 128 b 148 130 108 130 128 130 b 271 128 190 130 230 128 l 271 130 l 420 130 b 428 20 425 92 425 56 l 436 -127 l 246 -127 z"
        },
        noteheadSquareBlack: {
            x_min: 0,
            x_max: 342,
            y_min: -130,
            y_max: 132,
            ha: 262,
            o: "m 217 190 b 439 186 304 190 372 190 b 467 180 448 184 458 183 b 492 145 484 176 492 167 b 490 -124 490 56 490 -33 b 488 -141 490 -130 488 -135 b 456 -170 488 -163 478 -168 b 118 -183 344 -176 230 -181 b 29 -184 89 -183 60 -192 b 0 -148 4 -180 0 -168 b 1 29 1 -89 1 -30 l 1 156 b 36 190 3 187 4 190 b 217 190 102 192 168 190 z"
        },
        noteheadTriangleDownDoubleWhole: {
            x_min: 0,
            x_max: 510,
            y_min: -213,
            y_max: 213,
            ha: 426,
            o: "m 16 -307 b 30 -289 26 -307 29 -297 b 43 -236 36 -272 42 -253 l 65 219 b 59 285 62 240 69 264 b 46 307 55 294 58 307 l 43 307 b 19 279 30 304 20 295 b 13 184 17 248 14 216 b 1 -125 9 81 7 -23 b 0 -163 0 -138 0 -150 b 6 -287 0 -204 4 -245 b 16 -307 6 -295 7 -305 z m 707 -294 b 734 -213 733 -271 734 -242 b 729 245 733 -60 730 92 b 719 285 729 259 724 272 b 707 298 716 291 714 298 l 703 298 b 685 284 696 297 687 292 b 683 253 683 274 683 264 b 691 -181 685 108 685 -36 b 707 -294 693 -217 690 -256 z m 108 -238 b 125 -203 125 -238 121 -216 b 127 -190 127 -199 127 -194 b 120 -138 127 -173 120 -156 l 120 -66 b 114 167 120 12 118 89 l 118 161 b 314 -153 184 58 248 -48 b 350 -184 327 -173 338 -184 b 387 -154 361 -184 374 -174 b 567 108 449 -68 508 20 b 626 193 588 137 608 164 b 615 -132 622 85 619 -24 l 615 -166 b 619 -207 615 -180 615 -194 b 638 -226 622 -217 629 -225 b 651 -209 648 -226 649 -216 b 658 -177 655 -199 658 -187 l 658 -171 b 667 49 655 -98 667 -23 b 665 88 667 62 667 75 b 665 220 665 135 667 179 b 641 265 664 238 660 265 b 626 243 629 265 626 255 b 628 222 626 236 628 228 b 612 225 624 223 619 225 b 384 223 537 223 461 223 l 384 225 l 170 225 b 131 215 157 225 144 222 b 112 200 122 210 117 206 b 88 266 111 225 108 249 b 75 239 76 259 75 249 b 73 147 75 207 73 179 b 82 -189 73 35 79 -78 b 84 -203 82 -194 82 -199 b 108 -238 86 -219 91 -238 z m 361 -79 b 295 78 336 -26 314 26 b 284 151 287 101 284 125 b 310 177 284 171 291 177 b 419 176 346 176 383 174 l 423 176 b 445 153 441 176 445 168 l 445 147 b 361 -79 442 65 415 -10 z"
        },
        noteheadTriangleDownWhole: {
            x_min: 0,
            x_max: 366,
            y_min: -145,
            y_max: 138,
            ha: 283,
            o: "m 242 -209 b 279 -180 253 -209 266 -200 b 459 84 341 -92 400 -4 b 520 170 480 112 501 141 b 527 189 524 177 527 183 b 504 199 527 196 520 199 l 55 199 b 23 190 45 199 33 196 b 0 161 9 181 0 173 b 10 135 0 154 3 145 b 206 -177 76 32 140 -73 b 242 -209 219 -199 230 -209 z m 253 -105 b 187 52 228 -52 206 0 b 176 127 179 76 176 101 b 197 151 176 144 181 151 l 202 151 b 256 150 220 151 238 150 b 311 151 275 150 294 151 b 337 128 331 151 337 144 l 337 122 b 253 -105 334 39 307 -35 z"
        },
        noteheadTriangleDownHalf: {
            x_min: 0,
            x_max: 341,
            y_min: -159,
            y_max: 159,
            ha: 318,
            o: "m 266 -229 b 282 -215 274 -229 278 -225 b 487 153 350 -92 418 30 b 491 170 490 158 491 164 b 480 189 491 177 487 183 b 425 215 464 202 448 213 b 33 226 297 217 168 222 b 13 229 29 223 22 229 b 1 222 9 229 4 228 b 14 184 -4 207 7 196 b 210 -176 81 65 145 -56 b 253 -225 222 -194 230 -213 b 266 -229 259 -226 264 -228 z m 134 22 b 147 43 138 27 141 37 b 206 163 174 79 179 127 b 213 170 209 166 212 167 l 340 167 b 193 -75 287 89 251 1 b 190 -82 192 -76 190 -79 z"
        },
        noteheadTriangleDownBlack: {
            x_min: 0,
            x_max: 346,
            y_min: -149,
            y_max: 149,
            ha: 298,
            o: "m 229 -215 b 259 -202 238 -215 248 -210 b 284 -173 269 -194 278 -184 l 482 173 b 498 209 488 184 498 194 b 481 215 492 215 487 215 b 63 213 343 215 203 213 b 12 197 45 213 29 206 b 0 180 4 193 0 187 b 3 168 0 177 1 173 b 13 150 6 163 9 156 l 196 -189 b 229 -215 206 -206 216 -215 z"
        },
        noteheadTriangleUpDoubleWhole: {
            x_min: 0,
            x_max: 510,
            y_min: -213,
            y_max: 213,
            ha: 426,
            o: "m 16 -307 b 30 -289 26 -307 29 -297 b 43 -236 36 -272 42 -253 l 65 219 b 59 285 62 240 69 264 b 46 307 55 294 58 307 l 43 307 b 19 279 30 304 20 295 b 13 184 17 248 14 216 b 1 -125 9 81 7 -23 b 0 -163 0 -138 0 -150 b 6 -287 0 -204 4 -245 b 16 -307 6 -295 7 -305 z m 707 -298 b 734 -217 733 -275 734 -246 b 729 240 733 -65 730 88 b 719 281 729 255 724 268 b 707 294 716 287 714 294 l 703 294 b 685 279 696 292 687 288 b 683 249 683 269 683 259 b 691 -186 685 104 685 -40 b 707 -298 693 -222 690 -261 z m 88 -266 b 112 -200 108 -249 111 -225 b 131 -215 117 -206 122 -210 b 170 -225 144 -222 157 -225 l 384 -225 l 384 -223 b 612 -225 461 -223 537 -223 b 628 -222 619 -225 624 -223 b 641 -265 628 -238 622 -265 b 665 -220 660 -265 664 -238 b 665 -88 667 -179 665 -135 b 667 -49 667 -75 667 -62 b 658 171 667 23 655 98 b 651 209 660 184 655 197 b 638 226 649 216 648 226 b 619 207 629 225 622 217 b 615 166 615 194 615 180 l 615 132 b 626 -193 619 24 622 -85 b 567 -108 608 -164 588 -137 b 387 154 508 -20 449 68 b 350 184 374 174 361 184 b 314 153 338 184 327 173 b 118 -161 248 48 184 -58 l 114 -167 b 120 66 118 -89 120 -12 l 120 138 b 127 190 120 156 127 173 b 125 203 127 194 127 199 b 108 238 121 216 125 238 b 84 203 91 238 86 219 b 82 189 82 199 82 194 b 73 -147 79 78 73 -35 b 75 -239 73 -179 75 -207 b 88 -266 75 -249 76 -259 z m 310 -177 b 284 -151 291 -177 284 -171 b 295 -78 284 -125 287 -101 b 361 79 314 -26 336 26 b 445 -147 415 10 442 -65 b 423 -176 446 -166 442 -176 l 419 -176 b 310 -177 383 -174 346 -176 z"
        },
        noteheadTriangleUpWhole: {
            x_min: 0,
            x_max: 366,
            y_min: -145,
            y_max: 138,
            ha: 283,
            o: "m 504 -209 b 527 -199 520 -209 527 -206 b 520 -180 527 -193 524 -187 b 459 -94 501 -151 480 -122 b 279 170 400 -6 341 82 b 242 199 266 190 253 199 b 206 167 230 199 219 189 b 10 -145 140 63 76 -42 b 0 -171 3 -156 0 -164 b 23 -200 0 -183 9 -192 b 55 -209 33 -206 45 -209 z m 202 -161 b 176 -137 183 -163 176 -156 b 187 -62 176 -111 179 -86 b 253 95 206 -10 228 42 b 337 -132 307 24 334 -49 b 311 -161 338 -153 334 -161 b 256 -160 294 -161 275 -160 b 202 -161 238 -160 220 -161 z"
        },
        noteheadTriangleUpHalf: {
            x_min: 0,
            x_max: 341,
            y_min: -159,
            y_max: 159,
            ha: 318,
            o: "m 458 -226 b 478 -229 462 -223 469 -229 b 490 -222 482 -229 487 -228 b 477 -184 495 -207 484 -196 b 281 176 410 -65 346 56 b 238 225 269 194 261 213 b 225 229 232 226 228 228 b 209 215 217 229 213 225 b 4 -153 141 92 73 -30 b 0 -170 1 -158 0 -164 b 12 -189 0 -177 4 -183 b 66 -215 27 -202 43 -213 b 458 -226 194 -217 323 -222 z m 151 -167 b 298 75 204 -89 240 -1 b 301 82 300 76 301 79 l 357 -22 b 344 -43 353 -27 350 -37 b 285 -163 317 -79 312 -127 b 278 -170 282 -166 279 -167 z"
        },
        noteheadTriangleUpBlack: {
            x_min: 0,
            x_max: 346,
            y_min: -149,
            y_max: 149,
            ha: 298,
            o: "m 481 -215 b 498 -209 487 -215 492 -215 b 482 -173 498 -194 488 -184 l 284 173 b 259 202 278 184 269 194 b 229 215 248 210 238 215 b 196 189 216 215 206 206 l 13 -150 b 3 -168 9 -156 6 -163 b 0 -180 1 -173 0 -177 b 12 -197 0 -187 4 -193 b 63 -213 29 -206 45 -213 b 481 -215 203 -213 343 -215 z"
        },
        noteheadSlashedDoubleWhole1: {
            x_min: 0,
            x_max: 697,
            y_min: -290,
            y_max: 290,
            ha: 580,
            o: "m 20 -418 b 42 -376 40 -418 37 -392 b 43 -356 45 -370 43 -363 l 43 -348 b 50 -197 43 -298 49 -248 b 78 317 58 -24 69 147 b 72 387 75 343 82 366 b 52 418 68 397 69 418 l 49 416 b 24 380 33 413 24 399 b 19 235 23 333 20 284 b 7 -82 14 130 10 24 b 0 -264 6 -143 0 -203 b 10 -382 0 -302 1 -343 b 20 -418 13 -393 6 -418 z m 976 -344 b 991 -331 985 -346 988 -337 b 1004 -271 999 -312 1004 -292 l 1004 -194 b 996 184 1004 -68 1001 59 b 996 281 996 216 998 249 b 984 379 995 314 991 347 b 971 397 981 392 976 396 b 952 386 965 397 959 392 b 943 361 943 380 945 370 b 937 288 939 337 937 312 b 945 158 937 245 942 203 b 959 -248 950 23 953 -112 b 966 -325 960 -274 963 -300 b 976 -344 966 -334 968 -344 z m 102 -331 b 124 -272 120 -314 122 -294 b 135 -278 127 -276 131 -278 l 141 -278 b 320 -199 206 -262 272 -252 b 348 -171 328 -189 338 -180 b 482 -199 392 -190 436 -199 b 704 -173 576 -199 641 -187 b 847 -82 760 -158 809 -130 l 855 -69 l 855 -73 b 863 -229 857 -125 860 -177 b 876 -255 863 -239 863 -255 b 893 -233 886 -255 888 -242 b 900 -189 899 -219 900 -203 l 900 66 b 900 192 899 108 900 150 b 893 301 900 228 899 265 b 877 325 890 310 893 325 l 876 325 b 855 301 865 324 855 315 b 850 202 852 268 847 235 b 854 50 854 151 854 101 b 821 99 847 68 835 85 b 733 167 795 127 765 148 b 831 253 766 196 799 225 b 851 265 837 258 844 261 b 829 282 840 275 835 279 b 772 295 815 291 795 295 b 685 271 739 295 704 287 b 624 215 665 252 645 233 l 566 232 b 527 239 553 236 540 239 b 490 228 514 239 501 236 b 451 219 475 217 467 219 b 275 176 389 219 331 200 b 184 53 216 150 184 105 b 199 -14 184 32 189 10 b 262 -108 215 -52 236 -82 l 125 -230 b 134 225 130 -78 132 73 b 135 269 134 239 135 255 b 121 330 135 291 132 311 b 95 287 99 323 95 307 b 92 124 94 233 95 179 b 85 -143 88 36 85 -53 b 89 -300 85 -196 86 -248 b 102 -331 89 -311 89 -323 z m 367 -14 b 350 43 359 3 351 22 b 392 122 350 82 363 107 b 544 171 439 150 492 160 b 572 168 554 174 563 171 z m 564 -132 b 467 -105 528 -138 497 -121 b 442 -89 458 -101 449 -95 l 658 101 b 690 30 677 82 690 59 b 688 10 690 24 690 17 b 564 -132 678 -45 611 -127 z"
        },
        noteheadSlashedWhole1: {
            x_min: -76,
            x_max: 498,
            y_min: -168,
            y_max: 168,
            ha: 336,
            o: "m -79 -242 b 55 -202 -32 -236 14 -228 l 145 -143 b 333 -171 203 -166 265 -171 b 429 -164 361 -174 395 -168 b 582 -130 481 -158 534 -154 b 657 -20 631 -105 657 -65 b 619 68 657 9 644 40 b 552 120 599 89 577 107 b 582 138 562 127 572 132 b 717 226 625 167 668 194 b 638 242 688 236 662 242 b 543 213 603 242 573 232 b 455 154 514 194 484 174 b 325 199 412 167 367 179 b 233 215 298 210 265 215 b 75 156 173 215 124 186 b 0 27 24 122 0 76 b 66 -98 0 -17 22 -63 b 72 -102 69 -99 71 -101 b -89 -209 17 -137 -36 -173 b -109 -225 -95 -213 -109 -216 b -108 -229 -109 -226 -108 -228 b -85 -242 -104 -239 -95 -242 z m 181 -29 b 167 14 171 -13 167 1 b 187 62 167 30 173 46 b 301 137 217 99 258 118 b 312 138 304 138 308 138 l 317 138 b 389 109 340 125 364 118 l 383 105 z m 337 -109 b 239 -82 301 -107 268 -99 l 468 65 b 482 24 477 53 482 40 b 480 4 482 19 481 12 b 337 -109 467 -56 399 -111 z"
        },
        noteheadSlashedHalf1: {
            x_min: -79,
            x_max: 471,
            y_min: -184,
            y_max: 184,
            ha: 368,
            o: "m -112 -251 b -94 -265 -107 -261 -101 -264 b -52 -242 -79 -265 -63 -249 l 89 -148 b 212 -180 125 -170 167 -179 b 238 -177 220 -180 229 -179 l 262 -180 b 346 -171 289 -180 318 -176 b 576 -91 431 -166 507 -140 b 641 4 619 -60 641 -29 b 592 96 641 35 625 65 l 583 104 b 533 147 567 121 550 134 l 613 200 b 678 261 636 216 664 232 b 658 265 671 264 664 265 b 611 248 641 265 625 258 l 491 171 b 337 204 444 194 392 204 b 281 200 318 204 300 204 b 27 62 180 187 92 145 b -1 -19 9 37 -1 10 b 36 -107 -1 -50 12 -82 b 52 -121 42 -112 46 -117 l -72 -203 b -112 -251 -91 -216 -122 -233 z m 161 -49 b 158 -29 160 -42 158 -35 b 183 33 158 -7 167 16 b 395 137 239 95 311 122 b 420 125 405 134 413 130 z m 276 -128 b 261 -131 271 -130 266 -131 b 181 -86 233 -131 203 -114 l 454 94 l 468 72 b 481 36 477 60 481 49 b 469 1 481 26 477 14 b 276 -128 422 -66 354 -105 z"
        },
        noteheadSlashedBlack1: {
            x_min: -110,
            x_max: 452,
            y_min: -190,
            y_max: 190,
            ha: 380,
            o: "m -131 -274 b -102 -262 -121 -272 -111 -266 b 7 -186 -65 -239 -29 -212 b 50 -157 22 -176 36 -166 b 105 -176 65 -166 84 -173 b 207 -183 140 -181 173 -183 b 239 -184 219 -184 229 -184 b 428 -91 327 -184 377 -150 b 487 43 461 -52 487 -7 b 482 76 487 53 485 65 b 459 128 478 95 469 112 b 507 161 475 138 491 150 l 651 262 b 622 274 641 271 632 274 b 605 271 616 274 611 272 b 514 233 573 262 541 252 l 422 167 b 317 203 392 190 354 203 b 271 196 301 203 285 200 b 168 157 236 186 200 173 b 6 -16 94 120 33 68 b -1 -62 1 -32 -1 -48 b 17 -125 -1 -86 4 -108 b -81 -196 -16 -148 -48 -173 b -145 -242 -102 -212 -128 -219 b -158 -256 -150 -246 -158 -251 b -157 -261 -158 -258 -157 -259 b -131 -274 -153 -269 -141 -274 z"
        },
        noteheadSlashedDoubleWhole2: {
            x_min: 0,
            x_max: 697,
            y_min: -295,
            y_max: 295,
            ha: 590,
            o: "m 870 -338 b 891 -315 884 -341 887 -325 b 906 -183 907 -274 903 -228 b 914 186 912 -60 904 62 b 914 240 914 203 916 222 b 916 276 913 251 916 265 b 899 300 916 289 913 300 b 871 253 874 300 871 274 b 858 -168 871 111 858 -27 b 860 -235 858 -190 860 -213 l 736 -131 b 834 -20 799 -111 834 -69 b 789 85 834 13 819 49 b 683 160 760 118 723 140 b 383 216 589 209 487 215 b 330 213 364 217 347 216 b 228 300 295 242 261 271 b 86 347 184 337 138 348 b 58 343 76 347 63 350 l 58 360 b 35 425 58 384 53 423 b 6 382 9 425 6 403 l 6 131 b 0 -164 6 33 4 -66 b 24 -327 -1 -216 6 -271 b 50 -262 46 -305 50 -284 l 50 -154 b 52 -45 50 -118 50 -81 b 58 325 55 79 58 202 b 73 310 60 320 68 315 b 94 294 79 304 86 298 b 89 271 89 287 89 278 l 89 94 b 104 -194 101 -20 88 -108 b 118 -245 107 -213 104 -248 b 140 -190 140 -243 140 -212 l 140 -62 b 132 258 140 46 138 153 l 132 259 l 235 173 b 193 132 219 161 204 148 b 153 26 167 101 153 63 b 164 -35 153 7 157 -16 b 341 -170 196 -114 261 -158 b 433 -177 372 -174 403 -177 b 619 -157 497 -177 559 -170 l 706 -230 b 799 -276 736 -258 765 -276 b 818 -274 806 -276 812 -276 l 861 -274 b 863 -312 861 -287 863 -300 b 870 -338 864 -321 858 -337 z m 966 -425 b 986 -397 979 -425 982 -408 b 991 -373 989 -390 989 -382 b 995 -239 991 -328 995 -284 b 1004 334 1001 -49 1002 143 b 995 380 1005 350 1005 367 b 982 402 989 386 992 402 l 978 400 b 949 374 965 396 950 390 b 948 333 948 360 948 346 l 948 -37 b 949 -84 949 -52 949 -68 b 946 -248 949 -132 946 -189 b 953 -396 946 -297 948 -346 b 966 -425 955 -408 950 -425 z m 624 -36 b 416 140 554 22 485 81 b 482 156 439 150 461 154 b 625 81 537 156 588 124 b 647 27 639 63 647 46 b 624 -36 647 7 638 -14 z m 469 -117 b 320 14 386 -118 320 -60 b 343 81 320 37 327 60 l 547 -95 b 469 -117 521 -105 494 -111 z"
        },
        noteheadSlashedWhole2: {
            x_min: -83,
            x_max: 510,
            y_min: -201,
            y_max: 198,
            ha: 399,
            o: "m 734 -289 b 696 -245 726 -266 710 -256 b 586 -164 660 -217 622 -192 l 589 -161 b 654 -50 631 -135 654 -94 b 616 40 654 -19 641 13 b 305 174 536 127 420 174 b 171 151 261 174 215 167 b 166 150 170 151 168 150 b 86 209 140 170 112 189 b -94 284 32 249 -22 289 l -108 285 b -120 274 -114 285 -120 284 b -104 251 -120 266 -112 258 b 71 124 -46 209 12 166 l 85 114 b 36 72 66 102 50 89 b 0 -30 12 40 0 4 b 122 -186 0 -96 45 -160 b 343 -222 194 -210 268 -222 b 514 -197 410 -220 467 -213 l 554 -228 b 734 -289 609 -268 668 -275 z m 477 -82 b 268 73 408 -30 338 22 l 301 91 b 336 101 314 96 324 101 b 370 88 347 101 359 96 b 459 9 405 66 436 43 b 481 -56 474 -13 481 -35 b 477 -82 481 -65 480 -73 z m 310 -161 b 216 -143 276 -161 246 -156 b 166 -72 181 -128 166 -105 b 168 -46 166 -65 167 -55 b 206 26 176 -16 189 7 b 436 -140 282 -29 360 -84 b 382 -158 420 -150 402 -157 b 310 -161 357 -161 333 -161 z"
        },
        noteheadSlashedHalf2: {
            x_min: -73,
            x_max: 454,
            y_min: -188,
            y_max: 188,
            ha: 376,
            o: "m 654 -271 b 603 -202 649 -233 625 -217 b 481 -115 563 -173 523 -144 b 564 -60 510 -101 539 -82 b 615 40 596 -33 615 4 b 609 69 615 50 613 60 b 505 167 590 120 554 151 b 336 190 451 184 392 190 b 124 134 259 190 189 171 l -42 248 b -88 271 -56 256 -75 271 b -101 265 -94 271 -98 269 b -105 252 -104 259 -105 255 b -66 210 -105 235 -82 222 l 85 107 b 0 -24 42 73 0 35 b 183 -183 0 -118 75 -184 b 262 -176 206 -180 233 -177 b 438 -135 324 -171 383 -158 b 570 -228 482 -166 527 -197 b 654 -271 595 -243 621 -259 z m 393 -53 l 311 4 l 225 65 b 392 134 274 102 331 122 b 455 50 425 141 455 101 b 439 -3 455 35 451 14 b 393 -53 425 -22 409 -37 z m 287 -121 b 246 -130 272 -127 259 -130 b 171 -89 215 -130 189 -115 b 156 -40 161 -73 156 -58 b 186 29 156 -17 166 7 l 192 35 l 359 -82 b 287 -121 337 -98 312 -111 z"
        },
        noteheadSlashedBlack2: {
            x_min: -84,
            x_max: 405,
            y_min: -189,
            y_max: 189,
            ha: 378,
            o: "m 557 -265 b 573 -272 562 -268 567 -272 b 583 -261 577 -272 580 -269 b 575 -242 580 -253 579 -248 b 524 -190 563 -220 544 -204 b 405 -99 485 -160 445 -130 b 497 50 449 -60 482 -9 b 500 72 498 58 500 65 b 478 122 500 91 492 107 b 331 186 438 167 387 186 b 120 131 258 186 186 167 l 107 124 b -52 242 53 163 1 203 b -89 265 -63 251 -76 259 b -107 272 -95 268 -101 272 b -117 266 -109 272 -114 271 b -121 251 -120 262 -121 256 b -114 235 -121 245 -120 239 b -60 186 -96 217 -81 199 b 63 95 -20 156 22 125 b -1 -35 26 66 -1 27 b 137 -183 -1 -130 46 -183 b 174 -180 148 -183 161 -181 l 245 -171 b 366 -128 289 -166 331 -150 l 426 -171 b 557 -265 469 -203 514 -233 z"
        },
        noteheadDiamondDoubleWhole: {
            x_min: 0,
            x_max: 429,
            y_min: -221,
            y_max: 221,
            ha: 442,
            o: "m 22 -318 b 42 -294 33 -318 37 -302 b 46 -266 45 -285 45 -275 b 50 -219 49 -249 50 -233 b 48 -153 50 -197 49 -176 b 43 120 43 -62 43 29 l 43 253 b 37 298 43 269 45 284 b 26 318 35 305 35 318 l 24 318 b 1 295 13 317 3 308 b 0 268 0 285 0 276 l 0 -121 b 10 -291 0 -177 1 -235 b 22 -318 12 -301 10 -318 z m 593 -312 b 618 -256 611 -294 616 -276 l 618 -186 b 611 253 618 -40 612 108 b 605 276 611 261 608 268 b 589 295 600 284 600 297 b 567 272 577 294 569 285 l 567 251 b 575 -197 573 102 575 -48 b 593 -312 575 -233 579 -271 z m 99 -268 b 114 -256 107 -269 111 -262 b 127 -196 124 -238 125 -217 b 128 -144 128 -179 128 -161 b 122 -9 128 -99 125 -55 l 135 -19 b 344 -179 206 -71 276 -122 b 370 -190 354 -186 363 -190 b 395 -173 379 -190 386 -184 b 492 -33 426 -127 459 -79 b 491 -86 491 -50 491 -68 b 507 -251 491 -138 495 -193 b 534 -184 530 -228 533 -206 b 541 144 537 -75 539 35 b 530 204 541 164 539 186 b 520 220 528 210 528 220 b 500 203 511 219 503 213 b 498 192 498 200 498 194 l 498 176 b 494 7 497 120 497 63 l 490 12 l 287 176 b 258 190 279 181 274 190 b 212 153 239 186 225 168 l 127 40 b 121 32 124 37 122 35 b 118 114 120 59 118 86 b 102 249 117 158 122 206 b 75 219 85 246 79 236 b 72 187 72 209 72 197 b 76 117 72 164 75 141 b 85 -151 79 27 79 -62 b 91 -251 86 -184 91 -217 b 99 -268 91 -258 92 -266 z m 392 -128 b 374 -122 387 -134 380 -127 l 180 29 b 170 45 173 35 170 39 b 176 56 170 48 173 52 b 236 122 204 101 219 122 b 308 76 252 122 272 107 l 433 -26 b 449 -50 439 -32 449 -36 b 392 -128 432 -75 413 -102 z"
        },
        noteheadDiamondWhole: {
            x_min: 0,
            x_max: 271,
            y_min: -132,
            y_max: 132,
            ha: 264,
            o: "m 230 -177 b 256 -190 240 -186 249 -190 b 281 -173 265 -190 272 -184 b 382 -29 314 -124 347 -76 b 390 -10 387 -22 390 -14 b 376 12 390 -3 386 4 b 173 177 308 66 240 121 b 144 190 166 183 160 190 b 98 153 127 186 112 170 b 13 40 69 115 42 76 b 0 13 4 29 0 20 b 22 -19 0 3 7 -9 b 230 -177 92 -69 163 -122 z m 279 -128 b 261 -122 274 -134 266 -127 l 66 30 b 56 45 59 35 56 39 b 62 56 56 48 59 52 b 122 122 91 101 105 122 b 194 76 138 122 158 107 l 320 -26 b 336 -50 325 -32 336 -35 b 279 -128 318 -75 300 -102 z"
        },
        noteheadDiamondHalf: {
            x_min: 0,
            x_max: 295,
            y_min: -148,
            y_max: 148,
            ha: 296,
            o: "m 228 -207 b 245 -213 235 -210 240 -213 b 264 -203 252 -213 258 -210 b 415 -46 314 -150 364 -98 b 425 -27 420 -40 425 -35 b 416 -10 425 -22 422 -16 b 217 200 350 60 284 131 b 194 213 212 207 204 213 b 170 196 181 213 177 203 b 14 33 118 143 68 86 b 0 7 4 23 0 16 b 17 -20 0 -1 6 -10 b 118 -114 52 -50 82 -85 b 228 -207 156 -144 184 -184 z m 209 -157 b 134 -69 177 -138 141 -115 b 130 -26 131 -55 130 -40 b 215 148 130 42 160 99 b 225 156 217 151 220 156 b 230 153 226 156 228 156 b 323 -26 276 104 321 55 b 298 -75 324 -42 315 -59 b 265 -109 287 -86 276 -99 b 209 -157 245 -125 228 -167 z"
        },
        noteheadDiamondBlack: {
            x_min: 0,
            x_max: 310,
            y_min: -146,
            y_max: 146,
            ha: 292,
            o: "m 266 -210 b 289 -194 278 -209 284 -200 b 406 -76 330 -156 367 -115 b 446 -23 433 -49 446 -36 b 412 29 446 -10 435 3 b 405 36 409 30 408 33 b 252 196 354 89 304 143 b 225 210 243 204 235 210 b 204 202 219 210 212 209 b 10 24 141 141 75 82 b 0 9 4 19 0 14 b 9 -6 0 4 3 0 l 232 -192 b 266 -210 242 -200 256 -204 z"
        },
        noteheadParenthesis: {
            x_min: -70,
            x_max: 329,
            y_min: -196,
            y_max: 201,
            ha: 397,
            o: "m 344 -279 b 382 -262 361 -288 370 -272 b 405 -233 390 -255 399 -245 b 474 9 455 -158 468 -73 b 416 228 474 78 448 174 b 364 282 403 249 387 271 b 344 289 359 285 350 288 b 331 279 338 289 333 287 b 325 248 328 269 325 258 b 338 225 325 238 328 229 b 412 138 379 207 396 174 b 445 1 433 92 445 45 b 346 -217 445 -81 410 -154 b 336 -252 340 -223 336 -238 b 344 -279 336 -265 338 -276 z m 19 -274 b 35 -282 24 -279 30 -281 b 49 -265 42 -282 46 -275 b 52 -243 50 -256 52 -249 b 36 -210 52 -230 49 -220 b -60 -59 -16 -173 -35 -114 b -73 9 -69 -39 -73 -16 b 33 223 -73 92 -24 189 b 50 265 43 229 50 249 b 33 288 50 278 46 289 b 4 272 23 288 14 275 b -9 261 0 269 -4 265 b -101 23 -58 193 -105 124 b -37 -206 -104 -52 -75 -130 b 19 -274 -23 -232 -6 -255 z"
        },
        noteheadParenthesisRight: {
            x_min: -30,
            x_max: 82,
            y_min: -199,
            y_max: 206,
            ha: 405,
            o: "m -17 -282 b 24 -264 -6 -297 12 -272 b 60 -219 40 -253 52 -236 b 117 1 96 -150 112 -75 b 118 16 118 6 118 12 b 109 73 118 36 112 55 b 4 279 99 154 68 226 b -23 297 -4 287 -13 297 b -37 289 -27 297 -32 294 b -43 266 -42 285 -43 276 b -32 225 -43 251 -37 229 b 84 -7 48 170 84 82 b 32 -184 84 -69 65 -132 b -10 -222 22 -200 4 -209 b -24 -258 -20 -232 -24 -245 b -17 -282 -24 -266 -22 -276 z"
        },
        noteheadParenthesisLeft: {
            x_min: 0,
            x_max: 106,
            y_min: -197,
            y_max: 197,
            ha: 394,
            o: "m 134 -284 b 138 -281 135 -284 137 -284 b 145 -268 144 -278 145 -274 l 144 -253 b 107 -180 138 -225 121 -204 b 42 13 71 -120 42 -56 b 49 73 42 32 43 52 b 137 210 62 128 95 171 b 153 255 147 219 153 239 b 145 278 153 265 151 274 b 130 284 140 281 135 284 b 98 259 117 284 108 268 b 0 37 35 203 1 131 b 118 -268 9 -69 53 -173 b 134 -284 121 -274 127 -284 z"
        },
        noteheadMoonBlack: {
            x_min: 0,
            x_max: 328,
            y_min: -125,
            y_max: 125,
            ha: 250,
            o: "m 353 -160 b 465 -40 412 -140 451 -102 b 472 30 471 -17 472 6 b 469 124 472 60 469 92 b 406 179 469 170 459 177 l 128 179 b 37 180 98 179 68 179 b 0 141 7 180 0 170 b 3 -20 3 88 3 33 b 69 -134 3 -72 26 -109 b 240 -180 125 -164 181 -180 b 353 -160 278 -180 315 -174 z"
        },
        noteheadTriangleLeftBlack: {
            x_min: 0,
            x_max: 391,
            y_min: -142,
            y_max: 142,
            ha: 284,
            o: "m 138 -204 b 318 -197 197 -199 258 -197 l 431 -197 b 544 -192 469 -196 507 -193 b 563 -184 552 -190 560 -193 b 553 -167 564 -177 559 -171 l 540 -157 b 232 60 436 -85 334 -12 l 50 190 b 20 204 42 197 32 204 b 10 202 17 204 14 204 b 0 184 1 197 0 192 b 1 164 0 177 1 170 b 6 -150 3 59 6 -45 b 39 -193 7 -176 17 -186 b 138 -204 72 -204 105 -204 z"
        },
        noteheadTriangleRightBlack: {
            x_min: 0,
            x_max: 398,
            y_min: -139,
            y_max: 140,
            ha: 279,
            o: "m 543 -200 b 573 -176 566 -200 573 -194 l 573 -168 b 554 141 566 -66 560 37 b 520 197 553 167 546 187 b 495 202 511 200 504 202 b 454 184 481 202 467 196 l 35 -137 b 0 -171 22 -147 -4 -154 b 52 -199 6 -193 33 -193 b 69 -199 58 -200 63 -199 z"
        },
        noteheadTriangleRoundDownBlack: {
            x_min: 0,
            x_max: 334,
            y_min: -134,
            y_max: 136,
            ha: 270,
            o: "m 252 -192 b 285 -176 269 -196 276 -187 b 468 52 346 -99 406 -23 b 481 79 477 62 481 71 b 465 104 481 88 475 95 b 441 124 456 109 449 117 b 249 196 380 174 314 194 b 13 104 157 196 69 154 b 0 86 6 98 0 92 b 7 69 0 82 3 76 b 202 -164 73 -7 137 -85 b 252 -192 216 -181 235 -186 z"
        },
        augmentationDot: {
            x_min: 0,
            x_max: 96,
            y_min: -57,
            y_max: 57,
            ha: 114,
            o: "m 13 -82 b 16 -81 14 -82 14 -82 b 105 -73 46 -76 75 -76 b 131 -48 121 -72 131 -60 b 138 26 134 -24 138 0 b 137 48 138 33 138 40 b 108 82 134 71 125 82 b 95 81 104 82 99 82 b 33 71 75 78 53 75 b 4 46 20 68 6 62 b 0 -66 1 9 0 -29 b 13 -82 0 -73 1 -82 z"
        },
        tremolo1: {
            x_min: -158,
            x_max: 156,
            y_min: -88,
            y_max: 88,
            ha: 176,
            o: "m -206 -127 b -194 -125 -203 -127 -199 -127 b 173 -36 -72 -94 50 -65 b 220 16 202 -29 215 -12 b 225 50 223 30 225 45 b 216 107 226 76 222 91 b 194 127 210 120 204 127 b 183 124 192 127 189 127 l -192 33 b -226 -9 -213 27 -222 14 b -228 -32 -226 -16 -228 -23 b -222 -108 -228 -58 -222 -82 b -206 -127 -222 -120 -217 -127 z"
        },
        flag8thUp: {
            x_min: 0,
            x_max: 261,
            y_min: -819,
            y_max: 0,
            ha: 819,
            o: "m 265 -1171 b 351 -1035 301 -1130 336 -1087 b 376 -867 369 -979 376 -923 b 367 -755 376 -829 373 -792 b 233 -422 350 -632 311 -520 b 131 -291 199 -379 166 -334 b 65 -125 91 -239 66 -192 b 62 -75 65 -112 62 -91 b 42 0 62 -49 52 -24 l 35 0 b 0 -63 6 -13 0 -36 l 0 -144 b 96 -445 0 -255 29 -356 b 177 -547 124 -478 150 -514 b 308 -831 246 -629 298 -721 b 317 -890 310 -851 317 -871 b 311 -919 317 -900 315 -910 b 256 -1005 297 -950 282 -984 b 228 -1068 233 -1024 228 -1045 b 230 -1106 228 -1080 229 -1093 b 240 -1162 232 -1125 239 -1143 b 251 -1179 242 -1174 246 -1179 b 265 -1171 255 -1179 259 -1176 z"
        },
        flag8thDown: {
            x_min: 0,
            x_max: 261,
            y_min: 0,
            y_max: 819,
            ha: 819,
            o: "m 265 1171 b 251 1179 259 1176 255 1179 b 240 1162 246 1179 242 1174 b 230 1106 239 1143 232 1125 b 228 1068 229 1093 228 1080 b 256 1005 228 1045 233 1024 b 311 919 282 984 297 950 b 317 890 315 910 317 900 b 308 831 317 871 310 851 b 177 547 298 721 246 629 b 96 445 150 514 124 478 b 0 144 29 356 0 255 l 0 63 b 35 0 0 36 6 13 l 42 0 b 62 75 52 24 62 49 b 59 117 62 91 59 104 b 131 291 60 183 91 239 b 233 422 166 334 199 379 b 367 755 311 520 350 632 b 376 867 373 792 376 829 b 351 1035 376 923 369 979 b 265 1171 336 1087 301 1130 z"
        },
        flag16thUp: {
            x_min: 0,
            x_max: 327,
            y_min: -819,
            y_max: 0,
            ha: 819,
            o: "m 415 -1179 b 435 -1168 423 -1182 429 -1174 b 451 -1138 442 -1159 446 -1149 b 465 -1020 464 -1102 467 -1064 b 461 -962 464 -1004 464 -984 b 471 -821 467 -916 472 -870 b 465 -721 472 -791 467 -756 b 415 -520 459 -651 441 -585 b 200 -245 370 -408 284 -327 b 96 -114 160 -206 118 -168 b 75 -24 84 -85 85 -53 b 59 0 72 -16 72 0 b 53 -1 58 0 56 -1 b 27 -32 40 -6 27 -10 b 29 -68 27 -43 29 -55 b 10 -79 20 -69 13 -72 b 1 -109 6 -89 1 -99 b 0 -170 0 -130 0 -148 b 35 -410 0 -252 12 -333 b 258 -793 76 -557 156 -681 b 409 -1158 350 -896 410 -1014 b 415 -1179 409 -1165 405 -1175 z m 413 -816 b 331 -681 392 -769 364 -723 b 145 -420 266 -596 189 -521 b 86 -281 125 -374 102 -330 b 156 -370 105 -312 128 -343 b 318 -539 210 -425 269 -478 b 413 -816 383 -621 420 -713 z"
        },
        flag16thDown: {
            x_min: 0,
            x_max: 327,
            y_min: 0,
            y_max: 819,
            ha: 819,
            o: "m 59 0 b 75 24 72 0 72 16 b 96 114 85 53 84 85 b 200 245 118 168 160 206 b 415 520 284 327 370 408 b 465 721 441 585 459 651 b 471 821 467 756 472 791 b 461 962 472 870 467 916 b 465 1020 464 984 464 1004 b 451 1138 467 1064 464 1102 b 435 1168 446 1149 442 1159 b 418 1179 431 1172 425 1179 l 415 1179 b 408 1169 409 1176 408 1174 b 409 1158 408 1165 409 1161 b 258 793 410 1014 350 896 b 35 410 156 681 76 557 b 0 170 12 333 0 252 l 0 88 b 29 7 0 71 6 23 b 59 0 33 4 58 0 z m 86 281 b 145 420 102 330 125 374 b 331 681 189 521 266 596 b 413 816 364 723 392 769 b 415 791 413 808 415 799 b 318 539 415 698 377 613 b 156 370 269 478 210 425 b 86 281 128 343 105 312 z"
        },
        flag32ndUp: {
            x_min: 0,
            x_max: 268,
            y_min: -849,
            y_max: 149,
            ha: 999,
            o: "m 323 -1223 b 351 -1198 337 -1227 344 -1210 b 359 -1184 354 -1194 356 -1188 b 386 -999 377 -1122 387 -1060 b 341 -783 386 -927 372 -855 b 330 -736 334 -769 330 -753 b 333 -708 330 -727 330 -717 b 344 -621 340 -678 344 -649 b 341 -579 344 -608 343 -593 b 328 -500 338 -553 328 -526 b 331 -475 328 -491 328 -484 b 347 -370 343 -438 348 -402 b 151 27 348 -212 288 -56 b 53 176 98 59 50 102 b 45 197 53 183 48 192 b 33 215 40 203 40 216 l 30 215 b 6 194 22 212 9 209 b 0 120 3 170 -1 145 b 0 -43 4 65 0 13 b 0 -98 0 -60 1 -79 b 4 -276 0 -157 6 -216 b 7 -456 4 -337 7 -397 b 66 -638 7 -523 22 -585 b 158 -724 94 -671 127 -697 b 318 -1011 246 -801 295 -899 b 321 -1044 321 -1021 321 -1032 b 312 -1152 321 -1080 312 -1116 b 317 -1192 312 -1165 314 -1179 b 323 -1223 320 -1202 311 -1220 z m 285 -376 b 121 -180 249 -289 173 -245 b 91 -105 104 -158 92 -135 b 288 -354 181 -144 288 -269 b 285 -376 288 -363 287 -370 z m 275 -657 b 111 -492 226 -589 163 -547 b 65 -376 78 -456 66 -418 b 71 -323 65 -360 68 -341 b 275 -657 164 -418 265 -504 z"
        },
        flag32ndDown: {
            x_min: -3,
            x_max: 268,
            y_min: -169,
            y_max: 829,
            ha: 999,
            o: "m 323 1194 b 317 1164 311 1191 320 1174 b 312 1123 314 1151 312 1136 b 321 1015 312 1087 321 1051 b 318 982 321 1004 321 992 b 158 696 295 870 246 772 b 66 609 127 668 94 642 b 7 428 22 556 7 494 b 4 248 7 369 4 308 b -1 78 6 187 -10 137 b 0 14 0 59 0 32 l 0 -148 b 6 -223 0 -174 3 -199 b 30 -243 9 -238 22 -240 l 33 -243 b 45 -226 40 -245 40 -232 b 53 -204 48 -220 53 -212 b 151 -56 50 -131 98 -88 b 347 341 288 27 348 183 b 331 446 348 373 343 409 b 328 471 328 455 328 462 b 341 550 328 497 338 524 b 344 592 343 564 344 579 b 333 680 344 621 340 649 b 330 707 330 688 330 698 b 341 755 330 724 334 740 b 386 971 372 827 386 899 b 359 1155 387 1031 377 1093 b 351 1169 356 1159 354 1165 b 323 1194 344 1181 337 1198 z m 275 628 b 71 294 265 475 164 389 b 65 347 68 312 65 331 b 111 464 66 389 78 428 b 275 628 163 518 226 560 z m 285 347 b 288 325 287 341 288 334 b 91 76 288 240 181 115 b 121 151 92 107 104 130 b 285 347 173 216 249 261 z"
        },
        flag64thUp: {
            x_min: -4,
            x_max: 282,
            y_min: -824,
            y_max: 347,
            ha: 1171,
            o: "m 350 -1185 b 380 -1162 364 -1189 374 -1175 b 406 -1022 399 -1119 406 -1071 b 359 -798 406 -945 384 -871 b 348 -756 353 -785 348 -772 b 350 -744 348 -753 350 -749 b 363 -621 356 -704 363 -664 b 360 -580 363 -608 363 -593 b 359 -560 359 -573 359 -567 b 373 -490 359 -536 366 -513 b 393 -346 386 -444 393 -395 b 387 -269 393 -320 390 -294 b 348 -127 382 -219 348 -173 b 351 -104 348 -120 348 -111 b 353 -65 351 -91 353 -78 b 341 37 353 -26 348 6 b 226 215 323 108 278 164 b 86 336 181 258 127 288 b 62 395 72 353 62 370 b 42 481 62 423 55 454 b 27 500 37 488 36 500 b 24 498 26 500 26 500 b -1 480 14 497 1 492 b -6 444 -4 467 -6 455 l -6 435 b -1 341 -1 403 -1 372 l -1 266 b 6 156 -1 230 0 193 b 13 35 12 117 13 75 l 13 -35 b 14 -85 13 -52 14 -68 b 29 -276 19 -150 33 -213 b 20 -448 24 -334 20 -392 b 24 -534 20 -477 22 -505 b 114 -708 30 -605 59 -664 b 197 -780 143 -732 171 -755 b 344 -1153 301 -884 341 -1011 b 343 -1172 344 -1159 343 -1166 b 350 -1185 343 -1176 344 -1182 z m 287 -88 b 62 193 186 -17 79 48 b 229 52 121 144 174 98 b 289 -33 256 29 274 -3 b 295 -56 294 -42 295 -49 b 287 -88 295 -66 292 -76 z m 298 -410 b 118 -235 238 -351 176 -295 b 76 -88 82 -197 78 -147 b 268 -252 137 -153 203 -202 b 330 -360 304 -279 330 -315 b 323 -402 330 -373 327 -387 b 311 -418 318 -413 315 -418 b 298 -410 307 -418 302 -415 z m 300 -691 b 117 -508 243 -616 168 -575 b 82 -408 94 -480 82 -448 b 84 -379 82 -397 82 -387 b 259 -553 135 -451 206 -492 b 301 -667 287 -583 301 -619 b 300 -691 301 -674 301 -683 z"
        },
        flag64thDown: {
            x_min: -5,
            x_max: 281,
            y_min: -375,
            y_max: 796,
            ha: 1171,
            o: "m 348 1145 b 341 1132 343 1142 341 1136 b 343 1113 341 1126 343 1119 b 196 740 340 971 300 844 b 112 668 170 714 141 691 b 23 494 58 624 29 564 b 19 408 20 465 19 436 b 27 236 19 351 23 294 b 13 45 32 173 17 109 b 12 -6 13 27 12 12 l 12 -75 b 4 -196 12 -115 10 -157 b -3 -307 -1 -233 -3 -271 l -3 -382 b -7 -475 -3 -412 -3 -444 l -7 -484 b -3 -520 -7 -495 -6 -507 b 23 -539 0 -533 13 -537 b 26 -540 24 -540 24 -540 b 40 -521 35 -540 36 -528 b 60 -435 53 -494 60 -464 b 85 -376 60 -410 71 -393 b 225 -255 125 -328 180 -298 b 340 -78 276 -204 321 -148 b 351 24 347 -46 351 -14 b 350 63 351 37 350 50 b 347 86 347 71 347 79 b 386 229 347 132 380 179 b 392 305 389 253 392 279 b 372 449 392 354 384 403 b 357 520 364 472 357 495 b 359 540 357 527 357 533 b 361 580 361 553 361 567 b 348 704 361 624 354 664 b 347 716 348 708 347 713 b 357 757 347 732 351 744 b 405 982 383 831 405 904 b 379 1122 405 1031 397 1079 b 348 1145 373 1135 363 1149 z m 298 651 b 300 626 300 642 300 634 b 258 513 300 579 285 543 b 82 338 204 452 134 410 b 81 367 81 347 81 357 b 115 468 81 408 92 439 b 298 651 167 534 242 576 z m 297 370 b 310 377 301 374 305 377 b 321 361 314 377 317 373 b 328 320 325 347 328 333 b 266 212 328 275 302 239 b 75 48 202 161 135 112 b 117 194 76 107 81 157 b 297 370 174 255 236 311 z m 285 48 b 294 16 291 36 294 26 b 288 -7 294 9 292 1 b 228 -92 272 -37 255 -69 b 60 -233 173 -138 120 -184 b 285 48 78 -88 184 -23 z"
        },
        flag128thUp: {
            x_min: 0,
            x_max: 252,
            y_min: -804,
            y_max: 530,
            ha: 1334,
            o: "m 298 -1158 b 328 -1126 312 -1158 320 -1139 b 330 -1116 330 -1123 330 -1119 b 347 -996 343 -1076 347 -1037 b 328 -837 347 -943 338 -890 b 320 -778 324 -816 320 -798 b 330 -733 320 -763 323 -749 b 340 -665 338 -714 337 -688 b 341 -645 340 -660 341 -652 b 333 -534 341 -609 333 -572 b 343 -471 333 -513 334 -492 b 361 -366 356 -436 361 -402 b 331 -202 361 -311 348 -256 b 328 -187 330 -197 328 -193 b 331 -179 328 -184 328 -181 b 363 -55 353 -137 363 -96 b 337 79 363 -12 351 33 b 327 114 333 92 327 104 b 344 144 327 124 331 132 b 359 174 353 150 357 163 b 361 228 360 193 361 210 b 243 517 361 337 325 435 b 147 596 213 546 179 569 b 75 708 111 626 75 655 b 62 744 75 723 68 733 b 50 763 58 752 58 763 b 46 762 49 763 48 762 b 17 742 36 757 22 757 b 0 697 14 726 0 711 b 1 595 0 662 3 631 b 0 469 0 552 0 511 b 1 429 0 456 0 442 b 22 289 6 382 22 337 b 24 128 22 238 24 184 b 22 66 24 108 23 86 b 19 -19 20 37 19 10 b 20 -132 19 -56 20 -95 b 13 -276 20 -180 19 -229 b 9 -359 10 -304 9 -330 b 12 -487 9 -402 12 -445 b 56 -582 12 -526 29 -554 b 197 -742 107 -632 160 -681 b 288 -1100 265 -851 276 -976 b 288 -1122 288 -1107 287 -1115 b 287 -1145 289 -1129 287 -1138 b 298 -1158 287 -1153 288 -1158 z m 304 150 b 75 475 229 256 112 334 b 304 150 233 357 305 287 z m 271 -73 b 127 72 233 -14 179 26 b 81 167 96 98 81 127 b 84 194 81 176 82 184 b 271 -73 148 102 242 39 z m 279 -396 b 132 -223 233 -330 180 -279 b 81 -112 104 -192 81 -156 b 82 -91 81 -105 81 -98 b 279 -396 167 -125 269 -281 z m 249 -609 b 69 -357 197 -520 88 -471 b 249 -609 131 -441 229 -498 z"
        },
        flag128thDown: {
            x_min: -1,
            x_max: 252,
            y_min: -580,
            y_max: 754,
            ha: 1334,
            o: "m 298 1086 b 287 1073 288 1086 287 1081 b 288 1050 287 1066 289 1057 b 288 1028 287 1043 288 1035 b 197 670 276 904 265 779 b 56 510 160 609 107 560 b 12 415 29 482 12 454 b 9 287 12 373 9 330 b 13 204 9 258 10 232 b 20 60 19 157 20 108 b 19 -53 20 23 19 -16 b 22 -138 19 -82 20 -109 b 24 -200 23 -158 24 -180 b 22 -361 24 -256 22 -310 b 1 -501 22 -409 6 -454 b 0 -541 0 -514 0 -528 b 0 -667 0 -583 -3 -624 b 0 -809 0 -675 -3 -791 b 46 -834 4 -825 36 -829 b 50 -835 48 -834 49 -835 b 62 -816 58 -835 58 -824 b 75 -780 68 -805 75 -795 b 147 -668 75 -727 111 -698 b 243 -589 179 -641 213 -618 b 361 -300 325 -507 361 -409 b 359 -246 361 -282 360 -265 b 344 -216 357 -235 353 -222 b 327 -186 331 -204 327 -196 b 337 -151 327 -176 333 -164 b 363 -17 351 -105 363 -60 b 331 107 363 24 353 65 b 328 115 328 109 328 112 b 331 130 328 121 330 125 b 361 294 348 184 361 239 b 343 399 361 330 356 364 b 333 462 334 420 333 441 b 341 573 333 500 341 537 b 340 593 341 580 340 588 b 330 661 337 616 338 642 b 320 706 323 677 320 691 b 328 765 320 726 324 744 b 347 924 338 818 347 871 b 330 1044 347 965 343 1004 b 328 1054 330 1047 330 1051 b 298 1086 320 1067 312 1086 z m 249 537 b 69 285 229 426 131 369 b 249 537 88 399 197 448 z m 279 324 b 82 19 269 209 167 53 b 81 40 81 26 81 33 b 132 151 81 84 104 120 b 279 324 180 207 233 258 z m 271 1 b 84 -266 242 -111 148 -174 b 81 -239 82 -256 81 -248 b 127 -144 81 -199 96 -170 b 271 1 179 -98 233 -58 z m 304 -222 b 75 -547 305 -359 233 -429 b 304 -222 112 -406 229 -328 z"
        },
        accidentalFlat: {
            x_min: 1,
            x_max: 209,
            y_min: -208,
            y_max: 472,
            ha: 680,
            o: "m 29 -300 b 46 -289 33 -300 39 -297 b 107 -243 65 -274 86 -258 b 301 127 233 -153 301 -30 b 298 186 301 147 301 166 b 190 297 291 256 251 297 b 147 289 177 297 163 294 b 86 265 127 284 107 274 l 85 264 l 85 301 b 91 465 85 356 88 410 b 94 559 91 497 94 527 b 84 651 94 589 91 621 b 66 680 81 661 81 680 l 65 680 b 37 645 49 678 37 665 b 33 523 36 605 32 563 l 33 478 b 26 223 33 393 29 308 b 1 -141 22 101 1 -19 b 17 -287 1 -189 4 -239 b 29 -300 20 -295 23 -300 z m 68 -105 b 76 12 71 -68 72 -29 b 81 107 79 43 81 75 l 86 109 b 171 135 114 121 141 135 b 204 128 181 135 193 132 b 238 92 228 120 239 108 b 230 63 238 84 236 75 b 68 -105 193 -10 132 -59 z"
        },
        accidentalNatural: {
            x_min: 0,
            x_max: 214,
            y_min: -456,
            y_max: 462,
            ha: 918,
            o: "m 255 -657 b 281 -624 271 -657 275 -636 b 285 -599 282 -615 285 -608 b 292 -300 288 -500 289 -400 b 289 -161 292 -253 289 -207 b 300 128 292 -65 297 32 b 304 168 300 128 302 150 l 304 173 l 305 190 l 305 199 l 307 225 b 304 259 307 229 310 246 b 272 298 297 274 302 305 b 63 266 204 279 134 272 b 72 514 68 348 72 432 b 71 595 72 541 72 567 b 56 665 71 619 66 642 b 17 579 9 651 17 608 b 3 144 19 433 7 289 b 0 -7 1 94 0 43 b 3 -134 0 -50 1 -92 b 7 -219 3 -163 7 -192 b 35 -251 7 -243 17 -251 b 49 -249 39 -251 43 -251 l 223 -223 l 230 -222 l 230 -359 b 223 -516 230 -410 223 -464 b 236 -619 223 -550 226 -585 b 255 -657 240 -634 236 -657 z m 58 -63 b 55 81 56 -14 53 33 l 56 99 b 85 99 65 99 75 98 b 232 108 134 104 183 107 l 240 109 l 236 66 b 232 -48 235 29 232 -10 b 58 -81 174 -63 115 -73 z"
        },
        accidentalSharp: {
            x_min: -22,
            x_max: 390,
            y_min: -384,
            y_max: 383,
            ha: 767,
            o: "m 202 -553 b 219 -526 213 -552 216 -536 b 226 -471 225 -507 226 -488 b 225 -425 226 -455 225 -441 b 226 -392 225 -415 225 -402 b 233 -305 229 -363 232 -334 l 297 -292 b 331 -469 300 -353 311 -412 b 347 -485 333 -477 338 -485 b 363 -469 356 -487 359 -477 b 374 -418 373 -454 374 -435 b 376 -382 376 -405 376 -393 b 372 -276 376 -347 373 -311 l 455 -259 b 550 -156 534 -243 544 -232 b 550 -109 550 -137 552 -124 b 526 -78 549 -91 541 -78 l 523 -78 b 507 -79 517 -78 513 -78 b 403 -101 474 -88 438 -95 l 379 -105 b 382 -42 380 -85 380 -63 b 384 96 383 4 384 50 b 503 131 425 107 464 118 b 549 173 524 138 543 150 b 562 249 554 199 562 223 b 554 294 562 264 560 279 b 536 315 549 308 544 315 l 533 315 b 517 312 528 315 523 315 b 382 266 472 294 428 279 l 377 344 b 359 531 374 406 372 469 b 348 552 356 539 357 552 l 347 552 l 343 552 b 315 528 331 549 317 544 l 315 501 b 320 249 315 416 318 333 l 243 232 b 239 361 243 275 242 318 b 226 425 238 383 238 403 b 199 359 194 409 199 382 b 193 223 196 312 194 268 b 72 202 153 215 112 209 b 4 118 13 192 4 183 b 10 66 0 102 12 84 b 33 29 7 39 14 30 b 48 32 37 29 42 30 b 187 55 95 39 141 46 l 183 -75 b 176 -145 181 -99 179 -122 b 16 -179 122 -156 69 -166 b -32 -232 -14 -186 -32 -197 b -17 -331 -32 -266 -19 -298 b -1 -356 -17 -347 -13 -354 b 12 -353 1 -356 6 -354 b 167 -320 63 -341 115 -331 b 166 -377 166 -338 166 -357 b 189 -526 166 -428 171 -477 b 202 -553 192 -536 189 -553 z m 240 -132 b 243 -37 242 -101 242 -69 b 245 65 245 -3 245 30 b 315 79 269 69 292 73 b 301 -120 308 13 305 -53 z"
        },
        accidentalDoubleSharp: {
            x_min: 0,
            x_max: 287,
            y_min: -159,
            y_max: 159,
            ha: 318,
            o: "m 84 -229 b 107 -216 91 -229 98 -225 b 200 -125 138 -186 167 -154 b 232 -95 212 -115 222 -105 b 347 -189 271 -125 310 -157 b 370 -200 356 -196 363 -200 b 396 -179 380 -200 389 -192 b 412 -102 410 -154 406 -125 b 377 -27 410 -69 400 -46 l 325 14 b 402 91 350 42 374 68 b 413 127 410 96 413 107 b 382 200 409 148 397 176 b 350 229 370 220 360 229 b 314 210 340 229 328 223 b 274 174 300 199 285 187 b 212 104 252 151 232 128 b 92 187 173 132 132 161 b 78 193 86 192 82 193 b 68 190 75 193 72 193 b 48 179 62 186 53 187 b 40 137 43 168 40 154 b 81 16 40 92 56 32 b 107 -3 89 10 98 4 b 14 -94 76 -32 45 -62 b 0 -124 6 -102 0 -114 b 12 -154 0 -134 3 -144 b 62 -215 26 -176 48 -193 b 84 -229 69 -225 76 -229 z"
        },
        accidentalDoubleFlat: {
            x_min: 0,
            x_max: 359,
            y_min: -220,
            y_max: 446,
            ha: 666,
            o: "m 43 -317 b 72 -301 55 -317 63 -310 b 160 -186 108 -268 134 -226 b 236 -60 186 -145 212 -102 b 233 -131 235 -85 233 -108 b 239 -220 233 -161 235 -190 b 259 -246 240 -233 239 -240 b 301 -228 284 -252 291 -238 b 465 -7 369 -163 416 -85 b 517 173 500 48 517 108 b 451 307 517 229 505 284 b 409 315 436 312 422 315 b 331 287 382 315 356 305 b 311 274 324 282 320 274 l 310 274 l 310 566 b 305 621 310 585 312 603 b 294 642 301 628 305 642 l 292 642 b 264 622 282 641 266 636 b 253 575 259 606 256 590 b 246 418 248 523 246 471 b 248 243 246 360 248 302 l 248 187 b 164 238 220 225 193 238 b 85 213 140 238 112 226 b 84 229 85 220 84 225 b 86 315 85 258 86 287 b 81 528 86 386 82 458 b 71 582 81 547 78 566 b 56 603 66 590 68 603 l 53 603 b 23 580 40 600 26 598 b 19 537 20 566 19 552 b 20 514 19 530 19 521 b 26 390 24 472 26 432 b 14 66 26 282 16 174 b 0 -168 13 -12 0 -91 b 12 -279 0 -206 3 -242 b 30 -314 16 -294 14 -308 b 43 -317 35 -317 39 -317 z m 301 -72 b 302 7 302 -45 302 -19 l 302 86 b 351 158 304 121 321 145 b 383 166 361 163 373 166 b 435 143 402 166 419 157 b 445 127 441 138 445 132 b 441 114 445 122 444 118 b 301 -72 397 49 354 -14 z m 75 -147 b 73 30 75 -86 75 -29 b 118 82 73 62 92 76 b 132 84 124 84 128 84 b 190 52 156 84 174 69 b 193 40 192 49 193 45 b 192 33 193 37 193 35 b 75 -147 157 -30 125 -95 z"
        },
        accidentalParensLeft: {
            x_min: 0,
            x_max: 130,
            y_min: -270,
            y_max: 268,
            ha: 538,
            o: "m 107 -389 b 127 -374 114 -389 120 -384 b 141 -347 132 -367 137 -357 b 151 -294 148 -330 151 -311 b 122 -207 151 -265 141 -236 b 63 -65 94 -164 72 -117 b 59 -10 60 -46 59 -27 b 145 223 59 78 94 153 b 187 354 176 262 189 305 b 177 384 187 364 190 380 b 143 373 166 387 153 383 b 124 354 137 367 130 361 b 0 -35 33 240 0 108 l 0 -92 b 85 -372 4 -193 27 -287 b 107 -389 92 -383 99 -389 z"
        },
        accidentalParensRight: {
            x_min: 0,
            x_max: 139,
            y_min: -275,
            y_max: 277,
            ha: 552,
            o: "m 58 -396 b 96 -354 75 -396 85 -370 b 200 13 168 -238 200 -111 b 153 268 200 109 184 190 b 49 392 131 320 101 364 b 26 399 40 397 33 399 b 0 366 10 399 0 387 b 0 318 -1 350 0 334 l 0 291 b 27 238 -3 266 7 253 b 143 9 105 180 143 98 b 141 -20 143 -1 143 -10 b 63 -225 135 -92 108 -164 b 36 -307 45 -251 36 -278 b 40 -344 36 -320 37 -331 b 42 -356 42 -347 42 -351 b 58 -396 42 -374 37 -396 z"
        },
        accidentalQuarterToneFlatStein: {
            x_min: 0,
            x_max: 208,
            y_min: -240,
            y_max: 440,
            ha: 680,
            o: "m 272 -346 b 284 -333 278 -346 281 -341 b 300 -187 297 -285 300 -235 b 275 177 300 -65 279 55 b 268 432 272 262 268 347 l 268 477 b 264 599 269 517 265 559 b 236 634 264 619 252 632 l 235 634 b 217 605 220 634 220 615 b 207 513 210 575 207 543 b 210 419 207 481 210 451 b 216 255 213 364 216 310 l 216 217 l 215 219 b 154 243 194 228 174 238 b 111 251 138 248 124 251 b 3 140 50 251 10 210 b 0 81 0 120 0 101 b 194 -289 0 -76 68 -199 b 255 -336 215 -304 236 -320 b 272 -346 262 -343 268 -346 z m 233 -151 b 71 17 168 -105 108 -56 b 63 46 65 29 63 37 b 96 82 62 62 73 73 b 130 89 108 86 120 89 b 215 63 160 89 187 75 l 220 60 b 225 -35 220 29 222 -3 b 233 -151 229 -75 230 -114 z"
        },
        accidentalThreeQuarterTonesFlatZimmermann: {
            x_min: 0,
            x_max: 422,
            y_min: -240,
            y_max: 440,
            ha: 680,
            o: "m 272 -346 b 284 -333 278 -346 281 -341 b 300 -187 297 -285 300 -235 b 275 177 300 -65 279 55 b 268 432 272 262 268 347 l 268 477 b 264 599 269 517 265 559 b 236 634 264 619 252 632 l 235 634 b 217 605 220 634 220 615 b 207 513 210 575 207 543 b 210 419 207 481 210 451 b 216 255 213 364 216 310 l 216 217 l 215 219 b 154 243 194 228 174 238 b 111 251 138 248 124 251 b 3 140 50 251 10 210 b 0 81 0 120 0 101 b 194 -289 0 -76 68 -199 b 255 -336 215 -304 236 -320 b 272 -346 262 -343 268 -346 z m 336 -346 b 353 -336 340 -346 346 -343 b 413 -289 372 -320 393 -304 b 608 81 540 -199 608 -76 b 605 140 608 101 608 120 b 497 251 598 210 557 251 b 454 243 484 251 469 248 b 393 219 433 238 413 228 l 392 217 l 392 255 b 397 419 392 310 395 364 b 400 513 397 451 400 481 b 390 605 400 543 397 575 b 373 634 387 615 387 634 l 372 634 b 344 599 356 632 344 619 b 340 477 343 559 338 517 l 340 432 b 333 177 340 347 336 262 b 308 -187 328 55 308 -65 b 324 -333 308 -235 311 -285 b 336 -346 327 -341 330 -346 z m 233 -151 b 71 17 168 -105 108 -56 b 63 46 65 29 63 37 b 96 82 62 62 73 73 b 130 89 108 86 120 89 b 215 63 160 89 187 75 l 220 60 b 225 -35 220 29 222 -3 b 233 -151 229 -75 230 -114 z m 374 -151 b 383 -35 377 -114 379 -75 b 387 60 386 -3 387 29 l 393 63 b 478 89 420 75 448 89 b 511 82 488 89 500 86 b 544 46 534 73 546 62 b 537 17 544 37 543 29 b 374 -151 500 -56 439 -105 z"
        },
        accidentalQuarterToneSharpStein: {
            x_min: 0,
            x_max: 300,
            y_min: -338,
            y_max: 351,
            ha: 689,
            o: "m 194 -487 b 225 -432 215 -469 223 -452 b 238 -232 229 -366 236 -298 b 377 -199 285 -220 331 -209 b 418 -164 397 -193 410 -181 b 432 -88 428 -138 432 -114 b 412 -42 432 -55 428 -42 b 389 -46 406 -42 399 -43 l 235 -85 b 233 -20 235 -63 233 -42 b 233 105 232 22 233 63 b 312 121 259 111 285 117 b 406 226 390 134 400 145 b 373 284 409 268 402 284 b 344 281 364 284 356 282 b 232 258 307 276 269 266 b 230 308 232 275 232 291 b 210 505 229 374 232 441 b 183 471 189 501 184 490 b 180 406 181 449 180 428 b 184 246 180 353 184 300 b 48 222 140 236 94 228 b 0 168 6 216 0 209 b 7 86 1 141 4 114 b 27 66 9 73 13 66 l 35 66 b 184 94 85 66 135 84 b 187 -1 184 62 186 30 b 190 -96 189 -33 190 -65 l 112 -114 b 35 -213 27 -132 35 -132 b 33 -253 35 -226 35 -240 b 49 -276 33 -269 37 -276 b 62 -275 52 -276 56 -276 l 186 -245 l 186 -256 b 179 -387 180 -300 177 -343 b 194 -487 180 -419 179 -454 z"
        },
        accidentalThreeQuarterTonesSharpStein: {
            x_min: -23,
            x_max: 388,
            y_min: -373,
            y_max: 445,
            ha: 818,
            o: "m 114 -537 b 138 -475 137 -518 138 -495 b 147 -292 138 -413 144 -353 b 212 -278 168 -287 190 -282 b 243 -444 215 -333 225 -389 b 261 -467 248 -454 251 -465 b 281 -446 272 -469 276 -455 b 292 -347 292 -416 288 -384 b 288 -262 289 -320 288 -291 l 374 -245 b 376 -311 374 -266 374 -288 b 390 -456 379 -357 379 -405 b 416 -396 412 -436 415 -418 b 423 -287 420 -360 423 -323 b 422 -235 423 -269 423 -252 b 451 -229 432 -233 441 -232 b 547 -98 524 -215 547 -199 l 547 -89 b 521 -49 546 -59 540 -49 b 497 -52 516 -49 507 -49 b 418 -68 469 -56 444 -63 b 423 52 419 -29 422 12 b 426 140 425 81 425 109 b 495 160 449 145 472 153 b 552 219 526 170 546 189 b 559 279 557 240 553 262 b 530 341 559 324 552 341 b 490 331 520 341 507 338 b 432 311 471 324 452 318 b 449 552 436 392 442 471 b 452 588 451 563 452 575 b 446 622 452 599 451 611 b 436 641 444 629 448 641 b 418 628 428 641 420 636 b 409 602 413 621 410 611 b 386 297 396 501 390 399 b 297 274 356 288 327 281 b 291 403 295 317 294 360 b 274 550 288 452 284 501 b 259 569 271 564 265 569 b 240 559 253 569 248 563 b 230 537 232 554 230 546 l 230 488 b 233 369 230 448 232 409 b 236 261 236 333 238 297 b 156 245 210 255 183 251 b 154 396 154 295 154 346 b 150 416 154 403 153 410 b 140 438 145 423 150 438 l 138 438 b 118 413 128 436 118 428 b 112 354 118 393 114 374 b 109 238 109 315 109 276 b 49 226 89 233 69 230 b 3 163 16 222 3 202 b 7 91 3 138 9 114 b 29 62 7 69 13 62 b 39 63 32 62 35 63 b 104 73 60 66 82 71 b 101 -10 104 46 102 17 l 92 -132 l 10 -150 b -33 -204 -19 -157 -33 -170 b -19 -310 -32 -240 -19 -274 b -6 -324 -19 -321 -13 -324 b 6 -323 -1 -324 1 -324 b 82 -307 32 -317 58 -311 b 81 -376 82 -330 81 -353 b 114 -537 81 -431 94 -484 z m 294 -92 b 297 -37 295 -73 295 -56 b 300 49 300 -9 300 20 l 300 108 b 379 127 325 114 353 120 b 374 -76 376 59 374 -9 b 294 -92 347 -82 320 -86 z m 154 -120 b 157 20 154 -73 156 -26 b 158 82 158 40 158 62 b 230 95 183 86 206 89 b 225 0 229 63 226 32 b 217 -107 223 -35 220 -71 z"
        },
        accidentalBuyukMucennebFlat: {
            x_min: 2,
            x_max: 287,
            y_min: -248,
            y_max: 432,
            ha: 680,
            o: "m 410 128 b 302 239 403 199 363 239 b 259 232 289 239 275 236 b 199 207 239 226 219 216 l 197 206 l 197 243 l 197 251 b 347 317 248 272 298 295 b 376 347 360 324 372 334 b 389 435 387 376 393 405 b 348 454 384 462 377 465 b 202 387 300 432 251 409 b 203 408 203 395 203 402 l 203 431 b 347 490 252 451 300 469 b 376 517 360 495 372 505 b 389 599 387 546 393 572 b 348 616 384 625 377 628 l 203 556 b 196 593 202 569 199 582 b 179 622 193 603 193 622 l 177 622 b 150 588 161 621 150 608 b 147 533 150 570 148 552 b 29 488 108 517 69 503 b 3 455 12 482 3 472 b 12 353 1 422 9 389 b 145 408 56 372 101 389 b 145 363 145 392 145 377 l 29 315 b 3 281 12 310 3 298 b 12 170 1 245 9 209 l 141 226 b 138 166 140 206 138 186 b 114 -199 134 43 115 -76 b 130 -344 114 -246 117 -297 b 141 -357 132 -353 135 -357 b 158 -347 145 -357 151 -354 b 219 -301 177 -331 199 -315 b 413 69 346 -210 413 -88 b 410 128 413 89 413 108 z m 350 35 b 343 6 350 26 348 17 b 180 -163 308 -69 245 -117 b 189 -46 183 -125 184 -86 b 193 49 192 -14 193 17 l 199 52 b 284 78 226 63 253 78 b 317 71 294 78 305 75 b 350 35 340 62 351 50 z"
        },
        accidentalBuyukMucennebSharp: {
            x_min: -1,
            x_max: 467,
            y_min: -460,
            y_max: 350,
            ha: 810,
            o: "m 230 -662 b 256 -615 249 -647 255 -631 b 264 -495 261 -575 264 -534 b 261 -361 264 -451 262 -406 b 415 -324 312 -348 363 -336 b 416 -445 415 -364 416 -405 b 431 -593 416 -492 419 -541 b 458 -533 454 -573 456 -554 b 464 -418 462 -494 464 -455 b 459 -314 464 -383 462 -348 b 531 -298 484 -308 508 -304 b 570 -259 554 -292 566 -278 b 579 -192 575 -236 579 -215 b 576 -164 579 -183 577 -173 b 556 -143 573 -147 567 -143 b 543 -144 553 -143 549 -143 b 459 -164 516 -151 487 -157 b 462 -102 459 -144 461 -122 l 608 -76 b 667 -24 639 -71 660 -53 b 672 19 671 -9 671 9 l 672 46 b 641 108 668 94 662 108 b 605 101 632 108 621 105 l 580 96 b 469 72 544 88 507 79 b 471 131 469 91 471 111 b 521 141 488 135 504 138 b 573 197 550 148 570 167 b 577 271 576 222 577 246 b 553 300 577 291 567 300 b 537 297 549 300 543 298 b 480 285 517 292 498 288 b 491 410 482 327 485 369 b 494 445 492 422 494 433 b 488 482 494 458 492 469 b 477 504 487 490 491 504 b 455 484 467 504 458 495 b 451 464 452 478 452 471 b 433 275 442 402 438 338 b 282 246 383 265 333 255 l 291 346 b 294 382 292 359 294 370 b 287 418 294 395 292 406 b 276 435 284 423 289 435 b 259 423 269 435 264 429 b 251 397 255 416 252 406 b 235 239 242 346 239 292 b 166 228 212 235 189 232 b 118 170 134 223 112 207 b 120 140 120 160 120 150 b 120 84 120 121 118 102 b 131 69 120 75 122 69 b 138 71 132 69 135 71 b 226 85 168 75 197 81 b 223 30 226 66 225 49 l 223 17 l 45 -22 b -1 -92 13 -29 -1 -48 b 1 -171 -1 -118 3 -145 b 12 -187 0 -184 4 -187 b 22 -186 14 -187 17 -187 b 115 -164 53 -179 84 -170 b 217 -145 150 -158 183 -153 b 215 -225 216 -173 216 -199 l 203 -229 b 132 -275 141 -246 132 -249 b 134 -315 132 -285 134 -298 b 135 -382 134 -336 132 -359 b 144 -396 135 -386 134 -396 b 151 -395 145 -396 148 -396 b 215 -376 171 -387 193 -382 b 216 -516 215 -422 215 -468 b 230 -662 217 -563 219 -611 z m 271 27 b 274 94 272 50 274 72 b 425 122 324 102 374 112 l 425 101 b 422 62 423 88 423 75 z m 262 -177 b 264 -137 264 -164 264 -151 b 418 -109 315 -128 366 -120 b 415 -174 416 -131 416 -153 b 262 -213 364 -186 312 -199 z"
        },
        accidentalBakiyeFlat: {
            x_min: 2,
            x_max: 287,
            y_min: -236,
            y_max: 444,
            ha: 680,
            o: "m 141 -340 b 158 -330 145 -340 151 -337 b 219 -284 177 -314 199 -298 b 413 86 346 -193 413 -71 b 410 145 413 107 413 125 b 302 256 403 216 363 256 b 259 249 289 256 275 253 b 199 225 239 243 219 233 l 197 223 l 197 261 b 199 334 197 285 199 310 b 347 406 249 357 298 382 b 376 439 360 413 372 425 b 390 516 384 465 390 490 b 389 537 390 523 390 530 b 372 564 384 556 382 564 b 348 557 367 564 359 562 b 204 487 300 537 253 510 b 206 518 206 497 206 507 b 196 611 206 549 203 580 b 179 639 193 621 193 639 l 177 639 b 150 605 161 638 150 625 b 145 482 148 564 144 523 l 145 458 b 29 405 107 439 68 420 b 3 366 12 397 3 386 b 12 243 1 325 9 287 b 143 307 56 265 99 285 l 138 183 b 114 -181 134 60 114 -59 b 130 -327 114 -229 117 -279 b 141 -340 132 -336 135 -340 z m 180 -145 b 189 -29 183 -108 184 -69 b 193 66 192 3 193 35 l 199 69 b 284 95 226 81 253 95 b 317 88 294 95 305 92 b 350 52 340 79 351 68 b 343 23 350 43 348 35 b 180 -145 305 -50 245 -99 z"
        },
        accidentalKomaSharp: {
            x_min: 0,
            x_max: 300,
            y_min: -338,
            y_max: 351,
            ha: 689,
            o: "m 194 -487 b 225 -432 215 -469 223 -452 b 238 -232 229 -366 236 -298 b 377 -199 285 -220 331 -209 b 418 -164 397 -193 410 -181 b 432 -88 428 -138 432 -114 b 412 -42 432 -55 428 -42 b 389 -46 406 -42 399 -43 l 235 -85 b 233 -20 235 -63 233 -42 b 233 105 232 22 233 63 b 312 121 259 111 285 117 b 406 226 390 134 400 145 b 373 284 409 268 402 284 b 344 281 364 284 356 282 b 232 258 307 276 269 266 b 230 308 232 275 232 291 b 210 505 229 374 232 441 b 183 471 189 501 184 490 b 180 406 181 449 180 428 b 184 246 180 353 184 300 b 48 222 140 236 94 228 b 0 168 6 216 0 209 b 7 86 1 141 4 114 b 27 66 9 73 13 66 l 35 66 b 184 94 85 66 135 84 b 187 -1 184 62 186 30 b 190 -96 189 -33 190 -65 l 112 -114 b 35 -213 27 -132 35 -132 b 33 -253 35 -226 35 -240 b 49 -276 33 -269 37 -276 b 62 -275 52 -276 56 -276 l 186 -245 l 186 -256 b 179 -387 180 -300 177 -343 b 194 -487 180 -419 179 -454 z"
        },
        accidentalKucukMucennebSharp: {
            x_min: 0,
            x_max: 359,
            y_min: -420,
            y_max: 343,
            ha: 763,
            o: "m 236 -605 b 262 -543 256 -583 261 -564 b 269 -423 268 -503 269 -464 b 266 -340 269 -396 268 -367 l 361 -318 b 405 -276 384 -312 399 -298 b 413 -189 412 -248 416 -219 b 395 -164 412 -171 409 -164 b 382 -166 392 -164 387 -164 b 264 -193 343 -176 304 -184 b 269 -102 265 -163 268 -132 b 454 -62 331 -89 392 -78 b 501 -23 477 -58 494 -45 b 517 62 511 6 517 33 b 487 112 517 95 513 112 b 471 111 482 112 477 112 b 274 66 406 95 340 81 b 276 138 275 91 276 114 b 350 154 301 144 325 148 b 402 203 377 160 396 176 b 412 284 408 230 412 258 b 392 311 412 302 406 311 b 372 308 386 311 379 310 b 287 291 343 301 314 297 l 295 405 b 298 441 297 416 298 428 b 292 475 298 452 297 464 b 282 494 289 482 294 494 b 264 481 274 494 266 490 b 255 455 259 474 256 464 b 239 282 248 397 243 340 b 148 268 209 278 179 274 b 62 164 62 252 62 253 l 62 132 b 79 108 60 117 65 108 l 86 108 l 230 130 b 229 92 230 118 229 105 b 228 56 228 79 228 68 b 66 20 173 43 120 32 b 0 -59 6 7 3 1 l 0 -138 b 14 -160 -1 -156 4 -160 b 27 -158 19 -160 23 -160 b 222 -112 92 -141 157 -127 b 220 -203 220 -143 220 -173 b 147 -217 196 -207 171 -213 b 89 -288 92 -228 89 -229 b 95 -347 85 -305 96 -325 b 112 -374 92 -366 98 -374 b 125 -373 117 -374 121 -374 l 220 -351 b 222 -458 220 -386 220 -422 b 236 -605 223 -504 225 -552 z"
        },
        accidentalKoron: {
            x_min: 0,
            x_max: 303,
            y_min: -462,
            y_max: 180,
            ha: 642,
            o: "m 59 -665 b 72 -649 69 -662 72 -657 b 69 -626 72 -642 69 -634 b 69 -622 69 -625 69 -624 l 69 -600 b 55 -156 60 -456 68 -311 b 86 -170 66 -166 76 -170 b 112 -163 95 -170 104 -166 b 390 -35 204 -120 298 -78 b 436 -1 409 -27 436 -27 b 396 46 436 22 413 33 l 382 55 b 46 243 271 121 157 179 b 12 259 29 253 17 259 b 0 219 1 259 0 248 b 3 -372 0 22 3 -176 b 6 -616 3 -454 6 -536 b 59 -665 6 -638 40 -671 z m 55 199 b 363 24 156 141 258 84 b 55 -118 259 -24 160 -69 z"
        },
        accidentalSori: {
            x_min: 0,
            x_max: 434,
            y_min: -295,
            y_max: 325,
            ha: 620,
            o: "m 194 -425 b 196 -409 194 -418 196 -413 b 194 -194 196 -337 196 -266 b 364 -127 251 -171 308 -150 b 361 -321 363 -192 364 -256 b 410 -387 360 -357 373 -377 b 413 -373 412 -382 413 -377 b 418 -114 418 -287 418 -200 l 418 -105 b 595 -35 477 -82 536 -59 b 625 0 612 -27 625 -22 b 593 48 624 23 618 39 l 419 117 b 423 370 419 202 423 285 b 426 403 423 382 426 393 b 418 436 426 415 425 426 b 384 468 409 449 399 468 b 369 448 370 468 369 459 b 369 436 369 444 369 441 l 369 428 l 369 423 b 367 138 369 328 367 233 l 353 143 l 192 207 l 192 367 b 173 406 192 383 184 396 b 151 422 167 413 160 422 b 144 420 148 422 147 422 b 137 403 138 416 137 410 l 137 392 l 137 229 b 33 271 102 243 68 256 b 13 276 26 274 19 276 b 0 262 6 276 0 272 b 35 199 1 239 0 212 l 138 160 b 140 -148 138 58 138 -45 b 56 -181 111 -158 84 -170 b 24 -215 35 -189 24 -199 b 29 -235 24 -220 26 -228 b 49 -253 35 -249 42 -253 b 78 -240 59 -253 69 -243 b 140 -216 98 -233 120 -225 l 140 -356 b 194 -425 140 -406 141 -406 z m 194 -125 b 193 138 194 -37 193 50 b 315 89 233 122 275 107 b 366 71 333 84 350 76 b 364 -58 366 27 366 -16 b 194 -125 308 -81 251 -104 z m 419 49 l 526 7 l 485 -10 l 419 -36 z"
        },
        articAccentAbove: {
            x_min: 0,
            x_max: 425,
            y_min: 0,
            y_max: 326,
            ha: 326,
            o: "m 27 1 b 78 12 46 0 62 6 b 347 112 168 45 253 91 b 521 184 409 128 459 167 b 608 259 557 194 589 220 b 612 274 611 265 612 271 b 598 292 612 281 608 287 b 477 347 559 312 518 331 b 176 465 374 384 275 425 b 156 469 168 468 161 469 b 125 456 145 469 137 465 b 53 370 96 432 78 399 b 45 353 48 363 45 357 b 68 333 45 344 52 337 b 360 225 166 298 262 261 b 192 154 302 203 249 171 b 13 36 120 132 53 105 b 0 13 9 29 0 22 l 0 9 b 16 0 3 1 10 0 l 26 0 b 27 1 27 0 27 0 z"
        },
        articAccentBelow: {
            x_min: 0,
            x_max: 425,
            y_min: -326,
            y_max: 0,
            ha: 326,
            o: "m 26 -469 l 27 -469 b 78 -458 46 -469 62 -464 b 347 -357 168 -426 253 -380 b 521 -285 409 -341 459 -302 b 608 -210 557 -276 589 -249 b 612 -196 611 -204 612 -200 b 598 -179 612 -189 608 -183 b 477 -122 559 -157 518 -138 b 176 -4 374 -85 275 -45 b 156 0 168 -1 161 0 b 125 -13 145 0 137 -4 b 53 -99 96 -37 78 -71 b 45 -117 48 -107 45 -112 b 68 -137 45 -125 52 -132 b 360 -245 166 -171 262 -209 b 192 -315 302 -266 249 -300 b 13 -433 120 -337 53 -366 b 0 -456 9 -442 0 -448 l 0 -461 b 16 -469 3 -468 10 -469 z"
        },
        articTenutoAbove: {
            x_min: 0,
            x_max: 471,
            y_min: 0,
            y_max: 56,
            ha: 56,
            o: "m 137 0 b 197 1 156 0 179 1 b 409 6 268 1 338 6 b 482 4 432 6 459 6 b 556 0 508 3 534 0 b 651 10 588 0 621 3 b 678 27 662 12 678 10 b 654 59 680 45 672 53 b 511 75 606 73 560 73 b 255 81 426 78 341 81 b 160 79 222 81 193 79 l 36 79 b 1 71 24 78 7 85 b 19 32 -3 56 9 43 b 45 16 26 24 36 20 b 137 0 76 3 108 0 z"
        },
        articTenutoBelow: {
            x_min: 0,
            x_max: 471,
            y_min: -59,
            y_max: -3,
            ha: 56,
            o: "m 137 -85 b 197 -84 156 -85 179 -84 b 409 -79 268 -84 338 -79 b 482 -81 432 -79 459 -79 b 556 -85 508 -82 534 -85 b 651 -75 588 -85 621 -82 b 678 -58 662 -73 678 -75 b 654 -26 680 -40 672 -32 b 511 -10 606 -12 560 -12 b 255 -4 426 -7 341 -4 b 160 -6 222 -4 193 -6 l 36 -6 b 1 -14 24 -7 7 0 b 19 -53 -3 -29 9 -42 b 45 -69 26 -60 36 -65 b 137 -85 76 -82 108 -85 z"
        },
        articStaccatoAbove: {
            x_min: 1,
            x_max: 112,
            y_min: 0,
            y_max: 156,
            ha: 156,
            o: "m 98 0 b 132 23 109 0 122 7 b 161 112 150 50 161 79 b 158 148 161 124 161 137 b 125 186 154 167 131 167 b 63 225 117 215 85 216 b 23 197 45 222 30 219 b 3 91 12 163 12 127 b 19 66 0 79 4 69 b 65 27 40 62 53 46 b 98 0 76 9 88 0 z"
        },
        articStaccatoBelow: {
            x_min: 1,
            x_max: 112,
            y_min: -156,
            y_max: 0,
            ha: 156,
            o: "m 132 -202 b 161 -112 151 -174 163 -145 b 158 -76 161 -101 161 -88 b 125 -39 153 -58 131 -58 b 63 0 115 -10 85 -9 b 23 -27 45 -3 30 -6 b 3 -134 12 -62 10 -98 b 19 -158 0 -145 4 -156 b 65 -197 40 -164 53 -179 b 98 -225 75 -216 88 -225 b 132 -202 109 -225 122 -217 z"
        },
        articStaccatissimoAbove: {
            x_min: 0,
            x_max: 139,
            y_min: 0,
            y_max: 411,
            ha: 411,
            o: "m 104 0 b 144 115 143 29 138 75 b 197 423 158 217 180 320 b 200 454 199 433 200 444 b 181 540 200 482 193 513 b 112 592 167 573 141 592 b 55 567 92 592 72 585 b 0 490 32 546 3 527 l 0 484 b 27 279 14 416 14 347 b 84 20 43 193 52 104 b 96 0 86 13 92 6 z"
        },
        articStaccatissimoBelow: {
            x_min: 0,
            x_max: 139,
            y_min: -411,
            y_max: 0,
            ha: 411,
            o: "m 88 -592 b 145 -567 108 -592 128 -585 b 200 -490 168 -546 197 -527 l 200 -484 b 173 -279 186 -416 186 -347 b 117 -20 157 -193 148 -104 b 104 0 114 -13 108 -6 l 96 0 b 56 -115 58 -29 62 -75 b 3 -423 42 -217 20 -320 b 0 -454 1 -433 0 -444 b 19 -540 0 -482 7 -513 b 88 -592 33 -573 59 -592 z"
        },
        articMarcatoAbove: {
            x_min: 0,
            x_max: 396,
            y_min: 0,
            y_max: 328,
            ha: 328,
            o: "m 477 0 b 510 13 488 0 500 6 b 570 124 546 40 563 81 b 547 183 570 147 560 166 b 356 422 487 265 405 330 b 346 442 354 429 350 436 l 346 444 b 318 465 340 456 330 464 l 312 469 b 274 449 294 480 284 461 b 242 413 262 438 253 425 b 56 196 177 343 112 274 b 1 56 26 154 13 105 b 27 20 -4 35 9 20 b 42 23 32 20 37 20 b 84 53 59 29 72 39 b 255 269 141 125 193 200 b 275 229 262 255 266 242 b 448 14 324 151 390 86 b 477 0 456 4 467 0 z"
        },
        articMarcatoBelow: {
            x_min: 0,
            x_max: 396,
            y_min: -328,
            y_max: 0,
            ha: 328,
            o: "m 258 -469 b 297 -449 276 -480 287 -461 b 328 -413 308 -438 317 -425 b 514 -196 393 -343 458 -274 b 569 -56 544 -154 557 -105 b 543 -20 575 -35 562 -20 b 528 -23 539 -20 533 -20 b 487 -53 511 -29 498 -39 b 315 -269 429 -125 377 -200 b 295 -229 308 -255 304 -242 b 122 -14 246 -151 180 -86 b 94 0 114 -4 104 0 b 60 -13 82 0 71 -6 b 0 -124 24 -40 7 -81 b 23 -183 0 -147 10 -166 b 215 -422 84 -265 166 -330 b 225 -442 216 -429 220 -436 l 225 -444 b 252 -465 230 -456 240 -464 z"
        },
        fermataAbove: {
            x_min: 0,
            x_max: 472,
            y_min: 2,
            y_max: 454,
            ha: 452,
            o: "m 39 10 b 78 108 66 37 71 73 b 163 311 92 181 111 252 b 284 423 199 353 239 392 b 373 458 312 444 340 454 b 433 431 395 458 410 446 b 603 153 530 361 596 276 b 595 121 603 144 595 131 l 595 88 b 602 50 596 75 589 55 b 639 73 619 43 631 60 b 651 102 645 82 648 92 b 667 194 660 132 662 163 b 680 278 671 222 672 248 b 560 567 680 386 638 481 b 396 654 508 625 452 649 b 291 632 364 654 325 644 b 161 526 235 613 200 566 b 4 249 85 446 26 357 b 4 174 0 222 -3 196 b 10 19 4 124 4 69 b 29 4 12 6 16 0 b 39 10 35 4 33 4 z m 338 37 b 370 40 350 36 357 36 b 380 75 387 40 380 43 b 389 94 382 79 382 85 b 356 132 389 111 374 122 b 269 154 328 147 300 156 b 225 125 252 154 228 157 b 261 48 222 81 232 56 b 338 37 287 40 312 40 z"
        },
        fermataBelow: {
            x_min: 0,
            x_max: 519,
            y_min: -430,
            y_max: -1,
            ha: 429,
            o: "m 344 -615 b 500 -543 402 -602 452 -576 b 713 -253 605 -471 661 -364 b 746 -98 737 -204 750 -153 b 727 -59 744 -82 744 -59 b 688 -88 711 -59 694 -68 b 678 -109 687 -96 683 -102 b 562 -314 648 -183 611 -252 b 387 -439 516 -373 458 -416 b 328 -449 367 -446 347 -449 b 180 -386 274 -449 225 -423 b 69 -179 111 -330 69 -262 b 75 -121 69 -160 71 -141 b 84 -58 78 -101 84 -79 b 82 -39 84 -52 84 -45 b 68 -1 79 -26 82 -4 b 26 -32 49 0 33 -12 b 20 -52 24 -39 22 -45 b 0 -223 9 -107 -3 -161 b 141 -553 1 -348 27 -468 b 304 -619 192 -590 243 -619 b 344 -615 317 -619 330 -618 z m 415 -190 b 435 -157 429 -192 435 -184 b 308 -27 435 -86 379 -27 b 271 -46 287 -27 272 -35 b 269 -69 269 -55 269 -62 b 364 -183 269 -128 302 -170 z"
        },
        fermataLongAbove: {
            x_min: 0,
            x_max: 591,
            y_min: -6,
            y_max: 337,
            ha: 343,
            o: "m 20 -9 b 36 14 29 -9 35 3 b 49 109 45 45 49 78 b 48 143 49 121 49 131 b 42 312 40 200 45 256 b 63 338 42 331 46 338 b 68 340 65 338 66 338 b 279 333 138 336 209 334 b 760 317 439 330 599 323 b 783 298 775 317 782 315 l 796 161 b 814 17 801 115 802 68 b 851 144 840 45 855 102 b 824 396 842 228 834 312 b 760 468 816 459 812 467 l 55 485 b 1 433 12 487 1 478 l 1 387 b 0 203 1 325 0 264 b 9 17 0 141 3 79 b 20 -9 9 7 6 -9 z m 403 3 b 439 6 413 3 425 4 b 477 42 464 9 474 22 b 478 62 478 49 478 55 l 478 84 b 465 160 478 109 478 135 b 449 173 461 167 459 173 b 354 105 386 179 354 156 b 359 71 354 95 356 84 b 360 65 360 69 360 66 b 403 3 372 14 373 3 z"
        },
        fermataLongBelow: {
            x_min: 0,
            x_max: 602,
            y_min: -335,
            y_max: 7,
            ha: 342,
            o: "m 793 -482 b 851 -444 822 -482 842 -471 b 867 -357 860 -416 867 -387 b 865 -336 867 -350 867 -343 b 851 -189 858 -287 855 -238 b 832 -32 847 -135 840 -84 b 824 -17 832 -26 832 -17 l 822 -17 b 805 -30 816 -19 806 -20 b 798 -88 802 -50 798 -69 b 805 -292 798 -157 801 -225 b 772 -327 806 -318 801 -327 b 360 -324 635 -327 497 -325 b 78 -327 265 -323 171 -327 b 50 -304 59 -327 50 -320 l 50 -297 b 62 -187 55 -261 60 -225 b 71 -60 62 -144 71 -102 b 68 -20 71 -48 71 -33 b 53 10 66 -10 69 10 l 52 10 b 22 -22 37 9 24 -1 b 14 -121 17 -55 16 -89 b 0 -359 10 -200 0 -279 b 6 -452 0 -390 3 -420 b 42 -481 9 -478 20 -481 l 415 -481 l 415 -482 z m 409 -183 b 454 -179 420 -183 435 -181 b 505 -124 487 -176 504 -158 b 505 -89 507 -112 505 -101 b 507 -58 505 -79 507 -68 b 505 -42 507 -52 507 -48 b 485 -10 503 -29 501 -10 b 448 -9 472 -9 461 -9 b 380 -22 425 -9 402 -12 b 363 -46 372 -27 363 -35 l 363 -49 b 364 -114 363 -71 361 -94 b 409 -183 374 -168 377 -183 z"
        },
        fermataVeryLongAbove: {
            x_min: 0,
            x_max: 715,
            y_min: -14,
            y_max: 437,
            ha: 451,
            o: "m 26 -20 b 42 -4 36 -22 39 -12 b 49 53 49 14 49 33 l 49 448 b 69 478 49 467 52 478 l 72 478 b 81 480 75 478 78 478 b 144 477 102 477 122 477 l 207 477 b 943 471 452 477 698 471 b 978 442 966 471 976 467 b 989 99 985 327 985 213 b 999 -19 991 60 995 22 b 1030 62 1028 6 1030 35 b 1021 507 1028 210 1025 359 b 1012 596 1021 537 1017 567 b 976 624 1009 618 998 624 b 507 626 819 624 662 625 b 46 629 353 628 200 629 b 7 590 19 629 7 618 b 0 101 7 428 0 264 b 16 -4 0 65 13 32 b 26 -20 17 -10 22 -19 z m 187 -9 b 207 30 206 -7 204 14 b 207 55 209 37 207 46 b 200 240 210 117 197 179 b 219 262 200 256 203 262 l 223 262 b 456 252 301 258 379 255 l 772 239 b 804 209 792 238 802 235 b 818 69 806 163 809 115 b 834 -4 821 46 816 19 b 857 56 852 13 857 35 b 851 183 857 99 858 141 b 827 360 841 242 841 301 b 786 390 821 383 809 389 b 189 409 588 403 387 402 b 153 377 163 409 153 400 b 173 27 153 259 150 143 b 187 -9 176 13 177 -9 z m 478 3 b 536 10 491 3 510 6 b 582 60 569 14 580 32 l 582 89 l 580 89 b 580 117 580 98 582 107 b 540 171 577 158 572 171 b 521 171 534 171 528 170 b 459 166 500 170 480 168 b 423 132 436 164 423 154 b 428 88 423 118 425 102 b 478 3 438 22 439 4 z"
        },
        fermataVeryLongBelow: {
            x_min: 0,
            x_max: 686,
            y_min: -427,
            y_max: 30,
            ha: 457,
            o: "m 56 -615 b 282 -612 132 -612 207 -613 b 924 -606 497 -608 710 -606 b 973 -570 953 -606 968 -593 b 988 -455 984 -533 991 -494 b 982 -262 984 -390 982 -327 b 976 -69 982 -197 981 -134 b 976 -14 975 -50 976 -33 b 966 43 976 4 975 23 b 940 20 953 37 943 35 b 933 -76 936 -12 933 -45 b 935 -121 933 -91 933 -107 b 940 -307 940 -183 940 -245 l 940 -435 b 919 -458 940 -451 935 -458 b 894 -459 910 -458 903 -458 b 206 -467 665 -461 435 -467 b 88 -467 167 -467 127 -468 b 45 -425 45 -467 42 -465 b 46 -400 46 -416 46 -408 b 43 -325 46 -376 43 -350 b 42 -59 42 -236 42 -148 b 22 17 42 -32 36 -6 b 0 -27 -1 7 0 -10 b 7 -420 0 -158 7 -289 l 7 -474 b 16 -579 7 -510 7 -544 b 56 -615 22 -603 27 -615 z m 789 -390 b 835 -357 816 -392 829 -380 b 850 -256 844 -324 850 -291 b 848 -230 850 -248 850 -239 b 845 -135 845 -199 845 -167 l 845 -72 b 837 23 845 -40 848 -9 b 809 -27 809 14 809 -7 l 809 -222 b 788 -242 809 -238 805 -242 l 203 -229 b 180 -209 186 -229 180 -223 l 180 -160 b 179 -115 180 -145 180 -131 b 179 -50 177 -94 179 -72 b 163 24 179 -26 176 0 b 137 -6 145 19 140 10 b 134 -39 134 -17 134 -27 b 138 -105 134 -60 137 -82 l 138 -197 b 145 -343 138 -246 138 -294 b 179 -377 148 -364 151 -377 b 789 -390 383 -377 586 -380 z m 480 -164 b 566 -65 549 -164 566 -140 b 527 1 566 -10 564 1 b 436 -71 426 1 436 -9 l 436 -88 l 436 -143 b 454 -163 436 -153 439 -161 b 480 -164 464 -163 472 -164 z"
        },
        fermataVeryShortAbove: {
            x_min: 0,
            x_max: 711,
            y_min: -31,
            y_max: 496,
            ha: 527,
            o: "m 1018 -45 b 1024 -1 1021 -29 1024 -14 b 986 105 1024 40 1008 75 b 557 688 845 302 701 495 b 520 714 544 706 531 714 b 480 687 505 714 492 706 b 340 490 433 621 387 556 b 73 127 252 367 168 243 b 0 22 48 95 22 63 b 68 60 33 27 52 42 b 167 170 101 96 132 135 b 494 503 276 279 384 393 b 518 518 504 513 511 518 b 543 501 526 518 533 513 b 923 63 670 356 799 212 b 1018 -45 952 29 984 -4 z m 837 -16 b 838 1 838 -10 838 -4 b 799 82 838 37 818 60 b 560 369 721 179 639 274 b 541 396 553 377 546 386 b 518 422 533 413 527 422 b 491 400 511 422 503 415 b 347 229 445 341 396 285 b 203 45 297 170 239 117 b 184 17 199 36 184 26 b 189 9 184 14 186 12 b 226 26 200 -1 215 19 l 238 35 b 494 245 321 107 408 176 b 510 253 501 251 505 253 b 526 245 514 253 520 251 b 729 73 592 186 660 130 z m 495 0 b 511 6 500 0 505 1 b 556 32 526 16 540 30 b 586 68 583 35 586 50 b 579 115 586 86 582 101 b 533 190 566 168 553 190 b 459 154 516 190 494 177 b 442 122 448 145 442 135 b 445 105 442 117 442 111 b 477 17 456 76 465 46 b 495 0 481 7 487 0 z"
        },
        fermataVeryShortBelow: {
            x_min: 0,
            x_max: 697,
            y_min: -475,
            y_max: 13,
            ha: 488,
            o: "m 507 -383 b 530 -369 514 -383 521 -377 b 775 -130 611 -288 694 -210 b 824 3 811 -94 822 -48 b 789 -7 808 6 799 0 b 521 -212 698 -72 611 -143 b 488 -226 508 -222 498 -226 b 452 -209 477 -226 467 -220 b 202 7 370 -135 285 -65 b 187 19 197 10 193 19 b 179 14 184 19 181 17 b 171 -3 174 10 171 4 b 173 -13 171 -6 171 -9 b 235 -122 186 -53 206 -94 l 484 -370 b 507 -383 492 -379 500 -383 z m 503 -684 b 539 -647 517 -674 528 -661 b 917 -153 665 -482 793 -318 b 999 -24 948 -112 984 -73 b 1004 -10 1001 -20 1004 -16 b 999 -3 1004 -7 1002 -4 b 973 -10 991 1 981 -1 l 963 -23 b 552 -505 825 -184 688 -344 b 528 -521 543 -517 536 -521 b 505 -505 521 -521 514 -516 b 156 -128 393 -374 274 -253 b 27 6 114 -84 72 -39 b 16 17 24 9 22 17 b 9 13 13 17 12 16 b 0 -3 6 10 0 3 b 1 -9 0 -4 0 -7 b 14 -36 4 -17 9 -27 b 117 -179 45 -86 81 -132 b 482 -667 242 -338 360 -504 b 503 -684 487 -672 491 -683 z m 487 -164 b 552 -98 523 -164 552 -137 b 544 -30 550 -78 549 -55 b 521 -1 541 -19 537 -1 l 517 -1 b 446 -29 492 -9 462 0 b 445 -42 444 -32 445 -37 b 464 -145 451 -76 458 -111 b 487 -164 468 -157 467 -164 z"
        },
        fermataShortAbove: {
            x_min: 0,
            x_max: 545,
            y_min: -18,
            y_max: 348,
            ha: 366,
            o: "m 16 -26 b 36 -9 26 -27 30 -16 b 354 340 143 107 249 223 b 369 348 360 346 364 348 b 382 341 373 348 377 346 l 530 199 b 743 0 599 131 672 68 b 753 -7 747 -3 750 -7 b 762 -1 756 -7 759 -6 b 785 84 776 10 785 48 b 768 150 785 112 779 138 l 399 491 b 379 501 392 498 384 501 b 357 488 372 501 364 495 b 27 137 248 370 141 251 b 1 84 12 121 1 105 b 3 69 1 79 1 75 b 0 55 1 65 0 59 b 9 1 0 36 9 20 b 16 -26 10 -7 3 -22 z m 357 24 b 367 27 360 24 363 24 b 431 118 422 42 431 49 b 429 151 431 130 431 141 b 400 193 428 171 429 193 b 333 147 359 193 333 176 b 341 42 333 111 337 78 b 357 24 343 30 346 24 z"
        },
        fermataShortBelow: {
            x_min: 0,
            x_max: 565,
            y_min: -335,
            y_max: 10,
            ha: 345,
            o: "m 386 -482 b 422 -455 395 -482 405 -474 b 732 -117 526 -343 631 -232 b 814 12 765 -79 799 -42 b 752 -22 780 14 768 -7 b 436 -320 645 -120 540 -219 b 419 -328 429 -325 425 -328 b 400 -318 413 -328 408 -325 b 35 0 279 -212 157 -105 b 16 14 29 4 23 14 b 7 12 13 14 10 14 b 0 -3 1 7 0 1 b 7 -23 0 -10 3 -17 b 20 -48 12 -30 14 -39 b 167 -238 60 -117 115 -177 b 351 -455 229 -310 289 -383 b 386 -482 367 -474 377 -482 z m 382 -213 b 406 -207 389 -213 396 -210 b 452 -156 431 -199 446 -180 b 461 -85 456 -132 458 -108 b 448 -32 461 -66 454 -49 b 418 -6 442 -12 431 -6 b 397 -9 410 -6 405 -7 b 348 -50 376 -14 350 -14 b 356 -170 348 -91 354 -130 b 382 -213 357 -199 363 -213 z"
        },
        breathMarkComma: {
            x_min: 0,
            x_max: 148,
            y_min: 0,
            y_max: 275,
            ha: 275,
            o: "m 120 0 b 187 78 156 20 174 48 b 213 209 206 121 213 164 b 206 294 213 238 210 265 b 140 390 200 337 171 367 b 122 396 134 395 128 396 b 68 382 105 396 85 384 b 46 379 60 382 53 382 b 0 328 12 369 0 357 b 1 311 0 323 1 317 b 30 210 4 275 22 243 b 66 167 39 179 46 167 b 94 171 73 167 82 168 b 143 180 109 174 124 180 b 160 179 148 180 154 180 b 120 66 124 145 120 107 b 120 0 120 45 121 23 z"
        },
        breathMarkUpbow: {
            x_min: 0,
            x_max: 254,
            y_min: 0,
            y_max: 595,
            ha: 595,
            o: "m 233 0 b 256 48 251 14 253 30 b 272 183 264 92 265 138 b 311 455 289 274 295 364 b 350 716 327 541 341 628 b 366 815 354 749 366 782 b 359 857 366 829 363 842 b 327 815 334 852 330 832 b 302 674 315 769 310 721 b 248 357 288 567 269 462 b 225 226 240 314 242 268 b 210 251 212 232 213 243 b 69 721 163 408 117 564 b 32 835 58 760 53 801 b 20 851 29 841 27 851 b 14 850 19 851 16 851 b 0 828 6 847 0 838 l 0 825 b 12 765 1 804 7 785 b 194 125 73 552 132 338 b 233 0 206 84 213 42 z"
        },
        caesura: {
            x_min: 0,
            x_max: 566,
            y_min: 0,
            y_max: 562,
            ha: 563,
            o: "m 0 76 b 49 122 24 92 37 107 b 444 613 180 287 305 455 b 528 770 484 660 518 708 b 531 792 530 778 531 785 b 524 808 531 799 530 805 b 490 792 513 815 498 802 b 390 683 456 756 420 721 b 48 262 275 543 164 400 b 0 76 0 207 7 145 z m 226 1 b 248 13 238 -4 243 7 l 353 137 b 759 638 490 302 632 464 b 814 805 795 688 819 740 b 779 786 796 805 788 796 b 628 609 724 732 678 668 b 310 242 523 485 416 363 b 217 69 265 190 217 140 b 222 30 217 58 219 45 b 222 23 222 29 220 26 b 220 12 222 20 220 16 b 226 1 220 7 222 3 z"
        },
        caesuraCurved: {
            x_min: 0,
            x_max: 386,
            y_min: -10,
            y_max: 584,
            ha: 594,
            o: "m 180 -14 b 246 14 213 -13 230 0 b 347 144 288 52 315 99 b 526 471 420 246 488 350 b 556 671 546 537 556 603 b 543 798 556 713 553 756 b 504 837 537 822 521 828 b 490 841 500 840 494 841 b 472 832 482 841 477 838 b 406 678 436 785 406 737 b 410 638 406 665 408 652 b 425 511 419 595 425 553 b 315 186 425 395 387 287 b 180 -14 271 122 228 58 z m 14 24 b 49 39 29 24 40 32 b 120 114 76 60 99 85 b 216 276 156 166 184 223 b 317 626 281 384 317 501 b 315 664 317 639 317 651 b 301 773 314 701 311 737 b 262 808 295 795 278 808 b 245 799 256 808 249 805 b 170 641 209 750 170 706 b 171 621 170 634 170 628 b 177 511 176 585 177 549 b 114 229 177 415 160 320 b 0 26 79 161 42 95 b 14 24 6 24 10 24 z"
        },
        restMaxima: {
            x_min: 0,
            x_max: 366,
            y_min: -255,
            y_max: 255,
            ha: 510,
            o: "m 397 -367 b 504 -343 436 -367 468 -347 b 518 -318 516 -341 518 -330 b 527 -30 518 -217 527 -117 b 526 33 527 -7 527 13 l 526 301 b 501 350 526 323 520 341 b 428 367 477 361 452 367 b 374 359 410 367 393 364 b 357 333 361 354 357 347 b 356 91 357 252 356 171 l 356 30 b 340 -307 357 -82 346 -194 b 397 -367 337 -354 350 -367 z m 46 -357 b 58 -356 49 -357 53 -357 b 154 -333 91 -351 121 -338 b 173 -305 168 -330 173 -320 l 173 302 b 132 356 173 330 157 348 b 68 364 112 363 89 364 b 3 304 19 363 1 348 l 3 4 l 0 4 b 1 -302 0 -98 0 -200 b 46 -357 1 -331 16 -357 z"
        },
        restDoubleWhole: {
            x_min: 0,
            x_max: 122,
            y_min: 0,
            y_max: 249,
            ha: 249,
            o: "m 43 0 b 58 1 48 0 52 0 b 124 20 81 6 102 17 b 176 96 173 27 176 58 b 173 220 174 138 173 179 b 176 304 173 248 176 276 b 140 353 176 331 163 346 b 95 359 125 356 111 359 b 32 346 73 359 52 354 b 0 315 20 340 0 337 b 1 243 0 291 1 268 l 1 174 l 4 174 l 4 48 b 43 0 4 16 17 0 z"
        },
        restWhole: {
            x_min: 1,
            x_max: 500,
            y_min: -120,
            y_max: 14,
            ha: 134,
            o: "m 356 -173 l 356 -171 l 642 -171 b 719 -115 680 -171 717 -145 b 720 -82 719 -104 720 -92 b 711 -20 720 -60 719 -40 b 672 17 704 0 694 10 b 649 20 664 20 657 20 b 605 17 634 20 621 17 b 92 19 433 17 262 17 b 29 7 69 20 49 12 b 9 -17 12 4 9 -6 b 10 -43 9 -26 10 -35 b 1 -84 10 -58 3 -72 b 76 -173 0 -147 7 -173 z"
        },
        restWholeLegerLine: {
            x_min: -197,
            x_max: 685,
            y_min: -157,
            y_max: 29,
            ha: 186,
            o: "m 96 -226 b 167 -223 121 -226 144 -225 b 300 -222 207 -222 252 -222 l 444 -222 b 660 -217 520 -222 595 -222 b 746 -131 703 -216 746 -200 b 744 -62 746 -108 747 -85 b 743 -39 743 -53 743 -46 b 789 -14 743 -16 752 -17 b 883 -16 821 -13 851 -16 b 965 -9 910 -16 937 -14 b 986 3 972 -7 986 -10 l 986 6 b 963 35 984 17 982 32 b 887 42 937 39 913 42 b 39 27 605 42 321 33 l -76 27 b -261 20 -138 27 -200 26 b -282 14 -269 20 -279 23 b -271 -7 -287 4 -276 -1 b -209 -27 -253 -23 -230 -24 b -153 -30 -190 -30 -173 -30 b -48 -29 -118 -30 -82 -27 b 6 -32 -22 -29 -6 -27 b 1 -72 3 -43 1 -58 b 4 -167 1 -105 7 -140 b 53 -223 3 -207 14 -217 b 96 -226 68 -226 82 -226 z"
        },
        restHalf: {
            x_min: 0,
            x_max: 518,
            y_min: 0,
            y_max: 162,
            ha: 162,
            o: "m 98 0 l 556 0 b 665 1 592 0 629 0 b 746 82 720 3 743 29 b 736 174 749 114 740 144 b 670 232 729 215 708 232 b 570 229 636 232 603 229 b 356 233 498 229 426 233 l 73 233 b 0 179 19 233 0 220 b 1 154 0 171 0 164 b 6 95 4 135 6 115 b 98 0 3 27 29 0 z"
        },
        restHalfLegerLine: {
            x_min: -120,
            x_max: 448,
            y_min: -20,
            y_max: 143,
            ha: 163,
            o: "m 397 -29 b 482 -23 426 -29 455 -27 b 526 -24 497 -24 511 -24 b 608 -17 554 -24 582 -23 b 645 -1 622 -14 644 -17 b 615 26 648 13 629 20 b 595 32 608 29 602 30 b 526 37 572 35 549 37 b 498 36 517 37 507 37 b 471 35 487 35 478 35 b 445 53 451 35 445 39 b 449 89 445 60 446 73 l 454 117 b 373 206 456 173 428 206 b 324 204 356 206 340 206 b 209 203 287 203 248 203 b 46 193 156 203 101 202 b 16 170 32 190 19 187 b 9 112 13 151 9 131 b 14 78 9 101 10 89 b 19 59 17 71 19 63 b -4 45 19 49 12 45 l -10 45 b -150 33 -58 45 -104 46 b -173 22 -158 32 -173 33 l -173 19 b -151 -13 -170 6 -168 -10 b -117 -17 -140 -16 -128 -17 b 118 -13 -37 -17 39 -13 b 397 -29 213 -13 308 -29 z"
        },
        restQuarter: {
            x_min: 0,
            x_max: 263,
            y_min: -415,
            y_max: 415,
            ha: 830,
            o: "m 151 -596 b 164 -563 163 -589 161 -575 b 160 -546 164 -557 161 -552 b 124 -396 148 -495 135 -446 b 122 -380 122 -390 122 -384 b 199 -255 122 -331 158 -272 b 228 -256 209 -249 217 -253 b 324 -346 274 -271 298 -310 b 353 -369 331 -356 341 -369 b 360 -367 356 -369 357 -369 b 379 -336 373 -361 379 -348 l 377 -325 b 344 -232 372 -292 366 -258 b 249 -58 301 -180 278 -117 b 242 -36 245 -49 242 -42 b 258 -7 242 -26 248 -17 b 328 78 284 20 311 45 b 354 158 344 104 354 131 b 337 216 354 177 350 196 b 213 435 294 288 249 359 b 115 575 189 487 158 536 b 78 598 105 585 92 598 b 59 592 72 598 66 596 b 39 562 45 583 39 572 b 53 527 39 550 45 539 b 168 344 98 469 125 402 b 187 307 181 328 187 317 b 153 269 187 294 176 284 b 62 213 122 252 91 235 b 40 180 48 203 40 192 b 46 158 40 173 43 166 b 99 65 60 125 79 95 b 183 -79 131 20 160 -29 b 156 -86 173 -88 164 -85 b 0 -261 58 -99 -7 -173 b 96 -557 10 -366 49 -464 b 124 -585 102 -569 109 -580 b 145 -598 132 -588 138 -598 b 151 -596 147 -598 150 -598 z"
        },
        rest8th: {
            x_min: 0,
            x_max: 289,
            y_min: -260,
            y_max: 261,
            ha: 521,
            o: "m 164 -374 b 212 -340 190 -373 203 -357 b 276 -190 238 -292 258 -242 b 410 285 333 -36 359 128 b 416 314 413 294 416 304 l 416 321 b 393 354 415 341 410 354 b 382 353 389 354 386 354 b 292 311 347 347 315 333 b 174 225 256 276 216 251 b 157 219 168 222 163 219 b 140 228 151 219 145 222 b 131 246 134 233 131 240 b 135 262 131 252 132 256 b 147 298 141 272 147 285 b 127 367 147 323 154 354 b 94 376 114 373 102 376 b 48 336 75 376 63 363 b 3 181 20 288 12 235 b 0 150 1 170 0 160 b 109 24 0 84 35 24 b 171 36 127 24 148 27 b 289 101 213 52 248 75 b 164 -374 256 -62 193 -213 z"
        },
        rest16th: {
            x_min: 0,
            x_max: 333,
            y_min: -328,
            y_max: 244,
            ha: 572,
            o: "m 209 -471 b 246 -458 222 -477 236 -468 b 307 -338 279 -425 300 -384 b 324 -226 312 -301 317 -262 b 428 161 350 -94 386 35 b 480 318 445 215 480 259 b 467 347 480 331 477 341 b 445 351 461 350 454 351 b 408 337 432 351 419 347 b 402 333 405 336 403 334 b 223 215 344 294 294 245 b 236 259 229 233 235 246 b 238 276 238 265 238 271 b 212 338 238 302 226 334 b 193 341 206 340 199 341 b 86 289 156 341 104 317 b 59 180 66 255 59 217 b 156 27 59 76 92 27 b 236 46 179 27 204 35 b 338 101 271 59 298 82 b 289 -49 312 49 302 0 b 196 -122 276 -99 235 -107 b 176 -114 187 -127 176 -127 l 176 -111 b 157 -53 177 -88 164 -72 b 69 -9 141 -7 101 -16 b 17 -48 43 -3 29 -27 b 0 -127 4 -73 0 -99 b 6 -186 0 -147 1 -167 b 82 -294 17 -262 37 -294 b 160 -276 102 -294 128 -289 b 219 -242 181 -268 203 -259 b 236 -230 223 -236 229 -230 b 243 -232 239 -230 240 -230 b 235 -275 248 -246 239 -261 b 202 -456 220 -334 202 -395 b 209 -471 202 -462 203 -468 z"
        },
        rest32nd: {
            x_min: 0,
            x_max: 347,
            y_min: -498,
            y_max: 483,
            ha: 981,
            o: "m 177 -716 b 217 -690 194 -720 209 -704 b 233 -655 225 -680 230 -668 b 292 -390 253 -567 275 -480 b 361 -48 312 -275 336 -161 b 452 400 393 102 422 252 b 497 629 467 477 482 553 b 500 647 498 635 500 641 b 480 691 500 665 492 684 b 464 696 475 694 469 696 b 418 674 448 696 431 685 l 361 626 b 333 611 353 618 343 612 b 308 629 325 611 317 616 b 239 667 292 651 265 661 b 204 670 228 668 216 670 b 86 559 141 670 95 628 b 85 537 86 552 85 544 b 107 416 85 495 95 455 b 161 372 114 389 134 372 b 174 373 166 372 170 372 b 226 383 192 374 209 377 b 387 478 285 402 330 444 b 364 386 379 444 364 415 b 276 271 364 323 320 298 b 265 266 272 268 268 266 b 252 276 261 266 256 269 b 143 333 229 311 186 333 b 107 327 130 333 118 330 b 43 243 62 314 46 291 b 58 145 43 210 52 179 b 150 63 68 92 99 63 b 315 132 213 63 259 98 b 266 -58 297 63 281 4 b 207 -101 259 -91 230 -96 b 186 -66 186 -107 199 -75 b 180 -50 181 -63 183 -55 b 101 -3 160 -23 135 -3 b 9 -66 59 -3 20 -32 b 0 -118 3 -84 0 -101 b 10 -196 0 -144 6 -170 b 104 -287 20 -256 52 -287 b 137 -282 114 -287 125 -287 b 184 -269 151 -281 171 -269 b 196 -275 190 -269 193 -271 b 199 -287 197 -278 199 -282 b 184 -343 199 -304 189 -325 b 181 -348 184 -346 183 -347 b 134 -595 158 -429 131 -508 b 156 -677 134 -624 150 -648 b 177 -716 158 -693 160 -713 z"
        },
        rest64th: {
            x_min: 0,
            x_max: 428,
            y_min: -720,
            y_max: 474,
            ha: 1194,
            o: "m 200 -1037 b 229 -1012 215 -1037 222 -1025 b 238 -984 233 -1004 236 -994 b 282 -780 248 -914 265 -848 b 386 -369 317 -644 354 -507 b 491 104 422 -212 451 -53 b 600 541 528 249 550 399 b 616 629 611 570 616 599 b 600 680 616 648 615 671 b 550 665 586 687 566 677 b 480 618 527 649 501 635 b 464 611 474 613 468 611 b 448 622 458 611 454 615 b 366 662 425 651 397 662 b 331 658 354 662 343 661 b 242 572 285 647 253 619 b 236 528 239 557 236 543 b 266 400 236 484 251 442 b 325 373 274 377 301 373 b 436 409 366 373 403 383 l 494 452 b 474 360 485 416 474 389 b 383 248 474 297 435 269 b 320 328 377 288 351 310 b 276 341 305 337 291 341 b 186 269 235 341 194 311 b 181 230 183 256 181 243 b 187 153 181 204 186 179 b 279 63 192 86 233 63 b 304 65 288 63 295 63 b 416 115 344 72 379 92 b 387 -14 406 69 397 27 b 320 -95 380 -52 369 -86 b 318 -79 320 -89 320 -84 b 223 0 305 -29 271 0 b 122 -81 171 0 135 -30 b 118 -127 120 -96 118 -112 l 118 -196 b 137 -242 118 -215 125 -229 b 209 -275 157 -266 181 -275 b 249 -269 222 -275 235 -274 b 318 -248 272 -264 294 -255 b 281 -390 315 -301 292 -344 b 276 -400 279 -393 279 -397 b 259 -420 272 -408 266 -416 b 246 -429 255 -425 251 -429 b 233 -415 242 -429 238 -426 b 176 -359 225 -389 200 -372 b 121 -346 158 -348 140 -346 b 14 -408 73 -346 27 -370 b 0 -498 4 -438 0 -468 b 6 -564 0 -520 3 -543 b 91 -635 12 -611 45 -635 b 131 -629 104 -635 117 -634 b 223 -590 163 -622 190 -603 b 166 -824 203 -671 189 -747 b 148 -912 157 -852 148 -881 b 156 -955 148 -926 150 -940 b 177 -1008 161 -972 170 -991 b 200 -1037 181 -1020 183 -1037 z"
        },
        rest128th: {
            x_min: 1,
            x_max: 491,
            y_min: -711,
            y_max: 719,
            ha: 1430,
            o: "m 233 -1015 b 271 -956 256 -1002 266 -981 l 314 -723 b 393 -350 337 -598 366 -474 b 543 312 442 -128 492 91 b 687 841 583 490 635 665 b 707 958 698 880 707 919 b 706 986 707 968 707 976 b 688 1025 704 999 704 1024 b 670 1027 683 1025 677 1027 b 629 1007 655 1027 639 1022 b 559 945 613 981 586 968 b 541 1004 553 968 559 991 b 456 1035 516 1024 488 1035 b 419 1030 444 1035 431 1034 b 344 953 379 1018 353 995 b 340 900 341 936 340 917 b 341 847 340 881 341 864 b 380 779 340 815 354 793 b 464 763 406 765 435 762 b 592 814 510 763 549 786 b 546 660 575 757 556 710 b 480 585 537 619 517 598 b 478 599 480 590 478 595 b 386 678 472 641 428 678 b 294 612 343 678 304 651 b 279 477 282 567 278 521 b 363 395 281 428 317 395 b 380 396 369 395 374 395 b 488 436 416 403 449 419 b 384 233 469 357 468 275 b 359 291 373 252 377 276 b 282 318 337 310 310 318 b 181 264 243 318 203 298 b 154 107 153 216 154 161 b 242 6 154 42 187 6 b 278 10 253 6 265 7 b 408 88 330 22 366 55 b 387 -1 400 56 393 27 b 301 -112 379 -55 354 -94 b 289 -65 297 -95 302 -79 b 219 -32 269 -42 245 -32 b 183 -37 207 -32 196 -35 b 112 -109 144 -46 121 -71 b 105 -219 104 -145 108 -183 b 186 -315 101 -276 134 -315 b 230 -307 199 -315 215 -312 b 324 -256 264 -295 292 -275 b 180 -491 323 -383 266 -471 b 183 -459 180 -480 180 -469 b 184 -442 184 -454 184 -448 l 184 -436 b 135 -369 184 -403 170 -383 b 102 -363 125 -364 114 -363 b 29 -399 73 -363 45 -376 b 1 -556 -4 -448 6 -503 b 109 -670 -4 -625 43 -670 b 140 -667 118 -670 130 -668 b 253 -616 180 -658 213 -638 b 238 -688 248 -644 242 -665 b 192 -959 220 -779 192 -867 b 193 -992 192 -971 192 -981 b 210 -1024 194 -1014 199 -1024 b 233 -1015 216 -1024 223 -1021 z"
        },
        dynamicPiano: {
            x_min: -49,
            x_max: 327,
            y_min: -142,
            y_max: 515,
            ha: 657,
            o: "m -56 -204 b -42 -202 -52 -204 -46 -203 b -19 -194 -35 -202 -26 -197 b 147 -138 35 -170 91 -151 b 249 -58 194 -127 223 -95 b 262 -29 255 -50 262 -39 b 258 -17 262 -24 261 -20 b 232 -7 252 -10 242 -7 b 210 -12 225 -7 217 -9 b 125 -40 184 -23 157 -30 b 183 140 153 19 171 79 b 251 167 207 144 230 153 b 469 518 383 262 480 382 b 357 687 472 626 420 687 b 315 678 344 687 330 684 b 204 600 279 664 240 634 b 210 704 206 635 209 670 b 215 721 212 710 215 716 b 206 733 215 727 212 730 b 180 742 197 736 189 742 b 164 734 176 742 170 740 b 1 575 108 684 36 645 b -7 557 -1 569 -7 563 b -6 553 -7 556 -7 554 b 7 547 -3 547 3 547 l 17 547 b 82 575 43 547 59 567 l 82 452 b 56 46 82 317 81 180 b 17 -66 49 7 46 -36 b -62 -173 -13 -99 -37 -135 b -71 -192 -66 -179 -71 -184 b -68 -199 -71 -193 -69 -196 b -56 -204 -65 -203 -60 -204 z m 196 258 b 197 266 197 261 197 264 b 200 510 200 347 199 429 b 233 543 210 521 222 533 b 281 560 249 554 266 560 b 340 503 310 560 333 540 b 344 461 343 488 344 474 b 321 323 344 413 333 369 b 268 272 315 300 295 281 b 196 258 245 265 220 261 z"
        },
        dynamicMezzo: {
            x_min: -18,
            x_max: 559,
            y_min: -50,
            y_max: 365,
            ha: 415,
            o: "m 43 -71 b 160 19 86 -71 143 -26 b 230 264 189 99 200 184 b 282 363 243 297 259 327 b 287 320 285 347 287 333 b 284 279 287 305 285 292 l 249 -12 b 275 -43 248 -29 245 -43 b 395 45 321 -43 389 3 b 462 271 406 124 436 197 b 523 387 475 310 490 348 l 523 346 b 504 130 521 274 513 202 b 501 81 501 114 501 98 b 510 3 501 55 504 29 b 580 -72 521 -48 543 -72 b 625 -63 593 -72 608 -69 b 789 50 690 -43 744 -3 b 805 72 795 56 805 63 b 798 85 805 76 802 81 b 778 94 792 91 785 94 b 755 85 770 94 763 91 l 693 40 b 675 33 685 36 680 33 b 658 52 668 33 662 39 b 645 144 651 82 645 112 b 658 448 641 246 660 346 b 606 507 658 485 638 507 b 583 504 599 507 592 505 b 495 446 547 497 521 471 b 420 373 471 423 448 399 b 413 458 418 406 418 432 b 361 507 408 490 386 507 b 320 491 347 507 333 501 b 160 307 256 444 207 382 l 160 337 b 174 488 160 387 174 438 b 156 521 174 501 173 513 b 137 526 148 524 143 526 b 109 513 127 526 118 520 b -16 399 66 477 23 439 b -26 383 -20 395 -26 389 l -26 379 b -14 370 -24 372 -20 370 b -6 372 -12 370 -9 372 b 19 376 4 374 12 376 b 36 359 32 376 36 370 b 30 330 36 350 35 341 l 30 323 b 9 -35 23 203 17 85 b 43 -71 6 -65 19 -71 z"
        },
        dynamicForte: {
            x_min: -144,
            x_max: 311,
            y_min: -115,
            y_max: 504,
            ha: 619,
            o: "m -101 -166 b 173 76 7 -153 150 -30 b 206 344 192 164 202 253 b 268 338 226 343 246 341 b 384 395 317 333 353 361 b 397 419 393 405 397 412 b 367 442 397 429 387 436 b 350 444 361 444 356 444 b 206 455 302 449 255 454 l 206 474 b 202 540 204 495 202 518 b 209 593 202 557 203 576 b 236 624 215 613 225 624 b 265 612 245 624 253 619 b 308 552 287 596 302 577 b 336 533 312 534 323 533 b 448 611 366 533 444 583 b 399 696 452 648 423 671 b 382 706 395 700 387 703 b 308 726 357 720 333 726 b 207 684 272 726 239 711 b 60 455 135 622 60 560 l 10 455 b -23 448 -1 455 -13 454 b -102 372 -55 426 -76 397 b -109 357 -108 367 -109 361 b -95 347 -109 353 -105 348 b -63 346 -84 346 -73 346 b 0 344 -43 344 -22 344 l 63 344 b 53 186 63 291 59 239 b 23 0 46 124 42 60 b -35 -60 10 -42 -6 -60 b -73 -52 -45 -60 -58 -58 b -91 -48 -79 -49 -85 -48 b -109 -53 -96 -48 -102 -49 b -199 -124 -143 -72 -168 -99 b -207 -137 -203 -128 -207 -132 b -194 -148 -207 -141 -203 -145 b -101 -166 -164 -160 -132 -168 z"
        },
        dynamicRinforzando: {
            x_min: -75,
            x_max: 322,
            y_min: -90,
            y_max: 325,
            ha: 415,
            o: "m 23 -130 b 40 -125 27 -130 33 -128 b 128 -9 81 -114 125 -53 b 145 200 132 62 141 130 b 148 238 147 212 148 225 b 308 321 184 291 245 321 b 363 314 325 321 344 318 b 377 310 369 312 373 310 b 384 311 380 310 382 310 b 464 415 410 317 464 389 b 446 433 465 429 455 429 b 390 445 428 441 409 445 b 305 429 361 445 334 438 b 167 346 252 413 202 393 b 153 325 163 338 158 333 b 148 438 154 363 151 399 b 121 468 147 456 134 468 b 101 458 115 468 108 465 b -63 310 46 409 -16 367 b -108 240 -78 289 -98 271 b 32 330 -50 256 -13 297 b 37 304 37 320 37 312 l 37 292 b 10 -101 27 161 20 30 b 23 -130 9 -120 12 -130 z"
        },
        dynamicSforzando: {
            x_min: 0,
            x_max: 296,
            y_min: 0,
            y_max: 379,
            ha: 379,
            o: "m 151 0 b 174 1 160 0 166 0 b 392 158 272 14 346 71 b 405 207 400 174 405 190 b 359 287 405 236 389 265 b 261 325 328 308 294 315 b 168 413 216 340 181 366 b 166 426 167 418 166 423 b 176 438 166 432 167 436 b 199 441 183 441 190 441 b 310 393 238 441 295 422 b 334 370 317 376 325 370 b 363 386 343 370 353 379 b 422 445 386 402 408 420 b 426 458 425 449 426 454 b 422 469 426 462 425 465 b 274 546 395 518 333 546 b 161 503 232 546 190 531 b 86 405 132 472 108 439 b 71 347 75 387 71 367 b 112 256 71 312 85 279 b 209 215 141 232 176 226 b 284 168 238 206 266 197 b 300 131 291 157 300 144 b 298 120 300 127 298 122 b 278 107 294 109 285 108 b 262 108 271 107 266 108 l 259 108 b 114 157 200 107 156 125 b 96 181 104 163 96 170 l 96 184 b 102 202 96 190 102 196 b 96 209 102 204 101 207 b 63 194 82 215 72 204 b 7 109 42 168 26 138 b 0 86 3 101 0 94 b 13 60 0 78 4 68 b 151 0 53 23 101 0 z"
        },
        dynamicZ: {
            x_min: -43,
            x_max: 331,
            y_min: 0,
            y_max: 328,
            ha: 328,
            o: "m -45 0 b -6 16 -32 0 -17 10 b 3 20 -3 16 0 19 b 144 60 49 48 96 60 b 284 22 190 60 238 46 b 348 4 305 10 327 4 b 461 75 393 4 435 30 b 468 91 464 81 467 86 b 456 104 468 95 465 99 b 287 173 402 131 348 167 b 239 176 271 174 255 176 b 168 174 217 176 194 174 b 367 340 236 236 298 294 b 459 423 402 363 432 392 b 477 454 467 431 475 442 b 474 462 477 456 475 459 b 454 472 469 469 462 472 b 432 468 446 472 439 469 b 356 448 406 461 380 455 b 210 422 307 433 258 422 b 109 442 177 422 144 428 b 94 445 104 444 99 445 b 69 433 85 445 76 442 b 27 390 56 419 39 406 b -9 343 16 373 -17 357 b 63 311 3 320 36 314 l 78 311 b 132 307 95 308 114 307 b 240 314 168 307 203 311 l 193 271 b -37 50 117 196 19 145 b -59 7 -46 36 -69 20 b -45 0 -55 3 -50 0 z"
        },
        ornamentTrill: {
            x_min: 1,
            x_max: 551,
            y_min: -18,
            y_max: 539,
            ha: 557,
            o: "m 321 612 b 190 602 278 605 235 605 l 190 638 b 187 693 190 652 190 667 b 161 776 184 717 193 776 b 137 747 150 776 137 766 b 130 654 135 716 131 685 l 130 596 l 52 588 b 4 539 23 585 7 570 b 1 477 3 530 1 500 b 3 448 1 461 3 448 l 3 452 b 53 432 6 436 23 432 b 134 435 75 432 102 433 b 151 117 138 328 147 223 b 170 13 153 82 157 46 b 209 -26 179 -10 193 -26 b 222 -22 213 -26 217 -24 b 269 -17 233 -16 253 -27 b 343 135 325 19 346 66 b 343 158 343 147 344 147 b 323 192 341 171 337 187 b 291 176 311 194 300 184 l 264 148 b 229 131 261 145 238 131 b 212 170 209 131 213 154 b 194 438 203 259 199 348 l 272 442 b 284 452 276 441 279 441 b 305 462 287 461 295 462 l 312 462 b 346 477 325 462 340 464 b 366 560 357 503 366 531 b 321 612 366 598 356 618 z m 759 588 b 711 560 749 592 733 570 b 588 500 671 541 631 521 b 583 533 586 514 586 524 b 560 576 577 549 577 572 b 517 550 541 582 528 564 b 416 423 482 508 452 462 b 382 353 392 397 384 370 b 387 305 380 341 386 318 b 392 275 389 295 392 285 b 409 243 393 262 393 243 b 431 262 419 243 425 255 b 521 373 459 298 488 333 b 523 354 521 366 523 360 b 520 337 523 346 521 340 b 508 295 513 323 508 310 b 530 102 508 279 524 122 b 549 66 533 88 530 66 b 577 99 563 66 572 84 b 580 131 580 109 580 121 l 580 302 b 600 347 580 318 582 337 b 701 392 632 364 665 384 b 793 518 785 409 793 435 b 759 588 793 559 785 576 z"
        },
        ornamentTurn: {
            x_min: 0,
            x_max: 574,
            y_min: 0,
            y_max: 312,
            ha: 312,
            o: "m 651 0 b 816 132 727 0 796 46 b 827 223 822 163 827 193 b 808 340 827 262 821 301 b 665 449 785 408 729 449 b 636 446 655 449 647 448 b 589 384 600 441 586 422 l 602 300 b 611 285 603 291 605 285 b 621 288 613 285 616 287 b 655 295 632 294 644 295 b 711 284 674 295 693 289 b 773 209 740 275 773 232 b 697 156 773 184 734 160 b 664 154 685 154 675 154 b 579 168 635 154 608 158 b 455 242 533 186 495 213 b 261 400 387 291 331 354 b 160 432 225 422 190 432 b 20 328 98 432 49 392 b 0 229 6 295 0 262 b 30 71 0 176 14 122 b 144 3 43 29 96 3 b 168 6 153 3 160 4 b 248 122 233 20 248 39 b 246 147 248 124 248 135 b 226 177 243 164 239 177 b 206 170 220 177 215 174 b 144 154 186 158 166 154 b 79 170 122 154 101 160 b 53 202 62 179 53 189 b 60 228 53 209 55 217 b 161 281 81 261 120 281 b 183 279 168 281 176 281 b 325 190 243 269 284 229 b 572 16 402 124 475 53 b 651 0 598 6 625 0 z"
        },
        ornamentTurnSlash: {
            x_min: 0,
            x_max: 574,
            y_min: -106,
            y_max: 405,
            ha: 511,
            o: "m 441 -153 b 456 -60 455 -118 456 -89 b 455 81 455 -14 455 33 b 572 14 491 55 530 30 b 651 -1 598 4 625 -1 b 816 131 727 -1 796 45 b 827 222 822 161 827 192 b 808 338 827 261 821 300 b 665 448 785 406 729 448 b 636 445 655 448 647 446 b 589 383 600 439 586 420 l 602 298 b 611 284 603 289 605 284 b 621 287 613 284 616 285 b 655 294 632 292 644 294 b 711 282 674 294 693 288 b 773 207 740 274 773 230 b 697 154 773 183 734 158 b 664 153 685 153 675 153 b 579 167 635 153 608 157 b 455 240 533 183 495 212 b 454 242 455 240 455 242 l 454 337 b 452 488 454 386 452 439 b 433 570 452 517 451 546 b 425 583 431 575 431 583 l 422 583 b 403 566 415 582 408 573 b 402 546 400 560 402 553 l 397 287 b 261 399 353 325 310 366 b 160 431 225 420 190 431 b 20 327 98 431 48 390 b 0 228 6 294 0 261 b 30 69 0 174 14 121 b 144 1 43 27 96 1 b 168 4 153 1 160 3 b 248 121 233 19 248 37 b 246 145 248 122 248 134 b 226 176 243 163 239 176 b 206 168 220 176 215 173 b 144 153 186 157 166 153 b 79 168 122 153 101 158 b 53 200 62 177 53 187 b 60 226 53 207 55 216 b 161 279 79 259 120 279 b 183 278 168 279 176 279 b 325 189 243 266 282 226 b 395 130 348 168 372 148 b 393 71 393 109 393 89 b 441 -153 390 -6 402 -78 z"
        },
        ornamentMordent: {
            x_min: 0,
            x_max: 700,
            y_min: 0,
            y_max: 497,
            ha: 497,
            o: "m 513 0 b 528 39 526 14 527 27 b 531 72 531 50 531 60 b 528 138 531 94 528 117 l 528 347 b 552 359 537 354 544 359 b 579 338 560 359 569 353 b 674 217 609 297 639 255 b 719 190 690 200 704 190 b 759 215 732 190 744 197 b 940 395 815 279 877 337 b 1001 490 968 422 986 455 b 1008 513 1004 495 1008 505 b 1002 524 1008 517 1007 521 b 968 516 994 530 978 524 b 960 508 965 513 963 510 b 798 356 900 464 848 410 b 778 341 791 347 783 341 b 757 354 772 341 765 346 b 661 475 720 392 690 432 b 611 517 644 504 629 517 b 563 498 598 517 583 511 b 527 471 550 490 539 481 l 527 570 b 492 716 526 619 523 671 b 472 677 480 704 472 694 b 465 399 474 585 468 491 b 439 366 456 387 448 376 b 384 320 415 336 399 320 b 330 367 369 320 354 336 b 325 376 328 369 327 373 b 226 490 291 413 265 456 b 189 505 213 500 202 505 b 157 491 177 505 167 500 b 0 229 75 420 0 346 b 1 202 0 220 0 212 b 22 215 12 203 16 209 b 124 327 55 252 89 289 b 147 343 132 337 140 343 b 171 323 156 343 164 336 b 266 197 196 276 232 236 b 337 157 291 170 314 157 b 410 207 361 157 386 174 b 461 274 428 229 444 252 b 462 166 461 238 461 202 b 513 0 465 108 487 55 z"
        },
        ornamentShortTrill: {
            x_min: 0,
            x_max: 747,
            y_min: 0,
            y_max: 243,
            ha: 243,
            o: "m 379 0 b 428 14 395 0 410 4 b 474 56 445 26 461 39 b 552 157 500 89 526 122 b 566 168 556 163 560 168 b 575 157 569 168 572 166 b 664 36 592 107 628 72 b 733 1 685 13 710 1 b 802 35 757 1 780 13 b 1007 249 871 105 940 177 b 1067 324 1028 272 1054 295 b 1076 340 1068 330 1076 334 b 1073 346 1076 341 1076 343 b 1057 350 1068 348 1063 350 b 1047 347 1053 350 1050 350 b 1001 310 1031 336 1015 324 l 857 157 b 844 143 852 153 848 143 b 835 150 841 143 838 144 b 757 242 815 186 780 209 b 685 298 739 268 713 284 b 641 310 670 305 655 310 b 590 288 625 310 608 304 b 497 179 554 256 527 215 b 480 164 490 170 485 164 b 462 179 474 164 469 168 b 372 295 436 220 405 258 b 278 344 346 324 312 344 b 199 310 252 344 226 334 b 92 196 161 274 128 233 b 0 24 46 148 23 89 b 42 48 22 27 32 37 b 156 168 84 85 114 132 b 196 192 174 184 186 192 b 228 158 206 192 215 181 b 312 36 252 114 282 75 b 379 0 331 12 354 0 z"
        },
        ornamentTremblement: {
            x_min: 0,
            x_max: 982,
            y_min: 0,
            y_max: 224,
            ha: 224,
            o: "m 0 0 b 63 36 30 12 48 23 b 157 124 94 66 125 94 b 177 135 164 131 170 135 b 196 122 183 135 189 131 b 268 40 217 94 245 68 b 323 6 288 16 304 6 b 369 20 336 6 350 10 b 412 53 384 29 399 40 b 501 145 442 84 472 114 b 523 158 508 154 516 158 b 543 145 528 158 536 154 b 641 45 576 112 608 78 b 698 17 658 27 677 17 b 729 23 708 17 719 20 b 804 65 756 32 780 46 b 904 154 837 95 871 124 b 920 163 910 160 916 163 b 936 153 924 163 930 160 b 1024 60 965 121 996 92 b 1112 13 1053 29 1080 13 b 1184 39 1135 13 1158 22 b 1359 194 1248 84 1305 138 b 1413 301 1388 223 1403 261 b 1404 323 1417 315 1413 323 b 1391 320 1400 323 1395 321 b 1344 294 1375 314 1358 307 b 1224 186 1305 258 1269 216 b 1194 173 1212 179 1202 173 b 1165 193 1184 173 1175 179 b 1096 271 1145 222 1122 248 b 1001 318 1061 302 1031 318 b 903 268 969 318 937 301 b 806 186 871 239 841 210 b 782 174 796 179 789 174 b 756 193 773 174 765 180 b 652 291 729 232 693 266 b 596 308 634 302 615 308 b 530 278 573 308 552 298 l 415 168 b 393 157 408 161 400 157 b 373 171 387 157 380 161 b 305 245 353 197 330 222 b 248 276 285 266 266 278 b 189 245 229 276 210 266 b 81 144 156 209 120 174 b 0 0 33 109 26 56 z"
        },
        ornamentPrecompAppoggTrill: {
            x_min: 0,
            x_max: 1066,
            y_min: -50,
            y_max: 533,
            ha: 583,
            o: "m 187 -46 b 213 -14 197 -37 204 -26 b 285 151 251 36 266 94 b 304 189 294 177 297 189 b 337 168 311 189 320 181 b 458 33 386 131 415 76 b 495 12 472 19 484 12 b 531 40 508 12 518 22 b 580 168 557 79 569 124 b 622 235 592 213 603 235 b 683 194 636 235 655 222 b 838 26 737 140 791 86 b 919 -33 860 -1 881 -39 b 984 53 960 -27 971 19 b 1022 156 998 86 1008 122 b 1054 190 1032 179 1041 190 b 1089 167 1063 190 1074 183 b 1208 32 1129 122 1171 78 b 1244 10 1221 17 1231 10 b 1273 22 1253 10 1263 14 b 1496 206 1352 78 1427 137 b 1535 310 1526 236 1535 272 b 1531 359 1535 325 1534 343 b 1496 343 1515 360 1506 351 l 1309 192 b 1269 167 1289 176 1279 167 b 1234 199 1260 167 1251 177 b 1122 324 1200 243 1168 289 b 1074 344 1106 337 1089 344 b 1014 301 1051 344 1030 328 b 952 144 985 252 971 197 b 933 121 946 128 940 121 b 910 137 927 121 920 125 b 850 210 888 161 870 186 b 687 369 799 266 750 325 b 631 390 665 383 647 390 b 567 327 602 390 580 369 b 527 199 554 284 543 242 b 508 168 520 179 514 168 b 482 192 503 168 495 177 b 353 328 444 240 405 292 b 312 343 338 338 324 343 b 266 297 292 343 276 327 b 204 125 248 239 232 180 b 143 79 193 102 173 79 b 92 122 117 79 105 102 b 81 154 86 131 84 143 b 48 423 59 242 50 333 b 45 544 46 464 45 504 b 53 730 45 606 48 668 b 40 768 55 744 52 766 b 13 730 19 770 14 747 b 0 514 7 658 -1 586 b 26 122 3 383 6 252 b 75 -36 35 66 40 10 b 134 -72 92 -59 112 -72 b 187 -46 151 -72 170 -63 z"
        },
        ornamentPrecompSlideTrillDAnglebert: {
            x_min: 0,
            x_max: 1088,
            y_min: -380,
            y_max: 252,
            ha: 632,
            o: "m 560 -539 b 439 -481 527 -497 484 -485 b 354 -461 409 -478 380 -477 b 131 -154 236 -389 161 -285 b 124 -98 127 -135 124 -117 b 196 55 124 -40 148 10 b 308 99 230 86 268 99 b 399 81 337 99 367 92 b 514 22 441 66 477 43 b 619 -30 567 -9 590 -30 b 719 17 642 -30 670 -16 b 861 131 769 52 818 88 b 899 150 874 144 887 150 b 936 117 913 150 926 138 b 965 43 948 94 956 68 b 1007 -1 973 24 978 -1 b 1048 30 1025 -1 1037 16 b 1070 65 1057 40 1064 52 b 1110 148 1084 92 1096 121 b 1145 190 1120 164 1120 190 b 1191 153 1169 192 1179 168 b 1256 29 1218 115 1231 68 b 1292 1 1267 10 1277 1 b 1320 10 1300 1 1309 4 b 1369 48 1339 19 1355 33 b 1515 196 1418 96 1464 148 b 1567 343 1558 238 1567 287 b 1555 363 1565 357 1562 363 b 1539 356 1551 363 1547 360 b 1433 268 1502 330 1466 301 b 1335 171 1401 236 1374 199 b 1310 163 1325 166 1318 163 b 1286 183 1302 163 1293 168 b 1218 311 1264 226 1247 272 b 1164 351 1200 337 1182 351 b 1110 308 1146 351 1128 337 b 1031 176 1084 265 1058 219 b 1015 161 1025 166 1021 161 b 999 179 1009 161 1005 167 b 955 279 985 213 973 248 b 913 307 943 300 930 307 b 887 302 904 307 896 305 b 852 281 874 298 863 291 b 693 167 804 236 747 204 b 612 140 667 150 639 140 b 549 157 592 140 570 145 b 403 220 503 181 452 202 b 271 248 360 236 315 248 b 179 229 239 248 209 242 b 0 -29 65 180 0 85 b 9 -104 0 -53 3 -78 b 397 -526 56 -317 183 -464 b 505 -547 432 -536 468 -547 b 560 -539 524 -547 541 -544 z"
        },
        ornamentPrecompSlideTrillBach: {
            x_min: 0,
            x_max: 1185,
            y_min: -380,
            y_max: 465,
            ha: 845,
            o: "m 624 -544 b 642 -528 638 -543 642 -537 b 639 -514 642 -524 642 -520 b 590 -444 629 -487 609 -467 b 523 -413 573 -422 553 -410 b 498 -415 514 -415 507 -415 b 399 -389 464 -415 431 -405 b 89 -157 281 -330 176 -255 b 72 -117 78 -144 72 -131 b 73 -101 72 -111 72 -107 b 187 186 91 3 147 91 b 246 230 200 216 222 230 b 300 209 262 230 281 223 b 456 48 359 163 403 101 b 540 -10 494 10 518 -10 b 625 59 566 -10 589 13 b 690 148 648 88 668 118 b 711 167 697 160 704 167 b 733 153 719 167 724 163 b 844 14 769 105 808 60 b 903 -42 873 -23 886 -42 b 973 -1 919 -42 937 -27 b 1008 33 986 7 996 20 b 1048 81 1021 48 1035 65 b 1050 37 1048 66 1050 52 b 1047 -24 1050 17 1048 -3 b 1038 -275 1038 -108 1040 -192 l 1037 -289 b 1045 -302 1037 -295 1038 -301 b 1068 -284 1056 -304 1064 -292 b 1084 -242 1076 -271 1081 -256 b 1099 -109 1096 -199 1099 -154 b 1106 158 1099 -19 1106 71 b 1128 187 1113 167 1120 177 b 1168 223 1143 212 1155 223 b 1210 193 1179 223 1191 213 b 1220 183 1214 190 1215 186 b 1329 36 1261 138 1292 84 b 1374 7 1345 16 1358 7 b 1411 20 1384 7 1395 12 b 1479 84 1437 37 1459 59 b 1610 235 1521 135 1564 186 b 1706 403 1655 282 1695 334 b 1614 346 1663 400 1637 373 b 1464 170 1564 287 1515 228 b 1440 150 1453 156 1447 150 b 1414 173 1433 150 1426 158 b 1283 336 1371 228 1333 288 b 1220 366 1261 356 1240 366 b 1148 318 1194 366 1169 350 b 1103 255 1133 297 1119 275 b 1097 301 1102 271 1100 285 b 1099 334 1099 312 1099 324 b 1092 428 1099 367 1094 397 b 1071 647 1087 501 1079 575 b 1058 670 1071 657 1071 670 b 1035 648 1047 670 1038 661 b 1018 516 1024 605 1015 560 b 1041 203 1025 412 1037 307 b 1043 180 1041 196 1043 187 b 992 127 1027 161 1009 143 b 965 111 981 117 972 111 b 936 132 955 111 946 120 b 829 268 900 179 867 225 b 760 317 801 301 780 317 b 691 258 739 317 719 297 b 605 147 664 219 641 177 b 589 138 599 141 593 138 b 572 148 583 138 579 141 b 415 317 520 206 467 261 b 327 372 390 343 366 366 b 300 373 317 373 308 373 b 154 295 239 373 190 348 b 55 138 120 243 85 192 b 0 -53 22 79 0 13 b 160 -317 0 -156 49 -252 b 209 -354 177 -327 192 -343 b 510 -531 305 -419 397 -495 b 593 -547 537 -540 564 -547 b 624 -544 603 -547 613 -546 z"
        },
        ornamentPrecompTrillSuffixDandrieu: {
            x_min: 0,
            x_max: 1003,
            y_min: -20,
            y_max: 521,
            ha: 541,
            o: "m 791 -16 b 844 33 812 -3 829 14 b 981 271 900 107 937 190 b 994 288 984 278 985 288 b 1009 269 1004 288 1007 278 b 1077 112 1034 217 1051 163 b 1158 43 1103 62 1129 43 b 1231 69 1179 43 1204 55 b 1348 189 1280 98 1315 143 b 1444 451 1407 271 1444 357 b 1431 547 1444 482 1440 514 b 1188 750 1401 665 1299 750 b 1158 747 1178 750 1168 749 b 1079 684 1119 742 1089 727 b 1063 632 1076 665 1071 648 b 1056 609 1058 622 1056 615 b 1071 599 1056 602 1060 599 b 1086 600 1076 599 1080 600 b 1130 605 1102 603 1116 605 b 1244 569 1171 605 1210 595 b 1349 346 1322 511 1349 433 b 1348 312 1349 334 1349 324 b 1289 197 1345 266 1325 228 b 1238 174 1270 181 1253 174 b 1188 215 1220 174 1202 187 b 1145 308 1172 245 1159 276 b 1096 413 1129 343 1120 382 b 1053 438 1084 431 1068 438 b 1011 413 1038 438 1022 431 b 955 324 989 384 971 354 b 850 127 920 258 886 192 b 838 112 847 121 842 112 b 824 128 828 109 825 121 b 802 193 815 150 809 171 b 730 400 779 264 766 337 b 688 431 719 420 703 431 b 647 403 674 431 660 422 b 606 338 632 383 619 361 b 513 167 575 282 546 223 b 480 122 503 150 498 122 b 452 171 459 122 459 153 b 420 255 442 199 432 228 b 337 408 399 308 380 364 b 276 436 317 428 297 436 b 215 397 253 436 230 423 b 23 72 148 289 81 184 b 0 29 17 59 0 40 b 7 17 0 23 1 20 b 59 58 26 7 46 39 b 190 276 111 127 143 206 b 216 301 202 292 207 301 b 245 279 223 301 232 294 b 311 166 278 248 292 206 b 367 16 331 117 346 65 b 402 -19 377 -7 387 -19 b 438 -4 412 -19 423 -13 b 518 88 474 17 495 55 b 628 284 562 150 592 216 b 657 223 648 266 651 243 b 717 13 677 154 696 84 b 755 -29 726 -16 737 -29 b 791 -16 765 -29 776 -24 z"
        },
        ornamentPrecompDoubleCadenceUpperPrefix: {
            x_min: 0,
            x_max: 1246,
            y_min: -30,
            y_max: 296,
            ha: 326,
            o: "m 360 -43 b 559 59 445 -43 503 7 b 698 236 615 111 652 179 b 714 248 704 243 710 248 b 727 235 719 248 721 243 l 848 42 b 883 12 860 22 870 12 b 917 32 891 12 903 19 b 946 62 927 42 939 50 b 1037 192 972 108 1009 147 b 1057 210 1044 204 1051 210 b 1076 190 1063 210 1068 203 l 1176 12 b 1215 -19 1188 -9 1201 -19 b 1250 -6 1225 -19 1237 -14 b 1284 27 1264 3 1274 16 b 1380 190 1323 78 1351 135 b 1395 210 1384 197 1385 210 b 1413 190 1405 210 1410 197 b 1508 40 1436 134 1467 85 b 1564 3 1529 14 1547 3 b 1617 32 1580 3 1597 12 b 1767 238 1678 92 1719 167 b 1794 310 1781 259 1791 282 b 1752 294 1776 317 1764 304 b 1656 164 1711 258 1689 206 b 1629 144 1646 151 1637 144 b 1603 161 1620 144 1613 150 b 1502 315 1562 207 1525 258 b 1452 357 1490 344 1470 357 b 1397 320 1431 357 1411 344 b 1316 170 1368 271 1345 219 b 1280 127 1306 154 1303 127 b 1244 171 1256 127 1254 154 b 1145 337 1210 226 1179 282 b 1110 363 1135 354 1122 363 b 1070 338 1097 363 1084 354 b 1050 311 1063 330 1057 320 b 959 181 1017 271 992 223 b 939 167 950 173 945 167 b 920 184 933 167 927 173 b 818 343 887 238 852 291 b 759 395 795 377 778 395 b 701 344 742 395 724 377 b 698 338 700 341 700 340 b 544 154 652 272 605 207 b 412 98 501 117 458 98 b 304 130 377 98 341 108 b 95 373 204 187 144 275 b 58 426 85 393 82 428 b 19 366 26 426 26 389 b 0 307 13 346 0 327 b 4 287 0 300 1 294 b 174 36 49 194 91 102 b 360 -43 230 -9 289 -43 z"
        },
        ornamentPrecompDoubleCadenceUpperPrefixTurn: {
            x_min: 0,
            x_max: 1226,
            y_min: -237,
            y_max: 436,
            ha: 673,
            o: "m 1279 -341 b 1293 -252 1293 -307 1295 -278 b 1277 36 1287 -156 1282 -59 l 1273 118 b 1318 176 1289 137 1303 157 b 1349 203 1332 193 1342 203 b 1378 168 1359 203 1367 192 b 1456 35 1401 122 1428 78 b 1511 -12 1476 3 1493 -12 b 1568 23 1526 -12 1544 0 b 1597 53 1578 32 1588 42 b 1705 186 1629 101 1669 143 b 1761 284 1728 216 1751 246 b 1765 300 1763 288 1765 295 b 1763 307 1765 302 1765 305 b 1737 302 1754 311 1744 308 b 1718 287 1729 298 1725 292 b 1598 145 1673 245 1637 194 b 1578 130 1590 135 1584 130 b 1557 147 1571 130 1565 135 b 1447 321 1516 202 1488 265 b 1403 351 1433 341 1417 351 b 1358 323 1388 351 1372 341 b 1269 209 1329 285 1299 248 b 1254 521 1264 314 1259 418 b 1228 616 1253 554 1247 588 b 1218 628 1224 621 1223 628 l 1215 628 b 1201 613 1210 626 1202 619 b 1200 600 1200 609 1200 605 l 1200 586 b 1211 348 1204 507 1207 428 b 1217 166 1214 288 1215 226 b 1202 181 1212 168 1208 174 b 1094 334 1168 233 1130 284 b 1048 366 1079 356 1064 366 b 1004 331 1034 366 1018 354 b 904 154 969 275 930 220 b 873 202 887 171 880 187 b 778 356 845 256 819 311 b 737 379 763 372 750 379 b 698 353 724 379 711 370 l 621 232 b 415 114 570 154 495 114 b 302 138 377 114 340 121 b 73 400 187 192 117 284 b 55 420 69 415 62 420 b 42 410 50 420 45 416 b 0 292 23 373 0 334 b 4 262 0 282 1 272 b 168 39 32 168 92 99 b 359 -26 225 -6 292 -26 b 585 76 446 -26 530 10 b 668 202 616 115 641 160 b 693 228 680 219 687 228 b 720 203 700 228 707 219 b 801 63 752 160 775 111 b 844 7 812 42 818 7 b 910 66 877 6 894 39 b 923 94 916 75 919 85 b 995 219 945 137 968 179 b 1025 184 1009 210 1017 197 b 1119 56 1054 141 1087 98 b 1166 20 1138 32 1152 20 b 1215 50 1181 20 1195 30 b 1221 56 1217 52 1218 55 b 1228 -163 1223 -17 1225 -89 b 1279 -341 1231 -223 1251 -278 z"
        },
        ornamentPrecompTrillLowerSuffix: {
            x_min: 0,
            x_max: 833,
            y_min: -309,
            y_max: 319,
            ha: 628,
            o: "m 778 -444 b 801 -445 785 -444 793 -445 b 1037 -338 894 -445 969 -397 b 1200 37 1149 -240 1200 -109 b 1084 406 1200 171 1172 300 b 1024 444 1064 431 1043 444 b 960 390 999 444 978 426 b 841 163 923 314 886 236 b 812 128 832 150 827 128 b 786 167 796 130 793 153 b 660 418 744 251 716 341 b 599 459 639 445 619 459 b 541 410 577 459 557 444 b 439 197 507 340 474 269 b 422 179 435 190 435 179 b 338 393 392 251 379 328 b 275 439 320 423 298 439 b 212 396 253 439 230 425 b 71 219 170 333 128 268 b 0 45 17 173 16 112 b 68 98 32 62 50 78 b 194 264 112 150 153 209 b 230 292 209 282 219 292 b 264 261 240 292 251 282 b 274 242 268 255 269 248 b 346 46 304 179 325 112 b 376 10 351 32 354 10 b 412 35 392 10 403 22 b 452 107 429 56 441 82 b 541 291 481 168 511 230 b 556 307 547 302 552 307 b 573 295 562 307 567 302 b 624 217 595 272 611 246 b 721 1 657 145 685 72 b 755 -27 732 -19 742 -27 b 786 -16 765 -27 775 -24 b 857 73 819 7 840 39 b 952 256 887 134 920 194 b 978 289 963 279 969 289 b 1009 262 985 289 994 281 b 1030 235 1017 253 1024 245 b 1110 -4 1071 161 1099 81 b 1116 -68 1113 -26 1116 -48 b 1009 -243 1116 -140 1090 -200 b 848 -291 956 -272 901 -291 b 730 -261 809 -291 770 -282 b 696 -248 714 -252 703 -248 b 671 -284 684 -248 678 -258 l 662 -312 b 657 -357 658 -330 657 -344 b 744 -439 657 -403 683 -425 z"
        },
        brassScoop: {
            x_min: 0,
            x_max: 312,
            y_min: -390,
            y_max: 28,
            ha: 418,
            o: "m 0 -562 b 393 -256 171 -504 307 -412 b 449 -39 431 -189 449 -115 b 448 -1 449 -26 449 -14 b 433 40 446 14 448 40 b 408 -3 410 40 412 14 b 396 -66 403 -23 402 -46 b 45 -397 346 -243 209 -337 b 0 -451 13 -409 1 -423 b 0 -562 -1 -485 0 -520 z"
        },
        brassDoitMedium: {
            x_min: 0,
            x_max: 476,
            y_min: -50,
            y_max: 333,
            ha: 383,
            o: "m 16 -72 b 27 -71 19 -72 23 -72 b 215 -33 89 -56 153 -48 b 521 114 327 -7 435 35 b 685 432 615 199 691 295 b 670 480 684 449 688 475 b 642 441 654 482 648 456 b 403 183 599 321 513 240 b 79 89 301 130 192 105 b 0 -1 -12 76 0 76 b 0 -50 0 -17 1 -33 b 16 -72 0 -65 3 -72 z"
        },
        brassFallLipShort: {
            x_min: 0,
            x_max: 298,
            y_min: -344,
            y_max: 65,
            ha: 409,
            o: "m 396 -495 b 420 -461 412 -487 418 -474 b 429 -382 428 -435 429 -409 b 426 -330 429 -364 428 -347 b 285 -6 410 -209 356 -104 b 98 94 239 59 173 94 b 39 86 79 94 58 92 b 0 49 20 81 0 73 l 0 -52 b 10 -69 0 -62 1 -69 b 20 -68 13 -69 16 -69 b 88 -56 45 -59 66 -56 b 261 -160 156 -56 213 -95 b 396 -495 333 -259 382 -369 z"
        },
        brassLiftMedium: {
            x_min: 0,
            x_max: 807,
            y_min: 0,
            y_max: 838,
            ha: 838,
            o: "m 50 0 b 55 1 52 0 53 0 b 58 23 65 7 59 16 b 55 58 56 36 55 48 b 130 117 55 99 75 112 b 220 213 202 121 220 141 b 315 308 220 289 238 308 l 336 308 b 408 380 393 310 406 321 b 461 452 409 438 416 452 b 485 451 468 452 477 451 b 569 510 531 448 556 464 b 573 543 572 520 572 531 b 657 619 580 605 595 618 b 698 621 670 619 684 619 b 788 700 749 625 778 649 b 798 778 792 726 793 752 b 873 857 806 841 809 845 b 985 950 927 867 973 887 b 1084 1047 1002 1035 1004 1034 b 1162 1128 1133 1056 1162 1087 b 1146 1182 1162 1145 1158 1164 b 1125 1207 1140 1191 1136 1207 l 1122 1207 b 1110 1191 1113 1205 1110 1198 b 1112 1174 1110 1185 1112 1178 b 1048 1110 1109 1126 1096 1113 b 1028 1109 1043 1110 1035 1109 b 939 1022 969 1102 948 1081 b 845 922 929 949 917 936 b 746 812 773 909 753 886 b 744 780 744 802 744 791 b 635 681 737 700 717 683 b 524 583 553 680 536 665 b 439 510 514 520 503 510 b 357 431 377 510 360 492 l 357 406 b 314 364 356 379 343 364 b 238 361 288 364 264 364 b 173 300 202 357 180 334 b 167 245 168 281 167 262 b 105 174 166 192 157 180 b 75 171 95 173 85 171 b 6 112 30 166 14 153 b 0 73 1 98 0 85 b 37 10 0 45 13 26 b 50 0 42 7 46 0 z"
        },
        brassFallRoughMedium: {
            x_min: 0,
            x_max: 791,
            y_min: 0,
            y_max: 819,
            ha: 819,
            o: "m 1117 0 b 1139 101 1129 26 1139 71 b 1138 121 1139 109 1139 115 b 1084 193 1125 171 1110 193 b 1044 183 1073 193 1060 189 b 1022 177 1035 179 1028 177 b 1007 209 1012 177 1008 186 b 876 324 1004 292 959 330 b 799 317 850 321 825 320 b 759 354 772 314 755 320 b 760 373 760 360 760 366 b 759 392 760 379 760 384 b 681 477 753 451 730 477 b 654 474 672 477 664 475 b 606 467 638 471 622 468 b 586 465 599 465 592 465 b 564 481 570 465 564 469 b 569 505 564 487 566 495 b 575 553 572 521 575 537 b 572 585 575 564 573 575 b 481 665 560 657 539 668 b 412 665 458 664 435 665 b 382 690 392 667 382 672 b 383 700 382 693 383 696 b 386 773 387 724 387 749 b 297 858 382 828 351 857 b 229 861 274 858 251 858 b 190 897 207 863 193 871 b 163 1012 186 936 180 976 b 79 1084 145 1050 124 1084 b 66 1083 75 1084 71 1083 b 43 1096 49 1081 43 1087 b 48 1112 43 1100 45 1106 b 53 1130 52 1119 53 1125 b 39 1169 53 1145 45 1158 b 26 1179 36 1175 30 1179 b 16 1171 22 1179 17 1176 b 0 1103 10 1149 0 1126 b 9 1067 0 1092 1 1079 b 91 1021 26 1031 52 1018 b 145 978 122 1024 141 1011 b 156 913 147 956 151 935 b 291 795 170 831 210 795 b 346 768 337 795 346 796 b 344 743 346 760 344 753 b 343 716 344 733 343 724 b 455 600 343 651 390 602 b 505 605 471 599 490 605 b 528 598 514 605 523 603 b 536 579 534 592 536 586 b 524 523 536 562 526 541 b 523 505 524 517 523 511 b 621 405 523 442 560 405 b 639 406 626 405 634 406 b 677 413 652 408 664 410 b 701 416 687 415 696 416 b 721 392 716 416 721 410 b 720 373 721 386 720 380 b 831 255 714 301 759 252 b 897 261 854 255 876 261 b 926 262 909 261 919 262 b 969 197 963 262 965 252 b 971 184 969 193 971 189 b 1031 115 979 137 998 115 b 1071 122 1043 115 1056 118 b 1096 130 1079 125 1086 127 b 1087 59 1094 107 1087 82 b 1117 0 1087 37 1094 17 z"
        },
        brassBend: {
            x_min: 0,
            x_max: 381,
            y_min: 0,
            y_max: 367,
            ha: 367,
            o: "m 298 0 b 472 50 359 0 418 14 b 537 135 501 71 530 92 b 543 216 543 163 543 190 l 543 266 b 544 308 543 281 543 295 b 549 433 546 354 549 395 b 543 507 549 459 547 482 b 533 528 541 516 544 528 b 511 508 524 528 514 520 b 508 478 510 498 508 488 b 504 318 507 425 504 372 b 505 264 504 300 505 282 b 446 181 505 220 484 199 b 294 150 396 160 344 150 b 92 194 226 150 158 167 b 45 269 62 207 45 230 b 46 359 46 300 46 328 b 37 497 46 405 45 451 b 27 523 36 507 37 523 b 4 498 14 524 6 513 b 3 481 3 492 3 487 b 0 409 1 456 0 433 b 4 228 0 348 4 288 b 3 177 4 210 4 194 b 68 53 1 125 20 84 b 200 10 108 27 154 17 b 298 0 233 4 266 0 z"
        },
        brassMuteClosed: {
            x_min: 0,
            x_max: 274,
            y_min: 0,
            y_max: 260,
            ha: 260,
            o: "m 203 0 b 209 1 206 0 207 0 b 216 13 215 4 216 9 l 215 27 l 215 153 b 216 161 216 156 216 158 b 372 164 268 163 318 164 b 395 184 383 164 395 166 l 395 189 b 357 229 392 209 386 229 b 219 228 311 229 265 228 l 223 310 b 209 357 225 328 219 344 b 189 374 203 364 197 374 b 184 373 187 374 186 373 b 177 359 179 372 177 366 l 177 348 l 173 222 l 39 222 b 0 206 12 222 0 219 b 10 174 0 199 3 189 b 46 157 19 157 30 157 b 108 160 68 158 88 160 b 171 161 130 161 150 161 l 167 58 b 184 16 167 40 171 26 b 203 0 192 12 196 0 z"
        },
        brassMuteOpen: {
            x_min: 1,
            x_max: 313,
            y_min: 0,
            y_max: 309,
            ha: 309,
            o: "m 265 0 b 451 189 363 7 452 88 l 451 215 b 348 383 441 285 405 343 b 209 445 288 426 248 445 b 84 379 168 445 132 420 b 69 364 79 373 73 369 b 1 213 30 323 1 275 b 230 0 1 88 94 0 z m 210 62 b 128 73 181 62 154 66 b 40 171 71 91 42 125 b 52 226 40 187 45 206 b 197 374 79 295 130 344 b 228 382 207 380 217 382 b 300 361 252 382 276 370 b 374 308 328 350 353 331 b 410 223 397 284 410 253 b 393 163 410 202 405 181 b 210 62 354 91 288 63 z"
        },
        brassFlip: {
            x_min: 0,
            x_max: 402,
            y_min: 0,
            y_max: 361,
            ha: 361,
            o: "m 579 0 b 511 153 579 68 557 117 b 52 504 359 271 206 387 b 29 520 45 510 39 520 b 20 517 26 520 23 518 b 0 477 3 510 0 494 l 0 125 b 17 20 1 92 1 56 b 40 84 37 40 40 60 b 42 287 40 151 42 219 l 42 363 z"
        },
        brassJazzTurn: {
            x_min: 0,
            x_max: 646,
            y_min: 0,
            y_max: 212,
            ha: 212,
            o: "m 310 0 b 367 33 327 0 344 10 b 389 55 374 40 382 49 b 490 145 423 85 456 114 b 507 154 495 151 501 154 b 524 144 513 154 517 151 b 598 72 547 120 575 98 b 700 24 625 42 662 24 b 765 43 721 24 744 30 b 893 147 812 72 855 105 b 930 212 910 166 923 186 b 912 215 923 213 917 215 b 871 199 896 215 883 209 b 812 153 852 183 832 167 b 789 144 805 148 796 144 b 773 156 782 144 776 147 b 691 251 757 199 720 222 b 603 301 658 282 631 301 b 527 258 580 301 556 288 b 420 156 494 222 455 190 b 399 143 412 147 405 143 b 377 157 392 143 386 147 b 259 282 340 200 300 242 b 219 305 245 298 232 305 b 177 279 204 305 192 297 b 55 127 137 228 95 177 b 0 52 36 104 20 79 b 14 50 6 50 10 50 b 53 66 32 50 45 58 b 115 131 75 88 98 108 b 135 148 124 143 130 148 b 157 132 141 148 148 143 b 252 33 186 96 219 65 b 310 0 275 12 292 0 z"
        },
        brassSmear: {
            x_min: 0,
            x_max: 334,
            y_min: 0,
            y_max: 151,
            ha: 151,
            o: "m 321 0 b 475 125 390 0 436 43 b 481 143 478 131 481 137 b 475 154 481 147 480 151 b 449 148 468 158 458 154 b 395 132 432 137 413 132 b 343 140 377 132 360 137 b 229 194 301 148 266 173 b 168 217 206 209 186 217 b 109 192 148 217 130 209 b 0 26 59 148 32 89 b 59 63 32 29 45 48 b 98 84 72 78 84 84 b 130 73 108 84 118 81 b 213 26 157 58 183 37 b 321 0 255 9 289 0 z"
        },
        stringsDownBow: {
            x_min: 0,
            x_max: 306,
            y_min: 0,
            y_max: 366,
            ha: 366,
            o: "m 405 0 b 425 17 413 -1 420 9 b 439 66 435 32 439 48 b 441 268 439 137 441 202 b 436 412 441 314 439 361 l 435 413 b 423 469 435 436 431 456 b 344 508 406 501 373 501 b 204 527 298 520 251 527 b 60 498 156 527 108 518 b 7 438 32 485 10 468 l 7 426 b 4 337 7 396 7 367 b 0 140 0 272 0 206 b 1 42 0 107 0 73 b 13 3 1 27 -3 4 b 40 39 29 3 35 24 b 42 53 42 43 40 49 b 49 141 48 84 49 112 b 48 215 49 167 48 192 b 49 252 48 228 48 240 l 49 312 b 130 343 72 331 99 340 b 206 347 156 346 180 347 b 372 314 262 347 318 338 l 390 307 l 390 245 b 390 138 392 212 390 176 b 397 23 390 101 392 62 b 405 0 399 14 393 1 z"
        },
        stringsUpBow: {
            x_min: 0,
            x_max: 219,
            y_min: 0,
            y_max: 489,
            ha: 489,
            o: "m 151 0 b 184 42 170 12 180 26 b 297 554 223 212 261 382 b 315 690 305 598 318 645 b 304 704 315 697 311 704 b 276 670 288 704 282 697 b 157 131 236 490 196 311 l 157 144 b 73 526 134 276 104 396 b 30 677 60 576 52 638 b 13 694 26 684 22 694 b 0 674 9 694 0 691 l 0 671 b 10 603 3 649 6 626 b 105 174 42 461 72 317 b 150 0 117 117 128 58 z"
        },
        stringsHarmonic: {
            x_min: 0,
            x_max: 191,
            y_min: 0,
            y_max: 202,
            ha: 202,
            o: "m 143 0 b 275 122 217 0 275 53 b 127 291 275 206 202 291 b 0 154 63 291 0 222 b 143 0 0 76 71 0 z m 122 68 b 43 105 89 66 59 75 b 39 124 40 111 39 117 b 79 199 39 148 56 180 b 145 226 101 216 122 226 b 199 210 163 226 180 220 b 235 150 223 196 235 173 b 203 92 235 128 225 107 b 122 68 181 76 150 68 z"
        },
        pluckedSnapPizzicatoAbove: {
            x_min: 0,
            x_max: 201,
            y_min: 0,
            y_max: 325,
            ha: 325,
            o: "m 171 0 b 289 99 240 0 289 45 b 258 183 289 130 274 156 b 174 269 236 217 203 240 l 174 408 b 174 429 174 415 176 422 b 131 468 168 451 153 468 b 117 451 120 468 117 461 b 118 429 117 444 118 435 b 115 307 117 389 115 347 b 0 166 59 295 0 223 b 171 0 0 85 89 0 z m 134 55 b 52 131 84 55 52 85 b 115 233 52 179 81 209 b 114 192 114 220 114 206 b 174 120 114 137 114 137 l 174 228 b 233 148 200 207 223 183 b 236 130 235 143 236 135 b 197 72 236 105 223 85 b 134 55 177 60 157 55 z"
        },
        pluckedSnapPizzicatoBelow: {
            x_min: 0,
            x_max: 211,
            y_min: 0,
            y_max: 307,
            ha: 307,
            o: "m 145 7 b 163 0 153 3 158 0 b 173 23 170 0 173 7 l 173 140 l 170 140 l 170 163 l 171 163 b 206 170 179 164 193 166 b 304 287 264 186 304 233 b 281 354 304 308 297 333 b 118 442 240 412 186 439 b 0 324 69 442 0 370 b 115 176 0 266 55 202 l 115 56 b 145 7 114 33 125 19 z m 115 220 b 62 256 92 223 73 230 b 53 292 56 269 53 281 b 78 344 53 311 60 328 b 168 384 105 372 135 384 b 213 376 183 384 199 382 b 253 321 239 366 253 346 b 246 291 253 311 251 301 b 170 226 230 256 203 236 l 170 258 b 148 305 171 278 163 292 b 128 315 143 310 135 315 l 124 315 b 115 301 117 314 115 308 z"
        },
        pluckedLeftHandPizzicato: {
            x_min: 0,
            x_max: 271,
            y_min: 0,
            y_max: 284,
            ha: 284,
            o: "m 213 0 b 223 14 222 0 223 7 b 222 35 223 22 222 29 l 222 176 b 373 170 272 174 323 170 b 390 180 382 170 390 171 l 390 184 b 347 232 386 207 382 232 b 219 238 307 233 266 235 l 219 364 b 171 409 219 395 193 409 b 156 393 160 409 156 402 b 158 370 156 384 158 376 l 158 240 b 16 239 115 240 66 239 b 0 226 7 239 0 238 l 0 223 b 50 179 1 203 29 179 b 158 177 86 179 122 179 l 158 63 b 161 29 158 52 158 40 b 213 0 166 -1 194 1 z"
        },
        keyboardPedalPed: {
            x_min: 0,
            x_max: 944,
            y_min: -13,
            y_max: 550,
            ha: 563,
            o: "m 22 0 b 109 78 53 0 105 46 l 144 333 b 163 376 147 347 140 372 b 364 465 238 390 301 426 b 454 599 416 497 454 540 b 452 618 454 605 454 612 b 320 770 442 694 396 747 b 248 779 295 778 272 779 b 193 778 229 779 212 779 b 160 780 181 778 167 775 b 137 792 153 789 144 791 b 109 789 128 792 118 789 b 7 719 59 789 48 737 b 23 708 16 714 20 708 b 36 710 29 710 33 710 b 53 684 52 710 53 698 l 53 674 b 43 386 53 577 53 482 b 20 164 36 312 30 238 b 1 30 14 120 7 75 b 0 19 0 26 0 22 b 22 0 0 9 4 0 z m 171 425 b 156 442 160 425 156 429 b 157 475 157 452 157 464 b 164 602 161 517 164 560 b 161 698 164 635 163 667 b 184 729 161 720 167 729 l 193 729 b 348 563 278 719 348 641 b 346 539 348 554 347 547 b 171 425 328 459 229 422 z m 979 6 b 1008 13 986 6 995 9 b 1081 101 1047 29 1079 46 b 1116 449 1087 217 1104 333 b 1143 654 1123 518 1133 586 b 1148 685 1145 664 1148 675 b 1140 704 1148 693 1146 700 b 1107 716 1130 713 1119 716 b 1056 706 1092 716 1073 710 b 1037 671 1035 703 1038 685 b 1004 439 1025 595 1014 517 b 986 419 1001 428 999 419 b 979 419 985 419 982 420 b 935 426 965 423 949 425 b 795 376 884 426 838 405 b 664 153 714 323 664 249 b 665 130 664 145 665 138 b 753 29 671 65 704 29 b 815 40 773 29 792 33 b 975 147 873 65 923 101 b 965 45 971 108 968 76 b 979 6 963 17 966 6 z m 393 -17 b 634 145 494 16 579 52 b 638 160 636 151 638 156 b 625 168 638 166 634 168 b 621 167 624 168 622 168 b 524 118 582 164 544 160 b 495 79 517 104 505 92 b 435 33 471 49 452 33 b 380 96 416 33 397 55 b 369 145 373 114 369 131 b 442 225 369 186 395 213 b 468 232 451 228 459 229 b 654 344 539 255 606 285 b 677 395 667 360 677 376 b 672 415 677 402 675 408 b 612 459 661 442 639 455 b 589 461 602 461 592 461 b 348 328 500 461 409 408 b 269 120 302 268 269 199 b 379 -19 269 45 318 -19 b 393 -17 383 -19 389 -19 z m 395 240 b 494 383 418 300 452 344 l 521 405 b 544 419 528 409 536 418 b 554 415 547 419 550 418 b 570 383 564 406 570 396 l 570 379 b 552 331 570 360 562 344 b 395 240 511 285 462 253 z m 827 89 b 792 111 815 89 804 96 b 766 204 775 131 766 158 b 845 360 772 256 799 314 b 871 372 854 369 863 372 b 897 366 880 372 888 369 b 978 279 942 353 963 320 b 976 259 981 272 981 265 b 858 104 942 203 909 147 b 827 89 847 94 837 89 z m 1282 12 b 1336 35 1303 14 1320 23 b 1359 71 1351 45 1359 58 b 1338 102 1359 82 1352 95 b 1254 130 1312 118 1284 130 b 1187 88 1223 130 1202 109 b 1178 65 1182 81 1178 72 b 1195 37 1178 55 1182 45 b 1282 12 1223 23 1253 19 z"
        },
        keyboardPedalUp: {
            x_min: 0,
            x_max: 437,
            y_min: 0,
            y_max: 461,
            ha: 461,
            o: "m 330 0 b 334 1 331 0 333 0 b 340 12 338 4 340 7 l 338 26 b 340 264 338 105 338 184 b 526 95 400 206 461 148 b 559 71 536 88 547 71 b 564 72 560 71 563 71 b 580 121 580 79 580 102 l 580 127 b 543 203 585 158 573 184 b 472 259 518 219 495 238 l 445 285 b 590 292 494 288 541 291 b 622 318 609 294 618 302 b 628 359 625 331 626 346 b 586 402 632 393 621 405 b 464 395 546 399 504 396 l 559 491 b 567 524 567 500 567 510 b 564 543 567 527 567 536 b 539 596 559 563 560 590 b 494 564 521 600 508 577 b 340 413 442 514 390 464 l 340 560 b 287 664 340 600 321 632 b 271 518 274 612 272 566 b 268 445 269 494 269 469 b 117 569 219 488 168 530 b 96 579 109 575 102 579 b 85 560 89 579 85 573 b 124 446 85 518 82 477 b 209 380 153 426 181 403 b 45 374 154 377 99 376 b 0 324 9 374 0 359 b 63 266 0 265 1 265 b 144 272 89 269 117 272 l 196 272 b 108 193 167 246 138 219 b 60 135 76 164 60 151 b 99 73 60 121 73 105 b 104 68 101 72 102 71 b 114 58 107 60 111 58 b 130 66 120 58 124 62 b 259 186 173 107 217 145 b 256 117 259 163 256 140 b 311 13 256 72 271 37 b 330 0 317 10 323 0 z"
        },
        pictChokeCymbal: {
            x_min: 1,
            x_max: 147,
            y_min: 0,
            y_max: 242,
            ha: 242,
            o: "m 79 4 b 207 158 153 32 192 88 b 212 200 210 173 212 187 b 143 336 212 253 187 298 b 98 348 131 344 115 348 b 4 295 60 348 16 327 b 1 276 1 289 1 282 b 9 249 1 266 3 258 b 121 183 35 206 72 183 b 156 186 132 183 144 183 b 26 53 134 115 91 73 b 7 39 13 49 7 45 b 19 20 7 33 12 27 b 59 0 30 9 43 0 b 79 4 65 0 72 1 z"
        },
        wiggleArpeggiatoUp: {
            x_min: -22,
            x_max: 300,
            y_min: 0,
            y_max: 176,
            ha: 176,
            o: "m 173 4 b 196 0 180 1 189 0 b 246 26 215 0 230 9 b 301 117 271 53 285 85 b 312 131 305 125 307 131 b 327 124 315 131 321 128 b 373 86 341 112 353 101 b 412 69 389 75 402 69 b 432 94 425 69 432 79 b 373 181 432 117 413 154 b 235 252 323 216 285 245 b 220 253 229 253 225 253 b 168 215 196 253 181 240 b 111 112 151 180 140 141 b 94 102 105 105 99 102 b 78 111 89 102 84 105 b 0 181 55 135 35 160 b -32 153 -20 194 -32 168 b 0 86 -32 124 -32 109 b 94 36 22 71 73 46 b 173 4 134 16 131 17 z"
        },
        arpeggiatoUp: {
            x_min: 0,
            x_max: 262,
            y_min: 0,
            y_max: 1459,
            ha: 1459,
            o: "m 190 0 b 160 63 187 29 170 45 b 145 108 150 81 145 95 b 183 163 145 128 157 145 b 300 246 222 190 262 216 b 347 318 333 272 347 295 b 301 393 347 341 331 364 b 258 413 289 403 272 408 b 145 449 220 425 183 436 b 117 464 135 452 120 452 b 140 491 115 477 128 484 b 294 593 192 526 243 557 b 330 647 318 611 330 626 b 314 693 330 660 324 675 b 262 736 302 714 285 729 b 170 763 230 744 200 753 b 122 783 153 768 125 768 b 160 831 120 804 143 818 b 288 922 202 861 246 890 b 333 999 318 945 333 972 b 266 1083 333 1032 310 1064 b 189 1115 240 1094 215 1103 b 122 1178 145 1133 122 1153 b 168 1250 122 1200 138 1223 l 180 1257 b 269 1333 210 1283 240 1306 b 305 1405 294 1356 305 1381 b 284 1469 305 1426 298 1447 b 228 1525 269 1492 251 1511 b 183 1600 197 1545 183 1571 b 190 1640 183 1613 184 1626 b 197 1670 193 1650 194 1660 b 272 1735 213 1719 230 1735 b 295 1734 279 1735 287 1735 b 323 1732 305 1732 314 1732 b 350 1731 333 1732 341 1732 b 377 1742 369 1729 377 1732 b 370 1761 377 1747 374 1754 l 301 1898 b 217 2066 274 1954 248 2012 b 186 2101 204 2089 196 2101 b 154 2069 177 2101 167 2091 b 12 1824 105 1987 59 1907 b 0 1787 4 1810 0 1797 b 59 1744 0 1761 20 1745 b 160 1738 92 1744 125 1740 b 145 1692 156 1721 151 1706 b 135 1633 138 1672 135 1652 b 184 1518 135 1591 151 1552 b 229 1475 199 1503 213 1488 b 259 1431 249 1456 259 1444 b 229 1388 259 1420 249 1407 b 151 1325 203 1365 177 1345 b 105 1279 134 1310 118 1296 b 73 1202 84 1251 73 1227 b 108 1123 73 1176 85 1152 b 255 1031 148 1077 199 1051 b 282 1014 274 1025 282 1021 b 262 991 282 1008 275 1001 b 151 914 226 963 189 939 b 79 851 125 896 99 877 b 63 809 69 837 63 824 b 79 769 63 796 68 783 b 202 697 111 729 154 710 b 266 670 225 690 266 688 b 210 622 266 648 232 635 b 82 534 167 593 120 570 b 55 491 63 518 55 505 b 79 448 55 478 63 465 b 255 361 127 395 192 380 b 288 343 269 359 288 357 b 266 312 288 331 275 320 b 144 223 229 278 184 253 b 85 134 104 193 85 166 b 118 53 85 111 96 85 b 190 0 135 29 160 14 z"
        },
        arpeggiatoDown: {
            x_min: 0,
            x_max: 218,
            y_min: 0,
            y_max: 1440,
            ha: 1440,
            o: "m 161 16 b 310 261 210 98 259 180 b 314 275 312 266 314 271 b 302 295 314 282 310 289 b 252 311 287 308 269 311 b 217 310 240 311 229 310 b 190 333 202 310 194 315 b 151 412 186 363 171 389 b 102 501 120 452 102 477 b 150 588 102 524 118 547 b 161 603 154 592 158 598 b 181 661 176 622 181 641 b 173 704 181 675 179 690 b 86 795 156 746 121 770 b 53 829 63 811 53 819 b 78 868 53 840 62 851 b 102 888 85 876 94 883 b 180 956 128 912 156 933 b 216 1028 204 979 216 1002 b 203 1081 216 1044 212 1061 b 115 1171 186 1123 148 1145 b 75 1221 88 1191 75 1207 b 114 1272 75 1237 88 1251 b 173 1308 132 1284 154 1296 b 226 1339 190 1318 209 1328 b 265 1405 253 1359 265 1380 b 258 1447 265 1418 264 1431 b 154 1541 242 1499 199 1521 b 109 1581 124 1555 109 1567 b 141 1627 109 1594 121 1608 b 204 1680 163 1646 184 1662 b 233 1742 223 1699 233 1719 b 226 1777 233 1752 230 1764 b 135 1862 210 1822 173 1840 b 104 1895 114 1875 104 1884 b 118 1930 104 1904 109 1914 b 192 2006 135 1961 161 1986 b 206 2029 203 2013 206 2022 b 192 2064 206 2040 197 2052 b 180 2074 187 2071 184 2074 b 156 2061 171 2074 163 2065 b 84 1983 125 2040 102 2013 b 65 1921 71 1961 65 1941 b 88 1853 65 1899 72 1876 b 171 1784 108 1820 138 1801 b 190 1764 184 1777 190 1770 b 174 1741 190 1757 184 1750 b 107 1683 153 1722 128 1704 b 68 1610 81 1659 68 1636 b 88 1548 68 1591 75 1571 b 177 1470 109 1512 141 1489 b 223 1431 209 1453 223 1443 b 179 1390 223 1420 209 1408 b 128 1361 163 1380 145 1371 b 71 1322 108 1348 88 1338 b 32 1253 45 1300 32 1277 b 48 1198 32 1236 37 1218 b 147 1090 71 1152 108 1120 b 174 1057 166 1076 174 1067 b 153 1022 174 1047 167 1037 b 109 982 140 1008 124 995 b 37 919 85 962 59 942 b 9 860 17 899 9 880 b 26 806 9 844 14 827 b 120 717 50 769 84 740 b 138 691 132 708 138 700 b 130 668 138 684 135 677 b 92 618 118 651 105 635 b 59 531 71 589 59 560 b 84 455 59 507 68 481 b 132 386 98 431 115 408 b 148 341 144 372 148 357 b 144 317 148 333 147 324 b 121 305 140 307 131 305 l 98 305 b 82 304 94 304 88 304 l 32 304 b 0 292 10 304 0 302 b 12 266 0 287 4 279 b 60 164 32 233 46 199 b 127 20 84 117 105 68 b 144 0 132 9 137 0 b 161 16 150 0 154 4 z"
        },
        repeat1Bar: {
            x_min: 0,
            x_max: 599,
            y_min: -250,
            y_max: 175,
            ha: 425,
            o: "m 216 98 b 255 75 236 84 246 75 b 291 104 265 75 274 85 b 323 147 304 117 327 125 b 289 215 323 168 314 184 b 238 252 269 239 253 252 b 187 222 222 252 207 242 b 173 206 183 216 177 212 b 157 170 163 194 157 183 b 174 138 157 160 161 150 b 216 98 189 127 200 109 z m 76 -334 b 181 -285 111 -315 148 -302 b 831 52 396 -168 613 -58 b 863 114 855 63 864 82 b 828 202 855 140 855 176 b 808 213 821 209 815 213 b 793 209 804 213 799 212 l 422 19 b 26 -179 291 -48 164 -124 b 0 -213 10 -186 0 -196 b 3 -232 0 -219 0 -225 b 52 -325 14 -265 37 -294 b 66 -337 55 -331 59 -337 b 76 -334 69 -337 72 -336 z m 769 -360 b 829 -264 779 -360 829 -284 b 769 -176 822 -232 799 -200 b 742 -163 760 -167 750 -163 b 716 -184 733 -163 723 -168 b 683 -228 708 -202 693 -213 b 672 -253 675 -236 672 -245 b 683 -281 672 -262 675 -271 b 752 -353 703 -308 732 -327 b 769 -360 756 -357 763 -360 z"
        },
        repeat2Bars: {
            x_min: 0,
            x_max: 775,
            y_min: -247,
            y_max: 363,
            ha: 610,
            o: "m 909 412 b 873 351 906 384 893 367 b 436 50 729 249 585 147 l 91 -179 b 62 -174 76 -189 68 -183 b 12 -96 48 -147 24 -125 b 36 -16 -7 -53 -6 -43 b 220 104 96 24 158 65 b 819 507 425 232 624 369 b 881 495 852 530 861 528 b 909 412 899 469 900 439 z m 333 338 b 302 240 330 307 317 274 b 276 235 297 225 287 228 l 233 269 b 203 376 186 307 183 318 b 225 441 212 397 217 419 b 246 454 228 452 232 458 b 333 338 284 441 333 380 z m 1116 228 b 1067 158 1115 192 1092 174 b 910 59 1015 125 963 92 b 478 -240 762 -33 622 -140 b 311 -350 423 -279 366 -314 b 285 -344 298 -360 289 -356 b 239 -258 272 -314 251 -288 b 261 -196 228 -228 235 -210 b 517 -29 348 -144 436 -91 b 1030 321 681 98 861 202 b 1093 307 1060 343 1076 340 b 1116 228 1107 281 1109 252 z m 1070 -105 b 1020 -210 1057 -143 1038 -176 b 998 -210 1014 -219 1004 -215 l 924 -153 b 913 -88 899 -135 897 -112 b 949 -22 926 -66 939 -45 b 998 -7 960 6 976 9 b 1070 -105 1032 -32 1058 -63 z"
        },
        repeat4Bars: {
            x_min: 0,
            x_max: 1374,
            y_min: -304,
            y_max: 304,
            ha: 608,
            o: "m 78 -266 b 92 -258 82 -266 88 -264 b 114 -240 98 -251 107 -246 b 638 107 289 -125 467 -14 b 873 271 716 161 793 216 b 907 337 894 285 906 305 b 887 400 901 354 897 379 b 852 438 877 426 867 438 b 814 420 842 438 829 432 b 135 -33 592 262 366 111 b 12 -121 92 -60 48 -84 b 0 -144 4 -128 0 -135 b 4 -160 0 -148 1 -154 b 63 -255 17 -196 45 -223 b 78 -266 68 -262 72 -266 z m 291 148 b 325 223 302 148 308 170 b 333 256 328 235 330 246 b 264 363 330 305 298 336 b 242 373 255 369 248 373 b 220 347 232 373 225 364 b 202 288 216 327 213 305 b 190 252 193 275 190 262 b 222 200 190 232 202 215 b 291 148 264 170 279 148 z m 815 -367 b 829 -359 819 -367 824 -364 b 851 -343 835 -353 844 -347 b 1375 6 1027 -228 1205 -117 l 1610 170 b 1644 235 1632 184 1643 203 b 1626 300 1639 253 1634 276 b 1590 337 1614 325 1604 337 b 1551 320 1580 337 1567 330 b 873 -135 1329 161 1103 10 b 749 -222 829 -161 785 -184 b 737 -245 742 -230 737 -238 b 742 -261 737 -249 739 -255 b 802 -357 755 -297 782 -325 b 815 -367 805 -363 809 -367 z m 396 -360 b 408 -356 400 -360 403 -359 b 609 -223 471 -307 543 -269 b 896 -19 706 -156 795 -81 b 1164 154 985 37 1074 96 b 1214 223 1189 170 1211 187 b 1176 321 1204 253 1205 292 b 1159 330 1169 327 1165 330 b 1145 324 1155 330 1151 328 b 1048 258 1113 302 1081 278 b 357 -202 809 117 598 -65 b 333 -238 341 -212 333 -223 b 338 -262 333 -245 334 -253 b 384 -350 350 -294 372 -318 b 396 -360 386 -354 390 -360 z m 1162 -438 b 1174 -433 1166 -438 1169 -436 b 1374 -300 1237 -384 1309 -346 b 1660 -96 1470 -233 1561 -158 b 1930 76 1751 -39 1840 19 b 1979 147 1954 92 1977 109 b 1943 243 1968 177 1971 216 b 1924 253 1935 251 1930 253 b 1911 248 1920 253 1915 252 b 1814 181 1878 225 1848 202 b 1123 -279 1575 40 1364 -141 b 1099 -315 1106 -289 1099 -300 b 1103 -338 1099 -321 1100 -330 b 1149 -426 1115 -370 1138 -396 b 1162 -438 1151 -432 1156 -438 z m 1875 -295 b 1882 -291 1878 -295 1879 -294 b 1934 -189 1904 -258 1921 -223 b 1872 -96 1925 -147 1901 -120 b 1840 -78 1858 -84 1848 -78 b 1812 -109 1830 -78 1823 -88 l 1777 -173 b 1770 -199 1773 -181 1770 -190 b 1786 -230 1770 -210 1774 -220 b 1862 -289 1809 -253 1837 -269 b 1875 -295 1865 -292 1871 -295 z"
        },
        repeatBarSlash: {
            x_min: 0,
            x_max: 630,
            y_min: -225,
            y_max: 265,
            ha: 490,
            o: "m 78 -324 b 92 -314 82 -325 88 -321 b 114 -298 96 -307 107 -302 b 638 49 289 -183 467 -72 b 873 215 716 104 792 161 b 907 279 894 229 906 248 b 887 344 901 298 897 321 b 852 382 877 369 867 380 b 814 363 842 383 829 376 b 135 -91 603 192 364 55 b 12 -177 92 -118 45 -137 b 0 -202 4 -186 0 -192 b 4 -217 0 -206 1 -212 b 63 -312 17 -253 42 -284 b 78 -324 68 -318 72 -323 z"
        },
        csymDiminished: {
            x_min: 0,
            x_max: 506,
            y_min: 0,
            y_max: 500,
            ha: 500,
            o: "m 397 0 b 729 265 576 -1 729 95 b 711 367 729 297 723 331 b 472 670 668 498 586 595 b 315 720 423 701 372 720 b 253 713 295 720 275 719 b 32 514 144 687 75 615 b 0 374 12 468 0 420 b 27 251 0 333 9 292 b 140 117 52 196 92 153 b 397 0 223 52 317 4 z m 340 95 b 132 314 233 84 122 216 b 324 589 145 438 200 539 b 415 611 360 603 389 611 b 544 505 469 611 505 576 b 590 392 564 471 583 432 b 596 343 593 374 596 359 b 340 95 596 210 485 96 z"
        },
        csymHalfDiminished: {
            x_min: -32,
            x_max: 496,
            y_min: -33,
            y_max: 492,
            ha: 525,
            o: "m -29 -48 b 0 -36 -19 -48 -9 -40 b 17 -20 7 -32 12 -24 b 134 94 56 19 95 56 b 372 0 207 43 282 0 b 455 13 397 0 426 4 b 677 258 556 45 671 141 b 678 289 677 268 678 278 b 593 539 678 380 654 467 b 592 541 593 540 592 540 l 684 632 b 713 678 700 647 711 665 b 714 691 714 684 714 688 b 707 704 714 698 711 701 b 691 708 701 707 696 708 b 660 691 680 708 670 701 l 552 585 b 478 634 530 606 507 624 b 361 684 438 648 397 661 b 301 703 341 697 320 703 b 226 677 275 703 251 693 b 27 449 140 618 72 543 b 0 324 9 410 -4 370 b 88 128 -1 243 30 177 b -30 -7 43 86 0 46 b -46 -33 -35 -16 -46 -24 b -42 -42 -46 -36 -45 -39 b -29 -48 -37 -46 -33 -48 z m 141 179 b 121 251 128 200 121 225 b 128 297 121 265 124 281 b 351 575 163 420 248 505 b 377 582 359 579 369 580 b 501 536 422 586 468 567 b 141 179 382 416 261 298 z m 281 105 b 179 137 240 105 206 117 b 210 168 189 147 200 157 l 537 487 b 547 455 541 477 544 467 b 556 370 552 426 556 397 b 429 154 556 274 503 207 b 281 105 384 122 336 105 z"
        },
        csymAugmented: {
            x_min: 0,
            x_max: 530,
            y_min: 0,
            y_max: 539,
            ha: 539,
            o: "m 380 0 b 393 14 384 4 390 9 b 397 46 397 24 397 36 l 397 333 b 736 327 511 331 624 330 b 763 343 755 327 763 333 b 755 361 763 348 760 354 b 635 431 726 402 688 431 l 390 431 l 390 485 b 386 606 392 526 386 566 b 392 664 386 625 387 645 b 395 690 393 672 395 681 b 376 753 395 711 389 734 b 357 776 372 762 369 776 b 350 775 354 776 353 776 b 327 740 337 769 327 759 b 327 621 328 700 327 661 b 330 438 328 559 328 498 l 29 438 b 4 431 20 438 7 442 b 0 413 3 425 0 419 b 7 399 0 408 1 403 b 131 338 45 369 85 340 b 331 334 199 336 265 334 b 333 163 333 276 333 220 b 366 13 333 109 348 63 b 380 0 367 7 374 4 z"
        },
        csymMajorSeventh: {
            x_min: 0,
            x_max: 593,
            y_min: 0,
            y_max: 569,
            ha: 569,
            o: "m 124 1 l 497 27 b 819 50 605 35 711 43 b 854 98 847 52 855 63 b 812 200 845 128 835 166 b 564 585 730 328 648 456 b 435 786 521 652 480 720 b 397 819 419 809 408 819 b 369 792 387 819 379 811 b 7 173 248 585 128 379 b 0 150 3 166 0 158 b 7 128 0 143 3 135 b 89 10 30 86 65 50 b 109 0 95 1 102 0 z m 163 147 b 153 153 158 147 156 148 b 164 179 147 163 158 170 b 426 644 251 334 338 488 b 442 660 432 655 436 660 b 458 645 446 660 452 655 b 727 220 547 503 636 361 b 736 202 732 213 736 206 b 714 190 736 196 730 192 b 179 148 537 177 359 163 b 163 147 174 150 168 147 z"
        },
        csymMinor: {
            x_min: 0,
            x_max: 482,
            y_min: 193,
            y_max: 265,
            ha: 72,
            o: "m 168 278 b 197 279 177 278 187 278 b 431 292 275 287 353 288 l 431 291 b 661 302 508 295 585 300 b 693 311 672 304 688 300 b 674 346 697 324 685 338 b 564 382 641 366 606 384 l 27 360 b 0 347 17 360 1 366 b 19 314 0 333 3 321 b 168 278 66 291 115 278 z"
        },
        csymParensLeftTall: {
            x_min: 0,
            x_max: 185,
            y_min: 0,
            y_max: 1034,
            ha: 1034,
            o: "m 215 0 b 226 17 223 1 223 10 b 229 37 229 24 229 32 b 220 81 229 52 225 66 b 167 203 206 124 181 160 b 86 616 124 338 89 474 b 82 765 85 665 82 716 b 91 886 82 805 84 845 b 245 1319 120 1038 171 1184 b 266 1397 259 1346 266 1371 b 259 1443 266 1411 264 1427 b 226 1489 253 1463 248 1489 b 193 1454 212 1489 203 1467 b 114 1292 158 1404 140 1346 b 0 806 40 1138 0 978 b 3 721 0 779 0 750 b 1 677 1 707 1 693 b 36 418 1 593 16 504 b 144 96 62 307 95 199 b 196 12 158 66 179 39 b 212 0 200 7 204 0 z"
        },
        csymParensRightTall: {
            x_min: -40,
            x_max: 189,
            y_min: 0,
            y_max: 1058,
            ha: 1058,
            o: "m 30 1 b 63 14 42 -3 55 6 b 122 99 86 40 108 68 b 189 258 145 153 166 204 b 271 667 239 379 268 503 b 246 852 275 708 261 780 b 10 1495 197 1077 128 1295 b -14 1524 4 1505 1 1524 b -16 1522 -14 1524 -16 1524 b -46 1489 -33 1521 -43 1503 b -58 1417 -53 1464 -58 1440 b -36 1335 -58 1390 -52 1364 b 68 1138 0 1270 35 1204 b 163 883 108 1056 137 969 b 206 668 184 814 200 742 b 207 631 207 655 207 642 b 166 426 207 560 192 492 b 46 143 130 330 111 228 b 19 29 19 109 17 69 b 30 1 20 19 24 3 z"
        },
        csymBracketLeftTall: {
            x_min: 0,
            x_max: 328,
            y_min: 2,
            y_max: 807,
            ha: 805,
            o: "m 68 3 b 76 4 71 3 73 3 b 186 13 112 12 150 13 b 240 13 204 13 222 13 l 287 13 b 379 17 317 13 348 13 b 472 121 435 24 472 69 b 467 156 472 132 469 144 b 446 174 462 168 456 174 l 439 174 b 327 166 402 167 364 166 b 265 167 307 166 285 167 l 209 167 b 187 475 199 269 189 372 b 166 985 186 645 187 815 l 377 1002 b 415 1001 389 1002 402 1001 b 456 1027 432 1001 448 1005 b 472 1096 467 1048 472 1073 b 464 1146 472 1113 469 1130 b 439 1162 459 1161 452 1162 b 40 1129 305 1151 173 1139 b 1 1093 17 1128 1 1120 b 0 1009 0 1064 0 1037 b 13 975 0 991 3 981 b 30 670 23 873 30 772 b 29 608 30 649 29 628 l 29 563 b 56 88 29 405 49 246 b 53 22 55 66 55 43 b 68 3 53 12 56 3 z"
        },
        csymBracketRightTall: {
            x_min: 1,
            x_max: 306,
            y_min: 0,
            y_max: 829,
            ha: 829,
            o: "m 117 0 b 372 29 203 -3 287 20 l 373 29 b 406 32 383 30 395 30 b 436 60 428 33 432 43 b 441 109 439 76 441 92 b 433 200 441 140 436 170 b 409 696 422 366 409 530 b 416 887 409 763 416 831 b 415 920 416 899 415 910 l 415 1106 b 412 1135 415 1116 415 1126 l 412 1145 b 373 1189 413 1171 408 1192 b 321 1189 356 1189 338 1189 l 215 1189 l 215 1194 l 56 1194 b 6 1153 27 1195 10 1187 b 1 1064 3 1123 4 1093 b 22 1043 0 1050 6 1043 b 84 1044 42 1044 63 1044 b 264 1038 144 1044 203 1040 b 265 958 264 1011 265 985 b 262 845 265 920 264 883 b 259 710 259 801 259 755 b 279 243 259 554 271 399 b 285 170 281 219 284 194 b 95 151 222 161 158 156 b 29 81 27 147 27 147 l 29 73 b 105 0 33 0 33 0 z"
        },
        csymParensLeftVeryTall: {
            x_min: 0,
            x_max: 116,
            y_min: 0,
            y_max: 934,
            ha: 934,
            o: "m 128 0 b 147 17 137 0 144 9 b 167 102 160 45 167 73 b 158 154 167 120 164 137 b 117 307 141 204 130 256 b 63 698 84 435 71 567 b 62 788 62 729 62 757 b 69 916 62 829 63 873 b 109 1172 81 1001 94 1087 b 132 1320 118 1221 137 1269 b 124 1345 131 1329 134 1342 b 96 1332 114 1346 102 1341 b 71 1269 82 1313 75 1292 b 39 1104 59 1214 48 1159 b 0 742 19 988 0 871 b 10 559 3 688 6 624 b 58 226 16 446 33 336 b 112 20 73 157 94 89 b 128 0 115 13 118 0 z"
        },
        csymParensRightVeryTall: {
            x_min: -20,
            x_max: 111,
            y_min: 0,
            y_max: 1009,
            ha: 1009,
            o: "m -3 0 b 20 22 9 -1 14 12 b 36 56 26 33 32 45 b 99 274 58 128 84 199 b 160 788 135 439 163 605 b 122 1181 164 912 145 1047 b 50 1431 108 1267 86 1351 b 36 1453 48 1439 46 1453 l 35 1453 l 30 1453 b 7 1423 17 1449 7 1440 b 27 1287 9 1377 10 1331 b 96 963 71 1184 85 1074 b 105 818 102 914 105 867 b 91 624 105 753 99 688 b -4 213 72 484 48 344 b -29 101 -19 174 -29 138 b -16 27 -29 76 -24 52 b -3 0 -13 17 -14 3 z"
        },
        csymDiagonalArrangementSlash: {
            x_min: 0,
            x_max: 990,
            y_min: -27,
            y_max: 1028,
            ha: 1054,
            o: "m 14 -37 b 58 -9 35 -45 46 -22 b 392 333 170 105 279 217 l 765 711 b 1372 1329 968 916 1168 1125 b 1424 1439 1403 1359 1417 1397 b 1426 1457 1424 1444 1426 1450 b 1416 1477 1426 1466 1423 1475 b 1374 1462 1400 1485 1385 1473 b 1181 1269 1309 1397 1246 1331 b 736 831 1031 1122 884 979 b 356 452 609 704 485 576 b 32 132 246 347 143 236 b 0 50 7 109 1 84 b 6 9 -1 37 3 23 b 14 -37 10 -9 0 -32 z"
        },
        accidentalNarrowReversedFlat: {
            x_min: 0,
            x_max: 208,
            y_min: -231,
            y_max: 449,
            ha: 680,
            o: "m 272 -333 b 284 -320 278 -333 281 -328 b 300 -174 297 -272 300 -222 b 275 190 298 -52 279 68 b 268 445 272 275 268 360 l 268 490 b 264 612 269 530 265 572 b 236 647 264 632 252 645 l 235 647 b 217 618 220 647 220 628 b 207 526 210 588 207 556 b 210 432 207 494 210 464 b 216 268 213 377 215 323 l 216 230 l 215 232 b 154 256 194 240 174 251 b 111 264 138 261 124 264 b 3 153 50 264 10 223 b 0 94 0 132 0 114 b 194 -276 0 -63 68 -186 b 255 -323 215 -291 236 -307 b 272 -333 262 -330 268 -333 z m 233 -138 b 71 30 168 -92 105 -45 b 63 59 65 42 63 50 b 96 95 62 75 73 86 b 130 102 108 99 120 102 b 215 76 160 102 187 88 l 220 73 b 225 -22 220 42 222 10 b 233 -138 229 -62 230 -101 z"
        },
        accidentalNarrowReversedFlatAndFlat: {
            x_min: 0,
            x_max: 335,
            y_min: -231,
            y_max: 449,
            ha: 680,
            o: "m 151 490 b 148 612 151 530 150 572 b 132 647 148 632 141 645 b 122 618 124 647 124 628 b 117 526 118 588 117 556 b 118 432 117 494 118 464 b 121 268 120 377 121 323 l 121 232 b 86 256 109 240 98 251 b 62 264 78 261 69 264 b 1 153 29 264 6 223 b 0 94 0 132 0 114 b 109 -276 0 -63 37 -186 b 144 -323 121 -291 132 -307 b 153 -333 147 -330 151 -333 b 160 -320 157 -333 158 -328 b 168 -174 167 -272 168 -222 b 154 190 168 -52 157 68 b 151 445 153 275 151 360 z m 480 153 b 372 264 472 223 432 264 b 328 256 359 264 344 261 b 268 232 308 251 288 240 l 266 230 l 266 268 b 272 432 266 323 269 377 b 275 526 272 464 275 494 b 265 618 275 556 272 588 b 248 647 262 628 262 647 l 246 647 b 219 612 230 645 219 632 b 215 490 217 572 213 530 l 215 445 b 207 190 215 360 210 275 b 183 -174 203 68 183 -52 b 199 -320 183 -222 186 -272 b 210 -333 202 -328 204 -333 b 228 -323 215 -333 220 -330 b 288 -276 246 -307 268 -291 b 482 94 415 -186 482 -63 b 480 153 482 114 482 132 z m 40 30 b 36 59 36 42 36 50 b 55 95 35 75 42 86 b 73 102 60 99 68 102 b 121 76 89 102 105 88 l 124 73 b 127 -22 124 42 125 10 l 131 -138 b 40 30 95 -92 60 -43 z m 419 59 b 412 30 419 50 418 42 b 249 -138 374 -43 314 -92 b 258 -22 252 -101 253 -62 b 262 73 261 10 262 42 l 268 76 b 353 102 295 88 323 102 b 386 95 363 102 374 99 b 419 59 409 86 420 75 z"
        },
        accidentalWilsonPlus: {
            x_min: 0,
            x_max: 298,
            y_min: -218,
            y_max: 218,
            ha: 436,
            o: "m 232 -314 b 236 -301 236 -310 236 -305 l 236 -295 b 243 -52 239 -213 242 -132 l 369 62 b 429 200 413 101 425 147 b 416 243 429 216 428 236 b 383 225 406 251 393 232 l 377 220 b 246 98 336 177 291 138 b 249 242 248 145 246 193 b 225 304 251 265 242 287 b 209 314 220 308 215 314 b 204 312 207 314 206 312 b 196 292 196 310 196 300 b 193 184 194 256 194 220 b 187 48 192 140 190 94 b 46 -72 141 7 94 -32 b 0 -163 13 -98 0 -127 b 1 -187 0 -170 0 -179 b 10 -235 4 -203 6 -219 b 20 -255 12 -242 14 -251 b 36 -245 26 -259 30 -249 b 181 -109 85 -200 132 -154 b 176 -258 180 -158 176 -209 b 232 -314 176 -298 186 -307 z"
        },
        accidentalWilsonMinus: {
            x_min: 0,
            x_max: 284,
            y_min: -163,
            y_max: 163,
            ha: 326,
            o: "m 386 -232 b 409 -163 415 -222 408 -180 b 382 -69 410 -120 408 -89 b 32 228 264 30 141 118 b 17 235 26 233 22 235 b 3 219 9 235 3 228 b 0 157 3 199 0 179 b 29 69 0 125 6 95 b 323 -194 115 -29 222 -111 b 374 -235 338 -206 353 -235 b 386 -232 377 -235 382 -233 z"
        }
    },
    fontFamily: "Petaluma",
    resolution: 1e3,
    generatedOn: "2022-12-18T09:07:50.817Z"
};
// node_modules/vexflow/build/esm/src/fonts/load_petaluma.js
var $a801f2c896bd09f1$var$petalumaChordMetrics = {
    csymDiminished: {
        leftSideBearing: -95,
        advanceWidth: 506,
        yOffset: 0
    },
    csymHalfDiminished: {
        leftSideBearing: -32,
        advanceWidth: 506,
        yOffset: 0
    },
    csymAugmented: {
        leftSideBearing: -25,
        advanceWidth: 530,
        yOffset: 0
    },
    csymParensLeftTall: {
        leftSideBearing: 0,
        advanceWidth: 155,
        yOffset: 150
    },
    csymParensRightTall: {
        leftSideBearing: 40,
        advanceWidth: 189,
        yOffset: 150
    },
    csymBracketLeftTall: {
        leftSideBearing: 0,
        advanceWidth: 328,
        yOffset: 0
    },
    csymBracketRightTall: {
        leftSideBearing: 1,
        advanceWidth: 600,
        yOffset: 0
    },
    csymParensLeftVeryTall: {
        leftSideBearing: 0,
        advanceWidth: 210,
        yOffset: 250
    },
    csymParensRightVeryTall: {
        leftSideBearing: -100,
        advanceWidth: 111,
        yOffset: 250
    },
    csymDiagonalArrangementSlash: {
        leftSideBearing: -1,
        advanceWidth: 990,
        yOffset: 0
    },
    csymMinor: {
        leftSideBearing: 0,
        advanceWidth: 482,
        yOffset: 0
    },
    csymMajorSeventh: {
        leftSideBearing: 100,
        yOffset: 0,
        advanceWidth: 600
    },
    accidentalSharp: {
        leftSideBearing: 0,
        advanceWidth: 425,
        yOffset: -422
    },
    accidentalFlat: {
        leftSideBearing: -10,
        advanceWidth: 228,
        yOffset: -284
    }
};
function $a801f2c896bd09f1$var$loadPetaluma() {
    const metrics = JSON.parse(JSON.stringify($a801f2c896bd09f1$var$CommonMetrics));
    const chordMetrics = metrics.chordSymbol;
    if (chordMetrics) chordMetrics.glyphs = $a801f2c896bd09f1$var$petalumaChordMetrics;
    $a801f2c896bd09f1$var$Font.load("Petaluma", $a801f2c896bd09f1$var$PetalumaFont, metrics);
}
// node_modules/vexflow/build/esm/src/fonts/load_all.js
function $a801f2c896bd09f1$var$loadAllMusicFonts() {
    $a801f2c896bd09f1$var$loadBravura();
    $a801f2c896bd09f1$var$loadGonville();
    $a801f2c896bd09f1$var$loadPetaluma();
    $a801f2c896bd09f1$var$loadCustom();
    $a801f2c896bd09f1$var$loadLeland();
}
// node_modules/vexflow/build/esm/src/fonts/petalumascript_glyphs.js
var $a801f2c896bd09f1$var$PetalumaScriptFont = {
    spacing: 50,
    glyphs: {
        " ": {
            x_min: 0,
            x_max: 250,
            y_min: 0,
            y_max: 500,
            ha: 500,
            leftSideBearing: 0,
            advanceWidth: 250
        },
        "0": {
            x_min: 33,
            x_max: 534,
            y_min: -13,
            y_max: 751,
            ha: 764,
            leftSideBearing: 33,
            advanceWidth: 570
        },
        "1": {
            x_min: 48,
            x_max: 235,
            y_min: -17,
            y_max: 734,
            ha: 751,
            leftSideBearing: 48,
            advanceWidth: 286
        },
        "2": {
            x_min: 56,
            x_max: 571,
            y_min: -19,
            y_max: 741,
            ha: 760,
            leftSideBearing: 56,
            advanceWidth: 626
        },
        "3": {
            x_min: 50,
            x_max: 528,
            y_min: -7,
            y_max: 731,
            ha: 738,
            leftSideBearing: 50,
            advanceWidth: 589
        },
        "4": {
            x_min: 38,
            x_max: 564,
            y_min: -13,
            y_max: 743,
            ha: 756,
            leftSideBearing: 38,
            advanceWidth: 614
        },
        "5": {
            x_min: 42,
            x_max: 601,
            y_min: -34,
            y_max: 743,
            ha: 777,
            leftSideBearing: 42,
            advanceWidth: 648
        },
        "6": {
            x_min: 47,
            x_max: 606,
            y_min: -16,
            y_max: 743,
            ha: 759,
            leftSideBearing: 47,
            advanceWidth: 667
        },
        "7": {
            x_min: 47,
            x_max: 567,
            y_min: 5,
            y_max: 739,
            ha: 734,
            leftSideBearing: 0,
            advanceWidth: 615
        },
        "8": {
            x_min: 40,
            x_max: 541,
            y_min: -15,
            y_max: 752,
            ha: 767,
            leftSideBearing: 40,
            advanceWidth: 585
        },
        "9": {
            x_min: 40,
            x_max: 537,
            y_min: -52,
            y_max: 736,
            ha: 788,
            leftSideBearing: 40,
            advanceWidth: 592
        },
        "!": {
            x_min: 49,
            x_max: 180,
            y_min: -7,
            y_max: 761,
            ha: 768,
            leftSideBearing: 49,
            advanceWidth: 230
        },
        '"': {
            x_min: 39,
            x_max: 304,
            y_min: 596,
            y_max: 804,
            ha: 208,
            leftSideBearing: 39,
            advanceWidth: 353
        },
        "#": {
            x_min: 33,
            x_max: 599,
            y_min: -8,
            y_max: 765,
            ha: 773,
            leftSideBearing: 33,
            advanceWidth: 648
        },
        $: {
            x_min: 53,
            x_max: 495,
            y_min: -111,
            y_max: 823,
            ha: 934,
            leftSideBearing: 53,
            advanceWidth: 560
        },
        "%": {
            x_min: 35,
            x_max: 656,
            y_min: -128,
            y_max: 808,
            ha: 936,
            leftSideBearing: 35,
            advanceWidth: 711
        },
        "&": {
            x_min: 53,
            x_max: 441,
            y_min: -3,
            y_max: 753,
            ha: 756,
            leftSideBearing: 53,
            advanceWidth: 500
        },
        "'": {
            x_min: 43,
            x_max: 161,
            y_min: 590,
            y_max: 811,
            ha: 221,
            leftSideBearing: 43,
            advanceWidth: 217
        },
        "(": {
            x_min: 41,
            x_max: 311,
            y_min: -36,
            y_max: 845,
            ha: 881,
            leftSideBearing: 41,
            advanceWidth: 308
        },
        ")": {
            x_min: -8,
            x_max: 257,
            y_min: -21,
            y_max: 852,
            ha: 873,
            leftSideBearing: -8,
            advanceWidth: 280
        },
        "*": {
            x_min: 59,
            x_max: 539,
            y_min: 175,
            y_max: 589,
            ha: 414,
            leftSideBearing: 59,
            advanceWidth: 601
        },
        "+": {
            x_min: 33,
            x_max: 361,
            y_min: 180,
            y_max: 587,
            ha: 407,
            leftSideBearing: 33,
            advanceWidth: 400
        },
        ",": {
            x_min: 15,
            x_max: 176,
            y_min: -129,
            y_max: 92,
            ha: 221,
            leftSideBearing: 15,
            advanceWidth: 205
        },
        "-": {
            x_min: 40,
            x_max: 380,
            y_min: 317,
            y_max: 452,
            ha: 135,
            leftSideBearing: 40,
            advanceWidth: 422
        },
        ".": {
            x_min: 48,
            x_max: 185,
            y_min: -56,
            y_max: 84,
            ha: 140,
            leftSideBearing: 48,
            advanceWidth: 227
        },
        "/": {
            x_min: -58,
            x_max: 654,
            y_min: -122,
            y_max: 844,
            ha: 966,
            leftSideBearing: -58,
            advanceWidth: 626
        },
        ":": {
            x_min: 65,
            x_max: 225,
            y_min: 97,
            y_max: 536,
            ha: 439,
            leftSideBearing: 65,
            advanceWidth: 302
        },
        ";": {
            x_min: 13,
            x_max: 295,
            y_min: -139,
            y_max: 536,
            ha: 675,
            leftSideBearing: 13,
            advanceWidth: 334
        },
        "<": {
            x_min: 28,
            x_max: 438,
            y_min: -1,
            y_max: 607,
            ha: 608,
            leftSideBearing: 28,
            advanceWidth: 475
        },
        "=": {
            x_min: 40,
            x_max: 383,
            y_min: 199.9598640852289,
            y_max: 541,
            ha: 341.0401359147711,
            leftSideBearing: 40,
            advanceWidth: 422
        },
        ">": {
            x_min: 35,
            x_max: 421,
            y_min: 28,
            y_max: 632,
            ha: 604,
            leftSideBearing: 35,
            advanceWidth: 466
        },
        "?": {
            x_min: 45,
            x_max: 548,
            y_min: -17,
            y_max: 767,
            ha: 784,
            leftSideBearing: 45,
            advanceWidth: 592
        },
        "@": {
            x_min: 51,
            x_max: 730,
            y_min: -78,
            y_max: 753,
            ha: 831,
            leftSideBearing: 51,
            advanceWidth: 781
        },
        A: {
            x_min: 37,
            x_max: 554,
            y_min: -4,
            y_max: 746,
            ha: 750,
            leftSideBearing: 37,
            advanceWidth: 617
        },
        B: {
            x_min: 37,
            x_max: 532,
            y_min: 3,
            y_max: 783,
            ha: 780,
            leftSideBearing: 37,
            advanceWidth: 579
        },
        C: {
            x_min: 37,
            x_max: 583,
            y_min: -3,
            y_max: 775,
            ha: 778,
            leftSideBearing: 37,
            advanceWidth: 623
        },
        D: {
            x_min: 50,
            x_max: 530,
            y_min: -15,
            y_max: 749,
            ha: 764,
            leftSideBearing: 50,
            advanceWidth: 579
        },
        E: {
            x_min: 45,
            x_max: 531,
            y_min: -1,
            y_max: 743,
            ha: 744,
            leftSideBearing: 45,
            advanceWidth: 585
        },
        F: {
            x_min: 45,
            x_max: 459,
            y_min: 23,
            y_max: 727,
            ha: 704,
            leftSideBearing: 45,
            advanceWidth: 510
        },
        G: {
            x_min: 31,
            x_max: 577,
            y_min: -8,
            y_max: 733,
            ha: 741,
            leftSideBearing: 31,
            advanceWidth: 611
        },
        H: {
            x_min: 37,
            x_max: 493,
            y_min: -22,
            y_max: 758,
            ha: 780,
            leftSideBearing: 37,
            advanceWidth: 535
        },
        I: {
            x_min: 47,
            x_max: 501,
            y_min: -3,
            y_max: 731,
            ha: 734,
            leftSideBearing: 47,
            advanceWidth: 541
        },
        J: {
            x_min: 33,
            x_max: 531,
            y_min: -23,
            y_max: 725,
            ha: 748,
            leftSideBearing: 33,
            advanceWidth: 573
        },
        K: {
            x_min: 43,
            x_max: 505,
            y_min: -10,
            y_max: 740,
            ha: 750,
            leftSideBearing: 43,
            advanceWidth: 560
        },
        L: {
            x_min: 49,
            x_max: 457,
            y_min: -2,
            y_max: 746,
            ha: 748,
            leftSideBearing: 49,
            advanceWidth: 510
        },
        M: {
            x_min: 35,
            x_max: 699,
            y_min: 1,
            y_max: 744,
            ha: 743,
            leftSideBearing: 35,
            advanceWidth: 743
        },
        N: {
            x_min: 34,
            x_max: 533,
            y_min: -17,
            y_max: 761,
            ha: 778,
            leftSideBearing: 34,
            advanceWidth: 579
        },
        O: {
            x_min: 41,
            x_max: 608,
            y_min: -5,
            y_max: 735,
            ha: 740,
            leftSideBearing: 41,
            advanceWidth: 667
        },
        P: {
            x_min: 53,
            x_max: 451,
            y_min: -18,
            y_max: 735,
            ha: 753,
            leftSideBearing: 53,
            advanceWidth: 497
        },
        Q: {
            x_min: 40,
            x_max: 599,
            y_min: -67,
            y_max: 744,
            ha: 811,
            leftSideBearing: 40,
            advanceWidth: 648
        },
        R: {
            x_min: 39,
            x_max: 487,
            y_min: 16,
            y_max: 735,
            ha: 719,
            leftSideBearing: 39,
            advanceWidth: 535
        },
        S: {
            x_min: 35,
            x_max: 552,
            y_min: -47,
            y_max: 708,
            ha: 755,
            leftSideBearing: 35,
            advanceWidth: 604
        },
        T: {
            x_min: 26,
            x_max: 656,
            y_min: -13,
            y_max: 718,
            ha: 731,
            leftSideBearing: 26,
            advanceWidth: 705
        },
        U: {
            x_min: 41,
            x_max: 518,
            y_min: -20,
            y_max: 748,
            ha: 768,
            leftSideBearing: 41,
            advanceWidth: 567
        },
        V: {
            x_min: 47,
            x_max: 509,
            y_min: -26,
            y_max: 744,
            ha: 770,
            leftSideBearing: 47,
            advanceWidth: 567
        },
        W: {
            x_min: 44,
            x_max: 789,
            y_min: -35,
            y_max: 720,
            ha: 755,
            leftSideBearing: 44,
            advanceWidth: 833
        },
        X: {
            x_min: 63,
            x_max: 635,
            y_min: -10,
            y_max: 745,
            ha: 755,
            leftSideBearing: 63,
            advanceWidth: 680
        },
        Y: {
            x_min: 43,
            x_max: 503,
            y_min: -21,
            y_max: 734,
            ha: 755,
            leftSideBearing: 43,
            advanceWidth: 541
        },
        Z: {
            x_min: 42,
            x_max: 584,
            y_min: -10,
            y_max: 739,
            ha: 749,
            leftSideBearing: 42,
            advanceWidth: 629
        },
        "[": {
            x_min: 46,
            x_max: 346,
            y_min: -150,
            y_max: 884,
            ha: 1034,
            leftSideBearing: 46,
            advanceWidth: 291
        },
        "\\": {
            x_min: 20,
            x_max: 616,
            y_min: -100,
            y_max: 797,
            ha: 897,
            leftSideBearing: 20,
            advanceWidth: 645
        },
        "]": {
            x_min: -76,
            x_max: 226,
            y_min: -150,
            y_max: 881,
            ha: 1031,
            leftSideBearing: -76,
            advanceWidth: 297
        },
        "^": {
            x_min: 43,
            x_max: 437,
            y_min: 517,
            y_max: 812,
            ha: 295,
            leftSideBearing: 43,
            advanceWidth: 478
        },
        _: {
            x_min: 29,
            x_max: 563,
            y_min: -110,
            y_max: -1,
            ha: 109,
            leftSideBearing: 29,
            advanceWidth: 598
        },
        "`": {
            x_min: 54,
            x_max: 321,
            y_min: 540,
            y_max: 747,
            ha: 207,
            leftSideBearing: 54,
            advanceWidth: 368
        },
        a: {
            x_min: 20,
            x_max: 447,
            y_min: -17,
            y_max: 495,
            ha: 512,
            leftSideBearing: 20,
            advanceWidth: 494
        },
        b: {
            x_min: 37,
            x_max: 466,
            y_min: -27,
            y_max: 770,
            ha: 797,
            leftSideBearing: 37,
            advanceWidth: 510
        },
        c: {
            x_min: 35,
            x_max: 456,
            y_min: -9,
            y_max: 507,
            ha: 516,
            leftSideBearing: 35,
            advanceWidth: 460
        },
        d: {
            x_min: 45,
            x_max: 520,
            y_min: -15,
            y_max: 764,
            ha: 779,
            leftSideBearing: 45,
            advanceWidth: 560
        },
        e: {
            x_min: 33,
            x_max: 370,
            y_min: -5,
            y_max: 501,
            ha: 506,
            leftSideBearing: 33,
            advanceWidth: 397
        },
        f: {
            x_min: 35,
            x_max: 411,
            y_min: -13,
            y_max: 695,
            ha: 708,
            leftSideBearing: 35,
            advanceWidth: 453
        },
        g: {
            x_min: 33,
            x_max: 551,
            y_min: -257,
            y_max: 505,
            ha: 762,
            leftSideBearing: 33,
            advanceWidth: 611
        },
        h: {
            x_min: 32,
            x_max: 458,
            y_min: -29,
            y_max: 743,
            ha: 772,
            leftSideBearing: 32,
            advanceWidth: 491
        },
        i: {
            x_min: 45,
            x_max: 167,
            y_min: -13,
            y_max: 631,
            ha: 644,
            leftSideBearing: 45,
            advanceWidth: 220
        },
        j: {
            x_min: -127,
            x_max: 261,
            y_min: -231,
            y_max: 601,
            ha: 832,
            leftSideBearing: -127,
            advanceWidth: 308
        },
        k: {
            x_min: 39,
            x_max: 443,
            y_min: -3,
            y_max: 700,
            ha: 703,
            leftSideBearing: 39,
            advanceWidth: 497
        },
        l: {
            x_min: 58,
            x_max: 168,
            y_min: -8,
            y_max: 686,
            ha: 694,
            leftSideBearing: 58,
            advanceWidth: 227
        },
        m: {
            x_min: 39,
            x_max: 688,
            y_min: -14,
            y_max: 501,
            ha: 515,
            leftSideBearing: 39,
            advanceWidth: 718
        },
        n: {
            x_min: 45,
            x_max: 491,
            y_min: -32,
            y_max: 512,
            ha: 544,
            leftSideBearing: 45,
            advanceWidth: 541
        },
        o: {
            x_min: 41,
            x_max: 424,
            y_min: -12,
            y_max: 493,
            ha: 505,
            leftSideBearing: 41,
            advanceWidth: 447
        },
        p: {
            x_min: 25,
            x_max: 529,
            y_min: -260,
            y_max: 500,
            ha: 760,
            leftSideBearing: 25,
            advanceWidth: 573
        },
        q: {
            x_min: 53,
            x_max: 603,
            y_min: -235,
            y_max: 514,
            ha: 749,
            leftSideBearing: 53,
            advanceWidth: 623
        },
        r: {
            x_min: 32,
            x_max: 407,
            y_min: -7,
            y_max: 492,
            ha: 499,
            leftSideBearing: 32,
            advanceWidth: 460
        },
        s: {
            x_min: 49,
            x_max: 416,
            y_min: -12,
            y_max: 519,
            ha: 531,
            leftSideBearing: 49,
            advanceWidth: 460
        },
        t: {
            x_min: 32,
            x_max: 442,
            y_min: -5,
            y_max: 684,
            ha: 689,
            leftSideBearing: 32,
            advanceWidth: 469
        },
        u: {
            x_min: 41,
            x_max: 487,
            y_min: -5,
            y_max: 507,
            ha: 512,
            leftSideBearing: 41,
            advanceWidth: 510
        },
        v: {
            x_min: 16,
            x_max: 441,
            y_min: -20,
            y_max: 542,
            ha: 562,
            leftSideBearing: 16,
            advanceWidth: 456
        },
        w: {
            x_min: 39,
            x_max: 639,
            y_min: -22,
            y_max: 505,
            ha: 527,
            leftSideBearing: 39,
            advanceWidth: 661
        },
        x: {
            x_min: 15,
            x_max: 505,
            y_min: -39,
            y_max: 539,
            ha: 578,
            leftSideBearing: 15,
            advanceWidth: 541
        },
        y: {
            x_min: -98,
            x_max: 501,
            y_min: -242,
            y_max: 511,
            ha: 753,
            leftSideBearing: -98,
            advanceWidth: 548
        },
        z: {
            x_min: 27,
            x_max: 479,
            y_min: -3,
            y_max: 494,
            ha: 497,
            leftSideBearing: 27,
            advanceWidth: 494
        },
        "{": {
            x_min: 0,
            x_max: 0,
            y_min: 0,
            y_max: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 308
        },
        "|": {
            x_min: 0,
            x_max: 0,
            y_min: 0,
            y_max: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 308
        },
        "}": {
            x_min: 0,
            x_max: 0,
            y_min: 0,
            y_max: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 308
        },
        "~": {
            x_min: 0,
            x_max: 0,
            y_min: 0,
            y_max: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 308
        }
    },
    fontFamily: "PetalumaScript",
    resolution: 1e3,
    generatedOn: "2020-06-14T18:33:25.407Z"
};
// node_modules/vexflow/build/esm/src/fonts/robotoslab_glyphs.js
var $a801f2c896bd09f1$var$RobotoSlabFont = {
    spacing: 50,
    glyphs: {
        " ": {
            x_min: 0,
            x_max: 509,
            y_min: 0,
            y_max: 2e3,
            ha: 2e3,
            leftSideBearing: 0,
            advanceWidth: 509
        },
        "0": {
            x_min: 121,
            x_max: 1048,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 121,
            advanceWidth: 1168
        },
        "1": {
            x_min: 117,
            x_max: 767,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 117,
            advanceWidth: 844
        },
        "2": {
            x_min: 75.8474576645637,
            x_max: 1040,
            y_min: 0,
            y_max: 1477,
            ha: 1477,
            leftSideBearing: 75,
            advanceWidth: 1131
        },
        "3": {
            x_min: 74.85365853658536,
            x_max: 994,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 74,
            advanceWidth: 1106
        },
        "4": {
            x_min: 63,
            x_max: 1114,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 63,
            advanceWidth: 1187
        },
        "5": {
            x_min: 96.8448275474953,
            x_max: 982,
            y_min: -21,
            y_max: 1456,
            ha: 1477,
            leftSideBearing: 96,
            advanceWidth: 1081
        },
        "6": {
            x_min: 121,
            x_max: 1067,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 121,
            advanceWidth: 1144
        },
        "7": {
            x_min: 76,
            x_max: 1060,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: -30,
            advanceWidth: 1128
        },
        "8": {
            x_min: 92,
            x_max: 1039,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 92,
            advanceWidth: 1131
        },
        "9": {
            x_min: 84,
            x_max: 1026,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 84,
            advanceWidth: 1154
        },
        "!": {
            x_min: 143,
            x_max: 340,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 143,
            advanceWidth: 483
        },
        '"': {
            x_min: 166,
            x_max: 634,
            y_min: 1055,
            y_max: 1560,
            ha: 505,
            leftSideBearing: 166,
            advanceWidth: 770
        },
        "#": {
            x_min: 63,
            x_max: 1179,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 63,
            advanceWidth: 1246
        },
        $: {
            x_min: 81.92156915727656,
            x_max: 1012,
            y_min: -208,
            y_max: 1693,
            ha: 1901,
            leftSideBearing: 81,
            advanceWidth: 1110
        },
        "%": {
            x_min: 77,
            x_max: 1384,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 77,
            advanceWidth: 1460
        },
        "&": {
            x_min: 74,
            x_max: 1242,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 74,
            advanceWidth: 1289
        },
        "'": {
            x_min: 166,
            x_max: 324,
            y_min: 1055,
            y_max: 1560,
            ha: 505,
            leftSideBearing: 166,
            advanceWidth: 460
        },
        "(": {
            x_min: 114,
            x_max: 650,
            y_min: -463,
            y_max: 1636,
            ha: 2099,
            leftSideBearing: 114,
            advanceWidth: 662
        },
        ")": {
            x_min: 11,
            x_max: 547,
            y_min: -463,
            y_max: 1636,
            ha: 2099,
            leftSideBearing: 11,
            advanceWidth: 654
        },
        "*": {
            x_min: 66,
            x_max: 893,
            y_min: 607,
            y_max: 1456,
            ha: 849,
            leftSideBearing: 66,
            advanceWidth: 958
        },
        "+": {
            x_min: 73,
            x_max: 1071,
            y_min: 146,
            y_max: 1206,
            ha: 1060,
            leftSideBearing: 73,
            advanceWidth: 1145
        },
        ",": {
            x_min: 23,
            x_max: 315,
            y_min: -311,
            y_max: 221,
            ha: 532,
            leftSideBearing: 23,
            advanceWidth: 404
        },
        "-": {
            x_min: 154,
            x_max: 643,
            y_min: 538,
            y_max: 692,
            ha: 154,
            leftSideBearing: 154,
            advanceWidth: 797
        },
        ".": {
            x_min: 145,
            x_max: 342,
            y_min: 0,
            y_max: 202,
            ha: 202,
            leftSideBearing: 145,
            advanceWidth: 493
        },
        "/": {
            x_min: 0,
            x_max: 774,
            y_min: -125,
            y_max: 1456,
            ha: 1581,
            leftSideBearing: 0,
            advanceWidth: 824
        },
        ":": {
            x_min: 145,
            x_max: 342,
            y_min: 0,
            y_max: 1082,
            ha: 1082,
            leftSideBearing: 145,
            advanceWidth: 419
        },
        ";": {
            x_min: 53,
            x_max: 345,
            y_min: -311,
            y_max: 1082,
            ha: 1393,
            leftSideBearing: 53,
            advanceWidth: 424
        },
        "<": {
            x_min: 76,
            x_max: 892,
            y_min: 107,
            y_max: 1013,
            ha: 906,
            leftSideBearing: 76,
            advanceWidth: 1017
        },
        "=": {
            x_min: 147,
            x_max: 981,
            y_min: 407,
            y_max: 987,
            ha: 580,
            leftSideBearing: 147,
            advanceWidth: 1127
        },
        ">": {
            x_min: 125,
            x_max: 980,
            y_min: 87,
            y_max: 993,
            ha: 906,
            leftSideBearing: 125,
            advanceWidth: 1060
        },
        "?": {
            x_min: 65.92660602419838,
            x_max: 890,
            y_min: 0,
            y_max: 1477,
            ha: 1477,
            leftSideBearing: 65,
            advanceWidth: 953
        },
        "@": {
            x_min: 84.3592218305664,
            x_max: 1705.2346925277395,
            y_min: -453,
            y_max: 1431,
            ha: 1884,
            leftSideBearing: 84,
            advanceWidth: 1821
        },
        A: {
            x_min: 70,
            x_max: 1463,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 70,
            advanceWidth: 1533
        },
        B: {
            x_min: 81,
            x_max: 1253,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1322
        },
        C: {
            x_min: 80,
            x_max: 1174,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 80,
            advanceWidth: 1290
        },
        D: {
            x_min: 81,
            x_max: 1291,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1356
        },
        E: {
            x_min: 81,
            x_max: 1190,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1306
        },
        F: {
            x_min: 81,
            x_max: 1176,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1256
        },
        G: {
            x_min: 80,
            x_max: 1226,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 80,
            advanceWidth: 1346
        },
        H: {
            x_min: 81,
            x_max: 1497,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1578
        },
        I: {
            x_min: 81,
            x_max: 604,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 685
        },
        J: {
            x_min: 60,
            x_max: 1100,
            y_min: -21,
            y_max: 1456,
            ha: 1477,
            leftSideBearing: 60,
            advanceWidth: 1169
        },
        K: {
            x_min: 81,
            x_max: 1427,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1501
        },
        L: {
            x_min: 81,
            x_max: 1130,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1210
        },
        M: {
            x_min: 94,
            x_max: 1888,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 94,
            advanceWidth: 1982
        },
        N: {
            x_min: 83,
            x_max: 1509,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 83,
            advanceWidth: 1592
        },
        O: {
            x_min: 70,
            x_max: 1281,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 70,
            advanceWidth: 1351
        },
        P: {
            x_min: 81,
            x_max: 1242,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 81,
            advanceWidth: 1297
        },
        Q: {
            x_min: 70,
            x_max: 1348,
            y_min: -245,
            y_max: 1477,
            ha: 1722,
            leftSideBearing: 70,
            advanceWidth: 1376
        },
        R: {
            x_min: 81,
            x_max: 1285,
            y_min: 0,
            y_max: 1455,
            ha: 1455,
            leftSideBearing: 81,
            advanceWidth: 1385
        },
        S: {
            x_min: 115,
            x_max: 1116,
            y_min: -21,
            y_max: 1477,
            ha: 1498,
            leftSideBearing: 115,
            advanceWidth: 1206
        },
        T: {
            x_min: 96,
            x_max: 1306,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 96,
            advanceWidth: 1406
        },
        U: {
            x_min: 70,
            x_max: 1452,
            y_min: -21,
            y_max: 1456,
            ha: 1477,
            leftSideBearing: 70,
            advanceWidth: 1522
        },
        V: {
            x_min: 65,
            x_max: 1443,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 65,
            advanceWidth: 1508
        },
        W: {
            x_min: 72,
            x_max: 2057,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 72,
            advanceWidth: 2129
        },
        X: {
            x_min: 80,
            x_max: 1449,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 80,
            advanceWidth: 1529
        },
        Y: {
            x_min: 65,
            x_max: 1396,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 65,
            advanceWidth: 1461
        },
        Z: {
            x_min: 90,
            x_max: 1107,
            y_min: 0,
            y_max: 1456,
            ha: 1456,
            leftSideBearing: 90,
            advanceWidth: 1197
        },
        "[": {
            x_min: 157,
            x_max: 541,
            y_min: -312,
            y_max: 1664,
            ha: 1976,
            leftSideBearing: 157,
            advanceWidth: 573
        },
        "\\": {
            x_min: 36,
            x_max: 830,
            y_min: -125,
            y_max: 1456,
            ha: 1581,
            leftSideBearing: 36,
            advanceWidth: 841
        },
        "]": {
            x_min: 23,
            x_max: 408,
            y_min: -312,
            y_max: 1664,
            ha: 1976,
            leftSideBearing: 23,
            advanceWidth: 552
        },
        "^": {
            x_min: 71,
            x_max: 802,
            y_min: 729,
            y_max: 1456,
            ha: 727,
            leftSideBearing: 71,
            advanceWidth: 864
        },
        _: {
            x_min: 119,
            x_max: 1041,
            y_min: -154,
            y_max: 0,
            ha: 154,
            leftSideBearing: 119,
            advanceWidth: 1168
        },
        "`": {
            x_min: 40,
            x_max: 456,
            y_min: 1288,
            y_max: 1560,
            ha: 272,
            leftSideBearing: 40,
            advanceWidth: 496
        },
        a: {
            x_min: 79,
            x_max: 1053,
            y_min: -21,
            y_max: 1102,
            ha: 1123,
            leftSideBearing: 79,
            advanceWidth: 1132
        },
        b: {
            x_min: -16,
            x_max: 1071,
            y_min: -21,
            y_max: 1560,
            ha: 1581,
            leftSideBearing: -16,
            advanceWidth: 1145
        },
        c: {
            x_min: 78,
            x_max: 988,
            y_min: -21,
            y_max: 1102,
            ha: 1123,
            leftSideBearing: 78,
            advanceWidth: 1067
        },
        d: {
            x_min: 78,
            x_max: 1156,
            y_min: -21,
            y_max: 1560,
            ha: 1581,
            leftSideBearing: 78,
            advanceWidth: 1218
        },
        e: {
            x_min: 74,
            x_max: 980,
            y_min: -21,
            y_max: 1102,
            ha: 1123,
            leftSideBearing: 74,
            advanceWidth: 1059
        },
        f: {
            x_min: 64,
            x_max: 731,
            y_min: 0,
            y_max: 1581,
            ha: 1581,
            leftSideBearing: 64,
            advanceWidth: 725
        },
        g: {
            x_min: 78,
            x_max: 1133,
            y_min: -437,
            y_max: 1102,
            ha: 1539,
            leftSideBearing: 78,
            advanceWidth: 1157
        },
        h: {
            x_min: 49,
            x_max: 1255,
            y_min: 0,
            y_max: 1560,
            ha: 1560,
            leftSideBearing: 49,
            advanceWidth: 1315
        },
        i: {
            x_min: 67,
            x_max: 590,
            y_min: 0,
            y_max: 1560,
            ha: 1560,
            leftSideBearing: 67,
            advanceWidth: 652
        },
        j: {
            x_min: -56,
            x_max: 381,
            y_min: -437,
            y_max: 1560,
            ha: 1997,
            leftSideBearing: -56,
            advanceWidth: 525
        },
        k: {
            x_min: 64,
            x_max: 1248,
            y_min: 0,
            y_max: 1560,
            ha: 1560,
            leftSideBearing: 64,
            advanceWidth: 1287
        },
        l: {
            x_min: 64,
            x_max: 587,
            y_min: 0,
            y_max: 1560,
            ha: 1560,
            leftSideBearing: 64,
            advanceWidth: 653
        },
        m: {
            x_min: 74,
            x_max: 1905,
            y_min: 0,
            y_max: 1102,
            ha: 1102,
            leftSideBearing: 74,
            advanceWidth: 1977
        },
        n: {
            x_min: 74,
            x_max: 1278,
            y_min: 0,
            y_max: 1102,
            ha: 1102,
            leftSideBearing: 74,
            advanceWidth: 1343
        },
        o: {
            x_min: 78,
            x_max: 1046,
            y_min: -21,
            y_max: 1102,
            ha: 1123,
            leftSideBearing: 78,
            advanceWidth: 1124
        },
        p: {
            x_min: 34,
            x_max: 1119,
            y_min: -416,
            y_max: 1102,
            ha: 1518,
            leftSideBearing: 34,
            advanceWidth: 1197
        },
        q: {
            x_min: 78,
            x_max: 1135,
            y_min: -416,
            y_max: 1102,
            ha: 1518,
            leftSideBearing: 78,
            advanceWidth: 1139
        },
        r: {
            x_min: 72,
            x_max: 808,
            y_min: 0,
            y_max: 1102,
            ha: 1102,
            leftSideBearing: 72,
            advanceWidth: 854
        },
        s: {
            x_min: 104,
            x_max: 933,
            y_min: -21,
            y_max: 1102,
            ha: 1123,
            leftSideBearing: 104,
            advanceWidth: 1022
        },
        t: {
            x_min: 24,
            x_max: 678,
            y_min: -17,
            y_max: 1343,
            ha: 1360,
            leftSideBearing: 24,
            advanceWidth: 730
        },
        u: {
            x_min: 52,
            x_max: 1181,
            y_min: -21,
            y_max: 1082,
            ha: 1103,
            leftSideBearing: 52,
            advanceWidth: 1245
        },
        v: {
            x_min: 26,
            x_max: 1176,
            y_min: 0,
            y_max: 1082,
            ha: 1082,
            leftSideBearing: 26,
            advanceWidth: 1206
        },
        w: {
            x_min: 52,
            x_max: 1777,
            y_min: 0,
            y_max: 1082,
            ha: 1082,
            leftSideBearing: 52,
            advanceWidth: 1823
        },
        x: {
            x_min: 42,
            x_max: 1163,
            y_min: 0,
            y_max: 1082,
            ha: 1082,
            leftSideBearing: 42,
            advanceWidth: 1203
        },
        y: {
            x_min: 24,
            x_max: 1172,
            y_min: -437,
            y_max: 1082,
            ha: 1519,
            leftSideBearing: 24,
            advanceWidth: 1192
        },
        z: {
            x_min: 88,
            x_max: 960,
            y_min: 0,
            y_max: 1082,
            ha: 1082,
            leftSideBearing: 88,
            advanceWidth: 1032
        },
        "{": {
            x_min: 63,
            x_max: 671,
            y_min: -364,
            y_max: 1597,
            ha: 1961,
            leftSideBearing: 63,
            advanceWidth: 701
        },
        "|": {
            x_min: 150,
            x_max: 307,
            y_min: -270,
            y_max: 1456,
            ha: 1726,
            leftSideBearing: 150,
            advanceWidth: 451
        },
        "}": {
            x_min: 27,
            x_max: 635,
            y_min: -364,
            y_max: 1597,
            ha: 1961,
            leftSideBearing: 27,
            advanceWidth: 701
        },
        "~": {
            x_min: 121,
            x_max: 1257,
            y_min: 401,
            y_max: 803,
            ha: 402,
            leftSideBearing: 121,
            advanceWidth: 1386
        }
    },
    fontFamily: "Roboto Slab",
    resolution: 2048,
    generatedOn: "2020-06-15T19:12:58.120Z"
};
// node_modules/vexflow/build/esm/src/fonts/sans_bold_text_metrics.js
var $a801f2c896bd09f1$var$SansFontBold = {
    glyphs: {
        "0": {
            x_min: 86,
            x_max: 1038,
            y_min: -25,
            y_max: 1472,
            ha: 1497,
            leftSideBearing: 86,
            advanceWidth: 1139
        },
        "1": {
            x_min: 162,
            x_max: 806,
            y_min: 0,
            y_max: 1472,
            ha: 1472,
            leftSideBearing: 162,
            advanceWidth: 1139
        },
        "2": {
            x_min: 51,
            x_max: 1036,
            y_min: 0,
            y_max: 1472,
            ha: 1472,
            leftSideBearing: 51,
            advanceWidth: 1139
        },
        "3": {
            x_min: 77,
            x_max: 1051,
            y_min: -25,
            y_max: 1472,
            ha: 1497,
            leftSideBearing: 77,
            advanceWidth: 1139
        },
        "4": {
            x_min: 38,
            x_max: 1092,
            y_min: 0,
            y_max: 1472,
            ha: 1472,
            leftSideBearing: 38,
            advanceWidth: 1139
        },
        "5": {
            x_min: 91,
            x_max: 1077,
            y_min: -25,
            y_max: 1446,
            ha: 1471,
            leftSideBearing: 91,
            advanceWidth: 1139
        },
        "6": {
            x_min: 87,
            x_max: 1066,
            y_min: -25,
            y_max: 1472,
            ha: 1497,
            leftSideBearing: 87,
            advanceWidth: 1139
        },
        "7": {
            x_min: 87,
            x_max: 1048,
            y_min: 0,
            y_max: 1446,
            ha: 1446,
            leftSideBearing: 87,
            advanceWidth: 1139
        },
        "8": {
            x_min: 83,
            x_max: 1047,
            y_min: -26,
            y_max: 1472,
            ha: 1498,
            leftSideBearing: 83,
            advanceWidth: 1139
        },
        "9": {
            x_min: 65,
            x_max: 1044,
            y_min: -26,
            y_max: 1472,
            ha: 1498,
            leftSideBearing: 65,
            advanceWidth: 1139
        },
        " ": {
            x_min: 0,
            x_max: 0,
            y_min: 0,
            y_max: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 569
        },
        "!": {
            x_min: 184,
            x_max: 488,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 184,
            advanceWidth: 682
        },
        '"': {
            x_min: 112,
            x_max: 869,
            y_min: 945,
            y_max: 1466,
            ha: 521,
            leftSideBearing: 112,
            advanceWidth: 971
        },
        "#": {
            x_min: 18,
            x_max: 1115,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 18,
            advanceWidth: 1139
        },
        $: {
            x_min: 70,
            x_max: 1048,
            y_min: -205,
            y_max: 1584,
            ha: 1789,
            leftSideBearing: 70,
            advanceWidth: 1139
        },
        "%": {
            x_min: 89,
            x_max: 1725,
            y_min: -59,
            y_max: 1491,
            ha: 1550,
            leftSideBearing: 89,
            advanceWidth: 1821
        },
        "&": {
            x_min: 90,
            x_max: 1446,
            y_min: -38,
            y_max: 1491,
            ha: 1529,
            leftSideBearing: 90,
            advanceWidth: 1479
        },
        "'": {
            x_min: 92,
            x_max: 398,
            y_min: 945,
            y_max: 1466,
            ha: 521,
            leftSideBearing: 92,
            advanceWidth: 487
        },
        "(": {
            x_min: 107,
            x_max: 616,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 107,
            advanceWidth: 682
        },
        ")": {
            x_min: 67,
            x_max: 576,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 67,
            advanceWidth: 682
        },
        "*": {
            x_min: 28,
            x_max: 753,
            y_min: 792,
            y_max: 1491,
            ha: 699,
            leftSideBearing: 28,
            advanceWidth: 797
        },
        "+": {
            x_min: 85,
            x_max: 1110,
            y_min: 211,
            y_max: 1236,
            ha: 1025,
            leftSideBearing: 85,
            advanceWidth: 1196
        },
        ",": {
            x_min: 117,
            x_max: 421,
            y_min: -327,
            y_max: 281,
            ha: 608,
            leftSideBearing: 117,
            advanceWidth: 569
        },
        "-": {
            x_min: 115,
            x_max: 667,
            y_min: 391,
            y_max: 672,
            ha: 281,
            leftSideBearing: 115,
            advanceWidth: 682
        },
        ".": {
            x_min: 147,
            x_max: 428,
            y_min: 0,
            y_max: 281,
            ha: 281,
            leftSideBearing: 147,
            advanceWidth: 569
        },
        "/": {
            x_min: -3,
            x_max: 571,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: -3,
            advanceWidth: 569
        },
        ":": {
            x_min: 201,
            x_max: 482,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 201,
            advanceWidth: 682
        },
        ";": {
            x_min: 170,
            x_max: 474,
            y_min: -327,
            y_max: 1062,
            ha: 1389,
            leftSideBearing: 170,
            advanceWidth: 682
        },
        "<": {
            x_min: 95,
            x_max: 1100,
            y_min: 167,
            y_max: 1281,
            ha: 1114,
            leftSideBearing: 95,
            advanceWidth: 1196
        },
        "=": {
            x_min: 85,
            x_max: 1110,
            y_min: 372,
            y_max: 1074,
            ha: 702,
            leftSideBearing: 85,
            advanceWidth: 1196
        },
        ">": {
            x_min: 95,
            x_max: 1101,
            y_min: 166,
            y_max: 1279,
            ha: 1113,
            leftSideBearing: 95,
            advanceWidth: 1196
        },
        "?": {
            x_min: 106,
            x_max: 1158,
            y_min: 0,
            y_max: 1481,
            ha: 1481,
            leftSideBearing: 106,
            advanceWidth: 1251
        },
        "@": {
            x_min: 61,
            x_max: 1990,
            y_min: -431,
            y_max: 1492,
            ha: 1923,
            leftSideBearing: 61,
            advanceWidth: 1997
        },
        A: {
            x_min: 0,
            x_max: 1471,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 0,
            advanceWidth: 1479
        },
        B: {
            x_min: 150,
            x_max: 1378,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1479
        },
        C: {
            x_min: 97,
            x_max: 1374,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 97,
            advanceWidth: 1479
        },
        D: {
            x_min: 148,
            x_max: 1377,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 148,
            advanceWidth: 1479
        },
        E: {
            x_min: 149,
            x_max: 1264,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 149,
            advanceWidth: 1366
        },
        F: {
            x_min: 151,
            x_max: 1156,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 151,
            advanceWidth: 1251
        },
        G: {
            x_min: 98,
            x_max: 1469,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 98,
            advanceWidth: 1593
        },
        H: {
            x_min: 150,
            x_max: 1322,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1479
        },
        I: {
            x_min: 140,
            x_max: 436,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 140,
            advanceWidth: 569
        },
        J: {
            x_min: 35,
            x_max: 973,
            y_min: -25,
            y_max: 1466,
            ha: 1491,
            leftSideBearing: 35,
            advanceWidth: 1139
        },
        K: {
            x_min: 153,
            x_max: 1475,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 153,
            advanceWidth: 1479
        },
        L: {
            x_min: 157,
            x_max: 1189,
            y_min: 0,
            y_max: 1454,
            ha: 1454,
            leftSideBearing: 157,
            advanceWidth: 1251
        },
        M: {
            x_min: 145,
            x_max: 1561,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 145,
            advanceWidth: 1706
        },
        N: {
            x_min: 152,
            x_max: 1315,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 152,
            advanceWidth: 1479
        },
        O: {
            x_min: 89,
            x_max: 1511,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 89,
            advanceWidth: 1593
        },
        P: {
            x_min: 149,
            x_max: 1272,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 149,
            advanceWidth: 1366
        },
        Q: {
            x_min: 89,
            x_max: 1566,
            y_min: -147,
            y_max: 1491,
            ha: 1638,
            leftSideBearing: 89,
            advanceWidth: 1593
        },
        R: {
            x_min: 150,
            x_max: 1468,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1479
        },
        S: {
            x_min: 74,
            x_max: 1266,
            y_min: -26,
            y_max: 1491,
            ha: 1517,
            leftSideBearing: 74,
            advanceWidth: 1366
        },
        T: {
            x_min: 44,
            x_max: 1209,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 44,
            advanceWidth: 1251
        },
        U: {
            x_min: 147,
            x_max: 1316,
            y_min: -25,
            y_max: 1466,
            ha: 1491,
            leftSideBearing: 147,
            advanceWidth: 1479
        },
        V: {
            x_min: -1,
            x_max: 1364,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: -1,
            advanceWidth: 1366
        },
        W: {
            x_min: 7,
            x_max: 1931,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 7,
            advanceWidth: 1933
        },
        X: {
            x_min: 0,
            x_max: 1363,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 0,
            advanceWidth: 1366
        },
        Y: {
            x_min: -3,
            x_max: 1368,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: -3,
            advanceWidth: 1366
        },
        Z: {
            x_min: 22,
            x_max: 1213,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 22,
            advanceWidth: 1251
        },
        "[": {
            x_min: 146,
            x_max: 644,
            y_min: -413,
            y_max: 1466,
            ha: 1879,
            leftSideBearing: 146,
            advanceWidth: 682
        },
        "\\": {
            x_min: -3,
            x_max: 571,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: -3,
            advanceWidth: 569
        },
        "]": {
            x_min: 38,
            x_max: 536,
            y_min: -413,
            y_max: 1466,
            ha: 1879,
            leftSideBearing: 38,
            advanceWidth: 682
        },
        "^": {
            x_min: 115,
            x_max: 1080,
            y_min: 692,
            y_max: 1491,
            ha: 799,
            leftSideBearing: 115,
            advanceWidth: 1196
        },
        _: {
            x_min: -19,
            x_max: 1149,
            y_min: -405,
            y_max: -223,
            ha: 182,
            leftSideBearing: -19,
            advanceWidth: 1139
        },
        "`": {
            x_min: 42,
            x_max: 495,
            y_min: 1192,
            y_max: 1491,
            ha: 299,
            leftSideBearing: 42,
            advanceWidth: 682
        },
        a: {
            x_min: 73,
            x_max: 1070,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 73,
            advanceWidth: 1139
        },
        b: {
            x_min: 135,
            x_max: 1172,
            y_min: -24,
            y_max: 1466,
            ha: 1490,
            leftSideBearing: 135,
            advanceWidth: 1251
        },
        c: {
            x_min: 85,
            x_max: 1087,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 85,
            advanceWidth: 1139
        },
        d: {
            x_min: 84,
            x_max: 1121,
            y_min: -24,
            y_max: 1466,
            ha: 1490,
            leftSideBearing: 84,
            advanceWidth: 1251
        },
        e: {
            x_min: 65,
            x_max: 1057.2517482517483,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 65,
            advanceWidth: 1139
        },
        f: {
            x_min: 24,
            x_max: 742,
            y_min: 0,
            y_max: 1491,
            ha: 1491,
            leftSideBearing: 24,
            advanceWidth: 682
        },
        g: {
            x_min: 84,
            x_max: 1120,
            y_min: -431,
            y_max: 1086,
            ha: 1517,
            leftSideBearing: 84,
            advanceWidth: 1251
        },
        h: {
            x_min: 146,
            x_max: 1113,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 146,
            advanceWidth: 1251
        },
        i: {
            x_min: 147,
            x_max: 428,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 147,
            advanceWidth: 569
        },
        j: {
            x_min: -94,
            x_max: 422,
            y_min: -431,
            y_max: 1466,
            ha: 1897,
            leftSideBearing: -94,
            advanceWidth: 569
        },
        k: {
            x_min: 137,
            x_max: 1119,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 137,
            advanceWidth: 1139
        },
        l: {
            x_min: 147,
            x_max: 428,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 147,
            advanceWidth: 569
        },
        m: {
            x_min: 126,
            x_max: 1688,
            y_min: 0,
            y_max: 1086,
            ha: 1086,
            leftSideBearing: 126,
            advanceWidth: 1821
        },
        n: {
            x_min: 145,
            x_max: 1113,
            y_min: 0,
            y_max: 1086,
            ha: 1086,
            leftSideBearing: 145,
            advanceWidth: 1251
        },
        o: {
            x_min: 82,
            x_max: 1178,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 82,
            advanceWidth: 1251
        },
        p: {
            x_min: 139,
            x_max: 1175,
            y_min: -404,
            y_max: 1086,
            ha: 1490,
            leftSideBearing: 139,
            advanceWidth: 1251
        },
        q: {
            x_min: 91,
            x_max: 1122,
            y_min: -404,
            y_max: 1086,
            ha: 1490,
            leftSideBearing: 91,
            advanceWidth: 1251
        },
        r: {
            x_min: 135,
            x_max: 823,
            y_min: 0,
            y_max: 1086,
            ha: 1086,
            leftSideBearing: 135,
            advanceWidth: 797
        },
        s: {
            x_min: 48,
            x_max: 1040,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 48,
            advanceWidth: 1139
        },
        t: {
            x_min: 31,
            x_max: 657,
            y_min: -24,
            y_max: 1437,
            ha: 1461,
            leftSideBearing: 31,
            advanceWidth: 682
        },
        u: {
            x_min: 141,
            x_max: 1107,
            y_min: -24,
            y_max: 1062,
            ha: 1086,
            leftSideBearing: 141,
            advanceWidth: 1251
        },
        v: {
            x_min: 11,
            x_max: 1114,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 11,
            advanceWidth: 1139
        },
        w: {
            x_min: 9,
            x_max: 1592,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 9,
            advanceWidth: 1593
        },
        x: {
            x_min: 12,
            x_max: 1120,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 12,
            advanceWidth: 1139
        },
        y: {
            x_min: 14,
            x_max: 1106,
            y_min: -431,
            y_max: 1062,
            ha: 1493,
            leftSideBearing: 14,
            advanceWidth: 1139
        },
        z: {
            x_min: 34,
            x_max: 982,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 34,
            advanceWidth: 1024
        },
        "{": {
            x_min: 60,
            x_max: 744,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 60,
            advanceWidth: 797
        },
        "|": {
            x_min: 176,
            x_max: 399,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 176,
            advanceWidth: 573
        },
        "}": {
            x_min: 45,
            x_max: 729,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 45,
            advanceWidth: 797
        },
        "~": {
            x_min: 67,
            x_max: 1129,
            y_min: 519,
            y_max: 924,
            ha: 405,
            leftSideBearing: 67,
            advanceWidth: 1196
        }
    },
    fontFamily: "Arial",
    resolution: 2048,
    generatedOn: "2022-11-04T20:05:21.000Z"
};
// node_modules/vexflow/build/esm/src/fonts/sans_text_metrics.js
var $a801f2c896bd09f1$var$SansFont = {
    smufl: false,
    name: "SANS",
    spacing: 50,
    Description: "Built-in sans-serif font",
    bold: true,
    italic: true,
    monospaced: false,
    serifs: false,
    glyphs: {
        "0": {
            x_min: 85,
            x_max: 1041,
            y_min: -25,
            y_max: 1472,
            ha: 1497,
            leftSideBearing: 85,
            advanceWidth: 1139
        },
        "1": {
            x_min: 223,
            x_max: 763,
            y_min: 0,
            y_max: 1472,
            ha: 1472,
            leftSideBearing: 223,
            advanceWidth: 1139
        },
        "2": {
            x_min: 61.840001123045234,
            x_max: 1031,
            y_min: 0,
            y_max: 1472,
            ha: 1472,
            leftSideBearing: 61,
            advanceWidth: 1139
        },
        "3": {
            x_min: 86,
            x_max: 1046,
            y_min: -26,
            y_max: 1472,
            ha: 1498,
            leftSideBearing: 86,
            advanceWidth: 1139
        },
        "4": {
            x_min: 26,
            x_max: 1040,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 26,
            advanceWidth: 1139
        },
        "5": {
            x_min: 85,
            x_max: 1057,
            y_min: -25,
            y_max: 1446,
            ha: 1471,
            leftSideBearing: 85,
            advanceWidth: 1139
        },
        "6": {
            x_min: 77,
            x_max: 1045,
            y_min: -25,
            y_max: 1472,
            ha: 1497,
            leftSideBearing: 77,
            advanceWidth: 1139
        },
        "7": {
            x_min: 97,
            x_max: 1046,
            y_min: 0,
            y_max: 1447,
            ha: 1447,
            leftSideBearing: 97,
            advanceWidth: 1139
        },
        "8": {
            x_min: 83,
            x_max: 1049,
            y_min: -25,
            y_max: 1472,
            ha: 1497,
            leftSideBearing: 83,
            advanceWidth: 1139
        },
        "9": {
            x_min: 85,
            x_max: 1049,
            y_min: -25,
            y_max: 1472,
            ha: 1497,
            leftSideBearing: 85,
            advanceWidth: 1139
        },
        " ": {
            x_min: 0,
            x_max: 0,
            y_min: 0,
            y_max: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 569
        },
        "!": {
            x_min: 176,
            x_max: 399,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 176,
            advanceWidth: 569
        },
        '"': {
            x_min: 94,
            x_max: 631,
            y_min: 947,
            y_max: 1466,
            ha: 519,
            leftSideBearing: 94,
            advanceWidth: 727
        },
        "#": {
            x_min: 21,
            x_max: 1113,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 21,
            advanceWidth: 1139
        },
        $: {
            x_min: 73,
            x_max: 1043,
            y_min: -211,
            y_max: 1601,
            ha: 1812,
            leftSideBearing: 73,
            advanceWidth: 1139
        },
        "%": {
            x_min: 119,
            x_max: 1695,
            y_min: -54,
            y_max: 1491,
            ha: 1545,
            leftSideBearing: 119,
            advanceWidth: 1821
        },
        "&": {
            x_min: 88,
            x_max: 1319,
            y_min: -34,
            y_max: 1491,
            ha: 1525,
            leftSideBearing: 88,
            advanceWidth: 1366
        },
        "'": {
            x_min: 90,
            x_max: 295,
            y_min: 947,
            y_max: 1466,
            ha: 519,
            leftSideBearing: 90,
            advanceWidth: 391
        },
        "(": {
            x_min: 124,
            x_max: 608,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 124,
            advanceWidth: 682
        },
        ")": {
            x_min: 124,
            x_max: 608,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 124,
            advanceWidth: 682
        },
        "*": {
            x_min: 64,
            x_max: 725,
            y_min: 867,
            y_max: 1491,
            ha: 624,
            leftSideBearing: 64,
            advanceWidth: 797
        },
        "+": {
            x_min: 114,
            x_max: 1082,
            y_min: 237,
            y_max: 1206,
            ha: 969,
            leftSideBearing: 114,
            advanceWidth: 1196
        },
        ",": {
            x_min: 170,
            x_max: 387,
            y_min: -290,
            y_max: 205,
            ha: 495,
            leftSideBearing: 170,
            advanceWidth: 569
        },
        "-": {
            x_min: 65,
            x_max: 618,
            y_min: 440,
            y_max: 621,
            ha: 181,
            leftSideBearing: 65,
            advanceWidth: 682
        },
        ".": {
            x_min: 186,
            x_max: 391,
            y_min: 0,
            y_max: 205,
            ha: 205,
            leftSideBearing: 186,
            advanceWidth: 569
        },
        "/": {
            x_min: 0,
            x_max: 569,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 0,
            advanceWidth: 569
        },
        ":": {
            x_min: 185,
            x_max: 390,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 185,
            advanceWidth: 569
        },
        ";": {
            x_min: 170,
            x_max: 387,
            y_min: -290,
            y_max: 1062,
            ha: 1352,
            leftSideBearing: 170,
            advanceWidth: 569
        },
        "<": {
            x_min: 112,
            x_max: 1083,
            y_min: 226,
            y_max: 1219,
            ha: 993,
            leftSideBearing: 112,
            advanceWidth: 1196
        },
        "=": {
            x_min: 114,
            x_max: 1082,
            y_min: 417,
            y_max: 1030,
            ha: 613,
            leftSideBearing: 114,
            advanceWidth: 1196
        },
        ">": {
            x_min: 112,
            x_max: 1083,
            y_min: 226,
            y_max: 1219,
            ha: 993,
            leftSideBearing: 112,
            advanceWidth: 1196
        },
        "?": {
            x_min: 90,
            x_max: 1036,
            y_min: 0,
            y_max: 1491,
            ha: 1491,
            leftSideBearing: 90,
            advanceWidth: 1139
        },
        "@": {
            x_min: 111,
            x_max: 2005,
            y_min: -431,
            y_max: 1493,
            ha: 1924,
            leftSideBearing: 111,
            advanceWidth: 2079
        },
        A: {
            x_min: -3,
            x_max: 1369,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: -3,
            advanceWidth: 1366
        },
        B: {
            x_min: 150,
            x_max: 1257,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1366
        },
        C: {
            x_min: 102,
            x_max: 1398,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 102,
            advanceWidth: 1479
        },
        D: {
            x_min: 158,
            x_max: 1370,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 158,
            advanceWidth: 1479
        },
        E: {
            x_min: 162,
            x_max: 1256,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 162,
            advanceWidth: 1366
        },
        F: {
            x_min: 168,
            x_max: 1157,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 168,
            advanceWidth: 1251
        },
        G: {
            x_min: 109,
            x_max: 1465,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 109,
            advanceWidth: 1593
        },
        H: {
            x_min: 164,
            x_max: 1314,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 164,
            advanceWidth: 1479
        },
        I: {
            x_min: 191,
            x_max: 385,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 191,
            advanceWidth: 569
        },
        J: {
            x_min: 58.84976474807333,
            x_max: 865,
            y_min: -25,
            y_max: 1466,
            ha: 1491,
            leftSideBearing: 58,
            advanceWidth: 1024
        },
        K: {
            x_min: 150,
            x_max: 1362,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1366
        },
        L: {
            x_min: 150,
            x_max: 1066,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 150,
            advanceWidth: 1139
        },
        M: {
            x_min: 152,
            x_max: 1551,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 152,
            advanceWidth: 1706
        },
        N: {
            x_min: 156,
            x_max: 1311,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 156,
            advanceWidth: 1479
        },
        O: {
            x_min: 99,
            x_max: 1501,
            y_min: -25,
            y_max: 1492,
            ha: 1517,
            leftSideBearing: 99,
            advanceWidth: 1593
        },
        P: {
            x_min: 158,
            x_max: 1277,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 158,
            advanceWidth: 1366
        },
        Q: {
            x_min: 88,
            x_max: 1518,
            y_min: -114,
            y_max: 1492,
            ha: 1606,
            leftSideBearing: 88,
            advanceWidth: 1593
        },
        R: {
            x_min: 161,
            x_max: 1453,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 161,
            advanceWidth: 1479
        },
        S: {
            x_min: 92,
            x_max: 1259,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 92,
            advanceWidth: 1366
        },
        T: {
            x_min: 48,
            x_max: 1210,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 48,
            advanceWidth: 1251
        },
        U: {
            x_min: 161,
            x_max: 1314,
            y_min: -25,
            y_max: 1466,
            ha: 1491,
            leftSideBearing: 161,
            advanceWidth: 1479
        },
        V: {
            x_min: 9,
            x_max: 1350,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 9,
            advanceWidth: 1366
        },
        W: {
            x_min: 25,
            x_max: 1910,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 25,
            advanceWidth: 1933
        },
        X: {
            x_min: 9,
            x_max: 1353,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 9,
            advanceWidth: 1366
        },
        Y: {
            x_min: 6,
            x_max: 1350,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 6,
            advanceWidth: 1366
        },
        Z: {
            x_min: 41,
            x_max: 1200,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 41,
            advanceWidth: 1251
        },
        "[": {
            x_min: 139,
            x_max: 536,
            y_min: -407,
            y_max: 1466,
            ha: 1873,
            leftSideBearing: 139,
            advanceWidth: 569
        },
        "\\": {
            x_min: 0,
            x_max: 569,
            y_min: -25,
            y_max: 1491,
            ha: 1516,
            leftSideBearing: 0,
            advanceWidth: 569
        },
        "]": {
            x_min: 39,
            x_max: 436,
            y_min: -407,
            y_max: 1466,
            ha: 1873,
            leftSideBearing: 39,
            advanceWidth: 569
        },
        "^": {
            x_min: 54,
            x_max: 907,
            y_min: 690,
            y_max: 1491,
            ha: 801,
            leftSideBearing: 54,
            advanceWidth: 961
        },
        _: {
            x_min: -31,
            x_max: 1162,
            y_min: -407,
            y_max: -277,
            ha: 130,
            leftSideBearing: -31,
            advanceWidth: 1139
        },
        "`": {
            x_min: 89,
            x_max: 465,
            y_min: 1194,
            y_max: 1474,
            ha: 280,
            leftSideBearing: 89,
            advanceWidth: 682
        },
        a: {
            x_min: 74,
            x_max: 1052,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 74,
            advanceWidth: 1139
        },
        b: {
            x_min: 134,
            x_max: 1055,
            y_min: -24,
            y_max: 1466,
            ha: 1490,
            leftSideBearing: 134,
            advanceWidth: 1139
        },
        c: {
            x_min: 80,
            x_max: 1005,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 80,
            advanceWidth: 1024
        },
        d: {
            x_min: 70,
            x_max: 991,
            y_min: -24,
            y_max: 1466,
            ha: 1490,
            leftSideBearing: 70,
            advanceWidth: 1139
        },
        e: {
            x_min: 75,
            x_max: 1054,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 75,
            advanceWidth: 1139
        },
        f: {
            x_min: 19,
            x_max: 640,
            y_min: 0,
            y_max: 1491,
            ha: 1491,
            leftSideBearing: 19,
            advanceWidth: 569
        },
        g: {
            x_min: 66,
            x_max: 1002,
            y_min: -431,
            y_max: 1086,
            ha: 1517,
            leftSideBearing: 66,
            advanceWidth: 1139
        },
        h: {
            x_min: 135,
            x_max: 1e3,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 135,
            advanceWidth: 1139
        },
        i: {
            x_min: 136,
            x_max: 316,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 136,
            advanceWidth: 455
        },
        j: {
            x_min: -94,
            x_max: 314,
            y_min: -431,
            y_max: 1466,
            ha: 1897,
            leftSideBearing: -94,
            advanceWidth: 455
        },
        k: {
            x_min: 136,
            x_max: 1016,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 136,
            advanceWidth: 1024
        },
        l: {
            x_min: 131,
            x_max: 311,
            y_min: 0,
            y_max: 1466,
            ha: 1466,
            leftSideBearing: 131,
            advanceWidth: 455
        },
        m: {
            x_min: 135,
            x_max: 1574,
            y_min: 0,
            y_max: 1086,
            ha: 1086,
            leftSideBearing: 135,
            advanceWidth: 1706
        },
        n: {
            x_min: 135,
            x_max: 998,
            y_min: 0,
            y_max: 1086,
            ha: 1086,
            leftSideBearing: 135,
            advanceWidth: 1139
        },
        o: {
            x_min: 68,
            x_max: 1063,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 68,
            advanceWidth: 1139
        },
        p: {
            x_min: 135,
            x_max: 1057,
            y_min: -407,
            y_max: 1086,
            ha: 1493,
            leftSideBearing: 135,
            advanceWidth: 1139
        },
        q: {
            x_min: 72,
            x_max: 992,
            y_min: -407,
            y_max: 1086,
            ha: 1493,
            leftSideBearing: 72,
            advanceWidth: 1139
        },
        r: {
            x_min: 133,
            x_max: 710,
            y_min: 0,
            y_max: 1086,
            ha: 1086,
            leftSideBearing: 133,
            advanceWidth: 682
        },
        s: {
            x_min: 63,
            x_max: 945,
            y_min: -24,
            y_max: 1086,
            ha: 1110,
            leftSideBearing: 63,
            advanceWidth: 1024
        },
        t: {
            x_min: 36,
            x_max: 554,
            y_min: -14,
            y_max: 1433,
            ha: 1447,
            leftSideBearing: 36,
            advanceWidth: 569
        },
        u: {
            x_min: 131,
            x_max: 992,
            y_min: -24,
            y_max: 1062,
            ha: 1086,
            leftSideBearing: 131,
            advanceWidth: 1139
        },
        v: {
            x_min: 26,
            x_max: 1e3,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 26,
            advanceWidth: 1024
        },
        w: {
            x_min: 6,
            x_max: 1463,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 6,
            advanceWidth: 1479
        },
        x: {
            x_min: 15,
            x_max: 1009,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 15,
            advanceWidth: 1024
        },
        y: {
            x_min: 33,
            x_max: 1006,
            y_min: -431,
            y_max: 1062,
            ha: 1493,
            leftSideBearing: 33,
            advanceWidth: 1024
        },
        z: {
            x_min: 40,
            x_max: 980,
            y_min: 0,
            y_max: 1062,
            ha: 1062,
            leftSideBearing: 40,
            advanceWidth: 1024
        },
        "{": {
            x_min: 57,
            x_max: 636,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 57,
            advanceWidth: 684
        },
        "|": {
            x_min: 188,
            x_max: 345,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 188,
            advanceWidth: 532
        },
        "}": {
            x_min: 47,
            x_max: 626,
            y_min: -431,
            y_max: 1491,
            ha: 1922,
            leftSideBearing: 47,
            advanceWidth: 684
        },
        "~": {
            x_min: 87,
            x_max: 1110,
            y_min: 557,
            y_max: 885,
            ha: 328,
            leftSideBearing: 87,
            advanceWidth: 1196
        }
    },
    fontFamily: "sans-serif",
    resolution: 2048,
    generatedOn: "2020-10-18T18:48:11.823Z"
};
// node_modules/vexflow/build/esm/src/fonts/serif_text_metrics.js
var $a801f2c896bd09f1$var$SerifFont = {
    smufl: false,
    name: "SERIF",
    spacing: 50,
    Description: "Built-in serif font",
    bold: true,
    italic: true,
    monospaced: false,
    serifs: true,
    glyphs: {
        "0": {
            x_min: 49,
            x_max: 975,
            y_min: -27,
            y_max: 1383,
            ha: 1410,
            leftSideBearing: 49,
            advanceWidth: 1024
        },
        "1": {
            x_min: 227,
            x_max: 811,
            y_min: 0,
            y_max: 1383,
            ha: 1383,
            leftSideBearing: 227,
            advanceWidth: 1024
        },
        "2": {
            x_min: 61,
            x_max: 965,
            y_min: 0,
            y_max: 1383,
            ha: 1383,
            leftSideBearing: 61,
            advanceWidth: 1024
        },
        "3": {
            x_min: 88,
            x_max: 883,
            y_min: -27,
            y_max: 1383,
            ha: 1410,
            leftSideBearing: 88,
            advanceWidth: 1024
        },
        "4": {
            x_min: 25,
            x_max: 967,
            y_min: 0,
            y_max: 1384,
            ha: 1384,
            leftSideBearing: 25,
            advanceWidth: 1024
        },
        "5": {
            x_min: 66,
            x_max: 898,
            y_min: -27,
            y_max: 1409,
            ha: 1436,
            leftSideBearing: 66,
            advanceWidth: 1024
        },
        "6": {
            x_min: 70,
            x_max: 958,
            y_min: -27,
            y_max: 1401,
            ha: 1428,
            leftSideBearing: 70,
            advanceWidth: 1024
        },
        "7": {
            x_min: 41,
            x_max: 920,
            y_min: -16,
            y_max: 1356,
            ha: 1372,
            leftSideBearing: 41,
            advanceWidth: 1024
        },
        "8": {
            x_min: 115,
            x_max: 911,
            y_min: -27,
            y_max: 1383,
            ha: 1410,
            leftSideBearing: 115,
            advanceWidth: 1024
        },
        "9": {
            x_min: 61,
            x_max: 940,
            y_min: -41,
            y_max: 1383,
            ha: 1424,
            leftSideBearing: 61,
            advanceWidth: 1024
        },
        " ": {
            x_min: 0,
            x_max: 0,
            y_min: 0,
            y_max: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 512
        },
        "!": {
            x_min: 266,
            x_max: 488,
            y_min: -22,
            y_max: 1383,
            ha: 1405,
            leftSideBearing: 266,
            advanceWidth: 682
        },
        '"': {
            x_min: 157.2000021972655,
            x_max: 678.2500021457677,
            y_min: 881,
            y_max: 1385,
            ha: 504,
            leftSideBearing: 157,
            advanceWidth: 836
        },
        "#": {
            x_min: 10,
            x_max: 1016,
            y_min: -1,
            y_max: 1356,
            ha: 1357,
            leftSideBearing: 10,
            advanceWidth: 1024
        },
        $: {
            x_min: 90,
            x_max: 936,
            y_min: -180,
            y_max: 1492,
            ha: 1672,
            leftSideBearing: 90,
            advanceWidth: 1024
        },
        "%": {
            x_min: 125,
            x_max: 1581,
            y_min: -30,
            y_max: 1388,
            ha: 1418,
            leftSideBearing: 125,
            advanceWidth: 1706
        },
        "&": {
            x_min: 86,
            x_max: 1536,
            y_min: -28,
            y_max: 1383,
            ha: 1411,
            leftSideBearing: 86,
            advanceWidth: 1593
        },
        "'": {
            x_min: 97.20000219726548,
            x_max: 273.2500021457677,
            y_min: 881,
            y_max: 1385,
            ha: 504,
            leftSideBearing: 97,
            advanceWidth: 369
        },
        "(": {
            x_min: 98,
            x_max: 623,
            y_min: -363,
            y_max: 1383,
            ha: 1746,
            leftSideBearing: 98,
            advanceWidth: 682
        },
        ")": {
            x_min: 59,
            x_max: 584,
            y_min: -363,
            y_max: 1383,
            ha: 1746,
            leftSideBearing: 59,
            advanceWidth: 682
        },
        "*": {
            x_min: 137.96078522291893,
            x_max: 886.039214777081,
            y_min: 543,
            y_max: 1383,
            ha: 840,
            leftSideBearing: 137,
            advanceWidth: 1024
        },
        "+": {
            x_min: 61,
            x_max: 1093,
            y_min: 2,
            y_max: 1034,
            ha: 1032,
            leftSideBearing: 61,
            advanceWidth: 1155
        },
        ",": {
            x_min: 115,
            x_max: 399,
            y_min: -291,
            y_max: 208,
            ha: 499,
            leftSideBearing: 115,
            advanceWidth: 512
        },
        "-": {
            x_min: 80,
            x_max: 584,
            y_min: 396,
            y_max: 525,
            ha: 129,
            leftSideBearing: 80,
            advanceWidth: 682
        },
        ".": {
            x_min: 143,
            x_max: 371,
            y_min: -22,
            y_max: 205,
            ha: 227,
            leftSideBearing: 143,
            advanceWidth: 512
        },
        "/": {
            x_min: -17,
            x_max: 586,
            y_min: -27,
            y_max: 1383,
            ha: 1410,
            leftSideBearing: -17,
            advanceWidth: 569
        },
        ":": {
            x_min: 166,
            x_max: 394,
            y_min: -22,
            y_max: 943,
            ha: 965,
            leftSideBearing: 166,
            advanceWidth: 569
        },
        ";": {
            x_min: 164,
            x_max: 448,
            y_min: -290,
            y_max: 943,
            ha: 1233,
            leftSideBearing: 164,
            advanceWidth: 569
        },
        "<": {
            x_min: 57,
            x_max: 1098,
            y_min: -15,
            y_max: 1051,
            ha: 1066,
            leftSideBearing: 57,
            advanceWidth: 1155
        },
        "=": {
            x_min: 61,
            x_max: 1093,
            y_min: 246,
            y_max: 791,
            ha: 545,
            leftSideBearing: 61,
            advanceWidth: 1155
        },
        ">": {
            x_min: 57,
            x_max: 1098,
            y_min: -15,
            y_max: 1051,
            ha: 1066,
            leftSideBearing: 57,
            advanceWidth: 1155
        },
        "?": {
            x_min: 139,
            x_max: 848,
            y_min: -15,
            y_max: 1383,
            ha: 1398,
            leftSideBearing: 139,
            advanceWidth: 909
        },
        "@": {
            x_min: 238,
            x_max: 1657,
            y_min: -29,
            y_max: 1386,
            ha: 1415,
            leftSideBearing: 238,
            advanceWidth: 1886
        },
        A: {
            x_min: 31,
            x_max: 1445,
            y_min: 0,
            y_max: 1380,
            ha: 1380,
            leftSideBearing: 31,
            advanceWidth: 1479
        },
        B: {
            x_min: 35,
            x_max: 1214,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 35,
            advanceWidth: 1366
        },
        C: {
            x_min: 57,
            x_max: 1296,
            y_min: -28,
            y_max: 1383,
            ha: 1411,
            leftSideBearing: 57,
            advanceWidth: 1366
        },
        D: {
            x_min: 33,
            x_max: 1403,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 33,
            advanceWidth: 1479
        },
        E: {
            x_min: 25,
            x_max: 1222,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 25,
            advanceWidth: 1251
        },
        F: {
            x_min: 25,
            x_max: 1119,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 25,
            advanceWidth: 1139
        },
        G: {
            x_min: 66,
            x_max: 1452,
            y_min: -28,
            y_max: 1383,
            ha: 1411,
            leftSideBearing: 66,
            advanceWidth: 1479
        },
        H: {
            x_min: 39,
            x_max: 1438,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 39,
            advanceWidth: 1479
        },
        I: {
            x_min: 37,
            x_max: 642,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 37,
            advanceWidth: 682
        },
        J: {
            x_min: 20,
            x_max: 758,
            y_min: -28,
            y_max: 1356,
            ha: 1384,
            leftSideBearing: 20,
            advanceWidth: 797
        },
        K: {
            x_min: 70,
            x_max: 1479,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 70,
            advanceWidth: 1479
        },
        L: {
            x_min: 25,
            x_max: 1224,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 25,
            advanceWidth: 1251
        },
        M: {
            x_min: 25,
            x_max: 1768,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 25,
            advanceWidth: 1821
        },
        N: {
            x_min: 25,
            x_max: 1450,
            y_min: -22,
            y_max: 1356,
            ha: 1378,
            leftSideBearing: 25,
            advanceWidth: 1479
        },
        O: {
            x_min: 70,
            x_max: 1409,
            y_min: -28,
            y_max: 1383,
            ha: 1411,
            leftSideBearing: 70,
            advanceWidth: 1479
        },
        P: {
            x_min: 33,
            x_max: 1110,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 33,
            advanceWidth: 1139
        },
        Q: {
            x_min: 70,
            x_max: 1435,
            y_min: -364.28571588721996,
            y_max: 1383,
            ha: 1747.28571588722,
            leftSideBearing: 70,
            advanceWidth: 1479
        },
        R: {
            x_min: 35,
            x_max: 1347,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 35,
            advanceWidth: 1366
        },
        S: {
            x_min: 86,
            x_max: 1006,
            y_min: -28,
            y_max: 1383,
            ha: 1411,
            leftSideBearing: 86,
            advanceWidth: 1139
        },
        T: {
            x_min: 35,
            x_max: 1214,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 35,
            advanceWidth: 1251
        },
        U: {
            x_min: 29,
            x_max: 1444,
            y_min: -28,
            y_max: 1356,
            ha: 1384,
            leftSideBearing: 29,
            advanceWidth: 1479
        },
        V: {
            x_min: 33,
            x_max: 1428,
            y_min: -22,
            y_max: 1356,
            ha: 1378,
            leftSideBearing: 33,
            advanceWidth: 1479
        },
        W: {
            x_min: 10,
            x_max: 1906,
            y_min: -22,
            y_max: 1356,
            ha: 1378,
            leftSideBearing: 10,
            advanceWidth: 1933
        },
        X: {
            x_min: 20,
            x_max: 1449,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 20,
            advanceWidth: 1479
        },
        Y: {
            x_min: 45,
            x_max: 1441,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 45,
            advanceWidth: 1479
        },
        Z: {
            x_min: 18,
            x_max: 1222,
            y_min: 0,
            y_max: 1356,
            ha: 1356,
            leftSideBearing: 18,
            advanceWidth: 1251
        },
        "[": {
            x_min: 180,
            x_max: 612,
            y_min: -319,
            y_max: 1355,
            ha: 1674,
            leftSideBearing: 180,
            advanceWidth: 682
        },
        "\\": {
            x_min: -17,
            x_max: 586,
            y_min: -27,
            y_max: 1383,
            ha: 1410,
            leftSideBearing: -17,
            advanceWidth: 569
        },
        "]": {
            x_min: 70,
            x_max: 502,
            y_min: -319,
            y_max: 1355,
            ha: 1674,
            leftSideBearing: 70,
            advanceWidth: 682
        },
        "^": {
            x_min: 49,
            x_max: 914,
            y_min: 608,
            y_max: 1355,
            ha: 747,
            leftSideBearing: 49,
            advanceWidth: 961
        },
        _: {
            x_min: 0,
            x_max: 1024,
            y_min: -255,
            y_max: -153,
            ha: 102,
            leftSideBearing: 0,
            advanceWidth: 1024
        },
        "`": {
            x_min: 39,
            x_max: 499,
            y_min: 1037,
            y_max: 1392.509803639748,
            ha: 355.50980363974804,
            leftSideBearing: 39,
            advanceWidth: 682
        },
        a: {
            x_min: 76,
            x_max: 905,
            y_min: -20,
            y_max: 942,
            ha: 962,
            leftSideBearing: 76,
            advanceWidth: 909
        },
        b: {
            x_min: 6,
            x_max: 958,
            y_min: -20,
            y_max: 1399,
            ha: 1419,
            leftSideBearing: 6,
            advanceWidth: 1024
        },
        c: {
            x_min: 51,
            x_max: 843,
            y_min: -20,
            y_max: 942,
            ha: 962,
            leftSideBearing: 51,
            advanceWidth: 909
        },
        d: {
            x_min: 55,
            x_max: 1006,
            y_min: -20,
            y_max: 1399,
            ha: 1419,
            leftSideBearing: 55,
            advanceWidth: 1024
        },
        e: {
            x_min: 51,
            x_max: 868,
            y_min: -20,
            y_max: 942,
            ha: 962,
            leftSideBearing: 51,
            advanceWidth: 909
        },
        f: {
            x_min: 41,
            x_max: 783,
            y_min: 0,
            y_max: 1399,
            ha: 1399,
            leftSideBearing: 41,
            advanceWidth: 682
        },
        g: {
            x_min: 57,
            x_max: 963,
            y_min: -446,
            y_max: 942,
            ha: 1388,
            leftSideBearing: 57,
            advanceWidth: 1024
        },
        h: {
            x_min: 18,
            x_max: 997,
            y_min: 0,
            y_max: 1399,
            ha: 1399,
            leftSideBearing: 18,
            advanceWidth: 1024
        },
        i: {
            x_min: 33,
            x_max: 516,
            y_min: 0,
            y_max: 1399,
            ha: 1399,
            leftSideBearing: 33,
            advanceWidth: 569
        },
        j: {
            x_min: -142,
            x_max: 397,
            y_min: -446,
            y_max: 1399,
            ha: 1845,
            leftSideBearing: -142,
            advanceWidth: 569
        },
        k: {
            x_min: 14,
            x_max: 1029,
            y_min: 0,
            y_max: 1399,
            ha: 1399,
            leftSideBearing: 14,
            advanceWidth: 1024
        },
        l: {
            x_min: 39,
            x_max: 523,
            y_min: 0,
            y_max: 1399,
            ha: 1399,
            leftSideBearing: 39,
            advanceWidth: 569
        },
        m: {
            x_min: 33,
            x_max: 1587,
            y_min: 0,
            y_max: 944,
            ha: 944,
            leftSideBearing: 33,
            advanceWidth: 1593
        },
        n: {
            x_min: 33,
            x_max: 993,
            y_min: 0,
            y_max: 944,
            ha: 944,
            leftSideBearing: 33,
            advanceWidth: 1024
        },
        o: {
            x_min: 59,
            x_max: 963,
            y_min: -20,
            y_max: 942,
            ha: 962,
            leftSideBearing: 59,
            advanceWidth: 1024
        },
        p: {
            x_min: 10,
            x_max: 964,
            y_min: -443,
            y_max: 944,
            ha: 1387,
            leftSideBearing: 10,
            advanceWidth: 1024
        },
        q: {
            x_min: 49,
            x_max: 999,
            y_min: -443,
            y_max: 942.0135137169275,
            ha: 1385.0135137169275,
            leftSideBearing: 49,
            advanceWidth: 1024
        },
        r: {
            x_min: 10,
            x_max: 685,
            y_min: 0,
            y_max: 944,
            ha: 944,
            leftSideBearing: 10,
            advanceWidth: 682
        },
        s: {
            x_min: 104,
            x_max: 713,
            y_min: -20,
            y_max: 942.0263161804552,
            ha: 962.0263161804552,
            leftSideBearing: 104,
            advanceWidth: 797
        },
        t: {
            x_min: 27,
            x_max: 572,
            y_min: -18,
            y_max: 1186,
            ha: 1204,
            leftSideBearing: 27,
            advanceWidth: 569
        },
        u: {
            x_min: 18,
            x_max: 981,
            y_min: -21,
            y_max: 921,
            ha: 942,
            leftSideBearing: 18,
            advanceWidth: 1024
        },
        v: {
            x_min: 39,
            x_max: 976,
            y_min: -28,
            y_max: 921,
            ha: 949,
            leftSideBearing: 39,
            advanceWidth: 1024
        },
        w: {
            x_min: 43,
            x_max: 1423,
            y_min: -28,
            y_max: 921,
            ha: 949,
            leftSideBearing: 43,
            advanceWidth: 1479
        },
        x: {
            x_min: 35,
            x_max: 989,
            y_min: 0,
            y_max: 921,
            ha: 921,
            leftSideBearing: 35,
            advanceWidth: 1024
        },
        y: {
            x_min: 29,
            x_max: 976,
            y_min: -445,
            y_max: 921,
            ha: 1366,
            leftSideBearing: 29,
            advanceWidth: 1024
        },
        z: {
            x_min: 55,
            x_max: 855,
            y_min: 0,
            y_max: 921,
            ha: 921,
            leftSideBearing: 55,
            advanceWidth: 909
        },
        "{": {
            x_min: 205,
            x_max: 717,
            y_min: -377,
            y_max: 1397,
            ha: 1774,
            leftSideBearing: 205,
            advanceWidth: 983
        },
        "|": {
            x_min: 137,
            x_max: 273,
            y_min: -512,
            y_max: 1535,
            ha: 2047,
            leftSideBearing: 137,
            advanceWidth: 410
        },
        "}": {
            x_min: 266,
            x_max: 778,
            y_min: -377,
            y_max: 1397,
            ha: 1774,
            leftSideBearing: 266,
            advanceWidth: 983
        },
        "~": {
            x_min: 82,
            x_max: 1028,
            y_min: 380,
            y_max: 666,
            ha: 286,
            leftSideBearing: 82,
            advanceWidth: 1108
        }
    },
    fontFamily: "serif",
    resolution: 2048,
    generatedOn: "2020-10-18T19:03:12.514Z"
};
// node_modules/vexflow/build/esm/src/fonts/textfonts.js
function $a801f2c896bd09f1$var$loadTextFonts() {
    {
        const fontData = $a801f2c896bd09f1$var$SansFontBold;
        const { fontFamily: fontFamily, resolution: resolution, glyphs: glyphs } = fontData;
        $a801f2c896bd09f1$var$Font.load(fontFamily, fontData);
        const maxSizeGlyph = "@";
        $a801f2c896bd09f1$var$TextFormatter.registerInfo({
            family: fontFamily,
            resolution: resolution,
            glyphs: glyphs,
            maxSizeGlyph: maxSizeGlyph,
            monospaced: false,
            bold: true,
            italic: false,
            superscriptOffset: 0.66,
            subscriptOffset: 0.66,
            serifs: false,
            description: "Generic SANS font"
        });
    }
    {
        const fontData = $a801f2c896bd09f1$var$SansFont;
        const { fontFamily: fontFamily, resolution: resolution, glyphs: glyphs } = fontData;
        $a801f2c896bd09f1$var$Font.load(fontFamily, fontData);
        const maxSizeGlyph = "@";
        $a801f2c896bd09f1$var$TextFormatter.registerInfo({
            family: fontFamily,
            resolution: resolution,
            glyphs: glyphs,
            maxSizeGlyph: maxSizeGlyph,
            monospaced: false,
            bold: false,
            italic: false,
            superscriptOffset: 0.66,
            subscriptOffset: 0.66,
            serifs: false,
            description: "Generic SANS font"
        });
    }
    {
        const fontData = $a801f2c896bd09f1$var$SerifFont;
        const { fontFamily: fontFamily, resolution: resolution, glyphs: glyphs } = fontData;
        $a801f2c896bd09f1$var$Font.load(fontFamily, fontData);
        const maxSizeGlyph = "@";
        $a801f2c896bd09f1$var$TextFormatter.registerInfo({
            family: fontFamily,
            resolution: resolution,
            glyphs: glyphs,
            maxSizeGlyph: maxSizeGlyph,
            monospaced: false,
            bold: false,
            italic: false,
            superscriptOffset: 0.66,
            subscriptOffset: 0.66,
            serifs: true,
            description: "Generic SERIF font"
        });
    }
    {
        const fontData = $a801f2c896bd09f1$var$RobotoSlabFont;
        const { fontFamily: fontFamily, resolution: resolution, glyphs: glyphs } = fontData;
        $a801f2c896bd09f1$var$Font.load(fontFamily, fontData);
        const maxSizeGlyph = "b";
        $a801f2c896bd09f1$var$TextFormatter.registerInfo({
            family: fontFamily,
            resolution: resolution,
            glyphs: glyphs,
            maxSizeGlyph: maxSizeGlyph,
            monospaced: false,
            bold: false,
            italic: false,
            superscriptOffset: 0.66,
            subscriptOffset: 0.66,
            serifs: true,
            description: "Text font to pair with the Bravura / Gonville music fonts."
        });
    }
    {
        const fontData = $a801f2c896bd09f1$var$PetalumaScriptFont;
        const { fontFamily: fontFamily, resolution: resolution, glyphs: glyphs } = fontData;
        $a801f2c896bd09f1$var$Font.load(fontFamily, fontData);
        const maxSizeGlyph = "b";
        $a801f2c896bd09f1$var$TextFormatter.registerInfo({
            family: fontFamily,
            resolution: resolution,
            glyphs: glyphs,
            maxSizeGlyph: maxSizeGlyph,
            monospaced: false,
            bold: false,
            italic: false,
            superscriptOffset: 0.66,
            subscriptOffset: 0.66,
            serifs: false,
            description: "Text font to pair with the Petaluma music font."
        });
    }
}
// node_modules/vexflow/build/esm/src/vex.js
var $a801f2c896bd09f1$var$Vex = class {
    static sortAndUnique(arr, cmp, eq29) {
        if (arr.length > 1) {
            const newArr = [];
            let last3;
            arr.sort(cmp);
            for(let i2 = 0; i2 < arr.length; ++i2){
                if (i2 === 0 || !eq29(arr[i2], last3)) newArr.push(arr[i2]);
                last3 = arr[i2];
            }
            return newArr;
        } else return arr;
    }
    static contains(arr, obj) {
        let i2 = arr.length;
        while(i2--){
            if (arr[i2] === obj) return true;
        }
        return false;
    }
    static getCanvasContext(canvasSelector) {
        if (!canvasSelector) throw new $a801f2c896bd09f1$var$RuntimeError("BadArgument", "Invalid canvas selector: " + canvasSelector);
        const canvas2 = document.getElementById(canvasSelector);
        if (!(canvas2 && canvas2.getContext)) throw new $a801f2c896bd09f1$var$RuntimeError("UnsupportedBrowserError", "This browser does not support HTML5 Canvas");
        return canvas2.getContext("2d");
    }
    static benchmark(s2, f2) {
        const start_time = /* @__PURE__ */ new Date().getTime();
        f2();
        const elapsed = /* @__PURE__ */ new Date().getTime() - start_time;
        $a801f2c896bd09f1$var$log3(s2, elapsed + "ms");
    }
    static stackTrace() {
        const err = new Error();
        return err.stack;
    }
};
$a801f2c896bd09f1$var$Vex.Flow = $a801f2c896bd09f1$var$Flow;
// node_modules/vexflow/build/esm/entry/vexflow.js
$a801f2c896bd09f1$var$loadAllMusicFonts();
$a801f2c896bd09f1$var$Flow.setMusicFont("Bravura", "Gonville", "Custom");
$a801f2c896bd09f1$var$loadTextFonts();
// output/ProtoVoices.RenderSVG/foreign.js
var $a801f2c896bd09f1$var$VF = $a801f2c896bd09f1$var$Flow;
function $a801f2c896bd09f1$var$drawSlice(slice4, staffType, scale, id_pfx, styles) {
    let div6 = $a801f2c896bd09f1$var$createSvgElt("g");
    let renderer = new $a801f2c896bd09f1$var$VF.Renderer(div6, $a801f2c896bd09f1$var$VF.Renderer.Backends.SVG);
    let ctx = renderer.getContext();
    let voices = [];
    let formatter = new $a801f2c896bd09f1$var$VF.Formatter();
    function renderNotes(notes, clef) {
        let voice = new $a801f2c896bd09f1$var$VF.Voice({
            num_beats: 1,
            beat_value: 4
        });
        if (notes.length > 0) {
            let chord = new $a801f2c896bd09f1$var$VF.StaveNote({
                clef: clef,
                keys: notes.map($a801f2c896bd09f1$var$noteToVex),
                duration: "q"
            });
            for(let i2 = 0; i2 < notes.length; i2++)chord._noteHeads[i2].attrs.id = notes[i2].id;
            chord.attrs.id = `${id_pfx}slice${slice4.id}-${clef}`;
            if (styles) for(let i2 = 0; i2 < notes.length; i2++){
                let style3 = styles.noteStyles[notes[i2].id];
                if (style3) chord._noteHeads[i2].attrs.class = style3.classes;
            }
            chord.getStem().setVisibility(false);
            notes.forEach((n, i2)=>$a801f2c896bd09f1$var$addAcc(i2, chord, n.accs));
            voice.addTickables([
                chord
            ]);
            formatter.joinVoices([
                voice
            ]);
            voices.push({
                v: voice,
                c: clef
            });
        }
    }
    if (staffType == "grand") {
        let notesT = slice4.notes.filter((n)=>n.oct >= 4);
        renderNotes(notesT, "treble");
        let notesB = slice4.notes.filter((n)=>n.oct < 4);
        renderNotes(notesB, "bass");
    } else renderNotes(slice4.notes, staffType);
    formatter.format(voices.map((v3)=>v3.v));
    let width9 = formatter.getMinTotalWidth();
    if (staffType == "grand") {
        let staveT = new $a801f2c896bd09f1$var$VF.Stave(0, 0, width9);
        let staveB = new $a801f2c896bd09f1$var$VF.Stave(0, 70, width9);
        voices.forEach((voice)=>voice.v.draw(ctx, voice.c == "treble" ? staveT : staveB));
    } else {
        let staff = new $a801f2c896bd09f1$var$VF.Stave(0, 0, width9);
        voices.forEach((voice)=>voice.v.draw(ctx, staff));
    }
    let xcorrection = (width9 / 2 + 17 * scale).toFixed(3);
    div6.setAttribute("transform", `translate(${-xcorrection} 0)`);
    return div6;
}
function $a801f2c896bd09f1$var$drawStaff(width9, staffType) {
    let div6 = document.createElement("div");
    let renderer = new $a801f2c896bd09f1$var$VF.Renderer(div6, $a801f2c896bd09f1$var$VF.Renderer.Backends.SVG);
    let ctx = renderer.getContext();
    if (staffType == "grand") {
        let staveT = new $a801f2c896bd09f1$var$VF.Stave(0, 0, width9).addClef("treble");
        staveT.setContext(ctx).draw();
        let staveB = new $a801f2c896bd09f1$var$VF.Stave(0, 70, width9).addClef("bass");
        staveB.setContext(ctx).draw();
    } else {
        let stave = new $a801f2c896bd09f1$var$VF.Stave(0, 0, width9).addClef(staffType);
        stave.setContext(ctx).draw();
    }
    let elt = div6.children[0];
    elt.setAttribute("style", "overflow: visible;");
    return elt;
}
function $a801f2c896bd09f1$var$drawSystem(slices, totalWidth, scale, staffType, id_pfx, styles = null) {
    let container = $a801f2c896bd09f1$var$createSvgElt("g");
    let staff = $a801f2c896bd09f1$var$createSvgElt("g");
    staff.setAttribute("transform", "scale(" + scale + " " + scale + ")");
    staff.appendChild($a801f2c896bd09f1$var$drawStaff(totalWidth / scale, staffType));
    slices.forEach((slice4)=>{
        if (slice4.notes.length === 0) return;
        let sliceG = $a801f2c896bd09f1$var$createSvgElt("g");
        sliceG.setAttribute("transform", "translate(" + slice4.x + " 0) scale(" + scale + " " + scale + ")");
        sliceG.setAttribute("id", "slice-" + slice4.id);
        sliceG.appendChild($a801f2c896bd09f1$var$drawSlice(slice4, staffType, scale, id_pfx, styles));
        if (styles !== null) {
            let sliceStyle = styles.sliceStyles[slice4.id];
            if (sliceStyle) {
                sliceG.setAttribute("class", "pv-slice " + sliceStyle.classes);
                let label5 = $a801f2c896bd09f1$var$createSvgElt("text");
                label5.setAttribute("y", 20);
                label5.textContent = sliceStyle.label;
                label5.setAttribute("text-anchor", "middle");
                label5.setAttribute("dominant-baseline", "middle");
                label5.setAttribute("class", "pv-label");
                sliceG.appendChild(label5);
            }
        }
        container.appendChild(sliceG);
    });
    return {
        notes: container,
        staff: staff
    };
}
function $a801f2c896bd09f1$var$drawScoreEdge(container, edge, passing) {
    const bbleft = $a801f2c896bd09f1$var$getNoteBBox(edge.left.id, container);
    const bbright = $a801f2c896bd09f1$var$getNoteBBox(edge.right.id, container);
    let x12 = bbleft.x + bbleft.width + $a801f2c896bd09f1$var$markerWidth + 2;
    let y12 = bbleft.y + bbleft.height / 2;
    let x22 = bbright.x - $a801f2c896bd09f1$var$markerWidth - 2;
    let y22 = bbright.y + bbright.height / 2;
    let line2 = $a801f2c896bd09f1$var$createSvgElt("line");
    line2.setAttribute("x1", x12);
    line2.setAttribute("y1", y12);
    line2.setAttribute("x2", x22);
    line2.setAttribute("y2", y22);
    let classes = "pv-score-edge";
    if (passing) {
        line2.setAttribute("stroke-dasharray", "6,3");
        classes += " pv-passing";
    } else classes += " pv-regular";
    line2.setAttribute("class", classes);
    return line2;
}
var $a801f2c896bd09f1$var$drawScore = (slices)=>(transitions)=>(staffType)=>(totalWidth)=>(scale)=>{
                    let system = $a801f2c896bd09f1$var$drawSystem(slices, totalWidth, scale, staffType, "score-");
                    let container = $a801f2c896bd09f1$var$createSvgElt("g");
                    container.appendChild(system.staff);
                    container.appendChild(system.notes);
                    let fakesvg = $a801f2c896bd09f1$var$createSvgElt("svg");
                    fakesvg.appendChild(container);
                    document.body.appendChild(fakesvg);
                    transitions.forEach((transition)=>{
                        let transElt = $a801f2c896bd09f1$var$createSvgElt("g");
                        transElt.setAttribute("id", `score-transition-${transition.id}`);
                        transElt.setAttribute("class", "pv-score-transition");
                        transition.regular.forEach((edge)=>{
                            transElt.appendChild($a801f2c896bd09f1$var$drawScoreEdge(container, edge, false));
                        });
                        transition.passing.forEach((edge)=>{
                            transElt.appendChild($a801f2c896bd09f1$var$drawScoreEdge(container, edge, true));
                        });
                        container.appendChild(transElt);
                    });
                    fakesvg.remove();
                    container.remove();
                    return container;
                };
var $a801f2c896bd09f1$var$insertScore = (el)=>(score)=>()=>el.replaceChildren(score);
function $a801f2c896bd09f1$var$drawEdge(container, edge, selection, passing, edgeStyles, looseness = 1) {
    let line2 = $a801f2c896bd09f1$var$createSvgElt("path");
    line2.setAttribute("fill", "none");
    const bbleft = $a801f2c896bd09f1$var$getNoteBBox(edge.left.id, container);
    const bbright = $a801f2c896bd09f1$var$getNoteBBox(edge.right.id, container);
    let x12 = bbleft.x + bbleft.width + $a801f2c896bd09f1$var$markerWidth + 2;
    let y12 = bbleft.y + bbleft.height / 2;
    let x22 = bbright.x - $a801f2c896bd09f1$var$markerWidth - 2;
    let y22 = bbright.y + bbright.height / 2;
    let dist = Math.sqrt((x22 - x12) ** 2 + (y22 - y12) ** 2);
    let d = dist * looseness * 0.3915;
    line2.setAttribute("d", `M ${x12} ${y12} C ${x12 + d} ${y12}, ${x22 - d} ${y22}, ${x22} ${y22}`);
    let classes = "pv-edge";
    if (passing) {
        line2.setAttribute("stroke-dasharray", "6,3");
        classes += " pv-passing";
    } else classes += " pv-regular";
    if (selection && (selection.note.id == edge.left.id || selection.note.id == edge.right.id)) classes += " pv-selected";
    let styleKey = JSON.stringify({
        left: edge.left.id,
        right: edge.right.id
    });
    let style3 = edgeStyles.get(styleKey);
    if (style3) {
        classes += " " + style3.classes;
        let label5 = $a801f2c896bd09f1$var$createSvgElt("title");
        label5.setAttribute("class", "pv-label");
        label5.textContent = style3.label;
        line2.appendChild(label5);
    }
    line2.setAttribute("class", classes);
    return line2;
}
function $a801f2c896bd09f1$var$drawHori(hori, container) {
    let bbparent = $a801f2c896bd09f1$var$getBBox(container.querySelector("#vf-slice" + hori.parent + "-bass") || container.querySelector("#vf-slice" + hori.parent + "-treble"), false, container);
    let bbchild = $a801f2c896bd09f1$var$getBBox(container.querySelector("#vf-slice" + hori.child + "-treble") || container.querySelector("#vf-slice" + hori.child + "-bass"), false, container);
    let line2 = $a801f2c896bd09f1$var$createSvgElt("line");
    line2.setAttribute("x1", bbparent.x + bbparent.width / 2);
    line2.setAttribute("y1", bbparent.y + bbparent.height + 5);
    line2.setAttribute("x2", bbchild.x + bbparent.width / 2);
    line2.setAttribute("y2", bbchild.y - 5);
    line2.setAttribute("stroke", "lightgray");
    line2.setAttribute("stroke-width", "5");
    return line2;
}
function $a801f2c896bd09f1$var$drawMarker(noteid, expl, container, notemap) {
    const bbox = $a801f2c896bd09f1$var$getNoteBBox(noteid, container);
    const y4 = bbox.y + bbox.height / 2;
    let marker = $a801f2c896bd09f1$var$createSvgElt("g");
    marker.setAttribute("id", "marker-" + noteid);
    marker.setAttribute("class", "pv-op-marker");
    container.appendChild(marker);
    let left = "none";
    let right = "none";
    switch(expl.typ){
        case "Root":
            left = "root-left";
            right = "root-right";
            break;
        case "Hori":
            if (expl.parent) {
                if (notemap[expl.parent] > notemap[noteid]) right = "spread-right";
                else left = "spread-left";
            }
            break;
        case "RightRepeat":
            left = "repeat";
            break;
        case "RightNeighbor":
            left = "neighbor-left";
            break;
        case "LeftRepeat":
            right = "repeat";
            break;
        case "LeftNeighbor":
            right = "neighbor-right";
            break;
        case "FullNeighbor":
            left = "neighbor-left";
            right = "neighbor-right";
            break;
        case "FullRepeat":
            left = "repeat";
            right = "repeat";
            break;
        case "LeftRepeatOfRight":
            left = "neighbor-left";
            right = "repeat";
            break;
        case "RightRepeatOfLeft":
            left = "repeat";
            right = "neighbor-right";
            break;
        case "PassingMid":
            left = "pass";
            right = "pass";
            break;
        case "PassingLeft":
            left = "pass";
            break;
        case "PassingRight":
            right = "pass";
            break;
    }
    marker.innerHTML = `
    <use href="#marker-${left}" x="${bbox.x - $a801f2c896bd09f1$var$markerWidth - 1}" y="${y4}"/>
    <use href="#marker-${right}" x="${bbox.x + bbox.width + 1}" y="${y4}"/>
  `;
}
function $a801f2c896bd09f1$var$drawTimeLabel(time3, y4) {
    let label5 = $a801f2c896bd09f1$var$createSvgElt("text");
    label5.setAttribute("x", time3.x);
    label5.setAttribute("y", y4);
    label5.setAttribute("text-anchor", "middle");
    label5.setAttribute("dominant-baseline", "middle");
    label5.textContent = time3.label;
    return label5;
}
var $a801f2c896bd09f1$var$drawGraph = (graph)=>(totalWidth)=>(scale)=>(showScore)=>{
                let graphContainer = document.createElementNS("http://www.w3.org/2000/svg", "g");
                graphContainer.innerHTML = $a801f2c896bd09f1$var$markers;
                let styleElt = $a801f2c896bd09f1$var$createSvgElt("style");
                let combinedStyles = $a801f2c896bd09f1$var$defaultStyles + "\n" + graph.styles.css + "\n" + $a801f2c896bd09f1$var$uiStyles;
                styleElt.innerHTML = combinedStyles;
                graphContainer.appendChild(styleElt);
                let fg_sep = $a801f2c896bd09f1$var$createSvgElt("g");
                graphContainer.appendChild(fg_sep);
                let minLevel = graph.slices.filter((s2)=>s2.depth == 0).length == 2 ? 1 : 0;
                let levelOffset = graph.styles.staffType == "grand" ? 150 : 80;
                for(let level = minLevel; level <= graph.maxd; level++){
                    let levelSlices = graph.slices.filter((s2)=>s2.depth == level);
                    let levelG = $a801f2c896bd09f1$var$drawSystem(levelSlices, totalWidth, scale, graph.styles.staffType, "", graph.styles);
                    let transform = `translate(0 ${(level - minLevel) * levelOffset})`;
                    levelG.notes.setAttribute("transform", transform);
                    levelG.staff.setAttribute("transform", transform + " " + levelG.staff.getAttribute("transform"));
                    graphContainer.appendChild(levelG.notes);
                    graphContainer.insertBefore(levelG.staff, fg_sep);
                }
                graph.slices.forEach((slice4)=>{
                    slice4.notes.forEach((note2)=>{
                        let elt = graphContainer.querySelector("#vf-" + CSS.escape(note2.id));
                        let classes = elt.getAttribute("class") + " pv-note";
                        if (graph.styles) {
                            let noteStyle = graph.styles.noteStyles[note2.id];
                            if (noteStyle) {
                                classes += " " + noteStyle.classes;
                                let label5 = $a801f2c896bd09f1$var$createSvgElt("title");
                                label5.setAttribute("class", "pv-label");
                                label5.textContent = noteStyle.label;
                                elt.insertBefore(label5, elt.firstChild);
                            }
                        }
                        if (graph.select) {
                            classes += " pv-selectable";
                            if (graph.selection && graph.selection.note.id == note2.id) elt.addEventListener("click", graph.select(null));
                            else elt.addEventListener("click", graph.select(note2.sel));
                        }
                        elt.setAttribute("class", classes);
                    });
                });
                if (showScore) {
                    let score = $a801f2c896bd09f1$var$drawScore(graph.surfaceSlices)(graph.surfaceTransitions)(graph.styles.staffType)(totalWidth)(scale);
                    score.setAttribute("transform", `translate(0 ${(graph.maxd - minLevel + 1) * levelOffset})`);
                    graphContainer.appendChild(score);
                }
                let yoff = (graph.maxd - minLevel + (showScore ? 2 : 1)) * levelOffset + 20;
                graph.times.forEach((time3)=>{
                    graphContainer.appendChild($a801f2c896bd09f1$var$drawTimeLabel(time3, yoff));
                });
                let edgeStyles = /* @__PURE__ */ new Map();
                graph.styles.edgeStyles.forEach(function(es) {
                    edgeStyles.set(JSON.stringify(es.edge), es.style);
                });
                let fakesvg = $a801f2c896bd09f1$var$createSvgElt("svg");
                fakesvg.appendChild(graphContainer);
                document.body.appendChild(fakesvg);
                graph.horis.forEach((hori)=>{
                    graphContainer.insertBefore($a801f2c896bd09f1$var$drawHori(hori, graphContainer), fg_sep);
                });
                graph.transitions.forEach((transition)=>{
                    let transElt = $a801f2c896bd09f1$var$createSvgElt("g");
                    transElt.setAttribute("id", `transition-${transition.id}`);
                    let transStyle = graph.styles.transStyles[transition.id];
                    if (transStyle) {
                        transElt.setAttribute("class", "pv-trans " + transStyle.classes);
                        let label5 = $a801f2c896bd09f1$var$createSvgElt("title");
                        label5.setAttribute("class", "pv-label");
                        label5.textContent = transStyle.label;
                        transElt.appendChild(label5);
                    }
                    transition.regular.forEach((edge)=>{
                        transElt.appendChild($a801f2c896bd09f1$var$drawEdge(graphContainer, edge, graph.selection, false, edgeStyles));
                    });
                    transition.passing.forEach((edge)=>{
                        transElt.appendChild($a801f2c896bd09f1$var$drawEdge(graphContainer, edge, graph.selection, true, edgeStyles));
                    });
                    graphContainer.insertBefore(transElt, fg_sep);
                });
                let notemap = {};
                graph.slices.forEach((slice4)=>{
                    slice4.notes.forEach((note2)=>{
                        notemap[note2.id] = slice4.x;
                    });
                });
                graph.slices.forEach((slice4)=>{
                    slice4.notes.forEach((note2)=>{
                        $a801f2c896bd09f1$var$drawMarker(note2.id, note2.expl, graphContainer, notemap);
                    });
                });
                if (graph.selection) {
                    let note2 = graphContainer.querySelector("#vf-" + CSS.escape(graph.selection.note.id));
                    note2.setAttribute("class", note2.getAttribute("class") + " pv-selected");
                    graphContainer.querySelector("#marker-" + CSS.escape(graph.selection.note.id)).setAttribute("class", "pv-op-marker pv-selected");
                    graph.selection.parents.forEach((parent2)=>{
                        let parentNode3 = graphContainer.querySelector("#vf-" + CSS.escape(parent2.id));
                        parentNode3.setAttribute("class", parentNode3.getAttribute("class") + " pv-parent");
                    });
                }
                fakesvg.remove();
                graphContainer.remove();
                return graphContainer;
            };
var $a801f2c896bd09f1$var$markerWidth = 5;
var $a801f2c896bd09f1$var$markers = `<defs>
  <symbol id="marker-repeat" width="${$a801f2c896bd09f1$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <line x1="0" y1="1.5" x2="${$a801f2c896bd09f1$var$markerWidth}" y2="1.5"/>
    <line x1="0" y1="-1.5" x2="${$a801f2c896bd09f1$var$markerWidth}" y2="-1.5"/>
  </symbol>
  <symbol id="marker-neighbor-left" width="${$a801f2c896bd09f1$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <line x1="0" y1="1.5" x2="${$a801f2c896bd09f1$var$markerWidth}" y2="-1.5"/>
  </symbol>
  <symbol id="marker-neighbor-right" width="${$a801f2c896bd09f1$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <line x1="0" y1="-1.5" x2="${$a801f2c896bd09f1$var$markerWidth}" y2="1.5"/>
  </symbol>
  <symbol id="marker-pass" width="${$a801f2c896bd09f1$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <line x1="0" y1="-1.5" x2="${$a801f2c896bd09f1$var$markerWidth}" y2="0"/>
    <line x1="0" y1="1.5" x2="${$a801f2c896bd09f1$var$markerWidth}" y2="0"/>
  </symbol>
  <symbol id="marker-spread-left" width="${$a801f2c896bd09f1$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <polyline points="1,-1.5 1,1.5 ${$a801f2c896bd09f1$var$markerWidth},1.5"/>
  </symbol>
  <symbol id="marker-spread-right" width="${$a801f2c896bd09f1$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <polyline points="0,1.5 ${$a801f2c896bd09f1$var$markerWidth - 1},1.5 ${$a801f2c896bd09f1$var$markerWidth - 1},-1.5"/>
  </symbol>
  <symbol id="marker-root-left" width="${$a801f2c896bd09f1$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <polygon points="1,0 ${$a801f2c896bd09f1$var$markerWidth},-1.5 ${$a801f2c896bd09f1$var$markerWidth},1.5 0,0"/>
  </symbol>
  <symbol id="marker-root-right" width="${$a801f2c896bd09f1$var$markerWidth}" height="3" viewport="0 -2 5 3" overflow="visible">
    <polygon points="0,1.5 0,-1.5 ${$a801f2c896bd09f1$var$markerWidth - 1},0 0,1.5"/>
  </symbol>
</defs>
<!--rect width="100%" height="100%" fill="white"/-->`;
var $a801f2c896bd09f1$var$defaultStyles = `
:root {
  stroke: black;
}
text {
  font-size: 16px;
  fill: black;
  stroke: none;
}
.pv-op-marker {
  stroke-width: 1.5;
  fill: none;
}

.visible { display: inline; }
.hidden { display: none; }
.strong { font-weight: bold; }
.emph { font-style: italic; }

:root {
  --cat1: #4C72B0;
  --cat2: #DD8452;
  --cat3: #55A868;
  --cat4: #C44E52;
  --cat5: #8172B3;
  --cat6: #937860;
  --cat7: #DA8BC3;
  --cat8: #8C8C8C;
  --cat9: #CCB974;
  --cat10: #64B5CD;
  --cat1b: #aec7e8;
  --cat2b: #ffbb78;
  --cat3b: #98df8a;
  --cat4b: #ff9896;
  --cat5b: #c5b0d5;
  --cat6b: #c49c94;
  --cat7b: #f7b6d2;
  --cat8b: #c7c7c7;
  --cat9b: #dbdb8d;
  --cat10b: #9edae5;
  --cat1c: #001C7F;
  --cat2c: #B1400D;
  --cat3c: #12711C;
  --cat4c: #8C0800;
  --cat5c: #591E71;
  --cat6c: #592F0D;
  --cat7c: #A23582;
  --cat8c: #3C3C3C;
  --cat9c: #B8850A;
  --cat10c: #006374;
}

.cat1, .cat1 svg { fill: #4C72B0; stroke: #4C72B0; }
.cat2, .cat2 svg { fill: #DD8452; stroke: #DD8452; }
.cat3, .cat3 svg { fill: #55A868; stroke: #55A868; }
.cat4, .cat4 svg { fill: #C44E52; stroke: #C44E52; }
.cat5, .cat5 svg { fill: #8172B3; stroke: #8172B3; }
.cat6, .cat6 svg { fill: #937860; stroke: #937860; }
.cat7, .cat7 svg { fill: #DA8BC3; stroke: #DA8BC3; }
.cat8, .cat8 svg { fill: #8C8C8C; stroke: #8C8C8C; }
.cat9, .cat9 svg { fill: #CCB974; stroke: #CCB974; }
.cat10, .cat10 svg { fill: #64B5CD; stroke: #64B5CD; }
.cat1b, .cat1b svg { fill: #aec7e8; stroke: #aec7e8; }
.cat2b, .cat2b svg { fill: #ffbb78; stroke: #ffbb78; }
.cat3b, .cat3b svg { fill: #98df8a; stroke: #98df8a; }
.cat4b, .cat4b svg { fill: #ff9896; stroke: #ff9896; }
.cat5b, .cat5b svg { fill: #c5b0d5; stroke: #c5b0d5; }
.cat6b, .cat6b svg { fill: #c49c94; stroke: #c49c94; }
.cat7b, .cat7b svg { fill: #f7b6d2; stroke: #f7b6d2; }
.cat8b, .cat8b svg { fill: #c7c7c7; stroke: #c7c7c7; }
.cat9b, .cat9b svg { fill: #dbdb8d; stroke: #dbdb8d; }
.cat10b, .cat10b svg { fill: #9edae5; stroke: #9edae5; }
.cat1c, .cat1c svg { fill: #001C7F; stroke: #001C7F; }
.cat2c, .cat2c svg { fill: #B1400D; stroke: #B1400D; }
.cat3c, .cat3c svg { fill: #12711C; stroke: #12711C; }
.cat4c, .cat4c svg { fill: #8C0800; stroke: #8C0800; }
.cat5c, .cat5c svg { fill: #591E71; stroke: #591E71; }
.cat6c, .cat6c svg { fill: #592F0D; stroke: #592F0D; }
.cat7c, .cat7c svg { fill: #A23582; stroke: #A23582; }
.cat8c, .cat8c svg { fill: #3C3C3C; stroke: #3C3C3C; }
.cat9c, .cat9c svg { fill: #B8850A; stroke: #B8850A; }
.cat10c, .cat10c svg { fill: #006374; stroke: #006374; }
`;
var $a801f2c896bd09f1$var$uiStyles = `
  .pv-edge.pv-selected, .pv-op-marker.pv-selected {
    stroke: rgb(30, 144, 255);
  }
  .vf-notehead.pv-selected {
    fill: rgb(30, 144, 255);
  }
  .vf-notehead.pv-parent {
    fill: rgb(135, 206, 250);
  }
  .pv-selectable {
    cursor: pointer;
  }
`;
var $a801f2c896bd09f1$var$createSvgElt = (name17)=>document.createElementNS("http://www.w3.org/2000/svg", name17);
function $a801f2c896bd09f1$var$addAcc(i2, chord, n) {
    if (n > 0) chord.addModifier(new $a801f2c896bd09f1$var$VF.Accidental("#".repeat(n)), i2);
    if (n < 0) chord.addModifier(new $a801f2c896bd09f1$var$VF.Accidental("b".repeat(-n)), i2);
}
function $a801f2c896bd09f1$var$noteToVex(n) {
    return n.name + "/" + n.oct;
}
function $a801f2c896bd09f1$var$getNoteBBox(noteid, container) {
    let note2 = container.querySelector("#vf-" + CSS.escape(noteid));
    let notebb = $a801f2c896bd09f1$var$getBBox(note2, false, container);
    let slicebb = $a801f2c896bd09f1$var$getBBox(note2.parentElement, false, container);
    return {
        x: slicebb.x,
        y: notebb.y,
        width: slicebb.width,
        height: notebb.height
    };
}
function $a801f2c896bd09f1$var$getBBox(element4, withoutTransforms, toElement) {
    let svg2 = element4.ownerSVGElement;
    if (!svg2) return {
        x: 0,
        y: 0,
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    };
    let r = element4.getBBox();
    if (withoutTransforms) return {
        x: r.x,
        y: r.y,
        width: r.width,
        height: r.height,
        cx: r.x + r.width / 2,
        cy: r.y + r.height / 2
    };
    let p3 = svg2.createSVGPoint();
    let matrix = (toElement || svg2).getScreenCTM().inverse().multiply(element4.getScreenCTM());
    p3.x = r.x;
    p3.y = r.y;
    let a3 = p3.matrixTransform(matrix);
    p3.x = r.x + r.width;
    p3.y = r.y;
    let b3 = p3.matrixTransform(matrix);
    p3.x = r.x + r.width;
    p3.y = r.y + r.height;
    let c3 = p3.matrixTransform(matrix);
    p3.x = r.x;
    p3.y = r.y + r.height;
    let d = p3.matrixTransform(matrix);
    let minX = Math.min(a3.x, b3.x, c3.x, d.x);
    let maxX = Math.max(a3.x, b3.x, c3.x, d.x);
    let minY = Math.min(a3.y, b3.y, c3.y, d.y);
    let maxY = Math.max(a3.y, b3.y, c3.y, d.y);
    let width9 = maxX - minX;
    let height9 = maxY - minY;
    return {
        x: minX,
        y: minY,
        width: width9,
        height: height9,
        cx: minX + width9 / 2,
        cy: minY + height9 / 2
    };
}
// output/ProtoVoices.RenderSVG/index.js
var $a801f2c896bd09f1$var$map37 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$fromFoldable9 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableSet);
var $a801f2c896bd09f1$var$show17 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showRightOrnament);
var $a801f2c896bd09f1$var$show18 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showLeftOrnament);
var $a801f2c896bd09f1$var$show26 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showDoubleOrnament);
var $a801f2c896bd09f1$var$spelledPitch3 = /* @__PURE__ */ $a801f2c896bd09f1$var$spelledPitch($a801f2c896bd09f1$var$spelledSInterval)($a801f2c896bd09f1$var$hasIntervalClassSInterval)($a801f2c896bd09f1$var$spelledSIC);
var $a801f2c896bd09f1$var$letter3 = /* @__PURE__ */ $a801f2c896bd09f1$var$letter($a801f2c896bd09f1$var$spelledPitch3);
var $a801f2c896bd09f1$var$octaves3 = /* @__PURE__ */ $a801f2c896bd09f1$var$octaves($a801f2c896bd09f1$var$spelledPitch3);
var $a801f2c896bd09f1$var$alteration2 = /* @__PURE__ */ $a801f2c896bd09f1$var$alteration($a801f2c896bd09f1$var$spelledPitch3);
var $a801f2c896bd09f1$var$sortWith2 = /* @__PURE__ */ $a801f2c896bd09f1$var$sortWith(/* @__PURE__ */ $a801f2c896bd09f1$var$ordPitch($a801f2c896bd09f1$var$ordSInterval));
var $a801f2c896bd09f1$var$eq19 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRatio($a801f2c896bd09f1$var$eqInt));
var $a801f2c896bd09f1$var$reduce3 = /* @__PURE__ */ $a801f2c896bd09f1$var$reduce($a801f2c896bd09f1$var$ordInt)($a801f2c896bd09f1$var$euclideanRingInt);
var $a801f2c896bd09f1$var$show33 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$fromFoldable14 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$map115 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorList);
var $a801f2c896bd09f1$var$map211 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$mkRenderTrans = function(t2) {
    var innerEdges = function(edges) {
        return $a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$map37(function(edge) {
            if (edge.left instanceof $a801f2c896bd09f1$var$Inner && edge.right instanceof $a801f2c896bd09f1$var$Inner) return new $a801f2c896bd09f1$var$Just({
                left: edge.left.value0,
                right: edge.right.value0
            });
            return $a801f2c896bd09f1$var$Nothing.value;
        })(edges));
    };
    return {
        regular: innerEdges($a801f2c896bd09f1$var$fromFoldable9(t2.edges.regular)),
        passing: innerEdges(t2.edges.passing),
        id: t2.id
    };
};
var $a801f2c896bd09f1$var$encodeExplanation = function(expl) {
    if (expl instanceof $a801f2c896bd09f1$var$NoExpl) return {
        typ: "None",
        parent: $a801f2c896bd09f1$var$nullImpl
    };
    if (expl instanceof $a801f2c896bd09f1$var$RootExpl) return {
        typ: "Root",
        parent: $a801f2c896bd09f1$var$nullImpl
    };
    if (expl instanceof $a801f2c896bd09f1$var$HoriExpl) return {
        typ: "Hori",
        parent: $a801f2c896bd09f1$var$notNull(expl.value0.id)
    };
    if (expl instanceof $a801f2c896bd09f1$var$RightExpl) return {
        typ: function() {
            if (expl.value0.orn instanceof $a801f2c896bd09f1$var$Nothing) return "RightNone";
            if (expl.value0.orn instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$show17(expl.value0.orn.value0);
            throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 165, column 12 - line 167, column 25): " + [
                expl.value0.orn.constructor.name
            ]);
        }(),
        parent: $a801f2c896bd09f1$var$nullImpl
    };
    if (expl instanceof $a801f2c896bd09f1$var$LeftExpl) return {
        typ: function() {
            if (expl.value0.orn instanceof $a801f2c896bd09f1$var$Nothing) return "LeftNone";
            if (expl.value0.orn instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$show18(expl.value0.orn.value0);
            throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 171, column 12 - line 173, column 25): " + [
                expl.value0.orn.constructor.name
            ]);
        }(),
        parent: $a801f2c896bd09f1$var$nullImpl
    };
    if (expl instanceof $a801f2c896bd09f1$var$DoubleExpl) return {
        typ: function() {
            if (expl.value0.orn instanceof $a801f2c896bd09f1$var$Nothing) return "DoubleNone";
            if (expl.value0.orn instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$show26(expl.value0.orn.value0);
            throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 177, column 12 - line 179, column 25): " + [
                expl.value0.orn.constructor.name
            ]);
        }(),
        parent: $a801f2c896bd09f1$var$nullImpl
    };
    throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 160, column 26 - line 181, column 6): " + [
        expl.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$mkRenderSlice = function(toX) {
    return function(slice4) {
        var noteToVex2 = function(n) {
            return {
                id: n.note.id,
                name: $a801f2c896bd09f1$var$letter3(n.note.pitch),
                oct: $a801f2c896bd09f1$var$octaves3(n.note.pitch),
                accs: $a801f2c896bd09f1$var$alteration2(n.note.pitch),
                sel: n,
                expl: $a801f2c896bd09f1$var$encodeExplanation(n.expl)
            };
        };
        return {
            x: toX(slice4.x),
            id: slice4.id,
            notes: $a801f2c896bd09f1$var$map37(noteToVex2)($a801f2c896bd09f1$var$sortWith2(function(v3) {
                return v3.note.pitch;
            })($a801f2c896bd09f1$var$getInnerNotes(slice4)))
        };
    };
};
var $a801f2c896bd09f1$var$renderGraph = function(graph) {
    return function(piece) {
        return function(surface) {
            return function(styles) {
                return function(selection) {
                    return function(selectCallback) {
                        return function(toX) {
                            var mkTime = function(i2) {
                                return function(time3) {
                                    var label5 = function() {
                                        if (time3 instanceof $a801f2c896bd09f1$var$Right) {
                                            var $47 = $a801f2c896bd09f1$var$eq19(time3.value0.s)($a801f2c896bd09f1$var$reduce3(0)(1));
                                            if ($47) return $a801f2c896bd09f1$var$show33(time3.value0.m) + ("." + $a801f2c896bd09f1$var$show33(time3.value0.b));
                                            return "";
                                        }
                                        if (time3 instanceof $a801f2c896bd09f1$var$Left) return time3.value0;
                                        throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 126, column 13 - line 128, column 22): " + [
                                            time3.constructor.name
                                        ]);
                                    }();
                                    return {
                                        x: toX($a801f2c896bd09f1$var$toNumber(i2 + 1 | 0)),
                                        label: label5
                                    };
                                };
                            };
                            var mkGraphSlice = function(s2) {
                                var rs = $a801f2c896bd09f1$var$mkRenderSlice(toX)(s2.slice);
                                return {
                                    depth: s2.depth,
                                    x: rs.x,
                                    id: rs.id,
                                    notes: rs.notes
                                };
                            };
                            return $a801f2c896bd09f1$var$drawGraph({
                                slices: $a801f2c896bd09f1$var$fromFoldable14($a801f2c896bd09f1$var$map115(mkGraphSlice)($a801f2c896bd09f1$var$values2(graph.slices))),
                                surfaceSlices: $a801f2c896bd09f1$var$map37($a801f2c896bd09f1$var$mkRenderSlice(toX))(surface.slices),
                                transitions: $a801f2c896bd09f1$var$fromFoldable14($a801f2c896bd09f1$var$map115($a801f2c896bd09f1$var$mkRenderTrans)($a801f2c896bd09f1$var$values2(graph.transitions))),
                                surfaceTransitions: $a801f2c896bd09f1$var$map37($a801f2c896bd09f1$var$mkRenderTrans)(surface.transs),
                                horis: $a801f2c896bd09f1$var$fromFoldable14(graph.horis),
                                times: $a801f2c896bd09f1$var$mapWithIndex3(mkTime)($a801f2c896bd09f1$var$map37(function(v3) {
                                    return v3.time;
                                })(piece)),
                                maxd: graph.maxd,
                                selection: function() {
                                    if (selection instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$nullImpl;
                                    if (selection instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$notNull({
                                        note: selection.value0.note,
                                        parents: $a801f2c896bd09f1$var$explParents(selection.value0.expl)
                                    });
                                    throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 107, column 16 - line 109, column 75): " + [
                                        selection.constructor.name
                                    ]);
                                }(),
                                select: $a801f2c896bd09f1$var$toNullable($a801f2c896bd09f1$var$map211(function(v3) {
                                    return function($57) {
                                        return v3($a801f2c896bd09f1$var$toMaybe($57));
                                    };
                                })(selectCallback)),
                                styles: $a801f2c896bd09f1$var$stylesToJSON(styles)
                            });
                        };
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$renderScore = function(slices) {
    return function(transitions) {
        return function(toX) {
            return function(staffType) {
                return $a801f2c896bd09f1$var$drawScore($a801f2c896bd09f1$var$map37($a801f2c896bd09f1$var$mkRenderSlice(toX))(slices))($a801f2c896bd09f1$var$map37($a801f2c896bd09f1$var$mkRenderTrans)(transitions))($a801f2c896bd09f1$var$staffType2JS(staffType));
            };
        };
    };
};
// output/ProtoVoices.Validation/index.js
var $a801f2c896bd09f1$var$eq20 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqPitch($a801f2c896bd09f1$var$eqSInterval));
var $a801f2c896bd09f1$var$eq110 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqLeftOrnament));
var $a801f2c896bd09f1$var$eq24 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqRightOrnament));
var $a801f2c896bd09f1$var$eq33 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqDoubleOrnament));
var $a801f2c896bd09f1$var$bind20 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$pure26 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeMaybe);
var $a801f2c896bd09f1$var$foldl9 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$insert10 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert6($a801f2c896bd09f1$var$ordString);
var $a801f2c896bd09f1$var$map38 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$genericShowConstructor4 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor($a801f2c896bd09f1$var$genericShowArgsNoArguments);
var $a801f2c896bd09f1$var$monoidRecord3 = /* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecord();
var $a801f2c896bd09f1$var$ordRecord5 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord();
var $a801f2c896bd09f1$var$ordRecordCons5 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons($a801f2c896bd09f1$var$ordRecordNil)();
var $a801f2c896bd09f1$var$ordStartStop4 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord5(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons5({
    reflectSymbol: function() {
        return "pitch";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$ordPitch($a801f2c896bd09f1$var$ordSInterval)))()({
    reflectSymbol: function() {
        return "id";
    }
})($a801f2c896bd09f1$var$ordString)));
var $a801f2c896bd09f1$var$ordRecord14 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord5(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons5({
    reflectSymbol: function() {
        return "right";
    }
})($a801f2c896bd09f1$var$ordStartStop4))()({
    reflectSymbol: function() {
        return "left";
    }
})($a801f2c896bd09f1$var$ordStartStop4));
var $a801f2c896bd09f1$var$monoidRecord1 = /* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecordCons({
    reflectSymbol: function() {
        return "passing";
    }
})($a801f2c896bd09f1$var$monoidArray)()(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecordCons({
    reflectSymbol: function() {
        return "regular";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidSet($a801f2c896bd09f1$var$ordRecord14))()($a801f2c896bd09f1$var$monoidRecordNil)));
var $a801f2c896bd09f1$var$monoidRecord22 = /* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecordCons({
    reflectSymbol: function() {
        return "ls";
    }
})($a801f2c896bd09f1$var$monoidRecord1)()(/* @__PURE__ */ $a801f2c896bd09f1$var$monoidRecordCons({
    reflectSymbol: function() {
        return "rs";
    }
})($a801f2c896bd09f1$var$monoidRecord1)()($a801f2c896bd09f1$var$monoidRecordNil)));
var $a801f2c896bd09f1$var$fold4 = /* @__PURE__ */ $a801f2c896bd09f1$var$fold($a801f2c896bd09f1$var$foldableArray)($a801f2c896bd09f1$var$monoidRecord22);
var $a801f2c896bd09f1$var$mempty3 = /* @__PURE__ */ $a801f2c896bd09f1$var$mempty($a801f2c896bd09f1$var$monoidRecord22);
var $a801f2c896bd09f1$var$mempty1 = /* @__PURE__ */ $a801f2c896bd09f1$var$mempty($a801f2c896bd09f1$var$monoidRecord1);
var $a801f2c896bd09f1$var$member3 = /* @__PURE__ */ $a801f2c896bd09f1$var$member2($a801f2c896bd09f1$var$ordRecord14);
var $a801f2c896bd09f1$var$discard6 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit)(/* @__PURE__ */ $a801f2c896bd09f1$var$bindStateT($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$modify_4 = /* @__PURE__ */ $a801f2c896bd09f1$var$modify_2(/* @__PURE__ */ $a801f2c896bd09f1$var$monadStateStateT($a801f2c896bd09f1$var$monadIdentity));
var $a801f2c896bd09f1$var$foldl13 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldl($a801f2c896bd09f1$var$foldableSet);
var $a801f2c896bd09f1$var$insert12 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert6($a801f2c896bd09f1$var$ordRecord14);
var $a801f2c896bd09f1$var$applicativeStateT3 = /* @__PURE__ */ $a801f2c896bd09f1$var$applicativeStateT($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$pure111 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeStateT3);
var $a801f2c896bd09f1$var$map116 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorList);
var $a801f2c896bd09f1$var$when2 = /* @__PURE__ */ $a801f2c896bd09f1$var$when($a801f2c896bd09f1$var$applicativeStateT3);
var $a801f2c896bd09f1$var$all5 = /* @__PURE__ */ $a801f2c896bd09f1$var$all($a801f2c896bd09f1$var$foldableSet)($a801f2c896bd09f1$var$heytingAlgebraBoolean);
var $a801f2c896bd09f1$var$insert22 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert6($a801f2c896bd09f1$var$ordSliceId);
var $a801f2c896bd09f1$var$for_2 = /* @__PURE__ */ $a801f2c896bd09f1$var$for_($a801f2c896bd09f1$var$applicativeStateT3)($a801f2c896bd09f1$var$foldableSet);
var $a801f2c896bd09f1$var$SSInvalidReduction = /* @__PURE__ */ function() {
    function SSInvalidReduction2() {}
    SSInvalidReduction2.value = new SSInvalidReduction2();
    return SSInvalidReduction2;
}();
var $a801f2c896bd09f1$var$NSNoExpl = /* @__PURE__ */ function() {
    function NSNoExpl2() {}
    NSNoExpl2.value = new NSNoExpl2();
    return NSNoExpl2;
}();
var $a801f2c896bd09f1$var$NSInvalidExplanation = /* @__PURE__ */ function() {
    function NSInvalidExplanation2() {}
    NSInvalidExplanation2.value = new NSInvalidExplanation2();
    return NSInvalidExplanation2;
}();
var $a801f2c896bd09f1$var$ESNotUsed = /* @__PURE__ */ function() {
    function ESNotUsed2() {}
    ESNotUsed2.value = new ESNotUsed2();
    return ESNotUsed2;
}();
var $a801f2c896bd09f1$var$ESNotStepwise = /* @__PURE__ */ function() {
    function ESNotStepwise2() {}
    ESNotStepwise2.value = new ESNotStepwise2();
    return ESNotStepwise2;
}();
var $a801f2c896bd09f1$var$ESNotRepetition = /* @__PURE__ */ function() {
    function ESNotRepetition2() {}
    ESNotRepetition2.value = new ESNotRepetition2();
    return ESNotRepetition2;
}();
var $a801f2c896bd09f1$var$validationIsOk = function(val) {
    return $a801f2c896bd09f1$var$isEmpty(val.notes) && $a801f2c896bd09f1$var$isEmpty(val.edges) && $a801f2c896bd09f1$var$isEmpty(val.slices);
};
var $a801f2c896bd09f1$var$validateNote = function(note2) {
    var err = function() {
        if (note2.expl instanceof $a801f2c896bd09f1$var$NoExpl) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSNoExpl.value);
        if (note2.expl instanceof $a801f2c896bd09f1$var$RootExpl) return $a801f2c896bd09f1$var$Nothing.value;
        if (note2.expl instanceof $a801f2c896bd09f1$var$HoriExpl) {
            var $152 = $a801f2c896bd09f1$var$eq20(note2.note.pitch)(note2.expl.value0.pitch);
            if ($152) return $a801f2c896bd09f1$var$Nothing.value;
            return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSInvalidExplanation.value);
        }
        if (note2.expl instanceof $a801f2c896bd09f1$var$LeftExpl) {
            if (note2.expl.value0.orn instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSInvalidExplanation.value);
            var $155 = $a801f2c896bd09f1$var$eq110(note2.expl.value0.orn)($a801f2c896bd09f1$var$findLeftOrn(note2.note.pitch)(note2.expl.value0.rightParent));
            if ($155) return $a801f2c896bd09f1$var$Nothing.value;
            return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSInvalidExplanation.value);
        }
        if (note2.expl instanceof $a801f2c896bd09f1$var$RightExpl) {
            if (note2.expl.value0.orn instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSInvalidExplanation.value);
            var $158 = $a801f2c896bd09f1$var$eq24(note2.expl.value0.orn)($a801f2c896bd09f1$var$findRightOrn(note2.note.pitch)(note2.expl.value0.leftParent));
            if ($158) return $a801f2c896bd09f1$var$Nothing.value;
            return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSInvalidExplanation.value);
        }
        if (note2.expl instanceof $a801f2c896bd09f1$var$DoubleExpl) {
            var predOrn = $a801f2c896bd09f1$var$findDoubleOrn(note2.note.pitch)(note2.expl.value0.leftParent)(note2.expl.value0.rightParent);
            if (note2.expl.value0.orn instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSInvalidExplanation.value);
            if (note2.expl.value0.orn instanceof $a801f2c896bd09f1$var$Just && note2.expl.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingLeft) {
                var $161 = $a801f2c896bd09f1$var$eq33(predOrn)(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingLeft.value)) || $a801f2c896bd09f1$var$eq33(predOrn)(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingMid.value));
                if ($161) return $a801f2c896bd09f1$var$Nothing.value;
                return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSInvalidExplanation.value);
            }
            if (note2.expl.value0.orn instanceof $a801f2c896bd09f1$var$Just && note2.expl.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingRight) {
                var $163 = $a801f2c896bd09f1$var$eq33(predOrn)(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingRight.value)) || $a801f2c896bd09f1$var$eq33(predOrn)(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$PassingMid.value));
                if ($163) return $a801f2c896bd09f1$var$Nothing.value;
                return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSInvalidExplanation.value);
            }
            var $165 = $a801f2c896bd09f1$var$eq33(predOrn)(note2.expl.value0.orn);
            if ($165) return $a801f2c896bd09f1$var$Nothing.value;
            return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$NSInvalidExplanation.value);
        }
        throw new Error("Failed pattern match at ProtoVoices.Validation (line 54, column 9 - line 97, column 40): " + [
            note2.expl.constructor.name
        ]);
    }();
    return $a801f2c896bd09f1$var$bind20(err)(function(stat) {
        return $a801f2c896bd09f1$var$pure26({
            id: note2.note.id,
            stat: stat
        });
    });
};
var $a801f2c896bd09f1$var$validateSlice = function(slice4) {
    return function(st) {
        var notes$prime = function() {
            if (slice4.notes instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$foldl9(function(mp) {
                return function(v3) {
                    return $a801f2c896bd09f1$var$insert10(v3.id)(v3.stat)(mp);
                };
            })(st.notes)($a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$map38($a801f2c896bd09f1$var$validateNote)(slice4.notes.value0)));
            return st.notes;
        }();
        return {
            edges: st.edges,
            slices: st.slices,
            notes: notes$prime
        };
    };
};
var $a801f2c896bd09f1$var$genericSliceError = {
    to: function(x4) {
        return $a801f2c896bd09f1$var$SSInvalidReduction.value;
    },
    from: function(x4) {
        return $a801f2c896bd09f1$var$NoArguments.value;
    }
};
var $a801f2c896bd09f1$var$genericShow8 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericSliceError)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor4({
    reflectSymbol: function() {
        return "SSInvalidReduction";
    }
}));
var $a801f2c896bd09f1$var$showSliceError = {
    show: function(ns) {
        return $a801f2c896bd09f1$var$genericShow8(ns);
    }
};
var $a801f2c896bd09f1$var$genericNoteError = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$NSNoExpl.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr) return $a801f2c896bd09f1$var$NSInvalidExplanation.value;
        throw new Error("Failed pattern match at ProtoVoices.Validation (line 174, column 1 - line 174, column 56): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$NSNoExpl) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$NSInvalidExplanation) return new $a801f2c896bd09f1$var$Inr($a801f2c896bd09f1$var$NoArguments.value);
        throw new Error("Failed pattern match at ProtoVoices.Validation (line 174, column 1 - line 174, column 56): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow13 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericNoteError)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor4({
    reflectSymbol: function() {
        return "NSNoExpl";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor4({
    reflectSymbol: function() {
        return "NSInvalidExplanation";
    }
})));
var $a801f2c896bd09f1$var$showNoteError = {
    show: function(ns) {
        return $a801f2c896bd09f1$var$genericShow13(ns);
    }
};
var $a801f2c896bd09f1$var$genericEdgeError = {
    to: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$ESNotUsed.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inl) return $a801f2c896bd09f1$var$ESNotStepwise.value;
        if (x4 instanceof $a801f2c896bd09f1$var$Inr && x4.value0 instanceof $a801f2c896bd09f1$var$Inr) return $a801f2c896bd09f1$var$ESNotRepetition.value;
        throw new Error("Failed pattern match at ProtoVoices.Validation (line 184, column 1 - line 184, column 56): " + [
            x4.constructor.name
        ]);
    },
    from: function(x4) {
        if (x4 instanceof $a801f2c896bd09f1$var$ESNotUsed) return new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value);
        if (x4 instanceof $a801f2c896bd09f1$var$ESNotStepwise) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inl($a801f2c896bd09f1$var$NoArguments.value));
        if (x4 instanceof $a801f2c896bd09f1$var$ESNotRepetition) return new $a801f2c896bd09f1$var$Inr(new $a801f2c896bd09f1$var$Inr($a801f2c896bd09f1$var$NoArguments.value));
        throw new Error("Failed pattern match at ProtoVoices.Validation (line 184, column 1 - line 184, column 56): " + [
            x4.constructor.name
        ]);
    }
};
var $a801f2c896bd09f1$var$genericShow24 = /* @__PURE__ */ $a801f2c896bd09f1$var$genericShow($a801f2c896bd09f1$var$genericEdgeError)(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor4({
    reflectSymbol: function() {
        return "ESNotUsed";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowSum(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor4({
    reflectSymbol: function() {
        return "ESNotStepwise";
    }
}))(/* @__PURE__ */ $a801f2c896bd09f1$var$genericShowConstructor4({
    reflectSymbol: function() {
        return "ESNotRepetition";
    }
}))));
var $a801f2c896bd09f1$var$showEdgeError = {
    show: function(ns) {
        return $a801f2c896bd09f1$var$genericShow24(ns);
    }
};
var $a801f2c896bd09f1$var$eqSliceError = {
    eq: function(x4) {
        return function(y4) {
            return true;
        };
    }
};
var $a801f2c896bd09f1$var$eqEdgeError = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$ESNotUsed && y4 instanceof $a801f2c896bd09f1$var$ESNotUsed) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$ESNotStepwise && y4 instanceof $a801f2c896bd09f1$var$ESNotStepwise) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$ESNotRepetition && y4 instanceof $a801f2c896bd09f1$var$ESNotRepetition) return true;
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$ordEdgeError = {
    compare: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$ESNotUsed && y4 instanceof $a801f2c896bd09f1$var$ESNotUsed) return $a801f2c896bd09f1$var$EQ.value;
            if (x4 instanceof $a801f2c896bd09f1$var$ESNotUsed) return $a801f2c896bd09f1$var$LT.value;
            if (y4 instanceof $a801f2c896bd09f1$var$ESNotUsed) return $a801f2c896bd09f1$var$GT.value;
            if (x4 instanceof $a801f2c896bd09f1$var$ESNotStepwise && y4 instanceof $a801f2c896bd09f1$var$ESNotStepwise) return $a801f2c896bd09f1$var$EQ.value;
            if (x4 instanceof $a801f2c896bd09f1$var$ESNotStepwise) return $a801f2c896bd09f1$var$LT.value;
            if (y4 instanceof $a801f2c896bd09f1$var$ESNotStepwise) return $a801f2c896bd09f1$var$GT.value;
            if (x4 instanceof $a801f2c896bd09f1$var$ESNotRepetition && y4 instanceof $a801f2c896bd09f1$var$ESNotRepetition) return $a801f2c896bd09f1$var$EQ.value;
            throw new Error("Failed pattern match at ProtoVoices.Validation (line 0, column 0 - line 0, column 0): " + [
                x4.constructor.name,
                y4.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a801f2c896bd09f1$var$eqEdgeError;
    }
};
var $a801f2c896bd09f1$var$ordRecord24 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord5(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons5({
    reflectSymbol: function() {
        return "stat";
    }
})($a801f2c896bd09f1$var$ordEdgeError))()({
    reflectSymbol: function() {
        return "edge";
    }
})($a801f2c896bd09f1$var$ordRecord14));
var $a801f2c896bd09f1$var$ordMaybe2 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordMaybe($a801f2c896bd09f1$var$ordRecord24);
var $a801f2c896bd09f1$var$map212 = /* @__PURE__ */ $a801f2c896bd09f1$var$map18($a801f2c896bd09f1$var$ordMaybe2);
var $a801f2c896bd09f1$var$catMaybes5 = /* @__PURE__ */ $a801f2c896bd09f1$var$catMaybes3($a801f2c896bd09f1$var$ordRecord24);
var $a801f2c896bd09f1$var$append7 = /* @__PURE__ */ $a801f2c896bd09f1$var$append(/* @__PURE__ */ $a801f2c896bd09f1$var$semigroupSet($a801f2c896bd09f1$var$ordMaybe2));
var $a801f2c896bd09f1$var$validationAlg = /* @__PURE__ */ function() {
    var splitLeft = function(v3) {
        return function(v1) {
            return function(v22) {
                var usedEdges = $a801f2c896bd09f1$var$fold4($a801f2c896bd09f1$var$map38(function(v32) {
                    if (v32.expl instanceof $a801f2c896bd09f1$var$DoubleExpl) {
                        var redge = {
                            left: new $a801f2c896bd09f1$var$Inner(v32.note),
                            right: new $a801f2c896bd09f1$var$Inner(v32.expl.value0.rightParent)
                        };
                        var ledge = {
                            left: new $a801f2c896bd09f1$var$Inner(v32.expl.value0.leftParent),
                            right: new $a801f2c896bd09f1$var$Inner(v32.note)
                        };
                        if (v32.expl.value0.orn instanceof $a801f2c896bd09f1$var$Just && v32.expl.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingLeft) return {
                            ls: $a801f2c896bd09f1$var$regularEdge(ledge),
                            rs: $a801f2c896bd09f1$var$passingEdge(redge)
                        };
                        if (v32.expl.value0.orn instanceof $a801f2c896bd09f1$var$Just && v32.expl.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingRight) return {
                            ls: $a801f2c896bd09f1$var$passingEdge(ledge),
                            rs: $a801f2c896bd09f1$var$regularEdge(redge)
                        };
                        if (v32.expl.value0.orn instanceof $a801f2c896bd09f1$var$Just) return {
                            ls: $a801f2c896bd09f1$var$regularEdge(ledge),
                            rs: $a801f2c896bd09f1$var$regularEdge(redge)
                        };
                        return $a801f2c896bd09f1$var$mempty3;
                    }
                    if (v32.expl instanceof $a801f2c896bd09f1$var$LeftExpl) return {
                        ls: $a801f2c896bd09f1$var$mempty1,
                        rs: $a801f2c896bd09f1$var$regularEdge({
                            left: new $a801f2c896bd09f1$var$Inner(v32.note),
                            right: new $a801f2c896bd09f1$var$Inner(v32.expl.value0.rightParent)
                        })
                    };
                    if (v32.expl instanceof $a801f2c896bd09f1$var$RightExpl) return {
                        rs: $a801f2c896bd09f1$var$mempty1,
                        ls: $a801f2c896bd09f1$var$regularEdge({
                            left: new $a801f2c896bd09f1$var$Inner(v32.expl.value0.leftParent),
                            right: new $a801f2c896bd09f1$var$Inner(v32.note)
                        })
                    };
                    return $a801f2c896bd09f1$var$mempty3;
                })($a801f2c896bd09f1$var$getInnerNotes(v22.childl.rslice)));
                var checkUsed = function(used) {
                    return function(toCheck) {
                        return $a801f2c896bd09f1$var$map212(function(edge) {
                            var $215 = $a801f2c896bd09f1$var$member3(edge)(used);
                            if ($215) return $a801f2c896bd09f1$var$Nothing.value;
                            return new $a801f2c896bd09f1$var$Just({
                                edge: edge,
                                stat: $a801f2c896bd09f1$var$ESNotUsed.value
                            });
                        })(toCheck);
                    };
                };
                var leftChildrenReg = checkUsed(usedEdges.ls.regular)(v22.childl.trans.edges.regular);
                var rightChildrenReg = checkUsed(usedEdges.rs.regular)(v22.childr.trans.edges.regular);
                var allChildren = $a801f2c896bd09f1$var$catMaybes5($a801f2c896bd09f1$var$append7(leftChildrenReg)(rightChildrenReg));
                return $a801f2c896bd09f1$var$discard6($a801f2c896bd09f1$var$modify_4(function(st) {
                    var $219 = {};
                    for(var $220 in st)if (({}).hasOwnProperty.call(st, $220)) $219[$220] = st[$220];
                    $219.edges = $a801f2c896bd09f1$var$foldl13(function(mp) {
                        return function(v4) {
                            return $a801f2c896bd09f1$var$insert12(v4.edge)(v4.stat)(mp);
                        };
                    })(st.edges)(allChildren);
                    return $219;
                }))(function() {
                    return $a801f2c896bd09f1$var$pure111($a801f2c896bd09f1$var$map116($a801f2c896bd09f1$var$nothingMore)(new $a801f2c896bd09f1$var$Cons(v22.childl, new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(v22.childr)(v1.seg.rslice), $a801f2c896bd09f1$var$Nil.value))));
                });
            };
        };
    };
    var splitRight = function(lSlice) {
        return function(v3) {
            return splitLeft(lSlice);
        };
    };
    var init3 = function(_start) {
        return $a801f2c896bd09f1$var$pure111($a801f2c896bd09f1$var$unit);
    };
    var hori = function(v3) {
        return function(v1) {
            return function(v22) {
                return function(v32) {
                    return $a801f2c896bd09f1$var$discard6($a801f2c896bd09f1$var$modify_4($a801f2c896bd09f1$var$validateSlice(v1.seg.rslice)))(function() {
                        return $a801f2c896bd09f1$var$discard6($a801f2c896bd09f1$var$when2(!$a801f2c896bd09f1$var$all5($a801f2c896bd09f1$var$isRepeatingEdge)(v32.childm.trans.edges.regular))($a801f2c896bd09f1$var$modify_4(function(st) {
                            var $229 = {};
                            for(var $230 in st)if (({}).hasOwnProperty.call(st, $230)) $229[$230] = st[$230];
                            $229.slices = $a801f2c896bd09f1$var$insert22(v1.seg.rslice.id)($a801f2c896bd09f1$var$SSInvalidReduction.value)(st.slices);
                            return $229;
                        })))(function() {
                            return $a801f2c896bd09f1$var$discard6($a801f2c896bd09f1$var$for_2(v32.childm.trans.edges.regular)(function(edge) {
                                return $a801f2c896bd09f1$var$when2(!$a801f2c896bd09f1$var$isRepeatingEdge(edge))($a801f2c896bd09f1$var$modify_4(function(st) {
                                    var $232 = {};
                                    for(var $233 in st)if (({}).hasOwnProperty.call(st, $233)) $232[$233] = st[$233];
                                    $232.edges = $a801f2c896bd09f1$var$insert12(edge)($a801f2c896bd09f1$var$ESNotRepetition.value)(st.edges);
                                    return $232;
                                }));
                            }))(function() {
                                return $a801f2c896bd09f1$var$pure111($a801f2c896bd09f1$var$map116($a801f2c896bd09f1$var$nothingMore)(new $a801f2c896bd09f1$var$Cons(v32.childl, new $a801f2c896bd09f1$var$Cons(v32.childm, new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$attachSegment(v32.childr)(v22.seg.rslice), $a801f2c896bd09f1$var$Nil.value)))));
                            });
                        });
                    });
                };
            };
        };
    };
    var freezeLeft = function(v3) {
        return function(v1) {
            return $a801f2c896bd09f1$var$modify_4($a801f2c896bd09f1$var$validateSlice(v1.seg.rslice));
        };
    };
    return {
        init: init3,
        freezeLeft: freezeLeft,
        freezeOnly: freezeLeft,
        splitLeft: splitLeft,
        splitOnly: splitLeft,
        splitRight: splitRight,
        hori: hori
    };
}();
var $a801f2c896bd09f1$var$validateReduction = function(red) {
    var emptyVal = {
        notes: $a801f2c896bd09f1$var$empty3,
        edges: $a801f2c896bd09f1$var$empty3,
        slices: $a801f2c896bd09f1$var$empty3
    };
    var agenda = $a801f2c896bd09f1$var$map116($a801f2c896bd09f1$var$nothingMore)(red.segments);
    return $a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$execState)(emptyVal)($a801f2c896bd09f1$var$walkGraph($a801f2c896bd09f1$var$validationAlg)(red.start)(agenda));
};
// output/Web.UIEvent.MouseEvent/foreign.js
function $a801f2c896bd09f1$var$ctrlKey(e) {
    return e.ctrlKey;
}
function $a801f2c896bd09f1$var$shiftKey(e) {
    return e.shiftKey;
}
// output/App.Render/index.js
var $a801f2c896bd09f1$var$value3 = /* @__PURE__ */ $a801f2c896bd09f1$var$value($a801f2c896bd09f1$var$isPropString);
var $a801f2c896bd09f1$var$map39 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$append8 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$pitchIsSymbol3 = {
    reflectSymbol: function() {
        return "pitch";
    }
};
var $a801f2c896bd09f1$var$idIsSymbol3 = {
    reflectSymbol: function() {
        return "id";
    }
};
var $a801f2c896bd09f1$var$eq21 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec()(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons($a801f2c896bd09f1$var$eqRowNil)()($a801f2c896bd09f1$var$pitchIsSymbol3)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqPitch($a801f2c896bd09f1$var$eqSInterval)))()($a801f2c896bd09f1$var$idIsSymbol3)($a801f2c896bd09f1$var$eqString)));
var $a801f2c896bd09f1$var$showPitch2 = /* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval);
var $a801f2c896bd09f1$var$show19 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showPitch2);
var $a801f2c896bd09f1$var$show110 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showLeftOrnament);
var $a801f2c896bd09f1$var$show27 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showRightOrnament);
var $a801f2c896bd09f1$var$show34 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showDoubleOrnament);
var $a801f2c896bd09f1$var$lookup5 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordTransId);
var $a801f2c896bd09f1$var$eq111 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqOuterSelection);
var $a801f2c896bd09f1$var$bind21 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$lookup1 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordSliceId);
var $a801f2c896bd09f1$var$lookup22 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3(/* @__PURE__ */ $a801f2c896bd09f1$var$ordTuple($a801f2c896bd09f1$var$ordString)($a801f2c896bd09f1$var$ordString));
var $a801f2c896bd09f1$var$ordRecord6 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord();
var $a801f2c896bd09f1$var$ordRecordCons6 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons($a801f2c896bd09f1$var$ordRecordNil)();
var $a801f2c896bd09f1$var$ordStartStop5 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons6($a801f2c896bd09f1$var$pitchIsSymbol3)(/* @__PURE__ */ $a801f2c896bd09f1$var$ordPitch($a801f2c896bd09f1$var$ordSInterval)))()($a801f2c896bd09f1$var$idIsSymbol3)($a801f2c896bd09f1$var$ordString)));
var $a801f2c896bd09f1$var$lookup32 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecord6(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons(/* @__PURE__ */ $a801f2c896bd09f1$var$ordRecordCons6({
    reflectSymbol: function() {
        return "right";
    }
})($a801f2c896bd09f1$var$ordStartStop5))()({
    reflectSymbol: function() {
        return "left";
    }
})($a801f2c896bd09f1$var$ordStartStop5)));
var $a801f2c896bd09f1$var$fromFoldable10 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableSet);
var $a801f2c896bd09f1$var$fromFoldable15 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$show44 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showTransId);
var $a801f2c896bd09f1$var$pure27 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeMaybe);
var $a801f2c896bd09f1$var$eq34 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqSliceError));
var $a801f2c896bd09f1$var$elem3 = /* @__PURE__ */ $a801f2c896bd09f1$var$elem2($a801f2c896bd09f1$var$eqSliceId);
var $a801f2c896bd09f1$var$lookup42 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordString);
var $a801f2c896bd09f1$var$showRecord7 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord()();
var $a801f2c896bd09f1$var$show53 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord7(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "expl";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "note";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord7(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$idIsSymbol3)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$pitchIsSymbol3)($a801f2c896bd09f1$var$showPitch2))($a801f2c896bd09f1$var$showString))))($a801f2c896bd09f1$var$showNoteExplanation)))));
var $a801f2c896bd09f1$var$eq43 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRatio($a801f2c896bd09f1$var$eqInt));
var $a801f2c896bd09f1$var$reduce4 = /* @__PURE__ */ $a801f2c896bd09f1$var$reduce($a801f2c896bd09f1$var$ordInt)($a801f2c896bd09f1$var$euclideanRingInt);
var $a801f2c896bd09f1$var$show62 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$fromFoldable24 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$NotSelected = /* @__PURE__ */ function() {
    function NotSelected2() {}
    NotSelected2.value = new NotSelected2();
    return NotSelected2;
}();
var $a801f2c896bd09f1$var$Selected = /* @__PURE__ */ function() {
    function Selected2() {}
    Selected2.value = new Selected2();
    return Selected2;
}();
var $a801f2c896bd09f1$var$Related = /* @__PURE__ */ function() {
    function Related2() {}
    Related2.value = new Related2();
    return Related2;
}();
var $a801f2c896bd09f1$var$white = /* @__PURE__ */ function() {
    return new $a801f2c896bd09f1$var$RGB(255, 255, 255);
}();
var $a801f2c896bd09f1$var$warnColor = /* @__PURE__ */ function() {
    return new $a801f2c896bd09f1$var$RGB(255, 165, 0);
}();
var $a801f2c896bd09f1$var$sliceDistance = 70;
var $a801f2c896bd09f1$var$selColorOuter = /* @__PURE__ */ function() {
    return new $a801f2c896bd09f1$var$RGB(30, 144, 255);
}();
var $a801f2c896bd09f1$var$selColorInner = $a801f2c896bd09f1$var$selColorOuter;
var $a801f2c896bd09f1$var$scoreScale = 0.9;
var $a801f2c896bd09f1$var$scoreHeight = 150;
var $a801f2c896bd09f1$var$scaley = function(v3) {
    return function(y4) {
        return y4 * 100 * $a801f2c896bd09f1$var$exp(v3.yscale);
    };
};
var $a801f2c896bd09f1$var$scalex = function(v3) {
    return function(x4) {
        return x4 * $a801f2c896bd09f1$var$sliceDistance * $a801f2c896bd09f1$var$exp(v3.xscale);
    };
};
var $a801f2c896bd09f1$var$offset = function(i2) {
    return $a801f2c896bd09f1$var$toNumber(i2) * 20;
};
var $a801f2c896bd09f1$var$noteSize = 29;
var $a801f2c896bd09f1$var$mkOption = function(updateAction) {
    return function(v3) {
        return $a801f2c896bd09f1$var$option2([
            $a801f2c896bd09f1$var$value3(v3.v),
            $a801f2c896bd09f1$var$selected(v3.s),
            $a801f2c896bd09f1$var$onClick(function(v22) {
                return updateAction(v3.k);
            })
        ])([
            $a801f2c896bd09f1$var$text(v3.v)
        ]);
    };
};
var $a801f2c896bd09f1$var$mkSelect = function(dictEq) {
    var eq62 = $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqMaybe(dictEq));
    return function(updateAction) {
        return function(showValue) {
            return function(value1) {
                return function(opts) {
                    var options2 = $a801f2c896bd09f1$var$map39($a801f2c896bd09f1$var$mkOption(updateAction))($a801f2c896bd09f1$var$append8([
                        {
                            k: $a801f2c896bd09f1$var$Nothing.value,
                            v: "Nothing",
                            s: false
                        }
                    ])($a801f2c896bd09f1$var$map39(function(o2) {
                        return {
                            k: new $a801f2c896bd09f1$var$Just(o2),
                            v: showValue(o2),
                            s: eq62(new $a801f2c896bd09f1$var$Just(o2))(value1)
                        };
                    })(opts)));
                    return $a801f2c896bd09f1$var$select_(options2);
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$mkSelect1 = /* @__PURE__ */ $a801f2c896bd09f1$var$mkSelect($a801f2c896bd09f1$var$eqLeftOrnament);
var $a801f2c896bd09f1$var$mkSelect2 = /* @__PURE__ */ $a801f2c896bd09f1$var$mkSelect($a801f2c896bd09f1$var$eqRightOrnament);
var $a801f2c896bd09f1$var$mkSelect3 = /* @__PURE__ */ $a801f2c896bd09f1$var$mkSelect($a801f2c896bd09f1$var$eqDoubleOrnament);
var $a801f2c896bd09f1$var$mkSelect$prime = function(dictEq) {
    var eq62 = $a801f2c896bd09f1$var$eq(dictEq);
    return function(updateAction) {
        return function(showValue) {
            return function(value1) {
                return function(opts) {
                    var options2 = $a801f2c896bd09f1$var$map39($a801f2c896bd09f1$var$mkOption(updateAction))($a801f2c896bd09f1$var$map39(function(o2) {
                        return {
                            k: o2,
                            v: showValue(o2),
                            s: eq62(o2)(value1)
                        };
                    })(opts));
                    return $a801f2c896bd09f1$var$select_(options2);
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$lightgray = /* @__PURE__ */ function() {
    return new $a801f2c896bd09f1$var$RGB(211, 211, 211);
}();
var $a801f2c896bd09f1$var$findPitchIndex = function(v3) {
    return function(v1) {
        if (v3 instanceof $a801f2c896bd09f1$var$Inner && v1 instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$fromMaybe(-1)($a801f2c896bd09f1$var$findIndex2(function(n) {
            return $a801f2c896bd09f1$var$eq21(n.note)(v3.value0);
        })(v1.value0));
        return 0;
    };
};
var $a801f2c896bd09f1$var$eqSelectionStatus = {
    eq: function(x4) {
        return function(y4) {
            if (x4 instanceof $a801f2c896bd09f1$var$NotSelected && y4 instanceof $a801f2c896bd09f1$var$NotSelected) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$Selected && y4 instanceof $a801f2c896bd09f1$var$Selected) return true;
            if (x4 instanceof $a801f2c896bd09f1$var$Related && y4 instanceof $a801f2c896bd09f1$var$Related) return true;
            return false;
        };
    }
};
var $a801f2c896bd09f1$var$eq52 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqSelectionStatus);
var $a801f2c896bd09f1$var$doubleOrnaments = /* @__PURE__ */ function() {
    return [
        $a801f2c896bd09f1$var$FullNeighbor.value,
        $a801f2c896bd09f1$var$FullRepeat.value,
        $a801f2c896bd09f1$var$LeftRepeatOfRight.value,
        $a801f2c896bd09f1$var$RightRepeatOfLeft.value,
        $a801f2c896bd09f1$var$PassingMid.value,
        $a801f2c896bd09f1$var$PassingLeft.value,
        $a801f2c896bd09f1$var$PassingRight.value
    ];
}();
var $a801f2c896bd09f1$var$renderNoteExplanation = function(_graph) {
    return function(note2) {
        return function(expl) {
            return function(_parents) {
                return $a801f2c896bd09f1$var$div5([
                    $a801f2c896bd09f1$var$class_2("pure-g"),
                    $a801f2c896bd09f1$var$style("height:30px;")
                ])($a801f2c896bd09f1$var$append8([
                    $a801f2c896bd09f1$var$label([
                        $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                    ])([
                        $a801f2c896bd09f1$var$text("Note selected: " + $a801f2c896bd09f1$var$show19(note2.pitch))
                    ])
                ])(function() {
                    if (expl instanceof $a801f2c896bd09f1$var$NoExpl) return [
                        $a801f2c896bd09f1$var$label([
                            $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                        ])([
                            $a801f2c896bd09f1$var$text("no parents")
                        ])
                    ];
                    if (expl instanceof $a801f2c896bd09f1$var$RootExpl) return [
                        $a801f2c896bd09f1$var$label([
                            $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                        ])([
                            $a801f2c896bd09f1$var$text("root note")
                        ])
                    ];
                    if (expl instanceof $a801f2c896bd09f1$var$HoriExpl) return [
                        $a801f2c896bd09f1$var$button([
                            $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-24"),
                            $a801f2c896bd09f1$var$onClick(function(v3) {
                                return $a801f2c896bd09f1$var$removeParent(note2)(expl)($a801f2c896bd09f1$var$setHoriExplParent);
                            })
                        ])([
                            $a801f2c896bd09f1$var$text("x")
                        ]),
                        $a801f2c896bd09f1$var$label([
                            $a801f2c896bd09f1$var$class_2("pure-u-5-24")
                        ])([
                            $a801f2c896bd09f1$var$text(" parent: " + $a801f2c896bd09f1$var$show19(expl.value0.pitch))
                        ])
                    ];
                    if (expl instanceof $a801f2c896bd09f1$var$LeftExpl) return [
                        $a801f2c896bd09f1$var$div5([
                            $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                        ])([]),
                        $a801f2c896bd09f1$var$div5([
                            $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                        ])([
                            $a801f2c896bd09f1$var$mkSelect1(function(orn$prime) {
                                return new $a801f2c896bd09f1$var$SetNoteExplanation({
                                    noteId: note2.id,
                                    expl: new $a801f2c896bd09f1$var$LeftExpl({
                                        rightParent: expl.value0.rightParent,
                                        orn: orn$prime
                                    })
                                });
                            })($a801f2c896bd09f1$var$show110)(expl.value0.orn)([
                                $a801f2c896bd09f1$var$LeftRepeat.value,
                                $a801f2c896bd09f1$var$LeftNeighbor.value
                            ])
                        ]),
                        $a801f2c896bd09f1$var$button([
                            $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-24"),
                            $a801f2c896bd09f1$var$onClick(function(v3) {
                                return $a801f2c896bd09f1$var$removeParent(note2)(expl)($a801f2c896bd09f1$var$setRightExplParent);
                            })
                        ])([
                            $a801f2c896bd09f1$var$text("x")
                        ]),
                        $a801f2c896bd09f1$var$label([
                            $a801f2c896bd09f1$var$class_2("pure-u-5-24")
                        ])([
                            $a801f2c896bd09f1$var$text(" right parent: " + $a801f2c896bd09f1$var$show19(expl.value0.rightParent.pitch))
                        ])
                    ];
                    if (expl instanceof $a801f2c896bd09f1$var$RightExpl) return [
                        $a801f2c896bd09f1$var$button([
                            $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-24"),
                            $a801f2c896bd09f1$var$onClick(function(v3) {
                                return $a801f2c896bd09f1$var$removeParent(note2)(expl)($a801f2c896bd09f1$var$setLeftExplParent);
                            })
                        ])([
                            $a801f2c896bd09f1$var$text("x")
                        ]),
                        $a801f2c896bd09f1$var$label([
                            $a801f2c896bd09f1$var$class_2("pure-u-5-24")
                        ])([
                            $a801f2c896bd09f1$var$text(" left parent: " + $a801f2c896bd09f1$var$show19(expl.value0.leftParent.pitch))
                        ]),
                        $a801f2c896bd09f1$var$div5([
                            $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                        ])([
                            $a801f2c896bd09f1$var$mkSelect2(function(orn$prime) {
                                return new $a801f2c896bd09f1$var$SetNoteExplanation({
                                    noteId: note2.id,
                                    expl: new $a801f2c896bd09f1$var$RightExpl({
                                        leftParent: expl.value0.leftParent,
                                        orn: orn$prime
                                    })
                                });
                            })($a801f2c896bd09f1$var$show27)(expl.value0.orn)([
                                $a801f2c896bd09f1$var$RightRepeat.value,
                                $a801f2c896bd09f1$var$RightNeighbor.value
                            ])
                        ])
                    ];
                    if (expl instanceof $a801f2c896bd09f1$var$DoubleExpl) return [
                        $a801f2c896bd09f1$var$button([
                            $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-24"),
                            $a801f2c896bd09f1$var$onClick(function(v3) {
                                return $a801f2c896bd09f1$var$removeParent(note2)(expl)($a801f2c896bd09f1$var$setLeftExplParent);
                            })
                        ])([
                            $a801f2c896bd09f1$var$text("x")
                        ]),
                        $a801f2c896bd09f1$var$label([
                            $a801f2c896bd09f1$var$class_2("pure-u-5-24")
                        ])([
                            $a801f2c896bd09f1$var$text(" left parent: " + $a801f2c896bd09f1$var$show19(expl.value0.leftParent.pitch))
                        ]),
                        $a801f2c896bd09f1$var$div5([
                            $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                        ])([
                            $a801f2c896bd09f1$var$mkSelect3(function(orn$prime) {
                                return new $a801f2c896bd09f1$var$SetNoteExplanation({
                                    noteId: note2.id,
                                    expl: new $a801f2c896bd09f1$var$DoubleExpl({
                                        leftParent: expl.value0.leftParent,
                                        rightParent: expl.value0.rightParent,
                                        orn: orn$prime
                                    })
                                });
                            })($a801f2c896bd09f1$var$show34)(expl.value0.orn)($a801f2c896bd09f1$var$doubleOrnaments)
                        ]),
                        $a801f2c896bd09f1$var$button([
                            $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-24"),
                            $a801f2c896bd09f1$var$onClick(function(v3) {
                                return $a801f2c896bd09f1$var$removeParent(note2)(expl)($a801f2c896bd09f1$var$setRightExplParent);
                            })
                        ])([
                            $a801f2c896bd09f1$var$text("x")
                        ]),
                        $a801f2c896bd09f1$var$label([
                            $a801f2c896bd09f1$var$class_2("pure-u-5-24")
                        ])([
                            $a801f2c896bd09f1$var$text(" right parent: " + $a801f2c896bd09f1$var$show19(expl.value0.rightParent.pitch))
                        ])
                    ];
                    throw new Error("Failed pattern match at App.Render (line 532, column 12 - line 571, column 14): " + [
                        expl.constructor.name
                    ]);
                }()));
            };
        };
    };
};
var $a801f2c896bd09f1$var$defaultCSS2 = /* @__PURE__ */ function() {
    return "\n@layer defaults, userstyles, ui;\n@layer defaults {\n  .node {\n    fill: white;\n  }\n  .slice {\n    fill: lightgray;\n  }\n  .transition {\n    stroke: lightgray;\n  }\n  .test {\n    fill: red;\n  }\n" + ($a801f2c896bd09f1$var$defaultStyles + "\n}\n@layer ui {\n  .node {\n    stroke: none;\n  }\n  .slice {\n    rx: 5px;\n    stroke: none;\n  }\n\n  .hidden {\n    display: inline !important;\n    stroke: lightgray;\n  }\n\n  .selected {\n    fill: #1e90ff;\n  }\n  .related {\n    fill: #87cefa;\n  }\n  .warning {\n    fill: #ffa500;\n  }\n  .error {\n    fill: red;\n  }\n\n\n  .transition.selected, .edge.selected {\n    stroke: #1e90ff;\n  }\n  .edge.warning {\n    stroke: #ffa500;\n  }\n  .edge.error {\n    stroke: red;\n  }\n}\n");
}();
var $a801f2c896bd09f1$var$cursor = /* @__PURE__ */ $a801f2c896bd09f1$var$attr2("cursor");
var $a801f2c896bd09f1$var$renderTrans = function(sett) {
    return function(selection) {
        return function(validation) {
            return function(styles) {
                return function(slices) {
                    return function(v3) {
                        var transStyle = $a801f2c896bd09f1$var$lookup5(v3.id)(styles.transitions);
                        var transSelected = $a801f2c896bd09f1$var$eq111(selection)(new $a801f2c896bd09f1$var$SelTrans(v3.id));
                        var transLabel = $a801f2c896bd09f1$var$maybe("")(function(v1) {
                            return v1.label;
                        })(transStyle);
                        var transClasses = $a801f2c896bd09f1$var$maybe("")(function(v1) {
                            return v1.classes;
                        })(transStyle);
                        var selectionAttr = [
                            $a801f2c896bd09f1$var$cursor("pointer"),
                            $a801f2c896bd09f1$var$onClick(function(v1) {
                                return new $a801f2c896bd09f1$var$Select(function() {
                                    if (transSelected) return $a801f2c896bd09f1$var$SelNone.value;
                                    return new $a801f2c896bd09f1$var$SelTrans(v3.id);
                                }());
                            })
                        ];
                        return $a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$text(""))($a801f2c896bd09f1$var$bind21($a801f2c896bd09f1$var$lookup1(v3.left)(slices))(function(v1) {
                            return $a801f2c896bd09f1$var$bind21($a801f2c896bd09f1$var$lookup1(v3.right)(slices))(function(v22) {
                                var topLevel = v1.depth === 0 && v22.depth === 0;
                                var mkedge = function(isPassing) {
                                    return function(v32) {
                                        var x22 = $a801f2c896bd09f1$var$scalex(sett)(v22.slice.x);
                                        var x12 = $a801f2c896bd09f1$var$scalex(sett)(v1.slice.x);
                                        var offr = $a801f2c896bd09f1$var$findPitchIndex(v32.right)(v22.slice.notes);
                                        var y22 = $a801f2c896bd09f1$var$scaley(sett)(v22.depth) + $a801f2c896bd09f1$var$offset(offr);
                                        var offl = $a801f2c896bd09f1$var$findPitchIndex(v32.left)(v1.slice.notes);
                                        var y12 = $a801f2c896bd09f1$var$scaley(sett)(v1.depth) + $a801f2c896bd09f1$var$offset(offl);
                                        var edgeStyle = $a801f2c896bd09f1$var$lookup22($a801f2c896bd09f1$var$edgeIds(v32))(styles.edges);
                                        var edgeSelected = $a801f2c896bd09f1$var$noteIsSelected(selection)(v32.left) || $a801f2c896bd09f1$var$noteIsSelected(selection)(v32.right);
                                        var edgeLabel = $a801f2c896bd09f1$var$maybe("")(function(v4) {
                                            return v4.label;
                                        })(edgeStyle);
                                        var edgeClasses = $a801f2c896bd09f1$var$maybe("")(function(v4) {
                                            return v4.classes;
                                        })(edgeStyle);
                                        return $a801f2c896bd09f1$var$g([])([
                                            $a801f2c896bd09f1$var$line([
                                                $a801f2c896bd09f1$var$x1(x12),
                                                $a801f2c896bd09f1$var$y1(y12),
                                                $a801f2c896bd09f1$var$x2(x22),
                                                $a801f2c896bd09f1$var$y2(y22),
                                                $a801f2c896bd09f1$var$strokeWidth(1),
                                                $a801f2c896bd09f1$var$attr2("stroke-dasharray")(function() {
                                                    if (isPassing) return "6,3";
                                                    return "";
                                                }()),
                                                $a801f2c896bd09f1$var$class_3("edge " + (edgeClasses + function() {
                                                    if (edgeSelected) return " selected";
                                                    var v4 = $a801f2c896bd09f1$var$lookup32(v32)(validation.edges);
                                                    if (v4 instanceof $a801f2c896bd09f1$var$Just && v4.value0 instanceof $a801f2c896bd09f1$var$ESNotUsed) return " warning";
                                                    if (v4 instanceof $a801f2c896bd09f1$var$Just && v4.value0 instanceof $a801f2c896bd09f1$var$ESNotStepwise) return " error";
                                                    if (v4 instanceof $a801f2c896bd09f1$var$Just && v4.value0 instanceof $a801f2c896bd09f1$var$ESNotRepetition) return " error";
                                                    return "";
                                                }()))
                                            ]),
                                            $a801f2c896bd09f1$var$text2([
                                                $a801f2c896bd09f1$var$textAnchor($a801f2c896bd09f1$var$AnchorMiddle.value),
                                                $a801f2c896bd09f1$var$dominantBaseline($a801f2c896bd09f1$var$Hanging.value)
                                            ])([
                                                $a801f2c896bd09f1$var$element3("textPath")([
                                                    $a801f2c896bd09f1$var$path([
                                                        $a801f2c896bd09f1$var$m2($a801f2c896bd09f1$var$Abs.value)(x12)(y12),
                                                        $a801f2c896bd09f1$var$l($a801f2c896bd09f1$var$Abs.value)(x22)(y22)
                                                    ]),
                                                    $a801f2c896bd09f1$var$attr2("startOffset")("50%")
                                                ])([
                                                    $a801f2c896bd09f1$var$text(edgeLabel)
                                                ])
                                            ])
                                        ]);
                                    };
                                };
                                var edgeLines = $a801f2c896bd09f1$var$append8($a801f2c896bd09f1$var$map39(mkedge(false))($a801f2c896bd09f1$var$fromFoldable10(v3.edges.regular)))($a801f2c896bd09f1$var$map39(mkedge(true))($a801f2c896bd09f1$var$fromFoldable15(v3.edges.passing)));
                                var bar = [
                                    $a801f2c896bd09f1$var$line($a801f2c896bd09f1$var$append8([
                                        $a801f2c896bd09f1$var$id3($a801f2c896bd09f1$var$show44(v3.id)),
                                        $a801f2c896bd09f1$var$x1($a801f2c896bd09f1$var$scalex(sett)(v1.slice.x)),
                                        $a801f2c896bd09f1$var$y1($a801f2c896bd09f1$var$scaley(sett)(v1.depth)),
                                        $a801f2c896bd09f1$var$x2($a801f2c896bd09f1$var$scalex(sett)(v22.slice.x)),
                                        $a801f2c896bd09f1$var$y2($a801f2c896bd09f1$var$scaley(sett)(v22.depth)),
                                        $a801f2c896bd09f1$var$stroke(function() {
                                            if (transSelected) return $a801f2c896bd09f1$var$selColorOuter;
                                            return $a801f2c896bd09f1$var$lightgray;
                                        }()),
                                        $a801f2c896bd09f1$var$strokeWidth(function() {
                                            if (topLevel) return $a801f2c896bd09f1$var$noteSize / 2;
                                            return 7;
                                        }()),
                                        $a801f2c896bd09f1$var$class_3("transition " + (transClasses + function() {
                                            if (transSelected) return " selected";
                                            return "";
                                        }()))
                                    ])(selectionAttr)),
                                    $a801f2c896bd09f1$var$text2([
                                        $a801f2c896bd09f1$var$textAnchor($a801f2c896bd09f1$var$AnchorMiddle.value),
                                        $a801f2c896bd09f1$var$dominantBaseline($a801f2c896bd09f1$var$Auto.value)
                                    ])([
                                        $a801f2c896bd09f1$var$element3("textPath")([
                                            $a801f2c896bd09f1$var$href2("#" + $a801f2c896bd09f1$var$show44(v3.id)),
                                            $a801f2c896bd09f1$var$attr2("startOffset")("50%")
                                        ])([
                                            $a801f2c896bd09f1$var$text(transLabel)
                                        ])
                                    ])
                                ];
                                return $a801f2c896bd09f1$var$pure27($a801f2c896bd09f1$var$g([])($a801f2c896bd09f1$var$append8(bar)(edgeLines)));
                            });
                        }));
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$black = /* @__PURE__ */ function() {
    return new $a801f2c896bd09f1$var$RGB(0, 0, 0);
}();
var $a801f2c896bd09f1$var$renderHori = function(sett) {
    return function(selection) {
        return function(slices) {
            return function(v3) {
                var explToHori = function(note2) {
                    if (note2.expl instanceof $a801f2c896bd09f1$var$HoriExpl) return new $a801f2c896bd09f1$var$Just({
                        childNote: note2.note,
                        parentNote: note2.expl.value0
                    });
                    return $a801f2c896bd09f1$var$Nothing.value;
                };
                return $a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$text(""))($a801f2c896bd09f1$var$bind21($a801f2c896bd09f1$var$lookup1(v3.child)(slices))(function(v1) {
                    return $a801f2c896bd09f1$var$bind21($a801f2c896bd09f1$var$lookup1(v3.parent)(slices))(function(v22) {
                        var mkedge = function(v32) {
                            var offp = $a801f2c896bd09f1$var$findPitchIndex(new $a801f2c896bd09f1$var$Inner(v32.parentNote))(v22.slice.notes);
                            var offc = $a801f2c896bd09f1$var$findPitchIndex(new $a801f2c896bd09f1$var$Inner(v32.childNote))(v1.slice.notes);
                            var edgeSelected = $a801f2c896bd09f1$var$noteIsSelected(selection)(new $a801f2c896bd09f1$var$Inner(v32.parentNote)) || $a801f2c896bd09f1$var$noteIsSelected(selection)(new $a801f2c896bd09f1$var$Inner(v32.childNote));
                            return $a801f2c896bd09f1$var$line([
                                $a801f2c896bd09f1$var$x1($a801f2c896bd09f1$var$scalex(sett)(v22.slice.x)),
                                $a801f2c896bd09f1$var$y1($a801f2c896bd09f1$var$scaley(sett)(v22.depth) + $a801f2c896bd09f1$var$offset(offp)),
                                $a801f2c896bd09f1$var$x2($a801f2c896bd09f1$var$scalex(sett)(v1.slice.x)),
                                $a801f2c896bd09f1$var$y2($a801f2c896bd09f1$var$scaley(sett)(v1.depth) + $a801f2c896bd09f1$var$offset(offc)),
                                $a801f2c896bd09f1$var$stroke(function() {
                                    if (edgeSelected) return $a801f2c896bd09f1$var$selColorInner;
                                    return $a801f2c896bd09f1$var$black;
                                }()),
                                $a801f2c896bd09f1$var$strokeWidth(1)
                            ]);
                        };
                        var edges = $a801f2c896bd09f1$var$map39(mkedge)($a801f2c896bd09f1$var$catMaybes2($a801f2c896bd09f1$var$map39(explToHori)($a801f2c896bd09f1$var$getInnerNotes(v1.slice))));
                        var bar = [
                            $a801f2c896bd09f1$var$line([
                                $a801f2c896bd09f1$var$x1($a801f2c896bd09f1$var$scalex(sett)(v22.slice.x)),
                                $a801f2c896bd09f1$var$y1($a801f2c896bd09f1$var$scaley(sett)(v22.depth)),
                                $a801f2c896bd09f1$var$x2($a801f2c896bd09f1$var$scalex(sett)(v1.slice.x)),
                                $a801f2c896bd09f1$var$y2($a801f2c896bd09f1$var$scaley(sett)(v1.depth)),
                                $a801f2c896bd09f1$var$stroke($a801f2c896bd09f1$var$lightgray),
                                $a801f2c896bd09f1$var$strokeWidth(5),
                                $a801f2c896bd09f1$var$attr2("stroke-dasharray")("10,5")
                            ])
                        ];
                        return $a801f2c896bd09f1$var$pure27($a801f2c896bd09f1$var$g([])($a801f2c896bd09f1$var$append8(bar)(edges)));
                    });
                }));
            };
        };
    };
};
var $a801f2c896bd09f1$var$renderSlice = function(sett) {
    return function(selection) {
        return function(validation) {
            return function(styles) {
                return function(v3) {
                    var svgy = $a801f2c896bd09f1$var$scaley(sett)(v3.depth) - $a801f2c896bd09f1$var$offset(1);
                    var svgx = $a801f2c896bd09f1$var$scalex(sett)(v3.slice.x) - $a801f2c896bd09f1$var$noteSize / 2;
                    var sliceStyle = $a801f2c896bd09f1$var$lookup1(v3.slice.id)(styles.slices);
                    var sliceLabel = $a801f2c896bd09f1$var$maybe("")(function(v1) {
                        return v1.label;
                    })(sliceStyle);
                    var sliceInvalid = $a801f2c896bd09f1$var$eq34($a801f2c896bd09f1$var$lookup1(v3.slice.id)(validation.slices))(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$SSInvalidReduction.value));
                    var sliceClasses = $a801f2c896bd09f1$var$maybe("")(function(v1) {
                        return v1.classes;
                    })(sliceStyle);
                    var selected3 = $a801f2c896bd09f1$var$eq111(selection)(new $a801f2c896bd09f1$var$SelSlice(v3.slice.id));
                    var selectionAttr = [
                        $a801f2c896bd09f1$var$cursor("pointer"),
                        $a801f2c896bd09f1$var$onClick(function(ev) {
                            var $232 = $a801f2c896bd09f1$var$ctrlKey(ev);
                            if ($232) return $a801f2c896bd09f1$var$NoOp.value;
                            return new $a801f2c896bd09f1$var$Select(function() {
                                if (selected3) return $a801f2c896bd09f1$var$SelNone.value;
                                return new $a801f2c896bd09f1$var$SelSlice(v3.slice.id);
                            }());
                        })
                    ];
                    var mknode = function(text7) {
                        return function(title5) {
                            return function(xcoord) {
                                return function(ycoord) {
                                    return function(selStatus) {
                                        return function(valid) {
                                            return function(attr3) {
                                                return function(classes) {
                                                    var label5 = $a801f2c896bd09f1$var$element3("text")([
                                                        $a801f2c896bd09f1$var$x3(xcoord),
                                                        $a801f2c896bd09f1$var$y3(ycoord),
                                                        $a801f2c896bd09f1$var$textAnchor($a801f2c896bd09f1$var$AnchorMiddle.value),
                                                        $a801f2c896bd09f1$var$dominantBaseline($a801f2c896bd09f1$var$BaselineMiddle.value),
                                                        $a801f2c896bd09f1$var$style("pointer-events: none;"),
                                                        $a801f2c896bd09f1$var$fill(function() {
                                                            if (valid instanceof $a801f2c896bd09f1$var$Nothing) {
                                                                var $235 = $a801f2c896bd09f1$var$eq52(selStatus)($a801f2c896bd09f1$var$Related.value);
                                                                if ($235) return $a801f2c896bd09f1$var$white;
                                                                return $a801f2c896bd09f1$var$lightgray;
                                                            }
                                                            if (valid instanceof $a801f2c896bd09f1$var$Just && valid.value0 instanceof $a801f2c896bd09f1$var$NSNoExpl) {
                                                                if (selStatus instanceof $a801f2c896bd09f1$var$Selected) return $a801f2c896bd09f1$var$white;
                                                                return $a801f2c896bd09f1$var$black;
                                                            }
                                                            if (valid instanceof $a801f2c896bd09f1$var$Just && valid.value0 instanceof $a801f2c896bd09f1$var$NSInvalidExplanation) return $a801f2c896bd09f1$var$warnColor;
                                                            throw new Error("Failed pattern match at App.Render (line 242, column 19 - line 247, column 51): " + [
                                                                valid.constructor.name
                                                            ]);
                                                        }())
                                                    ])([
                                                        $a801f2c896bd09f1$var$text(text7)
                                                    ]);
                                                    var bg = $a801f2c896bd09f1$var$rect([
                                                        $a801f2c896bd09f1$var$x3(xcoord - $a801f2c896bd09f1$var$noteSize / 2),
                                                        $a801f2c896bd09f1$var$y3(ycoord - $a801f2c896bd09f1$var$offset(1) / 2),
                                                        $a801f2c896bd09f1$var$width2($a801f2c896bd09f1$var$noteSize),
                                                        $a801f2c896bd09f1$var$height2($a801f2c896bd09f1$var$offset(1)),
                                                        $a801f2c896bd09f1$var$class_3("node " + (classes + function() {
                                                            if (selStatus instanceof $a801f2c896bd09f1$var$NotSelected) return "";
                                                            if (selStatus instanceof $a801f2c896bd09f1$var$Selected) return " selected";
                                                            if (selStatus instanceof $a801f2c896bd09f1$var$Related) return " related";
                                                            throw new Error("Failed pattern match at App.Render (line 229, column 60 - line 232, column 34): " + [
                                                                selStatus.constructor.name
                                                            ]);
                                                        }()))
                                                    ]);
                                                    return $a801f2c896bd09f1$var$g(attr3)([
                                                        bg,
                                                        label5,
                                                        $a801f2c896bd09f1$var$title2([])([
                                                            $a801f2c896bd09f1$var$text(title5)
                                                        ])
                                                    ]);
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                    var activeParent = function() {
                        if (selection instanceof $a801f2c896bd09f1$var$SelNote) return $a801f2c896bd09f1$var$elem3(v3.slice.id)($a801f2c896bd09f1$var$getParents(selection.value0.parents));
                        return false;
                    }();
                    var mknote = function(i2) {
                        return function(v1) {
                            var style3 = $a801f2c896bd09f1$var$lookup42(v1.note.id)(styles.notes);
                            var nselectedParent = function() {
                                if (selection instanceof $a801f2c896bd09f1$var$SelNote) return $a801f2c896bd09f1$var$explHasParent(v1.note.id)(selection.value0.expl);
                                return false;
                            }();
                            var nselected = $a801f2c896bd09f1$var$noteIsSelected(selection)(new $a801f2c896bd09f1$var$Inner(v1.note));
                            var nodeselected = function() {
                                if (nselected) return $a801f2c896bd09f1$var$Selected.value;
                                if (nselectedParent) return $a801f2c896bd09f1$var$Related.value;
                                return $a801f2c896bd09f1$var$NotSelected.value;
                            }();
                            var label5 = $a801f2c896bd09f1$var$maybe("")(function(s2) {
                                return " - " + s2.label;
                            })(style3);
                            var clickable = true;
                            var classes = $a801f2c896bd09f1$var$maybe("")(function(v22) {
                                return v22.classes;
                            })(style3);
                            var attrsSel = [
                                $a801f2c896bd09f1$var$cursor("pointer"),
                                $a801f2c896bd09f1$var$onClick(function(ev) {
                                    var $250 = $a801f2c896bd09f1$var$ctrlKey(ev);
                                    if ($250) {
                                        if (activeParent) return $a801f2c896bd09f1$var$addParentToNote(selection)(v3.slice.id)(v1.note);
                                        return $a801f2c896bd09f1$var$NoOp.value;
                                    }
                                    return new $a801f2c896bd09f1$var$Select(function() {
                                        if (nselected) return $a801f2c896bd09f1$var$SelNone.value;
                                        return new $a801f2c896bd09f1$var$SelNote({
                                            note: v1.note,
                                            expl: v1.expl,
                                            parents: v3.slice.parents,
                                            slice: v3.slice.id
                                        });
                                    }());
                                })
                            ];
                            return mknode($a801f2c896bd09f1$var$show19(v1.note.pitch))(v1.note.id + label5)($a801f2c896bd09f1$var$scalex(sett)(v3.slice.x))($a801f2c896bd09f1$var$scaley(sett)(v3.depth) + $a801f2c896bd09f1$var$offset(i2))(nodeselected)($a801f2c896bd09f1$var$lookup42(v1.note.id)(validation.notes))(function() {
                                if (clickable) return attrsSel;
                                return [];
                            }())(classes);
                        };
                    };
                    if (v3.slice.notes instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$g([])($a801f2c896bd09f1$var$append8([
                        $a801f2c896bd09f1$var$g([
                            $a801f2c896bd09f1$var$class_3(sliceClasses)
                        ])([
                            $a801f2c896bd09f1$var$rect($a801f2c896bd09f1$var$append8([
                                $a801f2c896bd09f1$var$x3(svgx),
                                $a801f2c896bd09f1$var$y3(svgy),
                                $a801f2c896bd09f1$var$width2($a801f2c896bd09f1$var$noteSize),
                                $a801f2c896bd09f1$var$height2($a801f2c896bd09f1$var$offset(1)),
                                $a801f2c896bd09f1$var$class_3("slice " + (sliceClasses + function() {
                                    if (selected3) return " selected";
                                    if (activeParent) return " related";
                                    if (sliceInvalid) return " error";
                                    return "";
                                }()))
                            ])(selectionAttr)),
                            $a801f2c896bd09f1$var$element3("text")([
                                $a801f2c896bd09f1$var$x3(svgx + $a801f2c896bd09f1$var$noteSize / 2),
                                $a801f2c896bd09f1$var$y3(svgy),
                                $a801f2c896bd09f1$var$textAnchor($a801f2c896bd09f1$var$AnchorMiddle.value),
                                $a801f2c896bd09f1$var$dominantBaseline($a801f2c896bd09f1$var$BaselineMiddle.value),
                                $a801f2c896bd09f1$var$style("pointer-events: none;"),
                                $a801f2c896bd09f1$var$class_3("slice-label")
                            ])([
                                $a801f2c896bd09f1$var$text(sliceLabel)
                            ])
                        ])
                    ])($a801f2c896bd09f1$var$mapWithIndex3(mknote)(v3.slice.notes.value0)));
                    return mknode($a801f2c896bd09f1$var$show53(v3.slice.notes))($a801f2c896bd09f1$var$show53(v3.slice.notes))($a801f2c896bd09f1$var$scalex(sett)(v3.slice.x))($a801f2c896bd09f1$var$scaley(sett)(v3.depth))(function() {
                        if (activeParent) return $a801f2c896bd09f1$var$Related.value;
                        return $a801f2c896bd09f1$var$NotSelected.value;
                    }())($a801f2c896bd09f1$var$Nothing.value)([])("");
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$axisHeight = 60;
var $a801f2c896bd09f1$var$renderScore2 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$element3("svg")([
        $a801f2c896bd09f1$var$x3(0),
        $a801f2c896bd09f1$var$y3(-($a801f2c896bd09f1$var$scoreHeight + $a801f2c896bd09f1$var$axisHeight)),
        $a801f2c896bd09f1$var$style("overflow: visible;"),
        $a801f2c896bd09f1$var$ref2("scoreStaff"),
        $a801f2c896bd09f1$var$ref($a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe)(function($288) {
            return $a801f2c896bd09f1$var$Action.create($a801f2c896bd09f1$var$RegisterScoreElt.create($288));
        }))
    ])([]);
}();
var $a801f2c896bd09f1$var$renderTime = function(sett) {
    return function(i2) {
        return function(v3) {
            var label5 = function() {
                if (v3.time instanceof $a801f2c896bd09f1$var$Right) {
                    var $273 = $a801f2c896bd09f1$var$eq43(v3.time.value0.s)($a801f2c896bd09f1$var$reduce4(0)(1));
                    if ($273) return $a801f2c896bd09f1$var$show62(v3.time.value0.m) + ("." + $a801f2c896bd09f1$var$show62(v3.time.value0.b));
                    return "";
                }
                if (v3.time instanceof $a801f2c896bd09f1$var$Left) return v3.time.value0;
                throw new Error("Failed pattern match at App.Render (line 446, column 11 - line 448, column 20): " + [
                    v3.time.constructor.name
                ]);
            }();
            return $a801f2c896bd09f1$var$text2([
                $a801f2c896bd09f1$var$x3($a801f2c896bd09f1$var$scalex(sett)($a801f2c896bd09f1$var$toNumber(i2 + 1 | 0))),
                $a801f2c896bd09f1$var$y3(-($a801f2c896bd09f1$var$axisHeight / 2)),
                $a801f2c896bd09f1$var$textAnchor($a801f2c896bd09f1$var$AnchorMiddle.value),
                $a801f2c896bd09f1$var$dominantBaseline($a801f2c896bd09f1$var$BaselineMiddle.value)
            ])([
                $a801f2c896bd09f1$var$text(label5)
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$renderReduction = function(sett) {
    return function(piece) {
        return function(graph) {
            return function(validation) {
                return function(styles) {
                    return function(selection) {
                        var width9 = $a801f2c896bd09f1$var$scalex(sett)(graph.maxx + 2);
                        var svgTranss = $a801f2c896bd09f1$var$map39($a801f2c896bd09f1$var$renderTrans(sett)(selection)(validation)(styles)(graph.slices))($a801f2c896bd09f1$var$fromFoldable24($a801f2c896bd09f1$var$values2(graph.transitions)));
                        var svgSlices = $a801f2c896bd09f1$var$map39($a801f2c896bd09f1$var$renderSlice(sett)(selection)(validation)(styles))($a801f2c896bd09f1$var$fromFoldable24($a801f2c896bd09f1$var$values2(graph.slices)));
                        var svgScore = function() {
                            if (sett.showScore) return [
                                $a801f2c896bd09f1$var$renderScore2
                            ];
                            return [];
                        }();
                        var svgHoris = $a801f2c896bd09f1$var$map39($a801f2c896bd09f1$var$renderHori(sett)(selection)(graph.slices))($a801f2c896bd09f1$var$fromFoldable24(graph.horis));
                        var svgAxis = $a801f2c896bd09f1$var$mapWithIndex3($a801f2c896bd09f1$var$renderTime(sett))(piece);
                        var extraHeight = $a801f2c896bd09f1$var$axisHeight + function() {
                            if (sett.showScore) return $a801f2c896bd09f1$var$scoreHeight;
                            return 0;
                        }();
                        var height9 = $a801f2c896bd09f1$var$scaley(sett)(graph.maxd + 2) + extraHeight;
                        var css = $a801f2c896bd09f1$var$defs([])([
                            $a801f2c896bd09f1$var$style_([
                                $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$defaultCSS2),
                                $a801f2c896bd09f1$var$text("@layer userstyles {" + (styles.css + "}"))
                            ])
                        ]);
                        return $a801f2c896bd09f1$var$div5([
                            $a801f2c896bd09f1$var$style("overflow-x: scroll; max-width: max-content;")
                        ])([
                            $a801f2c896bd09f1$var$svg([
                                $a801f2c896bd09f1$var$width2(width9),
                                $a801f2c896bd09f1$var$height2(height9),
                                $a801f2c896bd09f1$var$viewBox(-$a801f2c896bd09f1$var$scalex(sett)(1))(-extraHeight)(width9)(height9)
                            ])($a801f2c896bd09f1$var$append8([
                                css
                            ])($a801f2c896bd09f1$var$append8(svgScore)($a801f2c896bd09f1$var$append8(svgTranss)($a801f2c896bd09f1$var$append8(svgHoris)($a801f2c896bd09f1$var$append8(svgSlices)(svgAxis))))))
                        ]);
                    };
                };
            };
        };
    };
};
// output/Data.Hashable/foreign.js
function $a801f2c896bd09f1$var$hashString(s2) {
    var h7 = 0;
    for(var i2 = 0; i2 < s2.length; i2++)h7 = 31 * h7 + s2.charCodeAt(i2) | 0;
    return h7;
}
// output/Data.Hashable/index.js
var $a801f2c896bd09f1$var$hashableString = {
    hash: $a801f2c896bd09f1$var$hashString,
    Eq0: function() {
        return $a801f2c896bd09f1$var$eqString;
    }
};
var $a801f2c896bd09f1$var$hash = function(dict) {
    return dict.hash;
};
// output/App.Tabs.Debug/index.js
var $a801f2c896bd09f1$var$show20 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showInt);
var $a801f2c896bd09f1$var$hash2 = /* @__PURE__ */ $a801f2c896bd09f1$var$hash($a801f2c896bd09f1$var$hashableString);
var $a801f2c896bd09f1$var$showRecord8 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord()();
var $a801f2c896bd09f1$var$showRecordFieldsCons10 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "edges";
    }
});
var $a801f2c896bd09f1$var$notesIsSymbol = {
    reflectSymbol: function() {
        return "notes";
    }
};
var $a801f2c896bd09f1$var$showRecordFieldsCons13 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$notesIsSymbol);
var $a801f2c896bd09f1$var$slicesIsSymbol = {
    reflectSymbol: function() {
        return "slices";
    }
};
var $a801f2c896bd09f1$var$showRecord13 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "classes";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "label";
    }
})($a801f2c896bd09f1$var$showString))($a801f2c896bd09f1$var$showString));
var $a801f2c896bd09f1$var$showMap3 = /* @__PURE__ */ $a801f2c896bd09f1$var$showMap($a801f2c896bd09f1$var$showSliceId);
var $a801f2c896bd09f1$var$showMap12 = /* @__PURE__ */ $a801f2c896bd09f1$var$showMap($a801f2c896bd09f1$var$showString);
var $a801f2c896bd09f1$var$idIsSymbol4 = {
    reflectSymbol: function() {
        return "id";
    }
};
var $a801f2c896bd09f1$var$showRecordFieldsCons24 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$idIsSymbol4);
var $a801f2c896bd09f1$var$pitchIsSymbol4 = {
    reflectSymbol: function() {
        return "pitch";
    }
};
var $a801f2c896bd09f1$var$showRecord24 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons24(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$pitchIsSymbol4)(/* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval)))($a801f2c896bd09f1$var$showString));
var $a801f2c896bd09f1$var$showRecordFieldsConsNil4 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "note";
    }
})($a801f2c896bd09f1$var$showRecord24);
var $a801f2c896bd09f1$var$showRecord33 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons24(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons13(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "parents";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "x";
    }
})($a801f2c896bd09f1$var$showNumber))(/* @__PURE__ */ $a801f2c896bd09f1$var$showParents($a801f2c896bd09f1$var$showSliceId)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "expl";
    }
})($a801f2c896bd09f1$var$showRecordFieldsConsNil4)($a801f2c896bd09f1$var$showNoteExplanation))))))($a801f2c896bd09f1$var$showSliceId));
var $a801f2c896bd09f1$var$showStartStop3 = /* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop($a801f2c896bd09f1$var$showRecord24);
var $a801f2c896bd09f1$var$showRecord42 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "left";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "right";
    }
})($a801f2c896bd09f1$var$showStartStop3))($a801f2c896bd09f1$var$showStartStop3));
var $a801f2c896bd09f1$var$timeIsSymbol = {
    reflectSymbol: function() {
        return "time";
    }
};
var $a801f2c896bd09f1$var$holdIsSymbol = {
    reflectSymbol: function() {
        return "hold";
    }
};
var $a801f2c896bd09f1$var$show111 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "piece";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "reduction";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "styles";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "css";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons10(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons13(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$slicesIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "staff";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "transitions";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap($a801f2c896bd09f1$var$showTransId)($a801f2c896bd09f1$var$showRecord13)))($a801f2c896bd09f1$var$showStaff))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap3($a801f2c896bd09f1$var$showRecord13)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap12($a801f2c896bd09f1$var$showRecord13)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap(/* @__PURE__ */ $a801f2c896bd09f1$var$showTuple($a801f2c896bd09f1$var$showString)($a801f2c896bd09f1$var$showString))($a801f2c896bd09f1$var$showRecord13)))($a801f2c896bd09f1$var$showString))))(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "nextSliceId";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "nextTransId";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "segments";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "start";
    }
})($a801f2c896bd09f1$var$showRecord33))(/* @__PURE__ */ $a801f2c896bd09f1$var$showList(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "op";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "rslice";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "trans";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons10(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons24(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "is2nd";
    }
})($a801f2c896bd09f1$var$showBoolean))($a801f2c896bd09f1$var$showTransId))(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "passing";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "regular";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showSet($a801f2c896bd09f1$var$showRecord42)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray($a801f2c896bd09f1$var$showRecord42)))))))($a801f2c896bd09f1$var$showRecord33))($a801f2c896bd09f1$var$showOp)))))($a801f2c896bd09f1$var$showTransId))($a801f2c896bd09f1$var$showSliceId))))(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons13(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$timeIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showEither($a801f2c896bd09f1$var$showString)($a801f2c896bd09f1$var$showMBS)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$holdIsSymbol)($a801f2c896bd09f1$var$showRecordFieldsConsNil4)(/* @__PURE__ */ $a801f2c896bd09f1$var$showMaybe($a801f2c896bd09f1$var$showString))))))))));
var $a801f2c896bd09f1$var$append13 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$show28 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showOuterSelection);
var $a801f2c896bd09f1$var$show35 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "flatHori";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "showAllEdges";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "showScore";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "xscale";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "yscale";
    }
})($a801f2c896bd09f1$var$showNumber))($a801f2c896bd09f1$var$showNumber))($a801f2c896bd09f1$var$showBoolean))($a801f2c896bd09f1$var$showBoolean))($a801f2c896bd09f1$var$showBoolean)));
var $a801f2c896bd09f1$var$show45 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showList($a801f2c896bd09f1$var$showString));
var $a801f2c896bd09f1$var$map40 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorList);
var $a801f2c896bd09f1$var$show54 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord8(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons10(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons13(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$slicesIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap3($a801f2c896bd09f1$var$showSliceError)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap12($a801f2c896bd09f1$var$showNoteError)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap($a801f2c896bd09f1$var$showRecord42)($a801f2c896bd09f1$var$showEdgeError))));
var $a801f2c896bd09f1$var$map117 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$show63 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showLeftmost($a801f2c896bd09f1$var$showSplitOp)($a801f2c896bd09f1$var$showFreezeOp)($a801f2c896bd09f1$var$showHoriOp));
var $a801f2c896bd09f1$var$recordWriteForeign2 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign();
var $a801f2c896bd09f1$var$consWriteForeignFields2 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$notesIsSymbol);
var $a801f2c896bd09f1$var$consWriteForeignFields1 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$holdIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$writeForeignString));
var $a801f2c896bd09f1$var$consWriteForeignFields22 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$pitchIsSymbol4)($a801f2c896bd09f1$var$writeForeignString)($a801f2c896bd09f1$var$nilWriteForeignFields)()()();
var $a801f2c896bd09f1$var$consWriteForeignFields3 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$timeIsSymbol)($a801f2c896bd09f1$var$writeForeignString)($a801f2c896bd09f1$var$nilWriteForeignFields)()()();
var $a801f2c896bd09f1$var$writeJSON2 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeJSON(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign2(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields2(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign2(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields1(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$idIsSymbol4)($a801f2c896bd09f1$var$writeForeignString)($a801f2c896bd09f1$var$consWriteForeignFields22)()()())()()())))($a801f2c896bd09f1$var$consWriteForeignFields3)()()())));
var $a801f2c896bd09f1$var$writeJSON1 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeJSON(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign2(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields2(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign2(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields1($a801f2c896bd09f1$var$consWriteForeignFields22)()()())))($a801f2c896bd09f1$var$consWriteForeignFields3)()()())));
var $a801f2c896bd09f1$var$showStackItem = function(item2) {
    return item2.name + (": " + $a801f2c896bd09f1$var$show20($a801f2c896bd09f1$var$hash2($a801f2c896bd09f1$var$show111(item2.m))));
};
var $a801f2c896bd09f1$var$debugComponent = function(st) {
    return function(modelInfo) {
        return $a801f2c896bd09f1$var$div5([
            $a801f2c896bd09f1$var$class_2("content-np tab")
        ])($a801f2c896bd09f1$var$append13([
            $a801f2c896bd09f1$var$h3_([
                $a801f2c896bd09f1$var$text("Selection")
            ]),
            $a801f2c896bd09f1$var$p_([
                $a801f2c896bd09f1$var$text("Selection: "),
                $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show28(st.selected))
            ]),
            $a801f2c896bd09f1$var$h3_([
                $a801f2c896bd09f1$var$text("Settings")
            ]),
            $a801f2c896bd09f1$var$p_([
                $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show35(st.settings))
            ]),
            $a801f2c896bd09f1$var$h3_([
                $a801f2c896bd09f1$var$text("Undo / Redo")
            ]),
            $a801f2c896bd09f1$var$p_([
                $a801f2c896bd09f1$var$p_([
                    $a801f2c896bd09f1$var$text("Undo Stack: " + $a801f2c896bd09f1$var$show45($a801f2c896bd09f1$var$map40($a801f2c896bd09f1$var$showStackItem)(st.undoStack)))
                ]),
                $a801f2c896bd09f1$var$p_([
                    $a801f2c896bd09f1$var$text("Redo Stack: " + $a801f2c896bd09f1$var$show45($a801f2c896bd09f1$var$map40($a801f2c896bd09f1$var$showStackItem)(st.redoStack)))
                ])
            ]),
            $a801f2c896bd09f1$var$p_([
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("Model")
                ]),
                $a801f2c896bd09f1$var$text(function() {
                    if (st.loaded instanceof $a801f2c896bd09f1$var$Nothing) return "";
                    if (st.loaded instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$show20($a801f2c896bd09f1$var$hash2($a801f2c896bd09f1$var$show111(st.loaded.value0.model)));
                    throw new Error("Failed pattern match at App.Tabs.Debug (line 35, column 21 - line 37, column 55): " + [
                        st.loaded.constructor.name
                    ]);
                }())
            ])
        ])(function() {
            if (modelInfo instanceof $a801f2c896bd09f1$var$Nothing) return [
                $a801f2c896bd09f1$var$text("No analysis or piece loaded.")
            ];
            if (modelInfo instanceof $a801f2c896bd09f1$var$Just) return [
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("Validation")
                ]),
                $a801f2c896bd09f1$var$p_([
                    $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show54(modelInfo.value0.validation))
                ]),
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("Reduction Steps")
                ]),
                function() {
                    var v3 = $a801f2c896bd09f1$var$reductionToLeftmost(modelInfo.value0.model);
                    if (v3 instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$ol_($a801f2c896bd09f1$var$map117(function(step4) {
                        return $a801f2c896bd09f1$var$li_([
                            $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show63(step4))
                        ]);
                    })(v3.value0));
                    if (v3 instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$p2([
                        $a801f2c896bd09f1$var$class_2("alert")
                    ])([
                        $a801f2c896bd09f1$var$text("Warning: reduction cannot be turned into leftmost derivation: " + v3.value0)
                    ]);
                    throw new Error("Failed pattern match at App.Tabs.Debug (line 45, column 11 - line 47, column 134): " + [
                        v3.constructor.name
                    ]);
                }(),
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("Piece JSON")
                ]),
                $a801f2c896bd09f1$var$div_([
                    $a801f2c896bd09f1$var$p_([
                        $a801f2c896bd09f1$var$text("with IDs:")
                    ]),
                    $a801f2c896bd09f1$var$pre_([
                        $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$writeJSON2($a801f2c896bd09f1$var$pieceToJSON(modelInfo.value0.model.piece)))
                    ]),
                    $a801f2c896bd09f1$var$p_([
                        $a801f2c896bd09f1$var$text("without IDs:")
                    ]),
                    $a801f2c896bd09f1$var$pre_([
                        $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$writeJSON1($a801f2c896bd09f1$var$stripJSONIds($a801f2c896bd09f1$var$pieceToJSON(modelInfo.value0.model.piece))))
                    ])
                ])
            ];
            throw new Error("Failed pattern match at App.Tabs.Debug (line 39, column 10 - line 55, column 10): " + [
                modelInfo.constructor.name
            ]);
        }()));
    };
};
// output/App.TikZ/index.js
var $a801f2c896bd09f1$var$show21 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showSliceId);
var $a801f2c896bd09f1$var$showPitch3 = /* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval);
var $a801f2c896bd09f1$var$show112 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop($a801f2c896bd09f1$var$showPitch3));
var $a801f2c896bd09f1$var$map41 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorStartStop);
var $a801f2c896bd09f1$var$show29 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showNumber);
var $a801f2c896bd09f1$var$bind25 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$lookup6 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordSliceId);
var $a801f2c896bd09f1$var$pure28 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeMaybe);
var $a801f2c896bd09f1$var$show36 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showPitch3);
var $a801f2c896bd09f1$var$map118 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$fold5 = /* @__PURE__ */ $a801f2c896bd09f1$var$fold($a801f2c896bd09f1$var$foldableArray)($a801f2c896bd09f1$var$monoidString);
var $a801f2c896bd09f1$var$intercalate6 = /* @__PURE__ */ $a801f2c896bd09f1$var$intercalate($a801f2c896bd09f1$var$foldableArray)($a801f2c896bd09f1$var$monoidString);
var $a801f2c896bd09f1$var$append14 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$fromFoldable11 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableSet);
var $a801f2c896bd09f1$var$intercalate1 = /* @__PURE__ */ $a801f2c896bd09f1$var$intercalate($a801f2c896bd09f1$var$foldableList)($a801f2c896bd09f1$var$monoidString);
var $a801f2c896bd09f1$var$map213 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorList);
var $a801f2c896bd09f1$var$fold12 = /* @__PURE__ */ $a801f2c896bd09f1$var$fold($a801f2c896bd09f1$var$foldableList)($a801f2c896bd09f1$var$monoidString);
var $a801f2c896bd09f1$var$tikzPre = "\\documentclass{standalone}\n\\usepackage{tikz,xcolor,amssymb}\n\\usetikzlibrary{positioning,fit,backgrounds,scopes,arrows.meta}\n\\definecolor{lightergray}{gray}{0.9}\n\\tikzset{slice/.style={rectangle,draw,fill=lightergray,semithick,minimum size=0.4cm,inner sep=3pt,align=center}}\n\\tikzset{transition/.style={semithick}}\n\\tikzset{non-terminal/.style={}}\n\\tikzset{terminal/.style={double}}\n\\tikzset{hori/.style={lightgray,dashed,thick}}\n\\tikzset{outeredge/.style={->,>=Stealth,out=0,in=180}}\n\\tikzset{outerpass/.style={outeredge,dashed}}\n\\tikzset{outernote/.style={inner xsep=0, inner ysep=2pt}}\n\\begin{document}\n\n\\begin{tikzpicture}[xscale=2,yscale=2]\n";
var $a801f2c896bd09f1$var$tikzPost = "\n\\end{tikzpicture}\n\n\\end{document}\n";
var $a801f2c896bd09f1$var$tikzOpType = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$RootExpl) return new $a801f2c896bd09f1$var$Just("root note");
    if (v3 instanceof $a801f2c896bd09f1$var$DoubleExpl) {
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$FullNeighbor) return new $a801f2c896bd09f1$var$Just("full neighbor");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$FullRepeat) return new $a801f2c896bd09f1$var$Just("full repeat");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$LeftRepeatOfRight) return new $a801f2c896bd09f1$var$Just("left repeat of right");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$RightRepeatOfLeft) return new $a801f2c896bd09f1$var$Just("right repeat of left");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingMid) return new $a801f2c896bd09f1$var$Just("passing mid");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingLeft) return new $a801f2c896bd09f1$var$Just("passing left");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$PassingRight) return new $a801f2c896bd09f1$var$Just("passing right");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$Nothing.value;
        throw new Error("Failed pattern match at App.TikZ (line 154, column 25 - line 162, column 23): " + [
            v3.value0.orn.constructor.name
        ]);
    }
    if (v3 instanceof $a801f2c896bd09f1$var$RightExpl) {
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$RightRepeat) return new $a801f2c896bd09f1$var$Just("right repeat");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$RightNeighbor) return new $a801f2c896bd09f1$var$Just("right neighbor");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$Nothing.value;
        throw new Error("Failed pattern match at App.TikZ (line 163, column 24 - line 166, column 23): " + [
            v3.value0.orn.constructor.name
        ]);
    }
    if (v3 instanceof $a801f2c896bd09f1$var$LeftExpl) {
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$LeftRepeat) return new $a801f2c896bd09f1$var$Just("left repeat");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Just && v3.value0.orn.value0 instanceof $a801f2c896bd09f1$var$LeftNeighbor) return new $a801f2c896bd09f1$var$Just("left neighbor");
        if (v3.value0.orn instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$Nothing.value;
        throw new Error("Failed pattern match at App.TikZ (line 167, column 23 - line 170, column 23): " + [
            v3.value0.orn.constructor.name
        ]);
    }
    return $a801f2c896bd09f1$var$Nothing.value;
};
var $a801f2c896bd09f1$var$showTex = function(dictShow) {
    var $109 = $a801f2c896bd09f1$var$replaceAll("\u266D")("$\\flat$");
    var $110 = $a801f2c896bd09f1$var$replaceAll("\u266F")("$\\sharp$");
    var $111 = $a801f2c896bd09f1$var$show(dictShow);
    return function($112) {
        return $109($110($111($112)));
    };
};
var $a801f2c896bd09f1$var$showTex1 = /* @__PURE__ */ $a801f2c896bd09f1$var$showTex($a801f2c896bd09f1$var$showPitch3);
var $a801f2c896bd09f1$var$parens = function(str) {
    return "(" + (str + ")");
};
var $a801f2c896bd09f1$var$idToName = function(noteid) {
    return $a801f2c896bd09f1$var$replaceAll(".")("_")(noteid);
};
var $a801f2c896bd09f1$var$tikzEdge = function(style3) {
    return function(sleft) {
        return function(sright) {
            return function(v3) {
                var nodeTo = function() {
                    if (v3.right instanceof $a801f2c896bd09f1$var$Start) return "start";
                    if (v3.right instanceof $a801f2c896bd09f1$var$Stop) return "stop";
                    if (v3.right instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$idToName($a801f2c896bd09f1$var$show21(sright)) + (".west |- " + $a801f2c896bd09f1$var$idToName(v3.right.value0.id));
                    throw new Error("Failed pattern match at App.TikZ (line 88, column 12 - line 91, column 76): " + [
                        v3.right.constructor.name
                    ]);
                }();
                var nodeFrom = function() {
                    if (v3.left instanceof $a801f2c896bd09f1$var$Start) return "start";
                    if (v3.left instanceof $a801f2c896bd09f1$var$Stop) return "stop";
                    if (v3.left instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$idToName($a801f2c896bd09f1$var$show21(sleft)) + (".east |- " + $a801f2c896bd09f1$var$idToName(v3.left.value0.id));
                    throw new Error("Failed pattern match at App.TikZ (line 83, column 14 - line 86, column 75): " + [
                        v3.left.constructor.name
                    ]);
                }();
                return "\\draw[" + (style3 + ("] (" + (nodeFrom + (") to (" + (nodeTo + ("); % " + ($a801f2c896bd09f1$var$show112($a801f2c896bd09f1$var$map41(function(v1) {
                    return v1.pitch;
                })(v3.left)) + (" -> " + ($a801f2c896bd09f1$var$show112($a801f2c896bd09f1$var$map41(function(v1) {
                    return v1.pitch;
                })(v3.right)) + "\n")))))))));
            };
        };
    };
};
var $a801f2c896bd09f1$var$tikzFirstNote = function(depth) {
    return function(x4) {
        return function(note2) {
            return "\\node[outernote] (" + ($a801f2c896bd09f1$var$idToName(note2.id) + (") at (" + ($a801f2c896bd09f1$var$show29(x4) + (",-" + ($a801f2c896bd09f1$var$show29(depth) + (") {" + ($a801f2c896bd09f1$var$showTex1(note2.pitch) + "};\n")))))));
        };
    };
};
var $a801f2c896bd09f1$var$tikzHori = function(slices) {
    return function(v3) {
        var sliceName = function(v1) {
            return $a801f2c896bd09f1$var$parens($a801f2c896bd09f1$var$idToName($a801f2c896bd09f1$var$show21(v1.slice.id)));
        };
        return $a801f2c896bd09f1$var$fromMaybe("")($a801f2c896bd09f1$var$bind25($a801f2c896bd09f1$var$lookup6(v3.child)(slices))(function(c3) {
            return $a801f2c896bd09f1$var$bind25($a801f2c896bd09f1$var$lookup6(v3.parent)(slices))(function(p3) {
                return $a801f2c896bd09f1$var$pure28("\\draw[hori] " + (sliceName(c3) + (" to " + (sliceName(p3) + ";\n"))));
            });
        }));
    };
};
var $a801f2c896bd09f1$var$tikzOpDecor = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$SelNote) {
        var v1 = $a801f2c896bd09f1$var$tikzOpType(v3.value0.expl);
        if (v1 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Just("\\opdecor{" + (v1.value0 + ("}{" + ($a801f2c896bd09f1$var$idToName(v3.value0.note.id) + ("}{" + ($a801f2c896bd09f1$var$show21(v3.value0.slice) + ("} % " + $a801f2c896bd09f1$var$show36(v3.value0.note.pitch))))))));
        if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$Nothing.value;
        throw new Error("Failed pattern match at App.TikZ (line 140, column 36 - line 148, column 23): " + [
            v1.constructor.name
        ]);
    }
    return $a801f2c896bd09f1$var$Nothing.value;
};
var $a801f2c896bd09f1$var$tikzOtherNote = function(pred2) {
    return function(note2) {
        return "\\node[outernote,below=0 of " + (pred2 + ("] (" + ($a801f2c896bd09f1$var$idToName(note2.id) + (") {" + ($a801f2c896bd09f1$var$showTex1(note2.pitch) + "};\n")))));
    };
};
var $a801f2c896bd09f1$var$tikzSlice = function(v3) {
    if (v3.slice.notes instanceof $a801f2c896bd09f1$var$Start) return "\\node[slice] (start) at (0,0) {$\\rtimes$};\n";
    if (v3.slice.notes instanceof $a801f2c896bd09f1$var$Stop) return "\\node[slice] (stop) at (" + ($a801f2c896bd09f1$var$show29(v3.slice.x) + ",0) {$\\ltimes$};\n");
    if (v3.slice.notes instanceof $a801f2c896bd09f1$var$Inner) {
        var noteids = $a801f2c896bd09f1$var$map118(function(n) {
            return $a801f2c896bd09f1$var$idToName(n.note.id);
        })(v3.slice.notes.value0);
        var tNotes = function() {
            var v1 = $a801f2c896bd09f1$var$uncons2(v3.slice.notes.value0);
            if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return "";
            if (v1 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$tikzFirstNote(v3.depth)(v3.slice.x)(v1.value0.head.note) + $a801f2c896bd09f1$var$fold5($a801f2c896bd09f1$var$zipWith2($a801f2c896bd09f1$var$tikzOtherNote)(noteids)($a801f2c896bd09f1$var$map118(function(v22) {
                return v22.note;
            })(v1.value0.tail)));
            throw new Error("Failed pattern match at App.TikZ (line 39, column 16 - line 43, column 74): " + [
                v1.constructor.name
            ]);
        }();
        var tSlice = "{[on background layer] \\node[slice,fit={" + ($a801f2c896bd09f1$var$intercalate6(" ")($a801f2c896bd09f1$var$map118($a801f2c896bd09f1$var$parens)(noteids)) + ("}] (" + ($a801f2c896bd09f1$var$idToName($a801f2c896bd09f1$var$show21(v3.slice.id)) + ") {};}\n")));
        return tNotes + tSlice;
    }
    throw new Error("Failed pattern match at App.TikZ (line 32, column 30 - line 47, column 23): " + [
        v3.slice.notes.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$tikzTrans = function(slices) {
    return function(v3) {
        var tEdges = $a801f2c896bd09f1$var$append14($a801f2c896bd09f1$var$map118($a801f2c896bd09f1$var$tikzEdge("outeredge")(v3.left)(v3.right))($a801f2c896bd09f1$var$fromFoldable11(v3.edges.regular)))($a801f2c896bd09f1$var$map118($a801f2c896bd09f1$var$tikzEdge("outerpass")(v3.left)(v3.right))(v3.edges.passing));
        var sliceName = function(slice4) {
            if (slice4.notes instanceof $a801f2c896bd09f1$var$Start) return "start";
            if (slice4.notes instanceof $a801f2c896bd09f1$var$Stop) return "stop";
            if (slice4.notes instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$idToName($a801f2c896bd09f1$var$show21(slice4.id));
            throw new Error("Failed pattern match at App.TikZ (line 72, column 21 - line 75, column 40): " + [
                slice4.notes.constructor.name
            ]);
        };
        var tTrans = $a801f2c896bd09f1$var$fromMaybe("")($a801f2c896bd09f1$var$bind25($a801f2c896bd09f1$var$lookup6(v3.left)(slices))(function(l2) {
            return $a801f2c896bd09f1$var$bind25($a801f2c896bd09f1$var$lookup6(v3.right)(slices))(function(r) {
                return $a801f2c896bd09f1$var$pure28("{[on background layer] \\draw[transition] " + function() {
                    var $99 = l2.depth === 0 && r.depth === 0;
                    if ($99) return "(" + (sliceName(l2.slice) + (".east |- 0,0) to (" + (sliceName(r.slice) + ".west |- 0,0);}\n")));
                    return "(" + (sliceName(l2.slice) + (") to (" + (sliceName(r.slice) + ");}\n")));
                }());
            });
        }));
        return tTrans + $a801f2c896bd09f1$var$fold5(tEdges);
    };
};
var $a801f2c896bd09f1$var$tikzReduction = function(standalone) {
    return function(v3) {
        var tTranss = $a801f2c896bd09f1$var$intercalate1("\n")($a801f2c896bd09f1$var$map213($a801f2c896bd09f1$var$tikzTrans(v3.slices))($a801f2c896bd09f1$var$values2(v3.transitions)));
        var tSlices = $a801f2c896bd09f1$var$intercalate1("\n")($a801f2c896bd09f1$var$map213($a801f2c896bd09f1$var$tikzSlice)($a801f2c896bd09f1$var$values2(v3.slices)));
        var tHoris = $a801f2c896bd09f1$var$fold12($a801f2c896bd09f1$var$map213($a801f2c896bd09f1$var$tikzHori(v3.slices))(v3.horis));
        var tikz = tSlices + ("\n" + (tHoris + ("\n" + tTranss)));
        if (standalone) return $a801f2c896bd09f1$var$tikzPre + (tikz + $a801f2c896bd09f1$var$tikzPost);
        return tikz;
    };
};
// output/Data.Exists/index.js
var $a801f2c896bd09f1$var$runExists = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$mkExists = $a801f2c896bd09f1$var$unsafeCoerce2;
// output/Data.Coyoneda/index.js
var $a801f2c896bd09f1$var$CoyonedaF = /* @__PURE__ */ function() {
    function CoyonedaF2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CoyonedaF2.create = function(value0) {
        return function(value1) {
            return new CoyonedaF2(value0, value1);
        };
    };
    return CoyonedaF2;
}();
var $a801f2c896bd09f1$var$unCoyoneda = function(f2) {
    return function(v3) {
        return $a801f2c896bd09f1$var$runExists(function(v1) {
            return f2(v1.value0)(v1.value1);
        })(v3);
    };
};
var $a801f2c896bd09f1$var$coyoneda = function(k2) {
    return function(fi) {
        return $a801f2c896bd09f1$var$mkExists(new $a801f2c896bd09f1$var$CoyonedaF(k2, fi));
    };
};
var $a801f2c896bd09f1$var$functorCoyoneda = {
    map: function(f2) {
        return function(v3) {
            return $a801f2c896bd09f1$var$runExists(function(v1) {
                return $a801f2c896bd09f1$var$coyoneda(function($180) {
                    return f2(v1.value0($180));
                })(v1.value1);
            })(v3);
        };
    }
};
var $a801f2c896bd09f1$var$liftCoyoneda = /* @__PURE__ */ $a801f2c896bd09f1$var$coyoneda(/* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn));
// output/Halogen.Data.OrdBox/index.js
var $a801f2c896bd09f1$var$OrdBox = /* @__PURE__ */ function() {
    function OrdBox2(value0, value1, value22) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value22;
    }
    OrdBox2.create = function(value0) {
        return function(value1) {
            return function(value22) {
                return new OrdBox2(value0, value1, value22);
            };
        };
    };
    return OrdBox2;
}();
var $a801f2c896bd09f1$var$mkOrdBox = function(dictOrd) {
    return $a801f2c896bd09f1$var$OrdBox.create($a801f2c896bd09f1$var$eq(dictOrd.Eq0()))($a801f2c896bd09f1$var$compare(dictOrd));
};
var $a801f2c896bd09f1$var$eqOrdBox = {
    eq: function(v3) {
        return function(v1) {
            return v3.value0(v3.value2)(v1.value2);
        };
    }
};
var $a801f2c896bd09f1$var$ordOrdBox = {
    compare: function(v3) {
        return function(v1) {
            return v3.value1(v3.value2)(v1.value2);
        };
    },
    Eq0: function() {
        return $a801f2c896bd09f1$var$eqOrdBox;
    }
};
// output/Halogen.Data.Slot/index.js
var $a801f2c896bd09f1$var$ordTuple3 = /* @__PURE__ */ $a801f2c896bd09f1$var$ordTuple($a801f2c896bd09f1$var$ordString)($a801f2c896bd09f1$var$ordOrdBox);
var $a801f2c896bd09f1$var$pop1 = /* @__PURE__ */ $a801f2c896bd09f1$var$pop($a801f2c896bd09f1$var$ordTuple3);
var $a801f2c896bd09f1$var$lookup12 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordTuple3);
var $a801f2c896bd09f1$var$insert13 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert6($a801f2c896bd09f1$var$ordTuple3);
var $a801f2c896bd09f1$var$pop2 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox2 = $a801f2c896bd09f1$var$mkOrdBox(dictOrd);
            return function(sym) {
                return function(key2) {
                    return function(v3) {
                        return $a801f2c896bd09f1$var$pop1(new $a801f2c896bd09f1$var$Tuple(reflectSymbol2(sym), mkOrdBox2(key2)))(v3);
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$lookup7 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox2 = $a801f2c896bd09f1$var$mkOrdBox(dictOrd);
            return function(sym) {
                return function(key2) {
                    return function(v3) {
                        return $a801f2c896bd09f1$var$lookup12(new $a801f2c896bd09f1$var$Tuple(reflectSymbol2(sym), mkOrdBox2(key2)))(v3);
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$insert11 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol2 = $a801f2c896bd09f1$var$reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox2 = $a801f2c896bd09f1$var$mkOrdBox(dictOrd);
            return function(sym) {
                return function(key2) {
                    return function(val) {
                        return function(v3) {
                            return $a801f2c896bd09f1$var$insert13(new $a801f2c896bd09f1$var$Tuple(reflectSymbol2(sym), mkOrdBox2(key2)))(val)(v3);
                        };
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$foreachSlot = function(dictApplicative) {
    var traverse_8 = $a801f2c896bd09f1$var$traverse_(dictApplicative)($a801f2c896bd09f1$var$foldableMap);
    return function(v3) {
        return function(k2) {
            return traverse_8(function($54) {
                return k2($54);
            })(v3);
        };
    };
};
var $a801f2c896bd09f1$var$empty5 = $a801f2c896bd09f1$var$empty3;
// output/Control.Applicative.Free/index.js
var $a801f2c896bd09f1$var$identity13 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$Pure = /* @__PURE__ */ function() {
    function Pure2(value0) {
        this.value0 = value0;
    }
    Pure2.create = function(value0) {
        return new Pure2(value0);
    };
    return Pure2;
}();
var $a801f2c896bd09f1$var$Lift = /* @__PURE__ */ function() {
    function Lift3(value0) {
        this.value0 = value0;
    }
    Lift3.create = function(value0) {
        return new Lift3(value0);
    };
    return Lift3;
}();
var $a801f2c896bd09f1$var$Ap = /* @__PURE__ */ function() {
    function Ap2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Ap2.create = function(value0) {
        return function(value1) {
            return new Ap2(value0, value1);
        };
    };
    return Ap2;
}();
var $a801f2c896bd09f1$var$mkAp = function(fba) {
    return function(fb) {
        return new $a801f2c896bd09f1$var$Ap(fba, fb);
    };
};
var $a801f2c896bd09f1$var$liftFreeAp = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$Lift.create;
}();
var $a801f2c896bd09f1$var$goLeft = function(dictApplicative) {
    var pure43 = $a801f2c896bd09f1$var$pure(dictApplicative);
    return function(fStack) {
        return function(valStack) {
            return function(nat) {
                return function(func) {
                    return function(count) {
                        if (func instanceof $a801f2c896bd09f1$var$Pure) return new $a801f2c896bd09f1$var$Tuple(new $a801f2c896bd09f1$var$Cons({
                            func: pure43(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $a801f2c896bd09f1$var$Lift) return new $a801f2c896bd09f1$var$Tuple(new $a801f2c896bd09f1$var$Cons({
                            func: nat(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $a801f2c896bd09f1$var$Ap) return $a801f2c896bd09f1$var$goLeft(dictApplicative)(fStack)($a801f2c896bd09f1$var$cons(func.value1)(valStack))(nat)(func.value0)(count + 1 | 0);
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 102, column 41 - line 105, column 81): " + [
                            func.constructor.name
                        ]);
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$goApply = function(dictApplicative) {
    var apply4 = $a801f2c896bd09f1$var$apply(dictApplicative.Apply0());
    return function(fStack) {
        return function(vals) {
            return function(gVal) {
                if (fStack instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left(gVal);
                if (fStack instanceof $a801f2c896bd09f1$var$Cons) {
                    var gRes = apply4(fStack.value0.func)(gVal);
                    var $31 = fStack.value0.count === 1;
                    if ($31) {
                        if (fStack.value1 instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left(gRes);
                        return $a801f2c896bd09f1$var$goApply(dictApplicative)(fStack.value1)(vals)(gRes);
                    }
                    if (vals instanceof $a801f2c896bd09f1$var$Nil) return new $a801f2c896bd09f1$var$Left(gRes);
                    if (vals instanceof $a801f2c896bd09f1$var$Cons) return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Tuple(new $a801f2c896bd09f1$var$Cons({
                        func: gRes,
                        count: fStack.value0.count - 1 | 0
                    }, fStack.value1), new $a801f2c896bd09f1$var$NonEmpty(vals.value0, vals.value1)));
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 83, column 11 - line 88, column 50): " + [
                        vals.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Control.Applicative.Free (line 72, column 3 - line 88, column 50): " + [
                    fStack.constructor.name
                ]);
            };
        };
    };
};
var $a801f2c896bd09f1$var$functorFreeAp = {
    map: function(f2) {
        return function(x4) {
            return $a801f2c896bd09f1$var$mkAp(new $a801f2c896bd09f1$var$Pure(f2))(x4);
        };
    }
};
var $a801f2c896bd09f1$var$foldFreeAp = function(dictApplicative) {
    var goApply1 = $a801f2c896bd09f1$var$goApply(dictApplicative);
    var pure43 = $a801f2c896bd09f1$var$pure(dictApplicative);
    var goLeft1 = $a801f2c896bd09f1$var$goLeft(dictApplicative);
    return function(nat) {
        return function(z3) {
            var go2 = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v3) {
                    if (v3.value1.value0 instanceof $a801f2c896bd09f1$var$Pure) {
                        var v1 = goApply1(v3.value0)(v3.value1.value1)(pure43(v3.value1.value0.value0));
                        if (v1 instanceof $a801f2c896bd09f1$var$Left) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $a801f2c896bd09f1$var$Right) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 54, column 17 - line 56, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v3.value1.value0 instanceof $a801f2c896bd09f1$var$Lift) {
                        var v1 = goApply1(v3.value0)(v3.value1.value1)(nat(v3.value1.value0.value0));
                        if (v1 instanceof $a801f2c896bd09f1$var$Left) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $a801f2c896bd09f1$var$Right) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 57, column 17 - line 59, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v3.value1.value0 instanceof $a801f2c896bd09f1$var$Ap) {
                        var nextVals = new $a801f2c896bd09f1$var$NonEmpty(v3.value1.value0.value1, v3.value1.value1);
                        $copy_v = goLeft1(v3.value0)(nextVals)(nat)(v3.value1.value0.value0)(1);
                        return;
                    }
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 53, column 5 - line 62, column 47): " + [
                        v3.value1.value0.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go2(new $a801f2c896bd09f1$var$Tuple($a801f2c896bd09f1$var$Nil.value, $a801f2c896bd09f1$var$singleton3(z3)));
        };
    };
};
var $a801f2c896bd09f1$var$retractFreeAp = function(dictApplicative) {
    return $a801f2c896bd09f1$var$foldFreeAp(dictApplicative)($a801f2c896bd09f1$var$identity13);
};
var $a801f2c896bd09f1$var$applyFreeAp = {
    apply: function(fba) {
        return function(fb) {
            return $a801f2c896bd09f1$var$mkAp(fba)(fb);
        };
    },
    Functor0: function() {
        return $a801f2c896bd09f1$var$functorFreeAp;
    }
};
var $a801f2c896bd09f1$var$applicativeFreeAp = /* @__PURE__ */ function() {
    return {
        pure: $a801f2c896bd09f1$var$Pure.create,
        Apply0: function() {
            return $a801f2c896bd09f1$var$applyFreeAp;
        }
    };
}();
var $a801f2c896bd09f1$var$foldFreeAp1 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldFreeAp($a801f2c896bd09f1$var$applicativeFreeAp);
var $a801f2c896bd09f1$var$hoistFreeAp = function(f2) {
    return $a801f2c896bd09f1$var$foldFreeAp1(function($54) {
        return $a801f2c896bd09f1$var$liftFreeAp(f2($54));
    });
};
// output/Data.CatQueue/index.js
var $a801f2c896bd09f1$var$CatQueue = /* @__PURE__ */ function() {
    function CatQueue2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatQueue2.create = function(value0) {
        return function(value1) {
            return new CatQueue2(value0, value1);
        };
    };
    return CatQueue2;
}();
var $a801f2c896bd09f1$var$uncons4 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v3) {
        if (v3.value0 instanceof $a801f2c896bd09f1$var$Nil && v3.value1 instanceof $a801f2c896bd09f1$var$Nil) {
            $tco_done = true;
            return $a801f2c896bd09f1$var$Nothing.value;
        }
        if (v3.value0 instanceof $a801f2c896bd09f1$var$Nil) {
            $copy_v = new $a801f2c896bd09f1$var$CatQueue($a801f2c896bd09f1$var$reverse(v3.value1), $a801f2c896bd09f1$var$Nil.value);
            return;
        }
        if (v3.value0 instanceof $a801f2c896bd09f1$var$Cons) {
            $tco_done = true;
            return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Tuple(v3.value0.value0, new $a801f2c896bd09f1$var$CatQueue(v3.value0.value1, v3.value1)));
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 82, column 1 - line 82, column 63): " + [
            v3.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $a801f2c896bd09f1$var$snoc3 = function(v3) {
    return function(a3) {
        return new $a801f2c896bd09f1$var$CatQueue(v3.value0, new $a801f2c896bd09f1$var$Cons(a3, v3.value1));
    };
};
var $a801f2c896bd09f1$var$$$null3 = function(v3) {
    if (v3.value0 instanceof $a801f2c896bd09f1$var$Nil && v3.value1 instanceof $a801f2c896bd09f1$var$Nil) return true;
    return false;
};
var $a801f2c896bd09f1$var$empty6 = /* @__PURE__ */ function() {
    return new $a801f2c896bd09f1$var$CatQueue($a801f2c896bd09f1$var$Nil.value, $a801f2c896bd09f1$var$Nil.value);
}();
// output/Data.CatList/index.js
var $a801f2c896bd09f1$var$CatNil = /* @__PURE__ */ function() {
    function CatNil2() {}
    CatNil2.value = new CatNil2();
    return CatNil2;
}();
var $a801f2c896bd09f1$var$CatCons = /* @__PURE__ */ function() {
    function CatCons2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatCons2.create = function(value0) {
        return function(value1) {
            return new CatCons2(value0, value1);
        };
    };
    return CatCons2;
}();
var $a801f2c896bd09f1$var$link = function(v3) {
    return function(v1) {
        if (v3 instanceof $a801f2c896bd09f1$var$CatNil) return v1;
        if (v1 instanceof $a801f2c896bd09f1$var$CatNil) return v3;
        if (v3 instanceof $a801f2c896bd09f1$var$CatCons) return new $a801f2c896bd09f1$var$CatCons(v3.value0, $a801f2c896bd09f1$var$snoc3(v3.value1)(v1));
        throw new Error("Failed pattern match at Data.CatList (line 108, column 1 - line 108, column 54): " + [
            v3.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$foldr6 = function(k2) {
    return function(b3) {
        return function(q4) {
            var foldl10 = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v3, v1, v22) {
                            if (v22 instanceof $a801f2c896bd09f1$var$Nil) {
                                $tco_done = true;
                                return v1;
                            }
                            if (v22 instanceof $a801f2c896bd09f1$var$Cons) {
                                $tco_var_v = v3;
                                $tco_var_v1 = v3(v1)(v22.value0);
                                $copy_v2 = v22.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.CatList (line 124, column 3 - line 124, column 59): " + [
                                v3.constructor.name,
                                v1.constructor.name,
                                v22.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            var go2 = function($copy_xs) {
                return function($copy_ys) {
                    var $tco_var_xs = $copy_xs;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(xs, ys) {
                        var v3 = $a801f2c896bd09f1$var$uncons4(xs);
                        if (v3 instanceof $a801f2c896bd09f1$var$Nothing) {
                            $tco_done1 = true;
                            return foldl10(function(x4) {
                                return function(i2) {
                                    return i2(x4);
                                };
                            })(b3)(ys);
                        }
                        if (v3 instanceof $a801f2c896bd09f1$var$Just) {
                            $tco_var_xs = v3.value0.value1;
                            $copy_ys = new $a801f2c896bd09f1$var$Cons(k2(v3.value0.value0), ys);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 120, column 14 - line 122, column 67): " + [
                            v3.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
                    return $tco_result;
                };
            };
            return go2(q4)($a801f2c896bd09f1$var$Nil.value);
        };
    };
};
var $a801f2c896bd09f1$var$uncons5 = function(v3) {
    if (v3 instanceof $a801f2c896bd09f1$var$CatNil) return $a801f2c896bd09f1$var$Nothing.value;
    if (v3 instanceof $a801f2c896bd09f1$var$CatCons) return new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Tuple(v3.value0, function() {
        var $66 = $a801f2c896bd09f1$var$$$null3(v3.value1);
        if ($66) return $a801f2c896bd09f1$var$CatNil.value;
        return $a801f2c896bd09f1$var$foldr6($a801f2c896bd09f1$var$link)($a801f2c896bd09f1$var$CatNil.value)(v3.value1);
    }()));
    throw new Error("Failed pattern match at Data.CatList (line 99, column 1 - line 99, column 61): " + [
        v3.constructor.name
    ]);
};
var $a801f2c896bd09f1$var$empty7 = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$CatNil.value;
}();
var $a801f2c896bd09f1$var$append9 = $a801f2c896bd09f1$var$link;
var $a801f2c896bd09f1$var$semigroupCatList = {
    append: $a801f2c896bd09f1$var$append9
};
var $a801f2c896bd09f1$var$snoc4 = function(cat) {
    return function(a3) {
        return $a801f2c896bd09f1$var$append9(cat)(new $a801f2c896bd09f1$var$CatCons(a3, $a801f2c896bd09f1$var$empty6));
    };
};
// output/Control.Monad.Free/index.js
var $a801f2c896bd09f1$var$$runtime_lazy8 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$append10 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupCatList);
var $a801f2c896bd09f1$var$Free = /* @__PURE__ */ function() {
    function Free2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Free2.create = function(value0) {
        return function(value1) {
            return new Free2(value0, value1);
        };
    };
    return Free2;
}();
var $a801f2c896bd09f1$var$Return = /* @__PURE__ */ function() {
    function Return2(value0) {
        this.value0 = value0;
    }
    Return2.create = function(value0) {
        return new Return2(value0);
    };
    return Return2;
}();
var $a801f2c896bd09f1$var$Bind = /* @__PURE__ */ function() {
    function Bind2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Bind2.create = function(value0) {
        return function(value1) {
            return new Bind2(value0, value1);
        };
    };
    return Bind2;
}();
var $a801f2c896bd09f1$var$toView = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v3) {
        var runExpF = function(v23) {
            return v23;
        };
        var concatF = function(v23) {
            return function(r) {
                return new $a801f2c896bd09f1$var$Free(v23.value0, $a801f2c896bd09f1$var$append10(v23.value1)(r));
            };
        };
        if (v3.value0 instanceof $a801f2c896bd09f1$var$Return) {
            var v22 = $a801f2c896bd09f1$var$uncons5(v3.value1);
            if (v22 instanceof $a801f2c896bd09f1$var$Nothing) {
                $tco_done = true;
                return new $a801f2c896bd09f1$var$Return(v3.value0.value0);
            }
            if (v22 instanceof $a801f2c896bd09f1$var$Just) {
                $copy_v = concatF(runExpF(v22.value0.value0)(v3.value0.value0))(v22.value0.value1);
                return;
            }
            throw new Error("Failed pattern match at Control.Monad.Free (line 227, column 7 - line 231, column 64): " + [
                v22.constructor.name
            ]);
        }
        if (v3.value0 instanceof $a801f2c896bd09f1$var$Bind) {
            $tco_done = true;
            return new $a801f2c896bd09f1$var$Bind(v3.value0.value0, function(a3) {
                return concatF(v3.value0.value1(a3))(v3.value1);
            });
        }
        throw new Error("Failed pattern match at Control.Monad.Free (line 225, column 3 - line 233, column 56): " + [
            v3.value0.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $a801f2c896bd09f1$var$fromView = function(f2) {
    return new $a801f2c896bd09f1$var$Free(f2, $a801f2c896bd09f1$var$empty7);
};
var $a801f2c896bd09f1$var$freeMonad = {
    Applicative0: function() {
        return $a801f2c896bd09f1$var$freeApplicative;
    },
    Bind1: function() {
        return $a801f2c896bd09f1$var$freeBind;
    }
};
var $a801f2c896bd09f1$var$freeFunctor = {
    map: function(k2) {
        return function(f2) {
            return $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$freeBind)(function() {
                var $189 = $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$freeApplicative);
                return function($190) {
                    return $189(k2($190));
                };
            }())(f2);
        };
    }
};
var $a801f2c896bd09f1$var$freeBind = {
    bind: function(v3) {
        return function(k2) {
            return new $a801f2c896bd09f1$var$Free(v3.value0, $a801f2c896bd09f1$var$snoc4(v3.value1)(k2));
        };
    },
    Apply0: function() {
        return $a801f2c896bd09f1$var$$lazy_freeApply(0);
    }
};
var $a801f2c896bd09f1$var$freeApplicative = {
    pure: function($191) {
        return $a801f2c896bd09f1$var$fromView($a801f2c896bd09f1$var$Return.create($191));
    },
    Apply0: function() {
        return $a801f2c896bd09f1$var$$lazy_freeApply(0);
    }
};
var $a801f2c896bd09f1$var$$lazy_freeApply = /* @__PURE__ */ $a801f2c896bd09f1$var$$runtime_lazy8("freeApply", "Control.Monad.Free", function() {
    return {
        apply: $a801f2c896bd09f1$var$ap($a801f2c896bd09f1$var$freeMonad),
        Functor0: function() {
            return $a801f2c896bd09f1$var$freeFunctor;
        }
    };
});
var $a801f2c896bd09f1$var$freeApply = /* @__PURE__ */ $a801f2c896bd09f1$var$$lazy_freeApply(77);
var $a801f2c896bd09f1$var$pure29 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$freeApplicative);
var $a801f2c896bd09f1$var$liftF = function(f2) {
    return $a801f2c896bd09f1$var$fromView(new $a801f2c896bd09f1$var$Bind(f2, function($192) {
        return $a801f2c896bd09f1$var$pure29($192);
    }));
};
var $a801f2c896bd09f1$var$foldFree = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var map121 = $a801f2c896bd09f1$var$map(Monad0.Bind1().Apply0().Functor0());
    var pure116 = $a801f2c896bd09f1$var$pure(Monad0.Applicative0());
    var tailRecM5 = $a801f2c896bd09f1$var$tailRecM(dictMonadRec);
    return function(k2) {
        var go2 = function(f2) {
            var v3 = $a801f2c896bd09f1$var$toView(f2);
            if (v3 instanceof $a801f2c896bd09f1$var$Return) return map121($a801f2c896bd09f1$var$Done.create)(pure116(v3.value0));
            if (v3 instanceof $a801f2c896bd09f1$var$Bind) return map121(function($199) {
                return $a801f2c896bd09f1$var$Loop.create(v3.value1($199));
            })(k2(v3.value0));
            throw new Error("Failed pattern match at Control.Monad.Free (line 158, column 10 - line 160, column 37): " + [
                v3.constructor.name
            ]);
        };
        return tailRecM5(go2);
    };
};
// output/Effect.Aff.Class/index.js
var $a801f2c896bd09f1$var$monadAffAff = {
    liftAff: /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn),
    MonadEffect0: function() {
        return $a801f2c896bd09f1$var$monadEffectAff;
    }
};
var $a801f2c896bd09f1$var$liftAff = function(dict) {
    return dict.liftAff;
};
// output/Halogen.Query.ChildQuery/index.js
var $a801f2c896bd09f1$var$unChildQueryBox = $a801f2c896bd09f1$var$unsafeCoerce2;
// output/Unsafe.Reference/foreign.js
function $a801f2c896bd09f1$var$reallyUnsafeRefEq(a3) {
    return function(b3) {
        return a3 === b3;
    };
}
// output/Unsafe.Reference/index.js
var $a801f2c896bd09f1$var$unsafeRefEq = $a801f2c896bd09f1$var$reallyUnsafeRefEq;
// output/Halogen.Subscription/index.js
var $a801f2c896bd09f1$var$$$void5 = /* @__PURE__ */ $a801f2c896bd09f1$var$$$void($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$coerce5 = /* @__PURE__ */ $a801f2c896bd09f1$var$coerce();
var $a801f2c896bd09f1$var$bind26 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindEffect);
var $a801f2c896bd09f1$var$append11 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$traverse_2 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$traverse_1 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_2($a801f2c896bd09f1$var$foldableArray);
var $a801f2c896bd09f1$var$unsubscribe = function(v3) {
    return v3;
};
var $a801f2c896bd09f1$var$subscribe = function(v3) {
    return function(k2) {
        return v3(function($76) {
            return $a801f2c896bd09f1$var$$$void5(k2($76));
        });
    };
};
var $a801f2c896bd09f1$var$notify = function(v3) {
    return function(a3) {
        return v3(a3);
    };
};
var $a801f2c896bd09f1$var$makeEmitter = $a801f2c896bd09f1$var$coerce5;
var $a801f2c896bd09f1$var$create = function __do() {
    var subscribers = $a801f2c896bd09f1$var$$$new([])();
    return {
        emitter: function(k2) {
            return function __do2() {
                $a801f2c896bd09f1$var$modify_(function(v3) {
                    return $a801f2c896bd09f1$var$append11(v3)([
                        k2
                    ]);
                })(subscribers)();
                return $a801f2c896bd09f1$var$modify_($a801f2c896bd09f1$var$deleteBy($a801f2c896bd09f1$var$unsafeRefEq)(k2))(subscribers);
            };
        },
        listener: function(a3) {
            return $a801f2c896bd09f1$var$bind26($a801f2c896bd09f1$var$read(subscribers))($a801f2c896bd09f1$var$traverse_1(function(k2) {
                return k2(a3);
            }));
        }
    };
};
// output/Halogen.Query.HalogenM/index.js
var $a801f2c896bd09f1$var$SubscriptionId = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$ForkId = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$State = /* @__PURE__ */ function() {
    function State2(value0) {
        this.value0 = value0;
    }
    State2.create = function(value0) {
        return new State2(value0);
    };
    return State2;
}();
var $a801f2c896bd09f1$var$Subscribe = /* @__PURE__ */ function() {
    function Subscribe2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Subscribe2.create = function(value0) {
        return function(value1) {
            return new Subscribe2(value0, value1);
        };
    };
    return Subscribe2;
}();
var $a801f2c896bd09f1$var$Unsubscribe = /* @__PURE__ */ function() {
    function Unsubscribe2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Unsubscribe2.create = function(value0) {
        return function(value1) {
            return new Unsubscribe2(value0, value1);
        };
    };
    return Unsubscribe2;
}();
var $a801f2c896bd09f1$var$Lift2 = /* @__PURE__ */ function() {
    function Lift3(value0) {
        this.value0 = value0;
    }
    Lift3.create = function(value0) {
        return new Lift3(value0);
    };
    return Lift3;
}();
var $a801f2c896bd09f1$var$ChildQuery2 = /* @__PURE__ */ function() {
    function ChildQuery3(value0) {
        this.value0 = value0;
    }
    ChildQuery3.create = function(value0) {
        return new ChildQuery3(value0);
    };
    return ChildQuery3;
}();
var $a801f2c896bd09f1$var$Raise = /* @__PURE__ */ function() {
    function Raise2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Raise2.create = function(value0) {
        return function(value1) {
            return new Raise2(value0, value1);
        };
    };
    return Raise2;
}();
var $a801f2c896bd09f1$var$Par = /* @__PURE__ */ function() {
    function Par2(value0) {
        this.value0 = value0;
    }
    Par2.create = function(value0) {
        return new Par2(value0);
    };
    return Par2;
}();
var $a801f2c896bd09f1$var$Fork = /* @__PURE__ */ function() {
    function Fork2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Fork2.create = function(value0) {
        return function(value1) {
            return new Fork2(value0, value1);
        };
    };
    return Fork2;
}();
var $a801f2c896bd09f1$var$Join = /* @__PURE__ */ function() {
    function Join2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Join2.create = function(value0) {
        return function(value1) {
            return new Join2(value0, value1);
        };
    };
    return Join2;
}();
var $a801f2c896bd09f1$var$Kill = /* @__PURE__ */ function() {
    function Kill2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Kill2.create = function(value0) {
        return function(value1) {
            return new Kill2(value0, value1);
        };
    };
    return Kill2;
}();
var $a801f2c896bd09f1$var$GetRef = /* @__PURE__ */ function() {
    function GetRef2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    GetRef2.create = function(value0) {
        return function(value1) {
            return new GetRef2(value0, value1);
        };
    };
    return GetRef2;
}();
var $a801f2c896bd09f1$var$HalogenM = function(x4) {
    return x4;
};
var $a801f2c896bd09f1$var$subscribe$prime = function(esc) {
    return $a801f2c896bd09f1$var$liftF(new $a801f2c896bd09f1$var$Subscribe(esc, $a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$unit)));
};
var $a801f2c896bd09f1$var$raise = function(o2) {
    return $a801f2c896bd09f1$var$liftF(new $a801f2c896bd09f1$var$Raise(o2, $a801f2c896bd09f1$var$unit));
};
var $a801f2c896bd09f1$var$ordSubscriptionId = $a801f2c896bd09f1$var$ordInt;
var $a801f2c896bd09f1$var$ordForkId = $a801f2c896bd09f1$var$ordInt;
var $a801f2c896bd09f1$var$monadHalogenM = $a801f2c896bd09f1$var$freeMonad;
var $a801f2c896bd09f1$var$monadStateHalogenM = {
    state: function($181) {
        return $a801f2c896bd09f1$var$HalogenM($a801f2c896bd09f1$var$liftF($a801f2c896bd09f1$var$State.create($181)));
    },
    Monad0: function() {
        return $a801f2c896bd09f1$var$monadHalogenM;
    }
};
var $a801f2c896bd09f1$var$monadEffectHalogenM = function(dictMonadEffect) {
    return {
        liftEffect: function() {
            var $186 = $a801f2c896bd09f1$var$liftEffect(dictMonadEffect);
            return function($187) {
                return $a801f2c896bd09f1$var$HalogenM($a801f2c896bd09f1$var$liftF($a801f2c896bd09f1$var$Lift2.create($186($187))));
            };
        }(),
        Monad0: function() {
            return $a801f2c896bd09f1$var$monadHalogenM;
        }
    };
};
var $a801f2c896bd09f1$var$monadAffHalogenM = function(dictMonadAff) {
    var monadEffectHalogenM1 = $a801f2c896bd09f1$var$monadEffectHalogenM(dictMonadAff.MonadEffect0());
    return {
        liftAff: function() {
            var $188 = $a801f2c896bd09f1$var$liftAff(dictMonadAff);
            return function($189) {
                return $a801f2c896bd09f1$var$HalogenM($a801f2c896bd09f1$var$liftF($a801f2c896bd09f1$var$Lift2.create($188($189))));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectHalogenM1;
        }
    };
};
var $a801f2c896bd09f1$var$functorHalogenM = $a801f2c896bd09f1$var$freeFunctor;
var $a801f2c896bd09f1$var$bindHalogenM = $a801f2c896bd09f1$var$freeBind;
var $a801f2c896bd09f1$var$applyHalogenM = $a801f2c896bd09f1$var$freeApply;
var $a801f2c896bd09f1$var$applicativeHalogenM = $a801f2c896bd09f1$var$freeApplicative;
// output/Halogen.Query.HalogenQ/index.js
var $a801f2c896bd09f1$var$Initialize = /* @__PURE__ */ function() {
    function Initialize2(value0) {
        this.value0 = value0;
    }
    Initialize2.create = function(value0) {
        return new Initialize2(value0);
    };
    return Initialize2;
}();
var $a801f2c896bd09f1$var$Finalize = /* @__PURE__ */ function() {
    function Finalize2(value0) {
        this.value0 = value0;
    }
    Finalize2.create = function(value0) {
        return new Finalize2(value0);
    };
    return Finalize2;
}();
var $a801f2c896bd09f1$var$Receive = /* @__PURE__ */ function() {
    function Receive2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Receive2.create = function(value0) {
        return function(value1) {
            return new Receive2(value0, value1);
        };
    };
    return Receive2;
}();
var $a801f2c896bd09f1$var$Action2 = /* @__PURE__ */ function() {
    function Action3(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Action3.create = function(value0) {
        return function(value1) {
            return new Action3(value0, value1);
        };
    };
    return Action3;
}();
var $a801f2c896bd09f1$var$Query = /* @__PURE__ */ function() {
    function Query2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Query2.create = function(value0) {
        return function(value1) {
            return new Query2(value0, value1);
        };
    };
    return Query2;
}();
// output/Halogen.VDom.Thunk/index.js
var $a801f2c896bd09f1$var$$runtime_lazy9 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$unsafeEqThunk = function(v3, v1) {
    return $a801f2c896bd09f1$var$refEq2(v3.value0, v1.value0) && $a801f2c896bd09f1$var$refEq2(v3.value1, v1.value1) && v3.value1(v3.value3, v1.value3);
};
var $a801f2c896bd09f1$var$runThunk = function(v3) {
    return v3.value2(v3.value3);
};
var $a801f2c896bd09f1$var$buildThunk = function(toVDom) {
    var haltThunk = function(state3) {
        return $a801f2c896bd09f1$var$halt(state3.vdom);
    };
    var $lazy_patchThunk = $a801f2c896bd09f1$var$$runtime_lazy9("patchThunk", "Halogen.VDom.Thunk", function() {
        return function(state3, t2) {
            var $48 = $a801f2c896bd09f1$var$unsafeEqThunk(state3.thunk, t2);
            if ($48) return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2($a801f2c896bd09f1$var$extract2(state3.vdom), state3, $lazy_patchThunk(112), haltThunk));
            var vdom = $a801f2c896bd09f1$var$step(state3.vdom, toVDom($a801f2c896bd09f1$var$runThunk(t2)));
            return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2($a801f2c896bd09f1$var$extract2(vdom), {
                vdom: vdom,
                thunk: t2
            }, $lazy_patchThunk(115), haltThunk));
        };
    });
    var patchThunk = $lazy_patchThunk(108);
    var renderThunk = function(spec) {
        return function(t2) {
            var vdom = $a801f2c896bd09f1$var$buildVDom(spec)(toVDom($a801f2c896bd09f1$var$runThunk(t2)));
            return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2($a801f2c896bd09f1$var$extract2(vdom), {
                thunk: t2,
                vdom: vdom
            }, patchThunk, haltThunk));
        };
    };
    return renderThunk;
};
// output/Halogen.Component/index.js
var $a801f2c896bd09f1$var$voidLeft2 = /* @__PURE__ */ $a801f2c896bd09f1$var$voidLeft($a801f2c896bd09f1$var$functorHalogenM);
var $a801f2c896bd09f1$var$traverse_3 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_($a801f2c896bd09f1$var$applicativeHalogenM)($a801f2c896bd09f1$var$foldableMaybe);
var $a801f2c896bd09f1$var$map44 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorHalogenM);
var $a801f2c896bd09f1$var$pure30 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeHalogenM);
var $a801f2c896bd09f1$var$lookup8 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup7();
var $a801f2c896bd09f1$var$pop3 = /* @__PURE__ */ $a801f2c896bd09f1$var$pop2();
var $a801f2c896bd09f1$var$insert14 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert11();
var $a801f2c896bd09f1$var$ComponentSlot = /* @__PURE__ */ function() {
    function ComponentSlot2(value0) {
        this.value0 = value0;
    }
    ComponentSlot2.create = function(value0) {
        return new ComponentSlot2(value0);
    };
    return ComponentSlot2;
}();
var $a801f2c896bd09f1$var$ThunkSlot = /* @__PURE__ */ function() {
    function ThunkSlot2(value0) {
        this.value0 = value0;
    }
    ThunkSlot2.create = function(value0) {
        return new ThunkSlot2(value0);
    };
    return ThunkSlot2;
}();
var $a801f2c896bd09f1$var$unComponentSlot = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$unComponent = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$mkEval = function(args) {
    return function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$Initialize) return $a801f2c896bd09f1$var$voidLeft2($a801f2c896bd09f1$var$traverse_3(args.handleAction)(args.initialize))(v3.value0);
        if (v3 instanceof $a801f2c896bd09f1$var$Finalize) return $a801f2c896bd09f1$var$voidLeft2($a801f2c896bd09f1$var$traverse_3(args.handleAction)(args.finalize))(v3.value0);
        if (v3 instanceof $a801f2c896bd09f1$var$Receive) return $a801f2c896bd09f1$var$voidLeft2($a801f2c896bd09f1$var$traverse_3(args.handleAction)(args.receive(v3.value0)))(v3.value1);
        if (v3 instanceof $a801f2c896bd09f1$var$Action2) return $a801f2c896bd09f1$var$voidLeft2(args.handleAction(v3.value0))(v3.value1);
        if (v3 instanceof $a801f2c896bd09f1$var$Query) return $a801f2c896bd09f1$var$unCoyoneda(function(g2) {
            var $45 = $a801f2c896bd09f1$var$map44($a801f2c896bd09f1$var$maybe(v3.value1($a801f2c896bd09f1$var$unit))(g2));
            return function($46) {
                return $45(args.handleQuery($46));
            };
        })(v3.value0);
        throw new Error("Failed pattern match at Halogen.Component (line 182, column 15 - line 192, column 71): " + [
            v3.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$mkComponentSlot = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$mkComponent = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$defaultEval = /* @__PURE__ */ function() {
    return {
        handleAction: $a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$pure30($a801f2c896bd09f1$var$unit)),
        handleQuery: $a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$pure30($a801f2c896bd09f1$var$Nothing.value)),
        receive: $a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$Nothing.value),
        initialize: $a801f2c896bd09f1$var$Nothing.value,
        finalize: $a801f2c896bd09f1$var$Nothing.value
    };
}();
var $a801f2c896bd09f1$var$componentSlot = function() {
    return function(dictIsSymbol) {
        var lookup15 = $a801f2c896bd09f1$var$lookup8(dictIsSymbol);
        var pop12 = $a801f2c896bd09f1$var$pop3(dictIsSymbol);
        var insert17 = $a801f2c896bd09f1$var$insert14(dictIsSymbol);
        return function(dictOrd) {
            var lookup25 = lookup15(dictOrd);
            var pop22 = pop12(dictOrd);
            var insert23 = insert17(dictOrd);
            return function(label5) {
                return function(p3) {
                    return function(comp) {
                        return function(input3) {
                            return function(output2) {
                                return $a801f2c896bd09f1$var$mkComponentSlot({
                                    get: lookup25(label5)(p3),
                                    pop: pop22(label5)(p3),
                                    set: insert23(label5)(p3),
                                    component: comp,
                                    input: input3,
                                    output: output2
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
// output/App.Tabs.Export/index.js
var $a801f2c896bd09f1$var$map45 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEither);
var $a801f2c896bd09f1$var$recordWriteForeign3 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign();
var $a801f2c896bd09f1$var$writeForeignVariant2 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignVariant();
var $a801f2c896bd09f1$var$writeForeignMaybe2 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$writeForeignString);
var $a801f2c896bd09f1$var$leftIsSymbol3 = {
    reflectSymbol: function() {
        return "left";
    }
};
var $a801f2c896bd09f1$var$consWriteForeignFields4 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$leftIsSymbol3);
var $a801f2c896bd09f1$var$idIsSymbol5 = {
    reflectSymbol: function() {
        return "id";
    }
};
var $a801f2c896bd09f1$var$consWriteForeignFields12 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$idIsSymbol5);
var $a801f2c896bd09f1$var$pitchIsSymbol5 = {
    reflectSymbol: function() {
        return "pitch";
    }
};
var $a801f2c896bd09f1$var$recordWriteForeign1 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields12($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$pitchIsSymbol5)(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignPitch($a801f2c896bd09f1$var$writeForeignPitchSInterva))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$writeForeignStartStop2 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignStartStop($a801f2c896bd09f1$var$recordWriteForeign1);
var $a801f2c896bd09f1$var$rightIsSymbol4 = {
    reflectSymbol: function() {
        return "right";
    }
};
var $a801f2c896bd09f1$var$consWriteForeignFields23 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$rightIsSymbol4);
var $a801f2c896bd09f1$var$recordWriteForeign22 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields4($a801f2c896bd09f1$var$writeForeignStartStop2)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields23($a801f2c896bd09f1$var$writeForeignStartStop2)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$writeForeignArray2 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray($a801f2c896bd09f1$var$recordWriteForeign22);
var $a801f2c896bd09f1$var$recordWriteForeign32 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "prevTime";
    }
})($a801f2c896bd09f1$var$writeForeignMaybe2)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "ties";
    }
})($a801f2c896bd09f1$var$writeForeignArray2)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$consWriteForeignFields32 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "children";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields42 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "child";
    }
});
var $a801f2c896bd09f1$var$writeForeignArray1 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray($a801f2c896bd09f1$var$recordWriteForeign1);
var $a801f2c896bd09f1$var$recordWriteForeign4 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields4($a801f2c896bd09f1$var$writeForeignArray1)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields23($a801f2c896bd09f1$var$writeForeignArray1)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$consWriteForeignFields5 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "parent";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields6 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields5($a801f2c896bd09f1$var$recordWriteForeign1)($a801f2c896bd09f1$var$nilWriteForeignFields)()()();
var $a801f2c896bd09f1$var$consWriteForeignFields7 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "ids";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields8 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields4($a801f2c896bd09f1$var$writeForeignTransId);
var $a801f2c896bd09f1$var$consWriteForeignFields9 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields23($a801f2c896bd09f1$var$writeForeignTransId);
var $a801f2c896bd09f1$var$rsliceIsSymbol = {
    reflectSymbol: function() {
        return "rslice";
    }
};
var $a801f2c896bd09f1$var$consWriteForeignFields10 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$rsliceIsSymbol);
var $a801f2c896bd09f1$var$passingIsSymbol3 = {
    reflectSymbol: function() {
        return "passing";
    }
};
var $a801f2c896bd09f1$var$consWriteForeignFields11 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$passingIsSymbol3);
var $a801f2c896bd09f1$var$regularIsSymbol4 = {
    reflectSymbol: function() {
        return "regular";
    }
};
var $a801f2c896bd09f1$var$consWriteForeignFields122 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$regularIsSymbol4);
var $a801f2c896bd09f1$var$recordWriteForeign5 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields11($a801f2c896bd09f1$var$writeForeignArray2)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields122($a801f2c896bd09f1$var$writeForeignArray2)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$consWriteForeignFields13 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "unexplained";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields14 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields32(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields42($a801f2c896bd09f1$var$recordWriteForeign1)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "orn";
    }
})($a801f2c896bd09f1$var$writeForeignMaybe2)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())));
var $a801f2c896bd09f1$var$writeForeignArray22 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields14($a801f2c896bd09f1$var$consWriteForeignFields6)()()()));
var $a801f2c896bd09f1$var$writeForeignArray3 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields14(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields5($a801f2c896bd09f1$var$recordWriteForeign22)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()()));
var $a801f2c896bd09f1$var$recordWriteForeign6 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "fromLeft";
    }
})($a801f2c896bd09f1$var$writeForeignArray22)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "fromRight";
    }
})($a801f2c896bd09f1$var$writeForeignArray22)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields7(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields8(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields9(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "slice";
    }
})($a801f2c896bd09f1$var$writeForeignSliceId)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "keepLeft";
    }
})($a801f2c896bd09f1$var$writeForeignArray2)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "keepRight";
    }
})($a801f2c896bd09f1$var$writeForeignArray2)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "passLeft";
    }
})($a801f2c896bd09f1$var$writeForeignArray2)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "passRight";
    }
})($a801f2c896bd09f1$var$writeForeignArray2)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields11($a801f2c896bd09f1$var$writeForeignArray3)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields122($a801f2c896bd09f1$var$writeForeignArray3)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields13(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$writeForeignArray1))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()());
var $a801f2c896bd09f1$var$startIsSymbol = {
    reflectSymbol: function() {
        return "start";
    }
};
var $a801f2c896bd09f1$var$notesIsSymbol2 = {
    reflectSymbol: function() {
        return "notes";
    }
};
var $a801f2c896bd09f1$var$recordWriteForeign7 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields12(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$writeForeignSliceId))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$notesIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignStartStop($a801f2c896bd09f1$var$writeForeignArray1))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$stylesIsSymbol = {
    reflectSymbol: function() {
        return "styles";
    }
};
var $a801f2c896bd09f1$var$cssIsSymbol = {
    reflectSymbol: function() {
        return "css";
    }
};
var $a801f2c896bd09f1$var$classesIsSymbol = {
    reflectSymbol: function() {
        return "classes";
    }
};
var $a801f2c896bd09f1$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $a801f2c896bd09f1$var$recordWriteForeign8 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$classesIsSymbol)($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$labelIsSymbol)($a801f2c896bd09f1$var$writeForeignString)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$writeForeignObject2 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignObject($a801f2c896bd09f1$var$recordWriteForeign8);
var $a801f2c896bd09f1$var$transIsSymbol = {
    reflectSymbol: function() {
        return "trans";
    }
};
var $a801f2c896bd09f1$var$edgesIsSymbol = {
    reflectSymbol: function() {
        return "edges";
    }
};
var $a801f2c896bd09f1$var$recordWriteForeign9 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "derivation";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignVariant2(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "freezeLeft";
    }
})($a801f2c896bd09f1$var$recordWriteForeign32)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "freezeOnly";
    }
})($a801f2c896bd09f1$var$recordWriteForeign32)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "hori";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields32(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields42(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignVariant2(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "bothChildren";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields4($a801f2c896bd09f1$var$recordWriteForeign1)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields23($a801f2c896bd09f1$var$recordWriteForeign1)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()()))()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "leftChild";
    }
})($a801f2c896bd09f1$var$recordWriteForeign1)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "rightChild";
    }
})($a801f2c896bd09f1$var$recordWriteForeign1)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "tooManyChildren";
    }
})($a801f2c896bd09f1$var$recordWriteForeign4)()($a801f2c896bd09f1$var$nilWriteForeignVariant))))))($a801f2c896bd09f1$var$consWriteForeignFields6)()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields7(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields8(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "lslice";
    }
})($a801f2c896bd09f1$var$writeForeignSliceId)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "mid";
    }
})($a801f2c896bd09f1$var$writeForeignTransId)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields9(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields10($a801f2c896bd09f1$var$writeForeignSliceId)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()())()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "midEdges";
    }
})($a801f2c896bd09f1$var$recordWriteForeign5)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields13(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$recordWriteForeign4))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()()))()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "splitLeft";
    }
})($a801f2c896bd09f1$var$recordWriteForeign6)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "splitOnly";
    }
})($a801f2c896bd09f1$var$recordWriteForeign6)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "splitRight";
    }
})($a801f2c896bd09f1$var$recordWriteForeign6)()($a801f2c896bd09f1$var$nilWriteForeignVariant)))))))))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$startIsSymbol)($a801f2c896bd09f1$var$recordWriteForeign7)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$stylesIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$cssIsSymbol)($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "edgeStyles";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "edge";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields4($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields23($a801f2c896bd09f1$var$writeForeignString)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()()))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "style";
    }
})($a801f2c896bd09f1$var$recordWriteForeign8)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "noteStyles";
    }
})($a801f2c896bd09f1$var$writeForeignObject2)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "sliceStyles";
    }
})($a801f2c896bd09f1$var$writeForeignObject2)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "staffType";
    }
})($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "transStyles";
    }
})($a801f2c896bd09f1$var$writeForeignObject2)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "topSegments";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields10($a801f2c896bd09f1$var$recordWriteForeign7)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$transIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$edgesIsSymbol)($a801f2c896bd09f1$var$recordWriteForeign5)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields12(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$writeForeignTransId))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()()))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()());
var $a801f2c896bd09f1$var$writeJSONPretty2 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeJSONPretty($a801f2c896bd09f1$var$recordWriteForeign9);
var $a801f2c896bd09f1$var$writeJSON3 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeJSON($a801f2c896bd09f1$var$recordWriteForeign9);
var $a801f2c896bd09f1$var$bindFlipped7 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindEither);
var $a801f2c896bd09f1$var$type_4 = /* @__PURE__ */ $a801f2c896bd09f1$var$type_($a801f2c896bd09f1$var$isPropInputType);
var $a801f2c896bd09f1$var$eqRec5 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec();
var $a801f2c896bd09f1$var$eqRowCons4 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons($a801f2c896bd09f1$var$eqRowNil)();
var $a801f2c896bd09f1$var$transitionsIsSymbol = {
    reflectSymbol: function() {
        return "transitions";
    }
};
var $a801f2c896bd09f1$var$eqRec12 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$labelIsSymbol)($a801f2c896bd09f1$var$eqString))()($a801f2c896bd09f1$var$classesIsSymbol)($a801f2c896bd09f1$var$eqString));
var $a801f2c896bd09f1$var$staffIsSymbol = {
    reflectSymbol: function() {
        return "staff";
    }
};
var $a801f2c896bd09f1$var$slicesIsSymbol2 = {
    reflectSymbol: function() {
        return "slices";
    }
};
var $a801f2c896bd09f1$var$reductionIsSymbol = {
    reflectSymbol: function() {
        return "reduction";
    }
};
var $a801f2c896bd09f1$var$xIsSymbol = {
    reflectSymbol: function() {
        return "x";
    }
};
var $a801f2c896bd09f1$var$parentsIsSymbol = {
    reflectSymbol: function() {
        return "parents";
    }
};
var $a801f2c896bd09f1$var$noteIsSymbol2 = {
    reflectSymbol: function() {
        return "note";
    }
};
var $a801f2c896bd09f1$var$eqRec23 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$pitchIsSymbol5)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqPitch($a801f2c896bd09f1$var$eqSInterval)))()($a801f2c896bd09f1$var$idIsSymbol5)($a801f2c896bd09f1$var$eqString));
var $a801f2c896bd09f1$var$eqRowCons1 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$noteIsSymbol2)($a801f2c896bd09f1$var$eqRec23))();
var $a801f2c896bd09f1$var$explIsSymbol2 = {
    reflectSymbol: function() {
        return "expl";
    }
};
var $a801f2c896bd09f1$var$eqRec32 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$xIsSymbol)($a801f2c896bd09f1$var$eqNumber))()($a801f2c896bd09f1$var$parentsIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqParents($a801f2c896bd09f1$var$eqSliceId)))()($a801f2c896bd09f1$var$notesIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$eqArray(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons1($a801f2c896bd09f1$var$explIsSymbol2)($a801f2c896bd09f1$var$eqNoteExplanation))))))()($a801f2c896bd09f1$var$idIsSymbol5)($a801f2c896bd09f1$var$eqSliceId));
var $a801f2c896bd09f1$var$segmentsIsSymbol = {
    reflectSymbol: function() {
        return "segments";
    }
};
var $a801f2c896bd09f1$var$is2ndIsSymbol = {
    reflectSymbol: function() {
        return "is2nd";
    }
};
var $a801f2c896bd09f1$var$eqStartStop3 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqStartStop($a801f2c896bd09f1$var$eqRec23);
var $a801f2c896bd09f1$var$eqRec42 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$rightIsSymbol4)($a801f2c896bd09f1$var$eqStartStop3))()($a801f2c896bd09f1$var$leftIsSymbol3)($a801f2c896bd09f1$var$eqStartStop3));
var $a801f2c896bd09f1$var$opIsSymbol = {
    reflectSymbol: function() {
        return "op";
    }
};
var $a801f2c896bd09f1$var$eqRec52 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$transIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$is2ndIsSymbol)($a801f2c896bd09f1$var$eqBoolean))()($a801f2c896bd09f1$var$idIsSymbol5)($a801f2c896bd09f1$var$eqTransId))()($a801f2c896bd09f1$var$edgesIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$regularIsSymbol4)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqSet($a801f2c896bd09f1$var$eqRec42)))()($a801f2c896bd09f1$var$passingIsSymbol3)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqArray($a801f2c896bd09f1$var$eqRec42)))))))()($a801f2c896bd09f1$var$rsliceIsSymbol)($a801f2c896bd09f1$var$eqRec32))()($a801f2c896bd09f1$var$opIsSymbol)($a801f2c896bd09f1$var$eqOp));
var $a801f2c896bd09f1$var$nextTransIdIsSymbol = {
    reflectSymbol: function() {
        return "nextTransId";
    }
};
var $a801f2c896bd09f1$var$nextSliceIdIsSymbol = {
    reflectSymbol: function() {
        return "nextSliceId";
    }
};
var $a801f2c896bd09f1$var$pieceIsSymbol = {
    reflectSymbol: function() {
        return "piece";
    }
};
var $a801f2c896bd09f1$var$timeIsSymbol2 = {
    reflectSymbol: function() {
        return "time";
    }
};
var $a801f2c896bd09f1$var$holdIsSymbol2 = {
    reflectSymbol: function() {
        return "hold";
    }
};
var $a801f2c896bd09f1$var$eqArray2 = /* @__PURE__ */ $a801f2c896bd09f1$var$eqArray(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$timeIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqEither($a801f2c896bd09f1$var$eqString)($a801f2c896bd09f1$var$eqMBS)))()($a801f2c896bd09f1$var$notesIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqArray(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons1($a801f2c896bd09f1$var$holdIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqString)))))));
var $a801f2c896bd09f1$var$eq25 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$stylesIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$transitionsIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMap($a801f2c896bd09f1$var$eqTransId)($a801f2c896bd09f1$var$eqRec12)))()($a801f2c896bd09f1$var$staffIsSymbol)($a801f2c896bd09f1$var$eqStaff))()($a801f2c896bd09f1$var$slicesIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMap($a801f2c896bd09f1$var$eqSliceId)($a801f2c896bd09f1$var$eqRec12)))()($a801f2c896bd09f1$var$notesIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMap($a801f2c896bd09f1$var$eqString)($a801f2c896bd09f1$var$eqRec12)))()($a801f2c896bd09f1$var$edgesIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMap(/* @__PURE__ */ $a801f2c896bd09f1$var$eqTuple($a801f2c896bd09f1$var$eqString)($a801f2c896bd09f1$var$eqString))($a801f2c896bd09f1$var$eqRec12)))()($a801f2c896bd09f1$var$cssIsSymbol)($a801f2c896bd09f1$var$eqString))))()($a801f2c896bd09f1$var$reductionIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec5(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons4($a801f2c896bd09f1$var$startIsSymbol)($a801f2c896bd09f1$var$eqRec32))()($a801f2c896bd09f1$var$segmentsIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqList($a801f2c896bd09f1$var$eqRec52)))()($a801f2c896bd09f1$var$nextTransIdIsSymbol)($a801f2c896bd09f1$var$eqTransId))()($a801f2c896bd09f1$var$nextSliceIdIsSymbol)($a801f2c896bd09f1$var$eqSliceId))))()($a801f2c896bd09f1$var$pieceIsSymbol)($a801f2c896bd09f1$var$eqArray2)));
var $a801f2c896bd09f1$var$notEq4 = /* @__PURE__ */ $a801f2c896bd09f1$var$notEq($a801f2c896bd09f1$var$eqArray2);
var $a801f2c896bd09f1$var$showRecord9 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord()();
var $a801f2c896bd09f1$var$showRecordFieldsCons11 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$notesIsSymbol2);
var $a801f2c896bd09f1$var$showRecordFieldsCons14 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$idIsSymbol5);
var $a801f2c896bd09f1$var$showRecord14 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons14(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$pitchIsSymbol5)(/* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval)))($a801f2c896bd09f1$var$showString));
var $a801f2c896bd09f1$var$showRecordFieldsConsNil5 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$noteIsSymbol2)($a801f2c896bd09f1$var$showRecord14);
var $a801f2c896bd09f1$var$showArray3 = /* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons11(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$timeIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$showEither($a801f2c896bd09f1$var$showString)($a801f2c896bd09f1$var$showMBS)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$holdIsSymbol2)($a801f2c896bd09f1$var$showRecordFieldsConsNil5)(/* @__PURE__ */ $a801f2c896bd09f1$var$showMaybe($a801f2c896bd09f1$var$showString)))))));
var $a801f2c896bd09f1$var$show30 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showArray3);
var $a801f2c896bd09f1$var$find3 = /* @__PURE__ */ $a801f2c896bd09f1$var$find($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$notEq1 = /* @__PURE__ */ $a801f2c896bd09f1$var$notEq($a801f2c896bd09f1$var$eqRec52);
var $a801f2c896bd09f1$var$showRecordFieldsCons25 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$edgesIsSymbol);
var $a801f2c896bd09f1$var$showRecord25 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$classesIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$labelIsSymbol)($a801f2c896bd09f1$var$showString))($a801f2c896bd09f1$var$showString));
var $a801f2c896bd09f1$var$showRecord34 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons14(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons11(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$parentsIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$xIsSymbol)($a801f2c896bd09f1$var$showNumber))(/* @__PURE__ */ $a801f2c896bd09f1$var$showParents($a801f2c896bd09f1$var$showSliceId)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$explIsSymbol2)($a801f2c896bd09f1$var$showRecordFieldsConsNil5)($a801f2c896bd09f1$var$showNoteExplanation))))))($a801f2c896bd09f1$var$showSliceId));
var $a801f2c896bd09f1$var$showStartStop4 = /* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop($a801f2c896bd09f1$var$showRecord14);
var $a801f2c896bd09f1$var$showRecord43 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$leftIsSymbol3)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$rightIsSymbol4)($a801f2c896bd09f1$var$showStartStop4))($a801f2c896bd09f1$var$showStartStop4));
var $a801f2c896bd09f1$var$showRecord52 = /* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$opIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$rsliceIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$transIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons25(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons14(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$is2ndIsSymbol)($a801f2c896bd09f1$var$showBoolean))($a801f2c896bd09f1$var$showTransId))(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$passingIsSymbol3)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$regularIsSymbol4)(/* @__PURE__ */ $a801f2c896bd09f1$var$showSet($a801f2c896bd09f1$var$showRecord43)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showArray($a801f2c896bd09f1$var$showRecord43)))))))($a801f2c896bd09f1$var$showRecord34))($a801f2c896bd09f1$var$showOp));
var $a801f2c896bd09f1$var$show113 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$pieceIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$reductionIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$stylesIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$cssIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons25(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons11(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$slicesIsSymbol2)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$staffIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$transitionsIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap($a801f2c896bd09f1$var$showTransId)($a801f2c896bd09f1$var$showRecord25)))($a801f2c896bd09f1$var$showStaff))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap($a801f2c896bd09f1$var$showSliceId)($a801f2c896bd09f1$var$showRecord25)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap($a801f2c896bd09f1$var$showString)($a801f2c896bd09f1$var$showRecord25)))(/* @__PURE__ */ $a801f2c896bd09f1$var$showMap(/* @__PURE__ */ $a801f2c896bd09f1$var$showTuple($a801f2c896bd09f1$var$showString)($a801f2c896bd09f1$var$showString))($a801f2c896bd09f1$var$showRecord25)))($a801f2c896bd09f1$var$showString))))(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord9(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$nextSliceIdIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$nextTransIdIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons($a801f2c896bd09f1$var$segmentsIsSymbol)(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil($a801f2c896bd09f1$var$startIsSymbol)($a801f2c896bd09f1$var$showRecord34))(/* @__PURE__ */ $a801f2c896bd09f1$var$showList($a801f2c896bd09f1$var$showRecord52)))($a801f2c896bd09f1$var$showTransId))($a801f2c896bd09f1$var$showSliceId))))($a801f2c896bd09f1$var$showArray3)));
var $a801f2c896bd09f1$var$show210 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showRecord52);
var $a801f2c896bd09f1$var$bind27 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$pure31 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeHalogenM);
var $a801f2c896bd09f1$var$modify_5 = /* @__PURE__ */ $a801f2c896bd09f1$var$modify_2($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$CopyToClipboard = /* @__PURE__ */ function() {
    function CopyToClipboard2(value0) {
        this.value0 = value0;
    }
    CopyToClipboard2.create = function(value0) {
        return new CopyToClipboard2(value0);
    };
    return CopyToClipboard2;
}();
var $a801f2c896bd09f1$var$DownloadJSON = /* @__PURE__ */ function() {
    function DownloadJSON2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DownloadJSON2.create = function(value0) {
        return function(value1) {
            return new DownloadJSON2(value0, value1);
        };
    };
    return DownloadJSON2;
}();
var $a801f2c896bd09f1$var$TogglePretty = /* @__PURE__ */ function() {
    function TogglePretty2() {}
    TogglePretty2.value = new TogglePretty2();
    return TogglePretty2;
}();
var $a801f2c896bd09f1$var$ToggleTikzStandalone = /* @__PURE__ */ function() {
    function ToggleTikzStandalone2() {}
    ToggleTikzStandalone2.value = new ToggleTikzStandalone2();
    return ToggleTikzStandalone2;
}();
var $a801f2c896bd09f1$var$ExportReceive = /* @__PURE__ */ function() {
    function ExportReceive2(value0) {
        this.value0 = value0;
    }
    ExportReceive2.create = function(value0) {
        return new ExportReceive2(value0);
    };
    return ExportReceive2;
}();
var $a801f2c896bd09f1$var$exportComponent = function(dictMonadEffect) {
    var liftEffect8 = $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectHalogenM(dictMonadEffect));
    var render = function(v3) {
        if (v3.model instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$text("");
        if (v3.model instanceof $a801f2c896bd09f1$var$Just) {
            var val = $a801f2c896bd09f1$var$validateReduction(v3.model.value0.reduction);
            var tikzStrOrErr = new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$tikzReduction(v3.tikzStandalone)($a801f2c896bd09f1$var$evalGraph(true)(true)(v3.model.value0.reduction)));
            var json = $a801f2c896bd09f1$var$modelToJSON(v3.model.value0);
            var jsonStrOrErr = $a801f2c896bd09f1$var$map45(function() {
                if (v3.pretty) return $a801f2c896bd09f1$var$writeJSONPretty2;
                return $a801f2c896bd09f1$var$writeJSON3;
            }())(json);
            var reLoad = $a801f2c896bd09f1$var$bindFlipped7($a801f2c896bd09f1$var$modelFromJSON)(json);
            return $a801f2c896bd09f1$var$div5([
                $a801f2c896bd09f1$var$class_2("content-np tab pure-form")
            ])([
                function() {
                    var $836 = $a801f2c896bd09f1$var$validationIsOk(val);
                    if ($836) return $a801f2c896bd09f1$var$text("");
                    return $a801f2c896bd09f1$var$p2([
                        $a801f2c896bd09f1$var$class_2("alert")
                    ])([
                        $a801f2c896bd09f1$var$text("Warning: reduction is incomplete and/or contains errors.")
                    ]);
                }(),
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("JSON String")
                ]),
                function() {
                    if (jsonStrOrErr instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$div_([
                        $a801f2c896bd09f1$var$div5([
                            $a801f2c896bd09f1$var$class_2("pure-g")
                        ])([
                            $a801f2c896bd09f1$var$label([
                                $a801f2c896bd09f1$var$class_2("pure-u-3-5")
                            ])([
                                $a801f2c896bd09f1$var$input([
                                    $a801f2c896bd09f1$var$type_4($a801f2c896bd09f1$var$InputCheckbox.value),
                                    $a801f2c896bd09f1$var$checked(v3.pretty),
                                    $a801f2c896bd09f1$var$onChange(function(v1) {
                                        return $a801f2c896bd09f1$var$TogglePretty.value;
                                    }),
                                    $a801f2c896bd09f1$var$id2("prettyJSON")
                                ]),
                                $a801f2c896bd09f1$var$text(" pretty")
                            ]),
                            $a801f2c896bd09f1$var$button([
                                $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-5"),
                                $a801f2c896bd09f1$var$onClick(function(v1) {
                                    return new $a801f2c896bd09f1$var$CopyToClipboard(jsonStrOrErr.value0);
                                })
                            ])([
                                $a801f2c896bd09f1$var$text("Copy to Clipboard")
                            ]),
                            $a801f2c896bd09f1$var$button([
                                $a801f2c896bd09f1$var$class_2("pure-button pure-button-primary pure-u-1-5"),
                                $a801f2c896bd09f1$var$onClick(function(v1) {
                                    return new $a801f2c896bd09f1$var$DownloadJSON(v3.name + ".analysis.json", jsonStrOrErr.value0);
                                })
                            ])([
                                $a801f2c896bd09f1$var$text("Download")
                            ])
                        ]),
                        $a801f2c896bd09f1$var$pre_([
                            $a801f2c896bd09f1$var$text(jsonStrOrErr.value0)
                        ])
                    ]);
                    if (jsonStrOrErr instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$p2([
                        $a801f2c896bd09f1$var$class_2("alert")
                    ])([
                        $a801f2c896bd09f1$var$text("Cannot serialize reduction to JSON:" + jsonStrOrErr.value0)
                    ]);
                    throw new Error("Failed pattern match at App.Tabs.Export (line 69, column 13 - line 95, column 109): " + [
                        jsonStrOrErr.constructor.name
                    ]);
                }(),
                $a801f2c896bd09f1$var$div_(function() {
                    if (reLoad instanceof $a801f2c896bd09f1$var$Left) return [
                        $a801f2c896bd09f1$var$text("Error re-reading reduction: " + reLoad.value0)
                    ];
                    if (reLoad instanceof $a801f2c896bd09f1$var$Right) {
                        var $842 = $a801f2c896bd09f1$var$eq25(reLoad.value0)(v3.model.value0);
                        if ($842) return [
                            $a801f2c896bd09f1$var$text("roundtrip ok")
                        ];
                        var $843 = $a801f2c896bd09f1$var$notEq4(reLoad.value0.piece)(v3.model.value0.piece);
                        if ($843) return [
                            $a801f2c896bd09f1$var$text("pieces are different! original"),
                            $a801f2c896bd09f1$var$pre_([
                                $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show30(v3.model.value0.piece))
                            ]),
                            $a801f2c896bd09f1$var$text("re-read:"),
                            $a801f2c896bd09f1$var$pre_([
                                $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show30(reLoad.value0.piece))
                            ])
                        ];
                        var v1 = $a801f2c896bd09f1$var$find3(function(v22) {
                            return $a801f2c896bd09f1$var$notEq1(v22.value0)(v22.value1);
                        })($a801f2c896bd09f1$var$zip(v3.model.value0.reduction.segments)(reLoad.value0.reduction.segments));
                        if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return [
                            $a801f2c896bd09f1$var$text("roundtrip not ok (but can't find wrong segment)! original:"),
                            $a801f2c896bd09f1$var$pre_([
                                $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show113(v3.model.value0))
                            ]),
                            $a801f2c896bd09f1$var$text("re-read:"),
                            $a801f2c896bd09f1$var$pre_([
                                $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show113(reLoad.value0))
                            ])
                        ];
                        if (v1 instanceof $a801f2c896bd09f1$var$Just) return [
                            $a801f2c896bd09f1$var$text("roundtrip not ok! offending segment original: "),
                            $a801f2c896bd09f1$var$pre_([
                                $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show210(v1.value0.value0))
                            ]),
                            $a801f2c896bd09f1$var$text(" re-read:"),
                            $a801f2c896bd09f1$var$pre_([
                                $a801f2c896bd09f1$var$text($a801f2c896bd09f1$var$show210(v1.value0.value1))
                            ])
                        ];
                        throw new Error("Failed pattern match at App.Tabs.Export (line 107, column 22 - line 119, column 22): " + [
                            v1.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at App.Tabs.Export (line 96, column 21 - line 119, column 22): " + [
                        reLoad.constructor.name
                    ]);
                }()),
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("TikZ Code")
                ]),
                function() {
                    if (tikzStrOrErr instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$div_([
                        $a801f2c896bd09f1$var$div5([
                            $a801f2c896bd09f1$var$class_2("pure-g")
                        ])([
                            $a801f2c896bd09f1$var$label([
                                $a801f2c896bd09f1$var$class_2("pure-u-3-5")
                            ])([
                                $a801f2c896bd09f1$var$input([
                                    $a801f2c896bd09f1$var$type_4($a801f2c896bd09f1$var$InputCheckbox.value),
                                    $a801f2c896bd09f1$var$checked(v3.tikzStandalone),
                                    $a801f2c896bd09f1$var$onChange(function(v1) {
                                        return $a801f2c896bd09f1$var$ToggleTikzStandalone.value;
                                    }),
                                    $a801f2c896bd09f1$var$id2("tikzStandalone")
                                ]),
                                $a801f2c896bd09f1$var$text(" standalone document")
                            ]),
                            $a801f2c896bd09f1$var$button([
                                $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-5"),
                                $a801f2c896bd09f1$var$onClick(function(v1) {
                                    return new $a801f2c896bd09f1$var$CopyToClipboard(tikzStrOrErr.value0);
                                })
                            ])([
                                $a801f2c896bd09f1$var$text("Copy to Clipboard")
                            ]),
                            $a801f2c896bd09f1$var$button([
                                $a801f2c896bd09f1$var$class_2("pure-button pure-button-primary pure-u-1-5"),
                                $a801f2c896bd09f1$var$onClick(function(v1) {
                                    return new $a801f2c896bd09f1$var$DownloadJSON(v3.name + ".tex", tikzStrOrErr.value0);
                                })
                            ])([
                                $a801f2c896bd09f1$var$text("Download")
                            ])
                        ]),
                        $a801f2c896bd09f1$var$pre_([
                            $a801f2c896bd09f1$var$text(tikzStrOrErr.value0)
                        ])
                    ]);
                    if (tikzStrOrErr instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$p2([
                        $a801f2c896bd09f1$var$class_2("alert")
                    ])([
                        $a801f2c896bd09f1$var$text("Cannot create TikZ code:" + tikzStrOrErr.value0)
                    ]);
                    throw new Error("Failed pattern match at App.Tabs.Export (line 121, column 13 - line 147, column 98): " + [
                        tikzStrOrErr.constructor.name
                    ]);
                }(),
                $a801f2c896bd09f1$var$h4_([
                    $a801f2c896bd09f1$var$text("Operation Decorator for Current Note")
                ]),
                function() {
                    var v1 = $a801f2c896bd09f1$var$tikzOpDecor(v3.selection);
                    if (v1 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$div_([
                        $a801f2c896bd09f1$var$pre([
                            $a801f2c896bd09f1$var$class_2("pure-u-4-5")
                        ])([
                            $a801f2c896bd09f1$var$text(v1.value0)
                        ]),
                        $a801f2c896bd09f1$var$button([
                            $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-5"),
                            $a801f2c896bd09f1$var$onClick(function(v22) {
                                return new $a801f2c896bd09f1$var$CopyToClipboard(v1.value0);
                            })
                        ])([
                            $a801f2c896bd09f1$var$text("Copy to Clipboard")
                        ])
                    ]);
                    if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$text("");
                    throw new Error("Failed pattern match at App.Tabs.Export (line 149, column 13 - line 159, column 36): " + [
                        v1.constructor.name
                    ]);
                }()
            ]);
        }
        throw new Error("Failed pattern match at App.Tabs.Export (line 49, column 75 - line 160, column 12): " + [
            v3.model.constructor.name
        ]);
    };
    var initialState = function(v3) {
        return {
            model: v3.model,
            name: v3.name,
            selection: v3.selection,
            pretty: false,
            tikzStandalone: false
        };
    };
    var handleExportAction = function(v3) {
        if (v3 instanceof $a801f2c896bd09f1$var$CopyToClipboard) return liftEffect8($a801f2c896bd09f1$var$copyToClipboard(v3.value0));
        if (v3 instanceof $a801f2c896bd09f1$var$DownloadJSON) return $a801f2c896bd09f1$var$bind27(liftEffect8($a801f2c896bd09f1$var$download(v3.value1)(v3.value0)("application/json")))(function() {
            return $a801f2c896bd09f1$var$pure31($a801f2c896bd09f1$var$unit);
        });
        if (v3 instanceof $a801f2c896bd09f1$var$TogglePretty) return $a801f2c896bd09f1$var$modify_5(function(st) {
            var $871 = {};
            for(var $872 in st)if (({}).hasOwnProperty.call(st, $872)) $871[$872] = st[$872];
            $871.pretty = !st.pretty;
            return $871;
        });
        if (v3 instanceof $a801f2c896bd09f1$var$ToggleTikzStandalone) return $a801f2c896bd09f1$var$modify_5(function(st) {
            var $874 = {};
            for(var $875 in st)if (({}).hasOwnProperty.call(st, $875)) $874[$875] = st[$875];
            $874.tikzStandalone = !st.tikzStandalone;
            return $874;
        });
        if (v3 instanceof $a801f2c896bd09f1$var$ExportReceive) return $a801f2c896bd09f1$var$modify_5(function(st) {
            var $877 = {};
            for(var $878 in st)if (({}).hasOwnProperty.call(st, $878)) $877[$878] = st[$878];
            $877.model = v3.value0.model;
            $877.name = v3.value0.name;
            $877.selection = v3.value0.selection;
            return $877;
        });
        throw new Error("Failed pattern match at App.Tabs.Export (line 162, column 24 - line 175, column 12): " + [
            v3.constructor.name
        ]);
    };
    return $a801f2c896bd09f1$var$mkComponent({
        initialState: initialState,
        render: render,
        "eval": $a801f2c896bd09f1$var$mkEval({
            handleQuery: $a801f2c896bd09f1$var$defaultEval.handleQuery,
            initialize: $a801f2c896bd09f1$var$defaultEval.initialize,
            finalize: $a801f2c896bd09f1$var$defaultEval.finalize,
            handleAction: handleExportAction,
            receive: function($884) {
                return $a801f2c896bd09f1$var$Just.create($a801f2c896bd09f1$var$ExportReceive.create($884));
            }
        })
    });
};
// output/Web.File.File/foreign.js
function $a801f2c896bd09f1$var$name4(file) {
    return file.name;
}
// output/Web.File.File/index.js
var $a801f2c896bd09f1$var$toBlob = $a801f2c896bd09f1$var$unsafeCoerce2;
// output/Web.File.FileReader/foreign.js
function $a801f2c896bd09f1$var$fileReader() {
    return new FileReader();
}
function $a801f2c896bd09f1$var$result(fr) {
    return function() {
        return fr.result;
    };
}
function $a801f2c896bd09f1$var$readAsText(blob) {
    return function(fr) {
        return function() {
            fr.readAsText(blob);
        };
    };
}
// output/Web.File.FileReader/index.js
var $a801f2c896bd09f1$var$toEventTarget = $a801f2c896bd09f1$var$unsafeCoerce2;
// output/Web.File.FileReader.Aff/index.js
var $a801f2c896bd09f1$var$show31 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showNonEmptyList($a801f2c896bd09f1$var$showForeignError));
var $a801f2c896bd09f1$var$mempty4 = /* @__PURE__ */ $a801f2c896bd09f1$var$mempty($a801f2c896bd09f1$var$monoidCanceler);
var $a801f2c896bd09f1$var$readString5 = /* @__PURE__ */ $a801f2c896bd09f1$var$readString($a801f2c896bd09f1$var$monadIdentity);
var $a801f2c896bd09f1$var$readAs = function(readMethod) {
    return function(getResult) {
        return function(blob) {
            return $a801f2c896bd09f1$var$makeAff(function(fun) {
                var succ2 = function($12) {
                    return fun($a801f2c896bd09f1$var$Right.create($12));
                };
                var err = function($13) {
                    return fun($a801f2c896bd09f1$var$Left.create($13));
                };
                return function __do2() {
                    var fr = $a801f2c896bd09f1$var$fileReader();
                    var et2 = $a801f2c896bd09f1$var$toEventTarget(fr);
                    var errorListener = $a801f2c896bd09f1$var$eventListener(function(v3) {
                        return err($a801f2c896bd09f1$var$error("error"));
                    })();
                    var loadListener = $a801f2c896bd09f1$var$eventListener(function(v3) {
                        return function __do3() {
                            var res = $a801f2c896bd09f1$var$result(fr)();
                            return $a801f2c896bd09f1$var$either(function(errs) {
                                return err($a801f2c896bd09f1$var$error($a801f2c896bd09f1$var$show31(errs)));
                            })(succ2)($a801f2c896bd09f1$var$runExcept(readMethod(res)))();
                        };
                    })();
                    $a801f2c896bd09f1$var$addEventListener2($a801f2c896bd09f1$var$error3)(errorListener)(false)(et2)();
                    $a801f2c896bd09f1$var$addEventListener2($a801f2c896bd09f1$var$load)(loadListener)(false)(et2)();
                    getResult(blob)(fr)();
                    return $a801f2c896bd09f1$var$mempty4;
                };
            });
        };
    };
};
var $a801f2c896bd09f1$var$readAsText2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readAs($a801f2c896bd09f1$var$readString5)($a801f2c896bd09f1$var$readAsText);
// output/Web.HTML/foreign.js
var $a801f2c896bd09f1$var$windowImpl = function() {
    return window;
};
// output/Web.HTML.HTMLDocument/foreign.js
function $a801f2c896bd09f1$var$_readyState(doc) {
    return doc.readyState;
}
// output/Web.HTML.HTMLDocument.ReadyState/index.js
var $a801f2c896bd09f1$var$Loading = /* @__PURE__ */ function() {
    function Loading2() {}
    Loading2.value = new Loading2();
    return Loading2;
}();
var $a801f2c896bd09f1$var$Interactive = /* @__PURE__ */ function() {
    function Interactive2() {}
    Interactive2.value = new Interactive2();
    return Interactive2;
}();
var $a801f2c896bd09f1$var$Complete = /* @__PURE__ */ function() {
    function Complete2() {}
    Complete2.value = new Complete2();
    return Complete2;
}();
var $a801f2c896bd09f1$var$parse = function(v3) {
    if (v3 === "loading") return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$Loading.value);
    if (v3 === "interactive") return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$Interactive.value);
    if (v3 === "complete") return new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$Complete.value);
    return $a801f2c896bd09f1$var$Nothing.value;
};
// output/Web.HTML.HTMLDocument/index.js
var $a801f2c896bd09f1$var$map46 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$toParentNode = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$toEventTarget2 = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$toDocument = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$readyState = function(doc) {
    return $a801f2c896bd09f1$var$map46(function() {
        var $4 = $a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$Loading.value);
        return function($5) {
            return $4($a801f2c896bd09f1$var$parse($5));
        };
    }())(function() {
        return $a801f2c896bd09f1$var$_readyState(doc);
    });
};
// output/Web.HTML.HTMLElement/foreign.js
function $a801f2c896bd09f1$var$_read(nothing, just, value17) {
    var tag = Object.prototype.toString.call(value17);
    if (tag.indexOf("[object HTML") === 0 && tag.indexOf("Element]") === tag.length - 8) return just(value17);
    else return nothing;
}
// output/Web.HTML.HTMLElement/index.js
var $a801f2c896bd09f1$var$toNode2 = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$fromElement = function(x4) {
    return $a801f2c896bd09f1$var$_read($a801f2c896bd09f1$var$Nothing.value, $a801f2c896bd09f1$var$Just.create, x4);
};
// output/Web.HTML.Window/foreign.js
function $a801f2c896bd09f1$var$document2(window2) {
    return function() {
        return window2.document;
    };
}
function $a801f2c896bd09f1$var$alert(str) {
    return function(window2) {
        return function() {
            window2.alert(str);
        };
    };
}
function $a801f2c896bd09f1$var$localStorage(window2) {
    return function() {
        return window2.localStorage;
    };
}
// output/Web.HTML.Window/index.js
var $a801f2c896bd09f1$var$toEventTarget3 = $a801f2c896bd09f1$var$unsafeCoerce2;
// output/Web.Storage.Storage/foreign.js
function $a801f2c896bd09f1$var$_getItem(key2) {
    return function(storage) {
        return function() {
            return storage.getItem(key2);
        };
    };
}
function $a801f2c896bd09f1$var$setItem(key2) {
    return function(value17) {
        return function(storage) {
            return function() {
                storage.setItem(key2, value17);
            };
        };
    };
}
// output/Web.Storage.Storage/index.js
var $a801f2c896bd09f1$var$map47 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$getItem = function(s2) {
    var $5 = $a801f2c896bd09f1$var$map47($a801f2c896bd09f1$var$toMaybe);
    var $6 = $a801f2c896bd09f1$var$_getItem(s2);
    return function($7) {
        return $5($6($7));
    };
};
// output/App.Tabs.Import/index.js
var $a801f2c896bd09f1$var$$runtime_lazy10 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$readRecord3 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord();
var $a801f2c896bd09f1$var$readFieldsCons2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "notes";
    }
});
var $a801f2c896bd09f1$var$readMaybe2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readMaybe($a801f2c896bd09f1$var$readString2);
var $a801f2c896bd09f1$var$readFieldsCons1 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "hold";
    }
})($a801f2c896bd09f1$var$readMaybe2);
var $a801f2c896bd09f1$var$readFieldsCons22 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "id";
    }
});
var $a801f2c896bd09f1$var$readFieldsCons3 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons22($a801f2c896bd09f1$var$readString2);
var $a801f2c896bd09f1$var$readFieldsCons4 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "pitch";
    }
});
var $a801f2c896bd09f1$var$readFieldsCons5 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons4($a801f2c896bd09f1$var$readString2)($a801f2c896bd09f1$var$readFieldsNil)()();
var $a801f2c896bd09f1$var$readFieldsCons6 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "time";
    }
})($a801f2c896bd09f1$var$readString2)($a801f2c896bd09f1$var$readFieldsNil)()();
var $a801f2c896bd09f1$var$readJSON2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readJSON(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons2(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons1(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons3($a801f2c896bd09f1$var$readFieldsCons5)()())()())))($a801f2c896bd09f1$var$readFieldsCons6)()())));
var $a801f2c896bd09f1$var$readJSON1 = /* @__PURE__ */ $a801f2c896bd09f1$var$readJSON(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons2(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons1($a801f2c896bd09f1$var$readFieldsCons5)()())))($a801f2c896bd09f1$var$readFieldsCons6)()())));
var $a801f2c896bd09f1$var$showJSONErrors2 = /* @__PURE__ */ $a801f2c896bd09f1$var$showJSONErrors($a801f2c896bd09f1$var$foldableNonEmptyList)($a801f2c896bd09f1$var$functorNonEmptyList);
var $a801f2c896bd09f1$var$eq26 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqNonEmptyList($a801f2c896bd09f1$var$eqForeignError));
var $a801f2c896bd09f1$var$append15 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupNonEmptyList);
var $a801f2c896bd09f1$var$readForeignVariant2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readForeignVariant();
var $a801f2c896bd09f1$var$readFieldsCons7 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "left";
    }
});
var $a801f2c896bd09f1$var$readRecord1 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons4(/* @__PURE__ */ $a801f2c896bd09f1$var$readForeignPitch($a801f2c896bd09f1$var$readForeignPitchSInterval))($a801f2c896bd09f1$var$readFieldsNil)()())()());
var $a801f2c896bd09f1$var$readForeignStartStop2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readForeignStartStop($a801f2c896bd09f1$var$readRecord1);
var $a801f2c896bd09f1$var$readFieldsCons8 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "right";
    }
});
var $a801f2c896bd09f1$var$readRecord22 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons7($a801f2c896bd09f1$var$readForeignStartStop2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons8($a801f2c896bd09f1$var$readForeignStartStop2)($a801f2c896bd09f1$var$readFieldsNil)()())()());
var $a801f2c896bd09f1$var$readArray3 = /* @__PURE__ */ $a801f2c896bd09f1$var$readArray2($a801f2c896bd09f1$var$readRecord22);
var $a801f2c896bd09f1$var$readRecord32 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "prevTime";
    }
})($a801f2c896bd09f1$var$readMaybe2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "ties";
    }
})($a801f2c896bd09f1$var$readArray3)($a801f2c896bd09f1$var$readFieldsNil)()())()());
var $a801f2c896bd09f1$var$readFieldsCons9 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "children";
    }
});
var $a801f2c896bd09f1$var$readFieldsCons10 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "child";
    }
});
var $a801f2c896bd09f1$var$readArray12 = /* @__PURE__ */ $a801f2c896bd09f1$var$readArray2($a801f2c896bd09f1$var$readRecord1);
var $a801f2c896bd09f1$var$readRecord4 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons7($a801f2c896bd09f1$var$readArray12)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons8($a801f2c896bd09f1$var$readArray12)($a801f2c896bd09f1$var$readFieldsNil)()())()());
var $a801f2c896bd09f1$var$readFieldsCons11 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "parent";
    }
});
var $a801f2c896bd09f1$var$readFieldsCons12 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons11($a801f2c896bd09f1$var$readRecord1)($a801f2c896bd09f1$var$readFieldsNil)()();
var $a801f2c896bd09f1$var$readFieldsCons13 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "ids";
    }
});
var $a801f2c896bd09f1$var$readFieldsCons14 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons7($a801f2c896bd09f1$var$readForeignTransId);
var $a801f2c896bd09f1$var$readFieldsCons15 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons8($a801f2c896bd09f1$var$readForeignTransId);
var $a801f2c896bd09f1$var$readFieldsCons16 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "rslice";
    }
});
var $a801f2c896bd09f1$var$readFieldsCons17 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "passing";
    }
});
var $a801f2c896bd09f1$var$readFieldsCons18 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "regular";
    }
});
var $a801f2c896bd09f1$var$readRecord5 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons17($a801f2c896bd09f1$var$readArray3)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons18($a801f2c896bd09f1$var$readArray3)($a801f2c896bd09f1$var$readFieldsNil)()())()());
var $a801f2c896bd09f1$var$readFieldsCons19 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "unexplained";
    }
});
var $a801f2c896bd09f1$var$readFieldsCons20 = /* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons9(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons10($a801f2c896bd09f1$var$readRecord1)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "orn";
    }
})($a801f2c896bd09f1$var$readMaybe2)($a801f2c896bd09f1$var$readFieldsNil)()())()())));
var $a801f2c896bd09f1$var$readArray22 = /* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons20($a801f2c896bd09f1$var$readFieldsCons12)()()));
var $a801f2c896bd09f1$var$readArray32 = /* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons20(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons11($a801f2c896bd09f1$var$readRecord22)($a801f2c896bd09f1$var$readFieldsNil)()())()()));
var $a801f2c896bd09f1$var$readRecord6 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "fromLeft";
    }
})($a801f2c896bd09f1$var$readArray22)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "fromRight";
    }
})($a801f2c896bd09f1$var$readArray22)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons13(/* @__PURE__ */ $a801f2c896bd09f1$var$readMaybe(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons14(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons15(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "slice";
    }
})($a801f2c896bd09f1$var$readForeignSliceId)($a801f2c896bd09f1$var$readFieldsNil)()())()())()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "keepLeft";
    }
})($a801f2c896bd09f1$var$readArray3)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "keepRight";
    }
})($a801f2c896bd09f1$var$readArray3)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "passLeft";
    }
})($a801f2c896bd09f1$var$readArray3)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "passRight";
    }
})($a801f2c896bd09f1$var$readArray3)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons17($a801f2c896bd09f1$var$readArray32)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons18($a801f2c896bd09f1$var$readArray32)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons19(/* @__PURE__ */ $a801f2c896bd09f1$var$readMaybe($a801f2c896bd09f1$var$readArray12))($a801f2c896bd09f1$var$readFieldsNil)()())()())()())()())()())()())()())()())()())()());
var $a801f2c896bd09f1$var$readRecord7 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons22(/* @__PURE__ */ $a801f2c896bd09f1$var$readMaybe($a801f2c896bd09f1$var$readForeignSliceId))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons2(/* @__PURE__ */ $a801f2c896bd09f1$var$readForeignStartStop($a801f2c896bd09f1$var$readArray12))($a801f2c896bd09f1$var$readFieldsNil)()())()());
var $a801f2c896bd09f1$var$readRecord8 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "classes";
    }
})($a801f2c896bd09f1$var$readString2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "label";
    }
})($a801f2c896bd09f1$var$readString2)($a801f2c896bd09f1$var$readFieldsNil)()())()());
var $a801f2c896bd09f1$var$readObject2 = /* @__PURE__ */ $a801f2c896bd09f1$var$readObject($a801f2c896bd09f1$var$readRecord8);
var $a801f2c896bd09f1$var$readRecord9 = /* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "derivation";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readForeignVariant2(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "freezeLeft";
    }
})($a801f2c896bd09f1$var$readRecord32)()(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "freezeOnly";
    }
})($a801f2c896bd09f1$var$readRecord32)()(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "hori";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons9(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons10(/* @__PURE__ */ $a801f2c896bd09f1$var$readForeignVariant2(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "bothChildren";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons7($a801f2c896bd09f1$var$readRecord1)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons8($a801f2c896bd09f1$var$readRecord1)($a801f2c896bd09f1$var$readFieldsNil)()())()()))()(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "leftChild";
    }
})($a801f2c896bd09f1$var$readRecord1)()(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "rightChild";
    }
})($a801f2c896bd09f1$var$readRecord1)()(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "tooManyChildren";
    }
})($a801f2c896bd09f1$var$readRecord4)()($a801f2c896bd09f1$var$readVariantNil))))))($a801f2c896bd09f1$var$readFieldsCons12)()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons13(/* @__PURE__ */ $a801f2c896bd09f1$var$readMaybe(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons14(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "lslice";
    }
})($a801f2c896bd09f1$var$readForeignSliceId)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "mid";
    }
})($a801f2c896bd09f1$var$readForeignTransId)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons15(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons16($a801f2c896bd09f1$var$readForeignSliceId)($a801f2c896bd09f1$var$readFieldsNil)()())()())()())()())()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "midEdges";
    }
})($a801f2c896bd09f1$var$readRecord5)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons19(/* @__PURE__ */ $a801f2c896bd09f1$var$readMaybe($a801f2c896bd09f1$var$readRecord4))($a801f2c896bd09f1$var$readFieldsNil)()())()())()())()()))()(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "splitLeft";
    }
})($a801f2c896bd09f1$var$readRecord6)()(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "splitOnly";
    }
})($a801f2c896bd09f1$var$readRecord6)()(/* @__PURE__ */ $a801f2c896bd09f1$var$readVariantCons({
    reflectSymbol: function() {
        return "splitRight";
    }
})($a801f2c896bd09f1$var$readRecord6)()($a801f2c896bd09f1$var$readVariantNil)))))))))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "start";
    }
})($a801f2c896bd09f1$var$readRecord7)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "styles";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readMaybe(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "css";
    }
})($a801f2c896bd09f1$var$readString2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "edgeStyles";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "edge";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons7($a801f2c896bd09f1$var$readString2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons8($a801f2c896bd09f1$var$readString2)($a801f2c896bd09f1$var$readFieldsNil)()())()()))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "style";
    }
})($a801f2c896bd09f1$var$readRecord8)($a801f2c896bd09f1$var$readFieldsNil)()())()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "noteStyles";
    }
})($a801f2c896bd09f1$var$readObject2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "sliceStyles";
    }
})($a801f2c896bd09f1$var$readObject2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "staffType";
    }
})($a801f2c896bd09f1$var$readString2)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "transStyles";
    }
})($a801f2c896bd09f1$var$readObject2)($a801f2c896bd09f1$var$readFieldsNil)()())()())()())()())()())()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "topSegments";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readArray2(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons16($a801f2c896bd09f1$var$readRecord7)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "trans";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "edges";
    }
})($a801f2c896bd09f1$var$readRecord5)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons22(/* @__PURE__ */ $a801f2c896bd09f1$var$readMaybe($a801f2c896bd09f1$var$readForeignTransId))($a801f2c896bd09f1$var$readFieldsNil)()())()()))($a801f2c896bd09f1$var$readFieldsNil)()())()())))($a801f2c896bd09f1$var$readFieldsNil)()())()())()())()());
var $a801f2c896bd09f1$var$readJSON22 = /* @__PURE__ */ $a801f2c896bd09f1$var$readJSON($a801f2c896bd09f1$var$readRecord9);
var $a801f2c896bd09f1$var$type_21 = /* @__PURE__ */ $a801f2c896bd09f1$var$type_($a801f2c896bd09f1$var$isPropInputType);
var $a801f2c896bd09f1$var$value14 = /* @__PURE__ */ $a801f2c896bd09f1$var$value($a801f2c896bd09f1$var$isPropString);
var $a801f2c896bd09f1$var$onFileUpload2 = /* @__PURE__ */ $a801f2c896bd09f1$var$onFileUpload($a801f2c896bd09f1$var$unfoldableList);
var $a801f2c896bd09f1$var$bind28 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindEither);
var $a801f2c896bd09f1$var$pure34 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEither);
var $a801f2c896bd09f1$var$pure112 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeHalogenM);
var $a801f2c896bd09f1$var$bind110 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$discard7 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit)($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$modify_6 = /* @__PURE__ */ $a801f2c896bd09f1$var$modify_2($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$gets3 = /* @__PURE__ */ $a801f2c896bd09f1$var$gets($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$readJSON3 = /* @__PURE__ */ $a801f2c896bd09f1$var$readJSON(/* @__PURE__ */ $a801f2c896bd09f1$var$readRecord3(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "model";
    }
})($a801f2c896bd09f1$var$readRecord9)(/* @__PURE__ */ $a801f2c896bd09f1$var$readFieldsCons({
    reflectSymbol: function() {
        return "name";
    }
})($a801f2c896bd09f1$var$readString2)($a801f2c896bd09f1$var$readFieldsNil)()())()()));
var $a801f2c896bd09f1$var$ImportUpdateModelInput = /* @__PURE__ */ function() {
    function ImportUpdateModelInput2(value0) {
        this.value0 = value0;
    }
    ImportUpdateModelInput2.create = function(value0) {
        return new ImportUpdateModelInput2(value0);
    };
    return ImportUpdateModelInput2;
}();
var $a801f2c896bd09f1$var$ImportUpdatePieceInput = /* @__PURE__ */ function() {
    function ImportUpdatePieceInput2(value0) {
        this.value0 = value0;
    }
    ImportUpdatePieceInput2.create = function(value0) {
        return new ImportUpdatePieceInput2(value0);
    };
    return ImportUpdatePieceInput2;
}();
var $a801f2c896bd09f1$var$ImportUpdateName = /* @__PURE__ */ function() {
    function ImportUpdateName2(value0) {
        this.value0 = value0;
    }
    ImportUpdateName2.create = function(value0) {
        return new ImportUpdateName2(value0);
    };
    return ImportUpdateName2;
}();
var $a801f2c896bd09f1$var$ImportUpdateMusicXMLInput = /* @__PURE__ */ function() {
    function ImportUpdateMusicXMLInput2(value0) {
        this.value0 = value0;
    }
    ImportUpdateMusicXMLInput2.create = function(value0) {
        return new ImportUpdateMusicXMLInput2(value0);
    };
    return ImportUpdateMusicXMLInput2;
}();
var $a801f2c896bd09f1$var$ImportToggleMusicXMLUnfold = /* @__PURE__ */ function() {
    function ImportToggleMusicXMLUnfold2() {}
    ImportToggleMusicXMLUnfold2.value = new ImportToggleMusicXMLUnfold2();
    return ImportToggleMusicXMLUnfold2;
}();
var $a801f2c896bd09f1$var$ImportUploadModel = /* @__PURE__ */ function() {
    function ImportUploadModel2(value0) {
        this.value0 = value0;
    }
    ImportUploadModel2.create = function(value0) {
        return new ImportUploadModel2(value0);
    };
    return ImportUploadModel2;
}();
var $a801f2c896bd09f1$var$ImportUploadPiece = /* @__PURE__ */ function() {
    function ImportUploadPiece2(value0) {
        this.value0 = value0;
    }
    ImportUploadPiece2.create = function(value0) {
        return new ImportUploadPiece2(value0);
    };
    return ImportUploadPiece2;
}();
var $a801f2c896bd09f1$var$ImportUploadMusicXML = /* @__PURE__ */ function() {
    function ImportUploadMusicXML2(value0) {
        this.value0 = value0;
    }
    ImportUploadMusicXML2.create = function(value0) {
        return new ImportUploadMusicXML2(value0);
    };
    return ImportUploadMusicXML2;
}();
var $a801f2c896bd09f1$var$ImportLoadPiece = /* @__PURE__ */ function() {
    function ImportLoadPiece2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ImportLoadPiece2.create = function(value0) {
        return function(value1) {
            return new ImportLoadPiece2(value0, value1);
        };
    };
    return ImportLoadPiece2;
}();
var $a801f2c896bd09f1$var$ImportLoadModel = /* @__PURE__ */ function() {
    function ImportLoadModel2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ImportLoadModel2.create = function(value0) {
        return function(value1) {
            return new ImportLoadModel2(value0, value1);
        };
    };
    return ImportLoadModel2;
}();
var $a801f2c896bd09f1$var$ImportConvertMusicXML = /* @__PURE__ */ function() {
    function ImportConvertMusicXML2(value0) {
        this.value0 = value0;
    }
    ImportConvertMusicXML2.create = function(value0) {
        return new ImportConvertMusicXML2(value0);
    };
    return ImportConvertMusicXML2;
}();
var $a801f2c896bd09f1$var$ImportRestoreAutosave = /* @__PURE__ */ function() {
    function ImportRestoreAutosave2() {}
    ImportRestoreAutosave2.value = new ImportRestoreAutosave2();
    return ImportRestoreAutosave2;
}();
var $a801f2c896bd09f1$var$importComponent = function(dictMonadAff) {
    var liftAff2 = $a801f2c896bd09f1$var$liftAff($a801f2c896bd09f1$var$monadAffHalogenM(dictMonadAff));
    var liftEffect8 = $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectHalogenM(dictMonadAff.MonadEffect0()));
    var render = function(v3) {
        var pieceEither = function() {
            var v1 = $a801f2c896bd09f1$var$readJSON2(v3.pieceText);
            if (v1 instanceof $a801f2c896bd09f1$var$Right) {
                var v22 = $a801f2c896bd09f1$var$pieceFromJSON(v1.value0);
                if (v22 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$loadPiece(v22.value0)));
                if (v22 instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Left("Invalid piece!");
                throw new Error("Failed pattern match at App.Tabs.Import (line 183, column 21 - line 185, column 41): " + [
                    v22.constructor.name
                ]);
            }
            if (v1 instanceof $a801f2c896bd09f1$var$Left) {
                var v22 = $a801f2c896bd09f1$var$readJSON1(v3.pieceText);
                if (v22 instanceof $a801f2c896bd09f1$var$Right) {
                    var v32 = $a801f2c896bd09f1$var$pieceFromJSON($a801f2c896bd09f1$var$addJSONIds(v22.value0));
                    if (v32 instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Right(new $a801f2c896bd09f1$var$Left($a801f2c896bd09f1$var$loadPiece(v32.value0)));
                    if (v32 instanceof $a801f2c896bd09f1$var$Nothing) return new $a801f2c896bd09f1$var$Left("Invalid piece!");
                    throw new Error("Failed pattern match at App.Tabs.Import (line 187, column 28 - line 189, column 43): " + [
                        v32.constructor.name
                    ]);
                }
                if (v22 instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$showJSONErrors2(function() {
                    var $541 = $a801f2c896bd09f1$var$eq26(v1.value0)(v22.value0);
                    if ($541) return v1.value0;
                    return $a801f2c896bd09f1$var$append15(v1.value0)(v22.value0);
                }());
                throw new Error("Failed pattern match at App.Tabs.Import (line 186, column 21 - line 190, column 88): " + [
                    v22.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at App.Tabs.Import (line 182, column 19 - line 190, column 88): " + [
                v1.constructor.name
            ]);
        }();
        var modelEither = function() {
            var modeljson = $a801f2c896bd09f1$var$readJSON22(v3.modelText);
            return $a801f2c896bd09f1$var$either($a801f2c896bd09f1$var$showJSONErrors2)($a801f2c896bd09f1$var$modelFromJSON)(modeljson);
        }();
        return $a801f2c896bd09f1$var$div5([
            $a801f2c896bd09f1$var$class_2("content-np tab")
        ])([
            $a801f2c896bd09f1$var$button([
                $a801f2c896bd09f1$var$class_2("pure-button"),
                $a801f2c896bd09f1$var$onClick(function(v1) {
                    var model = $a801f2c896bd09f1$var$loadPiece($a801f2c896bd09f1$var$examplePiece);
                    return new $a801f2c896bd09f1$var$ImportLoadModel("example", {
                        piece: model.piece,
                        reduction: model.reduction,
                        styles: {
                            notes: model.styles.notes,
                            edges: model.styles.edges,
                            slices: model.styles.slices,
                            transitions: model.styles.transitions,
                            css: model.styles.css,
                            staff: $a801f2c896bd09f1$var$TrebleStaff.value
                        }
                    });
                })
            ])([
                $a801f2c896bd09f1$var$text("Load Example")
            ]),
            $a801f2c896bd09f1$var$button([
                $a801f2c896bd09f1$var$class_2("pure-button"),
                $a801f2c896bd09f1$var$onClick(function(v1) {
                    return new $a801f2c896bd09f1$var$ImportLoadPiece("example-long", $a801f2c896bd09f1$var$examplePieceLong);
                })
            ])([
                $a801f2c896bd09f1$var$text("Load Example (Long)")
            ]),
            $a801f2c896bd09f1$var$button([
                $a801f2c896bd09f1$var$class_2("pure-button pure-button-primary"),
                $a801f2c896bd09f1$var$onClick(function(v1) {
                    return $a801f2c896bd09f1$var$ImportRestoreAutosave.value;
                })
            ])([
                $a801f2c896bd09f1$var$text("Restore Autosave Data")
            ]),
            $a801f2c896bd09f1$var$p2([
                $a801f2c896bd09f1$var$class_2("pure-g")
            ])([
                $a801f2c896bd09f1$var$label([
                    $a801f2c896bd09f1$var$$$for2("piece-name"),
                    $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                ])([
                    $a801f2c896bd09f1$var$text("Piece Name:")
                ]),
                $a801f2c896bd09f1$var$input([
                    $a801f2c896bd09f1$var$type_21($a801f2c896bd09f1$var$InputText.value),
                    $a801f2c896bd09f1$var$class_2("pure-u-1-2"),
                    $a801f2c896bd09f1$var$id2("piece-name"),
                    $a801f2c896bd09f1$var$value14(v3.name),
                    $a801f2c896bd09f1$var$onValueInput($a801f2c896bd09f1$var$ImportUpdateName.create)
                ])
            ]),
            $a801f2c896bd09f1$var$div_([
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("Import Piece")
                ]),
                $a801f2c896bd09f1$var$div_([
                    $a801f2c896bd09f1$var$label([
                        $a801f2c896bd09f1$var$$$for2("upload-piece")
                    ])([
                        $a801f2c896bd09f1$var$text("Choose a file: ")
                    ]),
                    $a801f2c896bd09f1$var$input([
                        $a801f2c896bd09f1$var$type_21($a801f2c896bd09f1$var$InputFile.value),
                        $a801f2c896bd09f1$var$id2("upload-piece"),
                        $a801f2c896bd09f1$var$accept([
                            new $a801f2c896bd09f1$var$AcceptFileExtension(".piece.json")
                        ]),
                        $a801f2c896bd09f1$var$onFileUpload2(function(files2) {
                            return new $a801f2c896bd09f1$var$ImportUploadPiece($a801f2c896bd09f1$var$head(files2));
                        })
                    ])
                ]),
                $a801f2c896bd09f1$var$p_([
                    $a801f2c896bd09f1$var$text("or enter JSON directly:")
                ]),
                $a801f2c896bd09f1$var$textarea([
                    $a801f2c896bd09f1$var$value14(v3.pieceText),
                    $a801f2c896bd09f1$var$onValueInput($a801f2c896bd09f1$var$ImportUpdatePieceInput.create)
                ]),
                function() {
                    var $544 = v3.pieceText === "";
                    if ($544) return $a801f2c896bd09f1$var$text("");
                    if (pieceEither instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$p2([
                        $a801f2c896bd09f1$var$class_2("alert")
                    ])([
                        $a801f2c896bd09f1$var$text("Invalid input:  "),
                        $a801f2c896bd09f1$var$pre_([
                            $a801f2c896bd09f1$var$text(pieceEither.value0)
                        ])
                    ]);
                    if (pieceEither instanceof $a801f2c896bd09f1$var$Right) {
                        if (pieceEither.value0 instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$div_([
                            $a801f2c896bd09f1$var$p_([
                                $a801f2c896bd09f1$var$text("Input valid, but no (or not all) IDs were given. Use generated IDs?")
                            ]),
                            $a801f2c896bd09f1$var$button([
                                $a801f2c896bd09f1$var$class_2("pure-button pure-button-primary"),
                                $a801f2c896bd09f1$var$onClick($a801f2c896bd09f1$var$$$const(new $a801f2c896bd09f1$var$ImportLoadModel(v3.name, pieceEither.value0.value0)))
                            ])([
                                $a801f2c896bd09f1$var$text("Import Piece (New IDs)")
                            ])
                        ]);
                        if (pieceEither.value0 instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$div_([
                            $a801f2c896bd09f1$var$p_([
                                $a801f2c896bd09f1$var$text("Input valid!")
                            ]),
                            $a801f2c896bd09f1$var$button([
                                $a801f2c896bd09f1$var$class_2("pure-button pure-button-primary"),
                                $a801f2c896bd09f1$var$onClick($a801f2c896bd09f1$var$$$const(new $a801f2c896bd09f1$var$ImportLoadModel(v3.name, pieceEither.value0.value0)))
                            ])([
                                $a801f2c896bd09f1$var$text("Import Piece")
                            ])
                        ]);
                        throw new Error("Failed pattern match at App.Tabs.Import (line 111, column 30 - line 123, column 22): " + [
                            pieceEither.value0.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at App.Tabs.Import (line 109, column 18 - line 123, column 22): " + [
                        pieceEither.constructor.name
                    ]);
                }()
            ]),
            $a801f2c896bd09f1$var$div_([
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("Import MusicXML")
                ]),
                $a801f2c896bd09f1$var$div_([
                    $a801f2c896bd09f1$var$label([
                        $a801f2c896bd09f1$var$$$for2("upload-musicxml")
                    ])([
                        $a801f2c896bd09f1$var$text("Choose a file: ")
                    ]),
                    $a801f2c896bd09f1$var$input([
                        $a801f2c896bd09f1$var$type_21($a801f2c896bd09f1$var$InputFile.value),
                        $a801f2c896bd09f1$var$id2("upload-musicxml"),
                        $a801f2c896bd09f1$var$accept([
                            new $a801f2c896bd09f1$var$AcceptFileExtension(".musicxml")
                        ]),
                        $a801f2c896bd09f1$var$onFileUpload2(function(files2) {
                            return new $a801f2c896bd09f1$var$ImportUploadMusicXML($a801f2c896bd09f1$var$head(files2));
                        })
                    ])
                ]),
                $a801f2c896bd09f1$var$p_([
                    $a801f2c896bd09f1$var$text("or enter MusicXML directly:")
                ]),
                $a801f2c896bd09f1$var$textarea([
                    $a801f2c896bd09f1$var$value14(v3.musicXMLText),
                    $a801f2c896bd09f1$var$onValueInput($a801f2c896bd09f1$var$ImportUpdateMusicXMLInput.create)
                ]),
                $a801f2c896bd09f1$var$p_([
                    $a801f2c896bd09f1$var$input([
                        $a801f2c896bd09f1$var$type_21($a801f2c896bd09f1$var$InputCheckbox.value),
                        $a801f2c896bd09f1$var$checked(v3.musicXMLUnfold),
                        $a801f2c896bd09f1$var$onChange(function(v1) {
                            return $a801f2c896bd09f1$var$ImportToggleMusicXMLUnfold.value;
                        }),
                        $a801f2c896bd09f1$var$id2("unfoldReps")
                    ]),
                    $a801f2c896bd09f1$var$label([
                        $a801f2c896bd09f1$var$$$for2("unfoldReps")
                    ])([
                        $a801f2c896bd09f1$var$text(" unfold repetitions")
                    ])
                ]),
                function() {
                    var $551 = v3.musicXMLText === "";
                    if ($551) return $a801f2c896bd09f1$var$text("");
                    return $a801f2c896bd09f1$var$div_([
                        $a801f2c896bd09f1$var$button([
                            $a801f2c896bd09f1$var$class_2("pure-button pure-button-primary"),
                            $a801f2c896bd09f1$var$onClick($a801f2c896bd09f1$var$$$const(new $a801f2c896bd09f1$var$ImportConvertMusicXML(v3.musicXMLText)))
                        ])([
                            $a801f2c896bd09f1$var$text("Convert MusicXML to Piece JSON")
                        ])
                    ]);
                }()
            ]),
            $a801f2c896bd09f1$var$div_([
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("Import Analysis")
                ]),
                $a801f2c896bd09f1$var$div_([
                    $a801f2c896bd09f1$var$label([
                        $a801f2c896bd09f1$var$$$for2("upload-analysis")
                    ])([
                        $a801f2c896bd09f1$var$text("Choose a file: ")
                    ]),
                    $a801f2c896bd09f1$var$input([
                        $a801f2c896bd09f1$var$type_21($a801f2c896bd09f1$var$InputFile.value),
                        $a801f2c896bd09f1$var$id2("upload-analysis"),
                        $a801f2c896bd09f1$var$accept([
                            new $a801f2c896bd09f1$var$AcceptFileExtension(".analysis.json")
                        ]),
                        $a801f2c896bd09f1$var$onFileUpload2(function(files2) {
                            return new $a801f2c896bd09f1$var$ImportUploadModel($a801f2c896bd09f1$var$head(files2));
                        })
                    ])
                ]),
                $a801f2c896bd09f1$var$p_([
                    $a801f2c896bd09f1$var$text("or enter JSON directly:")
                ]),
                $a801f2c896bd09f1$var$textarea([
                    $a801f2c896bd09f1$var$value14(v3.modelText),
                    $a801f2c896bd09f1$var$onValueInput($a801f2c896bd09f1$var$ImportUpdateModelInput.create)
                ]),
                function() {
                    var $552 = v3.modelText === "";
                    if ($552) return $a801f2c896bd09f1$var$text("");
                    if (modelEither instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$p2([
                        $a801f2c896bd09f1$var$class_2("alert")
                    ])([
                        $a801f2c896bd09f1$var$text("Invalid input:  "),
                        $a801f2c896bd09f1$var$pre_([
                            $a801f2c896bd09f1$var$text(modelEither.value0)
                        ])
                    ]);
                    if (modelEither instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$div_([
                        $a801f2c896bd09f1$var$p_([
                            $a801f2c896bd09f1$var$text("Input valid!")
                        ]),
                        $a801f2c896bd09f1$var$button([
                            $a801f2c896bd09f1$var$class_2("pure-button pure-button-primary"),
                            $a801f2c896bd09f1$var$onClick($a801f2c896bd09f1$var$$$const(new $a801f2c896bd09f1$var$ImportLoadModel(v3.name, modelEither.value0)))
                        ])([
                            $a801f2c896bd09f1$var$text("Import Analysis")
                        ])
                    ]);
                    throw new Error("Failed pattern match at App.Tabs.Import (line 171, column 18 - line 178, column 20): " + [
                        modelEither.constructor.name
                    ]);
                }()
            ])
        ]);
    };
    var initialState = function(v3) {
        return {
            modelText: "",
            pieceText: "",
            musicXMLText: "",
            musicXMLUnfold: true,
            name: "unnamed"
        };
    };
    var $lazy_handleImportAction = $a801f2c896bd09f1$var$$runtime_lazy10("handleImportAction", "App.Tabs.Import", function() {
        var modelFromAutosave = function(v3) {
            return $a801f2c896bd09f1$var$bind28($a801f2c896bd09f1$var$modelFromJSON(v3.model))(function(model$prime) {
                return $a801f2c896bd09f1$var$pure34({
                    name: v3.name,
                    model: model$prime
                });
            });
        };
        var loadFile = function(f2) {
            return function(ext) {
                return function(action2) {
                    if (f2 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure112($a801f2c896bd09f1$var$unit);
                    if (f2 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$bind110(liftAff2($a801f2c896bd09f1$var$readAsText2($a801f2c896bd09f1$var$toBlob(f2.value0))))(function(str) {
                        var fname = $a801f2c896bd09f1$var$name4(f2.value0);
                        var name17 = $a801f2c896bd09f1$var$fromMaybe(fname)($a801f2c896bd09f1$var$stripSuffix(ext)(fname));
                        return $a801f2c896bd09f1$var$discard7($lazy_handleImportAction(234)(action2(str)))(function() {
                            return $a801f2c896bd09f1$var$modify_6(function(st) {
                                var $565 = {};
                                for(var $566 in st)if (({}).hasOwnProperty.call(st, $566)) $565[$566] = st[$566];
                                $565.name = name17;
                                return $565;
                            });
                        });
                    });
                    throw new Error("Failed pattern match at App.Tabs.Import (line 226, column 29 - line 235, column 44): " + [
                        f2.constructor.name
                    ]);
                };
            };
        };
        return function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$ImportUpdateModelInput) return $a801f2c896bd09f1$var$modify_6(function(st) {
                var $570 = {};
                for(var $571 in st)if (({}).hasOwnProperty.call(st, $571)) $570[$571] = st[$571];
                $570.modelText = v3.value0;
                return $570;
            });
            if (v3 instanceof $a801f2c896bd09f1$var$ImportUpdatePieceInput) return $a801f2c896bd09f1$var$modify_6(function(st) {
                var $574 = {};
                for(var $575 in st)if (({}).hasOwnProperty.call(st, $575)) $574[$575] = st[$575];
                $574.pieceText = v3.value0;
                return $574;
            });
            if (v3 instanceof $a801f2c896bd09f1$var$ImportUpdateMusicXMLInput) return $a801f2c896bd09f1$var$modify_6(function(st) {
                var $578 = {};
                for(var $579 in st)if (({}).hasOwnProperty.call(st, $579)) $578[$579] = st[$579];
                $578.musicXMLText = v3.value0;
                return $578;
            });
            if (v3 instanceof $a801f2c896bd09f1$var$ImportToggleMusicXMLUnfold) return $a801f2c896bd09f1$var$modify_6(function(st) {
                var $582 = {};
                for(var $583 in st)if (({}).hasOwnProperty.call(st, $583)) $582[$583] = st[$583];
                $582.musicXMLUnfold = !st.musicXMLUnfold;
                return $582;
            });
            if (v3 instanceof $a801f2c896bd09f1$var$ImportUpdateName) return $a801f2c896bd09f1$var$modify_6(function(st) {
                var $585 = {};
                for(var $586 in st)if (({}).hasOwnProperty.call(st, $586)) $585[$586] = st[$586];
                $585.name = v3.value0;
                return $585;
            });
            if (v3 instanceof $a801f2c896bd09f1$var$ImportUploadModel) return loadFile(v3.value0)(".analysis.json")($a801f2c896bd09f1$var$ImportUpdateModelInput.create);
            if (v3 instanceof $a801f2c896bd09f1$var$ImportUploadPiece) return loadFile(v3.value0)(".piece.json")($a801f2c896bd09f1$var$ImportUpdatePieceInput.create);
            if (v3 instanceof $a801f2c896bd09f1$var$ImportUploadMusicXML) return loadFile(v3.value0)(".musicxml")($a801f2c896bd09f1$var$ImportUpdateMusicXMLInput.create);
            if (v3 instanceof $a801f2c896bd09f1$var$ImportLoadPiece) return $a801f2c896bd09f1$var$raise({
                name: v3.value0,
                thing: new $a801f2c896bd09f1$var$ImportPiece(v3.value1)
            });
            if (v3 instanceof $a801f2c896bd09f1$var$ImportLoadModel) return $a801f2c896bd09f1$var$raise({
                name: v3.value0,
                thing: new $a801f2c896bd09f1$var$ImportModel(v3.value1)
            });
            if (v3 instanceof $a801f2c896bd09f1$var$ImportConvertMusicXML) return $a801f2c896bd09f1$var$bind110($a801f2c896bd09f1$var$gets3(function(v1) {
                return v1.musicXMLUnfold;
            }))(function(unfold) {
                return $a801f2c896bd09f1$var$bind110(liftAff2($a801f2c896bd09f1$var$convertMusicXML(unfold)(v3.value0)))(function(res) {
                    return $a801f2c896bd09f1$var$bind110(liftEffect8($a801f2c896bd09f1$var$windowImpl))(function(w2) {
                        if (res instanceof $a801f2c896bd09f1$var$Left) return liftEffect8($a801f2c896bd09f1$var$alert("Error converting file:" + res.value0)(w2));
                        if (res instanceof $a801f2c896bd09f1$var$Right) return $lazy_handleImportAction(215)(new $a801f2c896bd09f1$var$ImportUpdatePieceInput(res.value0));
                        throw new Error("Failed pattern match at App.Tabs.Import (line 213, column 7 - line 215, column 69): " + [
                            res.constructor.name
                        ]);
                    });
                });
            });
            if (v3 instanceof $a801f2c896bd09f1$var$ImportRestoreAutosave) return $a801f2c896bd09f1$var$bind110(liftEffect8($a801f2c896bd09f1$var$windowImpl))(function(w2) {
                return $a801f2c896bd09f1$var$bind110(liftEffect8($a801f2c896bd09f1$var$localStorage(w2)))(function(s2) {
                    return $a801f2c896bd09f1$var$bind110(liftEffect8($a801f2c896bd09f1$var$getItem("autosave")(s2)))(function(autodata) {
                        if (autodata instanceof $a801f2c896bd09f1$var$Nothing) return liftEffect8($a801f2c896bd09f1$var$alert("No autosave data found.")(w2));
                        if (autodata instanceof $a801f2c896bd09f1$var$Just) {
                            var v1 = $a801f2c896bd09f1$var$either($a801f2c896bd09f1$var$showJSONErrors2)(modelFromAutosave)($a801f2c896bd09f1$var$readJSON3(autodata.value0));
                            if (v1 instanceof $a801f2c896bd09f1$var$Left) return liftEffect8($a801f2c896bd09f1$var$alert("Error loading autosave data: " + v1.value0)(w2));
                            if (v1 instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$raise({
                                name: v1.value0.name,
                                thing: new $a801f2c896bd09f1$var$ImportModel(v1.value0.model)
                            });
                            throw new Error("Failed pattern match at App.Tabs.Import (line 222, column 21 - line 224, column 80): " + [
                                v1.constructor.name
                            ]);
                        }
                        throw new Error("Failed pattern match at App.Tabs.Import (line 220, column 7 - line 224, column 80): " + [
                            autodata.constructor.name
                        ]);
                    });
                });
            });
            throw new Error("Failed pattern match at App.Tabs.Import (line 197, column 24 - line 224, column 80): " + [
                v3.constructor.name
            ]);
        };
    });
    var handleImportAction = $lazy_handleImportAction(197);
    return $a801f2c896bd09f1$var$mkComponent({
        initialState: initialState,
        render: render,
        "eval": $a801f2c896bd09f1$var$mkEval({
            handleQuery: $a801f2c896bd09f1$var$defaultEval.handleQuery,
            receive: $a801f2c896bd09f1$var$defaultEval.receive,
            initialize: $a801f2c896bd09f1$var$defaultEval.initialize,
            finalize: $a801f2c896bd09f1$var$defaultEval.finalize,
            handleAction: handleImportAction
        })
    });
};
// output/App.Tabs.SVG/index.js
var $a801f2c896bd09f1$var$bind29 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$get3 = /* @__PURE__ */ $a801f2c896bd09f1$var$get($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$pure35 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeHalogenM);
var $a801f2c896bd09f1$var$eq27 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq($a801f2c896bd09f1$var$eqStaff);
var $a801f2c896bd09f1$var$map48 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$type_22 = /* @__PURE__ */ $a801f2c896bd09f1$var$type_($a801f2c896bd09f1$var$isPropInputType);
var $a801f2c896bd09f1$var$discard8 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit)($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$modify_7 = /* @__PURE__ */ $a801f2c896bd09f1$var$modify_2($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$SVGRegisterElt = /* @__PURE__ */ function() {
    function SVGRegisterElt2(value0) {
        this.value0 = value0;
    }
    SVGRegisterElt2.create = function(value0) {
        return new SVGRegisterElt2(value0);
    };
    return SVGRegisterElt2;
}();
var $a801f2c896bd09f1$var$SVGReceive = /* @__PURE__ */ function() {
    function SVGReceive2(value0) {
        this.value0 = value0;
    }
    SVGReceive2.create = function(value0) {
        return new SVGReceive2(value0);
    };
    return SVGReceive2;
}();
var $a801f2c896bd09f1$var$SVGToggleSurface = /* @__PURE__ */ function() {
    function SVGToggleSurface2() {}
    SVGToggleSurface2.value = new SVGToggleSurface2();
    return SVGToggleSurface2;
}();
var $a801f2c896bd09f1$var$SVGDownload = /* @__PURE__ */ function() {
    function SVGDownload2() {}
    SVGDownload2.value = new SVGDownload2();
    return SVGDownload2;
}();
var $a801f2c896bd09f1$var$scoreScale2 = 0.9;
var $a801f2c896bd09f1$var$scoreHeightSingle = 80;
var $a801f2c896bd09f1$var$scoreHeightGrand = 150;
var $a801f2c896bd09f1$var$renderSVG = function(v3) {
    return function(settings) {
        return function(showSurface) {
            var totalWidth = $a801f2c896bd09f1$var$scalex(settings)($a801f2c896bd09f1$var$toNumber($a801f2c896bd09f1$var$length4(v3.model.piece))) + $a801f2c896bd09f1$var$sliceDistance / 2;
            var toX = function(x4) {
                return $a801f2c896bd09f1$var$scalex(settings)(x4);
            };
            return $a801f2c896bd09f1$var$renderGraph(v3.graph)(v3.model.piece)(v3.surface)(v3.model.styles)($a801f2c896bd09f1$var$Nothing.value)($a801f2c896bd09f1$var$Nothing.value)(toX)(totalWidth)($a801f2c896bd09f1$var$scoreScale2)(showSurface);
        };
    };
};
var $a801f2c896bd09f1$var$redrawGraph = function(dictMonadEffect) {
    var liftEffect8 = $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectHalogenM(dictMonadEffect));
    return $a801f2c896bd09f1$var$bind29($a801f2c896bd09f1$var$get3)(function(v3) {
        if (v3.scoreElt instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure35($a801f2c896bd09f1$var$unit);
        if (v3.scoreElt instanceof $a801f2c896bd09f1$var$Just) return liftEffect8($a801f2c896bd09f1$var$insertScore(v3.scoreElt.value0)($a801f2c896bd09f1$var$renderSVG(v3.modelInfo)(v3.settings)(v3.showSurface)));
        throw new Error("Failed pattern match at App.Tabs.SVG (line 147, column 3 - line 151, column 67): " + [
            v3.scoreElt.constructor.name
        ]);
    });
};
var $a801f2c896bd09f1$var$axisHeight2 = /* @__PURE__ */ $a801f2c896bd09f1$var$offset(2);
var $a801f2c896bd09f1$var$svgContainer = function(sett) {
    return function(showSurface) {
        return function(v3) {
            var width9 = $a801f2c896bd09f1$var$scalex(sett)(v3.graph.maxx + 1) + $a801f2c896bd09f1$var$sliceDistance / 2;
            var surfaceRows = function() {
                if (showSurface) return 1;
                return 0;
            }();
            var systemHeight = function() {
                var $53 = $a801f2c896bd09f1$var$eq27(v3.model.styles.staff)($a801f2c896bd09f1$var$GrandStaff.value);
                if ($53) return $a801f2c896bd09f1$var$scoreHeightGrand;
                return $a801f2c896bd09f1$var$scoreHeightSingle;
            }();
            var isComplete = $a801f2c896bd09f1$var$length(v3.model.reduction.segments) === 1;
            var extraRows = function() {
                if (isComplete) return 0;
                return 1;
            }();
            var height9 = systemHeight * (v3.graph.maxd + surfaceRows + extraRows) + $a801f2c896bd09f1$var$axisHeight2;
            return $a801f2c896bd09f1$var$div5([
                $a801f2c896bd09f1$var$style("overflow: scroll;")
            ])([
                $a801f2c896bd09f1$var$svg([
                    $a801f2c896bd09f1$var$width2(width9),
                    $a801f2c896bd09f1$var$height2(height9),
                    $a801f2c896bd09f1$var$viewBox(-$a801f2c896bd09f1$var$scalex(sett)(1))(0)(width9)(height9),
                    $a801f2c896bd09f1$var$ref($a801f2c896bd09f1$var$map48(function($81) {
                        return $a801f2c896bd09f1$var$Action.create($a801f2c896bd09f1$var$SVGRegisterElt.create($81));
                    })),
                    $a801f2c896bd09f1$var$style("overflow: visible;"),
                    $a801f2c896bd09f1$var$id2("svg-graph"),
                    $a801f2c896bd09f1$var$attr2("xmlns")("http://www.w3.org/2000/svg")
                ])([])
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$svgComponent = function(dictMonadEffect) {
    var liftEffect8 = $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectHalogenM(dictMonadEffect));
    var redrawGraph1 = $a801f2c896bd09f1$var$redrawGraph(dictMonadEffect);
    var render = function(v3) {
        return $a801f2c896bd09f1$var$div_([
            $a801f2c896bd09f1$var$div5([
                $a801f2c896bd09f1$var$class_2("content-np tab pure-form pure-g")
            ])([
                $a801f2c896bd09f1$var$label([
                    $a801f2c896bd09f1$var$class_2("pure-u-4-5")
                ])([
                    $a801f2c896bd09f1$var$input([
                        $a801f2c896bd09f1$var$type_22($a801f2c896bd09f1$var$InputCheckbox.value),
                        $a801f2c896bd09f1$var$checked(v3.showSurface),
                        $a801f2c896bd09f1$var$onChange(function(v1) {
                            return $a801f2c896bd09f1$var$SVGToggleSurface.value;
                        }),
                        $a801f2c896bd09f1$var$id2("showSurface")
                    ]),
                    $a801f2c896bd09f1$var$text(" show full surface below graph")
                ]),
                $a801f2c896bd09f1$var$button([
                    $a801f2c896bd09f1$var$class_2("pure-button pure-button-primary pure-u-1-5 center"),
                    $a801f2c896bd09f1$var$onClick(function(v1) {
                        return $a801f2c896bd09f1$var$SVGDownload.value;
                    })
                ])([
                    $a801f2c896bd09f1$var$text("Download")
                ])
            ]),
            $a801f2c896bd09f1$var$div5([
                $a801f2c896bd09f1$var$class_2("wide")
            ])([
                $a801f2c896bd09f1$var$svgContainer(v3.settings)(v3.showSurface)(v3.modelInfo)
            ])
        ]);
    };
    var initialState = function(v3) {
        return {
            modelInfo: v3.modelInfo,
            settings: v3.settings,
            scoreElt: $a801f2c896bd09f1$var$Nothing.value,
            showSurface: true,
            name: v3.name
        };
    };
    var handleSVGAction = function(action2) {
        return $a801f2c896bd09f1$var$discard8(function() {
            if (action2 instanceof $a801f2c896bd09f1$var$SVGRegisterElt) return $a801f2c896bd09f1$var$modify_7(function(st) {
                var $66 = {};
                for(var $67 in st)if (({}).hasOwnProperty.call(st, $67)) $66[$67] = st[$67];
                $66.scoreElt = new $a801f2c896bd09f1$var$Just(action2.value0);
                return $66;
            });
            if (action2 instanceof $a801f2c896bd09f1$var$SVGReceive) return $a801f2c896bd09f1$var$modify_7(function(st) {
                var $70 = {};
                for(var $71 in st)if (({}).hasOwnProperty.call(st, $71)) $70[$71] = st[$71];
                $70.modelInfo = action2.value0.modelInfo;
                $70.settings = action2.value0.settings;
                return $70;
            });
            if (action2 instanceof $a801f2c896bd09f1$var$SVGToggleSurface) return $a801f2c896bd09f1$var$modify_7(function(st) {
                var $76 = {};
                for(var $77 in st)if (({}).hasOwnProperty.call(st, $77)) $76[$77] = st[$77];
                $76.showSurface = !st.showSurface;
                return $76;
            });
            if (action2 instanceof $a801f2c896bd09f1$var$SVGDownload) return $a801f2c896bd09f1$var$bind29($a801f2c896bd09f1$var$get3)(function(v3) {
                return $a801f2c896bd09f1$var$bind29(liftEffect8($a801f2c896bd09f1$var$getElementHTML("svg-graph")))(function(svg2) {
                    return $a801f2c896bd09f1$var$bind29(liftEffect8($a801f2c896bd09f1$var$download('<?xml version="1.0" encoding="UTF-8"?>\n' + svg2)(v3.name + ".svg")("image/svg+xml")))(function() {
                        return $a801f2c896bd09f1$var$pure35($a801f2c896bd09f1$var$unit);
                    });
                });
            });
            throw new Error("Failed pattern match at App.Tabs.SVG (line 92, column 5 - line 104, column 18): " + [
                action2.constructor.name
            ]);
        }())(function() {
            return redrawGraph1;
        });
    };
    return $a801f2c896bd09f1$var$mkComponent({
        initialState: initialState,
        render: render,
        "eval": $a801f2c896bd09f1$var$mkEval({
            handleQuery: $a801f2c896bd09f1$var$defaultEval.handleQuery,
            initialize: $a801f2c896bd09f1$var$defaultEval.initialize,
            finalize: $a801f2c896bd09f1$var$defaultEval.finalize,
            handleAction: handleSVGAction,
            receive: function($82) {
                return $a801f2c896bd09f1$var$Just.create($a801f2c896bd09f1$var$SVGReceive.create($82));
            }
        })
    });
};
// output/App.Tabs.Settings/index.js
var $a801f2c896bd09f1$var$type_23 = /* @__PURE__ */ $a801f2c896bd09f1$var$type_($a801f2c896bd09f1$var$isPropInputType);
var $a801f2c896bd09f1$var$show37 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showNumber);
var $a801f2c896bd09f1$var$value15 = /* @__PURE__ */ $a801f2c896bd09f1$var$value($a801f2c896bd09f1$var$isPropString);
var $a801f2c896bd09f1$var$discard9 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit)($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$modify_8 = /* @__PURE__ */ $a801f2c896bd09f1$var$modify_2($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$pure36 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeHalogenM);
var $a801f2c896bd09f1$var$bindFlipped8 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$gets4 = /* @__PURE__ */ $a801f2c896bd09f1$var$gets($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$SettingsToggleFlatHori = /* @__PURE__ */ function() {
    function SettingsToggleFlatHori2() {}
    SettingsToggleFlatHori2.value = new SettingsToggleFlatHori2();
    return SettingsToggleFlatHori2;
}();
var $a801f2c896bd09f1$var$SettingsToggleShowAllEdges = /* @__PURE__ */ function() {
    function SettingsToggleShowAllEdges2() {}
    SettingsToggleShowAllEdges2.value = new SettingsToggleShowAllEdges2();
    return SettingsToggleShowAllEdges2;
}();
var $a801f2c896bd09f1$var$SettingsToggleShowScore = /* @__PURE__ */ function() {
    function SettingsToggleShowScore2() {}
    SettingsToggleShowScore2.value = new SettingsToggleShowScore2();
    return SettingsToggleShowScore2;
}();
var $a801f2c896bd09f1$var$SettingsSetXScale = /* @__PURE__ */ function() {
    function SettingsSetXScale2(value0) {
        this.value0 = value0;
    }
    SettingsSetXScale2.create = function(value0) {
        return new SettingsSetXScale2(value0);
    };
    return SettingsSetXScale2;
}();
var $a801f2c896bd09f1$var$SettingsSetYScale = /* @__PURE__ */ function() {
    function SettingsSetYScale2(value0) {
        this.value0 = value0;
    }
    SettingsSetYScale2.create = function(value0) {
        return new SettingsSetYScale2(value0);
    };
    return SettingsSetYScale2;
}();
var $a801f2c896bd09f1$var$settingsComponent = /* @__PURE__ */ function() {
    var render = function(v3) {
        return $a801f2c896bd09f1$var$div5([
            $a801f2c896bd09f1$var$class_2("content-np tab pure-form")
        ])([
            $a801f2c896bd09f1$var$div5([
                $a801f2c896bd09f1$var$class_2("pure-g")
            ])([
                $a801f2c896bd09f1$var$label([
                    $a801f2c896bd09f1$var$class_2("pure-u-1-5")
                ])([
                    $a801f2c896bd09f1$var$input([
                        $a801f2c896bd09f1$var$type_23($a801f2c896bd09f1$var$InputCheckbox.value),
                        $a801f2c896bd09f1$var$checked(v3.settings.flatHori),
                        $a801f2c896bd09f1$var$onChange(function(v1) {
                            return $a801f2c896bd09f1$var$SettingsToggleFlatHori.value;
                        })
                    ]),
                    $a801f2c896bd09f1$var$text(" render horis flat")
                ]),
                $a801f2c896bd09f1$var$label([
                    $a801f2c896bd09f1$var$class_2("pure-u-1-5")
                ])([
                    $a801f2c896bd09f1$var$input([
                        $a801f2c896bd09f1$var$type_23($a801f2c896bd09f1$var$InputCheckbox.value),
                        $a801f2c896bd09f1$var$checked(v3.settings.showAllEdges),
                        $a801f2c896bd09f1$var$onChange(function(v1) {
                            return $a801f2c896bd09f1$var$SettingsToggleShowAllEdges.value;
                        })
                    ]),
                    $a801f2c896bd09f1$var$text(" show all edges")
                ]),
                $a801f2c896bd09f1$var$label([
                    $a801f2c896bd09f1$var$class_2("pure-u-1-5")
                ])([
                    $a801f2c896bd09f1$var$input([
                        $a801f2c896bd09f1$var$type_23($a801f2c896bd09f1$var$InputCheckbox.value),
                        $a801f2c896bd09f1$var$checked(v3.settings.showScore),
                        $a801f2c896bd09f1$var$onChange(function(v1) {
                            return $a801f2c896bd09f1$var$SettingsToggleShowScore.value;
                        })
                    ]),
                    $a801f2c896bd09f1$var$text(" show score")
                ])
            ]),
            $a801f2c896bd09f1$var$p2([
                $a801f2c896bd09f1$var$class_2("pure-g")
            ])([
                $a801f2c896bd09f1$var$label([
                    $a801f2c896bd09f1$var$class_2("pure-u-1-5"),
                    $a801f2c896bd09f1$var$$$for2("xscale")
                ])([
                    $a801f2c896bd09f1$var$text("horizontal zoom: " + $a801f2c896bd09f1$var$show37(v3.settings.xscale))
                ]),
                $a801f2c896bd09f1$var$input([
                    $a801f2c896bd09f1$var$class_2("pure-u-3-5"),
                    $a801f2c896bd09f1$var$type_23($a801f2c896bd09f1$var$InputRange.value),
                    $a801f2c896bd09f1$var$min3(-5),
                    $a801f2c896bd09f1$var$max4(0),
                    $a801f2c896bd09f1$var$step2(new $a801f2c896bd09f1$var$Step(0.01)),
                    $a801f2c896bd09f1$var$value15($a801f2c896bd09f1$var$show37(v3.settings.xscale)),
                    $a801f2c896bd09f1$var$onValueChange($a801f2c896bd09f1$var$SettingsSetXScale.create),
                    $a801f2c896bd09f1$var$name2("xscale")
                ]),
                $a801f2c896bd09f1$var$div5([
                    $a801f2c896bd09f1$var$class_2("pure-u-1-5")
                ])([
                    $a801f2c896bd09f1$var$button([
                        $a801f2c896bd09f1$var$class_2("pure-button center"),
                        $a801f2c896bd09f1$var$onClick(function(v1) {
                            return new $a801f2c896bd09f1$var$SettingsSetXScale($a801f2c896bd09f1$var$show37($a801f2c896bd09f1$var$defaultSettings.xscale));
                        })
                    ])([
                        $a801f2c896bd09f1$var$text("Reset")
                    ])
                ])
            ]),
            $a801f2c896bd09f1$var$p2([
                $a801f2c896bd09f1$var$class_2("pure-g")
            ])([
                $a801f2c896bd09f1$var$label([
                    $a801f2c896bd09f1$var$class_2("pure-u-1-5"),
                    $a801f2c896bd09f1$var$$$for2("yscale")
                ])([
                    $a801f2c896bd09f1$var$text("yscale: " + $a801f2c896bd09f1$var$show37(v3.settings.yscale))
                ]),
                $a801f2c896bd09f1$var$input([
                    $a801f2c896bd09f1$var$class_2("pure-u-3-5"),
                    $a801f2c896bd09f1$var$type_23($a801f2c896bd09f1$var$InputRange.value),
                    $a801f2c896bd09f1$var$min3(-2),
                    $a801f2c896bd09f1$var$max4(2),
                    $a801f2c896bd09f1$var$step2(new $a801f2c896bd09f1$var$Step(0.01)),
                    $a801f2c896bd09f1$var$value15($a801f2c896bd09f1$var$show37(v3.settings.yscale)),
                    $a801f2c896bd09f1$var$onValueChange($a801f2c896bd09f1$var$SettingsSetYScale.create),
                    $a801f2c896bd09f1$var$name2("vertical zoom")
                ]),
                $a801f2c896bd09f1$var$div5([
                    $a801f2c896bd09f1$var$class_2("pure-u-1-5")
                ])([
                    $a801f2c896bd09f1$var$button([
                        $a801f2c896bd09f1$var$class_2("pure-button center"),
                        $a801f2c896bd09f1$var$onClick(function(v1) {
                            return new $a801f2c896bd09f1$var$SettingsSetYScale($a801f2c896bd09f1$var$show37($a801f2c896bd09f1$var$defaultSettings.yscale));
                        })
                    ])([
                        $a801f2c896bd09f1$var$text("Reset")
                    ])
                ])
            ])
        ]);
    };
    var initialState = function(settings) {
        return {
            settings: settings
        };
    };
    var handleOptAction = function(msg) {
        return $a801f2c896bd09f1$var$discard9(function() {
            if (msg instanceof $a801f2c896bd09f1$var$SettingsToggleFlatHori) return $a801f2c896bd09f1$var$modify_8(function(st) {
                var $33 = {};
                for(var $34 in st)if (({}).hasOwnProperty.call(st, $34)) $33[$34] = st[$34];
                $33.settings = function() {
                    var $30 = {};
                    for(var $31 in st.settings)if (({}).hasOwnProperty.call(st.settings, $31)) $30[$31] = st["settings"][$31];
                    $30.flatHori = !st.settings.flatHori;
                    return $30;
                }();
                return $33;
            });
            if (msg instanceof $a801f2c896bd09f1$var$SettingsToggleShowAllEdges) return $a801f2c896bd09f1$var$modify_8(function(st) {
                var $39 = {};
                for(var $40 in st)if (({}).hasOwnProperty.call(st, $40)) $39[$40] = st[$40];
                $39.settings = function() {
                    var $36 = {};
                    for(var $37 in st.settings)if (({}).hasOwnProperty.call(st.settings, $37)) $36[$37] = st["settings"][$37];
                    $36.showAllEdges = !st.settings.showAllEdges;
                    return $36;
                }();
                return $39;
            });
            if (msg instanceof $a801f2c896bd09f1$var$SettingsToggleShowScore) return $a801f2c896bd09f1$var$modify_8(function(st) {
                var $45 = {};
                for(var $46 in st)if (({}).hasOwnProperty.call(st, $46)) $45[$46] = st[$46];
                $45.settings = function() {
                    var $42 = {};
                    for(var $43 in st.settings)if (({}).hasOwnProperty.call(st.settings, $43)) $42[$43] = st["settings"][$43];
                    $42.showScore = !st.settings.showScore;
                    return $42;
                }();
                return $45;
            });
            if (msg instanceof $a801f2c896bd09f1$var$SettingsSetXScale) {
                var v3 = $a801f2c896bd09f1$var$fromString(msg.value0);
                if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure36($a801f2c896bd09f1$var$unit);
                if (v3 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$modify_8(function(st) {
                    var $52 = {};
                    for(var $53 in st)if (({}).hasOwnProperty.call(st, $53)) $52[$53] = st[$53];
                    $52.settings = function() {
                        var $49 = {};
                        for(var $50 in st.settings)if (({}).hasOwnProperty.call(st.settings, $50)) $49[$50] = st["settings"][$50];
                        $49.xscale = v3.value0;
                        return $49;
                    }();
                    return $52;
                });
                throw new Error("Failed pattern match at App.Tabs.Settings (line 93, column 30 - line 95, column 66): " + [
                    v3.constructor.name
                ]);
            }
            if (msg instanceof $a801f2c896bd09f1$var$SettingsSetYScale) {
                var v3 = $a801f2c896bd09f1$var$fromString(msg.value0);
                if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure36($a801f2c896bd09f1$var$unit);
                if (v3 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$modify_8(function(st) {
                    var $61 = {};
                    for(var $62 in st)if (({}).hasOwnProperty.call(st, $62)) $61[$62] = st[$62];
                    $61.settings = function() {
                        var $58 = {};
                        for(var $59 in st.settings)if (({}).hasOwnProperty.call(st.settings, $59)) $58[$59] = st["settings"][$59];
                        $58.yscale = v3.value0;
                        return $58;
                    }();
                    return $61;
                });
                throw new Error("Failed pattern match at App.Tabs.Settings (line 96, column 30 - line 98, column 66): " + [
                    v3.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at App.Tabs.Settings (line 89, column 5 - line 98, column 66): " + [
                msg.constructor.name
            ]);
        }())(function() {
            return $a801f2c896bd09f1$var$bindFlipped8($a801f2c896bd09f1$var$raise)($a801f2c896bd09f1$var$gets4(function(v3) {
                return v3.settings;
            }));
        });
    };
    return $a801f2c896bd09f1$var$mkComponent({
        initialState: initialState,
        render: render,
        "eval": $a801f2c896bd09f1$var$mkEval({
            handleQuery: $a801f2c896bd09f1$var$defaultEval.handleQuery,
            receive: $a801f2c896bd09f1$var$defaultEval.receive,
            initialize: $a801f2c896bd09f1$var$defaultEval.initialize,
            finalize: $a801f2c896bd09f1$var$defaultEval.finalize,
            handleAction: handleOptAction
        })
    });
}();
// output/App.Tabs.Style/index.js
var $a801f2c896bd09f1$var$type_24 = /* @__PURE__ */ $a801f2c896bd09f1$var$type_($a801f2c896bd09f1$var$isPropInputType);
var $a801f2c896bd09f1$var$value16 = /* @__PURE__ */ $a801f2c896bd09f1$var$value($a801f2c896bd09f1$var$isPropString);
var $a801f2c896bd09f1$var$mkSelect$prime2 = /* @__PURE__ */ $a801f2c896bd09f1$var$mkSelect$prime($a801f2c896bd09f1$var$eqStaff);
var $a801f2c896bd09f1$var$showPitch4 = /* @__PURE__ */ $a801f2c896bd09f1$var$showPitch($a801f2c896bd09f1$var$notationPitchSInterval);
var $a801f2c896bd09f1$var$show38 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showPitch4);
var $a801f2c896bd09f1$var$show114 = /* @__PURE__ */ $a801f2c896bd09f1$var$show(/* @__PURE__ */ $a801f2c896bd09f1$var$showStartStop(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecord()()(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsCons({
    reflectSymbol: function() {
        return "id";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$showRecordFieldsConsNil({
    reflectSymbol: function() {
        return "pitch";
    }
})($a801f2c896bd09f1$var$showPitch4))($a801f2c896bd09f1$var$showString))));
var $a801f2c896bd09f1$var$lookup9 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3(/* @__PURE__ */ $a801f2c896bd09f1$var$ordTuple($a801f2c896bd09f1$var$ordString)($a801f2c896bd09f1$var$ordString));
var $a801f2c896bd09f1$var$lookup13 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordTransId);
var $a801f2c896bd09f1$var$append16 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$map49 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$toUnfoldable8 = /* @__PURE__ */ $a801f2c896bd09f1$var$toUnfoldable5($a801f2c896bd09f1$var$unfoldableArray);
var $a801f2c896bd09f1$var$lookup23 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordString);
var $a801f2c896bd09f1$var$show211 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showTransId);
var $a801f2c896bd09f1$var$show39 = /* @__PURE__ */ $a801f2c896bd09f1$var$show($a801f2c896bd09f1$var$showSliceId);
var $a801f2c896bd09f1$var$lookup33 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordSliceId);
var $a801f2c896bd09f1$var$pure37 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeHalogenM);
var $a801f2c896bd09f1$var$bind30 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$get4 = /* @__PURE__ */ $a801f2c896bd09f1$var$get($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$put2 = /* @__PURE__ */ $a801f2c896bd09f1$var$put($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$StyleActionUpdateCSS = /* @__PURE__ */ function() {
    function StyleActionUpdateCSS2(value0) {
        this.value0 = value0;
    }
    StyleActionUpdateCSS2.create = function(value0) {
        return new StyleActionUpdateCSS2(value0);
    };
    return StyleActionUpdateCSS2;
}();
var $a801f2c896bd09f1$var$StyleActionUpdateStaff = /* @__PURE__ */ function() {
    function StyleActionUpdateStaff2(value0) {
        this.value0 = value0;
    }
    StyleActionUpdateStaff2.create = function(value0) {
        return new StyleActionUpdateStaff2(value0);
    };
    return StyleActionUpdateStaff2;
}();
var $a801f2c896bd09f1$var$StyleActionUpdateClasses = /* @__PURE__ */ function() {
    function StyleActionUpdateClasses2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    StyleActionUpdateClasses2.create = function(value0) {
        return function(value1) {
            return new StyleActionUpdateClasses2(value0, value1);
        };
    };
    return StyleActionUpdateClasses2;
}();
var $a801f2c896bd09f1$var$StyleActionUpdateLabel = /* @__PURE__ */ function() {
    function StyleActionUpdateLabel2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    StyleActionUpdateLabel2.create = function(value0) {
        return function(value1) {
            return new StyleActionUpdateLabel2(value0, value1);
        };
    };
    return StyleActionUpdateLabel2;
}();
var $a801f2c896bd09f1$var$StyleActionReceive = /* @__PURE__ */ function() {
    function StyleActionReceive2(value0) {
        this.value0 = value0;
    }
    StyleActionReceive2.create = function(value0) {
        return new StyleActionReceive2(value0);
    };
    return StyleActionReceive2;
}();
var $a801f2c896bd09f1$var$styleComponent = /* @__PURE__ */ function() {
    var render = function(v3) {
        var styleBox = function(elt) {
            return function(heading) {
                return function(style3) {
                    return $a801f2c896bd09f1$var$div_([
                        $a801f2c896bd09f1$var$h4_([
                            $a801f2c896bd09f1$var$text(heading)
                        ]),
                        $a801f2c896bd09f1$var$p2([
                            $a801f2c896bd09f1$var$class_2("pure-g")
                        ])([
                            $a801f2c896bd09f1$var$label([
                                $a801f2c896bd09f1$var$$$for2("style-classes"),
                                $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                            ])([
                                $a801f2c896bd09f1$var$text("Classes:")
                            ]),
                            $a801f2c896bd09f1$var$input([
                                $a801f2c896bd09f1$var$type_24($a801f2c896bd09f1$var$InputText.value),
                                $a801f2c896bd09f1$var$class_2("pure-u-1-2"),
                                $a801f2c896bd09f1$var$id2("style-classes"),
                                $a801f2c896bd09f1$var$value16(style3.classes),
                                $a801f2c896bd09f1$var$onValueInput($a801f2c896bd09f1$var$StyleActionUpdateClasses.create(elt))
                            ])
                        ]),
                        $a801f2c896bd09f1$var$p2([
                            $a801f2c896bd09f1$var$class_2("pure-g")
                        ])([
                            $a801f2c896bd09f1$var$label([
                                $a801f2c896bd09f1$var$$$for2("style-label"),
                                $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                            ])([
                                $a801f2c896bd09f1$var$text("Label:")
                            ]),
                            $a801f2c896bd09f1$var$input([
                                $a801f2c896bd09f1$var$type_24($a801f2c896bd09f1$var$InputText.value),
                                $a801f2c896bd09f1$var$class_2("pure-u-1-2"),
                                $a801f2c896bd09f1$var$id2("style-label"),
                                $a801f2c896bd09f1$var$value16(style3.label),
                                $a801f2c896bd09f1$var$onValueInput($a801f2c896bd09f1$var$StyleActionUpdateLabel.create(elt))
                            ])
                        ])
                    ]);
                };
            };
        };
        var showStaffType = function(v1) {
            if (v1 instanceof $a801f2c896bd09f1$var$GrandStaff) return "Grand";
            if (v1 instanceof $a801f2c896bd09f1$var$TrebleStaff) return "Treble";
            if (v1 instanceof $a801f2c896bd09f1$var$BassStaff) return "Bass";
            throw new Error("Failed pattern match at App.Tabs.Style (line 54, column 21 - line 57, column 26): " + [
                v1.constructor.name
            ]);
        };
        var generalBox = function(styles) {
            return $a801f2c896bd09f1$var$div_([
                $a801f2c896bd09f1$var$h3_([
                    $a801f2c896bd09f1$var$text("General Style Options")
                ]),
                $a801f2c896bd09f1$var$p2([
                    $a801f2c896bd09f1$var$class_2("pure-g")
                ])([
                    $a801f2c896bd09f1$var$label([
                        $a801f2c896bd09f1$var$$$for2("style-staff"),
                        $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                    ])([
                        $a801f2c896bd09f1$var$text("Staff Type:")
                    ]),
                    $a801f2c896bd09f1$var$mkSelect$prime2($a801f2c896bd09f1$var$StyleActionUpdateStaff.create)(showStaffType)(styles.staff)([
                        $a801f2c896bd09f1$var$GrandStaff.value,
                        $a801f2c896bd09f1$var$TrebleStaff.value,
                        $a801f2c896bd09f1$var$BassStaff.value
                    ])
                ]),
                $a801f2c896bd09f1$var$label([
                    $a801f2c896bd09f1$var$$$for2("style-css")
                ])([
                    $a801f2c896bd09f1$var$text("Custom CSS:")
                ]),
                $a801f2c896bd09f1$var$textarea([
                    $a801f2c896bd09f1$var$id2("style-css"),
                    $a801f2c896bd09f1$var$value16(styles.css),
                    $a801f2c896bd09f1$var$onValueInput($a801f2c896bd09f1$var$StyleActionUpdateCSS.create)
                ])
            ]);
        };
        var edgeStyleBoxes = function(transid) {
            return function(graph) {
                return function(styles) {
                    var showNote = function(v12) {
                        if (v12 instanceof $a801f2c896bd09f1$var$Inner) return $a801f2c896bd09f1$var$show38(v12.value0.pitch) + (" (" + (v12.value0.id + ")"));
                        return $a801f2c896bd09f1$var$show114(v12);
                    };
                    var mkEdgeBox = function(prefix2) {
                        return function(edge) {
                            return styleBox(new $a801f2c896bd09f1$var$Right(edge))(prefix2 + ("Edge " + (showNote(edge.left) + (" to " + showNote(edge.right)))))($a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$emptyStyle)($a801f2c896bd09f1$var$lookup9($a801f2c896bd09f1$var$edgeIds(edge))(styles.edges)));
                        };
                    };
                    var v1 = $a801f2c896bd09f1$var$lookup13(transid)(graph.transitions);
                    if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return [];
                    if (v1 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$append16($a801f2c896bd09f1$var$map49(mkEdgeBox(""))($a801f2c896bd09f1$var$toUnfoldable8(v1.value0.edges.regular)))($a801f2c896bd09f1$var$map49(mkEdgeBox("Passing "))(v1.value0.edges.passing));
                    throw new Error("Failed pattern match at App.Tabs.Style (line 88, column 43 - line 92, column 57): " + [
                        v1.constructor.name
                    ]);
                };
            };
        };
        var selectionStyle = function(styles) {
            return function(graph) {
                if (v3.selection instanceof $a801f2c896bd09f1$var$SelNone) return $a801f2c896bd09f1$var$text("");
                if (v3.selection instanceof $a801f2c896bd09f1$var$SelNote) return styleBox(new $a801f2c896bd09f1$var$Left(v3.selection))("Note " + v3.selection.value0.note.id)($a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$emptyStyle)($a801f2c896bd09f1$var$lookup23(v3.selection.value0.note.id)(styles.notes)));
                if (v3.selection instanceof $a801f2c896bd09f1$var$SelTrans) return $a801f2c896bd09f1$var$div_($a801f2c896bd09f1$var$append16([
                    styleBox(new $a801f2c896bd09f1$var$Left(v3.selection))("Transition " + $a801f2c896bd09f1$var$show211(v3.selection.value0))($a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$emptyStyle)($a801f2c896bd09f1$var$lookup13(v3.selection.value0)(styles.transitions)))
                ])(edgeStyleBoxes(v3.selection.value0)(graph)(styles)));
                if (v3.selection instanceof $a801f2c896bd09f1$var$SelSlice) return styleBox(new $a801f2c896bd09f1$var$Left(v3.selection))("Slice " + $a801f2c896bd09f1$var$show39(v3.selection.value0))($a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$emptyStyle)($a801f2c896bd09f1$var$lookup33(v3.selection.value0)(styles.slices)));
                throw new Error("Failed pattern match at App.Tabs.Style (line 69, column 35 - line 86, column 66): " + [
                    v3.selection.constructor.name
                ]);
            };
        };
        if (v3.modelInfo instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$text("");
        if (v3.modelInfo instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$div5([
            $a801f2c896bd09f1$var$class_2("content-np tab")
        ])([
            generalBox(v3.modelInfo.value0.model.styles),
            selectionStyle(v3.modelInfo.value0.model.styles)(v3.modelInfo.value0.graph)
        ]);
        throw new Error("Failed pattern match at App.Tabs.Style (line 48, column 44 - line 51, column 84): " + [
            v3.modelInfo.constructor.name
        ]);
    };
    var initialState = function(state3) {
        return state3;
    };
    var handleStyleAction = /* @__PURE__ */ function() {
        var updateEltStyle = function(st) {
            return function(elt) {
                return function(f2) {
                    if (st.modelInfo instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure37($a801f2c896bd09f1$var$unit);
                    if (st.modelInfo instanceof $a801f2c896bd09f1$var$Just) {
                        if (elt instanceof $a801f2c896bd09f1$var$Left && elt.value0 instanceof $a801f2c896bd09f1$var$SelNone) return $a801f2c896bd09f1$var$pure37($a801f2c896bd09f1$var$unit);
                        if (elt instanceof $a801f2c896bd09f1$var$Left && elt.value0 instanceof $a801f2c896bd09f1$var$SelNote) return $a801f2c896bd09f1$var$raise($a801f2c896bd09f1$var$stylesUpdateNote(f2)(elt.value0.value0.note.id)(st.modelInfo.value0.model.styles));
                        if (elt instanceof $a801f2c896bd09f1$var$Left && elt.value0 instanceof $a801f2c896bd09f1$var$SelSlice) return $a801f2c896bd09f1$var$raise($a801f2c896bd09f1$var$stylesUpdateSlice(f2)(elt.value0.value0)(st.modelInfo.value0.model.styles));
                        if (elt instanceof $a801f2c896bd09f1$var$Left && elt.value0 instanceof $a801f2c896bd09f1$var$SelTrans) return $a801f2c896bd09f1$var$raise($a801f2c896bd09f1$var$stylesUpdateTrans(f2)(elt.value0.value0)(st.modelInfo.value0.model.styles));
                        if (elt instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$raise($a801f2c896bd09f1$var$stylesUpdateEdge(f2)($a801f2c896bd09f1$var$edgeIds(elt.value0))(st.modelInfo.value0.model.styles));
                        throw new Error("Failed pattern match at App.Tabs.Style (line 154, column 20 - line 159, column 84): " + [
                            elt.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at App.Tabs.Style (line 152, column 31 - line 159, column 84): " + [
                        st.modelInfo.constructor.name
                    ]);
                };
            };
        };
        return function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$StyleActionUpdateCSS) return $a801f2c896bd09f1$var$bind30($a801f2c896bd09f1$var$get4)(function(st) {
                if (st.modelInfo instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure37($a801f2c896bd09f1$var$unit);
                if (st.modelInfo instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$raise({
                    staff: st.modelInfo.value0.model.styles.staff,
                    edges: st.modelInfo.value0.model.styles.edges,
                    notes: st.modelInfo.value0.model.styles.notes,
                    slices: st.modelInfo.value0.model.styles.slices,
                    transitions: st.modelInfo.value0.model.styles.transitions,
                    css: v3.value0
                });
                throw new Error("Failed pattern match at App.Tabs.Style (line 132, column 7 - line 134, column 62): " + [
                    st.modelInfo.constructor.name
                ]);
            });
            if (v3 instanceof $a801f2c896bd09f1$var$StyleActionUpdateStaff) return $a801f2c896bd09f1$var$bind30($a801f2c896bd09f1$var$get4)(function(st) {
                if (st.modelInfo instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure37($a801f2c896bd09f1$var$unit);
                if (st.modelInfo instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$raise({
                    css: st.modelInfo.value0.model.styles.css,
                    edges: st.modelInfo.value0.model.styles.edges,
                    notes: st.modelInfo.value0.model.styles.notes,
                    slices: st.modelInfo.value0.model.styles.slices,
                    transitions: st.modelInfo.value0.model.styles.transitions,
                    staff: v3.value0
                });
                throw new Error("Failed pattern match at App.Tabs.Style (line 137, column 7 - line 139, column 65): " + [
                    st.modelInfo.constructor.name
                ]);
            });
            if (v3 instanceof $a801f2c896bd09f1$var$StyleActionUpdateClasses) {
                var classes = $a801f2c896bd09f1$var$trim(v3.value1);
                return $a801f2c896bd09f1$var$bind30($a801f2c896bd09f1$var$get4)(function(st) {
                    return updateEltStyle(st)(v3.value0)($a801f2c896bd09f1$var$styleSetClasses(classes));
                });
            }
            if (v3 instanceof $a801f2c896bd09f1$var$StyleActionUpdateLabel) {
                var label5 = $a801f2c896bd09f1$var$trim(v3.value1);
                return $a801f2c896bd09f1$var$bind30($a801f2c896bd09f1$var$get4)(function(st) {
                    return updateEltStyle(st)(v3.value0)($a801f2c896bd09f1$var$styleSetLabel(label5));
                });
            }
            if (v3 instanceof $a801f2c896bd09f1$var$StyleActionReceive) return $a801f2c896bd09f1$var$put2(v3.value0);
            throw new Error("Failed pattern match at App.Tabs.Style (line 129, column 23 - line 148, column 44): " + [
                v3.constructor.name
            ]);
        };
    }();
    return $a801f2c896bd09f1$var$mkComponent({
        initialState: initialState,
        render: render,
        "eval": $a801f2c896bd09f1$var$mkEval({
            handleQuery: $a801f2c896bd09f1$var$defaultEval.handleQuery,
            initialize: $a801f2c896bd09f1$var$defaultEval.initialize,
            finalize: $a801f2c896bd09f1$var$defaultEval.finalize,
            handleAction: handleStyleAction,
            receive: function($81) {
                return $a801f2c896bd09f1$var$Just.create($a801f2c896bd09f1$var$StyleActionReceive.create($81));
            }
        })
    });
}();
// output/Halogen.HTML/index.js
var $a801f2c896bd09f1$var$componentSlot2 = /* @__PURE__ */ $a801f2c896bd09f1$var$componentSlot();
var $a801f2c896bd09f1$var$slot_ = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $a801f2c896bd09f1$var$componentSlot2(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot22 = componentSlot1(dictOrd);
            return function(label5) {
                return function(p3) {
                    return function(component) {
                        return function(input3) {
                            return $a801f2c896bd09f1$var$widget(new $a801f2c896bd09f1$var$ComponentSlot(componentSlot22(label5)(p3)(component)(input3)($a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$Nothing.value))));
                        };
                    };
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$slot = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $a801f2c896bd09f1$var$componentSlot2(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot22 = componentSlot1(dictOrd);
            return function(label5) {
                return function(p3) {
                    return function(component) {
                        return function(input3) {
                            return function(outputQuery) {
                                return $a801f2c896bd09f1$var$widget(new $a801f2c896bd09f1$var$ComponentSlot(componentSlot22(label5)(p3)(component)(input3)(function($11) {
                                    return $a801f2c896bd09f1$var$Just.create(outputQuery($11));
                                })));
                            };
                        };
                    };
                };
            };
        };
    };
};
// output/App.Tabs/index.js
var $a801f2c896bd09f1$var$eq28 = /* @__PURE__ */ $a801f2c896bd09f1$var$eq(/* @__PURE__ */ $a801f2c896bd09f1$var$eqMaybe($a801f2c896bd09f1$var$eqTab));
var $a801f2c896bd09f1$var$slot2 = /* @__PURE__ */ $a801f2c896bd09f1$var$slot();
var $a801f2c896bd09f1$var$slot1 = /* @__PURE__ */ $a801f2c896bd09f1$var$slot2({
    reflectSymbol: function() {
        return "importTab";
    }
})($a801f2c896bd09f1$var$ordInt);
var $a801f2c896bd09f1$var$slot_2 = /* @__PURE__ */ $a801f2c896bd09f1$var$slot_();
var $a801f2c896bd09f1$var$slot_1 = /* @__PURE__ */ $a801f2c896bd09f1$var$slot_2({
    reflectSymbol: function() {
        return "exportTab";
    }
})($a801f2c896bd09f1$var$ordInt);
var $a801f2c896bd09f1$var$map51 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$slot22 = /* @__PURE__ */ $a801f2c896bd09f1$var$slot2({
    reflectSymbol: function() {
        return "styleTab";
    }
})($a801f2c896bd09f1$var$ordInt);
var $a801f2c896bd09f1$var$slot3 = /* @__PURE__ */ $a801f2c896bd09f1$var$slot2({
    reflectSymbol: function() {
        return "settingsTab";
    }
})($a801f2c896bd09f1$var$ordInt);
var $a801f2c896bd09f1$var$slot_22 = /* @__PURE__ */ $a801f2c896bd09f1$var$slot_2({
    reflectSymbol: function() {
        return "svgTab";
    }
})($a801f2c896bd09f1$var$ordInt);
var $a801f2c896bd09f1$var$tabHandle = function(st) {
    return function(tab) {
        return function(name17) {
            return $a801f2c896bd09f1$var$li([
                $a801f2c896bd09f1$var$class_2("pure-menu-item" + function() {
                    var $29 = $a801f2c896bd09f1$var$eq28(st.tab)(new $a801f2c896bd09f1$var$Just(tab));
                    if ($29) return " pure-menu-selected";
                    return "";
                }())
            ])([
                $a801f2c896bd09f1$var$a([
                    $a801f2c896bd09f1$var$class_2("pure-menu-link"),
                    $a801f2c896bd09f1$var$onClick(function(v3) {
                        return new $a801f2c896bd09f1$var$SwitchTab(function() {
                            var $30 = $a801f2c896bd09f1$var$eq28(st.tab)(new $a801f2c896bd09f1$var$Just(tab));
                            if ($30) return $a801f2c896bd09f1$var$Nothing.value;
                            return new $a801f2c896bd09f1$var$Just(tab);
                        }());
                    }),
                    $a801f2c896bd09f1$var$href("javascript:;")
                ])([
                    $a801f2c896bd09f1$var$text(name17)
                ])
            ]);
        };
    };
};
var $a801f2c896bd09f1$var$helpText = /* @__PURE__ */ $a801f2c896bd09f1$var$div5([
    /* @__PURE__ */ $a801f2c896bd09f1$var$class_2("content-np tab")
])([
    /* @__PURE__ */ $a801f2c896bd09f1$var$h2_([
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("Manual")
    ]),
    /* @__PURE__ */ $a801f2c896bd09f1$var$p_([
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("This app can be used to create protovoice analyses of pieces.")
    ]),
    /* @__PURE__ */ $a801f2c896bd09f1$var$p_([
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("Load pieces or analyses using the Import tab. Save analyses using the Export tab.")
    ]),
    /* @__PURE__ */ $a801f2c896bd09f1$var$p_([
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("A piece is analyzed by reducing it using outer structure operations. "),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("Reducing a slice creates a 'split' operation, reducing a transition creates a horizontalization. "),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("Select a top-level slice or transition and press Enter to reduce it. "),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("Pressing Backspace removes the operation below the selected slice or transition, if possible. ")
    ]),
    /* @__PURE__ */ $a801f2c896bd09f1$var$p_([
        /* @__PURE__ */ $a801f2c896bd09f1$var$text('The inner structure is determined by providing an "explanation" for every note. '),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("This done by selecting the parent(s) of a note: "),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("Click on a note in a slice below the top-level to select it. "),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("Then hold CTRL and click on a note in one of its parent slices. "),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("For notes that result from a split, you also have to provide the type of operation. "),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("This is automatically determined from to the selected pitches, but can be overriden if desired. "),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("Split notes can have either one (left/right ornament) or two parents (double-parent ornament). "),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text('Double-parent ornaments create new "mandatory edges", which must be used in the next reduction step.'),
        /* @__PURE__ */ $a801f2c896bd09f1$var$text("Correctly reduced notes are shown in grey, unreduced notes are shown in black, and inconsistencies are shown in orange or red.")
    ])
]);
var $a801f2c896bd09f1$var$renderTabs = function(dictMonadEffect) {
    return function(dictMonadAff) {
        var importComponent2 = $a801f2c896bd09f1$var$importComponent(dictMonadAff);
        var MonadEffect0 = dictMonadAff.MonadEffect0();
        var exportComponent2 = $a801f2c896bd09f1$var$exportComponent(MonadEffect0);
        var svgComponent2 = $a801f2c896bd09f1$var$svgComponent(MonadEffect0);
        return function(st) {
            return function(modelInfo) {
                return $a801f2c896bd09f1$var$div_([
                    $a801f2c896bd09f1$var$div5([
                        $a801f2c896bd09f1$var$class_2("content-np pure-menu pure-menu-horizontal")
                    ])([
                        $a801f2c896bd09f1$var$ul([
                            $a801f2c896bd09f1$var$class_2("pure-menu-list")
                        ])([
                            $a801f2c896bd09f1$var$tabHandle(st)($a801f2c896bd09f1$var$ImportTab.value)("Import"),
                            $a801f2c896bd09f1$var$tabHandle(st)($a801f2c896bd09f1$var$ExportTab.value)("Export"),
                            $a801f2c896bd09f1$var$tabHandle(st)($a801f2c896bd09f1$var$SVGTab.value)("SVG"),
                            $a801f2c896bd09f1$var$tabHandle(st)($a801f2c896bd09f1$var$StyleTab.value)("Style"),
                            $a801f2c896bd09f1$var$tabHandle(st)($a801f2c896bd09f1$var$SettingsTab.value)("Settings"),
                            $a801f2c896bd09f1$var$tabHandle(st)($a801f2c896bd09f1$var$HelpTab.value)("Help"),
                            $a801f2c896bd09f1$var$tabHandle(st)($a801f2c896bd09f1$var$DebugTab.value)("Debug")
                        ])
                    ]),
                    function() {
                        if (st.tab instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$text("");
                        if (st.tab instanceof $a801f2c896bd09f1$var$Just && st.tab.value0 instanceof $a801f2c896bd09f1$var$HelpTab) return $a801f2c896bd09f1$var$helpText;
                        if (st.tab instanceof $a801f2c896bd09f1$var$Just && st.tab.value0 instanceof $a801f2c896bd09f1$var$ImportTab) return $a801f2c896bd09f1$var$slot1($a801f2c896bd09f1$var$$$Proxy.value)(1)(importComponent2)($a801f2c896bd09f1$var$unit)($a801f2c896bd09f1$var$HandleImport.create);
                        if (st.tab instanceof $a801f2c896bd09f1$var$Just && st.tab.value0 instanceof $a801f2c896bd09f1$var$ExportTab) return $a801f2c896bd09f1$var$slot_1($a801f2c896bd09f1$var$$$Proxy.value)(0)(exportComponent2)({
                            model: $a801f2c896bd09f1$var$map51(function(v3) {
                                return v3.model;
                            })(st.loaded),
                            name: st.name,
                            selection: st.selected
                        });
                        if (st.tab instanceof $a801f2c896bd09f1$var$Just && st.tab.value0 instanceof $a801f2c896bd09f1$var$StyleTab) return $a801f2c896bd09f1$var$slot22($a801f2c896bd09f1$var$$$Proxy.value)(2)($a801f2c896bd09f1$var$styleComponent)({
                            modelInfo: modelInfo,
                            selection: st.selected
                        })($a801f2c896bd09f1$var$HandleStyle.create);
                        if (st.tab instanceof $a801f2c896bd09f1$var$Just && st.tab.value0 instanceof $a801f2c896bd09f1$var$SettingsTab) return $a801f2c896bd09f1$var$slot3($a801f2c896bd09f1$var$$$Proxy.value)(3)($a801f2c896bd09f1$var$settingsComponent)(st.settings)($a801f2c896bd09f1$var$HandleSettings.create);
                        if (st.tab instanceof $a801f2c896bd09f1$var$Just && st.tab.value0 instanceof $a801f2c896bd09f1$var$SVGTab) {
                            if (modelInfo instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$text("");
                            if (modelInfo instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$slot_22($a801f2c896bd09f1$var$$$Proxy.value)(4)(svgComponent2)({
                                modelInfo: modelInfo.value0,
                                settings: st.settings,
                                name: st.name
                            });
                            throw new Error("Failed pattern match at App.Tabs (line 62, column 24 - line 64, column 143): " + [
                                modelInfo.constructor.name
                            ]);
                        }
                        if (st.tab instanceof $a801f2c896bd09f1$var$Just && st.tab.value0 instanceof $a801f2c896bd09f1$var$DebugTab) return $a801f2c896bd09f1$var$debugComponent(st)(modelInfo);
                        throw new Error("Failed pattern match at App.Tabs (line 55, column 7 - line 65, column 53): " + [
                            st.tab.constructor.name
                        ]);
                    }()
                ]);
            };
        };
    };
};
// output/Effect.Class.Console/index.js
var $a801f2c896bd09f1$var$log4 = function(dictMonadEffect) {
    var $67 = $a801f2c896bd09f1$var$liftEffect(dictMonadEffect);
    return function($68) {
        return $67($a801f2c896bd09f1$var$log2($68));
    };
};
// output/Halogen.Aff.Util/index.js
var $a801f2c896bd09f1$var$bind31 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$liftEffect4 = /* @__PURE__ */ $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectAff);
var $a801f2c896bd09f1$var$bindFlipped9 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindEffect);
var $a801f2c896bd09f1$var$composeKleisliFlipped4 = /* @__PURE__ */ $a801f2c896bd09f1$var$composeKleisliFlipped($a801f2c896bd09f1$var$bindEffect);
var $a801f2c896bd09f1$var$pure38 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeAff);
var $a801f2c896bd09f1$var$bindFlipped1 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$pure113 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$map53 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$selectElement = function(query2) {
    return $a801f2c896bd09f1$var$bind31($a801f2c896bd09f1$var$liftEffect4($a801f2c896bd09f1$var$bindFlipped9($a801f2c896bd09f1$var$composeKleisliFlipped4(function() {
        var $16 = $a801f2c896bd09f1$var$querySelector(query2);
        return function($17) {
            return $16($a801f2c896bd09f1$var$toParentNode($17));
        };
    }())($a801f2c896bd09f1$var$document2))($a801f2c896bd09f1$var$windowImpl)))(function(mel) {
        return $a801f2c896bd09f1$var$pure38($a801f2c896bd09f1$var$bindFlipped1($a801f2c896bd09f1$var$fromElement)(mel));
    });
};
var $a801f2c896bd09f1$var$runHalogenAff = /* @__PURE__ */ $a801f2c896bd09f1$var$runAff_(/* @__PURE__ */ $a801f2c896bd09f1$var$either($a801f2c896bd09f1$var$throwException)(/* @__PURE__ */ $a801f2c896bd09f1$var$$$const(/* @__PURE__ */ $a801f2c896bd09f1$var$pure113($a801f2c896bd09f1$var$unit))));
var $a801f2c896bd09f1$var$awaitLoad = /* @__PURE__ */ $a801f2c896bd09f1$var$makeAff(function(callback) {
    return function __do2() {
        var rs = $a801f2c896bd09f1$var$bindFlipped9($a801f2c896bd09f1$var$readyState)($a801f2c896bd09f1$var$bindFlipped9($a801f2c896bd09f1$var$document2)($a801f2c896bd09f1$var$windowImpl))();
        if (rs instanceof $a801f2c896bd09f1$var$Loading) {
            var et2 = $a801f2c896bd09f1$var$map53($a801f2c896bd09f1$var$toEventTarget3)($a801f2c896bd09f1$var$windowImpl)();
            var listener = $a801f2c896bd09f1$var$eventListener(function(v3) {
                return callback(new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$unit));
            })();
            $a801f2c896bd09f1$var$addEventListener2($a801f2c896bd09f1$var$domcontentloaded)(listener)(false)(et2)();
            return $a801f2c896bd09f1$var$effectCanceler($a801f2c896bd09f1$var$removeEventListener2($a801f2c896bd09f1$var$domcontentloaded)(listener)(false)(et2));
        }
        callback(new $a801f2c896bd09f1$var$Right($a801f2c896bd09f1$var$unit))();
        return $a801f2c896bd09f1$var$nonCanceler;
    };
});
// output/Halogen.Query.Event/index.js
var $a801f2c896bd09f1$var$traverse_4 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_($a801f2c896bd09f1$var$applicativeEffect)($a801f2c896bd09f1$var$foldableMaybe);
var $a801f2c896bd09f1$var$eventListener2 = function(eventType) {
    return function(target6) {
        return function(f2) {
            return $a801f2c896bd09f1$var$makeEmitter(function(push2) {
                return function __do2() {
                    var listener = $a801f2c896bd09f1$var$eventListener(function(ev) {
                        return $a801f2c896bd09f1$var$traverse_4(push2)(f2(ev));
                    })();
                    $a801f2c896bd09f1$var$addEventListener2(eventType)(listener)(false)(target6)();
                    return $a801f2c896bd09f1$var$removeEventListener2(eventType)(listener)(false)(target6);
                };
            });
        };
    };
};
// output/Control.Monad.Fork.Class/index.js
var $a801f2c896bd09f1$var$monadForkAff = {
    suspend: $a801f2c896bd09f1$var$suspendAff,
    fork: $a801f2c896bd09f1$var$forkAff,
    join: $a801f2c896bd09f1$var$joinFiber,
    Monad0: function() {
        return $a801f2c896bd09f1$var$monadAff;
    },
    Functor1: function() {
        return $a801f2c896bd09f1$var$functorFiber;
    }
};
var $a801f2c896bd09f1$var$fork = function(dict) {
    return dict.fork;
};
// output/Halogen.Aff.Driver.State/index.js
var $a801f2c896bd09f1$var$unRenderStateX = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$unDriverStateX = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$renderStateX_ = function(dictApplicative) {
    var traverse_8 = $a801f2c896bd09f1$var$traverse_(dictApplicative)($a801f2c896bd09f1$var$foldableMaybe);
    return function(f2) {
        return $a801f2c896bd09f1$var$unDriverStateX(function(st) {
            return traverse_8(f2)(st.rendering);
        });
    };
};
var $a801f2c896bd09f1$var$mkRenderStateX = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$renderStateX = function(dictFunctor) {
    return function(f2) {
        return $a801f2c896bd09f1$var$unDriverStateX(function(st) {
            return $a801f2c896bd09f1$var$mkRenderStateX(f2(st.rendering));
        });
    };
};
var $a801f2c896bd09f1$var$mkDriverStateXRef = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$mapDriverState = function(f2) {
    return function(v3) {
        return f2(v3);
    };
};
var $a801f2c896bd09f1$var$initDriverState = function(component) {
    return function(input3) {
        return function(handler3) {
            return function(lchs) {
                return function __do2() {
                    var selfRef = $a801f2c896bd09f1$var$$$new({})();
                    var childrenIn = $a801f2c896bd09f1$var$$$new($a801f2c896bd09f1$var$empty5)();
                    var childrenOut = $a801f2c896bd09f1$var$$$new($a801f2c896bd09f1$var$empty5)();
                    var handlerRef = $a801f2c896bd09f1$var$$$new(handler3)();
                    var pendingQueries = $a801f2c896bd09f1$var$$$new(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$Nil.value))();
                    var pendingOuts = $a801f2c896bd09f1$var$$$new(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$Nil.value))();
                    var pendingHandlers = $a801f2c896bd09f1$var$$$new($a801f2c896bd09f1$var$Nothing.value)();
                    var fresh2 = $a801f2c896bd09f1$var$$$new(1)();
                    var subscriptions = $a801f2c896bd09f1$var$$$new(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$empty3))();
                    var forks = $a801f2c896bd09f1$var$$$new($a801f2c896bd09f1$var$empty3)();
                    var ds = {
                        component: component,
                        state: component.initialState(input3),
                        refs: $a801f2c896bd09f1$var$empty3,
                        children: $a801f2c896bd09f1$var$empty5,
                        childrenIn: childrenIn,
                        childrenOut: childrenOut,
                        selfRef: selfRef,
                        handlerRef: handlerRef,
                        pendingQueries: pendingQueries,
                        pendingOuts: pendingOuts,
                        pendingHandlers: pendingHandlers,
                        rendering: $a801f2c896bd09f1$var$Nothing.value,
                        fresh: fresh2,
                        subscriptions: subscriptions,
                        forks: forks,
                        lifecycleHandlers: lchs
                    };
                    $a801f2c896bd09f1$var$write(ds)(selfRef)();
                    return $a801f2c896bd09f1$var$mkDriverStateXRef(selfRef);
                };
            };
        };
    };
};
// output/Halogen.Aff.Driver.Eval/index.js
var $a801f2c896bd09f1$var$traverse_5 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_($a801f2c896bd09f1$var$applicativeEffect)($a801f2c896bd09f1$var$foldableMaybe);
var $a801f2c896bd09f1$var$bindFlipped10 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$lookup10 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordSubscriptionId);
var $a801f2c896bd09f1$var$bind111 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$liftEffect5 = /* @__PURE__ */ $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectAff);
var $a801f2c896bd09f1$var$discard10 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit);
var $a801f2c896bd09f1$var$discard12 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard10($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$traverse_12 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_($a801f2c896bd09f1$var$applicativeAff);
var $a801f2c896bd09f1$var$traverse_22 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_12($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$fork3 = /* @__PURE__ */ $a801f2c896bd09f1$var$fork($a801f2c896bd09f1$var$monadForkAff);
var $a801f2c896bd09f1$var$parSequence_3 = /* @__PURE__ */ $a801f2c896bd09f1$var$parSequence_($a801f2c896bd09f1$var$parallelAff)($a801f2c896bd09f1$var$applicativeParAff)($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$pure39 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeAff);
var $a801f2c896bd09f1$var$map54 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorCoyoneda);
var $a801f2c896bd09f1$var$parallel3 = /* @__PURE__ */ $a801f2c896bd09f1$var$parallel($a801f2c896bd09f1$var$parallelAff);
var $a801f2c896bd09f1$var$map119 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorAff);
var $a801f2c896bd09f1$var$sequential2 = /* @__PURE__ */ $a801f2c896bd09f1$var$sequential($a801f2c896bd09f1$var$parallelAff);
var $a801f2c896bd09f1$var$map214 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$insert15 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert6($a801f2c896bd09f1$var$ordSubscriptionId);
var $a801f2c896bd09f1$var$retractFreeAp2 = /* @__PURE__ */ $a801f2c896bd09f1$var$retractFreeAp($a801f2c896bd09f1$var$applicativeParAff);
var $a801f2c896bd09f1$var$$$delete3 = /* @__PURE__ */ $a801f2c896bd09f1$var$$$delete2($a801f2c896bd09f1$var$ordForkId);
var $a801f2c896bd09f1$var$unlessM2 = /* @__PURE__ */ $a801f2c896bd09f1$var$unlessM($a801f2c896bd09f1$var$monadEffect);
var $a801f2c896bd09f1$var$insert16 = /* @__PURE__ */ $a801f2c896bd09f1$var$insert6($a801f2c896bd09f1$var$ordForkId);
var $a801f2c896bd09f1$var$traverse_32 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_12($a801f2c896bd09f1$var$foldableMaybe);
var $a801f2c896bd09f1$var$lookup14 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordForkId);
var $a801f2c896bd09f1$var$lookup24 = /* @__PURE__ */ $a801f2c896bd09f1$var$lookup3($a801f2c896bd09f1$var$ordString);
var $a801f2c896bd09f1$var$foldFree2 = /* @__PURE__ */ $a801f2c896bd09f1$var$foldFree($a801f2c896bd09f1$var$monadRecAff);
var $a801f2c896bd09f1$var$alter4 = /* @__PURE__ */ $a801f2c896bd09f1$var$alter($a801f2c896bd09f1$var$ordString);
var $a801f2c896bd09f1$var$unsubscribe3 = function(sid) {
    return function(ref3) {
        return function __do2() {
            var v3 = $a801f2c896bd09f1$var$read(ref3)();
            var subs = $a801f2c896bd09f1$var$read(v3.subscriptions)();
            return $a801f2c896bd09f1$var$traverse_5($a801f2c896bd09f1$var$unsubscribe)($a801f2c896bd09f1$var$bindFlipped10($a801f2c896bd09f1$var$lookup10(sid))(subs))();
        };
    };
};
var $a801f2c896bd09f1$var$queueOrRun = function(ref3) {
    return function(au) {
        return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return au;
            if (v3 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$write(new $a801f2c896bd09f1$var$Just(new $a801f2c896bd09f1$var$Cons(au, v3.value0)))(ref3));
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 188, column 33 - line 190, column 57): " + [
                v3.constructor.name
            ]);
        });
    };
};
var $a801f2c896bd09f1$var$handleLifecycle = function(lchs) {
    return function(f2) {
        return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$write({
            initializers: $a801f2c896bd09f1$var$Nil.value,
            finalizers: $a801f2c896bd09f1$var$Nil.value
        })(lchs)))(function() {
            return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5(f2))(function(result2) {
                return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(lchs)))(function(v3) {
                    return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$traverse_22($a801f2c896bd09f1$var$fork3)(v3.finalizers))(function() {
                        return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$parSequence_3(v3.initializers))(function() {
                            return $a801f2c896bd09f1$var$pure39(result2);
                        });
                    });
                });
            });
        });
    };
};
var $a801f2c896bd09f1$var$handleAff = /* @__PURE__ */ $a801f2c896bd09f1$var$runAff_(/* @__PURE__ */ $a801f2c896bd09f1$var$either($a801f2c896bd09f1$var$throwException)(/* @__PURE__ */ $a801f2c896bd09f1$var$$$const(/* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEffect)($a801f2c896bd09f1$var$unit))));
var $a801f2c896bd09f1$var$fresh = function(f2) {
    return function(ref3) {
        return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v3) {
            return $a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$modify$prime(function(i2) {
                return {
                    state: i2 + 1 | 0,
                    value: f2(i2)
                };
            })(v3.fresh));
        });
    };
};
var $a801f2c896bd09f1$var$evalQ = function(render) {
    return function(ref3) {
        return function(q4) {
            return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v3) {
                return $a801f2c896bd09f1$var$evalM(render)(ref3)(v3["component"]["eval"](new $a801f2c896bd09f1$var$Query($a801f2c896bd09f1$var$map54($a801f2c896bd09f1$var$Just.create)($a801f2c896bd09f1$var$liftCoyoneda(q4)), $a801f2c896bd09f1$var$$$const($a801f2c896bd09f1$var$Nothing.value))));
            });
        };
    };
};
var $a801f2c896bd09f1$var$evalM = function(render) {
    return function(initRef) {
        return function(v3) {
            var evalChildQuery = function(ref3) {
                return function(cqb) {
                    return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v1) {
                        return $a801f2c896bd09f1$var$unChildQueryBox(function(v22) {
                            var evalChild = function(v32) {
                                return $a801f2c896bd09f1$var$parallel3($a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(v32)))(function(dsx) {
                                    return $a801f2c896bd09f1$var$unDriverStateX(function(ds) {
                                        return $a801f2c896bd09f1$var$evalQ(render)(ds.selfRef)(v22.value1);
                                    })(dsx);
                                }));
                            };
                            return $a801f2c896bd09f1$var$map119(v22.value2)($a801f2c896bd09f1$var$sequential2(v22.value0($a801f2c896bd09f1$var$applicativeParAff)(evalChild)(v1.children)));
                        })(cqb);
                    });
                };
            };
            var go2 = function(ref3) {
                return function(v1) {
                    if (v1 instanceof $a801f2c896bd09f1$var$State) return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v22) {
                        var v32 = v1.value0(v22.state);
                        if ($a801f2c896bd09f1$var$unsafeRefEq(v22.state)(v32.value1)) return $a801f2c896bd09f1$var$pure39(v32.value0);
                        if ($a801f2c896bd09f1$var$otherwise) return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$write({
                            component: v22.component,
                            refs: v22.refs,
                            children: v22.children,
                            childrenIn: v22.childrenIn,
                            childrenOut: v22.childrenOut,
                            selfRef: v22.selfRef,
                            handlerRef: v22.handlerRef,
                            pendingQueries: v22.pendingQueries,
                            pendingOuts: v22.pendingOuts,
                            pendingHandlers: v22.pendingHandlers,
                            rendering: v22.rendering,
                            fresh: v22.fresh,
                            subscriptions: v22.subscriptions,
                            forks: v22.forks,
                            lifecycleHandlers: v22.lifecycleHandlers,
                            state: v32.value1
                        })(ref3)))(function() {
                            return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$handleLifecycle(v22.lifecycleHandlers)(render(v22.lifecycleHandlers)(ref3)))(function() {
                                return $a801f2c896bd09f1$var$pure39(v32.value0);
                            });
                        });
                        throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 86, column 7 - line 92, column 21): " + [
                            v32.constructor.name
                        ]);
                    });
                    if (v1 instanceof $a801f2c896bd09f1$var$Subscribe) return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$fresh($a801f2c896bd09f1$var$SubscriptionId)(ref3))(function(sid) {
                        return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$subscribe(v1.value0(sid))(function(act) {
                            return $a801f2c896bd09f1$var$handleAff($a801f2c896bd09f1$var$evalF(render)(ref3)(new $a801f2c896bd09f1$var$Action(act)));
                        })))(function(finalize) {
                            return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v22) {
                                return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$modify_($a801f2c896bd09f1$var$map214($a801f2c896bd09f1$var$insert15(sid)(finalize)))(v22.subscriptions)))(function() {
                                    return $a801f2c896bd09f1$var$pure39(v1.value1(sid));
                                });
                            });
                        });
                    });
                    if (v1 instanceof $a801f2c896bd09f1$var$Unsubscribe) return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$unsubscribe3(v1.value0)(ref3)))(function() {
                        return $a801f2c896bd09f1$var$pure39(v1.value1);
                    });
                    if (v1 instanceof $a801f2c896bd09f1$var$Lift2) return v1.value0;
                    if (v1 instanceof $a801f2c896bd09f1$var$ChildQuery2) return evalChildQuery(ref3)(v1.value0);
                    if (v1 instanceof $a801f2c896bd09f1$var$Raise) return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v22) {
                        return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(v22.handlerRef)))(function(handler3) {
                            return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$queueOrRun(v22.pendingOuts)(handler3(v1.value0)))(function() {
                                return $a801f2c896bd09f1$var$pure39(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $a801f2c896bd09f1$var$Par) return $a801f2c896bd09f1$var$sequential2($a801f2c896bd09f1$var$retractFreeAp2($a801f2c896bd09f1$var$hoistFreeAp(function() {
                        var $119 = $a801f2c896bd09f1$var$evalM(render)(ref3);
                        return function($120) {
                            return $a801f2c896bd09f1$var$parallel3($119($120));
                        };
                    }())(v1.value0)));
                    if (v1 instanceof $a801f2c896bd09f1$var$Fork) return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$fresh($a801f2c896bd09f1$var$ForkId)(ref3))(function(fid) {
                        return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v22) {
                            return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$$$new(false)))(function(doneRef) {
                                return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$fork3($a801f2c896bd09f1$var$$$finally($a801f2c896bd09f1$var$liftEffect5(function __do2() {
                                    $a801f2c896bd09f1$var$modify_($a801f2c896bd09f1$var$$$delete3(fid))(v22.forks)();
                                    return $a801f2c896bd09f1$var$write(true)(doneRef)();
                                }))($a801f2c896bd09f1$var$evalM(render)(ref3)(v1.value0))))(function(fiber) {
                                    return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$unlessM2($a801f2c896bd09f1$var$read(doneRef))($a801f2c896bd09f1$var$modify_($a801f2c896bd09f1$var$insert16(fid)(fiber))(v22.forks))))(function() {
                                        return $a801f2c896bd09f1$var$pure39(v1.value1(fid));
                                    });
                                });
                            });
                        });
                    });
                    if (v1 instanceof $a801f2c896bd09f1$var$Join) return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v22) {
                        return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(v22.forks)))(function(forkMap) {
                            return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$traverse_32($a801f2c896bd09f1$var$joinFiber)($a801f2c896bd09f1$var$lookup14(v1.value0)(forkMap)))(function() {
                                return $a801f2c896bd09f1$var$pure39(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $a801f2c896bd09f1$var$Kill) return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v22) {
                        return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(v22.forks)))(function(forkMap) {
                            return $a801f2c896bd09f1$var$discard12($a801f2c896bd09f1$var$traverse_32($a801f2c896bd09f1$var$killFiber($a801f2c896bd09f1$var$error("Cancelled")))($a801f2c896bd09f1$var$lookup14(v1.value0)(forkMap)))(function() {
                                return $a801f2c896bd09f1$var$pure39(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $a801f2c896bd09f1$var$GetRef) return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v22) {
                        return $a801f2c896bd09f1$var$pure39(v1.value1($a801f2c896bd09f1$var$lookup24(v1.value0)(v22.refs)));
                    });
                    throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 83, column 12 - line 139, column 33): " + [
                        v1.constructor.name
                    ]);
                };
            };
            return $a801f2c896bd09f1$var$foldFree2(go2(initRef))(v3);
        };
    };
};
var $a801f2c896bd09f1$var$evalF = function(render) {
    return function(ref3) {
        return function(v3) {
            if (v3 instanceof $a801f2c896bd09f1$var$RefUpdate) return $a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$modify_)(ref3)($a801f2c896bd09f1$var$mapDriverState(function(st) {
                return {
                    component: st.component,
                    state: st.state,
                    children: st.children,
                    childrenIn: st.childrenIn,
                    childrenOut: st.childrenOut,
                    selfRef: st.selfRef,
                    handlerRef: st.handlerRef,
                    pendingQueries: st.pendingQueries,
                    pendingOuts: st.pendingOuts,
                    pendingHandlers: st.pendingHandlers,
                    rendering: st.rendering,
                    fresh: st.fresh,
                    subscriptions: st.subscriptions,
                    forks: st.forks,
                    lifecycleHandlers: st.lifecycleHandlers,
                    refs: $a801f2c896bd09f1$var$alter4($a801f2c896bd09f1$var$$$const(v3.value1))(v3.value0)(st.refs)
                };
            })));
            if (v3 instanceof $a801f2c896bd09f1$var$Action) return $a801f2c896bd09f1$var$bind111($a801f2c896bd09f1$var$liftEffect5($a801f2c896bd09f1$var$read(ref3)))(function(v1) {
                return $a801f2c896bd09f1$var$evalM(render)(ref3)(v1["component"]["eval"](new $a801f2c896bd09f1$var$Action2(v3.value0, $a801f2c896bd09f1$var$unit)));
            });
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 52, column 20 - line 58, column 62): " + [
                v3.constructor.name
            ]);
        };
    };
};
// output/Halogen.Aff.Driver/index.js
var $a801f2c896bd09f1$var$bind34 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindEffect);
var $a801f2c896bd09f1$var$discard11 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit);
var $a801f2c896bd09f1$var$for_3 = /* @__PURE__ */ $a801f2c896bd09f1$var$for_($a801f2c896bd09f1$var$applicativeEffect)($a801f2c896bd09f1$var$foldableMaybe);
var $a801f2c896bd09f1$var$traverse_6 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_($a801f2c896bd09f1$var$applicativeAff)($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$fork4 = /* @__PURE__ */ $a801f2c896bd09f1$var$fork($a801f2c896bd09f1$var$monadForkAff);
var $a801f2c896bd09f1$var$bindFlipped11 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindEffect);
var $a801f2c896bd09f1$var$traverse_13 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$traverse_23 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_13($a801f2c896bd09f1$var$foldableMaybe);
var $a801f2c896bd09f1$var$traverse_33 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_13($a801f2c896bd09f1$var$foldableMap);
var $a801f2c896bd09f1$var$discard24 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard11($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$parSequence_4 = /* @__PURE__ */ $a801f2c896bd09f1$var$parSequence_($a801f2c896bd09f1$var$parallelAff)($a801f2c896bd09f1$var$applicativeParAff)($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$liftEffect6 = /* @__PURE__ */ $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectAff);
var $a801f2c896bd09f1$var$pure40 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$map55 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$pure114 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeAff);
var $a801f2c896bd09f1$var$when3 = /* @__PURE__ */ $a801f2c896bd09f1$var$when($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$renderStateX2 = /* @__PURE__ */ $a801f2c896bd09f1$var$renderStateX($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$$$void6 = /* @__PURE__ */ $a801f2c896bd09f1$var$$$void($a801f2c896bd09f1$var$functorAff);
var $a801f2c896bd09f1$var$foreachSlot2 = /* @__PURE__ */ $a801f2c896bd09f1$var$foreachSlot($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$renderStateX_2 = /* @__PURE__ */ $a801f2c896bd09f1$var$renderStateX_($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$tailRecM4 = /* @__PURE__ */ $a801f2c896bd09f1$var$tailRecM($a801f2c896bd09f1$var$monadRecEffect);
var $a801f2c896bd09f1$var$voidLeft3 = /* @__PURE__ */ $a801f2c896bd09f1$var$voidLeft($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$bind112 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$liftEffect1 = /* @__PURE__ */ $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectEffect);
var $a801f2c896bd09f1$var$newLifecycleHandlers = /* @__PURE__ */ function() {
    return $a801f2c896bd09f1$var$$$new({
        initializers: $a801f2c896bd09f1$var$Nil.value,
        finalizers: $a801f2c896bd09f1$var$Nil.value
    });
}();
var $a801f2c896bd09f1$var$handlePending = function(ref3) {
    return function __do2() {
        var queue = $a801f2c896bd09f1$var$read(ref3)();
        $a801f2c896bd09f1$var$write($a801f2c896bd09f1$var$Nothing.value)(ref3)();
        return $a801f2c896bd09f1$var$for_3(queue)(function() {
            var $59 = $a801f2c896bd09f1$var$traverse_6($a801f2c896bd09f1$var$fork4);
            return function($60) {
                return $a801f2c896bd09f1$var$handleAff($59($a801f2c896bd09f1$var$reverse($60)));
            };
        }())();
    };
};
var $a801f2c896bd09f1$var$cleanupSubscriptionsAndForks = function(v3) {
    return function __do2() {
        $a801f2c896bd09f1$var$bindFlipped11($a801f2c896bd09f1$var$traverse_23($a801f2c896bd09f1$var$traverse_33($a801f2c896bd09f1$var$unsubscribe)))($a801f2c896bd09f1$var$read(v3.subscriptions))();
        $a801f2c896bd09f1$var$write($a801f2c896bd09f1$var$Nothing.value)(v3.subscriptions)();
        $a801f2c896bd09f1$var$bindFlipped11($a801f2c896bd09f1$var$traverse_33(function() {
            var $61 = $a801f2c896bd09f1$var$killFiber($a801f2c896bd09f1$var$error("finalized"));
            return function($62) {
                return $a801f2c896bd09f1$var$handleAff($61($62));
            };
        }()))($a801f2c896bd09f1$var$read(v3.forks))();
        return $a801f2c896bd09f1$var$write($a801f2c896bd09f1$var$empty3)(v3.forks)();
    };
};
var $a801f2c896bd09f1$var$runUI = function(renderSpec2) {
    return function(component) {
        return function(i2) {
            var squashChildInitializers = function(lchs) {
                return function(preInits) {
                    return $a801f2c896bd09f1$var$unDriverStateX(function(st) {
                        var parentInitializer = $a801f2c896bd09f1$var$evalM(render)(st.selfRef)(st["component"]["eval"](new $a801f2c896bd09f1$var$Initialize($a801f2c896bd09f1$var$unit)));
                        return $a801f2c896bd09f1$var$modify_(function(handlers) {
                            return {
                                initializers: new $a801f2c896bd09f1$var$Cons($a801f2c896bd09f1$var$discard24($a801f2c896bd09f1$var$parSequence_4($a801f2c896bd09f1$var$reverse(handlers.initializers)))(function() {
                                    return $a801f2c896bd09f1$var$discard24(parentInitializer)(function() {
                                        return $a801f2c896bd09f1$var$liftEffect6(function __do2() {
                                            $a801f2c896bd09f1$var$handlePending(st.pendingQueries)();
                                            return $a801f2c896bd09f1$var$handlePending(st.pendingOuts)();
                                        });
                                    });
                                }), preInits),
                                finalizers: handlers.finalizers
                            };
                        })(lchs);
                    });
                };
            };
            var runComponent = function(lchs) {
                return function(handler3) {
                    return function(j2) {
                        return $a801f2c896bd09f1$var$unComponent(function(c3) {
                            return function __do2() {
                                var lchs$prime = $a801f2c896bd09f1$var$newLifecycleHandlers();
                                var $$var2 = $a801f2c896bd09f1$var$initDriverState(c3)(j2)(handler3)(lchs$prime)();
                                var pre2 = $a801f2c896bd09f1$var$read(lchs)();
                                $a801f2c896bd09f1$var$write({
                                    initializers: $a801f2c896bd09f1$var$Nil.value,
                                    finalizers: pre2.finalizers
                                })(lchs)();
                                $a801f2c896bd09f1$var$bindFlipped11($a801f2c896bd09f1$var$unDriverStateX(function() {
                                    var $63 = render(lchs);
                                    return function($64) {
                                        return $63(function(v3) {
                                            return v3.selfRef;
                                        }($64));
                                    };
                                }()))($a801f2c896bd09f1$var$read($$var2))();
                                $a801f2c896bd09f1$var$bindFlipped11(squashChildInitializers(lchs)(pre2.initializers))($a801f2c896bd09f1$var$read($$var2))();
                                return $$var2;
                            };
                        });
                    };
                };
            };
            var renderChild = function(lchs) {
                return function(handler3) {
                    return function(childrenInRef) {
                        return function(childrenOutRef) {
                            return $a801f2c896bd09f1$var$unComponentSlot(function(slot4) {
                                return function __do2() {
                                    var childrenIn = $a801f2c896bd09f1$var$map55(slot4.pop)($a801f2c896bd09f1$var$read(childrenInRef))();
                                    var $$var2 = function() {
                                        if (childrenIn instanceof $a801f2c896bd09f1$var$Just) {
                                            $a801f2c896bd09f1$var$write(childrenIn.value0.value1)(childrenInRef)();
                                            var dsx = $a801f2c896bd09f1$var$read(childrenIn.value0.value0)();
                                            $a801f2c896bd09f1$var$unDriverStateX(function(st) {
                                                return function __do3() {
                                                    $a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$write)(st.handlerRef)(function() {
                                                        var $65 = $a801f2c896bd09f1$var$maybe($a801f2c896bd09f1$var$pure114($a801f2c896bd09f1$var$unit))(handler3);
                                                        return function($66) {
                                                            return $65(slot4.output($66));
                                                        };
                                                    }())();
                                                    return $a801f2c896bd09f1$var$handleAff($a801f2c896bd09f1$var$evalM(render)(st.selfRef)(st["component"]["eval"](new $a801f2c896bd09f1$var$Receive(slot4.input, $a801f2c896bd09f1$var$unit))))();
                                                };
                                            })(dsx)();
                                            return childrenIn.value0.value0;
                                        }
                                        if (childrenIn instanceof $a801f2c896bd09f1$var$Nothing) return runComponent(lchs)(function() {
                                            var $67 = $a801f2c896bd09f1$var$maybe($a801f2c896bd09f1$var$pure114($a801f2c896bd09f1$var$unit))(handler3);
                                            return function($68) {
                                                return $67(slot4.output($68));
                                            };
                                        }())(slot4.input)(slot4.component)();
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 213, column 14 - line 222, column 98): " + [
                                            childrenIn.constructor.name
                                        ]);
                                    }();
                                    var isDuplicate = $a801f2c896bd09f1$var$map55(function($69) {
                                        return $a801f2c896bd09f1$var$isJust(slot4.get($69));
                                    })($a801f2c896bd09f1$var$read(childrenOutRef))();
                                    $a801f2c896bd09f1$var$when3(isDuplicate)($a801f2c896bd09f1$var$warn("Halogen: Duplicate slot address was detected during rendering, unexpected results may occur"))();
                                    $a801f2c896bd09f1$var$modify_(slot4.set($$var2))(childrenOutRef)();
                                    return $a801f2c896bd09f1$var$bind34($a801f2c896bd09f1$var$read($$var2))($a801f2c896bd09f1$var$renderStateX2(function(v3) {
                                        if (v3 instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$$$throw("Halogen internal error: child was not initialized in renderChild");
                                        if (v3 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$pure40(renderSpec2.renderChild(v3.value0));
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 227, column 37 - line 229, column 50): " + [
                                            v3.constructor.name
                                        ]);
                                    }))();
                                };
                            });
                        };
                    };
                };
            };
            var render = function(lchs) {
                return function($$var2) {
                    return function __do2() {
                        var v3 = $a801f2c896bd09f1$var$read($$var2)();
                        var shouldProcessHandlers = $a801f2c896bd09f1$var$map55($a801f2c896bd09f1$var$isNothing)($a801f2c896bd09f1$var$read(v3.pendingHandlers))();
                        $a801f2c896bd09f1$var$when3(shouldProcessHandlers)($a801f2c896bd09f1$var$write(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$Nil.value))(v3.pendingHandlers))();
                        $a801f2c896bd09f1$var$write($a801f2c896bd09f1$var$empty5)(v3.childrenOut)();
                        $a801f2c896bd09f1$var$write(v3.children)(v3.childrenIn)();
                        var handler3 = function() {
                            var $70 = $a801f2c896bd09f1$var$queueOrRun(v3.pendingHandlers);
                            var $71 = $a801f2c896bd09f1$var$evalF(render)(v3.selfRef);
                            return function($72) {
                                return $70($a801f2c896bd09f1$var$$$void6($71($72)));
                            };
                        }();
                        var childHandler = function() {
                            var $73 = $a801f2c896bd09f1$var$queueOrRun(v3.pendingQueries);
                            return function($74) {
                                return $73(handler3($a801f2c896bd09f1$var$Action.create($74)));
                            };
                        }();
                        var rendering = renderSpec2.render(function($75) {
                            return $a801f2c896bd09f1$var$handleAff(handler3($75));
                        })(renderChild(lchs)(childHandler)(v3.childrenIn)(v3.childrenOut))(v3.component.render(v3.state))(v3.rendering)();
                        var children2 = $a801f2c896bd09f1$var$read(v3.childrenOut)();
                        var childrenIn = $a801f2c896bd09f1$var$read(v3.childrenIn)();
                        $a801f2c896bd09f1$var$foreachSlot2(childrenIn)(function(v1) {
                            return function __do3() {
                                var childDS = $a801f2c896bd09f1$var$read(v1)();
                                $a801f2c896bd09f1$var$renderStateX_2(renderSpec2.removeChild)(childDS)();
                                return finalize(lchs)(childDS)();
                            };
                        })();
                        $a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$modify_)(v3.selfRef)($a801f2c896bd09f1$var$mapDriverState(function(ds$prime) {
                            return {
                                component: ds$prime.component,
                                state: ds$prime.state,
                                refs: ds$prime.refs,
                                childrenIn: ds$prime.childrenIn,
                                childrenOut: ds$prime.childrenOut,
                                selfRef: ds$prime.selfRef,
                                handlerRef: ds$prime.handlerRef,
                                pendingQueries: ds$prime.pendingQueries,
                                pendingOuts: ds$prime.pendingOuts,
                                pendingHandlers: ds$prime.pendingHandlers,
                                fresh: ds$prime.fresh,
                                subscriptions: ds$prime.subscriptions,
                                forks: ds$prime.forks,
                                lifecycleHandlers: ds$prime.lifecycleHandlers,
                                rendering: new $a801f2c896bd09f1$var$Just(rendering),
                                children: children2
                            };
                        }))();
                        return $a801f2c896bd09f1$var$when3(shouldProcessHandlers)($a801f2c896bd09f1$var$flip($a801f2c896bd09f1$var$tailRecM4)($a801f2c896bd09f1$var$unit)(function(v1) {
                            return function __do3() {
                                var handlers = $a801f2c896bd09f1$var$read(v3.pendingHandlers)();
                                $a801f2c896bd09f1$var$write(new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$Nil.value))(v3.pendingHandlers)();
                                $a801f2c896bd09f1$var$traverse_23(function() {
                                    var $76 = $a801f2c896bd09f1$var$traverse_6($a801f2c896bd09f1$var$fork4);
                                    return function($77) {
                                        return $a801f2c896bd09f1$var$handleAff($76($a801f2c896bd09f1$var$reverse($77)));
                                    };
                                }())(handlers)();
                                var mmore = $a801f2c896bd09f1$var$read(v3.pendingHandlers)();
                                var $52 = $a801f2c896bd09f1$var$maybe(false)($a801f2c896bd09f1$var$$$null)(mmore);
                                if ($52) return $a801f2c896bd09f1$var$voidLeft3($a801f2c896bd09f1$var$write($a801f2c896bd09f1$var$Nothing.value)(v3.pendingHandlers))(new $a801f2c896bd09f1$var$Done($a801f2c896bd09f1$var$unit))();
                                return new $a801f2c896bd09f1$var$Loop($a801f2c896bd09f1$var$unit);
                            };
                        }))();
                    };
                };
            };
            var finalize = function(lchs) {
                return $a801f2c896bd09f1$var$unDriverStateX(function(st) {
                    return function __do2() {
                        $a801f2c896bd09f1$var$cleanupSubscriptionsAndForks(st)();
                        var f2 = $a801f2c896bd09f1$var$evalM(render)(st.selfRef)(st["component"]["eval"](new $a801f2c896bd09f1$var$Finalize($a801f2c896bd09f1$var$unit)));
                        $a801f2c896bd09f1$var$modify_(function(handlers) {
                            return {
                                initializers: handlers.initializers,
                                finalizers: new $a801f2c896bd09f1$var$Cons(f2, handlers.finalizers)
                            };
                        })(lchs)();
                        return $a801f2c896bd09f1$var$foreachSlot2(st.children)(function(v3) {
                            return function __do3() {
                                var dsx = $a801f2c896bd09f1$var$read(v3)();
                                return finalize(lchs)(dsx)();
                            };
                        })();
                    };
                });
            };
            var evalDriver = function(disposed) {
                return function(ref3) {
                    return function(q4) {
                        return $a801f2c896bd09f1$var$bind112($a801f2c896bd09f1$var$liftEffect6($a801f2c896bd09f1$var$read(disposed)))(function(v3) {
                            if (v3) return $a801f2c896bd09f1$var$pure114($a801f2c896bd09f1$var$Nothing.value);
                            return $a801f2c896bd09f1$var$evalQ(render)(ref3)(q4);
                        });
                    };
                };
            };
            var dispose = function(disposed) {
                return function(lchs) {
                    return function(dsx) {
                        return $a801f2c896bd09f1$var$handleLifecycle(lchs)(function __do2() {
                            var v3 = $a801f2c896bd09f1$var$read(disposed)();
                            if (v3) return $a801f2c896bd09f1$var$unit;
                            $a801f2c896bd09f1$var$write(true)(disposed)();
                            finalize(lchs)(dsx)();
                            return $a801f2c896bd09f1$var$unDriverStateX(function(v1) {
                                return function __do3() {
                                    var v22 = $a801f2c896bd09f1$var$liftEffect1($a801f2c896bd09f1$var$read(v1.selfRef))();
                                    return $a801f2c896bd09f1$var$for_3(v22.rendering)(renderSpec2.dispose)();
                                };
                            })(dsx)();
                        });
                    };
                };
            };
            return $a801f2c896bd09f1$var$bind112($a801f2c896bd09f1$var$liftEffect6($a801f2c896bd09f1$var$newLifecycleHandlers))(function(lchs) {
                return $a801f2c896bd09f1$var$bind112($a801f2c896bd09f1$var$liftEffect6($a801f2c896bd09f1$var$$$new(false)))(function(disposed) {
                    return $a801f2c896bd09f1$var$handleLifecycle(lchs)(function __do2() {
                        var sio = $a801f2c896bd09f1$var$create();
                        var dsx = $a801f2c896bd09f1$var$bindFlipped11($a801f2c896bd09f1$var$read)(runComponent(lchs)(function() {
                            var $78 = $a801f2c896bd09f1$var$notify(sio.listener);
                            return function($79) {
                                return $a801f2c896bd09f1$var$liftEffect6($78($79));
                            };
                        }())(i2)(component))();
                        return $a801f2c896bd09f1$var$unDriverStateX(function(st) {
                            return $a801f2c896bd09f1$var$pure40({
                                query: evalDriver(disposed)(st.selfRef),
                                messages: sio.emitter,
                                dispose: dispose(disposed)(lchs)(dsx)
                            });
                        })(dsx)();
                    });
                });
            });
        };
    };
};
// output/Web.DOM.Node/foreign.js
var $a801f2c896bd09f1$var$getEffProp2 = function(name17) {
    return function(node) {
        return function() {
            return node[name17];
        };
    };
};
var $a801f2c896bd09f1$var$baseURI = $a801f2c896bd09f1$var$getEffProp2("baseURI");
var $a801f2c896bd09f1$var$_ownerDocument = $a801f2c896bd09f1$var$getEffProp2("ownerDocument");
var $a801f2c896bd09f1$var$_parentNode = $a801f2c896bd09f1$var$getEffProp2("parentNode");
var $a801f2c896bd09f1$var$_parentElement = $a801f2c896bd09f1$var$getEffProp2("parentElement");
var $a801f2c896bd09f1$var$childNodes = $a801f2c896bd09f1$var$getEffProp2("childNodes");
var $a801f2c896bd09f1$var$_firstChild = $a801f2c896bd09f1$var$getEffProp2("firstChild");
var $a801f2c896bd09f1$var$_lastChild = $a801f2c896bd09f1$var$getEffProp2("lastChild");
var $a801f2c896bd09f1$var$_previousSibling = $a801f2c896bd09f1$var$getEffProp2("previousSibling");
var $a801f2c896bd09f1$var$_nextSibling = $a801f2c896bd09f1$var$getEffProp2("nextSibling");
var $a801f2c896bd09f1$var$_nodeValue = $a801f2c896bd09f1$var$getEffProp2("nodeValue");
var $a801f2c896bd09f1$var$textContent = $a801f2c896bd09f1$var$getEffProp2("textContent");
function $a801f2c896bd09f1$var$insertBefore(node1) {
    return function(node2) {
        return function(parent2) {
            return function() {
                parent2.insertBefore(node1, node2);
            };
        };
    };
}
function $a801f2c896bd09f1$var$appendChild(node) {
    return function(parent2) {
        return function() {
            parent2.appendChild(node);
        };
    };
}
function $a801f2c896bd09f1$var$removeChild2(node) {
    return function(parent2) {
        return function() {
            parent2.removeChild(node);
        };
    };
}
// output/Web.DOM.Node/index.js
var $a801f2c896bd09f1$var$map56 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$parentNode2 = /* @__PURE__ */ function() {
    var $6 = $a801f2c896bd09f1$var$map56($a801f2c896bd09f1$var$toMaybe);
    return function($7) {
        return $6($a801f2c896bd09f1$var$_parentNode($7));
    };
}();
var $a801f2c896bd09f1$var$nextSibling = /* @__PURE__ */ function() {
    var $15 = $a801f2c896bd09f1$var$map56($a801f2c896bd09f1$var$toMaybe);
    return function($16) {
        return $15($a801f2c896bd09f1$var$_nextSibling($16));
    };
}();
// output/Halogen.VDom.Driver/index.js
var $a801f2c896bd09f1$var$$runtime_lazy11 = function(name17, moduleName, init3) {
    var state3 = 0;
    var val;
    return function(lineNumber) {
        if (state3 === 2) return val;
        if (state3 === 1) throw new ReferenceError(name17 + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state3 = 1;
        val = init3();
        state3 = 2;
        return val;
    };
};
var $a801f2c896bd09f1$var$$$void7 = /* @__PURE__ */ $a801f2c896bd09f1$var$$$void($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$pure41 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$traverse_7 = /* @__PURE__ */ $a801f2c896bd09f1$var$traverse_($a801f2c896bd09f1$var$applicativeEffect)($a801f2c896bd09f1$var$foldableMaybe);
var $a801f2c896bd09f1$var$unwrap4 = /* @__PURE__ */ $a801f2c896bd09f1$var$unwrap();
var $a801f2c896bd09f1$var$when4 = /* @__PURE__ */ $a801f2c896bd09f1$var$when($a801f2c896bd09f1$var$applicativeEffect);
var $a801f2c896bd09f1$var$not2 = /* @__PURE__ */ $a801f2c896bd09f1$var$not(/* @__PURE__ */ $a801f2c896bd09f1$var$heytingAlgebraFunction(/* @__PURE__ */ $a801f2c896bd09f1$var$heytingAlgebraFunction($a801f2c896bd09f1$var$heytingAlgebraBoolean)));
var $a801f2c896bd09f1$var$identity14 = /* @__PURE__ */ $a801f2c896bd09f1$var$identity($a801f2c896bd09f1$var$categoryFn);
var $a801f2c896bd09f1$var$bind113 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$liftEffect7 = /* @__PURE__ */ $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectAff);
var $a801f2c896bd09f1$var$map57 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorEffect);
var $a801f2c896bd09f1$var$bindFlipped12 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindEffect);
var $a801f2c896bd09f1$var$substInParent = function(v3) {
    return function(v1) {
        return function(v22) {
            if (v1 instanceof $a801f2c896bd09f1$var$Just && v22 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$$$void7($a801f2c896bd09f1$var$insertBefore(v3)(v1.value0)(v22.value0));
            if (v1 instanceof $a801f2c896bd09f1$var$Nothing && v22 instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$$$void7($a801f2c896bd09f1$var$appendChild(v3)(v22.value0));
            return $a801f2c896bd09f1$var$pure41($a801f2c896bd09f1$var$unit);
        };
    };
};
var $a801f2c896bd09f1$var$removeChild3 = function(v3) {
    return function __do2() {
        var npn = $a801f2c896bd09f1$var$parentNode2(v3.node)();
        return $a801f2c896bd09f1$var$traverse_7(function(pn) {
            return $a801f2c896bd09f1$var$removeChild2(v3.node)(pn);
        })(npn)();
    };
};
var $a801f2c896bd09f1$var$mkSpec = function(handler3) {
    return function(renderChildRef) {
        return function(document3) {
            var getNode = $a801f2c896bd09f1$var$unRenderStateX(function(v3) {
                return v3.node;
            });
            var done = function(st) {
                if (st instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$halt(st.value0);
                return $a801f2c896bd09f1$var$unit;
            };
            var buildWidget2 = function(spec) {
                var buildThunk2 = $a801f2c896bd09f1$var$buildThunk($a801f2c896bd09f1$var$unwrap4)(spec);
                var $lazy_patch = $a801f2c896bd09f1$var$$runtime_lazy11("patch", "Halogen.VDom.Driver", function() {
                    return function(st, slot4) {
                        if (st instanceof $a801f2c896bd09f1$var$Just) {
                            if (slot4 instanceof $a801f2c896bd09f1$var$ComponentSlot) {
                                $a801f2c896bd09f1$var$halt(st.value0);
                                return $lazy_renderComponentSlot(100)(slot4.value0);
                            }
                            if (slot4 instanceof $a801f2c896bd09f1$var$ThunkSlot) {
                                var step$prime = $a801f2c896bd09f1$var$step(st.value0, slot4.value0);
                                return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2($a801f2c896bd09f1$var$extract2(step$prime), new $a801f2c896bd09f1$var$Just(step$prime), $lazy_patch(103), done));
                            }
                            throw new Error("Failed pattern match at Halogen.VDom.Driver (line 97, column 22 - line 103, column 79): " + [
                                slot4.constructor.name
                            ]);
                        }
                        return $lazy_render(104)(slot4);
                    };
                });
                var $lazy_render = $a801f2c896bd09f1$var$$runtime_lazy11("render", "Halogen.VDom.Driver", function() {
                    return function(slot4) {
                        if (slot4 instanceof $a801f2c896bd09f1$var$ComponentSlot) return $lazy_renderComponentSlot(86)(slot4.value0);
                        if (slot4 instanceof $a801f2c896bd09f1$var$ThunkSlot) {
                            var step4 = buildThunk2(slot4.value0);
                            return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2($a801f2c896bd09f1$var$extract2(step4), new $a801f2c896bd09f1$var$Just(step4), $lazy_patch(89), done));
                        }
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 84, column 7 - line 89, column 75): " + [
                            slot4.constructor.name
                        ]);
                    };
                });
                var $lazy_renderComponentSlot = $a801f2c896bd09f1$var$$runtime_lazy11("renderComponentSlot", "Halogen.VDom.Driver", function() {
                    return function(cs) {
                        var renderChild = $a801f2c896bd09f1$var$read(renderChildRef)();
                        var rsx = renderChild(cs)();
                        var node = getNode(rsx);
                        return $a801f2c896bd09f1$var$mkStep(new $a801f2c896bd09f1$var$Step2(node, $a801f2c896bd09f1$var$Nothing.value, $lazy_patch(117), done));
                    };
                });
                var patch = $lazy_patch(91);
                var render = $lazy_render(82);
                var renderComponentSlot = $lazy_renderComponentSlot(109);
                return render;
            };
            var buildAttributes = $a801f2c896bd09f1$var$buildProp(handler3);
            return {
                buildWidget: buildWidget2,
                buildAttributes: buildAttributes,
                document: document3
            };
        };
    };
};
var $a801f2c896bd09f1$var$renderSpec = function(document3) {
    return function(container) {
        var render = function(handler3) {
            return function(child) {
                return function(v3) {
                    return function(v1) {
                        if (v1 instanceof $a801f2c896bd09f1$var$Nothing) return function __do2() {
                            var renderChildRef = $a801f2c896bd09f1$var$$$new(child)();
                            var spec = $a801f2c896bd09f1$var$mkSpec(handler3)(renderChildRef)(document3);
                            var machine = $a801f2c896bd09f1$var$buildVDom(spec)(v3);
                            var node = $a801f2c896bd09f1$var$extract2(machine);
                            $a801f2c896bd09f1$var$$$void7($a801f2c896bd09f1$var$appendChild(node)($a801f2c896bd09f1$var$toNode2(container)))();
                            return {
                                machine: machine,
                                node: node,
                                renderChildRef: renderChildRef
                            };
                        };
                        if (v1 instanceof $a801f2c896bd09f1$var$Just) return function __do2() {
                            $a801f2c896bd09f1$var$write(child)(v1.value0.renderChildRef)();
                            var parent2 = $a801f2c896bd09f1$var$parentNode2(v1.value0.node)();
                            var nextSib = $a801f2c896bd09f1$var$nextSibling(v1.value0.node)();
                            var machine$prime = $a801f2c896bd09f1$var$step(v1.value0.machine, v3);
                            var newNode = $a801f2c896bd09f1$var$extract2(machine$prime);
                            $a801f2c896bd09f1$var$when4($a801f2c896bd09f1$var$not2($a801f2c896bd09f1$var$unsafeRefEq)(v1.value0.node)(newNode))($a801f2c896bd09f1$var$substInParent(newNode)(nextSib)(parent2))();
                            return {
                                machine: machine$prime,
                                node: newNode,
                                renderChildRef: v1.value0.renderChildRef
                            };
                        };
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 157, column 5 - line 173, column 80): " + [
                            v1.constructor.name
                        ]);
                    };
                };
            };
        };
        return {
            render: render,
            renderChild: $a801f2c896bd09f1$var$identity14,
            removeChild: $a801f2c896bd09f1$var$removeChild3,
            dispose: $a801f2c896bd09f1$var$removeChild3
        };
    };
};
var $a801f2c896bd09f1$var$runUI2 = function(component) {
    return function(i2) {
        return function(element4) {
            return $a801f2c896bd09f1$var$bind113($a801f2c896bd09f1$var$liftEffect7($a801f2c896bd09f1$var$map57($a801f2c896bd09f1$var$toDocument)($a801f2c896bd09f1$var$bindFlipped12($a801f2c896bd09f1$var$document2)($a801f2c896bd09f1$var$windowImpl))))(function(document3) {
                return $a801f2c896bd09f1$var$runUI($a801f2c896bd09f1$var$renderSpec(document3)(element4))(component)(i2);
            });
        };
    };
};
// output/Web.UIEvent.KeyboardEvent/foreign.js
function $a801f2c896bd09f1$var$key(e) {
    return e.key;
}
// output/Web.UIEvent.KeyboardEvent/index.js
var $a801f2c896bd09f1$var$toEvent = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$fromEvent = /* @__PURE__ */ $a801f2c896bd09f1$var$unsafeReadProtoTagged("KeyboardEvent");
// output/Web.UIEvent.WheelEvent/foreign.js
function $a801f2c896bd09f1$var$deltaY(e) {
    return e.deltaY;
}
// output/Web.UIEvent.WheelEvent/index.js
var $a801f2c896bd09f1$var$toMouseEvent = $a801f2c896bd09f1$var$unsafeCoerce2;
var $a801f2c896bd09f1$var$toEvent2 = $a801f2c896bd09f1$var$unsafeCoerce2;
// output/App.Main/index.js
var $a801f2c896bd09f1$var$bind35 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$get5 = /* @__PURE__ */ $a801f2c896bd09f1$var$get($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$when5 = /* @__PURE__ */ $a801f2c896bd09f1$var$when($a801f2c896bd09f1$var$applicativeHalogenM);
var $a801f2c896bd09f1$var$bind114 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindMaybe);
var $a801f2c896bd09f1$var$elem4 = /* @__PURE__ */ $a801f2c896bd09f1$var$elem2($a801f2c896bd09f1$var$eqSliceId);
var $a801f2c896bd09f1$var$pitchIsSymbol6 = {
    reflectSymbol: function() {
        return "pitch";
    }
};
var $a801f2c896bd09f1$var$idIsSymbol6 = {
    reflectSymbol: function() {
        return "id";
    }
};
var $a801f2c896bd09f1$var$elem1 = /* @__PURE__ */ $a801f2c896bd09f1$var$elem2(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRec()(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons(/* @__PURE__ */ $a801f2c896bd09f1$var$eqRowCons($a801f2c896bd09f1$var$eqRowNil)()($a801f2c896bd09f1$var$pitchIsSymbol6)(/* @__PURE__ */ $a801f2c896bd09f1$var$eqPitch($a801f2c896bd09f1$var$eqSInterval)))()($a801f2c896bd09f1$var$idIsSymbol6)($a801f2c896bd09f1$var$eqString)));
var $a801f2c896bd09f1$var$map58 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorArray);
var $a801f2c896bd09f1$var$fromFoldable16 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableMap);
var $a801f2c896bd09f1$var$fromFoldable17 = /* @__PURE__ */ $a801f2c896bd09f1$var$fromFoldable2($a801f2c896bd09f1$var$foldableList);
var $a801f2c896bd09f1$var$pure42 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeMaybe);
var $a801f2c896bd09f1$var$pure115 = /* @__PURE__ */ $a801f2c896bd09f1$var$pure($a801f2c896bd09f1$var$applicativeHalogenM);
var $a801f2c896bd09f1$var$gets5 = /* @__PURE__ */ $a801f2c896bd09f1$var$gets($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$recordWriteForeign10 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign();
var $a801f2c896bd09f1$var$writeForeignVariant3 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignVariant();
var $a801f2c896bd09f1$var$writeForeignMaybe3 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$writeForeignString);
var $a801f2c896bd09f1$var$consWriteForeignFields15 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "left";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields16 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$idIsSymbol6);
var $a801f2c896bd09f1$var$recordWriteForeign12 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields16($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields($a801f2c896bd09f1$var$pitchIsSymbol6)(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignPitch($a801f2c896bd09f1$var$writeForeignPitchSInterva))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$writeForeignStartStop3 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignStartStop($a801f2c896bd09f1$var$recordWriteForeign12);
var $a801f2c896bd09f1$var$consWriteForeignFields24 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "right";
    }
});
var $a801f2c896bd09f1$var$recordWriteForeign23 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields15($a801f2c896bd09f1$var$writeForeignStartStop3)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields24($a801f2c896bd09f1$var$writeForeignStartStop3)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$writeForeignArray4 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray($a801f2c896bd09f1$var$recordWriteForeign23);
var $a801f2c896bd09f1$var$recordWriteForeign33 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "prevTime";
    }
})($a801f2c896bd09f1$var$writeForeignMaybe3)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "ties";
    }
})($a801f2c896bd09f1$var$writeForeignArray4)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$consWriteForeignFields33 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "children";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields43 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "child";
    }
});
var $a801f2c896bd09f1$var$writeForeignArray12 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray($a801f2c896bd09f1$var$recordWriteForeign12);
var $a801f2c896bd09f1$var$recordWriteForeign42 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields15($a801f2c896bd09f1$var$writeForeignArray12)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields24($a801f2c896bd09f1$var$writeForeignArray12)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$consWriteForeignFields52 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "parent";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields62 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields52($a801f2c896bd09f1$var$recordWriteForeign12)($a801f2c896bd09f1$var$nilWriteForeignFields)()()();
var $a801f2c896bd09f1$var$consWriteForeignFields72 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "ids";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields82 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields15($a801f2c896bd09f1$var$writeForeignTransId);
var $a801f2c896bd09f1$var$consWriteForeignFields92 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields24($a801f2c896bd09f1$var$writeForeignTransId);
var $a801f2c896bd09f1$var$consWriteForeignFields102 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "rslice";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields112 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "passing";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields123 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "regular";
    }
});
var $a801f2c896bd09f1$var$recordWriteForeign52 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields112($a801f2c896bd09f1$var$writeForeignArray4)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields123($a801f2c896bd09f1$var$writeForeignArray4)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$consWriteForeignFields132 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "unexplained";
    }
});
var $a801f2c896bd09f1$var$consWriteForeignFields142 = /* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields33(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields43($a801f2c896bd09f1$var$recordWriteForeign12)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "orn";
    }
})($a801f2c896bd09f1$var$writeForeignMaybe3)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())));
var $a801f2c896bd09f1$var$writeForeignArray23 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields142($a801f2c896bd09f1$var$consWriteForeignFields62)()()()));
var $a801f2c896bd09f1$var$writeForeignArray32 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields142(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields52($a801f2c896bd09f1$var$recordWriteForeign23)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()()));
var $a801f2c896bd09f1$var$recordWriteForeign62 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "fromLeft";
    }
})($a801f2c896bd09f1$var$writeForeignArray23)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "fromRight";
    }
})($a801f2c896bd09f1$var$writeForeignArray23)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields72(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields82(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields92(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "slice";
    }
})($a801f2c896bd09f1$var$writeForeignSliceId)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "keepLeft";
    }
})($a801f2c896bd09f1$var$writeForeignArray4)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "keepRight";
    }
})($a801f2c896bd09f1$var$writeForeignArray4)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "passLeft";
    }
})($a801f2c896bd09f1$var$writeForeignArray4)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "passRight";
    }
})($a801f2c896bd09f1$var$writeForeignArray4)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields112($a801f2c896bd09f1$var$writeForeignArray32)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields123($a801f2c896bd09f1$var$writeForeignArray32)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields132(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$writeForeignArray12))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()());
var $a801f2c896bd09f1$var$recordWriteForeign72 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields16(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$writeForeignSliceId))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "notes";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignStartStop($a801f2c896bd09f1$var$writeForeignArray12))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$recordWriteForeign82 = /* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "classes";
    }
})($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "label";
    }
})($a801f2c896bd09f1$var$writeForeignString)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()());
var $a801f2c896bd09f1$var$writeForeignObject3 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignObject($a801f2c896bd09f1$var$recordWriteForeign82);
var $a801f2c896bd09f1$var$writeJSON4 = /* @__PURE__ */ $a801f2c896bd09f1$var$writeJSON(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "model";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "derivation";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignVariant3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "freezeLeft";
    }
})($a801f2c896bd09f1$var$recordWriteForeign33)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "freezeOnly";
    }
})($a801f2c896bd09f1$var$recordWriteForeign33)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "hori";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields33(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields43(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignVariant3(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "bothChildren";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields15($a801f2c896bd09f1$var$recordWriteForeign12)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields24($a801f2c896bd09f1$var$recordWriteForeign12)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()()))()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "leftChild";
    }
})($a801f2c896bd09f1$var$recordWriteForeign12)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "rightChild";
    }
})($a801f2c896bd09f1$var$recordWriteForeign12)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "tooManyChildren";
    }
})($a801f2c896bd09f1$var$recordWriteForeign42)()($a801f2c896bd09f1$var$nilWriteForeignVariant))))))($a801f2c896bd09f1$var$consWriteForeignFields62)()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields72(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields82(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "lslice";
    }
})($a801f2c896bd09f1$var$writeForeignSliceId)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "mid";
    }
})($a801f2c896bd09f1$var$writeForeignTransId)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields92(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields102($a801f2c896bd09f1$var$writeForeignSliceId)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()())()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "midEdges";
    }
})($a801f2c896bd09f1$var$recordWriteForeign52)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields132(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$recordWriteForeign42))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()()))()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "splitLeft";
    }
})($a801f2c896bd09f1$var$recordWriteForeign62)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "splitOnly";
    }
})($a801f2c896bd09f1$var$recordWriteForeign62)()(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignVariant({
    reflectSymbol: function() {
        return "splitRight";
    }
})($a801f2c896bd09f1$var$recordWriteForeign62)()($a801f2c896bd09f1$var$nilWriteForeignVariant)))))))))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "start";
    }
})($a801f2c896bd09f1$var$recordWriteForeign72)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "styles";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "css";
    }
})($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "edgeStyles";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "edge";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields15($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields24($a801f2c896bd09f1$var$writeForeignString)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()()))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "style";
    }
})($a801f2c896bd09f1$var$recordWriteForeign82)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "noteStyles";
    }
})($a801f2c896bd09f1$var$writeForeignObject3)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "sliceStyles";
    }
})($a801f2c896bd09f1$var$writeForeignObject3)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "staffType";
    }
})($a801f2c896bd09f1$var$writeForeignString)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "transStyles";
    }
})($a801f2c896bd09f1$var$writeForeignObject3)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "topSegments";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignArray(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields102($a801f2c896bd09f1$var$recordWriteForeign72)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "trans";
    }
})(/* @__PURE__ */ $a801f2c896bd09f1$var$recordWriteForeign10(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "edges";
    }
})($a801f2c896bd09f1$var$recordWriteForeign52)(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields16(/* @__PURE__ */ $a801f2c896bd09f1$var$writeForeignMaybe($a801f2c896bd09f1$var$writeForeignTransId))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()()))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())))($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()())()()())()()()))(/* @__PURE__ */ $a801f2c896bd09f1$var$consWriteForeignFields({
    reflectSymbol: function() {
        return "name";
    }
})($a801f2c896bd09f1$var$writeForeignString)($a801f2c896bd09f1$var$nilWriteForeignFields)()()())()()()));
var $a801f2c896bd09f1$var$discard13 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard($a801f2c896bd09f1$var$discardUnit);
var $a801f2c896bd09f1$var$discard14 = /* @__PURE__ */ $a801f2c896bd09f1$var$discard13($a801f2c896bd09f1$var$bindHalogenM);
var $a801f2c896bd09f1$var$put3 = /* @__PURE__ */ $a801f2c896bd09f1$var$put($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$bindFlipped13 = /* @__PURE__ */ $a801f2c896bd09f1$var$bindFlipped($a801f2c896bd09f1$var$bindEffect);
var $a801f2c896bd09f1$var$map120 = /* @__PURE__ */ $a801f2c896bd09f1$var$map($a801f2c896bd09f1$var$functorMaybe);
var $a801f2c896bd09f1$var$modify_9 = /* @__PURE__ */ $a801f2c896bd09f1$var$modify_2($a801f2c896bd09f1$var$monadStateHalogenM);
var $a801f2c896bd09f1$var$applySecond2 = /* @__PURE__ */ $a801f2c896bd09f1$var$applySecond($a801f2c896bd09f1$var$applyHalogenM);
var $a801f2c896bd09f1$var$min6 = /* @__PURE__ */ $a801f2c896bd09f1$var$min($a801f2c896bd09f1$var$ordNumber);
var $a801f2c896bd09f1$var$max9 = /* @__PURE__ */ $a801f2c896bd09f1$var$max($a801f2c896bd09f1$var$ordNumber);
var $a801f2c896bd09f1$var$append17 = /* @__PURE__ */ $a801f2c896bd09f1$var$append($a801f2c896bd09f1$var$semigroupArray);
var $a801f2c896bd09f1$var$bind36 = /* @__PURE__ */ $a801f2c896bd09f1$var$bind($a801f2c896bd09f1$var$bindAff);
var $a801f2c896bd09f1$var$for_4 = /* @__PURE__ */ $a801f2c896bd09f1$var$for_($a801f2c896bd09f1$var$applicativeAff)($a801f2c896bd09f1$var$foldableMaybe);
var $a801f2c896bd09f1$var$redrawScore = function(dictMonadEffect) {
    var liftEffect8 = $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectHalogenM(dictMonadEffect));
    return $a801f2c896bd09f1$var$bind35($a801f2c896bd09f1$var$get5)(function(st) {
        return $a801f2c896bd09f1$var$when5(st.settings.showScore)(function() {
            var update = $a801f2c896bd09f1$var$bind114(st.loaded)(function(loaded) {
                return $a801f2c896bd09f1$var$bind114(st.scoreElt)(function(scoreElt) {
                    var totalWidth = $a801f2c896bd09f1$var$scalex(st.settings)($a801f2c896bd09f1$var$toNumber($a801f2c896bd09f1$var$length4(loaded.model.piece))) + $a801f2c896bd09f1$var$sliceDistance / 2;
                    var toX = function(x4) {
                        return $a801f2c896bd09f1$var$scalex(st.settings)(x4);
                    };
                    var graph = $a801f2c896bd09f1$var$evalGraph(false)(false)(loaded.model.reduction);
                    var slices = function() {
                        if (st.selected instanceof $a801f2c896bd09f1$var$SelNote) return $a801f2c896bd09f1$var$filter2(function(s2) {
                            return $a801f2c896bd09f1$var$elem4(s2.slice.id)($a801f2c896bd09f1$var$getParents(st.selected.value0.parents)) || $a801f2c896bd09f1$var$elem1(st.selected.value0.note)($a801f2c896bd09f1$var$map58(function(v3) {
                                return v3.note;
                            })($a801f2c896bd09f1$var$getInnerNotes(s2.slice)));
                        })($a801f2c896bd09f1$var$fromFoldable16(graph.slices));
                        return $a801f2c896bd09f1$var$filter2(function(s2) {
                            return s2.depth === 0;
                        })($a801f2c896bd09f1$var$fromFoldable16(graph.slices));
                    }();
                    var transitions = function() {
                        var sliceIds = $a801f2c896bd09f1$var$map58(function(v3) {
                            return v3.slice.id;
                        })(slices);
                        return $a801f2c896bd09f1$var$filter2(function(t2) {
                            return $a801f2c896bd09f1$var$elem4(t2.left)(sliceIds) && $a801f2c896bd09f1$var$elem4(t2.right)(sliceIds);
                        })($a801f2c896bd09f1$var$fromFoldable17($a801f2c896bd09f1$var$values2(graph.transitions)));
                    }();
                    return $a801f2c896bd09f1$var$pure42(liftEffect8($a801f2c896bd09f1$var$insertScore(scoreElt)($a801f2c896bd09f1$var$renderScore($a801f2c896bd09f1$var$map58(function(v3) {
                        return v3.slice;
                    })(slices))(transitions)(toX)(loaded.model.styles.staff)(totalWidth)($a801f2c896bd09f1$var$scoreScale))));
                });
            });
            return $a801f2c896bd09f1$var$fromMaybe($a801f2c896bd09f1$var$pure115($a801f2c896bd09f1$var$unit))(update);
        }());
    });
};
var $a801f2c896bd09f1$var$autoSaveModel = function(dictMonadEffect) {
    var liftEffect8 = $a801f2c896bd09f1$var$liftEffect($a801f2c896bd09f1$var$monadEffectHalogenM(dictMonadEffect));
    return $a801f2c896bd09f1$var$bind35($a801f2c896bd09f1$var$gets5(function(v3) {
        return v3.loaded;
    }))(function(loaded) {
        return $a801f2c896bd09f1$var$bind35($a801f2c896bd09f1$var$gets5(function(v3) {
            return v3.name;
        }))(function(name17) {
            if (loaded instanceof $a801f2c896bd09f1$var$Just) {
                var v3 = $a801f2c896bd09f1$var$modelToJSON(loaded.value0.model);
                if (v3 instanceof $a801f2c896bd09f1$var$Right) return liftEffect8(function __do2() {
                    var w2 = $a801f2c896bd09f1$var$windowImpl();
                    var s2 = $a801f2c896bd09f1$var$localStorage(w2)();
                    return $a801f2c896bd09f1$var$setItem("autosave")($a801f2c896bd09f1$var$writeJSON4({
                        name: name17,
                        model: v3.value0
                    }))(s2)();
                });
                if (v3 instanceof $a801f2c896bd09f1$var$Left) return $a801f2c896bd09f1$var$pure115($a801f2c896bd09f1$var$unit);
                throw new Error("Failed pattern match at App.Main (line 133, column 15 - line 139, column 29): " + [
                    v3.constructor.name
                ]);
            }
            if (loaded instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure115($a801f2c896bd09f1$var$unit);
            throw new Error("Failed pattern match at App.Main (line 132, column 3 - line 140, column 25): " + [
                loaded.constructor.name
            ]);
        });
    });
};
var $a801f2c896bd09f1$var$tryModelAction = function(dictMonadEffect) {
    var log5 = $a801f2c896bd09f1$var$log4($a801f2c896bd09f1$var$monadEffectHalogenM(dictMonadEffect));
    var autoSaveModel1 = $a801f2c896bd09f1$var$autoSaveModel(dictMonadEffect);
    var redrawScore1 = $a801f2c896bd09f1$var$redrawScore(dictMonadEffect);
    return function(selector) {
        return function(action2) {
            return function(actionName) {
                return function(clearSel) {
                    return $a801f2c896bd09f1$var$bind35($a801f2c896bd09f1$var$get5)(function(st) {
                        var modelAndSel = $a801f2c896bd09f1$var$bind114(selector(st.selected))(function(sel) {
                            return $a801f2c896bd09f1$var$bind114(st.loaded)(function(loaded) {
                                return $a801f2c896bd09f1$var$pure42({
                                    sel: sel,
                                    loaded: loaded
                                });
                            });
                        });
                        if (modelAndSel instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$pure115($a801f2c896bd09f1$var$unit);
                        if (modelAndSel instanceof $a801f2c896bd09f1$var$Just) {
                            var v3 = action2(modelAndSel.value0.sel)(modelAndSel.value0.loaded.model);
                            if (v3 instanceof $a801f2c896bd09f1$var$Left) return log5(v3.value0);
                            if (v3 instanceof $a801f2c896bd09f1$var$Right) return $a801f2c896bd09f1$var$discard14($a801f2c896bd09f1$var$put3(function() {
                                var $641 = {};
                                for(var $642 in st)if (({}).hasOwnProperty.call(st, $642)) $641[$642] = st[$642];
                                $641.loaded = new $a801f2c896bd09f1$var$Just(function() {
                                    var $637 = {};
                                    for(var $638 in modelAndSel.value0.loaded)if (({}).hasOwnProperty.call(modelAndSel.value0.loaded, $638)) $637[$638] = modelAndSel["value0"]["loaded"][$638];
                                    $637.model = v3.value0;
                                    return $637;
                                }());
                                $641.selected = function() {
                                    if (clearSel) return $a801f2c896bd09f1$var$SelNone.value;
                                    return st.selected;
                                }();
                                $641.undoStack = new $a801f2c896bd09f1$var$Cons({
                                    m: modelAndSel.value0.loaded.model,
                                    name: actionName
                                }, st.undoStack);
                                $641.redoStack = $a801f2c896bd09f1$var$Nil.value;
                                return $641;
                            }()))(function() {
                                return $a801f2c896bd09f1$var$discard14(autoSaveModel1)(function() {
                                    return redrawScore1;
                                });
                            });
                            throw new Error("Failed pattern match at App.Main (line 72, column 29 - line 83, column 20): " + [
                                v3.constructor.name
                            ]);
                        }
                        throw new Error("Failed pattern match at App.Main (line 70, column 3 - line 83, column 20): " + [
                            modelAndSel.constructor.name
                        ]);
                    });
                };
            };
        };
    };
};
var $a801f2c896bd09f1$var$removeAny = function(dictMonadEffect) {
    return $a801f2c896bd09f1$var$bind35($a801f2c896bd09f1$var$get5)(function(st) {
        if (st.selected instanceof $a801f2c896bd09f1$var$SelTrans) return $a801f2c896bd09f1$var$handleAction(dictMonadEffect)($a801f2c896bd09f1$var$UnMergeAtSelected.value);
        if (st.selected instanceof $a801f2c896bd09f1$var$SelSlice) return $a801f2c896bd09f1$var$handleAction(dictMonadEffect)($a801f2c896bd09f1$var$UnVertAtSelected.value);
        return $a801f2c896bd09f1$var$pure115($a801f2c896bd09f1$var$unit);
    });
};
var $a801f2c896bd09f1$var$handleAction = function(dictMonadEffect) {
    var monadEffectHalogenM2 = $a801f2c896bd09f1$var$monadEffectHalogenM(dictMonadEffect);
    var liftEffect8 = $a801f2c896bd09f1$var$liftEffect(monadEffectHalogenM2);
    var log5 = $a801f2c896bd09f1$var$log4(monadEffectHalogenM2);
    var redrawScore1 = $a801f2c896bd09f1$var$redrawScore(dictMonadEffect);
    var autoSaveModel1 = $a801f2c896bd09f1$var$autoSaveModel(dictMonadEffect);
    var tryModelAction1 = $a801f2c896bd09f1$var$tryModelAction(dictMonadEffect);
    return function(act) {
        var updateSelection = function(v4) {
            return function(sel) {
                var v1 = function(v22) {
                    if ($a801f2c896bd09f1$var$otherwise) return sel;
                    throw new Error("Failed pattern match at App.Main (line 93, column 1 - line 93, column 94): " + [
                        v4.constructor.name,
                        sel.constructor.name
                    ]);
                };
                if (sel instanceof $a801f2c896bd09f1$var$SelNote) {
                    var $658 = sel.value0.note.id === v4.noteId;
                    if ($658) return new $a801f2c896bd09f1$var$SelNote({
                        note: sel.value0.note,
                        parents: sel.value0.parents,
                        slice: sel.value0.slice,
                        expl: v4.expl
                    });
                    return v1(true);
                }
                return v1(true);
            };
        };
        var swapTops = function(loaded) {
            return function(s1) {
                return function(s2) {
                    if (loaded instanceof $a801f2c896bd09f1$var$Nothing) return {
                        loaded: loaded,
                        s1: s1,
                        s2: s2
                    };
                    if (loaded instanceof $a801f2c896bd09f1$var$Just) {
                        if (s1 instanceof $a801f2c896bd09f1$var$Nil) return {
                            loaded: loaded,
                            s1: s1,
                            s2: s2
                        };
                        if (s1 instanceof $a801f2c896bd09f1$var$Cons) return {
                            loaded: new $a801f2c896bd09f1$var$Just(function() {
                                var $664 = {};
                                for(var $665 in loaded.value0)if (({}).hasOwnProperty.call(loaded.value0, $665)) $664[$665] = loaded["value0"][$665];
                                $664.model = s1.value0.m;
                                return $664;
                            }()),
                            s1: s1.value1,
                            s2: new $a801f2c896bd09f1$var$Cons({
                                m: loaded.value0.model,
                                name: s1.value0.name
                            }, s2)
                        };
                        throw new Error("Failed pattern match at App.Main (line 242, column 21 - line 244, column 123): " + [
                            s1.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at App.Main (line 240, column 27 - line 244, column 123): " + [
                        loaded.constructor.name
                    ]);
                };
            };
        };
        var pr = function(ev) {
            return liftEffect8($a801f2c896bd09f1$var$preventDefault($a801f2c896bd09f1$var$toEvent(ev)));
        };
        if (act instanceof $a801f2c896bd09f1$var$NoOp) return log5("NoOp");
        if (act instanceof $a801f2c896bd09f1$var$Init) return $a801f2c896bd09f1$var$bind35(liftEffect8($a801f2c896bd09f1$var$bindFlipped13($a801f2c896bd09f1$var$document2)($a801f2c896bd09f1$var$windowImpl)))(function(doc) {
            return $a801f2c896bd09f1$var$subscribe$prime(function(_sid) {
                return $a801f2c896bd09f1$var$eventListener2($a801f2c896bd09f1$var$keyup)($a801f2c896bd09f1$var$toEventTarget2(doc))(function() {
                    var $769 = $a801f2c896bd09f1$var$map120($a801f2c896bd09f1$var$HandleKey.create);
                    return function($770) {
                        return $769($a801f2c896bd09f1$var$fromEvent($770));
                    };
                }());
            });
        });
        if (act instanceof $a801f2c896bd09f1$var$SwitchTab) return $a801f2c896bd09f1$var$modify_9(function(st) {
            var $673 = {};
            for(var $674 in st)if (({}).hasOwnProperty.call(st, $674)) $673[$674] = st[$674];
            $673.tab = act.value0;
            return $673;
        });
        if (act instanceof $a801f2c896bd09f1$var$HandleKey) {
            var $677 = $a801f2c896bd09f1$var$maybe(false)($a801f2c896bd09f1$var$eventTargetIsBody)($a801f2c896bd09f1$var$target($a801f2c896bd09f1$var$toEvent(act.value0)));
            if ($677) {
                var v3 = $a801f2c896bd09f1$var$key(act.value0);
                if (v3 === "z") return $a801f2c896bd09f1$var$applySecond2(pr(act.value0))($a801f2c896bd09f1$var$handleAction(dictMonadEffect)($a801f2c896bd09f1$var$Undo.value));
                if (v3 === "Z") return $a801f2c896bd09f1$var$applySecond2(pr(act.value0))($a801f2c896bd09f1$var$handleAction(dictMonadEffect)($a801f2c896bd09f1$var$Redo.value));
                if (v3 === "Enter") return $a801f2c896bd09f1$var$applySecond2(pr(act.value0))($a801f2c896bd09f1$var$combineAny(dictMonadEffect));
                if (v3 === "Backspace") return $a801f2c896bd09f1$var$applySecond2(pr(act.value0))($a801f2c896bd09f1$var$removeAny(dictMonadEffect));
                return $a801f2c896bd09f1$var$pure115($a801f2c896bd09f1$var$unit);
            }
            return $a801f2c896bd09f1$var$pure115($a801f2c896bd09f1$var$unit);
        }
        if (act instanceof $a801f2c896bd09f1$var$HandleScroll) return $a801f2c896bd09f1$var$when5($a801f2c896bd09f1$var$ctrlKey($a801f2c896bd09f1$var$toMouseEvent(act.value0)))($a801f2c896bd09f1$var$discard14(liftEffect8($a801f2c896bd09f1$var$preventDefault($a801f2c896bd09f1$var$toEvent2(act.value0))))(function() {
            return $a801f2c896bd09f1$var$discard14(function() {
                var $680 = $a801f2c896bd09f1$var$shiftKey($a801f2c896bd09f1$var$toMouseEvent(act.value0));
                if ($680) return $a801f2c896bd09f1$var$modify_9(function(st) {
                    var $684 = {};
                    for(var $685 in st)if (({}).hasOwnProperty.call(st, $685)) $684[$685] = st[$685];
                    $684.settings = function() {
                        var $681 = {};
                        for(var $682 in st.settings)if (({}).hasOwnProperty.call(st.settings, $682)) $681[$682] = st["settings"][$682];
                        $681.yscale = $a801f2c896bd09f1$var$min6(2)($a801f2c896bd09f1$var$max9(-2)(st.settings.yscale - $a801f2c896bd09f1$var$deltaY(act.value0) / 1e3));
                        return $681;
                    }();
                    return $684;
                });
                return $a801f2c896bd09f1$var$modify_9(function(st) {
                    var $690 = {};
                    for(var $691 in st)if (({}).hasOwnProperty.call(st, $691)) $690[$691] = st[$691];
                    $690.settings = function() {
                        var $687 = {};
                        for(var $688 in st.settings)if (({}).hasOwnProperty.call(st.settings, $688)) $687[$688] = st["settings"][$688];
                        $687.xscale = $a801f2c896bd09f1$var$min6(0)($a801f2c896bd09f1$var$max9(-5)(st.settings.xscale - $a801f2c896bd09f1$var$deltaY(act.value0) / 1e3));
                        return $687;
                    }();
                    return $690;
                });
            }())(function() {
                return redrawScore1;
            });
        }));
        if (act instanceof $a801f2c896bd09f1$var$Select) return $a801f2c896bd09f1$var$discard14($a801f2c896bd09f1$var$modify_9(function(st) {
            var $694 = {};
            for(var $695 in st)if (({}).hasOwnProperty.call(st, $695)) $694[$695] = st[$695];
            $694.selected = act.value0;
            return $694;
        }))(function() {
            return $a801f2c896bd09f1$var$discard14(autoSaveModel1)(function() {
                return redrawScore1;
            });
        });
        if (act instanceof $a801f2c896bd09f1$var$HandleImport) return $a801f2c896bd09f1$var$discard14(function() {
            if (act.value0.thing instanceof $a801f2c896bd09f1$var$ImportPiece) {
                var model = $a801f2c896bd09f1$var$loadPiece(act.value0.thing.value0);
                return $a801f2c896bd09f1$var$modify_9(function(st) {
                    var $699 = {};
                    for(var $700 in st)if (({}).hasOwnProperty.call(st, $700)) $699[$700] = st[$700];
                    $699.loaded = new $a801f2c896bd09f1$var$Just({
                        model: model,
                        surface: $a801f2c896bd09f1$var$findSurface(false)(model.reduction)
                    });
                    $699.name = act.value0.name;
                    return $699;
                });
            }
            if (act.value0.thing instanceof $a801f2c896bd09f1$var$ImportModel) return $a801f2c896bd09f1$var$modify_9(function(st) {
                var $703 = {};
                for(var $704 in st)if (({}).hasOwnProperty.call(st, $704)) $703[$704] = st[$704];
                $703.loaded = new $a801f2c896bd09f1$var$Just({
                    model: act.value0.thing.value0,
                    surface: $a801f2c896bd09f1$var$findSurface(false)(act.value0.thing.value0.reduction)
                });
                $703.name = act.value0.name;
                return $703;
            });
            throw new Error("Failed pattern match at App.Main (line 173, column 7 - line 185, column 12): " + [
                act.value0.thing.constructor.name
            ]);
        }())(function() {
            return $a801f2c896bd09f1$var$discard14(autoSaveModel1)(function() {
                return $a801f2c896bd09f1$var$discard14(redrawScore1)(function() {
                    return $a801f2c896bd09f1$var$modify_9(function(st) {
                        var $707 = {};
                        for(var $708 in st)if (({}).hasOwnProperty.call(st, $708)) $707[$708] = st[$708];
                        $707.selected = $a801f2c896bd09f1$var$SelNone.value;
                        $707.tab = $a801f2c896bd09f1$var$Nothing.value;
                        $707.undoStack = $a801f2c896bd09f1$var$Nil.value;
                        $707.redoStack = $a801f2c896bd09f1$var$Nil.value;
                        return $707;
                    });
                });
            });
        });
        if (act instanceof $a801f2c896bd09f1$var$HandleSettings) return $a801f2c896bd09f1$var$discard14($a801f2c896bd09f1$var$modify_9(function(st) {
            var $713 = {};
            for(var $714 in st)if (({}).hasOwnProperty.call(st, $714)) $713[$714] = st[$714];
            $713.settings = act.value0;
            return $713;
        }))(function() {
            return redrawScore1;
        });
        if (act instanceof $a801f2c896bd09f1$var$HandleStyle) return $a801f2c896bd09f1$var$discard14($a801f2c896bd09f1$var$modify_9(function(st) {
            if (st.loaded instanceof $a801f2c896bd09f1$var$Nothing) return st;
            if (st.loaded instanceof $a801f2c896bd09f1$var$Just) {
                var $724 = {};
                for(var $725 in st)if (({}).hasOwnProperty.call(st, $725)) $724[$725] = st[$725];
                $724.loaded = new $a801f2c896bd09f1$var$Just(function() {
                    var $721 = {};
                    for(var $722 in st.loaded.value0)if (({}).hasOwnProperty.call(st.loaded.value0, $722)) $721[$722] = st["loaded"]["value0"][$722];
                    $721.model = function() {
                        var $718 = {};
                        for(var $719 in st.loaded.value0.model)if (({}).hasOwnProperty.call(st.loaded.value0.model, $719)) $718[$719] = st["loaded"]["value0"]["model"][$719];
                        $718.styles = act.value0;
                        return $718;
                    }();
                    return $721;
                }());
                return $724;
            }
            throw new Error("Failed pattern match at App.Main (line 199, column 24 - line 201, column 83): " + [
                st.loaded.constructor.name
            ]);
        }))(function() {
            return redrawScore1;
        });
        if (act instanceof $a801f2c896bd09f1$var$MergeAtSelected) return tryModelAction1($a801f2c896bd09f1$var$getSelSlice)($a801f2c896bd09f1$var$mergeAtSlice)("Merge Transitions")(true);
        if (act instanceof $a801f2c896bd09f1$var$VertAtSelected) return tryModelAction1($a801f2c896bd09f1$var$getSelTrans)($a801f2c896bd09f1$var$vertAtMid)("Vert Slices")(true);
        if (act instanceof $a801f2c896bd09f1$var$UnMergeAtSelected) return tryModelAction1($a801f2c896bd09f1$var$getSelTrans)($a801f2c896bd09f1$var$undoMergeAtTrans)("Unmerge Transition")(true);
        if (act instanceof $a801f2c896bd09f1$var$UnVertAtSelected) return tryModelAction1($a801f2c896bd09f1$var$getSelSlice)($a801f2c896bd09f1$var$undoVertAtSlice)("Unvert Slice")(true);
        if (act instanceof $a801f2c896bd09f1$var$CombineAny) return $a801f2c896bd09f1$var$combineAny(dictMonadEffect);
        if (act instanceof $a801f2c896bd09f1$var$RemoveAny) return $a801f2c896bd09f1$var$removeAny(dictMonadEffect);
        if (act instanceof $a801f2c896bd09f1$var$SetNoteExplanation) return $a801f2c896bd09f1$var$discard14(tryModelAction1($a801f2c896bd09f1$var$$$const(new $a801f2c896bd09f1$var$Just(act.value0)))(function(v4) {
            return $a801f2c896bd09f1$var$noteSetExplanation(v4.noteId)(v4.expl);
        })("Set Note Explanation")(false))(function() {
            return $a801f2c896bd09f1$var$modify_9(function(st) {
                var $732 = {};
                for(var $733 in st)if (({}).hasOwnProperty.call(st, $733)) $732[$733] = st[$733];
                $732.selected = updateSelection(act.value0)(st.selected);
                return $732;
            });
        });
        if (act instanceof $a801f2c896bd09f1$var$Undo) return $a801f2c896bd09f1$var$bind35($a801f2c896bd09f1$var$get5)(function(st) {
            var v4 = swapTops(st.loaded)(st.undoStack)(st.redoStack);
            return $a801f2c896bd09f1$var$discard14($a801f2c896bd09f1$var$put3(function() {
                var $737 = {};
                for(var $738 in st)if (({}).hasOwnProperty.call(st, $738)) $737[$738] = st[$738];
                $737.undoStack = v4.s1;
                $737.redoStack = v4.s2;
                $737.loaded = v4.loaded;
                $737.selected = $a801f2c896bd09f1$var$SelNone.value;
                return $737;
            }()))(function() {
                return $a801f2c896bd09f1$var$discard14(autoSaveModel1)(function() {
                    return redrawScore1;
                });
            });
        });
        if (act instanceof $a801f2c896bd09f1$var$Redo) return $a801f2c896bd09f1$var$bind35($a801f2c896bd09f1$var$get5)(function(st) {
            var v4 = swapTops(st.loaded)(st.redoStack)(st.undoStack);
            return $a801f2c896bd09f1$var$discard14($a801f2c896bd09f1$var$put3(function() {
                var $744 = {};
                for(var $745 in st)if (({}).hasOwnProperty.call(st, $745)) $744[$745] = st[$745];
                $744.undoStack = v4.s2;
                $744.redoStack = v4.s1;
                $744.loaded = v4.loaded;
                $744.selected = $a801f2c896bd09f1$var$SelNone.value;
                return $744;
            }()))(function() {
                return $a801f2c896bd09f1$var$discard14(autoSaveModel1)(function() {
                    return redrawScore1;
                });
            });
        });
        if (act instanceof $a801f2c896bd09f1$var$RegisterScoreElt) return $a801f2c896bd09f1$var$discard14($a801f2c896bd09f1$var$modify_9(function(st) {
            var $750 = {};
            for(var $751 in st)if (({}).hasOwnProperty.call(st, $751)) $750[$751] = st[$751];
            $750.scoreElt = new $a801f2c896bd09f1$var$Just(act.value0);
            return $750;
        }))(function() {
            return redrawScore1;
        });
        throw new Error("Failed pattern match at App.Main (line 144, column 3 - line 236, column 18): " + [
            act.constructor.name
        ]);
    };
};
var $a801f2c896bd09f1$var$combineAny = function(dictMonadEffect) {
    return $a801f2c896bd09f1$var$bind35($a801f2c896bd09f1$var$get5)(function(st) {
        if (st.selected instanceof $a801f2c896bd09f1$var$SelTrans) return $a801f2c896bd09f1$var$handleAction(dictMonadEffect)($a801f2c896bd09f1$var$VertAtSelected.value);
        if (st.selected instanceof $a801f2c896bd09f1$var$SelSlice) return $a801f2c896bd09f1$var$handleAction(dictMonadEffect)($a801f2c896bd09f1$var$MergeAtSelected.value);
        return $a801f2c896bd09f1$var$pure115($a801f2c896bd09f1$var$unit);
    });
};
var $a801f2c896bd09f1$var$appComponent = function(dictMonadEffect) {
    return function(dictMonadAff) {
        var MonadEffect0 = dictMonadAff.MonadEffect0();
        var renderTabs2 = $a801f2c896bd09f1$var$renderTabs(MonadEffect0)(dictMonadAff);
        var render = function(st) {
            var modelInfo = function() {
                if (st.loaded instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$Nothing.value;
                if (st.loaded instanceof $a801f2c896bd09f1$var$Just) return new $a801f2c896bd09f1$var$Just({
                    model: st.loaded.value0.model,
                    graph: $a801f2c896bd09f1$var$evalGraph(st.settings.flatHori)(st.settings.showAllEdges)(st.loaded.value0.model.reduction),
                    validation: $a801f2c896bd09f1$var$validateReduction(st.loaded.value0.model.reduction),
                    surface: st.loaded.value0.surface
                });
                throw new Error("Failed pattern match at App.Main (line 327, column 17 - line 334, column 10): " + [
                    st.loaded.constructor.name
                ]);
            }();
            return $a801f2c896bd09f1$var$div_([
                $a801f2c896bd09f1$var$h1([
                    $a801f2c896bd09f1$var$class_2("content")
                ])([
                    $a801f2c896bd09f1$var$text("Proto-Voice Annotation Tool")
                ]),
                renderTabs2(st)(modelInfo),
                $a801f2c896bd09f1$var$h2([
                    $a801f2c896bd09f1$var$class_2("content")
                ])([
                    $a801f2c896bd09f1$var$text("Annotations for " + st.name)
                ]),
                function() {
                    if (modelInfo instanceof $a801f2c896bd09f1$var$Nothing) return $a801f2c896bd09f1$var$text("");
                    if (modelInfo instanceof $a801f2c896bd09f1$var$Just) return $a801f2c896bd09f1$var$div_([
                        $a801f2c896bd09f1$var$div5([
                            $a801f2c896bd09f1$var$class_2("content pure-g pure-form")
                        ])($a801f2c896bd09f1$var$append17([
                            $a801f2c896bd09f1$var$button([
                                $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-12"),
                                $a801f2c896bd09f1$var$onClick(function(v3) {
                                    return $a801f2c896bd09f1$var$Undo.value;
                                }),
                                $a801f2c896bd09f1$var$disabled($a801f2c896bd09f1$var$$$null(st.undoStack)),
                                $a801f2c896bd09f1$var$title("Undo " + $a801f2c896bd09f1$var$maybe("")(function(v3) {
                                    return v3.name;
                                })($a801f2c896bd09f1$var$head(st.undoStack)))
                            ])([
                                $a801f2c896bd09f1$var$text("Undo")
                            ]),
                            $a801f2c896bd09f1$var$button([
                                $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-12"),
                                $a801f2c896bd09f1$var$onClick(function(v3) {
                                    return $a801f2c896bd09f1$var$Redo.value;
                                }),
                                $a801f2c896bd09f1$var$disabled($a801f2c896bd09f1$var$$$null(st.redoStack)),
                                $a801f2c896bd09f1$var$title("Redo " + $a801f2c896bd09f1$var$maybe("")(function(v3) {
                                    return v3.name;
                                })($a801f2c896bd09f1$var$head(st.redoStack)))
                            ])([
                                $a801f2c896bd09f1$var$text("Redo")
                            ])
                        ])(function() {
                            if (st.selected instanceof $a801f2c896bd09f1$var$SelNote) return [
                                $a801f2c896bd09f1$var$div5([
                                    $a801f2c896bd09f1$var$class_2("pure-u-1-12"),
                                    $a801f2c896bd09f1$var$style("height:30px;")
                                ])([]),
                                $a801f2c896bd09f1$var$div5([
                                    $a801f2c896bd09f1$var$class_2("pure-u-3-4")
                                ])([
                                    $a801f2c896bd09f1$var$renderNoteExplanation(modelInfo.value0.graph)(st.selected.value0.note)(st.selected.value0.expl)(st.selected.value0.parents)
                                ])
                            ];
                            if (st.selected instanceof $a801f2c896bd09f1$var$SelNone) return [
                                $a801f2c896bd09f1$var$div5([
                                    $a801f2c896bd09f1$var$class_2("pure-u-1-12"),
                                    $a801f2c896bd09f1$var$style("height:30px;")
                                ])([]),
                                $a801f2c896bd09f1$var$label([
                                    $a801f2c896bd09f1$var$class_2("pure-u-3-4")
                                ])([
                                    $a801f2c896bd09f1$var$text("Nothing selected.")
                                ])
                            ];
                            return [
                                $a801f2c896bd09f1$var$div5([
                                    $a801f2c896bd09f1$var$class_2("pure-u-1-12 pure-g"),
                                    $a801f2c896bd09f1$var$style("height:30px;")
                                ])([]),
                                $a801f2c896bd09f1$var$label([
                                    $a801f2c896bd09f1$var$class_2("pure-u-1-4")
                                ])([
                                    $a801f2c896bd09f1$var$text("Slice or transition selected.")
                                ]),
                                $a801f2c896bd09f1$var$button([
                                    $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-4"),
                                    $a801f2c896bd09f1$var$onClick(function(v3) {
                                        return $a801f2c896bd09f1$var$CombineAny.value;
                                    }),
                                    $a801f2c896bd09f1$var$enabled($a801f2c896bd09f1$var$outerSelected(st.selected))
                                ])([
                                    $a801f2c896bd09f1$var$text("Reduce (Enter)")
                                ]),
                                $a801f2c896bd09f1$var$button([
                                    $a801f2c896bd09f1$var$class_2("pure-button pure-u-1-4"),
                                    $a801f2c896bd09f1$var$onClick(function(v3) {
                                        return $a801f2c896bd09f1$var$RemoveAny.value;
                                    }),
                                    $a801f2c896bd09f1$var$enabled($a801f2c896bd09f1$var$outerSelected(st.selected))
                                ])([
                                    $a801f2c896bd09f1$var$text("Unreduce (Backspace)")
                                ])
                            ];
                        }())),
                        $a801f2c896bd09f1$var$div5([
                            $a801f2c896bd09f1$var$class_2("wide"),
                            $a801f2c896bd09f1$var$onWheel($a801f2c896bd09f1$var$HandleScroll.create)
                        ])([
                            $a801f2c896bd09f1$var$renderReduction(st.settings)(modelInfo.value0.model.piece)(modelInfo.value0.graph)(modelInfo.value0.validation)(modelInfo.value0.model.styles)(st.selected)
                        ])
                    ]);
                    throw new Error("Failed pattern match at App.Main (line 271, column 9 - line 324, column 16): " + [
                        modelInfo.constructor.name
                    ]);
                }()
            ]);
        };
        var initialState = function(v3) {
            return {
                selected: $a801f2c896bd09f1$var$SelNone.value,
                loaded: $a801f2c896bd09f1$var$Nothing.value,
                name: "unnamed",
                undoStack: $a801f2c896bd09f1$var$Nil.value,
                redoStack: $a801f2c896bd09f1$var$Nil.value,
                tab: new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$ImportTab.value),
                settings: $a801f2c896bd09f1$var$defaultSettings,
                scoreElt: $a801f2c896bd09f1$var$Nothing.value
            };
        };
        return $a801f2c896bd09f1$var$mkComponent({
            initialState: initialState,
            render: render,
            "eval": $a801f2c896bd09f1$var$mkEval({
                handleQuery: $a801f2c896bd09f1$var$defaultEval.handleQuery,
                receive: $a801f2c896bd09f1$var$defaultEval.receive,
                finalize: $a801f2c896bd09f1$var$defaultEval.finalize,
                handleAction: $a801f2c896bd09f1$var$handleAction(MonadEffect0),
                initialize: new $a801f2c896bd09f1$var$Just($a801f2c896bd09f1$var$Init.value)
            })
        });
    };
};
var $a801f2c896bd09f1$var$appComponent1 = /* @__PURE__ */ $a801f2c896bd09f1$var$appComponent($a801f2c896bd09f1$var$monadEffectAff)($a801f2c896bd09f1$var$monadAffAff);
var $a801f2c896bd09f1$var$main2 = /* @__PURE__ */ $a801f2c896bd09f1$var$runHalogenAff(/* @__PURE__ */ $a801f2c896bd09f1$var$discard13($a801f2c896bd09f1$var$bindAff)($a801f2c896bd09f1$var$awaitLoad)(function() {
    return $a801f2c896bd09f1$var$bind36($a801f2c896bd09f1$var$selectElement("#app"))(function(elt) {
        return $a801f2c896bd09f1$var$for_4(elt)($a801f2c896bd09f1$var$runUI2($a801f2c896bd09f1$var$appComponent1)($a801f2c896bd09f1$var$unit));
    });
}));
// output/Main/index.js
var $a801f2c896bd09f1$export$f22da7240b7add18 = $a801f2c896bd09f1$var$main2;

});
parcelRegister("cEkdT", function(module, exports) {
module.exports = new URL("musicxml2pv.fbe2cbb9.wasm", import.meta.url).toString();

});


var $4988e58b645bfc24$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"lwJ2Q\",\"index.1c8be784.js\",\"6a27C\",\"musicxml2pv.fbe2cbb9.wasm\"]"));


(parcelRequire("eqiDo")).main();


//# sourceMappingURL=index.1c8be784.js.map
